(function ()
{
    'use strict';

    angular
        .module('app.scrumboard',
            [
                // 3rd Party Dependencies
                'moment-picker',
                'ui.calendar',
                'ui.sortable',
                'xeditable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        $stateProvider
            .state('app.scrumboard', {
                abstract : true,
                url      : '/scrumboard',
                resolve  : {
                    BoardList: function (msApi)
                    {
                        return msApi.resolve('scrumboard.boardList@get');
                    }
                },
                bodyClass: 'scrumboard'
            })

            // Home
            .state('app.scrumboard.boards', {
                url  : '/boards',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/scrumboard/views/boards/boards-view.html',
                        controller : 'BoardsViewController as vm'
                    }
                }
            })

            // Board
            .state('app.scrumboard.boards.board', {
                    url    : '/:id/:uri',
                    views  : {
                        'content@app'                                  : {
                            templateUrl: 'app/main/apps/scrumboard/scrumboard.html',
                            controller : 'ScrumboardController as vm'
                        },
                        'scrumboardContent@app.scrumboard.boards.board': {
                            templateUrl: 'app/main/apps/scrumboard/views/board/board-view.html',
                            controller : 'BoardViewController as vm'
                        }
                    },
                    resolve: {
                        BoardData: function ($stateParams, BoardService)
                        {
                            return BoardService.getBoardData($stateParams.id);
                        }
                    }
                }
            )

            // Add board
            .state('app.scrumboard.boards.addBoard', {
                    url    : '/add',
                    views  : {
                        'content@app'                                     : {
                            templateUrl: 'app/main/apps/scrumboard/scrumboard.html',
                            controller : 'ScrumboardController as vm'
                        },
                        'scrumboardContent@app.scrumboard.boards.addBoard': {
                            templateUrl: 'app/main/apps/scrumboard/views/board/board-view.html',
                            controller : 'BoardViewController as vm'
                        }
                    },
                    resolve: {
                        BoardData: function ($stateParams, BoardService)
                        {
                            return BoardService.addNewBoard();
                        }
                    }
                }
            )

            // Calendar
            .state('app.scrumboard.boards.board.calendar', {
                url  : '/calendar',
                views: {
                    'scrumboardContent@app.scrumboard.boards.board': {
                        templateUrl: 'app/main/apps/scrumboard/views/calendar/calendar-view.html',
                        controller : 'CalendarViewController as vm'
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/scrumboard');

        // Api
        msApiProvider.register('scrumboard.boardList', ['app/data/scrumboard/board-list.json']);
        msApiProvider.register('scrumboard.board', ['app/data/scrumboard/boards/:id.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.scrumboard', {
            title : 'Scrumboard',
            icon  : 'icon-trello',
            state : 'app.scrumboard.boards',
            weight: 8
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ScrumboardCalendarEventDialogController', ScrumboardCalendarEventDialogController);

    /** @ngInject */
    function ScrumboardCalendarEventDialogController($mdDialog, dueDate, BoardService, msUtils)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.dueDate = dueDate;
        vm.newCard = {
            name  : '',
            listId: ''
        };
        vm.selectedCards = [];

        // Methods
        vm.exists = msUtils.exists;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.closeDialog = closeDialog;
        vm.addNewCard = addNewCard;
        vm.assignDueDate = assignDueDate;

        //////////

        /**
         * Close Dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Add New Card
         */
        function addNewCard()
        {
            var newCardId = msUtils.guidGenerator();

            vm.board.cards.push({
                'id'               : newCardId,
                'name'             : vm.newCard.name,
                'description'      : '',
                'idAttachmentCover': '',
                'idMembers'        : [],
                'idLabels'         : [],
                'attachments'      : [],
                'subscribed'       : false,
                'checklists'       : [],
                'checkItems'       : 0,
                'checkItemsChecked': 0,
                'comments'         : [],
                'activities'       : [],
                'due'              : vm.dueDate
            });

            vm.board.lists.getById(vm.newCard.listId).idCards.push(newCardId);

            // Reset the newCard object
            vm.newCard = {
                name: '',
                listId: ''
            };

            closeDialog();
        }

        /**
         * Assign Due Date
         */
        function assignDueDate()
        {
            angular.forEach(vm.selectedCards, function (cardId)
            {
                vm.board.cards.getById(cardId).due = vm.dueDate;
            });

            vm.selectedCards = [];

            closeDialog();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('MembersMenuController', MembersMenuController);

    /** @ngInject */
    function MembersMenuController($document, $mdDialog, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.newMemberSearchInput = '';

        // Methods
        vm.addNewMember = addNewMember;
        vm.removeMember = removeMember;

        ////////

        /**
         * Add New Member
         */
        function addNewMember()
        {
            // Add new member
        }

        /**
         * Remove member
         *
         * @param ev
         * @param memberId
         */
        function removeMember(ev, memberId)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove Member',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove member?',
                ariaLabel          : 'remove member',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });

            $mdDialog.show(confirm).then(function ()
            {
                var arr = vm.board.members;
                arr.splice(arr.indexOf(arr.getById(memberId)), 1);

                angular.forEach(vm.board.cards, function (card)
                {
                    if ( card.idMembers && card.idMembers.indexOf(memberId) > -1 )
                    {
                        card.idMembers.splice(card.idMembers.indexOf(memberId), 1);
                    }
                });
            }, function ()
            {
                // Canceled
            });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('LabelsMenuController', LabelsMenuController);

    /** @ngInject */
    function LabelsMenuController($document, $mdColorPalette, $mdDialog, fuseGenerator, msUtils, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.palettes = $mdColorPalette;
        vm.rgba = fuseGenerator.rgba;
        vm.hue = 500;
        vm.newLabelColor = 'red';
        vm.newLabelName = '';

        // Methods
        vm.addNewLabel = addNewLabel;
        vm.removeLabel = removeLabel;

        ////////

        /**
         * Add New Label
         */
        function addNewLabel()
        {
            vm.board.labels.push({
                id   : msUtils.guidGenerator(),
                name : vm.newLabelName,
                color: vm.newLabelColor
            });
            vm.newLabelName = '';
        }

        /**
         * Remove label
         *
         * @param ev
         * @param labelId
         */
        function removeLabel(ev, labelId)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove Label',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove label?',
                ariaLabel          : 'remove label',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });

            $mdDialog.show(confirm).then(function ()
            {
                var arr = vm.board.labels;
                arr.splice(arr.indexOf(arr.getById(labelId)), 1);

                angular.forEach(vm.board.cards, function (card)
                {
                    if ( card.idLabels && card.idLabels.indexOf(labelId) > -1 )
                    {
                        card.idLabels.splice(card.idLabels.indexOf(labelId), 1);
                    }
                });
            }, function ()
            {
                // Canceled
            });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ColorMenuController', ColorMenuController);

    /** @ngInject */
    function ColorMenuController($mdColorPalette, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.palettes = $mdColorPalette;

        // Methods

        ////////

    }
})();
angular.module('whiteframeDirectiveUsage', ['ngMaterial'])
    .controller('DemoCtrl', function($interval) {
      this.elevation = 1;
      this.showFrame = 3;
      
      this.nextElevation = function() {
        if (++this.elevation == 25) {
          this.elevation = 1;
        }
      };

      $interval(this.nextElevation.bind(this), 500);
      
      this.toggleFrame = function() {
        this.showFrame = this.showFrame == 3 ? -1 : 3;
      };
    });

angular.module('whiteframeDirectiveUsage', ['ngMaterial']);

angular.module('whiteframeBasicUsage', ['ngMaterial']);

(function () {
  'use strict';

    angular
      .module('virtualRepeatVerticalDemo', ['ngMaterial'])
      .controller('AppCtrl', function() {
        this.items = [];
        for (var i = 0; i < 1000; i++) {
          this.items.push(i);
        }
      });

})();

(function () {
  'use strict';

    angular
      .module('virtualRepeatScrollToDemo', ['ngMaterial'])
      .controller('AppCtrl', function($scope) {
        this.selectedYear = 0;
        this.years = [];
        this.items = [];
        var currentYear = new Date().getFullYear();
        var monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
          'July', 'August', 'September', 'October', 'November', 'December'];
        // Build a list of months over 20 years
        for (var y = currentYear; y >= (currentYear-20); y--) {
          this.years.push(y);
          this.items.push({year: y, text: y, header: true});
          for (var m = 11; m >= 0; m--) {
            this.items.push({year: y, month: m, text: monthNames[m]});
          }
        }
        // Whenever a different year is selected, scroll to that year
        $scope.$watch('ctrl.selectedYear', angular.bind(this, function(yearIndex) {
          var scrollYear = Math.floor(this.topIndex / 13);
          if(scrollYear !== yearIndex) {
            this.topIndex = yearIndex * 13;
          }
        }));
        // The selected year should follow the year that is at the top of the scroll container
        $scope.$watch('ctrl.topIndex', angular.bind(this, function(topIndex) {
          var scrollYear = Math.floor(topIndex / 13);
          this.selectedYear = scrollYear;
        }));
      });

})();

(function () {
  'use strict';

    angular
      .module('virtualRepeatInfiniteScrollDemo', ['ngMaterial'])
      .controller('AppCtrl', function($timeout) {

        // In this example, we set up our model using a plain object.
        // Using a class works too. All that matters is that we implement
        // getItemAtIndex and getLength.
        this.infiniteItems = {
          numLoaded_: 0,
          toLoad_: 0,

          // Required.
          getItemAtIndex: function(index) {
            if (index > this.numLoaded_) {
              this.fetchMoreItems_(index);
              return null;
            }

            return index;
          },

          // Required.
          // For infinite scroll behavior, we always return a slightly higher
          // number than the previously loaded items.
          getLength: function() {
            return this.numLoaded_ + 5;
          },

          fetchMoreItems_: function(index) {
            // For demo purposes, we simulate loading more items with a timed
            // promise. In real code, this function would likely contain an
            // $http request.

            if (this.toLoad_ < index) {
              this.toLoad_ += 20;
              $timeout(angular.noop, 300).then(angular.bind(this, function() {
                this.numLoaded_ = this.toLoad_;
              }));
            }
          }
        };
      });

})();

(function () {
  'use strict';

    angular
      .module('virtualRepeatHorizontalDemo', ['ngMaterial'])
      .controller('AppCtrl', function() {
        this.items = [];
        for (var i = 0; i < 1000; i++) {
          this.items.push(i);
        }
      });

})();

(function () {
  'use strict';

    angular
      .module('virtualRepeatDeferredLoadingDemo', ['ngMaterial'])
      .controller('AppCtrl', function($timeout) {

        // In this example, we set up our model using a class.
        // Using a plain object works too. All that matters
        // is that we implement getItemAtIndex and getLength.
        var DynamicItems = function() {
          /**
           * @type {!Object<?Array>} Data pages, keyed by page number (0-index).
           */
          this.loadedPages = {};

          /** @type {number} Total number of items. */
          this.numItems = 0;

          /** @const {number} Number of items to fetch per request. */
          this.PAGE_SIZE = 50;

          this.fetchNumItems_();
        };

        // Required.
        DynamicItems.prototype.getItemAtIndex = function(index) {
          var pageNumber = Math.floor(index / this.PAGE_SIZE);
          var page = this.loadedPages[pageNumber];

          if (page) {
            return page[index % this.PAGE_SIZE];
          } else if (page !== null) {
            this.fetchPage_(pageNumber);
          }
        };

        // Required.
        DynamicItems.prototype.getLength = function() {
          return this.numItems;
        };

        DynamicItems.prototype.fetchPage_ = function(pageNumber) {
          // Set the page to null so we know it is already being fetched.
          this.loadedPages[pageNumber] = null;

          // For demo purposes, we simulate loading more items with a timed
          // promise. In real code, this function would likely contain an
          // $http request.
          $timeout(angular.noop, 300).then(angular.bind(this, function() {
            this.loadedPages[pageNumber] = [];
            var pageOffset = pageNumber * this.PAGE_SIZE;
            for (var i = pageOffset; i < pageOffset + this.PAGE_SIZE; i++) {
              this.loadedPages[pageNumber].push(i);
            }
          }));
        };

        DynamicItems.prototype.fetchNumItems_ = function() {
          // For demo purposes, we simulate loading the item count with a timed
          // promise. In real code, this function would likely contain an
          // $http request.
          $timeout(angular.noop, 300).then(angular.bind(this, function() {
            this.numItems = 50000;
          }));
        };
        
        this.dynamicItems = new DynamicItems();
      });
})();

angular.module('tooltipDemo', ['ngMaterial'])
    .controller('AppCtrl', AppCtrl);

function AppCtrl($scope) {
  $scope.demo = {
    showTooltip: false,
    tipDirection: 'bottom'
  };

  $scope.demo.delayTooltip = undefined;
  $scope.$watch('demo.delayTooltip', function(val) {
    $scope.demo.delayTooltip = parseInt(val, 10) || 0;
  });
}

angular.module('toolbarDemo2', ['ngMaterial'])

.controller('TitleController', function($scope) {
  $scope.title = 'My App Title';
})
.controller('AppCtrl', function($scope) {
  var imagePath = 'assets/angular-material-assets/img/list/60.jpeg';

  $scope.todos = [];
  for (var i = 0; i < 15; i++) {
    $scope.todos.push({
      face: imagePath,
      what: "Brunch this weekend?",
      who: "Min Li Chan",
      notes: "I'll be in your neighborhood doing errands."
    });
  }
});


angular.module('toolbarDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

});

(function() {

  var isDlgOpen;

  angular
    .module('toastDemo2', ['ngMaterial'])
    .controller('AppCtrl', function($scope, $mdToast) {
      $scope.showCustomToast = function() {
        $mdToast.show({
          hideDelay   : 3000,
          position    : 'top right',
          controller  : 'ToastCtrl',
          templateUrl : 'toast-template.html'
        });
      };
    })
    .controller('ToastCtrl', function($scope, $mdToast, $mdDialog) {

      $scope.closeToast = function() {
        if (isDlgOpen) return;

        $mdToast
          .hide()
          .then(function() {
            isDlgOpen = false;
          });
      };

      $scope.openMoreInfo = function(e) {
        if ( isDlgOpen ) return;
        isDlgOpen = true;

        $mdDialog
          .show($mdDialog
            .alert()
            .title('More info goes here.')
            .textContent('Something witty.')
            .ariaLabel('More info')
            .ok('Got it')
            .targetEvent(e)
          )
          .then(function() {
            isDlgOpen = false;
          });
      };
    });

})();


angular.module('toastDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope, $mdToast) {
  var last = {
      bottom: false,
      top: true,
      left: false,
      right: true
    };

  $scope.toastPosition = angular.extend({},last);

  $scope.getToastPosition = function() {
    sanitizePosition();

    return Object.keys($scope.toastPosition)
      .filter(function(pos) { return $scope.toastPosition[pos]; })
      .join(' ');
  };

  function sanitizePosition() {
    var current = $scope.toastPosition;

    if ( current.bottom && last.top ) current.top = false;
    if ( current.top && last.bottom ) current.bottom = false;
    if ( current.right && last.left ) current.left = false;
    if ( current.left && last.right ) current.right = false;

    last = angular.extend({},current);
  }

  $scope.showSimpleToast = function() {
    var pinTo = $scope.getToastPosition();

    $mdToast.show(
      $mdToast.simple()
        .textContent('Simple Toast!')
        .position(pinTo )
        .hideDelay(3000)
    );
  };

  $scope.showActionToast = function() {
    var pinTo = $scope.getToastPosition();
    var toast = $mdToast.simple()
      .textContent('Marked as read')
      .action('UNDO')
      .highlightAction(true)
      .highlightClass('md-accent')// Accent is used by default, this just demonstrates the usage.
      .position(pinTo);

    $mdToast.show(toast).then(function(response) {
      if ( response == 'ok' ) {
        alert('You clicked the \'UNDO\' action.');
      }
    });
  };

})

.controller('ToastCtrl', function($scope, $mdToast) {
  $scope.closeToast = function() {
    $mdToast.hide();
  };
});

(function () {
  'use strict';
  angular
      .module('tabsDemoDynamicTabs', ['ngMaterial'])
      .controller('AppCtrl', AppCtrl);

  function AppCtrl ($scope, $log) {
    var tabs = [
          { title: 'One', content: "Tabs will become paginated if there isn't enough room for them."},
          { title: 'Two', content: "You can swipe left and right on a mobile device to change tabs."},
          { title: 'Three', content: "You can bind the selected tab via the selected attribute on the md-tabs element."},
          { title: 'Four', content: "If you set the selected tab binding to -1, it will leave no tab selected."},
          { title: 'Five', content: "If you remove a tab, it will try to select a new one."},
          { title: 'Six', content: "There's an ink bar that follows the selected tab, you can turn it off if you want."},
          { title: 'Seven', content: "If you set ng-disabled on a tab, it becomes unselectable. If the currently selected tab becomes disabled, it will try to select the next tab."},
          { title: 'Eight', content: "If you look at the source, you're using tabs to look at a demo for tabs. Recursion!"},
          { title: 'Nine', content: "If you set md-theme=\"green\" on the md-tabs element, you'll get green tabs."},
          { title: 'Ten', content: "If you're still reading this, you should just go check out the API docs for tabs!"}
        ],
        selected = null,
        previous = null;
    $scope.tabs = tabs;
    $scope.selectedIndex = 2;
    $scope.$watch('selectedIndex', function(current, old){
      previous = selected;
      selected = tabs[current];
      if ( old + 1 && (old != current)) $log.debug('Goodbye ' + previous.title + '!');
      if ( current + 1 )                $log.debug('Hello ' + selected.title + '!');
    });
    $scope.addTab = function (title, view) {
      view = view || title + " Content View";
      tabs.push({ title: title, content: view, disabled: false});
    };
    $scope.removeTab = function (tab) {
      var index = tabs.indexOf(tab);
      tabs.splice(index, 1);
    };
  }
})();


(function () {
  'use strict';

  angular
      .module('tabsDemoIconTabs', ['ngMaterial'] )
      .config(function($mdIconProvider) {
        $mdIconProvider
          .iconSet('communication', 'assets/angular-material-assets/img/icons/sets/communication-icons.svg')
          .icon('favorite', 'assets/angular-material-assets/img/icons/favorite.svg');
      })
      .controller('AppCtrl', AppCtrl);

  function AppCtrl ( $scope ) {
    $scope.data = {
      selectedIndex: 0,
      secondLocked:  true,
      secondLabel:   "Item Two",
      bottom:        false
    };
    $scope.next = function() {
      $scope.data.selectedIndex = Math.min($scope.data.selectedIndex + 1, 2) ;
    };
    $scope.previous = function() {
      $scope.data.selectedIndex = Math.max($scope.data.selectedIndex - 1, 0);
    };
  }
})();

angular.module('tabsDemoDynamicHeight', ['ngMaterial']);
angular.module('switchDemo1', ['ngMaterial'])
.controller('SwitchDemoCtrl', function($scope) {
  $scope.data = {
    cb1: true,
    cb4: true,
    cb5: false
  };

  $scope.message = 'false';

  $scope.onChange = function(cbState) {
  	$scope.message = cbState;
  };
});

angular.module('demoSwipe', ['ngMaterial'])
  .controller('demoSwipeCtrl', function($scope) {
    $scope.onSwipeLeft = function(ev) {
      alert('You swiped left!!');
    };

    $scope.onSwipeRight = function(ev) {
      alert('You swiped right!!');
    };
    $scope.onSwipeUp = function(ev) {
      alert('You swiped up!!');
    };

    $scope.onSwipeDown = function(ev) {
      alert('You swiped down!!');
    };
  });


angular.module('subheaderBasicDemo', ['ngMaterial'])
.config(function($mdThemingProvider) {
  $mdThemingProvider.theme('altTheme')
    .primaryPalette('purple');
})
.controller('SubheaderAppCtrl', function($scope) {
    var imagePath = 'assets/angular-material-assets/img/list/60.jpeg';
    $scope.messages = [
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
    ];
});


angular.module('sliderDemo1', ['ngMaterial'])
  .config(function($mdIconProvider) {
    $mdIconProvider
      .iconSet('device', 'assets/angular-material-assets/img/icons/sets/device-icons.svg', 24);
  })
.controller('AppCtrl', function($scope) {

  $scope.color = {
    red: Math.floor(Math.random() * 255),
    green: Math.floor(Math.random() * 255),
    blue: Math.floor(Math.random() * 255)
  };

  $scope.rating1 = 3;
  $scope.rating2 = 2;
  $scope.rating3 = 4;

  $scope.disabled1 = Math.floor(Math.random() * 100);
  $scope.disabled2 = 0;
  $scope.disabled3 = 70;

  $scope.invert = Math.floor(Math.random() * 100);

  $scope.isDisabled = true;
});


angular.module('sliderDemo2', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

  $scope.vol = Math.floor(Math.random() * 100);
  $scope.bass = Math.floor(Math.random() * 100);
  $scope.master = Math.floor(Math.random() * 100);
});

angular
  .module('sidenavDemo2', ['ngMaterial'])
  .controller('AppCtrl', function ($scope, $timeout, $mdSidenav) {
    $scope.toggleLeft = buildToggler('left');
    $scope.toggleRight = buildToggler('right');

    function buildToggler(componentId) {
      return function() {
        $mdSidenav(componentId).toggle();
      };
    }
  });

angular
  .module('sidenavDemo1', ['ngMaterial'])
  .controller('AppCtrl', function ($scope, $timeout, $mdSidenav, $log) {
    $scope.toggleLeft = buildDelayedToggler('left');
    $scope.toggleRight = buildToggler('right');
    $scope.isOpenRight = function(){
      return $mdSidenav('right').isOpen();
    };

    /**
     * Supplies a function that will continue to operate until the
     * time is up.
     */
    function debounce(func, wait, context) {
      var timer;

      return function debounced() {
        var context = $scope,
            args = Array.prototype.slice.call(arguments);
        $timeout.cancel(timer);
        timer = $timeout(function() {
          timer = undefined;
          func.apply(context, args);
        }, wait || 10);
      };
    }

    /**
     * Build handler to open/close a SideNav; when animation finishes
     * report completion in console
     */
    function buildDelayedToggler(navID) {
      return debounce(function() {
        // Component lookup should always be available since we are not using `ng-if`
        $mdSidenav(navID)
          .toggle()
          .then(function () {
            $log.debug("toggle " + navID + " is done");
          });
      }, 200);
    }

    function buildToggler(navID) {
      return function() {
        // Component lookup should always be available since we are not using `ng-if`
        $mdSidenav(navID)
          .toggle()
          .then(function () {
            $log.debug("toggle " + navID + " is done");
          });
      };
    }
  })
  .controller('LeftCtrl', function ($scope, $timeout, $mdSidenav, $log) {
    $scope.close = function () {
      // Component lookup should always be available since we are not using `ng-if`
      $mdSidenav('left').close()
        .then(function () {
          $log.debug("close LEFT is done");
        });

    };
  })
  .controller('RightCtrl', function ($scope, $timeout, $mdSidenav, $log) {
    $scope.close = function () {
      // Component lookup should always be available since we are not using `ng-if`
      $mdSidenav('right').close()
        .then(function () {
          $log.debug("close RIGHT is done");
        });
    };
  });

angular
    .module('selectDemoSelectedText', ['ngMaterial'])
    .controller('SelectedTextController', function($scope) {
      $scope.items = [1, 2, 3, 4, 5, 6, 7];
      $scope.selectedItem;
      $scope.getSelectedText = function() {
        if ($scope.selectedItem !== undefined) {
          return "You have selected: Item " + $scope.selectedItem;
        } else {
          return "Please select an item";
        }
      };
    });

angular.module('selectDemoValidation', ['ngMaterial', 'ngMessages'])
.controller('AppCtrl', function($scope) {
  $scope.clearValue = function() {
    $scope.quest = undefined;
    $scope.favoriteColor = undefined;
    $scope.myForm.$setPristine();
  };
  $scope.save = function() {
    if ($scope.myForm.$valid) {
      $scope.myForm.$setSubmitted();
      alert('Form was valid.');
    } else {
      alert('Form was invalid!');
    }
  };
});

angular
    .module('selectDemoSelectHeader', ['ngMaterial'])
    .controller('SelectHeaderController', function($scope, $element) {
      $scope.vegetables = ['Corn' ,'Onions' ,'Kale' ,'Arugula' ,'Peas', 'Zucchini'];
      $scope.searchTerm;
      $scope.clearSearchTerm = function() {
        $scope.searchTerm = '';
      };
      // The md-select directive eats keydown events for some quick select
      // logic. Since we have a search input here, we don't need that logic.
      $element.find('input').on('keydown', function(ev) {
          ev.stopPropagation();
      });
    });

angular.module('selectDemoOptionsAsync', ['ngMaterial'])
.controller('SelectAsyncController', function($timeout, $scope) {
  $scope.user = null;
  $scope.users = null;

  $scope.loadUsers = function() {

    // Use timeout to simulate a 650ms request.
    return $timeout(function() {

      $scope.users =  $scope.users  || [
        { id: 1, name: 'Scooby Doo' },
        { id: 2, name: 'Shaggy Rodgers' },
        { id: 3, name: 'Fred Jones' },
        { id: 4, name: 'Daphne Blake' },
        { id: 5, name: 'Velma Dinkley' }
      ];

    }, 650);
  };
});

angular
    .module('selectDemoOptGroups', ['ngMaterial'])
    .controller('SelectOptGroupController', function($scope) {
      $scope.sizes = [
          "small (12-inch)",
          "medium (14-inch)",
          "large (16-inch)",
          "insane (42-inch)"
      ];
      $scope.toppings = [
        { category: 'meat', name: 'Pepperoni' },
        { category: 'meat', name: 'Sausage' },
        { category: 'meat', name: 'Ground Beef' },
        { category: 'meat', name: 'Bacon' },
        { category: 'veg', name: 'Mushrooms' },
        { category: 'veg', name: 'Onion' },
        { category: 'veg', name: 'Green Pepper' },
        { category: 'veg', name: 'Green Olives' }
      ];
      $scope.selectedToppings = [];
      $scope.printSelectedToppings = function printSelectedToppings() {
        var numberOfToppings = this.selectedToppings.length;

        // If there is more than one topping, we add an 'and'
        // to be gramatically correct. If there are 3+ toppings
        // we also add an oxford comma.
        if (numberOfToppings > 1) {
          var needsOxfordComma = numberOfToppings > 2;
          var lastToppingConjunction = (needsOxfordComma ? ',' : '') + ' and ';
          var lastTopping = lastToppingConjunction +
              this.selectedToppings[this.selectedToppings.length - 1];
          return this.selectedToppings.slice(0, -1).join(', ') + lastTopping;
        }

        return this.selectedToppings.join('');
      };
    });

(function () {
  'use strict';
  angular
      .module('selectDemoBasic', ['ngMaterial'])
      .controller('AppCtrl', function() {
        this.userState = '';
        this.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
            'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
            'WY').split(' ').map(function (state) { return { abbrev: state }; });
      });
})();

angular.module('progressLinearDemo1', ['ngMaterial'])
  .config(function($mdThemingProvider) {
  })
  .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
    var self = this, j= 0, counter = 0;

    self.mode = 'query';
    self.activated = true;
    self.determinateValue = 30;
    self.determinateValue2 = 30;

    self.showList = [ ];

    /**
     * Turn off or on the 5 themed loaders
     */
    self.toggleActivation = function() {
        if ( !self.activated ) self.showList = [ ];
        if (  self.activated ) {
          j = counter = 0;
          self.determinateValue = 30;
          self.determinateValue2 = 30;
        }
    };

    $interval(function() {
      self.determinateValue += 1;
      self.determinateValue2 += 1.5;

      if (self.determinateValue > 100) self.determinateValue = 30;
      if (self.determinateValue2 > 100) self.determinateValue2 = 30;

        // Incrementally start animation the five (5) Indeterminate,
        // themed progress circular bars

        if ( (j < 2) && !self.showList[j] && self.activated ) {
          self.showList[j] = true;
        }
        if ( counter++ % 4 === 0 ) j++;

        // Show the indicator in the "Used within Containers" after 200ms delay
        if ( j == 2 ) self.contained = "indeterminate";

    }, 100, 0, true);

    $interval(function() {
      self.mode = (self.mode == 'query' ? 'determinate' : 'query');
    }, 7200, 0, true);
  }]);

angular
  .module('progressCircularDemo1', ['ngMaterial'], function($mdThemingProvider) {
    $mdThemingProvider.theme('docs-dark', 'default')
      .primaryPalette('yellow')
      .dark();
  })
  .controller('AppCtrl', ['$interval',
    function($interval) {
      var self = this;

      self.activated = true;
      self.determinateValue = 30;

      // Iterate every 100ms, non-stop and increment
      // the Determinate loader.
      $interval(function() {

        self.determinateValue += 1;
        if (self.determinateValue > 100) {
          self.determinateValue = 30;
        }

      }, 100);
    }
  ]);

angular
  .module('radioDemo2', ['ngMaterial'])
  .controller('ContactController', function($scope, $filter) {
    var self = this;

    self.contacts = [{
      'id': 1,
      'fullName': 'Maria Guadalupe',
      'lastName': 'Guadalupe',
      'title': "CEO, Found"
    }, {
      'id': 2,
      'fullName': 'Gabriel García Marquéz',
      'lastName': 'Marquéz',
      'title': "VP Sales & Marketing"
    }, {
      'id': 3,
      'fullName': 'Miguel de Cervantes',
      'lastName': 'Cervantes',
      'title': "Manager, Operations"
    }, {
      'id': 4,
      'fullName': 'Pacorro de Castel',
      'lastName': 'Castel',
      'title': "Security"
    }];
    self.selectedId = 2;
    self.selectedUser = function() {
      return $filter('filter')(self.contacts, { id: self.selectedId })[0].lastName;
    };
  });


angular
  .module('radioDemo1', ['ngMaterial'])
  .controller('AppCtrl', function($scope) {

    $scope.data = {
      group1 : 'Banana',
      group2 : '2',
      group3 : 'avatar-1'
    };

    $scope.avatarData = [{
        id: "avatars:svg-1",
        title: 'avatar 1',
        value: 'avatar-1'
      },{
        id: "avatars:svg-2",
        title: 'avatar 2',
        value: 'avatar-2'
      },{
        id: "avatars:svg-3",
        title: 'avatar 3',
        value: 'avatar-3'
    }];

    $scope.radioData = [
      { label: '1', value: 1 },
      { label: '2', value: 2 },
      { label: '3', value: '3', isDisabled: true },
      { label: '4', value: '4' }
    ];


    $scope.submit = function() {
      alert('submit');
    };

    $scope.addItem = function() {
      var r = Math.ceil(Math.random() * 1000);
      $scope.radioData.push({ label: r, value: r });
    };

    $scope.removeItem = function() {
      $scope.radioData.pop();
    };

  })
  .config(function($mdIconProvider) {
    $mdIconProvider.iconSet("avatars", 'assets/angular-material-assets/icons//avatar-icons.svg',128);
  });

(function() {
  'use strict';

  angular
      .module('panelProviderDemo', ['ngMaterial'])
      .config(PanelProviderConfig)
      .controller('PanelProviderCtrl', PanelProviderCtrl)
      .controller('PanelMenuCtrl', PanelMenuCtrl);

  /**
   * Configuration method that is used to define a preset for the upcoming panel
   * element. Each parameter in the preset is an available parameter in the
   * `$mdPanel.create` and `$mdPanel.open` methods. When the parameters are
   * defined here, they overwrite the default parameters for any panel that the
   * preset is requested for.
   * @param {!MdPanelProvider} $mdPanelProvider Provider method of the MdPanel
   *     API.
   */
  function PanelProviderConfig($mdPanelProvider) {
    $mdPanelProvider.definePreset('demoPreset', {
      attachTo: angular.element(document.body),
      controller: PanelMenuCtrl,
      controllerAs: 'ctrl',
      template: '' +
          '<div class="menu-panel" md-whiteframe="4">' +
          '  <div class="menu-content">' +
          '    <div class="menu-item" ng-repeat="item in ctrl.items">' +
          '      <button class="md-button">' +
          '        <span>{{item}}</span>' +
          '      </button>' +
          '    </div>' +
          '    <md-divider></md-divider>' +
          '    <div class="menu-item">' +
          '      <button class="md-button" ng-click="ctrl.closeMenu()">' +
          '        <span>Close Menu</span>' +
          '      </button>' +
          '    </div>' +
          '  </div>' +
          '</div>',
      panelClass: 'menu-panel-container',
      focusOnOpen: false,
      zIndex: 100,
      propagateContainerEvents: true,
      groupName: 'menus'
    });
  }

  function PanelProviderCtrl($mdPanel) {
    this.navigation = {
      name: 'navigation',
      items: [
        'Home',
        'About',
        'Contact'
      ]
    };
    this.favorites = {
      name: 'favorites',
      items: [
        'Add to Favorites'
      ]
    };
    this.more = {
      name: 'more',
      items: [
        'Account',
        'Sign Out'
      ]
    };

    $mdPanel.newPanelGroup('menus', {
      maxOpen: 2
    });

    this.showMenu = function($event, menu) {
      /**
       * The request to open the panel has two arguments passed into it. The
       * first is a preset name passed in as a string. This will request a
       * cached preset and apply its configuration parameters. The second is an
       * object containing parameters that can only be filled through a
       * controller. These parameters represent configuration needs associated
       * with user interaction, panel position, panel animation, and other
       * miscellaneous needs.
       */
      $mdPanel.open('demoPreset', {
        id: 'menu_' + menu.name,
        position: $mdPanel.newPanelPosition()
            .relativeTo($event.srcElement)
            .addPanelPosition(
              $mdPanel.xPosition.ALIGN_START,
              $mdPanel.yPosition.BELOW
            ),
        locals: {
          items: menu.items
        },
        openFrom: $event
      });
    };
  }

  function PanelMenuCtrl(mdPanelRef) {
    this.closeMenu = function() {
      mdPanelRef && mdPanelRef.close();
    };
  }
})();

(function() {
'use strict';

angular.module('panelAnimationsDemo', ['ngMaterial'])
    .controller('AnimationCtrl', AnimationCtrl)
    .controller('DialogCtrl', DialogCtrl);


function AnimationCtrl($mdPanel) {
  this._mdPanel = $mdPanel;
  this.openFrom = 'button';
  this.closeTo = 'button';
  this.animationType = 'scale';
  this.duration = 300;
  this.separateDurations = {
    open: this.duration,
    close: this.duration
  };
}


AnimationCtrl.prototype.showDialog = function() {
  var position = this._mdPanel.newPanelPosition()
      .absolute()
      .right()
      .top();

  var animation = this._mdPanel.newPanelAnimation();

  animation.duration(this.duration || this.separateDurations);

  switch(this.openFrom) {
    case 'button':
      animation.openFrom('.animation-target');
      break;
    case 'corner':
      animation.openFrom({top:0, left:0});
      break;
    case 'bottom':
      animation.openFrom({
        top: document.documentElement.clientHeight,
        left: document.documentElement.clientWidth / 2 - 250
      });
  }
  switch(this.closeTo) {
    case 'button':
      animation.closeTo('.animation-target');
      break;
    case 'corner':
      animation.closeTo({top:0, left:0});
      break;
    case 'bottom':
      animation.closeTo({
        top: document.documentElement.clientHeight,
        left: document.documentElement.clientWidth / 2 - 250
      });
  }

  switch(this.animationType) {
    case 'custom':
      animation.withAnimation({
        open: 'demo-dialog-custom-animation-open',
        close: 'demo-dialog-custom-animation-close'
      });
      break;
    case 'slide':
      animation.withAnimation(this._mdPanel.animation.SLIDE);
      break;
    case 'scale':
      animation.withAnimation(this._mdPanel.animation.SCALE);
      break;
    case 'fade':
      animation.withAnimation(this._mdPanel.animation.FADE);
      break;
    case 'none':
      animation = undefined;
      break;
  }

  var config = {
    animation: animation,
    attachTo: angular.element(document.body),
    controller: DialogCtrl,
    controllerAs: 'ctrl',
    templateUrl: 'panel.tmpl.html',
    panelClass: 'demo-dialog-example',
    position: position,
    trapFocus: true,
    zIndex: 150,
    clickOutsideToClose: true,
    clickEscapeToClose: true,
    hasBackdrop: true,
  };

  this._mdPanel.open(config);
};


// Necessary to pass locals to the dialog template.
function DialogCtrl(mdPanelRef) {
  this._mdPanelRef = mdPanelRef;
}

DialogCtrl.prototype.closeDialog = function() {
  this._mdPanelRef && this._mdPanelRef.close();
};

})();

(function() {
  'use strict';

  angular
    .module('panelGroupsDemo', ['ngMaterial'])
    .controller('PanelGroupsCtrl', PanelGroupsCtrl)
    .controller('PanelMenuCtrl', PanelMenuCtrl);

  function PanelGroupsCtrl($mdPanel) {
    this.settings = {
      name: 'settings',
      items: [
        'Home',
        'About',
        'Contact'
      ]
    };
    this.favorite = {
      name: 'favorite',
      items: [
        'Add to Favorites'
      ]
    };
    this.more = {
      name: 'more',
      items: [
        'Account',
        'Sign Out'
      ]
    };
    this.tools = {
      name: 'tools',
      items: [
        'Create',
        'Delete'
      ]
    };
    this.code = {
      name: 'code',
      items: [
        'See Source',
        'See Commits'
      ]
    };

    this.menuTemplate = '' +
        '<div class="menu-panel" md-whiteframe="4">' +
        '  <div class="menu-content">' +
        '    <div class="menu-item" ng-repeat="item in ctrl.items">' +
        '      <button class="md-button">' +
        '        <span>{{item}}</span>' +
        '      </button>' +
        '    </div>' +
        '    <md-divider></md-divider>' +
        '    <div class="menu-item">' +
        '      <button class="md-button" ng-click="ctrl.closeMenu()">' +
        '        <span>Close Menu</span>' +
        '      </button>' +
        '    </div>' +
        '  </div>' +
        '</div>';

    $mdPanel.newPanelGroup('toolbar', {
      maxOpen: 2
    });

    $mdPanel.newPanelGroup('menus', {
      maxOpen: 3
    });

    this.showToolbarMenu = function($event, menu) {
      var template = this.menuTemplate;

      var position = $mdPanel.newPanelPosition()
          .relativeTo($event.srcElement)
          .addPanelPosition(
            $mdPanel.xPosition.ALIGN_START,
            $mdPanel.yPosition.BELOW
          );

      var config = {
        id: 'toolbar_' + menu.name,
        attachTo: angular.element(document.body),
        controller: PanelMenuCtrl,
        controllerAs: 'ctrl',
        template: template,
        position: position,
        panelClass: 'menu-panel-container',
        locals: {
          items: menu.items
        },
        openFrom: $event,
        focusOnOpen: false,
        zIndex: 100,
        propagateContainerEvents: true,
        groupName: ['toolbar', 'menus']
      };

      $mdPanel.open(config);
    };

    this.showContentMenu = function($event, menu) {
      var template = this.menuTemplate;

      var position = $mdPanel.newPanelPosition()
          .relativeTo($event.srcElement)
          .addPanelPosition(
            $mdPanel.xPosition.ALIGN_START,
            $mdPanel.yPosition.BELOW
          );

      var config = {
        id: 'content_' + menu.name,
        attachTo: angular.element(document.body),
        controller: PanelMenuCtrl,
        controllerAs: 'ctrl',
        template: template,
        position: position,
        panelClass: 'menu-panel-container',
        locals: {
          items: menu.items
        },
        openFrom: $event,
        focusOnOpen: false,
        zIndex: 100,
        propagateContainerEvents: true,
        groupName: 'menus'
      };

      $mdPanel.open(config);
    };
  }

  function PanelMenuCtrl(mdPanelRef) {
    this.closeMenu = function() {
      mdPanelRef && mdPanelRef.close();
    }
  }
})();

(function() {
'use strict';

angular.module('panelDemo', ['ngMaterial'])
    .controller('BasicDemoCtrl', BasicDemoCtrl)
    .controller('PanelDialogCtrl', PanelDialogCtrl);


function BasicDemoCtrl($mdPanel) {
  this._mdPanel = $mdPanel;

  this.desserts = [
    'Apple Pie',
    'Donut',
    'Fudge',
    'Cupcake',
    'Ice Cream',
    'Tiramisu'
  ];

  this.selected = {favoriteDessert: 'Donut'};
  this.disableParentScroll = false;
}


BasicDemoCtrl.prototype.showDialog = function() {
  var position = this._mdPanel.newPanelPosition()
      .absolute()
      .center();

  var config = {
    attachTo: angular.element(document.body),
    controller: PanelDialogCtrl,
    controllerAs: 'ctrl',
    disableParentScroll: this.disableParentScroll,
    templateUrl: 'panel.tmpl.html',
    hasBackdrop: true,
    panelClass: 'demo-dialog-example',
    position: position,
    trapFocus: true,
    zIndex: 150,
    clickOutsideToClose: true,
    escapeToClose: true,
    focusOnOpen: true
  };

  this._mdPanel.open(config);
};


BasicDemoCtrl.prototype.showMenu = function(ev) {
  var position = this._mdPanel.newPanelPosition()
      .relativeTo('.demo-menu-open-button')
      .addPanelPosition(this._mdPanel.xPosition.ALIGN_START, this._mdPanel.yPosition.BELOW);

  var config = {
    attachTo: angular.element(document.body),
    controller: PanelMenuCtrl,
    controllerAs: 'ctrl',
    template:
        '<div class="demo-menu-example" ' +
        '     aria-label="Select your favorite dessert." ' +
        '     role="listbox">' +
        '  <div class="demo-menu-item" ' +
        '       ng-class="{selected : dessert == ctrl.favoriteDessert}" ' +
        '       aria-selected="{{dessert == ctrl.favoriteDessert}}" ' +
        '       tabindex="-1" ' +
        '       role="option" ' +
        '       ng-repeat="dessert in ctrl.desserts" ' +
        '       ng-click="ctrl.selectDessert(dessert)"' +
        '       ng-keydown="ctrl.onKeydown($event, dessert)">' +
        '    {{ dessert }} ' +
        '  </div>' +
        '</div>',
    panelClass: 'demo-menu-example',
    position: position,
    locals: {
      'selected': this.selected,
      'desserts': this.desserts
    },
    openFrom: ev,
    clickOutsideToClose: true,
    escapeToClose: true,
    focusOnOpen: false,
    zIndex: 2
  };

  this._mdPanel.open(config);
};


function PanelDialogCtrl(mdPanelRef) {
  this._mdPanelRef = mdPanelRef;
}


PanelDialogCtrl.prototype.closeDialog = function() {
  var panelRef = this._mdPanelRef;

  panelRef && panelRef.close().then(function() {
    angular.element(document.querySelector('.demo-dialog-open-button')).focus();
    panelRef.destroy();
  });
};



function PanelMenuCtrl(mdPanelRef, $timeout) {
  this._mdPanelRef = mdPanelRef;
  this.favoriteDessert = this.selected.favoriteDessert;
  $timeout(function() {
    var selected = document.querySelector('.demo-menu-item.selected');
    if (selected) {
      angular.element(selected).focus();
    } else {
      angular.element(document.querySelectorAll('.demo-menu-item')[0]).focus();
    }
  });
}


PanelMenuCtrl.prototype.selectDessert = function(dessert) {
  this.selected.favoriteDessert = dessert;
  this._mdPanelRef && this._mdPanelRef.close().then(function() {
    angular.element(document.querySelector('.demo-menu-open-button')).focus();
  });
};


PanelMenuCtrl.prototype.onKeydown = function($event, dessert) {
  var handled, els, index, prevIndex, nextIndex;
  switch ($event.which) {
    case 38: // Up Arrow.
      els = document.querySelectorAll('.demo-menu-item');
      index = indexOf(els, document.activeElement);
      prevIndex = (index + els.length - 1) % els.length;
      els[prevIndex].focus();
      handled = true;
      break;

    case 40: // Down Arrow.
      els = document.querySelectorAll('.demo-menu-item');
      index = indexOf(els, document.activeElement);
      nextIndex = (index + 1) % els.length;
      els[nextIndex].focus();
      handled = true;
      break;

    case 13: // Enter.
    case 32: // Space.
      this.selectDessert(dessert);
      handled = true;
      break;

    case 9: // Tab.
      this._mdPanelRef && this._mdPanelRef.close();
  }

  if (handled) {
    $event.preventDefault();
    $event.stopImmediatePropagation();
  }

  function indexOf(nodeList, element) {
    for (var item, i = 0; item = nodeList[i]; i++) {
      if (item === element) {
        return i;
      }
    }
    return -1;
  }
};

})();

(function() {
  'use strict';

  angular.module('navBarDemoBasicUsage', ['ngMaterial'])
      .controller('AppCtrl', AppCtrl);

  function AppCtrl($scope) {
    $scope.currentNavItem = 'page1';
  }
})();

angular
  .module('menuBarDemoBasic', ['ngMaterial'])
  .config(function($mdIconProvider) {
    $mdIconProvider
      .defaultIconSet('assets/angular-material-assets/img/icons/sets/core-icons.svg', 24);
  })
  .filter('keyboardShortcut', function($window) {
    return function(str) {
      if (!str) return;
      var keys = str.split('-');
      var isOSX = /Mac OS X/.test($window.navigator.userAgent);

      var seperator = (!isOSX || keys.length > 2) ? '+' : '';

      var abbreviations = {
        M: isOSX ? '⌘' : 'Ctrl',
        A: isOSX ? 'Option' : 'Alt',
        S: 'Shift'
      };

      return keys.map(function(key, index) {
        var last = index == keys.length - 1;
        return last ? key : abbreviations[key];
      }).join(seperator);
    };
  })
  .controller('DemoBasicCtrl', function DemoCtrl($mdDialog) {
    this.settings = {
      printLayout: true,
      showRuler: true,
      showSpellingSuggestions: true,
      presentationMode: 'edit'
    };

    this.sampleAction = function(name, ev) {
      $mdDialog.show($mdDialog.alert()
        .title(name)
        .textContent('You triggered the "' + name + '" action')
        .ok('Great')
        .targetEvent(ev)
      );
    };
  });


angular.module('menuDemoWidth', ['ngMaterial']).config(function($mdIconProvider) {
  $mdIconProvider
    .iconSet("call", 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24)
    .iconSet("social", 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24);
}).controller('WidthDemoCtrl', function($mdDialog) {
  var vm = this;

  this.announceClick = function(index) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('You clicked!')
        .textContent('You clicked the menu item at index ' + index)
        .ok('Nice')
    );
  };
});

angular
  .module('menuDemoPosition', ['ngMaterial'])
  .config(function($mdIconProvider) {
    $mdIconProvider
      .iconSet("call", 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24)
      .iconSet("social", 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24);
  })
  .controller('PositionDemoCtrl', function DemoCtrl($mdDialog) {
    var originatorEv;

    this.menuHref = "http://www.google.com/design/spec/components/menus.html#menus-specs";

    this.openMenu = function($mdMenu, ev) {
      originatorEv = ev;
      $mdMenu.open(ev);
    };

    this.announceClick = function(index) {
      $mdDialog.show(
        $mdDialog.alert()
          .title('You clicked!')
          .textContent('You clicked the menu item at index ' + index)
          .ok('Nice')
          .targetEvent(originatorEv)
      );
      originatorEv = null;
    };
  });



angular
  .module('menuDemoCustomTrigger', ['ngMaterial'])
  .config(function($mdIconProvider) {
    $mdIconProvider
      .iconSet('call', 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24);
  });

angular
  .module('menuDemoBasic', ['ngMaterial'])
  .config(function($mdIconProvider) {
    $mdIconProvider
      .iconSet("call", 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24)
      .iconSet("social", 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24);
  })
  .controller('BasicDemoCtrl', function DemoCtrl($mdDialog) {
    var originatorEv;

    this.openMenu = function($mdMenu, ev) {
      originatorEv = ev;
      $mdMenu.open(ev);
    };

    this.notificationsEnabled = true;
    this.toggleNotifications = function() {
      this.notificationsEnabled = !this.notificationsEnabled;
    };

    this.redial = function() {
      $mdDialog.show(
        $mdDialog.alert()
          .targetEvent(originatorEv)
          .clickOutsideToClose(true)
          .parent('body')
          .title('Suddenly, a redial')
          .textContent('You just called a friend; who told you the most amazing story. Have a cookie!')
          .ok('That was easy')
      );

      originatorEv = null;
    };

    this.checkVoicemail = function() {
      // This never happens.
    };
  });

angular.module('listDemo2', ['ngMaterial'])
.config(function($mdIconProvider) {
  $mdIconProvider
    .iconSet('social', 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24)
    .iconSet('device', 'assets/angular-material-assets/img/icons/sets/device-icons.svg', 24)
    .iconSet('communication', 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24)
    .defaultIconSet('assets/angular-material-assets/img/icons/sets/core-icons.svg', 24);
})
.controller('ListCtrl', function($scope, $mdDialog) {
  $scope.toppings = [
    { name: 'Pepperoni', wanted: true },
    { name: 'Sausage', wanted: false },
    { name: 'Black Olives', wanted: true },
    { name: 'Green Peppers', wanted: false }
  ];

  $scope.settings = [
    { name: 'Wi-Fi', extraScreen: 'Wi-fi menu', icon: 'device:network-wifi', enabled: true },
    { name: 'Bluetooth', extraScreen: 'Bluetooth menu', icon: 'device:bluetooth', enabled: false },
  ];

  $scope.messages = [
    {id: 1, title: "Message A", selected: false},
    {id: 2, title: "Message B", selected: true},
    {id: 3, title: "Message C", selected: true},
  ];

  $scope.people = [
    { name: 'Janet Perkins', img: 'assets/angular-material-assets/img/100-0.jpeg', newMessage: true },
    { name: 'Mary Johnson', img: 'assets/angular-material-assets/img/100-1.jpeg', newMessage: false },
    { name: 'Peter Carlsson', img: 'assets/angular-material-assets/img/100-2.jpeg', newMessage: false }
  ];

  $scope.goToPerson = function(person, event) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('Navigating')
        .textContent('Inspect ' + person)
        .ariaLabel('Person inspect demo')
        .ok('Neat!')
        .targetEvent(event)
    );
  };

  $scope.navigateTo = function(to, event) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('Navigating')
        .textContent('Imagine being taken to ' + to)
        .ariaLabel('Navigation demo')
        .ok('Neat!')
        .targetEvent(event)
    );
  };

  $scope.doPrimaryAction = function(event) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('Primary Action')
        .textContent('Primary actions can be used for one click actions')
        .ariaLabel('Primary click demo')
        .ok('Awesome!')
        .targetEvent(event)
    );
  };

  $scope.doSecondaryAction = function(event) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('Secondary Action')
        .textContent('Secondary actions can be used for one click actions')
        .ariaLabel('Secondary click demo')
        .ok('Neat!')
        .targetEvent(event)
    );
  };

});


angular.module('listDemo1', ['ngMaterial'])
.config(function($mdIconProvider) {
  $mdIconProvider
    .iconSet('communication', 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24);
})
.controller('AppCtrl', function($scope) {
    var imagePath = 'assets/angular-material-assets/img/list/60.jpeg';

    $scope.phones = [
      {
        type: 'Home',
        number: '(555) 251-1234',
        options: {
          icon: 'communication:phone'
        }
      },
      {
        type: 'Cell',
        number: '(555) 786-9841',
        options: {
          icon: 'communication:phone',
          avatarIcon: true
        }
      },
      {
        type: 'Office',
        number: '(555) 314-1592',
        options: {
          face : imagePath
        }
      },
      {
        type: 'Offset',
        number: '(555) 192-2010',
        options: {
          offset: true,
          actionIcon: 'communication:phone'
        }
      }
    ];
    $scope.todos = [
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
    ];
});

angular
  .module('inputIconDemo', ['ngMaterial', 'ngMessages'])
  .controller('DemoCtrl', function($scope) {
    $scope.user = {
      name: 'John Doe',
      email: '',
      phone: '',
      address: 'Mountain View, CA',
      donation: 19.99
    };
  });

angular.module('inputErrorsAdvancedApp', ['ngMaterial', 'ngMessages'])

  .controller('AppCtrl', function($scope) {
    $scope.showHints = true;

    $scope.user = {
      name: "",
      email: "",
      social: "123456789",
      phone: "N/A"
    };
  });

angular.module('inputErrorsApp', ['ngMaterial', 'ngMessages'])

.controller('AppCtrl', function($scope) {
  $scope.project = {
    description: 'Nuclear Missile Defense System',
    rate: 500,
    special: true
  };
});


angular.module('appSvgIconSets', ['ngMaterial'])
  .controller('DemoCtrl', function($scope) {})
  .config(['$mdIconProvider', function($mdIconProvider) {
    $mdIconProvider
      .iconSet('social', 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24)
      .defaultIconSet('assets/angular-material-assets/img/icons/sets/core-icons.svg', 24);
  }]);

angular
  .module('inputBasicDemo', ['ngMaterial', 'ngMessages'])
  .controller('DemoCtrl', function($scope) {
    $scope.user = {
      title: 'Developer',
      email: 'ipsum@lorem.com',
      firstName: '',
      lastName: '',
      company: 'Google',
      address: '1600 Amphitheatre Pkwy',
      city: 'Mountain View',
      state: 'CA',
      biography: 'Loves kittens, snowboarding, and can type at 130 WPM.\n\nAnd rumor has it she bouldered up Castle Craig!',
      postalCode: '94043'
    };

    $scope.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
    'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
    'WY').split(' ').map(function(state) {
        return {abbrev: state};
      });
  })
  .config(function($mdThemingProvider) {

    // Configure a dark theme with primary foreground yellow

    $mdThemingProvider.theme('docs-dark', 'default')
      .primaryPalette('yellow')
      .dark();

  });


angular.module('appUsingTemplateCache', ['ngMaterial'])
  .controller('DemoCtrl', function($scope) {})
  .config(function($mdIconProvider) {

    // Register icon IDs with sources. Future $mdIcon( <id> ) lookups
    // will load by url and retrieve the data via the $templateRequest

    $mdIconProvider
      .iconSet('core', 'assets/angular-material-assets/img/icons/sets/core-icons.svg',24)
      .icon('social:cake', 'assets/angular-material-assets/img/icons/cake.svg',24);

  })
  .run(function($templateRequest) {

    var urls = [
      'assets/angular-material-assets/img/icons/sets/core-icons.svg',
      'assets/angular-material-assets/img/icons/cake.svg',
      'assets/angular-material-assets/img/icons/android.svg'
    ];

    // Pre-fetch icons sources by URL and cache in the $templateCache...
    // subsequent $templateRequest calls will look there first.

    angular.forEach(urls, function(url) {
      $templateRequest(url);
    });

  })
  ;


angular
  .module('appDemoFontIconsWithLigatures', ['ngMaterial'])
  .controller('DemoCtrl', function( $scope ) {
      // Specify a list of font-icons with ligatures and color overrides
      var iconData = [
            {name: 'accessibility'  , color: "#777" },
            {name: 'question_answer', color: "rgb(89, 226, 168)" },
            {name: 'backup'         , color: "#A00" },
            {name: 'email'          , color: "#00A" }
          ];

      $scope.fonts = [].concat(iconData);

      // Create a set of sizes...
      $scope.sizes = [
        {size:"md-18",padding:0},
        {size:"md-24",padding:2},
        {size:"md-36",padding:6},
        {size:"md-48",padding:10}
      ];

  });


angular.module('appDemoSvgIcons', ['ngMaterial'])
.controller('DemoCtrl', function( $scope ) {

    $scope.insertDriveIconURL = 'assets/angular-material-assets/img/icons/ic_insert_drive_file_24px.svg';
    $scope.getAndroid = function() {
      return 'assets/angular-material-assets/img/icons/android.svg';
    };

    /* Returns base64 encoded SVG. */
    $scope.getAndroidEncoded = function() {
      return 'PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgaWQ9ImFuZHJvaWQiPjxwYXRoIGQ9Ik02IDE4YzAgLjU1LjQ1IDEgMSAxaDF2My41YzAgLjgzLjY3IDEuNSAxLjUgMS41czEuNS0uNjcgMS41LTEuNVYxOWgydjMuNWMwIC44My42NyAxLjUgMS41IDEuNXMxLjUtLjY3IDEuNS0xLjVWMTloMWMuNTUgMCAxLS40NSAxLTFWOEg2djEwek0zLjUgOEMyLjY3IDggMiA4LjY3IDIgOS41djdjMCAuODMuNjcgMS41IDEuNSAxLjVTNSAxNy4zMyA1IDE2LjV2LTdDNSA4LjY3IDQuMzMgOCAzLjUgOHptMTcgMGMtLjgzIDAtMS41LjY3LTEuNSAxLjV2N2MwIC44My42NyAxLjUgMS41IDEuNXMxLjUtLjY3IDEuNS0xLjV2LTdjMC0uODMtLjY3LTEuNS0xLjUtMS41em0tNC45Ny01Ljg0bDEuMy0xLjNjLjItLjIuMi0uNTEgMC0uNzEtLjItLjItLjUxLS4yLS43MSAwbC0xLjQ4IDEuNDhDMTMuODUgMS4yMyAxMi45NSAxIDEyIDFjLS45NiAwLTEuODYuMjMtMi42Ni42M0w3Ljg1LjE1Yy0uMi0uMi0uNTEtLjItLjcxIDAtLjIuMi0uMi41MSAwIC43MWwxLjMxIDEuMzFDNi45NyAzLjI2IDYgNS4wMSA2IDdoMTJjMC0xLjk5LS45Ny0zLjc1LTIuNDctNC44NHpNMTAgNUg5VjRoMXYxem01IDBoLTFWNGgxdjF6Ii8+PC9nPjwvc3ZnPg==';
    };

    /* Returns decoded SVG */
    $scope.getCartDecoded = function() {
      return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g id="add-shopping-cart"><path d="M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-9.83-3.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4h-.01l-1.1 2-2.76 5H8.53l-.13-.27L6.16 6l-.95-2-.94-2H1v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.13 0-.25-.11-.25-.25z"/></g></svg>';
    }
});


angular
  .module('appDemoFontIconsWithClassnames', ['ngMaterial'])
  .controller('DemoCtrl', function( $scope ) {
      // Create list of font-icon names with color overrides
      var iconData = [
            {name: 'icon-home'        , color: "#777" },
            {name: 'icon-user-plus'   , color: "rgb(89, 226, 168)" },
            {name: 'icon-google-plus2', color: "#A00" },
            {name: 'icon-youtube4'    , color:"#00A" },
             // Use theming to color the font-icon
            {name: 'icon-settings'    , color:"#A00", theme:"md-warn md-hue-5"}
          ];

      // Create a set of sizes...
      $scope.sizes = [
        {size:48,padding:10},
        {size:36,padding:6},
        {size:24,padding:2},
        {size:12,padding:0}
      ];

      $scope.fonts = [].concat(iconData);



  })
  .config(function($mdThemingProvider){
    // Update the theme colors to use themes on font-icons
    $mdThemingProvider.theme('default')
          .primaryPalette("red")
          .accentPalette('green')
          .warnPalette('blue');
  });


angular.module('gridListdemoResponsiveUsage', ['ngMaterial'])
.controller('AppCtrl', function($scope) {
  var COLORS = ['#ffebee', '#ffcdd2', '#ef9a9a', '#e57373', '#ef5350', '#f44336', '#e53935', '#d32f2f', '#c62828', '#b71c1c', '#ff8a80', '#ff5252', '#ff1744', '#d50000', '#f8bbd0', '#f48fb1', '#f06292', '#ec407a', '#e91e63', '#d81b60', '#c2185b', '#ad1457', '#880e4f', '#ff80ab', '#ff4081', '#f50057', '#c51162', '#e1bee7', '#ce93d8', '#ba68c8', '#ab47bc', '#9c27b0', '#8e24aa', '#7b1fa2', '#4a148c', '#ea80fc', '#e040fb', '#d500f9', '#aa00ff', '#ede7f6', '#d1c4e9', '#b39ddb', '#9575cd', '#7e57c2', '#673ab7', '#5e35b1', '#4527a0', '#311b92', '#b388ff', '#7c4dff', '#651fff', '#6200ea', '#c5cae9', '#9fa8da', '#7986cb', '#5c6bc0', '#3f51b5', '#3949ab', '#303f9f', '#283593', '#1a237e', '#8c9eff', '#536dfe', '#3d5afe', '#304ffe', '#e3f2fd', '#bbdefb', '#90caf9', '#64b5f6', '#42a5f5', '#2196f3', '#1e88e5', '#1976d2', '#1565c0', '#0d47a1', '#82b1ff', '#448aff', '#2979ff', '#2962ff', '#b3e5fc', '#81d4fa', '#4fc3f7', '#29b6f6', '#03a9f4', '#039be5', '#0288d1', '#0277bd', '#01579b', '#80d8ff', '#40c4ff', '#00b0ff', '#0091ea', '#e0f7fa', '#b2ebf2', '#80deea', '#4dd0e1', '#26c6da', '#00bcd4', '#00acc1', '#0097a7', '#00838f', '#006064', '#84ffff', '#18ffff', '#00e5ff', '#00b8d4', '#e0f2f1', '#b2dfdb', '#80cbc4', '#4db6ac', '#26a69a', '#009688', '#00897b', '#00796b', '#00695c', '#a7ffeb', '#64ffda', '#1de9b6', '#00bfa5', '#e8f5e9', '#c8e6c9', '#a5d6a7', '#81c784', '#66bb6a', '#4caf50', '#43a047', '#388e3c', '#2e7d32', '#1b5e20', '#b9f6ca', '#69f0ae', '#00e676', '#00c853', '#f1f8e9', '#dcedc8', '#c5e1a5', '#aed581', '#9ccc65', '#8bc34a', '#7cb342', '#689f38', '#558b2f', '#33691e', '#ccff90', '#b2ff59', '#76ff03', '#64dd17', '#f9fbe7', '#f0f4c3', '#e6ee9c', '#dce775', '#d4e157', '#cddc39', '#c0ca33', '#afb42b', '#9e9d24', '#827717', '#f4ff81', '#eeff41', '#c6ff00', '#aeea00', '#fffde7', '#fff9c4', '#fff59d', '#fff176', '#ffee58', '#ffeb3b', '#fdd835', '#fbc02d', '#f9a825', '#f57f17', '#ffff8d', '#ffff00', '#ffea00', '#ffd600', '#fff8e1', '#ffecb3', '#ffe082', '#ffd54f', '#ffca28', '#ffc107', '#ffb300', '#ffa000', '#ff8f00', '#ff6f00', '#ffe57f', '#ffd740', '#ffc400', '#ffab00', '#fff3e0', '#ffe0b2', '#ffcc80', '#ffb74d', '#ffa726', '#ff9800', '#fb8c00', '#f57c00', '#ef6c00', '#e65100', '#ffd180', '#ffab40', '#ff9100', '#ff6d00', '#fbe9e7', '#ffccbc', '#ffab91', '#ff8a65', '#ff7043', '#ff5722', '#f4511e', '#e64a19', '#d84315', '#bf360c', '#ff9e80', '#ff6e40', '#ff3d00', '#dd2c00', '#d7ccc8', '#bcaaa4', '#795548', '#d7ccc8', '#bcaaa4', '#8d6e63', '#eceff1', '#cfd8dc', '#b0bec5', '#90a4ae', '#78909c', '#607d8b', '#546e7a', '#cfd8dc', '#b0bec5', '#78909c'];

  this.colorTiles = (function() {
    var tiles = [];
    for (var i = 0; i < 46; i++) {
      tiles.push({
        color: randomColor(),
        colspan: randomSpan(),
        rowspan: randomSpan()
      });
    }
    return tiles;
  })();


  function randomColor() {
    return COLORS[Math.floor(Math.random() * COLORS.length)];
  }

  function randomSpan() {
    var r = Math.random();
    if (r < 0.8) {
      return 1;
    } else if (r < 0.9) {
      return 2;
    } else {
      return 3;
    }
  }
});


angular.module('gridListDemo1', ['ngMaterial'])
.controller('AppCtrl', function($scope) {});


angular
  .module('gridListDemoApp', ['ngMaterial'])
  .controller('gridListDemoCtrl', function($scope) {

    this.tiles = buildGridModel({
            icon : "avatar:svg-",
            title: "Svg-",
            background: ""
          });

    function buildGridModel(tileTmpl){
      var it, results = [ ];

      for (var j=0; j<11; j++) {

        it = angular.extend({},tileTmpl);
        it.icon  = it.icon + (j+1);
        it.title = it.title + (j+1);
        it.span  = { row : 1, col : 1 };

        switch(j+1) {
          case 1:
            it.background = "red";
            it.span.row = it.span.col = 2;
            break;

          case 2: it.background = "green";         break;
          case 3: it.background = "darkBlue";      break;
          case 4:
            it.background = "blue";
            it.span.col = 2;
            break;

          case 5:
            it.background = "yellow";
            it.span.row = it.span.col = 2;
            break;

          case 6: it.background = "pink";          break;
          case 7: it.background = "darkBlue";      break;
          case 8: it.background = "purple";        break;
          case 9: it.background = "deepBlue";      break;
          case 10: it.background = "lightPurple";  break;
          case 11: it.background = "yellow";       break;
        }

        results.push(it);
      }
      return results;
    }
  })
  .config( function( $mdIconProvider ){
    $mdIconProvider.iconSet("avatar", 'assets/angular-material-assets/icons//avatar-icons.svg', 128);
  });

(function() {
  'use strict';

  angular.module('fabToolbarBasicUsageDemo', ['ngMaterial'])
    .controller('AppCtrl', function($scope) {
      $scope.isOpen = false;

      $scope.demo = {
        isOpen: false,
        count: 0,
        selectedDirection: 'left'
      };
    });
})();
(function() {
  'use strict';

  angular.module('fabSpeedDialDemoMoreOptions', ['ngMaterial'])
    .controller('DemoCtrl', function($scope, $mdDialog, $timeout) {
      var self = this;

      self.hidden = false;
      self.isOpen = false;
      self.hover = false;

      // On opening, add a delayed property which shows tooltips after the speed dial has opened
      // so that they have the proper position; if closing, immediately hide the tooltips
      $scope.$watch('demo.isOpen', function(isOpen) {
        if (isOpen) {
          $timeout(function() {
            $scope.tooltipVisible = self.isOpen;
          }, 600);
        } else {
          $scope.tooltipVisible = self.isOpen;
        }
      });

      self.items = [
        { name: "Twitter", icon: "assets/angular-material-assets/img/icons/twitter.svg", direction: "bottom" },
        { name: "Facebook", icon: "assets/angular-material-assets/img/icons/facebook.svg", direction: "top" },
        { name: "Google Hangout", icon: "assets/angular-material-assets/img/icons/hangout.svg", direction: "bottom" }
      ];

      self.openDialog = function($event, item) {
        // Show the dialog
        $mdDialog.show({
          clickOutsideToClose: true,
          controller: function($mdDialog) {
            // Save the clicked item
            this.item = item;

            // Setup some handlers
            this.close = function() {
              $mdDialog.cancel();
            };
            this.submit = function() {
              $mdDialog.hide();
            };
          },
          controllerAs: 'dialog',
          templateUrl: 'dialog.html',
          targetEvent: $event
        });
      };
    });
})();

(function() {
  'use strict';

  angular.module('fabSpeedDialDemoBasicUsage', ['ngMaterial'])
    .controller('DemoCtrl', function() {
      this.topDirections = ['left', 'up'];
      this.bottomDirections = ['down', 'right'];

      this.isOpen = false;

      this.availableModes = ['md-fling', 'md-scale'];
      this.selectedMode = 'md-fling';

      this.availableDirections = ['up', 'down', 'left', 'right'];
      this.selectedDirection = 'up';
    });
})();

angular.module('dividerDemo1', ['ngMaterial'])
  .controller('AppCtrl', function($scope) {
    var imagePath = 'assets/angular-material-assets/img/list/60.jpeg';
    $scope.messages = [{
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }, {
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }, {
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }, {
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }, {
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }];
  });

angular.module('datepickerValidations', ['ngMaterial', 'ngMessages']).controller('AppCtrl', function() {
  this.myDate = new Date();

  this.minDate = new Date(
    this.myDate.getFullYear(),
    this.myDate.getMonth() - 2,
    this.myDate.getDate()
  );

  this.maxDate = new Date(
    this.myDate.getFullYear(),
    this.myDate.getMonth() + 2,
    this.myDate.getDate()
  );

  this.onlyWeekendsPredicate = function(date) {
    var day = date.getDay();
    return day === 0 || day === 6;
  };
});

angular.module('datepickerBasicUsage', ['ngMaterial', 'ngMessages']).controller('AppCtrl', function() {
  this.myDate = new Date();
  this.isOpen = false;
});

angular.module('dialogDemo3', ['ngMaterial'])
  .config(function ($mdThemingProvider) {
    $mdThemingProvider.theme('red')
      .primaryPalette('red');

    $mdThemingProvider.theme('blue')
      .primaryPalette('blue');

  })
.controller('AppCtrl', function($scope, $mdDialog, $interval) {
  $scope.theme = 'red';

  var isThemeRed = true;

  $interval(function () {
    $scope.theme = isThemeRed ? 'blue' : 'red';

    isThemeRed = !isThemeRed;
  }, 2000);

  $scope.showAdvanced = function(ev) {
    $mdDialog.show({
      controller: DialogController,
      templateUrl: 'dialog1.tmpl.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose:true
    })
    .then(function(answer) {
      $scope.status = 'You said the information was "' + answer + '".';
    }, function() {
      $scope.status = 'You cancelled the dialog.';
    });
  };

  function DialogController($scope, $mdDialog) {
    $scope.hide = function() {
      $mdDialog.hide();
    };

    $scope.cancel = function() {
      $mdDialog.cancel();
    };

    $scope.answer = function(answer) {
      $mdDialog.hide(answer);
    };
  }
});

angular.module('dialogDemo2', ['ngMaterial'])

.controller('AppCtrl', function($scope, $mdDialog) {
  $scope.openFromLeft = function() {
    $mdDialog.show(
      $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('Opening from the left')
        .textContent('Closing to the right!')
        .ariaLabel('Left to right demo')
        .parent(angular.element(document.body))
        .ok('Nice!')
        // You can specify either sting with query selector
        .openFrom('#left')
        // or an element
        .closeTo(angular.element(document.querySelector('#right')))
    );
  };

  $scope.openOffscreen = function() {
    $mdDialog.show(
      $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('Opening from offscreen')
        .textContent('Closing to offscreen')
        .ariaLabel('Offscreen Demo')
        .parent(angular.element(document.body))
        .ok('Amazing!')
        // Or you can specify the rect to do the transition from
        .openFrom({
          top: -50,
          width: 30,
          height: 80
        })
        .closeTo({
          left: 1500
        })
    );
  };
});

angular.module('dialogDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope, $mdDialog) {
  $scope.status = '  ';
  $scope.customFullscreen = false;

  $scope.showAlert = function(ev) {
    // Appending dialog to document.body to cover sidenav in docs app
    // Modal dialogs should fully cover application
    // to prevent interaction outside of dialog
    $mdDialog.show(
      $mdDialog.alert()
        .parent(angular.element(document.querySelector('#popupContainer')))
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .title('This is an alert title')
        .textContent('You can specify some description text in here.')
        .ariaLabel('Alert Dialog Demo')
        .ok('Got it!')
        .targetEvent(ev)
    );
  };

  $scope.showConfirm = function(ev) {
    // Appending dialog to document.body to cover sidenav in docs app
    var confirm = $mdDialog.confirm()
          .title('Would you like to delete your debt?')
          .textContent('All of the banks have agreed to forgive you your debts.')
          .ariaLabel('Lucky day')
          .targetEvent(ev)
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
          .ok('Please do it!')
          .cancel('Sounds like a scam');

    $mdDialog.show(confirm).then(function() {
      $scope.status = 'You decided to get rid of your debt.';
    }, function() {
      $scope.status = 'You decided to keep your debt.';
    });
  };

  $scope.showPrompt = function(ev) {
    // Appending dialog to document.body to cover sidenav in docs app
    var confirm = $mdDialog.prompt()
      .title('What would you name your dog?')
      .textContent('Bowser is a common name.')
      .placeholder('Dog name')
      .ariaLabel('Dog name')
      .initialValue('Buddy')
      .targetEvent(ev)
          .parent(angular.element(document.body))
      .ok('Okay!')
      .cancel('I\'m a cat person');

    $mdDialog.show(confirm).then(function(result) {
      $scope.status = 'You decided to name your dog ' + result + '.';
    }, function() {
      $scope.status = 'You didn\'t name your dog.';
    });
  };

  $scope.showAdvanced = function(ev) {
    $mdDialog.show({
      controller: DialogController,
      templateUrl: 'dialog1.tmpl.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose:true,
      fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
    })
    .then(function(answer) {
      $scope.status = 'You said the information was "' + answer + '".';
    }, function() {
      $scope.status = 'You cancelled the dialog.';
    });
  };

  $scope.showTabDialog = function(ev) {
    $mdDialog.show({
      controller: DialogController,
      templateUrl: 'tabDialog.tmpl.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose:true
    })
        .then(function(answer) {
          $scope.status = 'You said the information was "' + answer + '".';
        }, function() {
          $scope.status = 'You cancelled the dialog.';
        });
  };

  $scope.showPrerenderedDialog = function(ev) {
    $mdDialog.show({
      controller: DialogController,
      contentElement: '#myDialog',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose: true
    });
  };

  function DialogController($scope, $mdDialog) {
    $scope.hide = function() {
      $mdDialog.hide();
    };

    $scope.cancel = function() {
      $mdDialog.cancel();
    };

    $scope.answer = function(answer) {
      $mdDialog.hide(answer);
    };
  }
});


angular.module('contentDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

});

angular
  .module('colorsThemePickerDemo', ['ngMaterial'])
  .controller('ThemeDemoCtrl', function ($scope, $mdColorPalette) {
    $scope.colors = Object.keys($mdColorPalette); 

    $scope.mdURL = 'https://material.google.com/style/color.html#color-color-palette';
    $scope.primary = 'purple';
    $scope.accent = 'green';

    $scope.isPrimary = true;

    $scope.selectTheme = function (color) {
      if ($scope.isPrimary) {
        $scope.primary = color;

        $scope.isPrimary = false;
      }
      else {
        $scope.accent = color;

        $scope.isPrimary = true;
      }
    };
  })
  .directive('themePreview', function () {
    return {
      restrict: 'E',
      templateUrl: 'themePreview.tmpl.html',
      scope: {
        primary: '=',
        accent: '='
      },
      controller: function ($scope, $mdColors, $mdColorUtil) {
        $scope.getColor = function (color) {
          return $mdColorUtil.rgbaToHex($mdColors.getThemeColor(color))
        };
      }
    }
  })
  .directive('mdJustified', function() {
    return {
      restrict : 'A',
      compile : function(element, attrs)  {
        var layoutDirection = 'layout-'+ (attrs.mdJustified || "row");

        element.removeAttr('md-justified');
        element.addClass(layoutDirection);
        element.addClass("layout-align-space-between-stretch");

        return angular.noop;
      }
    };
  });

angular.module('colorsDemo', ['ngMaterial'])
  .config(function ($mdThemingProvider, $mdIconProvider) {
    $mdThemingProvider.theme('forest')
      .primaryPalette('brown')
      .accentPalette('green');

    $mdIconProvider
      .defaultIconSet('assets/angular-material-assets/img/icons/sets/social-icons.svg', 24);
  })
  .directive('regularCard', function () {
    return {
      restrict: 'E',
      templateUrl: 'regularCard.tmpl.html',
      scope: {
        name: '@',
      }
    }
  })
  .directive('userCard', function () {
    return {
      restrict: 'E',
      templateUrl: 'userCard.tmpl.html',
      scope: {
        name: '@',
        theme: '@'
      },
      controller: function ($scope) {
        $scope.theme = $scope.theme || 'default';
      }
    }
  });


angular.module('checkboxDemo2', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

    $scope.items = [1,2,3,4,5];
      $scope.selected = [];

      $scope.toggle = function (item, list) {
        var idx = list.indexOf(item);
        if (idx > -1) {
          list.splice(idx, 1);
        }
        else {
          list.push(item);
        }
      };

      $scope.exists = function (item, list) {
        return list.indexOf(item) > -1;
      };
});


angular.module('checkboxDemo3', ['ngMaterial'])

.controller('AppCtrl', function($scope) {
  $scope.items = [1,2,3,4,5];
  $scope.selected = [1];
  $scope.toggle = function (item, list) {
    var idx = list.indexOf(item);
    if (idx > -1) {
      list.splice(idx, 1);
    }
    else {
      list.push(item);
    }
  };

  $scope.exists = function (item, list) {
    return list.indexOf(item) > -1;
  };

  $scope.isIndeterminate = function() {
    return ($scope.selected.length !== 0 &&
        $scope.selected.length !== $scope.items.length);
  };

  $scope.isChecked = function() {
    return $scope.selected.length === $scope.items.length;
  };

  $scope.toggleAll = function() {
    if ($scope.selected.length === $scope.items.length) {
      $scope.selected = [];
    } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
      $scope.selected = $scope.items.slice(0);
    }
  };
});


angular.module('checkboxDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

  $scope.data = {};
  $scope.data.cb1 = true;
  $scope.data.cb2 = false;
  $scope.data.cb3 = false;
  $scope.data.cb4 = false;
  $scope.data.cb5 = false;

});

(function () {
  'use strict';
  angular
      .module('staticChipsDemo', ['ngMaterial'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q) {
    this.chipText = 'Football';
  }
})();

(function () {
  'use strict';
  angular
      .module('chipsCustomSeparatorDemo', ['ngMaterial'])
      .controller('CustomSeparatorCtrl', DemoCtrl);

  function DemoCtrl ($mdConstant) {
    // Use common key codes found in $mdConstant.KEY_CODE...
    this.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
    this.tags = [];

    // Any key code can be used to create a custom separator
    var semicolon = 186;
    this.customKeys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, semicolon];
    this.contacts = ['test@example.com'];
  }
})();

(function () {
  'use strict';
  angular
      .module('chipsCustomInputDemo', ['ngMaterial'])
      .controller('CustomInputDemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q) {
    var self = this;

    self.readonly = false;
    self.selectedItem = null;
    self.searchText = null;
    self.querySearch = querySearch;
    self.vegetables = loadVegetables();
    self.selectedVegetables = [];
    self.numberChips = [];
    self.numberChips2 = [];
    self.numberBuffer = '';
    self.autocompleteDemoRequireMatch = true;
    self.transformChip = transformChip;

    /**
     * Return the proper object when the append is called.
     */
    function transformChip(chip) {
      // If it is an object, it's already a known chip
      if (angular.isObject(chip)) {
        return chip;
      }

      // Otherwise, create a new one
      return { name: chip, type: 'new' }
    }

    /**
     * Search for vegetables.
     */
    function querySearch (query) {
      var results = query ? self.vegetables.filter(createFilterFor(query)) : [];
      return results;
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(vegetable) {
        return (vegetable._lowername.indexOf(lowercaseQuery) === 0) ||
            (vegetable._lowertype.indexOf(lowercaseQuery) === 0);
      };

    }

    function loadVegetables() {
      var veggies = [
        {
          'name': 'Broccoli',
          'type': 'Brassica'
        },
        {
          'name': 'Cabbage',
          'type': 'Brassica'
        },
        {
          'name': 'Carrot',
          'type': 'Umbelliferous'
        },
        {
          'name': 'Lettuce',
          'type': 'Composite'
        },
        {
          'name': 'Spinach',
          'type': 'Goosefoot'
        }
      ];

      return veggies.map(function (veg) {
        veg._lowername = veg.name.toLowerCase();
        veg._lowertype = veg.type.toLowerCase();
        return veg;
      });
    }
  }
})();

(function () {
  'use strict';
  angular
      .module('chipsDemo', ['ngMaterial', 'ngMessages'])
      .config(['$mdIconProvider', function($mdIconProvider) {
        $mdIconProvider.icon('md-close', 'assets/angular-material-assets/img/icons/ic_close_24px.svg', 24);
      }])
      .controller('BasicDemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q) {
    var self = this;

    self.readonly = false;

    // Lists of fruit names and Vegetable objects
    self.fruitNames = ['Apple', 'Banana', 'Orange'];
    self.roFruitNames = angular.copy(self.fruitNames);
    self.editableFruitNames = angular.copy(self.fruitNames);

    self.tags = [];
    self.vegObjs = [
      {
        'name' : 'Broccoli',
        'type' : 'Brassica'
      },
      {
        'name' : 'Cabbage',
        'type' : 'Brassica'
      },
      {
        'name' : 'Carrot',
        'type' : 'Umbelliferous'
      }
    ];

    self.newVeg = function(chip) {
      return {
        name: chip,
        type: 'unknown'
      };
    };
  }
})();

(function () {
  'use strict';

  // If we do not have CryptoJS defined; import it
  if (typeof CryptoJS == 'undefined') {
    var cryptoSrc = '//cdnjs.cloudflare.com/ajax/libs/crypto-js/3.1.2/rollups/md5.js';
    var scriptTag = document.createElement('script');
    scriptTag.setAttribute('src', cryptoSrc);
    document.body.appendChild(scriptTag);
  }

  angular
      .module('contactChipsDemo', ['ngMaterial'])
      .controller('ContactChipDemoCtrl', DemoCtrl);

  function DemoCtrl ($q, $timeout) {
    var self = this;
    var pendingSearch, cancelSearch = angular.noop;
    var lastSearch;

    self.allContacts = loadContacts();
    self.contacts = [self.allContacts[0]];
    self.asyncContacts = [];
    self.filterSelected = true;

    self.querySearch = querySearch;
    self.delayedQuerySearch = delayedQuerySearch;

    /**
     * Search for contacts; use a random delay to simulate a remote call
     */
    function querySearch (criteria) {
      return criteria ? self.allContacts.filter(createFilterFor(criteria)) : [];
    }

    /**
     * Async search for contacts
     * Also debounce the queries; since the md-contact-chips does not support this
     */
    function delayedQuerySearch(criteria) {
      if ( !pendingSearch || !debounceSearch() )  {
        cancelSearch();

        return pendingSearch = $q(function(resolve, reject) {
          // Simulate async search... (after debouncing)
          cancelSearch = reject;
          $timeout(function() {

            resolve( self.querySearch(criteria) );

            refreshDebounce();
          }, Math.random() * 500, true)
        });
      }

      return pendingSearch;
    }

    function refreshDebounce() {
      lastSearch = 0;
      pendingSearch = null;
      cancelSearch = angular.noop;
    }

    /**
     * Debounce if querying faster than 300ms
     */
    function debounceSearch() {
      var now = new Date().getMilliseconds();
      lastSearch = lastSearch || now;

      return ((now - lastSearch) < 300);
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(contact) {
        return (contact._lowername.indexOf(lowercaseQuery) != -1);
      };

    }

    function loadContacts() {
      var contacts = [
        'Marina Augustine',
        'Oddr Sarno',
        'Nick Giannopoulos',
        'Narayana Garner',
        'Anita Gros',
        'Megan Smith',
        'Tsvetko Metzger',
        'Hector Simek',
        'Some-guy withalongalastaname'
      ];

      return contacts.map(function (c, index) {
        var cParts = c.split(' ');
        var email = cParts[0][0].toLowerCase() + '.' + cParts[1].toLowerCase() + '@example.com';
        var hash = CryptoJS.MD5(email);

        var contact = {
          name: c,
          email: email,
          image: '//www.gravatar.com/avatar/' + hash + '?s=50&d=retro'
        };
        contact._lowername = contact.name.toLowerCase();
        return contact;
      });
    }
  }


})();


angular.module('cardDemo3', ['ngMaterial'])

.config(['$mdIconProvider', function($mdIconProvider) {
  $mdIconProvider.icon('md-toggle-arrow', 'assets/angular-material-assets/img/icons/toggle-arrow.svg', 48);
}])
.controller('AppCtrl', function($scope) {
  $scope.imagePath = 'assets/angular-material-assets/img/washedout.png';
});


angular.module('cardDemo2', ['ngMaterial'])

.controller('AppCtrl', function($scope) {
  $scope.imagePath = 'assets/angular-material-assets/img/washedout.png';
});


angular.module('cardDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {
  $scope.imagePath = 'assets/angular-material-assets/img/washedout.png';
})
.config(function($mdThemingProvider) {
  $mdThemingProvider.theme('dark-grey').backgroundPalette('grey').dark();
  $mdThemingProvider.theme('dark-orange').backgroundPalette('orange').dark();
  $mdThemingProvider.theme('dark-purple').backgroundPalette('deep-purple').dark();
  $mdThemingProvider.theme('dark-blue').backgroundPalette('blue').dark();
});

(function () {
  'use strict';
  angular
      .module('autocompleteDemoInsideDialog', ['ngMaterial'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl($mdDialog) {
    var self = this;

    self.openDialog = function($event) {
      $mdDialog.show({
        controller: DialogCtrl,
        controllerAs: 'ctrl',
        templateUrl: 'dialog.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: $event,
        clickOutsideToClose:true
      })
    }
  }

  function DialogCtrl ($timeout, $q, $scope, $mdDialog) {
    var self = this;

    // list of `state` value/display objects
    self.states        = loadAll();
    self.querySearch   = querySearch;

    // ******************************
    // Template methods
    // ******************************

    self.cancel = function($event) {
      $mdDialog.cancel();
    };
    self.finish = function($event) {
      $mdDialog.hide();
    };

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch (query) {
      return query ? self.states.filter( createFilterFor(query) ) : self.states;
    }

    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {
      var allStates = 'Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware,\
              Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana,\
              Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana,\
              Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, New York, North Carolina,\
              North Dakota, Ohio, Oklahoma, Oregon, Pennsylvania, Rhode Island, South Carolina,\
              South Dakota, Tennessee, Texas, Utah, Vermont, Virginia, Washington, West Virginia,\
              Wisconsin, Wyoming';

      return allStates.split(/, +/g).map( function (state) {
        return {
          value: state.toLowerCase(),
          display: state
        };
      });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(state) {
        return (state.value.indexOf(lowercaseQuery) === 0);
      };

    }
  }
})();

(function () {
  'use strict';
  angular
      .module('autocompleteFloatingLabelDemo', ['ngMaterial', 'ngMessages'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q) {
    var self = this;

    // list of `state` value/display objects
    self.states        = loadAll();
    self.selectedItem  = null;
    self.searchText    = null;
    self.querySearch   = querySearch;

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch (query) {
      var results = query ? self.states.filter( createFilterFor(query) ) : self.states;
      var deferred = $q.defer();
      $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
      return deferred.promise;
    }

    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {
      var allStates = 'Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware,\
              Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana,\
              Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana,\
              Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, New York, North Carolina,\
              North Dakota, Ohio, Oklahoma, Oregon, Pennsylvania, Rhode Island, South Carolina,\
              South Dakota, Tennessee, Texas, Utah, Vermont, Virginia, Washington, West Virginia,\
              Wisconsin, Wyoming';

      return allStates.split(/, +/g).map( function (state) {
        return {
          value: state.toLowerCase(),
          display: state
        };
      });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(state) {
        return (state.value.indexOf(lowercaseQuery) === 0);
      };

    }
  }
})();

(function () {
  'use strict';
  angular
      .module('autocompleteDemo', ['ngMaterial'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q, $log) {
    var self = this;

    self.simulateQuery = false;
    self.isDisabled    = false;

    // list of `state` value/display objects
    self.states        = loadAll();
    self.querySearch   = querySearch;
    self.selectedItemChange = selectedItemChange;
    self.searchTextChange   = searchTextChange;

    self.newState = newState;

    function newState(state) {
      alert("Sorry! You'll need to create a Constitution for " + state + " first!");
    }

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch (query) {
      var results = query ? self.states.filter( createFilterFor(query) ) : self.states,
          deferred;
      if (self.simulateQuery) {
        deferred = $q.defer();
        $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
        return deferred.promise;
      } else {
        return results;
      }
    }

    function searchTextChange(text) {
      $log.info('Text changed to ' + text);
    }

    function selectedItemChange(item) {
      $log.info('Item changed to ' + JSON.stringify(item));
    }

    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {
      var allStates = 'Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware,\
              Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana,\
              Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana,\
              Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, New York, North Carolina,\
              North Dakota, Ohio, Oklahoma, Oregon, Pennsylvania, Rhode Island, South Carolina,\
              South Dakota, Tennessee, Texas, Utah, Vermont, Virginia, Washington, West Virginia,\
              Wisconsin, Wyoming';

      return allStates.split(/, +/g).map( function (state) {
        return {
          value: state.toLowerCase(),
          display: state
        };
      });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(state) {
        return (state.value.indexOf(lowercaseQuery) === 0);
      };

    }
  }
})();

(function () {
  'use strict';
  angular
      .module('autocompleteCustomTemplateDemo', ['ngMaterial'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q, $log) {
    var self = this;

    self.simulateQuery = false;
    self.isDisabled    = false;

    self.repos         = loadAll();
    self.querySearch   = querySearch;
    self.selectedItemChange = selectedItemChange;
    self.searchTextChange   = searchTextChange;

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for repos... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch (query) {
      var results = query ? self.repos.filter( createFilterFor(query) ) : self.repos,
          deferred;
      if (self.simulateQuery) {
        deferred = $q.defer();
        $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
        return deferred.promise;
      } else {
        return results;
      }
    }

    function searchTextChange(text) {
      $log.info('Text changed to ' + text);
    }

    function selectedItemChange(item) {
      $log.info('Item changed to ' + JSON.stringify(item));
    }

    /**
     * Build `components` list of key/value pairs
     */
    function loadAll() {
      var repos = [
        {
          'name'      : 'AngularJS',
          'url'       : 'https://github.com/angular/angular.js',
          'watchers'  : '3,623',
          'forks'     : '16,175',
        },
        {
          'name'      : 'Angular',
          'url'       : 'https://github.com/angular/angular',
          'watchers'  : '469',
          'forks'     : '760',
        },
        {
          'name'      : 'AngularJS Material',
          'url'       : 'https://github.com/angular/material',
          'watchers'  : '727',
          'forks'     : '1,241',
        },
        {
          'name'      : 'Angular Material',
          'url'       : 'https://github.com/angular/material2',
          'watchers'  : '727',
          'forks'     : '1,241',
        },
        {
          'name'      : 'Bower Material',
          'url'       : 'https://github.com/angular/bower-material',
          'watchers'  : '42',
          'forks'     : '84',
        },
        {
          'name'      : 'Material Start',
          'url'       : 'https://github.com/angular/material-start',
          'watchers'  : '81',
          'forks'     : '303',
        }
      ];
      return repos.map( function (repo) {
        repo.value = repo.name.toLowerCase();
        return repo;
      });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(item) {
        return (item.value.indexOf(lowercaseQuery) === 0);
      };

    }
  }
})();


angular.module('buttonsDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {
  $scope.title1 = 'Button';
  $scope.title4 = 'Warn';
  $scope.isDisabled = true;

  $scope.googleUrl = 'http://google.com';

});

angular.module('bottomSheetDemo1', ['ngMaterial'])
.config(function($mdIconProvider) {
    $mdIconProvider
      .icon('share-arrow', 'assets/angular-material-assets/img/icons/share-arrow.svg', 24)
      .icon('upload', 'assets/angular-material-assets/img/icons/upload.svg', 24)
      .icon('copy', 'assets/angular-material-assets/img/icons/copy.svg', 24)
      .icon('print', 'assets/angular-material-assets/img/icons/print.svg', 24)
      .icon('hangout', 'assets/angular-material-assets/img/icons/hangout.svg', 24)
      .icon('mail', 'assets/angular-material-assets/img/icons/mail.svg', 24)
      .icon('message', 'assets/angular-material-assets/img/icons/message.svg', 24)
      .icon('copy2', 'assets/angular-material-assets/img/icons/copy2.svg', 24)
      .icon('facebook', 'assets/angular-material-assets/img/icons/facebook.svg', 24)
      .icon('twitter', 'assets/angular-material-assets/img/icons/twitter.svg', 24);
  })
.controller('BottomSheetExample', function($scope, $timeout, $mdBottomSheet, $mdToast) {
  $scope.alert = '';

  $scope.showListBottomSheet = function() {
    $scope.alert = '';
    $mdBottomSheet.show({
      templateUrl: 'bottom-sheet-list-template.html',
      controller: 'ListBottomSheetCtrl'
    }).then(function(clickedItem) {
      $scope.alert = clickedItem['name'] + ' clicked!';
    }).catch(function(error) {
      // User clicked outside or hit escape
    });
  };

  $scope.showGridBottomSheet = function() {
    $scope.alert = '';
    $mdBottomSheet.show({
      templateUrl: 'bottom-sheet-grid-template.html',
      controller: 'GridBottomSheetCtrl',
      clickOutsideToClose: false
    }).then(function(clickedItem) {
      $mdToast.show(
            $mdToast.simple()
              .textContent(clickedItem['name'] + ' clicked!')
              .position('top right')
              .hideDelay(1500)
          );
    }).catch(function(error) {
      // User clicked outside or hit escape
    });
  };
})

.controller('ListBottomSheetCtrl', function($scope, $mdBottomSheet) {

  $scope.items = [
    { name: 'Share', icon: 'share-arrow' },
    { name: 'Upload', icon: 'upload' },
    { name: 'Copy', icon: 'copy' },
    { name: 'Print this page', icon: 'print' },
  ];

  $scope.listItemClick = function($index) {
    var clickedItem = $scope.items[$index];
    $mdBottomSheet.hide(clickedItem);
  };
})
.controller('GridBottomSheetCtrl', function($scope, $mdBottomSheet) {
  $scope.items = [
    { name: 'Hangout', icon: 'hangout' },
    { name: 'Mail', icon: 'mail' },
    { name: 'Message', icon: 'message' },
    { name: 'Copy', icon: 'copy2' },
    { name: 'Facebook', icon: 'facebook' },
    { name: 'Twitter', icon: 'twitter' },
  ];

  $scope.listItemClick = function($index) {
    var clickedItem = $scope.items[$index];
    $mdBottomSheet.hide(clickedItem);
  };
})
.run(function($templateRequest) {

    var urls = [
      'assets/angular-material-assets/img/icons/share-arrow.svg',
      'assets/angular-material-assets/img/icons/upload.svg',
      'assets/angular-material-assets/img/icons/copy.svg',
      'assets/angular-material-assets/img/icons/print.svg',
      'assets/angular-material-assets/img/icons/hangout.svg',
      'assets/angular-material-assets/img/icons/mail.svg',
      'assets/angular-material-assets/img/icons/message.svg',
      'assets/angular-material-assets/img/icons/copy2.svg',
      'assets/angular-material-assets/img/icons/facebook.svg',
      'assets/angular-material-assets/img/icons/twitter.svg'
    ];

    angular.forEach(urls, function(url) {
      $templateRequest(url);
    });

  });

(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_right-sidenav-ii', {
            url  : '/ui/page-layouts/simple/right-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/right-sidenav-ii/right-sidenav-ii.html',
                    controller : 'SimpleRightSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-ii')
        .controller('SimpleRightSidenavIIController', SimpleRightSidenavIIController);

    /** @ngInject */
    function SimpleRightSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-iii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_right-sidenav-iii', {
            url  : '/ui/page-layouts/simple/right-sidenav-iii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/right-sidenav-iii/right-sidenav-iii.html',
                    controller : 'SimpleRightSidenavIIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-iii')
        .controller('SimpleRightSidenavIIIController', SimpleRightSidenavIIIController);

    /** @ngInject */
    function SimpleRightSidenavIIIController($mdSidenav)
    {

        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.tabbed', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_tabbed', {
            url  : '/ui/page-layouts/simple/tabbed',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/tabbed/tabbed.html',
                    controller : 'SimpleTabbedController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.tabbed')
        .controller('SimpleTabbedController', SimpleTabbedController);

    /** @ngInject */
    function SimpleTabbedController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_right-sidenav', {
            url  : '/ui/page-layouts/simple/right-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/right-sidenav/right-sidenav.html',
                    controller : 'SimpleRightSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav')
        .controller('SimpleRightSidenavController', SimpleRightSidenavController);

    /** @ngInject */
    function SimpleRightSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-iii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_left-sidenav-iii', {
            url  : '/ui/page-layouts/simple/left-sidenav-iii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/left-sidenav-iii/left-sidenav-iii.html',
                    controller : 'SimpleLeftSidenavIIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-iii')
        .controller('SimpleLeftSidenavIIIController', SimpleLeftSidenavIIIController);

    /** @ngInject */
    function SimpleLeftSidenavIIIController($mdSidenav)
    {

        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_left-sidenav-ii', {
            url  : '/ui/page-layouts/simple/left-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/left-sidenav-ii/left-sidenav-ii.html',
                    controller : 'SimpleLeftSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-ii')
        .controller('SimpleLeftSidenavIIController', SimpleLeftSidenavIIController);

    /** @ngInject */
    function SimpleLeftSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_left-sidenav', {
            url  : '/ui/page-layouts/simple/left-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/left-sidenav/left-sidenav.html',
                    controller : 'SimpleLeftSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav')
        .controller('SimpleLeftSidenavController', SimpleLeftSidenavController);

    /** @ngInject */
    function SimpleLeftSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.fullwidth', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_fullwidth', {
            url  : '/ui/page-layouts/simple/fullwidth',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/fullwidth/fullwidth.html',
                    controller : 'SimpleFullwidthController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.fullwidth')
        .controller('SimpleFullwidthController', SimpleFullwidthController);

    /** @ngInject */
    function SimpleFullwidthController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_left-sidenav-ii', {
            url  : '/ui/page-layouts/carded/left-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/left-sidenav-ii/left-sidenav-ii.html',
                    controller : 'CardedLeftSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav-ii')
        .controller('CardedLeftSidenavIIController', CardedLeftSidenavIIController);

    /** @ngInject */
    function CardedLeftSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_right-sidenav', {
            url  : '/ui/page-layouts/carded/right-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/right-sidenav/right-sidenav.html',
                    controller : 'CardedRightSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav')
        .controller('CardedRightSidenavController', CardedRightSidenavController);

    /** @ngInject */
    function CardedRightSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_right-sidenav-ii', {
            url  : '/ui/page-layouts/carded/right-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/right-sidenav-ii/right-sidenav-ii.html',
                    controller : 'CardedRightSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav-ii')
        .controller('CardedRightSidenavIIController', CardedRightSidenavIIController);

    /** @ngInject */
    function CardedRightSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_fullwidth-ii', {
            url  : '/ui/page-layouts/carded/fullwidth-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/fullwidth-ii/fullwidth-ii.html',
                    controller : 'CardedFullwidthIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth-ii')
        .controller('CardedFullwidthIIController', CardedFullwidthIIController);

    /** @ngInject */
    function CardedFullwidthIIController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_left-sidenav', {
            url  : '/ui/page-layouts/carded/left-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/left-sidenav/left-sidenav.html',
                    controller : 'CardedLeftSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav')
        .controller('CardedLeftSidenavController', CardedLeftSidenavController);

    /** @ngInject */
    function CardedLeftSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_fullwidth', {
            url  : '/ui/page-layouts/carded/fullwidth',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/fullwidth/fullwidth.html',
                    controller : 'CardedFullwidthController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth')
        .controller('CardedFullwidthController', CardedFullwidthController);

    /** @ngInject */
    function CardedFullwidthController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_theme-colors', {
            url      : '/ui/theme-colors',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/theme-colors/theme-colors.html',
                    controller : 'ThemeColorsController as vm'
                }
            },
            bodyClass: 'theme-colors'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors')
        .controller('CustomThemeDialogController', CustomThemeDialogController);

    /** @ngInject */
    function CustomThemeDialogController(fuseTheming, $mdDialog, fuseGenerator, $cookies, $window)
    {
        // Data
        var vm = this;
        vm.palettes = fuseTheming.getRegisteredPalettes();
        vm.themes = fuseTheming.getRegisteredThemes();

        // Delete Unnecessary hue value
        delete vm.palettes.grey['1000'];

        // Methods
        vm.rgba = fuseGenerator.rgba;
        vm.setTheme = setTheme;
        vm.closeDialog = closeDialog;

        //////////

        // If custom theme exist keep using it otherwise set default as a custom
        if ( !vm.themes.custom )
        {
            vm.theme = angular.copy(vm.themes['default'].colors);
        }
        else
        {
            vm.theme = vm.themes.custom.colors;
        }

        /**
         * Put custom theme into the cookies
         * and reload for generate styles
         */
        function setTheme()
        {
            $cookies.putObject('customTheme', vm.theme);
            $cookies.put('selectedTheme', 'custom');
            $window.location.reload();
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.menu.productos.varios',
            [
                // 3rd Party Dependencies
                //'wipImageZoom',
                'datatables',
                'flow',
                'nvd3',
                'textAngular',
                //'uiGmapgoogle-maps',
                'xeditable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider

            .state('app.menu_productos_varios', {
                url      : '/menu/productos/varios/varios',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/menu/productos/varios/varios/varios.html',
                        controller : 'VariosController as vm'
                    }
                },

                bodyClass: 'varios'
            })

            .state('app.menu_productos_varios_add', {
                url      : '/menu/productos/varios/varios/add',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/menu/productos/varios/vario/vario.html',
                        controller : 'VarioController as vm'
                    }
                },
 
                bodyClass: 'varios'
            })

            .state('app.menu_productos_varios_vario', {
                url      : '/menu/productos/varios/vario/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/menu/productos/varios/vario/vario.html',
                        controller : 'VarioController as vm'
                    }
                },

                bodyClass: 'varios'
            });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/menu/productos/varios');

        // Navigation
        msNavigationServiceProvider.saveItem('menu.productos.varios', {
            title : 'Varios',
            icon  : 'icon-arrange-bring-to-front',        //icon-gift
            state: 'app.menu_productos_varios',
            weight: 3
        });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.menu.productos.varios')
        .controller('VariosController', VariosController);

    /** @ngInject */
    function VariosController($state,WRITE_IN_CONSOLE,loginService,utilsService,firebaseDataService,$firebaseArray,$mdDialog)
    {

        //********************************************************        
        // DATA DECLARATION
        //********************************************************        
        var vm = this;

        vm.varios = [];
        vm.totalVarios = 0;  
/*        
        vm.role = "";
        vm.userKey= "";
*/
        //********************************************************
        // METHODS DECLARATION
        //********************************************************  
        vm.initData = initData;
        vm.getVarios = getVarios;
        vm.deleteVario = deleteVario;
        vm.showConfirmDeleteDialog = showConfirmDeleteDialog;
        vm.showAlertDialog = showAlertDialog;

        vm.gotoVarioDetail = gotoVarioDetail;
        vm.gotoAddVario = gotoAddVario;


//IMPORTANTE => MÉTODO PARA AÑADIR LOS PRECIOS DE LOS SERVICIOS DE MONTAJE, EMBALAJE, TRANSPORTE Y PASSE-PARTOUT MULTI-VENTANA
vm.addConfiguracionPrecios = addConfiguracionPrecios;



        //START CONTROLLER *******************************
        init();
        //START CONTROLLER *******************************


        //********************************************************
        // METHODS DECLARATION
        //********************************************************        
        function init()
        {
            //We initialize the data for the controller
            vm.initData();

/*
            var role = loginService.getUserProfile();
            var userKey = loginService.getUserKey();

            //Si el usuario es Administrador => Mostramos todos los presupuestos (de todas las empresas y de todas los usuarios(tiendas) )
            if (role == "administrator") {
                vm.getPresupuestos();

            //Si no es Administrador => Mostramos los presupuestos creados por la Tienda actual (usuario)
            } else {
                vm.getPresupuestosOfUsuario(userKey);
            }
*/

//IMPORTRANTE => EJECUCIÓN DEL MÉTODO PARA AÑADIR LOS PRECIOS DE LOS SERVICIOS
//vm.addConfiguracionPrecios();

            vm.getVarios();

        }


        //***************************************************************
        function initData() {

            vm.dtInstance = {};
            vm.dtOptions = {
                dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                columnDefs  : [
                    {
                        // Target the "Nº passe-partout" column
                        targets   : 0,
                        //filterable: false,
                        //sortable  : false,
                        width     : '30px'
                    },

                    {
                        // Target the "Referencia proveedor" column
                        targets   : 1,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },
                    {
                        // Target the "Referencia LM" column
                        targets   : 2,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },
                    {
                        // Target the "Descripcion" column
                        targets   : 3,
                        //filterable: false,
                        //sortable  : false,
                        width     : '300px'
                    },

                    {
                        // Target the "tipo" column
                        targets   : 4,
                        //filterable: false,
                        width     : '50px',
                    },

                    {
                        // Target the "Ancho máx(cm)" column
                        targets   : 5,
                        //filterable: false,
                        width     : '50px',
/*                        
                        render    : function (data, type)
                        {
                            if (data == 'true')
                            {
                                return '<i class="icon-alert red-500-fg"></i>';
                            }
                            return '';
                        }
*/                        
                    },

                    {
                        // Target the ""Alto máx(cm)" column
                        targets   : 6,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },

                    {
                        // Target the "Precio coste" column
                        targets   : 7,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },

                    {
                        // Target the "Precio LM" column
                        targets   : 8,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },

                    {
                        // Target the "Activo" column
                        targets   : 9,
                        //filterable: false,
                        width     : '80px',
                        render    : function (data, type)
                        {
                            if (data == 'true')
                            {
                                return '<i class="icon-checkbox-marked-circle green-500-fg"></i>';
                            }
                            return '<i class="icon-cancel red-500-fg"></i>';
                        }
                    },

                    {
                        // Target the "actions" column
                        targets           : 10,
                        width             : '100px',
                        responsivePriority: 1,
                        filterable        : false,
                        sortable          : false
                    }
                ],
                initComplete: function ()
                {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#varios-search');

                    // Bind an external input as a table wide search box
                    if ( searchBox.length > 0 )
                    {
                        searchBox.on('keyup', function (event)
                        {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType  : 'simple',
                lengthMenu  : [100, 250, 500],
                pageLength  : 100,
                scrollY     : 'auto',
                responsive  : true
            };
        }



        //***************************************************************
        function getVarios() {

            var fbUrl = firebaseDataService.productos_varios;
            var result = $firebaseArray(fbUrl.orderByChild("numeroArticulo"));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    utilsService.writeConsole("[VariosController] => getVarios() => EJECUCIÓN OK DE CONSULTA TABLA productos_varios con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        vm.varios = data;
                        vm.totalVarios = dataLength;

                    } else {

                        vm.varios = null;
                        vm.totalVarios = 0;
                    }

                    utilsService.writeConsole("vm.totalVarios = " + vm.totalVarios, WRITE_IN_CONSOLE);

                })

                .catch(function(error) {

                    vm.varios = null;

                    utilsService.writeConsole("[VariosController] => getVarios() => ERROR: " + error, WRITE_IN_CONSOLE);
                }
            );
        }



/*
        //***************************************************************
        function getPresupuestosOfUsuario(pUsuarioKey) {

            var fbUrl = firebaseDataService.presupuestos;
            var result = $firebaseArray(fbUrl.orderByChild("usuario_key").equalTo(pUsuarioKey));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    utilsService.writeConsole("[VariosController] => getPresupuestosOfUsuario() => EJECUCIÓN OK DE CONSULTA TABLA presupuestos con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        vm.presupuestos = data;
                        vm.totalPresupuestos = dataLength;

                    } else {

                        vm.presupuestos = null;
                        vm.totalPresupuestos = 0;
                    }

                    utilsService.writeConsole("vm.totalPresupuestos = " + vm.totalPresupuestos, WRITE_IN_CONSOLE);
                })

                .catch(function(error) {

                    vm.presupuestos = null;

                    utilsService.writeConsole("[VariosController] => getPresupuestosOfUsuario() => ERROR: " + error, WRITE_IN_CONSOLE);
                }
            );
        }


        //***************************************************************
        function getPresupuestosOfEmpresa(pEmpresaKey) {

            var fbUrl = firebaseDataService.presupuestos;
            var result = $firebaseArray(fbUrl.orderByChild("empresa_key").equalTo(pEmpresaKey));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    utilsService.writeConsole("[VariosController] => getPresupuestosOfEmpresa() => EJECUCIÓN OK DE CONSULTA TABLA presupuestos con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        vm.presupuestos = data;
                        vm.totalPresupuestos = dataLength;

                    } else {

                        vm.presupuestos = null;
                        vm.totalPresupuestos = 0;
                    }

                    utilsService.writeConsole("vm.totalPresupuestos = " + vm.totalPresupuestos, WRITE_IN_CONSOLE);
                })

                .catch(function(error) {

                    vm.presupuestos = null;

                    utilsService.writeConsole("[VariosController] => getPresupuestosOfEmpresa() => ERROR: " + error, WRITE_IN_CONSOLE);
                }
            );
        }
*/


        //***************************************************************
        function deleteVario(pId) {

            //We get the record with pId key
            var recordToDelete = vm.varios.$getRecord(pId)
            
            if (pId != null) {
                vm.varios.$remove(recordToDelete)
                    .then(function(ref) {
                        utilsService.writeConsole("[VariosController] => deleteVario() => Record deleted in 'productos_varios' table", WRITE_IN_CONSOLE);
                    }
                );
            } else {
                utilsService.writeConsole("[VariosController] => deleteVario() => We can´t remove the row.", WRITE_IN_CONSOLE);
            }
        }



        //***************************************************************
        function showConfirmDeleteDialog(ev,pId) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('¿Estás seguro de eliminar el registro?')
                .textContent("")
                //.ariaLabel(""'Lucky day')
                .ariaLabel("")
                .targetEvent(ev)
                .ok("ELIMINAR")
                .cancel("CANCELAR");

            $mdDialog.show(confirm)
                .then(function() {
                    //YOU HAVE PUSHED "YES" BUTTON
                    vm.deleteVario(pId);
                }, 
                function() {
                    //YOU HAVE PUSHED "NO" BUTTON
                });
        }



        //***************************************************************
        function showAlertDialog(pText) {
            // Appending dialog to document.body to cover sidenav in docs app
            var alert = $mdDialog.alert()
                .title("Información")
                .textContent(pText)
                //.ariaLabel("")
                //.targetEvent(ev)
                .ok("Cerrar")
                //.cancel("No");

            $mdDialog.show(alert)
                .finally(function() {
                    //utilsService.writeConsole("WE REDIRECT TO 'SELECT-ITB' PAGE", WRITE_IN_CONSOLE);
                    //$location.path("/workflow-admin/select-itb");
                }); 
        }



        //***************************************************************
        function gotoVarioDetail(id)
        {
            $state.go('app.menu_productos_varios_vario', {id: id});
        }



        //***************************************************************
        function gotoAddVario()
        {
            $state.go('app.menu_productos_varios_add');
        }




        //***************************************************************
        function addConfiguracionPrecios() {

            var fbUrl = firebaseDataService.configuracion_precios;
            var configuracionPrecios = $firebaseArray(fbUrl);

            var json = [

                    //*********************************************
                    //PRECIOS PARA PASSE-PARTOUT MULTI-VENTANA
                    {
                      "referencia": "19959793",
                      "refLeroyMerlin": "19959793",
                      "refProveedor": " ",
                      "descripcion": "Servicio passe-partout multi-ventana - 1 o 2 ventanas",
                      "precioCoste": 0,
                      "precioLeroyMerlin": 0,
                      "observaciones": ""
                    },
                    {
                      "referencia": "19959800",
                      "refLeroyMerlin": "19959800",
                      "refProveedor": " ",
                      "descripcion": "Servicio passe-partout multi-ventana - 3 ventanas",
                      "precioCoste": 3.00,
                      "precioLeroyMerlin": 7.95,
                      "observaciones": ""
                    },
                    {
                      "referencia": "19959814",
                      "refLeroyMerlin": "19959814",
                      "refProveedor": " ",
                      "descripcion": "Servicio passe-partout multi-ventana - 4 ventanas",
                      "precioCoste": 3.00,
                      "precioLeroyMerlin": 7.95,
                      "observaciones": ""
                    },
                    {
                      "referencia": "19959835",
                      "refLeroyMerlin": "19959835",
                      "refProveedor": " ",
                      "descripcion": "Servicio passe-partout multi-ventana - 5 ventanas",
                      "precioCoste": 5.00,
                      "precioLeroyMerlin": 8.95,
                      "observaciones": ""
                    },
                    {
                      "referencia": "19959842",
                      "refLeroyMerlin": "19959842",
                      "refProveedor": " ",
                      "descripcion": "Servicio passe-partout multi-ventana - 6 ventanas",
                      "precioCoste": 5.00,
                      "precioLeroyMerlin": 8.95,
                      "observaciones": ""
                    },
                    {
                      "referencia": "19959863",
                      "refLeroyMerlin": "19959863",
                      "refProveedor": " ",
                      "descripcion": "Servicio passe-partout multi-ventana - 7 a 10 ventanas",
                      "precioCoste": 5.00,
                      "precioLeroyMerlin": 8.95,
                      "observaciones": ""
                    },

                    //*********************************************
                    //PRECIOS PARA TRANSPORTE CON MOTIVO
                    {
                      "referencia": "T-CM-S1",
                      "refLeroyMerlin": "T-CM-S1",
                      "refProveedor": " ",
                      "descripcion": "Servicio Transporte con motivo S1 (area<0.36)",
                      "precioCoste": 19.33,
                      "precioLeroyMerlin": 27.599,
                      "observaciones": ""
                    },
                    {
                      "referencia": "T-CM-S2",
                      "refLeroyMerlin": "T-CM-S2",
                      "refProveedor": " ",
                      "descripcion": "Servicio Transporte con motivo S2 (area>=0.36 y area<0.98)",
                      "precioCoste": 29.56,
                      "precioLeroyMerlin": 42.206,
                      "observaciones": ""
                    },
                    {
                      "referencia": "T-CM-S3",
                      "refLeroyMerlin": "T-CM-S3",
                      "refProveedor": " ",
                      "descripcion": "Servicio Transporte con motivo S3 (area>=0.98)",
                      "precioCoste": 44.97,
                      "precioLeroyMerlin": 64.208,
                      "observaciones": ""
                    },


                    //PRECIOS PARA TRANSPORTE SIN MOTIVO
                    {
                      "referencia": "T-SM-S1",
                      "refLeroyMerlin": "T-SM-S1",
                      "refProveedor": " ",
                      "descripcion": "Servicio Transporte sin motivo S1 (area<0.36)",
                      "precioCoste": 14.83,
                      "precioLeroyMerlin": 21.174,
                      "observaciones": ""
                    },
                    {
                      "referencia": "T-SM-S2",
                      "refLeroyMerlin": "T-SM-S2",
                      "refProveedor": " ",
                      "descripcion": "Servicio Transporte sin motivo S2 (area>=0.36 y area<0.98)",
                      "precioCoste": 24.06,
                      "precioLeroyMerlin": 34.353,
                      "observaciones": ""
                    },
                    {
                      "referencia": "T-SM-S3",
                      "refLeroyMerlin": "T-SM-S3",
                      "refProveedor": " ",
                      "descripcion": "Servicio Transporte sin motivo S3 (area>=0.98)",
                      "precioCoste": 38.97,
                      "precioLeroyMerlin": 55.641,
                      "observaciones": ""
                    },


                    //*********************************************
                    //PRECIOS PARA MONTAJE CON MOTIVO
                    {
                      "referencia": "M-CM-S1",
                      "refLeroyMerlin": "M-CM-S1",
                      "refProveedor": " ",
                      "descripcion": "Servicio Montaje con motivo S1 (area<0.36)",
                      "precioCoste": 19.33,
                      "precioLeroyMerlin": 27.599,
                      "observaciones": ""
                    },
                    {
                      "referencia": "M-CM-S2",
                      "refLeroyMerlin": "M-CM-S2",
                      "refProveedor": " ",
                      "descripcion": "Servicio Montaje con motivo S2 (area>=0.36 y area<0.98)",
                      "precioCoste": 29.56,
                      "precioLeroyMerlin": 42.206,
                      "observaciones": ""
                    },
                    {
                      "referencia": "M-CM-S3",
                      "refLeroyMerlin": "M-CM-S3",
                      "refProveedor": " ",
                      "descripcion": "Servicio Montaje con motivo S3 (area>=0.98)",
                      "precioCoste": 44.97,
                      "precioLeroyMerlin": 64.208,
                      "observaciones": ""
                    },


                    //PRECIOS PARA MONTAJE SIN MOTIVO
                    {
                      "referencia": "M-SM-S1",
                      "refLeroyMerlin": "M-SM-S1",
                      "refProveedor": " ",
                      "descripcion": "Servicio Montaje sin motivo S1 (area<0.36)",
                      "precioCoste": 14.83,
                      "precioLeroyMerlin": 21.174,
                      "observaciones": ""
                    },
                    {
                      "referencia": "M-SM-S2",
                      "refLeroyMerlin": "M-SM-S2",
                      "refProveedor": " ",
                      "descripcion": "Servicio Montaje sin motivo S2 (area>=0.36 y area<0.98)",
                      "precioCoste": 24.06,
                      "precioLeroyMerlin": 34.353,
                      "observaciones": ""
                    },
                    {
                      "referencia": "M-SM-S3",
                      "refLeroyMerlin": "M-SM-S3",
                      "refProveedor": " ",
                      "descripcion": "Servicio Montaje sin motivo S3 (area>=0.98)",
                      "precioCoste": 38.97,
                      "precioLeroyMerlin": 55.641,
                      "observaciones": ""
                    },


                    //*********************************************
                    //PRECIOS PARA EMBALAJE CON MOTIVO
                    {
                      "referencia": "E-CM-S1",
                      "refLeroyMerlin": "E-CM-S1",
                      "refProveedor": " ",
                      "descripcion": "Servicio Embalaje con motivo S1 (area<0.36)",
                      "precioCoste": 19.33,
                      "precioLeroyMerlin": 27.599,
                      "observaciones": ""
                    },
                    {
                      "referencia": "E-CM-S2",
                      "refLeroyMerlin": "E-CM-S2",
                      "refProveedor": " ",
                      "descripcion": "Servicio Embalaje con motivo S2 (area>=0.36 y area<0.98)",
                      "precioCoste": 29.56,
                      "precioLeroyMerlin": 42.206,
                      "observaciones": ""
                    },
                    {
                      "referencia": "E-CM-S3",
                      "refLeroyMerlin": "E-CM-S3",
                      "refProveedor": " ",
                      "descripcion": "Servicio Embalaje con motivo S3 (area>=0.98)",
                      "precioCoste": 44.97,
                      "precioLeroyMerlin": 64.208,
                      "observaciones": ""
                    },


                    //PRECIOS PARA EMBALAJE SIN MOTIVO
                    {
                      "referencia": "E-SM-S1",
                      "refLeroyMerlin": "E-SM-S1",
                      "refProveedor": " ",
                      "descripcion": "Servicio Embalaje sin motivo S1 (area<0.36)",
                      "precioCoste": 14.83,
                      "precioLeroyMerlin": 21.174,
                      "observaciones": ""
                    },
                    {
                      "referencia": "E-SM-S2",
                      "refLeroyMerlin": "E-SM-S2",
                      "refProveedor": " ",
                      "descripcion": "Servicio Embalaje sin motivo S2 (area>=0.36 y area<0.98)",
                      "precioCoste": 24.06,
                      "precioLeroyMerlin": 34.353,
                      "observaciones": ""
                    },
                    {
                      "referencia": "E-SM-S3",
                      "refLeroyMerlin": "E-SM-S3",
                      "refProveedor": " ",
                      "descripcion": "Servicio Embalaje sin motivo S3 (area>=0.98)",
                      "precioCoste": 38.97,
                      "precioLeroyMerlin": 55.641,
                      "observaciones": ""
                    },

            ];

            for (var i=0;i<json.length;i++) {

                configuracionPrecios.$add(json[i])
                    .then(function(ref) {

                        utilsService.writeConsole("[VariosController] - addConfiguracionPrecios(json) => Added new record (" + i + ") to 'configuracionPrecios'", WRITE_IN_CONSOLE);

                    })
                    .catch(function(error) {
                        utilsService.writeConsole("[VariosController] - addConfiguracionPrecios(json) => ERROR: " + error, WRITE_IN_CONSOLE); 
                    }
                );
            }                    
        }




    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.menu.productos.varios')
        .controller('VarioController', VarioController);

    /** @ngInject */
    function VarioController($state,WRITE_IN_CONSOLE,utilsService,loginService,firebaseDataService,$firebaseArray,$firebaseObject,$timeout)
    {
        //********************************************************        
        // DATA DECLARATION
        //********************************************************        
        var vm = this;

        vm.mode = "";       //accepted values = ["insert","update"]

        vm.vario = {};
        vm.varioKey = "";
        vm.tipos = [];

        //vm.estados = ["Aprobado","Pendiente","Anulado"];
        //vm.provincias = ["Álava","Albacete","Alicante","Almería","Asturias","Ávila","Badajoz","Islas Baleares","Barcelona","Burgos","Cáceres","Cádiz","Cantabria","Castellón","Ciudad Real","Córdoba","Cuenca","Girona","Granada","Guadalajara","Guipúzcoa","Huelva","Huesca","Jaén","La Coruña","La Rioja","Las Palmas","León","Lleida","Lugo","Madrid","Málaga","Murcia","Navarra","Orense","Palencia","Pontevedra","Salamanca","Segovia","Sevilla","Soria","Tarragona","Santa Cruz de Tenerife","Teruel","Toledo","Valencia","Valladolid","Vizcaya","Zamora","Zaragoza"];

        //vm.fechaConFormato = "";

        //********************************************************
        // METHODS DECLARATION
        //********************************************************   
        vm.getVario = getVario;

        vm.addVario = addVario;
        vm.save = save;

/*
        vm.selectFile = selectFile;
        vm.selectFile2 = selectFile2;

        vm.handleFileSelect = handleFileSelect;
        vm.handleFileSelect2 = handleFileSelect2;
*/

        //vm.showAlertDialog = showAlertDialog;
        vm.gotoVarios = gotoVarios;



        //START CONTROLLER *******************************
        init();
        //START CONTROLLER *******************************


        //********************************************************
        // METHODS DECLARATION
        //********************************************************        
        function init()
        {
            var id;

            vm.tipos = ["cristal","espejo","trasera"];

            try {

                id = $state.params.id;

                if (id == null) {

                    vm.mode = "insert";

                    //Para el caso de la inserción => Asignamos los valores por defecto (estado, envioTienda, tienda y telefonoTienda)
                    vm.vario.limitacionAnchoCm = 0;
                    vm.vario.limitacionAltoCm = 0;
                    vm.vario.precioCoste = 0;
                    vm.vario.precioLeroyMerlin = 0;

                    vm.vario.activo = true;

                } else {
                    vm.mode = "update";
                    vm.getVario(id);
                }


            } catch (error) {
                vm.mode = "insert";
            }

/*
            document.getElementById('fileInput').addEventListener('change', handleFileSelect, false);
            document.getElementById('fileInput2').addEventListener('change', handleFileSelect2, false);
*/
        }



        //***************************************************************
        function getVario(pId) {

            var fbUrl = firebaseDataService.productos_varios.child(pId);
            var result = $firebaseObject(fbUrl);

            result.$loaded()
                .then(function(data) {

                    utilsService.writeConsole("[VariosController] => getVario(pId) => EJECUCIÓN OK DE CONSULTA TABLA productos_varios con $id = " + data.$id, WRITE_IN_CONSOLE);
                    vm.varioKey = data.$id;

                    vm.vario = data;

                    //vm.fechaConFormato = new Date(vm.vario.fechaTimestamp);

/*
                    try {

                        if (vm.vario.urlImagen != null) {
                            document.getElementById("imageFromStorage").src = vm.vario.urlImagen;

                        } else {
                            vm.vario.urlImagen = "";
                            vm.vario.nombreImagen = "";
                        }

                    } catch(error) {

                        vm.vario.urlImagen = "";
                        vm.vario.nombreImagen = "";
                    }

                    try {

                        if (vm.vario.urlImagen2 != null) {
                            document.getElementById("image2FromStorage").src = vm.vario.urlImagen2;

                        } else {
                            vm.vario.urlImagen2 = "";
                            vm.vario.nombreImagen2 = "";
                        }

                    } catch(error) {

                        vm.vario.urlImagen2 = "";
                        vm.vario.nombreImagen2 = "";
                    }
*/


                })

                .catch(function(error) {
                    vm.vario = null;
                    utilsService.writeConsole("[VariosController] => getVario(pId) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        //***************************************************************
        function addVario(pProducto) {

            var fbUrl = firebaseDataService.productos_varios;
            var productos = $firebaseArray(fbUrl.limitToLast(1));

/*
            //Nos aseguramos que los campos numéricos no se guardan como campos de texto
            pProducto.numeroArticulo = Number(pProducto.numeroArticulo);
            pProducto.limitacionAltoCm = Number(pProducto.limitacionAltoCm);
            pProducto.limitacionAnchoCm = Number(pProducto.limitacionAnchoCm);
            pProducto.precioCoste = Number(pProducto.precioCoste);
            pProducto.precioLeroyMerlin = Number(pProducto.precioLeroyMerlin);
            //pProducto.refLeroyMerlin = Number(pProducto.refLeroyMerlin);
*/

            productos.$add(pProducto)
                .then(function(ref) {
                    utilsService.writeConsole("[VariosController] - addVario(pProducto) => Added new record to 'productos_varios'", WRITE_IN_CONSOLE);

                    //We go to moldings list page
                    vm.gotoVarios();

                })
                .catch(function(error) {
                    utilsService.writeConsole("[VariosController] - addVario(pProducto) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        function save() {

            //utilsService.writeConsole("vm.fechaConFormato = " + vm.fechaConFormato, WRITE_IN_CONSOLE);
            //vm.vario.fechaTimestamp = vm.fechaConFormato.getTime();
            //utilsService.writeConsole("vm.vario.fechaTimestamp = " + vm.vario.fechaTimestamp, WRITE_IN_CONSOLE);

/*
            //Nos aseguramos que los campos numéricos no se guardan como campos de texto
            vm.vario.numeroArticulo = Number(vm.vario.numeroArticulo);
            vm.vario.limitacionAltoCm = Number(vm.vario.limitacionAltoCm);
            vm.vario.limitacionAnchoCm = Number(vm.vario.limitacionAnchoCm);
            vm.vario.precioCoste = Number(vm.vario.precioCoste);
            vm.vario.precioLeroyMerlin = Number(vm.vario.precioLeroyMerlin);
            //vm.vario.refLeroyMerlin = Number(vm.vario.refLeroyMerlin);
*/

            if (vm.mode == "update") {
                
                //We update product's data
                vm.vario.$save()
                    .then(function(ref) {
                        utilsService.writeConsole("[VariosController] - save() => moldura saved with ID = " + ref.key, WRITE_IN_CONSOLE);

                        //We go to moldings page
                        vm.gotoVarios();
                    })

                    .catch(function(error) {
                        utilsService.writeConsole("[VariosController] => save() => ERROR: " + error, WRITE_IN_CONSOLE); 
                });                

            } else {

                //We add a new moldura
                vm.addVario(vm.vario);
            }
        }


/*
        function selectFile() {
            angular.element(document.querySelector('#fileInput')).click();
        }


        function selectFile2() {
            angular.element(document.querySelector('#fileInput2')).click();
        }
*/


/*
        function handleFileSelect(evt) {

            vm.storageDirectoryPath = "/Buenatelier/productos/varios/";

            evt.stopPropagation();
            evt.preventDefault();
            var file = evt.target.files[0];

            try {
                var metadata = {
                    'contentType': file.type
                };
            } catch (error) {
                utilsService.writeConsole("[VariosController] => handleFileSelect() => We can´t assign 'contentType' to metadata.", WRITE_IN_CONSOLE)
            }


            var storageRef = firebaseDataService.firebaseStorageRootRef;
            console.log("storageRef = " + storageRef);

            storageRef.child(vm.storageDirectoryPath + file.name).put(file,metadata)
                .then(function(snapshot) {
                    utilsService.writeConsole('Uploaded', snapshot.totalBytes, 'bytes.', WRITE_IN_CONSOLE);
                    utilsService.writeConsole(snapshot.metadata, WRITE_IN_CONSOLE);
                    var url = snapshot.metadata.downloadURLs[0];
                    utilsService.writeConsole('File available at' + url, WRITE_IN_CONSOLE);
                    utilsService.writeConsole("FILE UPLOADED!!!", WRITE_IN_CONSOLE);

                    $timeout(function() {
                        vm.dropping = false;
                        
                        vm.vario.nombreImagen = file.name;
                        vm.vario.urlImagen = snapshot.metadata.downloadURLs[0];

console.log("vm.vario.nombreImagen = " + vm.vario.nombreImagen);
console.log("vm.vario.urlImagen = " + vm.vario.urlImagen);

                        document.getElementById("imageFromStorage").src = vm.vario.urlImagen;

                    });
                })
                .catch(function(error) {
                    utilsService.writeConsole("[VariosController] => handleFileSelect() => Upload failed!!! => ERROR: " + error, WRITE_IN_CONSOLE);
            });
        }


        function handleFileSelect2(evt) {

            vm.storageDirectoryPath = "/Buenatelier/productos/varios/";

            evt.stopPropagation();
            evt.preventDefault();
            var file = evt.target.files[0];

            try {
                var metadata = {
                    'contentType': file.type
                };
            } catch (error) {
                utilsService.writeConsole("[VariosController] => handleFileSelect2() => We can´t assign 'contentType' to metadata.", WRITE_IN_CONSOLE)
            }


            var storageRef = firebaseDataService.firebaseStorageRootRef;
            console.log("storageRef = " + storageRef);

            storageRef.child(vm.storageDirectoryPath + file.name).put(file,metadata)
                .then(function(snapshot) {
                    utilsService.writeConsole('Uploaded', snapshot.totalBytes, 'bytes.', WRITE_IN_CONSOLE);
                    utilsService.writeConsole(snapshot.metadata, WRITE_IN_CONSOLE);
                    var url = snapshot.metadata.downloadURLs[0];
                    utilsService.writeConsole('File available at' + url, WRITE_IN_CONSOLE);
                    utilsService.writeConsole("FILE UPLOADED!!!", WRITE_IN_CONSOLE);

                    $timeout(function() {
                        vm.dropping = false;
                        
                        vm.vario.nombreImagen2 = file.name;
                        vm.vario.urlImagen2 = snapshot.metadata.downloadURLs[0];

console.log("vm.vario.nombreImagen2 = " + vm.vario.nombreImagen2);
console.log("vm.vario.urlImagen2 = " + vm.vario.urlImagen2);

                        document.getElementById("image2FromStorage").src = vm.vario.urlImagen2;

                    });
                })
                .catch(function(error) {
                    utilsService.writeConsole("[VariosController] => handleFileSelect2() => Upload failed!!! => ERROR: " + error, WRITE_IN_CONSOLE);
            });
        }
*/



        //***************************************************************
        function gotoVarios()
        {
            $state.go('app.menu_productos_varios');
        }



/*
        //***************************************************************
        function gotoProductDetail(id)
        {
            $state.go('app.menu_presupuestos_budget', {id: id});
        }
*/


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.menu.productos.servicios',
            [
                // 3rd Party Dependencies
                //'wipImageZoom',
                'datatables',
                'flow',
                'nvd3',
                'textAngular',
                //'uiGmapgoogle-maps',
                'xeditable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider

            .state('app.menu_productos_servicios', {
                url      : '/menu/productos/servicios/servicios',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/menu/productos/servicios/servicios/servicios.html',
                        controller : 'ServiciosController as vm'
                    }
                },

                bodyClass: 'servicios'
            })

            .state('app.menu_productos_servicios_add', {
                url      : '/menu/productos/servicios/servicios/add',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/menu/productos/servicios/servicio/servicio.html',
                        controller : 'ServicioController as vm'
                    }
                },
 
                bodyClass: 'servicios'
            })

            .state('app.menu_productos_servicios_servicio', {
                url      : '/menu/productos/servicios/servicio/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/menu/productos/servicios/servicio/servicio.html',
                        controller : 'ServicioController as vm'
                    }
                },

                bodyClass: 'servicios'
            });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/menu/productos/servicios');

        // Navigation
        msNavigationServiceProvider.saveItem('menu.productos.servicios', {
            title : 'Servicios',
            icon  : 'icon-currency-eur',        //icon-gift
            state: 'app.menu_productos_servicios',
            weight: 4
        });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.menu.productos.servicios')
        .controller('ServiciosController', ServiciosController);

    /** @ngInject */
    function ServiciosController($state,WRITE_IN_CONSOLE,loginService,utilsService,firebaseDataService,$firebaseArray,$mdDialog)
    {

        //********************************************************        
        // DATA DECLARATION
        //********************************************************        
        var vm = this;

        vm.servicios = [];
        vm.totalServicios = 0;  
/*        
        vm.role = "";
        vm.userKey= "";
*/
        //********************************************************
        // METHODS DECLARATION
        //********************************************************  
        vm.initData = initData;
        vm.getServicios = getServicios;
        vm.deleteServicio = deleteServicio;
        vm.showConfirmDeleteDialog = showConfirmDeleteDialog;
        vm.showAlertDialog = showAlertDialog;

        vm.gotoServicioDetail = gotoServicioDetail;
        vm.gotoAddServicio = gotoAddServicio;


//IMPORTANTE => MÉTODO PARA AÑADIR LOS PRECIOS DE LOS SERVICIOS DE MONTAJE, EMBALAJE, TRANSPORTE Y PASSE-PARTOUT MULTI-VENTANA
//vm.addConfiguracionPrecios = addConfiguracionPrecios;



        //START CONTROLLER *******************************
        init();
        //START CONTROLLER *******************************


        //********************************************************
        // METHODS DECLARATION
        //********************************************************        
        function init()
        {
            //We initialize the data for the controller
            vm.initData();

/*
            var role = loginService.getUserProfile();
            var userKey = loginService.getUserKey();

            //Si el usuario es Administrador => Mostramos todos los presupuestos (de todas las empresas y de todas los usuarios(tiendas) )
            if (role == "administrator") {
                vm.getPresupuestos();

            //Si no es Administrador => Mostramos los presupuestos creados por la Tienda actual (usuario)
            } else {
                vm.getPresupuestosOfUsuario(userKey);
            }
*/

            vm.getServicios();

        }


        //***************************************************************
        function initData() {

            vm.dtInstance = {};
            vm.dtOptions = {
                dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                columnDefs  : [
                    {
                        // Target the "Ref servicio" column
                        targets   : 0,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },
/*
                    {
                        // Target the "Referencia proveedor" column
                        targets   : 1,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },
*/                    
                    {
                        // Target the "Referencia 1" column
                        targets   : 1,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },
                    {
                        // Target the "Descripcion" column
                        targets   : 2,
                        //filterable: false,
                        //sortable  : false,
                        width     : '300px'
                    },

/*
                    {
                        // Target the "tipo" column
                        targets   : 4,
                        //filterable: false,
                        width     : '50px',
                    },

                    {
                        // Target the "Ancho máx(cm)" column
                        targets   : 5,
                        //filterable: false,
                        width     : '50px',
                        
                        render    : function (data, type)
                        {
                            if (data == 'true')
                            {
                                return '<i class="icon-alert red-500-fg"></i>';
                            }
                            return '';
                        }
                    },

                    {
                        // Target the ""Alto máx(cm)" column
                        targets   : 6,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },
*/
                    {
                        // Target the "Precio coste" column
                        targets   : 3,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },

                    {
                        // Target the "Precio LM" column
                        targets   : 4,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },

                    {
                        // Target the "Activo" column
                        targets   : 5,
                        //filterable: false,
                        width     : '80px',
                        render    : function (data, type)
                        {
                            if (data == 'true')
                            {
                                return '<i class="icon-checkbox-marked-circle green-500-fg"></i>';
                            }
                            return '<i class="icon-cancel red-500-fg"></i>';
                        }
                    },

                    {
                        // Target the "actions" column
                        targets           : 6,
                        width             : '100px',
                        responsivePriority: 1,
                        filterable        : false,
                        sortable          : false
                    }
                ],
                initComplete: function ()
                {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#servicios-search');

                    // Bind an external input as a table wide search box
                    if ( searchBox.length > 0 )
                    {
                        searchBox.on('keyup', function (event)
                        {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType  : 'simple',
                lengthMenu  : [100, 250, 500],
                pageLength  : 100,
                scrollY     : 'auto',
                responsive  : true
            };
        }



        //***************************************************************
        function getServicios() {

            var fbUrl = firebaseDataService.configuracion_precios;
            var result = $firebaseArray(fbUrl.orderByChild("descripcion"));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    utilsService.writeConsole("[ServiciosController] => getServicios() => EJECUCIÓN OK DE CONSULTA TABLA configuracion_precios con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        vm.servicios = data;
                        vm.totalServicios = dataLength;

                    } else {

                        vm.servicios = null;
                        vm.totalServicios = 0;
                    }

                    utilsService.writeConsole("vm.totalServicios = " + vm.totalServicios, WRITE_IN_CONSOLE);

                })

                .catch(function(error) {

                    vm.servicios = null;

                    utilsService.writeConsole("[ServiciosController] => getServicios() => ERROR: " + error, WRITE_IN_CONSOLE);
                }
            );
        }



/*
        //***************************************************************
        function getPresupuestosOfUsuario(pUsuarioKey) {

            var fbUrl = firebaseDataService.presupuestos;
            var result = $firebaseArray(fbUrl.orderByChild("usuario_key").equalTo(pUsuarioKey));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    utilsService.writeConsole("[ServiciosController] => getPresupuestosOfUsuario() => EJECUCIÓN OK DE CONSULTA TABLA presupuestos con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        vm.presupuestos = data;
                        vm.totalPresupuestos = dataLength;

                    } else {

                        vm.presupuestos = null;
                        vm.totalPresupuestos = 0;
                    }

                    utilsService.writeConsole("vm.totalPresupuestos = " + vm.totalPresupuestos, WRITE_IN_CONSOLE);
                })

                .catch(function(error) {

                    vm.presupuestos = null;

                    utilsService.writeConsole("[ServiciosController] => getPresupuestosOfUsuario() => ERROR: " + error, WRITE_IN_CONSOLE);
                }
            );
        }


        //***************************************************************
        function getPresupuestosOfEmpresa(pEmpresaKey) {

            var fbUrl = firebaseDataService.presupuestos;
            var result = $firebaseArray(fbUrl.orderByChild("empresa_key").equalTo(pEmpresaKey));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    utilsService.writeConsole("[ServiciosController] => getPresupuestosOfEmpresa() => EJECUCIÓN OK DE CONSULTA TABLA presupuestos con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        vm.presupuestos = data;
                        vm.totalPresupuestos = dataLength;

                    } else {

                        vm.presupuestos = null;
                        vm.totalPresupuestos = 0;
                    }

                    utilsService.writeConsole("vm.totalPresupuestos = " + vm.totalPresupuestos, WRITE_IN_CONSOLE);
                })

                .catch(function(error) {

                    vm.presupuestos = null;

                    utilsService.writeConsole("[ServiciosController] => getPresupuestosOfEmpresa() => ERROR: " + error, WRITE_IN_CONSOLE);
                }
            );
        }
*/


        //***************************************************************
        function deleteServicio(pId) {

            //We get the record with pId key
            var recordToDelete = vm.servicios.$getRecord(pId)
            
            if (pId != null) {
                vm.servicios.$remove(recordToDelete)
                    .then(function(ref) {
                        utilsService.writeConsole("[ServiciosController] => deleteServicio() => Record deleted in 'configuracion_precios' table", WRITE_IN_CONSOLE);
                    }
                );
            } else {
                utilsService.writeConsole("[ServiciosController] => deleteServicio() => We can´t remove the row.", WRITE_IN_CONSOLE);
            }
        }



        //***************************************************************
        function showConfirmDeleteDialog(ev,pId) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('¿Estás seguro de eliminar el registro?')
                .textContent("")
                //.ariaLabel(""'Lucky day')
                .ariaLabel("")
                .targetEvent(ev)
                .ok("ELIMINAR")
                .cancel("CANCELAR");

            $mdDialog.show(confirm)
                .then(function() {
                    //YOU HAVE PUSHED "YES" BUTTON
                    vm.deleteServicio(pId);
                }, 
                function() {
                    //YOU HAVE PUSHED "NO" BUTTON
                });
        }



        //***************************************************************
        function showAlertDialog(pText) {
            // Appending dialog to document.body to cover sidenav in docs app
            var alert = $mdDialog.alert()
                .title("Información")
                .textContent(pText)
                //.ariaLabel("")
                //.targetEvent(ev)
                .ok("Cerrar")
                //.cancel("No");

            $mdDialog.show(alert)
                .finally(function() {
                    //utilsService.writeConsole("WE REDIRECT TO 'SELECT-ITB' PAGE", WRITE_IN_CONSOLE);
                    //$location.path("/workflow-admin/select-itb");
                }); 
        }



        //***************************************************************
        function gotoServicioDetail(id)
        {
            $state.go('app.menu_productos_servicios_servicio', {id: id});
        }



        //***************************************************************
        function gotoAddServicio()
        {
            $state.go('app.menu_productos_servicios_add');
        }



    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.menu.productos.servicios')
        .controller('ServicioController', ServicioController);

    /** @ngInject */
    function ServicioController($state,WRITE_IN_CONSOLE,utilsService,loginService,firebaseDataService,$firebaseArray,$firebaseObject,$timeout)
    {
        //********************************************************        
        // DATA DECLARATION
        //********************************************************        
        var vm = this;

        vm.mode = "";       //accepted values = ["insert","update"]

        vm.servicio = {};
        vm.servicioKey = "";
        //vm.tipos = [];

        //vm.estados = ["Aprobado","Pendiente","Anulado"];
        //vm.provincias = ["Álava","Albacete","Alicante","Almería","Asturias","Ávila","Badajoz","Islas Baleares","Barcelona","Burgos","Cáceres","Cádiz","Cantabria","Castellón","Ciudad Real","Córdoba","Cuenca","Girona","Granada","Guadalajara","Guipúzcoa","Huelva","Huesca","Jaén","La Coruña","La Rioja","Las Palmas","León","Lleida","Lugo","Madrid","Málaga","Murcia","Navarra","Orense","Palencia","Pontevedra","Salamanca","Segovia","Sevilla","Soria","Tarragona","Santa Cruz de Tenerife","Teruel","Toledo","Valencia","Valladolid","Vizcaya","Zamora","Zaragoza"];

        //vm.fechaConFormato = "";

        //********************************************************
        // METHODS DECLARATION
        //********************************************************   
        vm.getServicio = getServicio;

        vm.addServicio = addServicio;
        vm.save = save;

/*
        vm.selectFile = selectFile;
        vm.selectFile2 = selectFile2;

        vm.handleFileSelect = handleFileSelect;
        vm.handleFileSelect2 = handleFileSelect2;
*/

        //vm.showAlertDialog = showAlertDialog;
        vm.gotoServicios = gotoServicios;



        //START CONTROLLER *******************************
        init();
        //START CONTROLLER *******************************


        //********************************************************
        // METHODS DECLARATION
        //********************************************************        
        function init()
        {
            var id;

            //vm.tipos = ["cristal","espejo","trasera"];

            try {

                id = $state.params.id;

                if (id == null) {

                    vm.mode = "insert";

                    //Para el caso de la inserción => Asignamos los valores por defecto (estado, envioTienda, tienda y telefonoTienda)
                    vm.servicio.limitacionAnchoCm = 0;
                    vm.servicio.limitacionAltoCm = 0;
                    vm.servicio.precioCoste = 0;
                    vm.servicio.precioLeroyMerlin = 0;

                    vm.servicio.activo = true;

                } else {
                    vm.mode = "update";
                    vm.getServicio(id);
                }


            } catch (error) {
                vm.mode = "insert";
            }

/*
            document.getElementById('fileInput').addEventListener('change', handleFileSelect, false);
            document.getElementById('fileInput2').addEventListener('change', handleFileSelect2, false);
*/
        }



        //***************************************************************
        function getServicio(pId) {

            var fbUrl = firebaseDataService.configuracion_precios.child(pId);
            var result = $firebaseObject(fbUrl);

            result.$loaded()
                .then(function(data) {

                    utilsService.writeConsole("[ServicioController] => getServicio(pId) => EJECUCIÓN OK DE CONSULTA TABLA configuracion_precios con $id = " + data.$id, WRITE_IN_CONSOLE);
                    vm.servicioKey = data.$id;

                    vm.servicio = data;

                    //vm.fechaConFormato = new Date(vm.servicio.fechaTimestamp);

/*
                    try {

                        if (vm.servicio.urlImagen != null) {
                            document.getElementById("imageFromStorage").src = vm.servicio.urlImagen;

                        } else {
                            vm.servicio.urlImagen = "";
                            vm.servicio.nombreImagen = "";
                        }

                    } catch(error) {

                        vm.servicio.urlImagen = "";
                        vm.servicio.nombreImagen = "";
                    }

                    try {

                        if (vm.servicio.urlImagen2 != null) {
                            document.getElementById("image2FromStorage").src = vm.servicio.urlImagen2;

                        } else {
                            vm.servicio.urlImagen2 = "";
                            vm.servicio.nombreImagen2 = "";
                        }

                    } catch(error) {

                        vm.servicio.urlImagen2 = "";
                        vm.servicio.nombreImagen2 = "";
                    }
*/


                })

                .catch(function(error) {
                    vm.servicio = null;
                    utilsService.writeConsole("[ServicioController] => getServicio(pId) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        //***************************************************************
        function addServicio(pServicio) {

            var fbUrl = firebaseDataService.configuracion_precios;
            var productos = $firebaseArray(fbUrl.limitToLast(1));

/*
            //Nos aseguramos que los campos numéricos no se guardan como campos de texto
            pProducto.numeroArticulo = Number(pProducto.numeroArticulo);
            pProducto.limitacionAltoCm = Number(pProducto.limitacionAltoCm);
            pProducto.limitacionAnchoCm = Number(pProducto.limitacionAnchoCm);
            pProducto.precioCoste = Number(pProducto.precioCoste);
            pProducto.precioLeroyMerlin = Number(pProducto.precioLeroyMerlin);
            //pProducto.refLeroyMerlin = Number(pProducto.refLeroyMerlin);
*/

            productos.$add(pServicio)
                .then(function(ref) {
                    utilsService.writeConsole("[ServicioController] - addServicio(pServicio) => Added new record to 'configuracion_precios'", WRITE_IN_CONSOLE);

                    //We go to moldings list page
                    vm.gotoServicios();

                })
                .catch(function(error) {
                    utilsService.writeConsole("[ServicioController] - addServicio(pServicio) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        function save() {

            //utilsService.writeConsole("vm.fechaConFormato = " + vm.fechaConFormato, WRITE_IN_CONSOLE);
            //vm.servicio.fechaTimestamp = vm.fechaConFormato.getTime();
            //utilsService.writeConsole("vm.servicio.fechaTimestamp = " + vm.servicio.fechaTimestamp, WRITE_IN_CONSOLE);

/*
            //Nos aseguramos que los campos numéricos no se guardan como campos de texto
            vm.servicio.numeroArticulo = Number(vm.servicio.numeroArticulo);
            vm.servicio.limitacionAltoCm = Number(vm.servicio.limitacionAltoCm);
            vm.servicio.limitacionAnchoCm = Number(vm.servicio.limitacionAnchoCm);
            vm.servicio.precioCoste = Number(vm.servicio.precioCoste);
            vm.servicio.precioLeroyMerlin = Number(vm.servicio.precioLeroyMerlin);
            //vm.servicio.refLeroyMerlin = Number(vm.servicio.refLeroyMerlin);
*/

            if (vm.mode == "update") {
                
                //We update product's data
                vm.servicio.$save()
                    .then(function(ref) {
                        utilsService.writeConsole("[ServicioController] - save() => servicio saved with ID = " + ref.key, WRITE_IN_CONSOLE);

                        //We go to moldings page
                        vm.gotoServicios();
                    })

                    .catch(function(error) {
                        utilsService.writeConsole("[ServicioController] => save() => ERROR: " + error, WRITE_IN_CONSOLE); 
                });                

            } else {

                //We add a new servicio
                vm.addServicio(vm.servicio);
            }
        }


/*
        function selectFile() {
            angular.element(document.querySelector('#fileInput')).click();
        }


        function selectFile2() {
            angular.element(document.querySelector('#fileInput2')).click();
        }
*/


/*
        function handleFileSelect(evt) {

            vm.storageDirectoryPath = "/Buenatelier/productos/varios/";

            evt.stopPropagation();
            evt.preventDefault();
            var file = evt.target.files[0];

            try {
                var metadata = {
                    'contentType': file.type
                };
            } catch (error) {
                utilsService.writeConsole("[ServicioController] => handleFileSelect() => We can´t assign 'contentType' to metadata.", WRITE_IN_CONSOLE)
            }


            var storageRef = firebaseDataService.firebaseStorageRootRef;
            console.log("storageRef = " + storageRef);

            storageRef.child(vm.storageDirectoryPath + file.name).put(file,metadata)
                .then(function(snapshot) {
                    utilsService.writeConsole('Uploaded', snapshot.totalBytes, 'bytes.', WRITE_IN_CONSOLE);
                    utilsService.writeConsole(snapshot.metadata, WRITE_IN_CONSOLE);
                    var url = snapshot.metadata.downloadURLs[0];
                    utilsService.writeConsole('File available at' + url, WRITE_IN_CONSOLE);
                    utilsService.writeConsole("FILE UPLOADED!!!", WRITE_IN_CONSOLE);

                    $timeout(function() {
                        vm.dropping = false;
                        
                        vm.servicio.nombreImagen = file.name;
                        vm.servicio.urlImagen = snapshot.metadata.downloadURLs[0];

console.log("vm.servicio.nombreImagen = " + vm.servicio.nombreImagen);
console.log("vm.servicio.urlImagen = " + vm.servicio.urlImagen);

                        document.getElementById("imageFromStorage").src = vm.servicio.urlImagen;

                    });
                })
                .catch(function(error) {
                    utilsService.writeConsole("[ServicioController] => handleFileSelect() => Upload failed!!! => ERROR: " + error, WRITE_IN_CONSOLE);
            });
        }


        function handleFileSelect2(evt) {

            vm.storageDirectoryPath = "/Buenatelier/productos/varios/";

            evt.stopPropagation();
            evt.preventDefault();
            var file = evt.target.files[0];

            try {
                var metadata = {
                    'contentType': file.type
                };
            } catch (error) {
                utilsService.writeConsole("[ServicioController] => handleFileSelect2() => We can´t assign 'contentType' to metadata.", WRITE_IN_CONSOLE)
            }


            var storageRef = firebaseDataService.firebaseStorageRootRef;
            console.log("storageRef = " + storageRef);

            storageRef.child(vm.storageDirectoryPath + file.name).put(file,metadata)
                .then(function(snapshot) {
                    utilsService.writeConsole('Uploaded', snapshot.totalBytes, 'bytes.', WRITE_IN_CONSOLE);
                    utilsService.writeConsole(snapshot.metadata, WRITE_IN_CONSOLE);
                    var url = snapshot.metadata.downloadURLs[0];
                    utilsService.writeConsole('File available at' + url, WRITE_IN_CONSOLE);
                    utilsService.writeConsole("FILE UPLOADED!!!", WRITE_IN_CONSOLE);

                    $timeout(function() {
                        vm.dropping = false;
                        
                        vm.servicio.nombreImagen2 = file.name;
                        vm.servicio.urlImagen2 = snapshot.metadata.downloadURLs[0];

console.log("vm.servicio.nombreImagen2 = " + vm.servicio.nombreImagen2);
console.log("vm.servicio.urlImagen2 = " + vm.servicio.urlImagen2);

                        document.getElementById("image2FromStorage").src = vm.servicio.urlImagen2;

                    });
                })
                .catch(function(error) {
                    utilsService.writeConsole("[ServicioController] => handleFileSelect2() => Upload failed!!! => ERROR: " + error, WRITE_IN_CONSOLE);
            });
        }
*/



        //***************************************************************
        function gotoServicios()
        {
            $state.go('app.menu_productos_servicios');
        }



/*
        //***************************************************************
        function gotoProductDetail(id)
        {
            $state.go('app.menu_presupuestos_budget', {id: id});
        }
*/


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.menu.productos.passepartouts',
            [
                // 3rd Party Dependencies
                //'wipImageZoom',
                'datatables',
                'flow',
                'nvd3',
                'textAngular',
                //'uiGmapgoogle-maps',
                'xeditable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider

            .state('app.menu_productos_passepartouts', {
                url      : '/menu/productos/passepartouts/passepartouts',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/menu/productos/passepartouts/passepartouts/passepartouts.html',
                        controller : 'PassepartoutsController as vm'
                    }
                },

                bodyClass: 'passepartouts'
            })

            .state('app.menu_productos_passepartouts_add', {
                url      : '/menu/productos/passepartouts/passepartouts/add',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/menu/productos/passepartouts/passepartout/passepartout.html',
                        controller : 'PassepartoutController as vm'
                    }
                },
 
                bodyClass: 'passepartouts'
            })

            .state('app.menu_productos_passepartouts_passepartout', {
                url      : '/menu/productos/passepartouts/passepartout/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/menu/productos/passepartouts/passepartout/passepartout.html',
                        controller : 'PassepartoutController as vm'
                    }
                },

                bodyClass: 'passepartouts'
            });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/menu/productos/passepartouts');

        // Navigation
        msNavigationServiceProvider.saveItem('menu.productos.passepartouts', {
            title : 'Passe-partouts',
            icon  : 'icon-arrange-bring-forward',        //icon-gift
            state: 'app.menu_productos_passepartouts',
            weight: 2
        });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.menu.productos.passepartouts')
        .controller('PassepartoutsController', PassepartoutsController);

    /** @ngInject */
    function PassepartoutsController($state,WRITE_IN_CONSOLE,loginService,utilsService,firebaseDataService,$firebaseArray,$mdDialog)
    {

        //********************************************************        
        // DATA DECLARATION
        //********************************************************        
        var vm = this;

        vm.passepartouts = [];
        vm.totalPassepartouts = 0;  
/*        
        vm.role = "";
        vm.userKey= "";
*/
        //********************************************************
        // METHODS DECLARATION
        //********************************************************  
        vm.initData = initData;
        vm.getPassepartouts = getPassepartouts;
        vm.deletePassepartout = deletePassepartout;
        vm.showConfirmDeleteDialog = showConfirmDeleteDialog;
        vm.showAlertDialog = showAlertDialog;

        vm.gotoPassepartoutDetail = gotoPassepartoutDetail;
        vm.gotoAddPassepartout = gotoAddPassepartout;


//IMPORTANTE => MÉTODO PARA AÑADIR LOS PRODUCTOS DE TIPO "PASSEPARTOUT"
//vm.addPassepartouts = addPassepartouts;



        //START CONTROLLER *******************************
        init();
        //START CONTROLLER *******************************


        //********************************************************
        // METHODS DECLARATION
        //********************************************************        
        function init()
        {
            //We initialize the data for the controller
            vm.initData();

/*
            var role = loginService.getUserProfile();
            var userKey = loginService.getUserKey();

            //Si el usuario es Administrador => Mostramos todos los presupuestos (de todas las empresas y de todas los usuarios(tiendas) )
            if (role == "administrator") {
                vm.getPresupuestos();

            //Si no es Administrador => Mostramos los presupuestos creados por la Tienda actual (usuario)
            } else {
                vm.getPresupuestosOfUsuario(userKey);
            }
*/

//IMPORTRANTE => EJECUCIÓN DEL MÉTODO PARA AÑADIR LOS PRODUCTOS DE TIPO "MOLDURA"
//vm.addPassepartouts();

            vm.getPassepartouts();

        }


        //***************************************************************
        function initData() {

            vm.dtInstance = {};
            vm.dtOptions = {
                dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                columnDefs  : [
                    {
                        // Target the "Nº passe-partout" column
                        targets   : 0,
                        //filterable: false,
                        //sortable  : false,
                        width     : '30px'
                    },

                    {
                        // Target the "Referencia proveedor" column
                        targets   : 1,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },
                    {
                        // Target the "Referencia LM" column
                        targets   : 2,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },
                    {
                        // Target the "Descripcion" column
                        targets   : 3,
                        //filterable: false,
                        //sortable  : false,
                        width     : '300px'
                    },

                    {
                        // Target the "Ancho máx(cm)" column
                        targets   : 4,
                        //filterable: false,
                        width     : '50px',
/*                        
                        render    : function (data, type)
                        {
                            if (data == 'true')
                            {
                                return '<i class="icon-alert red-500-fg"></i>';
                            }
                            return '';
                        }
*/                        
                    },

                    {
                        // Target the ""Alto máx(cm)" column
                        targets   : 5,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },

                    {
                        // Target the "Precio coste" column
                        targets   : 6,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },

                    {
                        // Target the "Precio LM" column
                        targets   : 7,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },

                    {
                        // Target the "Activo" column
                        targets   : 8,
                        //filterable: false,
                        width     : '80px',
                        render    : function (data, type)
                        {
                            if (data == 'true')
                            {
                                return '<i class="icon-checkbox-marked-circle green-500-fg"></i>';
                            }
                            return '<i class="icon-cancel red-500-fg"></i>';
                        }
                    },

                    {
                        // Target the "actions" column
                        targets           : 9,
                        width             : '100px',
                        responsivePriority: 1,
                        filterable        : false,
                        sortable          : false
                    }
                ],
                initComplete: function ()
                {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#passepartouts-search');

                    // Bind an external input as a table wide search box
                    if ( searchBox.length > 0 )
                    {
                        searchBox.on('keyup', function (event)
                        {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType  : 'simple',
                lengthMenu  : [100, 250, 500],
                pageLength  : 100,
                scrollY     : 'auto',
                responsive  : true
            };
        }



        //***************************************************************
        function getPassepartouts() {

            var fbUrl = firebaseDataService.productos_passepartout;
//var result = $firebaseArray(fbUrl.limitToFirst(50).orderByChild("numeroPpt"));
            var result = $firebaseArray(fbUrl.orderByChild("numeroPpt"));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    utilsService.writeConsole("[PassepartoutsController] => getPassepartouts() => EJECUCIÓN OK DE CONSULTA TABLA productos_passepartout con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        vm.passepartouts = data;
                        vm.totalPassepartouts = dataLength;

                    } else {

                        vm.passepartouts = null;
                        vm.totalPassepartouts = 0;
                    }

                    utilsService.writeConsole("vm.totalPassepartouts = " + vm.totalPassepartouts, WRITE_IN_CONSOLE);

                })

                .catch(function(error) {

                    vm.passepartouts = null;

                    utilsService.writeConsole("[PassepartoutsController] => getPassepartouts() => ERROR: " + error, WRITE_IN_CONSOLE);
                }
            );
        }



/*
        //***************************************************************
        function getPresupuestosOfUsuario(pUsuarioKey) {

            var fbUrl = firebaseDataService.presupuestos;
            var result = $firebaseArray(fbUrl.orderByChild("usuario_key").equalTo(pUsuarioKey));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    utilsService.writeConsole("[PassepartoutsController] => getPresupuestosOfUsuario() => EJECUCIÓN OK DE CONSULTA TABLA presupuestos con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        vm.presupuestos = data;
                        vm.totalPresupuestos = dataLength;

                    } else {

                        vm.presupuestos = null;
                        vm.totalPresupuestos = 0;
                    }

                    utilsService.writeConsole("vm.totalPresupuestos = " + vm.totalPresupuestos, WRITE_IN_CONSOLE);
                })

                .catch(function(error) {

                    vm.presupuestos = null;

                    utilsService.writeConsole("[PassepartoutsController] => getPresupuestosOfUsuario() => ERROR: " + error, WRITE_IN_CONSOLE);
                }
            );
        }


        //***************************************************************
        function getPresupuestosOfEmpresa(pEmpresaKey) {

            var fbUrl = firebaseDataService.presupuestos;
            var result = $firebaseArray(fbUrl.orderByChild("empresa_key").equalTo(pEmpresaKey));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    utilsService.writeConsole("[PassepartoutsController] => getPresupuestosOfEmpresa() => EJECUCIÓN OK DE CONSULTA TABLA presupuestos con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        vm.presupuestos = data;
                        vm.totalPresupuestos = dataLength;

                    } else {

                        vm.presupuestos = null;
                        vm.totalPresupuestos = 0;
                    }

                    utilsService.writeConsole("vm.totalPresupuestos = " + vm.totalPresupuestos, WRITE_IN_CONSOLE);
                })

                .catch(function(error) {

                    vm.presupuestos = null;

                    utilsService.writeConsole("[PassepartoutsController] => getPresupuestosOfEmpresa() => ERROR: " + error, WRITE_IN_CONSOLE);
                }
            );
        }
*/


        //***************************************************************
        function deletePassepartout(pId) {

            //We get the record with pId key
            var recordToDelete = vm.passepartouts.$getRecord(pId)
            
            if (pId != null) {
                vm.passepartouts.$remove(recordToDelete)
                    .then(function(ref) {
                        utilsService.writeConsole("[PassepartoutsController] => deletePassepartout() => Record deleted in 'productos_passepartout' table", WRITE_IN_CONSOLE);
                    }
                );
            } else {
                utilsService.writeConsole("[PassepartoutsController] => deletePassepartout() => We can´t remove the row.", WRITE_IN_CONSOLE);
            }
        }



        //***************************************************************
        function showConfirmDeleteDialog(ev,pId) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('¿Estás seguro de eliminar el registro?')
                .textContent("")
                //.ariaLabel(""'Lucky day')
                .ariaLabel("")
                .targetEvent(ev)
                .ok("ELIMINAR")
                .cancel("CANCELAR");

            $mdDialog.show(confirm)
                .then(function() {
                    //YOU HAVE PUSHED "YES" BUTTON
                    vm.deletePassepartout(pId);
                }, 
                function() {
                    //YOU HAVE PUSHED "NO" BUTTON
                });
        }



        //***************************************************************
        function showAlertDialog(pText) {
            // Appending dialog to document.body to cover sidenav in docs app
            var alert = $mdDialog.alert()
                .title("Información")
                .textContent(pText)
                //.ariaLabel("")
                //.targetEvent(ev)
                .ok("Cerrar")
                //.cancel("No");

            $mdDialog.show(alert)
                .finally(function() {
                    //utilsService.writeConsole("WE REDIRECT TO 'SELECT-ITB' PAGE", WRITE_IN_CONSOLE);
                    //$location.path("/workflow-admin/select-itb");
                }); 
        }



        //***************************************************************
        function gotoPassepartoutDetail(id)
        {
            $state.go('app.menu_productos_passepartouts_passepartout', {id: id});
        }



        //***************************************************************
        function gotoAddPassepartout()
        {
            $state.go('app.menu_productos_passepartouts_add');
        }



/*
        //***************************************************************
        function addPassepartouts() {

            var fbUrl = firebaseDataService.productos_passepartout;
            var productosPassepartouts = $firebaseArray(fbUrl);

            var json = 
                    [
                     {
                       "numeroPpt": 1,
                       "refLeroyMerlin": 19533913,
                       "refProveedor": "7107/002",
                       "descripcion": "Passepartout Blanco 1,4 mm ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Blanco ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 2,
                       "refLeroyMerlin": 19533920,
                       "refProveedor": "7107/006",
                       "descripcion": "Passepartout blanco roto 1,4 mm ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Blanco roto ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 3,
                       "refLeroyMerlin": 19533934,
                       "refProveedor": "7107/013",
                       "descripcion": "Passepartout Crema 1,4 mm ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Crema  ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 4,
                       "refLeroyMerlin": 19533941,
                       "refProveedor": "7107/021",
                       "descripcion": "Passepartout Vainilla 1,4 mm ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Vainilla ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 5,
                       "refLeroyMerlin": 19533955,
                       "refProveedor": "7107/028",
                       "descripcion": "Passepartout Arena  1,4 mm ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Arena ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 6,
                       "refLeroyMerlin": 19533962,
                       "refProveedor": "7107/039",
                       "descripcion": "Passepartout Camel  1,4 mm ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Camel  ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 7,
                       "refLeroyMerlin": 19533976,
                       "refProveedor": "7107/041",
                       "descripcion": "Passepartout Marrón 1,4 mm ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Marrón ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 8,
                       "refLeroyMerlin": 19533983,
                       "refProveedor": "7107/043",
                       "descripcion": "Passepartout Café 1,4 mm ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Café ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 9,
                       "refLeroyMerlin": 19533990,
                       "refProveedor": "7107/044",
                       "descripcion": "Passepartout Rosa pastel 1,4 mm ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Rosa Pastel ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 10,
                       "refLeroyMerlin": 19534004,
                       "refProveedor": "7107/053",
                       "descripcion": "Passepartout Tierra 1,4 mm  ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Tierra ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 11,
                       "refLeroyMerlin": 19534011,
                       "refProveedor": "7107/054",
                       "descripcion": "Passepartout Rubí 1,4 mm  ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Rubí ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 12,
                       "refLeroyMerlin": 19534025,
                       "refProveedor": "7107/055",
                       "descripcion": "Passepartout Rojo 1,4 mm  ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Rojo  ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 13,
                       "refLeroyMerlin": 19534032,
                       "refProveedor": "7107/057",
                       "descripcion": "Passepartout granate 1,4 mm  ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Granate ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 14,
                       "refLeroyMerlin": 19534046,
                       "refProveedor": "7107/059",
                       "descripcion": "Passepartout Vino 1,4 mm  ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Vino  ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 15,
                       "refLeroyMerlin": 19534053,
                       "refProveedor": "7107/062",
                       "descripcion": "Passepartout Azul pastel 1,4 mm  ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Azul Pastel ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 16,
                       "refLeroyMerlin": 19534060,
                       "refProveedor": "7107/063",
                       "descripcion": "Passepartout Cielo 1,4 mm  ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "cielo  ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 17,
                       "refLeroyMerlin": 19534074,
                       "refProveedor": "7107/067",
                       "descripcion": "Passepartout Azul 1,4 mm  ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Azul  ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 18,
                       "refLeroyMerlin": 19534081,
                       "refProveedor": "7107/069",
                       "descripcion": "Passepartout Marino  1,4 mm  ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Marino ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 19,
                       "refLeroyMerlin": 19534095,
                       "refProveedor": "7107/081",
                       "descripcion": "Passepartout Verde pastel  1,4 mm  ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Verde Pastel ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 20,
                       "refLeroyMerlin": 19534102,
                       "refProveedor": "7107/089",
                       "descripcion": "Passepartout Aceituna  1,4 mm ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Aceituna ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 21,
                       "refLeroyMerlin": 19534116,
                       "refProveedor": "7107/092",
                       "descripcion": "Passepartout Verde Botella 1,4 mm ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Verde Botella ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 22,
                       "refLeroyMerlin": 19534123,
                       "refProveedor": "7107/094",
                       "descripcion": "Passepartout Gris 1,4 mm ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Gris ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 23,
                       "refLeroyMerlin": 19534130,
                       "refProveedor": "7107/095",
                       "descripcion": "Passepartout Negro 1,4 mm ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Negro ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 24,
                       "refLeroyMerlin": 19534144,
                       "refProveedor": "7107/096",
                       "descripcion": "Passepartout Amarillo 1,4 mm ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Amarillo ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 25,
                       "refLeroyMerlin": 19534151,
                       "refProveedor": "7107/097",
                       "descripcion": "Passepartout Naranja 1,4 mm ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Naranja ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 26,
                       "refLeroyMerlin": 19534165,
                       "refProveedor": "7107/100",
                       "descripcion": "Passepartout Rosa 1,4 mm ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Rosa ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 27,
                       "refLeroyMerlin": 19534186,
                       "refProveedor": "7107/101",
                       "descripcion": "Passepartout violeta   1,4 mm ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Violeta ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 28,
                       "refLeroyMerlin": 19534193,
                       "refProveedor": "7107/102",
                       "descripcion": "Passepartout lila  1,4 mm ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Lila ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 29,
                       "refLeroyMerlin": 19534200,
                       "refProveedor": "7107/105",
                       "descripcion": "Passepartout Verde 1,4 mm ",
                       "precioCoste": 14.55,
                       "precioLeroyMerlin": 26.41,
                       "Color": "Verde ",
                       "limitacionAnchoCm": 80,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 30,
                       "refLeroyMerlin": 19534221,
                       "refProveedor": "7120/102",
                       "descripcion": "Passepartout Terciopelo crema 1,4 mm ",
                       "precioCoste": 18.8,
                       "precioLeroyMerlin": 31.85,
                       "Color": "Crema ",
                       "limitacionAnchoCm": 81,
                       "limitacionAltoCm": 102,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 31,
                       "refLeroyMerlin": 19534235,
                       "refProveedor": "7120/105",
                       "descripcion": "Passepartout Terciopelo Marrón  1,4 mm ",
                       "precioCoste": 18.8,
                       "precioLeroyMerlin": 31.85,
                       "Color": "Marrón ",
                       "limitacionAnchoCm": 81,
                       "limitacionAltoCm": 102,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 32,
                       "refLeroyMerlin": 19534242,
                       "refProveedor": "7120/114",
                       "descripcion": "Passepartout Terciopelo Negro 1,4 mm ",
                       "precioCoste": 18.8,
                       "precioLeroyMerlin": 31.85,
                       "Color": "Negro ",
                       "limitacionAnchoCm": 81,
                       "limitacionAltoCm": 102,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 33,
                       "refLeroyMerlin": 19534256,
                       "refProveedor": "7120/116",
                       "descripcion": "Passepartout Terciopelo Granate 1,4 mm ",
                       "precioCoste": 18.8,
                       "precioLeroyMerlin": 31.85,
                       "Color": "Granate ",
                       "limitacionAnchoCm": 81,
                       "limitacionAltoCm": 102,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 34,
                       "refLeroyMerlin": 19534270,
                       "refProveedor": "7121/526",
                       "descripcion": "Passepartout Tela Crema 1,4 mm ",
                       "precioCoste": 18.8,
                       "precioLeroyMerlin": 31.85,
                       "Color": "crema  ",
                       "limitacionAnchoCm": 81,
                       "limitacionAltoCm": 102,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 35,
                       "refLeroyMerlin": 19534291,
                       "refProveedor": "7121/550",
                       "descripcion": "Passepartout Saco Tierra 1,4 mm ",
                       "precioCoste": 18.8,
                       "precioLeroyMerlin": 31.85,
                       "Color": "Saco Tierra ",
                       "limitacionAnchoCm": 81,
                       "limitacionAltoCm": 102,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 36,
                       "refLeroyMerlin": 19534312,
                       "refProveedor": "7121/553",
                       "descripcion": "Passepartout Tela Crema moteado 1,4 mm ",
                       "precioCoste": 18.8,
                       "precioLeroyMerlin": 31.85,
                       "Color": "Crema moteado ",
                       "limitacionAnchoCm": 81,
                       "limitacionAltoCm": 102,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 37,
                       "refLeroyMerlin": 19534340,
                       "refProveedor": "7122/114",
                       "descripcion": "Passepartout Negro alma Negra 1,4 mm ",
                       "precioCoste": 18.8,
                       "precioLeroyMerlin": 31.85,
                       "Color": "negro alma negra ",
                       "limitacionAnchoCm": 81,
                       "limitacionAltoCm": 102,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 38,
                       "refLeroyMerlin": 19534431,
                       "refProveedor": "7122/132",
                       "descripcion": "Passepartout Blanco alma Negra 1,4 mm",
                       "precioCoste": 18.8,
                       "precioLeroyMerlin": 31.85,
                       "Color": "blanco alma negra ",
                       "limitacionAnchoCm": 81,
                       "limitacionAltoCm": 102,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 39,
                       "refLeroyMerlin": 19534473,
                       "refProveedor": "7139/075",
                       "descripcion": "Passepartout Oro  1,3 mm",
                       "precioCoste": 18.8,
                       "precioLeroyMerlin": 31.85,
                       "Color": "Oro ",
                       "limitacionAnchoCm": 70,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     },
                     {
                       "numeroPpt": 40,
                       "refLeroyMerlin": 19534480,
                       "refProveedor": "7139/076",
                       "descripcion": "Passepartout Plata 1,3 mm",
                       "precioCoste": 18.8,
                       "precioLeroyMerlin": 31.85,
                       "Color": "Plata ",
                       "limitacionAnchoCm": 70,
                       "limitacionAltoCm": 120,
                       "urlImagen": "",
                       "urlImagen2": "",
                       "observaciones": "",
                       "activo": true
                     }
                    ];

            for (var i=0;i<json.length;i++) {

                productosPassepartouts.$add(json[i])
                    .then(function(ref) {

                        utilsService.writeConsole("[PassepartoutsController] - addPassepartouts(json) => Added new record (" + i + ") to 'productos_passepartout'", WRITE_IN_CONSOLE);

                    })
                    .catch(function(error) {
                        utilsService.writeConsole("[PassepartoutsController] - addPassepartouts(json) => ERROR: " + error, WRITE_IN_CONSOLE); 
                    }
                );
            }                    
        }
*/



    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.menu.productos.passepartouts')
        .controller('PassepartoutController', PassepartoutController);

    /** @ngInject */
    function PassepartoutController($state,WRITE_IN_CONSOLE,utilsService,loginService,firebaseDataService,$firebaseArray,$firebaseObject,$timeout)
    {
        //********************************************************        
        // DATA DECLARATION
        //********************************************************        
        var vm = this;

        vm.mode = "";       //accepted values = ["insert","update"]

        vm.passepartout = {};
        vm.passepartoutKey = "";

        //vm.estados = ["Aprobado","Pendiente","Anulado"];
        //vm.provincias = ["Álava","Albacete","Alicante","Almería","Asturias","Ávila","Badajoz","Islas Baleares","Barcelona","Burgos","Cáceres","Cádiz","Cantabria","Castellón","Ciudad Real","Córdoba","Cuenca","Girona","Granada","Guadalajara","Guipúzcoa","Huelva","Huesca","Jaén","La Coruña","La Rioja","Las Palmas","León","Lleida","Lugo","Madrid","Málaga","Murcia","Navarra","Orense","Palencia","Pontevedra","Salamanca","Segovia","Sevilla","Soria","Tarragona","Santa Cruz de Tenerife","Teruel","Toledo","Valencia","Valladolid","Vizcaya","Zamora","Zaragoza"];

        //vm.fechaConFormato = "";

        //********************************************************
        // METHODS DECLARATION
        //********************************************************   
        vm.getPassepartout = getPassepartout;

        vm.addPassepartout = addPassepartout;
        vm.save = save;

        vm.selectFile = selectFile;
        vm.selectFile2 = selectFile2;

        vm.handleFileSelect = handleFileSelect;
        vm.handleFileSelect2 = handleFileSelect2;

        //vm.showAlertDialog = showAlertDialog;
        vm.gotoPassepartouts = gotoPassepartouts;

//vm.add100Presupuestos = add100Presupuestos;


        //START CONTROLLER *******************************
        init();
        //START CONTROLLER *******************************


        //********************************************************
        // METHODS DECLARATION
        //********************************************************        
        function init()
        {
            var id;

            try {

                id = $state.params.id;

                if (id == null) {

                    vm.mode = "insert";

                    //Para el caso de la inserción => Asignamos los valores por defecto (estado, envioTienda, tienda y telefonoTienda)
                    vm.passepartout.limitacionAnchoCm = 0;
                    vm.passepartout.limitacionAltoCm = 0;
                    vm.passepartout.precioCoste = 0;
                    vm.passepartout.precioLeroyMerlin = 0;

                    vm.passepartout.activo = true;

                } else {
                    vm.mode = "update";
                    vm.getPassepartout(id);
                }


            } catch (error) {
                vm.mode = "insert";
            }

            document.getElementById('fileInput').addEventListener('change', handleFileSelect, false);
            document.getElementById('fileInput2').addEventListener('change', handleFileSelect2, false);

        }



        //***************************************************************
        function getPassepartout(pId) {

            var fbUrl = firebaseDataService.productos_passepartout.child(pId);
            var result = $firebaseObject(fbUrl);

            result.$loaded()
                .then(function(data) {

                    utilsService.writeConsole("[PassepartoutController] => getPassepartout(pId) => EJECUCIÓN OK DE CONSULTA TABLA productos_passepartout con $id = " + data.$id, WRITE_IN_CONSOLE);
                    vm.passepartoutKey = data.$id;

                    vm.passepartout = data;

                    //vm.fechaConFormato = new Date(vm.passepartout.fechaTimestamp);

                    try {

                        if (vm.passepartout.urlImagen != null) {
                            document.getElementById("imageFromStorage").src = vm.passepartout.urlImagen;

                        } else {
                            vm.passepartout.urlImagen = "";
                            vm.passepartout.nombreImagen = "";
                        }

                    } catch(error) {

                        vm.passepartout.urlImagen = "";
                        vm.passepartout.nombreImagen = "";
                    }

                    try {

                        if (vm.passepartout.urlImagen2 != null) {
                            document.getElementById("image2FromStorage").src = vm.passepartout.urlImagen2;

                        } else {
                            vm.passepartout.urlImagen2 = "";
                            vm.passepartout.nombreImagen2 = "";
                        }

                    } catch(error) {

                        vm.passepartout.urlImagen2 = "";
                        vm.passepartout.nombreImagen2 = "";
                    }



                })

                .catch(function(error) {
                    vm.passepartout = null;
                    utilsService.writeConsole("[PassepartoutController] => getPassepartout(pId) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        //***************************************************************
        function addPassepartout(pMoldura) {

            var fbUrl = firebaseDataService.productos_passepartout;
            var molduras = $firebaseArray(fbUrl.limitToLast(1));

/*
            //Nos aseguramos que los campos numéricos no se guardan como campos de texto
            pMoldura.numeroPpt = Number(pMoldura.numeroPpt);
            pMoldura.limitacionAltoCm = Number(pMoldura.limitacionAltoCm);
            pMoldura.limitacionAnchoCm = Number(pMoldura.limitacionAnchoCm);
            pMoldura.precioCoste = Number(pMoldura.precioCoste);
            pMoldura.precioLeroyMerlin = Number(pMoldura.precioLeroyMerlin);
            //pMoldura.refLeroyMerlin = Number(pMoldura.refLeroyMerlin);
*/
            molduras.$add(pMoldura)
                .then(function(ref) {
                    utilsService.writeConsole("[PassepartoutController] - addPassepartout(pMoldura) => Added new record to 'productos_passepartout'", WRITE_IN_CONSOLE);

                    //We go to moldings list page
                    vm.gotoPassepartouts();

                })
                .catch(function(error) {
                    utilsService.writeConsole("[PassepartoutController] - addPassepartout(pMoldura) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        function save() {

            //utilsService.writeConsole("vm.fechaConFormato = " + vm.fechaConFormato, WRITE_IN_CONSOLE);
            //vm.passepartout.fechaTimestamp = vm.fechaConFormato.getTime();
            //utilsService.writeConsole("vm.passepartout.fechaTimestamp = " + vm.passepartout.fechaTimestamp, WRITE_IN_CONSOLE);

/*
            //Nos aseguramos que los campos numéricos no se guardan como campos de texto
            vm.passepartout.numeroPpt = Number(vm.passepartout.numeroPpt);
            vm.passepartout.limitacionAltoCm = Number(vm.passepartout.limitacionAltoCm);
            vm.passepartout.limitacionAnchoCm = Number(vm.passepartout.limitacionAnchoCm);
            vm.passepartout.precioCoste = Number(vm.passepartout.precioCoste);
            vm.passepartout.precioLeroyMerlin = Number(vm.passepartout.precioLeroyMerlin);
            //vm.passepartout.refLeroyMerlin = Number(vm.passepartout.refLeroyMerlin);
*/
            if (vm.mode == "update") {
                
                //We update product's data
                vm.passepartout.$save()
                    .then(function(ref) {
                        utilsService.writeConsole("[PassepartoutController] - save() => moldura saved with ID = " + ref.key, WRITE_IN_CONSOLE);

                        //We go to moldings page
                        vm.gotoPassepartouts();
                    })

                    .catch(function(error) {
                        utilsService.writeConsole("[PassepartoutController] => save() => ERROR: " + error, WRITE_IN_CONSOLE); 
                });                

            } else {

                //We add a new moldura
                vm.addPassepartout(vm.passepartout);
            }
        }



        function selectFile() {
            angular.element(document.querySelector('#fileInput')).click();
        }


        function selectFile2() {
            angular.element(document.querySelector('#fileInput2')).click();
        }



        function handleFileSelect(evt) {

            vm.storageDirectoryPath = "/Buenatelier/productos/passe-partouts/";

            evt.stopPropagation();
            evt.preventDefault();
            var file = evt.target.files[0];

            try {
                var metadata = {
                    'contentType': file.type
                };
            } catch (error) {
                utilsService.writeConsole("[PassepartoutController] => handleFileSelect() => We can´t assign 'contentType' to metadata.", WRITE_IN_CONSOLE)
            }


            var storageRef = firebaseDataService.firebaseStorageRootRef;
            console.log("storageRef = " + storageRef);

            storageRef.child(vm.storageDirectoryPath + file.name).put(file,metadata)
                .then(function(snapshot) {
                    utilsService.writeConsole('Uploaded', snapshot.totalBytes, 'bytes.', WRITE_IN_CONSOLE);
                    utilsService.writeConsole(snapshot.metadata, WRITE_IN_CONSOLE);
                    var url = snapshot.metadata.downloadURLs[0];
                    utilsService.writeConsole('File available at' + url, WRITE_IN_CONSOLE);
                    utilsService.writeConsole("FILE UPLOADED!!!", WRITE_IN_CONSOLE);

                    $timeout(function() {
                        vm.dropping = false;
                        
                        vm.passepartout.nombreImagen = file.name;
                        vm.passepartout.urlImagen = snapshot.metadata.downloadURLs[0];

console.log("vm.passepartout.nombreImagen = " + vm.passepartout.nombreImagen);
console.log("vm.passepartout.urlImagen = " + vm.passepartout.urlImagen);

                        document.getElementById("imageFromStorage").src = vm.passepartout.urlImagen;

                    });
                })
                .catch(function(error) {
                    utilsService.writeConsole("[PassepartoutController] => handleFileSelect() => Upload failed!!! => ERROR: " + error, WRITE_IN_CONSOLE);
            });
        }


        function handleFileSelect2(evt) {

            vm.storageDirectoryPath = "/Buenatelier/productos/passe-partouts/";

            evt.stopPropagation();
            evt.preventDefault();
            var file = evt.target.files[0];

            try {
                var metadata = {
                    'contentType': file.type
                };
            } catch (error) {
                utilsService.writeConsole("[PassepartoutController] => handleFileSelect2() => We can´t assign 'contentType' to metadata.", WRITE_IN_CONSOLE)
            }


            var storageRef = firebaseDataService.firebaseStorageRootRef;
            console.log("storageRef = " + storageRef);

            storageRef.child(vm.storageDirectoryPath + file.name).put(file,metadata)
                .then(function(snapshot) {
                    utilsService.writeConsole('Uploaded', snapshot.totalBytes, 'bytes.', WRITE_IN_CONSOLE);
                    utilsService.writeConsole(snapshot.metadata, WRITE_IN_CONSOLE);
                    var url = snapshot.metadata.downloadURLs[0];
                    utilsService.writeConsole('File available at' + url, WRITE_IN_CONSOLE);
                    utilsService.writeConsole("FILE UPLOADED!!!", WRITE_IN_CONSOLE);

                    $timeout(function() {
                        vm.dropping = false;
                        
                        vm.passepartout.nombreImagen2 = file.name;
                        vm.passepartout.urlImagen2 = snapshot.metadata.downloadURLs[0];

console.log("vm.passepartout.nombreImagen2 = " + vm.passepartout.nombreImagen2);
console.log("vm.passepartout.urlImagen2 = " + vm.passepartout.urlImagen2);

                        document.getElementById("image2FromStorage").src = vm.passepartout.urlImagen2;

                    });
                })
                .catch(function(error) {
                    utilsService.writeConsole("[PassepartoutController] => handleFileSelect2() => Upload failed!!! => ERROR: " + error, WRITE_IN_CONSOLE);
            });
        }




        //***************************************************************
        function gotoPassepartouts()
        {
            $state.go('app.menu_productos_passepartouts');
        }



/*
        //***************************************************************
        function gotoProductDetail(id)
        {
            $state.go('app.menu_presupuestos_budget', {id: id});
        }
*/



/*
        //***************************************************************
        function add100Presupuestos() {

            var fbUrl = firebaseDataService.presupuestos;
            var presupuestos = $firebaseArray(fbUrl.limitToLast(1));

            for (var i=4;i<100;i++) {

                var json = {"ciudadCliente": "Ciudad "+i,
                            "cliente": "Cliente "+i,
                            "codigo": "PRESU-00"+i,
                            "codigoPostalCliente": "08010",
                            "dimensiones": "¿?",
                            "direccionCliente": "Dirección " + i,
                            "emailCliente": "cliente"+i + "@dominio.com",
                            "envioTienda": true,
                            "envioTiendaValorString": "false",
                            "estado": "Pendiente",
                            "fechaTimestamp": new Date().getTime() + (i*86400000),
                            "numeroPC": "PC171213",
                            "observacionesCliente": "Observación " + i,
                            "provinciaCliente": "Barcelona",
                            "telefonoCliente": "600 11 22 33",
                            "telefonoTienda": "900 11 22 33",
                            "tipoPresupuesto": "¿?",
                            "unidades": 0,
                            "usuario": "Administración central",
                            "usuario_key": "-L-zqZMzj2ApqVql-nn9",
                            "vendedor": "Vendedor " + i
                            }


                presupuestos.$add(json)
                    .then(function(ref) {
                        utilsService.writeConsole("[PassepartoutController] - addPresupuesto(pPresupuesto) => Added new record to 'presupuestos'", WRITE_IN_CONSOLE);

                    })
                    .catch(function(error) {
                        utilsService.writeConsole("[PassepartoutController] - addPresupuesto(pPresupuesto) => ERROR: " + error, WRITE_IN_CONSOLE); 
                    }
                );
            }                    
        }
*/



    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.menu.productos.molduras',
            [
                // 3rd Party Dependencies
                //'wipImageZoom',
                'datatables',
                'flow',
                'nvd3',
                'textAngular',
                //'uiGmapgoogle-maps',
                'xeditable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider

            .state('app.menu_productos_molduras', {
                url      : '/menu/productos/molduras/moldings',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/menu/productos/molduras/moldings/moldings.html',
                        controller : 'MoldingsController as vm'
                    }
                },

                bodyClass: 'molduras'
            })

            .state('app.menu_productos_molduras_add', {
                url      : '/menu/productos/molduras/moldings/add',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/menu/productos/molduras/molding/molding.html',
                        controller : 'MoldingController as vm'
                    }
                },
 
                bodyClass: 'molduras'
            })

            .state('app.menu_productos_molduras_molding', {
                url      : '/menu/productos/molduras/molding/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/menu/productos/molduras/molding/molding.html',
                        controller : 'MoldingController as vm'
                    }
                },

                bodyClass: 'molduras'
            });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/menu/productos/molduras');

        // Navigation
        msNavigationServiceProvider.saveItem('menu.productos.molduras', {
            title : 'Molduras',
            icon  : 'icon-arrange-send-backward',        //icon-gift
            state: 'app.menu_productos_molduras',
            weight: 1
        });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.menu.productos.molduras')
        .controller('MoldingsController', MoldingsController);

    /** @ngInject */
    function MoldingsController($state,WRITE_IN_CONSOLE,loginService,utilsService,firebaseDataService,$firebaseArray,$mdDialog)
    {

        //********************************************************        
        // DATA DECLARATION
        //********************************************************        
        var vm = this;

        vm.molduras = [];
        vm.totalMolduras = 0;  
/*        
        vm.role = "";
        vm.userKey= "";
*/
        //********************************************************
        // METHODS DECLARATION
        //********************************************************  
        vm.initData = initData;
        vm.getMolduras = getMolduras;
        vm.deleteMoldura = deleteMoldura;
        vm.showConfirmDeleteDialog = showConfirmDeleteDialog;
        vm.showAlertDialog = showAlertDialog;

        vm.gotoMoldingDetail = gotoMoldingDetail;
        vm.gotoAddMolding = gotoAddMolding;

/*
//IMPORTANTE => MÉTODO PARA AÑADIR LOS PRODUCTOS DE TIPO "MOLDURA"
        vm.addMolduras = addMolduras;
*/


        //START CONTROLLER *******************************
        init();
        //START CONTROLLER *******************************


        //********************************************************
        // METHODS DECLARATION
        //********************************************************        
        function init()
        {
            //We initialize the data for the controller
            vm.initData();

/*
            var role = loginService.getUserProfile();
            var userKey = loginService.getUserKey();

            //Si el usuario es Administrador => Mostramos todos los presupuestos (de todas las empresas y de todas los usuarios(tiendas) )
            if (role == "administrator") {
                vm.getPresupuestos();

            //Si no es Administrador => Mostramos los presupuestos creados por la Tienda actual (usuario)
            } else {
                vm.getPresupuestosOfUsuario(userKey);
            }
*/

//IMPORTRANTE => EJECUCIÓN DEL MÉTODO PARA AÑADIR LOS PRODUCTOS DE TIPO "MOLDURA"
//vm.addMolduras();

            vm.getMolduras();

        }


        //***************************************************************
        function initData() {

            vm.dtInstance = {};
            vm.dtOptions = {
                dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                columnDefs  : [
                    {
                        // Target the "Nº moldura" column
                        targets   : 0,
                        //filterable: false,
                        //sortable  : false,
                        width     : '30px'
                    },

                    {
                        // Target the "Referencia proveedor" column
                        targets   : 1,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },
                    {
                        // Target the "Referencia LM" column
                        targets   : 2,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },
                    {
                        // Target the "Descripcion" column
                        targets   : 3,
                        //filterable: false,
                        //sortable  : false,
                        width     : '300px'
                    },

                    {
                        // Target the "Limitación 70 cm" column
                        targets   : 4,
                        //filterable: false,
                        width     : '50px',
                        render    : function (data, type)
                        {
                            if (data == 'true')
                            {
                                return '<i class="icon-alert red-500-fg"></i>';
                            }
                            return '';
                        }
                    },

                    {
                        // Target the "Desperdicio" column
                        targets   : 5,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },

                    {
                        // Target the "Precio coste" column
                        targets   : 6,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },

                    {
                        // Target the "Precio LM" column
                        targets   : 7,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },

                    {
                        // Target the "Activo" column
                        targets   : 8,
                        //filterable: false,
                        width     : '80px',
                        render    : function (data, type)
                        {
                            if (data == 'true')
                            {
                                return '<i class="icon-checkbox-marked-circle green-500-fg"></i>';
                            }
                            return '<i class="icon-cancel red-500-fg"></i>';
                        }
                    },

                    {
                        // Target the "actions" column
                        targets           : 9,
                        width             : '100px',
                        responsivePriority: 1,
                        filterable        : false,
                        sortable          : false
                    }
                ],
                initComplete: function ()
                {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#moldings-search');

                    // Bind an external input as a table wide search box
                    if ( searchBox.length > 0 )
                    {
                        searchBox.on('keyup', function (event)
                        {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType  : 'simple',
                lengthMenu  : [100, 250, 500],
                pageLength  : 500,
                scrollY     : 'auto',
                responsive  : true
            };
        }



        //***************************************************************
        function getMolduras() {

            var fbUrl = firebaseDataService.productos_moldura;
            
//var result = $firebaseArray(fbUrl.limitToFirst(50).orderByChild("numeroMoldura"));
            var result = $firebaseArray(fbUrl.orderByChild("numeroMoldura"));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    utilsService.writeConsole("[MoldingsController] => getMolduras() => EJECUCIÓN OK DE CONSULTA TABLA productos_moldura con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        vm.molduras = data;
                        vm.totalMolduras = dataLength;

                    } else {

                        vm.molduras = null;
                        vm.totalMolduras = 0;
                    }

                    utilsService.writeConsole("vm.totalMolduras = " + vm.totalMolduras, WRITE_IN_CONSOLE);

                })

                .catch(function(error) {

                    vm.molduras = null;

                    utilsService.writeConsole("[MoldingsController] => getMolduras() => ERROR: " + error, WRITE_IN_CONSOLE);
                }
            );
        }



/*
        //***************************************************************
        function getPresupuestosOfUsuario(pUsuarioKey) {

            var fbUrl = firebaseDataService.presupuestos;
            var result = $firebaseArray(fbUrl.orderByChild("usuario_key").equalTo(pUsuarioKey));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    utilsService.writeConsole("[MoldingsController] => getPresupuestosOfUsuario() => EJECUCIÓN OK DE CONSULTA TABLA presupuestos con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        vm.presupuestos = data;
                        vm.totalPresupuestos = dataLength;

                    } else {

                        vm.presupuestos = null;
                        vm.totalPresupuestos = 0;
                    }

                    utilsService.writeConsole("vm.totalPresupuestos = " + vm.totalPresupuestos, WRITE_IN_CONSOLE);
                })

                .catch(function(error) {

                    vm.presupuestos = null;

                    utilsService.writeConsole("[MoldingsController] => getPresupuestosOfUsuario() => ERROR: " + error, WRITE_IN_CONSOLE);
                }
            );
        }


        //***************************************************************
        function getPresupuestosOfEmpresa(pEmpresaKey) {

            var fbUrl = firebaseDataService.presupuestos;
            var result = $firebaseArray(fbUrl.orderByChild("empresa_key").equalTo(pEmpresaKey));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    utilsService.writeConsole("[MoldingsController] => getPresupuestosOfEmpresa() => EJECUCIÓN OK DE CONSULTA TABLA presupuestos con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        vm.presupuestos = data;
                        vm.totalPresupuestos = dataLength;

                    } else {

                        vm.presupuestos = null;
                        vm.totalPresupuestos = 0;
                    }

                    utilsService.writeConsole("vm.totalPresupuestos = " + vm.totalPresupuestos, WRITE_IN_CONSOLE);
                })

                .catch(function(error) {

                    vm.presupuestos = null;

                    utilsService.writeConsole("[MoldingsController] => getPresupuestosOfEmpresa() => ERROR: " + error, WRITE_IN_CONSOLE);
                }
            );
        }
*/


        //***************************************************************
        function deleteMoldura(pId) {

            //We get the record with pId key
            var recordToDelete = vm.molduras.$getRecord(pId)
            
            if (pId != null) {
                vm.molduras.$remove(recordToDelete)
                    .then(function(ref) {
                        utilsService.writeConsole("[MoldingsController] => deleteMoldura() => Record deleted in 'productos_moldura' table", WRITE_IN_CONSOLE);
                    }
                );
            } else {
                utilsService.writeConsole("[MoldingsController] => deleteMoldura() => We can´t remove the row.", WRITE_IN_CONSOLE);
            }
        }



        //***************************************************************
        function showConfirmDeleteDialog(ev,pId) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('¿Estás seguro de eliminar el registro?')
                .textContent("")
                //.ariaLabel(""'Lucky day')
                .ariaLabel("")
                .targetEvent(ev)
                .ok("ELIMINAR")
                .cancel("CANCELAR");

            $mdDialog.show(confirm)
                .then(function() {
                    //YOU HAVE PUSHED "YES" BUTTON
                    vm.deleteMoldura(pId);
                }, 
                function() {
                    //YOU HAVE PUSHED "NO" BUTTON
                });
        }



        //***************************************************************
        function showAlertDialog(pText) {
            // Appending dialog to document.body to cover sidenav in docs app
            var alert = $mdDialog.alert()
                .title("Información")
                .textContent(pText)
                //.ariaLabel("")
                //.targetEvent(ev)
                .ok("Cerrar")
                //.cancel("No");

            $mdDialog.show(alert)
                .finally(function() {
                    //utilsService.writeConsole("WE REDIRECT TO 'SELECT-ITB' PAGE", WRITE_IN_CONSOLE);
                    //$location.path("/workflow-admin/select-itb");
                }); 
        }



        //***************************************************************
        function gotoMoldingDetail(id)
        {
            $state.go('app.menu_productos_molduras_molding', {id: id});
        }



        //***************************************************************
        function gotoAddMolding()
        {
            $state.go('app.menu_productos_molduras_add');
        }



/*
        //***************************************************************
        function addMolduras() {

            var fbUrl = firebaseDataService.productos_moldura;
            var productosMolduras = $firebaseArray(fbUrl);

            var json = 
            [
             {
               "numeroMoldura": 1,
               "refProveedor": "092-030",
               "descripcion": "19523504  MOLD 1 ORO VIEJO ",
               "refLeroyMerlin": 19523504,
               "desperdicio": 0.25,
               "limitacion70cm": true,
               "precioCoste": 2.97,
               "precioLeroyMerlin": 6.24,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 2,
               "refProveedor": "092-P35",
               "descripcion": "19528502  MOLD 2 PLATA VIEJA ",
               "refLeroyMerlin": 19528502,
               "desperdicio": 0.25,
               "limitacion70cm": true,
               "precioCoste": 2.97,
               "precioLeroyMerlin": 6.24,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 3,
               "refProveedor": "092-P38",
               "descripcion": "19526283  MOLD 3 DORADO ",
               "refLeroyMerlin": 19526283,
               "desperdicio": 0.25,
               "limitacion70cm": true,
               "precioCoste": 2.97,
               "precioLeroyMerlin": 6.24,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 4,
               "refProveedor": "126-122",
               "descripcion": "19529265  MOLD 4 NOGAL ",
               "refLeroyMerlin": 19529265,
               "desperdicio": 0.26,
               "limitacion70cm": true,
               "precioCoste": 2.12,
               "precioLeroyMerlin": 4.45,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 5,
               "refProveedor": "126-322",
               "descripcion": "19528453  MOLD 5 NOGAL FILO ORO ",
               "refLeroyMerlin": 19528453,
               "desperdicio": 0.26,
               "limitacion70cm": true,
               "precioCoste": 2.12,
               "precioLeroyMerlin": 4.45,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 6,
               "refProveedor": "202-235",
               "descripcion": "19524365  MOLD 6 BLANCO DECAPÉ ",
               "refLeroyMerlin": 19524365,
               "desperdicio": 0.63,
               "limitacion70cm": false,
               "precioCoste": 5.52,
               "precioLeroyMerlin": 8.82,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 7,
               "refProveedor": "208-30B",
               "descripcion": "19523700  MOLD 7 NOGAL ",
               "refLeroyMerlin": 19523700,
               "desperdicio": 0.22,
               "limitacion70cm": true,
               "precioCoste": 2.26,
               "precioLeroyMerlin": 4.74,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 8,
               "refProveedor": "207-30B",
               "descripcion": "19528782  MOLD 8 NOGAL ",
               "refLeroyMerlin": 19528782,
               "desperdicio": 0.29,
               "limitacion70cm": true,
               "precioCoste": 2.26,
               "precioLeroyMerlin": 4.74,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 9,
               "refProveedor": "206-018",
               "descripcion": "19525625  MOLD 9 CHAMPAGNE ",
               "refLeroyMerlin": 19525625,
               "desperdicio": 0.44,
               "limitacion70cm": false,
               "precioCoste": 4.71,
               "precioLeroyMerlin": 7.54,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 10,
               "refProveedor": "206-037",
               "descripcion": "19530924  MOLD 10 BRONCE BRILLO ",
               "refLeroyMerlin": 19530924,
               "desperdicio": 0.44,
               "limitacion70cm": false,
               "precioCoste": 4.71,
               "precioLeroyMerlin": 7.54,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 11,
               "refProveedor": "218-214",
               "descripcion": "19529496  MOLD 11 BLANCO/AZUL ",
               "refLeroyMerlin": 19529496,
               "desperdicio": 0.21,
               "limitacion70cm": true,
               "precioCoste": 1.79,
               "precioLeroyMerlin": 3.77,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 12,
               "refProveedor": "218-215",
               "descripcion": "19525653  MOLD 12 BLANCO/ROSA ",
               "refLeroyMerlin": 19525653,
               "desperdicio": 0.21,
               "limitacion70cm": true,
               "precioCoste": 1.79,
               "precioLeroyMerlin": 3.77,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 13,
               "refProveedor": "218-216",
               "descripcion": "19526290  MOLD 13 VERDE DECAPÉ ",
               "refLeroyMerlin": 19526290,
               "desperdicio": 0.21,
               "limitacion70cm": true,
               "precioCoste": 1.79,
               "precioLeroyMerlin": 3.77,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 14,
               "refProveedor": "218-235",
               "descripcion": "19524372  MOLD 14 BLANCO DECAPÉ ",
               "refLeroyMerlin": 19524372,
               "desperdicio": 0.21,
               "limitacion70cm": true,
               "precioCoste": 1.79,
               "precioLeroyMerlin": 3.77,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 15,
               "refProveedor": "230-30B",
               "descripcion": "19530070  MOLD 15 NOGAL ",
               "refLeroyMerlin": 19530070,
               "desperdicio": 0.43,
               "limitacion70cm": false,
               "precioCoste": 3.16,
               "precioLeroyMerlin": 5.05,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 16,
               "refProveedor": "247-097",
               "descripcion": "19529125  MOLD 16 ORO ",
               "refLeroyMerlin": 19529125,
               "desperdicio": 0.99,
               "limitacion70cm": false,
               "precioCoste": 14.3,
               "precioLeroyMerlin": 22.88,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 17,
               "refProveedor": "254-100",
               "descripcion": "19531533  MOLD 17 CAOBA ",
               "refLeroyMerlin": 19531533,
               "desperdicio": 0.34,
               "limitacion70cm": true,
               "precioCoste": 3.25,
               "precioLeroyMerlin": 6.82,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 18,
               "refProveedor": "254-162",
               "descripcion": "19527984  MOLD 18 MIEL ",
               "refLeroyMerlin": 19527984,
               "desperdicio": 0.34,
               "limitacion70cm": false,
               "precioCoste": 3.25,
               "precioLeroyMerlin": 6.82,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 19,
               "refProveedor": "254-235",
               "descripcion": "19531820  MOLD 19 BLANCO ",
               "refLeroyMerlin": 19531820,
               "desperdicio": 0.34,
               "limitacion70cm": true,
               "precioCoste": 3.25,
               "precioLeroyMerlin": 6.82,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 20,
               "refProveedor": "254-51P",
               "descripcion": "19531673  MOLD 20 NEGRO ",
               "refLeroyMerlin": 19531673,
               "desperdicio": 0.34,
               "limitacion70cm": true,
               "precioCoste": 3.25,
               "precioLeroyMerlin": 6.82,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 21,
               "refProveedor": "264-024",
               "descripcion": "19528110  MOLD 21 COBRE ",
               "refLeroyMerlin": 19528110,
               "desperdicio": 0.78,
               "limitacion70cm": false,
               "precioCoste": 10.77,
               "precioLeroyMerlin": 17.22,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 22,
               "refProveedor": "264-074",
               "descripcion": "19530672  MOLD 22 ORO ",
               "refLeroyMerlin": 19530672,
               "desperdicio": 0.78,
               "limitacion70cm": false,
               "precioCoste": 10.77,
               "precioLeroyMerlin": 17.22,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 23,
               "refProveedor": "264-230",
               "descripcion": "19531960  MOLD 23 BLANCO PASTEL ",
               "refLeroyMerlin": 19531960,
               "desperdicio": 0.78,
               "limitacion70cm": false,
               "precioCoste": 10.77,
               "precioLeroyMerlin": 17.22,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 24,
               "refProveedor": "264-U50",
               "descripcion": "19523840  MOLD 24 PLATA ",
               "refLeroyMerlin": 19523840,
               "desperdicio": 0.78,
               "limitacion70cm": false,
               "precioCoste": 10.77,
               "precioLeroyMerlin": 17.22,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 25,
               "refProveedor": "272-163",
               "descripcion": "19525660  MOLD 25 MADERA ",
               "refLeroyMerlin": 19525660,
               "desperdicio": 0.7,
               "limitacion70cm": false,
               "precioCoste": 4.72,
               "precioLeroyMerlin": 7.56,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 26,
               "refProveedor": "272-223",
               "descripcion": "19526941  MOLD 26 MADERA ",
               "refLeroyMerlin": 19526941,
               "desperdicio": 0.7,
               "limitacion70cm": false,
               "precioCoste": 4.72,
               "precioLeroyMerlin": 7.56,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 27,
               "refProveedor": "272-202",
               "descripcion": "19528166  MOLD 27 BLANCA ",
               "refLeroyMerlin": 19528166,
               "desperdicio": 0.7,
               "limitacion70cm": false,
               "precioCoste": 4.72,
               "precioLeroyMerlin": 7.56,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 28,
               "refProveedor": "272-227",
               "descripcion": "19523140  MOLD 28 AZUL ",
               "refLeroyMerlin": 19523140,
               "desperdicio": 0.7,
               "limitacion70cm": false,
               "precioCoste": 4.72,
               "precioLeroyMerlin": 7.56,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 29,
               "refProveedor": "274-163",
               "descripcion": "19529545  MOLD 29 NOGAL ",
               "refLeroyMerlin": 19529545,
               "desperdicio": 0.29,
               "limitacion70cm": true,
               "precioCoste": 2.16,
               "precioLeroyMerlin": 4.55,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 30,
               "refProveedor": "274-223",
               "descripcion": "19530175  MOLD 30 MIEL ",
               "refLeroyMerlin": 19530175,
               "desperdicio": 0.29,
               "limitacion70cm": true,
               "precioCoste": 2.16,
               "precioLeroyMerlin": 4.55,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 31,
               "refProveedor": "274-219",
               "descripcion": "19530805  MOLD 31 NEGRO ",
               "refLeroyMerlin": 19530805,
               "desperdicio": 0.29,
               "limitacion70cm": true,
               "precioCoste": 2.16,
               "precioLeroyMerlin": 4.55,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 32,
               "refProveedor": "287-255",
               "descripcion": "19528740  MOLD 32 MADERA ",
               "refLeroyMerlin": 19528740,
               "desperdicio": 0.28,
               "limitacion70cm": true,
               "precioCoste": 2.19,
               "precioLeroyMerlin": 4.59,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 33,
               "refProveedor": "287-3370",
               "descripcion": "19531904  MOLD 33 BLANCO ",
               "refLeroyMerlin": 19531904,
               "desperdicio": 0.28,
               "limitacion70cm": true,
               "precioCoste": 2.19,
               "precioLeroyMerlin": 4.59,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 34,
               "refProveedor": "287-293",
               "descripcion": "19527676  MOLD 34 BLANCO DECAPÉ ",
               "refLeroyMerlin": 19527676,
               "desperdicio": 0.28,
               "limitacion70cm": true,
               "precioCoste": 2.19,
               "precioLeroyMerlin": 4.59,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 35,
               "refProveedor": "289-230",
               "descripcion": "19532016  MOLD 35 BLANCO ROTO ",
               "refLeroyMerlin": 19532016,
               "desperdicio": 0.22,
               "limitacion70cm": true,
               "precioCoste": 2.19,
               "precioLeroyMerlin": 4.59,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 36,
               "refProveedor": "317-R48",
               "descripcion": "19525191  MOLD 36 MADERA AZUL ",
               "refLeroyMerlin": 19525191,
               "desperdicio": 0.37,
               "limitacion70cm": true,
               "precioCoste": 3.07,
               "precioLeroyMerlin": 6.44,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 37,
               "refProveedor": "317-R49",
               "descripcion": "19527963  MOLD 37 MADERA GRIS ",
               "refLeroyMerlin": 19527963,
               "desperdicio": 0.37,
               "limitacion70cm": true,
               "precioCoste": 3.07,
               "precioLeroyMerlin": 6.44,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 38,
               "refProveedor": "317-R60",
               "descripcion": "19530525  MOLD 38 MADERA ",
               "refLeroyMerlin": 19530525,
               "desperdicio": 0.37,
               "limitacion70cm": true,
               "precioCoste": 3.07,
               "precioLeroyMerlin": 6.44,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 39,
               "refProveedor": "322-3620",
               "descripcion": "19532065  MOLD 39 BLANCA ",
               "refLeroyMerlin": 19532065,
               "desperdicio": 0.42,
               "limitacion70cm": false,
               "precioCoste": 4.18,
               "precioLeroyMerlin": 6.68,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 40,
               "refProveedor": "322-4870",
               "descripcion": "19526374  MOLD 40 BLANCA ",
               "refLeroyMerlin": 19526374,
               "desperdicio": 0.42,
               "limitacion70cm": false,
               "precioCoste": 4.18,
               "precioLeroyMerlin": 6.68,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 41,
               "refProveedor": "324-R39",
               "descripcion": "19525443  MOLD 41 PLATA ",
               "refLeroyMerlin": 19525443,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 2.19,
               "precioLeroyMerlin": 4.59,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 42,
               "refProveedor": "324-R40",
               "descripcion": "19526724  MOLD 42 ORO ",
               "refLeroyMerlin": 19526724,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 2.19,
               "precioLeroyMerlin": 4.59,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 43,
               "refProveedor": "350-217",
               "descripcion": "19528096  MOLD 43 BLANCO GASTADO ",
               "refLeroyMerlin": 19528096,
               "desperdicio": 0.53,
               "limitacion70cm": false,
               "precioCoste": 3.57,
               "precioLeroyMerlin": 5.72,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 44,
               "refProveedor": "350-219",
               "descripcion": "19529286  MOLD 44 NEGRO GASTADO ",
               "refLeroyMerlin": 19529286,
               "desperdicio": 0.53,
               "limitacion70cm": false,
               "precioCoste": 3.57,
               "precioLeroyMerlin": 5.72,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 45,
               "refProveedor": "356-100",
               "descripcion": "19530651  MOLD 45 NOGAL ",
               "refLeroyMerlin": 19530651,
               "desperdicio": 0.39,
               "limitacion70cm": true,
               "precioCoste": 4.4,
               "precioLeroyMerlin": 9.24,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 46,
               "refProveedor": "356-120",
               "descripcion": "19531400  MOLD 46 MIEL ",
               "refLeroyMerlin": 19531400,
               "desperdicio": 0.39,
               "limitacion70cm": true,
               "precioCoste": 4.4,
               "precioLeroyMerlin": 9.24,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 47,
               "refProveedor": "356-235",
               "descripcion": "19532072  MOLD 47 BLANCO DECAPÉ ",
               "refLeroyMerlin": 19532072,
               "desperdicio": 0.39,
               "limitacion70cm": true,
               "precioCoste": 4.4,
               "precioLeroyMerlin": 9.24,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 48,
               "refProveedor": "356-51P",
               "descripcion": "19523735  MOLD 48 NEGRO ",
               "refLeroyMerlin": 19523735,
               "desperdicio": 0.39,
               "limitacion70cm": true,
               "precioCoste": 4.4,
               "precioLeroyMerlin": 9.24,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 49,
               "refProveedor": "359-108",
               "descripcion": "19524092  MOLD 49 CAOBA ",
               "refLeroyMerlin": 19524092,
               "desperdicio": 0.49,
               "limitacion70cm": false,
               "precioCoste": 3.8,
               "precioLeroyMerlin": 6.08,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 50,
               "refProveedor": "359-223",
               "descripcion": "19524736  MOLD 50 MIEL ",
               "refLeroyMerlin": 19524736,
               "desperdicio": 0.49,
               "limitacion70cm": false,
               "precioCoste": 3.8,
               "precioLeroyMerlin": 6.08,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 51,
               "refProveedor": "359-229",
               "descripcion": "19525520  MOLD 51 BLANCO ",
               "refLeroyMerlin": 19525520,
               "desperdicio": 0.49,
               "limitacion70cm": false,
               "precioCoste": 3.8,
               "precioLeroyMerlin": 6.08,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 52,
               "refProveedor": "359-235",
               "descripcion": "19526010  MOLD 52 BLANCO DECAPÉ ",
               "refLeroyMerlin": 19526010,
               "desperdicio": 0.49,
               "limitacion70cm": false,
               "precioCoste": 3.8,
               "precioLeroyMerlin": 6.08,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 53,
               "refProveedor": "361-103",
               "descripcion": "19526801  MOLD 53 NOGAL ",
               "refLeroyMerlin": 19526801,
               "desperdicio": 0.7,
               "limitacion70cm": false,
               "precioCoste": 5.77,
               "precioLeroyMerlin": 9.24,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 54,
               "refProveedor": "361-108",
               "descripcion": "19527445  MOLD 54 NEGRO ",
               "refLeroyMerlin": 19527445,
               "desperdicio": 0.7,
               "limitacion70cm": false,
               "precioCoste": 5.77,
               "precioLeroyMerlin": 9.24,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 55,
               "refProveedor": "361-223",
               "descripcion": "19528152  MOLD 55 MIEL ",
               "refLeroyMerlin": 19528152,
               "desperdicio": 0.7,
               "limitacion70cm": false,
               "precioCoste": 5.77,
               "precioLeroyMerlin": 9.24,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 56,
               "refProveedor": "361-229",
               "descripcion": "19523392  MOLD 56 BLANCO DECAPÉ ",
               "refLeroyMerlin": 19523392,
               "desperdicio": 0.7,
               "limitacion70cm": false,
               "precioCoste": 5.77,
               "precioLeroyMerlin": 9.24,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 57,
               "refProveedor": "365-013",
               "descripcion": "19529104  MOLD 57 PLATA ",
               "refLeroyMerlin": 19529104,
               "desperdicio": 0.34,
               "limitacion70cm": false,
               "precioCoste": 4.56,
               "precioLeroyMerlin": 7.29,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 58,
               "refProveedor": "365-20B",
               "descripcion": "19528880  MOLD 58 MADERA ",
               "refLeroyMerlin": 19528880,
               "desperdicio": 0.34,
               "limitacion70cm": false,
               "precioCoste": 4.56,
               "precioLeroyMerlin": 7.29,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 59,
               "refProveedor": "365-235",
               "descripcion": "19530056  MOLD 59 BLANCO DECAPÉ ",
               "refLeroyMerlin": 19530056,
               "desperdicio": 0.34,
               "limitacion70cm": false,
               "precioCoste": 4.56,
               "precioLeroyMerlin": 7.29,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 60,
               "refProveedor": "365-510",
               "descripcion": "19529972  MOLD 60 NEGRO ",
               "refLeroyMerlin": 19529972,
               "desperdicio": 0.34,
               "limitacion70cm": false,
               "precioCoste": 4.56,
               "precioLeroyMerlin": 7.29,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 61,
               "refProveedor": "365-P56",
               "descripcion": "19530791  MOLD 61 BRONCE ",
               "refLeroyMerlin": 19530791,
               "desperdicio": 0.34,
               "limitacion70cm": false,
               "precioCoste": 4.56,
               "precioLeroyMerlin": 7.29,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 62,
               "refProveedor": "372-20B",
               "descripcion": "19525240  MOLD 62 MADERA NATURAL ",
               "refLeroyMerlin": 19525240,
               "desperdicio": 0.4,
               "limitacion70cm": false,
               "precioCoste": 3.57,
               "precioLeroyMerlin": 5.71,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 63,
               "refProveedor": "372-016",
               "descripcion": "19525814  MOLD 63 GRIS ",
               "refLeroyMerlin": 19525814,
               "desperdicio": 0.4,
               "limitacion70cm": false,
               "precioCoste": 3.57,
               "precioLeroyMerlin": 5.71,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 64,
               "refProveedor": "372-235",
               "descripcion": "19531526  MOLD 64 BLANCO DECAPÉ ",
               "refLeroyMerlin": 19531526,
               "desperdicio": 0.4,
               "limitacion70cm": false,
               "precioCoste": 3.57,
               "precioLeroyMerlin": 5.71,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 65,
               "refProveedor": "372-51P",
               "descripcion": "19527046  MOLD 65 NEGRO ",
               "refLeroyMerlin": 19527046,
               "desperdicio": 0.4,
               "limitacion70cm": false,
               "precioCoste": 3.57,
               "precioLeroyMerlin": 5.71,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 66,
               "refProveedor": "372-55P",
               "descripcion": "19523686  MOLD 66 BLANCO MATE ",
               "refLeroyMerlin": 19523686,
               "desperdicio": 0.4,
               "limitacion70cm": false,
               "precioCoste": 3.57,
               "precioLeroyMerlin": 5.71,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 67,
               "refProveedor": "373-223",
               "descripcion": "19524351  MOLD 67 CAOBA ",
               "refLeroyMerlin": 19524351,
               "desperdicio": 0.29,
               "limitacion70cm": true,
               "precioCoste": 2.11,
               "precioLeroyMerlin": 4.43,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 68,
               "refProveedor": "373-230",
               "descripcion": "19525436  MOLD 68 ORO ",
               "refLeroyMerlin": 19525436,
               "desperdicio": 0.29,
               "limitacion70cm": true,
               "precioCoste": 2.11,
               "precioLeroyMerlin": 4.43,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 69,
               "refProveedor": "373-235",
               "descripcion": "19526710  MOLD 69 BLANCO DECAPÉ ",
               "refLeroyMerlin": 19526710,
               "desperdicio": 0.29,
               "limitacion70cm": true,
               "precioCoste": 2.11,
               "precioLeroyMerlin": 4.43,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 70,
               "refProveedor": "373-240",
               "descripcion": "19527655  MOLD 70 AZUL DECAPÉ ",
               "refLeroyMerlin": 19527655,
               "desperdicio": 0.29,
               "limitacion70cm": true,
               "precioCoste": 2.11,
               "precioLeroyMerlin": 4.43,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 71,
               "refProveedor": "392-108",
               "descripcion": "19529272  MOLD 71 NEGRO ",
               "refLeroyMerlin": 19529272,
               "desperdicio": 0.55,
               "limitacion70cm": false,
               "precioCoste": 9.92,
               "precioLeroyMerlin": 15.87,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 72,
               "refProveedor": "392-120",
               "descripcion": "19531750  MOLD 72 MIEL ",
               "refLeroyMerlin": 19531750,
               "desperdicio": 0.55,
               "limitacion70cm": false,
               "precioCoste": 9.92,
               "precioLeroyMerlin": 15.87,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 73,
               "refProveedor": "392-235",
               "descripcion": "19531911  MOLD 73 BLANCO DECAPÉ ",
               "refLeroyMerlin": 19531911,
               "desperdicio": 0.55,
               "limitacion70cm": false,
               "precioCoste": 9.92,
               "precioLeroyMerlin": 15.87,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 74,
               "refProveedor": "398-V74",
               "descripcion": "19524505  MOLD 74 NOGAL/VERDE ",
               "refLeroyMerlin": 19524505,
               "desperdicio": 0.67,
               "limitacion70cm": false,
               "precioCoste": 7.7,
               "precioLeroyMerlin": 12.33,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 75,
               "refProveedor": "398-X76",
               "descripcion": "19525135  MOLD 75 NOGAL ",
               "refLeroyMerlin": 19525135,
               "desperdicio": 0.67,
               "limitacion70cm": false,
               "precioCoste": 7.7,
               "precioLeroyMerlin": 12.33,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 76,
               "refProveedor": "398-X59",
               "descripcion": "19525884  MOLD 76 NOGAL/AZUL ",
               "refLeroyMerlin": 19525884,
               "desperdicio": 0.67,
               "limitacion70cm": false,
               "precioCoste": 7.7,
               "precioLeroyMerlin": 12.33,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 77,
               "refProveedor": "408-W76",
               "descripcion": "19523210  MOLD 77 PLATA ",
               "refLeroyMerlin": 19523210,
               "desperdicio": 0.93,
               "limitacion70cm": false,
               "precioCoste": 9.42,
               "precioLeroyMerlin": 15.08,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 78,
               "refProveedor": "408-X61",
               "descripcion": "19527151  MOLD 78 ORO ",
               "refLeroyMerlin": 19527151,
               "desperdicio": 0.93,
               "limitacion70cm": false,
               "precioCoste": 9.42,
               "precioLeroyMerlin": 15.08,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 79,
               "refProveedor": "463-108",
               "descripcion": "19527781  MOLD 79 NEGRO ",
               "refLeroyMerlin": 19527781,
               "desperdicio": 0.36,
               "limitacion70cm": true,
               "precioCoste": 4.01,
               "precioLeroyMerlin": 8.43,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 80,
               "refProveedor": "463-235",
               "descripcion": "19528530  MOLD 80 BLANCO DECAPÉ ",
               "refLeroyMerlin": 19528530,
               "desperdicio": 0.36,
               "limitacion70cm": true,
               "precioCoste": 4.01,
               "precioLeroyMerlin": 8.43,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 81,
               "refProveedor": "463-S94",
               "descripcion": "19526094  MOLD 81 ORO ",
               "refLeroyMerlin": 19526094,
               "desperdicio": 0.36,
               "limitacion70cm": true,
               "precioCoste": 4.01,
               "precioLeroyMerlin": 8.43,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 82,
               "refProveedor": "463-S92",
               "descripcion": "19529713  MOLD 82 PLATA ",
               "refLeroyMerlin": 19529713,
               "desperdicio": 0.36,
               "limitacion70cm": true,
               "precioCoste": 4.01,
               "precioLeroyMerlin": 8.43,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 83,
               "refProveedor": "480-W53",
               "descripcion": "19530343  MOLD 83 NEGRA -ORO ",
               "refLeroyMerlin": 19530343,
               "desperdicio": 0.9,
               "limitacion70cm": false,
               "precioCoste": 6.33,
               "precioLeroyMerlin": 10.13,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 84,
               "refProveedor": "480-W54",
               "descripcion": "19530980  MOLD 84 NEGRO-PLATA ",
               "refLeroyMerlin": 19530980,
               "desperdicio": 0.9,
               "limitacion70cm": false,
               "precioCoste": 6.33,
               "precioLeroyMerlin": 10.13,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 85,
               "refProveedor": "480-W75",
               "descripcion": "19528656  MOLD 85 ORO ",
               "refLeroyMerlin": 19528656,
               "desperdicio": 0.9,
               "limitacion70cm": false,
               "precioCoste": 6.33,
               "precioLeroyMerlin": 10.13,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 86,
               "refProveedor": "480-W77",
               "descripcion": "19531610  MOLD 86 NEGRO ",
               "refLeroyMerlin": 19531610,
               "desperdicio": 0.9,
               "limitacion70cm": false,
               "precioCoste": 6.33,
               "precioLeroyMerlin": 10.13,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 87,
               "refProveedor": "485-258",
               "descripcion": "19531925  MOLD 87 MADERA NEGRO ",
               "refLeroyMerlin": 19531925,
               "desperdicio": 0.67,
               "limitacion70cm": false,
               "precioCoste": 4.57,
               "precioLeroyMerlin": 7.31,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 88,
               "refProveedor": "488-W15",
               "descripcion": "19523280  MOLD 88 NEGRO -PLATA ",
               "refLeroyMerlin": 19523280,
               "desperdicio": 0.29,
               "limitacion70cm": true,
               "precioCoste": 4.11,
               "precioLeroyMerlin": 8.63,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 89,
               "refProveedor": "488-W16",
               "descripcion": "19531092  MOLD 89 NEGRO - ORO ",
               "refLeroyMerlin": 19531092,
               "desperdicio": 0.29,
               "limitacion70cm": true,
               "precioCoste": 4.11,
               "precioLeroyMerlin": 8.63,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 90,
               "refProveedor": "510-W75",
               "descripcion": "19524015  MOLD 90 ORO ",
               "refLeroyMerlin": 19524015,
               "desperdicio": 0.75,
               "limitacion70cm": false,
               "precioCoste": 7.69,
               "precioLeroyMerlin": 12.31,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 91,
               "refProveedor": "510-W76",
               "descripcion": "19524323  MOLD 91 PLATA ",
               "refLeroyMerlin": 19524323,
               "desperdicio": 0.75,
               "limitacion70cm": false,
               "precioCoste": 7.69,
               "precioLeroyMerlin": 12.31,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 92,
               "refProveedor": "515-W75",
               "descripcion": "19524435  MOLD 92 ORO ",
               "refLeroyMerlin": 19524435,
               "desperdicio": 1.16,
               "limitacion70cm": false,
               "precioCoste": 12.29,
               "precioLeroyMerlin": 19.66,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 93,
               "refProveedor": "515-W76",
               "descripcion": "19523525  MOLD 93 PLATA ",
               "refLeroyMerlin": 19523525,
               "desperdicio": 1.16,
               "limitacion70cm": false,
               "precioCoste": 12.29,
               "precioLeroyMerlin": 19.66,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 94,
               "refProveedor": "516-235",
               "descripcion": "19525065  MOLD 94 BLANCO GASTADO ",
               "refLeroyMerlin": 19525065,
               "desperdicio": 0.43,
               "limitacion70cm": false,
               "precioCoste": 3.8,
               "precioLeroyMerlin": 6.09,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 95,
               "refProveedor": "516-258",
               "descripcion": "19525373  MOLD 95 MADERA NEGRO ",
               "refLeroyMerlin": 19525373,
               "desperdicio": 0.43,
               "limitacion70cm": false,
               "precioCoste": 3.8,
               "precioLeroyMerlin": 6.09,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 96,
               "refProveedor": "516-501",
               "descripcion": "19525793  MOLD 96 NEGRO-PLATA ",
               "refLeroyMerlin": 19525793,
               "desperdicio": 0.43,
               "limitacion70cm": false,
               "precioCoste": 3.8,
               "precioLeroyMerlin": 6.09,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 97,
               "refProveedor": "516-326",
               "descripcion": "19524421  MOLD 97 PLATA ",
               "refLeroyMerlin": 19524421,
               "desperdicio": 0.43,
               "limitacion70cm": false,
               "precioCoste": 3.8,
               "precioLeroyMerlin": 6.09,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 98,
               "refProveedor": "520-X48",
               "descripcion": "19526346  MOLD 98 ACERO ",
               "refLeroyMerlin": 19526346,
               "desperdicio": 0.35,
               "limitacion70cm": true,
               "precioCoste": 2.53,
               "precioLeroyMerlin": 5.3,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 99,
               "refProveedor": "520-X82",
               "descripcion": "19526654  MOLD 99 NEGRO-PLATA ",
               "refLeroyMerlin": 19526654,
               "desperdicio": 0.35,
               "limitacion70cm": true,
               "precioCoste": 2.53,
               "precioLeroyMerlin": 5.3,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 100,
               "refProveedor": "534-235",
               "descripcion": "19527060  MOLD 100 BLANCO DECAPÉ ",
               "refLeroyMerlin": 19527060,
               "desperdicio": 0.49,
               "limitacion70cm": false,
               "precioCoste": 4.31,
               "precioLeroyMerlin": 6.89,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 101,
               "refProveedor": "534-258",
               "descripcion": "19525702  MOLD 101 NEGRO ",
               "refLeroyMerlin": 19525702,
               "desperdicio": 0.49,
               "limitacion70cm": false,
               "precioCoste": 4.31,
               "precioLeroyMerlin": 6.89,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 102,
               "refProveedor": "534-W35",
               "descripcion": "19527690  MOLD 102 NEGRO-ORO ",
               "refLeroyMerlin": 19527690,
               "desperdicio": 0.49,
               "limitacion70cm": false,
               "precioCoste": 4.31,
               "precioLeroyMerlin": 6.89,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 103,
               "refProveedor": "534-W36",
               "descripcion": "19528005  MOLD 103 NEGRO-PLATA ",
               "refLeroyMerlin": 19528005,
               "desperdicio": 0.49,
               "limitacion70cm": false,
               "precioCoste": 4.31,
               "precioLeroyMerlin": 6.89,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 104,
               "refProveedor": "542-108",
               "descripcion": "19528390  MOLD 104 MADERA NEGRO ",
               "refLeroyMerlin": 19528390,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 2.31,
               "precioLeroyMerlin": 4.84,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 105,
               "refProveedor": "542-162",
               "descripcion": "19527130  MOLD 105 MIEL ",
               "refLeroyMerlin": 19527130,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 2.31,
               "precioLeroyMerlin": 4.84,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 106,
               "refProveedor": "542-235",
               "descripcion": "19528852  MOLD 106 BLANCO DECAPÉ ",
               "refLeroyMerlin": 19528852,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 2.31,
               "precioLeroyMerlin": 4.84,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 107,
               "refProveedor": "542-51P",
               "descripcion": "19529020  MOLD 107 NEGRO ",
               "refLeroyMerlin": 19529020,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 2.31,
               "precioLeroyMerlin": 4.84,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 108,
               "refProveedor": "546-501",
               "descripcion": "19529195  MOLD 108 NEGRO ",
               "refLeroyMerlin": 19529195,
               "desperdicio": 0.4,
               "limitacion70cm": true,
               "precioCoste": 3.14,
               "precioLeroyMerlin": 6.58,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 109,
               "refProveedor": "546-502",
               "descripcion": "19528264  MOLD 109 NEGRO ",
               "refLeroyMerlin": 19528264,
               "desperdicio": 0.4,
               "limitacion70cm": true,
               "precioCoste": 3.14,
               "precioLeroyMerlin": 6.58,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 110,
               "refProveedor": "546-S27",
               "descripcion": "19529503  MOLD 110 ACERO ",
               "refLeroyMerlin": 19529503,
               "desperdicio": 0.4,
               "limitacion70cm": true,
               "precioCoste": 3.14,
               "precioLeroyMerlin": 6.58,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 111,
               "refProveedor": "546-X26",
               "descripcion": "19529685  MOLD 111 PLATA ",
               "refLeroyMerlin": 19529685,
               "desperdicio": 0.4,
               "limitacion70cm": true,
               "precioCoste": 3.14,
               "precioLeroyMerlin": 6.58,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 112,
               "refProveedor": "546-X28",
               "descripcion": "19529783  MOLD 112 PLATA ",
               "refLeroyMerlin": 19529783,
               "desperdicio": 0.4,
               "limitacion70cm": true,
               "precioCoste": 3.14,
               "precioLeroyMerlin": 6.58,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 113,
               "refProveedor": "547-108",
               "descripcion": "19529174  MOLD 113 MADERA NEGRO ",
               "refLeroyMerlin": 19529174,
               "desperdicio": 0.16,
               "limitacion70cm": true,
               "precioCoste": 1.37,
               "precioLeroyMerlin": 2.87,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 114,
               "refProveedor": "547-162",
               "descripcion": "19530140  MOLD 114 NOGAL ",
               "refLeroyMerlin": 19530140,
               "desperdicio": 0.16,
               "limitacion70cm": true,
               "precioCoste": 1.52,
               "precioLeroyMerlin": 3.19,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 115,
               "refProveedor": "547-235",
               "descripcion": "19530315  MOLD 115 BLANCO DECAPÉ ",
               "refLeroyMerlin": 19530315,
               "desperdicio": 0.16,
               "limitacion70cm": true,
               "precioCoste": 1.52,
               "precioLeroyMerlin": 3.19,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 116,
               "refProveedor": "547-51P",
               "descripcion": "19530413  MOLD 116 NEGRO ",
               "refLeroyMerlin": 19530413,
               "desperdicio": 0.16,
               "limitacion70cm": true,
               "precioCoste": 1.52,
               "precioLeroyMerlin": 3.19,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 117,
               "refProveedor": "547-752",
               "descripcion": "19529811  MOLD 117 AZUL ",
               "refLeroyMerlin": 19529811,
               "desperdicio": 0.16,
               "limitacion70cm": true,
               "precioCoste": 1.52,
               "precioLeroyMerlin": 3.19,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 118,
               "refProveedor": "547-760",
               "descripcion": "19530721  MOLD 118 VERDE ",
               "refLeroyMerlin": 19530721,
               "desperdicio": 0.16,
               "limitacion70cm": true,
               "precioCoste": 1.52,
               "precioLeroyMerlin": 3.19,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 119,
               "refProveedor": "547-772",
               "descripcion": "19528236  MOLD 119 AMARILLO ",
               "refLeroyMerlin": 19528236,
               "desperdicio": 0.16,
               "limitacion70cm": true,
               "precioCoste": 1.52,
               "precioLeroyMerlin": 3.19,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 120,
               "refProveedor": "547-776",
               "descripcion": "19523105  MOLD 120 NARANJA ",
               "refLeroyMerlin": 19523105,
               "desperdicio": 0.16,
               "limitacion70cm": true,
               "precioCoste": 1.52,
               "precioLeroyMerlin": 3.19,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 121,
               "refProveedor": "547-778",
               "descripcion": "19530462  MOLD 121 MORADO ",
               "refLeroyMerlin": 19530462,
               "desperdicio": 0.16,
               "limitacion70cm": true,
               "precioCoste": 1.52,
               "precioLeroyMerlin": 3.19,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 122,
               "refProveedor": "547-780",
               "descripcion": "19527641  MOLD 122 ROJO ",
               "refLeroyMerlin": 19527641,
               "desperdicio": 0.16,
               "limitacion70cm": true,
               "precioCoste": 1.52,
               "precioLeroyMerlin": 3.19,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 123,
               "refProveedor": "547-R64",
               "descripcion": "19531834  MOLD 123 ORO BRILLO ",
               "refLeroyMerlin": 19531834,
               "desperdicio": 0.16,
               "limitacion70cm": true,
               "precioCoste": 1.52,
               "precioLeroyMerlin": 3.19,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 124,
               "refProveedor": "547-R65",
               "descripcion": "19525401  MOLD 124 CHAMPAGNE ",
               "refLeroyMerlin": 19525401,
               "desperdicio": 0.16,
               "limitacion70cm": true,
               "precioCoste": 1.52,
               "precioLeroyMerlin": 3.19,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 125,
               "refProveedor": "547-X41",
               "descripcion": "19527795  MOLD 125 PLATA AGUAS ",
               "refLeroyMerlin": 19527795,
               "desperdicio": 0.16,
               "limitacion70cm": true,
               "precioCoste": 1.52,
               "precioLeroyMerlin": 3.19,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 126,
               "refProveedor": "547-X42",
               "descripcion": "19530511  MOLD 126 ORO AGUAS ",
               "refLeroyMerlin": 19530511,
               "desperdicio": 0.16,
               "limitacion70cm": true,
               "precioCoste": 1.52,
               "precioLeroyMerlin": 3.19,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 127,
               "refProveedor": "547-X46",
               "descripcion": "19531981  MOLD 127 PLATA ",
               "refLeroyMerlin": 19531981,
               "desperdicio": 0.16,
               "limitacion70cm": true,
               "precioCoste": 1.52,
               "precioLeroyMerlin": 3.19,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 128,
               "refProveedor": "549-235",
               "descripcion": "19524281  MOLD 128 BLANCO DECAPÉ ",
               "refLeroyMerlin": 19524281,
               "desperdicio": 0.91,
               "limitacion70cm": false,
               "precioCoste": 9.88,
               "precioLeroyMerlin": 15.81,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 129,
               "refProveedor": "549-258",
               "descripcion": "19530854  MOLD 129 MADERA NEGRO ",
               "refLeroyMerlin": 19530854,
               "desperdicio": 0.91,
               "limitacion70cm": false,
               "precioCoste": 9.88,
               "precioLeroyMerlin": 15.81,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 130,
               "refProveedor": "549-510",
               "descripcion": "19526752  MOLD 130 NEGRO ",
               "refLeroyMerlin": 19526752,
               "desperdicio": 0.91,
               "limitacion70cm": false,
               "precioCoste": 9.88,
               "precioLeroyMerlin": 15.81,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 131,
               "refProveedor": "552-258",
               "descripcion": "19528026  MOLD 131 MADERA NEGRO ",
               "refLeroyMerlin": 19528026,
               "desperdicio": 0.44,
               "limitacion70cm": false,
               "precioCoste": 3.45,
               "precioLeroyMerlin": 5.52,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 132,
               "refProveedor": "554-185",
               "descripcion": "19529391  MOLD 132 NG",
               "refLeroyMerlin": 19529391,
               "desperdicio": 1.08,
               "limitacion70cm": false,
               "precioCoste": 11.99,
               "precioLeroyMerlin": 19.18,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 133,
               "refProveedor": "561-100",
               "descripcion": "19530581  MOLD 133 NOGAL ",
               "refLeroyMerlin": 19530581,
               "desperdicio": 0.28,
               "limitacion70cm": false,
               "precioCoste": 6.96,
               "precioLeroyMerlin": 11.13,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 134,
               "refProveedor": "561-108",
               "descripcion": "19530035  MOLD 134 NEGRO ",
               "refLeroyMerlin": 19530035,
               "desperdicio": 0.28,
               "limitacion70cm": false,
               "precioCoste": 6.96,
               "precioLeroyMerlin": 11.13,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 135,
               "refProveedor": "561-235",
               "descripcion": "19523721  MOLD 135 BLANCO DECAPÉ ",
               "refLeroyMerlin": 19523721,
               "desperdicio": 0.28,
               "limitacion70cm": false,
               "precioCoste": 6.96,
               "precioLeroyMerlin": 11.13,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 136,
               "refProveedor": "561-V38",
               "descripcion": "19524806  MOLD 136 PLATA ",
               "refLeroyMerlin": 19524806,
               "desperdicio": 0.28,
               "limitacion70cm": false,
               "precioCoste": 6.96,
               "precioLeroyMerlin": 11.13,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 137,
               "refProveedor": "561-W75",
               "descripcion": "19525415  MOLD 137 PAN DE ORO ",
               "refLeroyMerlin": 19525415,
               "desperdicio": 0.28,
               "limitacion70cm": false,
               "precioCoste": 6.96,
               "precioLeroyMerlin": 11.13,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 138,
               "refProveedor": "565-238",
               "descripcion": "19525275  MOLD 138 BLANCO DECAPÉ ",
               "refLeroyMerlin": 19525275,
               "desperdicio": 0.74,
               "limitacion70cm": false,
               "precioCoste": 9.24,
               "precioLeroyMerlin": 14.78,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 139,
               "refProveedor": "567-238",
               "descripcion": "19527025  MOLD 139 BLANCO DECAPÉ ",
               "refLeroyMerlin": 19527025,
               "desperdicio": 0.47,
               "limitacion70cm": false,
               "precioCoste": 8.02,
               "precioLeroyMerlin": 12.83,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 140,
               "refProveedor": "567-258",
               "descripcion": "19526556  MOLD 140 NEGRO ",
               "refLeroyMerlin": 19526556,
               "desperdicio": 0.47,
               "limitacion70cm": false,
               "precioCoste": 8.02,
               "precioLeroyMerlin": 12.83,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 141,
               "refProveedor": "567-501",
               "descripcion": "19525730  MOLD 141 NEGRO-PLATA ",
               "refLeroyMerlin": 19525730,
               "desperdicio": 0.47,
               "limitacion70cm": false,
               "precioCoste": 8.02,
               "precioLeroyMerlin": 12.83,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 142,
               "refProveedor": "572-326",
               "descripcion": "19527865  MOLD 142 BLANCO ",
               "refLeroyMerlin": 19527865,
               "desperdicio": 0.44,
               "limitacion70cm": false,
               "precioCoste": 3.72,
               "precioLeroyMerlin": 5.94,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 143,
               "refProveedor": "572-501",
               "descripcion": "19529580  MOLD 143 NEGRO ",
               "refLeroyMerlin": 19529580,
               "desperdicio": 0.44,
               "limitacion70cm": false,
               "precioCoste": 3.72,
               "precioLeroyMerlin": 5.94,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 144,
               "refProveedor": "572-S89",
               "descripcion": "19529111  MOLD 144 GRIS PLATA ",
               "refLeroyMerlin": 19529111,
               "desperdicio": 0.44,
               "limitacion70cm": false,
               "precioCoste": 3.72,
               "precioLeroyMerlin": 5.94,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 145,
               "refProveedor": "577-Y22",
               "descripcion": "19528292  MOLD 145 GRANATE-PLATA ",
               "refLeroyMerlin": 19528292,
               "desperdicio": 0.58,
               "limitacion70cm": false,
               "precioCoste": 6.87,
               "precioLeroyMerlin": 10.99,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 146,
               "refProveedor": "577-Y21",
               "descripcion": "19530420  MOLD 146 BLANCO-PLATA ",
               "refLeroyMerlin": 19530420,
               "desperdicio": 0.58,
               "limitacion70cm": false,
               "precioCoste": 6.87,
               "precioLeroyMerlin": 10.99,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 147,
               "refProveedor": "577-Y20",
               "descripcion": "19531603  MOLD 147 NEGRO-PLATA ",
               "refLeroyMerlin": 19531603,
               "desperdicio": 0.58,
               "limitacion70cm": false,
               "precioCoste": 6.87,
               "precioLeroyMerlin": 10.99,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 148,
               "refProveedor": "579-326",
               "descripcion": "19531302  MOLD 148 BLANCO-PLATA ",
               "refLeroyMerlin": 19531302,
               "desperdicio": 0.33,
               "limitacion70cm": true,
               "precioCoste": 2.57,
               "precioLeroyMerlin": 5.4,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 149,
               "refProveedor": "579-501",
               "descripcion": "19531540  MOLD 149 NEGRO PLATA ",
               "refLeroyMerlin": 19531540,
               "desperdicio": 0.33,
               "limitacion70cm": true,
               "precioCoste": 2.57,
               "precioLeroyMerlin": 5.4,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 150,
               "refProveedor": "579-X61",
               "descripcion": "19531561  MOLD 150 NEGRO-COBRE ",
               "refLeroyMerlin": 19531561,
               "desperdicio": 0.33,
               "limitacion70cm": true,
               "precioCoste": 2.57,
               "precioLeroyMerlin": 5.4,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 151,
               "refProveedor": "585-X61",
               "descripcion": "19525744  MOLD 151 MIEL ",
               "refLeroyMerlin": 19525744,
               "desperdicio": 0.29,
               "limitacion70cm": true,
               "precioCoste": 2.57,
               "precioLeroyMerlin": 5.4,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 152,
               "refProveedor": "585-Y15",
               "descripcion": "19523665  MOLD 152 PLATA ",
               "refLeroyMerlin": 19523665,
               "desperdicio": 0.29,
               "limitacion70cm": true,
               "precioCoste": 2.57,
               "precioLeroyMerlin": 5.4,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 153,
               "refProveedor": "588-Y34",
               "descripcion": "19524624  MOLD 153 ORO ",
               "refLeroyMerlin": 19524624,
               "desperdicio": 0.49,
               "limitacion70cm": false,
               "precioCoste": 4.93,
               "precioLeroyMerlin": 7.88,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 154,
               "refProveedor": "588-Y35",
               "descripcion": "19524120  MOLD 154 ORO ",
               "refLeroyMerlin": 19524120,
               "desperdicio": 0.49,
               "limitacion70cm": false,
               "precioCoste": 4.93,
               "precioLeroyMerlin": 7.88,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 155,
               "refProveedor": "588-Y36",
               "descripcion": "19525254  MOLD 155 ORO ",
               "refLeroyMerlin": 19525254,
               "desperdicio": 0.49,
               "limitacion70cm": false,
               "precioCoste": 4.93,
               "precioLeroyMerlin": 7.88,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 156,
               "refProveedor": "588-Y37",
               "descripcion": "19524764  MOLD 156 PLATA ",
               "refLeroyMerlin": 19524764,
               "desperdicio": 0.49,
               "limitacion70cm": false,
               "precioCoste": 4.93,
               "precioLeroyMerlin": 7.88,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 157,
               "refProveedor": "606-U11",
               "descripcion": "19523252  MOLD 157 ACERO ",
               "refLeroyMerlin": 19523252,
               "desperdicio": 0.69,
               "limitacion70cm": false,
               "precioCoste": 6.77,
               "precioLeroyMerlin": 10.83,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 158,
               "refProveedor": "606-U12",
               "descripcion": "19525485  MOLD 158 COBRE ",
               "refLeroyMerlin": 19525485,
               "desperdicio": 0.69,
               "limitacion70cm": false,
               "precioCoste": 6.77,
               "precioLeroyMerlin": 10.83,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 159,
               "refProveedor": "606-U13",
               "descripcion": "19526535  MOLD 159 PLATA ",
               "refLeroyMerlin": 19526535,
               "desperdicio": 0.69,
               "limitacion70cm": false,
               "precioCoste": 6.77,
               "precioLeroyMerlin": 10.83,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 160,
               "refProveedor": "606-U14",
               "descripcion": "19526045  MOLD 160 NEGRA ",
               "refLeroyMerlin": 19526045,
               "desperdicio": 0.69,
               "limitacion70cm": false,
               "precioCoste": 6.77,
               "precioLeroyMerlin": 10.83,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 161,
               "refProveedor": "606-U15",
               "descripcion": "19527004  MOLD 161 ORO ",
               "refLeroyMerlin": 19527004,
               "desperdicio": 0.69,
               "limitacion70cm": false,
               "precioCoste": 6.77,
               "precioLeroyMerlin": 10.83,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 162,
               "refProveedor": "606-U22",
               "descripcion": "19526766  MOLD 162 NEGRA ",
               "refLeroyMerlin": 19526766,
               "desperdicio": 0.69,
               "limitacion70cm": false,
               "precioCoste": 6.77,
               "precioLeroyMerlin": 10.83,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 163,
               "refProveedor": "607-U10",
               "descripcion": "19527634  MOLD 163 PLATA ",
               "refLeroyMerlin": 19527634,
               "desperdicio": 1.1,
               "limitacion70cm": false,
               "precioCoste": 15.17,
               "precioLeroyMerlin": 24.27,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 164,
               "refProveedor": "607-U12",
               "descripcion": "19527403  MOLD 164 BRONCE ",
               "refLeroyMerlin": 19527403,
               "desperdicio": 1.1,
               "limitacion70cm": false,
               "precioCoste": 15.17,
               "precioLeroyMerlin": 24.27,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 165,
               "refProveedor": "608-U23",
               "descripcion": "19526990  MOLD 165 BLANCO ",
               "refLeroyMerlin": 19526990,
               "desperdicio": 1.05,
               "limitacion70cm": false,
               "precioCoste": 14.53,
               "precioLeroyMerlin": 23.25,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 166,
               "refProveedor": "608-U16",
               "descripcion": "19528054  MOLD 166 NOGAL ",
               "refLeroyMerlin": 19528054,
               "desperdicio": 1.05,
               "limitacion70cm": false,
               "precioCoste": 14.53,
               "precioLeroyMerlin": 23.25,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 167,
               "refProveedor": "608-U20",
               "descripcion": "19529090  MOLD 167 NEGRO ",
               "refLeroyMerlin": 19529090,
               "desperdicio": 1.05,
               "limitacion70cm": false,
               "precioCoste": 14.53,
               "precioLeroyMerlin": 23.25,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 168,
               "refProveedor": "618-Y79",
               "descripcion": "19528600  MOLD 168 ORO ",
               "refLeroyMerlin": 19528600,
               "desperdicio": 0.79,
               "limitacion70cm": false,
               "precioCoste": 7.85,
               "precioLeroyMerlin": 12.56,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 169,
               "refProveedor": "618-Y81",
               "descripcion": "19529566  MOLD 169 NOGAL ",
               "refLeroyMerlin": 19529566,
               "desperdicio": 0.79,
               "limitacion70cm": false,
               "precioCoste": 7.85,
               "precioLeroyMerlin": 12.56,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 170,
               "refProveedor": "618-Y82",
               "descripcion": "19529321  MOLD 170 PLATA ",
               "refLeroyMerlin": 19529321,
               "desperdicio": 0.79,
               "limitacion70cm": false,
               "precioCoste": 7.85,
               "precioLeroyMerlin": 12.56,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 171,
               "refProveedor": "619-Y84",
               "descripcion": "19530196  MOLD 171 PLATA ",
               "refLeroyMerlin": 19530196,
               "desperdicio": 0.8,
               "limitacion70cm": false,
               "precioCoste": 8.46,
               "precioLeroyMerlin": 13.53,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 172,
               "refProveedor": "619-Y85",
               "descripcion": "19529965  MOLD 172 NOGAL ",
               "refLeroyMerlin": 19529965,
               "desperdicio": 0.8,
               "limitacion70cm": false,
               "precioCoste": 8.46,
               "precioLeroyMerlin": 13.53,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 173,
               "refProveedor": "622-Y74",
               "descripcion": "19529552  MOLD 173 PLATA ",
               "refLeroyMerlin": 19529552,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 2.63,
               "precioLeroyMerlin": 5.53,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 174,
               "refProveedor": "622-Y75",
               "descripcion": "19530616  MOLD 174 ORO ",
               "refLeroyMerlin": 19530616,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 2.63,
               "precioLeroyMerlin": 5.53,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 175,
               "refProveedor": "622-Y76",
               "descripcion": "19531183  MOLD 175 PLATA ",
               "refLeroyMerlin": 19531183,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 2.63,
               "precioLeroyMerlin": 5.53,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 176,
               "refProveedor": "622-Y77",
               "descripcion": "19531064  MOLD 176 NOGAL ",
               "refLeroyMerlin": 19531064,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 2.63,
               "precioLeroyMerlin": 5.53,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 177,
               "refProveedor": "626-238",
               "descripcion": "19530833  MOLD 177 BL GAST ",
               "refLeroyMerlin": 19530833,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 2.3,
               "precioLeroyMerlin": 4.84,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 178,
               "refProveedor": "626-258",
               "descripcion": "19531393  MOLD 178 NOGAL ",
               "refLeroyMerlin": 19531393,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 2.3,
               "precioLeroyMerlin": 4.84,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 179,
               "refProveedor": "638-326",
               "descripcion": "19531855  MOLD 179 BLANCO-PLATA ",
               "refLeroyMerlin": 19531855,
               "desperdicio": 0.33,
               "limitacion70cm": true,
               "precioCoste": 3.32,
               "precioLeroyMerlin": 6.97,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 180,
               "refProveedor": "638-501",
               "descripcion": "19531715  MOLD 180 NEGRO-PLATA ",
               "refLeroyMerlin": 19531715,
               "desperdicio": 0.33,
               "limitacion70cm": true,
               "precioCoste": 3.32,
               "precioLeroyMerlin": 6.97,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 181,
               "refProveedor": "638-U43",
               "descripcion": "19531792  MOLD 181 BLANCA-NEGRO ",
               "refLeroyMerlin": 19531792,
               "desperdicio": 0.33,
               "limitacion70cm": true,
               "precioCoste": 3.32,
               "precioLeroyMerlin": 6.97,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 182,
               "refProveedor": "638-U44",
               "descripcion": "19531806  MOLD 182 NEGRO-PLATA ",
               "refLeroyMerlin": 19531806,
               "desperdicio": 0.33,
               "limitacion70cm": true,
               "precioCoste": 3.32,
               "precioLeroyMerlin": 6.97,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 183,
               "refProveedor": "644-U50",
               "descripcion": "19523231  MOLD 183 ACERO ",
               "refLeroyMerlin": 19523231,
               "desperdicio": 0.55,
               "limitacion70cm": false,
               "precioCoste": 5.4,
               "precioLeroyMerlin": 8.64,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 184,
               "refProveedor": "644-U49",
               "descripcion": "19523455  MOLD 184 ORO ",
               "refLeroyMerlin": 19523455,
               "desperdicio": 0.55,
               "limitacion70cm": false,
               "precioCoste": 5.4,
               "precioLeroyMerlin": 8.64,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 185,
               "refProveedor": "644-U83",
               "descripcion": "19523931  MOLD 185 BLANCO -PLATA ",
               "refLeroyMerlin": 19523931,
               "desperdicio": 0.55,
               "limitacion70cm": false,
               "precioCoste": 5.4,
               "precioLeroyMerlin": 8.64,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 186,
               "refProveedor": "644-U48",
               "descripcion": "19523714  MOLD 186 NEGRO -PLATA ",
               "refLeroyMerlin": 19523714,
               "desperdicio": 0.55,
               "limitacion70cm": false,
               "precioCoste": 5.4,
               "precioLeroyMerlin": 8.64,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 187,
               "refProveedor": "649-U40",
               "descripcion": "19524246  MOLD 187 BLANCO ",
               "refLeroyMerlin": 19524246,
               "desperdicio": 0.67,
               "limitacion70cm": false,
               "precioCoste": 4.89,
               "precioLeroyMerlin": 7.83,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 188,
               "refProveedor": "649-Y42",
               "descripcion": "19524036  MOLD 188 PLATA ",
               "refLeroyMerlin": 19524036,
               "desperdicio": 0.67,
               "limitacion70cm": false,
               "precioCoste": 4.89,
               "precioLeroyMerlin": 7.83,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 189,
               "refProveedor": "649-501",
               "descripcion": "19524526  MOLD 189 NEGRO ",
               "refLeroyMerlin": 19524526,
               "desperdicio": 0.67,
               "limitacion70cm": false,
               "precioCoste": 4.89,
               "precioLeroyMerlin": 7.83,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 190,
               "refProveedor": "658-U17",
               "descripcion": "19524260  MOLD 190 ORO ",
               "refLeroyMerlin": 19524260,
               "desperdicio": 0.4,
               "limitacion70cm": true,
               "precioCoste": 3.51,
               "precioLeroyMerlin": 7.38,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 191,
               "refProveedor": "658-U19",
               "descripcion": "19524883  MOLD 191 BRONCE ",
               "refLeroyMerlin": 19524883,
               "desperdicio": 0.4,
               "limitacion70cm": true,
               "precioCoste": 3.51,
               "precioLeroyMerlin": 7.38,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 192,
               "refProveedor": "670-U76",
               "descripcion": "19524673  MOLD 192 BLANCO ",
               "refLeroyMerlin": 19524673,
               "desperdicio": 0.58,
               "limitacion70cm": false,
               "precioCoste": 4.92,
               "precioLeroyMerlin": 7.87,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 193,
               "refProveedor": "670-U83",
               "descripcion": "19525156  MOLD 193 BLANCO ",
               "refLeroyMerlin": 19525156,
               "desperdicio": 0.58,
               "limitacion70cm": false,
               "precioCoste": 4.92,
               "precioLeroyMerlin": 7.87,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 194,
               "refProveedor": "673-258",
               "descripcion": "19524904  MOLD 194 NEGRO MADERA ",
               "refLeroyMerlin": 19524904,
               "desperdicio": 0.4,
               "limitacion70cm": true,
               "precioCoste": 3.27,
               "precioLeroyMerlin": 6.86,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 195,
               "refProveedor": "673-U76",
               "descripcion": "19525464  MOLD 195 BLANCO ",
               "refLeroyMerlin": 19525464,
               "desperdicio": 0.4,
               "limitacion70cm": true,
               "precioCoste": 3.27,
               "precioLeroyMerlin": 6.86,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 196,
               "refProveedor": "823-X89",
               "descripcion": "19525226  MOLD 196 NEGRO ",
               "refLeroyMerlin": 19525226,
               "desperdicio": 0.22,
               "limitacion70cm": true,
               "precioCoste": 2.28,
               "precioLeroyMerlin": 4.8,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 197,
               "refProveedor": "823-X90",
               "descripcion": "19524400  MOLD 197 BLANCO MATE ",
               "refLeroyMerlin": 19524400,
               "desperdicio": 0.22,
               "limitacion70cm": true,
               "precioCoste": 2.28,
               "precioLeroyMerlin": 4.8,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 198,
               "refProveedor": "823-X91",
               "descripcion": "19525576  MOLD 198 NOGAL ",
               "refLeroyMerlin": 19525576,
               "desperdicio": 0.22,
               "limitacion70cm": true,
               "precioCoste": 2.28,
               "precioLeroyMerlin": 4.8,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 199,
               "refProveedor": "823-Y30",
               "descripcion": "19526164  MOLD 199 ALUMINIO ",
               "refLeroyMerlin": 19526164,
               "desperdicio": 0.22,
               "limitacion70cm": true,
               "precioCoste": 2.28,
               "precioLeroyMerlin": 4.8,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 200,
               "refProveedor": "823-Y31",
               "descripcion": "19525954  MOLD 200 GRIS METAL ",
               "refLeroyMerlin": 19525954,
               "desperdicio": 0.22,
               "limitacion70cm": true,
               "precioCoste": 2.28,
               "precioLeroyMerlin": 4.8,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 201,
               "refProveedor": "823-Y32",
               "descripcion": "19526430  MOLD 201 NEGRO ",
               "refLeroyMerlin": 19526430,
               "desperdicio": 0.22,
               "limitacion70cm": true,
               "precioCoste": 2.28,
               "precioLeroyMerlin": 4.8,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 202,
               "refProveedor": "823-Y33",
               "descripcion": "19526185  MOLD 202 MIEL ",
               "refLeroyMerlin": 19526185,
               "desperdicio": 0.22,
               "limitacion70cm": true,
               "precioCoste": 2.28,
               "precioLeroyMerlin": 4.8,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 203,
               "refProveedor": "Z08-X50",
               "descripcion": "19526745  MOLD 203 PLATA ",
               "refLeroyMerlin": 19526745,
               "desperdicio": 0.55,
               "limitacion70cm": false,
               "precioCoste": 5.95,
               "precioLeroyMerlin": 9.52,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 204,
               "refProveedor": "Z08-X51",
               "descripcion": "19526500  MOLD 204 ACERO ",
               "refLeroyMerlin": 19526500,
               "desperdicio": 0.55,
               "limitacion70cm": false,
               "precioCoste": 5.95,
               "precioLeroyMerlin": 9.52,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 205,
               "refProveedor": "Z08-X52",
               "descripcion": "19525681  MOLD 205 COBRE ",
               "refLeroyMerlin": 19525681,
               "desperdicio": 0.55,
               "limitacion70cm": false,
               "precioCoste": 5.95,
               "precioLeroyMerlin": 9.52,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 206,
               "refProveedor": "Z08-X53",
               "descripcion": "19526850  MOLD 206 ORO ",
               "refLeroyMerlin": 19526850,
               "desperdicio": 0.55,
               "limitacion70cm": false,
               "precioCoste": 5.95,
               "precioLeroyMerlin": 9.52,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 207,
               "refProveedor": "Z32-284",
               "descripcion": "19527382  MOLD 207 NOGAL ",
               "refLeroyMerlin": 19527382,
               "desperdicio": 0.75,
               "limitacion70cm": false,
               "precioCoste": 4.57,
               "precioLeroyMerlin": 7.31,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 208,
               "refProveedor": "Z32-300",
               "descripcion": "19527144  MOLD 208 NOGAL ",
               "refLeroyMerlin": 19527144,
               "desperdicio": 0.75,
               "limitacion70cm": false,
               "precioCoste": 4.57,
               "precioLeroyMerlin": 7.31,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 209,
               "refProveedor": "12BLRASC",
               "descripcion": "19527620  MOLD 209 BLANCO DECAPÉ ",
               "refLeroyMerlin": 19527620,
               "desperdicio": 0.45,
               "limitacion70cm": false,
               "precioCoste": 5.22,
               "precioLeroyMerlin": 8.35,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 210,
               "refProveedor": "12GRISRASC",
               "descripcion": "19527494  MOLD 210 GRIS DECAPÉ ",
               "refLeroyMerlin": 19527494,
               "desperdicio": 0.45,
               "limitacion70cm": false,
               "precioCoste": 5.22,
               "precioLeroyMerlin": 8.35,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 211,
               "refProveedor": "12NGRASC",
               "descripcion": "19527935  MOLD 211 NEGRO DECAPÉ ",
               "refLeroyMerlin": 19527935,
               "desperdicio": 0.45,
               "limitacion70cm": false,
               "precioCoste": 5.22,
               "precioLeroyMerlin": 8.35,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 212,
               "refProveedor": "84M-011",
               "descripcion": "19527816  MOLD 212 BLANCO PLATA ",
               "refLeroyMerlin": 19527816,
               "desperdicio": 0.7,
               "limitacion70cm": false,
               "precioCoste": 6.01,
               "precioLeroyMerlin": 9.62,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 213,
               "refProveedor": "84M-050",
               "descripcion": "19527592  MOLD 213 MADERA ",
               "refLeroyMerlin": 19527592,
               "desperdicio": 0.7,
               "limitacion70cm": false,
               "precioCoste": 4.5,
               "precioLeroyMerlin": 7.2,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 214,
               "refProveedor": "104-BL-RASC",
               "descripcion": "19528145  MOLD 214 BLANCO DECAPÉ ",
               "refLeroyMerlin": 19528145,
               "desperdicio": 0.7,
               "limitacion70cm": false,
               "precioCoste": 10.39,
               "precioLeroyMerlin": 16.62,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 215,
               "refProveedor": "104-033",
               "descripcion": "19523385  MOLD 215 PLATA ",
               "refLeroyMerlin": 19523385,
               "desperdicio": 0.7,
               "limitacion70cm": false,
               "precioCoste": 10.39,
               "precioLeroyMerlin": 16.62,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 216,
               "refProveedor": "104-011",
               "descripcion": "19528495  MOLD 216 BLANCO-PLATA ",
               "refLeroyMerlin": 19528495,
               "desperdicio": 0.7,
               "limitacion70cm": false,
               "precioCoste": 10.39,
               "precioLeroyMerlin": 16.62,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 217,
               "refProveedor": "129-BL",
               "descripcion": "19538106  MOLD 217 BLANCO ",
               "refLeroyMerlin": 19538106,
               "desperdicio": 1,
               "limitacion70cm": false,
               "precioCoste": 15.46,
               "precioLeroyMerlin": 24.74,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 218,
               "refProveedor": "129-NG-FILO-ORO",
               "descripcion": "19538085  MOLD 218 NEGRO ",
               "refLeroyMerlin": 19538085,
               "desperdicio": 1,
               "limitacion70cm": false,
               "precioCoste": 15.46,
               "precioLeroyMerlin": 24.74,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 219,
               "refProveedor": "138-BL",
               "descripcion": "19538183  MOLD 219 BLANCO ",
               "refLeroyMerlin": 19538183,
               "desperdicio": 0.43,
               "limitacion70cm": false,
               "precioCoste": 3.41,
               "precioLeroyMerlin": 5.46,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 220,
               "refProveedor": "319M-022",
               "descripcion": "19538274  MOLD 220 CROCO WENGUE ",
               "refLeroyMerlin": 19538274,
               "desperdicio": 1,
               "limitacion70cm": false,
               "precioCoste": 6.43,
               "precioLeroyMerlin": 10.29,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 221,
               "refProveedor": "319M-050",
               "descripcion": "19538582  MOLD 221 MADERA ",
               "refLeroyMerlin": 19538582,
               "desperdicio": 1,
               "limitacion70cm": false,
               "precioCoste": 6.43,
               "precioLeroyMerlin": 10.29,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 222,
               "refProveedor": "319M-Y4DJ",
               "descripcion": "19537700  MOLD 222 COBRE ",
               "refLeroyMerlin": 19537700,
               "desperdicio": 1,
               "limitacion70cm": false,
               "precioCoste": 6.43,
               "precioLeroyMerlin": 10.29,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 223,
               "refProveedor": "319RR",
               "descripcion": "19537364  MOLD 223 ROBLE ",
               "refLeroyMerlin": 19537364,
               "desperdicio": 1,
               "limitacion70cm": false,
               "precioCoste": 11.13,
               "precioLeroyMerlin": 17.81,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 224,
               "refProveedor": "515M-BL-MATE",
               "descripcion": "19534571  MOLD 224 BLANCO MATE ",
               "refLeroyMerlin": 19534571,
               "desperdicio": 0.52,
               "limitacion70cm": false,
               "precioCoste": 2.6,
               "precioLeroyMerlin": 4.16,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 225,
               "refProveedor": "515M-NG-BRILLO",
               "descripcion": "19534753  MOLD 225 NEGRO BRILLO",
               "refLeroyMerlin": 19534753,
               "desperdicio": 0.52,
               "limitacion70cm": false,
               "precioCoste": 2.6,
               "precioLeroyMerlin": 4.16,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 226,
               "refProveedor": "515M-NG-MATE",
               "descripcion": "19538162  MOLD 226 NEGRO MATE ",
               "refLeroyMerlin": 19538162,
               "desperdicio": 0.52,
               "limitacion70cm": false,
               "precioCoste": 2.6,
               "precioLeroyMerlin": 4.16,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 227,
               "refProveedor": "1063-01",
               "descripcion": "19538323  MOLD 227 NEGRO-PLATA ",
               "refLeroyMerlin": 19538323,
               "desperdicio": 0.9,
               "limitacion70cm": false,
               "precioCoste": 10.12,
               "precioLeroyMerlin": 16.19,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 228,
               "refProveedor": "1063-011",
               "descripcion": "19568255  MOLD 228 BLANCO-PLATA",
               "refLeroyMerlin": 19568255,
               "desperdicio": 0.9,
               "limitacion70cm": false,
               "precioCoste": 10.12,
               "precioLeroyMerlin": 16.19,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 229,
               "refProveedor": "4545M-NG",
               "descripcion": "19542425  MOLD 229 NEGRO",
               "refLeroyMerlin": 19542425,
               "desperdicio": 0.45,
               "limitacion70cm": false,
               "precioCoste": 7.87,
               "precioLeroyMerlin": 12.59,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 230,
               "refProveedor": "4545M-109",
               "descripcion": "19537861  MOLD 230 ROBLE ",
               "refLeroyMerlin": 19537861,
               "desperdicio": 0.45,
               "limitacion70cm": false,
               "precioCoste": 7.87,
               "precioLeroyMerlin": 12.59,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 231,
               "refProveedor": "4545M-050",
               "descripcion": "19538771  MOLD 231 MADERA ",
               "refLeroyMerlin": 19538771,
               "desperdicio": 0.45,
               "limitacion70cm": false,
               "precioCoste": 7.87,
               "precioLeroyMerlin": 12.59,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 232,
               "refProveedor": "4545M-CRAQUELAT",
               "descripcion": "19534900  MOLD 232 ORO CRAQ.",
               "refLeroyMerlin": 19534900,
               "desperdicio": 0.45,
               "limitacion70cm": false,
               "precioCoste": 7.87,
               "precioLeroyMerlin": 12.59,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 233,
               "refProveedor": "4545M-BL",
               "descripcion": "19538043  MOLD 233 BLANCO ",
               "refLeroyMerlin": 19538043,
               "desperdicio": 0.45,
               "limitacion70cm": false,
               "precioCoste": 7.87,
               "precioLeroyMerlin": 12.59,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 234,
               "refProveedor": "4545M-BL+MAT",
               "descripcion": "19535096  MOLD 234 MADERA+BLANCO",
               "refLeroyMerlin": 19535096,
               "desperdicio": 0.45,
               "limitacion70cm": false,
               "precioCoste": 7.87,
               "precioLeroyMerlin": 12.59,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 235,
               "refProveedor": "3019M2-NG",
               "descripcion": "19537854  MOLD 235 NEGRO ",
               "refLeroyMerlin": 19537854,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 2.07,
               "precioLeroyMerlin": 4.35,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 236,
               "refProveedor": "3019M2-BL",
               "descripcion": "19542495  MOLD 236 BLANCO",
               "refLeroyMerlin": 19542495,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 2.07,
               "precioLeroyMerlin": 4.35,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 237,
               "refProveedor": "3019M2-033",
               "descripcion": "19537560  MOLD 237 PLATA ",
               "refLeroyMerlin": 19537560,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 2.07,
               "precioLeroyMerlin": 4.35,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 238,
               "refProveedor": "3019M-PL",
               "descripcion": "19542586  MOLD 238 PLATA MATE",
               "refLeroyMerlin": 19542586,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 2.07,
               "precioLeroyMerlin": 4.35,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 239,
               "refProveedor": "3019M-NG",
               "descripcion": "19537105  MOLD 239 NEGRO MATE ",
               "refLeroyMerlin": 19537105,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 2.07,
               "precioLeroyMerlin": 4.35,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 240,
               "refProveedor": "3019M-BL",
               "descripcion": "19538155  MOLD 240 BLANCO ",
               "refLeroyMerlin": 19538155,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 2.07,
               "precioLeroyMerlin": 4.35,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 241,
               "refProveedor": "2019M-ROBLE",
               "descripcion": "19537504  MOLD 241 ROBLE ",
               "refLeroyMerlin": 19537504,
               "desperdicio": 0.2,
               "limitacion70cm": true,
               "precioCoste": 1.71,
               "precioLeroyMerlin": 3.6,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 242,
               "refProveedor": "2019M-PL",
               "descripcion": "19538673  MOLD 242 PLATA ",
               "refLeroyMerlin": 19538673,
               "desperdicio": 0.2,
               "limitacion70cm": true,
               "precioCoste": 1.71,
               "precioLeroyMerlin": 3.6,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 243,
               "refProveedor": "2019M-NG",
               "descripcion": "19537322  MOLD 243 NEGRO ",
               "refLeroyMerlin": 19537322,
               "desperdicio": 0.2,
               "limitacion70cm": true,
               "precioCoste": 1.71,
               "precioLeroyMerlin": 3.6,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 244,
               "refProveedor": "2019M-MIEL",
               "descripcion": "19537231  MOLD 244 MIEL ",
               "refLeroyMerlin": 19537231,
               "desperdicio": 0.2,
               "limitacion70cm": true,
               "precioCoste": 1.71,
               "precioLeroyMerlin": 3.6,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 245,
               "refProveedor": "2019M-BL",
               "descripcion": "19538575  MOLD 245 BLANCO ",
               "refLeroyMerlin": 19538575,
               "desperdicio": 0.2,
               "limitacion70cm": true,
               "precioCoste": 1.71,
               "precioLeroyMerlin": 3.6,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 246,
               "refProveedor": "319M-NG-BR",
               "descripcion": "19538883  MOLD 246 NEGRO ",
               "refLeroyMerlin": 19538883,
               "desperdicio": 1,
               "limitacion70cm": false,
               "precioCoste": 6.23,
               "precioLeroyMerlin": 9.97,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 247,
               "refProveedor": "319M-BL-BR",
               "descripcion": "19537224  MOLD 247 BLANCO BRILLO ",
               "refLeroyMerlin": 19537224,
               "desperdicio": 1,
               "limitacion70cm": false,
               "precioCoste": 6.23,
               "precioLeroyMerlin": 9.97,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 248,
               "refProveedor": "41M-WEN",
               "descripcion": "19537721  MOLD 248 WENGUE ",
               "refLeroyMerlin": 19537721,
               "desperdicio": 0.4,
               "limitacion70cm": true,
               "precioCoste": 1.83,
               "precioLeroyMerlin": 3.83,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 249,
               "refProveedor": "41M-ROBLE(MIEL)",
               "descripcion": "19537672  MOLD 249 MIEL ",
               "refLeroyMerlin": 19537672,
               "desperdicio": 0.4,
               "limitacion70cm": true,
               "precioCoste": 1.83,
               "precioLeroyMerlin": 3.83,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 250,
               "refProveedor": "41M-PL",
               "descripcion": "19537840  MOLD 250 PLATA MATE ",
               "refLeroyMerlin": 19537840,
               "desperdicio": 0.4,
               "limitacion70cm": true,
               "precioCoste": 1.83,
               "precioLeroyMerlin": 3.83,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 251,
               "refProveedor": "41M-NG",
               "descripcion": "19538036  MOLD 251 NEGRO ",
               "refLeroyMerlin": 19538036,
               "desperdicio": 0.4,
               "limitacion70cm": true,
               "precioCoste": 1.83,
               "precioLeroyMerlin": 3.83,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 252,
               "refProveedor": "41M-MIEL",
               "descripcion": "19537406  MOLD 252 MIEL ",
               "refLeroyMerlin": 19537406,
               "desperdicio": 0.4,
               "limitacion70cm": true,
               "precioCoste": 1.83,
               "precioLeroyMerlin": 3.83,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 253,
               "refProveedor": "41M-CAOBA",
               "descripcion": "19538344  MOLD 253 CAOBA ",
               "refLeroyMerlin": 19538344,
               "desperdicio": 0.4,
               "limitacion70cm": true,
               "precioCoste": 1.83,
               "precioLeroyMerlin": 3.83,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 254,
               "refProveedor": "41M-BL-ROTO",
               "descripcion": "19538526  MOLD 254 BLANCO ",
               "refLeroyMerlin": 19538526,
               "desperdicio": 0.4,
               "limitacion70cm": true,
               "precioCoste": 1.83,
               "precioLeroyMerlin": 3.83,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 255,
               "refProveedor": "41M-07",
               "descripcion": "19537091  MOLD 255 PLATA ",
               "refLeroyMerlin": 19537091,
               "desperdicio": 0.4,
               "limitacion70cm": true,
               "precioCoste": 1.83,
               "precioLeroyMerlin": 3.83,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 256,
               "refProveedor": "30M-WENGUE",
               "descripcion": "19537994  MOLD 256 WENGUE ",
               "refLeroyMerlin": 19537994,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 1.56,
               "precioLeroyMerlin": 3.27,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 257,
               "refProveedor": "30M-PLATA",
               "descripcion": "19537196  MOLD 257 PLATA ",
               "refLeroyMerlin": 19537196,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 1.56,
               "precioLeroyMerlin": 3.27,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 258,
               "refProveedor": "30M-NG",
               "descripcion": "19538463  MOLD 258 NEGRO ",
               "refLeroyMerlin": 19538463,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 1.56,
               "precioLeroyMerlin": 3.27,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 259,
               "refProveedor": "30M-BL-ROTO",
               "descripcion": "19537175  MOLD 259 BLANCO MADERA ",
               "refLeroyMerlin": 19537175,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 1.56,
               "precioLeroyMerlin": 3.27,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 260,
               "refProveedor": "30L-PINO",
               "descripcion": "19538134  MOLD 260 PINO ",
               "refLeroyMerlin": 19538134,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 2.16,
               "precioLeroyMerlin": 4.53,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 261,
               "refProveedor": "30L-NOGAL",
               "descripcion": "19538442  MOLD 261 NOGAL ",
               "refLeroyMerlin": 19538442,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 2.16,
               "precioLeroyMerlin": 4.53,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 262,
               "refProveedor": "30L-MIEL",
               "descripcion": "19538813  MOLD 262 MIEL ",
               "refLeroyMerlin": 19538813,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 2.16,
               "precioLeroyMerlin": 4.53,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 263,
               "refProveedor": "30L-CAOBA",
               "descripcion": "19537154  MOLD 263 WENGUE ",
               "refLeroyMerlin": 19537154,
               "desperdicio": 0.3,
               "limitacion70cm": true,
               "precioCoste": 2.16,
               "precioLeroyMerlin": 4.53,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 264,
               "refProveedor": "20M-NG",
               "descripcion": "19537791  MOLD 264 NEGRO ",
               "refLeroyMerlin": 19537791,
               "desperdicio": 0.2,
               "limitacion70cm": true,
               "precioCoste": 1.25,
               "precioLeroyMerlin": 2.62,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 265,
               "refProveedor": "TM2-NGL",
               "descripcion": "19537952  MOLD 265 ALUMINIO NEGRO BRILLO ",
               "refLeroyMerlin": 19537952,
               "desperdicio": 0.07,
               "limitacion70cm": false,
               "precioCoste": 5.08,
               "precioLeroyMerlin": 8.13,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 266,
               "refProveedor": "TM2-NG",
               "descripcion": "19538260  MOLD 266 ALUMINIO NEGRO MATE ",
               "refLeroyMerlin": 19538260,
               "desperdicio": 0.07,
               "limitacion70cm": false,
               "precioCoste": 5.08,
               "precioLeroyMerlin": 8.13,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 267,
               "refProveedor": "TM2-MA",
               "descripcion": "19538421  MOLD 267 ALUMINIO PLOMO ",
               "refLeroyMerlin": 19538421,
               "desperdicio": 0.07,
               "limitacion70cm": false,
               "precioCoste": 5.08,
               "precioLeroyMerlin": 8.13,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 268,
               "refProveedor": "TM2-PL",
               "descripcion": "19538722  MOLD 268 ALUMINIO  PLATA ",
               "refLeroyMerlin": 19538722,
               "desperdicio": 0.07,
               "limitacion70cm": false,
               "precioCoste": 5.08,
               "precioLeroyMerlin": 8.13,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 269,
               "refProveedor": "TM2-BRZ",
               "descripcion": "19538806  MOLD 269 ALUMINIO BRONCE ",
               "refLeroyMerlin": 19538806,
               "desperdicio": 0.07,
               "limitacion70cm": false,
               "precioCoste": 5.08,
               "precioLeroyMerlin": 8.13,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 270,
               "refProveedor": "TM2-RO",
               "descripcion": "19538953  MOLD 270 ALUMINIO ROJO ",
               "refLeroyMerlin": 19538953,
               "desperdicio": 0.07,
               "limitacion70cm": false,
               "precioCoste": 5.08,
               "precioLeroyMerlin": 8.13,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 271,
               "refProveedor": "TM2-BLC",
               "descripcion": "19538414  MOLD 271 ALUMINIO BLANCO ",
               "refLeroyMerlin": 19538414,
               "desperdicio": 0.07,
               "limitacion70cm": false,
               "precioCoste": 5.08,
               "precioLeroyMerlin": 8.13,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 272,
               "refProveedor": "TM2-AZ",
               "descripcion": "19537392  MOLD 272 ALUMINIO AZUL ",
               "refLeroyMerlin": 19537392,
               "desperdicio": 0.07,
               "limitacion70cm": false,
               "precioCoste": 5.08,
               "precioLeroyMerlin": 8.13,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 273,
               "refProveedor": "TM2-VE",
               "descripcion": "19537581  MOLD 273 ALUMINIO VERDE ",
               "refLeroyMerlin": 19537581,
               "desperdicio": 0.07,
               "limitacion70cm": false,
               "precioCoste": 5.08,
               "precioLeroyMerlin": 8.13,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 274,
               "refProveedor": "3035",
               "descripcion": "19537133  MOLD 274 BASTIDOR GRANDE ",
               "refLeroyMerlin": 19537133,
               "desperdicio": 0.3,
               "limitacion70cm": false,
               "precioCoste": 2.87,
               "precioLeroyMerlin": 4.59,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 275,
               "refProveedor": "2030",
               "descripcion": "19537252  MOLD 275 BASTIDOR PEQUEÑO ",
               "refLeroyMerlin": 19537252,
               "desperdicio": 0.2,
               "limitacion70cm": false,
               "precioCoste": 2.47,
               "precioLeroyMerlin": 3.96,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 276,
               "refProveedor": "20M-BL",
               "descripcion": "19644513  MOLD 276 BLANCO",
               "refLeroyMerlin": 19644513,
               "desperdicio": 0.2,
               "limitacion70cm": true,
               "precioCoste": 1.29,
               "precioLeroyMerlin": 2.71,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 277,
               "refProveedor": "20M-ROSA",
               "descripcion": "19644555  MOLD 277 ROSA ",
               "refLeroyMerlin": 19644555,
               "desperdicio": 0.2,
               "limitacion70cm": true,
               "precioCoste": 1.29,
               "precioLeroyMerlin": 2.71,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 278,
               "refProveedor": "20M-ROJO",
               "descripcion": "19644590  MOLD 278 ROJO",
               "refLeroyMerlin": 19644590,
               "desperdicio": 0.2,
               "limitacion70cm": true,
               "precioCoste": 1.29,
               "precioLeroyMerlin": 2.71,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 279,
               "refProveedor": "20M-WENGUE",
               "descripcion": "19644632  MOLD 279 WENGUE",
               "refLeroyMerlin": 19644632,
               "desperdicio": 0.2,
               "limitacion70cm": true,
               "precioCoste": 1.29,
               "precioLeroyMerlin": 2.71,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 280,
               "refProveedor": "20M-PL",
               "descripcion": "19644674  MOLD 280 PLATA",
               "refLeroyMerlin": 19644674,
               "desperdicio": 0.2,
               "limitacion70cm": true,
               "precioCoste": 1.29,
               "precioLeroyMerlin": 2.71,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             },
             {
               "numeroMoldura": 281,
               "refProveedor": "20M-050",
               "descripcion": "19644723  MOLD 281 MADERA",
               "refLeroyMerlin": 19644723,
               "desperdicio": 0.2,
               "limitacion70cm": true,
               "precioCoste": 1.29,
               "precioLeroyMerlin": 2.71,
               "urlImagen": "",
               "urlImagenPerfil": "",
               "observaciones": "",
               "activo": true
             }
            ];


            for (var i=0;i<json.length;i++) {

                productosMolduras.$add(json[i])
                    .then(function(ref) {

                        utilsService.writeConsole("[MoldingsController] - addMolduras(json) => Added new record (" + i + ") to 'productos_moldura'", WRITE_IN_CONSOLE);

                    })
                    .catch(function(error) {
                        utilsService.writeConsole("[MoldingsController] - addMolduras(json) => ERROR: " + error, WRITE_IN_CONSOLE); 
                    }
                );
            }                    
        }
*/


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.menu.productos.molduras')
        .controller('MoldingController', MoldingController);

    /** @ngInject */
    function MoldingController($state,WRITE_IN_CONSOLE,utilsService,loginService,firebaseDataService,$firebaseArray,$firebaseObject,$timeout)
    {
        //********************************************************        
        // DATA DECLARATION
        //********************************************************        
        var vm = this;

        vm.mode = "";       //accepted values = ["insert","update"]

        vm.moldura = {};
        vm.molduraKey = "";

        //vm.estados = ["Aprobado","Pendiente","Anulado"];
        //vm.provincias = ["Álava","Albacete","Alicante","Almería","Asturias","Ávila","Badajoz","Islas Baleares","Barcelona","Burgos","Cáceres","Cádiz","Cantabria","Castellón","Ciudad Real","Córdoba","Cuenca","Girona","Granada","Guadalajara","Guipúzcoa","Huelva","Huesca","Jaén","La Coruña","La Rioja","Las Palmas","León","Lleida","Lugo","Madrid","Málaga","Murcia","Navarra","Orense","Palencia","Pontevedra","Salamanca","Segovia","Sevilla","Soria","Tarragona","Santa Cruz de Tenerife","Teruel","Toledo","Valencia","Valladolid","Vizcaya","Zamora","Zaragoza"];

        //vm.fechaConFormato = "";

        //********************************************************
        // METHODS DECLARATION
        //********************************************************   
        vm.getMoldura = getMoldura;

        vm.addMoldura = addMoldura;
        vm.save = save;

        vm.selectFile = selectFile;
        vm.selectFile2 = selectFile2;

        vm.handleFileSelect = handleFileSelect;
        vm.handleFileSelect2 = handleFileSelect2;

        //vm.showAlertDialog = showAlertDialog;
        vm.gotoMoldings = gotoMoldings;

//vm.add100Presupuestos = add100Presupuestos;


        //START CONTROLLER *******************************
        init();
        //START CONTROLLER *******************************


        //********************************************************
        // METHODS DECLARATION
        //********************************************************        
        function init()
        {
            var id;

            try {

                id = $state.params.id;

                if (id == null) {

                    vm.mode = "insert";

                    //Para el caso de la inserción => Asignamos los valores por defecto (estado, envioTienda, tienda y telefonoTienda)
                    vm.moldura.desperdicio = 0;
                    vm.moldura.precioCoste = 0;
                    vm.moldura.precioLeroyMerlin = 0;

                    vm.moldura.limitacion70cm = false;
                    vm.moldura.activo = true;

                } else {
                    vm.mode = "update";
                    vm.getMoldura(id);
                }


            } catch (error) {
                vm.mode = "insert";
            }

            document.getElementById('fileInput').addEventListener('change', handleFileSelect, false);
            document.getElementById('fileInput2').addEventListener('change', handleFileSelect2, false);

        }



        //***************************************************************
        function getMoldura(pId) {

            var fbUrl = firebaseDataService.productos_moldura.child(pId);
            var result = $firebaseObject(fbUrl);

            result.$loaded()
                .then(function(data) {

                    utilsService.writeConsole("[MoldingController] => getMoldura(pId) => EJECUCIÓN OK DE CONSULTA TABLA productos_moldura con $id = " + data.$id, WRITE_IN_CONSOLE);
                    vm.molduraKey = data.$id;

                    vm.moldura = data;

                    //vm.fechaConFormato = new Date(vm.moldura.fechaTimestamp);

                    try {

                        if (vm.moldura.urlImagen != null) {
                            document.getElementById("imageFromStorage").src = vm.moldura.urlImagen;

                        } else {
                            vm.moldura.urlImagen = "";
                            vm.moldura.nombreImagen = "";
                        }

                    } catch(error) {

                        vm.moldura.urlImagen = "";
                        vm.moldura.nombreImagen = "";
                    }

                    try {

                        if (vm.moldura.urlImagenPerfil != null) {
                            document.getElementById("profileImageFromStorage").src = vm.moldura.urlImagenPerfil;

                        } else {
                            vm.moldura.urlImagenPerfil = "";
                            vm.moldura.nombreImagenPerfil = "";
                        }

                    } catch(error) {

                        vm.moldura.urlImagenPerfil = "";
                        vm.moldura.nombreImagenPerfil = "";
                    }



                })

                .catch(function(error) {
                    vm.moldura = null;
                    utilsService.writeConsole("[MoldingController] => getMoldura(pId) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        //***************************************************************
        function addMoldura(pMoldura) {

            var fbUrl = firebaseDataService.productos_moldura;
            var molduras = $firebaseArray(fbUrl.limitToLast(1));

/*
            //Nos aseguramos que los campos numéricos no se guardan como campos de texto
            pMoldura.numeroMoldura = Number(pMoldura.numeroMoldura);
            pMoldura.desperdicio = Number(pMoldura.desperdicio);
            pMoldura.precioCoste = Number(pMoldura.precioCoste);
            pMoldura.precioLeroyMerlin = Number(pMoldura.precioLeroyMerlin);
            //pMoldura.refLeroyMerlin = Number(pMoldura.refLeroyMerlin);
*/

            molduras.$add(pMoldura)
                .then(function(ref) {
                    utilsService.writeConsole("[MoldingController] - addMoldura(pMoldura) => Added new record to 'productos_moldura'", WRITE_IN_CONSOLE);

                    //We go to moldings list page
                    vm.gotoMoldings();

                })
                .catch(function(error) {
                    utilsService.writeConsole("[MoldingController] - addMoldura(pMoldura) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        function save() {

            //utilsService.writeConsole("vm.fechaConFormato = " + vm.fechaConFormato, WRITE_IN_CONSOLE);
            //vm.moldura.fechaTimestamp = vm.fechaConFormato.getTime();
            //utilsService.writeConsole("vm.moldura.fechaTimestamp = " + vm.moldura.fechaTimestamp, WRITE_IN_CONSOLE);

/*
            //Nos aseguramos que los campos numéricos NO se guardan como campos de texto
            vm.moldura.numeroMoldura = Number(vm.moldura.numeroMoldura);
            vm.moldura.desperdicio = Number(vm.moldura.desperdicio);
            vm.moldura.precioCoste = Number(vm.moldura.precioCoste);
            vm.moldura.precioLeroyMerlin = Number(vm.moldura.precioLeroyMerlin);
            //vm.moldura.refLeroyMerlin = Number(vm.moldura.refLeroyMerlin);
*/
            if (vm.mode == "update") {
                
                //We update product's data
                vm.moldura.$save()
                    .then(function(ref) {
                        utilsService.writeConsole("[MoldingController] - save() => moldura saved with ID = " + ref.key, WRITE_IN_CONSOLE);

                        //We go to moldings page
                        vm.gotoMoldings();
                    })

                    .catch(function(error) {
                        utilsService.writeConsole("[MoldingController] => save() => ERROR: " + error, WRITE_IN_CONSOLE); 
                });                

            } else {

                //We add a new moldura
                vm.addMoldura(vm.moldura);
            }
        }



        function selectFile() {
            angular.element(document.querySelector('#fileInput')).click();
        }


        function selectFile2() {
            angular.element(document.querySelector('#fileInput2')).click();
        }



        function handleFileSelect(evt) {

            vm.storageDirectoryPath = "/Buenatelier/productos/molduras/";

            evt.stopPropagation();
            evt.preventDefault();
            var file = evt.target.files[0];

            try {
                var metadata = {
                    'contentType': file.type
                };
            } catch (error) {
                utilsService.writeConsole("[MoldingController] => handleFileSelect() => We can´t assign 'contentType' to metadata.", WRITE_IN_CONSOLE)
            }


            var storageRef = firebaseDataService.firebaseStorageRootRef;
            console.log("storageRef = " + storageRef);

            storageRef.child(vm.storageDirectoryPath + file.name).put(file,metadata)
                .then(function(snapshot) {
                    utilsService.writeConsole('Uploaded', snapshot.totalBytes, 'bytes.', WRITE_IN_CONSOLE);
                    utilsService.writeConsole(snapshot.metadata, WRITE_IN_CONSOLE);
                    var url = snapshot.metadata.downloadURLs[0];
                    utilsService.writeConsole('File available at' + url, WRITE_IN_CONSOLE);
                    utilsService.writeConsole("FILE UPLOADED!!!", WRITE_IN_CONSOLE);

                    $timeout(function() {
                        vm.dropping = false;
                        
                        vm.moldura.nombreImagen = file.name;
                        vm.moldura.urlImagen = snapshot.metadata.downloadURLs[0];

                        document.getElementById("imageFromStorage").src = vm.moldura.urlImagen;

                    });
                })
                .catch(function(error) {
                    utilsService.writeConsole("[MoldingController] => handleFileSelect() => Upload failed!!! => ERROR: " + error, WRITE_IN_CONSOLE);
            });
        }


        function handleFileSelect2(evt) {

            vm.storageDirectoryPath = "/Buenatelier/productos/molduras/";

            evt.stopPropagation();
            evt.preventDefault();
            var file = evt.target.files[0];

            try {
                var metadata = {
                    'contentType': file.type
                };
            } catch (error) {
                utilsService.writeConsole("[MoldingController] => handleFileSelect2() => We can´t assign 'contentType' to metadata.", WRITE_IN_CONSOLE)
            }


            var storageRef = firebaseDataService.firebaseStorageRootRef;
            console.log("storageRef = " + storageRef);

            storageRef.child(vm.storageDirectoryPath + file.name).put(file,metadata)
                .then(function(snapshot) {
                    utilsService.writeConsole('Uploaded', snapshot.totalBytes, 'bytes.', WRITE_IN_CONSOLE);
                    utilsService.writeConsole(snapshot.metadata, WRITE_IN_CONSOLE);
                    var url = snapshot.metadata.downloadURLs[0];
                    utilsService.writeConsole('File available at' + url, WRITE_IN_CONSOLE);
                    utilsService.writeConsole("FILE UPLOADED!!!", WRITE_IN_CONSOLE);

                    $timeout(function() {
                        vm.dropping = false;
                        
                        vm.moldura.nombreImagenPerfil = file.name;
                        vm.moldura.urlImagenPerfil = snapshot.metadata.downloadURLs[0];

console.log("vm.moldura.nombreImagenPerfil = " + vm.moldura.nombreImagenPerfil);
console.log("vm.moldura.urlImagenPerfil = " + vm.moldura.urlImagenPerfil);

                        document.getElementById("profileImageFromStorage").src = vm.moldura.urlImagenPerfil;

                    });
                })
                .catch(function(error) {
                    utilsService.writeConsole("[MoldingController] => handleFileSelect2() => Upload failed!!! => ERROR: " + error, WRITE_IN_CONSOLE);
            });
        }




        //***************************************************************
        function gotoMoldings()
        {
            $state.go('app.menu_productos_molduras');
        }



/*
        //***************************************************************
        function gotoProductDetail(id)
        {
            $state.go('app.menu_presupuestos_budget', {id: id});
        }
*/



/*
        //***************************************************************
        function add100Presupuestos() {

            var fbUrl = firebaseDataService.presupuestos;
            var presupuestos = $firebaseArray(fbUrl.limitToLast(1));

            for (var i=4;i<100;i++) {

                var json = {"ciudadCliente": "Ciudad "+i,
                            "cliente": "Cliente "+i,
                            "codigo": "PRESU-00"+i,
                            "codigoPostalCliente": "08010",
                            "dimensiones": "¿?",
                            "direccionCliente": "Dirección " + i,
                            "emailCliente": "cliente"+i + "@dominio.com",
                            "envioTienda": true,
                            "envioTiendaValorString": "false",
                            "estado": "Pendiente",
                            "fechaTimestamp": new Date().getTime() + (i*86400000),
                            "numeroPC": "PC171213",
                            "observacionesCliente": "Observación " + i,
                            "provinciaCliente": "Barcelona",
                            "telefonoCliente": "600 11 22 33",
                            "telefonoTienda": "900 11 22 33",
                            "tipoPresupuesto": "¿?",
                            "unidades": 0,
                            "usuario": "Administración central",
                            "usuario_key": "-L-zqZMzj2ApqVql-nn9",
                            "vendedor": "Vendedor " + i
                            }


                presupuestos.$add(json)
                    .then(function(ref) {
                        utilsService.writeConsole("[MoldingController] - addPresupuesto(pPresupuesto) => Added new record to 'presupuestos'", WRITE_IN_CONSOLE);

                    })
                    .catch(function(error) {
                        utilsService.writeConsole("[MoldingController] - addPresupuesto(pPresupuesto) => ERROR: " + error, WRITE_IN_CONSOLE); 
                    }
                );
            }                    
        }
*/



    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.menu.presupuestos',
            [
                // 3rd Party Dependencies
                'datatables',
                'flow',
                'nvd3',
                'textAngular',
                'xeditable'
            ]
        )
        .config(config);

    /** @ngInject */
//    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider

            //PRESUPUESTOS
            .state('app.menu_presupuestos', {
                url      : '/menu/presupuestos/budgets',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/menu/presupuestos/budgets/budgets.html',
                        controller : 'BudgetsController as vm'
                    }
                },

                bodyClass: 'presupuestos'
            })


            //AÑADIR PRESUPUESTO
            .state('app.menu_presupuestos_add', {
                url      : '/menu/presupuestos/budgets/add',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/menu/presupuestos/budget/budget.html',
                        controller : 'BudgetController as vm'
                    }
                },

                bodyClass: 'presupuestos'
            })


            //VER-EDITAR PRESUPUESTO
            .state('app.menu_presupuestos_budget', {
                url      : '/menu/presupuestos/budget/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/menu/presupuestos/budget/budget.html',
                        controller : 'BudgetController as vm'
                    }
                },

                bodyClass: 'presupuestos'
            })


            //PRESUPUESTO "ENMARCACION"
            .state('app.menu_presupuestos_framing_budget', {
                url      : '/menu/presupuestos/framing-budget/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/menu/presupuestos/framing-budget/framingBudget.html',
                        controller : 'FramingBudgetController as vm'
                    }
                },

                bodyClass: 'presupuestos'
            })


            //PRESUPUESTO "ESPEJO"
            .state('app.menu_presupuestos_mirror_budget', {
                url      : '/menu/presupuestos/mirror-budget/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/menu/presupuestos/mirror-budget/mirrorBudget.html',
                        controller : 'MirrorBudgetController as vm'
                    }
                },

                bodyClass: 'presupuestos'
            })




        // Translation
        $translatePartialLoaderProvider.addPart('app/main/menu/presupuestos');


        // Navigation
        msNavigationServiceProvider.saveItem('menu.presupuestos', {
            title : 'Presupuestos',
            icon  : 'icon-cart',
            state: 'app.menu_presupuestos',
            weight: 1
        });
/*
        msNavigationServiceProvider.saveItem('menu.presupuestos.budgets', {
            title: 'Budgets',
            state: 'menu.presupuestos.budgets'
        });
*/

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.menu.presupuestos')
        .controller('PrintOrderDialogController', PrintOrderDialogController);

    /** @ngInject */
    function PrintOrderDialogController($mdDialog, $document, statusService, firebaseDataService, utilsService, WRITE_IN_CONSOLE, $firebaseObject, $firebaseArray,presupuestoKey,presupuestoNumeroPC)
    {

        // DECLARATIONS ***********************
        var vm = this;

        vm.presupuestoKey = "";
        vm.numeroPC = "";
        vm.presupuestoData;
        vm.presupuestoDetalle;
        vm.textoMedidaExteriorInterior = "";
        vm.textoClienteDejaObra = "No";
        vm.textoObraConDesperfectos = "No";
        vm.textoPptConVentanas = "No";

        vm.numeroPC = "";
        vm.tienda = "";
        vm.telefonoTienda = "";
        vm.vendedor = "";
        vm.fechaTimestamp = "";


        // METHODS DECLARATION ****************
        vm.getPresupuestoData = getPresupuestoData;

        vm.getPresupuestoDetalle = getPresupuestoDetalle;
        

        vm.print = print;
        vm.closeDialog = closeDialog;



        //START CONTROLLER *******************************
        init();
        //START CONTROLLER *******************************


        //********************************************************
        // METHODS DECLARATION
        //********************************************************        
        function init() 
        {

            if (angular.isDefined(presupuestoKey)) {
                vm.presupuestoKey = presupuestoKey;
            } else {
                vm.presupuestoKey = "";
            }

            if (angular.isDefined(presupuestoNumeroPC)) {
                vm.numeroPC = presupuestoNumeroPC;
            } else {
                vm.numeroPC = "?";
            }

console.log("vm.presupuestoKey = " + vm.presupuestoKey);

            //Obtenemos los datos generales del presupuesto a través del presupuesto seleccionado (presupuestoKey recibido) (datos procedentes de la tabla 'presupuestos')
            vm.getPresupuestoData(vm.presupuestoKey);

        }


        //***************************************************************
        function getPresupuestoData(pPresupuestoKey) {

console.log("pPresupuestoKey = " + pPresupuestoKey);

            var fbUrl = firebaseDataService.presupuestos.child(pPresupuestoKey);
            var result = $firebaseObject(fbUrl);

            result.$loaded()
                .then(function(data) {

                    console.log("[PrintOrderDialogController] => getPresupuestoData(pPresupuestoKey) => EJECUCIÓN OK DE CONSULTA TABLA presupuestos con $id = " + data.$id);
                
                    vm.presupuestoData = data;

                    //Obtenemos los datos de detalle del presupuesto (datos procedentes de la tabla 'presupuesto_marco')
                    vm.getPresupuestoDetalle(vm.presupuestoKey, vm.presupuestoData.tipo);

                })
                .catch(function(error) {
                    console.log("[PrintOrderDialogController] => getPresupuestoData(pPresupuestoKey) => ERROR: " + error);
                    vm.consignatarioData = null;
                }
            );
        }



        //***************************************************************
        function getPresupuestoDetalle(pPresupuestoKey,pTipo) {

            var fbUrl;
            var result;

            if (pTipo == "enmarcación") {

                fbUrl = firebaseDataService.presupuesto_marco;

            } else if (pTipo == "espejo") {

                fbUrl = firebaseDataService.presupuesto_espejo;
            }

            result = $firebaseArray(fbUrl.orderByChild("presupuesto_key").equalTo(pPresupuestoKey));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    utilsService.writeConsole("[PrintOrderDialogController] => getPresupuestoDetalle(pPresupuestoKey,pTipo) => EJECUCIÓN OK DE CONSULTA TABLA 'presupuesto_marco' o 'presupuesto_espejo' (dependiendo del tipo de presupuesto) con dataLength = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {
                        vm.presupuestoDetalle = data[0];

                    } else {
                        vm.presupuestoDetalle = null;    
                    }


                    if (vm.presupuestoDetalle.medidaExteriorValorString == "true") {
                        vm.textoMedidaExteriorInterior = "medida exterior";
                    } else {
                        vm.textoMedidaExteriorInterior = "medida interior";
                    }

                    if (pTipo == "enmarcación") {
                        if (vm.presupuestoDetalle.clienteDejaObraValorString == "true") {
                            vm.textoClienteDejaObra = "Sí";
                        } else {
                            vm.textoClienteDejaObra = "No";
                        }

                        if (vm.presupuestoDetalle.obraConDesperfectosValorString == "true") {
                            vm.textoObraConDesperfectos = "Sí";
                        } else {
                            vm.textoObraConDesperfectos = "No";
                        }


                        if (vm.presupuestoDetalle.multiventana) {
                            vm.textoPptConVentanas = "Sí";
                        } else {
                            vm.textoPptConVentanas = "No";
                        }




                    }

                })
                .catch(function(error) {
                    console.log("[PrintOrderDialogController] => getPresupuestoDetalle(pPresupuestoKey,pTipo) => ERROR: " + error);
                    vm.presupuestoDetalle = null;
                }
            );
        }







        //***************************************************************
        function calculateTotalWeights() {

            var length = vm.packinglistData.length;
            var totalNetWeight = 0;
            var totalGrossWeight = 0;

            for (var i=0;i<length;i++) {

                vm.totalNetWeight += parseFloat(vm.packinglistData[i].netWeight);
                vm.totalGrossWeight += parseFloat(vm.packinglistData[i].grossWeight);
            }
            
            vm.totalNetWeight = vm.totalNetWeight.toFixed(2);
            vm.totalGrossWeight = vm.totalGrossWeight.toFixed(2);

            console.log("vm.totalNetWeight = " + vm.totalNetWeight);
            console.log("vm.totalGrossWeight = " + vm.totalGrossWeight);
        }



        //***************************************************************
        function print(pDivToPrint) {

            var printContents = document.getElementById(pDivToPrint).innerHTML;
            var popupWin = window.open('', '_blank', 'width=600,height=450');
            popupWin.document.open();
            popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" media="print" href="print-packinglist-dialog.css" /></head><body onload="window.print()">' + printContents + '</body></html>');
            popupWin.document.close();
        }



        //***************************************************************
        function closeDialog() 
        {
            $mdDialog.hide();
        }




    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.menu.presupuestos')
        .controller('MenuDialogController', MenuDialogController);

    /** @ngInject */
    function MenuDialogController($state,firebaseDataService,$mdDialog,$firebaseArray,$document,presupuestoKey,presupuestoTipo)
    {
        // DECLARATIONS ***********************
        var vm = this;
        vm.presupuestoKey;

        vm.desactivaEnmarcacion = false;
        vm.desactivaEspejo = false;
        vm.desactivaCorte = false;
        vm.desactivaReparacion = false;

        // METHODS DECLARATION ****************
        vm.gotoMirrorBudget = gotoMirrorBudget;
        vm.gotoFramingBudget = gotoFramingBudget;
        vm.gotoCutBudget = gotoCutBudget;
        vm.gotoRepairBudget = gotoRepairBudget;

        vm.closeDialog = closeDialog;


        //START CONTROLLER *******************************
        init();
        //START CONTROLLER *******************************


        //********************************************************
        // METHODS DECLARATION
        //********************************************************        
        function init()
        {
            if ( angular.isDefined(presupuestoKey) ) {
                vm.presupuestoKey = presupuestoKey;
            } else {
                vm.presupuestoKey = null;
            }
            
            if ( angular.isDefined(presupuestoTipo) ) {

                if (presupuestoTipo == "enmarcación") {
                    vm.desactivaEnmarcacion = false;
                    vm.desactivaEspejo = true;
                    vm.desactivaCorte = true;
                    vm.desactivaReparacion = true;
                }

                else if (presupuestoTipo == "espejo") {
                    vm.desactivaEnmarcacion = true;
                    vm.desactivaEspejo = false;
                    vm.desactivaCorte = true;
                    vm.desactivaReparacion = true;
                }

                else if (presupuestoTipo == "corte") {
                    vm.desactivaEnmarcacion = true;
                    vm.desactivaEspejo = true;
                    vm.desactivaCorte = false;
                    vm.desactivaReparacion = true;
                }

                else if (presupuestoTipo == "reparación") {
                    vm.desactivaEnmarcacion = true;
                    vm.desactivaEspejo = true;
                    vm.desactivaCorte = true;
                    vm.desactivaReparacion = false;
                }

                else {
                    vm.desactivaEnmarcacion = false;
                    vm.desactivaEspejo = false;
                    vm.desactivaCorte = false;
                    vm.desactivaReparacion = false;
                }
            }
        }



        //***************************************************************
        function gotoFramingBudget(pPresupuestoKey)
        {
            $mdDialog.hide();

            $state.go('app.menu_presupuestos_framing_budget', {id: pPresupuestoKey});
        }


        //***************************************************************
        function gotoMirrorBudget(pPresupuestoKey)
        {
            $mdDialog.hide();

            $state.go('app.menu_presupuestos_mirror_budget', {id: pPresupuestoKey});
        }


        //***************************************************************
        function gotoCutBudget(pPresupuestoKey)
        {
            $mdDialog.hide();

            //$state.go('app.menu_presupuestos_cut_budget', {id: pPresupuestoKey});
        }


        //***************************************************************
        function gotoRepairBudget(pPresupuestoKey)
        {
            $mdDialog.hide();
            
            //$state.go('app.menu_presupuestos_repair_budget', {id: pPresupuestoKey});
        }




        //***************************************************************
        function closeDialog() 
        {
            $mdDialog.hide();

            $state.go('app.menu_presupuestos');
        }











    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.menu.presupuestos')
        .controller('MenuDialogEstadoController', MenuDialogEstadoController);

    /** @ngInject */
    function MenuDialogEstadoController(WRITE_IN_CONSOLE,$state,utilsService,firebaseDataService,$mdDialog,$firebaseArray,$firebaseObject,$document,presupuestoKey,presupuestoEstado,presupuestoNumeroPD,presupuestoNumeroPC)
    {

        // DECLARATIONS ***********************
        var vm = this;
        vm.presupuestoKey;
        vm.presupuesto = {};
        vm.usuarioPresupuestos = {};

        vm.estados = ["Aprobado","Pendiente","Anulado"];


        // METHODS DECLARATION ****************
        vm.getPresupuesto = getPresupuesto;
        vm.getUsuarioPresupuestos = getUsuarioPresupuestos;

        vm.updatePresupuestoMismoNumeroPD = updatePresupuestoMismoNumeroPD;
        vm.updateUsuarioPresupuestosMismoNumeroPD = updateUsuarioPresupuestosMismoNumeroPD;

//        vm.checkNumeroPC = checkNumeroPC;

        vm.save = save;
        vm.savePresupuestoToUsuarioPresupuestosTable = savePresupuestoToUsuarioPresupuestosTable;
        vm.showAlertDialog = showAlertDialog;
        vm.closeDialog = closeDialog;


        //START CONTROLLER *******************************
        init();
        //START CONTROLLER *******************************


        //********************************************************
        // METHODS DECLARATION
        //********************************************************        
        function init()
        {
            if (angular.isDefined(presupuestoKey)) {
                vm.presupuestoKey = presupuestoKey;

                vm.getPresupuesto(presupuestoKey);
                vm.getUsuarioPresupuestos(presupuestoKey);

            } else {
                vm.presupuestoKey = null;
            }
            

            if (angular.isDefined(presupuestoEstado)) {
                vm.presupuesto.estado = presupuestoEstado;
            } else {
                vm.presupuesto.estado = "Pendiente";
            }

            if (angular.isDefined(presupuestoNumeroPD)) {
                vm.presupuesto.numeroPD = presupuestoNumeroPD;
            } else {
                vm.presupuesto.numeroPD = "?";
            }

            if (angular.isDefined(presupuestoNumeroPC)) {
                vm.presupuesto.numeroPC = presupuestoNumeroPC;
            } else {
                vm.presupuesto.numeroPC = "?";
            }

        }



        //***************************************************************
        function getPresupuesto(pPresupuestoKey) {

            var fbUrl = firebaseDataService.presupuestos.child(pPresupuestoKey);
            var result = $firebaseObject(fbUrl);

            result.$loaded()
                .then(function(data) {

                    utilsService.writeConsole("[MenuDialogEstadoController] => getPresupuesto(pPresupuestoKey) => EJECUCIÓN OK DE CONSULTA TABLA presupuestos con $id = " + data.$id, WRITE_IN_CONSOLE);
                    vm.presupuestoKey = data.$id;

                    vm.presupuesto = data;

                    //vm.fechaConFormato = new Date(vm.presupuesto.fechaTimestamp);
                })

                .catch(function(error) {
                    vm.presupuesto = null;
                    utilsService.writeConsole("[MenuDialogEstadoController] => getPresupuesto(pPresupuestoKey) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        //***************************************************************
        function getUsuarioPresupuestos(pPresupuestoKey) {

            var fbUrl = firebaseDataService.usuario_presupuestos;
            var result = $firebaseArray(fbUrl.orderByChild("presupuesto_key").equalTo(pPresupuestoKey));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    utilsService.writeConsole("[MenuDialogEstadoController] => getUsuarioPresupuestos(pPresupuestoKey) => EJECUCIÓN OK DE CONSULTA TABLA 'usuario_presupuestos' con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        vm.usuarioPresupuestos = data;
                    } else {
                        vm.usuarioPresupuestos = null;
                    }
                })

                .catch(function(error) {
                    vm.usuarioPresupuestos = null;
                    utilsService.writeConsole("[MenuDialogEstadoController] => getUsuarioPresupuestos(pPresupuestoKey) => ERROR: " + error, WRITE_IN_CONSOLE);
                }
            );
        }



        //***************************************************************
        function updatePresupuestoMismoNumeroPD(pNumeroPD,pNumeroPC) {

            var presupuestos = {};

            var fbUrl = firebaseDataService.presupuestos;
            var result = $firebaseArray(fbUrl.orderByChild("numeroPD").equalTo(pNumeroPD));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;
                    
                    utilsService.writeConsole("[MenuDialogEstadoController] => updatePresupuestoMismoNumeroPD(pNumeroPD,pNumeroPC) => EJECUCIÓN OK DE CONSULTA TABLA 'presupuestos' con $id = " + data.$id, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        presupuestos = data;

                        for (var i=0;i<dataLength;i++) {

                            presupuestos[i].numeroPC = pNumeroPC;

                            //Guardamos el registro con el nuevo numeroPC
                            presupuestos.$save(presupuestos[i])
                                .then(function(ref) {
                                    utilsService.writeConsole("[MenuDialogEstadoController] => updatePresupuestoMismoNumeroPD() => save() in 'presupuestos' table =>  Saved record to 'presupuestos'", WRITE_IN_CONSOLE);
                                })

                                .catch(function(error) {
                                    utilsService.writeConsole("[MenuDialogEstadoController] => updatePresupuestoMismoNumeroPD() => save() => ERROR: " + error, WRITE_IN_CONSOLE); 
                                }
                            );
                        }

                    } 

                })

                .catch(function(error) {

                    presupuestos = null;
                    utilsService.writeConsole("[MenuDialogEstadoController] => updatePresupuestoMismoNumeroPD(pNumeroPD,pNumeroPC) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        //***************************************************************
        function updateUsuarioPresupuestosMismoNumeroPD(pNumeroPD,pNumeroPC) {

            var usuarioPresupuestos = {};

            var fbUrl = firebaseDataService.usuario_presupuestos;
            var result = $firebaseArray(fbUrl.orderByChild("numeroPD").equalTo(pNumeroPD));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;
                    
                    utilsService.writeConsole("[MenuDialogEstadoController] => updateUsuarioPresupuestosMismoNumeroPD(pNumeroPD,pNumeroPC) => EJECUCIÓN OK DE CONSULTA TABLA 'usuarioPresupuestos' con $id = " + data.$id, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        usuarioPresupuestos = data;

                        for (var i=0;i<dataLength;i++) {

                            usuarioPresupuestos[i].numeroPC = pNumeroPC;

                            //Guardamos el registro con el nuevo numeroPC
                            usuarioPresupuestos.$save(usuarioPresupuestos[i])
                                .then(function(ref) {
                                    utilsService.writeConsole("[MenuDialogEstadoController] => updateUsuarioPresupuestosMismoNumeroPD() => save() in 'usuarioPresupuestos' table =>  Saved record to 'presupuestos'", WRITE_IN_CONSOLE);
                                })

                                .catch(function(error) {
                                    utilsService.writeConsole("[MenuDialogEstadoController] => updateUsuarioPresupuestosMismoNumeroPD() => save() => ERROR: " + error, WRITE_IN_CONSOLE); 
                                }
                            );
                        }

                    } 

                })

                .catch(function(error) {
                    
                    usuarioPresupuestos = null;
                    utilsService.writeConsole("[MenuDialogEstadoController] => updateUsuarioPresupuestosMismoNumeroPD(pNumeroPD,pNumeroPC) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );

        }



        //***************************************************************
        function save() {

            //utilsService.writeConsole("vm.fechaConFormato = " + vm.fechaConFormato, WRITE_IN_CONSOLE);
            //vm.presupuesto.fechaTimestamp = vm.fechaConFormato.getTime();
            //utilsService.writeConsole("vm.presupuesto.fechaTimestamp = " + vm.presupuesto.fechaTimestamp, WRITE_IN_CONSOLE);

            if (vm.presupuesto.estado == null) {
                vm.presupuesto.estado = "?";
            }


            //We update budget's data
            vm.presupuesto.$save()
                .then(function(ref) {
                    utilsService.writeConsole("[MenuDialogEstadoController] - save() => Presupuesto saved with ID = " + ref.key, WRITE_IN_CONSOLE);

                    //We save the record in "usuario_presupuestos" table
                    vm.savePresupuestoToUsuarioPresupuestosTable();
                })

                .catch(function(error) {
                    utilsService.writeConsole("[MenuDialogEstadoController] => save() => ERROR: " + error, WRITE_IN_CONSOLE); 
            });                

        }



        //***************************************************************
        function savePresupuestoToUsuarioPresupuestosTable() {

            var recordToUpdate = vm.usuarioPresupuestos[0];

            //Asignamos los valores actuales

            /*
            recordToUpdate.codigoPresupuesto =  vm.presupuesto.codigo;
            recordToUpdate.fechaTimestamp = vm.presupuesto.fechaTimestamp;
            recordToUpdate.cliente = vm.presupuesto.cliente;
            recordToUpdate.tipo = vm.presupuesto.tipo;
            recordToUpdate.unidades = vm.presupuesto.unidades;
            recordToUpdate.importe = vm.presupuesto.importe;
            recordToUpdate.usuario = vm.presupuesto.usuario;
            */
            recordToUpdate.numeroPD = vm.presupuesto.numeroPD;
            recordToUpdate.numeroPC = vm.presupuesto.numeroPC;
            recordToUpdate.estado = vm.presupuesto.estado;

            //Guardamos el registro con los nuevos datos
            vm.usuarioPresupuestos.$save(recordToUpdate)
                .then(function(ref) {
                    utilsService.writeConsole("[MenuDialogEstadoController] => savePresupuestoToUsuarioPresupuestosTable() =>  Saved record to 'usuario_presupuestos'", WRITE_IN_CONSOLE);

                    //Actualizamos el valor de numeroPC en las tablas 'presupuestos' y 'usuarios_presupuestos' que tengan el mismo numeroPD
//                    vm.updatePresupuestoMismoNumeroPD(vm.presupuesto.numeroPD,vm.presupuesto.numeroPC);
//                    vm.updateUsuarioPresupuestosMismoNumeroPD(vm.presupuesto.numeroPD,vm.presupuesto.numeroPC);

                    $mdDialog.hide();
                })

                .catch(function(error) {
                    utilsService.writeConsole("[MenuDialogEstadoController] => savePresupuestoToUsuarioPresupuestosTable() => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );                        
        }



        //***************************************************************
        function showAlertDialog(pText) {
            // Appending dialog to document.body to cover sidenav in docs app
            var alert = $mdDialog.alert()
                .title("Información")
                .textContent(pText)
                //.ariaLabel("")
                //.targetEvent(ev)
                .ok("Cerrar")
                //.cancel("No");

            $mdDialog.show(alert)
                .finally(function() {
                    //utilsService.writeConsole("WE REDIRECT TO 'SELECT-ITB' PAGE", WRITE_IN_CONSOLE);
                    //$location.path("/workflow-admin/select-itb");
                }); 
        }


        //***************************************************************
        function closeDialog() 
        {
            $mdDialog.hide();
            //$state.go('app.menu_presupuestos');
        }



 







    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.todo',
            [
                // 3rd Party Dependencies
                'ng-sortable',
                'textAngular'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.to-do', {
            url      : '/to-do',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/todo/todo.html',
                    controller : 'TodoController as vm'
                }
            },
            resolve  : {
                Tasks: function (msApi)
                {
                    return msApi.resolve('todo.tasks@get');
                },
                Tags : function (msApi)
                {
                    return msApi.resolve('todo.tags@get');
                }
            },
            bodyClass: 'todo'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/todo');

        // Api
        msApiProvider.register('todo.tasks', ['app/data/todo/tasks.json']);
        msApiProvider.register('todo.tags', ['app/data/todo/tags.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.to-do', {
            title : 'To-Do',
            icon  : 'icon-checkbox-marked',
            state : 'app.to-do',
            badge : {
                content: 3,
                color  : '#FF6F00'
            },
            weight: 9
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.todo')
        .controller('TaskDialogController', TaskDialogController);

    /** @ngInject */
    function TaskDialogController($mdDialog, Task, Tasks, event)
    {
        var vm = this;

        // Data
        vm.title = 'Edit Task';
        vm.task = angular.copy(Task);
        vm.tasks = Tasks;
        vm.newTask = false;

        if ( !vm.task )
        {
            vm.task = {
                'id'                : '',
                'title'             : '',
                'notes'             : '',
                'startDate'         : new Date(),
                'startDateTimeStamp': new Date().getTime(),
                'dueDate'           : '',
                'dueDateTimeStamp'  : '',
                'completed'         : false,
                'starred'           : false,
                'important'         : false,
                'deleted'           : false,
                'tags'              : []
            };
            vm.title = 'New Task';
            vm.newTask = true;
            vm.task.tags = [];
        }

        // Methods
        vm.addNewTask = addNewTask;
        vm.saveTask = saveTask;
        vm.deleteTask = deleteTask;
        vm.newTag = newTag;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Add new task
         */
        function addNewTask()
        {
            vm.tasks.unshift(vm.task);

            closeDialog();
        }

        /**
         * Save task
         */
        function saveTask()
        {
            // Dummy save action
            for ( var i = 0; i < vm.tasks.length; i++ )
            {
                if ( vm.tasks[i].id === vm.task.id )
                {
                    vm.tasks[i] = angular.copy(vm.task);
                    break;
                }
            }

            closeDialog();
        }

        /**
         * Delete task
         */
        function deleteTask()
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure?')
                .content('The Task will be deleted.')
                .ariaLabel('Delete Task')
                .ok('Delete')
                .cancel('Cancel')
                .targetEvent(event);

            $mdDialog.show(confirm).then(function ()
            {
                // Dummy delete action
                for ( var i = 0; i < vm.tasks.length; i++ )
                {
                    if ( vm.tasks[i].id === vm.task.id )
                    {
                        vm.tasks[i].deleted = true;
                        break;
                    }
                }
            }, function ()
            {
                // Cancel Action
            });
        }


        /**
         * New tag
         *
         * @param chip
         * @returns {{label: *, color: string}}
         */
        function newTag(chip)
        {
            var tagColors = ['#388E3C', '#F44336', '#FF9800', '#0091EA', '#9C27B0'];

            return {
                name : chip,
                label: chip,
                color: tagColors[Math.floor(Math.random() * (tagColors.length))]
            };
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('BoardViewController', BoardViewController);

    /** @ngInject */
    function BoardViewController($document, $window, $timeout, $mdDialog, msUtils, BoardList, BoardService, CardFilters, DialogService)
    {
        var vm = this;

        // Data
        vm.currentView = 'board';
        vm.board = BoardService.data;
        vm.boardList = BoardList.data;
        vm.cardFilters = CardFilters;
        vm.card = {};
        vm.cardOptions = {};
        vm.newListName = '';
        vm.sortableListOptions = {
            axis       : 'x',
            delay      : 75,
            distance   : 7,
            items      : '> .list-wrapper',
            handle     : '.list-header',
            placeholder: 'list-wrapper list-sortable-placeholder',
            tolerance  : 'pointer',
            start      : function (event, ui)
            {
                var width = ui.item[0].children[0].clientWidth;
                var height = ui.item[0].children[0].clientHeight;
                ui.placeholder.css({
                    'min-width': width + 'px',
                    'width'    : width + 'px',
                    'height'   : height + 'px'
                });
            }
        };
        vm.sortableCardOptions = {
            appendTo            : 'body',
            connectWith         : '.list-cards',
            delay               : 75,
            distance            : 7,
            forceHelperSize     : true,
            forcePlaceholderSize: true,
            handle              : msUtils.isMobile() ? '.list-card-sort-handle' : false,
            helper              : function (event, el)
            {
                return el.clone().addClass('list-card-sort-helper');
            },
            placeholder         : 'list-card card-sortable-placeholder',
            tolerance           : 'pointer',
            scroll              : true,
            sort                : function (event, ui)
            {
                var listContentEl = ui.placeholder.closest('.list-content');
                var boardContentEl = ui.placeholder.closest('#board');

                if ( listContentEl )
                {
                    var listContentElHeight = listContentEl[0].clientHeight,
                        listContentElScrollHeight = listContentEl[0].scrollHeight;

                    if ( listContentElHeight !== listContentElScrollHeight )
                    {
                        var itemTop = ui.position.top,
                            itemBottom = itemTop + ui.item.height(),
                            listTop = listContentEl.offset().top,
                            listBottom = listTop + listContentElHeight;

                        if ( itemTop < listTop + 25 )
                        {
                            listContentEl.scrollTop(listContentEl.scrollTop() - 25);
                        }

                        if ( itemBottom > listBottom - 25 )
                        {
                            listContentEl.scrollTop(listContentEl.scrollTop() + 25);
                        }
                    }
                }

                if ( boardContentEl )
                {
                    var boardContentElWidth = boardContentEl[0].clientWidth;
                    var boardContentElScrollWidth = boardContentEl[0].scrollWidth;

                    if ( boardContentElWidth !== boardContentElScrollWidth )
                    {
                        var itemLeft = ui.position.left,
                            itemRight = itemLeft + ui.item.width(),
                            boardLeft = boardContentEl.offset().left,
                            boardRight = boardLeft + boardContentElWidth;

                        if ( itemLeft < boardLeft + 25 )
                        {
                            boardContentEl.scrollLeft(boardContentEl.scrollLeft() - 25);
                        }

                        if ( itemRight > boardRight )
                        {
                            boardContentEl.scrollLeft(boardContentEl.scrollLeft() + 25);
                        }
                    }
                }
            }
        };

        // Methods
        vm.openCardDialog = DialogService.openCardDialog;
        vm.addNewList = addNewList;
        vm.removeList = removeList;
        vm.cardFilter = cardFilter;
        vm.isOverdue = isOverdue;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {

            $timeout(function ()
            {
                // IE list-content max-height hack
                if ( angular.element('html').hasClass('explorer') )
                {
                    // Calculate the height for the first time
                    calculateListContentHeight();

                    // Attach calculateListContentHeight function to window resize
                    $window.onresize = function ()
                    {
                        calculateListContentHeight();
                    };
                }
            }, 0);

        }

        /**
         * IE ONLY
         * Calculate the list-content height
         * IE ONLY
         */
        function calculateListContentHeight()
        {
            var boardEl = angular.element('#board');
            var boardElHeight = boardEl.height();

            boardEl.find('.list-wrapper').each(function (index, el)
            {
                // Get the required heights for calculations
                var listWrapperEl = angular.element(el),
                    listHeaderElHeight = listWrapperEl.find('.list-header').height(),
                    listFooterElHeight = listWrapperEl.find('.list-footer').height();

                // Calculate the max height
                var maxHeight = boardElHeight - listHeaderElHeight - listFooterElHeight;

                // Add the max height
                listWrapperEl.find('.list-content').css({'max-height': maxHeight});
            });
        }

        /**
         * Add new list
         */
        function addNewList()
        {
            if ( vm.newListName === '' )
            {
                return;
            }

            vm.board.lists.push({
                id     : msUtils.guidGenerator(),
                name   : vm.newListName,
                idCards: []
            });

            vm.newListName = '';
        }

        /**
         * Remove list
         *
         * @param ev
         * @param list
         */
        function removeList(ev, list)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove List',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove list?',
                ariaLabel          : 'remove list',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });
            $mdDialog.show(confirm).then(function ()
            {
                vm.board.lists.splice(vm.board.lists.indexOf(list), 1);
            }, function ()
            {
                // Canceled
            });

        }

        /**
         * Card filter
         *
         * @param cardId
         * @returns {*}
         */
        function cardFilter(cardId)
        {
            var card = vm.board.cards.getById(cardId);

            try
            {
                if ( angular.lowercase(card.name).indexOf(angular.lowercase(vm.cardFilters.name)) < 0 )
                {
                    throw false;
                }

                angular.forEach(vm.cardFilters.labels, function (label)
                {
                    if ( !msUtils.exists(label, card.idLabels) )
                    {
                        throw false;
                    }
                });

                angular.forEach(vm.cardFilters.members, function (member)
                {
                    if ( !msUtils.exists(member, card.idMembers) )
                    {
                        throw false;
                    }
                });


            } catch ( err )
            {
                return err;
            }

            return true;
        }

        /**
         * Is the card overdue?
         *
         * @param cardDate
         * @returns {boolean}
         */
        function isOverdue(cardDate)
        {
            return moment() > moment(cardDate, 'x');
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('CalendarViewController', CalendarViewController);

    /** @ngInject */
    function CalendarViewController($scope, $document, $mdDialog, $mdSidenav, BoardService, DialogService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.eventSources = [];

        vm.calendarUiConfig = {
            calendar: {
                editable                 : true,
                eventLimit               : true,
                header                   : '',
                handleWindowResize       : false,
                aspectRatio              : 1,
                dayNames                 : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort            : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                timezone                 : 'local',
                eventDurationEditable    : false,
                defaultTimedEventDuration: '01:00:00',
                viewRender               : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                },
                columnFormat             : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd D'
                },
                eventClick               : function eventDetail(calendarEvent, ev)
                {
                    vm.openCardDialog(ev, calendarEvent.idCard);
                },
                eventDrop                : function (event)
                {
                    vm.board.cards.getById(event.idCard).due = moment.utc(event.start).format('x');
                },
                selectable               : true,
                selectHelper             : true,
                dayClick                 : function (date, ev)
                {
                    var offset = moment().utcOffset();
                    var corrDate = '';

                    if ( offset < 0 )
                    {
                        corrDate = moment.utc(date).subtract(offset, 'm').format('x');
                    }
                    else
                    {
                        corrDate = moment.utc(date).add(offset, 'm').format('x');
                    }

                    eventDialog(corrDate, ev);
                }
            }
        };

        // Methods
        vm.next = next;
        vm.prev = prev;
        vm.goToDate = goToDate;
        vm.openCardDialog = DialogService.openCardDialog;
        vm.toggleSidenav = toggleSidenav;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            vm.cards = getScheduledCards();
            vm.eventSources[0] = vm.cards;
        }

        /**
         * Get scheduled cards and prepare
         * them to show on the calendar
         *
         * @returns {Array}
         */
        function getScheduledCards()
        {
            var cards = [];

            angular.forEach(vm.board.cards, function (card)
            {
                if ( card.due )
                {
                    cards.push({
                        idCard         : card.id,
                        title          : card.name,
                        start          : moment.utc(card.due, 'x'),
                        due            : card.due,
                        backgroundColor: getEventBgColor(card.due)
                    });
                }
            });

            return cards;
        }

        /**
         * Get background color
         *
         * @param cardDue
         * @returns {*}
         */
        function getEventBgColor(cardDue)
        {
            if ( moment() > moment(cardDue, 'x') )
            {
                return '#F44336';
            }

            return '#4CAF50';
        }

        /**
         * Watch board changes
         */
        $scope.$watch('vm.board', function (current, old)
        {
            if ( angular.equals(current, old) )
            {
                return;
            }

            init();

        }, true);

        /**
         * Go to Date
         *
         * @param date
         */
        function goToDate(date)
        {
            vm.calendarView.calendar.gotoDate(date);
            $mdSidenav('scheduled-tasks-sidenav').close();
        }

        /**
         * Go to next on current view (week, month etc.)
         */
        function next()
        {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev()
        {
            vm.calendarView.calendar.prev();
        }

        /**
         * Event Dialog
         */
        function eventDialog(date, ev)
        {
            $mdDialog.show({
                templateUrl        : 'app/main/apps/scrumboard/views/calendar/dialogs/event/event-dialog.html',
                controller         : 'ScrumboardCalendarEventDialogController',
                controllerAs       : 'vm',
                parent             : $document.find('#scrumboard'),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    dueDate: date
                }
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('BoardsViewController', BoardsViewController);

    /** @ngInject */
    function BoardsViewController(BoardList)
    {
        var vm = this;

        // Data
        vm.boardList = BoardList.data;

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('SettingsSidenavController', SettingsSidenavController);

    /** @ngInject */
    function SettingsSidenavController($mdColorPalette, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.palettes = $mdColorPalette;
        vm.selectedMenu = 'Settings';

        // Methods

        ////////

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('FiltersSidenavController', FiltersSidenavController);

    /** @ngInject */
    function FiltersSidenavController(msUtils, BoardService, CardFilters)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.cardFilters = CardFilters;
        vm.labels = vm.board.labels;
        vm.members = vm.board.members;
        vm.selectedMenu = 'Settings';

        // Methods
        vm.exists = msUtils.exists;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.clearFilters = CardFilters.clear;
        vm.filteringIsOn = CardFilters.isOn;

        ////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ScrumboardCardDialogController', ScrumboardCardDialogController);

    /** @ngInject */
    function ScrumboardCardDialogController($document, $mdDialog, fuseTheming, fuseGenerator, msUtils, BoardService, cardId)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.card = vm.board.cards.getById(cardId);
        vm.newLabelColor = 'red';
        vm.members = vm.board.members;
        vm.labels = vm.board.labels;

        // Methods
        vm.palettes = fuseTheming.getRegisteredPalettes();
        vm.rgba = fuseGenerator.rgba;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.closeDialog = closeDialog;
        vm.getCardList = getCardList;
        vm.removeCard = removeCard;
        /* Attachment */
        vm.toggleCoverImage = toggleCoverImage;
        vm.removeAttachment = removeAttachment;
        /* Labels */
        vm.labelQuerySearch = labelQuerySearch;
        vm.filterLabel = filterLabel;
        vm.addNewLabel = addNewLabel;
        vm.removeLabel = removeLabel;
        /* Members */
        vm.memberQuerySearch = memberQuerySearch;
        vm.filterMember = filterMember;
        /* Checklist */
        vm.updateCheckedCount = updateCheckedCount;
        vm.addCheckItem = addCheckItem;
        vm.removeChecklist = removeChecklist;
        vm.removeChecklistItem = removeChecklistItem;
        vm.createCheckList = createCheckList;
        /* Comment */
        vm.addNewComment = addNewComment;

        //////////

        /**
         * Close Dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Get Card List
         */
        function getCardList()
        {
            var response;
            for ( var i = 0, len = vm.board.lists.length; i < len; i++ )
            {
                if ( vm.board.lists[i].idCards.indexOf(vm.card.id) > -1 )
                {
                    response = vm.board.lists[i];
                    break;
                }
            }
            return response;
        }

        /**
         * Remove card
         *
         * @param ev
         */
        function removeCard(ev)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove Card',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove card?',
                ariaLabel          : 'remove card',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });

            $mdDialog.show(confirm).then(function ()
            {
                var cardList = getCardList();

                cardList.idCards.splice(cardList.idCards.indexOf(vm.card.id), 1);

                vm.board.cards.splice(vm.board.cards.indexOf(vm.card), 1);

            }, function ()
            {
                // Canceled
            });
        }

        /**
         * Toggle cover image
         *
         * @param attachmentId
         */
        function toggleCoverImage(attachmentId)
        {
            if ( attachmentId === vm.card.idAttachmentCover )
            {
                vm.card.idAttachmentCover = null;
            }
            else
            {
                vm.card.idAttachmentCover = attachmentId;
            }
        }

        /**
         * Remove attachment
         *
         * @param item
         */
        function removeAttachment(item)
        {
            if ( vm.card.idAttachmentCover === item.id )
            {
                vm.card.idAttachmentCover = '';
            }
            vm.card.attachments.splice(vm.card.attachments.indexOf(item), 1);
        }

        /**
         * Add label chips
         *
         * @param query
         * @returns {filterFn}
         */
        function labelQuerySearch(query)
        {
            return query ? vm.labels.filter(createFilterFor(query)) : [];
        }

        /**
         * Label filter
         *
         * @param label
         * @returns {boolean}
         */
        function filterLabel(label)
        {
            if ( !vm.labelSearchText || vm.labelSearchText === '' )
            {
                return true;
            }

            return angular.lowercase(label.name).indexOf(angular.lowercase(vm.labelSearchText)) >= 0;
        }

        /**
         * Add new label
         */
        function addNewLabel()
        {
            vm.board.labels.push({
                id   : msUtils.guidGenerator(),
                name : vm.newLabelName,
                color: vm.newLabelColor
            });

            vm.newLabelName = '';
        }

        /**
         * Remove label
         */
        function removeLabel()
        {
            var arr = vm.board.labels;
            arr.splice(arr.indexOf(arr.getById(vm.editLabelId)), 1);

            angular.forEach(vm.board.cards, function (card)
            {
                if ( card.idLabels && card.idLabels.indexOf(vm.editLabelId) > -1 )
                {
                    card.idLabels.splice(card.idLabels.indexOf(vm.editLabelId), 1);
                }
            });

            vm.newLabelName = '';
        }

        /**
         * Add member chips
         *
         * @param query
         * @returns {Array}
         */
        function memberQuerySearch(query)
        {
            return query ? vm.members.filter(createFilterFor(query)) : [];
        }

        /**
         * Member filter
         *
         * @param member
         * @returns {boolean}
         */
        function filterMember(member)
        {
            if ( !vm.memberSearchText || vm.memberSearchText === '' )
            {
                return true;
            }

            return angular.lowercase(member.name).indexOf(angular.lowercase(vm.memberSearchText)) >= 0;
        }

        /**
         * Update check list stats
         * @param list
         */
        function updateCheckedCount(list)
        {
            var checkItems = list.checkItems;
            var checkedItems = 0;
            var allCheckedItems = 0;
            var allCheckItems = 0;

            angular.forEach(checkItems, function (checkItem)
            {
                if ( checkItem.checked )
                {
                    checkedItems++;
                }
            });

            list.checkItemsChecked = checkedItems;

            angular.forEach(vm.card.checklists, function (item)
            {
                allCheckItems += item.checkItems.length;
                allCheckedItems += item.checkItemsChecked;
            });

            vm.card.checkItems = allCheckItems;
            vm.card.checkItemsChecked = allCheckedItems;
        }

        /**
         * Add checklist item
         *
         * @param text
         * @param checkList
         */
        function addCheckItem(text, checkList)
        {
            if ( !text || text === '' )
            {
                return;
            }

            var newCheckItem = {
                'name'   : text,
                'checked': false
            };

            checkList.checkItems.push(newCheckItem);

            updateCheckedCount(checkList);
        }

        /**
         * Remove checklist
         *
         * @param item
         */
        function removeChecklist(item)
        {
            vm.card.checklists.splice(vm.card.checklists.indexOf(item), 1);

            angular.forEach(vm.card.checklists, function (list)
            {
                updateCheckedCount(list);
            });
        }

        /**
         * Remove checklist Item
         *
         * @param item
         */
        function removeChecklistItem(item, list)
        {
            list.splice(list.indexOf(item), 1);

            angular.forEach(vm.card.checklists, function (list)
            {
                updateCheckedCount(list);
            });
        }

        /**
         * Create checklist
         */
        function createCheckList()
        {
            vm.card.checklists.push({
                id               : msUtils.guidGenerator(),
                name             : vm.newCheckListTitle,
                checkItemsChecked: 0,
                checkItems       : []
            });

            vm.newCheckListTitle = '';
        }

        /**
         * Add new comment
         *
         * @param newCommentText
         */
        function addNewComment(newCommentText)
        {
            var newComment = {
                idMember: '36027j1930450d8bf7b10158',
                message : newCommentText,
                time    : 'now'
            };

            vm.card.comments.unshift(newComment);
        }

        /**
         * Filter for chips
         *
         * @param query
         * @returns {filterFn}
         */
        function createFilterFor(query)
        {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(item)
            {
                return angular.lowercase(item.name).indexOf(lowercaseQuery) >= 0;
            };
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('msSbAddCardController', msSbAddCardController)
        .directive('msSbAddCard', msSbAddCardDirective);

    /** @ngInject */
    function msSbAddCardController($scope, $timeout, BoardService, msUtils)
    {
        var vm = this;

        vm.newCardName = '';
        vm.listId = $scope.msListId;
        vm.board = BoardService.data;
        vm.cards = vm.board.cards;
        vm.list = vm.board.lists.getById(vm.listId);

        // Methods
        vm.addNewCard = addNewCard;

        /////

        /**
         * Add New Card
         */
        function addNewCard()
        {
            if ( vm.newCardName === '' )
            {
                return;
            }

            var newCardId = msUtils.guidGenerator();

            vm.cards.push({
                id               : newCardId,
                name             : vm.newCardName,
                description      : '',
                idAttachmentCover: '',
                idMembers        : [],
                idLabels         : [],
                attachments      : [],
                subscribed       : false,
                checklists       : [],
                checkItems       : 0,
                checkItemsChecked: 0,
                comments         : [],
                activities       : [],
                due              : null
            });

            vm.list.idCards.push(newCardId);

            $timeout(function ()
            {
                $scope.scrollListContentBottom();
            });

            vm.newCardName = '';
        }
    }

    /** @ngInject */
    function msSbAddCardDirective($document, $window, $timeout)
    {
        return {
            restrict   : 'E',
            controller : 'msSbAddCardController as vm',
            templateUrl: 'app/main/apps/scrumboard/directives/ms-sb-add-card/ms-sb-add-card.html',
            scope      : {
                msListId: '='
            },
            link       : function (scope, iElement)
            {
                scope.formActive = false;
                scope.toggleForm = toggleForm;
                scope.scrollListContentBottom = scrollListContentBottom;

                var buttonEl = iElement.find('.ms-sb-add-card-button'),
                    formEl = iElement.find('.ms-sb-add-card-form'),
                    listCards = iElement.parent().prev().find('.list-cards');

                /**
                 * Click Event
                 */
                buttonEl.on('click', toggleForm);

                /**
                 * Toggle Form
                 */
                function toggleForm()
                {
                    scope.$evalAsync(function ()
                    {
                        scope.formActive = !scope.formActive;

                        if ( scope.formActive )
                        {
                            $timeout(function ()
                            {
                                formEl.find('input').focus();

                                scrollListContentBottom();
                            });

                            $document.on('click', outSideClick);
                        }
                        else
                        {
                            PerfectScrollbar.update(listCards[0]);
                            $document.off('click', outSideClick);
                        }

                        $timeout(function ()
                        {
                            // IE list-content max-height hack
                            if ( angular.element('html').hasClass('explorer') )
                            {
                                angular.element($window).trigger('resize');
                            }
                        });

                    });
                }

                /**
                 * Scroll List to the Bottom
                 */
                function scrollListContentBottom()
                {
                    listCards[0].scrollTop = listCards[0].scrollHeight;
                }

                /**
                 * Click Outside Event Handler
                 * @param event
                 */
                var outSideClick = function (event)
                {
                    var isChild = formEl.has(event.target).length > 0;
                    var isSelf = formEl[0] === event.target;
                    var isInside = isChild || isSelf;

                    if ( !isInside )
                    {
                        toggleForm();
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notes', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        $stateProvider.state('app.notes', {
            url    : '/notes',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/notes/notes.html',
                    controller : 'NotesController as vm'
                }
            },
            resolve: {
                Notes : function (NotesService)
                {
                    return NotesService.getData();
                },
                Labels: function (LabelsService)
                {
                    return LabelsService.getData();
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/notes');

        // Api
        msApiProvider.register('notes.notes', ['app/data/notes/notes.json']);
        msApiProvider.register('notes.labels', ['app/data/notes/labels.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.notes', {
            title : 'Notes',
            icon  : 'icon-lightbulb',
            state : 'app.notes',
            weight: 11
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('msNoteItemController', msNoteItemController)
        .directive('msNoteItem', msNoteItemDirective);

    /** @ngInject */
    function msNoteItemController($document)
    {
        var vm = this;
        var fontSizes = {
            '1': {
                fontSize  : 14,
                lineHeight: 19
            },
            '2': {
                fontSize  : 18,
                lineHeight: 28
            },
            '3': {
                fontSize  : 24,
                lineHeight: 36
            },
            '4': {
                fontSize  : 36,
                lineHeight: 48
            },
            '5': {
                fontSize  : 48,
                lineHeight: 60
            }
        };

        vm.element = [];
        vm.noFontResize = false;

        // Methods
        vm.updateDescriptionFontSize = updateDescriptionFontSize;

        //////

        function updateDescriptionFontSize()
        {
            if ( vm.noFontResize || !vm.note.description || vm.note.description === '' )
            {
                return;
            }

            var fontSize = '';
            var descWidth = Math.floor(vm.columnWidth - 52); // 48px paddings, + 4px tolerance
            var tmp = angular.element('<div style="visibility:hidden; font-size:10px;line-height: 10px;position:absolute;z-index:-1;white-space:pre-wrap;word-wrap: break-word;"></div>');
            tmp.appendTo($document.find('body'));

            fontSize = checkLineCount(sizeFromMaxWordCount());

            angular.element(vm.element).find('md-description').attr('font-size', fontSize);

            tmp.remove();

            function sizeFromMaxWordCount()
            {
                var words = vm.note.description.split(' ');

                var wordLengths = words.map(function (word)
                {
                    return tmp.text(word)[0].clientWidth;
                });

                var maxWordLength = Math.max.apply(Math, wordLengths);

                var maxPx = Math.floor((descWidth * 10) / maxWordLength);

                if ( maxPx < 18 )
                {
                    fontSize = 1;
                }
                else if ( 18 <= maxPx && maxPx < 24 )
                {
                    fontSize = 2;
                }
                else if ( 24 <= maxPx && maxPx < 36 )
                {
                    fontSize = 3;
                }
                else if ( 36 <= maxPx && maxPx < 48 )
                {
                    fontSize = 4;

                }
                else if ( maxPx >= 48 )
                {
                    fontSize = 5;
                }
                return fontSize;
            }

            function checkLineCount(sizeFromMaxWord)
            {
                var size = fontSizes[sizeFromMaxWord];
                var result;

                tmp.text(vm.note.description);
                tmp.width(descWidth);
                tmp.css({
                    'line-height': size.lineHeight + 'px',
                    'font-size'  : size.fontSize + 'px'
                });

                var lineCount = tmp[0].clientHeight / size.lineHeight;

                if ( 4 < lineCount && lineCount < 6 )
                {
                    result = 4;
                }
                else if ( 6 <= lineCount && lineCount < 9 )
                {
                    result = 3;
                }
                else if ( 9 <= lineCount && lineCount < 11 )
                {
                    result = 2;
                }
                else if ( 11 <= lineCount )
                {
                    result = 1;
                }
                else
                {
                    result = sizeFromMaxWord;
                }
                return result;
            }
        }
    }

    /** @ngInject */
    function msNoteItemDirective()
    {
        return {
            restrict        : 'A',
            controller      : 'msNoteItemController as MsNoteItem',
            templateUrl     : 'app/main/apps/notes/directives/ms-note-item/ms-note-item.html',
            require         : ['msNoteItem', '^msMasonry'],
            bindToController: {
                msNoteItem: '='
            },
            link            : function (scope, element, attributes, controllers)
            {

                var MsNoteItem = controllers[0];
                var msMasonry = controllers[1];

                MsNoteItem.element = element;
                MsNoteItem.note = MsNoteItem.msNoteItem;


                if ( angular.isDefined(attributes.noFontResize) )
                {
                    MsNoteItem.noFontResize = true;
                }

                scope.$watch('MsNoteItem.msNoteItem', function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        MsNoteItem.note = newVal;
                    }
                });

                scope.$on('msMasonryItem:startReLayout', function ()
                {
                    if ( MsNoteItem.noFontResize || MsNoteItem.columnWidth === msMasonry.columnWidth )
                    {
                        return;
                    }

                    MsNoteItem.columnWidth = msMasonry.columnWidth;

                    MsNoteItem.updateDescriptionFontSize();
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('msNoteFormController', msNoteFormController)
        .directive('msNoteForm', msNoteFormDirective);

    /** @ngInject */
    function msNoteFormController($scope, NotesService, msUtils, $mdDialog, $timeout, LabelsService)
    {
        var MsNoteForm = this;
        var notes = NotesService.data;

        //Data
        MsNoteForm.type = '';
        MsNoteForm.defaultNote = {
            'id'         : '',
            'title'      : '',
            'description': '',
            'archive'    : false,
            'image'      : '',
            'color'      : '',
            'time'       : new Date(),
            'reminder'   : null,
            'checklist'  : [],
            'labels'     : []
        };
        MsNoteForm.noteId = '';
        MsNoteForm.editNode = {};
        MsNoteForm.newCheckListItem = '';
        MsNoteForm.checkListForm = false;
        MsNoteForm.labels = LabelsService.data;

        MsNoteForm.ngFlowOptions = {
            singleFile: true
            // You can configure the ngFlow from here
            /*target                   : 'api/media/image',
             chunkSize                : 15 * 1024 * 1024,
             maxChunkRetries          : 1,
             simultaneousUploads      : 1,
             testChunks               : false,
             progressCallbacksInterval: 1000*/
        };
        MsNoteForm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };

        //Methods
        MsNoteForm.init = init;
        MsNoteForm.submit = submit;
        MsNoteForm.isNotValid = isNotValid;
        MsNoteForm.deleteNote = deleteNote;
        MsNoteForm.deleteImage = deleteImage;
        MsNoteForm.addChecklistItem = addChecklistItem;
        MsNoteForm.checklistFormToggle = checklistFormToggle;
        MsNoteForm.deleteCheckItem = deleteCheckItem;
        MsNoteForm.toggleArchive = toggleArchive;
        MsNoteForm.toggleInArray = msUtils.toggleInArray;
        MsNoteForm.exists = msUtils.exists;
        MsNoteForm.upload = upload;
        MsNoteForm.imageSuccess = imageSuccess;

        //////

        /**
         * Initialize
         */
        function init()
        {
            // If form type edit
            if ( MsNoteForm.type === 'edit' )
            {
                MsNoteForm.editNode = notes.getById(MsNoteForm.noteId);
                MsNoteForm.note = angular.copy(MsNoteForm.editNode);
            }
            // If form type new
            else
            {
                resetForm();
            }
        }

        /**
         * Watch New Note Form, reset form if it is closed
         */
        $scope.$on('MsNewNote:closed', function ()
        {
            resetForm();
        });

        /**
         * Reset Form
         */
        function resetForm()
        {
            $scope.$evalAsync(function ()
            {
                MsNoteForm.note = angular.copy(MsNoteForm.defaultNote);
                MsNoteForm.checkListForm = false;
            });
        }

        /**
         * Submit Form
         */
        function submit()
        {
            if ( MsNoteForm.type === 'new' )
            {
                add();
            }
            else if ( MsNoteForm.type === 'edit' )
            {
                save();
            }
        }

        /**
         * Add new note
         */
        function add()
        {
            if ( isNotValid() )
            {
                return;
            }

            // Set default values
            MsNoteForm.note.id = msUtils.guidGenerator();
            MsNoteForm.note.time = new Date();

            // Add the note
            NotesService.addNote(angular.copy(MsNoteForm.note));

            // Reset the current note to an empty one
            MsNoteForm.note = angular.copy(MsNoteForm.defaultNote);

            $scope.$emit('MsNewNote:close');
        }

        /**
         * Save Note
         */
        function save()
        {
            if ( isNotValid() )
            {
                return;
            }

            // Update the note
            NotesService.updateNote(MsNoteForm.note);

            // Hide the dialog
            $mdDialog.hide();
        }

        /**
         * Delete Note Image
         */
        function deleteImage()
        {
            MsNoteForm.note.image = '';
        }

        /**
         * Toggle Archive State
         */
        function toggleArchive()
        {
            if ( MsNoteForm.type === 'new' )
            {
                MsNoteForm.note.archive = true;
                submit();
            }
            else if ( MsNoteForm.type === 'edit' )
            {
                MsNoteForm.note.archive = !MsNoteForm.note.archive;
                save();
            }
        }

        /**
         * One of the image, title, description, checklist inputs are should be exist.
         * @returns {boolean}
         */
        function isNotValid()
        {
            return MsNoteForm.note.image === '' && MsNoteForm.note.title === '' && MsNoteForm.note.description === '' && MsNoteForm.note.checklist.length === 0;
        }

        /**
         * Delete Note
         * @param ev
         */
        function deleteNote(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the note?')
                .htmlContent('the note will be deleted permanently.')
                .ariaLabel('delete note')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                NotesService.deleteNote(MsNoteForm.note);
            });
        }

        /**
         * Add Checklist Item
         */
        function addChecklistItem()
        {
            if ( MsNoteForm.newCheckListItem === '' )
            {
                return;
            }

            MsNoteForm.note.checklist.push({
                checked: false,
                text   : MsNoteForm.newCheckListItem
            });

            MsNoteForm.newCheckListItem = '';

            focusChecklistInput();
        }

        /**
         * Checklist form toggle
         */
        function checklistFormToggle()
        {
            $scope.$evalAsync(function ()
            {
                MsNoteForm.checkListForm = !MsNoteForm.checkListForm;

                $timeout(function ()
                {
                    focusChecklistInput();
                });
            });
        }

        /**
         * Delete check item
         * @param item
         */
        function deleteCheckItem(item)
        {
            MsNoteForm.note.checklist.splice(MsNoteForm.note.checklist.indexOf(item), 1);
            focusChecklistInput();
        }

        /**
         * Focus checklist input
         */
        function focusChecklistInput()
        {
            angular.element('#new-checklist-item-input').focus();
        }

        /**
         * Upload
         */
        function upload()
        {
            // Set headers
            MsNoteForm.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            MsNoteForm.ngFlow.flow.upload();
        }

        /**
         * Image Success
         * @param file
         * @param message
         */
        function imageSuccess(file, message)
        {
            var fileReader = new FileReader();

            fileReader.readAsDataURL(file.file);

            fileReader.onload = function (event)
            {
                file.url = event.target.result;

                $scope.$evalAsync(function ()
                {
                    MsNoteForm.note.image = file.url;
                });
            };

            file.type = 'image';
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };

    }

    /** @ngInject */
    function msNoteFormDirective()
    {
        return {
            restrict    : 'EA',
            controller  : 'msNoteFormController',
            controllerAs: 'MsNoteForm',
            scope       : {
                noteType: '=',
                noteId  : '='
            },
            templateUrl : 'app/main/apps/notes/directives/ms-note-form/ms-note-form.html',
            link        : function (scope, element, attributes, MsNoteForm)
            {
                // Type
                MsNoteForm.type = scope.noteType;

                // Note id
                if ( angular.isDefined(scope.noteId) )
                {
                    MsNoteForm.noteId = scope.noteId;
                }

                MsNoteForm.init();

            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('msNewNoteController', msNewNoteController)
        .directive('msNewNoteButton', msNewNoteButtonDirective)
        .directive('msNewNote', msNewNoteDirective);

    /** @ngInject */
    function msNewNoteController($scope, $document)
    {
        var MsNewNote = this;

        //Data
        MsNewNote.formVisible = false;
        MsNewNote.form = {
            title      : '',
            description: ''
        };

        //Methods
        MsNewNote.open = open;
        MsNewNote.close = close;
        MsNewNote.element = [];

        //////

        /**
         * Close Trigger
         */
        $scope.$on('MsNewNote:close', function ()
        {
            close();
        });

        /**
         * Open new note form
         */
        function open()
        {
            MsNewNote.element.addClass('form-visible');
            MsNewNote.element.find('textarea').focus();
            $document.on('click', outSideClick);
        }

        /**
         * Close new note form
         */
        function close()
        {
            MsNewNote.element.removeClass('form-visible');
            $scope.$broadcast('MsNewNote:closed');

            $document.off('click', outSideClick);
        }

        /**
         * Click Outside Event Handler
         * @param event
         */
        function outSideClick(event)
        {
            var isChild = MsNewNote.element.has(event.target).length > 0;
            var isSelf = MsNewNote.element[0] === event.target;
            var isMenu = angular.element(event.target).closest('md-menu-content').length > 0;
            var isCalendar = angular.element(event.target).closest('md-calendar').length > 0 || angular.element(event.target).closest('.md-datepicker-calendar-pane').length > 0 || angular.element(event.target).hasClass('md-scroll-mask');

            var isInside = isChild || isSelf || isMenu || isCalendar;

            if ( !isInside )
            {
                close();
            }
        }
    }

    /** @ngInject */
    function msNewNoteDirective()
    {
        return {
            restrict    : 'E',
            controller  : 'msNewNoteController',
            controllerAs: 'MsNewNote',
            templateUrl : 'app/main/apps/notes/directives/ms-new-note/ms-new-note.html',
            link        : function (scope, element, attributes, MsNewNote)
            {
                MsNewNote.element = element;
            }
        };
    }

    /** @ngInject */
    function msNewNoteButtonDirective()
    {
        return {
            restrict: 'EA',
            require : '^msNewNote',
            link    : function (scope, element, attributes, msNewNote)
            {
                element.on('click', function ()
                {
                    msNewNote.open();
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.mail',
            [
                // 3rd Party Dependencies
                'textAngular'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.mail', {
                abstract: true,
                url     : '/mail',
                resolve : {
                    Folders: function (msApi)
                    {
                        return msApi.resolve('mail.folders@get');
                    },
                    Labels : function (msApi)
                    {
                        return msApi.resolve('mail.labels@get');
                    }
                }
            })
            .state('app.mail.threads', {
                url      : '/{type:(?:label)}/:filter',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/mail/mail.html',
                        controller : 'MailController as vm'
                    }
                },
                params   : {
                    type: {
                        value : null,
                        squash: true
                    }
                },
                bodyClass: 'mail'
            })
            .state('app.mail.threads.thread', {
                url      : '/:threadId',
                bodyClass: 'mail'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/mail');

        // Api
        msApiProvider.register('mail.folders', ['app/data/mail/folders.json']);
        msApiProvider.register('mail.labels', ['app/data/mail/labels.json']);

        msApiProvider.register('mail.label.notes', ['app/data/mail/labels/notes.json']);
        msApiProvider.register('mail.label.paypal', ['app/data/mail/labels/paypal.json']);
        msApiProvider.register('mail.label.invoices', ['app/data/mail/labels/invoices.json']);
        msApiProvider.register('mail.label.amazon', ['app/data/mail/labels/amazon.json']);

        msApiProvider.register('mail.folder.inbox', ['app/data/mail/folders/inbox.json']);
        msApiProvider.register('mail.folder.sent', ['app/data/mail/folders/sent.json']);
        msApiProvider.register('mail.folder.drafts', ['app/data/mail/folders/drafts.json']);
        msApiProvider.register('mail.folder.spam', ['app/data/mail/folders/spam.json']);
        msApiProvider.register('mail.folder.trash', ['app/data/mail/folders/trash.json']);
        msApiProvider.register('mail.folder.starred', ['app/data/mail/folders/starred.json']);
        msApiProvider.register('mail.folder.important', ['app/data/mail/folders/important.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.mail', {
            title      : 'Mail',
            icon       : 'icon-email',
            state      : 'app.mail.threads',
            stateParams: {
                filter: 'inbox'
            },
            badge      : {
                content: 25,
                color  : '#F44336'
            },
            weight     : 4
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.mail')
        .controller('ComposeDialogController', ComposeDialogController);

    /** @ngInject */
    function ComposeDialogController($mdDialog, selectedMail)
    {
        var vm = this;

        // Data
        vm.form = {
            from: 'johndoe@creapond.com'
        };

        vm.hiddenCC = true;
        vm.hiddenBCC = true;

        // If replying
        if ( angular.isDefined(selectedMail) )
        {
            vm.form.to = selectedMail.from.email;
            vm.form.subject = 'RE: ' + selectedMail.subject;
            vm.form.message = '<blockquote>' + selectedMail.message + '</blockquote>';
        }

        // Methods
        vm.closeDialog = closeDialog;

        //////////

        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.gantt-chart',
            [
                // 3rd Party Dependencies
                'gantt',
                'gantt.sortable',
                'gantt.movable',
                'gantt.drawtask',
                'gantt.tooltips',
                'gantt.bounds',
                'gantt.progress',
                'gantt.table',
                'gantt.tree',
                'gantt.groups',
                'gantt.dependencies',
                'gantt.overlap',
                'gantt.resizeSensor'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, msApiProvider)
    {

        $stateProvider.state('app.gantt-chart', {
            url    : '/gantt-chart',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/gantt-chart/gantt-chart.html',
                    controller : 'GanttChartController as vm'
                }
            },
            resolve: {
                Tasks    : function (msApi)
                {
                    return msApi.resolve('ganttChart.tasks@get');
                },
                Timespans: function (msApi)
                {
                    return msApi.resolve('ganttChart.timespans@get');
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/gantt-chart');

        // Navigation
        msNavigationServiceProvider.saveItem('apps.gantt-chart', {
            title : 'Gantt Chart',
            icon  : 'icon-calendar-text',
            state : 'app.gantt-chart',
            weight: 7
        });

        // Api
        msApiProvider.register('ganttChart.tasks', ['app/data/gantt-chart/tasks.json']);
        msApiProvider.register('ganttChart.timespans', ['app/data/gantt-chart/timespans.json']);

    }

})();
(function ()
{
    'use strict';

    angular.module('app.gantt-chart')
        .controller('GanttChartAddEditDialogController', GanttChartAddEditDialogController);

    /** @ngInject */
    function GanttChartAddEditDialogController($mdDialog, ganttUtils, dialogData, fuseGenerator)
    {
        var vm = this;

        // Data
        vm.chartData = dialogData.chartData;
        vm.dialogType = dialogData.dialogType;

        /// Edit Dialog
        if ( vm.dialogType === 'edit' )
        {
            vm.formView = dialogData.formView;
            vm.row = vm.task = angular.copy(dialogData.formData.model);
        }

        /// Add Dialog
        else if ( vm.dialogType === 'add' )
        {
            vm.row = {
                id      : ganttUtils.randomUuid(),
                name    : '',
                tasks   : [],
                classes : ['', ''],
                sortable: true,
                parent  : ''
            };
            vm.task = {
                id      : ganttUtils.randomUuid(),
                name    : '',
                classes : ['', ''],
                from    : '',
                to      : '',
                progress: ''
            };
            vm.taskRowId = '';
        }

        // Methods
        vm.addNewRow = addNewRow;
        vm.saveRow = saveRow;
        vm.removeRow = removeRow;
        vm.addNewTask = addNewTask;
        vm.saveTask = saveTask;
        vm.removeTask = removeTask;
        vm.closeDialog = closeDialog;
        vm.rgba = fuseGenerator.rgba;

        //////////

        /**
         * Add New Row
         */
        function addNewRow()
        {
            vm.chartData.push(vm.row);

            closeDialog();
        }

        /**
         * Save Row
         */
        function saveRow()
        {
            dialogData.formData.model = vm.row;

            closeDialog();
        }

        /**
         * Remove Row
         */
        function removeRow()
        {
            vm.chartData.splice(vm.chartData.indexOf(vm.chartData.getById(vm.row.id)), 1);

            closeDialog();
        }

        /**
         * Add New Task
         */
        function addNewTask()
        {
            vm.chartData.getById(vm.taskRowId).tasks.push(angular.copy(vm.task));

            closeDialog();
        }

        /**
         * Save Task
         */
        function saveTask()
        {
            dialogData.formData.model = vm.task;

            closeDialog();
        }

        /**
         * Remove Task
         */
        function removeTask()
        {
            var taskRow = vm.chartData.getById(dialogData.formData.row.model.id);

            taskRow.tasks.splice(taskRow.tasks.indexOf(taskRow.tasks.getById(vm.task.id)), 1);

            closeDialog();
        }


        /**
         * Close Dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.e-commerce',
            [
                // 3rd Party Dependencies
                'wipImageZoom',
                'datatables',
                'flow',
                'nvd3',
                'textAngular',
                'uiGmapgoogle-maps',
                'xeditable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.e-commerce', {
                abstract: true,
                url     : '/e-commerce'
            })
            .state('app.e-commerce.dashboard', {
                url      : '/dashboard',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/dashboard/dashboard.html',
                        controller : 'DashboardEcommerceController as vm'
                    }
                },
                resolve  : {
                    Dashboard: function (msApi)
                    {
                        return msApi.resolve('e-commerce.dashboard@get');
                    }
                },
                bodyClass: 'ecommerce'
            })
            .state('app.e-commerce.products', {
                url      : '/products',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/products/products.html',
                        controller : 'ProductsController as vm'
                    }
                },
                resolve  : {
                    Products: function (eCommerceService)
                    {
                        return eCommerceService.getProducts();
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.products.add', {
                url      : '/add',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/product/product.html',
                        controller : 'ProductController as vm'
                    }
                },
                resolve: {
                    Product: function (eCommerceService)
                    {
                        return eCommerceService.newProduct();
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.products.detail', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/product/product.html',
                        controller : 'ProductController as vm'
                    }
                },
                resolve  : {
                    Product: function ($stateParams, Products, eCommerceService)
                    {
                        return eCommerceService.getProduct($stateParams.id);
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.orders', {
                url      : '/orders',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/orders/orders.html',
                        controller : 'OrdersController as vm'
                    }
                },
                resolve  : {
                    Orders: function (eCommerceService)
                    {
                        return eCommerceService.getOrders();
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.orders.detail', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/order/order.html',
                        controller : 'OrderController as vm'
                    }
                },
                resolve  : {
                    Order        : function ($stateParams, Orders, eCommerceService)
                    {
                        return eCommerceService.getOrder($stateParams.id);
                    },
                    OrderStatuses: function (eCommerceService)
                    {
                        return eCommerceService.getOrderStatuses();
                    }
                },
                bodyClass: 'e-commerce'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/e-commerce');

        // Api
        msApiProvider.register('e-commerce.dashboard', ['app/data/e-commerce/dashboard.json']);
        msApiProvider.register('e-commerce.products', ['app/data/e-commerce/products.json']);
        msApiProvider.register('e-commerce.orders', ['app/data/e-commerce/orders.json']);
        msApiProvider.register('e-commerce.order-statuses', ['app/data/e-commerce/order-statuses.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.e-commerce', {
            title : 'E-Commerce',
            icon  : 'icon-cart',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('apps.e-commerce.dashboard', {
            title: 'Dashboard',
            state: 'app.e-commerce.dashboard'
        });

        msNavigationServiceProvider.saveItem('apps.e-commerce.products', {
            title: 'Products',
            state: 'app.e-commerce.products'
        });

        msNavigationServiceProvider.saveItem('apps.e-commerce.orders', {
            title: 'Orders',
            state: 'app.e-commerce.orders'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('ProductController', ProductController);

    /** @ngInject */
    function ProductController($scope, $document, $state, eCommerceService, Product)
    {
        var vm = this;

        // Data
        vm.taToolbar = [
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
        ];
        vm.product = Product;
        vm.categoriesSelectFilter = '';
        vm.ngFlowOptions = {
            // You can configure the ngFlow from here
            /*target                   : 'api/media/image',
             chunkSize                : 15 * 1024 * 1024,
             maxChunkRetries          : 1,
             simultaneousUploads      : 1,
             testChunks               : false,
             progressCallbacksInterval: 1000*/
        };
        vm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };
        vm.dropping = false;
        vm.imageZoomOptions = {};

        // Methods
        vm.saveProduct = saveProduct;
        vm.gotoProducts = gotoProducts;
        vm.onCategoriesSelectorOpen = onCategoriesSelectorOpen;
        vm.onCategoriesSelectorClose = onCategoriesSelectorClose;
        vm.fileAdded = fileAdded;
        vm.upload = upload;
        vm.fileSuccess = fileSuccess;
        vm.isFormValid = isFormValid;
        vm.updateImageZoomOptions = updateImageZoomOptions;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            if ( vm.product.images.length > 0 )
            {
                vm.updateImageZoomOptions(vm.product.images[0].url);
            }
        }

        /**
         * Save product
         */
        function saveProduct()
        {
            // Since we have two-way binding in place, we don't really need
            // this function to update the products array in the demo.
            // But in real world, you would need this function to trigger
            // an API call to update your database.
            if ( vm.product.id )
            {
                eCommerceService.updateProduct(vm.product.id, vm.product);
            }
            else
            {
                eCommerceService.createProduct(vm.product);
            }

        }

        /**
         * Go to products page
         */
        function gotoProducts()
        {
            $state.go('app.e-commerce.products');
        }

        /**
         * On categories selector open
         */
        function onCategoriesSelectorOpen()
        {
            // The md-select directive eats keydown events for some quick select
            // logic. Since we have a search input here, we don't need that logic.
            $document.find('md-select-header input[type="search"]').on('keydown', function (e)
            {
                e.stopPropagation();
            });
        }

        /**
         * On categories selector close
         */
        function onCategoriesSelectorClose()
        {
            // Clear the filter
            vm.categoriesSelectFilter = '';

            // Unbind the input event
            $document.find('md-select-header input[type="search"]').unbind('keydown');
        }

        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */
        function fileAdded(file)
        {
            // Prepare the temp file data for media list
            var uploadingFile = {
                id  : file.uniqueIdentifier,
                file: file,
                type: 'uploading'
            };

            // Append it to the media list
            vm.product.images.unshift(uploadingFile);
        }

        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function upload()
        {
            // Set headers
            vm.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            vm.ngFlow.flow.upload();
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message)
        {
            // Iterate through the media list, find the one we
            // are added as a temp and replace its data
            // Normally you would parse the message and extract
            // the uploaded file data from it
            angular.forEach(vm.product.images, function (media, index)
            {
                if ( media.id === file.uniqueIdentifier )
                {
                    // Normally you would update the media item
                    // from database but we are cheating here!
                    var fileReader = new FileReader();
                    fileReader.readAsDataURL(media.file.file);
                    fileReader.onload = function (event)
                    {
                        media.url = event.target.result;
                    };

                    // Update the image type so the overlay can go away
                    media.type = 'image';
                }
            });
        }

        /**
         * Checks if the given form valid
         *
         * @param formName
         */
        function isFormValid(formName)
        {
            if ( $scope[formName] && $scope[formName].$valid )
            {
                return $scope[formName].$valid;
            }
        }

        /**
         * Update image zoom options
         *
         * @param url
         */
        function updateImageZoomOptions(url)
        {
            vm.imageZoomOptions = {
                images: [
                    {
                        thumb : url,
                        medium: url,
                        large : url
                    }
                ]
            };
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('ProductsController', ProductsController);

    /** @ngInject */
    function ProductsController($state, Products)
    {
        var vm = this;

        // Data
        vm.products = Products;

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs  : [
                {
                    // Target the id column
                    targets: 0,
                    width  : '72px'
                },
                {
                    // Target the image column
                    targets   : 1,
                    filterable: false,
                    sortable  : false,
                    width     : '80px'
                },
                {
                    // Target the price column
                    targets: 4,
                    render : function (data, type)
                    {
                        if ( type === 'display' )
                        {
                            return '<div class="layout-align-start-start layout-row">' + '<i class="s16 icon-currency-usd"></i>' + '<span>' + data + '</span>' + '</div>';
                        }

                        return data;
                    }
                },
                {
                    // Target the quantity column
                    targets: 5,
                    render : function (data, type)
                    {
                        if ( type === 'display' )
                        {
                            if ( parseInt(data) <= 5 )
                            {
                                return '<div class="quantity-indicator md-red-500-bg"></div><div>' + data + '</div>';
                            }
                            else if ( parseInt(data) > 5 && parseInt(data) <= 25 )
                            {
                                return '<div class="quantity-indicator md-amber-500-bg"></div><div>' + data + '</div>';
                            }
                            else
                            {
                                return '<div class="quantity-indicator md-green-600-bg"></div><div>' + data + '</div>';
                            }
                        }

                        return data;
                    }
                },
                {
                    // Target the status column
                    targets   : 6,
                    filterable: false,
                    render    : function (data, type)
                    {
                        if ( type === 'display' )
                        {
                            if ( data === 'true' )
                            {
                                return '<i class="icon-checkbox-marked-circle green-500-fg"></i>';
                            }

                            return '<i class="icon-cancel red-500-fg"></i>';
                        }

                        if ( type === 'filter' )
                        {
                            if ( data )
                            {
                                return '1';
                            }

                            return '0';
                        }

                        return data;
                    }
                },
                {
                    // Target the actions column
                    targets           : 7,
                    responsivePriority: 1,
                    filterable        : false,
                    sortable          : false
                }
            ],
            initComplete: function ()
            {
                var api = this.api(),
                    searchBox = angular.element('body').find('#e-commerce-products-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 20,
            scrollY     : 'auto',
            responsive  : true
        };

        // Methods
        vm.gotoAddProduct = gotoAddProduct;
        vm.gotoProductDetail = gotoProductDetail;

        //////////

        /**
         * Go to add product
         */
        function gotoAddProduct()
        {
            $state.go('app.e-commerce.products.add');
        }

        /**
         * Go to product detail
         *
         * @param id
         */
        function gotoProductDetail(id)
        {
            $state.go('app.e-commerce.products.detail', {id: id});
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('OrderController', OrderController);

    /** @ngInject */
    function OrderController($state, uiGmapGoogleMapApi, Order, OrderStatuses)
    {
        var vm = this;

        // Data
        vm.order = Order;
        vm.orderStatuses = OrderStatuses;
        vm.dtInstance = {};
        vm.dtOptions = {
            dom       : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [
                {
                    // Target the id column
                    targets: 0,
                    width  : '72px'
                },
                {
                    // Target the image column
                    targets   : 1,
                    filterable: false,
                    sortable  : false,
                    width     : '80px'
                },
                {
                    // Target the actions column
                    targets           : 5,
                    responsivePriority: 1,
                    filterable        : false,
                    sortable          : false
                }
            ],
            pagingType: 'simple',
            lengthMenu: [10, 20, 30, 50, 100],
            pageLength: 20,
            responsive: true
        };

        vm.newStatus = '';

        // Methods
        vm.gotoOrders = gotoOrders;
        vm.gotoProductDetail = gotoProductDetail;
        vm.updateStatus = updateStatus;

        //////////

        // Normally, you would need Google Maps Geocoding API
        // to convert addresses into latitude and longitude
        // but because Google's policies, we are faking it for
        // the demo
        uiGmapGoogleMapApi.then(function (maps)
        {
            vm.shippingAddressMap = {
                center: {
                    latitude : -34.397,
                    longitude: 150.644
                },
                marker: {
                    id: 'shippingAddress'
                },
                zoom  : 8
            };

            vm.invoiceAddressMap = {
                center: {
                    latitude : -34.397,
                    longitude: 150.644
                },
                marker: {
                    id: 'invoiceAddress'
                },
                zoom  : 8
            };
        });

        /**
         * Go to orders page
         */
        function gotoOrders()
        {
            $state.go('app.e-commerce.orders');
        }

        /**
         * Go to product page
         * @param id
         */
        function gotoProductDetail(id)
        {
            $state.go('app.e-commerce.products.detail', {id: id});
        }

        /**
         * Update order status
         *
         * @param id
         */
        function updateStatus(id)
        {
            if ( !id )
            {
                return;
            }

            for ( var i = 0; i < vm.orderStatuses.length; i++ )
            {
                if ( vm.orderStatuses[i].id === parseInt(id) )
                {
                    vm.order.status.unshift({
                        id   : vm.orderStatuses[i].id,
                        name : vm.orderStatuses[i].name,
                        color: vm.orderStatuses[i].color,
                        date : moment().format('YYYY/MM/DD HH:mm:ss')
                    });

                    break;
                }
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('OrdersController', OrdersController);

    /** @ngInject */
    function OrdersController($state, Orders)
    {
        var vm = this;

        // Data
        vm.orders = Orders;

        vm.dtInstance = {};
        vm.dtOptions = {
            dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs  : [
                {
                    // Target the id column
                    targets: 0,
                    width  : '72px'
                },
                {
                    // Target the status column
                    targets: 5,
                    render : function (data, type, row, meta)
                    {
                        // Get last order status
                        var orderStatus = vm.orders[meta.row].status[0];

                        if ( type === 'display' )
                        {
                            return '<span class="status ' + orderStatus.color + '">' + orderStatus.name + '</span>';
                        }

                        if ( type === 'filter' )
                        {
                            return orderStatus.name;
                        }

                        return data;
                    }
                },
                {
                    // Target the actions column
                    targets           : 7,
                    responsivePriority: 1,
                    filterable        : false,
                    sortable          : false
                }
            ],
            initComplete: function ()
            {
                var api = this.api(),
                    searchBox = angular.element('body').find('#e-commerce-products-search');

                // Bind an external input as a table wide search box
                if ( searchBox.length > 0 )
                {
                    searchBox.on('keyup', function (event)
                    {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType  : 'simple',
            lengthMenu  : [10, 20, 30, 50, 100],
            pageLength  : 20,
            scrollY     : 'auto',
            responsive  : true
        };

        // Methods
        vm.gotoOrderDetail = gotoOrderDetail;

        //////////

        /**
         * Go to product detail
         *
         * @param id
         */
        function gotoOrderDetail(id)
        {
            $state.go('app.e-commerce.orders.detail', {id: id});
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('DashboardEcommerceController', DashboardEcommerceController);

    /** @ngInject */
    function DashboardEcommerceController(Dashboard)
    {
        var vm = this;

        // Data
        vm.dashboard = Dashboard;

        vm.widget1 = vm.dashboard.widget1;
        vm.widget2 = vm.dashboard.widget2;
        vm.widget3 = vm.dashboard.widget3;
        vm.widget4 = vm.dashboard.widget4;
        vm.widget5 = {
            title       : vm.dashboard.widget5.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'multiBarChart',
                        color       : ['#03a9f4', '#b3e5fc'],
                        height      : 420,
                        margin      : {
                            top   : 8,
                            right : 16,
                            bottom: 32,
                            left  : 32
                        },
                        clipEdge    : true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked     : true,
                        duration    : 250,
                        x           : function (d)
                        {
                            return d.x;
                        },
                        y           : function (d)
                        {
                            return d.y;
                        },
                        yAxis       : {
                            tickFormat: function (d)
                            {
                                return d;
                            }
                        },
                        legend      : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        controls    : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            days        : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges      : vm.dashboard.widget5.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget5.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboard.widget5.mainChart, function (chartData, index)
                {
                    vm.widget5.mainChart.data[index] = {
                        key   : chartData.key,
                        values: chartData.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget5.changeRange('TW');
            }
        };

        // Widget 6
        vm.widget6 = {
            title       : vm.dashboard.widget6.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'pieChart',
                        color       : ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height      : 400,
                        margin      : {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        donut       : true,
                        clipEdge    : true,
                        cornerRadius: 0,
                        labelType   : 'percent',
                        padAngle    : 0.02,
                        x           : function (d)
                        {
                            return d.label;
                        },
                        y           : function (d)
                        {
                            return d.value;
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            footerLeft  : vm.dashboard.widget6.footerLeft,
            footerRight : vm.dashboard.widget6.footerRight,
            ranges      : vm.dashboard.widget6.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget6.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboard.widget6.mainChart, function (data, index)
                {
                    vm.widget6.mainChart.data[index] = {
                        label: data.label,
                        value: data.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget6.changeRange('TW');
            }
        };

        // Widget 7
        vm.widget7 = {
            title       : vm.dashboard.widget7.title,
            ranges      : vm.dashboard.widget7.ranges,
            customers   : vm.dashboard.widget7.customers,
            currentRange: 'T'
        };

        // Methods

        //////////

        // Initialize Widget 5
        vm.widget5.init();

        // Initialize Widget 6
        vm.widget6.init();
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts',
            [
                // 3rd Party Dependencies
                'xeditable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.contacts', {
            url    : '/contacts',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/contacts/contacts.html',
                    controller : 'ContactsController as vm'
                }
            },
            resolve: {
                Contacts: function (msApi)
                {
                    return msApi.resolve('contacts.contacts@get');
                },
                User: function (msApi)
                {
                    return msApi.resolve('contacts.user@get');
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/contacts');

        // Api
        msApiProvider.register('contacts.contacts', ['app/data/contacts/contacts.json']);
        msApiProvider.register('contacts.user', ['app/data/contacts/user.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.contacts', {
            title : 'Contacts',
            icon  : 'icon-account-box',
            state : 'app.contacts',
            weight: 10
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts')
        .controller('ContactDialogController', ContactDialogController);

    /** @ngInject */
    function ContactDialogController($mdDialog, Contact, Contacts, User, msUtils)
    {
        var vm = this;

        // Data
        vm.title = 'Edit Contact';
        vm.contact = angular.copy(Contact);
        vm.contacts = Contacts;
        vm.user = User;
        vm.newContact = false;
        vm.allFields = false;

        if ( !vm.contact )
        {
            vm.contact = {
                'id'      : msUtils.guidGenerator(),
                'name'    : '',
                'lastName': '',
                'avatar'  : 'assets/images/avatars/profile.jpg',
                'nickname': '',
                'company' : '',
                'jobTitle': '',
                'email'   : '',
                'phone'   : '',
                'address' : '',
                'birthday': null,
                'notes'   : ''
            };

            vm.title = 'New Contact';
            vm.newContact = true;
            vm.contact.tags = [];
        }

        // Methods
        vm.addNewContact = addNewContact;
        vm.saveContact = saveContact;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        //////////

        /**
         * Add new contact
         */
        function addNewContact()
        {
            vm.contacts.unshift(vm.contact);

            closeDialog();
        }

        /**
         * Save contact
         */
        function saveContact()
        {
            // Dummy save action
            for ( var i = 0; i < vm.contacts.length; i++ )
            {
                if ( vm.contacts[i].id === vm.contact.id )
                {
                    vm.contacts[i] = angular.copy(vm.contact);
                    break;
                }
            }

            closeDialog();
        }

        /**
         * Delete Contact Confirm Dialog
         */
        function deleteContactConfirm(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the contact?')
                .htmlContent('<b>' + vm.contact.name + ' ' + vm.contact.lastName + '</b>' + ' will be deleted.')
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.contacts.splice(vm.contacts.indexOf(Contact), 1);

            });
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.calendar',
            [
                // 3rd Party Dependencies
                'ui.calendar'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.calendar', {
            url      : '/calendar',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/calendar/calendar.html',
                    controller : 'CalendarController as vm'
                }
            },
            bodyClass: 'calendar'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/calendar');

        // Navigation
        msNavigationServiceProvider.saveItem('apps.calendar', {
            title : 'Calendar',
            icon  : 'icon-calendar-today',
            state : 'app.calendar',
            weight: 2
        });
    }
})();
(function ()
{
    'use strict';

    angular.module('app.calendar')
        .controller('EventFormDialogController', EventFormDialogController);

    /** @ngInject */
    function EventFormDialogController($mdDialog, dialogData)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.notifications = ['15 minutes before', '30 minutes before', '1 hour before'];

        // Methods
        vm.saveEvent = saveEvent;
        vm.removeEvent = removeEvent;
        vm.closeDialog = closeDialog;

        init();

        //////////

        /**
         * Initialize
         */
        function init()
        {
            // Figure out the title
            switch ( vm.dialogData.type )
            {
                case 'add' :
                    vm.dialogTitle = 'Add Event';
                    break;

                case 'edit' :
                    vm.dialogTitle = 'Add Event';
                    break;

                default:
                    break;
            }

            // Edit
            if ( vm.dialogData.calendarEvent )
            {
                // Clone the calendarEvent object before doing anything
                // to make sure we are not going to brake FullCalendar
                vm.calendarEvent = angular.copy(vm.dialogData.calendarEvent);

                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.calendarEvent.start) )
                {
                    vm.calendarEvent.start = vm.calendarEvent.start.toDate();
                }

                if ( moment.isMoment(vm.calendarEvent.end) )
                {
                    vm.calendarEvent.end = vm.calendarEvent.end.toDate();
                }
            }
            // Add
            else
            {
                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.dialogData.start) )
                {
                    vm.dialogData.start = vm.dialogData.start.toDate();
                }

                if ( moment.isMoment(vm.dialogData.end) )
                {
                    vm.dialogData.end = vm.dialogData.end.toDate();
                }

                vm.calendarEvent = {
                    start        : vm.dialogData.start,
                    end          : vm.dialogData.end,
                    notifications: []
                };
            }
        }

        /**
         * Save the event
         */
        function saveEvent()
        {
            // Convert the javascript date objects back to the moment.js dates
            var dates = {
                start: moment.utc(vm.calendarEvent.start),
                end  : moment.utc(vm.calendarEvent.end)
            };

            var response = {
                type         : vm.dialogData.type,
                calendarEvent: angular.extend({}, vm.calendarEvent, dates)
            };

            $mdDialog.hide(response);
        }

        /**
         * Remove the event
         */
        function removeEvent()
        {
            var response = {
                type         : 'remove',
                calendarEvent: vm.calendarEvent
            };

            $mdDialog.hide(response);
        }

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.calendar')
        .controller('EventDetailDialogController', EventDetailDialogController);

    /** @ngInject */
    function EventDetailDialogController($mdDialog, calendarEvent, showEventFormDialog, event)
    {
        var vm = this;

        // Data
        vm.calendarEvent = calendarEvent;

        // Methods
        vm.editEvent = editEvent;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Edit the calendar event
         *
         * @param calendarEvent
         */
        function editEvent(calendarEvent)
        {
            showEventFormDialog('edit', calendarEvent, false, false, event);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.blank', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_blank', {
            url  : '/ui/page-layouts/blank',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/blank/blank.html',
                    controller : 'BlankController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.blank')
        .controller('BlankController', BlankController);

    /** @ngInject */
    function BlankController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-500', {
            url      : '/pages/errors/error-500',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-500': {
                    templateUrl: 'app/main/pages/errors/500/error-500.html',
                    controller : 'Error500Controller as vm'
                }
            },
            bodyClass: 'error-500'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/500');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.errors.error-500', {
            title : '500',
            state : 'app.pages_errors_error-500',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500')
        .controller('Error500Controller', Error500Controller);

    /** @ngInject */
    function Error500Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-404', {
            url      : '/pages/errors/error-404',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-404': {
                    templateUrl: 'app/main/pages/errors/404/error-404.html',
                    controller : 'Error404Controller as vm'
                }
            },
            bodyClass: 'error-404'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/404');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.errors', {
            title : 'Errors',
            icon  : 'icon-alert',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('pages.errors.error-404', {
            title : '404',
            state : 'app.pages_errors_error-404',
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.reset-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_reset-password', {
            url      : '/pages/auth/reset-password',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_reset-password': {
                    templateUrl: 'app/main/pages/auth/reset-password/reset-password.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            bodyClass: 'reset-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/reset-password');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.reset-password', {
            title : 'Reset Password',
            state : 'app.pages_auth_reset-password',
            weight: 6
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.reset-password')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register-v2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_register-v2', {
            url      : '/pages/auth/register-v2',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_register-v2': {
                    templateUrl: 'app/main/pages/auth/register-v2/register-v2.html',
                    controller : 'RegisterV2Controller as vm'
                }
            },
            bodyClass: 'register-v2'
        });

        // Translate
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/register-v2');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.register-v2', {
            title : 'Register v2',
            state : 'app.pages_auth_register-v2',
            weight: 4
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register-v2')
        .controller('RegisterV2Controller', RegisterV2Controller);

    /** @ngInject */
    function RegisterV2Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login-v2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_login-v2', {
            url      : '/pages/auth/login-v2',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login-v2': {
                    templateUrl: 'app/main/pages/auth/login-v2/login-v2.html',
                    controller : 'LoginV2Controller as vm'
                }
            },
            bodyClass: 'login-v2'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/login-v2');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.login-v2', {
            title : 'Login v2',
            state : 'app.pages_auth_login-v2',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login-v2')
        .controller('LoginV2Controller', LoginV2Controller);

    /** @ngInject */
    function LoginV2Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_register', {
            url      : '/pages/auth/register',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_register': {
                    templateUrl: 'app/main/pages/auth/register/register.html',
                    controller : 'RegisterController as vm'
                }
            },
            bodyClass: 'register'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/register');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.register', {
            title : 'Register',
            state : 'app.pages_auth_register',
            weight: 3
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register')
        .controller('RegisterController', RegisterController);

    /** @ngInject */
    function RegisterController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_login', {
            url      : '/pages/auth/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login': {
                    templateUrl: 'app/main/pages/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/login');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth', {
            title : 'Authentication',
            icon  : 'icon-lock',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('pages.auth.login', {
            title : 'Login',
            state : 'app.pages_auth_login',
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.lock', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_lock', {
            url      : '/pages/auth/lock',
            views    : {
                'main@'                      : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_lock': {
                    templateUrl: 'app/main/pages/auth/lock/lock.html',
                    controller : 'LockController as vm'
                }
            },
            bodyClass: 'lock'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/lock');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.lock', {
            title : 'Lock Screen',
            state : 'app.pages_auth_lock',
            weight: 7
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.lock')
        .controller('LockController', LockController);

    /** @ngInject */
    function LockController()
    {
        var vm = this;

        // Data
        vm.form = {
            username: 'Jane Doe'
        };

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_forgot-password', {
            url      : '/pages/auth/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_forgot-password': {
                    templateUrl: 'app/main/pages/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/forgot-password');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.forgot-password', {
            title : 'Forgot Password',
            state : 'app.pages_auth_forgot-password',
            weight: 5
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.menu.usuarios',
            [
                // 3rd Party Dependencies
                //'wipImageZoom',
                'datatables',
                'flow',
                'nvd3',
                'textAngular',
                //'uiGmapgoogle-maps',
                'xeditable'
            ]
        )
        .config(config);

    /** @ngInject */
//    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider

            .state('app.menu_usuarios', {
                url      : '/menu/usuarios/users',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/menu/usuarios/users/users.html',
                        controller : 'UsersController as vm'
                    }
                },
/*                
                resolve  : {
                    Products: function (eCommerceService)
                    {
                        return eCommerceService.getProducts();
                    }
                },
*/                
                bodyClass: 'usuarios'
            })

            .state('app.menu_usuarios_add', {
                url      : '/menu/usuarios/users/add',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/menu/usuarios/user/user.html',
                        controller : 'UserController as vm'
                    }
                },
/*                
                resolve: {
                    Product: function (eCommerceService)
                    {
                        return eCommerceService.newProduct();
                    }
                },
*/                
                bodyClass: 'usuarios'
            })

            .state('app.menu_usuarios_user', {
                url      : '/menu/usuarios/user/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/menu/usuarios/user/user.html',
                        controller : 'UserController as vm'
                    }
                },
/*                
                resolve  : {
                    Product: function ($stateParams, Products, eCommerceService)
                    {
                        return eCommerceService.getProduct($stateParams.id);
                    }
                },
*/                
                bodyClass: 'usuarios'
            });

/*
            .state('app.menu.presupuestos.budgets', {
                url      : '/menu/budgets',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/menu/presupuestos/budgets/budgets.html',
                        controller : 'BudgetsController as vm'
                    }
                },
                
                resolve  : {
                    Orders: function (eCommerceService)
                    {
                        return eCommerceService.getOrders();
                    }
                },
                
                bodyClass: 'presupuestos'
            })

            .state('app.menu.presupuestos.budgets.detail', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/order/order.html',
                        controller : 'OrderController as vm'
                    }
                },
                resolve  : {
                    Order        : function ($stateParams, Orders, eCommerceService)
                    {
                        return eCommerceService.getOrder($stateParams.id);
                    },
                    OrderStatuses: function (eCommerceService)
                    {
                        return eCommerceService.getOrderStatuses();
                    }
                },
                bodyClass: 'presupuestos'
            });
*/            

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/menu/usuarios');
/*
        // Api
        msApiProvider.register('e-commerce.dashboard', ['app/data/e-commerce/dashboard.json']);
        msApiProvider.register('e-commerce.products', ['app/data/e-commerce/products.json']);
        msApiProvider.register('e-commerce.orders', ['app/data/e-commerce/orders.json']);
        msApiProvider.register('e-commerce.order-statuses', ['app/data/e-commerce/order-statuses.json']);
*/

        // Navigation
        msNavigationServiceProvider.saveItem('menu.usuarios', {
            title : 'Usuarios',
            icon  : 'icon-account-multiple',
            state: 'app.menu_usuarios',
            weight: 3
        });
/*
        msNavigationServiceProvider.saveItem('menu.presupuestos.budgets', {
            title: 'Budgets',
            state: 'menu.presupuestos.budgets'
        });
*/

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.menu.usuarios')
        .controller('UsersController', UsersController);

    /** @ngInject */
    function UsersController($state,WRITE_IN_CONSOLE,utilsService,firebaseDataService,$firebaseArray,$mdDialog)
    {

        //********************************************************        
        // DATA DECLARATION
        //********************************************************        
        var vm = this;

        vm.usuarios = [];
        vm.totalUsuarios = 0;  

        //********************************************************
        // METHODS DECLARATION
        //********************************************************  
        vm.initData = initData;
        vm.getUsuarios = getUsuarios;
        vm.deleteUsuario = deleteUsuario;
        vm.showConfirmDeleteDialog = showConfirmDeleteDialog;
        vm.showAlertDialog = showAlertDialog;

        vm.gotoUserDetail = gotoUserDetail;
        vm.gotoAddUser = gotoAddUser;


        //START CONTROLLER *******************************
        init();
        //START CONTROLLER *******************************


        //********************************************************
        // METHODS DECLARATION
        //********************************************************        
        function init()
        {
            //We initialize the data for the controller
            vm.initData();

            vm.getUsuarios();
        }




        //***************************************************************
        function initData() {

            vm.dtInstance = {};
            vm.dtOptions = {
                dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                columnDefs  : [
                    {
                        // Target the "codigo" column
                        targets   : 0,
                        //filterable: false,
                        sortable  : false,
                        width     : '50px'
                    },

                    {
                        // Target the "nombre" column
                        targets   : 1,
                        //filterable: false,
                        sortable  : false,
                        width     : '250px'
                    },
                    {
                        // Target the "empresa" column
                        targets   : 2,
                        //filterable: false,
                        //sortable  : false,
                        width     : '150px'
                    },
                    {
                        // Target the "email" column
                        targets   : 3,
                        //filterable: false,
                        //sortable  : false,
                        width     : '200px'
                    },

                    {
                        // Target the "administrador" column
                        targets   : 4,
                        //filterable: false,
                        //sortable  : false,
                        width     : '80px',
                        render    : function (data, type)
                        {
                            if (data == 'true')
                            {
                                return '<i class="icon-checkbox-marked-circle green-500-fg"></i>';
                            }
                            return '<i class="icon-cancel red-500-fg"></i>';

                            if ( type === 'filter' )
                            {
                                if ( data )
                                {
                                    return '1';
                                }

                                return '0';
                            }
                            return data;
                        }                        
                    },

                    {
                        // Target the "active" column
                        targets   : 5,
                        //filterable: false,
                        width     : '80px',
                        render    : function (data, type)
                        {
                            if (data == 'true')
                            {
                                return '<i class="icon-checkbox-marked-circle green-500-fg"></i>';
                            }
                            return '<i class="icon-cancel red-500-fg"></i>';
                        }
                    },
                    
                    {
                        // Target the "actions" column
                        targets           : 6,
                        width             : '100px',
                        responsivePriority: 1,
                        filterable        : false,
                        sortable          : false
                    }
                ],
                initComplete: function ()
                {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#users-search');

                    // Bind an external input as a table wide search box
                    if ( searchBox.length > 0 )
                    {
                        searchBox.on('keyup', function (event)
                        {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType  : 'simple',
                lengthMenu  : [50,100,200],
                pageLength  : 50,
                scrollY     : 'auto',
                responsive  : true
            };
        }



        //***************************************************************
        function getUsuarios() {

            var fbUrl = firebaseDataService.usuarios;
            var result = $firebaseArray(fbUrl.orderByChild("name"));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    utilsService.writeConsole("[UsersController] => getUsuarios() => EJECUCIÓN OK DE CONSULTA TABLA usuarios con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        vm.usuarios = data;
                        vm.totalUsuarios = dataLength;

                    } else {

                        vm.usuarios = null;
                        vm.totalUsuarios = 0;
                    }

                    utilsService.writeConsole("vm.totalUsuarios = " + vm.totalUsuarios, WRITE_IN_CONSOLE);

                    var usuarioNombre = vm.usuarios[0].nombre;
                    utilsService.writeConsole("nombre usuario = " + usuarioNombre, WRITE_IN_CONSOLE);

                })

                .catch(function(error) {

                    vm.usuarios = null;

                    utilsService.writeConsole("[UsersController] => getUsuarios() => ERROR: " + error, WRITE_IN_CONSOLE);
                }
            );
        }



        //***************************************************************
        function deleteUsuario(pId) {

            //We get the record with pId key
            var recordToDelete = vm.usuarios.$getRecord(pId)
            
            if (pId != null) {
                vm.usuarios.$remove(recordToDelete)
                    .then(function(ref) {
                        utilsService.writeConsole("Record deleted", WRITE_IN_CONSOLE);
                    }
                );
            } else {
                utilsService.writeConsole("[UsersController] => deleteUsuario() => We can´t remove the row.", WRITE_IN_CONSOLE);
            }
        }



        //***************************************************************
        function showConfirmDeleteDialog(ev,pId) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('¿Estás seguro de eliminar el registro?')
                .textContent("")
                //.ariaLabel(""'Lucky day')
                .ariaLabel("")
                .targetEvent(ev)
                .ok("ELIMINAR")
                .cancel("CANCELAR");

            $mdDialog.show(confirm)
                .then(function() {
                    //YOU HAVE PUSHED "YES" BUTTON
                    vm.deleteUsuario(pId);
                }, 
                function() {
                    //YOU HAVE PUSHED "NO" BUTTON
                });
        }



        //***************************************************************
        function showAlertDialog(pText) {
            // Appending dialog to document.body to cover sidenav in docs app
            var alert = $mdDialog.alert()
                .title("Información")
                .textContent(pText)
                //.ariaLabel("")
                //.targetEvent(ev)
                .ok("Cerrar")
                //.cancel("No");

            $mdDialog.show(alert)
                .finally(function() {
                    //utilsService.writeConsole("WE REDIRECT TO 'SELECT-ITB' PAGE", WRITE_IN_CONSOLE);
                    //$location.path("/workflow-admin/select-itb");
                }); 
        }



        //***************************************************************
        function gotoUserDetail(id)
        {
            $state.go('app.menu_usuarios_user', {id: id});
        }



        //***************************************************************
        function gotoAddUser()
        {
            $state.go('app.menu_usuarios_add');
        }




    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.menu.usuarios')
        .controller('UserController', UserController);

    /** @ngInject */
    function UserController($state,WRITE_IN_CONSOLE,utilsService,loginService,firebaseDataService,$firebaseArray,$firebaseObject,$mdDialog)
    {
        //********************************************************        
        // DATA DECLARATION
        //********************************************************        
        var vm = this;

        vm.mode = "";       //accepted values = ["insert","update"]

        vm.usuario;
        vm.empresas = [];
        vm.provincias = ["Álava","Albacete","Alicante","Almería","Asturias","Ávila","Badajoz","Islas Baleares","Barcelona","Burgos","Cáceres","Cádiz","Cantabria","Castellón","Ciudad Real","Córdoba","Cuenca","Girona","Granada","Guadalajara","Guipúzcoa","Huelva","Huesca","Jaén","La Coruña","La Rioja","Las Palmas","León","Lleida","Lugo","Madrid","Málaga","Murcia","Navarra","Orense","Palencia","Pontevedra","Salamanca","Segovia","Sevilla","Soria","Tarragona","Santa Cruz de Tenerife","Teruel","Toledo","Valencia","Valladolid","Vizcaya","Zamora","Zaragoza"];
        vm.passwordConfirmation = "";

        var previousEmail = "";
        var previousPassword = "";


        //********************************************************
        // METHODS DECLARATION
        //********************************************************  
        vm.getUsuario = getUsuario;    
        vm.getAllEmpresas = getAllEmpresas;  
        vm.assignCompany = assignCompany;
        vm.findCompany = findCompany;

        vm.addUsuario = addUsuario;
        vm.addNewFirebaseUser = addNewFirebaseUser;
        vm.updatePasswordInFirebase = updatePasswordInFirebase;
        vm.save = save;

        vm.showAlertDialog = showAlertDialog;

        vm.gotoUsers = gotoUsers;
        //vm.gotoUserDetail = gotoUserDetail;

        vm.addEmpresa = addEmpresa;



        //START CONTROLLER *******************************
        init();
        //START CONTROLLER *******************************


        //********************************************************
        // METHODS DECLARATION
        //********************************************************        
        function init()
        {

            var id;

            try {

                id = $state.params.id;

                if (id == null) {
                    vm.mode = "insert";

                } else {
                    vm.mode = "update";
                    vm.getUsuario(id);
                }

            } catch (error) {
                vm.mode = "insert";
            }

/*
            //INSERCIÓN DE NUEVA EMPRESAS (SI ES EL CASO)
            var nuevaEmpresa = {"nombre":"AKI", "activo":true};
            vm.addEmpresa(nuevaEmpresa);
*/
            
            vm.getAllEmpresas();
        }



        //***************************************************************
        function getUsuario(pId) {

            var fbUrl = firebaseDataService.usuarios.child(pId);
            var result = $firebaseObject(fbUrl);

            result.$loaded()
                .then(function(data) {

                    utilsService.writeConsole("[UserController] => getUsuario(pId) => EJECUCIÓN OK DE CONSULTA TABLA usuarios con $id = " + data.$id, WRITE_IN_CONSOLE);
                    vm.usuarioKey = data.$id;

                    vm.usuario = data;

                    previousEmail = vm.usuario.email;
                    //previousEmail2 = vm.usuario.email2;
                    //previousEmail3 = vm.usuario.email3;

                    previousPassword = vm.usuario.password;
                    //previousPassword2 = vm.usuario.password2;
                    //previousPassword3 = vm.usuario.password3;

                    vm.passwordConfirmation = vm.usuario.password;

                })

                .catch(function(error) {
                    vm.usuario = null;
                    utilsService.writeConsole("[UserController] => getUsuario(pId) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        //***************************************************************
        function getAllEmpresas() {
            //We retrieve the data from Firebase in a $firebaseArray object
            var fbUrl = firebaseDataService.empresas;
            var result = $firebaseArray(fbUrl.orderByChild("nombre"));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    utilsService.writeConsole("[UserController] => getAllEmpresas() para Combo empresas => EJECUCIÓN OK DE CONSULTA TABLA empresas con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {
                        vm.empresas = data;
                    } else {
                        vm.empresas = null;
                    }
                })

                .catch(function(error) {
                    vm.empresas = null;
                    utilsService.writeConsole("[UserController] => getAllEmpresas() para Combo empresas => ERROR: " + error, WRITE_IN_CONSOLE);
                }
            );
        }



        //***************************************************************
        function addUsuario(pUsuario) {

            var fbUrl = firebaseDataService.usuarios;
            var usuarios = $firebaseArray(fbUrl.limitToLast(1));

            usuarios.$add(pUsuario)
                .then(function(ref) {
                    utilsService.writeConsole("[UserController] Added new record to 'usuarios'", WRITE_IN_CONSOLE);

                    //BEGIN - CREATE FIREBASE USER FOR AUTHENTICATION
                    vm.addNewFirebaseUser(pUsuario.email,pUsuario.password);
                    //END - CREATE FIREBASE USER FOR AUTHENTICATION

                    //We go to users list page
                    vm.gotoUsers();

                })
                .catch(function(error) {
                    utilsService.writeConsole("[UserController] => addUsuario(pUsuario) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        //***************************************************************
        function addNewFirebaseUser(pEmail,pPassword) {

            //BEGIN - FIREBASE CREATE USER FOR AUTHENTICATION
            firebase.auth().createUserWithEmailAndPassword(pEmail,pPassword)
                .then(function() {
                    utilsService.writeConsole("FIREBASE USER CREATION SUCCESFUL", WRITE_IN_CONSOLE);
                })
                .catch(function(error) {
                    // Handle Errors here.
                    var errorCode = error.code;
                    var errorMessage = error.message;
                    utilsService.writeConsole("FIREBASE USER CREATION FAILED", WRITE_IN_CONSOLE);
            });
            //END - FIREBASE CREATE USER FOR AUTHENTICATION
        }



        //***************************************************************
        function updatePasswordInFirebase(pEmail,pPassword,pPreviousPassword) {

            if (pPassword == pPreviousPassword) {
                return;
            }

            //BEGIN - FIREBASE UPDATE USER's PASSWORD FOR AUTHENTICATION
            var firebaseUser = firebase.auth().currentUser;

            if (firebaseUser != null) {
                
                //If the email of the current Firebase user is the same as the email of the user to change => UPDATE THE PASSWORD FOR THE CURRENT FIREBASE USER
                if (firebaseUser.email == pEmail) {

                    firebaseUser.updatePassword(pPassword)
                        .then(function() {
                            utilsService.writeConsole("PASSWORD UPDATE SUCCESFUL for " + pEmail + " and " + pPassword, WRITE_IN_CONSOLE);
                        }, 
                        function(error) {
                            utilsService.writeConsole("PASSWORD UPDATE FAILED for " + pEmail + " and " + pPassword + " ERROR => " + error, WRITE_IN_CONSOLE);
                    });                    

                //If the email of the current Firebase user is different from the email of the user to change => LOGIN WITH THE OTHER USER AND UPDATE THE PASSWORD
                } else {

                    //BEGIN - FIREBASE USER AUTHENTICATION
                    utilsService.writeConsole(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> signInWithEmailAndPassword(" + pEmail + "," + pPreviousPassword + ")", WRITE_IN_CONSOLE);

                    firebase.auth().signInWithEmailAndPassword(pEmail,pPreviousPassword)
                        .then(function(firebaseUser) {
                            utilsService.writeConsole("LOGIN WITH SECONDARY USER CORRECT for " + pEmail + " and " + pPreviousPassword, WRITE_IN_CONSOLE);

                            var firebaseUser = firebase.auth().currentUser;

                            if (firebaseUser != null) {
                                
                                firebaseUser.updatePassword(pPassword)
                                    .then(function() {
                                        utilsService.writeConsole("PASSWORD UPDATE SUCCESFUL for " + pEmail + " and " + pPassword, WRITE_IN_CONSOLE);

                                        //We update App credentials password only if the email is the same as the Eintrade login
                                        if (loginService.getEmail() == pEmail) {
                                            loginService.setPassword(pPassword);
                                        }

                                    }, 
                                    function(error) {
                                        utilsService.writeConsole("PASSWORD UPDATE FAILED for " + pEmail + " and " + pPassword, WRITE_IN_CONSOLE);
                                });                    

                            } else {

                                utilsService.writeConsole("Firebase user signIn error: We can't get a firebase user for this email and password", WRITE_IN_CONSOLE);
                            }                                         
                            
                        })

                        .catch(function(error) {
                            // Handle Errors here.
                            var errorCode = error.code;
                            var errorMessage = error.message; 

                            utilsService.writeConsole("Login with secondary user (" + pEmail + "," + pPreviousPassword + ") error => ErrorCode = " + errorCode + "  / errorMessage = " + errorMessage, WRITE_IN_CONSOLE);

                    });
                    //END - FIREBASE USER AUTHENTICATION
                }

            }            
            //END - FIREBASE UPDATE USER's PASSWORD FOR AUTHENTICATION
        }


        function save() {

            var user = vm.usuario;

            try {
                //password is always mandatory for user
                if (user.password.trim() != vm.passwordConfirmation.trim()) {
                    vm.showAlertDialog("La confirmación de la contraseña no coincide con la contraseña introducida.");
                    return;
                }
            } catch(e) {
                vm.showAlertDialog("La confirmación de la contraseña no coincide con la contraseña introducida.");
                return;
            }

/*
            try {
                if (user.password2.trim() != user.passwordConfirm2.trim()) {
                    vm.showAlertDialog("La confirmación de la contraseña 2 no coincide.");
                    return;
                }
            } catch(e) {
                console.log("Do nothing for user2");
            }

            try {
                if (user.password3.trim() != user.passwordConfirm3.trim()) {
                    vm.showAlertDialog("La confirmación de la contraseña 3 no coincide.");
                    return;
                }
            } catch(e) {
                console.log("Do nothing for user3");
            }
*/

            if (vm.mode == "update") {
                
                //We update user's data
                vm.usuario.$save()
                    .then(function(ref) {

                        utilsService.writeConsole("User saved with ID = " + ref.key, WRITE_IN_CONSOLE);

//INICIO - HABILITAR TEMPORALMENTE PARA DAR DE ALTA LOS USUARIOS CREADOS ANTERIORMENTE A LA INTEGRACIÓN DE SECURIZACIÓN
/*
                        vm.addNewFirebaseUser(user.email1,user.password1);

                        if (user.email2 != null) {
                            vm.addNewFirebaseUser(user.email2,user.password2);
                        }

                        if (user.email3 != null) {
                            vm.addNewFirebaseUser(user.email3,user.password3);
                        }
*/                        
//FIN - HABILITAR TEMPORALMENTE PARA DAR DE ALTA LOS USUARIOS CREADOS ANTERIORMENTE A LA INTEGRACIÓN DE SECURIZACIÓN


                    //BEGIN - UPDATE FIREBASE USER's PASSWORD FOR AUTHENTICATION
                        //For USER 1
                        if (user.email == previousEmail) {
                            vm.updatePasswordInFirebase(user.email,user.password,previousPassword);
                        } else {
                            vm.addNewFirebaseUser(user.email,user.password);    
                        }

/*
                        //For USER 2
                        if (user.email2 != null) {

                            if (previousEmail2 != null) {

                                if (user.email2 == previousEmail2) {
                                    vm.updatePasswordInFirebase(user.email2,user.password2,previousPassword2);
                                } else {
                                    vm.addNewFirebaseUser(user.email2,user.password2);    
                                }

                            }
                            else {
                                vm.addNewFirebaseUser(user.email2,user.password2);
                            }
                        }

                        //For USER 3
                        if (user.email3 != null) {

                            if (previousEmail3 != null) {

                                if (user.email3 == previousEmail3) {
                                    vm.updatePasswordInFirebase(user.email3,user.password3,previousPassword3);
                                } else {
                                    vm.addNewFirebaseUser(user.email3,user.password3);
                                }

                            }
                            else {
                                vm.addNewFirebaseUser(user.email3,user.password3);
                            }
                        }
*/                        
                    //END - UPDATE FIREBASE USER's PASSWORD FOR AUTHENTICATION

                        //NOTA: Si el usuario actualizado es el actual usuario loginado => Actualizamos el valor de userProfile
                        if (user.$id == loginService.getUserKey()) {

                            if (user.administrador) {
                                loginService.setUserProfile("administrator");
                            } else {
                                loginService.setUserProfile("user");
                            }
                        }


                        //We go to Warehouses page
                        vm.gotoUsers();
                    })

                    .catch(function(error) {
                        utilsService.writeConsole("[UserController] => save() user => ERROR: " + error, WRITE_IN_CONSOLE); 
                });                

            } else {

                //We add a new user
                vm.addUsuario(vm.usuario);
            }

        }



        //***************************************************************
        function assignCompany(pKey) {

            try {
                var method = vm.empresas.find(findCompany);
                vm.usuario.empresa = method.nombre;

            } catch (error) {
                vm.usuario.empresa = "";
            }
        }


        //***************************************************************
        function findCompany(pValue) {
            return pValue.$id === vm.usuario.empresa_key;
        }



        //***************************************************************
        function showAlertDialog(pText) {
            // Appending dialog to document.body to cover sidenav in docs app
            var alert = $mdDialog.alert()
                .title("Aviso")
                .textContent(pText)
                //.ariaLabel("")
                //.targetEvent(ev)
                .ok("Cerrar")
                //.cancel("No");

            $mdDialog.show(alert)
                .finally(function() {
                    utilsService.writeConsole("[UserController] => Alert Dialog showed", WRITE_IN_CONSOLE);
                    //$location.path("/workflow-admin/select-itb");
                }); 
        }




        //***************************************************************
        function addEmpresa(pEmpresa) {

            var fbUrl = firebaseDataService.empresas;
            var empresas = $firebaseArray(fbUrl.limitToLast(1));

            empresas.$add(pEmpresa)
                .then(function(ref) {
                    utilsService.writeConsole("[UserController] Added new record to 'empresas' with KEY = " + ref.key, WRITE_IN_CONSOLE);

                })
                .catch(function(error) {
                    utilsService.writeConsole("[UserController] => addEmpresa(pEmpresa) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }


        //***************************************************************
        function gotoUsers()
        {
            $state.go('app.menu_usuarios');
        }


/*
        //***************************************************************
        function gotoUserDetail(id)
        {
            $state.go('app.menu_usuarios_user', {id: id});
        }
*/


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.menu.presupuestos')
        .controller('MirrorBudgetController', MirrorBudgetController);

    /** @ngInject */
    function MirrorBudgetController($state,$mdDialog,$document,WRITE_IN_CONSOLE,utilsService,loginService,firebaseDataService,$firebaseArray,$firebaseObject,preciosService)
    {
        //********************************************************        
        // DATA DECLARATION
        //********************************************************        
        var vm = this;

        vm.mode = "";       //accepted values = ["insert","update"]

        vm.arrayPresupuestoEspejo = {};
        vm.presupuestoEspejo = {};
        vm.presupuestoKey;
        vm.nuevoPresupuestoKey;

        vm.numeroEspejo;
        vm.numeroTrasera;
        vm.numeroMoldura1;
        vm.numeroMoldura2;
        vm.espejoSeleccionado = {};
        vm.traseraSeleccionada = {};
        vm.moldura1Seleccionada = {};
        vm.moldura2Seleccionada = {};

        vm.multiplicadorEspejo = 0;
        vm.multiplicadorTrasera = 0;
        vm.multiplicadorMoldura1 = 0;
        vm.multiplicadorMoldura2 = 0;

        vm.subtotalEspejo = 0;
        vm.subtotalTrasera = 0;
        vm.subtotalMoldura1 = 0;
        vm.subtotalMoldura2 = 0;

        vm.iconoDesplegarContraerMedidas = "icon-chevron-up";
        vm.textoDesplegarContraerMedidas = "contraer";
        vm.desplegadoContenidoMedidas = true;

        vm.iconoDesplegarContraerMoldura1 = "icon-chevron-down";
        vm.textoDesplegarContraerMoldura1 = "desplegar";
        vm.desplegadoContenidoMoldura1 = false;

        vm.iconoDesplegarContraerMoldura2 = "icon-chevron-down";
        vm.textoDesplegarContraerMoldura2 = "desplegar";
        vm.desplegadoContenidoMoldura2 = false;

        vm.iconoDesplegarContraerUnidades = "icon-chevron-down";
        vm.textoDesplegarContraerUnidades = "desplegar";
        vm.desplegadoContenidoUnidades = false;

        vm.muestraLineaPresupuestoParaEspejo = false
        vm.muestraLineaPresupuestoParaTrasera = false
        vm.muestraLineaPresupuestoParaMoldura1 = false;
        vm.muestraLineaPresupuestoParaMoldura2 = false;

vm.activarBotonSiguienteParaMedidas = false;
vm.activarBotonSiguienteParaMoldura1 = false;
vm.activarBotonSiguienteParaMoldura2 = false;
vm.activarBotonCalcularPresupuesto = false;

        vm.showSaveButtonInHeader = true;

        vm.budgetCalculated = false;

        vm.fechaConFormato = "";

        vm.isAdministrator = false;


        //******************************************************** 
        // METHODS DECLARATION
        //********************************************************   
        vm.getPresupuestoEspejo = getPresupuestoEspejo;

        vm.addPresupuestoEspejo = addPresupuestoEspejo;
        vm.save = save;

        vm.insertarEspejo = insertarEspejo;
        vm.insertarTrasera = insertarTrasera;
        vm.insertarMoldura1 = insertarMoldura1;
        vm.insertarMoldura2 = insertarMoldura2;
        vm.actualizaTotalPresupuesto = actualizaTotalPresupuesto;
        vm.updatePresupuesto = updatePresupuesto;
        vm.updateUsuarioPresupuestos = updateUsuarioPresupuestos;

        vm.copyPresupuestoConMismoNumeroPC = copyPresupuestoConMismoNumeroPC;
        vm.copyPresupuesto = copyPresupuesto;
        vm.copyPresupuestoToUsuarioPresupuestosTable = copyPresupuestoToUsuarioPresupuestosTable;

        vm.gotoBudgets = gotoBudgets;
        vm.gotoBudgetMenu = gotoBudgetMenu;
        vm.gotoStep = gotoStep;
        vm.omitirPaso = omitirPaso;
        vm.desplegarContraerContenido = desplegarContraerContenido;
        vm.resetValoresPresupuesto = resetValoresPresupuesto;

        vm.resetMultiplicadoresSubtotales = resetMultiplicadoresSubtotales;
        vm.calculateBudget = calculateBudget;
        vm.getMedidasMoldura1 = getMedidasMoldura1;
        vm.getMedidasMoldura2 = getMedidasMoldura2;
        vm.getMultiplicadorMolduraExteriorConImporteServicios = getMultiplicadorMolduraExteriorConImporteServicios;     

        vm.checkMaxValue = checkMaxValue;   

        vm.printOrderDialog = printOrderDialog;
        vm.showAlertDialog = showAlertDialog;
        vm.showMenuDialog = showMenuDialog;


        //START CONTROLLER *******************************
        init();
        //START CONTROLLER *******************************


        //********************************************************
        // METHODS DECLARATION
        //********************************************************        
        function init()
        {
            if (loginService.getUserProfile() == "administrator") {
                vm.isAdministrator = true;
            } else {
                vm.isAdministrator = false;
            }

            vm.presupuestoEspejo.total = 0;

            vm.presupuestoEspejo.width = 0;
            vm.presupuestoEspejo.height = 0;

            vm.presupuestoEspejo.urlImagen1 = "";
            vm.presupuestoEspejo.urlImagen2 = "";
            vm.presupuestoEspejo.urlImagenPerfil1 = "";
            vm.presupuestoEspejo.urlImagenPerfil2 = "";

            try {

                vm.presupuestoKey = $state.params.id;

                vm.getPresupuestoEspejo(vm.presupuestoKey);

            } catch (error) {
                vm.mode = "insert";
                vm.showSaveButtonInHeader = false;
            }

        }


        //***************************************************************
        function getPresupuestoEspejo(pPresupuestoKey) {

            var fbUrl = firebaseDataService.presupuesto_espejo;
            var result = $firebaseArray(fbUrl.orderByChild("presupuesto_key").equalTo(pPresupuestoKey));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;
                    utilsService.writeConsole("[MirrorBudgetController] => getPresupuestoEspejo(" + pPresupuestoKey + ") => EJECUCIÓN OK DE CONSULTA TABLA presupuesto_espejo con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        vm.mode = "update";
                        vm.showSaveButtonInHeader = true;

                        vm.arrayPresupuestoEspejo = data;
                        vm.presupuestoEspejo = data[0];

                        //ASIGNACION DATOS PARA ESPEJO
                        vm.numeroEspejo = vm.presupuestoEspejo.numeroEspejo;

                        vm.espejoSeleccionado.numeroEspejo = vm.presupuestoEspejo.numeroEspejo;
                        vm.espejoSeleccionado.refLeroyMerlin = vm.presupuestoEspejo.refLeroyMerlinEspejo;

                        vm.espejoSeleccionado.descripcion = vm.presupuestoEspejo.descripcionEspejo;
                        vm.espejoSeleccionado.precioLeroyMerlin = vm.presupuestoEspejo.precioLeroyMerlinEspejo;
                        vm.espejoSeleccionado.precioCoste = vm.presupuestoEspejo.precioCosteEspejo;

                        if (vm.espejoSeleccionado.numeroEspejo != null) {
                            vm.muestraLineaPresupuestoParaEspejo = true;
                        } else {
                            vm.muestraLineaPresupuestoParaEspejo = false;
                        }

                        vm.activarBotonSiguienteParaMedidas = true;

                        //ASIGNACION DATOS PARA TRASERA
                        vm.numeroTrasera = vm.presupuestoEspejo.numeroTrasera;

                        vm.traseraSeleccionada.numeroTrasera = vm.presupuestoEspejo.numeroTrasera;
                        vm.traseraSeleccionada.refLeroyMerlin = vm.presupuestoEspejo.refLeroyMerlinTrasera;

                        vm.traseraSeleccionada.descripcion = vm.presupuestoEspejo.descripcionTrasera;
                        vm.traseraSeleccionada.precioLeroyMerlin = vm.presupuestoEspejo.precioLeroyMerlinTrasera;
                        vm.traseraSeleccionada.precioCoste = vm.presupuestoEspejo.precioCosteTrasera;

                        if (vm.traseraSeleccionada.numeroTrasera != null) {
                            vm.muestraLineaPresupuestoParaTrasera = true;
                        } else {
                            vm.muestraLineaPresupuestoParaTrasera = false;
                        }


                        //ASIGNACION DATOS PARA MOLDURA 1
                        vm.numeroMoldura1 = vm.presupuestoEspejo.numeroMoldura1;

                        vm.moldura1Seleccionada.numeroMoldura = vm.presupuestoEspejo.numeroMoldura1;
                        vm.moldura1Seleccionada.refLeroyMerlin = vm.presupuestoEspejo.refLeroyMerlinMoldura1;

                        vm.moldura1Seleccionada.descripcion = vm.presupuestoEspejo.descripcion1;
                        vm.moldura1Seleccionada.precioLeroyMerlin = vm.presupuestoEspejo.precioLeroyMerlin1;
                        vm.moldura1Seleccionada.precioCoste = vm.presupuestoEspejo.precioCoste1;
                        vm.moldura1Seleccionada.desperdicio = vm.presupuestoEspejo.desperdicio1;

                        if (vm.moldura1Seleccionada.numeroMoldura != null) {
                            vm.muestraLineaPresupuestoParaMoldura1 = true;
                        } else {
                            vm.muestraLineaPresupuestoParaMoldura1 = false;
                        }

                        vm.activarBotonSiguienteParaMoldura1 = true;

                        document.getElementById("moldingImage1").src = vm.presupuestoEspejo.urlImagen1;
                        document.getElementById("outlineImage1").src = vm.presupuestoEspejo.urlImagenPerfil1;

                        //ASIGNACION DATOS PARA MOLDURA 2
                        vm.numeroMoldura2 = vm.presupuestoEspejo.numeroMoldura2;
                        
                        vm.moldura2Seleccionada.numeroMoldura = vm.presupuestoEspejo.numeroMoldura2;
                        vm.moldura2Seleccionada.refLeroyMerlin = vm.presupuestoEspejo.refLeroyMerlinMoldura2;

                        vm.moldura2Seleccionada.descripcion = vm.presupuestoEspejo.descripcion2;
                        vm.moldura2Seleccionada.precioLeroyMerlin = vm.presupuestoEspejo.precioLeroyMerlin2;
                        vm.moldura2Seleccionada.precioCoste = vm.presupuestoEspejo.precioCoste2;
                        vm.moldura2Seleccionada.desperdicio = vm.presupuestoEspejo.desperdicio2;

                        if (vm.moldura2Seleccionada.numeroMoldura != null) {
                            vm.muestraLineaPresupuestoParaMoldura2 = true;
                        } else {
                            vm.muestraLineaPresupuestoParaMoldura2 = false;
                        }

                        vm.activarBotonSiguienteParaMoldura2 = true;
                        vm.activarBotonCalcularPresupuesto = true;

                        document.getElementById("moldingImage2").src = vm.presupuestoEspejo.urlImagen2;
                        document.getElementById("outlineImage2").src = vm.presupuestoEspejo.urlImagenPerfil2;

                    } else {

                        vm.mode = "insert";
                        vm.showSaveButtonInHeader = false;

                        //Para el caso de la inserción => Asignamos los valores por defecto
                        vm.presupuestoEspejo.presupuesto_key = vm.presupuestoKey;
                        vm.presupuestoEspejo.medidaExteriorValorString = "true";

                        vm.presupuestoEspejo.unidades = 1;
                        vm.presupuestoEspejo.total = 0;

                        vm.muestraLineaPresupuestoParaEspejo = false;
                        vm.muestraLineaPresupuestoParaMoldura1 = false;
                        vm.muestraLineaPresupuestoParaMoldura2 = false;

                        vm.activarBotonSiguienteParaMedidas = false;
                        vm.activarBotonSiguienteParaMoldura1 = false;
                        vm.activarBotonSiguienteParaMoldura2 = false;
                        vm.activarBotonCalcularPresupuesto = false;
                    }

                })

                .catch(function(error) {

                    vm.presupuestoEspejo = null;
                    utilsService.writeConsole("[MirrorBudgetController] => getPresupuestoEspejo(pPresupuestoKey) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }


        
        //***************************************************************
        function save(pPresupuestoEspejo,pFinalizarPedido,pEvent) {

            vm.presupuestoEspejo.presupuesto_key = vm.presupuestoKey;

            if (vm.mode == "update") {
                
                //We update budget's data
                vm.arrayPresupuestoEspejo.$save(pPresupuestoEspejo)
                    .then(function(ref) {

                        utilsService.writeConsole("[MirrorBudgetController] - save() => Presupuesto saved with ID = " + ref.key, WRITE_IN_CONSOLE);

                        //Actualizamos la tabla "presupuestos" (con los valores de importe, unidades y tipo)
                        vm.updatePresupuesto(vm.presupuestoKey,pFinalizarPedido,pEvent);

                    })

                    .catch(function(error) {

                        vm.showAlertDialog("Se ha producido un error al guardar el presupuesto del espejo. Por favor contacte con el Administrador de la App.");                        
                        utilsService.writeConsole("[MirrorBudgetController] => save() => ERROR: " + error, WRITE_IN_CONSOLE); 
                });                

            //SI SE TRATA DE UNA INSERCIÓN
            } else {

                //We add a new "mirror" budget 
                vm.addPresupuestoEspejo(vm.presupuestoEspejo,pFinalizarPedido,pEvent); 

            }
        }



        //***************************************************************
        function addPresupuestoEspejo(pPresupuestoEspejo,pFinalizarPedido,pEvent) {

            pPresupuestoEspejo.presupuesto_key = vm.presupuestoKey;

            var fbUrl = firebaseDataService.presupuesto_espejo;
            var presupuestos = $firebaseArray(fbUrl.limitToLast(1));

            presupuestos.$add(pPresupuestoEspejo)
                .then(function(ref) {
                    utilsService.writeConsole("[MirrorBudgetController] - addPresupuestoEspejo(pPresupuestoEspejo) => Added new record to 'presupuesto_espejo'", WRITE_IN_CONSOLE);

                    //Actualizamos la tabla "presupuestos" (con los valores de importe, unidades y tipo)
                    vm.updatePresupuesto(vm.presupuestoKey,pFinalizarPedido,pEvent);

                })
                .catch(function(error) {

                    vm.showAlertDialog("Se ha producido un error al añadir el presupuesto del espejo. Por favor contacte con el Administrador de la App.");
                    utilsService.writeConsole("[MirrorBudgetController] - addPresupuestoEspejo(pPresupuestoEspejo) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        //***************************************************************
        function updatePresupuesto(pPresupuestoKey,pFinalizarPedido,pEvent) {

            var fbUrl = firebaseDataService.presupuestos.child(pPresupuestoKey);
            var result = $firebaseObject(fbUrl);

            result.$loaded()
                .then(function(data) {

                    utilsService.writeConsole("[MirrorBudgetController] => updatePresupuesto(pPresupuestoKey) => EJECUCIÓN OK DE CONSULTA en TABLA presupuestos con $id = " + data.$id, WRITE_IN_CONSOLE);

                    var presupuesto = data;

                    presupuesto.tipo = "espejo";
                    presupuesto.unidades = vm.presupuestoEspejo.unidades;
                    presupuesto.importe = vm.presupuestoEspejo.totalConIva;

                    presupuesto.$save()
                        .then(function(ref) {
                            utilsService.writeConsole("[MirrorBudgetController] => updatePresupuesto(pPresupuestoKey) => EJECUCIÓN OK DE UPDATE en TABLA presupuestos con $id = " + data.$id, WRITE_IN_CONSOLE);

                            //Actualizamos la tabla "usuario_presupuestos" (con los valores de importe, unidades y tipo)
                            vm.updateUsuarioPresupuestos(pPresupuestoKey,pFinalizarPedido,pEvent);
                        })

                        .catch(function(error) {
                            utilsService.writeConsole("[MirrorBudgetController] => updatePresupuesto(pPresupuestoKey) => ERROR: " + error, WRITE_IN_CONSOLE); 
                    });                


                })

                .catch(function(error) {
                    presupuesto = null;
                    utilsService.writeConsole("[MirrorBudgetController] => updatePresupuesto(pPresupuestoKey) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        //***************************************************************
        function updateUsuarioPresupuestos(pPresupuestoKey,pFinalizarPedido,pEvent) {

            var usuarioPresupuesto;

            var fbUrl = firebaseDataService.usuario_presupuestos;
            var result = $firebaseArray(fbUrl.orderByChild("presupuesto_key").equalTo(pPresupuestoKey));

            result.$loaded()
                .then(function(data) {

                    utilsService.writeConsole("[MirrorBudgetController] => updateUsuarioPresupuestos(pPresupuestoKey) => EJECUCIÓN OK DE CONSULTA en TABLA usuario_presupuestos con $id = " + data[0].$id, WRITE_IN_CONSOLE);

                    usuarioPresupuesto = data[0];

                    usuarioPresupuesto.tipo = "espejo";
                    usuarioPresupuesto.unidades = vm.presupuestoEspejo.unidades;
                    usuarioPresupuesto.importe = vm.presupuestoEspejo.totalConIva;

                    data.$save(usuarioPresupuesto)
                        .then(function(ref) {
                            utilsService.writeConsole("[MirrorBudgetController] => updateUsuarioPresupuestos(pPresupuestoKey) => EJECUCIÓN OK DE UPDATE en TABLA usuario_presupuestos con $id = " + data[0].$id, WRITE_IN_CONSOLE);

                            if (pFinalizarPedido) {

                                //IMPORTANTE => MOSTRAMOS LA VERSIÓN IMPRIMIBLE Y REDIRIGIMOS A LA PÁGINA DE LISTADO DE PRESUPUESTOS.
                                vm.printOrderDialog(pEvent,pPresupuestoKey,usuarioPresupuesto.numeroNumeroPC);
                                vm.gotoBudgets();

                            } else {

                                //Añadimos un nuevo presupuesto copiando los datos del actual y manteniendo el mismo Nº de PC
                                vm.copyPresupuestoConMismoNumeroPC(pPresupuestoKey);
                            }

                        })

                        .catch(function(error) {
                            utilsService.writeConsole("[MirrorBudgetController] => updateUsuarioPresupuestos(pPresupuestoKey) => ERROR: " + error, WRITE_IN_CONSOLE); 
                    });                

                })

                .catch(function(error) {
                    usuarioPresupuesto = null;
                    utilsService.writeConsole("[MirrorBudgetController] => updateUsuarioPresupuestos(pPresupuestoKey) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        //***************************************************************
        function printOrderDialog(ev,pPresupuestoKey,pPresupuestoNumeroPC)
        {
            $mdDialog.show({
                controller         : 'PrintOrderDialogController',
                controllerAs       : 'vm',
                
                locals             : {
                    presupuestoKey: pPresupuestoKey,
                    presupuestoNumeroPC: pPresupuestoNumeroPC
                    //,consignatarioData: vm.consignatarioData
                    //,packinglistData: vm.packinglistData
                },
                
                templateUrl        : 'app/main/menu/presupuestos/budgets/printOrderDialog/print-order-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev
                //clickOutsideToClose: true
            });
        }



        //***************************************************************
        function copyPresupuestoConMismoNumeroPC(pPresupuestoKey,pEvent) {

            var fbUrl = firebaseDataService.presupuestos.child(pPresupuestoKey);
            var result = $firebaseObject(fbUrl);

            result.$loaded()
                .then(function(data) {

                    utilsService.writeConsole("[MirrorBudgetController] => copyPresupuestoConMismoNumeroPC(pPresupuestoKey) => EJECUCIÓN OK DE CONSULTA TABLA presupuestos con $id = " + data.$id, WRITE_IN_CONSOLE);
                    vm.presupuestoKey = data.$id;

                    var presupuestoAcopiar = data;

                    presupuestoAcopiar.fechaTimestamp = new Date().getTime();
                    presupuestoAcopiar.tipo = "¿?";
                    presupuestoAcopiar.unidades = 0;
                    presupuestoAcopiar.importe = 0;
                    presupuestoAcopiar.numeroPC = "?";

                    vm.copyPresupuesto(presupuestoAcopiar,pEvent);

                })

                .catch(function(error) {
                    utilsService.writeConsole("[MirrorBudgetController] => copyPresupuestoConMismoNumeroPC(pPresupuestoKey) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        //***************************************************************
        function copyPresupuesto(pPresupuesto,pEvent) {

            var ultimoPresupuesto;

            var fbUrl = firebaseDataService.presupuestos;
            var presupuestos = $firebaseArray(fbUrl.limitToLast(1));

            presupuestos.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    if (dataLength > 0) {

                        ultimoPresupuesto = data[0];

                        //Incrementamos el número de presupuesto en 1 unidad
                        var ultimoCodigoPresupuesto = ultimoPresupuesto.codigo;
                        var nuevoCodigoPresupuesto = Number(ultimoCodigoPresupuesto.substring(3,ultimoCodigoPresupuesto.length));
                        nuevoCodigoPresupuesto++;
                        pPresupuesto.codigo = "PR-" + utilsService.padLeftWithZero(nuevoCodigoPresupuesto,6);

                        //Incrementamos el número de PC en 1 unidad
                        //IMPORTANTE => MANTENEMOS EL MISMO NUMERO DE PD y de PC del presupuesto copiado.
/*                        
                        var ultimoNumeroPC = ultimoPresupuesto.numeroPC;
                        var nuevoNumeroPC = Number(ultimoNumeroPC.substring(3,ultimoNumeroPC.length));
                        nuevoNumeroPC++;
                        pPresupuesto.numeroPC = "PT-" + utilsService.padLeftWithZero(nuevoNumeroPC,6);
*/

                        presupuestos.$add(pPresupuesto)
                            .then(function(ref) {
                                utilsService.writeConsole("[MirrorBudgetController] - copyPresupuesto(pPresupuesto,pEvent) => Added new record to 'presupuestos'", WRITE_IN_CONSOLE);

                                var nuevoPresupuestoKey = ref.key;

                                //AÑADIMOS UN NUEVO REGISTRO EN LA TABLA "usuario_exportaciones"
                                var newRecord = {
                                    "usuario_presupuesto_key": pPresupuesto.usuario_key + "&" + nuevoPresupuestoKey,
                                    "usuario_key": pPresupuesto.usuario_key,
                                    "presupuesto_key": nuevoPresupuestoKey,
                                    "usuario": pPresupuesto.usuario,
                                    "codigoPresupuesto": pPresupuesto.codigo,
                                    "fechaTimestamp": pPresupuesto.fechaTimestamp,
                                    "cliente": pPresupuesto.cliente,
                                    "tipo": pPresupuesto.tipo,
                                    "unidades": pPresupuesto.unidades,
                                    "importe": pPresupuesto.importe,
                                    "numeroPD": pPresupuesto.numeroPD,
                                    "numeroPC": pPresupuesto.numeroPC,
                                    "estado": pPresupuesto.estado
                                }

                                vm.copyPresupuestoToUsuarioPresupuestosTable(newRecord,pEvent);

                            })
                            .catch(function(error) {
                                utilsService.writeConsole("[MirrorBudgetController] - copyPresupuesto(pPresupuesto,pEvent) => ERROR: " + error, WRITE_IN_CONSOLE); 
                            }
                        );

                    } else {

                        //Asignamos el primer nº de presupuesto
                        pPresupuesto.codigo = "PR-000001";

                        //Asignamos el primer número de PD
                        pPresupuesto.numeroPD = "PD-000001";
                        pPresupuesto.numeroPC = "?";

                        presupuestos.$add(pPresupuesto)
                            .then(function(ref) {
                                utilsService.writeConsole("[MirrorBudgetController] - copyPresupuesto(pPresupuesto,pEvent) => Added new record to 'presupuestos'", WRITE_IN_CONSOLE);

                                var nuevoPresupuestoKey = ref.key;

                                //AÑADIMOS UN NUEVO REGISTRO EN LA TABLA "usuario_exportaciones"
                                var newRecord = {
                                    "usuario_presupuesto_key": pPresupuesto.usuario_key + "&" + nuevoPresupuestoKey,
                                    "usuario_key": pPresupuesto.usuario_key,
                                    "presupuesto_key": nuevoPresupuestoKey,
                                    "usuario": pPresupuesto.usuario,
                                    "codigoPresupuesto": pPresupuesto.codigo,
                                    "fechaTimestamp": pPresupuesto.fechaTimestamp,
                                    "cliente": pPresupuesto.cliente,
                                    "tipo": pPresupuesto.tipo,
                                    "unidades": pPresupuesto.unidades,
                                    "importe": pPresupuesto.importe,
                                    "numeroPD": pPresupuesto.numeroPD,
                                    "numeroPC": pPresupuesto.numeroPC,
                                    "estado": pPresupuesto.estado
                                }

                                vm.copyPresupuestoToUsuarioPresupuestosTable(newRecord,pEvent);

                            })
                            .catch(function(error) {
                                utilsService.writeConsole("[MirrorBudgetController] - copyPresupuesto(pPresupuesto,pEvent) => ERROR: " + error, WRITE_IN_CONSOLE); 
                            }
                        );


                    }
                })

                .catch(function(error) {
                    presupuestos = null;
                    utilsService.writeConsole("[MirrorBudgetController] => copyPresupuesto(pPresupuesto,pEvent) => ERROR al obtener los datos del presupuesto actual: " + error, WRITE_IN_CONSOLE);
                }
            );
        }



        //***************************************************************
        function copyPresupuestoToUsuarioPresupuestosTable(pNewRecord,pEvent) {

            var nuevoPresupuestoKey = pNewRecord.presupuesto_key;

            var fbUrl = firebaseDataService.usuario_presupuestos;
            var records = $firebaseArray(fbUrl.limitToLast(1));

            records.$add(pNewRecord)
                .then(function(ref) {
                    utilsService.writeConsole("[BudgetsController] => copyPresupuestoToUsuarioPresupuestosTable() => Added new record to 'usuario_presupuestos'", WRITE_IN_CONSOLE);

                    //Redirigimos a la página de selección de tipo de presupuesto.
                    var tipoPresupuesto = "¿?";
                    vm.showMenuDialog(pEvent,nuevoPresupuestoKey,tipoPresupuesto);

                })
                .catch(function(error) {
                    utilsService.writeConsole("[BudgetsController] => copyPresupuestoToUsuarioPresupuestosTable() => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }


        //***************************************************************
        function checkMaxValue(pValue) {

if (!vm.isAdministrator) {
            //Para medida exterior
            if (vm.presupuestoEspejo.medidaExteriorValorString == "true") {
                if (pValue > 200) {
                    vm.showAlertDialog("No se permite un valor superior a 200 cm para la enmarcación");
                    return false;
                }

            //Para medida interior
            } else {
                if (pValue > 180) {
                    vm.showAlertDialog("No se permite un valor superior a 180 cm para la enmarcación");
                    return false;
                }
            }
}
            return true;
        }



        //***************************************************************
        function desplegarContraerContenido(pDesplegado, pNombreCapa)
        {

            //Para la capa de MEDIDAS
            if (pNombreCapa == "capaMedidas") {
                vm.desplegadoContenidoMedidas = !vm.desplegadoContenidoMedidas;
                vm.pDesplegado = !vm.pDesplegado;           

                if (pDesplegado) {
                    vm.iconoDesplegarContraerMedidas = "icon-chevron-down";
                    vm.textoDesplegarContraerMedidas = "desplegar"
                } else {
                    vm.iconoDesplegarContraerMedidas = "icon-chevron-up";
                    vm.textoDesplegarContraerMedidas = "contraer";
                }
            }            

            //Para la capa de MOLDURA 1
            else if (pNombreCapa == "capaMoldura1") {
                
                vm.desplegadoContenidoMoldura1 = !vm.desplegadoContenidoMoldura1;
                vm.pDesplegado = !vm.pDesplegado;           

                if (pDesplegado) {
                    vm.iconoDesplegarContraerMoldura1 = "icon-chevron-down";
                    vm.textoDesplegarContraerMoldura1 = "desplegar"
                } else {
                    vm.iconoDesplegarContraerMoldura1 = "icon-chevron-up";
                    vm.textoDesplegarContraerMoldura1 = "contraer";
                }
            }            

            //Para la capa de MOLDURA 2
            else if (pNombreCapa == "capaMoldura2") {
                
                vm.desplegadoContenidoMoldura2 = !vm.desplegadoContenidoMoldura2;
                vm.pDesplegado = !vm.pDesplegado;           

                if (pDesplegado) {
                    vm.iconoDesplegarContraerMoldura2 = "icon-chevron-down";
                    vm.textoDesplegarContraerMoldura2 = "desplegar"
                } else {
                    vm.iconoDesplegarContraerMoldura2 = "icon-chevron-up";
                    vm.textoDesplegarContraerMoldura2 = "contraer";
                }
            }            

            //Para la capa de UNIDADES
            if (pNombreCapa == "capaUnidades") {
                vm.desplegadoContenidoUnidades = !vm.desplegadoContenidoUnidades;
                vm.pDesplegado = !vm.pDesplegado;           

                if (pDesplegado) {
                    vm.iconoDesplegarContraerUnidades = "icon-chevron-down";
                    vm.textoDesplegarContraerUnidades = "desplegar"
                } else {
                    vm.iconoDesplegarContraerUnidades = "icon-chevron-up";
                    vm.textoDesplegarContraerUnidades = "contraer";
                }
            }            

        }


        //***************************************************************
        function omitirPaso(pNombreCapa)
        {

            if (pNombreCapa == "moldura2") {

                if (vm.presupuestoEspejo.numeroMoldura1 == null ) {
                    vm.showAlertDialog("Recuerda que debes insertar como mínimo la moldura 1.")
                    return;
                }

if (!vm.isAdministrator) {
                //Comprobamos si las dimensiones de la moldura 1 superan la limitación de 70 cm
                if (vm.moldura1Seleccionada.limitacion70cm) {

                    var nuevoAncho = vm.presupuestoEspejo.width;
                    var nuevoAlto = vm.presupuestoEspejo.height;

                    if ( (nuevoAncho > 70) || (nuevoAlto > 70) ) {
                        vm.showAlertDialog("La moldura 1 insertada no permite que alguno de sus lados supere los 70 cm."); 

                        //Inicializamos todos los valores del presupuesto
                        vm.resetValoresPresupuesto("MOLDURA1",false);
                        vm.gotoStep('moldura1');
                        return;
                    }
                }
}
                vm.resetValoresPresupuesto('MOLDURA2',false);

                vm.presupuestoEspejo.widthMoldura2 = 0;
                vm.presupuestoEspejo.heightMoldura2 = 0;

                vm.gotoStep('unidades');

            } 
        }



        //***************************************************************
        function gotoStep(pNombreCapa)
        {
            if (pNombreCapa == "presupuestos") {

                $state.go('app.menu_presupuestos');

            } else if (pNombreCapa == "medidas") {

                //Mostramos la capa Medidas
                vm.iconoDesplegarContraerMedidas = "icon-chevron-up";
                vm.textoDesplegarContraerMedidas = "contraer";
                vm.desplegadoContenidoMedidas = true;

                vm.iconoDesplegarContraerMoldura1 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura1 = "desplegar";
                vm.desplegadoContenidoMoldura1 = false;

                vm.iconoDesplegarContraerMoldura2 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura2 = "desplegar";
                vm.desplegadoContenidoMoldura2 = false;

                vm.iconoDesplegarContraerUnidades = "icon-chevron-down";
                vm.textoDesplegarContraerUnidades = "desplegar";
                vm.desplegadoContenidoUnidades = false;

            } else if (pNombreCapa == "moldura1") {

                vm.iconoDesplegarContraerMedidas = "icon-chevron-down";
                vm.textoDesplegarContraerMedidas = "desplegar";
                vm.desplegadoContenidoMedidas = false;

                //Mostramos la capa Moldura 1
                vm.iconoDesplegarContraerMoldura1 = "icon-chevron-up";
                vm.textoDesplegarContraerMoldura1 = "contraer";
                vm.desplegadoContenidoMoldura1 = true;

                vm.iconoDesplegarContraerMoldura2 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura2 = "desplegar";
                vm.desplegadoContenidoMoldura2 = false;

                vm.iconoDesplegarContraerUnidades = "icon-chevron-down";
                vm.textoDesplegarContraerUnidades = "desplegar";
                vm.desplegadoContenidoUnidades = false;

            } else if (pNombreCapa == "moldura2") {

                vm.iconoDesplegarContraerMedidas = "icon-chevron-down";
                vm.textoDesplegarContraerMedidas = "desplegar";
                vm.desplegadoContenidoMedidas = false;

                vm.iconoDesplegarContraerMoldura1 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura1 = "desplegar";
                vm.desplegadoContenidoMoldura1 = false;

                //Mostramos la capa Moldura 2
                vm.iconoDesplegarContraerMoldura2 = "icon-chevron-up";
                vm.textoDesplegarContraerMoldura2 = "contraer";
                vm.desplegadoContenidoMoldura2 = true;

                vm.iconoDesplegarContraerUnidades = "icon-chevron-down";
                vm.textoDesplegarContraerUnidades = "desplegar";
                vm.desplegadoContenidoUnidades = false;

            } else if (pNombreCapa == "unidades") {

                vm.iconoDesplegarContraerMedidas = "icon-chevron-down";
                vm.textoDesplegarContraerMedidas = "desplegar";
                vm.desplegadoContenidoMedidas = false;

                vm.iconoDesplegarContraerMoldura1 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura1 = "desplegar";
                vm.desplegadoContenidoMoldura1 = false;

                vm.iconoDesplegarContraerMoldura2 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura2 = "desplegar";
                vm.desplegadoContenidoMoldura2 = false;

                //Mostramos la capa Unidades
                vm.iconoDesplegarContraerUnidades = "icon-chevron-up";
                vm.textoDesplegarContraerUnidades = "contraer";
                vm.desplegadoContenidoUnidades = true;

                vm.activarBotonCalcularPresupuesto = true;
                
            }

        }



        //***************************************************************
        function resetValoresPresupuesto(pMoldura,pResetElementoAnterior) {

            //Para Espejo
            if (pMoldura == "ESPEJO") {

                vm.numeroEspejo = null;
                vm.espejoSeleccionado = null;

                vm.presupuestoEspejo.numeroEspejo = null;
                vm.presupuestoEspejo.refLeroyMerlinEspejo = null;
                vm.presupuestoEspejo.descripcionEspejo = "";
                vm.presupuestoEspejo.multiplicadorEspejo = 0;
                vm.presupuestoEspejo.subtotalEspejo = 0;

                //Actualizamos los importes del subtotal y total
                try {
                        var subtotalEspejo = 0;
                        var subtotalTrasera = Number((vm.presupuestoEspejo.subtotalTrasera).toFixed(2));
                        var subtotalParte1 = Number((vm.presupuestoEspejo.subtotalMoldura1).toFixed(2));
                        var subtotalParte2 = Number((vm.presupuestoEspejo.subtotalMoldura2).toFixed(2));
                        vm.presupuestoEspejo.subtotal = Number( (subtotalEspejo + subtotalTrasera + subtotalParte1 + subtotalParte2).toFixed(2) );     

                        vm.presupuestoEspejo.total =  Number((vm.presupuestoEspejo.subtotal * vm.presupuestoEspejo.unidades).toFixed(2));

                } catch (error) {
                        vm.presupuestoEspejo.subtotal = 0;     
                        vm.presupuestoEspejo.total =  0;
                }

                vm.muestraLineaPresupuestoParaEspejo = false;
                vm.activarBotonSiguienteParaMedidas = false;


            //Para trasera
            } else if (pMoldura == "TRASERA") {

                vm.numeroTrasera = null;
                vm.traseraSeleccionada = null;

                vm.presupuestoEspejo.numeroTrasera = null;
                vm.presupuestoEspejo.refLeroyMerlinTrasera = null;
                vm.presupuestoEspejo.descripcionTrasera = "";
                vm.presupuestoEspejo.multiplicadorTrasera = 0;
                vm.presupuestoEspejo.subtotalTrasera = 0;

                //Actualizamos los importes del subtotal y total
                try {
                        var subtotalEspejo = Number((vm.presupuestoEspejo.subtotalEspejo).toFixed(2));
                        var subtotalTrasera = 0;
                        var subtotalParte1 = Number((vm.presupuestoEspejo.subtotalMoldura1).toFixed(2));
                        var subtotalParte2 = Number((vm.presupuestoEspejo.subtotalMoldura2).toFixed(2));
                        vm.presupuestoEspejo.subtotal = Number( (subtotalEspejo + subtotalTrasera + subtotalParte1 + subtotalParte2).toFixed(2) );

                        vm.presupuestoEspejo.total =  Number((vm.presupuestoEspejo.subtotal * vm.presupuestoEspejo.unidades).toFixed(2));

                } catch (error) {
                        vm.presupuestoEspejo.subtotal = 0;     
                        vm.presupuestoEspejo.total =  0;
                }

                vm.muestraLineaPresupuestoParaTrasera = false;
                vm.activarBotonSiguienteParaMedidas = false;


            //Para moldura1
            } else if (pMoldura == "MOLDURA1") {

                vm.numeroMoldura1 = null;
                vm.moldura1Seleccionada = null;

                vm.presupuestoEspejo.numeroMoldura1 = null;
                vm.presupuestoEspejo.refLeroyMerlinMoldura1 = null;
                vm.presupuestoEspejo.descripcion1 = "";
                vm.presupuestoEspejo.multiplicadorMoldura1 = 0;
                vm.presupuestoEspejo.subtotalMoldura1 = 0;

                //Actualizamos los importes del subtotal y total
                try {
                        var subtotalEspejo = Number((vm.presupuestoEspejo.subtotalEspejo).toFixed(2));
                        var subtotalTrasera = Number((vm.presupuestoEspejo.subtotalTrasera).toFixed(2));
                        var subtotalParte1 = 0;
                        var subtotalParte2 = Number((vm.presupuestoEspejo.subtotalMoldura2).toFixed(2));
                        vm.presupuestoEspejo.subtotal = Number( (subtotalEspejo + subtotalTrasera + subtotalParte1 + subtotalParte2).toFixed(2) );

                        vm.presupuestoEspejo.total =  Number((vm.presupuestoEspejo.subtotal * vm.presupuestoEspejo.unidades).toFixed(2));

                } catch (error) {
                        vm.presupuestoEspejo.subtotal = 0;     
                        vm.presupuestoEspejo.total =  0;
                }

                vm.muestraLineaPresupuestoParaMoldura1 = false;
                vm.activarBotonSiguienteParaMoldura1 = false;

                vm.presupuestoEspejo.urlImagen1 = "";
                document.getElementById("moldingImage1").src = "";

                vm.presupuestoEspejo.urlImagenPerfil1 = "";
                document.getElementById("outlineImage1").src = "";

                //Realizamos el reset del moldura 2
                vm.resetValoresPresupuesto("MOLDURA2",false);


            //Para moldura2
            } else if (pMoldura == "MOLDURA2") {

                //Reseteamos los valores del elemento anterior (en este caso MOLDURA1)
                if (pResetElementoAnterior) {

                    vm.resetValoresPresupuesto('MOLDURA1',false);
                    return;
                }

                vm.numeroMoldura2 = null;
                vm.moldura2Seleccionada = null;

                vm.presupuestoEspejo.numeroMoldura2 = null;
                vm.presupuestoEspejo.refLeroyMerlinMoldura2 = null;
                vm.presupuestoEspejo.descripcion2 = "";
                vm.presupuestoEspejo.multiplicadorMoldura2 = 0;
                vm.presupuestoEspejo.subtotalMoldura2 = 0;

                //Actualizamos los importes del subtotal y total
                try {
                        var subtotalEspejo = Number((vm.presupuestoEspejo.subtotalEspejo).toFixed(2));
                        var subtotalTrasera = Number((vm.presupuestoEspejo.subtotalTrasera).toFixed(2));
                        var subtotalParte1 = Number((vm.presupuestoEspejo.subtotalMoldura1).toFixed(2));
                        var subtotalParte2 = 0;
                        vm.presupuestoEspejo.subtotal = Number( (subtotalEspejo + subtotalTrasera + subtotalParte1 + subtotalParte2).toFixed(2) );  

                        vm.presupuestoEspejo.total =  Number((vm.presupuestoEspejo.subtotal * vm.presupuestoEspejo.unidades).toFixed(2));

                } catch (error) {
                        vm.presupuestoEspejo.subtotal = 0;     
                        vm.presupuestoEspejo.total =  0;
                }

                vm.muestraLineaPresupuestoParaMoldura2 = false;
                vm.activarBotonSiguienteParaMoldura2 = false;

                vm.presupuestoEspejo.urlImagen2 = "";
                document.getElementById("moldingImage2").src = "";

                vm.presupuestoEspejo.urlImagenPerfil2 = "";
                document.getElementById("outlineImage2").src = "";


            //PARA TODAS LAS MOLDURAS (INCLUIDO EL ESPEJO)
            } else {

                //Espejo
                vm.numeroEspejo = null;
                vm.espejoSeleccionado = null;

                vm.presupuestoEspejo.numeroEspejo = null;
                vm.presupuestoEspejo.refLeroyMerlinEspejo = null;
                vm.presupuestoEspejo.descripcionEspejo = "";
                vm.presupuestoEspejo.multiplicadorEspejo = 0;
                vm.presupuestoEspejo.subtotalEspejo = 0;

                vm.muestraLineaPresupuestoParaEspejo = false;

                //Trasera
                vm.numeroTrasera = null;
                vm.traseraSeleccionada = null;

                vm.presupuestoEspejo.numeroTrasera = null;
                vm.presupuestoEspejo.refLeroyMerlinTrasera = null;
                vm.presupuestoEspejo.descripcionTrasera = "";
                vm.presupuestoEspejo.multiplicadorTrasera = 0;
                vm.presupuestoEspejo.subtotalTrasera = 0;

                vm.muestraLineaPresupuestoParaTrasera = false;

                vm.activarBotonSiguienteParaMedidas = false;


                //Moldura 1
                vm.numeroMoldura1 = null;
                vm.moldura1Seleccionada = null;

                vm.presupuestoEspejo.numeroMoldura1 = null;
                vm.presupuestoEspejo.refLeroyMerlinMoldura1 = null;
                vm.presupuestoEspejo.descripcion1 = "";
                vm.presupuestoEspejo.multiplicadorMoldura1 = 0;
                vm.presupuestoEspejo.subtotalMoldura1 = 0;

                vm.presupuestoEspejo.urlImagen1 = "";
                document.getElementById("moldingImage1").src = "";

                vm.presupuestoEspejo.urlImagenPerfil1 = "";
                document.getElementById("outlineImage1").src = "";

                vm.muestraLineaPresupuestoParaMoldura1 = false;
                vm.activarBotonSiguienteParaMoldura1 = false;

                //Moldura 2
                vm.numeroMoldura2 = null;
                vm.moldura2Seleccionada = null;

                vm.presupuestoEspejo.numeroMoldura2 = null;
                vm.presupuestoEspejo.refLeroyMerlinMoldura2 = null;
                vm.presupuestoEspejo.descripcion2 = "";
                vm.presupuestoEspejo.multiplicadorMoldura2 = 0;
                vm.presupuestoEspejo.subtotalMoldura2 = 0;

                vm.presupuestoEspejo.urlImagen2 = "";
                document.getElementById("moldingImage2").src = "";

                vm.presupuestoEspejo.urlImagenPerfil2 = "";
                document.getElementById("outlineImage2").src = "";

                //Reseteamos los importes del subtotal y total
                vm.presupuestoEspejo.subtotal =  0;
                vm.presupuestoEspejo.total =  0; 
                
                vm.muestraLineaPresupuestoParaMoldura2 = false;
                vm.activarBotonSiguienteParaMoldura2 = false;    

                vm.budgetCalculated = false;
            }


            //RESETEAMOS LOS VALORES DE LOS SUBTOTALES PARA MOLDURAS1 y 2 Y CRISTAL-TRASERA, ADEMÁS DEL SUBTOTAL Y TOTAL DEL PRESUPUESTO
            vm.resetMultiplicadoresSubtotales();

            vm.activarBotonCalcularPresupuesto = false;
            
        }



        //***************************************************************
        function insertarEspejo() {

/*
            vm.presupuestoEspejo.width = Number(vm.presupuestoEspejo.width);
            vm.presupuestoEspejo.height = Number(vm.presupuestoEspejo.height);
*/
            if ( (vm.presupuestoEspejo.width==null) || (vm.presupuestoEspejo.height==null) || (vm.presupuestoEspejo.width<=0) || (vm.presupuestoEspejo.height<=0) ) {
                vm.showAlertDialog("Debes insertar las medidas del espejo.")
                return;
            }

            //Comprobamos el valor máximo para el ancho y el alto => en medida EXTERIOR no mayor de 200cm y en medida INTERIOR no mayor de 180cm
            if (!vm.checkMaxValue(vm.presupuestoEspejo.width)) {
                return;
            }

            if (!vm.checkMaxValue(vm.presupuestoEspejo.height)) {
                return;
            }
            
            vm.activarBotonSiguienteParaMedidas = true;

            //Calculamos el area del espejo para ver si debemos asignar un espejo de 3mm o de 5mm
            var areaEspejo = (Number(vm.presupuestoEspejo.width)/100) * (Number(vm.presupuestoEspejo.height)/100);
            var numeroArticulo = "";

            //Si area > 0.64 asignamos el espejo de 5mm
            if (areaEspejo > 0.64) {
                    numeroArticulo = "E-2";

            //Si area <= 0.64 asignamos espejo de 3mm
            } else {
                    numeroArticulo = "E-1";
            }

            var fbUrl = firebaseDataService.productos_varios;
            var result;
            try {
                result = $firebaseArray(fbUrl.orderByChild("numeroArticulo").equalTo(numeroArticulo));
            } catch(error) {
                return;
            }

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    if (dataLength > 0) {

                        //Obtenemos el espejo seleccionado
                        vm.espejoSeleccionado = data[0];

                        //Asignamos los valores del presupuesto.
                        vm.presupuestoEspejo.numeroEspejo = vm.espejoSeleccionado.numeroArticulo;
                        vm.presupuestoEspejo.refLeroyMerlinEspejo = vm.espejoSeleccionado.refLeroyMerlin;
                        vm.presupuestoEspejo.descripcionEspejo = vm.espejoSeleccionado.descripcion;
                        vm.presupuestoEspejo.precioLeroyMerlinEspejo = vm.espejoSeleccionado.precioLeroyMerlin;
                        vm.presupuestoEspejo.precioCosteEspejo = vm.espejoSeleccionado.precioCoste;

                        //RESETEAMOS LOS VALORES DE LOS SUBTOTALES PARA MOLDURAS1 y 2 Y CRISTAL-TRASERA, ADEMÁS DEL SUBTOTAL Y TOTAL DEL PRESUPUESTO
                        vm.resetMultiplicadoresSubtotales();

                        vm.muestraLineaPresupuestoParaEspejo = true;

                        //Insertamos la trasera de tipo "DM" (siempre es la que se inserta para el caso de enmarcación de espejos)
                        vm.insertarTrasera();

                    } else {

                        vm.espejoSeleccionado = null;
                        vm.resetValoresPresupuesto("ESPEJO",false);

                    }

                })

                .catch(function(error) {

                    utilsService.writeConsole("[MirrorBudgetController] => insertarEspejo() => ERROR: " + error, WRITE_IN_CONSOLE);

                    vm.espejoSeleccionado = null;
                }
            );            

        }



        //***************************************************************
        function insertarTrasera() {

            var fbUrl = firebaseDataService.productos_varios;
            var result;
            try {
                result = $firebaseArray(fbUrl.orderByChild("numeroArticulo").equalTo("T-1"));       //La trasera tipo "DM" tiene numeroArticulo="T-1"
            } catch(error) {
                return;
            }

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    if (dataLength > 0) {

                        //Obtenemos la trasera seleccionada
                        vm.traseraSeleccionada = data[0];

                        //Asignamos los valores del presupuesto.
                        vm.presupuestoEspejo.numeroTrasera = vm.traseraSeleccionada.numeroArticulo;
                        vm.presupuestoEspejo.refLeroyMerlinTrasera = vm.traseraSeleccionada.refLeroyMerlin;
                        vm.presupuestoEspejo.descripcionTrasera = vm.traseraSeleccionada.descripcion;
                        vm.presupuestoEspejo.precioLeroyMerlinTrasera = vm.traseraSeleccionada.precioLeroyMerlin;
                        vm.presupuestoEspejo.precioCosteTrasera = vm.traseraSeleccionada.precioCoste;

                        //RESETEAMOS LOS VALORES DE LOS SUBTOTALES PARA MOLDURAS1 y 2 Y CRISTAL-TRASERA, ADEMÁS DEL SUBTOTAL Y TOTAL DEL PRESUPUESTO
                        vm.resetMultiplicadoresSubtotales();

                        vm.muestraLineaPresupuestoParaTrasera = true;

                    } else {

                        vm.traseraSeleccionada = null;
                        vm.resetValoresPresupuesto("TRASERA",false);
                    }

                })

                .catch(function(error) {

                    utilsService.writeConsole("[MirrorBudgetController] => insertarTrasera() => ERROR: " + error, WRITE_IN_CONSOLE);

                    vm.traseraSeleccionada = null;
                }
            );            

        }




        //***************************************************************
        function insertarMoldura1(pNumeroMoldura) {

            if ( pNumeroMoldura == null ) {
                vm.showAlertDialog("Debes insertar una moldura.")
                return;
            }

            vm.activarBotonSiguienteParaMoldura1 = true;

            var fbUrl = firebaseDataService.productos_moldura;
            var result;
            try {
                result = $firebaseArray(fbUrl.orderByChild("numeroMoldura").equalTo(parseInt(pNumeroMoldura)));
            } catch(error) {
                return;
            }

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    if (dataLength > 0) {

                        //Obtenemos la moldura seleccionada
                        vm.moldura1Seleccionada = data[0];

                        //Convertimos algunos valores en números
                        vm.presupuestoEspejo.height = Number(vm.presupuestoEspejo.height);
                        vm.presupuestoEspejo.width = Number(vm.presupuestoEspejo.width);

/*
                        //Comprobamos si las dimensiones del espejo superan la limitación de 70 cm
                        if (vm.moldura1Seleccionada.limitacion70cm) {

                            if ( (vm.presupuestoEspejo.width > 70) || (vm.presupuestoEspejo.height > 70) ) {
                                    vm.showAlertDialog("Esta moldura no permite que el ancho o el alto supere los 70 cm.");

                                    //Inicializamos todos los valores del presupuesto
                                    vm.resetValoresPresupuesto("MOLDURA1",false);
                                    
                                    return;
                            }
                        }
*/

                        //Asignamos los valores del presupuesto.
                        vm.presupuestoEspejo.numeroMoldura1 = vm.moldura1Seleccionada.numeroMoldura;
                        vm.presupuestoEspejo.refLeroyMerlinMoldura1 = vm.moldura1Seleccionada.refLeroyMerlin;
                        vm.presupuestoEspejo.descripcion1 = vm.moldura1Seleccionada.descripcion;
                        vm.presupuestoEspejo.precioLeroyMerlin1 = vm.moldura1Seleccionada.precioLeroyMerlin;
                        vm.presupuestoEspejo.precioCoste1 = vm.moldura1Seleccionada.precioCoste;
                        vm.presupuestoEspejo.desperdicio1 = vm.moldura1Seleccionada.desperdicio;

                        //RESETEAMOS LOS VALORES DE LOS SUBTOTALES PARA MOLDURAS1 y 2 Y CRISTAL-TRASERA, ADEMÁS DEL SUBTOTAL Y TOTAL DEL PRESUPUESTO
                        vm.resetMultiplicadoresSubtotales();

                        vm.muestraLineaPresupuestoParaMoldura1 = true;
                        vm.activarBotonSiguienteParaMoldura1 = true;

                        if (vm.moldura1Seleccionada.urlImagen != null) {
                            vm.presupuestoEspejo.urlImagen1 = vm.moldura1Seleccionada.urlImagen;
                            document.getElementById("moldingImage1").src = vm.presupuestoEspejo.urlImagen1;
                        }

                        if (vm.moldura1Seleccionada.urlImagenPerfil != null) {
                            vm.presupuestoEspejo.urlImagenPerfil1 = vm.moldura1Seleccionada.urlImagenPerfil;
                            document.getElementById("outlineImage1").src = vm.presupuestoEspejo.urlImagenPerfil1;
                        }

                    } else {

                        vm.moldura1Seleccionada = null;
                        vm.resetValoresPresupuesto("MOLDURA1",false);
                    }

                })

                .catch(function(error) {

                    utilsService.writeConsole("[MirrorBudgetController] => insertarMoldura1() => ERROR: " + error, WRITE_IN_CONSOLE);

                    vm.moldura1Seleccionada = null;
                }
            );            

        }



        //***************************************************************
        function actualizaTotalPresupuesto() { 

             vm.presupuestoEspejo.total =  Number((vm.presupuestoEspejo.subtotal * vm.presupuestoEspejo.unidades).toFixed(2));
         }




        //***************************************************************
        function insertarMoldura2(pNumeroMoldura) {

            if ( pNumeroMoldura == null ) {
                vm.showAlertDialog("Debes insertar una moldura.")
                return;
            }

            vm.activarBotonSiguienteParaMoldura2 = true;

            var fbUrl = firebaseDataService.productos_moldura;
            var result;
            try {
                result = $firebaseArray(fbUrl.orderByChild("numeroMoldura").equalTo(parseInt(pNumeroMoldura)));
            } catch(error) {
                return;
            }

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    if (dataLength > 0) {

                        //Obtenemos la moldura seleccionada
                        vm.moldura2Seleccionada = data[0];

                        vm.presupuestoEspejo.height = Number(vm.presupuestoEspejo.height);
                        vm.presupuestoEspejo.width = Number(vm.presupuestoEspejo.width);

/*
                        //Comprobamos si las dimensiones de la moldura 2 superan la limitación de 70 cm
                        if (vm.moldura2Seleccionada.limitacion70cm) {

                            if ( (vm.presupuestoEspejo.width > 70) || (vm.presupuestoEspejo.height > 70) ) {
                                    vm.showAlertDialog("Esta moldura no permite que el ancho o el alto supere los 70 cm.");

                                    //Inicializamos todos los valores del presupuesto
                                    vm.resetValoresPresupuesto("MOLDURA2",false);
                                    
                                    return;
                            }
                        }
*/

                        //Asignamos los valores del presupuesto para la moldura2 y para el total del presupuesto.
                        vm.presupuestoEspejo.numeroMoldura2 = vm.moldura2Seleccionada.numeroMoldura;
                        vm.presupuestoEspejo.refLeroyMerlinMoldura2 = vm.moldura2Seleccionada.refLeroyMerlin;
                        vm.presupuestoEspejo.descripcion2 = vm.moldura2Seleccionada.descripcion;
                        vm.presupuestoEspejo.precioLeroyMerlin2 = vm.moldura2Seleccionada.precioLeroyMerlin;
                        vm.presupuestoEspejo.precioCoste2 = vm.moldura2Seleccionada.precioCoste;
                        vm.presupuestoEspejo.desperdicio2 = vm.moldura2Seleccionada.desperdicio;

                        //RESETEAMOS LOS VALORES DE LOS SUBTOTALES PARA MOLDURAS1 y 2 Y CRISTAL-TRASERA, ADEMÁS DEL SUBTOTAL Y TOTAL DEL PRESUPUESTO
                        vm.resetMultiplicadoresSubtotales();

                        vm.muestraLineaPresupuestoParaMoldura2 = true;
                        vm.activarBotonSiguienteParaMoldura2 = true;
                        vm.activarBotonCalcularPresupuesto = true;

                        if (vm.moldura2Seleccionada.urlImagen != null) {
                            vm.presupuestoEspejo.urlImagen2 = vm.moldura2Seleccionada.urlImagen;
                            document.getElementById("moldingImage2").src = vm.presupuestoEspejo.urlImagen2;
                        }

                        if (vm.moldura2Seleccionada.urlImagenPerfil != null) {
                            vm.presupuestoEspejo.urlImagenPerfil2 = vm.moldura2Seleccionada.urlImagenPerfil;
                            document.getElementById("outlineImage2").src = vm.presupuestoEspejo.urlImagenPerfil2;
                        }

                    } else {

                        vm.moldura2Seleccionada = null;
                        vm.resetValoresPresupuesto("MOLDURA2",false);
                    }

                })

                .catch(function(error) {

                    utilsService.writeConsole("[MirrorBudgetController] => insertarMoldura2() => ERROR: " + error, WRITE_IN_CONSOLE);

                    vm.moldura2Seleccionada = null;
                }
            );            

        }



        //*************************************************************** 
        function resetMultiplicadoresSubtotales() {

            //RESETEAMOS LOS VALORES DE LOS MULTIPLICADORES Y SUBTOTALES PARA MOLDURAS 1 y 2 Y ESPEJO-TRASERA, ADEMÁS DEL SUBTOTAL Y TOTAL DEL PRESUPUESTO
            vm.presupuestoEspejo.multiplicadorMoldura1 = 0;
            vm.presupuestoEspejo.multiplicadorMoldura2 = 0;
            vm.presupuestoEspejo.multiplicadorEspejo = 0;
            vm.presupuestoEspejo.multiplicadorTrasera = 0;

            vm.presupuestoEspejo.subtotalMoldura1 = 0;
            vm.presupuestoEspejo.subtotalMoldura2 = 0;
            vm.presupuestoEspejo.subtotalEspejo = 0;
            vm.presupuestoEspejo.subtotalTrasera = 0;

            vm.presupuestoEspejo.subtotal = 0;
            vm.presupuestoEspejo.total =  0;

            vm.budgetCalculated = false;
        }



        //***************************************************************
        function getMedidasMoldura1() {
    
            var nuevoAncho = 0;
            var nuevoAlto = 0;

            if (vm.presupuestoEspejo.medidaExteriorValorString == "false") {

                var anchuraMoldura1 = Number(vm.presupuestoEspejo.desperdicio1);
                anchuraMoldura1 = 10*anchuraMoldura1;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM
                var desperdicioMoldura1 = 8*anchuraMoldura1;

                nuevoAncho = Number( (vm.presupuestoEspejo.width + 0.25*desperdicioMoldura1).toFixed(2) );
                nuevoAlto = Number( (vm.presupuestoEspejo.height + 0.25*desperdicioMoldura1).toFixed(2) );

                //Asignamos el ancho y alto total de la moldura1 (sin contar desperdicio de la moldura) => ESTE VALOR LO UTILIZAMOS PARA SABER EL ANCHO Y ALTO INICIAL PARA CALCULAR LA SIGUIENTE MOLDURA
                vm.presupuestoEspejo.widthMoldura1 = Number( (vm.presupuestoEspejo.width + 2*anchuraMoldura1).toFixed(2) );
                vm.presupuestoEspejo.heightMoldura1 = Number( (vm.presupuestoEspejo.height + 2*anchuraMoldura1).toFixed(2) );

            //CALCULO MULTIPLICADOR MOLDURA 1 PARA MEDIDA EXTERIOR
            } else {


                //PENDIENTE DE CALCULAR




            }

            var medidas = {
                    ancho: nuevoAncho,
                    alto: nuevoAlto
            };

            return medidas;
        }



        //***************************************************************
        function getMedidasMoldura2() {

            var nuevoAncho = 0;
            var nuevoAlto = 0;

            if (vm.presupuestoEspejo.medidaExteriorValorString == "false") {

                var anchuraMoldura1 = Number(vm.presupuestoEspejo.desperdicio1);
                var anchuraMoldura1 = 10*anchuraMoldura1;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM
                
                var anchuraMoldura2 = Number(vm.presupuestoEspejo.desperdicio2);
                anchuraMoldura2 = 10*anchuraMoldura2;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM
                var desperdicioMoldura2 = 8*anchuraMoldura2;

                nuevoAncho = Number( (vm.presupuestoEspejo.width + 2*anchuraMoldura1 + 0.25*desperdicioMoldura2).toFixed(2) );
                nuevoAlto = Number( (vm.presupuestoEspejo.height + 2*anchuraMoldura1 + 0.25*desperdicioMoldura2).toFixed(2) );

                //Asignamos el ancho y alto total de la moldura2 (sin contar desperdicio de la moldura) => ESTE VALOR LO UTILIZAMOS PARA SABER EL ANCHO Y ALTO INICIAL PARA CALCULAR LA SIGUIENTE MOLDURA
                vm.presupuestoEspejo.widthMoldura2 = Number( (vm.presupuestoEspejo.width + 2*anchuraMoldura1 + 2*anchuraMoldura2).toFixed(2) );
                vm.presupuestoEspejo.heightMoldura2 = Number( (vm.presupuestoEspejo.height + 2*anchuraMoldura1 + 2*anchuraMoldura2).toFixed(2) );

            //CALCULO MULTIPLICADOR MOLDURA 1 PARA MEDIDA EXTERIOR
            } else {


                //PENDIENTE DE CALCULAR


            }

            var medidas = {
                    ancho: nuevoAncho,
                    alto: nuevoAlto
            };

            return medidas;
        }



        //**************************************************************************************************
        function getMultiplicadorMolduraExteriorConImporteServicios(pClienteDejaObra,pAnchoMolduraExterior,pAltoMolduraExterior,pCalculoPvpMolduraExterior,pPrecioLinealMolduraExterior) {

            var zona = "S3";
            var importeMontaje = 0;
            var importeEmbalaje = 0;
            var importeTransporte = 0;

            //Cálculo de los metros cuadrados de la moldura más exterior
            var areaMetrosCuadrados = ( (pAnchoMolduraExterior/100) * (pAltoMolduraExterior/100) );

            //Determinación de la zona S1,S2 o S3
            if (areaMetrosCuadrados < 0.36) {
                zona = "S1";
            } else if ( (areaMetrosCuadrados >= 0.36) && (areaMetrosCuadrados< 0.98) ) {
                zona = "S2";
            } else if (areaMetrosCuadrados >= 0.98) {
                zona = "S3";
            }

            //Asignación de precios SI EL CLIENTE DEJA OBRA
            if (pClienteDejaObra) {

                if (zona == "S1") {
                    importeMontaje = preciosService.getMontajeConMotivoS1().precioLeroyMerlin;
                    importeEmbalaje = preciosService.getEmbalajeConMotivoS1().precioLeroyMerlin;
                    importeTransporte = preciosService.getTransporteConMotivoS1().precioLeroyMerlin;     

                } else if (zona == "S2") {
                    importeMontaje = preciosService.getMontajeConMotivoS2().precioLeroyMerlin;
                    importeEmbalaje = preciosService.getEmbalajeConMotivoS2().precioLeroyMerlin;
                    importeTransporte = preciosService.getTransporteConMotivoS2().precioLeroyMerlin;     

                } else {
                    importeMontaje = preciosService.getMontajeConMotivoS3().precioLeroyMerlin;
                    importeEmbalaje = preciosService.getEmbalajeConMotivoS3().precioLeroyMerlin;
                    importeTransporte = preciosService.getTransporteConMotivoS3().precioLeroyMerlin;     
                }

            //Asignación de precios SI EL CLIENTE NO DEJA OBRA
            } else {

                if (zona == "S1") {
                    importeMontaje = preciosService.getMontajeSinMotivoS1().precioLeroyMerlin;
                    importeEmbalaje = preciosService.getEmbalajeSinMotivoS1().precioLeroyMerlin;
                    importeTransporte = preciosService.getTransporteSinMotivoS1().precioLeroyMerlin;

                } else if (zona == "S2") {
                    importeMontaje = preciosService.getMontajeSinMotivoS2().precioLeroyMerlin;
                    importeEmbalaje = preciosService.getEmbalajeSinMotivoS2().precioLeroyMerlin;
                    importeTransporte = preciosService.getTransporteSinMotivoS2().precioLeroyMerlin;

                } else {
                    importeMontaje = preciosService.getMontajeSinMotivoS3().precioLeroyMerlin;
                    importeEmbalaje = preciosService.getEmbalajeSinMotivoS3().precioLeroyMerlin;
                    importeTransporte = preciosService.getTransporteSinMotivoS3().precioLeroyMerlin;
                }

            }


            //Cálculo del nuevo multiplicador de la moldura más externa
            var nuevoMultiplicadorMolduraExterior = ( (importeMontaje + importeEmbalaje + importeTransporte + pCalculoPvpMolduraExterior) / pPrecioLinealMolduraExterior );
            nuevoMultiplicadorMolduraExterior = Number(nuevoMultiplicadorMolduraExterior.toFixed(2));

            return nuevoMultiplicadorMolduraExterior;
        }



//**********************************************************************
//********** FUNCIÓN CÁLCULO DE PRESUPUESTO ****************************
//**********************************************************************
        function calculateBudget() {

            var nuevoAncho = 0;
            var nuevoAlto = 0;
            var medidas = {};

            var anchuraMoldura1 = 0;
            var anchuraMoldura2 = 0;

            //var subtotalPartePpt1 = 0;
            //var subtotalPartePpt2 = 0;
            var subtotalParte1 = 0;
            var subtotalParte2 = 0;
            //var subtotalParte3 = 0;
            var subtotalParte4 = 0;
            var subtotalParte5 = 0;


            //INICIALIZAMOS LOS VALORES PARA LAS MEDIDAS DE MOLDURAS, PPTs, Y LOS MULTIPLICADORES DE TODOS LOS ELEMENTOS A CALCULAR
            vm.presupuestoEspejo.widthMoldura1 = 0;
            vm.presupuestoEspejo.heightMoldura1 = 0;

            vm.presupuestoEspejo.widthMoldura2 = 0;
            vm.presupuestoEspejo.heightMoldura2 = 0;

            vm.presupuestoEspejo.multiplicadorMoldura1 = 0;
            vm.presupuestoEspejo.multiplicadorMoldura2 = 0;

            vm.presupuestoEspejo.subtotalMoldura1 = 0;
            vm.presupuestoEspejo.subtotalMoldura2 = 0;
            vm.presupuestoEspejo.subtotalCristal = 0;
            vm.presupuestoEspejo.subtotalTrasera = 0;


//CALCULO MULTIPLICADOR MOLDURA 1
            //CALCULO MULTIPLICADOR MOLDURA 1 PARA MEDIDA INTERIOR
            nuevoAncho = 0;
            nuevoAlto = 0;

            if (vm.presupuestoEspejo.medidaExteriorValorString == "false") {

                if (vm.presupuestoEspejo.numeroMoldura1 != null) {

                    //Obtenemos las medidas para la moldura1                
                    medidas = vm.getMedidasMoldura1();
                    nuevoAncho = medidas.ancho;
                    nuevoAlto = medidas.alto;

                    var multiplicadorMoldura1 = ((2*nuevoAncho + 2*nuevoAlto)/100);
                    vm.presupuestoEspejo.multiplicadorMoldura1 = Number(multiplicadorMoldura1.toFixed(2));

                    try {
                        vm.presupuestoEspejo.subtotalMoldura1 = Number((vm.presupuestoEspejo.multiplicadorMoldura1 * vm.moldura1Seleccionada.precioLeroyMerlin).toFixed(2));
                    } catch (error) {
                        vm.presupuestoEspejo.subtotalMoldura1 = 0;
                    }

                } else {

                    vm.presupuestoEspejo.widthMoldura1 = 0;
                    vm.presupuestoEspejo.heightMoldura1 = 0;
                    vm.presupuestoEspejo.multiplicadorMoldura1 = 0;
                    vm.presupuestoEspejo.subtotalMoldura1 = 0;                                        
                }



            //CALCULO MULTIPLICADOR MOLDURA 1 PARA MEDIDA EXTERIOR
            } else {

                if (vm.presupuestoEspejo.numeroMoldura1 != null) {

                    if (vm.presupuestoEspejo.numeroMoldura2 != null) {
                        anchuraMoldura2 = Number(vm.presupuestoEspejo.desperdicio2);
                        anchuraMoldura2 = 10*anchuraMoldura2;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM
                    } else {
                        anchuraMoldura2 = 0;
                    }

                    nuevoAncho = Number(vm.presupuestoEspejo.width - 2*(anchuraMoldura2));
                    nuevoAlto = Number(vm.presupuestoEspejo.height - 2*(anchuraMoldura2));

                    vm.presupuestoEspejo.widthMoldura1 = nuevoAncho;
                    vm.presupuestoEspejo.heightMoldura1 = nuevoAlto;

                    vm.presupuestoEspejo.multiplicadorMoldura1 = Number( ( 2*(nuevoAncho/100) + 2*(nuevoAlto/100) ).toFixed(2) );

                    try {
                        vm.presupuestoEspejo.subtotalMoldura1 = Number((vm.presupuestoEspejo.multiplicadorMoldura1 * vm.moldura1Seleccionada.precioLeroyMerlin).toFixed(2));
                    } catch (error) {
                        vm.presupuestoEspejo.subtotalMoldura1 = 0;
                    }

                } else {

                    vm.presupuestoEspejo.widthMoldura1 = 0;
                    vm.presupuestoEspejo.heightMoldura1 = 0;
                    vm.presupuestoEspejo.multiplicadorMoldura1 = 0;
                    vm.presupuestoEspejo.subtotalMoldura1 = 0;                    
                }
            }


//CALCULO MULTIPLICADOR MOLDURA 2
            //CALCULO MULTIPLICADOR MOLDURA 2 PARA MEDIDA INTERIOR
            nuevoAncho = 0;
            nuevoAlto = 0;


            if (vm.presupuestoEspejo.medidaExteriorValorString == "false") {

                if (vm.presupuestoEspejo.numeroMoldura2 != null) {

                    //Obtenemos las medidas para la moldura2               
                    medidas = vm.getMedidasMoldura2();
                    nuevoAncho = medidas.ancho;
                    nuevoAlto = medidas.alto;

                    vm.presupuestoEspejo.widthMoldura2 = nuevoAncho;
                    vm.presupuestoEspejo.heightMoldura2 = nuevoAlto;

                    var multiplicadorMoldura2 = ((2*nuevoAncho + 2*nuevoAlto)/100);
                    vm.presupuestoEspejo.multiplicadorMoldura2 = Number(multiplicadorMoldura2.toFixed(2));

                    try {
                        vm.presupuestoEspejo.subtotalMoldura2 = Number((vm.presupuestoEspejo.multiplicadorMoldura2 * vm.moldura2Seleccionada.precioLeroyMerlin).toFixed(2));
                    } catch (error) {
                        vm.presupuestoEspejo.subtotalMoldura2 = 0;
                    }

                } else {

                    vm.presupuestoEspejo.multiplicadorMoldura2 = 0;
                    vm.presupuestoEspejo.subtotalMoldura2 = 0;                    
                    vm.presupuestoEspejo.widthMoldura2 = 0;
                    vm.presupuestoEspejo.heightMoldura2 = 0;
                }


            //CALCULO MULTIPLICADOR MOLDURA 2 PARA MEDIDA EXTERIOR
            } else {

                if (vm.presupuestoEspejo.numeroMoldura2 != null) {

                    nuevoAncho = Number(vm.presupuestoEspejo.width);
                    nuevoAlto = Number(vm.presupuestoEspejo.height);

                    vm.presupuestoEspejo.widthMoldura2 = nuevoAncho;
                    vm.presupuestoEspejo.heightMoldura2 = nuevoAlto;

                    vm.presupuestoEspejo.multiplicadorMoldura2 = Number( (2*(nuevoAncho/100) + 2*(nuevoAlto/100)).toFixed(2) );

                    try {
                        vm.presupuestoEspejo.subtotalMoldura2 = Number((vm.presupuestoEspejo.multiplicadorMoldura2 * vm.moldura2Seleccionada.precioLeroyMerlin).toFixed(2));
                    } catch (error) {
                        vm.presupuestoEspejo.subtotalMoldura2 = 0;
                    }

                } else {

                    vm.presupuestoEspejo.multiplicadorMoldura2 = 0;
                    vm.presupuestoEspejo.subtotalMoldura2 = 0;                    
                    vm.presupuestoEspejo.widthMoldura2 = 0;
                    vm.presupuestoEspejo.heightMoldura2 = 0;
                }
            }


//CÁLCULO DEL MULTIPLICADOR PARA EL ESPEJO Y LA TRASERA
            //CALCULO MULTIPLICADOR ESPEJO y TRASERA PARA MEDIDA INTERIOR
            if (vm.presupuestoEspejo.medidaExteriorValorString == "false") {

                nuevoAncho = Number(vm.presupuestoEspejo.width);
                nuevoAlto = Number(vm.presupuestoEspejo.height);

                vm.presupuestoEspejo.multiplicadorEspejo = Number( ( (nuevoAncho/100) * (nuevoAlto/100) ).toFixed(2) );
                try {
                    vm.presupuestoEspejo.subtotalEspejo = Number((vm.presupuestoEspejo.multiplicadorEspejo * vm.espejoSeleccionado.precioLeroyMerlin).toFixed(2));
                } catch (error) {
                    vm.presupuestoEspejo.subtotalEspejo = 0;
                }


                vm.presupuestoEspejo.multiplicadorTrasera = Number( ( (nuevoAncho/100) * (nuevoAlto/100) ).toFixed(2) );
                try {
                    vm.presupuestoEspejo.subtotalTrasera = Number((vm.presupuestoEspejo.multiplicadorTrasera * vm.traseraSeleccionada.precioLeroyMerlin).toFixed(2));
                } catch (error) {
                    vm.presupuestoEspejo.subtotalTrasera = 0;
                }


            //CALCULO MULTIPLICADOR ESPEJO y TRASERA PARA MEDIDA EXTERIOR
            } else {

                if (vm.presupuestoEspejo.numeroMoldura2 != null) {
                    anchuraMoldura2 = Number(vm.presupuestoEspejo.desperdicio2);
                    anchuraMoldura2 = 10*anchuraMoldura2;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM
                } else {
                    anchuraMoldura2 = 0;
                }

                if (vm.presupuestoEspejo.numeroMoldura1 != null) {
                    anchuraMoldura1 = Number(vm.presupuestoEspejo.desperdicio1);
                    anchuraMoldura1 = 10*anchuraMoldura1;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM
                } else {
                    anchuraMoldura1 = 0;
                }

                nuevoAncho = Number(vm.presupuestoEspejo.width - 2*(anchuraMoldura2) - 2*(anchuraMoldura1));
                nuevoAlto = Number(vm.presupuestoEspejo.height - 2*(anchuraMoldura2) - 2*(anchuraMoldura1));

                vm.presupuestoEspejo.multiplicadorEspejo = Number( ( (nuevoAncho/100) * (nuevoAlto/100) ).toFixed(2) );
                try {
                    vm.presupuestoEspejo.subtotalEspejo = Number((vm.presupuestoEspejo.multiplicadorEspejo * vm.espejoSeleccionado.precioLeroyMerlin).toFixed(2));
                } catch (error) {
                    vm.presupuestoEspejo.subtotalEspejo = 0;
                }

                vm.presupuestoEspejo.multiplicadorTrasera = Number( ( (nuevoAncho/100) * (nuevoAlto/100) ).toFixed(2) );
                try {
                    vm.presupuestoEspejo.subtotalTrasera = Number((vm.presupuestoEspejo.multiplicadorTrasera * vm.traseraSeleccionada.precioLeroyMerlin).toFixed(2));
                } catch (error) {
                    vm.presupuestoEspejo.subtotalTrasera = 0;
                }
            }


            //Asignamos el ancho y alto total 
            //vm.presupuestoEspejo.widthCristal = nuevoAncho;
            //vm.presupuestoEspejo.heightCristal = nuevoAlto;
            //vm.presupuestoEspejo.widthTrasera = nuevoAncho;
            //vm.presupuestoEspejo.heightTrasera = nuevoAlto;


            //CALCULAMOS LOS SUBTOTALES DE CADA SECCIÓN (MOLDURAS1 y 2 Y ESPEJO-TRASERA) 
            subtotalParte1 = 0;
            try {
                subtotalParte1 = Number((vm.presupuestoEspejo.subtotalMoldura1).toFixed(2));
            } catch(error) {
                subtotalParte1 = 0;
            }

            subtotalParte2 = 0;
            try {
                subtotalParte2 = Number((vm.presupuestoEspejo.subtotalMoldura2).toFixed(2));
            } catch(error) {
                subtotalParte2 = 0;
            }

            subtotalParte4 = 0;
            try {
                subtotalParte4 = Number((vm.presupuestoEspejo.subtotalEspejo).toFixed(2));
            } catch(error) {
                subtotalParte4 = 0;
            }

            subtotalParte5 = 0;
            try {
                subtotalParte5 = Number((vm.presupuestoEspejo.subtotalTrasera).toFixed(2));
            } catch(error) {
                subtotalParte5 = 0;
            }


//CALCULAMOS LOS MULTIPLICADORES FINALES CON LOS SERVICIOS DE MONTAJE, EMBALAJE Y TRANSPORTE 
            var clienteDejaObra = false;
            var anchoMolduraExterior = 0;
            var altoMolduraExterior = 0;
            var pvpMolduraExterior = 0;
            var precioLinealMolduraExterior = 0;
            var nuevoMultiplicadorMolduraExterior = 0;

            //DESHABILITAMOS LAS SIGUIENTES LINEAS PORQUE PARA EL CASO DEL ESPEJO NO TIENE SENTIDO EL CONCEPTO DE "EL CLIENTE DEJA OBRA" YA QUE SÓLO COMPRA EL ESPEJO Y LO ENMARCA
/*
            if (vm.presupuestoEspejo.clienteDejaObraValorString == "true") {
                clienteDejaObra = true;
            } else {
                clienteDejaObra = false;
            }
*/

            //Si la moldura2 es la moldura exterior
            if (subtotalParte2 > 0) {

                anchoMolduraExterior = vm.presupuestoEspejo.widthMoldura2;
                altoMolduraExterior = vm.presupuestoEspejo.heightMoldura2;
                pvpMolduraExterior = vm.presupuestoEspejo.subtotalMoldura2;
                precioLinealMolduraExterior = vm.presupuestoEspejo.precioLeroyMerlin2;

                nuevoMultiplicadorMolduraExterior = vm.getMultiplicadorMolduraExteriorConImporteServicios(clienteDejaObra,anchoMolduraExterior,altoMolduraExterior,pvpMolduraExterior,precioLinealMolduraExterior);
                vm.presupuestoEspejo.multiplicadorMoldura2 = Number(nuevoMultiplicadorMolduraExterior.toFixed(2));

                vm.presupuestoEspejo.subtotalMoldura2 = Number((nuevoMultiplicadorMolduraExterior * vm.presupuestoEspejo.precioLeroyMerlin2).toFixed(2));
                subtotalParte2 = vm.presupuestoEspejo.subtotalMoldura2;

            //Si la moldura1 es la moldura exterior
            } else {

                anchoMolduraExterior = vm.presupuestoEspejo.widthMoldura1;
                altoMolduraExterior = vm.presupuestoEspejo.heightMoldura1;
                pvpMolduraExterior = vm.presupuestoEspejo.subtotalMoldura1;
                precioLinealMolduraExterior = vm.presupuestoEspejo.precioLeroyMerlin1;

                nuevoMultiplicadorMolduraExterior = vm.getMultiplicadorMolduraExteriorConImporteServicios(clienteDejaObra,anchoMolduraExterior,altoMolduraExterior,pvpMolduraExterior,precioLinealMolduraExterior);
                vm.presupuestoEspejo.multiplicadorMoldura1 = Number(nuevoMultiplicadorMolduraExterior.toFixed(2));

                vm.presupuestoEspejo.subtotalMoldura1 = Number((nuevoMultiplicadorMolduraExterior * vm.presupuestoEspejo.precioLeroyMerlin1).toFixed(2));
                subtotalParte1 = vm.presupuestoEspejo.subtotalMoldura1;
            }


//CALCULAMOS EL SUBTOTAL Y TOTAL DEL PRESUPUESTO
            vm.presupuestoEspejo.subtotal = Number( (subtotalParte1 + subtotalParte2 + subtotalParte4 + subtotalParte5).toFixed(2) );
            vm.presupuestoEspejo.total =  Number((vm.presupuestoEspejo.subtotal * vm.presupuestoEspejo.unidades).toFixed(2));

//CALCULAMOS EL IMPORTE DEL IVA (21%) Y EL IMPORTE TOTAL CON IVA
            vm.presupuestoEspejo.iva =  Number((0.21*vm.presupuestoEspejo.total).toFixed(2));
            vm.presupuestoEspejo.totalConIva = Number((vm.presupuestoEspejo.total + vm.presupuestoEspejo.iva).toFixed(2));

            vm.budgetCalculated = true;
        }



        //***************************************************************
        function showMenuDialog(ev,pPresupuestoKey,pTipoPresupuesto) {

            $mdDialog.show({
              controller: 'MenuDialogController',
              controllerAs: 'vm',
              locals             : {
                    presupuestoKey: pPresupuestoKey,
                    presupuestoTipo: pTipoPresupuesto,
                },
              templateUrl: 'app/main/menu/presupuestos/budgets/menuDialog/menu-dialog.html',
              parent: angular.element($document.body),
              targetEvent: ev,
              clickOutsideToClose: true,
              escapeToClose: true
              //fullscreen: vm.customFullscreen // Only for -xs, -sm breakpoints.
            })
            .then(function(answer) {
              vm.status = 'We show the dialog menu';
            }, function() {
              vm.status = 'You cancelled the dialog menu.';
            });
        }



        //***************************************************************
        function showAlertDialog(pText) {
            // Appending dialog to document.body to cover sidenav in docs app
            var alert = $mdDialog.alert()
                .title("Información")
                .textContent(pText)
                //.ariaLabel("")
                //.targetEvent(ev)
                .ok("Cerrar")
                //.cancel("No");

            $mdDialog.show(alert)
                .finally(function() {
                    //utilsService.writeConsole("WE REDIRECT TO 'SELECT-ITB' PAGE", WRITE_IN_CONSOLE);
                    //$location.path("/workflow-admin/select-itb");
                }); 
        }



        //***************************************************************
        function gotoBudgets()
        {
            $state.go('app.menu_presupuestos');
        }



        //***************************************************************
        function gotoBudgetMenu()
        {
            $state.go('app.menu_presupuestos');
        }



/*
        //***************************************************************
        function gotoProductDetail(id)
        {
            $state.go('app.menu_presupuestos_budget', {id: id});
        }
*/



/*
        //***************************************************************
        function add100Presupuestos() {

            var fbUrl = firebaseDataService.presupuestos;
            var presupuestos = $firebaseArray(fbUrl.limitToLast(1));

            for (var i=2;i<102;i++) {

                var json = {"ciudadCliente": "Ciudad "+i,
                            "cliente": "Cliente "+i,
                            "codigo": "PRESU-00"+i,
                            "codigoPostalCliente": "08010",
                            "direccionCliente": "Dirección " + i,
                            "emailCliente": "cliente"+i + "@dominio.com",
                            "envioTienda": true,
                            "envioTiendaValorString": "false",
                            "estado": "Pendiente",
                            "fechaTimestamp": new Date().getTime() + (i*86400000),
                            "numeroPC": "PC171213",
                            "observacionesCliente": "Observación " + i,
                            "provinciaCliente": "Barcelona",
                            "telefonoCliente": "600 11 22 33",
                            "telefonoTienda": "900 11 22 33",
                            "tipo": "¿?",
                            "unidades": 0,
                            "importe": 0,                            
                            "usuario": "Administración central",
                            "usuario_key": "-L-zqZMzj2ApqVql-nn9",
                            "vendedor": "Vendedor " + i
                            };


                presupuestos.$add(json)
                    .then(function(ref) {

                        utilsService.writeConsole("[BudgetController] - copyPresupuesto(pPresupuesto) => Added new record to 'presupuestos'", WRITE_IN_CONSOLE);

                        //INSERTAMOS EL REGISTRO EN LA TABLA "usuario_presupuestos"
                        var fbUrl = firebaseDataService.usuario_presupuestos;
                        var usuarioPresupuestos = $firebaseArray(fbUrl.limitToLast(1));

                        var json2 = {"usuario_presupuesto_key": "-L-zqZMzj2ApqVql-nn9&" + ref.key,
                                     "usuario_key": "-L-zqZMzj2ApqVql-nn9",
                                     "presupuesto_key": ref.key,
                                     "codigoPresupuesto": "PRESU-00"+i,
                                     "fechaTimestamp": new Date().getTime() + (i*86400000),
                                     "cliente": "Cliente "+i,
                                     "tipo": "¿?",
                                     "unidades": 0,
                                     "importe": 0,
                                     "usuario": "Administración central",
                                     "numeroPC": "PC171213",
                                     "estado": "Pendiente"
                                    };

                        usuarioPresupuestos.$add(json2)
                            .then(function(ref) {

                                utilsService.writeConsole("[BudgetController] - copyPresupuesto(pPresupuesto) => Added new record to 'usuario_presupuestos'", WRITE_IN_CONSOLE);

                            })
                            .catch(function(error) {
                                utilsService.writeConsole("[BudgetController] - copyPresupuesto(pPresupuesto) => ERROR: " + error, WRITE_IN_CONSOLE); 
                            }
                        );

                    })
                    .catch(function(error) {
                        utilsService.writeConsole("[BudgetController] - copyPresupuesto(pPresupuesto) => ERROR: " + error, WRITE_IN_CONSOLE); 
                    }
                );
            }                    
        }
*/



    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.menu.presupuestos')
        .controller('FramingBudgetController', FramingBudgetController);

    /** @ngInject */
    function FramingBudgetController($state,$mdDialog,$document,WRITE_IN_CONSOLE,utilsService,loginService,firebaseDataService,$firebaseArray,$firebaseObject,$timeout,preciosService)
    {
        //********************************************************        
        // DATA DECLARATION
        //********************************************************        
        var vm = this;

        vm.mode = "";       //accepted values = ["insert","update"]

        vm.arrayPresupuestoMarco = {};
        vm.presupuestoMarco = {};
        vm.presupuestoKey;

        vm.cristales = {};
        vm.cristalesConRestriccion = {};
        vm.traseras = {};

        vm.numeroPpt1;
        vm.numeroPpt2;
        vm.numeroMoldura1;
        vm.numeroMoldura2;
        vm.numeroMoldura3;
        vm.numeroCristal;
        vm.numeroTrasera;
        
        vm.ppt1Seleccionada  = {};
        vm.ppt2Seleccionada  = {};
        vm.moldura1Seleccionada  = {};
        vm.moldura2Seleccionada  = {};
        vm.moldura3Seleccionada  = {};
        vm.cristalSeleccionado = {};
        vm.traseraSeleccionada = {};

        vm.multiplicadorPpt1 = 0;
        vm.multiplicadorPpt2 = 0;
        vm.multiplicadorMoldura1 = 0;
        vm.multiplicadorMoldura2 = 0;
        vm.multiplicadorMoldura3 = 0;
        vm.multiplicadorCristal = 0;
        vm.multiplicadorTrasera = 0;

        vm.subtotalPpt1 = 0;
        vm.subtotalPpt2 = 0;
        vm.subtotalMoldura1 = 0;
        vm.subtotalMoldura2 = 0;
        vm.subtotalMoldura3 = 0;
        vm.subtotalCristal = 0;
        vm.subtotalTrasera = 0;

        vm.iconoDesplegarContraerMedidas = "icon-chevron-up";
        vm.textoDesplegarContraerMedidas = "contraer";
        vm.desplegadoContenidoMedidas = true;

        vm.iconoDesplegarContraerPpt1 = "icon-chevron-down";
        vm.textoDesplegarContraerPpt1 = "desplegar";
        vm.desplegadoContenidoPpt1 = false;

        vm.iconoDesplegarContraerPpt2 = "icon-chevron-down";
        vm.textoDesplegarContraerPpt2 = "desplegar";
        vm.desplegadoContenidoPpt2 = false;

        vm.iconoDesplegarContraerMoldura1 = "icon-chevron-down";
        vm.textoDesplegarContraerMoldura1 = "desplegar";
        vm.desplegadoContenidoMoldura1 = false;

        vm.iconoDesplegarContraerMoldura2 = "icon-chevron-down";
        vm.textoDesplegarContraerMoldura2 = "desplegar";
        vm.desplegadoContenidoMoldura2 = false;

        vm.iconoDesplegarContraerMoldura3 = "icon-chevron-down";
        vm.textoDesplegarContraerMoldura3 = "desplegar";
        vm.desplegadoContenidoMoldura3 = false;

        vm.iconoDesplegarContraerCristalTrasera = "icon-chevron-down";
        vm.textoDesplegarContraerCristalTrasera = "desplegar";
        vm.desplegadoContenidoCristalTrasera = false;

        vm.iconoDesplegarContraerUnidades = "icon-chevron-down";
        vm.textoDesplegarContraerUnidades = "desplegar";
        vm.desplegadoContenidoUnidades = false;

        vm.muestraLineaPresupuestoParaPpt1 = false;
        vm.muestraLineaPresupuestoParaPpt2 = false;
        vm.muestraLineaPresupuestoParaMoldura1 = false;
        vm.muestraLineaPresupuestoParaMoldura2 = false;
        vm.muestraLineaPresupuestoParaMoldura3 = false;
        vm.muestraLineaPresupuestoParaCristal = false;
        vm.muestraLineaPresupuestoParaTrasera = false;
        vm.muestraLineaPresupuestoParaMultiventana = false

        vm.activarBotonSiguienteParaPpt1 = false;
        vm.activarBotonSiguienteParaPpt2 = false;
        vm.activarBotonSiguienteParaMoldura1 = false;
        vm.activarBotonSiguienteParaMoldura2 = false;
        vm.activarBotonSiguienteParaMoldura3 = false;
        vm.activarBotonSiguienteParaCristalTrasera = false;
        vm.activarBotonCalcularPresupuesto = false;

        vm.showSaveButtonInHeader = true;

         vm.mostrarTodosCristales = true;
         vm.ocultarSelectorCristal = false;

         vm.budgetCalculated = false;

         vm.isAdministrator = false;

        //********************************************************
        // METHODS DECLARATION
        //********************************************************   
        vm.getPresupuestoMarco = getPresupuestoMarco;

        vm.getCristales = getCristales;
        vm.getCristalesConRestriccion = getCristalesConRestriccion;
        vm.getTraseras = getTraseras;

        vm.addPresupuestoMarco = addPresupuestoMarco;
        vm.save = save;

        vm.insertarPpt1 = insertarPpt1;
        vm.insertarPpt2 = insertarPpt2;
        vm.insertarMoldura1 = insertarMoldura1;
        vm.insertarMoldura2 = insertarMoldura2;
        vm.insertarMoldura3 = insertarMoldura3;
        vm.insertarCristalTrasera = insertarCristalTrasera;

        vm.assignNumeroCristal = assignNumeroCristal;
        vm.assignNumeroTrasera = assignNumeroTrasera;

        vm.findNumeroCristal = findNumeroCristal;
        vm.findNumeroTrasera = findNumeroTrasera;

        vm.actualizaTotalPresupuesto = actualizaTotalPresupuesto;
        vm.updatePresupuesto = updatePresupuesto;
        vm.updateUsuarioPresupuestos = updateUsuarioPresupuestos;

        vm.copyPresupuestoConMismoNumeroPD = copyPresupuestoConMismoNumeroPD;
        vm.copyPresupuesto = copyPresupuesto;
        vm.copyPresupuestoToUsuarioPresupuestosTable = copyPresupuestoToUsuarioPresupuestosTable;

        vm.gotoBudgets = gotoBudgets;
        vm.gotoBudgetMenu = gotoBudgetMenu;
        vm.gotoStep = gotoStep;
        vm.omitirPaso = omitirPaso;
        vm.desplegarContraerContenido = desplegarContraerContenido;
        vm.resetValoresPresupuesto = resetValoresPresupuesto;

        vm.resetMultiplicadoresSubtotales = resetMultiplicadoresSubtotales;

        vm.calculateBudget = calculateBudget;
        vm.getMedidasMoldura1 = getMedidasMoldura1;
        vm.getMedidasMoldura2 = getMedidasMoldura2;
        vm.getMedidasMoldura3 = getMedidasMoldura3;
        vm.getLineaImporteMultiventana = getLineaImporteMultiventana;
        vm.getMultiplicadorMolduraExteriorConImporteServicios = getMultiplicadorMolduraExteriorConImporteServicios;

        vm.reseteaCombosSeleccionCristalYtrasera = reseteaCombosSeleccionCristalYtrasera;

        vm.printOrderDialog = printOrderDialog;

        vm.selectFile = selectFile;
        vm.handleFileSelect = handleFileSelect;

        vm.resetImagenCroquis = resetImagenCroquis;
        vm.checkMaxValue = checkMaxValue;

        vm.showAlertDialog = showAlertDialog;
        vm.showMenuDialog = showMenuDialog;


        //START CONTROLLER *******************************
        init();
        //START CONTROLLER *******************************


        //********************************************************
        // METHODS DECLARATION
        //********************************************************        
        function init()
        {

            if (loginService.getUserProfile() == "administrator") {
                vm.isAdministrator = true;
            } else {
                vm.isAdministrator = false;
            }

            vm.presupuestoMarco.width = 0;
            vm.presupuestoMarco.height = 0;

            vm.presupuestoMarco.widthPpt1 = 0;
            vm.presupuestoMarco.heightPpt1 = 0;

            vm.presupuestoMarco.widthPpt2 = 0;
            vm.presupuestoMarco.heightPpt2 = 0;

            vm.presupuestoMarco.widthMoldura1 = 0;
            vm.presupuestoMarco.heightMoldura1 = 0;

            vm.presupuestoMarco.widthMoldura2 = 0;
            vm.presupuestoMarco.heightMoldura2 = 0;

            vm.presupuestoMarco.widthMoldura3 = 0;
            vm.presupuestoMarco.heightMoldura3 = 0;

            vm.presupuestoMarco.urlImagenPpt1 = " ";
            vm.presupuestoMarco.urlImagenPpt2 = " ";
            vm.presupuestoMarco.urlImagen1 = " ";
            vm.presupuestoMarco.urlImagen2 = " ";
            vm.presupuestoMarco.urlImagen3 = " ";
            vm.presupuestoMarco.urlImagenPerfil1 = " ";
            vm.presupuestoMarco.urlImagenPerfil2 = " ";
            vm.presupuestoMarco.urlImagenPerfil3 = " ";

            //Cargamos un array con los objetos "cristal" que se mostrarán en los comboBox de selección de Cristal
            vm.getCristales();

            vm.getCristalesConRestriccion();

            //Cargamos un array con los objetos "trasera" que se mostrarán en los comboBox de selección de Trasera
            vm.getTraseras();


            try {

                vm.presupuestoKey = $state.params.id;

                vm.getPresupuestoMarco(vm.presupuestoKey);

            } catch (error) {

                vm.mode = "insert";
                vm.showSaveButtonInHeader = false;

                //Inicializamos por defecto las dimensiones de las molduras
                vm.presupuestoMarco.widthMoldura1 = 0;
                vm.presupuestoMarco.heightMoldura1 = 0;

                vm.presupuestoMarco.widthMoldura2 = 0;
                vm.presupuestoMarco.heightMoldura2 = 0;

                vm.presupuestoMarco.widthMoldura3 = 0;
                vm.presupuestoMarco.heightMoldura3 = 0;

                vm.presupuestoMarco.dobleCristal = false;
            }

            //Asignamos las imágenes de los croquis de las entrecalles de los PPTs
            document.getElementById("croquisEntrecallePpt1").src = "https://firebasestorage.googleapis.com/v0/b/buenatelier-app.appspot.com/o/Buenatelier%2Fcroquis%2F01_croquis_ppt1.png?alt=media&token=4a1c59b2-3a9a-4ff2-bcc6-e8f36e5e0bc5";
            document.getElementById("croquisEntrecallePpt2").src = "https://firebasestorage.googleapis.com/v0/b/buenatelier-app.appspot.com/o/Buenatelier%2Fcroquis%2F02_croquis_ppt2.png?alt=media&token=13663255-89c4-4d31-b72f-c6677f612327";

            document.getElementById('fileInput').addEventListener('change', handleFileSelect, false);
        }




        //***************************************************************
        function getCristales() {

            var fbUrl = firebaseDataService.productos_varios;
            var result = $firebaseArray(fbUrl.orderByChild("tipo").equalTo("cristal"));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;
                    utilsService.writeConsole("[FramingBudgetController] => getCristales() => EJECUCIÓN OK DE CONSULTA TABLA productos_varios con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        vm.cristales = data;

                        //Añadimos manualmente el elemento "sin cristal"
                        var sinCristal = {
                               "numeroArticulo": 0,
                               "refProveedor": "",
                               "refLeroyMerlin": 0,
                               "descripcion": "Sin cristal",
                               "tipo": "cristal",
                               "limitacionAnchoCm": 0,
                               "limitacionAltoCm": 0,
                               "precioCoste": 0,
                               "precioLeroyMerlin": 0,
                               "urlImagen": "",
                               "urlImagen2": "",
                               "observaciones": "",
                               "activo": true
                        };

                        vm.cristales.push(sinCristal);

                    }
                })

                .catch(function(error) {

                    vm.cristales = null;
                    utilsService.writeConsole("[FramingBudgetController] => getCristales() => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        //***************************************************************
        function getCristalesConRestriccion() {

            var fbUrl = firebaseDataService.productos_varios;
            var result = $firebaseArray(fbUrl.orderByChild("tipo").equalTo("cristal"));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;
                    utilsService.writeConsole("[FramingBudgetController] => getCristalesConRestriccion() => EJECUCIÓN OK DE CONSULTA TABLA productos_varios con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        vm.cristalesConRestriccion = data;

                        //Añadimos manualmente el elemento "sin cristal"
                        var sinCristal = {
                               "numeroArticulo": 0,
                               "refProveedor": "",
                               "refLeroyMerlin": 0,
                               "descripcion": "Sin cristal",
                               "tipo": "cristal",
                               "limitacionAnchoCm": 0,
                               "limitacionAltoCm": 0,
                               "precioCoste": 0,
                               "precioLeroyMerlin": 0,
                               "urlImagen": "",
                               "urlImagen2": "",
                               "observaciones": "",
                               "activo": true
                        };

                        vm.cristalesConRestriccion.push(sinCristal);

                        //Eliminamos los 2 primeros cristales de vm.cristalesConRestriccion ("Cristal normal transparente" y "Cristal anti-reflejante (VELGLASS)")
                        vm.cristalesConRestriccion.splice(0,2);

                    }
                })

                .catch(function(error) {

                    vm.cristalesConRestriccion = null;
                    utilsService.writeConsole("[FramingBudgetController] => getCristalesConRestriccion() => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        //***************************************************************
        function getTraseras() {

            var fbUrl = firebaseDataService.productos_varios;
            var result = $firebaseArray(fbUrl.orderByChild("tipo").equalTo("trasera"));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;
                    utilsService.writeConsole("[FramingBudgetController] => getTraseras() => EJECUCIÓN OK DE CONSULTA TABLA productos_varios con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        vm.traseras = data;

                        //Añadimos manualmente el elemento "sin trasera"
                        var sinTrasera = {
                               "numeroArticulo": 0,
                               "refProveedor": "",
                               "refLeroyMerlin": 0,
                               "descripcion": "Sin trasera",
                               "tipo": "trasera",
                               "limitacionAnchoCm": 0,
                               "limitacionAltoCm": 0,
                               "precioCoste": 0,
                               "precioLeroyMerlin": 0,
                               "urlImagen": "",
                               "urlImagen2": "",
                               "observaciones": "",
                               "activo": true
                        };

                        vm.traseras.push(sinTrasera);

                    }
                })

                .catch(function(error) {

                    vm.traseras = null;
                    utilsService.writeConsole("[FramingBudgetController] => getTraseras() => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        //***************************************************************
        function getPresupuestoMarco(pPresupuestoKey) {

            var fbUrl = firebaseDataService.presupuesto_marco;
            var result = $firebaseArray(fbUrl.orderByChild("presupuesto_key").equalTo(pPresupuestoKey));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;
                    utilsService.writeConsole("[FramingBudgetController] => getPresupuestoMarco(" + pPresupuestoKey + ") => EJECUCIÓN OK DE CONSULTA TABLA presupuesto_espejo con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        vm.arrayPresupuestoMarco = data;
                        vm.presupuestoMarco = data[0];

                        vm.mode = "update";
                        vm.showSaveButtonInHeader = true;

                        //ASIGNACION DATOS PARA PPT 1
                        vm.numeroPpt1 = vm.presupuestoMarco.numeroPpt1;
                        vm.ppt1Seleccionada.numeroPpt = vm.presupuestoMarco.numeroPpt1;
                        vm.ppt1Seleccionada.refLeroyMerlin = vm.presupuestoMarco.refLeroyMerlinPpt1;

                        vm.ppt1Seleccionada.descripcion = vm.presupuestoMarco.descripcionPpt1;
                        vm.ppt1Seleccionada.precioLeroyMerlin = vm.presupuestoMarco.precioLeroyMerlinPpt1;
                        vm.ppt1Seleccionada.precioCoste = vm.presupuestoMarco.precioCostePpt1;

                        if (vm.ppt1Seleccionada.numeroPpt != null) {
                            vm.muestraLineaPresupuestoParaPpt1 = true;
                        } else {
                            vm.muestraLineaPresupuestoParaPpt1 = false;
                        }

                        vm.activarBotonSiguienteParaPpt1 = true;

                        document.getElementById("pptImage1").src = vm.presupuestoMarco.urlImagenPpt1;

                        if (vm.presupuestoMarco.multiventana) {
                            vm.getLineaImporteMultiventana(vm.presupuestoMarco.numeroVentanas);
                            vm.muestraLineaPresupuestoParaMultiventana = true;
                        } else {
                            vm.muestraLineaPresupuestoParaMultiventana = false;
                        }


                        //ASIGNACION DATOS PARA PPT 2
                        vm.numeroPpt2 = vm.presupuestoMarco.numeroPpt2;
                        vm.ppt2Seleccionada.numeroPpt = vm.presupuestoMarco.numeroPpt2;
                        vm.ppt2Seleccionada.refLeroyMerlin = vm.presupuestoMarco.refLeroyMerlinPpt2;

                        vm.ppt2Seleccionada.descripcion = vm.presupuestoMarco.descripcionPpt2;
                        vm.ppt2Seleccionada.precioLeroyMerlin = vm.presupuestoMarco.precioLeroyMerlinPpt2;
                        vm.ppt2Seleccionada.precioCoste = vm.presupuestoMarco.precioCostePpt2;

                        if (vm.ppt2Seleccionada.numeroPpt != null) {
                            vm.muestraLineaPresupuestoParaPpt2 = true;
                        } else {
                            vm.muestraLineaPresupuestoParaPpt2 = false;
                        }

                        vm.activarBotonSiguienteParaPpt2 = true;

                        document.getElementById("pptImage2").src = vm.presupuestoMarco.urlImagenPpt2;

                        //ASIGNACION DATOS PARA MOLDURA 1
                        vm.numeroMoldura1 = vm.presupuestoMarco.numeroMoldura1;
                        vm.moldura1Seleccionada.numeroMoldura = vm.presupuestoMarco.numeroMoldura1;
                        vm.moldura1Seleccionada.refLeroyMerlin = vm.presupuestoMarco.refLeroyMerlinMoldura1;

                        vm.moldura1Seleccionada.descripcion = vm.presupuestoMarco.descripcion1;
                        vm.moldura1Seleccionada.precioLeroyMerlin = vm.presupuestoMarco.precioLeroyMerlin1;
                        vm.moldura1Seleccionada.precioCoste = vm.presupuestoMarco.precioCoste1;
                        vm.moldura1Seleccionada.desperdicio = vm.presupuestoMarco.desperdicio1;

                        if (vm.moldura1Seleccionada.numeroMoldura != null) {
                            vm.muestraLineaPresupuestoParaMoldura1 = true;
                        } else {
                            vm.muestraLineaPresupuestoParaMoldura1 = false;
                        }

                        vm.activarBotonSiguienteParaMoldura1 = true;

                        document.getElementById("moldingImage1").src = vm.presupuestoMarco.urlImagen1;
                        document.getElementById("outlineImage1").src = vm.presupuestoMarco.urlImagenPerfil1;

                        //ASIGNACION DATOS PARA MOLDURA 2
                        vm.numeroMoldura2 = vm.presupuestoMarco.numeroMoldura2;
                        vm.moldura2Seleccionada.numeroMoldura = vm.presupuestoMarco.numeroMoldura2;
                        vm.moldura2Seleccionada.refLeroyMerlin = vm.presupuestoMarco.refLeroyMerlinMoldura2;

                        vm.moldura2Seleccionada.descripcion = vm.presupuestoMarco.descripcion2;
                        vm.moldura2Seleccionada.precioLeroyMerlin = vm.presupuestoMarco.precioLeroyMerlin2;
                        vm.moldura2Seleccionada.precioCoste = vm.presupuestoMarco.precioCoste2;
                        vm.moldura2Seleccionada.desperdicio = vm.presupuestoMarco.desperdicio2;

                        if (vm.moldura2Seleccionada.numeroMoldura != null) {
                            vm.muestraLineaPresupuestoParaMoldura2 = true;
                        } else {
                            vm.muestraLineaPresupuestoParaMoldura2 = false;
                        }

                        vm.activarBotonSiguienteParaMoldura2 = true;

                        document.getElementById("moldingImage2").src = vm.presupuestoMarco.urlImagen2;
                        document.getElementById("outlineImage2").src = vm.presupuestoMarco.urlImagenPerfil2;

                        //ASIGNACION DATOS PARA MOLDURA 3
                        vm.numeroMoldura3 = vm.presupuestoMarco.numeroMoldura3;
                        vm.moldura3Seleccionada.numeroMoldura = vm.presupuestoMarco.numeroMoldura3;
                        vm.moldura3Seleccionada.refLeroyMerlin = vm.presupuestoMarco.refLeroyMerlinMoldura3;

                        vm.moldura3Seleccionada.descripcion = vm.presupuestoMarco.descripcion3;
                        vm.moldura3Seleccionada.precioLeroyMerlin = vm.presupuestoMarco.precioLeroyMerlin3;
                        vm.moldura3Seleccionada.precioCoste = vm.presupuestoMarco.precioCoste3;
                        vm.moldura3Seleccionada.desperdicio = vm.presupuestoMarco.desperdicio3;

                        if (vm.moldura3Seleccionada.numeroMoldura != null) {
                            vm.muestraLineaPresupuestoParaMoldura3 = true;
                        } else {
                            vm.muestraLineaPresupuestoParaMoldura3 = false;
                        }

                        vm.activarBotonSiguienteParaMoldura3 = true;

                        document.getElementById("moldingImage3").src = vm.presupuestoMarco.urlImagen3;
                        document.getElementById("outlineImage3").src = vm.presupuestoMarco.urlImagenPerfil3;


                        //ASIGNACION DATOS PARA CRISTAL
                        vm.numeroCristal = vm.presupuestoMarco.numeroCristal;
                        vm.cristalSeleccionado.numeroArticulo = vm.presupuestoMarco.numeroCristal;
                        vm.cristalSeleccionado.refLeroyMerlin = vm.presupuestoMarco.refLeroyMerlinCristal;

                        vm.cristalSeleccionado.descripcion = vm.presupuestoMarco.descripcionCristal;
                        vm.cristalSeleccionado.precioLeroyMerlin = vm.presupuestoMarco.precioLeroyMerlinCristal;
                        vm.cristalSeleccionado.precioCoste = vm.presupuestoMarco.precioCosteCristal;

                        if (vm.cristalSeleccionado.numeroArticulo != null) {
                            vm.muestraLineaPresupuestoParaCristal = true;
                        } else {
                            vm.muestraLineaPresupuestoParaCristal = false;
                        }

                        vm.activarBotonSiguienteParaCristalTrasera = true;

                        //ASIGNACION DATOS PARA TRASERA
                        vm.numeroTrasera = vm.presupuestoMarco.numeroTrasera;
                        vm.traseraSeleccionada.numeroArticulo = vm.presupuestoMarco.numeroTrasera;
                        vm.traseraSeleccionada.refLeroyMerlin = vm.presupuestoMarco.refLeroyMerlinTrasera;

                        vm.traseraSeleccionada.descripcion = vm.presupuestoMarco.descripcionTrasera;
                        vm.traseraSeleccionada.precioLeroyMerlin = vm.presupuestoMarco.precioLeroyMerlinTrasera;
                        vm.traseraSeleccionada.precioCoste = vm.presupuestoMarco.precioCosteTrasera;

                        if (vm.traseraSeleccionada.numeroArticulo != null) {
                            vm.muestraLineaPresupuestoParaTrasera = true;
                            
                        } else {
                            vm.muestraLineaPresupuestoParaTrasera = false;
                        }

                        vm.activarBotonSiguienteParaCristalTrasera = true;
                        vm.activarBotonCalcularPresupuesto = true;

                    } else {

                        vm.mode = "insert";
                        vm.showSaveButtonInHeader = false;

                        //Para el caso de la inserción => Asignamos los valores por defecto
                        vm.presupuestoMarco.presupuesto_key = vm.presupuestoKey;
                        vm.presupuestoMarco.medidaExteriorValorString = "false";
                        vm.presupuestoMarco.clienteDejaObraValorString = "false";
                        vm.presupuestoMarco.obraConDesperfectosValorString = "false";

                        vm.presupuestoMarco.subtotalPpt1 = 0;
                        vm.presupuestoMarco.subtotalPpt2 = 0;
                        vm.presupuestoMarco.subtotalMoldura1 = 0;
                        vm.presupuestoMarco.subtotalMoldura2 = 0;
                        vm.presupuestoMarco.subtotalMoldura3 = 0;
                        vm.presupuestoMarco.subtotalCristal = 0;
                        vm.presupuestoMarco.subtotalTrasera = 0;
                        vm.presupuestoMarco.subtotal = 0;     
                        vm.presupuestoMarco.total =  0;

                        vm.presupuestoMarco.unidades = 1;

                        vm.muestraLineaPresupuestoParaPpt1 = false;
                        vm.muestraLineaPresupuestoParaPpt2 = false;
                        vm.muestraLineaPresupuestoParaMoldura1 = false;
                        vm.muestraLineaPresupuestoParaMoldura2 = false;
                        vm.muestraLineaPresupuestoParaMoldura3 = false;
                        vm.muestraLineaPresupuestoParaCristal = false;
                        vm.muestraLineaPresupuestoParaTrasera = false;

                        vm.activarBotonSiguienteParaPpt1 = false;
                        vm.activarBotonSiguienteParaPpt2 = false;
                        vm.activarBotonSiguienteParaMoldura1 = false;
                        vm.activarBotonSiguienteParaMoldura2 = false;
                        vm.activarBotonSiguienteParaMoldura3 = false;
                        vm.activarBotonSiguienteParaCristalTrasera = false;
                        vm.activarBotonCalcularPresupuesto = false;
                    }

                })

                .catch(function(error) {

                    vm.presupuestoMarco = null;
                    utilsService.writeConsole("[FramingBudgetController] => getPresupuestoMarco(pPresupuestoKey) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }


        
        //***************************************************************
        function save(pPresupuestoMarco,pFinalizarPedido,pEvent) {

            vm.presupuestoMarco.presupuesto_key = vm.presupuestoKey;

            if (vm.mode == "update") {
                
                //We update budget's data
                vm.arrayPresupuestoMarco.$save(pPresupuestoMarco)
                    .then(function(ref) {

                        utilsService.writeConsole("[FramingBudgetController] - save() => Presupuesto_marco saved with ID = " + ref.key, WRITE_IN_CONSOLE);

                        //Actualizamos la tabla "presupuestos" (con los valores de importe, unidades y tipo)
                        vm.updatePresupuesto(vm.presupuestoKey,pFinalizarPedido,pEvent);

                    })

                    .catch(function(error) {

                        vm.showAlertDialog("Se ha producido un error al guardar el presupuesto de la enmarcación. Por favor contacte con el Administrador de la App.");                        
                        utilsService.writeConsole("[FramingBudgetController] => save() => ERROR: " + error, WRITE_IN_CONSOLE); 
                });                

            } else {

                //We add a new presupuesto
                vm.addPresupuestoMarco(vm.presupuestoMarco,pFinalizarPedido,pEvent); 
            }
        }



        //***************************************************************
        function addPresupuestoMarco(pPresupuestoMarco,pFinalizarPedido,pEvent) {

            pPresupuestoMarco.presupuesto_key = vm.presupuestoKey;

            var fbUrl = firebaseDataService.presupuesto_marco;
            var presupuestos = $firebaseArray(fbUrl.limitToLast(1));

            presupuestos.$add(pPresupuestoMarco)
                .then(function(ref) {
                    utilsService.writeConsole("[FramingBudgetController] - addPresupuestoMarco(pPresupuestoMarco) => Added new record to 'presupuesto_marco'", WRITE_IN_CONSOLE);

                    //Actualizamos la tabla "presupuestos" (con los valores de importe, unidades y tipo)
                    vm.updatePresupuesto(vm.presupuestoKey,pFinalizarPedido,pEvent);

                })
                .catch(function(error) {

                    vm.showAlertDialog("Se ha producido un error al guardar el presupuesto de la enmarcación. Por favor contacte con el Administrador de la App.");
                    utilsService.writeConsole("[FramingBudgetController] - addPresupuestoMarco(pPresupuestoMarco) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        //***************************************************************
        function updatePresupuesto(pPresupuestoKey,pFinalizarPedido,pEvent) {

            var fbUrl = firebaseDataService.presupuestos.child(pPresupuestoKey);
            var result = $firebaseObject(fbUrl);

            result.$loaded()
                .then(function(data) {

                    utilsService.writeConsole("[FramingBudgetController] => updatePresupuesto(pPresupuestoKey) => EJECUCIÓN OK DE CONSULTA en TABLA presupuestos con $id = " + data.$id, WRITE_IN_CONSOLE);

                    var presupuesto = data;

                    presupuesto.tipo = "enmarcación";
                    presupuesto.unidades = vm.presupuestoMarco.unidades;
                    presupuesto.importe = vm.presupuestoMarco.totalConIva;

                    presupuesto.$save()
                        .then(function(ref) {
                            utilsService.writeConsole("[FramingBudgetController] => updatePresupuesto(pPresupuestoKey) => EJECUCIÓN OK DE UPDATE en TABLA presupuestos con $id = " + data.$id, WRITE_IN_CONSOLE);

                            //Actualizamos la tabla "usuario_presupuestos" (con los valores de importe, unidades y tipo)
                            vm.updateUsuarioPresupuestos(pPresupuestoKey,pFinalizarPedido,pEvent);
                        })

                        .catch(function(error) {
                            utilsService.writeConsole("[FramingBudgetController] => updatePresupuesto(pPresupuestoKey) => ERROR: " + error, WRITE_IN_CONSOLE); 
                    });                


                })

                .catch(function(error) {
                    presupuesto = null;
                    utilsService.writeConsole("[FramingBudgetController] => updatePresupuesto(pPresupuestoKey) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        //***************************************************************
        function updateUsuarioPresupuestos(pPresupuestoKey,pFinalizarPedido,pEvent) {

            var usuarioPresupuesto;

            var fbUrl = firebaseDataService.usuario_presupuestos;
            var result = $firebaseArray(fbUrl.orderByChild("presupuesto_key").equalTo(pPresupuestoKey));

            result.$loaded()
                .then(function(data) {

                    utilsService.writeConsole("[FramingBudgetController] => updateUsuarioPresupuestos(pPresupuestoKey) => EJECUCIÓN OK DE CONSULTA en TABLA usuario_presupuestos con $id = " + data[0].$id, WRITE_IN_CONSOLE);

                    usuarioPresupuesto = data[0];

                    usuarioPresupuesto.tipo = "enmarcación";
                    usuarioPresupuesto.unidades = vm.presupuestoMarco.unidades;
                    usuarioPresupuesto.importe = vm.presupuestoMarco.totalConIva;

                    data.$save(usuarioPresupuesto)
                        .then(function(ref) {
                            utilsService.writeConsole("[FramingBudgetController] => updateUsuarioPresupuestos(pPresupuestoKey) => EJECUCIÓN OK DE UPDATE en TABLA usuario_presupuestos con $id = " + data[0].$id, WRITE_IN_CONSOLE);

                            if (pFinalizarPedido) {

                                //IMPORTANTE => MOSTRAMOS LA VERSIÓN IMPRIMIBLE Y REDIRIGIMOS A LA PÁGINA DE LISTADO DE PRESUPUESTOS.
                                vm.printOrderDialog(pEvent,pPresupuestoKey,usuarioPresupuesto.numeroNumeroPC);
                                vm.gotoBudgets();


                            } else {

                                //Añadimos un nuevo presupuesto copiando los datos del actual y manteniendo el mismo Nº de PC
                                vm.copyPresupuestoConMismoNumeroPD(pPresupuestoKey);
                            }

                        })

                        .catch(function(error) {
                            utilsService.writeConsole("[FramingBudgetController] => updateUsuarioPresupuestos(pPresupuestoKey) => ERROR: " + error, WRITE_IN_CONSOLE); 
                    });                

                })

                .catch(function(error) {
                    usuarioPresupuesto = null;
                    utilsService.writeConsole("[FramingBudgetController] => updateUsuarioPresupuestos(pPresupuestoKey) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        //***************************************************************
        function printOrderDialog(ev,pPresupuestoKey,pPresupuestoNumeroPC)
        {
            $mdDialog.show({
                controller         : 'PrintOrderDialogController',
                controllerAs       : 'vm',
                
                locals             : {
                    presupuestoKey: pPresupuestoKey,
                    presupuestoNumeroPC: pPresupuestoNumeroPC
                    //,consignatarioData: vm.consignatarioData
                    //,packinglistData: vm.packinglistData
                },
                
                templateUrl        : 'app/main/menu/presupuestos/budgets/printOrderDialog/print-order-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev
                //clickOutsideToClose: true
            });
        }


        //***************************************************************
        function copyPresupuestoConMismoNumeroPD(pPresupuestoKey,pEvent) {

            var fbUrl = firebaseDataService.presupuestos.child(pPresupuestoKey);
            var result = $firebaseObject(fbUrl);

            result.$loaded()
                .then(function(data) {

                    utilsService.writeConsole("[MirrorBudgetController] => copyPresupuestoConMismoNumeroPD(pPresupuestoKey) => EJECUCIÓN OK DE CONSULTA TABLA presupuestos con $id = " + data.$id, WRITE_IN_CONSOLE);
                    vm.presupuestoKey = data.$id;

                    var presupuestoAcopiar = data;

                    presupuestoAcopiar.fechaTimestamp = new Date().getTime();
                    presupuestoAcopiar.tipo = "¿?";
                    presupuestoAcopiar.unidades = 0;
                    presupuestoAcopiar.importe = 0;
                    presupuestoAcopiar.numeroPC = "?";

                    vm.copyPresupuesto(presupuestoAcopiar,pEvent);

                })

                .catch(function(error) {
                    utilsService.writeConsole("[MirrorBudgetController] => copyPresupuestoConMismoNumeroPD(pPresupuestoKey) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        //***************************************************************
        function copyPresupuesto(pPresupuesto,pEvent) {

            var ultimoPresupuesto;

            var fbUrl = firebaseDataService.presupuestos;
            var presupuestos = $firebaseArray(fbUrl.limitToLast(1));

            presupuestos.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    if (dataLength > 0) {

                        ultimoPresupuesto = data[0];

                        //Incrementamos el número de presupuesto en 1 unidad
                        var ultimoCodigoPresupuesto = ultimoPresupuesto.codigo;
                        var nuevoCodigoPresupuesto = Number(ultimoCodigoPresupuesto.substring(3,ultimoCodigoPresupuesto.length));
                        nuevoCodigoPresupuesto++;
                        pPresupuesto.codigo = "PR-" + utilsService.padLeftWithZero(nuevoCodigoPresupuesto,6);

                        //Incrementamos el número de PC en 1 unidad
                        //IMPORTANTE => MANTENEMOS EL MISMO NUMERO DE PC del presupuesto copiado.
/*                        
                        var ultimoNumeroPD = ultimoPresupuesto.numeroPD;
                        var nuevoNumeroPD = Number(ultimoNumeroPD.substring(3,ultimoNumeroPD.length));
                        nuevoNumeroPD++;
                        pPresupuesto.numeroPD = "PD-" + utilsService.padLeftWithZero(nuevoNumeroPD,6);
*/

                        presupuestos.$add(pPresupuesto)
                            .then(function(ref) {
                                utilsService.writeConsole("[MirrorBudgetController] - copyPresupuesto(pPresupuesto,pEvent) => Added new record to 'presupuestos'", WRITE_IN_CONSOLE);

                                var nuevoPresupuestoKey = ref.key;

                                //AÑADIMOS UN NUEVO REGISTRO EN LA TABLA "usuario_exportaciones"
                                var newRecord = {
                                    "usuario_presupuesto_key": pPresupuesto.usuario_key + "&" + nuevoPresupuestoKey,
                                    "usuario_key": pPresupuesto.usuario_key,
                                    "presupuesto_key": nuevoPresupuestoKey,
                                    "usuario": pPresupuesto.usuario,
                                    "codigoPresupuesto": pPresupuesto.codigo,
                                    "fechaTimestamp": pPresupuesto.fechaTimestamp,
                                    "cliente": pPresupuesto.cliente,
                                    "tipo": pPresupuesto.tipo,
                                    "unidades": pPresupuesto.unidades,
                                    "importe": pPresupuesto.importe,
                                    "numeroPD": pPresupuesto.numeroPD,
                                    "numeroPC": pPresupuesto.numeroPC,
                                    "estado": pPresupuesto.estado
                                }

                                vm.copyPresupuestoToUsuarioPresupuestosTable(newRecord,pEvent);

                            })
                            .catch(function(error) {
                                utilsService.writeConsole("[MirrorBudgetController] - copyPresupuesto(pPresupuesto,pEvent) => ERROR: " + error, WRITE_IN_CONSOLE); 
                            }
                        );

                    } else {

                        //Asignamos el primer nº de presupuesto
                        pPresupuesto.codigo = "PR-000001";

                        //Asignamos el primer número de PD
                        pPresupuesto.numeroPD = "PD-000001";

                        //Asignamos el primer número de PC
                        pPresupuesto.numeroPC = "?";

                        presupuestos.$add(pPresupuesto)
                            .then(function(ref) {
                                utilsService.writeConsole("[MirrorBudgetController] - copyPresupuesto(pPresupuesto,pEvent) => Added new record to 'presupuestos'", WRITE_IN_CONSOLE);

                                var nuevoPresupuestoKey = ref.key;

                                //AÑADIMOS UN NUEVO REGISTRO EN LA TABLA "usuario_exportaciones"
                                var newRecord = {
                                    "usuario_presupuesto_key": pPresupuesto.usuario_key + "&" + nuevoPresupuestoKey,
                                    "usuario_key": pPresupuesto.usuario_key,
                                    "presupuesto_key": nuevoPresupuestoKey,
                                    "usuario": pPresupuesto.usuario,
                                    "codigoPresupuesto": pPresupuesto.codigo,
                                    "fechaTimestamp": pPresupuesto.fechaTimestamp,
                                    "cliente": pPresupuesto.cliente,
                                    "tipo": pPresupuesto.tipo,
                                    "unidades": pPresupuesto.unidades,
                                    "importe": pPresupuesto.importe,
                                    "numeroPD": pPresupuesto.numeroPD,
                                    "numeroPC": pPresupuesto.numeroPC,
                                    "estado": pPresupuesto.estado
                                }

                                vm.copyPresupuestoToUsuarioPresupuestosTable(newRecord,pEvent);

                            })
                            .catch(function(error) {
                                utilsService.writeConsole("[MirrorBudgetController] - copyPresupuesto(pPresupuesto,pEvent) => ERROR: " + error, WRITE_IN_CONSOLE); 
                            }
                        );

                    }
                })

                .catch(function(error) {
                    presupuestos = null;
                    utilsService.writeConsole("[MirrorBudgetController] => copyPresupuesto(pPresupuesto,pEvent) => ERROR al obtener los datos del presupuesto actual: " + error, WRITE_IN_CONSOLE);
                }
            );
        }



        //***************************************************************
        function copyPresupuestoToUsuarioPresupuestosTable(pNewRecord,pEvent) {

            var nuevoPresupuestoKey = pNewRecord.presupuesto_key;

            var fbUrl = firebaseDataService.usuario_presupuestos;
            var records = $firebaseArray(fbUrl.limitToLast(1));

            records.$add(pNewRecord)
                .then(function(ref) {
                    utilsService.writeConsole("[BudgetsController] => copyPresupuestoToUsuarioPresupuestosTable() => Added new record to 'usuario_presupuestos'", WRITE_IN_CONSOLE);

                    //Redirigimos a la página de selección de tipo de presupuesto.
                    var tipoPresupuesto = "¿?";
                    vm.showMenuDialog(pEvent,nuevoPresupuestoKey,tipoPresupuesto);

                })
                .catch(function(error) {
                    utilsService.writeConsole("[BudgetsController] => copyPresupuestoToUsuarioPresupuestosTable() => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        //***************************************************************
        function checkMaxValue(pValue) {

if (!vm.isAdministrator) {

            //Para medida exterior
            if (vm.presupuestoMarco.medidaExteriorValorString == "true") {
                if (pValue > 200) {
                    vm.showAlertDialog("No se permite un valor superior a 200 cm para la enmarcación");
                    return false;
                }

            //Para medida interior
            } else {
                if (pValue > 180) {
                    vm.showAlertDialog("No se permite un valor superior a 180 cm para la enmarcación");
                    return false;
                }
            }
}
            return true;
        }



        //***************************************************************
        function desplegarContraerContenido(pDesplegado, pNombreCapa)
        {

            //Para la capa de MEDIDAS
            if (pNombreCapa == "capaMedidas") {
                vm.desplegadoContenidoMedidas = !vm.desplegadoContenidoMedidas;
                vm.pDesplegado = !vm.pDesplegado;           

                if (pDesplegado) {
                    vm.iconoDesplegarContraerMedidas = "icon-chevron-down";
                    vm.textoDesplegarContraerMedidas = "desplegar"
                } else {
                    vm.iconoDesplegarContraerMedidas = "icon-chevron-up";
                    vm.textoDesplegarContraerMedidas = "contraer";
                }
            }            

            //Para la capa de PPT 1
            else if (pNombreCapa == "capaPpt1") {
                
                vm.desplegadoContenidoPpt1 = !vm.desplegadoContenidoPpt1;
                vm.pDesplegado = !vm.pDesplegado;           

                if (pDesplegado) {
                    vm.iconoDesplegarContraerPpt1 = "icon-chevron-down";
                    vm.textoDesplegarContraerPpt1 = "desplegar"
                } else {
                    vm.iconoDesplegarContraerPpt1 = "icon-chevron-up";
                    vm.textoDesplegarContraerPpt1 = "contraer";
                }
            }            

            //Para la capa de PPT 2
            else if (pNombreCapa == "capaPpt2") {
                
                vm.desplegadoContenidoPpt2 = !vm.desplegadoContenidoPpt2;
                vm.pDesplegado = !vm.pDesplegado;           

                if (pDesplegado) {
                    vm.iconoDesplegarContraerPpt2 = "icon-chevron-down";
                    vm.textoDesplegarContraerPpt2 = "desplegar"
                } else {
                    vm.iconoDesplegarContraerPpt2 = "icon-chevron-up";
                    vm.textoDesplegarContraerPpt2 = "contraer";
                }
            }            


            //Para la capa de MOLDURA 1
            else if (pNombreCapa == "capaMoldura1") {
                
                vm.desplegadoContenidoMoldura1 = !vm.desplegadoContenidoMoldura1;
                vm.pDesplegado = !vm.pDesplegado;           

                if (pDesplegado) {
                    vm.iconoDesplegarContraerMoldura1 = "icon-chevron-down";
                    vm.textoDesplegarContraerMoldura1 = "desplegar"
                } else {
                    vm.iconoDesplegarContraerMoldura1 = "icon-chevron-up";
                    vm.textoDesplegarContraerMoldura1 = "contraer";
                }
            }            

            //Para la capa de MOLDURA 2
            else if (pNombreCapa == "capaMoldura2") {
                
                vm.desplegadoContenidoMoldura2 = !vm.desplegadoContenidoMoldura2;
                vm.pDesplegado = !vm.pDesplegado;           

                if (pDesplegado) {
                    vm.iconoDesplegarContraerMoldura2 = "icon-chevron-down";
                    vm.textoDesplegarContraerMoldura2 = "desplegar"
                } else {
                    vm.iconoDesplegarContraerMoldura2 = "icon-chevron-up";
                    vm.textoDesplegarContraerMoldura2 = "contraer";
                }
            }            


            //Para la capa de MOLDURA 3
            else if (pNombreCapa == "capaMoldura3") {
                
                vm.desplegadoContenidoMoldura3 = !vm.desplegadoContenidoMoldura3;
                vm.pDesplegado = !vm.pDesplegado;           

                if (pDesplegado) {
                    vm.iconoDesplegarContraerMoldura3 = "icon-chevron-down";
                    vm.textoDesplegarContraerMoldura3 = "desplegar"
                } else {
                    vm.iconoDesplegarContraerMoldura3 = "icon-chevron-up";
                    vm.textoDesplegarContraerMoldura3 = "contraer";
                }
            }            


            //Para la capa de CRISTAL y TRASERA
            else if (pNombreCapa == "capaCristalTrasera") {
                
                vm.desplegadoContenidoCristalTrasera = !vm.desplegadoContenidoCristalTrasera;
                vm.pDesplegado = !vm.pDesplegado;           

                if (pDesplegado) {
                    vm.iconoDesplegarContraerCristalTrasera = "icon-chevron-down";
                    vm.textoDesplegarContraerCristalTrasera = "desplegar"
                } else {
                    vm.iconoDesplegarContraerCristalTrasera = "icon-chevron-up";
                    vm.iconoDesplegarContraerCristalTrasera = "contraer";
                }
            }            


            //Para la capa de UNIDADES
            else if (pNombreCapa == "capaUnidades") {

                vm.desplegadoContenidoUnidades = !vm.desplegadoContenidoUnidades;
                vm.pDesplegado = !vm.pDesplegado;           

                if (pDesplegado) {
                    vm.iconoDesplegarContraerUnidades = "icon-chevron-down";
                    vm.textoDesplegarContraerUnidades = "desplegar"
                } else {
                    vm.iconoDesplegarContraerUnidades = "icon-chevron-up";
                    vm.textoDesplegarContraerUnidades = "contraer";
                }
            }            

        }



        //***************************************************************
        function omitirPaso(pNombreCapa)
        {
            if (pNombreCapa == "ppt1") {

                if (vm.presupuestoMarco.numeroPpt1 != null) {
                    vm.resetValoresPresupuesto('PPT1',false);
                }

                vm.presupuestoMarco.widthPpt1 = 0;
                vm.presupuestoMarco.heightPpt1 = 0;

                vm.gotoStep('moldura1');

            } else if (pNombreCapa == "ppt2") {

                if (vm.presupuestoMarco.numeroPpt2 != null) {
                    vm.resetValoresPresupuesto('PPT2',false);
                }

                vm.presupuestoMarco.widthPpt2 = 0;
                vm.presupuestoMarco.heightPpt2 = 0;

                vm.gotoStep('moldura1');

            } else if (pNombreCapa == "moldura2") {

                vm.resetValoresPresupuesto('MOLDURA2',false);

                vm.presupuestoMarco.widthMoldura2 = 0;
                vm.presupuestoMarco.heightMoldura2 = 0;


if (!vm.isAdministrator) {

                //Comprobamos si las dimensiones de la moldura 1 superan la limitación de 70 cm
                if (vm.moldura1Seleccionada.limitacion70cm) {

                    var medidas = vm.getMedidasMoldura1();
                    var nuevoAncho = medidas.ancho;
                    var nuevoAlto = medidas.alto;

                    if ( (nuevoAncho > 70) || (nuevoAlto > 70) ) {
                        vm.showAlertDialog("La moldura 1 insertada no permite que alguno de sus lados supere los 70 cm.");

                        //Inicializamos todos los valores del presupuesto
                        vm.resetValoresPresupuesto("MOLDURA1",false);
                        vm.gotoStep('moldura1');
                        return;
                    }
                }

}

                vm.gotoStep('cristalTrasera');

            } else if (pNombreCapa == "moldura3") {

                vm.resetValoresPresupuesto('MOLDURA3',false);

                vm.presupuestoMarco.widthMoldura3 = 0;
                vm.presupuestoMarco.heightMoldura3 = 0;

                vm.gotoStep('cristalTrasera');
            }

        }



        //***************************************************************
        function gotoStep(pNombreCapa)
        {
            if (pNombreCapa == "presupuestos") {

                $state.go('app.menu_presupuestos');

            } else if (pNombreCapa == "medidas") {

                //Mostramos la capa Medidas
                vm.iconoDesplegarContraerMedidas = "icon-chevron-up";
                vm.textoDesplegarContraerMedidas = "contraer";
                vm.desplegadoContenidoMedidas = true;

                vm.iconoDesplegarContraerPpt1 = "icon-chevron-down";
                vm.textoDesplegarContraerPpt1 = "desplegar";
                vm.desplegadoContenidoPpt1 = false;

                vm.iconoDesplegarContraerPpt2 = "icon-chevron-down";
                vm.textoDesplegarContraerPpt2 = "desplegar";
                vm.desplegadoContenidoPpt2 = false;

                vm.iconoDesplegarContraerMoldura1 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura1 = "desplegar";
                vm.desplegadoContenidoMoldura1 = false;

                vm.iconoDesplegarContraerMoldura2 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura2 = "desplegar";
                vm.desplegadoContenidoMoldura2 = false;

                vm.iconoDesplegarContraerMoldura3 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura3 = "desplegar";
                vm.desplegadoContenidoMoldura3 = false;

                vm.iconoDesplegarContraerCristalTrasera = "icon-chevron-down";
                vm.textoDesplegarContraerCristalTrasera = "desplegar";
                vm.desplegadoContenidoCristalTrasera = false;

                vm.iconoDesplegarContraerUnidades = "icon-chevron-down";
                vm.textoDesplegarContraerUnidades = "desplegar";
                vm.desplegadoContenidoUnidades = false;

            } else if (pNombreCapa == "ppt1") {

                if ( (vm.presupuestoMarco.width<=0) || (vm.presupuestoMarco.height<=0) ) {

                    vm.showAlertDialog("Debes insertar las medidas para la enmarcación.")
                    return;
                }

                //Comprobamos el valor máximo para el ancho y el alto => en medida EXTERIOR no mayor de 200cm y en medida INTERIOR no mayor de 180cm
                if (!vm.checkMaxValue(vm.presupuestoMarco.width)) {
                    return;
                }

                if (!vm.checkMaxValue(vm.presupuestoMarco.height)) {
                    return;
                }

                vm.iconoDesplegarContraerMedidas = "icon-chevron-down";
                vm.textoDesplegarContraerMedidas = "desplegar";
                vm.desplegadoContenidoMedidas = false;

                //Mostramos la capa ppt 1
                vm.iconoDesplegarContraerPpt1 = "icon-chevron-up";
                vm.textoDesplegarContraerPpt1 = "contraer";
                vm.desplegadoContenidoPpt1 = true;

                vm.iconoDesplegarContraerPpt2 = "icon-chevron-down";
                vm.textoDesplegarContraerPpt2 = "desplegar";
                vm.desplegadoContenidoPpt2 = false;

                vm.iconoDesplegarContraerMoldura1 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura1 = "desplegar";
                vm.desplegadoContenidoMoldura1 = false;

                vm.iconoDesplegarContraerMoldura2 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura2 = "desplegar";
                vm.desplegadoContenidoMoldura2 = false;

                vm.iconoDesplegarContraerMoldura3 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura3 = "desplegar";
                vm.desplegadoContenidoMoldura3 = false;

                vm.iconoDesplegarContraerCristalTrasera = "icon-chevron-down";
                vm.textoDesplegarContraerCristalTrasera = "desplegar";
                vm.desplegadoContenidoCristalTrasera = false;

                vm.iconoDesplegarContraerUnidades = "icon-chevron-down";
                vm.textoDesplegarContraerUnidades = "desplegar";
                vm.desplegadoContenidoUnidades = false;

            } else if (pNombreCapa == "ppt2") {

                vm.iconoDesplegarContraerMedidas = "icon-chevron-down";
                vm.textoDesplegarContraerMedidas = "desplegar";
                vm.desplegadoContenidoMedidas = false;

                vm.iconoDesplegarContraerPpt1 = "icon-chevron-down";
                vm.textoDesplegarContraerPpt1 = "desplegar";
                vm.desplegadoContenidoPpt1 = false;

                //Mostramos la capa ppt 2
                vm.iconoDesplegarContraerPpt2 = "icon-chevron-up";
                vm.textoDesplegarContraerPpt2 = "contraer";
                vm.desplegadoContenidoPpt2 = true;

                vm.iconoDesplegarContraerMoldura1 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura1 = "desplegar";
                vm.desplegadoContenidoMoldura1 = false;

                vm.iconoDesplegarContraerMoldura2 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura2 = "desplegar";
                vm.desplegadoContenidoMoldura2 = false;

                vm.iconoDesplegarContraerMoldura3 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura3 = "desplegar";
                vm.desplegadoContenidoMoldura3 = false;

                vm.iconoDesplegarContraerCristalTrasera = "icon-chevron-down";
                vm.textoDesplegarContraerCristalTrasera = "desplegar";
                vm.desplegadoContenidoCristalTrasera = false;

                vm.iconoDesplegarContraerUnidades = "icon-chevron-down";
                vm.textoDesplegarContraerUnidades = "desplegar";
                vm.desplegadoContenidoUnidades = false;

            } else if (pNombreCapa == "moldura1") {

                vm.iconoDesplegarContraerMedidas = "icon-chevron-down";
                vm.textoDesplegarContraerMedidas = "desplegar";
                vm.desplegadoContenidoMedidas = false;

                vm.iconoDesplegarContraerPpt1 = "icon-chevron-down";
                vm.textoDesplegarContraerPpt1 = "desplegar";
                vm.desplegadoContenidoPpt1 = false;

                vm.iconoDesplegarContraerPpt2 = "icon-chevron-down";
                vm.textoDesplegarContraerPpt2 = "desplegar";
                vm.desplegadoContenidoPpt2 = false;

                //Mostramos la capa Moldura 1
                vm.iconoDesplegarContraerMoldura1 = "icon-chevron-up";
                vm.textoDesplegarContraerMoldura1 = "contraer";
                vm.desplegadoContenidoMoldura1 = true;

                vm.iconoDesplegarContraerMoldura2 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura2 = "desplegar";
                vm.desplegadoContenidoMoldura2 = false;

                vm.iconoDesplegarContraerMoldura3 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura3 = "desplegar";
                vm.desplegadoContenidoMoldura3 = false;

                vm.iconoDesplegarContraerCristalTrasera = "icon-chevron-down";
                vm.textoDesplegarContraerCristalTrasera = "desplegar";
                vm.desplegadoContenidoCristalTrasera = false;

                vm.iconoDesplegarContraerUnidades = "icon-chevron-down";
                vm.textoDesplegarContraerUnidades = "desplegar";
                vm.desplegadoContenidoUnidades = false;

            } else if (pNombreCapa == "moldura2") {

                vm.iconoDesplegarContraerMedidas = "icon-chevron-down";
                vm.textoDesplegarContraerMedidas = "desplegar";
                vm.desplegadoContenidoMedidas = false;

                vm.iconoDesplegarContraerPpt1 = "icon-chevron-down";
                vm.textoDesplegarContraerPpt1 = "desplegar";
                vm.desplegadoContenidoPpt1 = false;

                vm.iconoDesplegarContraerPpt2 = "icon-chevron-down";
                vm.textoDesplegarContraerPpt2 = "desplegar";
                vm.desplegadoContenidoPpt2 = false;

                vm.iconoDesplegarContraerMoldura1 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura1 = "desplegar";
                vm.desplegadoContenidoMoldura1 = false;

                //Mostramos la capa Moldura 2
                vm.iconoDesplegarContraerMoldura2 = "icon-chevron-up";
                vm.textoDesplegarContraerMoldura2 = "contraer";
                vm.desplegadoContenidoMoldura2 = true;

                vm.iconoDesplegarContraerMoldura3 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura3 = "desplegar";
                vm.desplegadoContenidoMoldura3 = false;

                vm.iconoDesplegarContraerCristalTrasera = "icon-chevron-down";
                vm.textoDesplegarContraerCristalTrasera = "desplegar";
                vm.desplegadoContenidoCristalTrasera = false;

                vm.iconoDesplegarContraerUnidades = "icon-chevron-down";
                vm.textoDesplegarContraerUnidades = "desplegar";
                vm.desplegadoContenidoUnidades = false;

            } else if (pNombreCapa == "moldura3") {

                vm.iconoDesplegarContraerMedidas = "icon-chevron-down";
                vm.textoDesplegarContraerMedidas = "desplegar";
                vm.desplegadoContenidoMedidas = false;

                vm.iconoDesplegarContraerPpt1 = "icon-chevron-down";
                vm.textoDesplegarContraerPpt1 = "desplegar";
                vm.desplegadoContenidoPpt1 = false;

                vm.iconoDesplegarContraerPpt2 = "icon-chevron-down";
                vm.textoDesplegarContraerPpt2 = "desplegar";
                vm.desplegadoContenidoPpt2 = false;

                vm.iconoDesplegarContraerMoldura1 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura1 = "desplegar";
                vm.desplegadoContenidoMoldura1 = false;

                vm.iconoDesplegarContraerMoldura2 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura2 = "desplegar";
                vm.desplegadoContenidoMoldura2 = false;

                //Mostramos la capa Moldura 3
                vm.iconoDesplegarContraerMoldura3 = "icon-chevron-up";
                vm.textoDesplegarContraerMoldura3 = "contraer";
                vm.desplegadoContenidoMoldura3 = true;

                vm.iconoDesplegarContraerCristalTrasera = "icon-chevron-down";
                vm.textoDesplegarContraerCristalTrasera = "desplegar";
                vm.desplegadoContenidoCristalTrasera = false;

                vm.iconoDesplegarContraerUnidades = "icon-chevron-down";
                vm.textoDesplegarContraerUnidades = "desplegar";
                vm.desplegadoContenidoUnidades = false;

            } else if (pNombreCapa == "cristalTrasera") {

                vm.iconoDesplegarContraerMedidas = "icon-chevron-down";
                vm.textoDesplegarContraerMedidas = "desplegar";
                vm.desplegadoContenidoMedidas = false;

                vm.iconoDesplegarContraerPpt1 = "icon-chevron-down";
                vm.textoDesplegarContraerPpt1 = "desplegar";
                vm.desplegadoContenidoPpt1 = false;

                vm.iconoDesplegarContraerPpt2 = "icon-chevron-down";
                vm.textoDesplegarContraerPpt2 = "desplegar";
                vm.desplegadoContenidoPpt2 = false;

                vm.iconoDesplegarContraerMoldura1 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura1 = "desplegar";
                vm.desplegadoContenidoMoldura1 = false;

                vm.iconoDesplegarContraerMoldura2 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura2 = "desplegar";
                vm.desplegadoContenidoMoldura2 = false;

                vm.iconoDesplegarContraerMoldura3 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura3 = "desplegar";
                vm.desplegadoContenidoMoldura3 = false;

                //Mostramos la capa Cristal y Trasera
                vm.iconoDesplegarContraerCristalTrasera = "icon-chevron-up";
                vm.textoDesplegarContraerCristalTrasera = "contraer";
                vm.desplegadoContenidoCristalTrasera = true;

                vm.iconoDesplegarContraerUnidades = "icon-chevron-down";
                vm.textoDesplegarContraerUnidades = "desplegar";
                vm.desplegadoContenidoUnidades = false;

            } else if (pNombreCapa == "unidades") {

                vm.iconoDesplegarContraerMedidas = "icon-chevron-down";
                vm.textoDesplegarContraerMedidas = "desplegar";
                vm.desplegadoContenidoMedidas = false;

                vm.iconoDesplegarContraerPpt1 = "icon-chevron-down";
                vm.textoDesplegarContraerPpt1 = "desplegar";
                vm.desplegadoContenidoPpt1 = false;

                vm.iconoDesplegarContraerPpt2 = "icon-chevron-down";
                vm.textoDesplegarContraerPpt2 = "desplegar";
                vm.desplegadoContenidoPpt2 = false;

                vm.iconoDesplegarContraerMoldura1 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura1 = "desplegar";
                vm.desplegadoContenidoMoldura1 = false;

                vm.iconoDesplegarContraerMoldura2 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura2 = "desplegar";
                vm.desplegadoContenidoMoldura2 = false;

                vm.iconoDesplegarContraerMoldura3 = "icon-chevron-down";
                vm.textoDesplegarContraerMoldura3 = "desplegar";
                vm.desplegadoContenidoMoldura3 = false;

                vm.iconoDesplegarContraerCristalTrasera = "icon-chevron-down";
                vm.textoDesplegarContraerCristalTrasera = "desplegar";
                vm.desplegadoContenidoCristalTrasera = false;

                //Mostramos la capa Unidades
                vm.iconoDesplegarContraerUnidades = "icon-chevron-up";
                vm.textoDesplegarContraerUnidades = "contraer";
                vm.desplegadoContenidoUnidades = true;

                //Mostramos el botón "CALCULAR PRESUPUESTO"
                vm.activarBotonCalcularPresupuesto = true;
            }

        }



        //***************************************************************
        function resetValoresPresupuesto(pMoldura,pResetElementoAnterior) {

            //Para ppt1
            if (pMoldura == "PPT1") {

                vm.numeroPpt1 = null;
                vm.ppt1Seleccionada = null;

                vm.presupuestoMarco.numeroPpt1 = null;
                vm.presupuestoMarco.refLeroyMerlinPpt1 = null;
                vm.presupuestoMarco.descripcionPpt1 = "";
                vm.presupuestoMarco.multiplicadorPpt1 = 0;
                vm.presupuestoMarco.subtotalPpt1 = 0;

                vm.muestraLineaPresupuestoParaMultiventana = false;
                vm.muestraLineaPresupuestoParaPpt1 = false;

                vm.activarBotonSiguienteParaPpt1 = false;

/*
                //Actualizamos los importes del subtotal y total
                try {
                        var subtotalParte1 = 0;
                        var subtotalParte2 = Number((vm.presupuestoMarco.subtotalPpt2).toFixed(2));
                        var subtotalParte3 = Number((vm.presupuestoMarco.subtotalMoldura1).toFixed(2));
                        var subtotalParte4 = Number((vm.presupuestoMarco.subtotalMoldura2).toFixed(2));
                        var subtotalParte5 = Number((vm.presupuestoMarco.subtotalMoldura3).toFixed(2));
                        var subtotalParte6 = Number((vm.presupuestoMarco.subtotalCristal).toFixed(2));
                        var subtotalParte7 = Number((vm.presupuestoMarco.subtotalTrasera).toFixed(2));

                        vm.presupuestoMarco.subtotal = Number( (subtotalParte1 + subtotalParte2 + subtotalParte3 + subtotalParte4 + subtotalParte5 + subtotalParte6 + subtotalParte7).toFixed(2) );     

                        vm.presupuestoMarco.total =  Number((vm.presupuestoMarco.subtotal * vm.presupuestoMarco.unidades).toFixed(2));

                } catch (error) {
                        vm.presupuestoMarco.subtotal = 0;     
                        vm.presupuestoMarco.total =  0;
                }
*/
                vm.presupuestoMarco.urlImagenPpt1 = "";
                document.getElementById("pptImage1").src = "";

                //Inicializamos por defecto las dimensiones de las molduras
                vm.presupuestoMarco.widthMoldura1 = 0;
                vm.presupuestoMarco.heightMoldura1 = 0;

                vm.presupuestoMarco.widthMoldura2 = 0;
                vm.presupuestoMarco.heightMoldura2 = 0;

                vm.presupuestoMarco.widthMoldura3 = 0;
                vm.presupuestoMarco.heightMoldura3 = 0;

                //Reseteamos los valores del PPT 2 (que incluye también las molduras 1, 2 y 3)
                vm.resetValoresPresupuesto('PPT2',false);


            //Para ppt2
            } else if (pMoldura == "PPT2") {

                //Reseteamos los valores del elemento anterior (en este caso PPT1)
                if (pResetElementoAnterior) {

                    vm.resetValoresPresupuesto('PPT1',false);
                    return;
                }

                vm.numeroPpt2 = null;
                vm.ppt2Seleccionada = null;

                vm.presupuestoMarco.numeroPpt2 = null;
                vm.presupuestoMarco.refLeroyMerlinPpt2 = null;
                vm.presupuestoMarco.descripcionPpt2 = "";
                vm.presupuestoMarco.multiplicadorPpt2 = 0;
                vm.presupuestoMarco.subtotalPpt2 = 0;

                vm.muestraLineaPresupuestoParaPpt2 = false;
                vm.activarBotonSiguienteParaPpt2 = false;

/*
                //Actualizamos los importes del subtotal y total
                try {
                        var subtotalParte1 = Number((vm.presupuestoMarco.subtotalPpt1).toFixed(2));
                        var subtotalParte2 = 0;
                        var subtotalParte3 = Number((vm.presupuestoMarco.subtotalMoldura1).toFixed(2));
                        var subtotalParte4 = Number((vm.presupuestoMarco.subtotalMoldura2).toFixed(2));
                        var subtotalParte5 = Number((vm.presupuestoMarco.subtotalMoldura3).toFixed(2));
                        var subtotalParte6 = Number((vm.presupuestoMarco.subtotalCristal).toFixed(2));
                        var subtotalParte7 = Number((vm.presupuestoMarco.subtotalTrasera).toFixed(2));

                        vm.presupuestoMarco.subtotal = Number( (subtotalParte1 + subtotalParte2 + subtotalParte3 + subtotalParte4 + subtotalParte5 + subtotalParte6 + subtotalParte7).toFixed(2) );     

                        vm.presupuestoMarco.total =  Number((vm.presupuestoMarco.subtotal * vm.presupuestoMarco.unidades).toFixed(2));

                } catch (error) {
                        vm.presupuestoMarco.subtotal = 0;     
                        vm.presupuestoMarco.total =  0;
                }
*/
                vm.presupuestoMarco.urlImagenPpt2 = "";
                document.getElementById("pptImage2").src = "";

                //Inicializamos por defecto las dimensiones de las molduras
                vm.presupuestoMarco.widthMoldura1 = 0;
                vm.presupuestoMarco.heightMoldura1 = 0;

                vm.presupuestoMarco.widthMoldura2 = 0;
                vm.presupuestoMarco.heightMoldura2 = 0;

                vm.presupuestoMarco.widthMoldura3 = 0;
                vm.presupuestoMarco.heightMoldura3 = 0;

                //Reseteamos los valores de la moldura 1 (que incluye también las molduras 2 y 3)
                vm.resetValoresPresupuesto('MOLDURA1',false);

            //Para moldura1
            } else if (pMoldura == "MOLDURA1") {

                //Reseteamos los valores del elemento anterior (en este caso PPT2)
                if (pResetElementoAnterior) {

                    vm.resetValoresPresupuesto('PPT2',false);
                    return;
                }

                vm.numeroMoldura1 = null;
                vm.moldura1Seleccionada = null;

                vm.presupuestoMarco.numeroMoldura1 = null;
                vm.presupuestoMarco.refLeroyMerlinMoldura1 = null;
                vm.presupuestoMarco.descripcion1 = "";
                vm.presupuestoMarco.multiplicadorMoldura1 = 0;
                vm.presupuestoMarco.subtotalMoldura1 = 0;

                vm.muestraLineaPresupuestoParaMoldura1 = false;
                vm.activarBotonSiguienteParaMoldura1 = false;

/*
                //Actualizamos los importes del subtotal y total
                try {
                        var subtotalParte1 = Number((vm.presupuestoMarco.subtotalPpt1).toFixed(2));
                        var subtotalParte2 = Number((vm.presupuestoMarco.subtotalPpt2).toFixed(2));
                        var subtotalParte3 = 0;
                        var subtotalParte4 = Number((vm.presupuestoMarco.subtotalMoldura2).toFixed(2));
                        var subtotalParte5 = Number((vm.presupuestoMarco.subtotalMoldura3).toFixed(2));
                        var subtotalParte6 = Number((vm.presupuestoMarco.subtotalCristal).toFixed(2));
                        var subtotalParte7 = Number((vm.presupuestoMarco.subtotalTrasera).toFixed(2));

                        vm.presupuestoMarco.subtotal = Number( (subtotalParte1 + subtotalParte2 + subtotalParte3 + subtotalParte4 + subtotalParte5 + subtotalParte6 + subtotalParte7).toFixed(2) );     

                        vm.presupuestoMarco.total =  Number((vm.presupuestoMarco.subtotal * vm.presupuestoMarco.unidades).toFixed(2));

                } catch (error) {
                        vm.presupuestoMarco.subtotal = 0;     
                        vm.presupuestoMarco.total =  0;
                }
*/

                vm.presupuestoMarco.urlImagen1 = "";
                document.getElementById("moldingImage1").src = "";

                vm.presupuestoMarco.urlImagenPerfil1 = "";
                document.getElementById("outlineImage1").src = "";

                //Inicializamos por defecto las dimensiones de las molduras
                vm.presupuestoMarco.widthMoldura2 = 0;
                vm.presupuestoMarco.heightMoldura2 = 0;

                vm.presupuestoMarco.widthMoldura3 = 0;
                vm.presupuestoMarco.heightMoldura3 = 0;

                //Reseteamos los valores de la moldura 2 (que también incluye la moldura 3)
                vm.resetValoresPresupuesto('MOLDURA2',false);


            //Para moldura2
            } else if (pMoldura == "MOLDURA2") {

                //Reseteamos los valores del elemento anterior (en este caso MOLDURA1)
                if (pResetElementoAnterior) {

                    vm.resetValoresPresupuesto('MOLDURA1',false);
                    return;
                }

                vm.numeroMoldura2 = null;
                vm.moldura2Seleccionada = null;

                vm.presupuestoMarco.numeroMoldura2 = null;
                vm.presupuestoMarco.refLeroyMerlinMoldura2 = null;
                vm.presupuestoMarco.descripcion2 = "";
                vm.presupuestoMarco.multiplicadorMoldura2 = 0;
                vm.presupuestoMarco.subtotalMoldura2 = 0;

                vm.muestraLineaPresupuestoParaMoldura2 = false;
                vm.activarBotonSiguienteParaMoldura2 = false;

/*
                //Actualizamos los importes del subtotal y total
                try {
                        var subtotalParte1 = Number((vm.presupuestoMarco.subtotalPpt1).toFixed(2));
                        var subtotalParte2 = Number((vm.presupuestoMarco.subtotalPpt2).toFixed(2));
                        var subtotalParte3 = Number((vm.presupuestoMarco.subtotalMoldura1).toFixed(2));
                        var subtotalParte4 = 0;
                        var subtotalParte5 = Number((vm.presupuestoMarco.subtotalMoldura3).toFixed(2));
                        var subtotalParte6 = Number((vm.presupuestoMarco.subtotalCristal).toFixed(2));
                        var subtotalParte7 = Number((vm.presupuestoMarco.subtotalTrasera).toFixed(2));

                        vm.presupuestoMarco.subtotal = Number( (subtotalParte1 + subtotalParte2 + subtotalParte3 + subtotalParte4 + subtotalParte5 + subtotalParte6 + subtotalParte7).toFixed(2) );     

                        vm.presupuestoMarco.total =  Number((vm.presupuestoMarco.subtotal * vm.presupuestoMarco.unidades).toFixed(2));

                } catch (error) {
                        vm.presupuestoMarco.subtotal = 0;     
                        vm.presupuestoMarco.total =  0;
                }
*/

                vm.presupuestoMarco.urlImagen2 = "";
                document.getElementById("moldingImage2").src = "";

                vm.presupuestoMarco.urlImagenPerfil2 = "";
                document.getElementById("outlineImage2").src = "";

                //Inicializamos por defecto las dimensiones de las molduras
                vm.presupuestoMarco.widthMoldura3 = 0;
                vm.presupuestoMarco.heightMoldura3 = 0;

                //Reseteamos los valores de la moldura 3
                vm.resetValoresPresupuesto('MOLDURA3',false);


            //Para moldura3
            } else if (pMoldura == "MOLDURA3") {

                //Reseteamos los valores del elemento anterior (en este caso MOLDURA2)
                if (pResetElementoAnterior) {

                    vm.resetValoresPresupuesto('MOLDURA2',false);
                    return;
                }

                vm.numeroMoldura3 = null;
                vm.moldura3Seleccionada = null;

                vm.presupuestoMarco.numeroMoldura3 = null;
                vm.presupuestoMarco.refLeroyMerlinMoldura3 = null;
                vm.presupuestoMarco.descripcion3 = "";
                vm.presupuestoMarco.multiplicadorMoldura3 = 0;
                vm.presupuestoMarco.subtotalMoldura3 = 0;

                vm.muestraLineaPresupuestoParaMoldura3 = false;       
                vm.activarBotonSiguienteParaMoldura3 = false;         

/*
                //Actualizamos los importes del subtotal y total
                try {
                        var subtotalParte1 = Number((vm.presupuestoMarco.subtotalPpt1).toFixed(2));
                        var subtotalParte2 = Number((vm.presupuestoMarco.subtotalPpt2).toFixed(2));
                        var subtotalParte3 = Number((vm.presupuestoMarco.subtotalMoldura1).toFixed(2));
                        var subtotalParte4 = Number((vm.presupuestoMarco.subtotalMoldura2).toFixed(2));
                        var subtotalParte5 = 0;
                        var subtotalParte6 = Number((vm.presupuestoMarco.subtotalCristal).toFixed(2));
                        var subtotalParte7 = Number((vm.presupuestoMarco.subtotalTrasera).toFixed(2));

                        vm.presupuestoMarco.subtotal = Number( (subtotalParte1 + subtotalParte2 + subtotalParte3 + subtotalParte4 + subtotalParte5 + subtotalParte6 + subtotalParte7).toFixed(2) );     

                        vm.presupuestoMarco.total =  Number((vm.presupuestoMarco.subtotal * vm.presupuestoMarco.unidades).toFixed(2));

                } catch (error) {
                        vm.presupuestoMarco.subtotal = 0;     
                        vm.presupuestoMarco.total =  0;
                }
*/

                vm.presupuestoMarco.urlImagen3 = "";
                document.getElementById("moldingImage3").src = "";

                vm.presupuestoMarco.urlImagenPerfil3 = "";
                document.getElementById("outlineImage3").src = "";

            //Para cristal
            } else if (pMoldura == "CRISTAL") {

                //Reseteamos los valores del elemento anterior (en este caso MOLDURA3)
                /*
                if (pResetElementoAnterior) {

                    vm.resetValoresPresupuesto('MOLDURA3',false);
                    return;
                }
                */

                vm.numeroCristal = null;
                vm.cristalSeleccionado = null;

                vm.presupuestoMarco.numeroCristal = null;
                vm.presupuestoMarco.refLeroyMerlinCristal = null;
                vm.presupuestoMarco.descripcionCristal = "";
                vm.presupuestoMarco.multiplicadorCristal = 0;
                vm.presupuestoMarco.subtotalCristal = 0;

                vm.muestraLineaPresupuestoParaCristal = false; 
                vm.activarBotonSiguienteParaCristalTrasera = false;

/*
                //Actualizamos los importes del subtotal y total
                try {
                        var subtotalParte1 = Number((vm.presupuestoMarco.subtotalPpt1).toFixed(2));
                        var subtotalParte2 = Number((vm.presupuestoMarco.subtotalPpt2).toFixed(2));
                        var subtotalParte3 = Number((vm.presupuestoMarco.subtotalMoldura1).toFixed(2));
                        var subtotalParte4 = Number((vm.presupuestoMarco.subtotalMoldura2).toFixed(2));
                        var subtotalParte5 = Number((vm.presupuestoMarco.subtotalMoldura3).toFixed(2));
                        var subtotalParte6 = 0;
                        var subtotalParte7 = Number((vm.presupuestoMarco.subtotalTrasera).toFixed(2));

                        vm.presupuestoMarco.subtotal = Number( (subtotalParte1 + subtotalParte2 + subtotalParte3 + subtotalParte4 + subtotalParte5 + subtotalParte6 + subtotalParte7).toFixed(2) );     

                        vm.presupuestoMarco.total =  Number((vm.presupuestoMarco.subtotal * vm.presupuestoMarco.unidades).toFixed(2));

                } catch (error) {
                        vm.presupuestoMarco.subtotal = 0;     
                        vm.presupuestoMarco.total =  0;
                }
*/

            //Para trasera
            } else if (pMoldura == "TRASERA") {

                //Reseteamos los valores del elemento anterior (en este caso CRISTAL)
                /*
                if (pResetElementoAnterior) {

                    vm.resetValoresPresupuesto('CRISTAL',false);
                    return;
                }
                */

                vm.numeroTrasera = null;
                vm.traseraSeleccionada = null;

                vm.presupuestoMarco.numeroTrasera = null;
                vm.presupuestoMarco.refLeroyMerlinTrasera = null;
                vm.presupuestoMarco.descripcionTrasera = "";
                vm.presupuestoMarco.multiplicadorTrasera = 0;
                vm.presupuestoMarco.subtotalTrasera = 0;

                vm.muestraLineaPresupuestoParaTrasera = false;  
                vm.activarBotonSiguienteParaCristalTrasera = false;              

/*
                //Actualizamos los importes del subtotal y total
                try {
                        var subtotalParte1 = Number((vm.presupuestoMarco.subtotalPpt1).toFixed(2));
                        var subtotalParte2 = Number((vm.presupuestoMarco.subtotalPpt2).toFixed(2));
                        var subtotalParte3 = Number((vm.presupuestoMarco.subtotalMoldura1).toFixed(2));
                        var subtotalParte4 = Number((vm.presupuestoMarco.subtotalMoldura2).toFixed(2));
                        var subtotalParte5 = Number((vm.presupuestoMarco.subtotalMoldura3).toFixed(2));
                        var subtotalParte6 = Number((vm.presupuestoMarco.subtotalCristal).toFixed(2));
                        var subtotalParte7 = 0;

                        vm.presupuestoMarco.subtotal = Number( (subtotalParte1 + subtotalParte2 + subtotalParte3 + subtotalParte4 + subtotalParte5 + subtotalParte6 + subtotalParte7).toFixed(2) );     

                        vm.presupuestoMarco.total =  Number((vm.presupuestoMarco.subtotal * vm.presupuestoMarco.unidades).toFixed(2));

                } catch (error) {
                        vm.presupuestoMarco.subtotal = 0;     
                        vm.presupuestoMarco.total =  0;
                }
*/

            //PARA TODOS LOS PASSE-PARTOUTS Y TODAS LAS MOLDURAS
            } else if (pMoldura == "TODOS_LOS_VALORES") {

                //PPT 1
                vm.numeroPpt1 = null;
                vm.ppt1Seleccionada = null;

                vm.presupuestoMarco.numeroPpt1 = null;
                vm.presupuestoMarco.refLeroyMerlinPpt1 = null;
                vm.presupuestoMarco.descripcionPpt1 = "";
                vm.presupuestoMarco.multiplicadorPpt1 = 0;
                vm.presupuestoMarco.subtotalPpt1 = 0;
                vm.muestraLineaPresupuestoParaPpt1 = false;
                vm.muestraLineaPresupuestoParaMultiventana = false;
                vm.activarBotonSiguienteParaPpt1 = false;

                vm.presupuestoMarco.urlImagenPpt1 = "";
                document.getElementById("pptImage1").src = "";


                //PPT 2
                vm.numeroPpt2 = null;
                vm.ppt2Seleccionada = null;

                vm.presupuestoMarco.numeroPpt2 = null;
                vm.presupuestoMarco.refLeroyMerlinPpt2 = null;
                vm.presupuestoMarco.descripcionPpt2 = "";
                vm.presupuestoMarco.multiplicadorPpt2 = 0;
                vm.presupuestoMarco.subtotalPpt2 = 0;
                vm.muestraLineaPresupuestoParaPpt2 = false;
                vm.activarBotonSiguienteParaPpt2 = false;

                vm.presupuestoMarco.urlImagenPpt2 = "";
                document.getElementById("pptImage2").src = "";


                //MOLDURA 1
                vm.numeroMoldura1 = null;
                vm.moldura1Seleccionada = null;

                vm.presupuestoMarco.numeroMoldura1 = null;
                vm.presupuestoMarco.refLeroyMerlinMoldura1 = null;
                vm.presupuestoMarco.descripcion1 = "";
                vm.presupuestoMarco.multiplicadorMoldura1 = 0;
                vm.presupuestoMarco.subtotalMoldura1 = 0;
                vm.muestraLineaPresupuestoParaMoldura1 = false;
                vm.activarBotonSiguienteParaMoldura1 = false;

                //Para imágenes moldura 1
                vm.presupuestoMarco.urlImagen1 = "";
                document.getElementById("moldingImage1").src = "";

                vm.presupuestoMarco.urlImagenPerfil1 = "";
                document.getElementById("outlineImage1").src = "";


                //MOLDURA 2
                vm.numeroMoldura2 = null;
                vm.moldura2Seleccionada = null;

                vm.presupuestoMarco.numeroMoldura2 = null;
                vm.presupuestoMarco.refLeroyMerlinMoldura2 = null;
                vm.presupuestoMarco.descripcion2 = "";
                vm.presupuestoMarco.multiplicadorMoldura2 = 0;
                vm.presupuestoMarco.subtotalMoldura2 = 0;
                vm.muestraLineaPresupuestoParaMoldura2 = false;
                vm.activarBotonSiguienteParaMoldura2 = false;

                //Para imágenes moldura 2
                vm.presupuestoMarco.urlImagen2 = "";
                document.getElementById("moldingImage2").src = "";

                vm.presupuestoMarco.urlImagenPerfil2 = "";
                document.getElementById("outlineImage2").src = "";


                //MOLDURA 3
                vm.numeroMoldura3 = null;
                vm.moldura3Seleccionada = null;

                vm.presupuestoMarco.numeroMoldura3 = null;
                vm.presupuestoMarco.refLeroyMerlinMoldura3 = null;
                vm.presupuestoMarco.descripcion3 = "";
                vm.presupuestoMarco.multiplicadorMoldura3 = 0;
                vm.presupuestoMarco.subtotalMoldura3 = 0;
                vm.muestraLineaPresupuestoParaMoldura3 = false;
                vm.activarBotonSiguienteParaMoldura3 = false;

                //Para imágenes moldura 3
                vm.presupuestoMarco.urlImagen3 = "";
                document.getElementById("moldingImage3").src = "";

                vm.presupuestoMarco.urlImagenPerfil3 = "";
                document.getElementById("outlineImage3").src = "";

                //CRISTAL
                vm.numeroCristal = null;
                vm.cristalSeleccionado = null;

                vm.presupuestoMarco.numeroCristal = null;
                vm.presupuestoMarco.refLeroyMerlinCristal = null;
                vm.presupuestoMarco.descripcionCristal = "";
                vm.presupuestoMarco.multiplicadorCristal = 0;
                vm.presupuestoMarco.subtotalCristal = 0;
                vm.muestraLineaPresupuestoParaCristal = false;
                vm.activarBotonSiguienteParaCristalTrasera = false;

                //TRASERA
                vm.numeroTrasera = null;
                vm.traseraSeleccionada = null;

                vm.presupuestoMarco.numeroTrasera = null;
                vm.presupuestoMarco.refLeroyMerlinTrasera = null;
                vm.presupuestoMarco.descripcionTrasera = "";
                vm.presupuestoMarco.multiplicadorTrasera = 0;
                vm.presupuestoMarco.subtotalTrasera = 0;
                vm.muestraLineaPresupuestoParaTrasera = false;
                vm.activarBotonSiguienteParaCristalTrasera = false;

                //Reseteamos los importes del subtotal y total
                vm.presupuestoMarco.subtotal =  0;
                vm.presupuestoMarco.total =  0; 


                //Inicializamos por defecto las dimensiones de las molduras
                vm.presupuestoMarco.widthMoldura1 = 0;
                vm.presupuestoMarco.heightMoldura1 = 0;

                vm.presupuestoMarco.widthMoldura2 = 0;
                vm.presupuestoMarco.heightMoldura2 = 0;

                vm.presupuestoMarco.widthMoldura3 = 0;
                vm.presupuestoMarco.heightMoldura3 = 0;

                vm.budgetCalculated = false;
            }


            //RESETEAMOS LOS VALORES DE LOS SUBTOTALES PARA PPT1-2, MOLDURAS1-2-3 Y CRISTAL-TRASERA, ADEMÁS DEL SUBTOTAL Y TOTAL DEL PRESUPUESTO
            vm.resetMultiplicadoresSubtotales();

            vm.activarBotonCalcularPresupuesto = false;
            
        }


        //***************************************************************
        function actualizaTotalPresupuesto() { 

             vm.presupuestoMarco.total =  Number((vm.presupuestoMarco.subtotal * vm.presupuestoMarco.unidades).toFixed(2));
         }



        //***************************************************************
        function insertarPpt1(pNumeroPpt) {

            vm.presupuestoMarco.widthPpt1 = Number(vm.presupuestoMarco.widthPpt1);
            vm.presupuestoMarco.heightPpt1 = Number(vm.presupuestoMarco.heightPpt1);

            if ( (vm.presupuestoMarco.widthPpt1<=0) || (vm.presupuestoMarco.heightPpt1<=0) ) {
                vm.showAlertDialog("Debes insertar las medidas de entrecalle para el passe-partout.")
                return;
            }

            if (vm.numeroPpt1 == null) {
                vm.showAlertDialog("Debes insertar un passe-partout.")
                return;
            }

if (!vm.isAdministrator) {
            if ( (vm.presupuestoMarco.widthPpt1<3) || (vm.presupuestoMarco.heightPpt1<3) ) {
                vm.showAlertDialog("La medida de entrecalle no puede ser inferior a 3 cm.")
                return;
            }
}            

            vm.activarBotonSiguienteParaPpt1 = true;

            var fbUrl = firebaseDataService.productos_passepartout;
            var result;
            try {
                result = $firebaseArray(fbUrl.orderByChild("numeroPpt").equalTo(parseInt(pNumeroPpt)));
            } catch(error) {
                return;
            }

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    if (dataLength > 0) {

//Comprobamos si el producto seleccionado está ACTIVO
if (!data[0].activo) {

    vm.showAlertDialog("El passe-partout seleccionado no está disponible en este momento.");

    //Inicializamos todos los valores del presupuesto
    vm.resetValoresPresupuesto("PPT1",false);

    return;
}

                        //Obtenemos el ppt seleccionado
                        vm.ppt1Seleccionada = data[0];

                        //Convertimos algunos valores en números
                        vm.presupuestoMarco.height = Number(vm.presupuestoMarco.height);
                        vm.presupuestoMarco.width = Number(vm.presupuestoMarco.width);
                        vm.ppt1Seleccionada.limitacionAnchoCm = Number(vm.ppt1Seleccionada.limitacionAnchoCm);
                        vm.ppt1Seleccionada.limitacionAltoCm = Number(vm.ppt1Seleccionada.limitacionAltoCm);


if (!vm.isAdministrator) {

                        //RESTRICCIÓN PARA MEDIDA INTERIOR
                        if (vm.presupuestoMarco.medidaExteriorValorString == "false") {
                            //Comprobamos si el ancho de la obra supera la limitación de ancho (en cm)
                            if (vm.presupuestoMarco.width > vm.ppt1Seleccionada.limitacionAnchoCm) {
                                vm.showAlertDialog("Este passe-partout no permite que el ancho supere los " + vm.ppt1Seleccionada.limitacionAnchoCm + " cm.");

                                //Inicializamos todos los valores del presupuesto
                                vm.resetValoresPresupuesto("PPT1",false);
                                
                                return;
                            }

                            //Comprobamos si el alto de la obra supera la limitación de alto (en cm)
                            if (vm.presupuestoMarco.height > vm.ppt1Seleccionada.limitacionAltoCm) {
                                vm.showAlertDialog("Este passe-partout no permite que el alto supere los " + vm.ppt1Seleccionada.limitacionAltoCm + " cm.");

                                //Inicializamos todos los valores del presupuesto
                                vm.resetValoresPresupuesto("PPT1",false);
                                
                                return;
                            }

                        //RESTRICCIÓN PARA MEDIDA EXTERIOR    
                        } 

}


                        //Asignamos los valores del presupuesto.
                        vm.presupuestoMarco.numeroPpt1 = vm.ppt1Seleccionada.numeroPpt;
                        vm.presupuestoMarco.refLeroyMerlinPpt1 = vm.ppt1Seleccionada.refLeroyMerlin;
                        vm.presupuestoMarco.descripcionPpt1 = vm.ppt1Seleccionada.descripcion;
                        vm.presupuestoMarco.precioLeroyMerlinPpt1 = vm.ppt1Seleccionada.precioLeroyMerlin;
                        vm.presupuestoMarco.precioCostePpt1 = vm.ppt1Seleccionada.precioCoste;

                        //RESETEAMOS LOS VALORES DE LOS SUBTOTALES PARA PPT1-2, MOLDURAS1-2-3 Y CRISTAL-TRASERA, ADEMÁS DEL SUBTOTAL Y TOTAL DEL PRESUPUESTO
                        vm.resetMultiplicadoresSubtotales();

                        vm.muestraLineaPresupuestoParaPpt1 = true;


                        if (vm.ppt1Seleccionada.urlImagen != null) {
                            vm.presupuestoMarco.urlImagenPpt1 = vm.ppt1Seleccionada.urlImagen;
                            document.getElementById("pptImage1").src = vm.presupuestoMarco.urlImagenPpt1;
                        }

                        //Hacemos el reset de los valores de Ppt2, moldura 1, moldura 2 y moldura 3
                        vm.resetValoresPresupuesto("PPT2",false);

                    } else {

                        vm.ppt1Seleccionada = null;
                        vm.resetValoresPresupuesto("PPT1",false);
                    }

                })

                .catch(function(error) {

                    utilsService.writeConsole("[FramingBudgetController] => insertarPpt1() => ERROR: " + error, WRITE_IN_CONSOLE);

                    vm.ppt1Seleccionada = null;
                    vm.resetValoresPresupuesto("PPT1",false);
                }
            );            

        }


        //***************************************************************
        function insertarPpt2(pNumeroPpt) {

            if ( (vm.presupuestoMarco.widthPpt1<=0) || (vm.presupuestoMarco.heightPpt1<=0) || (vm.presupuestoMarco.numeroPpt1 == null) ) {
                vm.showAlertDialog("Debes insertar primero el passe-partout 1.")
                return;
            }

            vm.presupuestoMarco.widthPpt2 = Number(vm.presupuestoMarco.widthPpt2);
            vm.presupuestoMarco.heightPpt2 = Number(vm.presupuestoMarco.heightPpt2);

            if ( (vm.presupuestoMarco.widthPpt2<=0) || (vm.presupuestoMarco.heightPpt2<=0) ) {
                vm.showAlertDialog("Debes insertar las medidas de entrecalle para el passe-partout.")
                return;
            }

            if (vm.numeroPpt2 == null) {
                vm.showAlertDialog("Debes insertar un passe-partout.")
                return;
            }

if (!vm.isAdministrator) {
            if ( (vm.presupuestoMarco.widthPpt2<3) || (vm.presupuestoMarco.heightPpt2<3) ) {
                vm.showAlertDialog("La medida de entrecalle no puede ser inferior a 3 cm.")
                return;
            }
}

            vm.activarBotonSiguienteParaPpt2 = true;

            var fbUrl = firebaseDataService.productos_passepartout;
            var result;
            try {
                result = $firebaseArray(fbUrl.orderByChild("numeroPpt").equalTo(parseInt(pNumeroPpt)));
            } catch(error) {
                return;
            }


            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    if (dataLength > 0) {

//Comprobamos si el producto seleccionado está ACTIVO
if (!data[0].activo) {

    vm.showAlertDialog("El passe-partout seleccionado no está disponible en este momento.");

    //Inicializamos todos los valores del presupuesto
    vm.resetValoresPresupuesto("PPT2",false);

    return;
}

                        //Obtenemos el ppt seleccionado
                        vm.ppt2Seleccionada = data[0];

                        //Convertimos algunos valores en números
                        vm.presupuestoMarco.height = Number(vm.presupuestoMarco.height);
                        vm.presupuestoMarco.width = Number(vm.presupuestoMarco.width);
                        vm.ppt2Seleccionada.limitacionAnchoCm = Number(vm.ppt2Seleccionada.limitacionAnchoCm);
                        vm.ppt2Seleccionada.limitacionAltoCm = Number(vm.ppt2Seleccionada.limitacionAltoCm);

if (!vm.isAdministrator) {
                        //Comprobamos si el ancho de la obra supera la limitación de ancho (en cm)
                        if (vm.presupuestoMarco.width > vm.ppt2Seleccionada.limitacionAnchoCm) {

                            vm.showAlertDialog("Este passe-partout no permite que el ancho supere los " + vm.ppt2Seleccionada.limitacionAnchoCm + " cm.");

                            //Inicializamos todos los valores del presupuesto
                            vm.resetValoresPresupuesto("PPT2",false);
                            
                            return;
                        }

                        //Comprobamos si el alto de la obra supera la limitación de alto (en cm)
                        if (vm.presupuestoMarco.height > vm.ppt2Seleccionada.limitacionAltoCm) {

                            vm.showAlertDialog("Este passe-partout no permite que el alto supere los " + vm.ppt2Seleccionada.limitacionAltoCm + " cm.");

                            //Inicializamos todos los valores del presupuesto
                            vm.resetValoresPresupuesto("PPT2",false);
                            
                            return;
                        }
}

                        //Convertimos algunos valores en números
                        vm.presupuestoMarco.height = Number(vm.presupuestoMarco.height);
                        vm.presupuestoMarco.width = Number(vm.presupuestoMarco.width);

                        //Asignamos los valores del presupuesto.
                        vm.presupuestoMarco.numeroPpt2 = vm.ppt2Seleccionada.numeroPpt;
                        vm.presupuestoMarco.refLeroyMerlinPpt2 = vm.ppt2Seleccionada.refLeroyMerlin;
                        vm.presupuestoMarco.descripcionPpt2 = vm.ppt2Seleccionada.descripcion;
                        vm.presupuestoMarco.precioLeroyMerlinPpt2 = vm.ppt2Seleccionada.precioLeroyMerlin;
                        vm.presupuestoMarco.precioCostePpt2 = vm.ppt2Seleccionada.precioCoste;


                        //RESETEAMOS LOS VALORES DE LOS SUBTOTALES PARA PPT1-2, MOLDURAS1-2-3 Y CRISTAL-TRASERA, ADEMÁS DEL SUBTOTAL Y TOTAL DEL PRESUPUESTO
                        vm.resetMultiplicadoresSubtotales();

                        vm.muestraLineaPresupuestoParaPpt2 = true;

                        if (vm.ppt2Seleccionada.urlImagen != null) {
                            vm.presupuestoMarco.urlImagenPpt2 = vm.ppt2Seleccionada.urlImagen;
                            document.getElementById("pptImage2").src = vm.presupuestoMarco.urlImagenPpt2;
                        }

                        //Hacemos el reset de los valores de moldura 1, moldura 2 y moldura 3
                        vm.resetValoresPresupuesto("MOLDURA1",false);

                    } else {

                        vm.ppt2Seleccionada = null;
                        vm.resetValoresPresupuesto("PPT2",false);
                    }


                })

                .catch(function(error) {

                    utilsService.writeConsole("[FramingBudgetController] => insertarPpt2() => ERROR: " + error, WRITE_IN_CONSOLE);

                    vm.ppt2Seleccionada = null;
                    vm.resetValoresPresupuesto("PPT2",false);
                }
            );            

        }



        //***************************************************************
        function insertarMoldura1(pNumeroMoldura) {

            if ( pNumeroMoldura == null ) {

                vm.showAlertDialog("Debes insertar una moldura.")
                return;
            }

            vm.activarBotonSiguienteParaMoldura1 = true;


            var fbUrl = firebaseDataService.productos_moldura;
            var result;
            try {
                result = $firebaseArray(fbUrl.orderByChild("numeroMoldura").equalTo(parseInt(pNumeroMoldura)));
            } catch(error) {
                return;
            }

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    if (dataLength > 0) {

//Comprobamos si el producto seleccionado está ACTIVO
if (!data[0].activo) {

    vm.showAlertDialog("La moldura seleccionada no está disponible en este momento.");

    //Inicializamos todos los valores del presupuesto
    vm.resetValoresPresupuesto("MOLDURA1",false);

    return;
}

                        //Obtenemos la moldura seleccionada
                        vm.moldura1Seleccionada = data[0];

                        //Convertimos algunos valores en números
                        vm.presupuestoMarco.height = Number(vm.presupuestoMarco.height);
                        vm.presupuestoMarco.width = Number(vm.presupuestoMarco.width);

                        //Asignamos los valores del presupuesto.
                        vm.presupuestoMarco.numeroMoldura1 = vm.moldura1Seleccionada.numeroMoldura;
                        vm.presupuestoMarco.refLeroyMerlinMoldura1 = vm.moldura1Seleccionada.refLeroyMerlin;                        
                        vm.presupuestoMarco.descripcion1 = vm.moldura1Seleccionada.descripcion;
                        vm.presupuestoMarco.precioLeroyMerlin1 = vm.moldura1Seleccionada.precioLeroyMerlin;
                        vm.presupuestoMarco.precioCoste1 = vm.moldura1Seleccionada.precioCoste;
                        vm.presupuestoMarco.desperdicio1 = vm.moldura1Seleccionada.desperdicio;

                        //MUY IMPORTANTE => ANTES DE INSERTAR LA MOLDURA 1 DEBEMOS COMPROBAR SI APLICAMOS LAS RESTRICCIONES PARA LA SELECCIÓN DE CRISTAL (CASO EN QUE UNO DE LOS LADOS DEL MOTIVO > 70 cm)
                        if ( (vm.presupuestoMarco.width > 70) || (vm.presupuestoMarco.height > 70) ) {
                            vm.mostrarTodosCristales = false;
                        } else {
                            vm.mostrarTodosCristales = true;
                        }


                        //Si la moldura seleccionada tiene número de moldura = 17,18,19,20,  45,46,47 y 48 entonces asignamos el valor "SIN CRISTAL" al combo de cristal
                        vm.reseteaCombosSeleccionCristalYtrasera();
                        var numeroMolduraSeleccionada = parseInt(pNumeroMoldura);
                        if (  ((numeroMolduraSeleccionada > 16) && (numeroMolduraSeleccionada < 21)) || ((numeroMolduraSeleccionada > 44) && (numeroMolduraSeleccionada < 49)) ) {

                            vm.ocultarSelectorCristal = true;
                            vm.cristalSeleccionado = { "numeroArticulo": 0,
                                                       "refProveedor": "",
                                                       "refLeroyMerlin": 0,
                                                       "descripcion": "Sin cristal",
                                                       "tipo": "cristal",
                                                       "limitacionAnchoCm": 0,
                                                       "limitacionAltoCm": 0,
                                                       "precioCoste": 0,
                                                       "precioLeroyMerlin": 0,
                                                       "urlImagen": "",
                                                       "urlImagen2": "",
                                                       "observaciones": "",
                                                       "activo": true
                            };

                        } else {

                            vm.ocultarSelectorCristal = false;
                        }


                        //RESETEAMOS LOS VALORES DE LOS SUBTOTALES PARA PPT1-2, MOLDURAS1-2-3 Y CRISTAL-TRASERA, ADEMÁS DEL SUBTOTAL Y TOTAL DEL PRESUPUESTO
                        vm.resetMultiplicadoresSubtotales();

                        vm.muestraLineaPresupuestoParaMoldura1 = true;

                        if (vm.moldura1Seleccionada.urlImagen != null) {
                            vm.presupuestoMarco.urlImagen1 = vm.moldura1Seleccionada.urlImagen;
                            document.getElementById("moldingImage1").src = vm.presupuestoMarco.urlImagen1;
                        }

                        if (vm.moldura1Seleccionada.urlImagenPerfil != null) {
                            vm.presupuestoMarco.urlImagenPerfil1 = vm.moldura1Seleccionada.urlImagenPerfil;
                            document.getElementById("outlineImage1").src = vm.presupuestoMarco.urlImagenPerfil1;
                        }

                        //Hacemos el reset de los valores de moldura 2 y moldura 3
                        vm.resetValoresPresupuesto("MOLDURA2",false);

                    } else {

                        vm.moldura1Seleccionada = null;
                        vm.resetValoresPresupuesto("MOLDURA1",false);
                    }



                })

                .catch(function(error) {

                    utilsService.writeConsole("[FramingBudgetController] => insertarMoldura1() => ERROR: " + error, WRITE_IN_CONSOLE);

                    vm.moldura1Seleccionada = null;
                    vm.resetValoresPresupuesto("MOLDURA1",false);
                }
            );            

        }



        //***************************************************************
        function insertarMoldura2(pNumeroMoldura) {

            if ( pNumeroMoldura == null ) {

                vm.showAlertDialog("Debes insertar una moldura.")
                return;
            }

            vm.activarBotonSiguienteParaMoldura2 = true;


            var fbUrl = firebaseDataService.productos_moldura;
            var result;
            try {
                result = $firebaseArray(fbUrl.orderByChild("numeroMoldura").equalTo(parseInt(pNumeroMoldura)));
            } catch(error) {
                return;
            }


            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    if (dataLength > 0) {

//Comprobamos si el producto seleccionado está ACTIVO
if (!data[0].activo) {

    vm.showAlertDialog("La moldura seleccionada no está disponible en este momento.");

    //Inicializamos todos los valores del presupuesto
    vm.resetValoresPresupuesto("MOLDURA2",false);

    return;
}

                        //Obtenemos la moldura seleccionada
                        vm.moldura2Seleccionada = data[0];

                        //Convertimos algunos valores en números
                        vm.presupuestoMarco.height = Number(vm.presupuestoMarco.height);
                        vm.presupuestoMarco.width = Number(vm.presupuestoMarco.width);

                        //Asignamos los valores del presupuesto para la moldura2 y para el total del presupuesto.
                        vm.presupuestoMarco.numeroMoldura2 = vm.moldura2Seleccionada.numeroMoldura;
                        vm.presupuestoMarco.refLeroyMerlinMoldura2 = vm.moldura2Seleccionada.refLeroyMerlin;                                     
                        vm.presupuestoMarco.descripcion2 = vm.moldura2Seleccionada.descripcion;
                        vm.presupuestoMarco.precioLeroyMerlin2 = vm.moldura2Seleccionada.precioLeroyMerlin;
                        vm.presupuestoMarco.precioCoste2 = vm.moldura2Seleccionada.precioCoste;
                        vm.presupuestoMarco.desperdicio2 = vm.moldura2Seleccionada.desperdicio;


                        //RESETEAMOS LOS VALORES DE LOS SUBTOTALES PARA PPT1-2, MOLDURAS1-2-3 Y CRISTAL-TRASERA, ADEMÁS DEL SUBTOTAL Y TOTAL DEL PRESUPUESTO
                        vm.resetMultiplicadoresSubtotales();

                        vm.muestraLineaPresupuestoParaMoldura2 = true;

                        if (vm.moldura2Seleccionada.urlImagen != null) {
                            vm.presupuestoMarco.urlImagen2 = vm.moldura2Seleccionada.urlImagen;
                            document.getElementById("moldingImage2").src = vm.presupuestoMarco.urlImagen2;
                        }

                        if (vm.moldura2Seleccionada.urlImagenPerfil != null) {
                            vm.presupuestoMarco.urlImagenPerfil2 = vm.moldura2Seleccionada.urlImagenPerfil;
                            document.getElementById("outlineImage2").src = vm.presupuestoMarco.urlImagenPerfil2;
                        }

                        //Hacemos el reset de los valores de moldura 3
                        vm.resetValoresPresupuesto("MOLDURA3",false);

                    } else {

                        vm.moldura2Seleccionada = null;
                        vm.resetValoresPresupuesto("MOLDURA2",false);
                    }


                })

                .catch(function(error) {

                    utilsService.writeConsole("[FramingBudgetController] => insertarMoldura2() => ERROR: " + error, WRITE_IN_CONSOLE);

                    vm.moldura2Seleccionada = null;
                    vm.resetValoresPresupuesto("MOLDURA2",false);
                }
            );            

        }



        //***************************************************************
        function insertarMoldura3(pNumeroMoldura) {

            if (vm.presupuestoMarco.numeroMoldura2 == null) {
                vm.showAlertDialog("Debes insertar previamente la moldura 2.");
                return;
            }


            if ( pNumeroMoldura == null ) {

                vm.showAlertDialog("Debes insertar una moldura.")
                return;
            }

            vm.activarBotonSiguienteParaMoldura3 = true;


            var fbUrl = firebaseDataService.productos_moldura;
            var result;
            try {
                result = $firebaseArray(fbUrl.orderByChild("numeroMoldura").equalTo(parseInt(pNumeroMoldura)));
            } catch(error) {
                return;
            }


            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    if (dataLength > 0) {

//Comprobamos si el producto seleccionado está ACTIVO
if (!data[0].activo) {

    vm.showAlertDialog("La moldura seleccionada no está disponible en este momento.");

    //Inicializamos todos los valores del presupuesto
    vm.resetValoresPresupuesto("MOLDURA3",false);

    return;
}

                        //Obtenemos la moldura seleccionada
                        vm.moldura3Seleccionada = data[0];

                        //Convertimos algunos valores en números
                        vm.presupuestoMarco.height = Number(vm.presupuestoMarco.height);
                        vm.presupuestoMarco.width = Number(vm.presupuestoMarco.width);

                        //Asignamos los valores del presupuesto para la moldura3 y para el total del presupuesto.
                        vm.presupuestoMarco.numeroMoldura3 = vm.moldura3Seleccionada.numeroMoldura;
                        vm.presupuestoMarco.refLeroyMerlinMoldura3 = vm.moldura3Seleccionada.refLeroyMerlin;
                        vm.presupuestoMarco.descripcion3 = vm.moldura3Seleccionada.descripcion;
                        vm.presupuestoMarco.precioLeroyMerlin3 = vm.moldura3Seleccionada.precioLeroyMerlin;
                        vm.presupuestoMarco.precioCoste3 = vm.moldura3Seleccionada.precioCoste;
                        vm.presupuestoMarco.desperdicio3 = vm.moldura3Seleccionada.desperdicio;


                        //RESETEAMOS LOS VALORES DE LOS SUBTOTALES PARA PPT1-2, MOLDURAS1-2-3 Y CRISTAL-TRASERA, ADEMÁS DEL SUBTOTAL Y TOTAL DEL PRESUPUESTO
                        vm.resetMultiplicadoresSubtotales();

                        vm.muestraLineaPresupuestoParaMoldura3 = true;

                        if (vm.moldura3Seleccionada.urlImagen != null) {
                            vm.presupuestoMarco.urlImagen3 = vm.moldura3Seleccionada.urlImagen;
                            document.getElementById("moldingImage3").src = vm.presupuestoMarco.urlImagen3;
                        }

                        if (vm.moldura3Seleccionada.urlImagenPerfil != null) {
                            vm.presupuestoMarco.urlImagenPerfil3 = vm.moldura3Seleccionada.urlImagenPerfil;
                            document.getElementById("outlineImage3").src = vm.presupuestoMarco.urlImagenPerfil3;
                        }

                    } else {

                        vm.moldura3Seleccionada = null;
                        vm.resetValoresPresupuesto("MOLDURA3",false);

                    }

                })

                .catch(function(error) {

                    utilsService.writeConsole("[FramingBudgetController] => insertarMoldura3() => ERROR: " + error, WRITE_IN_CONSOLE);

                    vm.moldura3Seleccionada = null;
                    vm.resetValoresPresupuesto("MOLDURA3",false);

                }
            );            

        }



        //***************************************************************
        function assignNumeroCristal(pNumeroCristal) {
            var cristal = vm.cristales.find(findNumeroCristal);
            vm.cristalSeleccionado = cristal;
        }


        //***************************************************************
        function findNumeroCristal(pCristal) {
            return pCristal.numeroArticulo === vm.numeroCristal;
        }


        //***************************************************************
        function assignNumeroTrasera(pNumeroTrasera) {
            var trasera = vm.traseras.find(findNumeroTrasera);
            vm.traseraSeleccionada = trasera;
        }


        //***************************************************************
        function findNumeroTrasera(pTrasera) {
            return pTrasera.numeroArticulo === vm.numeroTrasera;
        }


        //***************************************************************
        function insertarCristalTrasera() {

            if ( (!vm.presupuestoMarco.dobleCristal) && (vm.cristalSeleccionado == null) ) {

                vm.showAlertDialog("Debes seleccionar un cristal.")
                return;
            }

            if ( (!vm.presupuestoMarco.dobleCristal) && (vm.traseraSeleccionada == null) ) {

                vm.showAlertDialog("Debes seleccionar una trasera.")
                return;
            }

            vm.activarBotonSiguienteParaCristalTrasera = true;
            vm.activarBotonCalcularPresupuesto = true;

            var nuevoAncho = 0;
            var nuevoAlto = 0;

            if (vm.numeroPpt1 == null) {

                nuevoAncho = Number(vm.presupuestoMarco.width);
                nuevoAlto = Number(vm.presupuestoMarco.height);

            } else if (vm.numeroPpt2 == null) {

                nuevoAncho = Number(vm.presupuestoMarco.width + 2*(vm.presupuestoMarco.widthPpt1) );
                nuevoAlto = Number(vm.presupuestoMarco.height + 2*(vm.presupuestoMarco.heightPpt1) );

            } else {

                nuevoAncho = Number(vm.presupuestoMarco.width + 2*(vm.presupuestoMarco.widthPpt1) + 2*(vm.presupuestoMarco.widthPpt2) );
                nuevoAlto = Number(vm.presupuestoMarco.height + 2*(vm.presupuestoMarco.heightPpt1) + 2*(vm.presupuestoMarco.heightPpt2) );
            }

            var areaDobleCristal = ( (nuevoAncho/100) * (nuevoAlto/100) );

            
if (!vm.isAdministrator) {
            if ( (vm.presupuestoMarco.dobleCristal) && (areaDobleCristal > 1) ) {

                //Mostramos mensaje de aviso de que no se puede seleccionar el "doble cristal" porque area > 1m2
                vm.showAlertDialog("No se puede seleccionar doble cristal porque la superficie del cristal es superior a 1 metro cuadrado.");
                return;

            //Para el caso de "doble cristal" si el area < 1 m2
            } else if ( (vm.presupuestoMarco.dobleCristal) && (areaDobleCristal <= 1) ) {

                vm.numeroCristal = "C-1";
                vm.assignNumeroCristal(vm.numeroCristal);

                vm.numeroTrasera = "C-1";
                vm.traseraSeleccionada = vm.cristalSeleccionado;
            }

} else {

    if (vm.presupuestoMarco.dobleCristal) {
        vm.numeroCristal = "C-1";
        vm.assignNumeroCristal(vm.numeroCristal);

        vm.numeroTrasera = "C-1";
        vm.traseraSeleccionada = vm.cristalSeleccionado;
    }
}

            //Asignamos los valores del presupuesto para el cristal.
            vm.presupuestoMarco.numeroCristal = vm.cristalSeleccionado.numeroArticulo;
            vm.presupuestoMarco.refLeroyMerlinCristal = vm.cristalSeleccionado.refLeroyMerlin;
            vm.presupuestoMarco.descripcionCristal = vm.cristalSeleccionado.descripcion;
            vm.presupuestoMarco.precioLeroyMerlinCristal = vm.cristalSeleccionado.precioLeroyMerlin;
            vm.presupuestoMarco.precioCosteCristal = vm.cristalSeleccionado.precioCoste;

            vm.muestraLineaPresupuestoParaCristal = true;


            //Asignamos los valores del presupuesto para la trasera.
            vm.presupuestoMarco.numeroTrasera = vm.traseraSeleccionada.numeroArticulo;
            vm.presupuestoMarco.refLeroyMerlinTrasera = vm.traseraSeleccionada.refLeroyMerlin;
            vm.presupuestoMarco.descripcionTrasera = vm.traseraSeleccionada.descripcion;
            vm.presupuestoMarco.precioLeroyMerlinTrasera = vm.traseraSeleccionada.precioLeroyMerlin;
            vm.presupuestoMarco.precioCosteTrasera = vm.traseraSeleccionada.precioCoste;


            //RESETEAMOS LOS VALORES DE LOS SUBTOTALES PARA PPT1-2, MOLDURAS1-2-3 Y CRISTAL-TRASERA, ADEMÁS DEL SUBTOTAL Y TOTAL DEL PRESUPUESTO
            vm.resetMultiplicadoresSubtotales();

            vm.muestraLineaPresupuestoParaTrasera = true;

        }


        //***************************************************************
        function reseteaCombosSeleccionCristalYtrasera() {

/*
            if (!vm.presupuestoMarco.dobleCristal) {

                vm.resetValoresPresupuesto("CRISTAL");
                vm.resetValoresPresupuesto("TRASERA");
            }
*/

            vm.resetValoresPresupuesto("CRISTAL");
            vm.resetValoresPresupuesto("TRASERA");

            vm.activarBotonSiguienteParaCristalTrasera = false;

        }


        //***************************************************************
        function resetMultiplicadoresSubtotales() {

            //RESETEAMOS LOS VALORES DE LOS MULTIPLICADORES Y SUBTOTALES PARA PPT1-2, MOLDURAS1-2-3 Y CRISTAL-TRASERA, ADEMÁS DEL SUBTOTAL Y TOTAL DEL PRESUPUESTO
            vm.presupuestoMarco.multiplicadorPpt1 = 0;
            vm.presupuestoMarco.multiplicadorPpt2 = 0;
            vm.presupuestoMarco.multiplicadorMoldura1 = 0;
            vm.presupuestoMarco.multiplicadorMoldura2 = 0;
            vm.presupuestoMarco.multiplicadorMoldura3 = 0;
            vm.presupuestoMarco.multiplicadorCristal = 0;
            vm.presupuestoMarco.multiplicadorTrasera = 0;

            vm.presupuestoMarco.subtotalPpt1 = 0;
            vm.presupuestoMarco.subtotalPpt2 = 0;
            vm.presupuestoMarco.subtotalMoldura1 = 0;
            vm.presupuestoMarco.subtotalMoldura2 = 0;
            vm.presupuestoMarco.subtotalMoldura3 = 0;
            vm.presupuestoMarco.subtotalCristal = 0;
            vm.presupuestoMarco.subtotalTrasera = 0;
            vm.presupuestoMarco.subtotal = 0;
            vm.presupuestoMarco.total =  0;

            vm.budgetCalculated = false;

        }



        //***************************************************************
        function getMedidasMoldura1() {
    
            var nuevoAncho = 0;
            var nuevoAlto = 0;

            if (vm.presupuestoMarco.medidaExteriorValorString == "false") {

                var anchuraMoldura1 = Number(vm.presupuestoMarco.desperdicio1);
                anchuraMoldura1 = 10*anchuraMoldura1;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM
                var desperdicioMoldura1 = 8*anchuraMoldura1;

                if (vm.numeroPpt1 == null) {

                    nuevoAncho = Number( (vm.presupuestoMarco.width + 0.25*desperdicioMoldura1).toFixed(2) );
                    nuevoAlto = Number( (vm.presupuestoMarco.height + 0.25*desperdicioMoldura1).toFixed(2) );

                    //Asignamos el ancho y alto total de la moldura1 (sin contar desperdicio de la moldura) => ESTE VALOR LO UTILIZAMOS PARA SABER EL ANCHO Y ALTO INICIAL PARA CALCULAR LA SIGUIENTE MOLDURA
                    vm.presupuestoMarco.widthMoldura1 = Number( (vm.presupuestoMarco.width + 0.25*anchuraMoldura1).toFixed(2) );
                    vm.presupuestoMarco.heightMoldura1 = Number( (vm.presupuestoMarco.height + 0.25*anchuraMoldura1).toFixed(2) );

                } else {

                    if (vm.numeroPpt2 == null) {    

                        nuevoAncho = Number( (vm.presupuestoMarco.width + 2*(vm.presupuestoMarco.widthPpt1) + 0.25*desperdicioMoldura1).toFixed(2) );
                        nuevoAlto = Number( (vm.presupuestoMarco.height + 2*(vm.presupuestoMarco.heightPpt1) + 0.25*desperdicioMoldura1).toFixed(2) );

                        //Asignamos el ancho y alto total de la moldura1 (sin contar desperdicio de la moldura) => ESTE VALOR LO UTILIZAMOS PARA SABER EL ANCHO Y ALTO INICIAL PARA CALCULAR LA SIGUIENTE MOLDURA
                        vm.presupuestoMarco.widthMoldura1 = Number( (vm.presupuestoMarco.width + 2*(vm.presupuestoMarco.widthPpt1) + 2*anchuraMoldura1).toFixed(2) );
                        vm.presupuestoMarco.heightMoldura1 = Number( (vm.presupuestoMarco.height + 2*(vm.presupuestoMarco.heightPpt1) + 2*anchuraMoldura1).toFixed(2) );

                    } else {

                        nuevoAncho = Number( (vm.presupuestoMarco.width + 2*(vm.presupuestoMarco.widthPpt1) + 2*(vm.presupuestoMarco.widthPpt2) + 0.25*desperdicioMoldura1).toFixed(2) );
                        nuevoAlto = Number( (vm.presupuestoMarco.height + 2*(vm.presupuestoMarco.heightPpt1) + 2*(vm.presupuestoMarco.heightPpt2) + 0.25*desperdicioMoldura1).toFixed(2) );

                        //Asignamos el ancho y alto total de la moldura1 (sin contar desperdicio de la moldura) => ESTE VALOR LO UTILIZAMOS PARA SABER EL ANCHO Y ALTO INICIAL PARA CALCULAR LA SIGUIENTE MOLDURA
                        vm.presupuestoMarco.widthMoldura1 = Number( (vm.presupuestoMarco.width + 2*(vm.presupuestoMarco.widthPpt1) + 2*(vm.presupuestoMarco.widthPpt2) + 2*anchuraMoldura1).toFixed(2) );
                        vm.presupuestoMarco.heightMoldura1 = Number( (vm.presupuestoMarco.height + 2*(vm.presupuestoMarco.heightPpt1) + 2*(vm.presupuestoMarco.heightPpt2) + 2*anchuraMoldura1).toFixed(2) );
                    }

                }


            //CALCULO MULTIPLICADOR MOLDURA 1 PARA MEDIDA EXTERIOR
            } else {


                //PENDIENTE DE CALCULAR




            }

            var medidas = {
                    ancho: nuevoAncho,
                    alto: nuevoAlto
            };

            return medidas;
        }



        //***************************************************************
        function getMedidasMoldura2() {

            var nuevoAncho = 0;
            var nuevoAlto = 0;

            if (vm.presupuestoMarco.medidaExteriorValorString == "false") {

                var anchuraMoldura1 = Number(vm.presupuestoMarco.desperdicio1);
                var anchuraMoldura1 = 10*anchuraMoldura1;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM
                
                var anchuraMoldura2 = Number(vm.presupuestoMarco.desperdicio2);
                anchuraMoldura2 = 10*anchuraMoldura2;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM
                var desperdicioMoldura2 = 8*anchuraMoldura2;

                if (vm.numeroPpt1 == null) {

                    nuevoAncho = Number( (vm.presupuestoMarco.width + 2*anchuraMoldura1 + 0.25*desperdicioMoldura2).toFixed(2) );
                    nuevoAlto = Number( (vm.presupuestoMarco.height + 2*anchuraMoldura1 + 0.25*desperdicioMoldura2).toFixed(2) );

                    //Asignamos el ancho y alto total de la moldura2 (sin contar desperdicio de la moldura) => ESTE VALOR LO UTILIZAMOS PARA SABER EL ANCHO Y ALTO INICIAL PARA CALCULAR LA SIGUIENTE MOLDURA
                    vm.presupuestoMarco.widthMoldura2 = Number( (vm.presupuestoMarco.width + 2*anchuraMoldura1 + 2*anchuraMoldura2).toFixed(2) );
                    vm.presupuestoMarco.heightMoldura2 = Number( (vm.presupuestoMarco.height + 2*anchuraMoldura1 + 2*anchuraMoldura2).toFixed(2) );

                } else {

                    if (vm.numeroPpt2 == null) {    

                        nuevoAncho = Number( (vm.presupuestoMarco.width + 2*(vm.presupuestoMarco.widthPpt1) + 2*anchuraMoldura1 + 0.25*desperdicioMoldura2).toFixed(2) );
                        nuevoAlto = Number( (vm.presupuestoMarco.height + 2*(vm.presupuestoMarco.heightPpt1) + 2*anchuraMoldura1 + 0.25*desperdicioMoldura2).toFixed(2) );

                        //Asignamos el ancho y alto total de la moldura2 (sin contar desperdicio de la moldura) => ESTE VALOR LO UTILIZAMOS PARA SABER EL ANCHO Y ALTO INICIAL PARA CALCULAR LA SIGUIENTE MOLDURA
                        vm.presupuestoMarco.widthMoldura2 = Number( (vm.presupuestoMarco.width + 2*(vm.presupuestoMarco.widthPpt1) + 2*anchuraMoldura1 + 2*anchuraMoldura2).toFixed(2) );
                        vm.presupuestoMarco.heightMoldura2 = Number( (vm.presupuestoMarco.height + 2*(vm.presupuestoMarco.heightPpt1) + 2*anchuraMoldura1 + 2*anchuraMoldura2).toFixed(2) );

                    } else {

                        nuevoAncho = Number( (vm.presupuestoMarco.width + 2*(vm.presupuestoMarco.widthPpt1) + 2*(vm.presupuestoMarco.widthPpt2) + 2*anchuraMoldura1 + 0.25*desperdicioMoldura2).toFixed(2) );
                        nuevoAlto = Number( (vm.presupuestoMarco.height + 2*(vm.presupuestoMarco.heightPpt1) + 2*(vm.presupuestoMarco.heightPpt2) + 2*anchuraMoldura1 + 0.25*desperdicioMoldura2).toFixed(2) );

                        //Asignamos el ancho y alto total de la moldura2 (sin contar desperdicio de la moldura) => ESTE VALOR LO UTILIZAMOS PARA SABER EL ANCHO Y ALTO INICIAL PARA CALCULAR LA SIGUIENTE MOLDURA
                        vm.presupuestoMarco.widthMoldura2 = Number( (vm.presupuestoMarco.width + 2*(vm.presupuestoMarco.widthPpt1) + 2*(vm.presupuestoMarco.widthPpt2) + 2*anchuraMoldura1 + 2*anchuraMoldura2).toFixed(2) );
                        vm.presupuestoMarco.heightMoldura2 = Number( (vm.presupuestoMarco.height + 2*(vm.presupuestoMarco.heightPpt1) + 2*(vm.presupuestoMarco.heightPpt2) + 2*anchuraMoldura1 + 2*anchuraMoldura2).toFixed(2) );
                    }

                }

                //var multiplicadorMoldura2 = ((2*nuevoAncho + 2*nuevoAlto)/100);
                //vm.presupuestoMarco.multiplicadorMoldura2 = Number(multiplicadorMoldura2.toFixed(2));


            //CALCULO MULTIPLICADOR MOLDURA 1 PARA MEDIDA EXTERIOR
            } else {


                //PENDIENTE DE CALCULAR


            }

            var medidas = {
                    ancho: nuevoAncho,
                    alto: nuevoAlto
            };

            return medidas;
        }



        //***************************************************************
        function getMedidasMoldura3() {

            var nuevoAncho = 0;
            var nuevoAlto = 0;

            if (vm.presupuestoMarco.medidaExteriorValorString == "false") {

                var anchuraMoldura1 = Number(vm.presupuestoMarco.desperdicio1);
                var anchuraMoldura1 = 10*anchuraMoldura1;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM
                
                var anchuraMoldura2 = Number(vm.presupuestoMarco.desperdicio2);
                var anchuraMoldura2 = 10*anchuraMoldura2;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM

                var anchuraMoldura3 = Number(vm.presupuestoMarco.desperdicio3);
                anchuraMoldura3 = 10*anchuraMoldura3;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM
                var desperdicioMoldura3 = 8*anchuraMoldura3;


                if (vm.numeroPpt1 == null) {

                    nuevoAncho = Number( (vm.presupuestoMarco.width + 2*anchuraMoldura1 + 2*anchuraMoldura2 + 0.25*desperdicioMoldura3).toFixed(2) );
                    nuevoAlto = Number( (vm.presupuestoMarco.height + 2*anchuraMoldura1 + 2*anchuraMoldura2 + 0.25*desperdicioMoldura3).toFixed(2) );

                    //Asignamos el ancho y alto total de la moldura3 (sin contar desperdicio de la moldura) => ESTE VALOR LO UTILIZAMOS PARA SABER EL ANCHO Y ALTO INICIAL PARA CALCULAR LA SIGUIENTE MOLDURA
                    vm.presupuestoMarco.widthMoldura3 = Number( (vm.presupuestoMarco.width + 2*anchuraMoldura1 + 2*anchuraMoldura2 + 2*anchuraMoldura3).toFixed(2) );
                    vm.presupuestoMarco.heightMoldura3 = Number( (vm.presupuestoMarco.height + 2*anchuraMoldura1 + 2*anchuraMoldura2 + 2*anchuraMoldura3).toFixed(2) );

                } else {

                    if (vm.numeroPpt2 == null) {    

                        nuevoAncho = Number( (vm.presupuestoMarco.width + 2*(vm.presupuestoMarco.widthPpt1) + 2*anchuraMoldura1 + 2*anchuraMoldura2 + 0.25*desperdicioMoldura3).toFixed(2) );
                        nuevoAlto = Number( (vm.presupuestoMarco.height + 2*(vm.presupuestoMarco.heightPpt1) + 2*anchuraMoldura1 + 2*anchuraMoldura2 + 0.25*desperdicioMoldura3).toFixed(2) );

                        //Asignamos el ancho y alto total de la moldura3 (sin contar desperdicio de la moldura) => ESTE VALOR LO UTILIZAMOS PARA SABER EL ANCHO Y ALTO INICIAL PARA CALCULAR LA SIGUIENTE MOLDURA
                        vm.presupuestoMarco.widthMoldura3 = Number( (vm.presupuestoMarco.width + 2*(vm.presupuestoMarco.widthPpt1) + 2*anchuraMoldura1 + 2*anchuraMoldura2 + 2*anchuraMoldura3).toFixed(2) );
                        vm.presupuestoMarco.heightMoldura3 = Number( (vm.presupuestoMarco.height + 2*(vm.presupuestoMarco.heightPpt1) + 2*anchuraMoldura1 + 2*anchuraMoldura2 + 2*anchuraMoldura3).toFixed(2) );

                    } else {

                        nuevoAncho = Number( (vm.presupuestoMarco.width + 2*(vm.presupuestoMarco.widthPpt1) + 2*(vm.presupuestoMarco.widthPpt2) + 2*anchuraMoldura1 + 2*anchuraMoldura2 + 0.25*desperdicioMoldura3).toFixed(2) );
                        nuevoAlto = Number( (vm.presupuestoMarco.height + 2*(vm.presupuestoMarco.heightPpt1) + 2*(vm.presupuestoMarco.heightPpt2) + 2*anchuraMoldura1 + 2*anchuraMoldura2 + 0.25*desperdicioMoldura3).toFixed(2) );

                        //Asignamos el ancho y alto total de la moldura3 (sin contar desperdicio de la moldura) => ESTE VALOR LO UTILIZAMOS PARA SABER EL ANCHO Y ALTO INICIAL PARA CALCULAR LA SIGUIENTE MOLDURA
                        vm.presupuestoMarco.widthMoldura3 = Number( (vm.presupuestoMarco.width + 2*(vm.presupuestoMarco.widthPpt1) + 2*(vm.presupuestoMarco.widthPpt2) + 2*anchuraMoldura1 + 2*anchuraMoldura2 + 2*anchuraMoldura3).toFixed(2) );
                        vm.presupuestoMarco.heightMoldura3 = Number( (vm.presupuestoMarco.height + 2*(vm.presupuestoMarco.heightPpt1) + 2*(vm.presupuestoMarco.heightPpt2) + 2*anchuraMoldura1 + 2*anchuraMoldura2 + 2*anchuraMoldura3).toFixed(2) );
                    }

                }

                //var multiplicadorMoldura3 = ((2*nuevoAncho + 2*nuevoAlto)/100);
                //vm.presupuestoMarco.multiplicadorMoldura3 = Number(multiplicadorMoldura3.toFixed(2));


            //CALCULO MULTIPLICADOR MOLDURA 1 PARA MEDIDA EXTERIOR
            } else {


                //PENDIENTE DE CALCULAR


            }

            var medidas = {
                    ancho: nuevoAncho,
                    alto: nuevoAlto
            };

            return medidas;

        }


        //**************************************************************************************************
        function getLineaImporteMultiventana(pNumeroVentanas) {

            switch(pNumeroVentanas) {
/*
                case 1:
                        vm.presupuestoMarco.refLeroyMerlinMultiventana = preciosService.getPpt1ventana().refLeroyMerlin;
                        vm.presupuestoMarco.descripcionMultiventana = preciosService.getPpt1ventana().descripcion;
                        vm.presupuestoMarco.multiplicadorMultiventana = 1.00;
                        vm.presupuestoMarco.subtotalMultiventana = preciosService.getPpt1ventana().precioLeroyMerlin;

                        vm.muestraLineaPresupuestoParaMultiventana = true;
                        break;
*/                        
                case 2:
                        vm.presupuestoMarco.refLeroyMerlinMultiventana = preciosService.getPpt2ventanas().refLeroyMerlin;
                        vm.presupuestoMarco.descripcionMultiventana = preciosService.getPpt2ventanas().descripcion;
                        vm.presupuestoMarco.multiplicadorMultiventana = 1.00;
                        vm.presupuestoMarco.subtotalMultiventana = preciosService.getPpt2ventanas().precioLeroyMerlin;

                        vm.muestraLineaPresupuestoParaMultiventana = true;
                        break;
                case 3:
                        vm.presupuestoMarco.refLeroyMerlinMultiventana = preciosService.getPpt3ventanas().refLeroyMerlin;
                        vm.presupuestoMarco.descripcionMultiventana = preciosService.getPpt3ventanas().descripcion;
                        vm.presupuestoMarco.multiplicadorMultiventana = 1.00;
                        vm.presupuestoMarco.subtotalMultiventana = preciosService.getPpt3ventanas().precioLeroyMerlin;

                        vm.muestraLineaPresupuestoParaMultiventana = true;
                        break;
                case 4:
                        vm.presupuestoMarco.refLeroyMerlinMultiventana = preciosService.getPpt4ventanas().refLeroyMerlin;
                        vm.presupuestoMarco.descripcionMultiventana = preciosService.getPpt4ventanas().descripcion;
                        vm.presupuestoMarco.multiplicadorMultiventana = 1.00;
                        vm.presupuestoMarco.subtotalMultiventana = preciosService.getPpt4ventanas().precioLeroyMerlin;

                        vm.muestraLineaPresupuestoParaMultiventana = true;
                        break;
                case 5:
                        vm.presupuestoMarco.refLeroyMerlinMultiventana = preciosService.getPpt5ventanas().refLeroyMerlin;
                        vm.presupuestoMarco.descripcionMultiventana = preciosService.getPpt5ventanas().descripcion;
                        vm.presupuestoMarco.multiplicadorMultiventana = 1.00;
                        vm.presupuestoMarco.subtotalMultiventana = preciosService.getPpt5ventanas().precioLeroyMerlin;

                        vm.muestraLineaPresupuestoParaMultiventana = true;
                        break;
                case 6:
                        vm.presupuestoMarco.refLeroyMerlinMultiventana = preciosService.getPpt6ventanas().refLeroyMerlin;
                        vm.presupuestoMarco.descripcionMultiventana = preciosService.getPpt6ventanas().descripcion;
                        vm.presupuestoMarco.multiplicadorMultiventana = 1.00;
                        vm.presupuestoMarco.subtotalMultiventana = preciosService.getPpt6ventanas().precioLeroyMerlin;

                        vm.muestraLineaPresupuestoParaMultiventana = true;
                        break;
                case 7:
                        vm.presupuestoMarco.refLeroyMerlinMultiventana = preciosService.getPptMas7ventanas().refLeroyMerlin;
                        vm.presupuestoMarco.descripcionMultiventana = preciosService.getPptMas7ventanas().descripcion;
                        vm.presupuestoMarco.multiplicadorMultiventana = 1.00;
                        vm.presupuestoMarco.subtotalMultiventana = preciosService.getPptMas7ventanas().precioLeroyMerlin;

                        vm.muestraLineaPresupuestoParaMultiventana = true;
                        break;
                case 8:
                        vm.presupuestoMarco.refLeroyMerlinMultiventana = preciosService.getPptMas7ventanas().refLeroyMerlin;
                        vm.presupuestoMarco.descripcionMultiventana = preciosService.getPptMas7ventanas().descripcion;
                        vm.presupuestoMarco.multiplicadorMultiventana = 1.00;
                        vm.presupuestoMarco.subtotalMultiventana = preciosService.getPptMas7ventanas().precioLeroyMerlin;

                        vm.muestraLineaPresupuestoParaMultiventana = true;
                        break;
                case 9:
                        vm.presupuestoMarco.refLeroyMerlinMultiventana = preciosService.getPptMas7ventanas().refLeroyMerlin;
                        vm.presupuestoMarco.descripcionMultiventana = preciosService.getPptMas7ventanas().descripcion;
                        vm.presupuestoMarco.multiplicadorMultiventana = 1.00;
                        vm.presupuestoMarco.subtotalMultiventana = preciosService.getPptMas7ventanas().precioLeroyMerlin;

                        vm.muestraLineaPresupuestoParaMultiventana = true;
                        break;
                case 10:
                        vm.presupuestoMarco.refLeroyMerlinMultiventana = preciosService.getPptMas7ventanas().refLeroyMerlin;
                        vm.presupuestoMarco.descripcionMultiventana = preciosService.getPptMas7ventanas().descripcion;
                        vm.presupuestoMarco.multiplicadorMultiventana = 1.00;
                        vm.presupuestoMarco.subtotalMultiventana = preciosService.getPptMas7ventanas().precioLeroyMerlin;

                        vm.muestraLineaPresupuestoParaMultiventana = true;
                        break;
            }

            return vm.presupuestoMarco.subtotalMultiventana;
        }



        //**************************************************************************************************
        function getMultiplicadorMolduraExteriorConImporteServicios(pClienteDejaObra,pAnchoMolduraExterior,pAltoMolduraExterior,pCalculoPvpMolduraExterior,pPrecioLinealMolduraExterior) {

            var zona = "S3";
            var importeMontaje = 0;
            var importeEmbalaje = 0;
            var importeTransporte = 0;

            //Cálculo de los metros cuadrados de la moldura más exterior
            var areaMetrosCuadrados = ( (pAnchoMolduraExterior/100) * (pAltoMolduraExterior/100) );

            //Determinación de la zona S1,S2 o S3
            if (areaMetrosCuadrados < 0.36) {
                zona = "S1";
            } else if ( (areaMetrosCuadrados >= 0.36) && (areaMetrosCuadrados< 0.98) ) {
                zona = "S2";
            } else if (areaMetrosCuadrados >= 0.98) {
                zona = "S3";
            }

            //Asignación de precios SI EL CLIENTE DEJA OBRA
            if (pClienteDejaObra) {

                if (zona == "S1") {
                    importeMontaje = preciosService.getMontajeConMotivoS1().precioLeroyMerlin;
                    importeEmbalaje = preciosService.getEmbalajeConMotivoS1().precioLeroyMerlin;
                    importeTransporte = preciosService.getTransporteConMotivoS1().precioLeroyMerlin;     

                } else if (zona == "S2") {
                    importeMontaje = preciosService.getMontajeConMotivoS2().precioLeroyMerlin;
                    importeEmbalaje = preciosService.getEmbalajeConMotivoS2().precioLeroyMerlin;
                    importeTransporte = preciosService.getTransporteConMotivoS2().precioLeroyMerlin;     

                } else {
                    importeMontaje = preciosService.getMontajeConMotivoS3().precioLeroyMerlin;
                    importeEmbalaje = preciosService.getEmbalajeConMotivoS3().precioLeroyMerlin;
                    importeTransporte = preciosService.getTransporteConMotivoS3().precioLeroyMerlin; 
                }

            //Asignación de precios SI EL CLIENTE NO DEJA OBRA
            } else {

                if (zona == "S1") {
                    importeMontaje = preciosService.getMontajeSinMotivoS1().precioLeroyMerlin;
                    importeEmbalaje = preciosService.getEmbalajeSinMotivoS1().precioLeroyMerlin;
                    importeTransporte = preciosService.getTransporteSinMotivoS1().precioLeroyMerlin;

                } else if (zona == "S2") {
                    importeMontaje = preciosService.getMontajeSinMotivoS2().precioLeroyMerlin;
                    importeEmbalaje = preciosService.getEmbalajeSinMotivoS2().precioLeroyMerlin;
                    importeTransporte = preciosService.getTransporteSinMotivoS2().precioLeroyMerlin;

                } else {
                    importeMontaje = preciosService.getMontajeSinMotivoS3().precioLeroyMerlin;
                    importeEmbalaje = preciosService.getEmbalajeSinMotivoS3().precioLeroyMerlin;
                    importeTransporte = preciosService.getTransporteSinMotivoS3().precioLeroyMerlin;
                }

            }


            //Cálculo del nuevo multiplicador de la moldura más externa
            var nuevoMultiplicadorMolduraExterior = ( (importeMontaje + importeEmbalaje + importeTransporte + pCalculoPvpMolduraExterior) / pPrecioLinealMolduraExterior );
            nuevoMultiplicadorMolduraExterior = Number(nuevoMultiplicadorMolduraExterior.toFixed(2));

            return nuevoMultiplicadorMolduraExterior;
        }



//**********************************************************************
//********** FUNCIÓN CÁLCULO DE PRESUPUESTO ****************************
//**********************************************************************
        function calculateBudget() {

            var nuevoAncho = 0;
            var nuevoAlto = 0;
            var medidas = {};

            var anchuraPpt1 = 0;
            var alturaPpt1 = 0;
            var anchuraPpt2 = 0;
            var alturaPpt2 = 0;
            var anchuraMoldura1 = 0;
            var anchuraMoldura2 = 0;
            var anchuraMoldura3 = 0;

            var subtotalPartePpt1 = 0;
            var subtotalPartePpt2 = 0;
            var subtotalParte1 = 0;
            var subtotalParte2 = 0;
            var subtotalParte3 = 0;
            var subtotalParte4 = 0;
            var subtotalParte5 = 0;


            //INICIALIZAMOS LOS VALORES PARA LAS MEDIDAS DE MOLDURAS, PPTs, Y LOS MULTIPLICADORES DE TODOS LOS ELEMENTOS A CALCULAR
            vm.presupuestoMarco.widthMoldura1 = 0;
            vm.presupuestoMarco.heightMoldura1 = 0;

            vm.presupuestoMarco.widthMoldura2 = 0;
            vm.presupuestoMarco.heightMoldura2 = 0;

            vm.presupuestoMarco.widthMoldura3 = 0;
            vm.presupuestoMarco.heightMoldura3 = 0;

            vm.presupuestoMarco.multiplicadorPpt1 = 0;
            vm.presupuestoMarco.multiplicadorPpt2 = 0;
            vm.presupuestoMarco.multiplicadorMoldura1 = 0;
            vm.presupuestoMarco.multiplicadorMoldura2 = 0;
            vm.presupuestoMarco.multiplicadorMoldura3 = 0;

            vm.presupuestoMarco.subtotalPpt1 = 0;
            vm.presupuestoMarco.subtotalPpt2 = 0;
            vm.presupuestoMarco.subtotalMoldura1 = 0;
            vm.presupuestoMarco.subtotalMoldura2 = 0;
            vm.presupuestoMarco.subtotalMoldura3 = 0;
            vm.presupuestoMarco.subtotalCristal = 0;
            vm.presupuestoMarco.subtotalTrasera = 0;

//CALCULO MULTIPLICADOR PASSE-PARTOUT 1
            //CALCULO MULTIPLICADOR PASSE-PARTOUT 1 PARA MEDIDA INTERIOR 
            if (vm.presupuestoMarco.medidaExteriorValorString == "false") {

                if (vm.presupuestoMarco.numeroPpt1 != null) {

                    nuevoAncho = Number( (vm.presupuestoMarco.width + 2*(vm.presupuestoMarco.widthPpt1)).toFixed(2) );
                    nuevoAlto = Number( (vm.presupuestoMarco.height + 2*(vm.presupuestoMarco.heightPpt1)).toFixed(2) );
                    vm.presupuestoMarco.multiplicadorPpt1 = Number( ((nuevoAncho/100)*(nuevoAlto/100) ).toFixed(2) );

                    try {
                        vm.presupuestoMarco.subtotalPpt1 = Number( (vm.presupuestoMarco.multiplicadorPpt1 * vm.ppt1Seleccionada.precioLeroyMerlin).toFixed(2) );
                    } catch (error) {
                        vm.presupuestoMarco.subtotalPpt1 = 0;
                    }

                } else {

                    vm.presupuestoMarco.multiplicadorPpt1 = 0;
                    vm.presupuestoMarco.subtotalPpt1 = 0;                    
                }

            //CALCULO MULTIPLICADOR PASSE-PARTOUT 1 PARA MEDIDA EXTERIOR
            } else {

                if (vm.presupuestoMarco.numeroPpt1 != null) {

                    if (vm.presupuestoMarco.numeroMoldura3 != null) {
                        anchuraMoldura3 = Number(vm.presupuestoMarco.desperdicio3);
                        anchuraMoldura3 = 10*anchuraMoldura3;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM
                    } else {
                        anchuraMoldura3 = 0;
                    }

                    if (vm.presupuestoMarco.numeroMoldura2 != null) {
                        anchuraMoldura2 = Number(vm.presupuestoMarco.desperdicio2);
                        anchuraMoldura2 = 10*anchuraMoldura2;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM
                    } else {
                        anchuraMoldura2 = 0;
                    }

                    if (vm.presupuestoMarco.numeroMoldura1 != null) {
                        anchuraMoldura1 = Number(vm.presupuestoMarco.desperdicio1);
                        anchuraMoldura1 = 10*anchuraMoldura1;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM
                    } else {
                        anchuraMoldura1 = 0;
                    }

                    if (vm.presupuestoMarco.numeroPpt2 != null) {
                        anchuraPpt2 = Number(vm.presupuestoMarco.widthPpt2);
                        alturaPpt2 = Number(vm.presupuestoMarco.heightPpt2);
                    } else {
                        anchuraPpt2 = 0;
                        alturaPpt2 = 0;
                    }

                    nuevoAncho = Number(vm.presupuestoMarco.width - (2*anchuraMoldura3) - (2*anchuraMoldura2) - (2*anchuraMoldura1) - (2*anchuraPpt2) );
                    nuevoAlto = Number(vm.presupuestoMarco.height - (2*anchuraMoldura3) - (2*anchuraMoldura2) - (2*anchuraMoldura1) - (2*alturaPpt2) );


                    vm.presupuestoMarco.multiplicadorPpt1 = Number( ((nuevoAncho/100)*(nuevoAlto/100) ).toFixed(2) );

                    try {
                        vm.presupuestoMarco.subtotalPpt1 = Number( (vm.presupuestoMarco.multiplicadorPpt1 * vm.ppt1Seleccionada.precioLeroyMerlin).toFixed(2) );
                    } catch (error) {
                        vm.presupuestoMarco.subtotalPpt1 = 0;
                    }

                } else {

                    vm.presupuestoMarco.multiplicadorPpt1 = 0;
                    vm.presupuestoMarco.subtotalPpt1 = 0;                    
                }

            }


//CALCULO MULTIPLICADOR PASSE-PARTOUT 2
            //CALCULO MULTIPLICADOR PASSE-PARTOUT 2 PARA MEDIDA INTERIOR
            if (vm.presupuestoMarco.medidaExteriorValorString == "false") {

                if (vm.presupuestoMarco.numeroPpt2 != null) {

                    nuevoAncho = Number( (vm.presupuestoMarco.width + 2*(vm.presupuestoMarco.widthPpt1) + 2*(vm.presupuestoMarco.widthPpt2)).toFixed(2) );
                    nuevoAlto = Number( (vm.presupuestoMarco.height + 2*(vm.presupuestoMarco.heightPpt1) + 2*(vm.presupuestoMarco.heightPpt2)).toFixed(2) );

                    vm.presupuestoMarco.multiplicadorPpt2 = Number( ((nuevoAncho/100)*(nuevoAlto/100) ).toFixed(2) );

                    try {
                        vm.presupuestoMarco.subtotalPpt2 = Number((vm.presupuestoMarco.multiplicadorPpt2 * vm.ppt2Seleccionada.precioLeroyMerlin).toFixed(2));
                    } catch (error) {
                        vm.presupuestoMarco.subtotalPpt2 = 0;
                    }

                } else {

                    vm.presupuestoMarco.multiplicadorPpt2 = 0;
                    vm.presupuestoMarco.subtotalPpt2 = 0;                    
                }

            //CALCULO MULTIPLICADOR PASSE-PARTOUT 2 PARA MEDIDA EXTERIOR
            } else {

                if (vm.presupuestoMarco.numeroPpt2 != null) {

                    if (vm.presupuestoMarco.numeroMoldura3 != null) {
                        anchuraMoldura3 = Number(vm.presupuestoMarco.desperdicio3);
                        anchuraMoldura3 = 10*anchuraMoldura3;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM
                    } else {
                        anchuraMoldura3 = 0;
                    }

                    if (vm.presupuestoMarco.numeroMoldura2 != null) {
                        anchuraMoldura2 = Number(vm.presupuestoMarco.desperdicio2);
                        anchuraMoldura2 = 10*anchuraMoldura2;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM
                    } else {
                        anchuraMoldura2 = 0;
                    }

                    if (vm.presupuestoMarco.numeroMoldura1 != null) {
                        anchuraMoldura1 = Number(vm.presupuestoMarco.desperdicio1);
                        anchuraMoldura1 = 10*anchuraMoldura1;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM
                    } else {
                        anchuraMoldura1 = 0;
                    }

                    nuevoAncho = Number(vm.presupuestoMarco.width - (2*anchuraMoldura3) - (2*anchuraMoldura2) - (2*anchuraMoldura1) );
                    nuevoAlto = Number(vm.presupuestoMarco.height - (2*anchuraMoldura3) - (2*anchuraMoldura2) - (2*anchuraMoldura1) );

                    vm.presupuestoMarco.multiplicadorPpt2 = Number( ((nuevoAncho/100)*(nuevoAlto/100) ).toFixed(2) );

                    try {
                        vm.presupuestoMarco.subtotalPpt2 = Number((vm.presupuestoMarco.multiplicadorPpt2 * vm.ppt2Seleccionada.precioLeroyMerlin).toFixed(2));
                    } catch (error) {
                        vm.presupuestoMarco.subtotalPpt2 = 0;
                    }

                } else {

                    vm.presupuestoMarco.multiplicadorPpt2 = 0;
                    vm.presupuestoMarco.subtotalPpt2 = 0;                                        
                }

            }


//CALCULO MULTIPLICADOR MOLDURA 1
            nuevoAncho = 0;
            nuevoAlto = 0;

            //CALCULO MULTIPLICADOR MOLDURA 1 PARA MEDIDA INTERIOR
            if (vm.presupuestoMarco.medidaExteriorValorString == "false") {

                if (vm.presupuestoMarco.numeroMoldura1 != null) {

                    //Obtenemos las medidas para la moldura1
                    medidas = vm.getMedidasMoldura1();
                    nuevoAncho = medidas.ancho;
                    nuevoAlto = medidas.alto;

                    var multiplicadorMoldura1 = ((2*nuevoAncho + 2*nuevoAlto)/100);
                    vm.presupuestoMarco.multiplicadorMoldura1 = Number(multiplicadorMoldura1.toFixed(2));

                    try {
                        vm.presupuestoMarco.subtotalMoldura1 = Number((vm.presupuestoMarco.multiplicadorMoldura1 * vm.moldura1Seleccionada.precioLeroyMerlin).toFixed(2));
                    } catch (error) {
                        vm.presupuestoMarco.subtotalMoldura1 = 0;
                    }

                } else {

                    vm.presupuestoMarco.multiplicadorMoldura1 = 0;
                    vm.presupuestoMarco.widthMoldura1 = 0;
                    vm.presupuestoMarco.heightMoldura1 = 0;
                    vm.presupuestoMarco.subtotalMoldura1 = 0;                                        
                }

            //CALCULO MULTIPLICADOR MOLDURA 1 PARA MEDIDA EXTERIOR
            } else {

                if (vm.presupuestoMarco.numeroMoldura1 != null) {

                    if (vm.presupuestoMarco.numeroMoldura3 != null) {
                        anchuraMoldura3 = Number(vm.presupuestoMarco.desperdicio3);
                        anchuraMoldura3 = 10*anchuraMoldura3;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM
                    } else {
                        anchuraMoldura3 = 0;
                    }

                    if (vm.presupuestoMarco.numeroMoldura2 != null) {
                        anchuraMoldura2 = Number(vm.presupuestoMarco.desperdicio2);
                        anchuraMoldura2 = 10*anchuraMoldura2;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM
                    } else {
                        anchuraMoldura2 = 0;
                    }

                    nuevoAncho = Number(vm.presupuestoMarco.width - (2*anchuraMoldura3) - (2*anchuraMoldura2) );
                    nuevoAlto = Number(vm.presupuestoMarco.height - (2*anchuraMoldura3) - (2*anchuraMoldura2) );

                    vm.presupuestoMarco.widthMoldura1 = nuevoAncho;
                    vm.presupuestoMarco.heightMoldura1 = nuevoAlto;
                    
                    vm.presupuestoMarco.multiplicadorMoldura1 = Number( ((2*nuevoAncho + 2*nuevoAlto)/100).toFixed(2) );

                    try {
                        vm.presupuestoMarco.subtotalMoldura1 = Number((vm.presupuestoMarco.multiplicadorMoldura1 * vm.moldura1Seleccionada.precioLeroyMerlin).toFixed(2));
                    } catch (error) {
                        vm.presupuestoMarco.subtotalMoldura1 = 0;
                    }

                } else {

                    vm.presupuestoMarco.multiplicadorMoldura1 = 0;
                    vm.presupuestoMarco.widthMoldura1 = 0;
                    vm.presupuestoMarco.heightMoldura1 = 0;
                    vm.presupuestoMarco.subtotalMoldura1 = 0;                    
                }
            }


//CALCULO MULTIPLICADOR MOLDURA 2
            nuevoAncho = 0;
            nuevoAlto = 0;

            //CALCULO MULTIPLICADOR MOLDURA 2 PARA MEDIDA INTERIOR
            if (vm.presupuestoMarco.medidaExteriorValorString == "false") {

                if (vm.presupuestoMarco.numeroMoldura2 != null) {

                    //Obtenemos las medidas para la moldura2               
                    medidas = vm.getMedidasMoldura2();
                    nuevoAncho = medidas.ancho;
                    nuevoAlto = medidas.alto;

                    vm.presupuestoMarco.widthMoldura2 = nuevoAncho;
                    vm.presupuestoMarco.heightMoldura2 = nuevoAlto;

                    var multiplicadorMoldura2 = ((2*nuevoAncho + 2*nuevoAlto)/100);
                    vm.presupuestoMarco.multiplicadorMoldura2 = Number(multiplicadorMoldura2.toFixed(2));

                    try {
                        vm.presupuestoMarco.subtotalMoldura2 = Number((vm.presupuestoMarco.multiplicadorMoldura2 * vm.moldura2Seleccionada.precioLeroyMerlin).toFixed(2));
                    } catch (error) {
                        vm.presupuestoMarco.subtotalMoldura2 = 0;
                    }

                } else {

                    vm.presupuestoMarco.multiplicadorMoldura2 = 0;
                    vm.presupuestoMarco.subtotalMoldura2 = 0;                    
                    vm.presupuestoMarco.widthMoldura2 = 0;
                    vm.presupuestoMarco.heightMoldura2 = 0;
                }


            //CALCULO MULTIPLICADOR MOLDURA 2 PARA MEDIDA EXTERIOR
            } else {

                if (vm.presupuestoMarco.numeroMoldura2 != null) {

                    if (vm.presupuestoMarco.numeroMoldura3 != null) {
                        var numeroMoldura3 = Number(vm.presupuestoMarco.numeroMoldura3);
                        anchuraMoldura3 = Number(vm.presupuestoMarco.desperdicio3);
                        anchuraMoldura3 = 10*anchuraMoldura3;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM
                    } else {
                        anchuraMoldura3 = 0;
                    }

                    nuevoAncho = Number(vm.presupuestoMarco.width - (2*anchuraMoldura3) );
                    nuevoAlto = Number(vm.presupuestoMarco.height - (2*anchuraMoldura3) );

                    vm.presupuestoMarco.widthMoldura2 = nuevoAncho;
                    vm.presupuestoMarco.heightMoldura2 = nuevoAlto;

                    vm.presupuestoMarco.multiplicadorMoldura2 = Number( ((2*nuevoAncho + 2*nuevoAlto)/100).toFixed(2) );

                    try {
                        vm.presupuestoMarco.subtotalMoldura2 = Number((vm.presupuestoMarco.multiplicadorMoldura2 * vm.moldura2Seleccionada.precioLeroyMerlin).toFixed(2));
                    } catch (error) {
                        vm.presupuestoMarco.subtotalMoldura2 = 0;
                    }


                } else {

                    vm.presupuestoMarco.multiplicadorMoldura2 = 0;
                    vm.presupuestoMarco.subtotalMoldura2 = 0;                    
                    vm.presupuestoMarco.widthMoldura2 = 0;
                    vm.presupuestoMarco.heightMoldura2 = 0;
                }
            }


//CALCULO MULTIPLICADOR MOLDURA 3
            nuevoAncho = 0;
            nuevoAlto = 0;

            //CALCULO MULTIPLICADOR MOLDURA 3 PARA MEDIDA INTERIOR
            if (vm.presupuestoMarco.medidaExteriorValorString == "false") {

                if (vm.presupuestoMarco.numeroMoldura3 != null) {

                    //Obtenemos las medidas para la moldura3
                    medidas = vm.getMedidasMoldura3();
                    nuevoAncho = medidas.ancho;
                    nuevoAlto = medidas.alto;

                    vm.presupuestoMarco.widthMoldura3 = nuevoAncho;
                    vm.presupuestoMarco.heightMoldura3 = nuevoAlto;

                    var multiplicadorMoldura3 = ((2*nuevoAncho + 2*nuevoAlto)/100);
                    vm.presupuestoMarco.multiplicadorMoldura3 = Number(multiplicadorMoldura3.toFixed(2));

                    try {
                        vm.presupuestoMarco.subtotalMoldura3 = Number((vm.presupuestoMarco.multiplicadorMoldura3 * vm.moldura3Seleccionada.precioLeroyMerlin).toFixed(2));
                    } catch (error) {
                        vm.presupuestoMarco.subtotalMoldura3 = 0;
                    }

                } else {

                    vm.presupuestoMarco.multiplicadorMoldura3 = 0;
                    vm.presupuestoMarco.subtotalMoldura3 = 0;
                    vm.presupuestoMarco.widthMoldura3 = 0;
                    vm.presupuestoMarco.heightMoldura3 = 0;
                }


            //CALCULO MULTIPLICADOR MOLDURA 3 PARA MEDIDA EXTERIOR
            } else {

                if (vm.presupuestoMarco.numeroMoldura3 != null) {

                    nuevoAncho = Number(vm.presupuestoMarco.width);
                    nuevoAlto = Number(vm.presupuestoMarco.height);

                    vm.presupuestoMarco.widthMoldura3 = nuevoAncho;
                    vm.presupuestoMarco.heightMoldura3 = nuevoAlto;

                    vm.presupuestoMarco.multiplicadorMoldura3 = Number( ((2*nuevoAncho + 2*nuevoAlto)/100).toFixed(2) );

                    try {
                        vm.presupuestoMarco.subtotalMoldura3 = Number((vm.presupuestoMarco.multiplicadorMoldura3 * vm.moldura3Seleccionada.precioLeroyMerlin).toFixed(2));
                    } catch (error) {
                        vm.presupuestoMarco.subtotalMoldura3 = 0;
                    }

                } else {

                    vm.presupuestoMarco.multiplicadorMoldura3 = 0;
                    vm.presupuestoMarco.subtotalMoldura3 = 0;                    
                    vm.presupuestoMarco.widthMoldura3 = 0;
                    vm.presupuestoMarco.heightMoldura3 = 0;
                }
            }



//CÁLCULO DEL MULTIPLICADOR PARA EL CRISTAL Y LA TRASERA
            nuevoAncho = 0;
            nuevoAlto = 0;

            //CALCULO MULTIPLICADOR CRISTAL Y LA TRASERA PARA MEDIDA INTERIOR
            if (vm.presupuestoMarco.medidaExteriorValorString == "false") {

                if (vm.numeroPpt1 == null) {

                    nuevoAncho = Number(vm.presupuestoMarco.width);
                    nuevoAlto = Number(vm.presupuestoMarco.height);

                } else if (vm.numeroPpt2 == null) {

                    nuevoAncho = Number(vm.presupuestoMarco.width + 2*(vm.presupuestoMarco.widthPpt1) );
                    nuevoAlto = Number(vm.presupuestoMarco.height + 2*(vm.presupuestoMarco.heightPpt1) );

                } else {

                    nuevoAncho = Number(vm.presupuestoMarco.width + 2*(vm.presupuestoMarco.widthPpt1) + 2*(vm.presupuestoMarco.widthPpt2) );
                    nuevoAlto = Number(vm.presupuestoMarco.height + 2*(vm.presupuestoMarco.heightPpt1) + 2*(vm.presupuestoMarco.heightPpt2) );
                }

                vm.presupuestoMarco.multiplicadorCristal = Number( ( (nuevoAncho/100) * (nuevoAlto/100) ).toFixed(2) );
                vm.presupuestoMarco.multiplicadorTrasera = Number( ( (nuevoAncho/100) * (nuevoAlto/100) ).toFixed(2) );

            //CALCULO MULTIPLICADOR CRISTAL Y LA TRASERA PARA MEDIDA EXTERIOR
            } else {

                if (vm.presupuestoMarco.numeroMoldura3 != null) {
                    anchuraMoldura3 = Number(vm.presupuestoMarco.desperdicio3);
                    anchuraMoldura3 = 10*anchuraMoldura3;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM
                } else {
                    anchuraMoldura3 = 0;
                }

                if (vm.presupuestoMarco.numeroMoldura2 != null) {
                    anchuraMoldura2 = Number(vm.presupuestoMarco.desperdicio2);
                    anchuraMoldura2 = 10*anchuraMoldura2;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM
                } else {
                    anchuraMoldura2 = 0;
                }

                if (vm.presupuestoMarco.numeroMoldura1 != null) {
                    anchuraMoldura1 = Number(vm.presupuestoMarco.desperdicio1);
                    anchuraMoldura1 = 10*anchuraMoldura1;   //IMPORTANTE: DEBEMOS MULTIPLICAR POR 10 PORQUE EN LA TABLA DE PRODUCTOS EL DESPERDICIO ESTÁ EN DECÍMETROS Y NO EN CM => CONVERTIMOS A CM
                } else {
                    anchuraMoldura1 = 0;
                }

/*
                if (vm.presupuestoMarco.numeroPpt2 != null) {
                    anchuraPpt2 = Number(vm.presupuestoMarco.widthPpt2);
                    alturaPpt2 = Number(vm.presupuestoMarco.heightPpt2);
                } else {
                    anchuraPpt2 = 0;
                    alturaPpt2 = 0;
                }

                if (vm.presupuestoMarco.numeroPpt1 != null) {
                    anchuraPpt1 = Number(vm.presupuestoMarco.widthPpt1);
                    alturaPpt1 = Number(vm.presupuestoMarco.heightPpt1);
                } else {
                    anchuraPpt1 = 0;
                    alturaPpt1 = 0;
                }

                nuevoAncho = Number(vm.presupuestoMarco.width - (2*anchuraMoldura3) - (2*anchuraMoldura2) - (2*anchuraMoldura1) - (2*anchuraPpt2) - (2*anchuraPpt1) );
                nuevoAlto = Number(vm.presupuestoMarco.height - (2*anchuraMoldura3) - (2*anchuraMoldura2) - (2*anchuraMoldura1) - (2*alturaPpt2) - (2*alturaPpt1) );
*/

                nuevoAncho = Number(vm.presupuestoMarco.width - (2*anchuraMoldura3) - (2*anchuraMoldura2) - (2*anchuraMoldura1) );
                nuevoAlto = Number(vm.presupuestoMarco.height - (2*anchuraMoldura3) - (2*anchuraMoldura2) - (2*anchuraMoldura1) );

                vm.presupuestoMarco.multiplicadorCristal = Number( ( (nuevoAncho/100)*(nuevoAlto/100) ).toFixed(2) );
                vm.presupuestoMarco.multiplicadorTrasera = Number( ( (nuevoAncho/100)*(nuevoAlto/100) ).toFixed(2) );
            }

            try {
                vm.presupuestoMarco.subtotalCristal = Number((vm.presupuestoMarco.multiplicadorCristal * vm.cristalSeleccionado.precioLeroyMerlin).toFixed(2));
            } catch (error) {
                vm.presupuestoMarco.subtotalCristal = 0;
            }

            try {
                vm.presupuestoMarco.subtotalTrasera = Number((vm.presupuestoMarco.multiplicadorTrasera * vm.traseraSeleccionada.precioLeroyMerlin).toFixed(2));
            } catch (error) {
                vm.presupuestoMarco.subtotalTrasera = 0;
            }


            //Asignamos el ancho y alto total 
            //vm.presupuestoMarco.widthCristal = nuevoAncho;
            //vm.presupuestoMarco.heightCristal = nuevoAlto;
            //vm.presupuestoMarco.widthTrasera = nuevoAncho;
            //vm.presupuestoMarco.heightTrasera = nuevoAlto;


//CÁLCULO DEL IMPORTE MONTAJE "MULTI-VENTANAS" PARA EL PASSE-PARTOUT 1 Y VISUALIZACION DE LA LINEA EN EL DETALLE DE PRESUPUESTO
            var numeroVentanas = 0;
            var subtotalMultiventana = 0;

            if (vm.presupuestoMarco.multiventana) {

                try {
                    numeroVentanas = Number(vm.presupuestoMarco.numeroVentanas);
                    subtotalMultiventana = vm.getLineaImporteMultiventana(numeroVentanas);

                }
                catch(error) {
                    vm.presupuestoMarco.subtotalMultiventana = 0;  
                    vm.presupuestoMarco.multiplicadorMultiventana = 0;
                    subtotalMultiventana = 0;
                }

            } else {
                    vm.presupuestoMarco.subtotalMultiventana = 0;  
                    vm.presupuestoMarco.multiplicadorMultiventana = 0;
                    subtotalMultiventana = 0;

                    vm.muestraLineaPresupuestoParaMultiventana = false;
            }


            //CALCULAMOS LOS SUBTOTALES DE CADA SECCIÓN (PASSE-PARTOUT1-2, MOLDURAS1-2-3 Y CRISTAL-TRASERA)
            subtotalPartePpt1 = 0;
            try {
                subtotalPartePpt1 = Number((vm.presupuestoMarco.subtotalPpt1).toFixed(2));
            } catch(error) {
                subtotalPartePpt1 = 0;
            }

            subtotalPartePpt2 = 0;
            try {
                subtotalPartePpt2 = Number((vm.presupuestoMarco.subtotalPpt2).toFixed(2));
            } catch(error) {
                subtotalPartePpt2 = 0;
            }

            subtotalParte1 = 0;
            try {
                subtotalParte1 = Number((vm.presupuestoMarco.subtotalMoldura1).toFixed(2));
            } catch(error) {
                subtotalParte1 = 0;
            }

            subtotalParte2 = 0;
            try {
                subtotalParte2 = Number((vm.presupuestoMarco.subtotalMoldura2).toFixed(2));
            } catch(error) {
                subtotalParte2 = 0;
            }

            subtotalParte3 = 0;
            try {
                subtotalParte3 = Number((vm.presupuestoMarco.subtotalMoldura3).toFixed(2));
            } catch(error) {
                subtotalParte3 = 0;
            }

            subtotalParte4 = 0;
            try {
                subtotalParte4 = Number((vm.presupuestoMarco.subtotalCristal).toFixed(2));
            } catch(error) {
                subtotalParte4 = 0;
            }

            subtotalParte5 = 0;
            try {
                subtotalParte5 = Number((vm.presupuestoMarco.subtotalTrasera).toFixed(2));
            } catch(error) {
                subtotalParte5 = 0;
            }



//CALCULAMOS LOS MULTIPLICADORES FINALES CON LOS SERVICIOS DE MONTAJE, EMBALAJE Y TRANSPORTE
            var clienteDejaObra = false;
            var anchoMolduraExterior = 0;
            var altoMolduraExterior = 0;
            var pvpMolduraExterior = 0;
            var precioLinealMolduraExterior = 0;
            var nuevoMultiplicadorMolduraExterior = 0;

            if (vm.presupuestoMarco.clienteDejaObraValorString == "true") {
                clienteDejaObra = true;
            } else {
                clienteDejaObra = false;
            }

            //Si la moldura3 es la moldura exterior
            if (subtotalParte3 > 0) {

                anchoMolduraExterior = vm.presupuestoMarco.widthMoldura3;
                altoMolduraExterior = vm.presupuestoMarco.heightMoldura3;
                pvpMolduraExterior = vm.presupuestoMarco.subtotalMoldura3;
                precioLinealMolduraExterior = vm.presupuestoMarco.precioLeroyMerlin3;

                nuevoMultiplicadorMolduraExterior = vm.getMultiplicadorMolduraExteriorConImporteServicios(clienteDejaObra,anchoMolduraExterior,altoMolduraExterior,pvpMolduraExterior,precioLinealMolduraExterior);
                vm.presupuestoMarco.multiplicadorMoldura3 = Number(nuevoMultiplicadorMolduraExterior.toFixed(2));

                vm.presupuestoMarco.subtotalMoldura3 = Number((vm.presupuestoMarco.multiplicadorMoldura3 * vm.presupuestoMarco.precioLeroyMerlin3).toFixed(2));
                subtotalParte3 = vm.presupuestoMarco.subtotalMoldura3;

            //Si la moldura2 es la moldura exterior
            } else if (subtotalParte2 > 0) {

                anchoMolduraExterior = vm.presupuestoMarco.widthMoldura2;
                altoMolduraExterior = vm.presupuestoMarco.heightMoldura2;
                pvpMolduraExterior = vm.presupuestoMarco.subtotalMoldura2;
                precioLinealMolduraExterior = vm.presupuestoMarco.precioLeroyMerlin2;

                nuevoMultiplicadorMolduraExterior = vm.getMultiplicadorMolduraExteriorConImporteServicios(clienteDejaObra,anchoMolduraExterior,altoMolduraExterior,pvpMolduraExterior,precioLinealMolduraExterior);
                vm.presupuestoMarco.multiplicadorMoldura2 = Number(nuevoMultiplicadorMolduraExterior.toFixed(2));

                vm.presupuestoMarco.subtotalMoldura2 = Number((vm.presupuestoMarco.multiplicadorMoldura2 * vm.presupuestoMarco.precioLeroyMerlin2).toFixed(2));
                subtotalParte2 = vm.presupuestoMarco.subtotalMoldura2;

            //Si la moldura1 es la moldura exterior
            } else {

                anchoMolduraExterior = vm.presupuestoMarco.widthMoldura1;
                altoMolduraExterior = vm.presupuestoMarco.heightMoldura1;
                pvpMolduraExterior = vm.presupuestoMarco.subtotalMoldura1;
                precioLinealMolduraExterior = vm.presupuestoMarco.precioLeroyMerlin1;

                nuevoMultiplicadorMolduraExterior = vm.getMultiplicadorMolduraExteriorConImporteServicios(clienteDejaObra,anchoMolduraExterior,altoMolduraExterior,pvpMolduraExterior,precioLinealMolduraExterior);
                vm.presupuestoMarco.multiplicadorMoldura1 = Number(nuevoMultiplicadorMolduraExterior.toFixed(2));

                vm.presupuestoMarco.subtotalMoldura1 = Number((vm.presupuestoMarco.multiplicadorMoldura1 * vm.presupuestoMarco.precioLeroyMerlin1).toFixed(2));
                subtotalParte1 = vm.presupuestoMarco.subtotalMoldura1;
            }


//CALCULAMOS EL SUBTOTAL Y TOTAL DEL PRESUPUESTO SIN IVA
            vm.presupuestoMarco.subtotal = Number( (subtotalPartePpt1 + subtotalMultiventana + subtotalPartePpt2 + subtotalParte1 + subtotalParte2 + subtotalParte3 + subtotalParte4 + subtotalParte5).toFixed(2) );
            vm.presupuestoMarco.total =  Number((vm.presupuestoMarco.subtotal * vm.presupuestoMarco.unidades).toFixed(2));

//CALCULAMOS EL IMPORTE DEL IVA (21%) Y EL IMPORTE TOTAL CON IVA
            vm.presupuestoMarco.iva =  Number((0.21*vm.presupuestoMarco.total).toFixed(2));
            vm.presupuestoMarco.totalConIva = Number((vm.presupuestoMarco.total + vm.presupuestoMarco.iva).toFixed(2));

            vm.budgetCalculated = true;
        }



        //***************************************************************
        function selectFile() {
            angular.element(document.querySelector('#fileInput')).click();
        }



        //***************************************************************
        function handleFileSelect(evt) {

            var storageDirectoryPath = "/Buenatelier/multiventana/";

            evt.stopPropagation();
            evt.preventDefault();
            var file = evt.target.files[0];

            try {
                var metadata = {
                    'contentType': file.type
                };
            } catch (error) {
                utilsService.writeConsole("[FramingBudgetController] => handleFileSelect() => We can´t assign 'contentType' to metadata.", WRITE_IN_CONSOLE)
            }

            var storageRef = firebaseDataService.firebaseStorageRootRef;
            storageRef.child(storageDirectoryPath + file.name).put(file,metadata)
                .then(function(snapshot) {
                    utilsService.writeConsole('Uploaded', snapshot.totalBytes, 'bytes.', WRITE_IN_CONSOLE);
                    utilsService.writeConsole(snapshot.metadata, WRITE_IN_CONSOLE);
                    var url = snapshot.metadata.downloadURLs[0];
                    utilsService.writeConsole('File available at' + url, WRITE_IN_CONSOLE);
                    utilsService.writeConsole("FILE UPLOADED!!!", WRITE_IN_CONSOLE);

                    $timeout(function() {
                        vm.dropping = false;
                        
                        vm.presupuestoMarco.nombreImagenVentanas = file.name;
                        vm.presupuestoMarco.urlImagenVentanas = snapshot.metadata.downloadURLs[0];

                        //document.getElementById("windowsImageFromStorage").src = vm.presupuestoMarco.nombreImagenVentanas;

                    });
                })
                .catch(function(error) {
                    utilsService.writeConsole("[FramingBudgetController] => handleFileSelect() => Upload failed!!! => ERROR: " + error, WRITE_IN_CONSOLE);
            });
        }



        //***************************************************************
        function resetImagenCroquis() {

            vm.presupuestoMarco.nombreImagenVentanas = "";
            vm.presupuestoMarco.urlImagenVentanas = "";
        }



        //***************************************************************
        function showMenuDialog(ev,pPresupuestoKey,pTipoPresupuesto) {

            $mdDialog.show({
              controller: 'MenuDialogController',
              controllerAs: 'vm',
              locals             : {
                    presupuestoKey: pPresupuestoKey,
                    presupuestoTipo: pTipoPresupuesto,
                },
              templateUrl: 'app/main/menu/presupuestos/budgets/menuDialog/menu-dialog.html',
              parent: angular.element($document.body),
              targetEvent: ev,
              clickOutsideToClose: true,
              escapeToClose: true
              //fullscreen: vm.customFullscreen // Only for -xs, -sm breakpoints.
            })
            .then(function(answer) {
              vm.status = 'We show the dialog menu';
            }, function() {
              vm.status = 'You cancelled the dialog menu.';
            });
        }



        //***************************************************************
        function showAlertDialog(pText) {
            // Appending dialog to document.body to cover sidenav in docs app
            var alert = $mdDialog.alert()
                .title("Información")
                .textContent(pText)
                //.ariaLabel("")
                //.targetEvent(ev)
                .ok("Cerrar")
                //.cancel("No");

            $mdDialog.show(alert)
                .finally(function() {
                    //utilsService.writeConsole("WE REDIRECT TO 'SELECT-ITB' PAGE", WRITE_IN_CONSOLE);
                    //$location.path("/workflow-admin/select-itb");
                }); 
        }



        //***************************************************************
        function gotoBudgets()
        {
            $state.go('app.menu_presupuestos');
        }



        //***************************************************************
        function gotoBudgetMenu()
        {
            $state.go('app.menu_presupuestos');
        }



/*
        //***************************************************************
        function gotoProductDetail(id)
        {
            $state.go('app.menu_presupuestos_budget', {id: id});
        }
*/



/*
        //***************************************************************
        function add100Presupuestos() {

            var fbUrl = firebaseDataService.presupuestos;
            var presupuestos = $firebaseArray(fbUrl.limitToLast(1));

            for (var i=2;i<102;i++) {

                var json = {"ciudadCliente": "Ciudad "+i,
                            "cliente": "Cliente "+i,
                            "codigo": "PRESU-00"+i,
                            "codigoPostalCliente": "08010",
                            "direccionCliente": "Dirección " + i,
                            "emailCliente": "cliente"+i + "@dominio.com",
                            "envioTienda": true,
                            "envioTiendaValorString": "false",
                            "estado": "Pendiente",
                            "fechaTimestamp": new Date().getTime() + (i*86400000),
                            "numeroPD": "PC171213",
                            "observacionesCliente": "Observación " + i,
                            "provinciaCliente": "Barcelona",
                            "telefonoCliente": "600 11 22 33",
                            "telefonoTienda": "900 11 22 33",
                            "tipo": "¿?",
                            "unidades": 0,
                            "importe": 0,                            
                            "usuario": "Administración central",
                            "usuario_key": "-L-zqZMzj2ApqVql-nn9",
                            "vendedor": "Vendedor " + i
                            };


                presupuestos.$add(json)
                    .then(function(ref) {

                        utilsService.writeConsole("[BudgetController] - addPresupuesto(pPresupuesto) => Added new record to 'presupuestos'", WRITE_IN_CONSOLE);

                        //INSERTAMOS EL REGISTRO EN LA TABLA "usuario_presupuestos"
                        var fbUrl = firebaseDataService.usuario_presupuestos;
                        var usuarioPresupuestos = $firebaseArray(fbUrl.limitToLast(1));

                        var json2 = {"usuario_presupuesto_key": "-L-zqZMzj2ApqVql-nn9&" + ref.key,
                                     "usuario_key": "-L-zqZMzj2ApqVql-nn9",
                                     "presupuesto_key": ref.key,
                                     "codigoPresupuesto": "PRESU-00"+i,
                                     "fechaTimestamp": new Date().getTime() + (i*86400000),
                                     "cliente": "Cliente "+i,
                                     "tipo": "¿?",
                                     "unidades": 0,
                                     "importe": 0,
                                     "usuario": "Administración central",
                                     "numeroPD": "PC171213",
                                     "estado": "Pendiente"
                                    };

                        usuarioPresupuestos.$add(json2)
                            .then(function(ref) {

                                utilsService.writeConsole("[BudgetController] - addPresupuesto(pPresupuesto) => Added new record to 'usuario_presupuestos'", WRITE_IN_CONSOLE);

                            })
                            .catch(function(error) {
                                utilsService.writeConsole("[BudgetController] - addPresupuesto(pPresupuesto) => ERROR: " + error, WRITE_IN_CONSOLE); 
                            }
                        );

                    })
                    .catch(function(error) {
                        utilsService.writeConsole("[BudgetController] - addPresupuesto(pPresupuesto) => ERROR: " + error, WRITE_IN_CONSOLE); 
                    }
                );
            }                    
        }
*/



    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.menu.presupuestos')
        .controller('BudgetsController', BudgetsController);

    /** @ngInject */
    function BudgetsController($state,WRITE_IN_CONSOLE,loginService,utilsService,msNavigationService,firebaseDataService,$firebaseArray,$firebaseObject,$mdDialog,$document)
    {

        //********************************************************        
        // DATA DECLARATION
        //********************************************************        
        var vm = this;

        vm.presupuestos = [];
        vm.totalPresupuestos = 0;  
        vm.role = "";
        vm.userKey = "";
        vm.numeroRegistros = 100;
/*        
        vm.userKey= "";
*/
        //********************************************************
        // METHODS DECLARATION
        //********************************************************  
        vm.initData = initData;
        vm.getPresupuestos = getPresupuestos;
        vm.getPresupuestosOfUsuario = getPresupuestosOfUsuario;
        //vm.getPresupuestosOfEmpresa = getPresupuestosOfEmpresa;
        vm.deletePresupuestoInUsuarioPresupuestosTable = deletePresupuestoInUsuarioPresupuestosTable;
        vm.deletePresupuestoInPresupuestosTable = deletePresupuestoInPresupuestosTable;
        vm.deletePresupuestoInPresupuestoMarcoTable = deletePresupuestoInPresupuestoMarcoTable;
        vm.deletePresupuestoInPresupuestoEspejoTable = deletePresupuestoInPresupuestoEspejoTable;

        vm.showConfirmDeleteDialog = showConfirmDeleteDialog;

        vm.copyBudget = copyBudget;
        vm.copyPresupuesto = copyPresupuesto;
        vm.copyPresupuestoToUsuarioPresupuestosTable = copyPresupuestoToUsuarioPresupuestosTable;

        vm.checkPendingStatusBudgets = checkPendingStatusBudgets;

        vm.showAlertDialog = showAlertDialog;
        vm.showMenuDialog = showMenuDialog;
        vm.showMenuDialogEstado = showMenuDialogEstado;
        vm.printOrderDialog = printOrderDialog;

        vm.gotoBudgetDetail = gotoBudgetDetail;
        vm.gotoAddBudget = gotoAddBudget;
        vm.gotoSelectTypeBudget = gotoSelectTypeBudget;


        //START CONTROLLER *******************************
        init();
        //START CONTROLLER *******************************


        //********************************************************
        // METHODS DECLARATION
        //********************************************************        
        function init()
        {
            //We initialize the data for the controller
            vm.initData();

            vm.role = loginService.getUserProfile();
            vm.userKey = loginService.getUserKey();

            //Si el usuario es Administrador => Mostramos todos los presupuestos (de todas las empresas y de todas los usuarios(tiendas) )
            if (vm.role == "administrator") {

                //Mostramos el menú de 'Productos'
                msNavigationService.saveItem('menu.productos', { hidden: function() { return false; } });

                //Mostramos el menú de 'Usuarios'
                msNavigationService.saveItem('menu.usuarios', { hidden: function() { return false; } });

                vm.getPresupuestos(vm.numeroRegistros);

            //Si no es Administrador => Mostramos los presupuestos creados por la Tienda actual (usuario)
            } else {

                //Ocultamos el menú de 'Productos'
                msNavigationService.saveItem('menu.productos', { hidden: function() { return true; } });

                //Ocultamos el menú de 'Usuarios'
                msNavigationService.saveItem('menu.usuarios', { hidden: function() { return true; } });

                vm.getPresupuestosOfUsuario(vm.userKey,vm.numeroRegistros);
            }
        }


        //***************************************************************
        function initData() {

            vm.dtInstance = {};
            vm.dtOptions = {
                dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                columnDefs  : [
                    {
                        // Target the "Nº presupuesto" column
                        targets   : 0,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },

                    {
                        // Target the "Fecha" column
                        targets   : 1,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },
                    {
                        // Target the "Cliente" column
                        targets   : 2,
                        //filterable: false,
                        //sortable  : false,
                        width     : '200px'
                    },
                    {
                        // Target the "Tipo" column
                        targets   : 3,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },

                    {
                        // Target the "Unidades" column
                        targets   : 4,
                        //filterable: false,
                        //sortable  : false,
                        width     : '20px'
                    },

                    {
                        // Target the "Importe" column
                        targets   : 5,
                        //filterable: false,
                        //sortable  : false,
                        width     : '30px'
                    },

                    {
                        // Target the "Usuario (Tienda)" column
                        targets   : 6,
                        //filterable: false,
                        //sortable  : false,
                        width     : '150px'
                    },

                    {
                        // Target the "Nº PC" column
                        targets   : 7,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },
/*
                    {
                        // Target the "Nº PD" column
                        targets   : 8,
                        //filterable: false,
                        //sortable  : false,
                        width     : '50px'
                    },
*/
                    {
                        // Target the "Estado" column
                        targets   : 8,
                        //filterable: false,
                        //sortable  : false,
                        width     : '40px'
                        /*
                        render    : function (data, type)
                        {
                            if (data == 'Pendiente')
                            {
                                return '<i class="icon-help-circle"></i>'
                            }
                            else if (data == 'Aprobado')
                            {
                                return '<i class="icon-checkbox-marked-circle green-500-fg"></i>';
                            }
                            else if (data == 'Anulado')
                            {
                                return '<i class="icon-cancel red-500-fg"></i>';
                            }

                            return ' ';

                        }  
                        */
                    },

                    {
                        // Target the "actions" column
                        targets           : 9,
                        width             : '200px',
                        responsivePriority: 1,
                        filterable        : false,
                        sortable          : false
                    }
                ],
                initComplete: function ()
                {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#budgets-search');

                    // Bind an external input as a table wide search box
                    if ( searchBox.length > 0 )
                    {
                        searchBox.on('keyup', function (event)
                        {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType  : 'simple',
                lengthMenu  : [100,250,500],
                pageLength  : 500,
                scrollY     : 'auto',
                responsive  : true,
                order       : [ 0, 'desc' ]
            };
        }



        //***************************************************************
        function getPresupuestos(pNumeroRegistros) {

            var fbUrl = firebaseDataService.usuario_presupuestos;
            
            var result = $firebaseArray(fbUrl.limitToLast(pNumeroRegistros).orderByChild("codigoPresupuesto"));
            //var result = $firebaseArray(fbUrl.orderByChild("codigoPresupuesto"));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    utilsService.writeConsole("[BudgetsController] => getPresupuestos() => EJECUCIÓN OK DE CONSULTA TABLA usuario_presupuestos con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        vm.presupuestos = data;

                        //We delete all budgets with date older than 6 days before today
                        deleteOldBudgetsPendingAndCanceled();

                        vm.totalPresupuestos = vm.presupuestos.length;

                    } else {

                        vm.presupuestos = null;
                        vm.totalPresupuestos = 0;
                    }

                    utilsService.writeConsole("vm.totalPresupuestos = " + vm.totalPresupuestos, WRITE_IN_CONSOLE);

/*
                    var usuarioNombre = vm.usuarios[0].nombre;
                    utilsService.writeConsole("nombre usuario = " + usuarioNombre, WRITE_IN_CONSOLE);
*/
                })

                .catch(function(error) {

                    vm.presupuestos = null;

                    utilsService.writeConsole("[BudgetsController] => getPresupuestos() => ERROR: " + error, WRITE_IN_CONSOLE);
                }
            );
        }



        //***************************************************************
        function deleteOldBudgetsPendingAndCanceled() {

            var timestampToday = utilsService.getTimestampToday();


            //We get the date for 6 days before today.
            var fecha6daysBefore = timestampToday - (6*86400000);      // NOTA => 1 DIA = 86,400,000 milisegundos

            var totalPresupuestos = vm.presupuestos.length;

            for (var i=0;i<totalPresupuestos;i++) {

                var budget = vm.presupuestos[i];

                if (budget.fechaTimestamp < fecha6daysBefore) {

                    if ( (budget.estado == "Pendiente") || (budget.estado == "Anulado") ) {

                        //We delete this budget because is older than 6 days before today
                        try {

                            //utilsService.writeConsole("ELIMINAMOS EL PRESUPUESTO " + budget.codigoPresupuesto, WRITE_IN_CONSOLE);
                            deletePresupuestoInUsuarioPresupuestosTableByRecord(budget);    //This function delete records in "presupuestos", "presupuesto_marco", "presupuesto_espejo" tables

                        } catch(error) {

                            utilsService.writeConsole("[BudgetsController] => deleteOldBudgets() => ERROR: " + error, WRITE_IN_CONSOLE);
                        }

                    }

                }

            }

        }



        //***************************************************************
        function getPresupuestosOfUsuario(pUsuarioKey,pNumeroRegistros) {

            var fbUrl = firebaseDataService.usuario_presupuestos;
            var result = $firebaseArray(fbUrl.orderByChild("usuario_key").equalTo(pUsuarioKey).limitToLast(pNumeroRegistros));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    utilsService.writeConsole("[BudgetsController] => getPresupuestosOfUsuario() => EJECUCIÓN OK DE CONSULTA TABLA usuario_presupuestos con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        vm.presupuestos = data;
                        vm.totalPresupuestos = dataLength;

//                        vm.checkPendingStatusBudgets();

                    } else {

                        vm.presupuestos = null;
                        vm.totalPresupuestos = 0;
                    }

                    utilsService.writeConsole("vm.totalPresupuestos = " + vm.totalPresupuestos, WRITE_IN_CONSOLE);
                })

                .catch(function(error) {

                    vm.presupuestos = null;

                    utilsService.writeConsole("[BudgetsController] => getPresupuestosOfUsuario() => ERROR: " + error, WRITE_IN_CONSOLE);
                }
            );
        }



        function checkPendingStatusBudgets() {

            var arrayLength = vm.presupuestos.length;

            for (var i=0;i<arrayLength;i++) {

                var budget = vm.presupuestos[i];

                if (budget.estado == "Pendiente") {

                    vm.showAlertDialog("ATENCIÓN: Existe algún presupuesto pendiente de asignar el estado 'Aprobado' o 'Anulado'.\n\rRecuerda revisar el estado y asignar el Número de Pedido de Cliente (nº de PC) a los que estén aprobados");
                    return;
                }
            }
        }



/*
        //***************************************************************
        function getPresupuestosOfEmpresa(pEmpresaKey) {

            var fbUrl = firebaseDataService.presupuestos;
            var result = $firebaseArray(fbUrl.orderByChild("empresa_key").equalTo(pEmpresaKey));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    utilsService.writeConsole("[BudgetsController] => getPresupuestosOfEmpresa() => EJECUCIÓN OK DE CONSULTA TABLA presupuestos con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        vm.presupuestos = data;
                        vm.totalPresupuestos = dataLength;

                    } else {

                        vm.presupuestos = null;
                        vm.totalPresupuestos = 0;
                    }

                    utilsService.writeConsole("vm.totalPresupuestos = " + vm.totalPresupuestos, WRITE_IN_CONSOLE);
                })

                .catch(function(error) {

                    vm.presupuestos = null;

                    utilsService.writeConsole("[BudgetsController] => getPresupuestosOfEmpresa() => ERROR: " + error, WRITE_IN_CONSOLE);
                }
            );
        }
*/


        //***************************************************************
        function showConfirmDeleteDialog(ev,pPresupuestoKey) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('¿Estás seguro de eliminar el registro?')
                .textContent("")
                //.ariaLabel(""'Lucky day')
                .ariaLabel("")
                .targetEvent(ev)
                .ok("ELIMINAR")
                .cancel("CANCELAR");

            $mdDialog.show(confirm)
                .then(function() {
                    //YOU HAVE PUSHED "YES" BUTTON
                    vm.deletePresupuestoInUsuarioPresupuestosTable(pPresupuestoKey);
                }, 
                function() {
                    //YOU HAVE PUSHED "NO" BUTTON
                });
        }



        //***************************************************************
        function deletePresupuestoInUsuarioPresupuestosTableByRecord(pUsuarioPresupuestoRecord) {

            //ELIMINAMOS EL REGISTRO CORRESPONDIENTE EN LA TABLA "usuario_presupuestos"
            var presupuestoKey = pUsuarioPresupuestoRecord.presupuesto_key;

            if (pUsuarioPresupuestoRecord != null) {
                vm.presupuestos.$remove(pUsuarioPresupuestoRecord)
                    .then(function(ref) {

                        utilsService.writeConsole("[BudgetsController] => deletePresupuestoInUsuarioPresupuestosTable(pPresupuestoKey) => Record deleted in 'usuario_presupuestos' table", WRITE_IN_CONSOLE);

                        //ELIMINAMOS EL REGISTRO RELACIONADO EN LAS TABLAS "presupuestos", "presupuesto_marco" y "presupuesto_espejo"
                        vm.deletePresupuestoInPresupuestosTable(presupuestoKey);
                        vm.deletePresupuestoInPresupuestoMarcoTable(presupuestoKey);
                        vm.deletePresupuestoInPresupuestoEspejoTable(presupuestoKey);

                        //We refesh the global variable "vm.totalPresupuestos" because we have removed the record in "usuario_presupuestos" table and the others one.
                        vm.totalPresupuestos = vm.presupuestos.length; 
                    })

                    .catch(function(error) {

                        utilsService.writeConsole("[BudgetsController] => deletePresupuestoInUsuarioPresupuestosTable(pPresupuestoKey) => ERROR: " + error, WRITE_IN_CONSOLE);
                    }
                );

            } else {
                utilsService.writeConsole("[BudgetsController] => deletePresupuestoInUsuarioPresupuestosTable(pPresupuestoKey) => We can´t remove the row.", WRITE_IN_CONSOLE);
            }
        }



        //***************************************************************
        function deletePresupuestoInUsuarioPresupuestosTable(pUsuarioPresupuestoKey) {

            //ELIMINAMOS EL REGISTRO CORRESPONDIENTE EN LA TABLA "usuario_presupuestos"

            //We get the record with pPresupuestoKey
            var recordToDelete = vm.presupuestos.$getRecord(pUsuarioPresupuestoKey);
            var presupuestoKey = recordToDelete.presupuesto_key;

            if (presupuestoKey != null) {
                vm.presupuestos.$remove(recordToDelete)
                    .then(function(ref) {

                        utilsService.writeConsole("[BudgetsController] => deletePresupuestoInUsuarioPresupuestosTable(pPresupuestoKey) => Record deleted in 'usuario_presupuestos' table", WRITE_IN_CONSOLE);

                        //ELIMINAMOS EL REGISTRO RELACIONADO EN LAS TABLAS "presupuestos", "presupuesto_marco" y "presupuesto_espejo"
                        vm.deletePresupuestoInPresupuestosTable(presupuestoKey);
                        vm.deletePresupuestoInPresupuestoMarcoTable(presupuestoKey);
                        vm.deletePresupuestoInPresupuestoEspejoTable(presupuestoKey);
                    })

                    .catch(function(error) {

                        utilsService.writeConsole("[BudgetsController] => deletePresupuestoInUsuarioPresupuestosTable(pPresupuestoKey) => ERROR: " + error, WRITE_IN_CONSOLE);
                    }
                );

            } else {
                utilsService.writeConsole("[BudgetsController] => deletePresupuestoInUsuarioPresupuestosTable(pPresupuestoKey) => We can´t remove the row.", WRITE_IN_CONSOLE);
            }
        }



        //***************************************************************
        function deletePresupuestoInPresupuestosTable(pPresupuestoKey) {

            var fbUrl = firebaseDataService.presupuestos.child(pPresupuestoKey);
            var record = $firebaseObject(fbUrl);

            record.$remove()
                .then(function(ref) {
                    utilsService.writeConsole("[BudgetsController] => deletePresupuestoInPresupuestosTable(pPresupuestoKey) => Record deleted in 'presupuestos' table", WRITE_IN_CONSOLE);
                })

                .catch(function(error) {

                    utilsService.writeConsole("[BudgetsController] => deletePresupuestoInPresupuestosTable(pPresupuestoKey) => ERROR: " + error, WRITE_IN_CONSOLE);
                }
            );            
        }



        //***************************************************************
        function deletePresupuestoInPresupuestoEspejoTable(pPresupuestoKey) {

            var fbUrl = firebaseDataService.presupuesto_espejo;
            var result = $firebaseArray(fbUrl.orderByChild("presupuesto_key").equalTo(pPresupuestoKey));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    utilsService.writeConsole("[BudgetsController] => deletePresupuestoInPresupuestoEspejoTable(pPresupuestoKey) => EJECUCIÓN OK DE CONSULTA TABLA 'presupuesto_espejo' con data.length = " + dataLength);

                    if (dataLength > 0) {

                        //We remove the record in 'presupuesto_espejo' table
                        data.$remove(0);

                    } else {

                        utilsService.writeConsole("[BudgetsController] => deletePresupuestoInPresupuestoEspejoTable(pPresupuestoKey) => NO HA SIDO POSIBLE ELIMINAR EL REGISTRO EN LA TABLA 'presupuesto_espejo'");
                    }
                })

                .catch(function(error) {
                    utilsService.writeConsole("[BudgetsController] => deletePresupuestoInPresupuestoEspejoTable(pPresupuestoKey) => ERROR: " + error);
                }
            );
        }



        //***************************************************************
        function deletePresupuestoInPresupuestoMarcoTable(pPresupuestoKey) {

            var fbUrl = firebaseDataService.presupuesto_marco;
            var result = $firebaseArray(fbUrl.orderByChild("presupuesto_key").equalTo(pPresupuestoKey));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    utilsService.writeConsole("[BudgetsController] => deletePresupuestoInPresupuestoMarcoTable(pPresupuestoKey) => EJECUCIÓN OK DE CONSULTA TABLA 'presupuesto_espejo' con data.length = " + dataLength);

                    if (dataLength > 0) {

                        //We remove the record in 'presupuesto_espejo' table
                        data.$remove(0);

                    } else {

                        utilsService.writeConsole("[BudgetsController] => deletePresupuestoInPresupuestoMarcoTable(pPresupuestoKey) => NO HA SIDO POSIBLE ELIMINAR EL REGISTRO EN LA TABLA 'presupuesto_espejo'");
                    }
                })

                .catch(function(error) {
                    utilsService.writeConsole("[BudgetsController] => deletePresupuestoInPresupuestoMarcoTable(pPresupuestoKey) => ERROR: " + error);
                }
            );
        }




        //***************************************************************
        function copyBudget(pPresupuestoKey) {

            var fbUrl = firebaseDataService.presupuestos.child(pPresupuestoKey);
            var result = $firebaseObject(fbUrl);

            result.$loaded()
                .then(function(data) {

                    utilsService.writeConsole("[BudgetsController] => copyBudget(pPresupuestoKey) => EJECUCIÓN OK DE CONSULTA TABLA presupuestos con $id = " + data.$id, WRITE_IN_CONSOLE);
                    vm.presupuestoKey = data.$id;

                    var presupuestoAcopiar = data;

                    presupuestoAcopiar.fechaTimestamp = new Date().getTime();
                    presupuestoAcopiar.tipo = "¿?";
                    presupuestoAcopiar.unidades = 0;
                    presupuestoAcopiar.importe = 0;
                    presupuestoAcopiar.estado = "Pendiente";

                    vm.copyPresupuesto(presupuestoAcopiar)

                })

                .catch(function(error) {
                    vm.presupuesto = null;
                    utilsService.writeConsole("[BudgetsController] => copyBudget(pPresupuestoKey) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        //***************************************************************
        function copyPresupuesto(pPresupuesto) {

            var ultimoPresupuesto;

            var fbUrl = firebaseDataService.presupuestos;
            var presupuestos = $firebaseArray(fbUrl.limitToLast(1));

            presupuestos.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    if (dataLength > 0) {

                        ultimoPresupuesto = data[0];

                        //Incrementamos el número de presupuesto en 1 unidad
                        var ultimoCodigoPresupuesto = ultimoPresupuesto.codigo;
                        var nuevoCodigoPresupuesto = Number(ultimoCodigoPresupuesto.substring(3,ultimoCodigoPresupuesto.length));
                        nuevoCodigoPresupuesto++;
                        pPresupuesto.codigo = "PR-" + utilsService.padLeftWithZero(nuevoCodigoPresupuesto,6);

                        //Deshabilitamos las siguientes líneas porque asignamos el mismo número de PD del presupuesto a copiar
                        /*
                        var ultimoNumeroPD = ultimoPresupuesto.numeroPD;
                        var nuevoNumeroPD = Number(ultimoNumeroPD.substring(3,ultimoNumeroPD.length));
                        nuevoNumeroPD++;
                        pPresupuesto.numeroPD = "PD-" + utilsService.padLeftWithZero(nuevoNumeroPD,6);
                        */
                        pPresupuesto.numeroPC = "?";


                        presupuestos.$add(pPresupuesto)
                            .then(function(ref) {
                                utilsService.writeConsole("[BudgetsController] - copyPresupuesto(pPresupuesto) => Added new record to 'presupuestos'", WRITE_IN_CONSOLE);

                                //AÑADIMOS UN NUEVO REGISTRO EN LA TABLA "usuario_exportaciones"
                                var newRecord = {
                                    "usuario_presupuesto_key": pPresupuesto.usuario_key + "&" + ref.key,
                                    "usuario_key": pPresupuesto.usuario_key,
                                    "presupuesto_key": ref.key,
                                    "usuario": pPresupuesto.usuario,
                                    "codigoPresupuesto": pPresupuesto.codigo,
                                    "fechaTimestamp": pPresupuesto.fechaTimestamp,
                                    "cliente": pPresupuesto.cliente,
                                    "tipo": pPresupuesto.tipo,
                                    "unidades": pPresupuesto.unidades,
                                    "importe": pPresupuesto.importe,
                                    "numeroPD": pPresupuesto.numeroPD,
                                    "numeroPC": "?",
                                    "estado": pPresupuesto.estado
                                }

                                vm.copyPresupuestoToUsuarioPresupuestosTable(newRecord);

                            })
                            .catch(function(error) {
                                utilsService.writeConsole("[BudgetsController] - copyPresupuesto(pPresupuesto) => ERROR: " + error, WRITE_IN_CONSOLE); 
                            }
                        );

                    } else {

                        //Asignamos el primer nº de presupuesto
                        pPresupuesto.codigo = "PR-000001";

                        //Asignamos el primer número de PD
                        pPresupuesto.numeroPD = "PD-000001";

                        pPresupuesto.numeroPC = "?";


                        presupuestos.$add(pPresupuesto)
                            .then(function(ref) {
                                utilsService.writeConsole("[BudgetsController] - copyPresupuesto(pPresupuesto) => Added new record to 'presupuestos'", WRITE_IN_CONSOLE);

                                //AÑADIMOS UN NUEVO REGISTRO EN LA TABLA "usuario_exportaciones"
                                var newRecord = {
                                    "usuario_presupuesto_key": pPresupuesto.usuario_key + "&" + ref.key,
                                    "usuario_key": pPresupuesto.usuario_key,
                                    "presupuesto_key": ref.key,
                                    "usuario": pPresupuesto.usuario,
                                    "codigoPresupuesto": pPresupuesto.codigo,
                                    "fechaTimestamp": pPresupuesto.fechaTimestamp,
                                    "cliente": pPresupuesto.cliente,
                                    "tipo": pPresupuesto.tipo,
                                    "unidades": pPresupuesto.unidades,
                                    "importe": pPresupuesto.importe,
                                    "numeroPD": pPresupuesto.numeroPD,
                                    "numeroPC": "?",
                                    "estado": pPresupuesto.estado
                                }

                                vm.copyPresupuestoToUsuarioPresupuestosTable(newRecord);

                            })
                            .catch(function(error) {
                                utilsService.writeConsole("[BudgetsController] - copyPresupuesto(pPresupuesto) => ERROR: " + error, WRITE_IN_CONSOLE); 
                            }
                        );


                    }
                })

                .catch(function(error) {
                    presupuestos = null;
                    utilsService.writeConsole("[BudgetsController] => getUsuarioPresupuestos() => ERROR: " + error, WRITE_IN_CONSOLE);
                }
            );
        }



        //***************************************************************
        function copyPresupuestoToUsuarioPresupuestosTable(pNewRecord) {

            var fbUrl = firebaseDataService.usuario_presupuestos;
            var records = $firebaseArray(fbUrl.limitToLast(1));

            records.$add(pNewRecord)
                .then(function(ref) {
                    utilsService.writeConsole("[BudgetsController] => copyPresupuestoToUsuarioPresupuestosTable() => Added new record to 'usuario_exportaciones'", WRITE_IN_CONSOLE);

                    //We go to budgets list page
                    vm.gotoBudgets();

                })
                .catch(function(error) {
                    utilsService.writeConsole("[BudgetsController] => copyPresupuestoToUsuarioPresupuestosTable() => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }




        //***************************************************************
        function showAlertDialog(pText) {
            // Appending dialog to document.body to cover sidenav in docs app
            var alert = $mdDialog.alert()
                .title("Información")
                .textContent(pText)
                //.ariaLabel("")
                //.targetEvent(ev)
                .ok("Cerrar")
                //.cancel("No");

            $mdDialog.show(alert)
                .finally(function() {
                    //utilsService.writeConsole("WE REDIRECT TO 'SELECT-ITB' PAGE", WRITE_IN_CONSOLE);
                    //$location.path("/workflow-admin/select-itb");
                }); 
        }



        //***************************************************************
        function showMenuDialog(ev,pPresupuestoKey,pPresupuestoTipo) {

            $mdDialog.show({
              controller: 'MenuDialogController',
              controllerAs: 'vm',
              locals             : {
                    presupuestoKey: pPresupuestoKey,
                    presupuestoTipo: pPresupuestoTipo,
                },
              templateUrl: 'app/main/menu/presupuestos/budgets/menuDialog/menu-dialog.html',
              parent: angular.element($document.body),
              targetEvent: ev,
              clickOutsideToClose: true,
              escapeToClose: true
              //fullscreen: vm.customFullscreen // Only for -xs, -sm breakpoints.
            })
            .then(function(answer) {
              vm.status = 'You said the information was "' + answer + '".';
            }, function() {
              vm.status = 'You cancelled the dialog.';
            });
        }



        //***************************************************************
        function showMenuDialogEstado(ev,pPresupuestoKey,pPresupuestoEstado,pPresupuestoNumeroPD,pPresupuestoNumeroPC) {

            if ( (pPresupuestoEstado == "Aprobado") || (pPresupuestoEstado == "Anulado") )  {
                return;
            }


            $mdDialog.show({
              controller: 'MenuDialogEstadoController',
              controllerAs: 'vm',
              locals             : {
                    presupuestoKey: pPresupuestoKey,
                    presupuestoEstado: pPresupuestoEstado,
                    presupuestoNumeroPD: pPresupuestoNumeroPD,
                    presupuestoNumeroPC: pPresupuestoNumeroPC
                },
              templateUrl: 'app/main/menu/presupuestos/budgets/menuDialogEstado/menu-dialog-estado.html',
              parent: angular.element($document.body),
              targetEvent: ev,
              clickOutsideToClose: false,
              escapeToClose: false
              //fullscreen: vm.customFullscreen // Only for -xs, -sm breakpoints.
            })
            .then(function(answer) {
              vm.status = 'You said the information was "' + answer + '".';
            }, function() {
              vm.status = 'You cancelled the dialog.';
            });
        }



        //***************************************************************
        function printOrderDialog(ev,pPresupuestoKey,pPresupuestoNumeroPC)
        {
            $mdDialog.show({
                controller         : 'PrintOrderDialogController',
                controllerAs       : 'vm',
                
                locals             : {
                    presupuestoKey: pPresupuestoKey,
                    presupuestoNumeroPC: pPresupuestoNumeroPC
                    //,consignatarioData: vm.consignatarioData
                    //,packinglistData: vm.packinglistData
                },
                
                templateUrl        : 'app/main/menu/presupuestos/budgets/printOrderDialog/print-order-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev
                //clickOutsideToClose: true
            });
        }



        //***************************************************************
        function gotoBudgetDetail(id)
        {
            $state.go('app.menu_presupuestos_budget', {id: id});
        }



        //***************************************************************
        function gotoAddBudget()
        {
            $state.go('app.menu_presupuestos_add');
        }



        //***************************************************************
        function gotoSelectTypeBudget(ev) {

            vm.showAdvanced(ev);

        }



    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.menu.presupuestos')
        .controller('BudgetController', BudgetController);

    /** @ngInject */
    function BudgetController($state,WRITE_IN_CONSOLE,utilsService,loginService,firebaseDataService,$firebaseArray,$firebaseObject,$mdDialog,$document)
    {
        //********************************************************        
        // DATA DECLARATION
        //********************************************************        
        var vm = this;

        vm.mode = "";       //accepted values = ["insert","update"]

        vm.presupuesto = {};
        vm.usuarioPresupuestos;
        vm.presupuestoKey = "";
        vm.estados = ["Aprobado","Pendiente","Anulado"];
        vm.provincias = ["Álava","Albacete","Alicante","Almería","Asturias","Ávila","Badajoz","Islas Baleares","Barcelona","Burgos","Cáceres","Cádiz","Cantabria","Castellón","Ciudad Real","Córdoba","Cuenca","Girona","Granada","Guadalajara","Guipúzcoa","Huelva","Huesca","Jaén","La Coruña","La Rioja","Las Palmas","León","Lleida","Lugo","Madrid","Málaga","Murcia","Navarra","Orense","Palencia","Pontevedra","Salamanca","Segovia","Sevilla","Soria","Tarragona","Santa Cruz de Tenerife","Teruel","Toledo","Valencia","Valladolid","Vizcaya","Zamora","Zaragoza"];

        vm.fechaConFormato = "";

        //********************************************************
        // METHODS DECLARATION
        //********************************************************   
        vm.getPresupuesto = getPresupuesto;
        vm.getUsuarioPresupuestos = getUsuarioPresupuestos;

        vm.addPresupuesto = addPresupuesto;
        vm.addPresupuestoToUsuarioPresupuestosTable = addPresupuestoToUsuarioPresupuestosTable;
        vm.save = save;
        vm.savePresupuestoToUsuarioPresupuestosTable = savePresupuestoToUsuarioPresupuestosTable;

        vm.showMenuDialog = showMenuDialog;

        vm.gotoBudgets = gotoBudgets;
        //vm.showAlertDialog = showAlertDialog;

//vm.add100Presupuestos = add200Presupuestos;



        //START CONTROLLER *******************************
        init();
        //START CONTROLLER *******************************


        //********************************************************
        // METHODS DECLARATION
        //********************************************************        
        function init()
        {
            var id;

            try {

                id = $state.params.id;

                //SI SE TRATA DE UNA INSERCIÓN
                if (id == null) {

                    vm.mode = "insert";

                    //Para el caso de la inserción => Asignamos los valores por defecto (estado, envioTienda, tienda y telefonoTienda)
                    vm.presupuesto.fechaTimestamp = new Date().getTime();
                    vm.fechaConFormato = new Date(vm.presupuesto.fechaTimestamp);

                    try {

                        if (vm.estado.trim().length == 0) {
                            vm.presupuesto.estado = "Pendiente";
                        }

                    } catch(error) {
                        vm.presupuesto.estado = "Pendiente";
                    }

                    vm.presupuesto.envioTiendaValorString = "true";

                    vm.presupuesto.usuario = loginService.getName(); 
                    vm.presupuesto.usuario_key = loginService.getUserKey();
                    vm.presupuesto.telefonoTienda = loginService.getPhone();


                    vm.presupuesto.tipo = "¿?";
                    vm.presupuesto.unidades = 0;
                    vm.presupuesto.importe = 0;


                //SI SE TRATA DE UNA MODIFICACIÓN
                } else {
                    vm.mode = "update";
                    vm.getPresupuesto(id);
                    vm.getUsuarioPresupuestos(id);
                }


//vm.add100Presupuestos();


            } catch (error) {
                vm.mode = "insert";
            }


        }



        //***************************************************************
        function getPresupuesto(pId) {

            var fbUrl = firebaseDataService.presupuestos.child(pId);
            var result = $firebaseObject(fbUrl);

            result.$loaded()
                .then(function(data) {

                    utilsService.writeConsole("[BudgetController] => getPresupuesto(pId) => EJECUCIÓN OK DE CONSULTA TABLA presupuestos con $id = " + data.$id, WRITE_IN_CONSOLE);
                    vm.presupuestoKey = data.$id;

                    vm.presupuesto = data;

                    vm.fechaConFormato = new Date(vm.presupuesto.fechaTimestamp);
                })

                .catch(function(error) {
                    vm.presupuesto = null;
                    utilsService.writeConsole("[BudgetController] => getPresupuesto(pId) => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }


        //***************************************************************
        function getUsuarioPresupuestos(pPresupuestoKey) {

            var fbUrl = firebaseDataService.usuario_presupuestos;
            var result = $firebaseArray(fbUrl.orderByChild("presupuesto_key").equalTo(pPresupuestoKey));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    utilsService.writeConsole("[BudgetController] => getUsuarioPresupuestos() => EJECUCIÓN OK DE CONSULTA TABLA 'usuario_presupuestos' con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        vm.usuarioPresupuestos = data;
                    } else {
                        vm.usuarioPresupuestos = null;
                    }
                })

                .catch(function(error) {
                    vm.usuarioPresupuestos = null;
                    utilsService.writeConsole("[BudgetController] => getUsuarioPresupuestos() => ERROR: " + error, WRITE_IN_CONSOLE);
                }
            );
        }




        //***************************************************************
        function addPresupuesto(pPresupuesto) {

            var ultimoPresupuesto;

            var fbUrl = firebaseDataService.presupuestos;
            var presupuestos = $firebaseArray(fbUrl.limitToLast(1));

            presupuestos.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    if (dataLength > 0) {

                        ultimoPresupuesto = data[0];

                        //Incrementamos el número de presupuesto en 1 unidad
                        var ultimoCodigoPresupuesto = ultimoPresupuesto.codigo;
                        var nuevoCodigoPresupuesto = Number(ultimoCodigoPresupuesto.substring(3,ultimoCodigoPresupuesto.length));
                        nuevoCodigoPresupuesto++;
                        pPresupuesto.codigo = "PR-" + utilsService.padLeftWithZero(nuevoCodigoPresupuesto,6);

                        //Incrementamos el número de PC en 1 unidad
                        var ultimoNumeroPD = ultimoPresupuesto.numeroPD;
                        var nuevoNumeroPD = Number(ultimoNumeroPD.substring(3,ultimoNumeroPD.length));
                        nuevoNumeroPD++;
                        pPresupuesto.numeroPD = "PD-" + utilsService.padLeftWithZero(nuevoNumeroPD,6);
                        pPresupuesto.numeroPC = "?";

                        presupuestos.$add(pPresupuesto)
                            .then(function(ref) {
                                utilsService.writeConsole("[BudgetController] - addPresupuesto(pPresupuesto) => Added new record to 'presupuestos'", WRITE_IN_CONSOLE);

                                //AÑADIMOS UN NUEVO REGISTRO EN LA TABLA "usuario_exportaciones"
                                var newRecord = {
                                    "usuario_presupuesto_key": pPresupuesto.usuario_key + "&" + ref.key,
                                    "usuario_key": pPresupuesto.usuario_key,
                                    "presupuesto_key": ref.key,
                                    "usuario": pPresupuesto.usuario,
                                    "codigoPresupuesto": pPresupuesto.codigo,
                                    "fechaTimestamp": pPresupuesto.fechaTimestamp,
                                    "cliente": pPresupuesto.cliente,
                                    "tipo": pPresupuesto.tipo,
                                    "unidades": pPresupuesto.unidades,
                                    "importe": pPresupuesto.importe,
                                    "numeroPD": pPresupuesto.numeroPD,
                                    "numeroPC": "?",
                                    "estado": pPresupuesto.estado
                                }

                                vm.presupuestoKey = ref.key;

                                vm.addPresupuestoToUsuarioPresupuestosTable(newRecord);

                            })
                            .catch(function(error) {
                                utilsService.writeConsole("[BudgetController] - addPresupuesto(pPresupuesto) => ERROR: " + error, WRITE_IN_CONSOLE); 
                            }
                        );

                    } else {

                        //Asignamos el primer nº de presupuesto
                        pPresupuesto.codigo = "PR-000001";

                        //Asignamos el primer número de PC
                        pPresupuesto.numeroPD = "PD-000001";
                        pPresupuesto.numeroPC = "?";

                        presupuestos.$add(pPresupuesto)
                            .then(function(ref) {
                                utilsService.writeConsole("[BudgetController] - addPresupuesto(pPresupuesto) => Added new record to 'presupuestos'", WRITE_IN_CONSOLE);

                                //AÑADIMOS UN NUEVO REGISTRO EN LA TABLA "usuario_exportaciones"
                                var newRecord = {
                                    "usuario_presupuesto_key": pPresupuesto.usuario_key + "&" + ref.key,
                                    "usuario_key": pPresupuesto.usuario_key,
                                    "presupuesto_key": ref.key,
                                    "usuario": pPresupuesto.usuario,
                                    "codigoPresupuesto": pPresupuesto.codigo,
                                    "fechaTimestamp": pPresupuesto.fechaTimestamp,
                                    "cliente": pPresupuesto.cliente,
                                    "tipo": pPresupuesto.tipo,
                                    "unidades": pPresupuesto.unidades,
                                    "importe": pPresupuesto.importe,
                                    "numeroPD": pPresupuesto.numeroPD,
                                    "numeroPC": "?",
                                    "estado": pPresupuesto.estado
                                }

                                vm.addPresupuestoToUsuarioPresupuestosTable(newRecord);

                            })
                            .catch(function(error) {
                                utilsService.writeConsole("[BudgetController] - addPresupuesto(pPresupuesto) => ERROR: " + error, WRITE_IN_CONSOLE); 
                            }
                        );


                    }
                })

                .catch(function(error) {
                    presupuestos = null;
                    utilsService.writeConsole("[BudgetController] => getUsuarioPresupuestos() => ERROR: " + error, WRITE_IN_CONSOLE);
                }
            );
        }



        //***************************************************************
        function addPresupuestoToUsuarioPresupuestosTable(pNewRecord) {

            var fbUrl = firebaseDataService.usuario_presupuestos;
            var records = $firebaseArray(fbUrl.limitToLast(1));

            records.$add(pNewRecord)
                .then(function(ref) {
                    utilsService.writeConsole("[BudgetController] => addPresupuestoToUsuarioPresupuestosTable() => Added new record to 'usuario_exportaciones'", WRITE_IN_CONSOLE);

                    //We go to budgets list page
                    //vm.gotoBudgets();     //DESHABILITADO

                    //Open autommatically the window of budge type selection
                    vm.showMenuDialog(vm.presupuestoKey,"¿?");

                })
                .catch(function(error) {
                    utilsService.writeConsole("[BudgetController] => addPresupuestoToUsuarioPresupuestosTable() => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );
        }



        //***************************************************************
        function save() {

            utilsService.writeConsole("vm.fechaConFormato = " + vm.fechaConFormato, WRITE_IN_CONSOLE);

            vm.presupuesto.fechaTimestamp = vm.fechaConFormato.getTime();
            utilsService.writeConsole("vm.presupuesto.fechaTimestamp = " + vm.presupuesto.fechaTimestamp, WRITE_IN_CONSOLE);

            if (vm.mode == "update") {
                
                //We update budget's data
                vm.presupuesto.$save()
                    .then(function(ref) {
                        utilsService.writeConsole("[BudgetController] - save() => Presupuesto saved with ID = " + ref.key, WRITE_IN_CONSOLE);

                        //We save the record in "usuario_presupuestos" table
                        vm.savePresupuestoToUsuarioPresupuestosTable();
                    })

                    .catch(function(error) {
                        utilsService.writeConsole("[BudgetController] => save() => ERROR: " + error, WRITE_IN_CONSOLE); 
                });                

            } else {

                //We add a new presupuesto
                vm.addPresupuesto(vm.presupuesto);
            }
        }



        //***************************************************************
        function savePresupuestoToUsuarioPresupuestosTable() {

            var recordToUpdate = vm.usuarioPresupuestos[0];

            //Asignamos los valores actuales
            recordToUpdate.codigoPresupuesto =  vm.presupuesto.codigo;
            recordToUpdate.fechaTimestamp = vm.presupuesto.fechaTimestamp;
            recordToUpdate.cliente = vm.presupuesto.cliente;
            recordToUpdate.tipo = vm.presupuesto.tipo;
            recordToUpdate.unidades = vm.presupuesto.unidades;
            recordToUpdate.importe = vm.presupuesto.importe;
            recordToUpdate.usuario = vm.presupuesto.usuario;
            recordToUpdate.numeroPD = vm.presupuesto.numeroPD;
            recordToUpdate.numeroPC = vm.presupuesto.numeroPC;
            recordToUpdate.estado = vm.presupuesto.estado;

            //Guardamos el registro con los nuevos datos
            vm.usuarioPresupuestos.$save(recordToUpdate)
                .then(function(ref) {
                    utilsService.writeConsole("[BudgetController] => savePresupuestoToUsuarioPresupuestosTable() =>  Saved record to 'usuario_exportaciones'", WRITE_IN_CONSOLE);

                    //We go to Presupuestos page
                    vm.gotoBudgets();
                })

                .catch(function(error) {
                    utilsService.writeConsole("[BudgetController] => savePresupuestoToUsuarioPresupuestosTable() => ERROR: " + error, WRITE_IN_CONSOLE); 
                }
            );                        
        }



        //***************************************************************
//        function showMenuDialog(ev,pPresupuestoKey,pPresupuestoTipo) {
        function showMenuDialog(pPresupuestoKey,pPresupuestoTipo) {    

            $mdDialog.show({
              controller: 'MenuDialogController',
              controllerAs: 'vm',
              locals             : {
                    presupuestoKey: pPresupuestoKey,
                    presupuestoTipo: pPresupuestoTipo,
                },
              templateUrl: 'app/main/menu/presupuestos/budgets/menuDialog/menu-dialog.html',
              parent: angular.element($document.body),
//              targetEvent: ev,
              clickOutsideToClose: true,
              escapeToClose: true
              //fullscreen: vm.customFullscreen // Only for -xs, -sm breakpoints.
            })
            .then(function(answer) {
              vm.status = 'You said the information was "' + answer + '".';
            }, function() {
              vm.status = 'You cancelled the dialog.';
            });
        }



        //***************************************************************
        function gotoBudgets()
        {
            $state.go('app.menu_presupuestos');
        }



/*
        //***************************************************************
        function gotoProductDetail(id)
        {
            $state.go('app.menu_presupuestos_budget', {id: id});
        }
*/



/*
        //***************************************************************
        function add100Presupuestos() {

            var fbUrl = firebaseDataService.presupuestos;
            var presupuestos = $firebaseArray(fbUrl.limitToLast(1));

            for (var i=2;i<102;i++) {

                var json = {"ciudadCliente": "Ciudad "+i,
                            "cliente": "Cliente "+i,
                            "codigo": "PRESU-00"+i,
                            "codigoPostalCliente": "08010",
                            "direccionCliente": "Dirección " + i,
                            "emailCliente": "cliente"+i + "@dominio.com",
                            "envioTiendaValorString": "false",
                            "estado": "Pendiente",
                            "fechaTimestamp": new Date().getTime() + (i*86400000),
                            "numeroPD": "PC171213",
                            "numeroPC": "?",
                            "observacionesCliente": "Observación " + i,
                            "provinciaCliente": "Barcelona",
                            "telefonoCliente": "600 11 22 33",
                            "telefonoTienda": "900 11 22 33",
                            "tipo": "¿?",
                            "unidades": 0,
                            "importe": 0,                            
                            "usuario": "Administración central",
                            "usuario_key": "-L-zqZMzj2ApqVql-nn9",
                            "vendedor": "Vendedor " + i
                            };


                presupuestos.$add(json)
                    .then(function(ref) {

                        utilsService.writeConsole("[BudgetController] - addPresupuesto(pPresupuesto) => Added new record to 'presupuestos'", WRITE_IN_CONSOLE);

                        //INSERTAMOS EL REGISTRO EN LA TABLA "usuario_presupuestos"
                        var fbUrl = firebaseDataService.usuario_presupuestos;
                        var usuarioPresupuestos = $firebaseArray(fbUrl.limitToLast(1));

                        var json2 = {"usuario_presupuesto_key": "-L-zqZMzj2ApqVql-nn9&" + ref.key,
                                     "usuario_key": "-L-zqZMzj2ApqVql-nn9",
                                     "presupuesto_key": ref.key,
                                     "codigoPresupuesto": "PRESU-00"+i,
                                     "fechaTimestamp": new Date().getTime() + (i*86400000),
                                     "cliente": "Cliente "+i,
                                     "tipo": "¿?",
                                     "unidades": 0,
                                     "importe": 0,
                                     "usuario": "Administración central",
                                     "numeroPD": "PC171213",
                                     "numeroPC": "?",
                                     "estado": "Pendiente"
                                    };

                        usuarioPresupuestos.$add(json2)
                            .then(function(ref) {

                                utilsService.writeConsole("[BudgetController] - addPresupuesto(pPresupuesto) => Added new record to 'usuario_presupuestos'", WRITE_IN_CONSOLE);

                            })
                            .catch(function(error) {
                                utilsService.writeConsole("[BudgetController] - addPresupuesto(pPresupuesto) => ERROR: " + error, WRITE_IN_CONSOLE); 
                            }
                        );

                    })
                    .catch(function(error) {
                        utilsService.writeConsole("[BudgetController] - addPresupuesto(pPresupuesto) => ERROR: " + error, WRITE_IN_CONSOLE); 
                    }
                );
            }                    
        }
*/



    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.simple-table', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider.state('app.components_tables_simple-table', {
            url  : '/components/table/simple-table',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/tables/simple-table/simple-table.html',
                    controller : 'SimpleTableController as vm'
                }
            },
            resolve: {
                Employees: function (msApi)
                {
                    return msApi.resolve('tables.employees@get');
                }
            }
        });

        // Api
        msApiProvider.register('tables.employees', ['app/data/tables/employees.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.simple-table')
        .controller('SimpleTableController', SimpleTableController);

    /** @ngInject */
    function SimpleTableController(Employees)
    {
        var vm = this;

        // Data
        vm.employees = Employees.data;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.datatable',
            [
                // 3rd Party Dependencies
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider.state('app.components_tables_datatable', {
            url    : '/components/table/datatable',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/components/tables/datatable/datatable.html',
                    controller : 'DatatableController as vm'
                }
            },
            resolve: {
                Employees: function (msApi)
                {
                    return msApi.resolve('tables.employees100@get');
                }
            }
        });

        // Api
        msApiProvider.register('tables.employees100', ['app/data/tables/employees100.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.datatable')
        .controller('DatatableController', DatatableController);

    /** @ngInject */
    function DatatableController(Employees)
    {
        var vm = this;

        // Data
        vm.employees = Employees.data;

        vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };

        // Methods

        //////////
    }

})();
(function () {
    'use strict';

    /**
     * Replace those for demo assets
     * img/                     >>>            assets/angular-material-assets/img/
     * 'icons                   >>>            'assets/angular-material-assets/icons/
     */
    angular
        .module('app.components.material-docs', ['ngMaterial', 'ngMessages'])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider, $stateProvider, ELEMENTS_NAVIGATION, LAYOUT_NAVIGATION, THEMING_NAVIGATION) {
        msNavigationServiceProvider.saveItem('components.elements', {
            title : 'Angular Material Elements',
            icon  : 'icon-layers',
            weight: 0
        });

        msNavigationServiceProvider.saveItem('components.elements.inputs', {
            title : 'Inputs',
            weight: 0
        });

        msNavigationServiceProvider.saveItem('components.elements.buttons', {
            title : 'Buttons',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('components.elements.content-elements', {
            title : 'Content Elements',
            weight: 2
        });

        msNavigationServiceProvider.saveItem('components.elements.lists', {
            title : 'Lists',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('components.elements.menus', {
            title : 'Menus',
            weight: 4
        });

        msNavigationServiceProvider.saveItem('components.elements.progress', {
            title : 'Progress',
            weight: 5
        });

        msNavigationServiceProvider.saveItem('components.elements.others', {
            title : 'Others',
            weight: 6
        });

        msNavigationServiceProvider.saveItem('components.material_layout', {
            title : 'Angular Material Layout',
            icon  : 'icon-view-quilt',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('components.material_theming', {
            title : 'Angular Material Theming',
            icon  : 'icon-palette-advanced',
            weight: 1
        });


        angular.forEach(ELEMENTS_NAVIGATION, function (component) {

            $stateProvider.state('app.docs_' + component.stateName, {
                url  : '/components/angular-material/elements/' + component.url,
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/material-docs/material-doc-template.html',
                        controller : 'DocTemplateController as vm'
                    }
                },
                data : component
            });

            // Navigation
            msNavigationServiceProvider.saveItem(component.navPath + '.' + component.url, {
                title : component.name,
                state : 'app.docs_' + component.stateName,
                weight: component.weight
            });
        });

        angular.forEach(LAYOUT_NAVIGATION, function (component) {

            $stateProvider.state('app.docs_' + component.stateName, {
                url  : '/components/angular-material/' + component.url,
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/material-docs/material-doc-basic-template.html',
                        controller : 'BasicDocTemplateController as vm',
                    },
                },
                 data : {
                    component: component,
                    parentTitle    : 'ANGULAR MATERIAL LAYOUT'
                }
            });

            // Navigation
            msNavigationServiceProvider.saveItem('components.material_layout.' + component.url, {
                title : component.name,
                state : 'app.docs_' + component.stateName,
                weight: component.weight
            });
        });

        angular.forEach(THEMING_NAVIGATION, function (component) {

            $stateProvider.state('app.docs_' + component.stateName, {
                url  : '/components/angular-material/' + component.url,
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/material-docs/material-doc-basic-template.html',
                        controller : 'BasicDocTemplateController as vm',
                    },
                },
                data : {
                    component: component,
                    parentTitle    : 'ANGULAR MATERIAL THEMING'
                }
            });

            // Navigation
            msNavigationServiceProvider.saveItem('components.material_theming.' + component.url, {
                title : component.name,
                state : 'app.docs_' + component.stateName,
                weight: component.weight
            });
        });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components.material-docs')
        .controller('LayoutCtrl', LayoutCtrl)
        .controller('LayoutTipsCtrl', LayoutTipsCtrl);

    /** @ngInject */
    function LayoutCtrl($scope, $attrs, $location, $rootScope)
    {
        $rootScope.currentComponent = $rootScope.currentDoc = null;

        $scope.exampleNotEditable = true;
        $scope.layoutDemo = {
            mainAxis : 'center',
            crossAxis: 'center',
            direction: 'row'
        };
        $scope.layoutAlign = function ()
        {
            return $scope.layoutDemo.mainAxis +
                   ($scope.layoutDemo.crossAxis ? ' ' + $scope.layoutDemo.crossAxis : '');
        };
    }

    /** @ngInject */
    function LayoutTipsCtrl()
    {
        var self = this;

        /*
         * Flex Sizing - Odd
         */
        self.toggleButtonText = 'Hide';

        self.toggleContentSize = function ()
        {
            var contentEl = angular.element(document.getElementById('toHide'));

            contentEl.toggleClass('ng-hide');

            self.toggleButtonText = contentEl.hasClass('ng-hide') ? 'Show' : 'Hide';
        };
    }

})();
(function ()
{
    'use strict';
    angular
        .module('app.components.material-docs')
        .factory('$demoAngularScripts', DemoAngularScripts);

    function DemoAngularScripts()
    {
        var scripts = [
            'angular.js',
            'angular-animate.min.js',
            'angular-route.min.js',
            'angular-aria.min.js',
            'angular-messages.min.js'
        ];

        return {
            all: allAngularScripts
        };

        function allAngularScripts()
        {
            return scripts.map(fullPathToScript);
        }

        function fullPathToScript(script)
        {
            return "https://ajax.googleapis.com/ajax/libs/angularjs/1.4.8/" + script;
            //return "https://ajax.googleapis.com/ajax/libs/angularjs/" + BUILDCONFIG.ngVersion + "/" + script;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.components.material-docs')
        .directive('demoInclude', demoInclude)

    function demoInclude($q, $http, $compile, $templateCache, $timeout)
    {
        return {
            restrict: 'E',
            link    : postLink
        };

        function postLink(scope, element, attr)
        {
            var demoContainer;

            // Interpret the expression given as `demo-include files="something"`
            var files = scope.$eval(attr.files) || {};
            var ngModule = scope.$eval(attr.module) || '';

            $timeout(handleDemoIndexFile);

            /**
             * Fetch the index file, and if it contains its own ngModule
             * then bootstrap a new angular app with that ngModule. Otherwise, compile
             * the demo into the current ng-app.
             */
            function handleDemoIndexFile()
            {
                files.index.contentsPromise.then(function (contents)
                {
                    demoContainer = angular.element(
                        '<div class="demo-content ' + ngModule + '">'
                    );

                    var isStandalone = !!ngModule;
                    var demoScope;
                    var demoCompileService;
                    if ( isStandalone )
                    {
                        angular.bootstrap(demoContainer[0], [ngModule]);
                        demoScope = demoContainer.scope();
                        demoCompileService = demoContainer.injector().get('$compile');

                        scope.$on('$destroy', function ()
                        {
                            demoScope.$destroy();
                        });

                    }
                    else
                    {
                        demoScope = scope.$new();
                        demoCompileService = $compile;
                    }

                    // Once everything is loaded, put the demo into the DOM
                    $q.all([
                        handleDemoStyles(),
                        handleDemoTemplates()
                    ]).finally(function ()
                    {

                        demoScope.$evalAsync(function ()
                        {
                            element.append(demoContainer);
                            demoContainer.html(contents);
                            demoCompileService(demoContainer.contents())(demoScope);
                        });


                    });
                });

            }


            /**
             * Fetch the demo styles, and append them to the DOM.
             */
            function handleDemoStyles()
            {
                return $q.all(files.css.map(function (file)
                    {
                        return file.contentsPromise;
                    }))
                    .then(function (styles)
                    {
                        styles = styles.join('\n'); //join styles as one string

                        var styleElement = angular.element('<style>' + styles + '</style>');
                        document.body.appendChild(styleElement[0]);

                        scope.$on('$destroy', function ()
                        {
                            styleElement.remove();
                        });
                    });

            }

            /**
             * Fetch the templates for this demo, and put the templates into
             * the demo app's templateCache, with a url that allows the demo apps
             * to reference their templates local to the demo index file.
             *
             * For example, make it so the dialog demo can reference templateUrl
             * 'my-dialog.tmpl.html' instead of having to reference the url
             * 'generated/material.components.dialog/demo/demo1/my-dialog.tmpl.html'.
             */
            function handleDemoTemplates()
            {

                return $q.all(files.html.map(function (file)
                {

                    return file.contentsPromise.then(function (contents)
                    {
                        // Get the $templateCache instance that goes with the demo's specific ng-app.
                        var demoTemplateCache = demoContainer.injector().get('$templateCache');
                        demoTemplateCache.put(file.name, contents);

                        scope.$on('$destroy', function ()
                        {
                            demoTemplateCache.remove(file.name);
                        });

                    });

                }));

            }

        }

    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.components.material-docs')
        .directive('docsDemo', docsDemo)
        .directive('demoFile', demoFile)
        .filter('toHtml', toHtml)
        .directive('layoutAlign', function ()
        {
            return angular.noop;
        })
        .directive('layout', function ()
        {
            return angular.noop;
        });

    /** @ngInject */
    function docsDemo($mdUtil)
    {
        return {
            restrict        : 'E',
            scope           : true,
            templateUrl     : 'app/main/components/material-docs/demo/docs-demo.tmpl.html',
            transclude      : true,
            controller      :DocsDemoCtrl,
            controllerAs    : 'demoCtrl',
            bindToController: true
        };

        function DocsDemoCtrl($scope, $element, $attrs, $interpolate)
        {
            var self = this;

            self.interpolateCode = angular.isDefined($attrs.interpolateCode);
            self.demoId = $interpolate($attrs.demoId || '')($scope.$parent);
            self.demoTitle = $interpolate($attrs.demoTitle || '')($scope.$parent);
            self.demoModule = $interpolate($attrs.demoModule || '')($scope.$parent);
            self.files = {
                css : [],
                js  : [],
                html: []
            };

            self.addFile = function (name, contentsPromise)
            {
                var file = {
                    name           : convertName(name),
                    contentsPromise: contentsPromise,
                    fileType       : name.split('.').pop()
                };
                contentsPromise.then(function (contents)
                {
                    file.contents = contents;
                });

                if ( name === 'index.html' )
                {
                    self.files.index = file;
                }
                else if ( name === 'readme.html' )
                {
                    self.demoDescription = file;
                }
                else
                {
                    self.files[file.fileType] = self.files[file.fileType] || [];
                    self.files[file.fileType].push(file);
                }

                self.orderedFiles = []
                    .concat(self.files.index || [])
                    .concat(self.files.js || [])
                    .concat(self.files.css || [])
                    .concat(self.files.html || []);

            };

            self.editOnCodepen = function ()
            {
                codepen.editOnCodepen({
                    title : self.demoTitle,
                    files : self.files,
                    id    : self.demoId,
                    module: self.demoModule
                });
            };

            function convertName(name)
            {
                switch ( name )
                {
                    case "index.html" :
                        return "HTML";
                    case "script.js" :
                        return "JS";
                    case "style.css" :
                        return "CSS";
                    default :
                        return name;
                }
            }

        }
    }

    /** @ngInject */
    function demoFile($q, $interpolate)
    {
        return {
            restrict: 'E',
            require : '^docsDemo',
            compile : compile
        };

        function compile(element, attr)
        {
            var contentsAttr = attr.contents;
            var html = element.html();
            var name = attr.name;
            element.contents().remove();

            return function postLink(scope, element, attr, docsDemoCtrl)
            {
                docsDemoCtrl.addFile(
                    $interpolate(name)(scope),
                    $q.when(scope.$eval(contentsAttr) || html)
                );
                element.remove();
            };
        }
    }

    /** @ngInject */
    function toHtml($sce)
    {
        return function (str)
        {
            return $sce.trustAsHtml(str);
        };
    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.components.material-docs')
        .factory('$demoAngularScripts', DemoAngularScripts);

    function DemoAngularScripts()
    {
        var scripts = [
            'angular.js',
            'angular-animate.min.js',
            'angular-route.min.js',
            'angular-aria.min.js',
            'angular-messages.min.js'
        ];

        return {
            all: allAngularScripts
        };

        function allAngularScripts()
        {
            return scripts.map(fullPathToScript);
        }

        function fullPathToScript(script)
        {
            return "https://ajax.googleapis.com/ajax/libs/angularjs/" + angular.version.full + "/" + script;
        }
    }
})();

angular.module('app.components.material-docs')
    .constant('THEMING_NAVIGATION', [
        {
            name       : "Introduction and Terms",
            stateName  : 'material_components_theming_introduction',
            id         : 'introduction',
            templateUrl: "partials/Theming/01_introduction.html",
            url        : "Theming/01_introduction",
            weight     : 1
        },
        {
            name       : "Declarative Syntax",
            stateName  : 'material_components_theming_declarative',
            id         : 'declarative',
            templateUrl: "partials/Theming/02_declarative_syntax.html",
            url        : "Theming/02_declarative_syntax",
            weight     : 2
        },
        {
            name       : "Configuring a Theme",
            stateName  : 'material_components_theming_configuring',
            id         : 'configuring',
            templateUrl: "partials/Theming/03_configuring_a_theme.html",
            url        : "Theming/03_configuring_a_theme",
            weight     : 3
        },
        {
            name       : "Multiple Themes",
            stateName  : 'material_components_theming_multiple',
            id         : 'multiple',
            templateUrl: "partials/Theming/04_multiple_themes.html",
            url        : "Theming/04_multiple_themes",
            weight     : 4
        },
        {
            name       : "Theming under the hood",
            stateName  : 'material_components_theming_under_the_hood',
            id         : 'under_the_hood',
            templateUrl: "partials/Theming/05_under_the_hood.html",
            url        : "Theming/05_under_the_hood",
            weight     : 5
        },
        {
            name       : "Browser Colors",
            stateName  : 'material_components_theming_browser_color',
            id         : 'browser_color',
            templateUrl: "partials/Theming/06_browser_color.html",
            url        : "Theming/06_browser_color",
            weight     : 6
        }
    ]);
angular.module('app.components.material-docs')
    .constant('LAYOUT_NAVIGATION', [
        {
            name       : 'Introduction',
            stateName  : 'material_components_layout_introduction',
            id         : 'layoutIntro',
            url        : 'layout/introduction',
            templateUrl: 'layout/layout-introduction.tmpl.html',
            weight     : 1
        },
        {
            name       : 'Layout Containers',
            stateName  : 'material_components_layout_containers',
            id         : 'layoutContainers',
            url        : 'layout/container',
            templateUrl: 'layout/layout-container.tmpl.html',
            weight     : 2
        },
        {
            name       : 'Layout Children',
            stateName  : 'material_components_layout_grid',
            id         : 'layoutGrid',
            url        : 'layout/children',
            templateUrl: 'layout/layout-children.tmpl.html',
            weight     : 3
        },
        {
            name       : 'Child Alignment',
            stateName  : 'material_components_layout_align',
            id         : 'layoutAlign',
            url        : 'layout/alignment',
            templateUrl: 'layout/layout-alignment.tmpl.html',
            weight     : 4
        },
        {
            name       : 'Extra Options',
            stateName  : 'material_components_layout_options',
            id         : 'layoutOptions',
            url        : 'layout/options',
            templateUrl: 'layout/layout-options.tmpl.html',
            weight     : 5
        },
        {
            name       : 'Troubleshooting',
            stateName  : 'material_components_layout_tips',
            id         : 'layoutTips',
            url        : 'layout/tips',
            templateUrl: 'layout/layout-tips.tmpl.html',
            weight     : 6
        }
    ]);
(function ()
{
    'use strict';

    angular
        .module('app.components.material-docs')
        .constant('ELEMENTS_NAVIGATION', [
            /* INPUTS */
            {
                name      : 'Autocomplete',
                url       : 'autocomplete',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.autocomplete',
                stateName : 'material_components_autocomplete',
                weight    : 1
            },
            {
                name      : 'Checkbox',
                url       : 'checkbox',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.checkbox',
                stateName : 'material_components_checkbox',
                weight    : 2
            },
            {
                name      : 'Chips',
                url       : 'chips',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.chips',
                stateName : 'material_components_chips',
                weight    : 3
            },
            {
                name      : 'Date Picker',
                url       : 'date-picker',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.datepicker',
                stateName : 'material_components_datepicker',
                weight    : 4
            },
            {
                name      : 'Input',
                url       : 'input',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.input',
                stateName : 'material_components_input',
                weight    : 5
            },
            {
                name      : 'Radio Button',
                url       : 'radio-button',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.radioButton',
                stateName : 'material_components_radioButton',
                weight    : 6
            },
            {
                name      : 'Select',
                url       : 'select',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.select',
                stateName : 'material_components_select',
                weight    : 7
            },
            {
                name      : 'Slider',
                url       : 'slider',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.slider',
                stateName : 'material_components_slider',
                weight    : 8
            },
            {
                name      : 'Switch',
                url       : 'switch',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.switch',
                stateName : 'material_components_switch',
                weight    : 9
            },
            /* BUTTONS */
            {
                name      : 'Button',
                url       : 'button',
                navPath   : 'components.elements.buttons',
                moduleName: 'material.components.button',
                stateName : 'material_components_button',
                weight    : 1
            },
            {
                name      : 'Fab Actions',
                url       : 'fab-actions',
                navPath   : 'components.elements.buttons',
                moduleName: 'material.components.fabActions',
                stateName : 'material_components_fabActions',
                weight    : 2
            },
            {
                name      : 'Fab Speed Dial',
                url       : 'fab-speed-dial',
                navPath   : 'components.elements.buttons',
                moduleName: 'material.components.fabSpeedDial',
                stateName : 'material_components_fabSpeedDial',
                weight    : 3
            },
            {
                name      : 'Fab Toolbar',
                url       : 'fab-toolbar',
                navPath   : 'components.elements.buttons',
                moduleName: 'material.components.fabToolbar',
                stateName : 'material_components_fabToolbar',
                weight    : 4
            },
            /* CONTENT ELEMENTS */
            {
                name      : 'Bottom Sheet',
                url       : 'bottom-sheet',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.bottomSheet',
                stateName : 'material_components_bottomSheet',
                weight    : 1
            },
            {
                name      : 'Card',
                url       : 'card',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.card',
                stateName : 'material_components_card',
                weight    : 2
            },
            {
                name      : 'Content',
                url       : 'content',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.content',
                stateName : 'material_components_content',
                weight    : 3
            },
            {
                name      : 'Dialog',
                url       : 'dialog',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.dialog',
                stateName : 'material_components_dialog',
                weight    : 4
            },
            {
                name       : 'Icon',
                url        : 'icon',
                navPath    : 'components.elements.content-elements',
                moduleName : 'material.components.icon',
                stateName  : 'material_components_icon',
                excludeDemo: true,
                weight     : 5
            },
            {
                name      : 'Navbar',
                url       : 'navbar',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.navBar',
                stateName : 'material_components_navBar',
                weight    : 6
            },
            {
                name      : 'Panel',
                url       : 'panel',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.panel',
                stateName : 'material_components_panel',
                weight    : 7
            },
            {
                name      : 'Sidenav',
                url       : 'sidenav',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.sidenav',
                stateName : 'material_components_sidenav',
                weight    : 8
            },
            {
                name      : 'Subheader',
                url       : 'subheader',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.subheader',
                stateName : 'material_components_subheader',
                weight    : 9
            },
            {
                name      : 'Tabs',
                url       : 'tabs',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.tabs',
                stateName : 'material_components_tabs',
                weight    : 10
            },
            {
                name      : 'Toast',
                url       : 'toast',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.toast',
                stateName : 'material_components_toast',
                weight    : 11
            },
            {
                name      : 'Toolbar',
                url       : 'toolbar',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.toolbar',
                stateName : 'material_components_toolbar',
                weight    : 12
            },
            {
                name      : 'Tooltip',
                url       : 'tooltip',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.tooltip',
                stateName : 'material_components_tooltip',
                weight    : 13
            },
            {
                name      : 'Whiteframe',
                url       : 'whiteframe',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.whiteframe',
                stateName : 'material_components_whiteframe',
                weight    : 14
            },
            /* LISTS */
            {
                name      : 'Grid List',
                url       : 'grid-list',
                navPath   : 'components.elements.lists',
                moduleName: 'material.components.gridList',
                stateName : 'material_components_gridList',
                weight    : 1
            },
            {
                name      : 'List',
                url       : 'list',
                navPath   : 'components.elements.lists',
                moduleName: 'material.components.list',
                stateName : 'material_components_list',
                weight    : 2
            },
            /* MENUS */
            {
                name      : 'Menu',
                url       : 'menu',
                navPath   : 'components.elements.menus',
                moduleName: 'material.components.menu',
                stateName : 'material_components_menu',
                weight    : 1
            },
            {
                name      : 'Menu Bar',
                url       : 'menu-bar',
                navPath   : 'components.elements.menus',
                moduleName: 'material.components.menuBar',
                stateName : 'material_components_menu-bar',
                weight    : 2
            },
            /* PROGRESS */
            {
                name      : 'Progress Circular',
                url       : 'progress-circular',
                navPath   : 'components.elements.progress',
                moduleName: 'material.components.progressCircular',
                stateName : 'material_components_progressCircular',
                weight    : 1
            },
            {
                name      : 'Progress Linear',
                url       : 'progress-linear',
                navPath   : 'components.elements.progress',
                moduleName: 'material.components.progressLinear',
                stateName : 'material_components_progressLinear',
                weight    : 2
            },
            /* OTHERS */
            {
                name      : 'Colors',
                url       : 'colors',
                navPath   : 'components.elements.others',
                moduleName: 'material.components.colors',
                stateName : 'material_components_colors',
                weight    : 1
            },
            {
                name      : 'Divider',
                url       : 'divider',
                navPath   : 'components.elements.others',
                moduleName: 'material.components.divider',
                stateName : 'material_components_divider',
                weight    : 2
            },
            {
                name      : 'Ripple',
                url       : 'ripple',
                navPath   : 'components.elements.others',
                moduleName: 'material.core.ripple',
                stateName : 'material_core_ripple',
                weight    : 3
            },
            {
                name      : 'Sticky',
                url       : 'sticky',
                navPath   : 'components.elements.others',
                moduleName: 'material.components.sticky',
                stateName : 'material_components_sticky',
                weight    : 4
            },
            {
                name      : 'Swipe',
                url       : 'swipe',
                navPath   : 'components.elements.others',
                moduleName: 'material.components.swipe',
                stateName : 'material_components_swipe',
                weight    : 5
            },
            {
                name      : 'Util',
                url       : 'util',
                navPath   : 'components.elements.others',
                moduleName: 'material.core.util',
                stateName : 'material_core_util',
                weight    : 6
            },
            {
                name      : 'Virtual Repeat',
                url       : 'virtual-repeat',
                navPath   : 'components.elements.others',
                moduleName: 'material.components.virtualRepeat',
                stateName : 'material_components_virtualRepeat',
                weight    : 7
            },
            {
                name      : 'Aria',
                url       : 'aria',
                navPath   : 'components.elements.others',
                moduleName: 'material.core.aria',
                stateName : 'material_components_aria',
                weight    : 8
            }
        ]);
})();
angular.module('app.components.material-docs')
  .constant('DEMOS', [
    {
      'name'      : 'autocomplete',
      'moduleName': 'material.components.autocomplete',
      'label'     : 'Autocomplete',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'autocompleteDemo',
            'module'      : 'autocompleteDemo',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'autocompletedemoBasicUsage',
          'css'       : [],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/autocomplete/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.autocomplete',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/autocomplete/demoBasicUsage/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'autocompleteCustomTemplateDemo',
            'module'      : 'autocompleteCustomTemplateDemo',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'autocompletedemoCustomTemplate',
          'css'       : [
            {
              'name'      : 'style.global.css',
              'label'     : 'style.global.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/autocomplete/demoCustomTemplate/style.global.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/autocomplete/demoCustomTemplate/script.js'
            }
          ],
          'moduleName': 'material.components.autocomplete',
          'name'      : 'demoCustomTemplate',
          'label'     : 'Custom Template',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/autocomplete/demoCustomTemplate/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'autocompleteFloatingLabelDemo',
            'module'      : 'autocompleteFloatingLabelDemo',
            'dependencies': [
              'ngMaterial',
              'ngMessages'
            ]
          },
          'id'        : 'autocompletedemoFloatingLabel',
          'css'       : [],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/autocomplete/demoFloatingLabel/script.js'
            }
          ],
          'moduleName': 'material.components.autocomplete',
          'name'      : 'demoFloatingLabel',
          'label'     : 'Floating Label',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/autocomplete/demoFloatingLabel/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'autocompleteDemoInsideDialog',
            'module'      : 'autocompleteDemoInsideDialog',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'autocompletedemoInsideDialog',
          'css'       : [],
          'html'      : [
            {
              'name'      : 'dialog.tmpl.html',
              'label'     : 'dialog.tmpl.html',
              'fileType'  : 'html',
              'outputPath': 'demo-partials/autocomplete/demoInsideDialog/dialog.tmpl.html'
            }
          ],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/autocomplete/demoInsideDialog/script.js'
            }
          ],
          'moduleName': 'material.components.autocomplete',
          'name'      : 'demoInsideDialog',
          'label'     : 'Inside Dialog',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/autocomplete/demoInsideDialog/index.html'
          }
        }
      ],
      'url'       : 'demo/autocomplete'
    },
    {
      'name'      : 'bottomSheet',
      'moduleName': 'material.components.bottomSheet',
      'label'     : 'Bottom Sheet',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'bottomSheetDemo1',
            'module'      : 'bottomSheetDemo1',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'bottomSheetdemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/bottomSheet/demoBasicUsage/style.css'
            }
          ],
          'html'      : [
            {
              'name'      : 'bottom-sheet-grid-template.html',
              'label'     : 'bottom-sheet-grid-template.html',
              'fileType'  : 'html',
              'outputPath': 'demo-partials/bottomSheet/demoBasicUsage/bottom-sheet-grid-template.html'
            },
            {
              'name'      : 'bottom-sheet-list-template.html',
              'label'     : 'bottom-sheet-list-template.html',
              'fileType'  : 'html',
              'outputPath': 'demo-partials/bottomSheet/demoBasicUsage/bottom-sheet-list-template.html'
            },
            {
              'name'      : 'readme.html',
              'label'     : 'readme.html',
              'fileType'  : 'html',
              'outputPath': 'demo-partials/bottomSheet/demoBasicUsage/readme.html'
            }
          ],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/bottomSheet/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.bottomSheet',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/bottomSheet/demoBasicUsage/index.html'
          }
        }
      ],
      'url'       : 'demo/bottomSheet'
    },
    {
      'name'      : 'button',
      'moduleName': 'material.components.button',
      'label'     : 'Button',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'buttonsDemo1',
            'module'      : 'buttonsDemo1',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'buttondemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/button/demoBasicUsage/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/button/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.button',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/button/demoBasicUsage/index.html'
          }
        }
      ],
      'url'       : 'demo/button'
    },
    {
      'name'      : 'card',
      'moduleName': 'material.components.card',
      'label'     : 'Card',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'cardDemo1',
            'module'      : 'cardDemo1',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'carddemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/card/demoBasicUsage/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/card/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.card',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/card/demoBasicUsage/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'cardDemo2',
            'module'      : 'cardDemo2',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'carddemoCardActionButtons',
          'css'       : [],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/card/demoCardActionButtons/script.js'
            }
          ],
          'moduleName': 'material.components.card',
          'name'      : 'demoCardActionButtons',
          'label'     : 'Card Action Buttons',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/card/demoCardActionButtons/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'cardDemo3',
            'module'      : 'cardDemo3',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'carddemoInCardActions',
          'css'       : [],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/card/demoInCardActions/script.js'
            }
          ],
          'moduleName': 'material.components.card',
          'name'      : 'demoInCardActions',
          'label'     : 'In Card Actions',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/card/demoInCardActions/index.html'
          }
        }
      ],
      'url'       : 'demo/card'
    },
    {
      'name'      : 'checkbox',
      'moduleName': 'material.components.checkbox',
      'label'     : 'Checkbox',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'checkboxDemo1',
            'module'      : 'checkboxDemo1',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'checkboxdemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/checkbox/demoBasicUsage/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/checkbox/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.checkbox',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/checkbox/demoBasicUsage/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'checkboxDemo3',
            'module'      : 'checkboxDemo3',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'checkboxdemoSelectAll',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/checkbox/demoSelectAll/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/checkbox/demoSelectAll/script.js'
            }
          ],
          'moduleName': 'material.components.checkbox',
          'name'      : 'demoSelectAll',
          'label'     : 'Select All',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/checkbox/demoSelectAll/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'checkboxDemo2',
            'module'      : 'checkboxDemo2',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'checkboxdemoSyncing',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/checkbox/demoSyncing/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/checkbox/demoSyncing/script.js'
            }
          ],
          'moduleName': 'material.components.checkbox',
          'name'      : 'demoSyncing',
          'label'     : 'Syncing',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/checkbox/demoSyncing/index.html'
          }
        }
      ],
      'url'       : 'demo/checkbox'
    },
    {
      'name'      : 'chips',
      'moduleName': 'material.components.chips',
      'label'     : 'Chips',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'chipsDemo',
            'module'      : 'chipsDemo',
            'dependencies': [
              'ngMaterial',
              'ngMessages'
            ]
          },
          'id'        : 'chipsdemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/chips/demoBasicUsage/style.css'
            }
          ],
          'html'      : [
            {
              'name'      : 'readme.html',
              'label'     : 'readme.html',
              'fileType'  : 'html',
              'outputPath': 'demo-partials/chips/demoBasicUsage/readme.html'
            }
          ],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/chips/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.chips',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/chips/demoBasicUsage/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'contactChipsDemo',
            'module'      : 'contactChipsDemo',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'chipsdemoContactChips',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/chips/demoContactChips/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/chips/demoContactChips/script.js'
            }
          ],
          'moduleName': 'material.components.chips',
          'name'      : 'demoContactChips',
          'label'     : 'Contact Chips',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/chips/demoContactChips/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'chipsCustomInputDemo',
            'module'      : 'chipsCustomInputDemo',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'chipsdemoCustomInputs',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/chips/demoCustomInputs/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/chips/demoCustomInputs/script.js'
            }
          ],
          'moduleName': 'material.components.chips',
          'name'      : 'demoCustomInputs',
          'label'     : 'Custom Inputs',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/chips/demoCustomInputs/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'chipsCustomSeparatorDemo',
            'module'      : 'chipsCustomSeparatorDemo',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'chipsdemoCustomSeparatorKeys',
          'css'       : [],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/chips/demoCustomSeparatorKeys/script.js'
            }
          ],
          'moduleName': 'material.components.chips',
          'name'      : 'demoCustomSeparatorKeys',
          'label'     : 'Custom Separator Keys',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/chips/demoCustomSeparatorKeys/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'staticChipsDemo',
            'module'      : 'staticChipsDemo',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'chipsdemoStaticChips',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/chips/demoStaticChips/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/chips/demoStaticChips/script.js'
            }
          ],
          'moduleName': 'material.components.chips',
          'name'      : 'demoStaticChips',
          'label'     : 'Static Chips',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/chips/demoStaticChips/index.html'
          }
        }
      ],
      'url'       : 'demo/chips'
    },
    {
      'name'      : 'colors',
      'moduleName': 'material.components.colors',
      'label'     : 'Colors',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'colorsDemo',
            'module'      : 'colorsDemo',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'colorsdemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/colors/demoBasicUsage/style.css'
            }
          ],
          'html'      : [
            {
              'name'      : 'regularCard.tmpl.html',
              'label'     : 'regularCard.tmpl.html',
              'fileType'  : 'html',
              'outputPath': 'demo-partials/colors/demoBasicUsage/regularCard.tmpl.html'
            },
            {
              'name'      : 'userCard.tmpl.html',
              'label'     : 'userCard.tmpl.html',
              'fileType'  : 'html',
              'outputPath': 'demo-partials/colors/demoBasicUsage/userCard.tmpl.html'
            }
          ],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/colors/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.colors',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/colors/demoBasicUsage/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'colorsThemePickerDemo',
            'module'      : 'colorsThemePickerDemo',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'colorsdemoThemePicker',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/colors/demoThemePicker/style.css'
            }
          ],
          'html'      : [
            {
              'name'      : 'themePreview.tmpl.html',
              'label'     : 'themePreview.tmpl.html',
              'fileType'  : 'html',
              'outputPath': 'demo-partials/colors/demoThemePicker/themePreview.tmpl.html'
            }
          ],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/colors/demoThemePicker/script.js'
            }
          ],
          'moduleName': 'material.components.colors',
          'name'      : 'demoThemePicker',
          'label'     : 'Theme Picker',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/colors/demoThemePicker/index.html'
          }
        }
      ],
      'url'       : 'demo/colors'
    },
    {
      'name'      : 'content',
      'moduleName': 'material.components.content',
      'label'     : 'Content',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'contentDemo1',
            'module'      : 'contentDemo1',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'contentdemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/content/demoBasicUsage/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/content/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.content',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/content/demoBasicUsage/index.html'
          }
        }
      ],
      'url'       : 'demo/content'
    },
    {
      'name'      : 'datepicker',
      'moduleName': 'material.components.datepicker',
      'label'     : 'Datepicker',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'datepickerBasicUsage',
            'module'      : 'datepickerBasicUsage',
            'dependencies': [
              'ngMaterial',
              'ngMessages'
            ]
          },
          'id'        : 'datepickerdemoBasicUsage',
          'css'       : [],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/datepicker/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.datepicker',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/datepicker/demoBasicUsage/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'datepickerValidations',
            'module'      : 'datepickerValidations',
            'dependencies': [
              'ngMaterial',
              'ngMessages'
            ]
          },
          'id'        : 'datepickerdemoValidations',
          'css'       : [],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/datepicker/demoValidations/script.js'
            }
          ],
          'moduleName': 'material.components.datepicker',
          'name'      : 'demoValidations',
          'label'     : 'Validations',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/datepicker/demoValidations/index.html'
          }
        }
      ],
      'url'       : 'demo/datepicker'
    },
    {
      'name'      : 'dialog',
      'moduleName': 'material.components.dialog',
      'label'     : 'Dialog',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'dialogDemo1',
            'module'      : 'dialogDemo1',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'dialogdemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/dialog/demoBasicUsage/style.css'
            }
          ],
          'html'      : [
            {
              'name'      : 'dialog1.tmpl.html',
              'label'     : 'dialog1.tmpl.html',
              'fileType'  : 'html',
              'outputPath': 'demo-partials/dialog/demoBasicUsage/dialog1.tmpl.html'
            },
            {
              'name'      : 'tabDialog.tmpl.html',
              'label'     : 'tabDialog.tmpl.html',
              'fileType'  : 'html',
              'outputPath': 'demo-partials/dialog/demoBasicUsage/tabDialog.tmpl.html'
            }
          ],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/dialog/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.dialog',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/dialog/demoBasicUsage/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'dialogDemo2',
            'module'      : 'dialogDemo2',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'dialogdemoOpenFromCloseTo',
          'css'       : [],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/dialog/demoOpenFromCloseTo/script.js'
            }
          ],
          'moduleName': 'material.components.dialog',
          'name'      : 'demoOpenFromCloseTo',
          'label'     : 'Open From Close To',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/dialog/demoOpenFromCloseTo/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'dialogDemo3',
            'module'      : 'dialogDemo3',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'dialogdemoThemeInheritance',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/dialog/demoThemeInheritance/style.css'
            }
          ],
          'html'      : [
            {
              'name'      : 'dialog1.tmpl.html',
              'label'     : 'dialog1.tmpl.html',
              'fileType'  : 'html',
              'outputPath': 'demo-partials/dialog/demoThemeInheritance/dialog1.tmpl.html'
            }
          ],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/dialog/demoThemeInheritance/script.js'
            }
          ],
          'moduleName': 'material.components.dialog',
          'name'      : 'demoThemeInheritance',
          'label'     : 'Theme Inheritance',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/dialog/demoThemeInheritance/index.html'
          }
        }
      ],
      'url'       : 'demo/dialog'
    },
    {
      'name'      : 'divider',
      'moduleName': 'material.components.divider',
      'label'     : 'Divider',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'dividerDemo1',
            'module'      : 'dividerDemo1',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'dividerdemoBasicUsage',
          'css'       : [],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/divider/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.divider',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/divider/demoBasicUsage/index.html'
          }
        }
      ],
      'url'       : 'demo/divider'
    },
    {
      'name'      : 'fabSpeedDial',
      'moduleName': 'material.components.fabSpeedDial',
      'label'     : 'FAB Speed Dial',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'fabSpeedDialDemoBasicUsage',
            'module'      : 'fabSpeedDialDemoBasicUsage',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'fabSpeedDialdemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/fabSpeedDial/demoBasicUsage/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/fabSpeedDial/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.fabSpeedDial',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/fabSpeedDial/demoBasicUsage/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'fabSpeedDialDemoMoreOptions',
            'module'      : 'fabSpeedDialDemoMoreOptions',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'fabSpeedDialdemoMoreOptions',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/fabSpeedDial/demoMoreOptions/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/fabSpeedDial/demoMoreOptions/script.js'
            }
          ],
          'moduleName': 'material.components.fabSpeedDial',
          'name'      : 'demoMoreOptions',
          'label'     : 'More Options',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/fabSpeedDial/demoMoreOptions/index.html'
          }
        }
      ],
      'url'       : 'demo/fabSpeedDial'
    },
    {
      'name'      : 'fabToolbar',
      'moduleName': 'material.components.fabToolbar',
      'label'     : 'FAB Toolbar',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'fabToolbarBasicUsageDemo',
            'module'      : 'fabToolbarBasicUsageDemo',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'fabToolbardemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/fabToolbar/demoBasicUsage/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/fabToolbar/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.fabToolbar',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/fabToolbar/demoBasicUsage/index.html'
          }
        }
      ],
      'url'       : 'demo/fabToolbar'
    },
    {
      'name'      : 'gridList',
      'moduleName': 'material.components.gridList',
      'label'     : 'Grid List',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'gridListDemo1',
            'module'      : 'gridListDemo1',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'gridListdemoBasicUsage',
          'css'       : [
            {
              'name'      : 'styles.css',
              'label'     : 'styles.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/gridList/demoBasicUsage/styles.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/gridList/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.gridList',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/gridList/demoBasicUsage/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'gridListDemoApp',
            'module'      : 'gridListDemoApp',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'gridListdemoDynamicTiles',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/gridList/demoDynamicTiles/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/gridList/demoDynamicTiles/script.js'
            }
          ],
          'moduleName': 'material.components.gridList',
          'name'      : 'demoDynamicTiles',
          'label'     : 'Dynamic Tiles',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/gridList/demoDynamicTiles/index.html'
          }
        },
        {
          'ngModule'  : {
                        'name'        : 'gridListdemoResponsiveUsage',
                        'module'      : 'gridListdemoResponsiveUsage',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'gridListdemoResponsiveUsage',
          'css'       : [],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/gridList/demoResponsiveUsage/script.js'
            }
          ],
          'moduleName': 'material.components.gridList',
          'name'      : 'demoResponsiveUsage',
          'label'     : 'Responsive Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/gridList/demoResponsiveUsage/index.html'
          }
        }
      ],
      'url'       : 'demo/gridList'
    },
    {
      'name'      : 'icon',
      'moduleName': 'material.components.icon',
      'label'     : 'Icon',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'appDemoFontIconsWithClassnames',
            'module'      : 'appDemoFontIconsWithClassnames',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'icondemoFontIconsWithClassnames',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/icon/demoFontIconsWithClassnames/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/icon/demoFontIconsWithClassnames/script.js'
            }
          ],
          'moduleName': 'material.components.icon',
          'name'      : 'demoFontIconsWithClassnames',
          'label'     : 'Font Icons With Classnames',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/icon/demoFontIconsWithClassnames/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'appDemoFontIconsWithLigatures',
            'module'      : 'appDemoFontIconsWithLigatures',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'icondemoFontIconsWithLigatures',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/icon/demoFontIconsWithLigatures/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/icon/demoFontIconsWithLigatures/script.js'
            }
          ],
          'moduleName': 'material.components.icon',
          'name'      : 'demoFontIconsWithLigatures',
          'label'     : 'Font Icons With Ligatures',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/icon/demoFontIconsWithLigatures/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'appDemoSvgIcons',
            'module'      : 'appDemoSvgIcons',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'icondemoLoadSvgIconsFromUrl',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/icon/demoLoadSvgIconsFromUrl/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/icon/demoLoadSvgIconsFromUrl/script.js'
            }
          ],
          'moduleName': 'material.components.icon',
          'name'      : 'demoLoadSvgIconsFromUrl',
          'label'     : 'Load Svg Icons From Url',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/icon/demoLoadSvgIconsFromUrl/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'appSvgIconSets',
            'module'      : 'appSvgIconSets',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'icondemoSvgIconSets',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/icon/demoSvgIconSets/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/icon/demoSvgIconSets/script.js'
            }
          ],
          'moduleName': 'material.components.icon',
          'name'      : 'demoSvgIconSets',
          'label'     : 'Svg Icon Sets',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/icon/demoSvgIconSets/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'appUsingTemplateCache',
            'module'      : 'appUsingTemplateCache',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'icondemoUsingTemplateRequest',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/icon/demoUsingTemplateRequest/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/icon/demoUsingTemplateRequest/script.js'
            }
          ],
          'moduleName': 'material.components.icon',
          'name'      : 'demoUsingTemplateRequest',
          'label'     : 'Using Template Request',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/icon/demoUsingTemplateRequest/index.html'
          }
        }
      ],
      'url'       : 'demo/icon'
    },
    {
      'name'      : 'input',
      'moduleName': 'material.components.input',
      'label'     : 'Input',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'inputBasicDemo',
            'module'      : 'inputBasicDemo',
            'dependencies': [
              'ngMaterial',
              'ngMessages'
            ]
          },
          'id'        : 'inputdemoBasicUsage',
          'css'       : [],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/input/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.input',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/input/demoBasicUsage/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'inputErrorsApp',
            'module'      : 'inputErrorsApp',
            'dependencies': [
              'ngMaterial',
              'ngMessages'
            ]
          },
          'id'        : 'inputdemoErrors',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/input/demoErrors/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/input/demoErrors/script.js'
            }
          ],
          'moduleName': 'material.components.input',
          'name'      : 'demoErrors',
          'label'     : 'Errors',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/input/demoErrors/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'inputErrorsAdvancedApp',
            'module'      : 'inputErrorsAdvancedApp',
            'dependencies': [
              'ngMaterial',
              'ngMessages'
            ]
          },
          'id'        : 'inputdemoErrorsAdvanced',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/input/demoErrorsAdvanced/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/input/demoErrorsAdvanced/script.js'
            }
          ],
          'moduleName': 'material.components.input',
          'name'      : 'demoErrorsAdvanced',
          'label'     : 'Errors Advanced',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/input/demoErrorsAdvanced/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'inputIconDemo',
            'module'      : 'inputIconDemo',
            'dependencies': [
              'ngMaterial',
              'ngMessages'
            ]
          },
          'id'        : 'inputdemoIcons',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/input/demoIcons/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/input/demoIcons/script.js'
            }
          ],
          'moduleName': 'material.components.input',
          'name'      : 'demoIcons',
          'label'     : 'Icons',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/input/demoIcons/index.html'
          }
        }
      ],
      'url'       : 'demo/input'
    },
    {
      'name'      : 'list',
      'moduleName': 'material.components.list',
      'label'     : 'List',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'listDemo1',
            'module'      : 'listDemo1',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'listdemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/list/demoBasicUsage/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/list/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.list',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/list/demoBasicUsage/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'listDemo2',
            'module'      : 'listDemo2',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'listdemoListControls',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/list/demoListControls/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/list/demoListControls/script.js'
            }
          ],
          'moduleName': 'material.components.list',
          'name'      : 'demoListControls',
          'label'     : 'List Controls',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/list/demoListControls/index.html'
          }
        }
      ],
      'url'       : 'demo/list'
    },
    {
      'name'      : 'menu',
      'moduleName': 'material.components.menu',
      'label'     : 'Menu',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'menuDemoBasic',
            'module'      : 'menuDemoBasic',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'menudemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/menu/demoBasicUsage/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/menu/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.menu',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/menu/demoBasicUsage/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'menuDemoCustomTrigger',
            'module'      : 'menuDemoCustomTrigger',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'menudemoCustomTrigger',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/menu/demoCustomTrigger/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/menu/demoCustomTrigger/script.js'
            }
          ],
          'moduleName': 'material.components.menu',
          'name'      : 'demoCustomTrigger',
          'label'     : 'Custom Trigger',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/menu/demoCustomTrigger/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'menuDemoPosition',
            'module'      : 'menuDemoPosition',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'menudemoMenuPositionModes',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/menu/demoMenuPositionModes/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/menu/demoMenuPositionModes/script.js'
            }
          ],
          'moduleName': 'material.components.menu',
          'name'      : 'demoMenuPositionModes',
          'label'     : 'Menu Position Modes',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/menu/demoMenuPositionModes/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'menuDemoWidth',
            'module'      : 'menuDemoWidth',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'menudemoMenuWidth',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/menu/demoMenuWidth/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/menu/demoMenuWidth/script.js'
            }
          ],
          'moduleName': 'material.components.menu',
          'name'      : 'demoMenuWidth',
          'label'     : 'Menu Width',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/menu/demoMenuWidth/index.html'
          }
        }
      ],
      'url'       : 'demo/menu'
    },
    {
      'name'      : 'menuBar',
      'moduleName': 'material.components.menuBar',
      'label'     : 'Menu Bar',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'menuBarDemoBasic',
            'module'      : 'menuBarDemoBasic',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'menuBardemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/menuBar/demoBasicUsage/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/menuBar/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.menuBar',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/menuBar/demoBasicUsage/index.html'
          }
        }
      ],
      'url'       : 'demo/menuBar'
    },
    {
      'name'      : 'navBar',
      'moduleName': 'material.components.navBar',
      'label'     : 'Nav Bar',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'navBarDemoBasicUsage',
            'module'      : 'navBarDemoBasicUsage',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'navBardemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/navBar/demoBasicUsage/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/navBar/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.navBar',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/navBar/demoBasicUsage/index.html'
          }
        }
      ],
      'url'       : 'demo/navBar'
    },
    {
      'name'      : 'panel',
      'moduleName': 'material.components.panel',
      'label'     : 'Panel',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'panelDemo',
            'module'      : 'panelDemo',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'paneldemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.global.css',
              'label'     : 'style.global.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/panel/demoBasicUsage/style.global.css'
            }
          ],
          'html'      : [
            {
              'name'      : 'panel.tmpl.html',
              'label'     : 'panel.tmpl.html',
              'fileType'  : 'html',
              'outputPath': 'demo-partials/panel/demoBasicUsage/panel.tmpl.html'
            }
          ],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/panel/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.panel',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/panel/demoBasicUsage/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'panelGroupsDemo',
            'module'      : 'panelGroupsDemo',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'paneldemoGroups',
          'css'       : [
            {
              'name'      : 'style.global.css',
              'label'     : 'style.global.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/panel/demoGroups/style.global.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/panel/demoGroups/script.js'
            }
          ],
          'moduleName': 'material.components.panel',
          'name'      : 'demoGroups',
          'label'     : 'Groups',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/panel/demoGroups/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'panelAnimationsDemo',
            'module'      : 'panelAnimationsDemo',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'paneldemoPanelAnimations',
          'css'       : [
            {
              'name'      : 'style.global.css',
              'label'     : 'style.global.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/panel/demoPanelAnimations/style.global.css'
            }
          ],
          'html'      : [
            {
              'name'      : 'panel.tmpl.html',
              'label'     : 'panel.tmpl.html',
              'fileType'  : 'html',
              'outputPath': 'demo-partials/panel/demoPanelAnimations/panel.tmpl.html'
            }
          ],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/panel/demoPanelAnimations/script.js'
            }
          ],
          'moduleName': 'material.components.panel',
          'name'      : 'demoPanelAnimations',
          'label'     : 'Panel Animations',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/panel/demoPanelAnimations/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'panelProviderDemo',
            'module'      : 'panelProviderDemo',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'paneldemoPanelProvider',
          'css'       : [
            {
              'name'      : 'style.global.css',
              'label'     : 'style.global.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/panel/demoPanelProvider/style.global.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/panel/demoPanelProvider/script.js'
            }
          ],
          'moduleName': 'material.components.panel',
          'name'      : 'demoPanelProvider',
          'label'     : 'Panel Provider',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/panel/demoPanelProvider/index.html'
          }
        }
      ],
      'url'       : 'demo/panel'
    },
    {
      'name'      : 'progressCircular',
      'moduleName': 'material.components.progressCircular',
      'label'     : 'Progress Circular',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'progressCircularDemo1',
            'module'      : 'progressCircularDemo1',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'progressCirculardemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/progressCircular/demoBasicUsage/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/progressCircular/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.progressCircular',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/progressCircular/demoBasicUsage/index.html'
          }
        }
      ],
      'url'       : 'demo/progressCircular'
    },
    {
      'name'      : 'progressLinear',
      'moduleName': 'material.components.progressLinear',
      'label'     : 'Progress Linear',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'progressLinearDemo1',
            'module'      : 'progressLinearDemo1',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'progressLineardemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/progressLinear/demoBasicUsage/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/progressLinear/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.progressLinear',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/progressLinear/demoBasicUsage/index.html'
          }
        }
      ],
      'url'       : 'demo/progressLinear'
    },
    {
      'name'      : 'radioButton',
      'moduleName': 'material.components.radioButton',
      'label'     : 'Radio Button',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'radioDemo1',
            'module'      : 'radioDemo1',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'radioButtondemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/radioButton/demoBasicUsage/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/radioButton/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.radioButton',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/radioButton/demoBasicUsage/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'radioDemo2',
            'module'      : 'radioDemo2',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'radioButtondemoMultiColumn',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/radioButton/demoMultiColumn/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/radioButton/demoMultiColumn/script.js'
            }
          ],
          'moduleName': 'material.components.radioButton',
          'name'      : 'demoMultiColumn',
          'label'     : 'Multi Column',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/radioButton/demoMultiColumn/index.html'
          }
        }
      ],
      'url'       : 'demo/radioButton'
    },
    {
      'name'      : 'select',
      'moduleName': 'material.components.select',
      'label'     : 'Select',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'selectDemoBasic',
            'module'      : 'selectDemoBasic',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'selectdemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/select/demoBasicUsage/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/select/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.select',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/select/demoBasicUsage/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'selectDemoOptGroups',
            'module'      : 'selectDemoOptGroups',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'selectdemoOptionGroups',
          'css'       : [],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/select/demoOptionGroups/script.js'
            }
          ],
          'moduleName': 'material.components.select',
          'name'      : 'demoOptionGroups',
          'label'     : 'Option Groups',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/select/demoOptionGroups/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'selectDemoOptionsAsync',
            'module'      : 'selectDemoOptionsAsync',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'selectdemoOptionsWithAsyncSearch',
          'css'       : [],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/select/demoOptionsWithAsyncSearch/script.js'
            }
          ],
          'moduleName': 'material.components.select',
          'name'      : 'demoOptionsWithAsyncSearch',
          'label'     : 'Options With Async Search',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/select/demoOptionsWithAsyncSearch/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'selectDemoSelectHeader',
            'module'      : 'selectDemoSelectHeader',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'selectdemoSelectHeader',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/select/demoSelectHeader/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/select/demoSelectHeader/script.js'
            }
          ],
          'moduleName': 'material.components.select',
          'name'      : 'demoSelectHeader',
          'label'     : 'Select Header',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/select/demoSelectHeader/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'selectDemoSelectedText',
            'module'      : 'selectDemoSelectedText',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'selectdemoSelectedText',
          'css'       : [],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/select/demoSelectedText/script.js'
            }
          ],
          'moduleName': 'material.components.select',
          'name'      : 'demoSelectedText',
          'label'     : 'Selected Text',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/select/demoSelectedText/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'selectDemoValidation',
            'module'      : 'selectDemoValidation',
            'dependencies': [
              'ngMaterial',
              'ngMessages'
            ]
          },
          'id'        : 'selectdemoValidations',
          'css'       : [],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/select/demoValidations/script.js'
            }
          ],
          'moduleName': 'material.components.select',
          'name'      : 'demoValidations',
          'label'     : 'Validations',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/select/demoValidations/index.html'
          }
        }
      ],
      'url'       : 'demo/select'
    },
    {
      'name'      : 'sidenav',
      'moduleName': 'material.components.sidenav',
      'label'     : 'Sidenav',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'sidenavDemo1',
            'module'      : 'sidenavDemo1',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'sidenavdemoBasicUsage',
          'css'       : [],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/sidenav/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.sidenav',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/sidenav/demoBasicUsage/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'sidenavDemo2',
            'module'      : 'sidenavDemo2',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'sidenavdemoCustomSidenav',
          'css'       : [],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/sidenav/demoCustomSidenav/script.js'
            }
          ],
          'moduleName': 'material.components.sidenav',
          'name'      : 'demoCustomSidenav',
          'label'     : 'Custom Sidenav',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/sidenav/demoCustomSidenav/index.html'
          }
        }
      ],
      'url'       : 'demo/sidenav'
    },
    {
      'name'      : 'slider',
      'moduleName': 'material.components.slider',
      'label'     : 'Slider',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'sliderDemo1',
            'module'      : 'sliderDemo1',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'sliderdemoBasicUsage',
          'css'       : [],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/slider/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.slider',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/slider/demoBasicUsage/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'sliderDemo2',
            'module'      : 'sliderDemo2',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'sliderdemoVertical',
          'css'       : [],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/slider/demoVertical/script.js'
            }
          ],
          'moduleName': 'material.components.slider',
          'name'      : 'demoVertical',
          'label'     : 'Vertical',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/slider/demoVertical/index.html'
          }
        }
      ],
      'url'       : 'demo/slider'
    },
    {
      'name'      : 'subheader',
      'moduleName': 'material.components.subheader',
      'label'     : 'Subheader',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'subheaderBasicDemo',
            'module'      : 'subheaderBasicDemo',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'subheaderdemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/subheader/demoBasicUsage/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/subheader/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.subheader',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/subheader/demoBasicUsage/index.html'
          }
        }
      ],
      'url'       : 'demo/subheader'
    },
    {
      'name'      : 'swipe',
      'moduleName': 'material.components.swipe',
      'label'     : 'Swipe',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'demoSwipe',
            'module'      : 'demoSwipe',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'swipedemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/swipe/demoBasicUsage/style.css'
            }
          ],
          'html'      : [
            {
              'name'      : 'readme.html',
              'label'     : 'readme.html',
              'fileType'  : 'html',
              'outputPath': 'demo-partials/swipe/demoBasicUsage/readme.html'
            }
          ],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/swipe/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.swipe',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/swipe/demoBasicUsage/index.html'
          }
        }
      ],
      'url'       : 'demo/swipe'
    },
    {
      'name'      : 'switch',
      'moduleName': 'material.components.switch',
      'label'     : 'Switch',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'switchDemo1',
            'module'      : 'switchDemo1',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'switchdemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/switch/demoBasicUsage/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/switch/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.switch',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/switch/demoBasicUsage/index.html'
          }
        }
      ],
      'url'       : 'demo/switch'
    },
    {
      'name'      : 'tabs',
      'moduleName': 'material.components.tabs',
      'label'     : 'Tabs',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'tabsDemoDynamicHeight',
            'module'      : 'tabsDemoDynamicHeight',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'tabsdemoDynamicHeight',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/tabs/demoDynamicHeight/style.css'
            }
          ],
          'html'      : [
            {
              'name'      : 'readme.html',
              'label'     : 'readme.html',
              'fileType'  : 'html',
              'outputPath': 'demo-partials/tabs/demoDynamicHeight/readme.html'
            }
          ],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/tabs/demoDynamicHeight/script.js'
            }
          ],
          'moduleName': 'material.components.tabs',
          'name'      : 'demoDynamicHeight',
          'label'     : 'Dynamic Height',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/tabs/demoDynamicHeight/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'tabsDemoDynamicTabs',
            'module'      : 'tabsDemoDynamicTabs',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'tabsdemoDynamicTabs',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/tabs/demoDynamicTabs/style.css'
            }
          ],
          'html'      : [
            {
              'name'      : 'readme.html',
              'label'     : 'readme.html',
              'fileType'  : 'html',
              'outputPath': 'demo-partials/tabs/demoDynamicTabs/readme.html'
            }
          ],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/tabs/demoDynamicTabs/script.js'
            }
          ],
          'moduleName': 'material.components.tabs',
          'name'      : 'demoDynamicTabs',
          'label'     : 'Dynamic Tabs',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/tabs/demoDynamicTabs/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'tabsDemoIconTabs',
            'module'      : 'tabsDemoIconTabs',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'tabsdemoStaticTabs',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/tabs/demoStaticTabs/style.css'
            }
          ],
          'html'      : [
            {
              'name'      : 'readme.html',
              'label'     : 'readme.html',
              'fileType'  : 'html',
              'outputPath': 'demo-partials/tabs/demoStaticTabs/readme.html'
            }
          ],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/tabs/demoStaticTabs/script.js'
            }
          ],
          'moduleName': 'material.components.tabs',
          'name'      : 'demoStaticTabs',
          'label'     : 'Static Tabs',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/tabs/demoStaticTabs/index.html'
          }
        }
      ],
      'url'       : 'demo/tabs'
    },
    {
      'name'      : 'toast',
      'moduleName': 'material.components.toast',
      'label'     : 'Toast',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'toastDemo1',
            'module'      : 'toastDemo1',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'toastdemoBasicUsage',
          'css'       : [],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/toast/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.toast',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/toast/demoBasicUsage/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'toastDemo2',
            'module'      : 'toastDemo2',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'toastdemoCustomUsage',
          'css'       : [],
          'html'      : [
            {
              'name'      : 'toast-template.html',
              'label'     : 'toast-template.html',
              'fileType'  : 'html',
              'outputPath': 'demo-partials/toast/demoCustomUsage/toast-template.html'
            }
          ],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/toast/demoCustomUsage/script.js'
            }
          ],
          'moduleName': 'material.components.toast',
          'name'      : 'demoCustomUsage',
          'label'     : 'Custom Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/toast/demoCustomUsage/index.html'
          }
        }
      ],
      'url'       : 'demo/toast'
    },
    {
      'name'      : 'toolbar',
      'moduleName': 'material.components.toolbar',
      'label'     : 'Toolbar',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'toolbarDemo1',
            'module'      : 'toolbarDemo1',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'toolbardemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/toolbar/demoBasicUsage/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/toolbar/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.toolbar',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/toolbar/demoBasicUsage/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'toolbarDemo2',
            'module'      : 'toolbarDemo2',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'toolbardemoScrollShrink',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/toolbar/demoScrollShrink/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/toolbar/demoScrollShrink/script.js'
            }
          ],
          'moduleName': 'material.components.toolbar',
          'name'      : 'demoScrollShrink',
          'label'     : 'Scroll Shrink',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/toolbar/demoScrollShrink/index.html'
          }
        }
      ],
      'url'       : 'demo/toolbar'
    },
    {
      'name'      : 'tooltip',
      'moduleName': 'material.components.tooltip',
      'label'     : 'Tooltip',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'tooltipDemo',
            'module'      : 'tooltipDemo',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'tooltipdemoBasicUsage',
          'css'       : [],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/tooltip/demoBasicUsage/script.js'
            }
          ],
          'moduleName': 'material.components.tooltip',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/tooltip/demoBasicUsage/index.html'
          }
        }
      ],
      'url'       : 'demo/tooltip'
    },
    {
      'name'      : 'truncate',
      'moduleName': 'material.components.truncate',
      'label'     : 'Truncate',
      'demos'     : [
        {
          'ngModule'  : '',
          'id'        : 'truncatedemoBasicUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/truncate/demoBasicUsage/style.css'
            }
          ],
          'html'      : [],
          'js'        : [],
          'moduleName': 'material.components.truncate',
          'name'      : 'demoBasicUsage',
          'label'     : 'Basic Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/truncate/demoBasicUsage/index.html'
          }
        }
      ],
      'url'       : 'demo/truncate'
    },
    {
      'name'      : 'virtualRepeat',
      'moduleName': 'material.components.virtualRepeat',
      'label'     : 'Virtual Repeat',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'virtualRepeatDeferredLoadingDemo',
            'module'      : 'virtualRepeatDeferredLoadingDemo',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'virtualRepeatdemoDeferredLoading',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/virtualRepeat/demoDeferredLoading/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/virtualRepeat/demoDeferredLoading/script.js'
            }
          ],
          'moduleName': 'material.components.virtualRepeat',
          'name'      : 'demoDeferredLoading',
          'label'     : 'Deferred Loading',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/virtualRepeat/demoDeferredLoading/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'virtualRepeatHorizontalDemo',
            'module'      : 'virtualRepeatHorizontalDemo',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'virtualRepeatdemoHorizontalUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/virtualRepeat/demoHorizontalUsage/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/virtualRepeat/demoHorizontalUsage/script.js'
            }
          ],
          'moduleName': 'material.components.virtualRepeat',
          'name'      : 'demoHorizontalUsage',
          'label'     : 'Horizontal Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/virtualRepeat/demoHorizontalUsage/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'virtualRepeatInfiniteScrollDemo',
            'module'      : 'virtualRepeatInfiniteScrollDemo',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'virtualRepeatdemoInfiniteScroll',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/virtualRepeat/demoInfiniteScroll/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/virtualRepeat/demoInfiniteScroll/script.js'
            }
          ],
          'moduleName': 'material.components.virtualRepeat',
          'name'      : 'demoInfiniteScroll',
          'label'     : 'Infinite Scroll',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/virtualRepeat/demoInfiniteScroll/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'virtualRepeatScrollToDemo',
            'module'      : 'virtualRepeatScrollToDemo',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'virtualRepeatdemoScrollTo',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/virtualRepeat/demoScrollTo/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/virtualRepeat/demoScrollTo/script.js'
            }
          ],
          'moduleName': 'material.components.virtualRepeat',
          'name'      : 'demoScrollTo',
          'label'     : 'Scroll To',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/virtualRepeat/demoScrollTo/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'virtualRepeatVerticalDemo',
            'module'      : 'virtualRepeatVerticalDemo',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'virtualRepeatdemoVerticalUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/virtualRepeat/demoVerticalUsage/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/virtualRepeat/demoVerticalUsage/script.js'
            }
          ],
          'moduleName': 'material.components.virtualRepeat',
          'name'      : 'demoVerticalUsage',
          'label'     : 'Vertical Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/virtualRepeat/demoVerticalUsage/index.html'
          }
        }
      ],
      'url'       : 'demo/virtualRepeat'
    },
    {
      'name'      : 'whiteframe',
      'moduleName': 'material.components.whiteframe',
      'label'     : 'Whiteframe',
      'demos'     : [
        {
          'ngModule'  : {
            'name'        : 'whiteframeBasicUsage',
            'module'      : 'whiteframeBasicUsage',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'whiteframedemoBasicClassUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/whiteframe/demoBasicClassUsage/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/whiteframe/demoBasicClassUsage/script.js'
            }
          ],
          'moduleName': 'material.components.whiteframe',
          'name'      : 'demoBasicClassUsage',
          'label'     : 'Basic Class Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/whiteframe/demoBasicClassUsage/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'whiteframeDirectiveUsage',
            'module'      : 'whiteframeDirectiveUsage',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'whiteframedemoDirectiveAttributeUsage',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/whiteframe/demoDirectiveAttributeUsage/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/whiteframe/demoDirectiveAttributeUsage/script.js'
            }
          ],
          'moduleName': 'material.components.whiteframe',
          'name'      : 'demoDirectiveAttributeUsage',
          'label'     : 'Directive Attribute Usage',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/whiteframe/demoDirectiveAttributeUsage/index.html'
          }
        },
        {
          'ngModule'  : {
            'name'        : 'whiteframeDirectiveUsage',
            'module'      : 'whiteframeDirectiveUsage',
            'dependencies': [
              'ngMaterial'
            ]
          },
          'id'        : 'whiteframedemoDirectiveInterpolation',
          'css'       : [
            {
              'name'      : 'style.css',
              'label'     : 'style.css',
              'fileType'  : 'css',
              'outputPath': 'demo-partials/whiteframe/demoDirectiveInterpolation/style.css'
            }
          ],
          'html'      : [],
          'js'        : [
            {
              'name'      : 'script.js',
              'label'     : 'script.js',
              'fileType'  : 'js',
              'outputPath': 'demo-partials/whiteframe/demoDirectiveInterpolation/script.js'
            }
          ],
          'moduleName': 'material.components.whiteframe',
          'name'      : 'demoDirectiveInterpolation',
          'label'     : 'Directive Interpolation',
          'index'     : {
            'name'      : 'index.html',
            'label'     : 'index.html',
            'fileType'  : 'html',
            'outputPath': 'demo-partials/whiteframe/demoDirectiveInterpolation/index.html'
          }
        }
      ],
      'url'       : 'demo/whiteframe'
    }
  ]);

angular.module('app.components.material-docs')
  .constant('COMPONENTS', [
    {
      'name'      : 'material.components.autocomplete',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.autocomplete/index.html',
      'url'       : 'api/material.components.autocomplete',
      'label'     : 'material.components.autocomplete',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/autocomplete/autocomplete.js',
      'docs'      : [
        {
          'name'      : 'mdAutocomplete',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': true,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.autocomplete/directive/mdAutocomplete.html',
          'url'       : 'api/directive/mdAutocomplete',
          'label'     : 'mdAutocomplete',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/autocomplete/js/autocompleteDirective.js',
          'hasDemo'   : true
        },
        {
          'name'      : 'mdHighlightText',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': true,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.autocomplete/directive/mdHighlightText.html',
          'url'       : 'api/directive/mdHighlightText',
          'label'     : 'mdHighlightText',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/autocomplete/js/highlightDirective.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.bottomSheet',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.bottomSheet/index.html',
      'url'       : 'api/material.components.bottomSheet',
      'label'     : 'material.components.bottomSheet',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/bottomSheet/bottom-sheet.js',
      'docs'      : [
        {
          'name'      : '$mdBottomSheet',
          'type'      : 'service',
          'outputPath': 'partials/api/material.components.bottomSheet/service/$mdBottomSheet.html',
          'url'       : 'api/service/$mdBottomSheet',
          'label'     : '$mdBottomSheet',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/bottomSheet/bottom-sheet.js',
          'hasDemo'   : false
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.button',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.button/index.html',
      'url'       : 'api/material.components.button',
      'label'     : 'material.components.button',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/button/button.js',
      'docs'      : [
        {
          'name'      : 'mdButton',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.button/directive/mdButton.html',
          'url'       : 'api/directive/mdButton',
          'label'     : 'mdButton',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/button/button.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.card',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.card/index.html',
      'url'       : 'api/material.components.card',
      'label'     : 'material.components.card',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/card/card.js',
      'docs'      : [
        {
          'name'      : 'mdCard',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.card/directive/mdCard.html',
          'url'       : 'api/directive/mdCard',
          'label'     : 'mdCard',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/card/card.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.checkbox',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.checkbox/index.html',
      'url'       : 'api/material.components.checkbox',
      'label'     : 'material.components.checkbox',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/checkbox/checkbox.js',
      'docs'      : [
        {
          'name'      : 'mdCheckbox',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.checkbox/directive/mdCheckbox.html',
          'url'       : 'api/directive/mdCheckbox',
          'label'     : 'mdCheckbox',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/checkbox/checkbox.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.chips',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.chips/index.html',
      'url'       : 'api/material.components.chips',
      'label'     : 'material.components.chips',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/chips/chips.js',
      'docs'      : [
        {
          'name'      : 'mdChip',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': true,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.chips/directive/mdChip.html',
          'url'       : 'api/directive/mdChip',
          'label'     : 'mdChip',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/chips/js/chipDirective.js',
          'hasDemo'   : true
        },
        {
          'name'      : 'mdChipRemove',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : false,
            'attribute': true,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.chips/directive/mdChipRemove.html',
          'url'       : 'api/directive/mdChipRemove',
          'label'     : 'mdChipRemove',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/chips/js/chipRemoveDirective.js',
          'hasDemo'   : true
        },
        {
          'name'      : 'mdChips',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': true,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.chips/directive/mdChips.html',
          'url'       : 'api/directive/mdChips',
          'label'     : 'mdChips',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/chips/js/chipsDirective.js',
          'hasDemo'   : true
        },
        {
          'name'      : 'mdContactChips',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': true,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.chips/directive/mdContactChips.html',
          'url'       : 'api/directive/mdContactChips',
          'label'     : 'mdContactChips',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/chips/js/contactChipsDirective.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.colors',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.colors/index.html',
      'url'       : 'api/material.components.colors',
      'label'     : 'material.components.colors',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/colors/colors.js',
      'docs'      : [
        {
          'name'      : '$mdColors',
          'type'      : 'service',
          'outputPath': 'partials/api/material.components.colors/service/$mdColors.html',
          'url'       : 'api/service/$mdColors',
          'label'     : '$mdColors',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/colors/colors.js',
          'hasDemo'   : false
        },
        {
          'name'      : 'mdColors',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : false,
            'attribute': true,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.colors/directive/mdColors.html',
          'url'       : 'api/directive/mdColors',
          'label'     : 'mdColors',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/colors/colors.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.content',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.content/index.html',
      'url'       : 'api/material.components.content',
      'label'     : 'material.components.content',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/content/content.js',
      'docs'      : [
        {
          'name'      : 'mdContent',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.content/directive/mdContent.html',
          'url'       : 'api/directive/mdContent',
          'label'     : 'mdContent',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/content/content.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.datepicker',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.datepicker/index.html',
      'url'       : 'api/material.components.datepicker',
      'label'     : 'material.components.datepicker',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/datepicker/datePicker.js',
      'docs'      : [
        {
          'name'      : 'mdCalendar',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': true,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.datepicker/directive/mdCalendar.html',
          'url'       : 'api/directive/mdCalendar',
          'label'     : 'mdCalendar',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/datepicker/js/calendar.js',
          'hasDemo'   : true
        },
        {
          'name'      : '$mdDateLocaleProvider',
          'type'      : 'service',
          'outputPath': 'partials/api/material.components.datepicker/service/$mdDateLocaleProvider.html',
          'url'       : 'api/service/$mdDateLocaleProvider',
          'label'     : '$mdDateLocaleProvider',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/datepicker/js/dateLocaleProvider.js',
          'hasDemo'   : false
        },
        {
          'name'      : 'mdDatepicker',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': true,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.datepicker/directive/mdDatepicker.html',
          'url'       : 'api/directive/mdDatepicker',
          'label'     : 'mdDatepicker',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/datepicker/js/datepickerDirective.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.dialog',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.dialog/index.html',
      'url'       : 'api/material.components.dialog',
      'label'     : 'material.components.dialog',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/dialog/dialog.js',
      'docs'      : [
        {
          'name'      : 'mdDialog',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.dialog/directive/mdDialog.html',
          'url'       : 'api/directive/mdDialog',
          'label'     : 'mdDialog',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/dialog/dialog.js',
          'hasDemo'   : true
        },
        {
          'name'      : '$mdDialog',
          'type'      : 'service',
          'outputPath': 'partials/api/material.components.dialog/service/$mdDialog.html',
          'url'       : 'api/service/$mdDialog',
          'label'     : '$mdDialog',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/dialog/dialog.js',
          'hasDemo'   : false
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.divider',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.divider/index.html',
      'url'       : 'api/material.components.divider',
      'label'     : 'material.components.divider',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/divider/divider.js',
      'docs'      : [
        {
          'name'      : 'mdDivider',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.divider/directive/mdDivider.html',
          'url'       : 'api/directive/mdDivider',
          'label'     : 'mdDivider',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/divider/divider.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.fabActions',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.fabActions/index.html',
      'url'       : 'api/material.components.fabActions',
      'label'     : 'material.components.fabActions',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/fabActions/fabActions.js',
      'docs'      : [
        {
          'name'      : 'mdFabActions',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.fabActions/directive/mdFabActions.html',
          'url'       : 'api/directive/mdFabActions',
          'label'     : 'mdFabActions',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/fabActions/fabActions.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.fabSpeedDial',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.fabSpeedDial/index.html',
      'url'       : 'api/material.components.fabSpeedDial',
      'label'     : 'material.components.fabSpeedDial',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/fabSpeedDial/fabSpeedDial.js',
      'docs'      : [
        {
          'name'      : 'mdFabSpeedDial',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.fabSpeedDial/directive/mdFabSpeedDial.html',
          'url'       : 'api/directive/mdFabSpeedDial',
          'label'     : 'mdFabSpeedDial',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/fabSpeedDial/fabSpeedDial.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.fabToolbar',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.fabToolbar/index.html',
      'url'       : 'api/material.components.fabToolbar',
      'label'     : 'material.components.fabToolbar',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/fabToolbar/fabToolbar.js',
      'docs'      : [
        {
          'name'      : 'mdFabToolbar',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.fabToolbar/directive/mdFabToolbar.html',
          'url'       : 'api/directive/mdFabToolbar',
          'label'     : 'mdFabToolbar',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/fabToolbar/fabToolbar.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.gridList',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.gridList/index.html',
      'url'       : 'api/material.components.gridList',
      'label'     : 'material.components.gridList',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/gridList/grid-list.js',
      'docs'      : [
        {
          'name'      : 'mdGridList',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.gridList/directive/mdGridList.html',
          'url'       : 'api/directive/mdGridList',
          'label'     : 'mdGridList',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/gridList/grid-list.js',
          'hasDemo'   : true
        },
        {
          'name'      : 'mdGridTile',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.gridList/directive/mdGridTile.html',
          'url'       : 'api/directive/mdGridTile',
          'label'     : 'mdGridTile',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/gridList/grid-list.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.icon',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.icon/index.html',
      'url'       : 'api/material.components.icon',
      'label'     : 'material.components.icon',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/icon/icon.js',
      'docs'      : [
        {
          'name'      : 'mdIcon',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.icon/directive/mdIcon.html',
          'url'       : 'api/directive/mdIcon',
          'label'     : 'mdIcon',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/icon/js/iconDirective.js',
          'hasDemo'   : true
        },
        {
          'name'      : '$mdIconProvider',
          'type'      : 'service',
          'outputPath': 'partials/api/material.components.icon/service/$mdIconProvider.html',
          'url'       : 'api/service/$mdIconProvider',
          'label'     : '$mdIconProvider',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/icon/js/iconService.js',
          'hasDemo'   : false
        },
        {
          'name'      : '$mdIcon',
          'type'      : 'service',
          'outputPath': 'partials/api/material.components.icon/service/$mdIcon.html',
          'url'       : 'api/service/$mdIcon',
          'label'     : '$mdIcon',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/icon/js/iconService.js',
          'hasDemo'   : false
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.input',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.input/index.html',
      'url'       : 'api/material.components.input',
      'label'     : 'material.components.input',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/input/input.js',
      'docs'      : [
        {
          'name'      : 'mdInputContainer',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.input/directive/mdInputContainer.html',
          'url'       : 'api/directive/mdInputContainer',
          'label'     : 'mdInputContainer',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/input/input.js',
          'hasDemo'   : true
        },
        {
          'name'      : 'mdInput',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.input/directive/mdInput.html',
          'url'       : 'api/directive/mdInput',
          'label'     : 'mdInput',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/input/input.js',
          'hasDemo'   : true
        },
        {
          'name'      : 'mdSelectOnFocus',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : false,
            'attribute': true,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.input/directive/mdSelectOnFocus.html',
          'url'       : 'api/directive/mdSelectOnFocus',
          'label'     : 'mdSelectOnFocus',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/input/input.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.list',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.list/index.html',
      'url'       : 'api/material.components.list',
      'label'     : 'material.components.list',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/list/list.js',
      'docs'      : [
        {
          'name'      : 'mdList',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.list/directive/mdList.html',
          'url'       : 'api/directive/mdList',
          'label'     : 'mdList',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/list/list.js',
          'hasDemo'   : true
        },
        {
          'name'      : 'mdListItem',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.list/directive/mdListItem.html',
          'url'       : 'api/directive/mdListItem',
          'label'     : 'mdListItem',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/list/list.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.menu',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.menu/index.html',
      'url'       : 'api/material.components.menu',
      'label'     : 'material.components.menu',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/menu/menu.js',
      'docs'      : [
        {
          'name'      : 'mdMenu',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.menu/directive/mdMenu.html',
          'url'       : 'api/directive/mdMenu',
          'label'     : 'mdMenu',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/menu/js/menuDirective.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.menuBar',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.menuBar/index.html',
      'url'       : 'api/material.components.menuBar',
      'label'     : 'material.components.menuBar',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/menuBar/menu-bar.js',
      'docs'      : [
        {
          'name'      : 'mdMenuBar',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.menuBar/directive/mdMenuBar.html',
          'url'       : 'api/directive/mdMenuBar',
          'label'     : 'mdMenuBar',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/menuBar/js/menuBarDirective.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.navBar',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.navBar/index.html',
      'url'       : 'api/material.components.navBar',
      'label'     : 'material.components.navBar',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/navBar/navBar.js',
      'docs'      : [
        {
          'name'      : 'mdNavBar',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.navBar/directive/mdNavBar.html',
          'url'       : 'api/directive/mdNavBar',
          'label'     : 'mdNavBar',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/navBar/navBar.js',
          'hasDemo'   : true
        },
        {
          'name'      : 'mdNavItem',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.navBar/directive/mdNavItem.html',
          'url'       : 'api/directive/mdNavItem',
          'label'     : 'mdNavItem',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/navBar/navBar.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.panel',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.panel/index.html',
      'url'       : 'api/material.components.panel',
      'label'     : 'material.components.panel',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/panel/panel.js',
      'docs'      : [
        {
          'name'      : '$mdPanelProvider',
          'type'      : 'service',
          'outputPath': 'partials/api/material.components.panel/service/$mdPanelProvider.html',
          'url'       : 'api/service/$mdPanelProvider',
          'label'     : '$mdPanelProvider',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/panel/panel.js',
          'hasDemo'   : false
        },
        {
          'name'      : '$mdPanel',
          'type'      : 'service',
          'outputPath': 'partials/api/material.components.panel/service/$mdPanel.html',
          'url'       : 'api/service/$mdPanel',
          'label'     : '$mdPanel',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/panel/panel.js',
          'hasDemo'   : false
        },
        {
          'name'      : 'MdPanelRef',
          'type'      : 'type',
          'outputPath': 'partials/api/material.components.panel/type/MdPanelRef.html',
          'url'       : 'api/type/MdPanelRef',
          'label'     : 'MdPanelRef',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/panel/panel.js',
          'hasDemo'   : false
        },
        {
          'name'      : 'MdPanelPosition',
          'type'      : 'type',
          'outputPath': 'partials/api/material.components.panel/type/MdPanelPosition.html',
          'url'       : 'api/type/MdPanelPosition',
          'label'     : 'MdPanelPosition',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/panel/panel.js',
          'hasDemo'   : false
        },
        {
          'name'      : 'MdPanelAnimation',
          'type'      : 'type',
          'outputPath': 'partials/api/material.components.panel/type/MdPanelAnimation.html',
          'url'       : 'api/type/MdPanelAnimation',
          'label'     : 'MdPanelAnimation',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/panel/panel.js',
          'hasDemo'   : false
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.progressCircular',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.progressCircular/index.html',
      'url'       : 'api/material.components.progressCircular',
      'label'     : 'material.components.progressCircular',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/progressCircular/progress-circular.js',
      'docs'      : [
        {
          'name'      : 'mdProgressCircular',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.progressCircular/directive/mdProgressCircular.html',
          'url'       : 'api/directive/mdProgressCircular',
          'label'     : 'mdProgressCircular',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/progressCircular/js/progressCircularDirective.js',
          'hasDemo'   : true
        },
        {
          'name'      : '$mdProgressCircular',
          'type'      : 'service',
          'outputPath': 'partials/api/material.components.progressCircular/service/$mdProgressCircular.html',
          'url'       : 'api/service/$mdProgressCircular',
          'label'     : '$mdProgressCircular',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/progressCircular/js/progressCircularProvider.js',
          'hasDemo'   : false
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.progressLinear',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.progressLinear/index.html',
      'url'       : 'api/material.components.progressLinear',
      'label'     : 'material.components.progressLinear',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/progressLinear/progress-linear.js',
      'docs'      : [
        {
          'name'      : 'mdProgressLinear',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.progressLinear/directive/mdProgressLinear.html',
          'url'       : 'api/directive/mdProgressLinear',
          'label'     : 'mdProgressLinear',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/progressLinear/progress-linear.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.radioButton',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.radioButton/index.html',
      'url'       : 'api/material.components.radioButton',
      'label'     : 'material.components.radioButton',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/radioButton/radio-button.js',
      'docs'      : [
        {
          'name'      : 'mdRadioGroup',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.radioButton/directive/mdRadioGroup.html',
          'url'       : 'api/directive/mdRadioGroup',
          'label'     : 'mdRadioGroup',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/radioButton/radio-button.js',
          'hasDemo'   : true
        },
        {
          'name'      : 'mdRadioButton',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.radioButton/directive/mdRadioButton.html',
          'url'       : 'api/directive/mdRadioButton',
          'label'     : 'mdRadioButton',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/radioButton/radio-button.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.select',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.select/index.html',
      'url'       : 'api/material.components.select',
      'label'     : 'material.components.select',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/select/select.js',
      'docs'      : [
        {
          'name'      : 'mdSelect',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.select/directive/mdSelect.html',
          'url'       : 'api/directive/mdSelect',
          'label'     : 'mdSelect',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/select/select.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.sidenav',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.sidenav/index.html',
      'url'       : 'api/material.components.sidenav',
      'label'     : 'material.components.sidenav',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/sidenav/sidenav.js',
      'docs'      : [
        {
          'name'      : '$mdSidenav',
          'type'      : 'service',
          'outputPath': 'partials/api/material.components.sidenav/service/$mdSidenav.html',
          'url'       : 'api/service/$mdSidenav',
          'label'     : '$mdSidenav',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/sidenav/sidenav.js',
          'hasDemo'   : false
        },
        {
          'name'      : 'mdSidenavFocus',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : false,
            'attribute': true,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.sidenav/directive/mdSidenavFocus.html',
          'url'       : 'api/directive/mdSidenavFocus',
          'label'     : 'mdSidenavFocus',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/sidenav/sidenav.js',
          'hasDemo'   : true
        },
        {
          'name'      : 'mdSidenav',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.sidenav/directive/mdSidenav.html',
          'url'       : 'api/directive/mdSidenav',
          'label'     : 'mdSidenav',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/sidenav/sidenav.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.slider',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.slider/index.html',
      'url'       : 'api/material.components.slider',
      'label'     : 'material.components.slider',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/slider/slider.js',
      'docs'      : [
        {
          'name'      : 'mdSliderContainer',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.slider/directive/mdSliderContainer.html',
          'url'       : 'api/directive/mdSliderContainer',
          'label'     : 'mdSliderContainer',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/slider/slider.js',
          'hasDemo'   : true
        },
        {
          'name'      : 'mdSlider',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.slider/directive/mdSlider.html',
          'url'       : 'api/directive/mdSlider',
          'label'     : 'mdSlider',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/slider/slider.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.sticky',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.sticky/index.html',
      'url'       : 'api/material.components.sticky',
      'label'     : 'material.components.sticky',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/sticky/sticky.js',
      'docs'      : [
        {
          'name'      : '$mdSticky',
          'type'      : 'service',
          'outputPath': 'partials/api/material.components.sticky/service/$mdSticky.html',
          'url'       : 'api/service/$mdSticky',
          'label'     : '$mdSticky',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/sticky/sticky.js',
          'hasDemo'   : false
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.subheader',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.subheader/index.html',
      'url'       : 'api/material.components.subheader',
      'label'     : 'material.components.subheader',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/subheader/subheader.js',
      'docs'      : [
        {
          'name'      : 'mdSubheader',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.subheader/directive/mdSubheader.html',
          'url'       : 'api/directive/mdSubheader',
          'label'     : 'mdSubheader',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/subheader/subheader.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.swipe',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.swipe/index.html',
      'url'       : 'api/material.components.swipe',
      'label'     : 'material.components.swipe',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/swipe/swipe.js',
      'docs'      : [
        {
          'name'      : 'mdSwipeLeft',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : false,
            'attribute': true,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.swipe/directive/mdSwipeLeft.html',
          'url'       : 'api/directive/mdSwipeLeft',
          'label'     : 'mdSwipeLeft',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/swipe/swipe.js',
          'hasDemo'   : true
        },
        {
          'name'      : 'mdSwipeRight',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : false,
            'attribute': true,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.swipe/directive/mdSwipeRight.html',
          'url'       : 'api/directive/mdSwipeRight',
          'label'     : 'mdSwipeRight',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/swipe/swipe.js',
          'hasDemo'   : true
        },
        {
          'name'      : 'mdSwipeUp',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : false,
            'attribute': true,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.swipe/directive/mdSwipeUp.html',
          'url'       : 'api/directive/mdSwipeUp',
          'label'     : 'mdSwipeUp',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/swipe/swipe.js',
          'hasDemo'   : true
        },
        {
          'name'      : 'mdSwipeDown',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : false,
            'attribute': true,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.swipe/directive/mdSwipeDown.html',
          'url'       : 'api/directive/mdSwipeDown',
          'label'     : 'mdSwipeDown',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/swipe/swipe.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.switch',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.switch/index.html',
      'url'       : 'api/material.components.switch',
      'label'     : 'material.components.switch',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/switch/switch.js',
      'docs'      : [
        {
          'name'      : 'mdSwitch',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': true,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.switch/directive/mdSwitch.html',
          'url'       : 'api/directive/mdSwitch',
          'label'     : 'mdSwitch',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/switch/switch.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.tabs',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.tabs/index.html',
      'url'       : 'api/material.components.tabs',
      'label'     : 'material.components.tabs',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/tabs/tabs.js',
      'docs'      : [
        {
          'name'      : 'mdTab',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.tabs/directive/mdTab.html',
          'url'       : 'api/directive/mdTab',
          'label'     : 'mdTab',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/tabs/js/tabDirective.js',
          'hasDemo'   : true
        },
        {
          'name'      : 'mdTabs',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.tabs/directive/mdTabs.html',
          'url'       : 'api/directive/mdTabs',
          'label'     : 'mdTabs',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/tabs/js/tabsDirective.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.toast',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.toast/index.html',
      'url'       : 'api/material.components.toast',
      'label'     : 'material.components.toast',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/toast/toast.js',
      'docs'      : [
        {
          'name'      : '$mdToast',
          'type'      : 'service',
          'outputPath': 'partials/api/material.components.toast/service/$mdToast.html',
          'url'       : 'api/service/$mdToast',
          'label'     : '$mdToast',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/toast/toast.js',
          'hasDemo'   : false
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.toolbar',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.toolbar/index.html',
      'url'       : 'api/material.components.toolbar',
      'label'     : 'material.components.toolbar',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/toolbar/toolbar.js',
      'docs'      : [
        {
          'name'      : 'mdToolbar',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.toolbar/directive/mdToolbar.html',
          'url'       : 'api/directive/mdToolbar',
          'label'     : 'mdToolbar',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/toolbar/toolbar.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.tooltip',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.tooltip/index.html',
      'url'       : 'api/material.components.tooltip',
      'label'     : 'material.components.tooltip',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/tooltip/tooltip.js',
      'docs'      : [
        {
          'name'      : 'mdTooltip',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': true,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.tooltip/directive/mdTooltip.html',
          'url'       : 'api/directive/mdTooltip',
          'label'     : 'mdTooltip',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/tooltip/tooltip.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.truncate',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.truncate/index.html',
      'url'       : 'api/material.components.truncate',
      'label'     : 'material.components.truncate',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/truncate/truncate.js',
      'docs'      : [
        {
          'name'      : 'mdTruncate',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': true,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.truncate/directive/mdTruncate.html',
          'url'       : 'api/directive/mdTruncate',
          'label'     : 'mdTruncate',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/truncate/truncate.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.virtualRepeat',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.virtualRepeat/index.html',
      'url'       : 'api/material.components.virtualRepeat',
      'label'     : 'material.components.virtualRepeat',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/virtualRepeat/virtual-repeater.js',
      'docs'      : [
        {
          'name'      : 'mdVirtualRepeatContainer',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': false,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.virtualRepeat/directive/mdVirtualRepeatContainer.html',
          'url'       : 'api/directive/mdVirtualRepeatContainer',
          'label'     : 'mdVirtualRepeatContainer',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/virtualRepeat/virtual-repeater.js',
          'hasDemo'   : true
        },
        {
          'name'      : 'mdVirtualRepeat',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : false,
            'attribute': true,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.virtualRepeat/directive/mdVirtualRepeat.html',
          'url'       : 'api/directive/mdVirtualRepeat',
          'label'     : 'mdVirtualRepeat',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/virtualRepeat/virtual-repeater.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.components.whiteframe',
      'type'      : 'module',
      'outputPath': 'partials/api/material.components.whiteframe/index.html',
      'url'       : 'api/material.components.whiteframe',
      'label'     : 'material.components.whiteframe',
      'module'    : 'material.components',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/whiteframe/whiteframe.js',
      'docs'      : [
        {
          'name'      : 'mdWhiteframe',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': true,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.components.whiteframe/directive/mdWhiteframe.html',
          'url'       : 'api/directive/mdWhiteframe',
          'label'     : 'mdWhiteframe',
          'module'    : 'material.components',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/whiteframe/whiteframe.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.core.aria',
      'type'      : 'module',
      'outputPath': 'partials/api/material.core.aria/index.html',
      'url'       : 'api/material.core.aria',
      'label'     : 'material.core.aria',
      'module'    : 'material.core',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/aria/aria.js',
      'docs'      : [
        {
          'name'      : '$mdAriaProvider',
          'type'      : 'service',
          'outputPath': 'partials/api/material.core.aria/service/$mdAriaProvider.html',
          'url'       : 'api/service/$mdAriaProvider',
          'label'     : '$mdAriaProvider',
          'module'    : 'material.core',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/aria/aria.js',
          'hasDemo'   : false
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.core.compiler',
      'type'      : 'module',
      'outputPath': 'partials/api/material.core.compiler/index.html',
      'url'       : 'api/material.core.compiler',
      'label'     : 'material.core.compiler',
      'module'    : 'material.core',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/compiler/compiler.js',
      'docs'      : [
        {
          'name'      : '$mdCompiler',
          'type'      : 'service',
          'outputPath': 'partials/api/material.core.compiler/service/$mdCompiler.html',
          'url'       : 'api/service/$mdCompiler',
          'label'     : '$mdCompiler',
          'module'    : 'material.core',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/compiler/compiler.js',
          'hasDemo'   : false
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.core.interaction',
      'type'      : 'module',
      'outputPath': 'partials/api/material.core.interaction/index.html',
      'url'       : 'api/material.core.interaction',
      'label'     : 'material.core.interaction',
      'module'    : 'material.core',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/interaction/interaction.js',
      'docs'      : [
        {
          'name'      : '$mdInteraction',
          'type'      : 'service',
          'outputPath': 'partials/api/material.core.interaction/service/$mdInteraction.html',
          'url'       : 'api/service/$mdInteraction',
          'label'     : '$mdInteraction',
          'module'    : 'material.core',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/interaction/interaction.js',
          'hasDemo'   : false
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.core.liveannouncer',
      'type'      : 'module',
      'outputPath': 'partials/api/material.core.liveannouncer/index.html',
      'url'       : 'api/material.core.liveannouncer',
      'label'     : 'material.core.liveannouncer',
      'module'    : 'material.core',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/liveAnnouncer/live-announcer.js',
      'docs'      : [
        {
          'name'      : '$mdLiveAnnouncer',
          'type'      : 'service',
          'outputPath': 'partials/api/material.core.liveannouncer/service/$mdLiveAnnouncer.html',
          'url'       : 'api/service/$mdLiveAnnouncer',
          'label'     : '$mdLiveAnnouncer',
          'module'    : 'material.core',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/liveAnnouncer/live-announcer.js',
          'hasDemo'   : false
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.core.ripple',
      'type'      : 'module',
      'outputPath': 'partials/api/material.core.ripple/index.html',
      'url'       : 'api/material.core.ripple',
      'label'     : 'material.core.ripple',
      'module'    : 'material.core',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/ripple/ripple.js',
      'docs'      : [
        {
          'name'      : 'mdInkRipple',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': true,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.core.ripple/directive/mdInkRipple.html',
          'url'       : 'api/directive/mdInkRipple',
          'label'     : 'mdInkRipple',
          'module'    : 'material.core',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/ripple/ripple.js',
          'hasDemo'   : true
        },
        {
          'name'      : '$mdInkRipple',
          'type'      : 'service',
          'outputPath': 'partials/api/material.core.ripple/service/$mdInkRipple.html',
          'url'       : 'api/service/$mdInkRipple',
          'label'     : '$mdInkRipple',
          'module'    : 'material.core',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/ripple/ripple.js',
          'hasDemo'   : false
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.core.theming',
      'type'      : 'module',
      'outputPath': 'partials/api/material.core.theming/index.html',
      'url'       : 'api/material.core.theming',
      'label'     : 'material.core.theming',
      'module'    : 'material.core',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/theming/theming.js',
      'docs'      : [
        {
          'name'      : '$mdThemingProvider',
          'type'      : 'service',
          'outputPath': 'partials/api/material.core.theming/service/$mdThemingProvider.html',
          'url'       : 'api/service/$mdThemingProvider',
          'label'     : '$mdThemingProvider',
          'module'    : 'material.core',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/theming/theming.js',
          'hasDemo'   : false
        },
        {
          'name'      : '$mdTheming',
          'type'      : 'service',
          'outputPath': 'partials/api/material.core.theming/service/$mdTheming.html',
          'url'       : 'api/service/$mdTheming',
          'label'     : '$mdTheming',
          'module'    : 'material.core',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/theming/theming.js',
          'hasDemo'   : false
        }
      ],
      'hasDemo'   : false
    },
    {
      'name'      : 'material.core.util',
      'type'      : 'module',
      'outputPath': 'partials/api/material.core.util/index.html',
      'url'       : 'api/material.core.util',
      'label'     : 'material.core.util',
      'module'    : 'material.core',
      'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/util/util.js',
      'docs'      : [
        {
          'name'      : 'mdAutofocus',
          'type'      : 'directive',
          'restrict'  : {
            'element'  : true,
            'attribute': true,
            'cssClass' : false,
            'comment'  : false
          },
          'outputPath': 'partials/api/material.core.util/directive/mdAutofocus.html',
          'url'       : 'api/directive/mdAutofocus',
          'label'     : 'mdAutofocus',
          'module'    : 'material.core',
          'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/util/autofocus.js',
          'hasDemo'   : true
        }
      ],
      'hasDemo'   : false
    }
  ]);

(function ()
{
    'use strict';

    angular
        .module('app.components.charts.nvd3',
            [
                // 3rd Party Dependencies
                'nvd3'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_charts_nvd3', {
            url  : '/components/charts/nvd3',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/charts/nvd3/nvd3.html',
                    controller : 'Nvd3Controller as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.nvd3')
        .controller('Nvd3Controller', Nvd3Controller);

    function Nvd3Controller()
    {
        var vm = this;

        // Data
        vm.lineChart = {
            options: {
                chart   : {
                    type                   : 'lineChart',
                    height                 : 450,
                    margin                 : {
                        top   : 20,
                        right : 20,
                        bottom: 40,
                        left  : 55
                    },
                    x                      : function (d)
                    {
                        return d.x;
                    },
                    y                      : function (d)
                    {
                        return d.y;
                    },
                    useInteractiveGuideline: true,
                    xAxis                  : {
                        axisLabel: 'Time (ms)'
                    },
                    yAxis                  : {
                        axisLabel        : 'Voltage (v)',
                        tickFormat       : function (d)
                        {
                            return d3.format('.02f')(d);
                        },
                        axisLabelDistance: 30
                    }
                },
                title   : {
                    enable: true,
                    text  : 'Title for Line Chart'
                },
                subtitle: {
                    enable: true,
                    text  : 'Subtitle for simple line chart. Lorem ipsum dolor sit amet, at eam blandit sadipscing, vim adhuc sanctus disputando ex, cu usu affert alienum urbanitas.',
                    css   : {
                        'text-align': 'center',
                        'margin'    : '10px 13px 0px 7px'
                    }
                },
                caption : {
                    enable: true,
                    html  : '<b>Figure 1.</b> Lorem ipsum dolor sit amet, at eam blandit sadipscing, <span style="text-decoration: underline;">vim adhuc sanctus disputando ex</span>, cu usu affert alienum urbanitas. <i>Cum in purto erat, mea ne nominavi persecuti reformidans.</i> Docendi blandit abhorreant ea has, minim tantas alterum pro eu. <span style="color: darkred;">Exerci graeci ad vix, elit tacimates ea duo</span>. Id mel eruditi fuisset. Stet vidit patrioque in pro, eum ex veri verterem abhorreant, id unum oportere intellegam nec<sup>[1, <a href="https://github.com/krispo/angular-nvd3" target="_blank">2</a>, 3]</sup>.',
                    css   : {
                        'text-align': 'justify',
                        'margin'    : '10px 13px 0px 7px'
                    }
                }
            },
            data   : sinAndCos()
        };

        vm.stackedAreaChart = {
            options: {
                chart: {
                    type                   : 'stackedAreaChart',
                    height                 : 450,
                    margin                 : {
                        top   : 20,
                        right : 20,
                        bottom: 60,
                        left  : 40
                    },
                    x                      : function (d)
                    {
                        return d[0];
                    },
                    y                      : function (d)
                    {
                        return d[1];
                    },
                    useVoronoi             : false,
                    clipEdge               : true,
                    transitionDuration     : 500,
                    useInteractiveGuideline: true,
                    xAxis                  : {
                        showMaxMin: false,
                        tickFormat: function (d)
                        {
                            return d3.time.format('%x')(new Date(d));
                        }
                    },
                    yAxis                  : {
                        tickFormat: function (d)
                        {
                            return d3.format(',.2f')(d);
                        }
                    }
                }
            },

            data: [
                {
                    'key'   : 'North America',
                    'values': [[1025409600000, 23.041422681023], [1028088000000, 19.854291255832], [1030766400000, 21.02286281168], [1033358400000, 22.093608385173], [1036040400000, 25.108079299458], [1038632400000, 26.982389242348], [1041310800000, 19.828984957662], [1043989200000, 19.914055036294], [1046408400000, 19.436150539916], [1049086800000, 21.558650338602], [1051675200000, 24.395594061773], [1054353600000, 24.747089309384], [1056945600000, 23.491755498807], [1059624000000, 23.376634878164], [1062302400000, 24.581223154533], [1064894400000, 24.922476843538], [1067576400000, 27.357712939042], [1070168400000, 26.503020572593], [1072846800000, 26.658901244878], [1075525200000, 27.065704156445], [1078030800000, 28.735320452588], [1080709200000, 31.572277846319], [1083297600000, 30.932161503638], [1085976000000, 31.627029785554], [1088568000000, 28.728743674232], [1091246400000, 26.858365172675], [1093924800000, 27.279922830032], [1096516800000, 34.408301211324], [1099195200000, 34.794362930439], [1101790800000, 35.609978198951], [1104469200000, 33.574394968037], [1107147600000, 31.979405070598], [1109566800000, 31.19009040297], [1112245200000, 31.083933968994], [1114833600000, 29.668971113185], [1117512000000, 31.490638014379], [1120104000000, 31.818617451128], [1122782400000, 32.960314008183], [1125460800000, 31.313383196209], [1128052800000, 33.125486081852], [1130734800000, 32.791805509149], [1133326800000, 33.506038030366], [1136005200000, 26.96501697216], [1138683600000, 27.38478809681], [1141102800000, 27.371377218209], [1143781200000, 26.309915460827], [1146369600000, 26.425199957518], [1149048000000, 26.823411519396], [1151640000000, 23.850443591587], [1154318400000, 23.158355444054], [1156996800000, 22.998689393695], [1159588800000, 27.9771285113], [1162270800000, 29.073672469719], [1164862800000, 28.587640408904], [1167541200000, 22.788453687637], [1170219600000, 22.429199073597], [1172638800000, 22.324103271052], [1175313600000, 17.558388444187], [1177905600000, 16.769518096208], [1180584000000, 16.214738201301], [1183176000000, 18.729632971229], [1185854400000, 18.814523318847], [1188532800000, 19.789986451358], [1191124800000, 17.070049054933], [1193803200000, 16.121349575716], [1196398800000, 15.141659430091], [1199077200000, 17.175388025297], [1201755600000, 17.286592443522], [1204261200000, 16.323141626568], [1206936000000, 19.231263773952], [1209528000000, 18.446256391095], [1212206400000, 17.822632399764], [1214798400000, 15.53936647598], [1217476800000, 15.255131790217], [1220155200000, 15.660963922592], [1222747200000, 13.254482273698], [1225425600000, 11.920796202299], [1228021200000, 12.122809090924], [1230699600000, 15.691026271393], [1233378000000, 14.720881635107], [1235797200000, 15.387939360044], [1238472000000, 13.765436672228], [1241064000000, 14.631445864799], [1243742400000, 14.292446536221], [1246334400000, 16.170071367017], [1249012800000, 15.948135554337], [1251691200000, 16.612872685134], [1254283200000, 18.778338719091], [1256961600000, 16.756026065421], [1259557200000, 19.385804443146], [1262235600000, 22.950590240168], [1264914000000, 23.61159018141], [1267333200000, 25.708586989581], [1270008000000, 26.883915999885], [1272600000000, 25.893486687065], [1275278400000, 24.678914263176], [1277870400000, 25.937275793024], [1280548800000, 29.461381693838], [1283227200000, 27.357322961861], [1285819200000, 29.057235285673], [1288497600000, 28.549434189386], [1291093200000, 28.506352379724], [1293771600000, 29.449241421598], [1296450000000, 25.796838168807], [1298869200000, 28.740145449188], [1301544000000, 22.091744141872], [1304136000000, 25.07966254541], [1306814400000, 23.674906973064], [1309406400000, 23.418002742929], [1312084800000, 23.24364413887], [1314763200000, 31.591854066817], [1317355200000, 31.497112374114], [1320033600000, 26.67238082043], [1322629200000, 27.297080015495], [1325307600000, 20.174315530051], [1327986000000, 19.631084213898], [1330491600000, 20.366462219461], [1333166400000, 19.284784434185], [1335758400000, 19.157810257624]]
                },

                {
                    'key'   : 'Africa',
                    'values': [[1025409600000, 7.9356392949025], [1028088000000, 7.4514668527298], [1030766400000, 7.9085410566608], [1033358400000, 5.8996782364764], [1036040400000, 6.0591869346923], [1038632400000, 5.9667815800451], [1041310800000, 8.65528925664], [1043989200000, 8.7690763386254], [1046408400000, 8.6386160387453], [1049086800000, 5.9895557449743], [1051675200000, 6.3840324338159], [1054353600000, 6.5196511461441], [1056945600000, 7.0738618553114], [1059624000000, 6.5745957367133], [1062302400000, 6.4658359184444], [1064894400000, 2.7622758754954], [1067576400000, 2.9794782986241], [1070168400000, 2.8735432712019], [1072846800000, 1.6344817513645], [1075525200000, 1.5869248754883], [1078030800000, 1.7172279157246], [1080709200000, 1.9649927409867], [1083297600000, 2.0261695079196], [1085976000000, 2.0541261923929], [1088568000000, 3.9466318927569], [1091246400000, 3.7826770946089], [1093924800000, 3.9543021004028], [1096516800000, 3.8309891064711], [1099195200000, 3.6340958946166], [1101790800000, 3.5289755762525], [1104469200000, 5.702378559857], [1107147600000, 5.6539569019223], [1109566800000, 5.5449506370392], [1112245200000, 4.7579993280677], [1114833600000, 4.4816139372906], [1117512000000, 4.5965558568606], [1120104000000, 4.3747066116976], [1122782400000, 4.4588822917087], [1125460800000, 4.4460351848286], [1128052800000, 3.7989113035136], [1130734800000, 3.7743883140088], [1133326800000, 3.7727852823828], [1136005200000, 7.2968111448895], [1138683600000, 7.2800122043237], [1141102800000, 7.1187787503354], [1143781200000, 8.351887016482], [1146369600000, 8.4156698763993], [1149048000000, 8.1673298604231], [1151640000000, 5.5132447126042], [1154318400000, 6.1152537710599], [1156996800000, 6.076765091942], [1159588800000, 4.6304473798646], [1162270800000, 4.6301068469402], [1164862800000, 4.3466656309389], [1167541200000, 6.830104897003], [1170219600000, 7.241633040029], [1172638800000, 7.1432372054153], [1175313600000, 10.608942063374], [1177905600000, 10.914964549494], [1180584000000, 10.933223880565], [1183176000000, 8.3457524851265], [1185854400000, 8.1078413081882], [1188532800000, 8.2697185922474], [1191124800000, 8.4742436475968], [1193803200000, 8.4994601179319], [1196398800000, 8.7387319683243], [1199077200000, 6.8829183612895], [1201755600000, 6.984133637885], [1204261200000, 7.0860136043287], [1206936000000, 4.3961787956053], [1209528000000, 3.8699674365231], [1212206400000, 3.6928925238305], [1214798400000, 6.7571718894253], [1217476800000, 6.4367313362344], [1220155200000, 6.4048441521454], [1222747200000, 5.4643833239669], [1225425600000, 5.3150786833374], [1228021200000, 5.3011272612576], [1230699600000, 4.1203601430809], [1233378000000, 4.0881783200525], [1235797200000, 4.1928665957189], [1238472000000, 7.0249415663205], [1241064000000, 7.006530880769], [1243742400000, 6.994835633224], [1246334400000, 6.1220222336254], [1249012800000, 6.1177436137653], [1251691200000, 6.1413396231981], [1254283200000, 4.8046006145874], [1256961600000, 4.6647600660544], [1259557200000, 4.544865006255], [1262235600000, 6.0488249316539], [1264914000000, 6.3188669540206], [1267333200000, 6.5873958262306], [1270008000000, 6.2281189839578], [1272600000000, 5.8948915746059], [1275278400000, 5.5967320482214], [1277870400000, 0.99784432084837], [1280548800000, 1.0950794175359], [1283227200000, 0.94479734407491], [1285819200000, 1.222093988688], [1288497600000, 1.335093106856], [1291093200000, 1.3302565104985], [1293771600000, 1.340824670897], [1296450000000, 0], [1298869200000, 0], [1301544000000, 0], [1304136000000, 0], [1306814400000, 0], [1309406400000, 0], [1312084800000, 0], [1314763200000, 0], [1317355200000, 4.4583692315], [1320033600000, 3.6493043348059], [1322629200000, 3.8610064091761], [1325307600000, 5.5144800685202], [1327986000000, 5.1750695220791], [1330491600000, 5.6710066952691], [1333166400000, 5.5611890039181], [1335758400000, 5.5979368839939]]
                },

                {
                    'key'   : 'South America',
                    'values': [[1025409600000, 7.9149900245423], [1028088000000, 7.0899888751059], [1030766400000, 7.5996132380614], [1033358400000, 8.2741174301034], [1036040400000, 9.3564460833513], [1038632400000, 9.7066786059904], [1041310800000, 10.213363052343], [1043989200000, 10.285809585273], [1046408400000, 10.222053149228], [1049086800000, 8.6188592137975], [1051675200000, 9.3335447543566], [1054353600000, 8.9312402186628], [1056945600000, 8.1895089343658], [1059624000000, 8.260622135079], [1062302400000, 7.7700786851364], [1064894400000, 7.9907428771318], [1067576400000, 8.7769091865606], [1070168400000, 8.4855077060661], [1072846800000, 9.6277203033655], [1075525200000, 9.9685913452624], [1078030800000, 10.615085181759], [1080709200000, 9.2902488079646], [1083297600000, 8.8610439830061], [1085976000000, 9.1075344931229], [1088568000000, 9.9156737639203], [1091246400000, 9.7826003238782], [1093924800000, 10.55403610555], [1096516800000, 10.926900264097], [1099195200000, 10.903144818736], [1101790800000, 10.862890389067], [1104469200000, 10.64604998964], [1107147600000, 10.042790814087], [1109566800000, 9.7173391591038], [1112245200000, 9.6122415755443], [1114833600000, 9.4337921146562], [1117512000000, 9.814827171183], [1120104000000, 12.059260396788], [1122782400000, 12.139649903873], [1125460800000, 12.281290663822], [1128052800000, 8.8037085409056], [1130734800000, 8.6300618239176], [1133326800000, 9.1225708491432], [1136005200000, 12.988124170836], [1138683600000, 13.356778764353], [1141102800000, 13.611196863271], [1143781200000, 6.8959030061189], [1146369600000, 6.9939633271353], [1149048000000, 6.7241510257676], [1151640000000, 5.5611293669517], [1154318400000, 5.6086488714041], [1156996800000, 5.4962849907033], [1159588800000, 6.9193153169278], [1162270800000, 7.0016334389778], [1164862800000, 6.7865422443273], [1167541200000, 9.0006454225383], [1170219600000, 9.2233916171431], [1172638800000, 8.8929316009479], [1175313600000, 10.345937520404], [1177905600000, 10.075914677026], [1180584000000, 10.089006188111], [1183176000000, 10.598330295008], [1185854400000, 9.9689546533009], [1188532800000, 9.7740580198146], [1191124800000, 10.558483060626], [1193803200000, 9.9314651823603], [1196398800000, 9.3997715873769], [1199077200000, 8.4086493387262], [1201755600000, 8.9698309085926], [1204261200000, 8.2778357995396], [1206936000000, 8.8585045600123], [1209528000000, 8.7013756413322], [1212206400000, 7.7933605469443], [1214798400000, 7.0236183483064], [1217476800000, 6.9873088186829], [1220155200000, 6.8031713070097], [1222747200000, 6.6869531315723], [1225425600000, 6.138256993963], [1228021200000, 5.6434994016354], [1230699600000, 5.495220262512], [1233378000000, 4.6885326869846], [1235797200000, 4.4524349883438], [1238472000000, 5.6766520778185], [1241064000000, 5.7675774480752], [1243742400000, 5.7882863168337], [1246334400000, 7.2666010034924], [1249012800000, 7.5191821322261], [1251691200000, 7.849651451445], [1254283200000, 10.383992037985], [1256961600000, 9.0653691861818], [1259557200000, 9.6705248324159], [1262235600000, 10.856380561349], [1264914000000, 11.27452370892], [1267333200000, 11.754156529088], [1270008000000, 8.2870811422455], [1272600000000, 8.0210264360699], [1275278400000, 7.5375074474865], [1277870400000, 8.3419527338039], [1280548800000, 9.4197471818443], [1283227200000, 8.7321733185797], [1285819200000, 9.6627062648126], [1288497600000, 10.187962234548], [1291093200000, 9.8144201733476], [1293771600000, 10.275723361712], [1296450000000, 16.796066079353], [1298869200000, 17.543254984075], [1301544000000, 16.673660675083], [1304136000000, 17.963944353609], [1306814400000, 16.63774086721], [1309406400000, 15.84857094609], [1312084800000, 14.767303362181], [1314763200000, 24.778452182433], [1317355200000, 18.370353229999], [1320033600000, 15.253137429099], [1322629200000, 14.989600840649], [1325307600000, 16.052539160125], [1327986000000, 16.424390322793], [1330491600000, 17.884020741104], [1333166400000, 18.372698836036], [1335758400000, 18.315881576096]]
                },

                {
                    'key'   : 'Asia',
                    'values': [[1025409600000, 13.153938631352], [1028088000000, 12.456410521864], [1030766400000, 12.537048663919], [1033358400000, 13.947386398309], [1036040400000, 14.421680682568], [1038632400000, 14.143238262286], [1041310800000, 12.229635347478], [1043989200000, 12.508479916948], [1046408400000, 12.155368409526], [1049086800000, 13.335455563994], [1051675200000, 12.888210138167], [1054353600000, 12.842092790511], [1056945600000, 12.513816474199], [1059624000000, 12.21453674494], [1062302400000, 11.750848343935], [1064894400000, 10.526579636787], [1067576400000, 10.873596086087], [1070168400000, 11.019967131519], [1072846800000, 11.235789380602], [1075525200000, 11.859910850657], [1078030800000, 12.531031616536], [1080709200000, 11.360451067019], [1083297600000, 11.456244780202], [1085976000000, 11.436991407309], [1088568000000, 11.638595744327], [1091246400000, 11.190418301469], [1093924800000, 11.835608007589], [1096516800000, 11.540980244475], [1099195200000, 10.958762325687], [1101790800000, 10.885791159509], [1104469200000, 13.605810720109], [1107147600000, 13.128978067437], [1109566800000, 13.119012086882], [1112245200000, 13.003706129783], [1114833600000, 13.326996807689], [1117512000000, 13.547947991743], [1120104000000, 12.807959646616], [1122782400000, 12.931763821068], [1125460800000, 12.795359993008], [1128052800000, 9.6998935538319], [1130734800000, 9.3473740089131], [1133326800000, 9.36902067716], [1136005200000, 14.258619539875], [1138683600000, 14.21241095603], [1141102800000, 13.973193618249], [1143781200000, 15.218233920664], [1146369600000, 14.382109727451], [1149048000000, 13.894310878491], [1151640000000, 15.593086090031], [1154318400000, 16.244839695189], [1156996800000, 16.017088850647], [1159588800000, 14.183951830057], [1162270800000, 14.148523245696], [1164862800000, 13.424326059971], [1167541200000, 12.974450435754], [1170219600000, 13.232470418021], [1172638800000, 13.318762655574], [1175313600000, 15.961407746104], [1177905600000, 16.287714639805], [1180584000000, 16.24659058389], [1183176000000, 17.564505594808], [1185854400000, 17.872725373164], [1188532800000, 18.018998508756], [1191124800000, 15.584518016602], [1193803200000, 15.480850647182], [1196398800000, 15.699120036985], [1199077200000, 19.184281817226], [1201755600000, 19.691226605205], [1204261200000, 18.982314051293], [1206936000000, 18.707820309008], [1209528000000, 17.459630929759], [1212206400000, 16.500616076782], [1214798400000, 18.086324003978], [1217476800000, 18.929464156259], [1220155200000, 18.233728682084], [1222747200000, 16.315776297325], [1225425600000, 14.632892190251], [1228021200000, 14.667835024479], [1230699600000, 13.946993947309], [1233378000000, 14.394304684398], [1235797200000, 13.724462792967], [1238472000000, 10.930879035807], [1241064000000, 9.8339915513708], [1243742400000, 10.053858541872], [1246334400000, 11.786998438286], [1249012800000, 11.780994901769], [1251691200000, 11.305889670277], [1254283200000, 10.918452290083], [1256961600000, 9.6811395055706], [1259557200000, 10.971529744038], [1262235600000, 13.330210480209], [1264914000000, 14.592637568961], [1267333200000, 14.605329141157], [1270008000000, 13.936853794037], [1272600000000, 12.189480759072], [1275278400000, 11.676151385046], [1277870400000, 13.058852800018], [1280548800000, 13.62891543203], [1283227200000, 13.811107569918], [1285819200000, 13.786494560786], [1288497600000, 14.045162857531], [1291093200000, 13.697412447286], [1293771600000, 13.677681376221], [1296450000000, 19.96151186453], [1298869200000, 21.049198298156], [1301544000000, 22.687631094009], [1304136000000, 25.469010617433], [1306814400000, 24.88379943712], [1309406400000, 24.203843814249], [1312084800000, 22.138760964036], [1314763200000, 16.034636966228], [1317355200000, 15.394958944555], [1320033600000, 12.62564246197], [1322629200000, 12.973735699739], [1325307600000, 15.78601833615], [1327986000000, 15.227368020134], [1330491600000, 15.899752650733], [1333166400000, 15.661317319168], [1335758400000, 15.359891177281]]
                },

                {
                    'key'   : 'Europe',
                    'values': [[1025409600000, 9.3433263069351], [1028088000000, 8.4583069475546], [1030766400000, 8.0342398154196], [1033358400000, 8.1538966876572], [1036040400000, 10.743604786849], [1038632400000, 12.349366155851], [1041310800000, 10.742682503899], [1043989200000, 11.360983869935], [1046408400000, 11.441336039535], [1049086800000, 10.897508791837], [1051675200000, 11.469101547709], [1054353600000, 12.086311476742], [1056945600000, 8.0697180773504], [1059624000000, 8.2004392233445], [1062302400000, 8.4566434900643], [1064894400000, 7.9565760979059], [1067576400000, 9.3764619255827], [1070168400000, 9.0747664160538], [1072846800000, 10.508939004673], [1075525200000, 10.69936754483], [1078030800000, 10.681562399145], [1080709200000, 13.184786109406], [1083297600000, 12.668213052351], [1085976000000, 13.430509403986], [1088568000000, 12.393086349213], [1091246400000, 11.942374044842], [1093924800000, 12.062227685742], [1096516800000, 11.969974363623], [1099195200000, 12.14374574055], [1101790800000, 12.69422821995], [1104469200000, 9.1235211044692], [1107147600000, 8.758211757584], [1109566800000, 8.8072309258443], [1112245200000, 11.687595946835], [1114833600000, 11.079723082664], [1117512000000, 12.049712896076], [1120104000000, 10.725319428684], [1122782400000, 10.844849996286], [1125460800000, 10.833535488461], [1128052800000, 17.180932407865], [1130734800000, 15.894764896516], [1133326800000, 16.412751299498], [1136005200000, 12.573569093402], [1138683600000, 13.242301508051], [1141102800000, 12.863536342041], [1143781200000, 21.034044171629], [1146369600000, 21.419084618802], [1149048000000, 21.142678863692], [1151640000000, 26.56848967753], [1154318400000, 24.839144939906], [1156996800000, 25.456187462166], [1159588800000, 26.350164502825], [1162270800000, 26.478333205189], [1164862800000, 26.425979547846], [1167541200000, 28.191461582256], [1170219600000, 28.930307448808], [1172638800000, 29.521413891117], [1175313600000, 28.188285966466], [1177905600000, 27.704619625831], [1180584000000, 27.49086242483], [1183176000000, 28.770679721286], [1185854400000, 29.06048067145], [1188532800000, 28.240998844973], [1191124800000, 33.004893194128], [1193803200000, 34.075180359928], [1196398800000, 32.548560664834], [1199077200000, 30.629727432729], [1201755600000, 28.642858788159], [1204261200000, 27.973575227843], [1206936000000, 27.393351882726], [1209528000000, 28.476095288522], [1212206400000, 29.29667866426], [1214798400000, 29.222333802896], [1217476800000, 28.092966093842], [1220155200000, 28.107159262922], [1222747200000, 25.482974832099], [1225425600000, 21.208115993834], [1228021200000, 20.295043095268], [1230699600000, 15.925754618402], [1233378000000, 17.162864628346], [1235797200000, 17.084345773174], [1238472000000, 22.24600710228], [1241064000000, 24.530543998508], [1243742400000, 25.084184918241], [1246334400000, 16.606166527359], [1249012800000, 17.239620011628], [1251691200000, 17.336739127379], [1254283200000, 25.478492475754], [1256961600000, 23.017152085244], [1259557200000, 25.617745423684], [1262235600000, 24.061133998641], [1264914000000, 23.223933318646], [1267333200000, 24.425887263936], [1270008000000, 35.501471156693], [1272600000000, 33.775013878675], [1275278400000, 30.417993630285], [1277870400000, 30.023598978467], [1280548800000, 33.327519522436], [1283227200000, 31.963388450372], [1285819200000, 30.49896723209], [1288497600000, 32.403696817913], [1291093200000, 31.47736071922], [1293771600000, 31.53259666241], [1296450000000, 41.760282761548], [1298869200000, 45.605771243237], [1301544000000, 39.986557966215], [1304136000000, 43.84633051005], [1306814400000, 39.857316881858], [1309406400000, 37.675127768207], [1312084800000, 35.775077970313], [1314763200000, 48.631009702578], [1317355200000, 42.830831754505], [1320033600000, 35.611502589362], [1322629200000, 35.320136981738], [1325307600000, 31.564136901516], [1327986000000, 32.074407502433], [1330491600000, 35.053013769977], [1333166400000, 33.873085184128], [1335758400000, 32.321039427046]]
                },

                {
                    'key'   : 'Australia',
                    'values': [[1025409600000, 5.1162447683392], [1028088000000, 4.2022848306513], [1030766400000, 4.3543715758736], [1033358400000, 5.4641223667245], [1036040400000, 6.0041275884577], [1038632400000, 6.6050520064486], [1041310800000, 5.0154059912793], [1043989200000, 5.1835708554647], [1046408400000, 5.1142682006164], [1049086800000, 5.0271381717695], [1051675200000, 5.3437782653456], [1054353600000, 5.2105844515767], [1056945600000, 6.552565997799], [1059624000000, 6.9873363581831], [1062302400000, 7.010986789097], [1064894400000, 4.4254242025515], [1067576400000, 4.9613848042174], [1070168400000, 4.8854920484764], [1072846800000, 4.0441111794228], [1075525200000, 4.0219596813179], [1078030800000, 4.3065749225355], [1080709200000, 3.9148434915404], [1083297600000, 3.8659430654512], [1085976000000, 3.9572824600686], [1088568000000, 4.7372190641522], [1091246400000, 4.6871476374455], [1093924800000, 5.0398702564196], [1096516800000, 5.5221787544964], [1099195200000, 5.424646299798], [1101790800000, 5.9240223067349], [1104469200000, 5.9936860983601], [1107147600000, 5.8499523215019], [1109566800000, 6.4149040329325], [1112245200000, 6.4547895561969], [1114833600000, 5.9385382611161], [1117512000000, 6.0486751030592], [1120104000000, 5.23108613838], [1122782400000, 5.5857797121029], [1125460800000, 5.3454665096987], [1128052800000, 5.0439154120119], [1130734800000, 5.054634702913], [1133326800000, 5.3819451380848], [1136005200000, 5.2638869269803], [1138683600000, 5.5806167415681], [1141102800000, 5.4539047069985], [1143781200000, 7.6728842432362], [1146369600000, 7.719946716654], [1149048000000, 8.0144619912942], [1151640000000, 7.942223133434], [1154318400000, 8.3998279827444], [1156996800000, 8.532324572605], [1159588800000, 4.7324285199763], [1162270800000, 4.7402397487697], [1164862800000, 4.9042069355168], [1167541200000, 5.9583963430882], [1170219600000, 6.3693899239171], [1172638800000, 6.261153903813], [1175313600000, 5.3443942184584], [1177905600000, 5.4932111235361], [1180584000000, 5.5747393101109], [1183176000000, 5.3833633060013], [1185854400000, 5.5125898831832], [1188532800000, 5.8116112661327], [1191124800000, 4.3962296939996], [1193803200000, 4.6967663605521], [1196398800000, 4.7963004350914], [1199077200000, 4.1817985183351], [1201755600000, 4.3797643870182], [1204261200000, 4.6966642197965], [1206936000000, 4.3609995132565], [1209528000000, 4.4736290996496], [1212206400000, 4.3749762738128], [1214798400000, 3.3274661194507], [1217476800000, 3.0316184691337], [1220155200000, 2.5718140204728], [1222747200000, 2.7034994044603], [1225425600000, 2.2033786591364], [1228021200000, 1.9850621240805], [1230699600000, 0], [1233378000000, 0], [1235797200000, 0], [1238472000000, 0], [1241064000000, 0], [1243742400000, 0], [1246334400000, 0], [1249012800000, 0], [1251691200000, 0], [1254283200000, 0.44495950017788], [1256961600000, 0.33945469262483], [1259557200000, 0.38348269455195], [1262235600000, 0], [1264914000000, 0], [1267333200000, 0], [1270008000000, 0], [1272600000000, 0], [1275278400000, 0], [1277870400000, 0], [1280548800000, 0], [1283227200000, 0], [1285819200000, 0], [1288497600000, 0], [1291093200000, 0], [1293771600000, 0], [1296450000000, 0.52216435716176], [1298869200000, 0.59275786698454], [1301544000000, 0], [1304136000000, 0], [1306814400000, 0], [1309406400000, 0], [1312084800000, 0], [1314763200000, 0], [1317355200000, 0], [1320033600000, 0], [1322629200000, 0], [1325307600000, 0], [1327986000000, 0], [1330491600000, 0], [1333166400000, 0], [1335758400000, 0]]
                },

                {
                    'key'   : 'Antarctica',
                    'values': [[1025409600000, 1.3503144674343], [1028088000000, 1.2232741112434], [1030766400000, 1.3930470790784], [1033358400000, 1.2631275030593], [1036040400000, 1.5842699103708], [1038632400000, 1.9546996043116], [1041310800000, 0.8504048300986], [1043989200000, 0.85340686311353], [1046408400000, 0.843061357391], [1049086800000, 2.119846992476], [1051675200000, 2.5285382124858], [1054353600000, 2.5056570712835], [1056945600000, 2.5212789901005], [1059624000000, 2.6192011642534], [1062302400000, 2.5382187823805], [1064894400000, 2.3393223047168], [1067576400000, 2.491219888698], [1070168400000, 2.497555874906], [1072846800000, 1.734018115546], [1075525200000, 1.9307268299646], [1078030800000, 2.2261679836799], [1080709200000, 1.7608893704206], [1083297600000, 1.6242690616808], [1085976000000, 1.7161663801295], [1088568000000, 1.7183554537038], [1091246400000, 1.7179780759145], [1093924800000, 1.7314274801784], [1096516800000, 1.2596883356752], [1099195200000, 1.381177053009], [1101790800000, 1.4408819615814], [1104469200000, 3.4743581836444], [1107147600000, 3.3603749903192], [1109566800000, 3.5350883257893], [1112245200000, 3.0949644237828], [1114833600000, 3.0796455899995], [1117512000000, 3.3441247640644], [1120104000000, 4.0947643978168], [1122782400000, 4.4072631274052], [1125460800000, 4.4870979780825], [1128052800000, 4.8404549457934], [1130734800000, 4.8293016233697], [1133326800000, 5.2238093263952], [1136005200000, 3.382306337815], [1138683600000, 3.7056975170243], [1141102800000, 3.7561118692318], [1143781200000, 2.861913700854], [1146369600000, 2.9933744103381], [1149048000000, 2.7127537218463], [1151640000000, 3.1195497076283], [1154318400000, 3.4066964004508], [1156996800000, 3.3754571113569], [1159588800000, 2.2965579982924], [1162270800000, 2.4486818633018], [1164862800000, 2.4002308848517], [1167541200000, 1.9649579750349], [1170219600000, 1.9385263638056], [1172638800000, 1.9128975336387], [1175313600000, 2.3412869836298], [1177905600000, 2.4337870351445], [1180584000000, 2.62179703171], [1183176000000, 3.2642864957929], [1185854400000, 3.3200396223709], [1188532800000, 3.3934212707572], [1191124800000, 4.2822327088179], [1193803200000, 4.1474964228541], [1196398800000, 4.1477082879801], [1199077200000, 5.2947122916128], [1201755600000, 5.2919843508028], [1204261200000, 5.198978305031], [1206936000000, 3.5603057673513], [1209528000000, 3.3009087690692], [1212206400000, 3.1784852603792], [1214798400000, 4.5889503538868], [1217476800000, 4.401779617494], [1220155200000, 4.2208301828278], [1222747200000, 3.89396671475], [1225425600000, 3.0423832241354], [1228021200000, 3.135520611578], [1230699600000, 1.9631418164089], [1233378000000, 1.8963543874958], [1235797200000, 1.8266636017025], [1238472000000, 0.93136635895188], [1241064000000, 0.92737801918888], [1243742400000, 0.97591889805002], [1246334400000, 2.6841193805515], [1249012800000, 2.5664341140531], [1251691200000, 2.3887523699873], [1254283200000, 1.1737801663681], [1256961600000, 1.0953582317281], [1259557200000, 1.2495674976653], [1262235600000, 0.36607452464754], [1264914000000, 0.3548719047291], [1267333200000, 0.36769242398939], [1270008000000, 0], [1272600000000, 0], [1275278400000, 0], [1277870400000, 0], [1280548800000, 0], [1283227200000, 0], [1285819200000, 0.85450741275337], [1288497600000, 0.91360317921637], [1291093200000, 0.89647678692269], [1293771600000, 0.87800687192639], [1296450000000, 0], [1298869200000, 0], [1301544000000, 0.43668720882994], [1304136000000, 0.4756523602692], [1306814400000, 0.46947368328469], [1309406400000, 0.45138896152316], [1312084800000, 0.43828726648117], [1314763200000, 2.0820861395316], [1317355200000, 0.9364411075395], [1320033600000, 0.60583907839773], [1322629200000, 0.61096950747437], [1325307600000, 0], [1327986000000, 0], [1330491600000, 0], [1333166400000, 0], [1335758400000, 0]]
                }

            ]
        };

        vm.historicalBarChart = {
            options: {
                chart: {
                    type              : 'historicalBarChart',
                    height            : 450,
                    margin            : {
                        top   : 20,
                        right : 20,
                        bottom: 60,
                        left  : 50
                    },
                    x                 : function (d)
                    {
                        return d[0];
                    },
                    y                 : function (d)
                    {
                        return d[1] / 100000;
                    },
                    showValues        : true,
                    valueFormat       : function (d)
                    {
                        return d3.format(',.1f')(d);
                    },
                    transitionDuration: 500,
                    xAxis             : {
                        axisLabel   : 'X Axis',
                        tickFormat  : function (d)
                        {
                            return d3.time.format('%x')(new Date(d));
                        },
                        rotateLabels: 50,
                        showMaxMin  : false
                    },
                    yAxis             : {
                        axisLabel        : 'Y Axis',
                        axisLabelDistance: 35,
                        tickFormat       : function (d)
                        {
                            return d3.format(',.1f')(d);
                        }
                    }
                }
            },

            data: [
                {
                    'key'   : 'Quantity',
                    'bar'   : true,
                    'values': [[1159588800000, 3899486.0], [1162270800000, 3899486.0], [1164862800000, 3899486.0], [1167541200000, 3564700.0], [1170219600000, 3564700.0], [1172638800000, 3564700.0], [1175313600000, 2648493.0], [1177905600000, 2648493.0], [1180584000000, 2648493.0], [1183176000000, 2522993.0], [1185854400000, 2522993.0], [1188532800000, 2522993.0], [1191124800000, 2906501.0], [1193803200000, 2906501.0], [1196398800000, 2906501.0], [1199077200000, 2206761.0], [1201755600000, 2206761.0], [1204261200000, 2206761.0], [1206936000000, 2287726.0], [1209528000000, 2287726.0], [1212206400000, 2287726.0], [1214798400000, 2732646.0], [1217476800000, 2732646.0], [1220155200000, 2732646.0], [1222747200000, 2599196.0], [1225425600000, 2599196.0], [1228021200000, 2599196.0], [1230699600000, 1924387.0], [1233378000000, 1924387.0], [1235797200000, 1924387.0], [1238472000000, 1756311.0], [1241064000000, 1756311.0], [1243742400000, 1756311.0], [1246334400000, 1743470.0], [1249012800000, 1743470.0], [1251691200000, 1743470.0], [1254283200000, 1519010.0], [1256961600000, 1519010.0], [1259557200000, 1519010.0], [1262235600000, 1591444.0], [1264914000000, 1591444.0], [1267333200000, 1591444.0], [1270008000000, 1543784.0], [1272600000000, 1543784.0], [1275278400000, 1543784.0], [1277870400000, 1309915.0], [1280548800000, 1309915.0], [1283227200000, 1309915.0], [1285819200000, 1331875.0], [1288497600000, 1331875.0], [1291093200000, 1331875.0], [1293771600000, 1331875.0], [1296450000000, 1154695.0], [1298869200000, 1154695.0], [1301544000000, 1194025.0], [1304136000000, 1194025.0], [1306814400000, 1194025.0], [1309406400000, 1194025.0], [1312084800000, 1194025.0], [1314763200000, 1244525.0], [1317355200000, 475000.0], [1320033600000, 475000.0], [1322629200000, 475000.0], [1325307600000, 690033.0], [1327986000000, 690033.0], [1330491600000, 690033.0], [1333166400000, 514733.0], [1335758400000, 514733.0]]
                }]
        };

        vm.multiBarHorizontalChart = {
            options: {
                chart: {
                    type              : 'multiBarHorizontalChart',
                    height            : 450,
                    x                 : function (d)
                    {
                        return d.label;
                    },
                    y                 : function (d)
                    {
                        return d.value;
                    },
                    showControls      : true,
                    showValues        : true,
                    transitionDuration: 500,
                    xAxis             : {
                        showMaxMin: false
                    },
                    yAxis             : {
                        axisLabel : 'Values',
                        tickFormat: function (d)
                        {
                            return d3.format(',.2f')(d);
                        }
                    }
                }
            },
            data   : [
                {
                    'key'   : 'Series1',
                    'color' : '#d62728',
                    'values': [
                        {
                            'label': 'Group A',
                            'value': -1.8746444827653
                        },
                        {
                            'label': 'Group B',
                            'value': -8.0961543492239
                        },
                        {
                            'label': 'Group C',
                            'value': -0.57072943117674
                        },
                        {
                            'label': 'Group D',
                            'value': -2.4174010336624
                        },
                        {
                            'label': 'Group E',
                            'value': -0.72009071426284
                        },
                        {
                            'label': 'Group F',
                            'value': -0.77154485523777
                        },
                        {
                            'label': 'Group G',
                            'value': -0.90152097798131
                        },
                        {
                            'label': 'Group H',
                            'value': -0.91445417330854
                        },
                        {
                            'label': 'Group I',
                            'value': -0.055746319141851
                        }
                    ]
                },
                {
                    'key'   : 'Series2',
                    'color' : '#1f77b4',
                    'values': [
                        {
                            'label': 'Group A',
                            'value': 25.307646510375
                        },
                        {
                            'label': 'Group B',
                            'value': 16.756779544553
                        },
                        {
                            'label': 'Group C',
                            'value': 18.451534877007
                        },
                        {
                            'label': 'Group D',
                            'value': 8.6142352811805
                        },
                        {
                            'label': 'Group E',
                            'value': 7.8082472075876
                        },
                        {
                            'label': 'Group F',
                            'value': 5.259101026956
                        },
                        {
                            'label': 'Group G',
                            'value': 0.30947953487127
                        },
                        {
                            'label': 'Group H',
                            'value': 0
                        },
                        {
                            'label': 'Group I',
                            'value': 0
                        }
                    ]
                }
            ]
        };

        vm.pieChart = {
            options: {
                chart: {
                    type              : 'pieChart',
                    height            : 500,
                    x                 : function (d)
                    {
                        return d.key;
                    },
                    y                 : function (d)
                    {
                        return d.y;
                    },
                    showLabels        : true,
                    transitionDuration: 500,
                    labelThreshold    : 0.01,
                    legend            : {
                        margin: {
                            top   : 5,
                            right : 35,
                            bottom: 5,
                            left  : 0
                        }
                    }
                }
            },
            data   : [
                {
                    key: 'One',
                    y  : 5
                },
                {
                    key: 'Two',
                    y  : 2
                },
                {
                    key: 'Three',
                    y  : 9
                },
                {
                    key: 'Four',
                    y  : 7
                },
                {
                    key: 'Five',
                    y  : 4
                },
                {
                    key: 'Six',
                    y  : 3
                },
                {
                    key: 'Seven',
                    y  : 0.5
                }
            ]
        };

        vm.donutChart = {
            options: {
                chart: {
                    type      : 'pieChart',
                    height    : 450,
                    donut     : true,
                    x         : function (d)
                    {
                        return d.key;
                    },
                    y         : function (d)
                    {
                        return d.y;
                    },
                    showLabels: true,

                    pie               : {
                        startAngle: function (d)
                        {
                            return d.startAngle / 2 - Math.PI / 2;
                        },
                        endAngle  : function (d)
                        {
                            return d.endAngle / 2 - Math.PI / 2;
                        }
                    },
                    transitionDuration: 500,
                    legend            : {
                        margin: {
                            top   : 5,
                            right : 70,
                            bottom: 5,
                            left  : 0
                        }
                    }
                }
            },

            data: [
                {
                    key: 'One',
                    y  : 5
                },
                {
                    key: 'Two',
                    y  : 2
                },
                {
                    key: 'Three',
                    y  : 9
                },
                {
                    key: 'Four',
                    y  : 7
                },
                {
                    key: 'Five',
                    y  : 4
                },
                {
                    key: 'Six',
                    y  : 3
                },
                {
                    key: 'Seven',
                    y  : 0.5
                }
            ]

        };

        vm.sparklineChart = {
            options: {
                chart: {
                    type              : 'sparklinePlus',
                    height            : 450,
                    x                 : function (d, i)
                    {
                        return i;
                    },
                    xTickFormat       : function (d)
                    {
                        return d3.time.format('%x')(new Date(vm.sparklineChart.data[d].x));
                    },
                    transitionDuration: 250
                }
            },

            //$scope.data = sine();
            data: volatileChart(130.0, 0.02)
        };

        vm.bulletChart = {
            options: {
                chart: {
                    type              : 'bulletChart',
                    transitionDuration: 500
                }
            },
            data   : {
                'title'   : 'Revenue',
                'subtitle': 'US$, in thousands',
                'ranges'  : [150, 225, 300],
                'measures': [220],
                'markers' : [250]
            }
        };

        vm.scatterChart = {
            options: {
                chart: {
                    type              : 'scatterChart',
                    height            : 450,
                    color             : d3.scale.category10().range(),
                    scatter           : {
                        onlyCircles: false
                    },
                    showDistX         : true,
                    showDistY         : true,
                    tooltipContent    : function (key)
                    {
                        return '<h3>' + key + '</h3>';
                    },
                    transitionDuration: 350,
                    xAxis             : {
                        axisLabel : 'X Axis',
                        tickFormat: function (d)
                        {
                            return d3.format('.02f')(d);
                        }
                    },
                    yAxis             : {
                        axisLabel        : 'Y Axis',
                        tickFormat       : function (d)
                        {
                            return d3.format('.02f')(d);
                        },
                        axisLabelDistance: 30
                    }
                }
            },
            data   : generateData(4, 5)
        };

        // Methods


        //////////

        /*Random Data Generator */
        function sinAndCos()
        {
            var sin = [], sin2 = [],
                cos = [];

            //Data is represented as an array of {x,y} pairs.
            for ( var i = 0; i < 100; i++ )
            {
                sin.push({
                    x: i,
                    y: Math.sin(i / 10)
                });
                sin2.push({
                    x: i,
                    y: (i % 10 === 5 ? null : Math.sin(i / 10) * 0.25 + 0.5)
                });
                cos.push({
                    x: i,
                    y: 0.5 * Math.cos(i / 10 + 2) + Math.random() / 10
                });
            }

            //Line chart data should be sent as an array of series objects.
            return [
                {
                    values: sin,      //values - represents the array of {x,y} data points
                    key   : 'Sine Wave', //key  - the name of the series.
                    color : '#ff7f0e'  //color - optional: choose your own line color.
                },
                {
                    values: cos,
                    key   : 'Cosine Wave',
                    color : '#2ca02c'
                },
                {
                    values: sin2,
                    key   : 'Another sine wave',
                    color : '#7777ff',
                    area  : true      //area - set to true if you want this line to turn into a filled area chart.
                }
            ];
        }

        function volatileChart(startPrice, volatility, numPoints)
        {
            var rval = [];
            var now = +new Date();
            numPoints = numPoints || 100;
            for ( var i = 1; i < numPoints; i++ )
            {
                rval.push({
                    x: now + i * 1000 * 60 * 60 * 24,
                    y: startPrice
                });
                var rnd = Math.random();
                var changePct = 2 * volatility * rnd;
                if ( changePct > volatility )
                {
                    changePct -= (2 * volatility);
                }
                startPrice = startPrice + startPrice * changePct;
            }
            return rval;
        }

        /* Random Data Generator (took from nvd3.org) */
        function generateData(groups, points)
        {
            var data = [],
                shapes = ['circle', 'cross', 'triangle-up', 'triangle-down', 'diamond', 'square'],
                random = d3.random.normal();

            for ( var i = 0; i < groups; i++ )
            {
                data.push({
                    key   : 'Group ' + i,
                    values: []
                });

                for ( var j = 0; j < points; j++ )
                {
                    data[i].values.push(
                        {
                            x    : random(),
                            y    : random(),
                            size : Math.random(),
                            shape: shapes[j % 6]
                        });
                }
            }
            return data;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.chartist',
            [
                // 3rd Party Dependencies
                'angular-chartist'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_charts_chartist', {
            url  : '/components/charts/chartist',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/charts/chartist/chartist.html',
                    controller : 'ChartistController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.chartist')
        .controller('ChartistController', ChartistController);

    function ChartistController()
    {
        var vm = this;

        // Data

        // line chart
        vm.lineChart = {
            data   : {
                labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
                series: [
                    [12, 9, 7, 8, 5],
                    [2, 1, 3.5, 7, 3],
                    [1, 3, 4, 5, 6]
                ]
            },
            options: {
                fullWidth   : true,
                chartPadding: {
                    right: 40
                }
            }
        };

        // line Area chart
        vm.lineAreaChart = {
            data   : {
                labels: [1, 2, 3, 4, 5, 6, 7, 8],
                series: [
                    [5, 9, 7, 8, 5, 3, 5, 4]
                ]
            },
            options: {
                low     : 0,
                showArea: true
            }
        };

        vm.biPolarLineChart = {
            data   : {
                labels: [1, 2, 3, 4, 5, 6, 7, 8],
                series: [
                    [1, 2, 3, 1, -2, 0, 1, 0],
                    [-2, -1, -2, -1, -2.5, -1, -2, -1],
                    [0, 0, 0, 1, 2, 2.5, 2, 1],
                    [2.5, 2, 1, 0.5, 1, 0.5, -1, -2.5]
                ]
            },
            options: {
                high     : 3,
                low      : -3,
                showArea : true,
                showLine : false,
                showPoint: false,
                fullWidth: true,
                axisX    : {
                    showLabel: false,
                    showGrid : false
                }
            }
        };

        vm.stackedBarChart = {
            data   : {
                labels: ['Q1', 'Q2', 'Q3', 'Q4'],
                series: [
                    [800000, 1200000, 1400000, 1300000],
                    [200000, 400000, 500000, 300000],
                    [100000, 200000, 400000, 600000]
                ]
            },
            options: {
                stackBars: true,
                axisY    : {
                    labelInterpolationFnc: function (value)
                    {
                        return (value / 1000) + 'k';
                    }
                }
            },
            events : {
                draw: function (data)
                {
                    if ( data.type === 'bar' )
                    {
                        data.element.attr({
                            style: 'stroke-width: 30px'
                        });
                    }
                }
            }
        };

        // bar chart
        vm.barChart = {
            data             : {
                labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                series: [
                    [5, 4, 3, 7, 5, 10, 3, 4, 8, 10, 6, 8],
                    [3, 2, 9, 5, 4, 6, 4, 6, 7, 8, 7, 4]
                ]
            },
            options          : {
                seriesBarDistance: 15
            },
            responsiveOptions: [
                ['screen and (min-width: 641px) and (max-width: 1024px)', {
                    seriesBarDistance: 10,
                    axisX            : {
                        labelInterpolationFnc: function (value)
                        {
                            return value;
                        }
                    }
                }],
                ['screen and (max-width: 640px)', {
                    seriesBarDistance: 5,
                    axisX            : {
                        labelInterpolationFnc: function (value)
                        {
                            return value[0];
                        }
                    }
                }]
            ]
        };

        // Horizontal bar chart
        vm.horizontalBarChart = {
            data   : {
                labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
                series: [
                    [5, 4, 3, 7, 5, 10, 3],
                    [3, 2, 9, 5, 4, 6, 4]
                ]
            },
            options: {
                seriesBarDistance: 10,
                reverseData      : true,
                horizontalBars   : true,
                axisY            : {
                    offset: 70
                }
            }
        };

        vm.biPolarBarChart = {
            data   : {
                labels: ['W1', 'W2', 'W3', 'W4', 'W5', 'W6', 'W7', 'W8', 'W9', 'W10'],
                series: [
                    [1, 2, 4, 8, 6, -2, -1, -4, -6, -2]
                ]
            },
            options: {
                high : 10,
                low  : -10,
                axisX: {
                    labelInterpolationFnc: function (value, index)
                    {
                        return index % 2 === 0 ? value : null;
                    }
                }
            }
        };

        // pie chart
        vm.pieChart = {
            data             : {
                labels: ['Bananas', 'Apples', 'Grapes'],
                series: [20, 15, 40]
            },
            options          : {
                labelInterpolationFnc: function (value)
                {
                    return value[0];
                }
            },
            responsiveOptions: [
                ['screen and (min-width: 640px)', {
                    chartPadding         : 40,
                    labelOffset          : 150,
                    labelDirection       : 'explode',
                    labelInterpolationFnc: function (value)
                    {
                        return value;
                    }
                }],
                ['screen and (min-width: 1024px)', {
                    labelOffset : 120,
                    chartPadding: 30
                }]
            ]

        };

        // donut chart
        vm.donutChart = {
            data   : {
                series: [20, 10, 30, 40]
            },
            options: {
                donut: true
            }
        };

        vm.gaugeChart = {
            data   : {
                series: [20, 10, 30, 40]
            },
            options: {
                donut     : true,
                donutWidth: 60,
                startAngle: 270,
                total     : 200,
                showLabel : true
            }
        };
        // Methods

        //////////

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.chart-js',
            [
                // 3rd Party Dependencies
                'chart.js'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_charts_chart-js', {
            url  : '/components/charts/chart-js',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/charts/chart-js/chart-js.html',
                    controller : 'ChartJsController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.chart-js')
        .controller('ChartJsController', ChartJsController);

    function ChartJsController()
    {
        var vm = this;

        // Data
        vm.lineChart = {
            labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
            series: ['Series A', 'Series B'],
            data  : [
                [65, 59, 80, 81, 56, 55, 40],
                [28, 48, 40, 19, 86, 27, 90]
            ]
        };

        vm.barChart = {
            labels: ['2006', '2007', '2008', '2009', '2010', '2011', '2012'],
            series: ['Series A', 'Series B'],
            data  : [
                [65, 59, 80, 81, 56, 55, 40],
                [28, 48, 40, 19, 86, 27, 90]
            ]
        };

        vm.doughnutChart = {
            labels: ['Download Sales', 'In-Store Sales', 'Mail-Order Sales'],
            data  : [300, 500, 100]
        };

        vm.radarChart = {
            labels: ['Eating', 'Drinking', 'Sleeping', 'Designing', 'Coding', 'Cycling', 'Running'],
            data  : [
                [65, 59, 90, 81, 56, 55, 40],
                [28, 48, 40, 19, 96, 27, 100]
            ]
        };

        vm.pieChart = {
            labels: ['Download Sales', 'In-Store Sales', 'Mail-Order Sales'],
            data  : [300, 500, 100]
        };

        vm.polarChart = {
            labels: ['Download Sales', 'In-Store Sales', 'Mail-Order Sales', 'Tele Sales', 'Corporate Sales'],
            data  : [300, 500, 100, 40, 120]
        };

        // Methods

        //////////

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.c3',
            [
                // 3rd Party Dependencies
                'gridshore.c3js.chart'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_charts_c3', {
            url  : '/components/charts/c3',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/charts/c3/c3.html',
                    controller : 'C3Controller as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.c3')
        .controller('C3Controller', C3Controller);

    function C3Controller()
    {
        var vm = this;

        // Data

        // Methods

        //////////

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('CardFilters', CardFiltersService);

    /** @ngInject */
    function CardFiltersService()
    {
        var service = {
            name   : '',
            labels : [],
            members: [],
            clear  : clear,
            isOn   : isOn
        };

        /**
         * Clear
         */
        function clear()
        {
            service.name = '';
            service.labels = [];
            service.members = [];
        }

        /**
         * Is on
         *
         * @returns {boolean}
         */
        function isOn()
        {
            return (service.name === '' && service.labels.length === 0 && service.members.length === 0 ) ? false : true;
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('DialogService', DialogService);

    /** @ngInject */
    function DialogService($mdDialog, $document)
    {
        var service = {
            openCardDialog: openCardDialog
        };

        //////////

        /**
         * Open card dialog
         *
         * @param ev
         * @param cardId
         */
        function openCardDialog(ev, cardId)
        {
            $mdDialog.show({
                templateUrl        : 'app/main/apps/scrumboard/dialogs/card/card-dialog.html',
                controller         : 'ScrumboardCardDialogController',
                controllerAs       : 'vm',
                parent             : $document.find('#scrumboard'),
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                locals             : {
                    cardId: cardId
                }
            });
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('BoardService', BoardService);

    /** @ngInject */
    function BoardService($q, msApi)
    {
        var service = {
            data        : {},
            addNewBoard : addNewBoard,
            getBoardData: getBoardData
        };

        /**
         * Get board data from the server
         *
         * @param boardId
         * @returns {*}
         */
        function getBoardData(boardId)
        {
            // Create a new deferred object
            var deferred = $q.defer();

            msApi.request('scrumboard.board@get', {id: boardId},

                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        /**
         * Create an empty board object and set it.
         *
         * For the demonstration purposes, we are creating the
         * empty object in the javascript which you wouldn't do
         * it in real life. Rather, you would make an API call
         * to your server to generate an empty object that fills
         * some of the areas for you like an ID, labels, members
         * or the default board settings.
         *
         * Then you would grab the response that comes from
         * the API call and attach it to the service.data object.
         */
        function addNewBoard()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Here you would make an API call to your server...
            _generateEmptyScrumboardObject().then(
                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the response
                    deferred.resolve(response);
                },
                // ERROR
                function (response)
                {
                    // Reject the response
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        /**
         * Dummy function for generating an empty
         * scrumboard object for demonstration
         * purposes
         *
         * @private
         * returns {$promise}
         */
        function _generateEmptyScrumboardObject()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Fake id generator
            var id = parseInt(new Date().valueOf(), 16);

            // Prepare an empty scrumboard object
            var emptyObject = {
                data: {
                    name    : 'Untitled Board',
                    uri     : 'untitled-board',
                    id      : id,
                    settings: {
                        color          : '',
                        subscribed     : false,
                        cardCoverImages: true
                    },
                    lists   : [],
                    cards   : [],
                    members : [
                        {
                            id    : '56027c1930450d8bf7b10758',
                            name  : 'Alice Freeman',
                            avatar: 'assets/images/avatars/alice.jpg'
                        },
                        {
                            id    : '26027s1930450d8bf7b10828',
                            name  : 'Danielle Obrien',
                            avatar: 'assets/images/avatars/danielle.jpg'
                        },
                        {
                            id    : '76027g1930450d8bf7b10958',
                            name  : 'James Lewis',
                            avatar: 'assets/images/avatars/james.jpg'
                        },
                        {
                            id    : '36027j1930450d8bf7b10158',
                            name  : 'Vincent Munoz',
                            avatar: 'assets/images/avatars/vincent.jpg'
                        }
                    ],
                    labels  : [
                        {
                            id   : '26022e4129ad3a5sc28b36cd',
                            name : 'High Priority',
                            color: 'red'
                        },
                        {
                            id   : '56027e4119ad3a5dc28b36cd',
                            name : 'Design',
                            color: 'orange'
                        },
                        {
                            id   : '5640635e19ad3a5dc21416b2',
                            name : 'App',
                            color: 'blue'
                        },
                        {
                            id   : '6540635g19ad3s5dc31412b2',
                            name : 'Feature',
                            color: 'green'
                        }
                    ]
                }
            };

            // Resolve the promise
            deferred.resolve(emptyObject);

            return deferred.promise;
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .factory('NotesService', NotesService);

    /** @ngInject */
    function NotesService(msApi, $q)
    {
        var service = {
            data      : [],
            addNote   : addNote,
            updateNote: updateNote,
            deleteNote: deleteNote,
            getData   : getData
        };

        /**
         * Add Note
         * @param note
         */
        function addNote(note)
        {
            service.data.push(note);
        }

        /**
         * Update Note
         * @param note
         */
        function updateNote(note)
        {
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === note.id )
                {
                    service.data[i] = note;
                }
            }
        }

        /**
         * Delete Note
         * @param note
         */
        function deleteNote(note)
        {
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === note.id )
                {
                    service.data.splice(i, 1);
                }
            }
        }

        /**
         * Get service data
         * @returns {Array}
         */
        function getData()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            msApi.request('notes.notes@get', {},
                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        return service;

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .factory('LabelsService', LabelsService);

    /** @ngInject */
    function LabelsService(msUtils, NotesService, msApi, $q)
    {
        var service = {
            data       : [],
            addLabel   : addLabel,
            updateLabel: updateLabel,
            deleteLabel: deleteLabel,
            getData    : getData
        };

        /**
         * Add label
         * @param newLabel
         */
        function addLabel(newLabel)
        {
            if ( newLabel.name === '' )
            {
                return;
            }

            service.data.push({
                id   : msUtils.guidGenerator(),
                name : newLabel.name,
                color: newLabel.color || ''
            });
        }

        /**
         * Update Label
         * @param note
         */
        function updateLabel(note)
        {
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === note.id )
                {
                    service.data[i] = note;
                }
            }
        }

        /**
         * Delete Label
         * @param label
         */
        function deleteLabel(label)
        {
            var notes = NotesService.data;

            // Look for all notes if they have the labels
            for ( var j = 0; j < notes.length; j++ )
            {
                if ( notes[j].labels.indexOf(label.id) > -1 )
                {
                    notes[j].labels.splice(notes[j].labels.indexOf(label.id), 1);
                }
            }

            // Delete label from service data
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === label.id )
                {
                    service.data.splice(i, 1);
                }
            }

        }

        /**
         * Get service data
         * @returns {Array}
         */
        function getData()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            msApi.request('notes.labels@get', {},
                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        return service;

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .factory('eCommerceService', eCommerceService);

    /** @ngInject */
    function eCommerceService($q, $mdToast, msApi)
    {
        var products = [],
            orders = [],
            orderStatuses = [];

        var service = {
            getProducts     : getProducts,
            getProduct      : getProduct,
            updateProduct   : updateProduct,
            newProduct      : newProduct,
            createProduct   : createProduct,
            getOrders       : getOrders,
            getOrder        : getOrder,
            getOrderStatuses: getOrderStatuses
        };

        return service;

        //////////

        /**
         * Get products
         */
        function getProducts()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // If we have already loaded the products,
            // don't do another API call, get them from
            // the array
            if ( products.length > 0 )
            {
                deferred.resolve(products);
            }
            // otherwise make an API call and load
            // the products
            else
            {
                msApi.request('e-commerce.products@get', {},

                    // SUCCESS
                    function (response)
                    {
                        // Store the products
                        products = response.data;

                        // Resolve the promise
                        deferred.resolve(products);
                    },

                    // ERROR
                    function (response)
                    {
                        // Reject the promise
                        deferred.reject(response);
                    }
                );
            }

            return deferred.promise;
        }

        /**
         * Get product by id
         *
         * @param id
         */
        function getProduct(id)
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Iterate through the products and find
            // the correct one. This is an unnecessary
            // code as in real world, you would do
            // another API call here to get the product
            // details
            for ( var i = 0; i < products.length; i++ )
            {
                if ( parseInt(products[i].id) === parseInt(id) )
                {
                    deferred.resolve(products[i]);
                }
            }

            return deferred.promise;
        }

        /**
         * Update the product
         *
         * @param id
         * @param product
         */
        function updateProduct(id, product)
        {
            // This is a dummy function for the demo.
            // In real world, you would use this
            // function to make another API call to
            // update your database.
            console.info('The product with the id of', id, 'has been updated with the following information:', product);
        }

        /**
         * Returns a default product structure
         */
        function newProduct()
        {
            return {
                categories      : ['None'],
                images          : [
                    {
                        default: true,
                        id     : 1,
                        url    : 'assets/images/ecommerce/product-image-placeholder.png',
                        type   : 'image'
                    }
                ],
                priceTaxExcl    : 0,
                priceTaxIncl    : 0,
                taxRate         : 0,
                quantity        : 0,
                extraShippingFee: 0,
                active          : false
            };
        }

        /**
         * Create product
         *
         * @param product
         */
        function createProduct(product)
        {
            // This is a dummy function for a demo.
            // In real world, you would do an API
            // call to add new product to your
            // database.

            // Generate a random id
            product.id = Math.floor((Math.random() * 10) + 1);

            // Add the product
            products.unshift(product);

            // Show a toast
            $mdToast.show(
                $mdToast.simple()
                    .textContent('Product created!')
                    .position('top right')
            );
        }

        /**
         * Get orders
         */
        function getOrders()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // If we have already loaded the orders,
            // don't do another API call, get them from
            // the array
            if ( orders.length > 0 )
            {
                deferred.resolve(orders);
            }
            // otherwise make an API call and load
            // the orders
            else
            {
                msApi.request('e-commerce.orders@get', {},

                    // SUCCESS
                    function (response)
                    {
                        // Store the orders
                        orders = response.data;

                        // Resolve the promise
                        deferred.resolve(orders);
                    },

                    // ERROR
                    function (response)
                    {
                        // Reject the promise
                        deferred.reject(response);
                    }
                );
            }

            return deferred.promise;
        }

        /**
         * Get order by id
         *
         * @param id
         */
        function getOrder(id)
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Iterate through the orders and find
            // the correct one. This is an unnecessary
            // code as in real world, you would do
            // another API call here to get the order
            // details
            for ( var i = 0; i < orders.length; i++ )
            {
                if ( parseInt(orders[i].id) === parseInt(id) )
                {
                    deferred.resolve(orders[i]);
                }
            }

            return deferred.promise;
        }

        /**
         * Get order statuses
         */
        function getOrderStatuses()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // If we have already loaded the order statuses,
            // don't do another API call, get them from
            // the array
            if ( orderStatuses.length > 0 )
            {
                deferred.resolve(orderStatuses);
            }
            // otherwise make an API call and load
            // the order statuses
            else
            {
                msApi.request('e-commerce.order-statuses@get', {},

                    // SUCCESS
                    function (response)
                    {
                        // Store the order statuses
                        orderStatuses = response.data;

                        // Resolve the promise
                        deferred.resolve(orderStatuses);
                    },

                    // ERROR
                    function (response)
                    {
                        // Reject the promise
                        deferred.reject(response);
                    }
                );
            }

            return deferred.promise;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.project',
            [
                // 3rd Party Dependencies
                'nvd3',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.dashboards_project', {
            url      : '/dashboard-project',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/project/dashboard-project.html',
                    controller : 'DashboardProjectController as vm'
                }
            },
            resolve  : {
                DashboardData: function (msApi)
                {
                    return msApi.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'dashboard-project'
        });

        // Api
        msApiProvider.register('dashboard.project', ['app/data/dashboard/project/data.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.project')
        .controller('DashboardProjectController', DashboardProjectController);

    /** @ngInject */
    function DashboardProjectController($scope, $interval, $mdSidenav, DashboardData)
    {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;
        vm.projects = vm.dashboardData.projects;

        // Widget 1
        vm.widget1 = vm.dashboardData.widget1;

        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;

        // Widget 5
        vm.widget5 = {
            title       : vm.dashboardData.widget5.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'multiBarChart',
                        color       : ['#03a9f4', '#b3e5fc'],
                        height      : 420,
                        margin      : {
                            top   : 8,
                            right : 16,
                            bottom: 32,
                            left  : 32
                        },
                        clipEdge    : true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked     : true,
                        duration    : 250,
                        x           : function (d)
                        {
                            return d.x;
                        },
                        y           : function (d)
                        {
                            return d.y;
                        },
                        yAxis       : {
                            tickFormat: function (d)
                            {
                                return d;
                            }
                        },
                        legend      : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        controls    : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            supporting  : {
                widgets: {
                    created  : {
                        data : vm.dashboardData.widget5.supporting.created,
                        chart: {
                            data: []
                        }
                    },
                    closed   : {
                        data : vm.dashboardData.widget5.supporting.closed,
                        chart: {
                            data: []
                        }
                    },
                    reOpened : {
                        data : vm.dashboardData.widget5.supporting.reOpened,
                        chart: {
                            data: []
                        }
                    },
                    wontFix  : {
                        data : vm.dashboardData.widget5.supporting.wontFix,
                        chart: {
                            data: []
                        }
                    },
                    needsTest: {
                        data : vm.dashboardData.widget5.supporting.needsTest,
                        chart: {
                            data: []
                        }
                    },
                    fixed    : {
                        data : vm.dashboardData.widget5.supporting.fixed,
                        chart: {
                            data: []
                        }
                    }
                },
                chart  : {
                    config : {
                        refreshDataOnly: true,
                        deepWatchData  : true
                    },
                    options: {
                        chart: {
                            type                   : 'lineChart',
                            color                  : ['#03A9F4'],
                            height                 : 50,
                            margin                 : {
                                top   : 8,
                                right : 0,
                                bottom: 0,
                                left  : 0
                            },
                            isArea                 : true,
                            interpolate            : 'cardinal',
                            clipEdge               : true,
                            duration               : 500,
                            showXAxis              : false,
                            showYAxis              : false,
                            showLegend             : false,
                            useInteractiveGuideline: true,
                            x                      : function (d)
                            {
                                return d.x;
                            },
                            y                      : function (d)
                            {
                                return d.y;
                            },
                            yDomain                : [0, 9],
                            xAxis                  : {
                                tickFormat: function (d)
                                {
                                    return vm.widget5.days[d];
                                }
                            },
                            interactiveLayer       : {
                                tooltip: {
                                    gravity: 'e',
                                    classes: 'gravity-e'
                                }
                            }
                        }
                    },
                    data   : []
                }
            },
            days        : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges      : vm.dashboardData.widget5.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget5.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget5.mainChart, function (chartData, index)
                {
                    vm.widget5.mainChart.data[index] = {
                        key   : chartData.key,
                        values: chartData.values[range]
                    };
                });

                /**
                 * Do the same thing for the supporting widgets but they
                 * only have 1 dataset so we can do [0] without needing to
                 * iterate through in their data arrays
                 */
                angular.forEach(vm.dashboardData.widget5.supporting, function (widget, name)
                {
                    vm.widget5.supporting.widgets[name].chart.data[0] = {
                        key   : widget.chart.key,
                        values: widget.chart.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget5.changeRange('TW');
            }
        };

        // Widget 6
        vm.widget6 = {
            title       : vm.dashboardData.widget6.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'pieChart',
                        color       : ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height      : 400,
                        margin      : {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        donut       : true,
                        clipEdge    : true,
                        cornerRadius: 0,
                        labelType   : 'percent',
                        padAngle    : 0.02,
                        x           : function (d)
                        {
                            return d.label;
                        },
                        y           : function (d)
                        {
                            return d.value;
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            footerLeft  : vm.dashboardData.widget6.footerLeft,
            footerRight : vm.dashboardData.widget6.footerRight,
            ranges      : vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget6.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget6.mainChart, function (data, index)
                {
                    vm.widget6.mainChart.data[index] = {
                        label: data.label,
                        value: data.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget6.changeRange('TW');
            }
        };

        // Widget 7
        vm.widget7 = {
            title       : vm.dashboardData.widget7.title,
            ranges      : vm.dashboardData.widget7.ranges,
            schedule    : vm.dashboardData.widget7.schedule,
            currentRange: 'T'
        };

        // Widget 8
        vm.widget8 = {
            title    : vm.dashboardData.widget8.title,
            mainChart: {
                options: {
                    chart: {
                        type     : 'pieChart',
                        color    : ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height   : 400,
                        margin   : {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        labelType: 'percent',
                        x        : function (d)
                        {
                            return d.label;
                        },
                        y        : function (d)
                        {
                            return d.value;
                        },
                        tooltip  : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : vm.dashboardData.widget8.mainChart
            }
        };

        // Widget 9
        vm.widget9 = {
            title       : vm.dashboardData.widget9.title,
            weeklySpent : {
                title    : vm.dashboardData.widget9.weeklySpent.title,
                count    : vm.dashboardData.widget9.weeklySpent.count,
                chartData: []
            },
            totalSpent  : {
                title    : vm.dashboardData.widget9.totalSpent.title,
                count    : vm.dashboardData.widget9.totalSpent.count,
                chartData: []
            },
            remaining   : {
                title    : vm.dashboardData.widget9.remaining.title,
                count    : vm.dashboardData.widget9.remaining.count,
                chartData: []
            },
            totalBudget : vm.dashboardData.widget9.totalBudget,
            chart       : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#00BCD4'],
                        height                 : 50,
                        margin                 : {
                            top   : 8,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        yDomain                : [0, 9],
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                return vm.widget9.days[d];
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 'e',
                                classes: 'gravity-e'
                            }
                        }
                    }
                }
            },
            days        : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges      : vm.dashboardData.widget9.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget9.currentRange = range;

                /**
                 * Update mini charts. They only have 1 dataset
                 * so we can do [0] without needing to iterate
                 * through in their data arrays
                 */
                vm.widget9.weeklySpent.chartData[0] = {
                    key   : vm.dashboardData.widget9.weeklySpent.chart.label,
                    values: vm.dashboardData.widget9.weeklySpent.chart.values[range]
                };

                vm.widget9.totalSpent.chartData[0] = {
                    key   : vm.dashboardData.widget9.totalSpent.chart.label,
                    values: vm.dashboardData.widget9.totalSpent.chart.values[range]
                };

                vm.widget9.remaining.chartData[0] = {
                    key   : vm.dashboardData.widget9.remaining.chart.label,
                    values: vm.dashboardData.widget9.remaining.chart.values[range]
                };
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget9.changeRange('TW');
            }
        };

        // Widget 10
        vm.widget10 = vm.dashboardData.widget10;

        // Widget 11
        vm.widget11 = {
            title    : vm.dashboardData.widget11.title,
            table    : vm.dashboardData.widget11.table,
            dtOptions: {
                dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth : false,
                responsive: true,
                order     : [1, 'asc'],
                columnDefs: [
                    {
                        width    : '40',
                        orderable: false,
                        targets  : [0]
                    },
                    {
                        width  : '20%',
                        targets: [1, 2, 3, 4, 5]
                    }
                ]
            }
        };

        // Now widget
        vm.nowWidget = {
            now   : {
                second: '',
                minute: '',
                hour  : '',
                day   : '',
                month : '',
                year  : ''
            },
            ticker: function ()
            {
                var now = moment();
                vm.nowWidget.now = {
                    second : now.format('ss'),
                    minute : now.format('mm'),
                    hour   : now.format('HH'),
                    day    : now.format('D'),
                    weekDay: now.format('dddd'),
                    month  : now.format('MMMM'),
                    year   : now.format('YYYY')
                };
            }
        };

        // Weather widget
        vm.weatherWidget = vm.dashboardData.weatherWidget;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProject = selectProject;

        //////////
        vm.selectedProject = vm.projects[0];

        // Initialize Widget 5
        vm.widget5.init();

        // Initialize Widget 6
        vm.widget6.init();

        // Initialize Widget 9
        vm.widget9.init();

        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function ()
        {
            $interval.cancel(nowWidgetTicker);
        });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select project
         */
        function selectProject(project)
        {
            vm.selectedProject = project;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.server',
            [
                // 3rd Party Dependencies
                'nvd3',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.dashboards_server', {
            url      : '/dashboard-server',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/server/dashboard-server.html',
                    controller : 'DashboardServerController as vm'
                }
            },
            resolve  : {
                DashboardData: function (msApi)
                {
                    return msApi.resolve('dashboard.server@get');
                }
            },
            bodyClass: 'dashboard-server'
        });

        // Api
        msApiProvider.register('dashboard.server', ['app/data/dashboard/server/data.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.server')
        .controller('DashboardServerController', DashboardServerController);

    /** @ngInject */
    function DashboardServerController($scope, $interval, DashboardData)
    {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;

        // Widget 1
        vm.widget1 = {
            title: vm.dashboardData.widget1.title,
            chart: {
                options: {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#4caf50', '#3f51b5', '#ff5722'],
                        height                 : 320,
                        margin                 : {
                            top   : 32,
                            right : 32,
                            bottom: 32,
                            left  : 48
                        },
                        useInteractiveGuideline: true,
                        clipVoronoi            : false,
                        interpolate            : 'cardinal',
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + ' min.';
                            },
                            showMaxMin: false
                        },
                        yAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + ' MB';
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        },
                        legend                 : {
                            margin    : {
                                top   : 8,
                                right : 0,
                                bottom: 32,
                                left  : 0
                            },
                            rightAlign: false
                        }
                    }
                },
                data   : vm.dashboardData.widget1.chart
            }
        };

        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = {
            title   : vm.dashboardData.widget4.title,
            value   : vm.dashboardData.widget4.value,
            footnote: vm.dashboardData.widget4.footnote,
            detail  : vm.dashboardData.widget4.detail,
            chart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'lineChart',
                        color       : ['rgba(0, 0, 0, 0.27)'],
                        height      : 50,
                        margin      : {
                            top   : 8,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        duration    : 1,
                        clipEdge    : true,
                        interpolate : 'cardinal',
                        interactive : false,
                        isArea      : true,
                        showLegend  : false,
                        showControls: false,
                        showXAxis   : false,
                        showYAxis   : false,
                        x           : function (d)
                        {
                            return d.x;
                        },
                        y           : function (d)
                        {
                            return d.y;
                        },
                        yDomain     : [0, 4]
                    }
                },
                data   : vm.dashboardData.widget4.chart
            },
            init    : function ()
            {
                // Run this function once to initialize the widget

                // Grab the x value
                var lastIndex = vm.dashboardData.widget4.chart[0].values.length - 1,
                    x = vm.dashboardData.widget4.chart[0].values[lastIndex].x;

                /**
                 * Emulate constant data flow
                 *
                 * @param min
                 * @param max
                 */
                function latencyTicker(min, max)
                {
                    // Increase the x value
                    x++;

                    var randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

                    var newValue = {
                        x: x,
                        y: randomNumber
                    };

                    vm.widget4.chart.data[0].values.shift();
                    vm.widget4.chart.data[0].values.push(newValue);

                    // Randomize the value
                    vm.widget4.value = 20 + randomNumber + 'ms';
                }

                // Set interval
                var latencyTickerInterval = $interval(function ()
                {
                    latencyTicker(1, 4);
                }, 1000);

                // Cleanup
                $scope.$on('$destroy', function ()
                {
                    $interval.cancel(latencyTickerInterval);
                });
            }
        };

        // Widget 5
        vm.widget5 = vm.dashboardData.widget5;

        // Widget 6
        vm.widget6 = {
            title: vm.dashboardData.widget6.title,
            chart: {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#03A9F4'],
                        height                 : 140,
                        margin                 : {
                            top   : 8,
                            right : 32,
                            bottom: 16,
                            left  : 48
                        },
                        duration               : 1,
                        clipEdge               : true,
                        clipVoronoi            : false,
                        interpolate            : 'cardinal',
                        isArea                 : true,
                        useInteractiveGuideline: true,
                        showLegend             : false,
                        showControls           : false,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        yDomain                : [0, 100],
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + ' sec.';
                            },
                            showMaxMin: false
                        },
                        yAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + '%';
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data   : vm.dashboardData.widget6.chart
            },
            init : function ()
            {
                // Run this function once to initialize the widget

                // Grab the x value
                var lastIndex = vm.dashboardData.widget6.chart[0].values.length - 1,
                    x = vm.dashboardData.widget6.chart[0].values[lastIndex].x;

                /**
                 * Emulate constant data flow
                 *
                 * @param min
                 * @param max
                 */
                function cpuTicker(min, max)
                {
                    // Increase the x value
                    x = x + 5;

                    var newValue = {
                        x: x,
                        y: Math.floor(Math.random() * (max - min + 1)) + min
                    };

                    vm.widget6.chart.data[0].values.shift();
                    vm.widget6.chart.data[0].values.push(newValue);
                }

                // Set interval
                var cpuTickerInterval = $interval(function ()
                {
                    cpuTicker(0, 100);
                }, 5000);

                // Cleanup
                $scope.$on('$destroy', function ()
                {
                    $interval.cancel(cpuTickerInterval);
                });
            }
        };

        // Widget 7
        vm.widget7 = {
            title    : vm.dashboardData.widget7.title,
            table    : vm.dashboardData.widget7.table,
            dtOptions: {
                dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                pageLength: 10,
                lengthMenu: [10, 20, 50, 100],
                autoWidth : false,
                responsive: true,
                columnDefs: [
                    {
                        width  : '20%',
                        targets: [0, 1, 2, 3, 4]
                    }
                ],
                columns   : [
                    {},
                    {},
                    {
                        render: function (data, type)
                        {
                            if ( type === 'display' )
                            {
                                return data + ' KB/s';
                            }
                            else
                            {
                                return data;
                            }
                        }
                    },
                    {
                        render: function (data, type)
                        {
                            if ( type === 'display' )
                            {
                                return data + '%';
                            }
                            else
                            {
                                return data;
                            }
                        }
                    },
                    {
                        render: function (data, type)
                        {
                            if ( type === 'display' )
                            {
                                var el = angular.element(data);
                                el.html(el.text() + ' MB');

                                return el[0].outerHTML;
                            }
                            else
                            {
                                return data;
                            }
                        }
                    }
                ]
            }
        };

        // Widget 8
        vm.widget8 = vm.dashboardData.widget8;

        // Methods

        //////////

        // Init Widget 4
        vm.widget4.init();

        // Init Widget 6
        vm.widget6.init();
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.analytics',
            [
                // 3rd Party Dependencies
                'nvd3'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.dashboards_analytics', {
            url      : '/dashboard-analytics',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/analytics/dashboard-analytics.html',
                    controller : 'DashboardAnalyticsController as vm'
                }
            },
            resolve  : {
                DashboardData: function (msApi)
                {
                    return msApi.resolve('dashboard.analytics@get');
                }
            },
            bodyClass: 'dashboard-analytics'
        });

        // Api
        msApiProvider.register('dashboard.analytics', ['app/data/dashboard/analytics/data.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.analytics')
        .controller('DashboardAnalyticsController', DashboardAnalyticsController);

    /** @ngInject */
    function DashboardAnalyticsController(DashboardData, uiGmapGoogleMapApi)
    {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];

        vm.widget1 = {
            title             : vm.dashboardData.widget1.title,
            onlineUsers       : vm.dashboardData.widget1.onlineUsers,
            bigChart          : {
                options: {
                    chart: {
                        type                   : 'lineWithFocusChart',
                        color                  : ['#2196F3'],
                        height                 : 400,
                        margin                 : {
                            top   : 32,
                            right : 32,
                            bottom: 64,
                            left  : 48
                        },
                        isArea                 : true,
                        useInteractiveGuideline: true,
                        duration               : 1,
                        clipEdge               : true,
                        clipVoronoi            : false,
                        interpolate            : 'cardinal',
                        showLegend             : false,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            showMaxMin: false,
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%b %d')(date);
                            }
                        },
                        yAxis                  : {
                            showMaxMin: false
                        },
                        x2Axis                 : {
                            showMaxMin: false,
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%b %d')(date);
                            }
                        },
                        y2Axis                 : {
                            showMaxMin: false
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        },
                        legend                 : {
                            margin    : {
                                top   : 8,
                                right : 0,
                                bottom: 32,
                                left  : 0
                            },
                            rightAlign: false
                        }
                    }
                },
                data   : vm.dashboardData.widget1.bigChart.chart
            },
            sessions          : {
                title   : vm.dashboardData.widget1.sessions.title,
                value   : vm.dashboardData.widget1.sessions.value,
                previous: vm.dashboardData.widget1.sessions.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#03A9F4'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.sessions.chart
            },
            pageviews         : {
                title   : vm.dashboardData.widget1.pageviews.title,
                value   : vm.dashboardData.widget1.pageviews.value,
                previous: vm.dashboardData.widget1.pageviews.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#3F51B5'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.pageviews.chart
            },
            pagesSessions     : {
                title   : vm.dashboardData.widget1.pagesSessions.title,
                value   : vm.dashboardData.widget1.pagesSessions.value,
                previous: vm.dashboardData.widget1.pagesSessions.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#E91E63'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.pagesSessions.chart
            },
            avgSessionDuration: {
                title   : vm.dashboardData.widget1.avgSessionDuration.title,
                value   : vm.dashboardData.widget1.avgSessionDuration.value,
                previous: vm.dashboardData.widget1.avgSessionDuration.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#009688'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        yAxis                  : {
                            tickFormat: function (d)
                            {
                                var formatTime = d3.time.format('%M:%S');
                                return formatTime(new Date('2012', '0', '1', '0', '0', d));
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.avgSessionDuration.chart
            }
        };

        // Widget 2
        vm.widget2 = {
            title: vm.dashboardData.widget2.title
        };

        // Widget 3
        vm.widget3 = {
            title       : vm.dashboardData.widget3.title,
            pages       : vm.dashboardData.widget3.pages,
            ranges      : vm.dashboardData.widget3.ranges,
            currentRange: vm.dashboardData.widget3.currentRange,
            changeRange : function (range)
            {
                vm.widget3.currentRange(range);
            }
        };

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;


        // Methods

        //////////

        // Widget 2
        uiGmapGoogleMapApi.then(function ()
        {
            vm.widget2.map = vm.dashboardData.widget2.map;
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.chat', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        // State
        $stateProvider.state('app.chat', {
            url    : '/chat',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/chat/chat.html',
                    controller : 'ChatController as vm'
                }
            },
            resolve: {
                Contacts: function (msApi)
                {
                    return msApi.resolve('chat.contacts@get');
                },
                User    : function (msApi)
                {
                    return msApi.resolve('chat.user@get');
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/chat');

        // Api
        // Contacts data must be alphabatically ordered.
        msApiProvider.register('chat.contacts', ['app/data/chat/contacts.json']);
        msApiProvider.register('chat.chats', ['app/data/chat/chats/:id.json']);
        msApiProvider.register('chat.user', ['app/data/chat/user.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.chat', {
            title : 'Chat',
            icon  : 'icon-hangouts',
            state : 'app.chat',
            badge : {
                content: 13,
                color  : '#09d261'
            },
            weight: 5
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.chat')
        .factory('ChatsService', ChatsService);

    /** @ngInject */
    function ChatsService($q, msApi)
    {
        
        var service = {
            chats         : {},
            contacts      : [],
            getContactChat: getContactChat
        };

        /**
         * Get contact chat from the server
         *
         * @param contactId
         * @returns {*}
         */
        function getContactChat(contactId)
        {

            // Create a new deferred object
            var deferred = $q.defer();

            // If contact doesn't have lastMessage, create a new chat
            if ( !service.contacts.getById(contactId).lastMessage)
            {
                service.chats[contactId] = [];

                deferred.resolve(service.chats[contactId]);
            }

            // If the chat exist in the service data, do not request
            if ( service.chats[contactId] )
            {
                deferred.resolve(service.chats[contactId]);
                
                return deferred.promise;
            }

            // Request the chat with the contactId
            msApi.request('chat.chats@get', {id: contactId},

                // SUCCESS
                function (response)
                {
                    // Attach the chats
                    service.chats[contactId] = response.data;

                    // Resolve the promise
                    deferred.resolve(service.chats[contactId]);
                },

                // ERROR
                function (response)
                {
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };
        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
/*        
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
*/        
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.typography', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_typography', {
            url      : '/ui/typography',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/typography/typography.html',
                    controller : 'TypographyController as vm'
                }
            },
            bodyClass: 'typography'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.typography')
        .controller('TypographyController', TypographyController);

    /** @ngInject */
    function TypographyController()
    {
        // Data

        // Methods

        //////////
    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors')
        .controller('ThemeColorsController', ThemeColorsController);

    /** @ngInject */
    function ThemeColorsController(fuseTheming, $mdDialog, $document)
    {
        var vm = this;
        // Data
        vm.themes = fuseTheming.themes;

        // Methods
        vm.createTheme = createTheme;
        //////////

        function createTheme(ev)
        {
            $mdDialog.show({
                controller         : 'CustomThemeDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/ui/theme-colors/dialogs/custom-theme/custom-theme-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.ui.material-colors', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_material-colors', {
            url  : '/ui/material-colors',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/material-colors/material-colors.html',
                    controller : 'MaterialColorsController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.material-colors')
        .controller('MaterialColorsController', MaterialColorsController);

    /** @ngInject */
    function MaterialColorsController($mdColorPalette)
    {
        var vm = this;

        // Data
        vm.palettes = $mdColorPalette;

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.icons', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider.state('app.ui_icons', {
            url      : '/ui/icons',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/icons/icons.html',
                    controller : 'IconsController as vm'
                }
            },
            resolve  : {
                Icons: function (msApi)
                {
                    return msApi.resolve('icons@get');
                }
            },
            bodyClass: 'icons'
        });

        // Api
        msApiProvider.register('icons', ['assets/icons/selection.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.icons')
        .controller('IconsController', IconsController);

    /** @ngInject */
    function IconsController(Icons)
    {
        var vm = this;

        // Data
        vm.icons = Icons.icons;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.helper-classes', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_helper-classes', {
            url      : '/ui/helper-classes',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/helper-classes/helper-classes.html',
                    controller : 'HelperClassesController as vm'
                }
            },
            bodyClass: 'helper-classes'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.helper-classes')
        .controller('HelperClassesController', HelperClassesController);

    /** @ngInject */
    function HelperClassesController()
    {
        // Data

        // Methods

        //////////
    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.ui.forms', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_forms', {
            url      : '/ui/forms',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/forms/forms.html',
                    controller : 'FormsController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.forms')
        .controller('FormsController', FormsController);

    /** @ngInject */
    function FormsController($mdDialog)
    {
        var vm = this;

        // Data
        vm.horizontalStepper = {
            step1: {},
            step2: {},
            step3: {},
            step4: {},
            step5: {}
        };

        vm.verticalStepper = {
            step1: {},
            step2: {},
            step3: {},
            step4: {},
            step5: {}
        };

        vm.basicForm = {};
        vm.formWizard = {};
        vm.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
        'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
        'WY').split(' ').map(function (state)
        {
            return {abbrev: state};
        });

        // Methods
        vm.sendForm = sendForm;
        vm.showDataDialog = showDataDialog;
        vm.submitHorizontalStepper = submitHorizontalStepper;
        vm.submitVerticalStepper = submitVerticalStepper;

        //////////

        /**
         * Submit horizontal stepper data
         * @param event
         */
        function submitHorizontalStepper(event)
        {
            // Show the model data in a dialog
            vm.showDataDialog(event, vm.horizontalStepper);

            // Reset the form model
            vm.horizontalStepper = {
                step1: {},
                step2: {},
                step3: {},
                step4: {},
                step5: {}
            };
        }

        /**
         * Submit vertical stepper data
         *
         * @param event
         */
        function submitVerticalStepper(event)
        {
            // Show the model data in a dialog
            vm.showDataDialog(event, vm.verticalStepper);

            // Reset the form model
            vm.verticalStepper = {
                step1: {},
                step2: {},
                step3: {},
                step4: {},
                step5: {}
            };
        }

        /**
         * Submit stepper form
         *
         * @param ev
         */
        function showDataDialog(ev, data)
        {
            // You can do an API call here to send the form to your server

            // Show the sent data.. you can delete this safely.
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    };
                },
                template           : '<md-dialog>' +
                '  <md-dialog-content><h1>You have sent the form with the following data</h1><div><pre>{{formWizardData | json}}</pre></div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Close' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: data
                },
                clickOutsideToClose: true
            });
        }

        /**
         * Send form
         */
        function sendForm(ev)
        {
            // You can do an API call here to send the form to your server

            // Show the sent data.. you can delete this safely.
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    };
                },
                template           : '<md-dialog>' +
                '  <md-dialog-content><h1>You have sent the form with the following data</h1><div><pre>{{formWizardData | json}}</pre></div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Close' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });

            // Clear the form data
            vm.formWizard = {};
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.timeline', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pages_timeline', {
                url      : '/pages/timeline',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (msApi)
                    {
                        return msApi.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline'
            })
            .state('app.pages_timeline_left', {
                url      : '/pages/timeline-left',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline-left.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (msApi)
                    {
                        return msApi.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline-left'
            })
            .state('app.pages_timeline_right', {
                url      : '/pages/timeline-right',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline-right.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (msApi)
                    {
                        return msApi.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline-right'
            });

        // API
        msApiProvider.register('timeline.page1', ['app/data/timeline/page-1.json']);
        msApiProvider.register('timeline.page2', ['app/data/timeline/page-2.json']);
        msApiProvider.register('timeline.page3', ['app/data/timeline/page-3.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('pages.timeline', {
            title : 'Timeline',
            icon  : 'icon-view-stream',
            weight: 8
        });

        msNavigationServiceProvider.saveItem('pages.timeline.default', {
            title: 'Default',
            state: 'app.pages_timeline'
        });

        msNavigationServiceProvider.saveItem('pages.timeline.left-aligned', {
            title: 'Left Aligned',
            state: 'app.pages_timeline_left'
        });

        msNavigationServiceProvider.saveItem('pages.timeline.right-aligned', {
            title: 'Right Aligned',
            state: 'app.pages_timeline_right'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.timeline')
        .controller('TimelineController', TimelineController);

    /** @ngInject */
    function TimelineController($q, msApi, Timeline)
    {
        var vm = this;

        // Data
        vm.timeline = Timeline.data;
        vm.timelineOptions = {
            scrollEl: '#content'
        };
        vm.currentPage = 1;
        vm.totalPages = 3;
        vm.pauseScroll = false;

        // Methods
        vm.loadNextPage = loadNextPage;

        //////////

        /**
         * Load next page
         * @returns promise
         */
        function loadNextPage()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Increase the current page number
            vm.currentPage = vm.currentPage + 1;

            // Check if we still have pages that we can load
            if ( vm.currentPage > vm.totalPages )
            {
                // Reject the promise
                deferred.reject('No more pages');
            }
            else
            {
                // Emulate the api call and load new timeline items in
                var pageName = 'timeline.page' + vm.currentPage + '@get';

                msApi.request(pageName, {},

                    // SUCCESS
                    function (response)
                    {
                        for ( var i = 0; i < response.data.length; i++ )
                        {
                            vm.timeline.push(response.data[i]);
                        }

                        // Resolve the promise
                        deferred.resolve(response);
                    },

                    // ERROR
                    function (response)
                    {
                        // Reject the promise
                        deferred.reject(response);
                    }
                );
            }

            return deferred.promise;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.profile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        $stateProvider.state('app.pages_profile', {
            url      : '/pages/profile',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/profile/profile.html',
                    controller : 'ProfileController as vm'
                }
            },
            resolve  : {
                Timeline    : function (msApi)
                {
                    return msApi.resolve('profile.timeline@get');
                },
                About       : function (msApi)
                {
                    return msApi.resolve('profile.about@get');
                },
                PhotosVideos: function (msApi)
                {
                    return msApi.resolve('profile.photosVideos@get');
                }
            },
            bodyClass: 'profile'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/profile');

        // Api
        msApiProvider.register('profile.timeline', ['app/data/profile/timeline.json']);
        msApiProvider.register('profile.about', ['app/data/profile/about.json']);
        msApiProvider.register('profile.photosVideos', ['app/data/profile/photos-videos.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('pages.profile', {
            title : 'Profile',
            icon  : 'icon-account',
            state : 'app.pages_profile',
            weight: 6
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.profile')
        .controller('ProfileController', ProfileController);

    /** @ngInject */
    function ProfileController(Timeline, About, PhotosVideos)
    {
        var vm = this;

        // Data
        vm.posts = Timeline.posts;
        vm.activities = Timeline.activities;
        vm.about = About.data;
        vm.photosVideos = PhotosVideos.data;

        // Methods

        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.search', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_search', {
            url      : '/pages/search',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/search/search.html',
                    controller : 'SearchController as vm'
                }
            },
            resolve  : {
                Classic : function (msApi)
                {
                    return msApi.resolve('search.classic@get');
                },
                Mails   : function (msApi)
                {
                    return msApi.resolve('search.mails@get');
                },
                Users   : function (msApi)
                {
                    return msApi.resolve('search.users@get');
                },
                Contacts: function (msApi)
                {
                    return msApi.resolve('search.contacts@get');
                }
            },
            bodyClass: 'search'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/search');

        // Api
        msApiProvider.register('search.classic', ['app/data/search/classic.json']);
        msApiProvider.register('search.mails', ['app/data/search/mails.json']);
        msApiProvider.register('search.users', ['app/data/search/users.json']);
        msApiProvider.register('search.contacts', ['app/data/search/contacts.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('pages.search', {
            title : 'Search',
            icon  : 'icon-magnify',
            state : 'app.pages_search',
            weight: 7
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.search')
        .controller('SearchController', SearchController);

    /** @ngInject */
    function SearchController(Classic, Mails, Users, Contacts)
    {
        var vm = this;

        // Data
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];

        vm.classic = Classic.data;
        vm.mails = Mails.data;
        vm.users = Users.data;
        vm.contacts = Contacts.data;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_maintenance', {
            url      : '/pages/maintenance',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_maintenance': {
                    templateUrl: 'app/main/pages/maintenance/maintenance.html',
                    controller : 'MaintenanceController as vm'
                }
            },
            bodyClass: 'maintenance'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/maintenance');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.maintenance', {
            title : 'Maintenance',
            icon  : 'icon-oil',
            state : 'app.pages_maintenance',
            weight: 5
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance')
        .controller('MaintenanceController', MaintenanceController);

    /** @ngInject */
    function MaintenanceController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.invoice', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pages_invoice_modern', {
                url      : '/pages/invoice/modern',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/invoice/views/modern/modern.html',
                        controller : 'InvoiceController as vm'
                    }
                },
                resolve  : {
                    Invoice: function (msApi)
                    {
                        return msApi.resolve('invoice@get');
                    }
                },
                bodyClass: 'invoice printable'
            })
            .state('app.pages_invoice_compact', {
                url      : '/pages/invoice/compact',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/invoice/views/compact/compact.html',
                        controller : 'InvoiceController as vm'
                    }
                },
                resolve  : {
                    Invoice: function (msApi)
                    {
                        return msApi.resolve('invoice@get');
                    }
                },
                bodyClass: 'invoice printable'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/invoice');

        // Api
        msApiProvider.register('invoice', ['app/data/invoice/invoice.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('pages.invoice', {
            title : 'Invoice',
            icon  : 'icon-receipt',
            weight: 4
        });

        msNavigationServiceProvider.saveItem('pages.invoice.modern', {
            title : 'Modern',
            state : 'app.pages_invoice_modern'
        });

        msNavigationServiceProvider.saveItem('pages.invoice.compact', {
            title : 'Compact',
            state : 'app.pages_invoice_compact'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.invoice')
        .controller('InvoiceController', InvoiceController);

    /** @ngInject */
    function InvoiceController(Invoice)
    {
        var vm = this;

        // Data
        vm.invoice = Invoice.data;

        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.coming-soon',
            [
                // 3rd Party Dependencies
                'timer'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_coming-soon', {
            url      : '/pages/coming-soon',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_coming-soon': {
                    templateUrl: 'app/main/pages/coming-soon/coming-soon.html',
                    controller : 'ComingSoonController as vm'
                }
            },
            bodyClass: 'coming-soon'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/coming-soon');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.coming-soon', {
            title : 'Coming Soon',
            icon  : 'icon-alarm-check',
            state : 'app.pages_coming-soon',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.coming-soon')
        .controller('ComingSoonController', ComingSoonController);

    /** @ngInject */
    function ComingSoonController()
    {
        var vm = this;

        // Data
        vm.endTime = 1499995790000;

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components.widgets',
            [
                // 3rd Party Dependencies
                'gridshore.c3js.chart'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_widgets', {
            url  : '/components/widgets',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/widgets/widgets.html',
                    controller : 'WidgetsController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.widgets')
        .controller('WidgetsController', WidgetsController);

    /** @ngInject */
    function WidgetsController()
    {
        var vm = this;

        // Data
        vm.widget1 = {
            title        : 'WEEKLY TRANSACTIONS',
            value        : 30342,
            lastWeekValue: 30002,
            lastWeekDiff : '+ 1,12%',
            detail       : 'This is the back side. You can show detailed information here.'
        };

        vm.widget2 = {
            title        : 'SALES QUOTA',
            value        : 40,
            lastWeekValue: 85,
            lastWeekDiff : '- 45%',
            detail       : 'This is the back side. You can show detailed information here.'
        };

        vm.widget3 = {
            title : 'BOUNCE RATE',
            value : 80,
            detail: 'This is the back side. You can show detailed information here.'
        };

        vm.widget4 = {
            title        : 'STOCK COUNT',
            value        : 5583,
            lastWeekValue: 5583,
            lastWeekDiff : '- 0%',
            detail       : 'This is the back side. You can show detailed information here.'
        };

        vm.widget5 = {
            title: 'USERS ONLINE',
            value: 658
        };

        vm.widget6 = {
            title: 'WASTELANDERS',
            value: 358
        };

        vm.widget7 = {
            title: 'VAULTS SEALED',
            value: 24
        };

        vm.widget8 = {
            title: 'VAULTS OPEN',
            value: 62
        };

        vm.widget9 = {
            title: 'SONGS',
            value: 210
        };

        vm.widget10 = {
            title: 'VIDEOS',
            value: 54
        };

        vm.widget11 = {
            title: 'DOCUMENTS',
            value: 1252
        };

        vm.widget12 = {
            date       : 'June 27, Saturday',
            temperature: 28,
            event      : 'Sunny',
            icon       : 'icon-weather-cloudy',
            location   : 'New York, NY',
            detail     : [
                {
                    day        : 'Sun',
                    icon       : 'icon-weather-rainy',
                    temperature: 24,
                    event      : 'Rainy'
                },
                {
                    day        : 'Mon',
                    icon       : 'icon-weather-pouring',
                    temperature: 23,
                    event      : 'Rainy'
                },
                {
                    day        : 'Tue',
                    icon       : 'icon-weather-cloudy',
                    temperature: 29,
                    event      : 'Overcast'
                },
                {
                    day        : 'Wed',
                    icon       : 'icon-weather-partlycloudy',
                    temperature: 28,
                    event      : 'Sunny'
                },
                {
                    day        : 'Thu',
                    icon       : 'icon-weather-partlycloudy',
                    temperature: 31,
                    event      : 'Sunny'
                }
            ]
        };

        vm.widget13 = {
            date       : 'June 28, Saturday',
            temperature: 16,
            event      : 'Rainy',
            icon       : 'icon-weather-rainy',
            location   : 'Moscow',
            detail     : [
                {
                    day        : 'Sun',
                    icon       : 'icon-weather-rainy',
                    temperature: 24,
                    event      : 'Rainy'
                },
                {
                    day        : 'Mon',
                    icon       : 'icon-weather-pouring',
                    temperature: 23,
                    event      : 'Rainy'
                },
                {
                    day        : 'Tue',
                    icon       : 'icon-weather-cloudy',
                    temperature: 29,
                    event      : 'Overcast'
                },
                {
                    day        : 'Wed',
                    icon       : 'icon-weather-partlycloudy',
                    temperature: 28,
                    event      : 'Sunny'
                },
                {
                    day        : 'Thu',
                    icon       : 'icon-weather-partlycloudy',
                    temperature: 31,
                    event      : 'Sunny'
                }
            ]
        };

        vm.widget14 = {
            title: 'Visitor Demographics',
            tabs : [
                {
                    label : '30 days',
                    groups: [
                        {
                            title: 'Genders',
                            data : [
                                {
                                    title: 'Male',
                                    value: 40
                                },
                                {
                                    title: 'Female',
                                    value: 41
                                }
                            ]
                        },
                        {
                            title: 'Age',
                            data : [
                                {
                                    title: '25 - 34',
                                    value: 32
                                },
                                {
                                    title: '35 - 44',
                                    value: 85
                                }
                            ]
                        }
                    ]
                },
                {
                    label : '10 days',
                    groups: [
                        {
                            title: 'Genders',
                            data : [
                                {
                                    title: 'Male',
                                    value: 32
                                },
                                {
                                    title: 'Female',
                                    value: 49
                                }
                            ]
                        },
                        {
                            title: 'Age',
                            data : [
                                {
                                    title: '25 - 34',
                                    value: 85
                                },
                                {
                                    title: '35 - 44',
                                    value: 60
                                }
                            ]
                        }
                    ]
                },
                {
                    label : '1 day',
                    groups: [
                        {
                            title: 'Genders',
                            data : [
                                {
                                    title: 'Male',
                                    value: 28
                                },
                                {
                                    title: 'Female',
                                    value: 60
                                }
                            ]
                        },
                        {
                            title: 'Age',
                            data : [
                                {
                                    title: '25 - 34',
                                    value: 17
                                },
                                {
                                    title: '35 - 44',
                                    value: 64
                                }
                            ]
                        }
                    ]
                }
            ]
        };

        vm.widget15 = {
            title: 'CPU USAGE',
            value: 200,
            chart: {
                columns: [
                    {
                        id    : 'CPU',
                        name  : 'CPU',
                        color : 'white',
                        values: '30,200,100,400,150,250',
                        type  : 'spline'
                    }
                ]
            }
        };

        vm.widget16 = {
            title        : 'STOCK COUNT',
            value        : 5583,
            lastWeekValue: 5583,
            lastWeekDiff : '- 0%',
            chart        : {
                columns: [
                    {
                        id    : 'STOCK',
                        name  : 'STOCK',
                        color : 'purple',
                        values: '30,200,100,400,150,250',
                        type  : 'area'
                    }
                ]
            }
        };

        vm.widget17 = {
            title   : 'IO RATE',
            subtitle: 'Showing last 5 hours',
            chart   : {
                columns: [
                    {
                        id    : 'Input',
                        name  : 'Input',
                        color : 'green',
                        values: '30,75,290,400,150,250',
                        type  : 'spline'
                    },
                    {
                        id    : 'Output',
                        name  : 'Output',
                        color : 'blue',
                        values: '500,300,120,600,50,80',
                        type  : 'spline'
                    }
                ]
            }
        };

        vm.widget18 = {
            title        : 'WEEKLY VISITORS',
            value        : 30342,
            lastWeekValue: 30002,
            lastWeekDiff : '1.12%',
            chart        : {
                columns: [
                    {
                        id    : 'Visitors',
                        name  : 'Visitors',
                        color : 'steelblue',
                        values: '30,75,290,400,150,250,75,210,125,92,30,75,290,400',
                        type  : 'bar'
                    }
                ]
            }
        };

        vm.widget19 = {
            title   : 'Google Inc.',
            subtitle: 'NASDAQ: GOOG',
            value   : '531.69',
            diff    : '2.29%',
            chart   : {
                columns: [
                    {
                        id    : 'GOOG',
                        name  : 'GOOG',
                        color : 'white',
                        values: '30,75,290,400,150,250,75,210,125,92,30,75,290,400',
                        type  : 'bar'
                    }
                ]
            }
        };

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.price-tables', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_price-tables', {
            url  : '/components/price-tables',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/price-tables/price-tables.html'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.price-tables')
        .controller('PriceTablesController', PriceTablesController);

    /** @ngInject */
    function PriceTablesController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.material-docs')
        .constant('ANGULAR_MATERIAL_VERSION', '1.1.4')
        .controller('DocTemplateController', DocTemplateController);

    /** @ngInject */
    function DocTemplateController(DEMOS, COMPONENTS, $state, $http, $templateCache, ANGULAR_MATERIAL_VERSION)
    {
        var vm = this;
        var component = $state.current.data;
        vm.materialVersion = ANGULAR_MATERIAL_VERSION;

        vm.componentName = component.name;

        vm.component = getComponent(component.moduleName);

        if ( !component.excludeDemo )
        {
            vm.demo = getDemo(component.moduleName);
        }

        if ( vm.component )
        {
            vm.docs = vm.component.docs;
        }

        if ( vm.demo )
        {
            vm.demos = [];

            angular.forEach(vm.demo.demos, function (demo)
            {
                // Get displayed contents (un-minified)
                var files = [demo.index]
                    .concat(demo.js || [])
                    .concat(demo.css || [])
                    .concat(demo.html || []);
                files.forEach(function (file)
                {
                    file.httpPromise = $http.get('app/main/components/material-docs/' + file.outputPath, {cache: $templateCache})
                        .then(function (response)
                        {
                            file.contents = response.data
                                .replace('<head/>', '');
                            return file.contents;
                        });
                });
                demo.$files = files;
                vm.demos.push(demo);
            });

            vm.demos = vm.demos.sort(function (a, b)
            {
                return a.name > b.name ? 1 : -1;
            });
        }

        // Data

        // Methods

        //////////

        function getDemo(value)
        {
            return DEMOS.filter(function (x)
            {
                return x.moduleName === value;
            })[0];
        }

        function getComponent(value)
        {
            return COMPONENTS.filter(function (x)
            {
                return x.name === value;
            })[0];
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.components.material-docs')
        .controller('BasicDocTemplateController', BasicDocTemplateController);

    /** @ngInject */
    function BasicDocTemplateController($state, ANGULAR_MATERIAL_VERSION) {
        var vm = this;
        vm.materialVersion = ANGULAR_MATERIAL_VERSION;

        vm.component = $state.current.data.component;
        vm.parentTitle = $state.current.data.parentTitle;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.maps',
            [
                // 3rd Party Dependencies
                'uiGmapgoogle-maps'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.components_maps', {
                url  : '/components/maps',
                views: {
                    'content@app'                   : {
                        templateUrl: 'app/main/components/maps/maps.html',
                        controller : 'MapsController as vm'
                    },
                    'tabContent@app.components_maps': {
                        templateUrl: 'app/main/components/maps/tabs/simple.html'
                    }
                }
            })

            .state('app.components_maps.satellite', {
                url  : '/satellite',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/satellite.html'
                    }
                }
            })

            .state('app.components_maps.terrain', {
                url  : '/terrain',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/terrain.html'
                    }
                }
            })

            .state('app.components_maps.simple-marker', {
                url  : '/simple-marker',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/simple-marker.html'
                    }
                }
            })

            .state('app.components_maps.custom-marker', {
                url  : '/custom-marker',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/custom-marker.html'
                    }
                }
            })

            .state('app.components_maps.info-window', {
                url  : '/info-window',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/info-window.html'
                    }
                }
            });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.maps')
        .controller('MapsController', MapsController);

    /** @ngInject */
    function MapsController($state, uiGmapGoogleMapApi)
    {
        var vm = this;

        // Data
        var currentState = $state.current.name;

        switch ( currentState )
        {
            case 'app.components_maps':
                vm.selectedNavItem = 'simpleMap';
                break;

            case 'app.components_maps.satellite':
                vm.selectedNavItem = 'satelliteMap';
                break;

            case 'app.components_maps.terrain':
                vm.selectedNavItem = 'terrainMap';
                break;

            case 'app.components_maps.simple-marker':
                vm.selectedNavItem = 'simpleMarkerMap';
                break;

            case 'app.components_maps.custom-marker':
                vm.selectedNavItem = 'customMarkerMap';
                break;

            case 'app.components_maps.info-window':
                vm.selectedNavItem = 'infoWindowMap';
                break;

            default:
                vm.selectedNavItem = 'simpleMap';
        }

        // Methods

        //////////

        uiGmapGoogleMapApi.then(function (maps)
        {
            vm.simpleMap = {
                center: {
                    latitude : -34.397,
                    longitude: 150.644
                },
                zoom  : 8
            };

            vm.satelliteMap = {
                center : {
                    latitude : -34.397,
                    longitude: 150.644
                },
                zoom   : 8,
                options: {
                    mapTypeId: maps.MapTypeId.SATELLITE
                }
            };

            vm.terrainMap = {
                center : {
                    latitude : -34.397,
                    longitude: 150.644
                },
                zoom   : 8,
                options: {
                    mapTypeId: maps.MapTypeId.TERRAIN
                }
            };

            vm.simpleMarkerMap = {
                center: {
                    latitude : -25.363882,
                    longitude: 131.044922
                },
                zoom  : 8,
                marker: {
                    id    : 0,
                    coords: {
                        latitude : -25.363882,
                        longitude: 131.044922
                    }
                }
            };

            vm.customMarkerMap = {
                center: {
                    latitude : -25.363882,
                    longitude: 131.044922
                },
                zoom  : 8,
                marker: {
                    id     : 0,
                    coords : {
                        latitude : -25.363882,
                        longitude: 131.044922
                    },
                    options: {
                        icon: {
                            anchor: new maps.Point(36, 36),
                            origin: new maps.Point(0, 0),
                            url   : '//google-developers.appspot.com/maps/documentation/javascript/examples/full/images/beachflag.png'
                        }
                    }
                }
            };

        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.custom-directives', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.components_custom-directives', {
                abstract: true,
                url     : '/components/custom-directives'
            })
            .state('app.components_custom-directives.ms-card', {
                url  : '/ms-card',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-card.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-form-wizard', {
                url  : '/ms-form-wizard',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-form-wizard.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-info-bar', {
                url  : '/ms-info-bar',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-info-bar.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-masonry', {
                url  : '/ms-masonry',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-masonry.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-material-color-picker', {
                url  : '/ms-material-color-picker',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-material-color-picker.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-nav', {
                url  : '/ms-nav',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-nav.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-navigation', {
                url  : '/ms-navigation',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-navigation.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-random-class', {
                url  : '/ms-random-class',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-random-class.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-responsive-table', {
                url  : '/ms-responsive-table',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-responsive-table.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-scroll', {
                url  : '/ms-scroll',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-scroll.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-search-bar', {
                url  : '/ms-search-bar',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-search-bar.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-shortcuts', {
                url  : '/ms-shortcuts',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-shortcuts.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-sidenav-helper', {
                url  : '/ms-sidenav-helper',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-sidenav-helper.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-splash-screen', {
                url  : '/ms-splash-screen',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-splash-screen.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-stepper', {
                url  : '/ms-stepper',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-stepper.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-timeline', {
                url  : '/ms-timeline',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-timeline.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-widget', {
                url  : '/ms-widget',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-widget.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('components.custom-directives', {
            title : 'Custom Directives',
            icon  : 'icon-star',
            weight: 2
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-card', {
            title : 'ms-card',
            state : 'app.components_custom-directives.ms-card',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-form-wizard', {
            title : 'ms-form-wizard',
            state : 'app.components_custom-directives.ms-form-wizard',
            weight: 2
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-info-bar', {
            title : 'ms-info-bar',
            state : 'app.components_custom-directives.ms-info-bar',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-masonry', {
            title : 'ms-masonry',
            state : 'app.components_custom-directives.ms-masonry',
            weight: 4
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-material-color-picker', {
            title : 'ms-material-color-picker',
            state : 'app.components_custom-directives.ms-material-color-picker',
            weight: 5
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-nav', {
            title : 'ms-nav',
            state : 'app.components_custom-directives.ms-nav',
            weight: 6
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-navigation', {
            title : 'ms-navigation',
            state : 'app.components_custom-directives.ms-navigation',
            weight: 7
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-random-class', {
            title : 'ms-random-class',
            state : 'app.components_custom-directives.ms-random-class',
            weight: 8
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-responsive-table', {
            title : 'ms-responsive-table',
            state : 'app.components_custom-directives.ms-responsive-table',
            weight: 9
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-scroll', {
            title : 'ms-scroll',
            state : 'app.components_custom-directives.ms-scroll',
            weight: 10
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-search-bar', {
            title : 'ms-search-bar',
            state : 'app.components_custom-directives.ms-search-bar',
            weight: 11
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-shortcuts', {
            title : 'ms-shortcuts',
            state : 'app.components_custom-directives.ms-shortcuts',
            weight: 12
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-sidenav-helper', {
            title : 'ms-sidenav-helper',
            state : 'app.components_custom-directives.ms-sidenav-helper',
            weight: 13
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-splash-screen', {
            title : 'ms-splash-screen',
            state : 'app.components_custom-directives.ms-splash-screen',
            weight: 14
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-stepper', {
            title : 'ms-stepper',
            state : 'app.components_custom-directives.ms-stepper',
            weight: 15
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-timeline', {
            title : 'ms-timeline',
            state : 'app.components_custom-directives.ms-timeline',
            weight: 16
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-widget', {
            title : 'ms-widget',
            state : 'app.components_custom-directives.ms-widget',
            weight: 17
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components.custom-directives')
        .controller('CustomDirectivesController', CustomDirectivesController);

    /** @ngInject */
    function CustomDirectivesController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components.cards', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider.state('app.components_cards', {
            url    : '/components/cards',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/components/cards/cards.html',
                    controller : 'CardsController as vm'
                }
            },
            resolve: {
                Cards: function (msApi)
                {
                    return msApi.resolve('cards@get');
                }
            }
        });

        // Api
        msApiProvider.register('cards', ['app/data/cards/cards.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.cards')
        .controller('CardsController', CardsController);

    /** @ngInject */
    function CardsController(Cards)
    {
        var vm = this;

        // Data
        vm.cards = Cards.data;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.reset-password')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register')
        .controller('RegisterController', RegisterController);

    /** @ngInject */
    function RegisterController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.register-v2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.auth_register-v2', {
            url      : '/auth/register-v2',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth_register-v2': {
                    templateUrl: 'app/main/auth/register-v2/register-v2.html',
                    controller : 'RegisterV2Controller as vm'
                }
            },
            bodyClass: 'register-v2'
        });

        // Translate
        $translatePartialLoaderProvider.addPart('app/main/auth/register-v2');

        // Navigation
        msNavigationServiceProvider.saveItem('auth.register-v2', {
            title : 'Register v2',
            state : 'app.auth_register-v2',
            weight: 4
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.register-v2')
        .controller('RegisterV2Controller', RegisterV2Controller);

    /** @ngInject */
    function RegisterV2Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.login-v2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.auth_login-v2', {
            url      : '/auth/login-v2',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth_login-v2': {
                    templateUrl: 'app/main/auth/login-v2/login-v2.html',
                    controller : 'LoginV2Controller as vm'
                }
            },
            bodyClass: 'login-v2'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/login-v2');

/*
        // Navigation
        msNavigationServiceProvider.saveItem('auth.login-v2', {
            title : 'Login v2',
            state : 'app.auth_login-v2',
            weight: 2
        });
*/        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.login-v2')
        .controller('LoginV2Controller', LoginV2Controller);

    /** @ngInject */
    function LoginV2Controller($location,WRITE_IN_CONSOLE,loginService,utilsService,statusService,firebaseDataService,$firebaseArray,$mdDialog,$document,$timeout,$state,preciosService)    
    {
        //********************************************************        
        // DATA DECLARATION
        //********************************************************        
        var vm = this;
        
        vm.login = {};

        vm.showAlert = false;
        vm.showLoginButton = false;

        //********************************************************
        // METHODS DECLARATION
        //********************************************************        
        vm.firebaseAuthenticate = firebaseAuthenticate;
        vm.authenticate = authenticate;
        vm.checkLoginContact = checkLoginContact;


        //********************************************************
        // METHODS
        //********************************************************        
        function firebaseAuthenticate() {

            vm.showAlert = false;

            //ABRIMOS LA CONEXION A LA BASE DE DATOS ANTES DE ENTRAR EN LA APP.
            //firebase.database().goOnline();


            //BEGIN - FIREBASE USER AUTHENTICATION
            firebase.auth().signInWithEmailAndPassword(vm.form.email,vm.form.password)

                .then(function(firebaseUser) {

                   utilsService.writeConsole("LOGIN BY FIREBASE RULES CORRECT",WRITE_IN_CONSOLE);

                    $timeout(function() {
                        vm.authenticate();
                    });
                    
                })

                .catch(function(error) {
                    
                    // Handle Errors here.
                    var errorCode = error.code;
                    var errorMessage = error.message; 

                    utilsService.writeConsole("REJECTED LOGIN BY FIREBASE RULES => ErrorCode = " + errorCode + "  / errorMessage = " + errorMessage, WRITE_IN_CONSOLE);


                    $timeout(function() {

                        vm.messageAlert = "Access denied for this user";
                        vm.showAlert = true;
                    });

            });
            //END - FIREBASE USER AUTHENTICATION

        }



        //***************************************************************
        function authenticate() {

            var authenticationOK = false;
            vm.showAlert = false;

            var contactNumber = 1;
            vm.checkLoginContact(contactNumber);
        }




        //***************************************************************
        function checkLoginContact(pContactNumber) {

            var authenticationOK = false;

            var result = loginService.getUserLogin(vm.form.email,vm.form.password,pContactNumber);

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                     utilsService.writeConsole("EJECUCIÓN OK DE CONSULTA TABLA usuarios para contact" + pContactNumber + " con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        utilsService.writeConsole("vm.form.email = " + vm.form.email, WRITE_IN_CONSOLE);
                         utilsService.writeConsole("data[0].activo = " + data[0].activo, WRITE_IN_CONSOLE);

                        if (data[0].password == vm.form.password) {

                            vm.login.name = data[0].nombre;
                            vm.login.email = data[0].email;
                            vm.login.userKey = data[0].$id;
                            vm.login.userName = data[0].nombre;
                            vm.login.company = data[0].empresa;
                            vm.login.companyKey = data[0].empresa_key;
                            vm.login.phone = data[0].telefonoCliente;

                            if (data[0].administrador) {
                                vm.login.userProfile = "administrator";
                            } else {
                                vm.login.userProfile = "user";
                            }
                            
                            vm.login.activo = data[0].activo;
                            

                            if (vm.login.activo) {
                                authenticationOK = true;
                                vm.login.ok = true;
                            } else {
                                authenticationOK = false;
                                vm.login.ok = false;
                            }

                        } else {

                            authenticationOK = false;
                        }                        


                    } else {

                        authenticationOK = false;
                    }


                    if (authenticationOK) {

                         utilsService.writeConsole("PASSWORD CORRECT", WRITE_IN_CONSOLE);

                        //Assign the values obtained from Firebase to the loginService
                        loginService.setName(vm.login.name);
                        loginService.setEmail(vm.login.email);
                        loginService.setUserKey(vm.login.userKey);
                        loginService.setUserProfile(vm.login.userProfile);
                        loginService.setUserName(vm.login.userName);
                        loginService.setCompany(vm.login.company);
                        loginService.setCompanyKey(vm.login.companyKey);
                        loginService.setPhone(vm.login.phone);
                        loginService.setPassword(vm.form.password);

                        //We assign the 'usuario_key' value to statusService
                        statusService.setUserKey(vm.login.userKey);

/*
                        utilsService.writeConsole("[loginService] => getUserLogin() => OK", WRITE_IN_CONSOLE);
                        utilsService.writeConsole("[loginService] => getUserLogin() method => vm.login.name = " + vm.login.name, WRITE_IN_CONSOLE);
                        utilsService.writeConsole("[loginService] => getUserLogin() method => vm.login.email = " + vm.login.email, WRITE_IN_CONSOLE);
                        utilsService.writeConsole("[loginService] => getUserLogin() method => vm.login.userKey = " + vm.login.userKey, WRITE_IN_CONSOLE);
                        utilsService.writeConsole("[loginService] => getUserLogin() method => vm.login.userProfile = " + vm.login.userProfile, WRITE_IN_CONSOLE);
                        utilsService.writeConsole("[loginService] => getUserLogin() method => vm.login.userName = " + vm.login.userName, WRITE_IN_CONSOLE);
                        utilsService.writeConsole("[loginService] => getUserLogin() method => vm.login.company = " + vm.login.company, WRITE_IN_CONSOLE);
                        utilsService.writeConsole("[loginService] => getUserLogin() method => vm.login.companyKey = " + vm.login.companyKey, WRITE_IN_CONSOLE);
                        utilsService.writeConsole("[loginService] => getUserLogin() method => vm.login.phone = " + vm.login.phone, WRITE_IN_CONSOLE);
                        utilsService.writeConsole("[loginService] => getUserLogin() method => vm.login.ok = " + vm.login.ok, WRITE_IN_CONSOLE); 
*/

                        vm.showAlert = false;

                        //**************************************************************************************************************
                        //IMPORTANTE => Obtenemos los valores de Precios para multi-ventana, servicios de montaje, embalaje y transporte
                        //**************************************************************************************************************
                        var precios = preciosService.getPrecios();


                        //Get all the records of user_key from "traceability" table in Firebase
                        //vm.traceability = vm.getTraceabilityFromFirebaseByUser(vm.login.userKey);

                        //Insert a record in "traceability" table
                        //vm.addTrace("Log In App");

                        //Redirect to "presupuestos" page
                        $state.go('app.menu_presupuestos');


                    } else {

                        vm.login.name = "";
                        vm.login.email = "";
                        vm.login.userKey = "";
                        vm.login.userProfile = "";
                        vm.login.userName = "";
                        vm.login.company = "";
                        vm.login.companyKey = "";
                        vm.login.phone = "";

                        vm.login.ok = false;

                        vm.showAlert = true;

                         utilsService.writeConsole("[loginService] => checkLoginContact() => INCORRECT A", WRITE_IN_CONSOLE);
                    }

                })

                .catch(function(error) {

                    vm.login.name = "";
                    vm.login.email = "";
                    vm.login.userKey = "";
                    vm.login.userProfile = "";
                    vm.login.userName = "";
                    vm.login.company = "";
                    vm.login.companyKey = "";
                    vm.login.phone = "";

                    vm.login.ok = false;

                    vm.showAlert = true;

                     utilsService.writeConsole("[loginService] => checkLoginContact() => INCORRECT B", WRITE_IN_CONSOLE);
                     utilsService.writeConsole("ERROR: " + error);
                }
            );
        }  


/*
        //***************************************************************
        function checkLoginContact(pContactNumber) {

            var authenticationOK = false;

            var result = loginService.getUserLogin(vm.form.email,vm.form.password,pContactNumber);

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                     utilsService.writeConsole("EJECUCIÓN OK DE CONSULTA TABLA usuarios para contact" + pContactNumber + " con data.length = " + dataLength, WRITE_IN_CONSOLE);

                    if (dataLength > 0) {

                        utilsService.writeConsole("vm.form.email = " + vm.form.email, WRITE_IN_CONSOLE);
                         utilsService.writeConsole("data[0].active = " + data[0].active, WRITE_IN_CONSOLE);

                        //For user1
                        if (data[0].password1 == vm.form.password) {

                            vm.login.name = data[0].company;
                            vm.login.email = data[0].email1;
                            vm.login.userKey = data[0].$id;
                            vm.login.userName = data[0].user1;

                            if (data[0].administrator) {
                                vm.login.userProfile = "administrator";
                            } else {
                                vm.login.userProfile = "user";
                            }
                            
                            vm.login.active = data[0].active;
                            

                            if (vm.login.active) {
                                authenticationOK = true;
                                vm.login.ok = true;
                            } else {
                                authenticationOK = false;
                                vm.login.ok = false;
                            }

                        //For user2
                        } else if (data[0].password2 == vm.form.password) {

                            vm.login.name = data[0].company;
                            vm.login.email = data[0].email2;
                            vm.login.userKey = data[0].$id;
                            vm.login.userName = data[0].user2;

                            if (data[0].administrator) {
                                vm.login.userProfile = "administrator";
                            } else {
                                vm.login.userProfile = "user";
                            }
                            
                            vm.login.active = data[0].active;
                            

                            if (vm.login.active) {
                                authenticationOK = true;
                                vm.login.ok = true;
                            } else {
                                authenticationOK = false;
                                vm.login.ok = false;
                            }

                        //For user3
                        } else if (data[0].password3 == vm.form.password) {

                            vm.login.name = data[0].company;
                            vm.login.email = data[0].email3;
                            vm.login.userKey = data[0].$id;
                            vm.login.userName = data[0].user3;

                            if (data[0].administrator) {
                                vm.login.userProfile = "administrator";
                            } else {
                                vm.login.userProfile = "user";
                            }
                            
                            vm.login.active = data[0].active;
                            

                            if (vm.login.active) {
                                authenticationOK = true;
                                vm.login.ok = true;
                            } else {
                                authenticationOK = false;
                                vm.login.ok = false;
                            }

                        } else {

                            authenticationOK = false;
                        }                        


                    } else {

                        if (pContactNumber <3) {
                            pContactNumber++;
                            vm.checkLoginContact(pContactNumber);
                        } else {
                            authenticationOK = false;
                             }
                    }


                    if (authenticationOK) {

                         utilsService.writeConsole("PASSWORD CORRECT", WRITE_IN_CONSOLE);

                        //Assign the values obtained from Firebase to the loginService
                        loginService.setName(vm.login.name);
                        loginService.setEmail(vm.login.email);
                        loginService.setUserKey(vm.login.userKey);
                        loginService.setUserProfile(vm.login.userProfile);
                        loginService.setUserName(vm.login.userName);
                        loginService.setPassword(vm.form.password);

                        //We assign the 'usuario_key' value to statusService
                        statusService.setUserKey(vm.login.userKey);

                         utilsService.writeConsole("[loginService] => getUserLogin() => OK", WRITE_IN_CONSOLE);
                         utilsService.writeConsole("[loginService] => getUserLogin() method => vm.login.name = " + vm.login.name, WRITE_IN_CONSOLE);
                         utilsService.writeConsole("[loginService] => getUserLogin() method => vm.login.email = " + vm.login.email, WRITE_IN_CONSOLE);
                         utilsService.writeConsole("[loginService] => getUserLogin() method => vm.login.userKey = " + vm.login.userKey, WRITE_IN_CONSOLE);
                         utilsService.writeConsole("[loginService] => getUserLogin() method => vm.login.userProfile = " + vm.login.userProfile, WRITE_IN_CONSOLE);
                         utilsService.writeConsole("[loginService] => getUserLogin() method => vm.login.userName = " + vm.login.userName, WRITE_IN_CONSOLE);
                         utilsService.writeConsole("[loginService] => getUserLogin() method => vm.login.ok = " + vm.login.ok, WRITE_IN_CONSOLE);

                        vm.showAlert = false;


                        //Get all the records of user_key from "traceability" table in Firebase
                        //vm.traceability = vm.getTraceabilityFromFirebaseByUser(vm.login.userKey);

                        //Insert a record in "traceability" table
                        //vm.addTrace("Log In App");

                        //Redirect to "home-dashboard" page
                        $location.path("/menu/home-dashboard");

                    } else {

                        vm.login.name = "";
                        vm.login.email = "";
                        vm.login.userKey = "";
                        vm.login.userProfile = "";
                        vm.login.contact = "";
                        vm.login.ok = false;

                        vm.showAlert = true;

                         utilsService.writeConsole("[loginService] => checkLoginContact() => INCORRECT A", WRITE_IN_CONSOLE);
                    }

                })

                .catch(function(error) {

                    vm.login.name = "";
                    vm.login.email = "";
                    vm.login.userKey = "";
                    vm.login.userProfile = "";
                    vm.login.userName = "";
                    vm.login.ok = false;

                    vm.showAlert = true;

                     utilsService.writeConsole("[loginService] => checkLoginContact() => INCORRECT B", WRITE_IN_CONSOLE);
                     utilsService.writeConsole("ERROR: " + error);
                }
            );
        }  
*/


    }


})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.lock')
        .controller('LockController', LockController);

    /** @ngInject */
    function LockController()
    {
        var vm = this;

        // Data
        vm.form = {
            username: 'Jane Doe'
        };

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.todo')
        .controller('TodoController', TodoController);

    /** @ngInject */
    function TodoController($document, $mdDialog, $mdSidenav, Tasks, Tags)
    {
        var vm = this;

        // Data
        vm.tasks = Tasks.data;
        vm.tags = Tags.data;
        vm.completed = [];
        vm.colors = ['blue', 'blue-grey', 'orange', 'pink', 'purple'];
        vm.projects = {
            'creapond'    : 'Project Creapond',
            'withinpixels': 'Project Withinpixels'
        };
        vm.selectedFilter = {
            filter : 'Start Date',
            dueDate: 'Next 3 days'
        };
        vm.selectedProject = 'creapond';

        // Tasks will be filtered against these models
        vm.taskFilters = {
            search   : '',
            tags     : [],
            completed: '',
            deleted  : false,
            important: '',
            starred  : '',
            startDate: '',
            dueDate  : ''
        };
        vm.taskFiltersDefaults = angular.copy(vm.taskFilters);
        vm.showAllTasks = true;

        vm.taskOrder = '';
        vm.taskOrderDescending = false;

        vm.sortableOptions = {
            handle        : '.handle',
            forceFallback : true,
            ghostClass    : 'todo-item-placeholder',
            fallbackClass : 'todo-item-ghost',
            fallbackOnBody: true,
            sort          : true
        };
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.preventDefault = preventDefault;
        vm.openTaskDialog = openTaskDialog;
        vm.toggleCompleted = toggleCompleted;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleFilter = toggleFilter;
        vm.toggleFilterWithEmpty = toggleFilterWithEmpty;
        vm.filterByStartDate = filterByStartDate;
        vm.filterByDueDate = filterByDueDate;
        vm.resetFilters = resetFilters;
        vm.toggleTagFilter = toggleTagFilter;
        vm.isTagFilterExists = isTagFilterExists;

        init();

        //////////

        /**
         * Initialize the controller
         */
        function init()
        {
            angular.forEach(vm.tasks, function (task)
            {
                if ( task.startDate )
                {
                    task.startDate = new Date(task.startDate);
                    task.startDateTimestamp = task.startDate.getTime();
                }

                if ( task.dueDate )
                {
                    task.dueDate = new Date(task.dueDate);
                    task.dueDateTimestamp = task.dueDate.getTime();
                }
            });
        }

        /**
         * Prevent default
         *
         * @param e
         */
        function preventDefault(e)
        {
            e.preventDefault();
            e.stopPropagation();
        }

        /**
         * Open new task dialog
         *
         * @param ev
         * @param task
         */
        function openTaskDialog(ev, task)
        {
            $mdDialog.show({
                controller         : 'TaskDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/todo/dialogs/task/task-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Task : task,
                    Tasks: vm.tasks,
                    event: ev
                }
            });
        }

        /**
         * Toggle completed status of the task
         *
         * @param task
         * @param event
         */
        function toggleCompleted(task, event)
        {
            event.stopPropagation();
            task.completed = !task.completed;
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggles filter with true or false
         *
         * @param filter
         */
        function toggleFilter(filter)
        {
            vm.taskFilters[filter] = !vm.taskFilters[filter];

            checkFilters();
        }

        /**
         * Toggles filter with true or empty string
         * @param filter
         */
        function toggleFilterWithEmpty(filter)
        {
            if ( vm.taskFilters[filter] === '' )
            {
                vm.taskFilters[filter] = true;
            }
            else
            {
                vm.taskFilters[filter] = '';
            }

            checkFilters();
        }

        /**
         * Reset filters
         */
        function resetFilters()
        {
            vm.showAllTasks = true;
            vm.taskFilters = angular.copy(vm.taskFiltersDefaults);
        }

        /**
         * Check filters and mark showAllTasks
         * as true if no filters selected
         */
        function checkFilters()
        {
            vm.showAllTasks = !!angular.equals(vm.taskFiltersDefaults, vm.taskFilters);
        }

        /**
         * Filter by startDate
         *
         * @param item
         * @returns {boolean}
         */
        function filterByStartDate(item)
        {
            if ( vm.taskFilters.startDate === true )
            {
                return item.startDate === new Date();
            }

            return true;
        }

        /**
         * Filter Due Date
         *
         * @param item
         * @returns {boolean}
         */
        function filterByDueDate(item)
        {
            if ( vm.taskFilters.dueDate === true )
            {
                return !(item.dueDate === null || item.dueDate.length === 0);
            }

            return true;
        }

        /**
         * Toggles tag filter
         *
         * @param tag
         */
        function toggleTagFilter(tag)
        {
            var i = vm.taskFilters.tags.indexOf(tag);

            if ( i > -1 )
            {
                vm.taskFilters.tags.splice(i, 1);
            }
            else
            {
                vm.taskFilters.tags.push(tag);
            }

            checkFilters();
        }

        /**
         * Returns if tag exists in the tagsFilter
         *
         * @param tag
         * @returns {boolean}
         */
        function isTagFilterExists(tag)
        {
            return vm.taskFilters.tags.indexOf(tag) > -1;
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ScrumboardController', ScrumboardController);

    /** @ngInject */
    function ScrumboardController($mdSidenav, BoardService, BoardList, CardFilters)
    {
        var vm = this;

        // Data
        vm.currentView = 'board';
        vm.board = BoardService.data;
        vm.boardList = BoardList.data;
        vm.boardSelectorVisible = false;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.updateBoardUri = updateBoardUri;
        vm.clearFilters = CardFilters.clear;
        vm.filteringIsOn = CardFilters.isOn;

        ////////

        /**
         * Update Board Uri
         *
         * Once you connect your app to your server,
         * you would do this on your API server.
         */
        function updateBoardUri()
        {
            if ( vm.boardList.getById(vm.board.id) )
            {
                vm.boardList.getById(vm.board.id).name = vm.board.name;
                vm.boardList.getById(vm.board.id).uri = vm.board.uri = encodeURIComponent(vm.board.name).replace(/%20/g, '-').toLowerCase();
            }
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('NotesController', NotesController);

    /** @ngInject */
    function NotesController($document, $timeout, $scope, $mdSidenav, NotesService, LabelsService, $mdDialog)
    {
        var vm = this;

        // Data
        vm.notes = NotesService.data;
        vm.labels = LabelsService.data;
        vm.search = '';
        vm.searchToolbar = false;
        vm.filters = {
            archive: false
        };
        vm.labelFilterIds = [];
        vm.noteListType = 'notes';

        // Methods
        vm.filterChange = filterChange;
        vm.openSearchToolbar = openSearchToolbar;
        vm.closeSearchToolbar = closeSearchToolbar;
        vm.editNote = editNote;
        vm.deleteLabel = deleteLabel;
        vm.toggleSidenav = toggleSidenav;
        vm.addNewLabel = LabelsService.addLabel;

        //////////

        /**
         * Change Notes Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.noteListType = type;

            if ( type === 'notes' )
            {
                vm.labelFilterIds = [];
                vm.filters = {
                    archive: false
                };
            }
            else if ( type === 'archive' )
            {
                vm.labelFilterIds = [];
                vm.filters = {
                    archive: true
                };
            }
            else if ( type === 'reminders' )
            {
                vm.labelFilterIds = [];
                vm.filters = {
                    reminder: '',
                    archive : false
                };
            }
            else if ( angular.isObject(type) )
            {
                vm.labelFilterIds = [];
                vm.labelFilterIds.push(type.id);
            }

            $mdSidenav('main-sidenav').close();

        }

        /**
         * Edit Note
         * @param ev
         * @param noteId
         */
        function editNote(ev, noteId)
        {
            $mdDialog.show({
                template           : '<md-dialog ms-scroll><ms-note-form note-type="\'edit\'" note-id="\'' + noteId + '\'"></ms-note-form></md-dialog>',
                parent             : $document.find('#notes'),
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true
            });
        }

        /**
         * Delete Label
         * @param ev
         * @param label
         */
        function deleteLabel(ev, label)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the label?')
                .htmlContent('The "' + label.name + '" label will be deleted permanently.')
                .ariaLabel('delete label')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                LabelsService.deleteLabel(label);
            });
        }

        /**
         * Open Search Toolbar
         */
        function openSearchToolbar()
        {
            vm.searchToolbar = true;

            $timeout(function ()
            {
                angular.element($document.find('#search-notes-input')).trigger('focus');

            });

            $document.on('keyup', escKeyEvent);
        }

        /**
         * Close Search Toolbar
         */
        function closeSearchToolbar()
        {
            $scope.$evalAsync(function ()
            {
                vm.searchToolbar = false;
                vm.search = '';
            });

            $document.off('keyup', escKeyEvent);
        }

        /**
         * Escape key event
         */
        function escKeyEvent(e)
        {
            if ( e.keyCode === 27 )
            {
                closeSearchToolbar();
            }
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.mail')
        .controller('MailController', MailController);

    /** @ngInject */
    function MailController($scope, $rootScope, $document, $mdDialog, $mdMedia, $mdSidenav, $state, msApi, Folders, Labels)
    {
        var vm = this;

        // Data
        vm.accounts = {
            'creapond'    : 'johndoe@creapond.com',
            'withinpixels': 'johndoe@withinpixels.com'
        };
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.selectedAccount = 'creapond';

        vm.folders = Folders.data;
        vm.labels = Labels.data;
        vm.loadingThreads = true;

        vm.currentFilter = {
            type  : $state.params.type,
            filter: $state.params.filter
        };
        vm.currentThread = null;
        vm.selectedThreads = [];

        vm.views = {
            classic: 'app/main/apps/mail/views/classic/classic-view.html',
            outlook: 'app/main/apps/mail/views/outlook/outlook-view.html'
        };
        vm.defaultView = 'outlook';
        vm.currentView = 'outlook';

        // Methods
        vm.loadFolder = loadFolder;
        vm.loadLabel = loadLabel;
        vm.isFolderActive = isFolderActive;
        vm.isLabelActive = isLabelActive;

        vm.openThread = openThread;
        vm.closeThread = closeThread;

        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.selectThreads = selectThreads;
        vm.deselectThreads = deselectThreads;
        vm.toggleSelectThreads = toggleSelectThreads;

        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;

        vm.getLabel = getLabel;
        vm.getLabelColor = getLabelColor;
        vm.getLabelTitle = getLabelTitle;
        vm.toggleLabel = toggleLabel;
        vm.isLabelExist = isLabelExist;

        vm.changeView = changeView;

        vm.composeDialog = composeDialog;
        vm.replyDialog = replyDialog;

        vm.toggleSidenav = toggleSidenav;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Figure out the api name
            var apiName = 'mail.' + ($state.params.type || 'folder') + '.' + $state.params.filter + '@get';

            // Request the mails
            msApi.request(apiName).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.threads = response.data;

                    // Hide the loading screen
                    vm.loadingThreads = false;

                    // Open the thread if needed
                    if ( $state.params.threadId )
                    {
                        for ( var i = 0; i < vm.threads.length; i++ )
                        {
                            if ( vm.threads[i].id === $state.params.threadId )
                            {
                                vm.openThread(vm.threads[i]);
                                break;
                            }
                        }
                    }
                }
            );
        }

        // Watch screen size to change view modes
        $scope.$watch(function ()
        {
            return $mdMedia('xs');
        }, function (current, old)
        {
            if ( current )
            {
                vm.currentView = 'classic';
            }
        });

        $scope.$watch(function ()
        {
            return $mdMedia('gt-xs');
        }, function (current, old)
        {
            if ( current )
            {
                if ( vm.defaultView === 'outlook' )
                {
                    vm.currentView = 'outlook';
                }
            }
        });

        /**
         * Load folder
         *
         * @param name
         */
        function loadFolder(name)
        {
            // If we are already in the selected folder and
            // there is an open thread just close it
            if ( vm.isFolderActive(name) )
            {
                // Close the current thread if open
                if ( vm.currentThread )
                {
                    vm.closeThread();
                }

                return;
            }

            // Show loader
            $rootScope.loadingProgress = true;

            // Update the state without reloading the controller
            $state.go('app.mail.threads', {
                type  : null,
                filter: name
            }, {notify: false});

            // Build the API name
            var apiName = 'mail.folder.' + name + '@get';

            // Make the call
            msApi.request(apiName).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.threads = response.data;

                    // Set the current filter
                    vm.currentFilter = {
                        type  : null,
                        filter: name
                    };

                    // Close the current thread if open
                    if ( vm.currentThread )
                    {
                        vm.closeThread();
                    }

                    // Hide loader
                    $rootScope.loadingProgress = false;
                }
            );
        }

        /**
         * Load label
         *
         * @param name
         */
        function loadLabel(name)
        {
            // Update the state without reloading the controller
            $state.go('app.mail.threads', {
                type  : 'label',
                filter: name
            }, {notify: false});

            // If we are already in the selected folder and
            // there is an open thread just close it
            if ( vm.isLabelActive(name) )
            {
                // Close the current thread if open
                if ( vm.currentThread )
                {
                    vm.closeThread();
                }

                return;
            }

            // Show loader
            $rootScope.loadingProgress = true;

            // Build the API name
            var apiName = 'mail.label.' + name + '@get';

            // Make the call
            msApi.request(apiName).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.threads = response.data;

                    // Set the current filter
                    vm.currentFilter = {
                        type  : 'label',
                        filter: name
                    };

                    // Close the current thread if open
                    if ( vm.currentThread )
                    {
                        vm.closeThread();
                    }

                    // Hide loader
                    $rootScope.loadingProgress = false;
                }
            );
        }

        /**
         * Is the folder with the given name active?
         *
         * @param name
         * @returns {boolean}
         */
        function isFolderActive(name)
        {
            return (vm.currentFilter.type === null && vm.currentFilter.filter === name);
        }

        /**
         * Is the label with the given name active?
         *
         * @param name
         * @returns {boolean}
         */
        function isLabelActive(name)
        {
            return (vm.currentFilter.type === 'label' && vm.currentFilter.filter === name);
        }

        /**
         * Open thread
         *
         * @param thread
         */
        function openThread(thread)
        {
            // Set the read status on the thread
            thread.read = true;

            // Assign thread as the current thread
            vm.currentThread = thread;

            // Update the state without reloading the controller
            $state.go('app.mail.threads.thread', {threadId: thread.id}, {notify: false});
        }

        /**
         * Close thread
         */
        function closeThread()
        {
            vm.currentThread = null;

            // Update the state without reloading the controller
            $state.go('app.mail.threads', {
                type  : vm.currentFilter.type,
                filter: vm.currentFilter.filter
            }, {notify: false});
        }

        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread)
        {
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            if ( vm.selectedThreads.indexOf(thread) > -1 )
            {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            }
            else
            {
                vm.selectedThreads.push(thread);
            }
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value)
        {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for ( var i = 0; i < vm.threads.length; i++ )
            {
                if ( angular.isUndefined(key) && angular.isUndefined(value) )
                {
                    vm.selectedThreads.push(vm.threads[i]);
                    continue;
                }

                if ( angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value )
                {
                    vm.selectedThreads.push(vm.threads[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function deselectThreads()
        {
            vm.selectedThreads = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads()
        {
            if ( vm.selectedThreads.length > 0 )
            {
                vm.deselectThreads();
            }
            else
            {
                vm.selectThreads();
            }
        }

        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event)
        {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if ( event )
            {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if ( thread )
            {
                thread[key] = value;
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if ( vm.currentThread )
            {
                vm.currentThread[key] = value;
                return;
            }

            // Otherwise do the status update on selected threads
            for ( var x = 0; x < vm.selectedThreads.length; x++ )
            {
                vm.selectedThreads[x][key] = value;
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event)
        {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if ( event )
            {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if ( thread )
            {
                if ( typeof(thread[key]) !== 'boolean' )
                {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if ( vm.currentThread )
            {
                if ( typeof(vm.currentThread[key]) !== 'boolean' )
                {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for ( var x = 0; x < vm.selectedThreads.length; x++ )
            {
                if ( typeof(vm.selectedThreads[x][key]) !== 'boolean' )
                {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }

        /**
         * Get label object content
         *
         * @param id
         * @returns {*}
         */
        function getLabel(id)
        {
            for ( var i = 0; i < vm.labels.length; i++ )
            {
                if ( vm.labels[i].id === id )
                {
                    return vm.labels[i];
                }
            }
        }

        /**
         * Get label color from label object
         *
         * @param id
         * @returns {*}
         */
        function getLabelColor(id)
        {
            return vm.getLabel(id).color;
        }

        /**
         * Get label title from label object
         *
         * @param id
         * @returns {*}
         */
        function getLabelTitle(id)
        {
            return vm.getLabel(id).title;
        }

        /**
         * Toggle label
         *
         * @param label
         */
        function toggleLabel(label)
        {
            // Toggle label on the currently open thread
            if ( vm.currentThread )
            {
                if ( vm.currentThread.labels.indexOf(label.id) > -1 )
                {
                    vm.currentThread.labels.splice(vm.currentThread.labels.indexOf(label.id), 1);
                }
                else
                {
                    vm.currentThread.labels.push(label.id);
                }

                return;
            }

            // Toggle labels on selected threads
            // Toggle action will be determined by the first thread from the selection.
            if ( vm.selectedThreads.length > 0 )
            {
                // Decide if we are going to remove or add labels
                var removeLabels = (vm.selectedThreads[0].labels.indexOf(label.id) > -1);

                for ( var i = 0; i < vm.selectedThreads.length; i++ )
                {
                    if ( !removeLabels )
                    {
                        vm.selectedThreads[i].labels.push(label.id);
                        continue;
                    }

                    if ( vm.selectedThreads[i].labels.indexOf(label.id) > -1 )
                    {
                        vm.selectedThreads[i].labels.splice(vm.selectedThreads[i].labels.indexOf(label.id), 1);
                    }
                }
            }
        }

        /**
         * Is label exist?
         *
         * @param label
         * @returns {boolean}
         */
        function isLabelExist(label)
        {
            if ( vm.currentThread && vm.currentThread.labels )
            {
                return (vm.currentThread.labels.indexOf(label.id) > -1);
            }
        }

        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view)
        {
            if ( vm.views[view] )
            {
                vm.defaultView = view;
                vm.currentView = view;
            }
        }

        /**
         * Open compose dialog
         *
         * @param ev
         */

        function composeDialog(ev)
        {
            $mdDialog.show({
                controller         : 'ComposeDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedMail: undefined
                },
                templateUrl        : 'app/main/apps/mail/dialogs/compose/compose-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

        /**
         * Open reply dialog
         *
         * @param ev
         */
        function replyDialog(ev)
        {
            $mdDialog.show({
                controller         : 'ComposeDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedMail: vm.selectedMail
                },
                templateUrl        : 'app/main/apps/mail/dialogs/compose/compose-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }
})();
(function ()
{
    'use strict';

    angular.module('app.gantt-chart')
        .controller('GanttChartController', GanttChartController);

    /** @ngInject */
    function GanttChartController($mdDialog, $document, $animate, $scope, $timeout, ganttUtils, GanttObjectModel, ganttDebounce, moment, Tasks, Timespans, $window, $mdSidenav, msApi)
    {
        var vm = this;
        var objectModel;

        // Data
        vm.live = {};
        vm.options = {
            mode                    : 'custom',
            scale                   : 'day',
            sortMode                : undefined,
            sideMode                : 'Tree',
            daily                   : true,
            maxHeight               : 300,
            width                   : true,
            zoom                    : 1,
            rowSortable             : true,
            columns                 : ['model.name', 'from', 'to'],
            treeTableColumns        : ['from', 'to'],
            columnsHeaders          : {
                'model.name': 'Name',
                'from'      : 'Start Time',
                'to'        : 'End Time'
            },
            columnsClasses          : {
                'model.name': 'gantt-column-name',
                'from'      : 'gantt-column-from',
                'to'        : 'gantt-column-to'
            },
            columnsFormatters       : {
                'from': function (from)
                {
                    return angular.isDefined(from) ? from.format('lll') : undefined;
                },
                'to'  : function (to)
                {
                    return angular.isDefined(to) ? to.format('lll') : undefined;
                }
            },
            treeHeaderContent       : '{{getHeader()}}',
            columnsHeaderContents   : {
                'model.name': '{{getHeader()}}',
                'from'      : '{{getHeader()}}',
                'to'        : '{{getHeader()}}'
            },
            autoExpand              : 'both',
            taskOutOfRange          : 'truncate',
            fromDate                : '',
            toDate                  : '',
            rowContentEnabled       : true,
            rowContent              : '{{row.model.name}}',
            taskContentEnabled      : true,
            taskContent             : '<i ng-click="scope.vm.editDialog($event, \'task\', task)" class="gantt-task-edit-button icon-pencil s12 icon"\n   aria-label="edit task">\n</i>\n<span class="gantt-task-name">\n    {{task.model.name}}\n    <md-tooltip md-direction="top" class="gantt-chart-task-tooltip">\n        <div layout="column" layout-align="center center">\n            <div class="tooltip-name">\n                {{task.model.name}}\n            </div>\n            <div class="tooltip-date">\n                <span>\n                    {{task.model.from.format(\'MMM DD, HH:mm\')}}\n                </span>\n                <span>-</span>\n                <span>\n                    {{task.model.to.format(\'MMM DD, HH:mm\')}}\n                </span>\n            </div>\n        </div>\n    </md-tooltip>\n</span>',
            allowSideResizing       : false,
            labelsEnabled           : true,
            currentDate             : 'line',
            currentDateValue        : new Date(),
            draw                    : true,
            readOnly                : false,
            groupDisplayMode        : 'group',
            filterTask              : '',
            filterRow               : '',
            timeFrames              : {
                'day'    : {
                    start  : moment('8:00', 'HH:mm'),
                    end    : moment('20:00', 'HH:mm'),
                    working: true,
                    default: true
                },
                'noon'   : {
                    start  : moment('12:00', 'HH:mm'),
                    end    : moment('13:30', 'HH:mm'),
                    working: false,
                    default: true
                },
                'weekend': {
                    working: false
                },
                'holiday': {
                    working: false,
                    color  : 'red',
                    classes: ['gantt-timeframe-holiday']
                }
            },
            dateFrames              : {
                'weekend'    : {
                    evaluator: function (date)
                    {
                        return date.isoWeekday() === 6 || date.isoWeekday() === 7;
                    },
                    targets  : ['weekend']
                },
                '11-november': {
                    evaluator: function (date)
                    {
                        return date.month() === 10 && date.date() === 11;
                    },
                    targets  : ['holiday']
                }
            },
            timeFramesWorkingMode   : 'hidden',
            timeFramesNonWorkingMode: 'visible',
            columnMagnet            : '15 minutes',
            timeFramesMagnet        : true,
            dependencies            : true,
            canDraw                 : function (event)
            {
                var isLeftMouseButton = event.button === 0 || event.button === 1;
                return vm.options.draw && !vm.options.readOnly && isLeftMouseButton;
            },
            drawTaskFactory         : function ()
            {
                return {
                    id   : ganttUtils.randomUuid(),  // Unique id of the task.
                    name : 'Drawn task', // Name shown on top of each task.
                    color: '#AA8833' // Color of the task in HEX format (Optional).
                };
            },
            api                     : function (ganttApi)
            {
                // API Object is used to control methods and events from angular-gantt.
                vm.api = ganttApi;

                vm.api.core.on.ready($scope, function ()
                {
                    // When gantt is ready, load data.
                    // `data` attribute could have been used too.
                    vm.load();

                    // DOM events
                    vm.api.directives.on.new($scope, function (directiveName, directiveScope, element)
                    {
                        /**
                         * Gantt Task
                         */
                        if ( directiveName === 'ganttTask' )
                        {
                            element.on('mousedown touchstart', function (event)
                            {
                                event.preventDefault();
                                event.stopPropagation();
                                vm.live.row = directiveScope.task.row.model;
                                if ( angular.isDefined(directiveScope.task.originalModel) )
                                {
                                    vm.live.task = directiveScope.task.originalModel;
                                }
                                else
                                {
                                    vm.live.task = directiveScope.task.model;
                                }
                                $scope.$digest();
                            });

                        }

                        /**
                         * Gantt Row
                         */
                        else if ( directiveName === 'ganttRow' )
                        {

                            element.on('click', function (event)
                            {
                                event.stopPropagation();
                            });

                            element.on('mousedown touchstart', function (event)
                            {
                                event.stopPropagation();
                                vm.live.row = directiveScope.row.model;
                                $scope.$digest();
                            });

                        }

                        /**
                         * Gantt Row Label
                         */
                        else if ( directiveName === 'ganttRowLabel' )
                        {
                            // Fix for double trigger due to gantt-sortable plugin
                            element.off('click');

                            element.on('click', function (event)
                            {
                                event.preventDefault();
                                editDialog(event, 'row', directiveScope.row);
                            });

                            element.on('mousedown touchstart', function ()
                            {
                                vm.live.row = directiveScope.row.model;
                                $scope.$digest();
                            });

                        }
                    });

                    vm.api.tasks.on.rowChange($scope, function (task)
                    {
                        vm.live.row = task.row.model;
                    });

                    objectModel = new GanttObjectModel(vm.api);
                });
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.search = search;
        vm.setSortMode = setSortMode;
        vm.addDialog = addDialog;
        vm.editDialog = editDialog;
        vm.canAutoWidth = canAutoWidth;
        vm.getColumnWidth = getColumnWidth;
        vm.load = load;
        vm.reload = reload;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Set Gantt Chart height at the init
            calculateHeight();

            angular.element($window).on('resize', function ()
            {
                $scope.$apply(function ()
                {
                    calculateHeight();
                });
            });
        }

        /**
         * Max Height Fix
         */
        function calculateHeight()
        {
            vm.options.maxHeight = $document.find('#chart-container').offsetHeight;
        }

        /**
         * Add New Row
         */
        function addDialog(ev)
        {
            $mdDialog.show({
                controller         : 'GanttChartAddEditDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/gantt-chart/dialogs/add-edit/add-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    dialogData: {
                        chartData : vm.data,
                        dialogType: 'add'
                    }
                }
            });
        }

        /**
         * Edit Dialog
         */
        function editDialog(ev, formView, formData)
        {
            $mdDialog.show({
                controller         : 'GanttChartAddEditDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/gantt-chart/dialogs/add-edit/edit-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    dialogData: {
                        chartData : vm.data,
                        dialogType: 'edit',
                        formView  : formView,
                        formData  : formData
                    }
                }
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Search
         * @param sidenavId
         */
        function search(option, keyword)
        {
            if ( option === 'rows' )
            {
                vm.options.filterRow = keyword;
            }
            else if ( option === 'tasks' )
            {
                vm.options.filterTask = keyword;
            }
        }

        /**
         * Sort Mode
         * @param mode
         */
        function setSortMode(mode)
        {
            vm.options.sortMode = mode;

            if ( angular.isUndefined(mode) )
            {
                vm.options.rowSortable = true;
            }
            else
            {
                vm.options.rowSortable = false;
            }
        }

        /**
         * Side Mode
         */
        $scope.$watch('vm.options.sideMode', function (newValue, oldValue)
        {
            if ( newValue !== oldValue )
            {
                vm.api.side.setWidth(undefined);

                $timeout(function ()
                {
                    vm.api.columns.refresh();
                });
            }
        });

        function canAutoWidth(scale)
        {
            if ( scale.match(/.*?hour.*?/) || scale.match(/.*?minute.*?/) )
            {
                return false;
            }

            return true;
        }

        function getColumnWidth(widthEnabled, scale, zoom)
        {
            if ( !widthEnabled && vm.canAutoWidth(scale) )
            {
                return undefined;
            }

            if ( scale.match(/.*?week.*?/) )
            {
                return 150 * zoom;
            }

            if ( scale.match(/.*?month.*?/) )
            {
                return 300 * zoom;
            }

            if ( scale.match(/.*?quarter.*?/) )
            {
                return 500 * zoom;
            }

            if ( scale.match(/.*?year.*?/) )
            {
                return 800 * zoom;
            }

            return 40 * zoom;
        }

        // Reload data action
        function load()
        {
            vm.data = Tasks.data;
            vm.timespans = Timespans.data;

            // Fix for Angular-gantt-chart issue
            $animate.enabled(true);
            $animate.enabled($document.find('#gantt'), false);

        }

        /**
         * Reload Data
         */
        function reload()
        {
            msApi.resolve('ganttChart.tasks@get', function (response)
            {
                vm.data = response.data;
            });

            msApi.resolve('ganttChart.timespans@get', function (response)
            {
                vm.timespans = response.data;
            });
        }

        // Visual two way binding.
        var ganttDebounceValue = 1000;

        var listenTaskJson = ganttDebounce(function (taskJson)
        {
            if ( angular.isDefined(taskJson) )
            {
                var task = angular.fromJson(taskJson);
                objectModel.cleanTask(task);
                var model = vm.live.task;
                angular.extend(model, task);
            }
        }, ganttDebounceValue);

        $scope.$watch('vm.live.taskJson', listenTaskJson);

        var listenRowJson = ganttDebounce(function (rowJson)
        {
            if ( angular.isDefined(rowJson) )
            {
                var row = angular.fromJson(rowJson);
                objectModel.cleanRow(row);
                var tasks = row.tasks;

                delete row.tasks;
                var rowModel = vm.live.row;

                angular.extend(rowModel, row);

                var newTasks = {};
                var i, l;

                if ( angular.isDefined(tasks) )
                {
                    for ( i = 0, l = tasks.length; i < l; i++ )
                    {
                        objectModel.cleanTask(tasks[i]);
                    }

                    for ( i = 0, l = tasks.length; i < l; i++ )
                    {
                        newTasks[tasks[i].id] = tasks[i];
                    }

                    if ( angular.isUndefined(rowModel.tasks) )
                    {
                        rowModel.tasks = [];
                    }

                    for ( i = rowModel.tasks.length - 1; i >= 0; i-- )
                    {
                        var existingTask = rowModel.tasks[i];
                        var newTask = newTasks[existingTask.id];

                        if ( angular.isUndefined(newTask) )
                        {
                            rowModel.tasks.splice(i, 1);
                        }
                        else
                        {
                            objectModel.cleanTask(newTask);
                            angular.extend(existingTask, newTask);

                            delete newTasks[existingTask.id];
                        }
                    }
                }
                else
                {
                    delete rowModel.tasks;
                }

                angular.forEach(newTasks, function (newTask)
                {
                    rowModel.tasks.push(newTask);
                });
            }
        }, ganttDebounceValue);

        $scope.$watch('vm.live.rowJson', listenRowJson);

        $scope.$watchCollection('vm.live.task', function (task)
        {
            vm.live.taskJson = angular.toJson(task, true);
            vm.live.rowJson = angular.toJson(vm.live.row, true);
        });

        $scope.$watchCollection('vm.live.row', function (row)
        {
            vm.live.rowJson = angular.toJson(row, true);
            if ( angular.isDefined(row) && angular.isDefined(row.tasks) && row.tasks.indexOf(vm.live.task) < 0 )
            {
                vm.live.task = row.tasks[0];
            }
        });

        $scope.$watchCollection('vm.live.row.tasks', function ()
        {
            vm.live.rowJson = angular.toJson(vm.live.row, true);
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.file-manager',
            [
                // 3rd Party Dependencies
                'flow'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.file-manager', {
            url      : '/file-manager',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/file-manager/file-manager.html',
                    controller : 'FileManagerController as vm'
                }
            },
            resolve  : {
                Documents: function (msApi)
                {
                    return msApi.resolve('fileManager.documents@get');
                }
            },
            bodyClass: 'file-manager'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/file-manager');

        // Api
        msApiProvider.register('fileManager.documents', ['app/data/file-manager/documents.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.file-manager', {
            title : 'File Manager',
            icon  : 'icon-folder',
            state : 'app.file-manager',
            weight: 6
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.file-manager')
        .controller('FileManagerController', FileManagerController);

    /** @ngInject */
    function FileManagerController($mdSidenav, Documents)
    {
        var vm = this;

        // Data
        vm.accounts = {
            'creapond'    : 'johndoe@creapond.com',
            'withinpixels': 'johndoe@withinpixels.com'
        };
        vm.selectedAccount = 'creapond';
        vm.currentView = 'list';
        vm.showDetails = true;

        vm.path = Documents.data.path;
        vm.folders = Documents.data.folders;
        vm.files = Documents.data.files;
        vm.selected = vm.files[0];

        vm.ngFlowOptions = {
            // You can configure the ngFlow from here
            /*target                   : 'api/media/image',
             chunkSize                : 15 * 1024 * 1024,
             maxChunkRetries          : 1,
             simultaneousUploads      : 1,
             testChunks               : false,
             progressCallbacksInterval: 1000*/
        };
        vm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };

        // Methods
        vm.fileAdded = fileAdded;
        vm.upload = upload;
        vm.fileSuccess = fileSuccess;

        vm.select = select;
        vm.toggleDetails = toggleDetails;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleView = toggleView;

        //////////

        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */
        function fileAdded(file)
        {
            // Prepare the temp file data for file list
            var uploadingFile = {
                id       : file.uniqueIdentifier,
                file     : file,
                type     : '',
                owner    : 'Emily Bennett',
                size     : '',
                modified : moment().format('MMMM D, YYYY'),
                opened   : '',
                created  : moment().format('MMMM D, YYYY'),
                extention: '',
                location : 'My Files > Documents',
                offline  : false,
                preview  : 'assets/images/etc/sample-file-preview.jpg'
            };

            // Append it to the file list
            vm.files.push(uploadingFile);
        }

        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function upload()
        {
            // Set headers
            vm.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            vm.ngFlow.flow.upload();
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message)
        {
            // Iterate through the file list, find the one we
            // are added as a temp and replace its data
            // Normally you would parse the message and extract
            // the uploaded file data from it
            angular.forEach(vm.files, function (item, index)
            {
                if ( item.id && item.id === file.uniqueIdentifier )
                {
                    // Normally you would update the file from
                    // database but we are cheating here!

                    // Update the file info
                    item.name = file.file.name;
                    item.type = 'document';

                    // Figure out & upddate the size
                    if ( file.file.size < 1024 )
                    {
                        item.size = parseFloat(file.file.size).toFixed(2) + ' B';
                    }
                    else if ( file.file.size >= 1024 && file.file.size < 1048576 )
                    {
                        item.size = parseFloat(file.file.size / 1024).toFixed(2) + ' Kb';
                    }
                    else if ( file.file.size >= 1048576 && file.file.size < 1073741824 )
                    {
                        item.size = parseFloat(file.file.size / (1024 * 1024)).toFixed(2) + ' Mb';
                    }
                    else
                    {
                        item.size = parseFloat(file.file.size / (1024 * 1024 * 1024)).toFixed(2) + ' Gb';
                    }
                }
            });
        }

        /**
         * Select an item
         *
         * @param item
         */
        function select(item)
        {
            vm.selected = item;
        }

        /**
         * Toggle details
         *
         * @param item
         */
        function toggleDetails(item)
        {
            vm.selected = item;
            toggleSidenav('details-sidenav');
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggle view
         */
        function toggleView()
        {
            vm.currentView = vm.currentView === 'list' ? 'grid' : 'list';
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts')
        .controller('ContactsController', ContactsController);

    /** @ngInject */
    function ContactsController($scope, $mdSidenav, Contacts, User, msUtils, $mdDialog, $document)
    {

        var vm = this;

        // Data
        vm.contacts = Contacts.data;
        vm.user = User.data;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'name';
        vm.listOrderAsc = false;
        vm.selectedContacts = [];
        vm.newGroupName = '';

        // Methods
        vm.filterChange = filterChange;
        vm.openContactDialog = openContactDialog;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.deleteContact = deleteContact;
        vm.deleteSelectedContacts = deleteSelectedContacts;
        vm.toggleSelectContact = toggleSelectContact;
        vm.deselectContacts = deselectContacts;
        vm.selectAllContacts = selectAllContacts;
        vm.deleteContact = deleteContact;
        vm.addNewGroup = addNewGroup;
        vm.deleteGroup = deleteGroup;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        //////////

        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if ( type === 'all' )
            {
                vm.filterIds = null;
            }
            else if ( type === 'frequent' )
            {
                vm.filterIds = vm.user.frequentContacts;
            }
            else if ( type === 'starred' )
            {
                vm.filterIds = vm.user.starred;
            }
            else if ( angular.isObject(type) )
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, contact)
        {
            $mdDialog.show({
                controller         : 'ContactDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/contacts/dialogs/contact/contact-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Contact : contact,
                    User    : vm.user,
                    Contacts: vm.contacts
                }
            });
        }

        /**
         * Delete Contact Confirm Dialog
         */
        function deleteContactConfirm(contact, ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the contact?')
                .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                deleteContact(contact);
                vm.selectedContacts = [];

            }, function ()
            {

            });
        }

        /**
         * Delete Contact
         */
        function deleteContact(contact)
        {
            vm.contacts.splice(vm.contacts.indexOf(contact), 1);
        }

        /**
         * Delete Selected Contacts
         */
        function deleteSelectedContacts(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the selected contacts?')
                .htmlContent('<b>' + vm.selectedContacts.length + ' selected</b>' + ' will be deleted.')
                .ariaLabel('delete contacts')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.selectedContacts.forEach(function (contact)
                {
                    deleteContact(contact);
                });

                vm.selectedContacts = [];

            });

        }

        /**
         * Toggle selected status of the contact
         *
         * @param contact
         * @param event
         */
        function toggleSelectContact(contact, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            if ( vm.selectedContacts.indexOf(contact) > -1 )
            {
                vm.selectedContacts.splice(vm.selectedContacts.indexOf(contact), 1);
            }
            else
            {
                vm.selectedContacts.push(contact);
            }
        }

        /**
         * Deselect contacts
         */
        function deselectContacts()
        {
            vm.selectedContacts = [];
        }

        /**
         * Sselect all contacts
         */
        function selectAllContacts()
        {
            vm.selectedContacts = $scope.filteredContacts;
        }

        /**
         *
         */
        function addNewGroup()
        {
            if ( vm.newGroupName === '' )
            {
                return;
            }

            var newGroup = {
                'id'        : msUtils.guidGenerator(),
                'name'      : vm.newGroupName,
                'contactIds': []
            };

            vm.user.groups.push(newGroup);
            vm.newGroupName = '';
        }

        /**
         * Delete Group
         */
        function deleteGroup(ev)
        {
            var group = vm.listType;

            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the group?')
                .htmlContent('<b>' + group.name + '</b>' + ' will be deleted.')
                .ariaLabel('delete group')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.user.groups.splice(vm.user.groups.indexOf(group), 1);

                filterChange('all');
            });

        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.chat')
        .controller('ChatController', ChatController);

    /** @ngInject */
    function ChatController(Contacts, ChatsService, $mdSidenav, User, $timeout, $document, $mdMedia)
    {

        var vm = this;

        // Data
        vm.contacts = ChatsService.contacts = Contacts.data;
        vm.chats = ChatsService.chats;
        vm.user = User.data;
        vm.leftSidenavView = false;
        vm.chat = undefined;

        // Methods
        vm.getChat = getChat;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleLeftSidenavView = toggleLeftSidenavView;
        vm.reply = reply;
        vm.setUserStatus = setUserStatus;
        vm.clearMessages = clearMessages;

        //////////

        /**
         * Get Chat by Contact id
         * @param contactId
         */
        function getChat(contactId)
        {
            ChatsService.getContactChat(contactId).then(function (response)
            {
                vm.chatContactId = contactId;
                vm.chat = response;

                // Reset the reply textarea
                resetReplyTextarea();

                // Scroll to the last message
                scrollToBottomOfChat();

                if ( !$mdMedia('gt-md') )
                {
                    $mdSidenav('left-sidenav').close();
                }

                // Reset Left Sidenav View
                vm.toggleLeftSidenavView(false);

            });
        }

        /**
         * Reply
         */
        function reply($event)
        {
            // If "shift + enter" pressed, grow the reply textarea
            if ( $event && $event.keyCode === 13 && $event.shiftKey )
            {
                vm.textareaGrow = true;
                return;
            }

            // Prevent the reply() for key presses rather than the"enter" key.
            if ( $event && $event.keyCode !== 13 )
            {
                return;
            }

            // Check for empty messages
            if ( vm.replyMessage === '' )
            {
                resetReplyTextarea();
                return;
            }

            // Message
            var message = {
                who    : 'user',
                message: vm.replyMessage,
                time   : new Date().toISOString()
            };

            // Add the message to the chat
            vm.chat.push(message);

            // Update Contact's lastMessage
            vm.contacts.getById(vm.chatContactId).lastMessage = message;

            // Reset the reply textarea
            resetReplyTextarea();

            // Scroll to the new message
            scrollToBottomOfChat();

        }

        /**
         * Clear Chat Messages
         */
        function clearMessages()
        {
            vm.chats[vm.chatContactId] = vm.chat = [];
            vm.contacts.getById(vm.chatContactId).lastMessage = null;
        }

        /**
         * Reset reply textarea
         */
        function resetReplyTextarea()
        {
            vm.replyMessage = '';
            vm.textareaGrow = false;
        }

        /**
         * Scroll Chat Content to the bottom
         * @param speed
         */
        function scrollToBottomOfChat()
        {
            $timeout(function ()
            {
                var chatContent = angular.element($document.find('#chat-content'));

                PerfectScrollbar.update(chatContent[0]);

                chatContent.animate({
                    scrollTop: chatContent[0].scrollHeight
                }, 400);
            }, 0);

        }

        /**
         * Set User Status
         */
        function setUserStatus(status)
        {
            vm.user.status = status;
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggle Left Sidenav View
         *
         * @param view id
         */
        function toggleLeftSidenavView(id)
        {
            vm.leftSidenavView = id;
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.calendar')
        .controller('CalendarController', CalendarController);

    /** @ngInject */
    function CalendarController($mdDialog, $document)
    {
        var vm = this;

        // Data
        var date = new Date();
        var d = date.getDate();
        var m = date.getMonth();
        var y = date.getFullYear();

        vm.events = [
            [
                {
                    id   : 1,
                    title: 'All Day Event',
                    start: new Date(y, m, 1),
                    end  : null
                },
                {
                    id   : 2,
                    title: 'Long Event',
                    start: new Date(y, m, d - 5),
                    end  : new Date(y, m, d - 2)
                },
                {
                    id   : 3,
                    title: 'Some Event',
                    start: new Date(y, m, d - 3, 16, 0),
                    end  : null
                },
                {
                    id   : 4,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 4, 16, 0),
                    end  : null
                },
                {
                    id   : 5,
                    title: 'Birthday Party',
                    start: new Date(y, m, d + 1, 19, 0),
                    end  : new Date(y, m, d + 1, 22, 30)
                },
                {
                    id   : 6,
                    title: 'All Day Event',
                    start: new Date(y, m, d + 8, 16, 0),
                    end  : null
                },
                {
                    id   : 7,
                    title: 'Long Event',
                    start: new Date(y, m, d + 12, 16, 0),
                    end  : null
                },
                {
                    id   : 8,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 2, 0),
                    end  : null
                },
                {
                    id   : 9,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 4, 0),
                    end  : null
                },
                {
                    id   : 10,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 2, 0),
                    end  : null
                },
                {
                    id   : 11,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 4, 0),
                    end  : null
                },
                {
                    id   : 12,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 2, 0),
                    end  : null
                },
                {
                    id   : 13,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 4, 0),
                    end  : null
                },
                {
                    id   : 14,
                    title: 'Conference',
                    start: new Date(y, m, d + 17, 4, 0),
                    end  : null
                },
                {
                    id   : 15,
                    title: 'Meeting',
                    start: new Date(y, m, d + 22, 4, 0),
                    end  : new Date(y, m, d + 24, 4, 0)
                }
            ]
        ];

        vm.calendarUiConfig = {
            calendar: {
                editable          : true,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                dayNames          : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort     : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                viewRender        : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M'
                },
                eventClick        : eventDetail,
                selectable        : true,
                selectHelper      : true,
                select            : select
            }
        };

        // Methods
        vm.addEvent = addEvent;
        vm.next = next;
        vm.prev = prev;

        //////////

        /**
         * Go to next on current view (week, month etc.)
         */
        function next()
        {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev()
        {
            vm.calendarView.calendar.prev();
        }

        /**
         * Show event detail
         *
         * @param calendarEvent
         * @param e
         */
        function eventDetail(calendarEvent, e)
        {
            showEventDetailDialog(calendarEvent, e);
        }

        /**
         * Add new event in between selected dates
         *
         * @param start
         * @param end
         * @param e
         */
        function select(start, end, e)
        {
            showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Add event
         *
         * @param e
         */
        function addEvent(e)
        {
            var start = new Date(),
                end = new Date();

            showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Show event detail dialog
         * @param calendarEvent
         * @param e
         */
        function showEventDetailDialog(calendarEvent, e)
        {
            $mdDialog.show({
                controller         : 'EventDetailDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/calendar/dialogs/event-detail/event-detail-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    calendarEvent      : calendarEvent,
                    showEventFormDialog: showEventFormDialog,
                    event              : e
                }
            });
        }

        /**
         * Show event add/edit form dialog
         *
         * @param type
         * @param calendarEvent
         * @param start
         * @param end
         * @param e
         */
        function showEventFormDialog(type, calendarEvent, start, end, e)
        {
            var dialogData = {
                type         : type,
                calendarEvent: calendarEvent,
                start        : start,
                end          : end
            };

            $mdDialog.show({
                controller         : 'EventFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/calendar/dialogs/event-form/event-form-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    dialogData: dialogData
                }
            }).then(function (response)
            {
                switch ( response.type )
                {
                    case 'add':
                        // Add new
                        vm.events[0].push({
                            id   : vm.events[0].length + 20,
                            title: response.calendarEvent.title,
                            start: response.calendarEvent.start,
                            end  : response.calendarEvent.end
                        });
                        break;

                    case 'edit':
                        // Edit
                        for ( var i = 0; i < vm.events[0].length; i++ )
                        {
                            // Update
                            if ( vm.events[0][i].id === response.calendarEvent.id )
                            {
                                vm.events[0][i] = {
                                    title: response.calendarEvent.title,
                                    start: response.calendarEvent.start,
                                    end  : response.calendarEvent.end
                                };

                                break;
                            }
                        }
                        break;

                    case 'remove':
                        // Remove
                        for ( var j = 0; j < vm.events[0].length; j++ )
                        {
                            // Update
                            if ( vm.events[0][j].id === response.calendarEvent.id )
                            {
                                vm.events[0].splice(j, 1);

                                break;
                            }
                        }
                        break;
                }
            });
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'firebase'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Chat',
                        'icon'       : 'icon-hangouts',
                        'state'      : 'app.chat',
                        'badge'      : {
                            'content': 13,
                            'color'  : '#09d261'
                        },
                        'weight'     : 5,
                        'children'   : [],
                        '_id'        : 'chat',
                        '_path'      : 'apps.chat',
                        'uisref'     : 'app.chat',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Contacts',
                        'icon'       : 'icon-account-box',
                        'state'      : 'app.contacts',
                        'weight'     : 10,
                        'children'   : [],
                        '_id'        : 'contacts',
                        '_path'      : 'apps.contacts',
                        'uisref'     : 'app.contacts',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Notes',
                        'icon'       : 'icon-lightbulb',
                        'state'      : 'app.notes',
                        'weight'     : 11,
                        'children'   : [],
                        '_id'        : 'notes',
                        '_path'      : 'apps.notes',
                        'uisref'     : 'app.notes',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {

//AKI THEME      
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        

/*
//LEROY MERLIN & DEVELOPER THEME
        default : {
            primary :{
                name:"fuse-paleblue",
                hues:{
                    "default":"900",
                    "hue-1":"500",
                    "hue-2":"600",
                    "hue-3":"400"
                }
            },
            accent  :{
                name:"green",
                hues:{
                    "default":"600",
                    "hue-1":"400",
                    "hue-2":"700",
                    "hue-3":"A100"
                }
            },
            warn:{
                name:"red",
                hues:{
                    "default":"500",
                    "hue-1":"300",
                    "hue-2":"800",
                    "hue-3":"A100"
                }
            },
            background:{
                name:"grey",
                hues:{
                    "default":"A100",
                    "hue-1":"A100",
                    "hue-2":"100",
                    "hue-3":"300"
                }
            }
        },

*/

        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService,WRITE_IN_CONSOLE,utilsService,loginService)
    {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
/*        
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
*/

        
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            }
        };


        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Select the first status as a default
            //vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];

            vm.userName = loginService.getUserName();
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout()
        {

            //CERRAMOS TODAS LAS CONEXIONES A LA BASE DE DATOS ANTES DE CERRAR LA SESIÓN CON FIREBASE.
            //firebase.database().goOffline();       
            //utilsService.writeConsole("CERRADAS TODAS LAS CONEXIONES CON LA BASE DE DATOS DE FIREBASE MEDIANTE firebase.database().goOffline();", WRITE_IN_CONSOLE);

            //Cerramos la sesión en Firebase
            firebase.auth().signOut().then(function() {

                // Sign-out successful.
                utilsService.writeConsole("CERRADA LA SESIÓN DE FIREBASE MEDIANTE firebase.auth().signOut()", WRITE_IN_CONSOLE);

                //Hacemos el reset de los datos de login de la sesión actual
                loginService.resetLogin();

                //Redirigimos a la pantalla de login
                $state.go('app.auth_login-v2');     

            })
            .catch(function(error) {
            
                // An error happened.
                utilsService.writeConsole("ERROR AL INTENTAR CERRAR LA SESIÓN DE FIREBASE MEDIANTE firebase.auth().signOut()", WRITE_IN_CONSOLE);
            });
        }


        /**
         * Change Language
         */
        function changeLanguage(lang)
        {

            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */

/*             
            if ( lang.code !== 'en' )
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }
*/
            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query )
            {
                navigation = navigation.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 )
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if ( item.uisref )
            {
                // If there are state params,
                // use them...
                if ( item.stateParams )
                {
                    $state.go(item.state, item.stateParams);
                }
                else
                {
                    $state.go(item.state);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function() {
  'use strict';

  angular.module('app.services', []);
})();
(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('workflowService', workflowService);

//  itbStatusService.$inject = ['$firebaseObject', 'firebaseDataService'];

  function workflowService() {

    var workflow = new Workflow();
    var dataLoaded = false;
    
    var service = {
      workflow: Workflow,
      getWorkflow: getWorkflow,      

      //GETTERS DECLARATION
      getExportKey: getExportKey,
      
      getFase1_1_done: getFase1_1_done,
      getFase1_1_omitted: getFase1_1_omitted,

      getFase1_2_done: getFase1_2_done,
      getFase1_2_omitted: getFase1_2_omitted,

      getFase1_3_done: getFase1_3_done,
      getFase1_3_omitted: getFase1_3_omitted,

      getFase1_4_done: getFase1_4_done,
      getFase1_4_omitted: getFase1_4_omitted,

      getFase1_5_done: getFase1_5_done,
      getFase1_5_omitted: getFase1_5_omitted,

      getFase1_6_done: getFase1_6_done,
      getFase1_6_omitted: getFase1_6_omitted,

      getFase1_7_done: getFase1_7_done,
      getFase1_7_omitted: getFase1_7_omitted,

      getFase1_8_done: getFase1_8_done,
      getFase1_8_omitted: getFase1_8_omitted,

      getFase1_9_done: getFase1_9_done,
      getFase1_9_omitted: getFase1_9_omitted,

      getFase1_10_done: getFase1_10_done,
      getFase1_10_omitted: getFase1_10_omitted,

      getFase2_1_done: getFase2_1_done,
      getFase2_1_omitted: getFase2_1_omitted,

      getFase2_2_done: getFase2_2_done,
      getFase2_2_omitted: getFase2_2_omitted,

      getFase2_3_done: getFase2_3_done,
      getFase2_3_omitted: getFase2_3_omitted,

      getFase2_4_done: getFase2_4_done,
      getFase2_4_omitted: getFase2_4_omitted,

      getFase2_5_done: getFase2_5_done,
      getFase2_5_omitted: getFase2_5_omitted,

      getFase2_6_done: getFase2_6_done,
      getFase2_6_omitted: getFase2_6_omitted,

      getFase2_7_done: getFase2_7_done,
      getFase2_7_omitted: getFase2_7_omitted,

      getFase2_8_done: getFase2_8_done,
      getFase2_8_omitted: getFase2_8_omitted,

      getFase3_1_done: getFase3_1_done,
      getFase3_1_omitted: getFase3_1_omitted,

      getFase3_2_done: getFase3_2_done,
      getFase3_2_omitted: getFase3_2_omitted,

      getFase3_3_done: getFase3_3_done,
      getFase3_3_omitted: getFase3_3_omitted,

      getFase3_4_done: getFase3_4_done,
      getFase3_4_omitted: getFase3_4_omitted,

      getFase3_5_done: getFase3_5_done,
      getFase3_5_omitted: getFase3_5_omitted,


      //SETTERS DECLARATION
      setExportKey: setExportKey,

      setFase1_1_done: setFase1_1_done,
      setFase1_1_omitted: setFase1_1_omitted,

      setFase1_2_done: setFase1_2_done,
      setFase1_2_omitted: setFase1_2_omitted,

      setFase1_3_done: setFase1_3_done,
      setFase1_3_omitted: setFase1_3_omitted,

      setFase1_4_done: setFase1_4_done,
      setFase1_4_omitted: setFase1_4_omitted,

      setFase1_5_done: setFase1_5_done,
      setFase1_5_omitted: setFase1_5_omitted,

      setFase1_6_done: setFase1_6_done,
      setFase1_6_omitted: setFase1_6_omitted,

      setFase1_7_done: setFase1_7_done,
      setFase1_7_omitted: setFase1_7_omitted,

      setFase1_8_done: setFase1_8_done,
      setFase1_8_omitted: setFase1_8_omitted,

      setFase1_9_done: setFase1_9_done,
      setFase1_9_omitted: setFase1_9_omitted,

      setFase1_10_done: setFase1_10_done,
      setFase1_10_omitted: setFase1_10_omitted,

      setFase2_1_done: setFase2_1_done,
      setFase2_1_omitted: setFase2_1_omitted,

      setFase2_2_done: setFase2_2_done,
      setFase2_2_omitted: setFase2_2_omitted,

      setFase2_3_done: setFase2_3_done,
      setFase2_3_omitted: setFase2_3_omitted,

      setFase2_4_done: setFase2_4_done,
      setFase2_4_omitted: setFase2_4_omitted,

      setFase2_5_done: setFase2_5_done,
      setFase2_5_omitted: setFase2_5_omitted,

      setFase2_6_done: setFase2_6_done,
      setFase2_6_omitted: setFase2_6_omitted,

      setFase2_7_done: setFase2_7_done,
      setFase2_7_omitted: setFase2_7_omitted,

      setFase2_8_done: setFase2_8_done,
      setFase2_8_omitted: setFase2_8_omitted,

      setFase3_1_done: setFase3_1_done,
      setFase3_1_omitted: setFase3_1_omitted,

      setFase3_2_done: setFase3_2_done,
      setFase3_2_omitted: setFase3_2_omitted,

      setFase3_3_done: setFase3_3_done,
      setFase3_3_omitted: setFase3_3_omitted,

      setFase3_4_done: setFase3_4_done,
      setFase3_4_omitted: setFase3_4_omitted,

      setFase3_5_done: setFase3_5_done,
      setFase3_5_omitted: setFase3_5_omitted

    };

    return service;


    ////////////
    function Workflow() {

      this.exportKey = "";

      this.fase1_1_done = "";
      this.fase1_1_omitted = "";

      this.fase1_2_done = "";
      this.fase1_2_omitted = "";

      this.fase1_3_done = "";
      this.fase1_3_omitted = "";

      this.fase1_4_done = "";
      this.fase1_4_omitted = "";

      this.fase1_5_done = "";
      this.fase1_5_omitted = "";

      this.fase1_6_done = "";
      this.fase1_6_omitted = "";

      this.fase1_7_done = "";
      this.fase1_7_omitted = "";

      this.fase1_8_done = "";
      this.fase1_8_omitted = "";

      this.fase1_9_done = "";
      this.fase1_9_omitted = "";

      this.fase1_10_done = "";
      this.fase1_10_omitted = "";

      this.fase2_1_done = "";
      this.fase2_1_omitted = "";

      this.fase2_2_done = "";
      this.fase2_2_omitted = "";

      this.fase2_3_done = "";
      this.fase2_3_omitted = "";

      this.fase2_4_done = "";
      this.fase2_4_omitted = "";

      this.fase2_5_done = "";
      this.fase2_5_omitted = "";

      this.fase2_6_done = "";
      this.fase2_6_omitted = "";

      this.fase2_7_done = "";
      this.fase2_7_omitted = "";

      this.fase2_8_done = "";
      this.fase2_8_omitted = "";

      this.fase3_1_done = "";
      this.fase3_1_omitted = "";

      this.fase3_2_done = "";
      this.fase3_2_omitted = "";

      this.fase3_3_done = "";
      this.fase3_3_omitted = "";

      this.fase3_4_done = "";
      this.fase3_4_omitted = "";

      this.fase3_5_done = "";
      this.fase3_5_omitted = "";

    }



    function getWorkflow() {

      console.log("************************************************************************");      
      console.log("[statusService] this.exportKey = " + this.exportKey);


      console.log("[statusService] this.fase1_1_done = " + this.fase1_1_done);
      console.log("[statusService] this.fase1_1_omitted = " + this.fase1_1_omitted);

      console.log("[statusService] this.fase1_2_done = " + this.fase1_2_done);
      console.log("[statusService] this.fase1_2_omitted = " + this.fase1_2_omitted);

      console.log("[statusService] this.fase1_3_done = " + this.fase1_3_done);
      console.log("[statusService] this.fase1_3_omitted = " + this.fase1_3_omitted);

      console.log("[statusService] this.fase1_4_done = " + this.fase1_4_done);
      console.log("[statusService] this.fase1_4_omitted = " + this.fase1_4_omitted);

      console.log("[statusService] this.fase1_5_done = " + this.fase1_5_done);
      console.log("[statusService] this.fase1_5_omitted = " + this.fase1_5_omitted);

      console.log("[statusService] this.fase1_6_done = " + this.fase1_6_done);
      console.log("[statusService] this.fase1_6_omitted = " + this.fase1_6_omitted);

      console.log("[statusService] this.fase1_7_done = " + this.fase1_7_done);
      console.log("[statusService] this.fase1_7_omitted = " + this.fase1_7_omitted);

      console.log("[statusService] this.fase1_8_done = " + this.fase1_8_done);
      console.log("[statusService] this.fase1_8_omitted = " + this.fase1_8_omitted);

      console.log("[statusService] this.fase1_9_done = " + this.fase1_9_done);
      console.log("[statusService] this.fase1_9_omitted = " + this.fase1_9_omitted);

      console.log("[statusService] this.fase1_10_done = " + this.fase1_10_done);
      console.log("[statusService] thisfase1_10_omitted= " + this.fase1_10_omitted);

      console.log("[statusService] this.fase2_1_done = " + this.fase2_1_done);
      console.log("[statusService] this.fase2_1_omitted = " + this.fase2_1_omitted);

      console.log("[statusService] this.fase2_2_done = " + this.fase2_2_done);
      console.log("[statusService] this.fase2_2_omitted = " + this.fase2_2_omitted);

      console.log("[statusService] this.fase2_3_done = " + this.fase2_3_done);
      console.log("[statusService] this.fase2_3_omitted = " + this.fase2_3_omitted);

      console.log("[statusService] this.fase2_4_done = " + this.fase2_4_done);
      console.log("[statusService] this.fase2_4_omitted = " + this.fase2_4_omitted);

      console.log("[statusService] this.fase2_5_done = " + this.fase2_5_done);
      console.log("[statusService] this.fase2_5_omitted = " + this.fase2_5_omitted);

      console.log("[statusService] this.fase2_6_done = " + this.fase2_6_done);
      console.log("[statusService] this.fase2_6_omitted = " + this.fase2_6_omitted);

      console.log("[statusService] this.fase2_7_done = " + this.fase2_7_done);
      console.log("[statusService] this.fase2_7_omitted = " + this.fase2_7_omitted);

      console.log("[statusService] this.fase2_8_done = " + this.fase2_8_done);
      console.log("[statusService] thisfase2_8_omitted. = " + this.fase2_8_omitted);

      console.log("[statusService] this.fase3_1_done = " + this.fase3_1_done);
      console.log("[statusService] this.fase3_1_omitted = " + this.fase3_1_omitted);

      console.log("[statusService] thisfase3_2_done. = " + this.fase3_2_done);
      console.log("[statusService] this.fase3_2_omitted = " + this.fase3_2_omitted);

      console.log("[statusService] this.fase3_3_done = " + this.fase3_3_done);
      console.log("[statusService] this.fase3_3_omitted = " + this.fase3_3_omitted);

      console.log("[statusService] this.fase3_4_done = " + this.fase3_4_done);
      console.log("[statusService] this.fase3_4_omitted = " + this.fase3_4_omitted);

      console.log("[statusService] this.fase3_5_done = " + this.fase3_5_done);
      console.log("[statusService] this.fase3_5_omitted = " + this.fase3_5_omitted);

      console.log("************************************************************************");      

      return this;
    }


    //************************************** 
    //************** GETTERS ************** 
    function getExportKey() {
        return this.exportKey;
    }

    function getFase1_1_done() {
        return this.fase1_1_done;
    }

    function getFase1_1_omitted() {
        return this.fase1_1_omitted;
    }

    function getFase1_2_done() {
        return this.fase1_2_done;
    }

    function getFase1_2_omitted() {
        return this.fase1_2_omitted;
    }

    function getFase1_3_done() {
        return this.fase1_3_done;
    }

    function getFase1_3_omitted() {
        return this.fase1_3_omitted;
    }

    function getFase1_4_done() {
        return this.fase1_4_done;
    }

    function getFase1_4_omitted() {
        return this.fase1_4_omitted;
    }

    function getFase1_5_done() {
        return this.fase1_5_done;
    }

    function getFase1_5_omitted() {
        return this.fase1_5_omitted;
    }

    function getFase1_6_done() {
        return this.fase1_6_done;
    }

    function getFase1_6_omitted() {
        return this.fase1_6_omitted;
    }

    function getFase1_7_done() {
        return this.fase1_7_done;
    }

    function getFase1_7_omitted() {
        return this.fase1_7_omitted;
    }

    function getFase1_8_done() {
        return this.fase1_8_done;
    }

    function getFase1_8_omitted() {
        return this.fase1_8_omitted;
    }

    function getFase1_9_done() {
        return this.fase1_9_done;
    }

    function getFase1_9_omitted() {
        return this.fase1_9_omitted;
    }

    function getFase1_10_done() {
        return this.fase1_10_done;
    }

    function getFase1_10_omitted() {
        return this.fase1_10_omitted;
    }




    function getFase2_1_done() {
        return this.fase2_1_done;
    }

    function getFase2_1_omitted() {
        return this.fase2_1_omitted;
    }

    function getFase2_2_done() {
        return this.fase2_2_done;
    }

    function getFase2_2_omitted() {
        return this.fase2_2_omitted;
    }

    function getFase2_3_done() {
        return this.fase2_3_done;
    }

    function getFase2_3_omitted() {
        return this.fase2_3_omitted;
    }

    function getFase2_4_done() {
        return this.fase2_4_done;
    }

    function getFase2_4_omitted() {
        return this.fase2_4_omitted;
    }

    function getFase2_5_done() {
        return this.fase2_5_done;
    }

    function getFase2_5_omitted() {
        return this.fase2_5_omitted;
    }

    function getFase2_6_done() {
        return this.fase2_6_done;
    }

    function getFase2_6_omitted() {
        return this.fase2_6_omitted;
    }

    function getFase2_7_done() {
        return this.fase2_7_done;
    }

    function getFase2_7_omitted() {
        return this.fase2_7_omitted;
    }

    function getFase2_8_done() {
        return this.fase2_8_done;
    }

    function getFase2_8_omitted() {
        return this.fase2_8_omitted;
    }


    function getFase3_1_done() {
        return this.fase3_1_done;
    }

    function getFase3_1_omitted() {
        return this.fase3_1_omitted;
    }

    function getFase3_2_done() {
        return this.fase3_2_done;
    }

    function getFase3_2_omitted() {
        return this.fase3_2_omitted;
    }

    function getFase3_3_done() {
        return this.fase3_3_done;
    }

    function getFase3_3_omitted() {
        return this.fase3_3_omitted;
    }

    function getFase3_4_done() {
        return this.fase3_4_done;
    }

    function getFase3_4_omitted() {
        return this.fase3_4_omitted;
    }

    function getFase3_5_done() {
        return this.fase3_5_done;
    }

    function getFase3_5_omitted() {
        return this.fase3_5_omitted;
    }




    //**************************************
    //************** SGETTERS ************** 
    function setExportKey(pValue) {
        this.exportKey = pValue;
    }

    function setFase1_1_done(pValue) {
        this.fase1_1_done = pValue;
    }

    function setFase1_1_omitted(pValue) {
        this.fase1_1_omitted = pValue;
    }

    function setFase1_2_done(pValue) {
         this.fase1_2_done = pValue;
    }

    function setFase1_2_omitted(pValue) {
        this.fase1_2_omitted = pValue;
    }

    function setFase1_3_done(pValue) {
        this.fase1_3_done = pValue;
    }

    function setFase1_3_omitted(pValue) {
        this.fase1_3_omitted = pValue;
    }

    function setFase1_4_done(pValue) {
        this.fase1_4_done = pValue;
    }

    function setFase1_4_omitted(pValue) {
        this.fase1_4_omitted = pValue;
    }

    function setFase1_5_done(pValue) {
        this.fase1_5_done = pValue;
    }

    function setFase1_5_omitted(pValue) {
        this.fase1_5_omitted = pValue;
    }

    function setFase1_6_done(pValue) {
        this.fase1_6_done = pValue;
    }

    function setFase1_6_omitted(pValue) {
        this.fase1_6_omitted = pValue;
    }

    function setFase1_7_done(pValue) {
        this.fase1_7_done = pValue;
    }

    function setFase1_7_omitted(pValue) {
        this.fase1_7_omitted = pValue;
    }

    function setFase1_8_done(pValue) {
        this.fase1_8_done = pValue;
    }

    function setFase1_8_omitted(pValue) {
        this.fase1_8_omitted = pValue;
    }

    function setFase1_9_done(pValue) {
        this.fase1_9_done = pValue;
    }

    function setFase1_9_omitted(pValue) {
        this.fase1_9_omitted = pValue;
    }

    function setFase1_10_done(pValue) {
        this.fase1_10_done = pValue;
    }

    function setFase1_10_omitted(pValue) {
        this.fase1_10_omitted = pValue;
    }




    function setFase2_1_done(pValue) {
        this.fase2_1_done = pValue;
    }

    function setFase2_1_omitted(pValue) {
        this.fase2_1_omitted = pValue;
    }

    function setFase2_2_done(pValue) {
        this.fase2_2_done = pValue;
    }

    function setFase2_2_omitted(pValue) {
        this.fase2_2_omitted = pValue;
    }

    function setFase2_3_done(pValue) {
        this.fase2_3_done = pValue;
    }

    function setFase2_3_omitted(pValue) {
        this.fase2_3_omitted = pValue;
    }

    function setFase2_4_done(pValue) {
        this.fase2_4_done = pValue;
    }

    function setFase2_4_omitted(pValue) {
        this.fase2_4_omitted = pValue;
    }

    function setFase2_5_done(pValue) {
        this.fase2_5_done = pValue;
    }

    function setFase2_5_omitted(pValue) {
        this.fase2_5_omitted = pValue;
    }

    function setFase2_6_done(pValue) {
        this.fase2_6_done = pValue;
    }

    function setFase2_6_omitted(pValue) {
        this.fase2_6_omitted = pValue;
    }

    function setFase2_7_done(pValue) {
        this.fase2_7_done = pValue;
    }

    function setFase2_7_omitted(pValue) {
        this.fase2_7_omitted = pValue;
    }

    function setFase2_8_done(pValue) {
        this.fase2_8_done = pValue;
    }

    function setFase2_8_omitted(pValue) {
        this.fase2_8_omitted = pValue;
    }


    function setFase3_1_done(pValue) {
        this.fase3_1_done = pValue;
    }

    function setFase3_1_omitted(pValue) {
        this.fase3_1_omitted = pValue;
    }

    function setFase3_2_done(pValue) {
        this.fase3_2_done = pValue;
    }

    function setFase3_2_omitted(pValue) {
        this.fase3_2_omitted = pValue;
    }

    function setFase3_3_done(pValue) {
        this.fase3_3_done = pValue;
    }

    function setFase3_3_omitted(pValue) {
        this.fase3_3_omitted = pValue;
    }

    function setFase3_4_done(pValue) {
        this.fase3_4_done = pValue;
    }

    function setFase3_4_omitted(pValue) {
        this.fase3_4_omitted = pValue;
    }

    function setFase3_5_done(pValue) {
        this.fase3_5_done = pValue;
    }

    function setFase3_5_omitted(pValue) {
        this.fase3_5_omitted = pValue;
    }


  }

})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('utilsService', utilsService);

  //workflowService.$inject = ['$firebaseArray', 'firebaseDataService'];

  function utilsService($http) {

    var service = {

      getCETdateTime: getCETdateTime,
      getInterval: getInterval,
      getDate: getDate,
      getTime: getTime,
      getDateTime: getDateTime,
      convertDateToString: convertDateToString,
      getTimestampToday: getTimestampToday,      
      getNameFromUrl: getNameFromUrl,
      writeConsole: writeConsole,
      padLeftWithZero: padLeftWithZero
    };


    return service;


    ////////////
    
    function Utils() {

    }


    //***************************************************************
    function getCETdateTime() {

      var user = "developer@chartbid.com";
      var password = "a-Syns6wSuqV4EajR6t7ig";

      var config = {
          headers : {
              'Content-Type': 'application/json'
          }
      }

      //IMPORTANT => The function return a PROMISE object.
      return $http.get('https://webapi2256.azurewebsites.net/api/DateTime?user=' + user + '&password=' + password,config);
/*
      $http.get('https://webapi2256.azurewebsites.net/api/DateTime?user=' + user + '&password=' + password,config)
          .success(function(data) {
 
              console.log("UTC DateTime string = " + data);

              return data;
          })
          .error(function () {

              console.log("ERROR => NOT POSSIBLE TO GET THE UTC DATETIME FROM THE AZURE SERVER.");

              return "";
          });
*/          
    }


    //***************************************************************
    function getInterval(pEndDateString, pStartDateString) {

      var endDate = new Date(pEndDateString);
      var startDate = new Date(pStartDateString);

      var endDateMiliseconds = endDate.getTime();
      var startDateMiliseconds = startDate.getTime();

      var intervalInSeconds = (endDateMiliseconds - startDateMiliseconds) / 1000;

      return intervalInSeconds;
    }



    //***************************************************************
    function getDate() {

      var date;
      var now = new Date();

      //Format = 'YYYY/MM/DD'
      date = now.getFullYear() + "/" + String("00" + (now.getMonth()+1)).slice(-2) + "/" + String("00" + now.getDate()).slice(-2);

      //Format = 'DD/MM/YYYY'
      //date = String("00" + now.getDate()).slice(-2) + "/" + String("00" + (now.getMonth()+1)).slice(-2) + "/" + now.getFullYear() + "/";

      return date;
    }


    //***************************************************************
    function getTime() {

      var now = new Date();
      var time = String("00" + now.getHours()).slice(-2) + ":" + String("00" + now.getMinutes()).slice(-2);

      return time;
    }


    //***************************************************************
    function getDateTime() {

      var date;
      var now = new Date();

      //Format = 'yyyy/mm/dd'
      date = now.getFullYear() + "/" + String("00" + (now.getMonth()+1)).slice(-2) + "/" + String("00" + now.getDate()).slice(-2);

      //Format = 'dd/mm/yyyy'
      //date = String("00" + now.getDate()).slice(-2) + "/" + String("00" + (now.getMonth()+1)).slice(-2) + "/" + now.getFullYear();

      var time = String("00" + now.getHours()).slice(-2) + ":" + String("00" + now.getMinutes()).slice(-2);
      var dateTime = date + " " + time;

      return dateTime;
    }


    //***************************************************************
    function convertDateToString(pFecha,pFormat) {

        var date;

        if (pFormat == "yyyy/mm/dd") {

          date = pFecha.getFullYear() + "/" + String("00" + (pFecha.getMonth()+1)).slice(-2) + "/" + String("00" + pFecha.getDate()).slice(-2);

        } else {

          //default format "dd/mm/yyyy"
          date = String("00" + pFecha.getDate()).slice(-2) + "/" + String("00" + (pFecha.getMonth()+1)).slice(-2) + "/" + pFecha.getFullYear();
        }

        return date;
    }



    //***************************************************************
    function getTimestampToday() {

      var timestampToday = new Date().getTime();
      return timestampToday;
    }



    //***************************************************************
    function getNameFromUrl(pUrl) {

      var name = pUrl.substring(pUrl.lastIndexOf('/')+1);

      return name;
    }



    //***************************************************************
    function writeConsole(pText,pActive) {

      if (pActive) {
        console.log(pText);
      }
    }



    //***************************************************************
    function padLeftWithZero(numberToPad, length) {

      var  numberToPad = numberToPad.toString();
      
      while (numberToPad.length < length) {
         numberToPad = "0" + numberToPad;
       }
    
      return numberToPad;
    }


  }

})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('statusService', statusService);

//  itbStatusService.$inject = ['$firebaseObject', 'firebaseDataService'];

  function statusService() {

    var status = new Status();
    var dataLoaded = false;
    
    var service = {
      status: Status,
      getStatus: getStatus,      

      getUserKey: getUserKey,
      getExportKey: getExportKey,
      getExportCode: getExportCode,
      getConsigneeKey: getConsigneeKey,
      getCustomerKey: getCustomerKey,
      getExportPaymentConditions: getExportPaymentConditions,
      getExportCustomsTariff : getExportCustomsTariff,
      getExportTermsOfDelivery: getExportTermsOfDelivery,
      getWorkflowVisible: getWorkflowVisible,
      getConsignatarioEsCliente: getConsignatarioEsCliente,
      getDivisa: getDivisa,

      setUserKey: setUserKey,
      setExportKey: setExportKey,
      setExportCode: setExportCode,
      setConsigneeKey: setConsigneeKey,
      setCustomerKey: setCustomerKey,
      setExportPaymentConditions: setExportPaymentConditions,
      setExportCustomsTariff : setExportCustomsTariff,
      setExportTermsOfDelivery: setExportTermsOfDelivery,
      setWorkflowVisible: setWorkflowVisible,
      setConsignatarioEsCliente: setConsignatarioEsCliente,
      setDivisa: setDivisa
    };

    return service;


    ////////////
    function Status() {

      this.userKey = "";
      this.exportKey = "";
      this.exportCode = "";
      this.consigneeKey = "";
      this.customerKey = "";
      this.exportPaymentConditions = "";
      this.exportCustomsTariff = "";
      this.exportTermsOfDelivery = "";
      this.workflowVisible = false;
      this.consignatarioEsCliente = false;
      this.divisa = "EUR";
    }



    function getStatus() {

      console.log("************************************************************************");      
      console.log("[statusService] this.userKey = " + this.userKey);      
      console.log("[statusService] this.exportKey = " + this.exportKey);
      console.log("[statusService] this.exportCode = " + this.exportCode);
      console.log("[statusService] this.consigneeKey = " + this.consigneeKey);
      console.log("[statusService] this.costumerKey = " + this.customerKey);

      console.log("[statusService] this.exportPaymentConditions = " + this.exportPaymentConditions);
      console.log("[statusService] this.exportCustomsTariff = " + this.exportCustomsTariff);
      console.log("[statusService] this.exportTermsOfDelivery = " + this.exportTermsOfDelivery);

      console.log("[statusService] this.workflowVisible = " + this.workflowVisible);

      console.log("[statusService] this.consignatarioEsCliente = " + this.consignatarioEsCliente);      
      console.log("[statusService] this.divisa = " + this.divisa);
      console.log("************************************************************************");      

      return this;
    }


    //************************************** 
    //************** GETTERS ************** 
    function getUserKey() {
        return this.userKey;
    }

    function getExportKey() {
        return this.exportKey;
    }

    function getExportCode() {
        return this.exportCode;
    }

    function getConsigneeKey() {
        return this.consigneeKey;
    }

    function getCustomerKey() {
        return this.customerKey;
    }

    function getExportPaymentConditions() {
        return this.exportPaymentConditions;
    }

    function getExportCustomsTariff() {
        return this.exportCustomsTariff;
    }

    function getExportTermsOfDelivery() {
        return this.exportTermsOfDelivery;
    }

    function getWorkflowVisible() {
        return this.workflowVisible;
    }

    function getConsignatarioEsCliente() {
        return this.consignatarioEsCliente;
    }

    function getDivisa() {
        return this.divisa;
    }


    //**************************************
    //************** SGETTERS ************** 
    function setUserKey(pValue) {
        this.userKey = pValue;
    }

    function setExportKey(pValue) {
        this.exportKey = pValue;
    }

    function setExportCode(pValue) {
        this.exportCode = pValue;
    }

    function setConsigneeKey(pValue) {
        this.consigneeKey = pValue;
    }

    function setCustomerKey(pValue) {
        this.customerKey = pValue;
    }

    function setExportPaymentConditions(pValue) {
        this.exportPaymentConditions = pValue;
    }

    function setExportCustomsTariff(pValue) {
        this.exportCustomsTariff = pValue;
    }

    function setExportTermsOfDelivery(pValue) {
        this.exportTermsOfDelivery = pValue;
    }

    function setWorkflowVisible(pValue) {
        this.workflowVisible = pValue;
    }

    function setWorkflowVisible(pValue) {
        this.workflowVisible = pValue;
    }

    function setConsignatarioEsCliente(pValue) {
        this.consignatarioEsCliente = pValue;
    }

    function setDivisa(pValue) {
        this.divisa = pValue;
    }


  }

})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('preciosService', preciosService);


  function preciosService(WRITE_IN_CONSOLE,utilsService,firebaseDataService,$firebaseArray) {

    var precios = new precios();


    var service = {
      precios: precios,

      getPrecios: getPrecios,      

      getPpt1ventana: getPpt1ventana,
      getPpt2ventanas: getPpt2ventanas,
      getPpt3ventanas: getPpt3ventanas,
      getPpt4ventanas: getPpt4ventanas,
      getPpt5ventanas: getPpt5ventanas,
      getPpt6ventanas: getPpt6ventanas,
      getPptMas7ventanas: getPptMas7ventanas,

      getMontajeConMotivoS1: getMontajeConMotivoS1,
      getMontajeConMotivoS2: getMontajeConMotivoS2,
      getMontajeConMotivoS3: getMontajeConMotivoS3,

      getMontajeSinMotivoS1: getMontajeSinMotivoS1,
      getMontajeSinMotivoS2: getMontajeSinMotivoS2,
      getMontajeSinMotivoS3: getMontajeSinMotivoS3,

      getEmbalajeConMotivoS1: getEmbalajeConMotivoS1,
      getEmbalajeConMotivoS2: getEmbalajeConMotivoS2,
      getEmbalajeConMotivoS3: getEmbalajeConMotivoS3,

      getEmbalajeSinMotivoS1: getEmbalajeSinMotivoS1,
      getEmbalajeSinMotivoS2: getEmbalajeSinMotivoS2,
      getEmbalajeSinMotivoS3: getEmbalajeSinMotivoS3,

      getTransporteConMotivoS1: getTransporteConMotivoS1,
      getTransporteConMotivoS2: getTransporteConMotivoS2,
      getTransporteConMotivoS3: getTransporteConMotivoS3,

      getTransporteSinMotivoS1: getTransporteSinMotivoS1,
      getTransporteSinMotivoS2: getTransporteSinMotivoS2,
      getTransporteSinMotivoS3: getTransporteSinMotivoS3,
    };

    return service;


    ////////////
    function precios() {

      this.ppt1ventana = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };

      this.ppt2ventanas = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };

      this.ppt3ventanas = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };

      this.ppt4ventanas = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };

      this.ppt5ventanas = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };

      this.ppt6ventanas = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };

      this.pptMas7ventanas = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };

      //Transporte CON MOTIVO S1
      this.transporteConMotivoS1 = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };

      //Transporte CON MOTIVO S2
      this.transporteConMotivoS2 = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };

      //Transporte CON MOTIVO S3
      this.transporteConMotivoS3 = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };


      //Transporte SIN MOTIVO S1
      this.transporteSinMotivoS1 = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };

      //Transporte SIN MOTIVO S2
      this.transporteSinMotivoS2 = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };

      //Transporte SIN MOTIVO S3
      this.transporteSinMotivoS3 = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };


      //Montaje CON MOTIVO S1
      this.montajeConMotivoS1 = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };

      //Montaje CON MOTIVO S2
      this.montajeConMotivoS2 = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };

      //Montaje CON MOTIVO S3
      this.montajeConMotivoS3 = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };


      //Montaje SIN MOTIVO S1
      this.montajeSinMotivoS1 = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };

      //Montaje SIN MOTIVO S2
      this.montajeSinMotivoS2 = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };

      //Montaje SIN MOTIVO S3
      this.montajeSinMotivoS3 = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };


      //Embalaje CON MOTIVO S1
      this.embalajeConMotivoS1 = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };

      //Embalaje CON MOTIVO S2
      this.embalajeConMotivoS2 = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };

      //Embalaje CON MOTIVO S3
      this.embalajeConMotivoS3 = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };


      //Embalaje SIN MOTIVO S1
      this.embalajeSinMotivoS1 = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };

      //Embalaje SIN MOTIVO S2
      this.embalajeSinMotivoS2 = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };

      //Embalaje SIN MOTIVO S3
      this.embalajeSinMotivoS3 = {
          referencia : "",
          refLeroyMerlin : "",
          descripcion : "",
          precioCoste : 0,
          precioLeroyMerlin : 0
      };
 
    }



    function getPrecios() {

      var fbUrl = firebaseDataService.configuracion_precios;
      var result = $firebaseArray(fbUrl);

      result.$loaded()
          .then(function(data) {

              var dataLength = data.length;

              utilsService.writeConsole("[PreciosService] => getPrecios() => EJECUCIÓN OK DE CONSULTA TABLA 'configuracion_precios' con data.length = " + dataLength, WRITE_IN_CONSOLE);

              if (dataLength > 0) {


                //Ventanas en passe-partout
                precios.ppt1ventana = data[0];
                precios.ppt2ventanas = data[0];
                precios.ppt3ventanas = data[1];
                precios.ppt4ventanas = data[2];
                precios.ppt5ventanas = data[3];
                precios.ppt6ventanas = data[4];
                precios.pptMas7ventanas = data[5];

                //Transporte CON MOTIVO
                precios.transporteConMotivoS1 = data[6];
                precios.transporteConMotivoS2 = data[7];
                precios.transporteConMotivoS3 = data[8];

                //Transporte SIN MOTIVO
                precios.transporteSinMotivoS1 = data[9];
                precios.transporteSinMotivoS2 = data[10];
                precios.transporteSinMotivoS3 = data[11];


                //Montaje CON MOTIVO
                precios.montajeConMotivoS1 = data[12];
                precios.montajeConMotivoS2 = data[13];
                precios.montajeConMotivoS3 = data[14];
                
                //Montaje SIN MOTIVO
                precios.montajeSinMotivoS1 = data[15];
                precios.montajeSinMotivoS2 = data[16];
                precios.montajeSinMotivoS3 = data[17];

                //Embalaje CON MOTIVO
                precios.embalajeConMotivoS1 = data[18];
                precios.embalajeConMotivoS2 = data[19];
                precios.embalajeConMotivoS3 = data[20];
                
                //Embalaje SIN MOTIVO
                precios.embalajeSinMotivoS1 = data[21];
                precios.embalajeSinMotivoS2 = data[22];
                precios.embalajeSinMotivoS3 = data[23];

              }

          })

          .catch(function(error) {

              utilsService.writeConsole("[PreciosService] => getPrecios() => ERROR: " + error, WRITE_IN_CONSOLE);
          }
      );

    }


    //************************************** 
    //************** GETTERS ************** 
    function getPpt1ventana() {
        return precios.ppt1ventana;
    }

    function getPpt2ventanas() {
        return precios.ppt2ventanas;
    }

    function getPpt3ventanas() {
        return precios.ppt3ventanas;
    }

    function getPpt4ventanas() {
        return precios.ppt4ventanas;
    }

    function getPpt5ventanas() {
        return precios.ppt5ventanas;
    }

    function getPpt6ventanas() {
        return precios.ppt6ventanas;
    }

    function getPptMas7ventanas() {
        return precios.pptMas7ventanas;
    }


    function getTransporteConMotivoS1() {
        return precios.transporteConMotivoS1;
    }

    function getTransporteConMotivoS2() {
        return precios.transporteConMotivoS2;
    }

    function getTransporteConMotivoS3() {
        return precios.transporteConMotivoS3;
    }


    function getTransporteSinMotivoS1() {
        return precios.transporteSinMotivoS1;
    }

    function getTransporteSinMotivoS2() {
        return precios.transporteSinMotivoS2;
    }

    function getTransporteSinMotivoS3() {
        return precios.transporteSinMotivoS3;
    }


    function getMontajeConMotivoS1() {
        return precios.montajeConMotivoS1;
    }

    function getMontajeConMotivoS2() {
        return precios.montajeConMotivoS2;
    }

    function getMontajeConMotivoS3() {
        return precios.montajeConMotivoS3;
    }


    function getMontajeSinMotivoS1() {
        return precios.montajeSinMotivoS1;
    }

    function getMontajeSinMotivoS2() {
        return precios.montajeSinMotivoS2;
    }

    function getMontajeSinMotivoS3() {
        return precios.montajeSinMotivoS3;
    }


    function getEmbalajeConMotivoS1() {
        return precios.embalajeConMotivoS1;
    }

    function getEmbalajeConMotivoS2() {
        return precios.embalajeConMotivoS2;
    }

    function getEmbalajeConMotivoS3() {
        return precios.embalajeConMotivoS3;
    }


    function getEmbalajeSinMotivoS1() {
        return precios.embalajeSinMotivoS1;
    }

    function getEmbalajeSinMotivoS2() {
        return precios.embalajeSinMotivoS2;
    }

    function getEmbalajeSinMotivoS3() {
        return precios.embalajeSinMotivoS3;
    }


    //**************************************
    //************** SETTERS ************** 


  }

})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('loginService', loginService);


  function loginService($http,WRITE_IN_CONSOLE,utilsService,firebaseDataService,$firebaseArray) {

    var login = new login();

    var service = {
        login: login,
        getLogin: getLogin,
        resetLogin: resetLogin,

        getUserLogin: getUserLogin,
        getName: getName,
        getEmail: getEmail,
        getUserKey: getUserKey,
        getUserProfile: getUserProfile,
        getUserName: getUserName,
        getPassword : getPassword,
        getCompany: getCompany,
        getCompanyKey: getCompanyKey,
        getPhone: getPhone,

        setName: setName,
        setEmail: setEmail,
        setUserKey: setUserKey,
        setUserProfile: setUserProfile,
        setUserName: setUserName,
        setPassword : setPassword,
        setCompany: setCompany,
        setCompanyKey: setCompanyKey,
        setPhone: setPhone
    };

    return service;



    ////////////
    function login() {

      this.name = "";
      this.email = "";
      this.userKey = "";
      this.userProfile = "";        
      this.userName = "";
      this.password = "";
      this.company = "";
      this.companyKey = "";
      this.phone = "";
      this.ok = false;

/* 
      utilsService.writeConsole("INICIO EJECUCION constructor login()",WRITE_IN_CONSOLE);
      utilsService.writeConsole("this.name = " + this.name,WRITE_IN_CONSOLE);
      utilsService.writeConsole("this.email = " + this.email,WRITE_IN_CONSOLE);
      utilsService.writeConsole("this.userKey = " + this.userKey,WRITE_IN_CONSOLE);
      utilsService.writeConsole("this.userProfile = " + this.userProfile,WRITE_IN_CONSOLE);
      utilsService.writeConsole("this.userName = " + this.userName,WRITE_IN_CONSOLE);
      utilsService.writeConsole("this.company = " + this.company,WRITE_IN_CONSOLE);
      utilsService.writeConsole("this.companyKey = " + this.companyKey,WRITE_IN_CONSOLE);
      utilsService.writeConsole("this.phone = " + this.phone,WRITE_IN_CONSOLE);
      utilsService.writeConsole("this.ok = " + this.ok,WRITE_IN_CONSOLE);
      utilsService.writeConsole("FIN EJECUCION constructor login()",WRITE_IN_CONSOLE);
*/      
    }



    function getLogin() {

/*
        utilsService.writeConsole("EJECUCION getLogin()",WRITE_IN_CONSOLE);
        utilsService.writeConsole("this.name = " + this.name,WRITE_IN_CONSOLE);
        utilsService.writeConsole("this.email = " + this.email,WRITE_IN_CONSOLE);
        utilsService.writeConsole("this.userKey = " + this.userKey,WRITE_IN_CONSOLE);
        utilsService.writeConsole("this.userProfile = " + this.userProfile,WRITE_IN_CONSOLE);
        utilsService.writeConsole("this.userName = " + this.userName,WRITE_IN_CONSOLE);
        utilsService.writeConsole("this.company = " + this.company,WRITE_IN_CONSOLE);
        utilsService.writeConsole("this.companyKey = " + this.companyKey,WRITE_IN_CONSOLE);        
        utilsService.writeConsole("this.phone = " + this.phone,WRITE_IN_CONSOLE);
        utilsService.writeConsole("this.ok = " + this.ok,WRITE_IN_CONSOLE);
        utilsService.writeConsole("FIN EJECUCION constructor login()",WRITE_IN_CONSOLE);
*/
        return this;
    }


    function resetLogin() {

      this.name = "";
      this.email = "";
      this.userKey = "";
      this.userProfile = "";        
      this.userName = "";
      this.company = "";
      this.companyKey = "";
      this.phone = "";
      this.password = "";
      this.ok = false;
    }


    function getUserLogin(pEmail,pPassword,pContactNumber) {

        var result;

        if ( (pEmail != null) && (pEmail.trim().length > 0) && (pPassword != null) && (pPassword.trim().length > 0) ) {
            
            var fbUrl = firebaseDataService.usuarios;

            if (pContactNumber == 1) {
                result = $firebaseArray(fbUrl.orderByChild("email").equalTo(pEmail));
            }
            else if (pContactNumber == 2) {
                result = $firebaseArray(fbUrl.orderByChild("email2").equalTo(pEmail));
            }
            else if (pContactNumber == 3) {
                result = $firebaseArray(fbUrl.orderByChild("email3").equalTo(pEmail));
            }
            
            return result;

        } else {

            return null;
        } 
    }



    //************ GETTERs *******************
    function getName() {
        return this.name;
    }


    function getEmail() {
        return this.email;
    }

    function getUserKey() {
        return this.userKey;
    }

    function getUserProfile() {
        return this.userProfile;
    }


    function getUserName() {
        return this.userName;
    }


    function getCompany() {
        return this.company;
    }


    function getCompanyKey() {
        return this.companyKey;
    }


    function getPhone() {
        return this.phone;
    }


    function getPassword() {
        return this.password;
    }


    //************ SETTERs *******************
    function setName(pValue) {
        this.name = pValue;
    }

    function setEmail(pValue) {
        this.email = pValue;
    }

    function setUserKey(pValue) {
        this.userKey = pValue;
    }

    function setUserProfile(pValue) {
        this.userProfile = pValue;
    }

    function setUserName(pValue) {
        this.userName = pValue;
    }

    function setCompany(pValue) {
        this.company = pValue;
    }

    function setCompanyKey(pValue) {
        this.companyKey = pValue;
    }

    function setPhone(pValue) {
        this.phone = pValue;
    }

    function setPassword(pValue) {
        this.password = pValue;
    }



  }

})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('firebaseDataService', firebaseDataService);

 
  function firebaseDataService() {
      
/*
    //SERVIDOR PRODUCCION LEROY MERLIN
    var config = {
        apiKey: "AIzaSyBMtIBEx6WfmV_niOTFvBre_GwSIcmww4Q",
        authDomain: "centros-lm.firebaseapp.com",
        databaseURL: "https://centros-lm.firebaseio.com/",
        storageBucket: "gs://centros-lm.appspot.com/",
    };
*/


    //SERVIDOR PRODUCCION AKI       
    var config = {
        apiKey: "AIzaSyDsfRKpnlb5dmB2_zhl-doMhecNp4owIfY",
        authDomain: "centros-aki.firebaseapp.com",
        databaseURL: "https://centros-aki.firebaseio.com/",
        storageBucket: "gs://centros-aki.appspot.com/",
    };


/*
    //SERVIDOR DEVELOPER (TEST)
    var config = {
        apiKey: "AIzaSyAyLihXHSnUMofKt3ZOwKEukFWc_jLGOP0",
        authDomain: "buenatelier-app.firebaseapp.com",
        databaseURL: "https://buenatelier-app.firebaseio.com/",
        storageBucket: "gs://buenatelier-app.appspot.com/",
    };
*/

    firebase.initializeApp(config);

    var firebaseRootRef = firebase.database().ref();
    var firebaseStorageRootRef = firebase.storage().ref();

    var service = {

      firebaseRootRef: firebaseRootRef,
      firebaseStorageRootRef: firebaseStorageRootRef,
      
      usuarios: firebaseRootRef.child("usuarios"),
      usuario_presupuestos: firebaseRootRef.child("usuario_presupuestos"),
      empresas: firebaseRootRef.child("empresas"),
      presupuestos: firebaseRootRef.child("presupuestos"),
      productos_moldura: firebaseRootRef.child("productos_moldura"),
      productos_passepartout: firebaseRootRef.child("productos_passepartout"),
      productos_varios: firebaseRootRef.child("productos_varios"),
      presupuesto_espejo: firebaseRootRef.child("presupuesto_espejo"),
      presupuesto_marco: firebaseRootRef.child("presupuesto_marco"),
      configuracion_precios: firebaseRootRef.child("configuracion_precios")
    };

    return service;
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');

/* E-LUSIONA => Ponemos vm.folded=true para que se muestre el menú principal contraído al iniciar la App
        vm.folded = false;
*/      vm.folded = true;


        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Common 3rd Party Dependencies
            'uiGmapgoogle-maps',
            'textAngular',
            'xeditable',

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // TOOLBAR (zona superior) - Incluye Botones de Workflow de FASES
            'app.toolbar',

            // Quick Panel 
            //'app.quick-panel',

            // Services
            'app.services',

            // AUTH
            'app.auth.login-v2',
//            'app.auth.register-v2',
//            'app.auth.forgot-password',
//            'app.auth.reset-password',
//            'app.auth.user-profile',

            // MENU
            'app.menu',


/*
            // Apps
            'app.dashboards',
            'app.calendar',
            'app.e-commerce',
            'app.mail',
            'app.chat',
            'app.file-manager',
            'app.gantt-chart',
            'app.scrumboard',
            'app.todo',
            'app.contacts',
            'app.notes',

            // Pages
            'app.pages',

            // User Interface
            'app.ui',

            // Components
            'app.components'
*/

        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, editableThemes)
    {
        // 3rd Party Dependencies
        editableThemes.default.submitTpl = '<md-button class="md-icon-button" type="submit" aria-label="save"><md-icon md-font-icon="icon-checkbox-marked-circle" class="md-accent-fg md-hue-1"></md-icon></md-button>';
        editableThemes.default.cancelTpl = '<md-button class="md-icon-button" ng-click="$form.$cancel()" aria-label="cancel"><md-icon md-font-icon="icon-close-circle" class="icon-cancel"></md-icon></md-button>';

        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        //INITIAL PAGE TO RUN
        $urlRouterProvider.otherwise('/auth/login-v2');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')

        //ACTIVAR "console.log"
        .constant('WRITE_IN_CONSOLE', false);

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config(uiGmapGoogleMapApiProvider, $translateProvider, $provide, $mdDateLocaleProvider)
    {
        // Put your common app configurations here


        //DATE FORMAT CONFIGURATION
        $mdDateLocaleProvider.formatDate = function(date) {
           //return moment(date).format('YYYY/MM/DD');
           return moment(date).format('DD/MM/YYYY');
        };

        $mdDateLocaleProvider.parseDate = function(dateString) {
            //var m = moment(dateString, 'YYYY/MM/DD', true);
            var m = moment(dateString, 'DD/MM/YYYY', true);

            return m.isValid() ? m.toDate() : new Date(NaN);
        };      




        // uiGmapgoogle-maps configuration
        uiGmapGoogleMapApiProvider.configure({
            //    key: 'your api key',
            v        : '3.exp',
            libraries: 'weather,geometry,visualization'
        });


        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });

        //DEFINIMOS EL IDIOMA INICIAL DE LA APLICACIÓN
        //$translateProvider.preferredLanguage('en');
        $translateProvider.preferredLanguage('es');

        $translateProvider.useSanitizeValueStrategy('sanitize');

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions)
            {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
                ];

                taOptions.classes = {
                    focussed           : 'focussed',
                    toolbar            : 'ta-toolbar',
                    toolbarGroup       : 'ta-group',
                    toolbarButton      : 'md-button',
                    toolbarButtonActive: 'active',
                    disabled           : '',
                    textEditor         : 'form-control',
                    htmlEditor         : 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools)
            {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';

                return taTools;
            }
        ]);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        /**
         * Here you can find all the definitions that the Demo Project requires
         *
         * If you wish to use this method, you can create your API definitions
         * in a similar way.
         */

        /*
         api.dashboard = {
         project  : $resource(api.baseUrl + 'dashboard/project/data.json'),
         server   : $resource(api.baseUrl + 'dashboard/server/data.json'),
         analytics: $resource(api.baseUrl + 'dashboard/analytics/data.json')
         };

         api.cards = $resource(api.baseUrl + 'cards/cards.json');

         api.fileManager = {
         documents: $resource(api.baseUrl + 'file-manager/documents.json')
         };

         api.ganttChart = {
         tasks: $resource(api.baseUrl + 'gantt-chart/tasks.json'),
         timespans : $resource(api.baseUrl + 'gantt-chart/timespans.json')
         };

         api.icons = $resource('assets/icons/selection.json');

         api.invoice = $resource(api.baseUrl + 'invoice/invoice.json');

         api.mail = {
         inbox: $resource(api.baseUrl + 'mail/inbox.json')
         };

         api.profile = {
         timeline    : $resource(api.baseUrl + 'profile/timeline.json'),
         about       : $resource(api.baseUrl + 'profile/about.json'),
         photosVideos: $resource(api.baseUrl + 'profile/photos-videos.json')
         };

         api.quickPanel = {
         activities: $resource(api.baseUrl + 'quick-panel/activities.json'),
         contacts  : $resource(api.baseUrl + 'quick-panel/contacts.json'),
         events    : $resource(api.baseUrl + 'quick-panel/events.json'),
         notes     : $resource(api.baseUrl + 'quick-panel/notes.json')
         };

         api.search = {
         classic : $resource(api.baseUrl + 'search/classic.json'),
         mails   : $resource(api.baseUrl + 'search/mails.json'),
         users   : $resource(api.baseUrl + 'search/users.json'),
         contacts: $resource(api.baseUrl + 'search/contacts.json')
         };

         api.scrumboard = {
         boardList: $resource(api.baseUrl + 'scrumboard/boardList.json'),
         board    : $resource(api.baseUrl + 'scrumboard/boards/:id.json')
         };

         api.tables = {
         employees   : $resource(api.baseUrl + 'tables/employees.json'),
         employees100: $resource(api.baseUrl + 'tables/employees100.json')
         };

         api.timeline = {
         page1: $resource(api.baseUrl + 'timeline/page-1.json'),
         page2: $resource(api.baseUrl + 'timeline/page-2.json'),
         page3: $resource(api.baseUrl + 'timeline/page-3.json')
         };

         api.todo = {
         tasks: $resource(api.baseUrl + 'todo/tasks.json'),
         tags : $resource(api.baseUrl + 'todo/tags.json')
         };
         */

        return api;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.menu.productos', [
            'app.menu.productos.molduras'
            ,'app.menu.productos.passepartouts'
            ,'app.menu.productos.varios'
            ,'app.menu.productos.servicios'
        ])
        .config(config);


    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('menu.productos', {
            title : 'Productos',
            icon  : 'icon-cube-outline',
            //state : 'app.menu_productos',
            weight: 2
        });        
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.reset-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_reset-password', {
            url      : '/pages/auth/reset-password',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_reset-password': {
                    templateUrl: 'app/main/pages/auth/reset-password/reset-password.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            bodyClass: 'reset-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/reset-password');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.reset-password', {
            title : 'Reset Password',
            state : 'app.pages_auth_reset-password',
            weight: 6
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_register', {
            url      : '/pages/auth/register',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_register': {
                    templateUrl: 'app/main/pages/auth/register/register.html',
                    controller : 'RegisterController as vm'
                }
            },
            bodyClass: 'register'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/register');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.register', {
            title : 'Register',
            state : 'app.pages_auth_register',
            weight: 3
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.lock', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_lock', {
            url      : '/pages/auth/lock',
            views    : {
                'main@'                      : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_lock': {
                    templateUrl: 'app/main/pages/auth/lock/lock.html',
                    controller : 'LockController as vm'
                }
            },
            bodyClass: 'lock'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/lock');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.lock', {
            title : 'Lock Screen',
            state : 'app.pages_auth_lock',
            weight: 7
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_forgot-password', {
            url      : '/pages/auth/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_forgot-password': {
                    templateUrl: 'app/main/pages/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/forgot-password');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.forgot-password', {
            title : 'Forgot Password',
            state : 'app.pages_auth_forgot-password',
            weight: 5
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_login', {
            url      : '/pages/auth/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login': {
                    templateUrl: 'app/main/pages/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/login');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth', {
            title : 'Authentication',
            icon  : 'icon-lock',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('pages.auth.login', {
            title : 'Login',
            state : 'app.pages_auth_login',
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards',
            [
                'app.dashboards.project',
                'app.dashboards.server',
                'app.dashboards.analytics'
            ]
        )
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('apps', {
            title : 'APPS',
            group : true,
            weight: 1
        });

        msNavigationServiceProvider.saveItem('apps.dashboards', {
            title : 'Dashboards',
            icon  : 'icon-tile-four',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('apps.dashboards.project', {
            title: 'Project',
            state: 'app.dashboards_project'
        });

        msNavigationServiceProvider.saveItem('apps.dashboards.server', {
            title: 'Server',
            state: 'app.dashboards_server'
        });

        msNavigationServiceProvider.saveItem('apps.dashboards.analytics', {
            title: 'Analytics',
            state: 'app.dashboards_analytics'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui', [
            'app.ui.forms',
            'app.ui.helper-classes',
            'app.ui.icons',
            'app.ui.material-colors',
            'app.ui.page-layouts.blank',
            'app.ui.page-layouts.carded.fullwidth',
            'app.ui.page-layouts.carded.fullwidth-ii',
            'app.ui.page-layouts.carded.left-sidenav',
            'app.ui.page-layouts.carded.left-sidenav-ii',
            'app.ui.page-layouts.carded.right-sidenav',
            'app.ui.page-layouts.carded.right-sidenav-ii',
            'app.ui.page-layouts.simple.fullwidth',
            'app.ui.page-layouts.simple.left-sidenav',
            'app.ui.page-layouts.simple.left-sidenav-ii',
            'app.ui.page-layouts.simple.left-sidenav-iii',
            'app.ui.page-layouts.simple.right-sidenav',
            'app.ui.page-layouts.simple.right-sidenav-ii',
            'app.ui.page-layouts.simple.right-sidenav-iii',
            'app.ui.page-layouts.simple.tabbed',
            'app.ui.theme-colors',
            'app.ui.typography'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('ui', {
            title : 'USER INTERFACE',
            group : true,
            weight: 3
        });

        msNavigationServiceProvider.saveItem('ui.forms', {
            title: 'Forms',
            icon : 'icon-window-restore',
            state: 'app.ui_forms'
        });

        msNavigationServiceProvider.saveItem('ui.icons', {
            title: 'Icons',
            icon : 'icon-file-image-box',
            state: 'app.ui_icons'
        });

        msNavigationServiceProvider.saveItem('ui.typography', {
            title: 'Typography',
            icon : 'icon-format-size',
            state: 'app.ui_typography'
        });

        msNavigationServiceProvider.saveItem('ui.helper-classes', {
            title: 'Helper Classes',
            icon : 'icon-help-circle',
            state: 'app.ui_helper-classes'
        });

        msNavigationServiceProvider.saveItem('ui.theme-colors', {
            title: 'Theme Colors',
            icon : 'icon-palette-advanced',
            state: 'app.ui_theme-colors'
        });

        msNavigationServiceProvider.saveItem('ui.material-colors', {
            title: 'Material Colors',
            icon : 'icon-palette',
            state: 'app.ui_material-colors'
        });


        msNavigationServiceProvider.saveItem('ui.page-layouts', {
            title: 'Page Layouts',
            icon : 'icon-view-quilt'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded', {
            title: 'Carded'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.fullwidth', {
            title: 'Full Width (I)',
            state: 'app.ui_page-layouts_carded_fullwidth'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.fullwidth-ii', {
            title: 'Full Width (II)',
            state: 'app.ui_page-layouts_carded_fullwidth-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.left-sidenav', {
            title: 'Left Sidenav (I)',
            state: 'app.ui_page-layouts_carded_left-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.left-sidenav-ii', {
            title: 'Left Sidenav (II)',
            state: 'app.ui_page-layouts_carded_left-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.right-sidenav', {
            title: 'Right Sidenav (I)',
            state: 'app.ui_page-layouts_carded_right-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.right-sidenav-ii', {
            title: 'Right Sidenav (II)',
            state: 'app.ui_page-layouts_carded_right-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple', {
            title: 'Simple'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.fullwidth', {
            title: 'Full Width (I)',
            state: 'app.ui_page-layouts_simple_fullwidth'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.left-sidenav', {
            title: 'Left Sidenav (I)',
            state: 'app.ui_page-layouts_simple_left-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.left-sidenav-ii', {
            title: 'Left Sidenav (II)',
            state: 'app.ui_page-layouts_simple_left-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.left-sidenav-iii', {
            title: 'Left Sidenav (III)',
            state: 'app.ui_page-layouts_simple_left-sidenav-iii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.right-sidenav', {
            title: 'Right Sidenav (I)',
            state: 'app.ui_page-layouts_simple_right-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.right-sidenav-ii', {
            title: 'Right Sidenav (II)',
            state: 'app.ui_page-layouts_simple_right-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.right-sidenav-iii', {
            title: 'Right Sidenav (III)',
            state: 'app.ui_page-layouts_simple_right-sidenav-iii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.tabbed', {
            title: 'Tabbed',
            state: 'app.ui_page-layouts_simple_tabbed'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.blank', {
            title: 'Blank',
            state: 'app.ui_page-layouts_blank'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages', [
            'app.pages.auth.login',
            'app.pages.auth.login-v2',
            'app.pages.auth.register',
            'app.pages.auth.register-v2',
            'app.pages.auth.forgot-password',
            'app.pages.auth.reset-password',
            'app.pages.auth.lock',
            'app.pages.coming-soon',
            'app.pages.error-404',
            'app.pages.error-500',
            'app.pages.invoice',
            'app.pages.maintenance',
            'app.pages.profile',
            'app.pages.search',
            'app.pages.timeline'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('pages', {
            title : 'PAGES',
            group : true,
            weight: 2
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.menu', [

            'app.menu.presupuestos',

            'app.menu.usuarios',

            'app.menu.productos',

/*            
            'app.pages.error-404',
            'app.pages.error-500',
*/
            
/*
            'app.menu.ayuda',
            'app.menu.contactar',
*/
            
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('menu', {
            title : 'MENÚ PRINCIPAL',
            group : true,
            weight: 1
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components', [
            'app.components.cards',
            'app.components.charts.c3',
            'app.components.charts.chart-js',
            'app.components.charts.chartist',
            'app.components.charts.nvd3',
            'app.components.custom-directives',
            'app.components.maps',
            'app.components.price-tables',
            'app.components.tables.simple-table',
            'app.components.tables.datatable',
            'app.components.widgets',
            'app.components.material-docs'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('components', {
            title : 'COMPONENTS',
            group : true,
            weight: 4
        });

        msNavigationServiceProvider.saveItem('components.cards', {
            title : 'Cards',
            icon  : 'icon-content-copy',
            state : 'app.components_cards',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('components.charts', {
            title : 'Charts',
            icon  : 'icon-poll',
            weight: 4
        });

        msNavigationServiceProvider.saveItem('components.charts.c3', {
            title: 'C3',
            state: 'app.components_charts_c3'
        });

        msNavigationServiceProvider.saveItem('components.charts.chart-js', {
            title: 'Chart.js',
            state: 'app.components_charts_chart-js'
        });

        msNavigationServiceProvider.saveItem('components.charts.chartist', {
            title: 'Chartist',
            state: 'app.components_charts_chartist'
        });

        msNavigationServiceProvider.saveItem('components.charts.nvd3', {
            title: 'nvD3',
            state: 'app.components_charts_nvd3'
        });

        msNavigationServiceProvider.saveItem('components.maps', {
            title: 'Maps',
            icon : 'icon-map-marker',
            state: 'app.components_maps',
            weight: 5
        });

        msNavigationServiceProvider.saveItem('components.price-tables', {
            title: 'Price Tables',
            icon : 'icon-view-carousel',
            state: 'app.components_price-tables',
            weight: 6
        });

        msNavigationServiceProvider.saveItem('components.tables', {
            title: 'Tables',
            icon : 'icon-table-large',
            weight: 7
        });

        msNavigationServiceProvider.saveItem('components.tables.simple-table', {
            title: 'Simple Table',
            state: 'app.components_tables_simple-table',
            weight: 8
        });

        msNavigationServiceProvider.saveItem('components.tables.datatable', {
            title: 'Datatable',
            state: 'app.components_tables_datatable',
            weight: 9
        });

        msNavigationServiceProvider.saveItem('components.widgets', {
            title: 'Widgets',
            icon : 'icon-apps',
            state: 'app.components_widgets',
            weight: 10
        });
    }
})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/theme-options/theme-options.html","");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" ms-scroll \nng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/apps/calendar/calendar.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header\" \nng-class=\"vm.currentMonthShort\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-top\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span \nclass=\"logo-text\" translate=\"CALENDAR.CALENDAR\">Calendar</span></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" aria-label=\"Search\" translate \ntranslate-attr-aria-label=\"CALENDAR.SEARCH\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.SEARCH\">Search</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.today()\" aria-label=\"Today\" translate translate-attr-aria-label=\"CALENDAR.TODAY\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span translate=\"CALENDAR.TODAY\">Today</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" \ntranslate translate-attr-aria-label=\"CALENDAR.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.DAY\">Day</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"Week\" translate translate-attr-aria-label=\"CALENDAR.WEEK\">\n<md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span translate=\"CALENDAR.WEEK\">Week</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate \ntranslate-attr-aria-label=\"CALENDAR.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.MONTH\">Month</span></md-tooltip></md-button></div></div><div class=\"header-bottom\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" \naria-label=\"Previous\" translate translate-attr-aria-label=\"CALENDAR.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><div class=\"title\">{{vm.calendarView.title}}</div><md-button \nclass=\"md-icon-button arrow\" ng-click=\"vm.calendar.next()\" aria-label=\"Next\" translate \ntranslate-attr-aria-label=\"CALENDAR.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div>\n<md-button class=\"add-event-button md-fab md-warn\" ng-click=\"vm.addEvent($event)\" aria-label=\"Add event\" translate \ntranslate-attr-aria-label=\"CALENDAR.ADD_EVENT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nclass=\"content\"><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\">\n</div></div></div>");
$templateCache.put("app/main/apps/gantt-chart/gantt-chart.html","<div id=\"gantt-chart\" class=\"page-layout carded fullwidth\" \nng-class=\"{\'date-filter-active\':vm.dateFilterActive, \'search-active\': vm.searchActive}\" layout=\"row\"><md-sidenav \nclass=\"sidenav settings-sidenav md-sidenav-right\" md-component-id=\"settings-sidenav\" \nng-include=\"\'app/main/apps/gantt-chart/sidenavs/settings/settings-sidenav.html\'\" ms-scroll ms-sidenav-helper>\n</md-sidenav><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" \nlayout=\"column\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-text\" class=\"icon\"></md-icon>\n</span><span class=\"logo-text\" translate=\"GANTT.GANTT_CHART\">Gantt Chart</span></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.searchActive = !vm.searchActive\" \naria-label=\"Search\" translate translate-attr-aria-label=\"GANTT.SEARCH\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<md-tooltip><span translate=\"GANTT.SEARCH\">Search</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.dateFilterActive = !vm.dateFilterActive\" aria-label=\"Filter Date\" translate \ntranslate-attr-aria-label=\"GANTT.FILTER_DATE\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><md-tooltip><span \ntranslate=\"GANTT.FILTER_DATE\">Filter Date</span></md-tooltip></md-button><md-button ng-click=\"vm.reload()\" \nclass=\"md-icon-button\" aria-label=\"Reload\" translate translate-attr-aria-label=\"GANTT.RELOAD\"><md-icon \nmd-font-icon=\"icon-reload\"></md-icon><md-tooltip><span translate=\"GANTT.RELOAD\">RELOAD</span></md-tooltip></md-button>\n<md-button ng-click=\"vm.toggleSidenav(\'settings-sidenav\')\" class=\"md-icon-button\" aria-label=\"Settings\" translate \ntranslate-attr-aria-label=\"GANTT.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip><span \ntranslate=\"GANTT.SETTINGS\">Settings</span></md-tooltip></md-button></div></div><div class=\"bottom\" layout=\"column\" \nlayout-gt-sm=\"row\" layout-align-gt-sm=\"end center\"><div class=\"search-boxes\" flex ng-show=\"vm.searchActive\" \nlayout=\"column\" layout-gt-xs=\"row\"><div class=\"search md-whiteframe-3dp mr-8\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex \nng-model=\"vm.searchRowKeyword\" ng-change=\"vm.search(\'rows\', vm.searchRowKeyword)\" type=\"text\" \nplaceholder=\"Search in rows\" translate translate-attr-placeholder=\"GANTT.SEARCH_IN_ROWS\"></div><div \nclass=\"search md-whiteframe-3dp\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon><input flex ng-model=\"vm.searchTaskKeyword\" \nng-change=\"vm.search(\'tasks\', vm.searchTaskKeyword)\" type=\"text\" placeholder=\"Search in tasks\" translate \ntranslate-attr-placeholder=\"GANTT.SEARCH_IN_TASKS\"></div></div><div class=\"date-filter-box md-whiteframe-3dp\" \nng-show=\"vm.dateFilterActive\" layout=\"column\" layout-gt-xs=\"row\" layout-align-gt-xs=\"center center\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"filter from\"><span class=\"label\">From:</span><md-datepicker ms-datepicker-fix \nng-model=\"vm.options.fromDate\" md-max-date=\"vm.options.toDate\" md-placeholder=\"Enter date\"></md-datepicker></div><div \nlayout=\"row\" layout-align=\"center center\" class=\"filter to\"><span class=\"label\">To:</span><md-datepicker \nms-datepicker-fix ng-model=\"vm.options.toDate\" md-min-date=\"vm.options.fromDate\" md-placeholder=\"Enter date\">\n</md-datepicker></div></div></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nng-click=\"vm.addDialog($event)\" class=\"md-icon-button add-row-button\" aria-label=\"Add\" translate \ntranslate-attr-aria-label=\"GANTT.ADD\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"zoom\" layout=\"row\" layout-align=\"end center\"><span class=\"label\">Zoom:</span>\n<div class=\"input-wrapper\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" \naria-label=\"minus\" ng-click=\"vm.options.zoom  = vm.options.zoom - 0.1\"><md-icon md-font-icon=\"icon-minus\"></md-icon>\n</md-button><input type=\"number\" ng-model=\"vm.options.zoom\" step=\"0.1\" min=\"0.1\" max=\"5\"><md-button \nclass=\"md-icon-button\" aria-label=\"plus\" ng-click=\"vm.options.zoom =vm.options.zoom + 0.1\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div></div><md-select class=\"simplified select-scale\" \nng-model=\"vm.options.scale\" placeholder=\"Scale\"><md-option value=\"hour\" translate=\"GANTT.HOUR\">hour</md-option>\n<md-option value=\"3 hours\" translate=\"GANTT.3_HOURS\">3 hours</md-option><md-option value=\"day\" translate=\"GANTT.DAY\">\nday</md-option><md-option value=\"week\" translate=\"GANTT.WEEK\">week</md-option><md-option value=\"2 weeks\" \ntranslate=\"GANTT.2_WEEKS\">2 weeks</md-option><md-option value=\"month\" translate=\"GANTT.MONTH\">month</md-option>\n<md-option value=\"quarter\" translate=\"GANTT.QUARTER\">quarter</md-option><md-option value=\"6 months\" \ntranslate=\"GANTT.6_MONTHS\">6 months</md-option><md-option value=\"year\" translate=\"GANTT.YEAR\">year</md-option>\n</md-select><div class=\"divider-vertical\"></div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"Filters\" translate translate-attr-aria-label=\"MAIL.FILTERS\"><md-icon \nmd-font-icon=\"icon-sort\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \naria-label=\"disabled\" ng-click=\"vm.setSortMode(undefined)\" translate=\"GANTT.DISABLED\" \ntranslate-attr-aria-label=\"GANTT.DISABLED\">disabled</md-button></md-menu-item><md-menu-item><md-button \naria-label=\"disabled\" ng-click=\"vm.setSortMode(\'from\')\" translate=\"GANTT.FROM\" translate-attr-aria-label=\"GANTT.FROM\">\nfrom</md-button></md-menu-item><md-menu-item><md-button aria-label=\"disabled\" ng-click=\"vm.setSortMode(\'to\')\" \ntranslate=\"GANTT.TO\" translate-attr-aria-label=\"GANTT.TO\">to</md-button></md-menu-item><md-menu-item><md-button \naria-label=\"disabled\" ng-click=\"vm.setSortMode(\'model.name\')\" translate=\"GANTT.NAME\" \ntranslate-attr-aria-label=\"GANTT.NAME\">name</md-button></md-menu-item></md-menu-content></md-menu></div></div>\n<md-content id=\"chart-container\" class=\"content\" flex layout=\"column\"><div flex layout-fill id=\"gantt\" gantt \ndata=\"vm.data\" timespans=\"vm.timespans\" show-side=\"vm.options.labelsEnabled\" daily=\"vm.options.daily\" \nfilter-task=\"{\'name\': vm.options.filterTask}\" filter-row=\"{\'name\': vm.options.filterRow}\" \nsort-mode=\"vm.options.sortMode\" view-scale=\"vm.options.scale\" \ncolumn-width=\"vm.getColumnWidth(vm.options.width, vm.options.scale, vm.options.zoom)\" \nauto-expand=\"vm.options.autoExpand\" task-out-of-range=\"vm.options.taskOutOfRange\" from-date=\"vm.options.fromDate\" \nto-date=\"vm.options.toDate\" allow-side-resizing=\"vm.options.allowSideResizing\" \ntask-content=\"vm.options.taskContentEnabled ? vm.options.taskContent : undefined\" \nrow-content=\"vm.options.rowContentEnabled ? vm.options.rowContent : undefined\" current-date=\"vm.options.currentDate\" \ncurrent-date-value=\"vm.options.currentDateValue\" \nheaders=\"vm.options.width && vm.options.shortHeaders || vm.options.longHeaders\" max-height=\"vm.options.maxHeight\" \ntime-frames=\"vm.options.timeFrames\" date-frames=\"vm.options.dateFrames\" \ntime-frames-non-working-mode=\"vm.options.timeFramesNonWorkingMode\" time-frames-magnet=\"vm.options.timeFramesMagnet\" \napi=\"vm.options.api\" column-magnet=\"vm.options.columnMagnet\"><gantt-tree \nenabled=\"vm.options.sideMode === \'Tree\' || vm.options.sideMode === \'TreeTable\'\" \nheader-content=\"vm.options.treeHeaderContent\" keep-ancestor-on-filter-row=\"true\"></gantt-tree><gantt-table \nenabled=\"vm.options.sideMode === \'Table\' || vm.options.sideMode === \'TreeTable\'\" \ncolumns=\"vm.options.sideMode === \'TreeTable\' ? vm.options.treeTableColumns : vm.options.columns\" \nheaders=\"vm.options.columnsHeaders\" classes=\"vm.options.columnsClasses\" formatters=\"vm.options.columnsFormatters\" \ncontents=\"vm.options.columnsContents\" header-contents=\"vm.options.columnsHeaderContents\"></gantt-table><gantt-groups \nenabled=\"vm.options.groupDisplayMode === \'group\' || vm.options.groupDisplayMode === \'overview\' || vm.options.groupDisplayMode === \'promote\'\" \ndisplay=\"vm.options.groupDisplayMode\"></gantt-groups><gantt-bounds></gantt-bounds><gantt-progress></gantt-progress>\n<gantt-sortable></gantt-sortable><gantt-movable enabled=\"!vm.options.readOnly\"></gantt-movable><gantt-draw-task \nenabled=\"vm.options.canDraw\" move-threshold=\"2\" task-factory=\"vm.options.drawTaskFactory\"></gantt-draw-task>\n<gantt-overlap></gantt-overlap><gantt-resize-sensor></gantt-resize-sensor><gantt-dependencies></gantt-dependencies>\n</div></md-content></div></div></div>");
$templateCache.put("app/main/apps/chat/chat.html","<div id=\"chat-app\" class=\"page-layout carded fullwidth\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\"><div\n class=\"content-card\" layout=\"row\" flex><md-sidenav class=\"sidenav left-sidenav md-sidenav-left\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"left-sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/apps/chat/sidenavs/left/left-sidenav.html\'\" layout=\"column\"></md-sidenav><div \nclass=\"start-point\" ng-if=\"!vm.chat\" flex layout=\"column\" flex layout-align=\"center center\"><div \nclass=\"big-circle md-whiteframe-4dp\"><md-icon class=\"s128 md-accent\" md-font-icon=\"icon-hangouts\"></md-icon></div><span\n class=\"app-title\" translate=\"CHAT.APP_TITLE\">Chat App</span> <span class=\"hide show-gt-md secondary-text\" \ntranslate=\"CHAT.START_MESSAGE\">Select contact to start the chat!..</span><md-button class=\"md-raised hide-gt-md\" \nng-click=\"vm.toggleSidenav(\'left-sidenav\')\" translate=\"CHAT.START_MESSAGE\">Select contact to start the chat!..\n</md-button></div><div ng-if=\"vm.chat\" class=\"chat\" layout=\"column\" flex><md-toolbar class=\"chat-toolbar\"><div \nclass=\"md-toolbar-tools\"><md-button class=\"hide-gt-md responsive-chats-button md-icon-button\" \nng-click=\"vm.toggleLeftSidenavView(false);vm.toggleSidenav(\'left-sidenav\')\" aria-label=\"chats button\"><md-icon \nmd-font-icon=\"icon-hangouts s36\"></md-icon></md-button><div class=\"chat-contact\" layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.toggleSidenav(\'right-sidenav\')\"><div class=\"avatar-wrapper\"><img \nng-src=\"{{vm.contacts.getById(vm.chatContactId).avatar}}\" class=\"avatar\" \nalt=\"{{vm.contacts.getById(vm.chatContactId).name}}\"> <i class=\"icon icon- s16 status\" \nng-class=\"vm.contacts.getById(vm.chatContactId).status\"></i></div><div class=\"chat-contact-name\">\n{{vm.contacts.getById(vm.chatContactId).name}}</div></div><md-menu md-position-mode=\"target-right target\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.toggleSidenav(\'right-sidenav\')\" \ntranslate=\"CHAT.CONTACT_INFO\">Contact Info</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.clearMessages()\" translate=\"CHAT.CLEAR_MESSAGES\">Clear Messages</md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><md-content id=\"chat-content\" flex ms-scroll><div class=\"chat-messages\" \nng-if=\"vm.chat\"><div layout=\"row\" ng-repeat=\"dialog in vm.chat\" class=\"md-padding message-row\" ng-class=\"dialog.who\">\n<img ng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.contacts.getById(vm.chatContactId).avatar}}\" class=\"avatar\" \nalt=\"{{vm.contacts.getById(vm.chatContactId).name}}\"> <img ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" \nng-src=\"{{vm.user.avatar}}\"><div class=\"bubble\"><div class=\"message\">{{dialog.message}}</div><div \nclass=\"time secondary-text\">{{dialog.time | altDate}}</div></div></div></div></md-content><div \nclass=\"chat-footer flex-noshrink\" layout=\"row\" layout-align=\"center center\"><form ng-submit=\"vm.reply()\" flex \nclass=\"reply-form\" layout=\"row\" layout-align=\"start center\"><md-input-container flex md-no-float><textarea \nng-keyup=\"vm.reply($event)\" md-no-autogrow ng-model=\"vm.replyMessage\" ng-class=\"{\'grow\': vm.textareaGrow}\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"CHAT.REPLY_PLACEHOLDER\">\n                            </textarea></md-input-container><md-button class=\"md-fab\" type=\"submit\" \naria-label=\"Send message\" translate translate-attr-aria-label=\"CHAT.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\">\n</md-icon></md-button></form></div></div><md-sidenav class=\"sidenav right-sidenav md-sidenav-right\" layout=\"column\" \nmd-component-id=\"right-sidenav\" ms-sidenav-helper ng-include=\"\'app/main/apps/chat/sidenavs/right/right-sidenav.html\'\">\n</md-sidenav></div></div></div>");
$templateCache.put("app/main/apps/mail/mail.html","<div id=\"mail\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav \nclass=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/apps/mail/sidenavs/main/main-sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle Sidenav\" translate translate-attr-aria-label=\"MAIL.TOGGLE_SIDENAV\"><md-icon class=\"icon\" \nmd-font-icon=\"icon-menu\"></md-icon></md-button><div class=\"search\" flex layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex ng-model=\"vm.search\" type=\"text\" \nplaceholder=\"Search for an e-mail or contact\" translate translate-attr-placeholder=\"MAIL.SEARCH_PLACEHOLDER\"></div>\n</div></div><div class=\"content-card\" ng-class=\"vm.currentView\" layout=\"column\" flex \nng-include=\"vm.views[vm.currentView]\"></div></div></div>");
$templateCache.put("app/main/apps/scrumboard/scrumboard.html","<div id=\"scrumboard\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\" layout=\"column\"><div class=\"header-content\" layout=\"row\" \nlayout-align=\"space-between\" layout-wrap flex><div layout=\"row\" layout-align=\"center center\" flex-order=\"1\" \nflex-order-xs=\"2\"><md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-700-bg\'\" ng-click=\"vm.boardSelectorVisible = !vm.boardSelectorVisible\" \naria-label=\"boards button\" translate translate-attr-aria-label=\"SB.BOARDS_BUTTON\"><md-icon md-font-icon=\"icon-trello\" \nclass=\"icon\"></md-icon><span translate=\"SB.BOARDS\">BOARDS</span></md-button></div><div class=\"header-board-name\" \nlayout=\"row\" layout-align=\"center center\" flex-order=\"2\" flex-order-xs=\"1\" flex-xs=\"100\"><i \nng-if=\"vm.board.settings.subscribed\" class=\"board-subscribe s16 icon-eye\"></i> <span editable-text=\"vm.board.name\" \nonaftersave=\"vm.updateBoardUri()\">{{vm.board.name}}</span></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\" flex-order=\"3\"><md-button class=\"md-icon-button\" \nui-sref=\"app.scrumboard.boards.board.calendar\" ng-hide=\"\'app.scrumboard.boards.board.calendar\' | isState\" \naria-label=\"Calendar\" translate translate-attr-aria-label=\"SB.CALENDAR\"><md-icon md-font-icon=\"icon-calendar\">\n</md-icon><md-tooltip><span translate=\"SB.CALENDAR\">Calendar</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ui-sref=\"app.scrumboard.boards.board\" ng-hide=\"\'app.scrumboard.boards.board\' | isState\" \naria-label=\"Board\" translate translate-attr-aria-label=\"SB.BOARD\"><md-icon md-font-icon=\"icon-trello\"></md-icon>\n<md-tooltip><span translate=\"SB.BOARD\">Board</span></md-tooltip></md-button><md-button ng-if=\"vm.filteringIsOn()\" \nclass=\"md-icon-button\" ng-click=\"vm.clearFilters()\" aria-label=\"Clear Filters\" translate \ntranslate-attr-aria-label=\"SB.CLEAR_FILTERS\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip \nsb.clear_filters>Clear Filters</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'filters-sidenav\')\" aria-label=\"Filter Cards\" translate \ntranslate-attr-aria-label=\"SB.FILTER_CARDS\"><md-icon md-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip><span \ntranslate=\"SB.FILTER_CARDS\">Filter Cards</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'settings-sidenav\')\" aria-label=\"Settings\" translate \ntranslate-attr-aria-label=\"SB.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip><span \ntranslate=\"SB.SETTINGS\">Settings</span></md-tooltip></md-button></div></div></div><div \nng-show=\"vm.boardSelectorVisible\" id=\"board-selector\" \nclass=\"md-accent-bg animate-slide-down board-list md-whiteframe-3dp\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"board-list-item\" ng-repeat=\"board in vm.boardList\" \nui-sref=\"app.scrumboard.boards.board({id:board.id, uri:board.uri})\" layout=\"column\" \nlayout-align=\"space-between center\"><div class=\"board-icon\"><i class=\"icon-trello s64\"></i></div><div flex \nclass=\"board-name\">{{board.name}}</div><div class=\"board-options\"><i class=\"icon-dots-horizontal\"></i></div><div \nng-if=\"board.id === vm.board.id\" class=\"selected-icon green-bg\"><i class=\"icon-check s24\"></i></div></div><div \nclass=\"board-list-item add-new-board\" ui-sref=\"app.scrumboard.boards.addBoard\" ui-sref-active=\"hidden\" layout=\"column\" \nlayout-align=\"space-between center\"><div class=\"board-icon\"><i class=\"icon-trello s64\"></i></div><div flex \nclass=\"board-name\" translate=\"SB.ADD_NEW_BOARD\">Add New Board</div></div></div><md-backdrop \nclass=\"board-selector-backdrop md-dialog-backdrop md-opaque\" ng-show=\"vm.boardSelectorVisible\" \nng-click=\"vm.boardSelectorVisible = false\" aria-hidden=\"true\"></md-backdrop><md-content class=\"content\" flex \nlayout=\"column\" ui-view=\"scrumboardContent\"></md-content><md-sidenav class=\"settings-sidenav md-sidenav-right\" \nmd-component-id=\"settings-sidenav\" ng-include=\"\'app/main/apps/scrumboard/sidenavs/settings/settings-sidenav.html\'\" \nng-controller=\"SettingsSidenavController as vm\" ms-sidenav-helper></md-sidenav><md-sidenav \nclass=\"filters-sidenav md-sidenav-right\" md-component-id=\"filters-sidenav\" \nng-include=\"\'app/main/apps/scrumboard/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"FiltersSidenavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/apps/file-manager/file-manager.html","<div id=\"file-manager\" class=\"page-layout simple right-sidenav\" layout=\"row\"><md-sidenav class=\"main-sidenav\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/file-manager/sidenavs/main/main-sidenav.html\'\" ms-scroll \nms-sidenav-helper></md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"header md-accent-bg\"><div \nclass=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between\"><md-button class=\"md-icon-button main-sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle Main Sidenav\" translate \ntranslate-attr-aria-label=\"FILE.TOOGLE_MAIN_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"right-side\" layout=\"row\"><md-button class=\"md-icon-button\" aria-label=\"Search\" translate \ntranslate-attr-aria-label=\"FM.SEARCH\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip><span \ntranslate=\"FM.SEARCH\">Search</span></md-tooltip></md-button><md-button ng-if=\"vm.currentView === \'list\'\" \nclass=\"md-icon-button\" ng-click=\"vm.toggleView()\" aria-label=\"view type\" translate \ntranslate-attr-aria-label=\"FM.GRID_VIEW\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span \ntranslate=\"FM.GRID_VIEW\">Grid View</span></md-tooltip></md-button><md-button ng-if=\"vm.currentView === \'grid\'\" \nclass=\"md-icon-button\" aria-label=\"view type\" ng-click=\"vm.toggleView()\" translate \ntranslate-attr-aria-label=\"FM.LIST_VIEW\"><md-icon md-font-icon=\"icon-view-headline\"></md-icon><md-tooltip><span \ntranslate=\"FM.LIST_VIEW\">List View</span></md-tooltip></md-button></div></div><div class=\"breadcrumb text-truncate\" \nlayout=\"row\" layout-align=\"start center\"><span data-ng-repeat=\"path in vm.path\">{{path}}<md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"icon separator\"></md-icon></span></div></div><div id=\"file-uploader\" \nflow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.upload()\" \nflow-file-added=\"vm.fileAdded($file)\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\"><md-button flow-btn class=\"add-file-button md-fab md-warn\" aria-label=\"Add file\" \ntranslate translate-attr-aria-label=\"FM.ADD_FILE\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div></div>\n<md-content class=\"content\" flex ms-scroll><div ng-if=\"vm.currentView === \'grid\'\" \nng-include=\"\'app/main/apps/file-manager/views/grid/grid-view.html\'\"></div><div ng-if=\"vm.currentView === \'list\'\" \nng-include=\"\'app/main/apps/file-manager/views/list/list-view.html\'\"></div></md-content></div><md-sidenav \nclass=\"sidenav details-sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"details-sidenav\" ng-include=\"\'app/main/apps/file-manager/sidenavs/details/details-sidenav.html\'\" \nms-scroll ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/auth/NO_login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>F\n</span></div><div class=\"title\" translate=\"LOGIN.TITLE\">Log in to your account</div><form name=\"loginForm\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nplaceholder=\"Email\" translate translate-attr-placeholder=\"LOGIN.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nplaceholder=\"Password\" translate translate-attr-placeholder=\"LOGIN.PASSWORD\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN.REMEMBER_ME\">Remember Me</span>\n</md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\" \ntranslate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \ntranslate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form><div class=\"separator\"><span\n class=\"text\" translate=\"LOGIN.OR\">OR</span></div><md-button class=\"md-raised google\"><div layout=\"row\" \nlayout-align=\"center center\"><span><md-icon md-font-icon=\"icon-google-plus\" class=\"s16\"></md-icon><span \ntranslate=\"LOGIN.WITH_GOOGLE\">Log in with Google</span></span></div></md-button><md-button class=\"md-raised facebook\">\n<div layout=\"row\" layout-align=\"center center\"><span><md-icon md-font-icon=\"icon-facebook\" class=\"s16\"></md-icon><span \ntranslate=\"LOGIN.WITH_FACEBOOK\">Log in with Facebook</span></span></div></md-button><div class=\"register\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"LOGIN.DONT_HAVE_ACCOUNT\">\nDon\'t have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_register\" translate=\"LOGIN.CREATE_ACCOUNT\">\nCreate an account</a></div></div></div></div>");
$templateCache.put("app/main/apps/notes/notes.html","<div id=\"notes\" class=\"\" layout=\"column\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" ms-scroll \nmd-component-id=\"main-sidenav\" ms-sidenav-helper ng-include=\"\'app/main/apps/notes/sidenavs/main/main-sidenav.html\'\">\n</md-sidenav><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"NOTES.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button>\n<div class=\"main-title\" layout=\"row\" layout-align=\"start center\"><md-icon class=\"logo-icon mr-8\" \nmd-font-icon=\"icon-lightbulb\"></md-icon><span class=\"title\" ng-if=\"vm.noteListType === \'notes\'\" \ntranslate=\"NOTES.NOTES\">Notes</span> <span class=\"title\" ng-if=\"vm.noteListType === \'reminders\'\" \ntranslate=\"NOTES.REMINDERS\">Reminders</span> <span class=\"title\" ng-if=\"vm.noteListType === \'archive\'\" \ntranslate=\"NOTES.ARCHIVE\">Archive</span> <span class=\"title\" ng-if=\"vm.noteListType.name\">{{vm.noteListType.name}}\n</span> <span ng-if=\"filteredNotes.length\" class=\"pl-8 white-text secondary-text notes-count\">\n({{filteredNotes.length}})</span></div></div><div flex></div><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.openSearchToolbar()\" aria-label=\"open search toolbar\" translate \ntranslate-attr-aria-label=\"NOTES.OPEN_SEARCH_TOOLBAR\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon\"></md-icon>\n</md-button></div><div ng-show=\"vm.searchToolbar\" \nclass=\"md-toolbar-tools search-toolbar animate-slide-down md-accent-bg\" layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeSearchToolbar()\" translate translate-attr-aria-label=\"NOTES.CLOSE\" \naria-label=\"close\"><md-icon md-font-icon=\"icon-close\" class=\"mr-8\"></md-icon></md-button><input \nid=\"search-notes-input\" placeholder=\"Search notes\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"NOTES.SEARCH_NOTES\" ng-model-options=\"{\'debounce\': 200}\" flex></div></md-toolbar>\n<md-content ms-scroll flex><ms-new-note ng-hide=\"vm.noteListType === \'archive\'\" class=\"md-whiteframe-2dp\">\n</ms-new-note><ms-masonry class=\"notes\" options=\'{\"columnCount\":5}\'><ms-masonry-item class=\"note\" \nng-repeat=\"note in vm.notes | filter:vm.search | filter:vm.filters | filterByPropIds:\'labels\':vm.labelFilterIds |  orderBy: \'time\':true | filter:query as filteredNotes track by note.id \" \nms-note-item=\"note\" ng-click=\"vm.editNote($event, note.id)\"></ms-masonry-item></ms-masonry><div \nclass=\"no-results text-center\" ng-if=\"filteredNotes.length === 0 &&  vm.search === \'\'\"><div class=\"message\" \nng-if=\"vm.noteListType === \'notes\'\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-lightbulb\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_NOTES_YET\">No notes yet...</div></div><div class=\"message\" \nng-if=\"vm.noteListType === \'reminders\'\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-bell\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_NOTES_WITH_REMINDERS\">No notes with reminders</div></div><div class=\"message\" \nng-if=\"vm.noteListType === \'archive\'\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-archive\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_ARCHIVED_NOTES\">No archived Notes</div></div><div class=\"message\" \nng-if=\"vm.noteListType.name\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-label\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_NOTES_WITH_THIS_LABEL\">No notes with this label</div></div></div><div \nclass=\"no-results text-center\" ng-if=\"filteredNotes.length === 0 &&  vm.search !== \'\'\"><div class=\"message\"><md-icon \nclass=\"message-icon s96\" md-font-icon=\"icon-lightbulb\"></md-icon><div class=\"message-text\" \ntranslate=\"NOTES.NO_RESULTS\">No results...</div></div></div></md-content></div>");
$templateCache.put("app/main/auth/lock/lock.html","<div id=\"lock\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"lock-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"lock-form\" class=\"md-whiteframe-8dp\"><div layout=\"row\" \nlayout-align=\"start center\" layout-sm=\"column\" layout-align-sm=\"center center\"><div class=\"avatar-container\"><img \nclass=\"avatar big\" src=\"assets/images/avatars/katherine.jpg\"><md-icon md-font-icon=\"icon-lock\" \nclass=\"md-warn-fg s36 md-hue-2\"></md-icon></div><div flex layout=\"column\" layout-align=\"start\" \nlayout-align-sm=\"center center\"><div class=\"title\" translate=\"LOCK.TITLE\">Your session is locked</div><div \nclass=\"subtitle\" translate=\"LOCK.SUBTITLE\">Due to inactivity, your session is locked. Enter your password to continue.\n</div></div></div><form name=\"lockForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input \nng-model=\"vm.form.username\" placeholder=\"Username\" translate translate-attr-placeholder=\"LOCK.USERNAME\" \ndisabled=\"disabled\"></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"LOCK.PASSWORD\" required><div ng-messages=\"lockForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"LOCK.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"UNLOCK\" \nng-disabled=\"lockForm.$invalid || lockForm.$pristine\" translate=\"LOCK.UNLOCK\" translate-attr-aria-label=\"LOCK.UNLOCK\">\nUNLOCK</md-button></form><div class=\"message\"><a ui-sref=\"app.pages_auth_login\" class=\"md-accent-color\"><span \ntranslate=\"LOCK.ARE_YOU_NOT\">Are you not</span><span> Jane Doe?</span></a></div></div></div></div>");
$templateCache.put("app/main/apps/contacts/contacts.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" hide-gt-md ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" \ntranslate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span><span class=\"logo-text\" translate=\"CONTACTS.CONTACTS\">\nContacts</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label \nfor=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input \nid=\"search\" placeholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"CONTACTS.SEARCH_FOR_ANYONE\"></md-input-container></div></div><div \nng-show=\"vm.selectedContacts.length > 0\" class=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"close-button-wrapper\" ng-click=\"vm.selectedContacts =[]\"><md-button \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon><span \ntranslate=\"CONTACTS.BACK\">Back</span></md-button></div><div flex layout=\"row\" layout-align=\"space-between center\"><div>\n<span class=\"selected-contacts-count\"><span>{{vm.selectedContacts.length}}</span> <span translate=\"CONTACTS.SELECTED\">\nselected</span></span><md-menu class=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"multi select toggle\" translate \ntranslate-attr-aria-label=\"CONTACTS.MULTI_SELECT_TOGGLE\"><md-icon md-font-icon=\"icon-menu-down\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectAllContacts()\" translate=\"CONTACTS.SELECT_ALL\">\nSelect all</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deselectContacts()\" \ntranslate=\"CONTACTS.SELECT_NONE\">Select none</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"multi-select-actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteSelectedContacts($event)\" \naria-label=\"delete selected\" translate translate-attr-label=\"CONTACTS.DELETE_SELECTED\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div><div class=\"content\" md-background-bg layout=\"row\" \nlayout-align=\"start start\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" ms-scroll \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/apps/contacts/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div class=\"main scrollable\" \nms-scroll><md-list class=\"contacts-list\"><md-subheader class=\"md-no-sticky md-white-bg\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"list-title\" layout=\"row\" layout-align=\"start center\" \nng-hide=\"editGroupForm.$visible\"><span ng-if=\"vm.listType === \'all\'\" translate=\"CONTACTS.ALL_CONTACTS\">All contacts\n</span> <span ng-if=\"vm.listType === \'frequent\'\" translate=\"CONTACTS.FREQUENTLY_CONTACTED\">Frequnetly contacted</span> \n<span ng-if=\"vm.listType === \'starred\'\" translate=\"CONTACTS.STARRED_CONTACTS\">Starred contacts</span> <span \nng-if=\"vm.listType.name\">{{vm.listType.name}}</span> <span ng-if=\"filteredContacts.length\" \nclass=\"secondary-text contacts-count\">({{filteredContacts.length}})</span></div><div class=\"edit-group-form\" \nng-show=\"vm.listType.name\" layout=\"row\" layout-align=\"start center\"><span ng-show=\"editGroupForm.$visible\" \neditable-text=\"vm.listType.name\" e-form=\"editGroupForm\" onaftersave=\"vm.editGroup()\"></span><md-button \nclass=\"md-icon-button edit-group-button\" ng-click=\"editGroupForm.$show()\" ng-hide=\"editGroupForm.$visible\" \naria-label=\"edit group name\" translate translate-attr-label=\"CONTACTS.EDIT_GROUP_NAME\"><md-icon \nmd-font-icon=\"icon-pencil s18\"></md-icon></md-button><md-button class=\"md-icon-button edit-group-button\" \nng-click=\"vm.deleteGroup($event)\" ng-hide=\"editGroupForm.$visible\" aria-label=\"delete group\" translate \ntranslate-attr-label=\"CONTACTS.DELETE_GROUP\"><md-icon md-font-icon=\"icon-delete s18\"></md-icon></md-button></div><div \nflex></div><md-menu><md-button class=\"md-icon-button\" aria-label=\"Sort\" translate \ntranslate-attr-aria-label=\"CONTACTS.SORT\"><md-icon md-font-icon=\"icon-sort-alphabetical\" \nng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.listOrder = \'name\';vm.listOrderAsc = false\" \nng-style=\"vm.listOrder === \'name\' && vm.listOrderAsc=== false && {\'font-weight\':\'500\'}\"><span \ntranslate=\"CONTACTS.FIRST_NAME\">First Name</span> <small translate=\"CONTACTS.A_TO_Z\">(A to Z)</small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.listOrder = \'name\'; vm.listOrderAsc = true\" \nng-style=\"vm.listOrder === \'name\' && vm.listOrderAsc=== true && {\'font-weight\':\'500\'}\"><span \ntranslate=\"CONTACTS.FIRST_NAME\">First Name</span> <small translate=\"CONTACTS.Z_TO_A\">(Z to A)</small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.listOrder = \'lastName\';vm.listOrderAsc = false\" \nng-style=\"vm.listOrder === \'lastName\' && vm.listOrderAsc=== false && {\'font-weight\':\'500\'}\"><span \ntranslate=\"CONTACTS.LAST_NAME\">Last Name</span> <small translate=\"CONTACTS.A_TO_Z\">(A to Z)</small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.listOrder = \'lastName\'; vm.listOrderAsc = true\" \nng-style=\"vm.listOrder === \'lastName\' && vm.listOrderAsc=== true && {\'font-weight\':\'500\'}\"><span \ntranslate=\"CONTACTS.LAST_NAME\">Last Name</span> <small translate=\"CONTACTS.Z_TO_A\">(Z to A)</small></md-button>\n</md-menu-item></md-menu-content></md-menu></div></md-subheader><md-list-item class=\"contact-item md-white-bg\" \nmd-ink-ripple \nng-repeat=\"contact in vm.contacts | filter: vm.search | filter: global.search | filterByIds:vm.filterIds |  orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredContacts track by contact.id \" \nng-click=\"vm.openContactDialog($event, contact)\" \nng-style=\"{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': filteredContacts.length - $index}\" \nng-class=\"{\'selected\': vm.isSelected(contact)}\"><md-checkbox ng-checked=\"vm.exists(contact, vm.selectedContacts)\" \nng-click=\"vm.toggleSelectContact(contact, $event)\" \naria-label=\"{{vm.exists(contact, vm.selectedContacts) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><img class=\"md-avatar\" \nng-if=\"contact.avatar\" alt=\"{{contact.name}}\" ng-src=\"{{contact.avatar}}\"><p class=\"text-truncate font-weight-600\">\n{{contact.name}} {{contact.lastName}}</p><p class=\"email text-truncate hide show-gt-sm\">{{contact.email}}</p><p \nclass=\"phone text-truncate hide show-gt-md\">{{contact.phone}}</p><p class=\"job-title text-truncate hide show-gt-lg\">\n{{contact.jobTitle}}</p><p class=\"company text-truncate hide show-gt-lg\">{{contact.company}}</p><div class=\"actions\" \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button hide show-gt-xs\" \nng-click=\"$event.stopPropagation();vm.toggleInArray(contact.id, vm.user.starred)\" aria-label=\"Toggle starred\" \ntranslate translate-attr-aria-label=\"CONTACTS.TOGGLE_STARRED\"><md-icon ng-if=\"vm.exists(contact.id,vm.user.starred)\" \nmd-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon ng-if=\"!vm.exists(contact.id,vm.user.starred)\" \nmd-font-icon=\"icon-star-outline\"></md-icon></md-button><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" \ntranslate translate-attr-aria-label=\"CONTACTS.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.deleteContactConfirm(contact, ev)\" translate=\"CONTACTS.DELETE_CONTACT\">Delete Contact</md-button>\n</md-menu-item><md-divider ng-if=\"vm.user.groups\"></md-divider><md-subheader class=\"md-no-sticky\" \nng-if=\"vm.user.groups\">Groups</md-subheader><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" \nng-click=\"vm.toggleInArray(contact.id,group.contactIds)\"><p class=\"pl-8\" \nng-style=\"vm.exists(contact.id,group.contactIds) && {\'font-weight\':\'500\'}\">{{group.name}}</p></md-list-item>\n</md-menu-content></md-menu></div></md-list-item></md-list><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredContacts.length === 0\"><p translate=\"CONTACTS.NO_RESULTS\">No results..</p></md-list-item></div></div>\n<md-button class=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" ng-click=\"vm.openContactDialog($event)\" \naria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/apps/todo/todo.html","<div id=\"todo\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav \nclass=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/apps/todo/sidenavs/main/main-sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" flex layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"TODO.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"search\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex \nng-model=\"vm.taskFilters.search\" type=\"text\" placeholder=\"Search for a task or tag\" translate \ntranslate-attr-placeholder=\"TODO.SEARCH\"></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><md-select class=\"simplified\" \nng-model=\"vm.selectedFilter.dueDate\" placeholder=\"Due Date\"><md-option value=\"Next 3 days\" \ntranslate=\"TODO.NEXT_3_DAYS\">Next 3 days</md-option><md-option value=\"Next 7 days\" translate=\"TODO.NEXT_7_DAYS\">\nNext 7 days</md-option><md-option value=\"Next 2 weeks\" translate=\"TODO.NEXT_2_WEEKS\">Next 2 weeks</md-option><md-option\n value=\"Next month\" translate=\"TODO.NEXT_MONTH\">Next month</md-option></md-select><div layout=\"row\" \nlayout-align=\"start center\"><md-select class=\"simplified\" ng-model=\"vm.taskOrder\" placeholder=\"Order\" \nng-change=\"vm.taskOrderDescending = vm.taskOrder === \'\' ? false : vm.taskOrderDescending\"><md-option \nvalue=\"startDateTimestamp\" translate=\"TODO.START_DATE\">Start Date</md-option><md-option value=\"dueDateTimestamp\" \ntranslate=\"TODO.DUE_DATE\">Due Date</md-option><md-option ng-value=\"\'\'\" translate=\"TODO.MANUAL\">Manual</md-option>\n<md-option value=\"title\" translate=\"TODO.TITLE\">Title</md-option></md-select><md-button class=\"md-icon-button\" \nng-disabled=\"vm.taskOrder === \'\'\" ng-click=\"vm.taskOrderDescending = !vm.taskOrderDescending\" \naria-label=\"Sort Direction\" translate translate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon \nmd-font-icon=\"icon-sort-ascending\" ng-if=\"vm.taskOrderDescending === false\"></md-icon><md-icon \nmd-font-icon=\"icon-sort-descending\" ng-if=\"vm.taskOrderDescending === true\"></md-icon></md-button></div></div><div \nclass=\"content\" layout=\"row\" flex><md-content class=\"todo-list-pane\" flex \nng-include=\"\'app/main/apps/todo/views/list/list-view.html\'\" ms-scroll=\"vm.msScrollOptions\"></md-content></div></div>\n</div></div>");
$templateCache.put("app/main/auth/register/register.html","<div id=\"register\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"register-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"register-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>F\n</span></div><div class=\"title\" translate=\"REGISTER.TITLE\">Create an account</div><form name=\"registerForm\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input name=\"username\" ng-model=\"vm.form.username\" placeholder=\"Name\" \ntranslate translate-attr-placeholder=\"REGISTER.NAME\" required><div ng-messages=\"registerForm.username.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.USERNAME_REQUIRED\">Username field is required\n</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"email\" \nname=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"REGISTER.EMAIL\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"REGISTER.PASSWORD\" required><div ng-messages=\"registerForm.password.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" translate \ntranslate-attr-placeholder=\"REGISTER.PASSWORD_CONFIRM\" required><div ng-messages=\"registerForm.passwordConfirm.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">\nPassword (Confirm) field is required</span></div></div></md-input-container><div class=\"terms\" layout=\"row\" \nlayout-align=\"center center\"><md-checkbox name=\"terms\" ng-model=\"data.cb1\" aria-label=\"I read and accept\" required>\n</md-checkbox><div layout=\"row\" layout-sm=\"column\" layout-align=\"start center\"><span translate=\"REGISTER.READ_ACCEPT\">\nI read and accept</span> <a href=\"#\" class=\"md-accent-color\" translate=\"REGISTER.TERMS_COND\">terms and conditions</a>\n</div></div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER.CREATE_ACCOUNT\" \ntranslate-attr-aria-label=\"REGISTER.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button></form><div class=\"login\" \nlayout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"REGISTER.ALREADY_HAVE\">\nAlready have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_login\" translate=\"REGISTER.LOGIN\">Log in</a>\n</div></div></div></div>");
$templateCache.put("app/main/auth/login-v2/login-v2.html","<div id=\"login-v2mod\" layout=\"row\" layout-align=\"start\"><div id=\"login-v2-intro\" flex hide show-gt-sm><div \nclass=\"logo md-accent-bg\"><span>B</span></div><div class=\"title\" translate=\"LOGIN_V2.INTRO_TITLE\">¡Bienvenidos!</div>\n</div><div id=\"login-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"imagen-logo\" \nlayout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><div flex=\"10\" flex-gt-xs=\"10\" \nflex-gt-md=\"10\"></div><div flex=\"80\" flex-gt-xs=\"80\" flex-gt-md=\"80\"><img width=\"340\" height=\"100\" \nsrc=\"https://firebasestorage.googleapis.com/v0/b/buenatelier-app.appspot.com/o/Buenatelier%2Flogos%2Fbuenatelier_340x100.jpg?alt=media&token=43206bf6-1669-4fae-9fdf-4bc89e9a9087\">\n</div><div flex=\"10\" flex-gt-xs=\"10\" flex-gt-md=\"10\"></div></div><div id=\"login-v2-form\"><div class=\"title\" \ntranslate=\"LOGIN_V2.TITLE\">Log in to your account</div><div class=\"description\" translate=\"LOGIN_V2.DESCRIPTION\">\nInsert your email and password</div><form name=\"loginForm\" ng-submit=\"vm.firebaseAuthenticate()\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nplaceholder=\"Email\" translate translate-attr-placeholder=\"LOGIN_V2.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN_V2.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"LOGIN_V2.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" placeholder=\"Password\" translate translate-attr-placeholder=\"LOGIN_V2.PASSWORD\" required>\n<div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN_V2.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container>\n<md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN_V2.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN_V2.LOG_IN\">LOG IN</md-button><div ng-show=\"vm.showAlert\" layout=\"row\" \nlayout-align=\"center\" class=\"red-text\" translate=\"LOGIN_V2.FAILED\">Email or password incorrect</div></form></div></div>\n</div>");
$templateCache.put("app/main/components/cards/cards.html","<div id=\"cards\" class=\"page-layout simple fullwidth doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span></div><div \nclass=\"title\">Cards</div></div></div><div class=\"content\" md-background-bg><p>\nCards are useful for showing excerpts, quick information or notifications. Using <code>ms-card</code>\n directive you can easily create different cards compatible with Google\'s Material Design specifications.</p><p><code>\nms-card</code>\n directive templates have pre-defined content areas. The reason for that is to force you to create cards that follows both Google\'s Material Design specifications and Fuse Theme\'s general design rules. But of course you can create your own designs and templates and use them with \n<code>ms-card</code> directive.</p><div><div class=\"md-title mt-32\">Template 1</div><ms-card \ntemplate=\"\'app/core/directives/ms-card/templates/template-1/template-1.html\'\" ng-model=\"vm.cards[0]\"></ms-card><div \nclass=\"md-title mt-48\">Template 2</div><ms-card \ntemplate=\"\'app/core/directives/ms-card/templates/template-2/template-2.html\'\" ng-model=\"vm.cards[1]\"></ms-card><div \nclass=\"md-title mt-48\">Template 3</div><ms-card \ntemplate=\"\'app/core/directives/ms-card/templates/template-3/template-3.html\'\" ng-model=\"vm.cards[2]\"></ms-card><div \nclass=\"md-title mt-48\">Template 4</div><ms-card \ntemplate=\"\'app/core/directives/ms-card/templates/template-4/template-4.html\'\" ng-model=\"vm.cards[3]\"></ms-card><div \nclass=\"md-title mt-48\">Template 5</div><ms-card \ntemplate=\"\'app/core/directives/ms-card/templates/template-5/template-5.html\'\" ng-model=\"vm.cards[4]\"></ms-card><div \nclass=\"md-title mt-48\">Template 6</div><ms-card \ntemplate=\"\'app/core/directives/ms-card/templates/template-6/template-6.html\'\" ng-model=\"vm.cards[5]\"></ms-card><div \nclass=\"md-title mt-48\">Template 7</div><ms-card \ntemplate=\"\'app/core/directives/ms-card/templates/template-7/template-7.html\'\" ng-model=\"vm.cards[6]\"></ms-card><div \nclass=\"md-title mt-48\">Template 8</div><ms-card \ntemplate=\"\'app/core/directives/ms-card/templates/template-8/template-8.html\'\" ng-model=\"vm.cards[7]\"></ms-card><div \nclass=\"md-title mt-48\">Template 9</div><ms-card \ntemplate=\"\'app/core/directives/ms-card/templates/template-9/template-9.html\'\" ng-model=\"vm.cards[8]\"></ms-card><div \nclass=\"md-title mt-48\">Template 10</div><ms-card \ntemplate=\"\'app/core/directives/ms-card/templates/template-10/template-10.html\'\" ng-model=\"vm.cards[9]\"></ms-card></div>\n</div></div>");
$templateCache.put("app/main/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"FORGOTPASSWORD.TITLE\">Recover your password\n</div><form name=\"forgotPasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"email\" \nname=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" translate=\"FORGOTPASSWORD.SEND_RESET_LINK\" \ntranslate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\">SEND RESET LINK</md-button></form><div class=\"login\" \nlayout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.pages_auth_login\" \ntranslate=\"FORGOTPASSWORD.GO_BACK\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/components/maps/maps.html","<div id=\"maps\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span></div><div \nclass=\"title\">Maps</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"http://angular-ui.github.io/angular-google-maps/\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><md-nav-bar \nmd-selected-nav-item=\"vm.selectedNavItem\" nav-bar-aria-label=\"Maps\"><md-nav-item md-nav-sref=\"app.components_maps\" \nname=\"simpleMap\">Simple Map</md-nav-item><md-nav-item md-nav-sref=\"app.components_maps.satellite\" name=\"satelliteMap\">\nSatellite Map</md-nav-item><md-nav-item md-nav-sref=\"app.components_maps.terrain\" name=\"terrainMap\">Terrain Map\n</md-nav-item><md-nav-item md-nav-sref=\"app.components_maps.simple-marker\" name=\"simpleMarkerMap\">Simple Marker\n</md-nav-item><md-nav-item md-nav-sref=\"app.components_maps.custom-marker\" name=\"customMarkerMap\">Custom Marker\n</md-nav-item><md-nav-item md-nav-sref=\"app.components_maps.info-window\" name=\"infoWindowMap\">Info Window</md-nav-item>\n</md-nav-bar><md-content ui-view=\"tabContent\" flex class=\"card md-whiteframe-4dp\"></md-content></div></div>");
$templateCache.put("app/main/components/material-docs/material-doc-basic-template.html","<div class=\"doc-page material-docs layout-docs doc-template page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{vm.parentTitle}}</span></div><div class=\"title\">{{vm.component.name}}</div></div></div><div flex class=\"content\"><a \nclass=\"reference-link md-yellow-200-bg\" \nhref=\"https://material.angularjs.org/{{vm.materialVersion}}/{{vm.component.url}}\" target=\"_blank\">\nGo to official Angular Material <b>{{vm.component.name}}</b> documentation page</a><div \nng-include=\"\'app/main/components/material-docs/\'+vm.component.templateUrl\"></div></div></div>");
$templateCache.put("app/main/components/material-docs/material-doc-template.html","<div class=\"doc-page material-docs doc-template page-layout simple tabbed\" layout=\"column\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\nANGULAR MATERIAL ELEMENTS</span></div><div class=\"title\">{{vm.componentName}}</div></div></div><div flex \nclass=\"content\"><md-tabs md-selected=\"selectedIndex\" md-dynamic-height><md-tab ng-if=\"vm.demo\"><md-tab-label>\n{{vm.demo.label}} (Demo)</md-tab-label><md-tab-body><a class=\"reference-link md-yellow-200-bg\" \nhref=\"https://material.angularjs.org/{{vm.materialVersion}}/demo/{{vm.demo.name}}\" target=\"_blank\">\nGo to official Angular Material <b>{{vm.demo.name}}</b> demo page</a><docs-demo ng-repeat=\"demo in vm.demos\" \ndemo-id=\"{{demo.id}}\" demo-title=\"{{demo.label}}\" demo-module=\"{{demo.ngModule.module}}\"><demo-file \nng-repeat=\"file in demo.$files\" name=\"{{file.name}}\" contents=\"file.httpPromise\"></demo-file></docs-demo></md-tab-body>\n</md-tab><md-tab ng-repeat=\"doc in vm.docs\"><md-tab-label>{{doc.name}} ({{doc.type}})</md-tab-label><md-tab-body><a \nclass=\"reference-link md-yellow-200-bg\" \nhref=\"https://material.angularjs.org/{{vm.materialVersion}}/api/{{doc.type}}/{{doc.name}}\" target=\"_blank\">\nGo to official Angular Material <b>{{doc.name}} {{doc.type}}</b> documentation page</a><div class=\"\" \nng-include=\"\'app/main/components/material-docs/\'+doc.outputPath\"></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/auth/register-v2/register-v2.html","<div id=\"register-v2\" layout=\"row\" layout-align=\"start\"><div id=\"register-v2-intro\" flex hide show-gt-sm><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"REGISTER_V2.INTRO_TITLE\">\nWelcome to the FUSE!</div><div class=\"description\" translate=\"REGISTER_V2.INTRO_DESCRIPTION\">\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.\n</div></div><div id=\"register-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" layout=\"column\" flex \nms-scroll><div id=\"register-v2-form\"><div class=\"logo md-accent-bg\" hide-gt-sm><span>F</span></div><div class=\"title\" \ntranslate=\"REGISTER_V2.TITLE\">Create an account</div><div class=\"description\" translate=\"REGISTER_V2.DESCRIPTION\">\nSed mollis velit facilisis facilisis viverra</div><form name=\"registerForm\" novalidate><md-input-container \nclass=\"md-block\" md-no-float><input name=\"username\" ng-model=\"vm.form.username\" placeholder=\"Name\" translate \ntranslate-attr-placeholder=\"REGISTER_V2.NAME\" required><div ng-messages=\"registerForm.username.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.USERNAME_REQUIRED\">Username field is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" \nng-model=\"vm.form.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"REGISTER_V2.EMAIL\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"REGISTER_V2.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"REGISTER_V2.PASSWORD\" required><div ng-messages=\"registerForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.PASSWORD_REQUIRED\">\nPassword field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float>\n<input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" \ntranslate translate-attr-placeholder=\"REGISTER_V2.PASSWORD_CONFIRM\" required><div \nng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER_V2.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div>\n</md-input-container><div class=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" \nng-model=\"data.cb1\" aria-label=\"I read and accept\" required></md-checkbox><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"start center\"><span translate=\"REGISTER_V2.READ_ACCEPT\">I read and accept</span> <a href=\"#\" \nclass=\"md-accent-color\" translate=\"REGISTER_V2.TERMS_COND\">terms and conditions</a></div></div><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER_V2.CREATE_ACCOUNT\" \ntranslate-attr-aria-label=\"REGISTER_V2.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button></form><div class=\"login\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"REGISTER_V2.ALREADY_HAVE\">\nAlready have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_login-v2\" translate=\"REGISTER_V2.LOGIN\">Log in\n</a></div></div></div></div>");
$templateCache.put("app/main/auth/reset-password/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"RESETPASSWORD.TITLE\">Reset your password\n</div><form name=\"resetPasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"email\" \nname=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"resetPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"RESETPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" placeholder=\"Password\" translate translate-attr-placeholder=\"RESETPASSWORD.PASSWORD\" \nrequired><div ng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.PASSWORD_CONFIRM\" required><div \nng-messages=\"resetPasswordForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"UPDATE MY PASSWORD\" ng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\" \ntranslate=\"RESETPASSWORD.UPDATE_PASSWORD\" translate-attr-aria-label=\"RESETPASSWORD.UPDATE_PASSWORD\">RESET MY PASSWORD\n</md-button></form></div></div></div>");
$templateCache.put("app/main/components/price-tables/price-tables.html","<div id=\"price-tables\" class=\"page-layout simple fullwidth doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">PAGES</span></div><div \nclass=\"title\">Price Tables</div></div></div><div class=\"content\"><div class=\"md-title\">Style 1</div><div \nclass=\"price-tables\" flex layout=\"row\" layout-wrap><div class=\"price-table style-1 md-whiteframe-1dp\" layout=\"column\">\n<div class=\"package-type md-primary-bg\"><span>BASIC</span></div><div class=\"price\" layout=\"row\" \nlayout-align=\"center start\"><div class=\"currency\">$</div><div layout=\"row\" layout-align=\"center end\"><div \nclass=\"value\">4</div><div class=\"period\">/ month</div></div></div><md-divider></md-divider><div class=\"terms\" \nlayout=\"column\"><div class=\"term\"><span class=\"text-bold\">10</span> Projects</div><div class=\"term\"><span \nclass=\"text-bold\">10</span> Pages</div><div class=\"term\"><span class=\"text-bold\">100</span> Mb Disk Space</div></div>\n<md-button class=\"cta-button md-raised md-accent\">BUY NOW</md-button></div><div \nclass=\"price-table style-1 md-whiteframe-8dp\" layout=\"column\"><div class=\"package-type md-primary-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><span>STANDARD</span> <span class=\"sale md-accent-color md-hue-1\">Save 15%</span>\n</div><div class=\"price\" layout=\"row\" layout-align=\"center start\"><div class=\"currency\">$</div><div layout=\"row\" \nlayout-align=\"center end\"><div class=\"value\">8</div><div class=\"period\">/ month</div></div></div><md-divider>\n</md-divider><div class=\"terms\" layout=\"column\"><div class=\"term\"><span class=\"text-bold\">20</span> Projects</div><div \nclass=\"term\"><span class=\"text-bold\">20</span> Pages</div><div class=\"term\"><span class=\"text-bold\">200</span>\n Mb Disk Space</div></div><md-button class=\"cta-button md-raised md-accent\">BUY NOW</md-button></div><div \nclass=\"price-table style-1 md-whiteframe-1dp\" layout=\"column\"><div class=\"package-type md-primary-bg\" layout=\"row\">\n<span>ADVANCED</span></div><div class=\"price\" layout=\"row\" layout-align=\"center start\"><div class=\"currency\">$</div>\n<div layout=\"row\" layout-align=\"center end\"><div class=\"value\">12</div><div class=\"period\">/ month</div></div></div>\n<md-divider></md-divider><div class=\"terms\" layout=\"column\"><div class=\"term\"><span class=\"text-bold\">40</span>\n Projects</div><div class=\"term\"><span class=\"text-bold\">40</span> Pages</div><div class=\"term\"><span \nclass=\"text-bold\">500</span> Mb Disk Space</div></div><md-button class=\"cta-button md-raised md-accent\">BUY NOW\n</md-button></div></div><div class=\"md-title\">Style 2</div><div class=\"price-tables\" flex layout=\"row\" layout-wrap><div\n class=\"price-table style-2 md-whiteframe-1dp\" layout=\"column\"><div class=\"package-type md-accent-fg\">SILVER PACKAGE\n</div><div class=\"price\" layout=\"row\" layout-align=\"center start\"><div class=\"currency\">$</div><div class=\"value\">99\n</div></div><div class=\"period\">PER MONTH</div><div class=\"terms\" layout=\"column\" layout-align=\"start center\"><div \nclass=\"term\"><span class=\"text-bold\">10</span> Projects</div><div class=\"term\"><span class=\"text-bold\">10</span> Pages\n</div><div class=\"term\"><span class=\"text-bold\">100</span> Mb Disk Space</div></div><md-button \nclass=\"cta-button md-raised md-accent\">GET STARTED</md-button></div><div class=\"price-table style-2 md-whiteframe-8dp\" \nlayout=\"column\"><div class=\"badge md-warn-bg\">BEST VALUE</div><div class=\"package-type md-accent-fg\">GOLD PACKAGE</div>\n<div class=\"price\" layout=\"row\" layout-align=\"center start\"><div class=\"currency\">$</div><div class=\"value\">299</div>\n</div><div class=\"period\">PER MONTH</div><div class=\"terms\" layout=\"column\" layout-align=\"start center\"><div \nclass=\"term\"><span class=\"text-bold\">20</span> Projects</div><div class=\"term\"><span class=\"text-bold\">20</span> Pages\n</div><div class=\"term\"><span class=\"text-bold\">200</span> Mb Disk Space</div></div><md-button \nclass=\"cta-button md-raised md-accent\">GET STARTED</md-button></div><div class=\"price-table style-2 md-whiteframe-1dp\" \nlayout=\"column\"><div class=\"package-type md-accent-fg\">PLATINUM PACKAGE</div><div class=\"price\" layout=\"row\" \nlayout-align=\"center start\"><div class=\"currency\">$</div><div class=\"value\">499</div></div><div class=\"period\">\nPER MONTH</div><div class=\"terms\" layout=\"column\" layout-align=\"start center\"><div class=\"term\"><span \nclass=\"text-bold\">40</span> Projects</div><div class=\"term\"><span class=\"text-bold\">40</span> Pages</div><div \nclass=\"term\"><span class=\"text-bold\">500</span> Mb Disk Space</div></div><md-button \nclass=\"cta-button md-raised md-accent\">GET STARTED</md-button></div></div><div class=\"md-title\">Style 3</div><div \nclass=\"price-tables\" flex layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"price-table style-3 md-whiteframe-1dp\" layout=\"column\"><div class=\"package-type\"><div class=\"title\">Starter\n</div><div class=\"subtitle\">For small teams</div></div><div class=\"price md-primary-bg md-hue-3\" layout=\"row\" \nlayout-align=\"center start\"><div class=\"currency\">$</div><div layout=\"row\" layout-align=\"center end\"><div \nclass=\"value\">29</div><div class=\"period\">monthly per user</div></div></div><div class=\"terms\" layout=\"column\" \nlayout-align=\"start center\"><div class=\"term\">Unlimited projects</div><div class=\"term\">Unlimited pages</div><div \nclass=\"term\">Unlimited disk space</div><div class=\"term\">24 / 7 Free support</div></div><md-button \nclass=\"cta-button md-raised md-accent\">GET STARTED FREE</md-button><div class=\"note\">7 day free trial to start</div>\n</div><div class=\"price-table style-3 md-whiteframe-8dp\" layout=\"column\"><div class=\"package-type\"><div class=\"title\">\nPro</div><div class=\"subtitle\">For larger teams</div></div><div class=\"price md-primary-bg\" layout=\"row\" \nlayout-align=\"center start\"><div class=\"currency\">$</div><div layout=\"row\" layout-align=\"center end\"><div \nclass=\"value\">59</div><div class=\"period\">monthly per user</div></div></div><div class=\"terms\" layout=\"column\" \nlayout-align=\"start center\"><div class=\"term\">Unlimited projects</div><div class=\"term\">Unlimited pages</div><div \nclass=\"term\">Unlimited disk space</div><div class=\"term\">24 / 7 Free support</div><div class=\"term md-warn-fg\">\nAdvanced reporting</div><div class=\"term md-warn-fg\">Customizable interface</div><div class=\"term md-warn-fg\">\nCRM Integration</div></div><md-button class=\"cta-button md-raised md-accent\">GET STARTED FREE</md-button><div \nclass=\"note\">30 day free trial to start</div></div><div class=\"price-table style-3 md-whiteframe-1dp\" layout=\"column\">\n<div class=\"package-type\"><div class=\"title\">Enterprise</div><div class=\"subtitle\">For big teams</div></div><div \nclass=\"price md-primary-bg md-hue-3\" layout=\"row\" layout-align=\"center start\"><div class=\"currency\">$</div><div \nlayout=\"row\" layout-align=\"center end\"><div class=\"value\">99</div><div class=\"period\">monthly per user</div></div>\n</div><div class=\"terms\" layout=\"column\" layout-align=\"start center\"><div class=\"term\">Unlimited projects</div><div \nclass=\"term\">Unlimited pages</div><div class=\"term\">Unlimited disk space</div><div class=\"term\">\nFor full feature list, call us</div></div><md-button class=\"cta-button md-raised md-accent\">CALL US</md-button><div \nclass=\"note\">90 day free trial to start</div></div></div></div></div>");
$templateCache.put("app/main/ui/forms/forms.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Forms</div></div></div><div class=\"content\" layout=\"column\"><div class=\"md-title\">Stepper</div><div \nclass=\"pb-16\"><b>ms-stepper</b>\n is a custom made form wizard directive. It follows Google\'s Material Design specifications and we recommend you to use it. If for some reason, it\'s not suitable for your project, you can always use the Form Wizard that we put together using md-tabs and forms.\n</div><form name=\"horizontalStepper\" ms-horizontal-stepper ng-submit=\"vm.submitHorizontalStepper()\" \nng-model=\"vm.horizontalStepper\" novalidate><ms-horizontal-stepper-step ng-form=\"horizontalStep1\" step=\"1\" \nstep-title=\"\'Personal Information\'\"><div ng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-1.html\'\"></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"horizontalStep2\" step=\"2\" step-title=\"\'Birthplace\'\" \noptional-step hide-step=\"!vm.horizontalStepper.step1.lastname\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-2.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep3\" step=\"3\" step-title=\"\'SSN\'\" optional-step \nhide-step=\"!vm.horizontalStepper.step2.birthplace\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-3.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep4\" step=\"4\" step-title=\"\'Address\'\" optional-step><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-4.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep5\" step=\"5\" step-title=\"\'Payment Method\'\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-5.html\'\"></div></ms-horizontal-stepper-step></form><div \nclass=\"mv-24\"></div><form name=\"verticalStepper\" ms-vertical-stepper ng-submit=\"vm.submitVerticalStepper()\" \nng-model=\"vm.verticalStepper\" novalidate><ms-vertical-stepper-step ng-form=\"verticalStep1\" step=\"1\" \nstep-title=\"\'Personal Information\'\"><div ng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-1.html\'\"></div>\n</ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"verticalStep2\" step=\"2\" step-title=\"\'Birthplace\'\" \noptional-step hide-step=\"!vm.verticalStepper.step1.lastname\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-2.html\'\"></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep3\" step=\"3\" step-title=\"\'SSN\'\" optional-step \nhide-step=\"!vm.verticalStepper.step2.birthplace\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-3.html\'\"></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep4\" step=\"4\" step-title=\"\'Address\'\" optional-step><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-4.html\'\"></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep5\" step=\"5\" step-title=\"\'Payment Method\'\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-5.html\'\"></div></ms-vertical-stepper-step></form><div \nclass=\"md-title mt-32\">Form Wizard</div><div class=\"pb-16\">\nForm wizard is a combination of md-tabs and forms that we have created for you. You can have as many steps as you want.\n</div><div layout=\"row\"><ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nmd-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Personal Information</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"vm.formWizard.firstname\" \nplaceholder=\"Firstname\" required><div ng-messages=\"wizardStep1.firstname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.formWizard.lastname\" placeholder=\"Lastname\" \nrequired><div ng-messages=\"wizardStep1.lastname.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nLastname field is required.</span></div></div></md-input-container></div><md-input-container class=\"md-block\"><input \ntype=\"email\" name=\"email\" ng-model=\"vm.formWizard.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"wizardStep1.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail field is required</span></div><div ng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div>\n</div></md-input-container><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<input type=\"password\" name=\"password\" ng-model=\"vm.formWizard.password\" placeholder=\"Password\" required><div \nng-messages=\"wizardStep1.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required.\n</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"password\" \nname=\"passwordConfirm\" ng-model=\"vm.formWizard.passwordConfirm\" placeholder=\"Password (Confirm)\" required><div \nng-messages=\"wizardStep1.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPassword (Confirm) field is required.</span></div></div></md-input-container></div></form></md-tab-body></md-tab>\n<md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Address</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" \nms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>City</label>\n<input type=\"text\" name=\"city\" ng-model=\"vm.formWizard.city\"></md-input-container><md-input-container flex><label>State\n</label><md-select ng-model=\"vm.formWizard.state\"><md-option ng-repeat=\"state in vm.states\" value=\"{{state.abbrev}}\">\n{{state.abbrev}}</md-option></md-select></md-input-container><md-input-container flex><label>Postal Code</label><input \nname=\"postalcode\" ng-model=\"vm.formWizard.postalCode\" placeholder=\"12345\" required ng-pattern=\"/^[0-9]{5}$/\" \nmd-maxlength=\"5\"><div ng-messages=\"wizardStep2.postalcode.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>You must supply a postal code.</span></div><div ng-message=\"pattern\"><span>\nThat doesn\'t look like a valid postal code.</span></div><div ng-message=\"md-maxlength\"><span>\nPostal code can\'t be longer than 5 characters.</span></div></div></md-input-container></div><md-input-container \nclass=\"md-block\"><label>Address</label><textarea ng-model=\"vm.formWizard.address\" md-maxlength=\"150\" max-rows=\"5\" \nrequired></textarea><div ng-messages=\"wizardStep2.address.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Address field is required.</span></div><div ng-message=\"md-maxlength\"><span>\nAddress can\'t be longer than 150 characters.</span></div></div></md-input-container></form></md-tab-body></md-tab>\n<md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Payment Method</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep3\" ms-form-wizard-form novalidate><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"cardholder\" ng-model=\"vm.formWizard.cardholder\" placeholder=\"Card Holder\" required><div \nng-messages=\"wizardStep3.cardholder.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard holder field is required.</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"cardnumber\" \nng-model=\"vm.formWizard.cardnumber\" placeholder=\"Card Number\" required><div \nng-messages=\"wizardStep3.cardnumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard number field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\">\n<input type=\"text\" name=\"CC2\" ng-model=\"vm.formWizard.cc2\" placeholder=\"CC2\" md-maxlength=\"3\" required><div \nng-messages=\"wizardStep3.cc2.$error\" role=\"alert\" multipl><div ng-message=\"required\"><span>CC2 field is required.\n</span></div><div ng-message=\"md-maxlength\"><span>CC2 can\'t be longer than 3 characters.</span></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"expirationDate\" \nng-model=\"vm.formWizard.expirationDate\" placeholder=\"Expiration Date\" required><div \nng-messages=\"wizardStep3.expirationDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nExpiration date field is required.</span></div></div></md-input-container></div></form></md-tab-body></md-tab>\n</md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Previous\n</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Next</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vm.sendForm(); msWizard.resetForm();\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete()\">Send</md-button></div></ms-form-wizard></div><div class=\"md-title mt-32\">\nBasic form with validation</div><div class=\"pb-16\">\nWith this form example, Submit button will only be activated if all the required fields are filled and if there is no error on the form.\n</div><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"60\"><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div class=\"form-title\">Optional form title</div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"firstname\" ng-model=\"vm.basicForm.firstname\" \nplaceholder=\"Firstname\" required><div ng-messages=\"basicForm.firstname.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Firstname field is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"lastname\" ng-model=\"vm.basicForm.lastname\" placeholder=\"Lastname\" required><div \nng-messages=\"basicForm.lastname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nCity</label><input type=\"text\" name=\"city\" ng-model=\"vm.basicForm.city\"></md-input-container><md-input-container flex>\n<label>State</label><md-select ng-model=\"vm.basicForm.state\"><md-option ng-repeat=\"state in vm.states\" \nvalue=\"{{state.abbrev}}\">{{state.abbrev}}</md-option></md-select></md-input-container><md-input-container flex><label>\nPostal Code</label><input name=\"postalcode\" ng-model=\"vm.basicForm.postalCode\" placeholder=\"12345\" required \nng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"><div ng-messages=\"basicForm.postalcode.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>You must supply a postal code.</span></div><div \nng-message=\"pattern\"><span>That doesn\'t look like a valid postal code.</span></div><div ng-message=\"md-maxlength\">\n<span>Postal code can\'t be longer than 5 characters.</span></div></div></md-input-container></div><md-input-container \nclass=\"md-block\"><label>Biography</label><textarea ng-model=\"vm.basicForm.biography\" md-maxlength=\"150\" max-rows=\"5\">\n</textarea></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button></form></div><div \nclass=\"form-wrapper form-data-wrapper md-whiteframe-1dp\" flex=\"40\"><div class=\"form-title\">Form ng-model data</div><div\n class=\"json-data-wrapper\"><pre>{{vm.basicForm | json}}</pre></div></div></div></div></div>");
$templateCache.put("app/main/ui/helper-classes/helper-classes.html","<div id=\"helper-classes\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Helper Classes</div></div></div><div class=\"content\" layout=\"column\"><md-tabs md-dynamic-height><md-tab \nlabel=\"Padding & Margin Helpers\"><div class=\"md-title\">Padding Helpers</div><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span>no-padding</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span class=\"no-padding\">No padding</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100\n</div><span>padding-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span class=\"padding-5\">5px padding</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100\n</div><span>p-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\">\n<span class=\"p-15\">15px padding</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96</div><span>\npadding-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"padding-8\">8px padding</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96</div><span>p-(8x)\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"p-32\">\n32px padding</span></hljs></div></div><div class=\"md-title\">Direction Specific Padding Helpers</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100</div><span>\npadding-top-(5x)</span> <span>padding-right-(5x)</span> <span>padding-bottom-(5x)</span> <span>padding-left-(5x)</span>\n <span>padding-horizontal-(5x)</span> <span>padding-vertical-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"padding-top-5\">5px from top</span> <span \nclass=\"padding-right-25\">25px from right</span> <span class=\"padding-bottom-10\">10px from bottom</span> <span \nclass=\"padding-left-20\">20px from left</span> <span class=\"padding-horizontal-5\">5px from left and right</span> <span \nclass=\"padding-vertical-5\">5px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100\n</div><span>pt-(5x)</span> <span>pr-(5x)</span> <span>pb-(5x)</span> <span>pl-(5x)</span> <span>ph-(5x)</span> <span>\npv-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"pt-5\">5px from top</span> <span class=\"pr-25\">25px from right</span> <span class=\"pb-10\">10px from bottom</span>\n <span class=\"pl-20\">20px from left</span> <span class=\"ph-5\">5px from left and right</span> <span class=\"pv-5\">\n5px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96</div><span>\npadding-top-(8x)</span> <span>padding-right-(8x)</span> <span>padding-bottom-(8x)</span> <span>padding-left-(8x)</span>\n <span>padding-horizontal-(8x)</span> <span>padding-vertical-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"padding-top-8\">8px from top</span> <span \nclass=\"padding-right-24\">24px from right</span> <span class=\"padding-bottom-16\">16px from bottom</span> <span \nclass=\"padding-left-8\">8px from left</span> <span class=\"padding-horizontal-8\">8px from left and right</span> <span \nclass=\"padding-vertical-8\">8px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96\n</div><span>pt-(8x)</span> <span>pr-(8x)</span> <span>pb-(8x)</span> <span>pl-(8x)</span> <span>ph-(8x)</span> <span>\npv-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"pt-8\">8px from top</span> <span class=\"pr-24\">24px from right</span> <span class=\"pb-16\">16px from bottom</span>\n <span class=\"pl-8\">8px from left</span> <span class=\"ph-8\">8px from left and right</span> <span class=\"pv-8\">\n8px from top and bottom</span></hljs></div></div><div class=\"md-title\">Margin Helpers</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span>no-margin</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"no-margin\">No margin</span></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption mb-16\">Multiples of 5, Max:100</div><span>margin-(5x)</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"margin-5\">5px margin</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption mb-16\">Multiples of 5, Max:100</div><span>m-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"m-15\">15px margin</span></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">\nMultiples of 8, Max:96</div><span>margin-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><span class=\"margin-8\">8px margin</span></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">\nMultiples of 8, Max:96</div><span>m-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><span class=\"m-32\">32px margin</span></hljs></div></div><div class=\"md-title\">\nDirection Specific Margin Helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">\nMultiples of 5, Max:100</div><span>margin-top-(5x)</span> <span>margin-right-(5x)</span> <span>margin-bottom-(5x)\n</span> <span>margin-left-(5x)</span> <span>margin-horizontal-(5x)</span> <span>margin-vertical-(5x)</span></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"margin-top-5\">5px from top\n</span> <span class=\"margin-right-25\">25px from right</span> <span class=\"margin-bottom-10\">10px from bottom</span> \n<span class=\"margin-left-20\">20px from left</span> <span class=\"margin-horizontal-5\">5px from left and right</span> \n<span class=\"margin-vertical-5\">5px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div\n class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100\n</div><span>mt-(5x)</span> <span>mr-(5x)</span> <span>mb-(5x)</span> <span>ml-(5x)</span> <span>mh-(5x)</span> <span>\nmv-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"mt-5\">5px from top</span> <span class=\"mr-25\">25px from right</span> <span class=\"mb-10\">10px from bottom</span>\n <span class=\"ml-20\">20px from left</span> <span class=\"mh-5\">5px from left and right</span> <span class=\"mv-5\">\n5px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96</div><span>\nmargin-top-(8x)</span> <span>margin-right-(8x)</span> <span>margin-bottom-(8x)</span> <span>margin-left-(8x)</span> \n<span>margin-horizontal-(8x)</span> <span>margin-vertical-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"margin-top-8\">8px from top</span> <span \nclass=\"margin-right-24\">24px from right</span> <span class=\"margin-bottom-16\">16px from bottom</span> <span \nclass=\"margin-left-8\">8px from left</span> <span class=\"margin-horizontal-8\">8px from left and right</span> <span \nclass=\"margin-vertical-8\">8px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96\n</div><span>mt-(8x)</span> <span>mr-(8x)</span> <span>mb-(8x)</span> <span>ml-(8x)</span> <span>mh-(8x)</span> <span>\nmv-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"mt-8\">8px from top</span> <span class=\"mr-24\">24px from right</span> <span class=\"mb-16\">16px from bottom</span>\n <span class=\"ml-8\">8px from left</span> <span class=\"mh-8\">8px from left and right</span> <span class=\"mv-8\">\n8px from top and bottom</span></hljs></div></div></md-tab><md-tab label=\"Width & Height Helpers\"><div class=\"md-title\">\nWidth Helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:500\n</div><span>width-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span class=\"width-5\">5px fixed width</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:500\n</div><span>w-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\">\n<span class=\"w-350\">350px fixed width</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:800</div><span>\nwidth-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"width-8\">8px fixed width</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:800</div><span>w-(8x)\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"w-560\">\n560px fixed width</span></hljs></div></div><div class=\"md-title\">Height Helpers</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:500</div><span>\nheight-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"height-5\">5px fixed height</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:500</div><span>h-(5x)\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"h-350\">\n350px fixed height</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:800</div><span>height-(8x)</span>\n</div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"height-8\">\n8px fixed height</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:800</div><span>h-(8x)</span></div>\n<hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"h-560\">\n560px fixed height</span></hljs></div></div></md-tab><md-tab label=\"Border Helpers\"><div class=\"md-title\">\nBorder Helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>border</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"border\">Border on all sides</span>\n</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span>b</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\">\n<span class=\"b\">Border on all sides</span></hljs></div></div><div class=\"md-title\">Direction Specific Border Helpers\n</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span>border-top</span> <span>border-right</span> <span>border-bottom\n</span> <span>border-left</span> <span>border-horizontal</span> <span>border-vertical</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"border-top\">Border top</span> <span \nclass=\"border-right\">Border right</span> <span class=\"border-bottom\">Border bottom</span> <span class=\"border-left\">\nBorder left</span> <span class=\"border-horizontal\">Border left and right</span> <span class=\"border-vertical\">\nBorder top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><span>bt</span> <span>br</span> <span>bb</span> <span>bl</span> <span>bh</span> <span>\nbv</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"bt\">\nBorder top</span> <span class=\"br\">Border right</span> <span class=\"bb\">Border bottom</span> <span class=\"bl\">\nBorder left</span> <span class=\"bh\">Border left and right</span> <span class=\"bv\">Border top and bottom</span></hljs>\n</div></div><div class=\"md-title\">Border Radius Helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption mb-16\">Multiples of 1, Max:12</div><span>brad-*</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"brad-2\">2px border radius</span> <span class=\"brad-5\">\n5px border radius</span></hljs></div></div></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/components/widgets/widgets.html","<div id=\"widgets\" class=\"page-layout simple fullwidth doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span></div><div \nclass=\"title\">Widgets</div></div></div><div class=\"content\"><p class=\"h3 m-16\">\nHere you can see some of the other widget styles. These are just tiny example of what you can do with using <code \nclass=\"no-highlight\">ms-widget</code>\n directive and helper classes. You are not limited to these styles or widgets, you can easily create wide variety of widgets.\n</p><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"h-170 p-16 light-blue-bg\"><div class=\"pb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">{{vm.widget1.title}}\n</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"md-display-1\" layout=\"row\" \nlayout-align=\"start center\"><span>{{vm.widget1.value | number}}</span><md-icon md-font-icon=\"icon-trending-up\" \nclass=\"s36 ml-16\"></md-icon></div><div layout=\"row\" layout-align=\"start center\"><span>\nLast week: {{vm.widget1.lastWeekValue | number}}</span> <span class=\"text-boxed-light\">{{vm.widget1.lastWeekDiff}}\n</span></div></div></ms-widget-front><ms-widget-back class=\"p-16 light-blue-bg white-fg\"><div class=\"flip-to-front\">\n<md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"h-170 p-16 green-bg\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h4 font-weight-500 secondary-text\">{{vm.widget2.title}}</div><md-menu><md-button aria-label=\"more\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"space-between\" flex><div><div class=\"md-display-1 pb-16\">{{vm.widget2.value}}%</div><div class=\"pb-16\">\n<md-progress-linear md-mode=\"determinate\" value=\"{{vm.widget2.value}}\"></md-progress-linear></div></div><div \nlayout=\"row\" layout-align=\"start center\"><span>Last week: {{vm.widget2.lastWeekValue}}%</span> <span \nclass=\"text-boxed-light\">{{vm.widget2.lastWeekDiff}}</span></div></div></ms-widget-front><ms-widget-back \nclass=\"p-16 green-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"h-170 p-16 blue-grey-bg white-fg\"><div class=\"pb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">{{vm.widget3.title}}\n</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div layout=\"column\" layout-align=\"space-between\" flex><div><div class=\"md-display-1 pb-16\">{{vm.widget3.value}}%\n</div><div class=\"pb-8\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.widget3.value}}\"></md-progress-linear>\n</div></div><div>See more details...</div></div></ms-widget-front><ms-widget-back class=\"p-16 blue-grey-bg white-fg\">\n<div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget3.detail}}</div></ms-widget-back>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"h-170 p-16 deep-purple-bg white-fg\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h4 font-weight-500 secondary-text\">{{vm.widget4.title}}</div><md-menu><md-button aria-label=\"more\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"column\" layout-align=\"space-between\" flex>\n<div class=\"md-display-1 pb-8\" layout=\"row\" layout-align=\"start center\"><span>{{vm.widget4.value | number}}</span>\n<md-icon md-font-icon=\"icon-trending-down\" class=\"s36 ml-16\"></md-icon></div><div>See more details...</div></div>\n</ms-widget-front><ms-widget-back class=\"p-16 deep-purple-bg white-fg\"><div class=\"flip-to-front\"><md-button \nclass=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\">\n</md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex><div class=\"pt-8 pb-8\" \nlayout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-1 pb-8\">{{vm.widget5.value}}</div><div \nclass=\"font-weight-500 secondary-text\">{{vm.widget5.title}}</div></div></ms-widget-front></ms-widget><ms-widget \nclass=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" \nlayout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"font-weight-500 secondary-text pb-8\">{{vm.widget6.title}}</div><div class=\"md-display-1\">{{vm.widget6.value}}\n</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"pl-8\" layout=\"column\" layout-align=\"center start\"><span \nclass=\"md-display-1 pb-8\">{{vm.widget7.value}}</span> <span class=\"font-weight-500 secondary-text\">{{vm.widget7.title}}\n</span></div><div><md-icon md-font-icon=\"icon-thumb-up\" class=\"s48 hint-text\"></md-icon></div></div></ms-widget-front>\n</ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 white-bg\" layout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"row\" layout-align=\"space-between center\" flex>\n<div><md-icon md-font-icon=\"icon-lock-unlocked\" class=\"s48 hint-text\"></md-icon></div><div class=\"pr-8\" \nlayout=\"column\" layout-align=\"center end\"><div class=\"md-display-1 pb-8\">{{vm.widget8.value}}</div><div \nclass=\"font-weight-500 secondary-text\">{{vm.widget8.title}}</div></div></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget class=\"h-300\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 deep-orange-bg white-fg\" layout=\"row\" flex><div \nlayout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-3 pb-8\">{{vm.widget9.value}}</div><div \nclass=\"h3 font-weight-500\">{{vm.widget9.title}}</div></div><div class=\"background-image-center\"><md-icon \nmd-font-icon=\"icon-music-note\" class=\"s256 faint-text\"></md-icon></div></ms-widget-front></ms-widget><ms-widget \nclass=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 cyan-bg white-fg\" layout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-3 pb-8\">{{vm.widget10.value}}</div><div class=\"h3 font-weight-500\">{{vm.widget10.title}}</div></div>\n<div class=\"background-image-center\"><md-icon md-font-icon=\"icon-filmstrip\" class=\"s256 faint-text\"></md-icon></div>\n</ms-widget-front></ms-widget><ms-widget class=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front \nclass=\"p-16 teal-bg white-fg\" layout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-3 pb-8\">{{vm.widget11.value}}</div><div class=\"h3 font-weight-500\">{{vm.widget11.title}}</div></div>\n<div class=\"background-image-center\"><md-icon md-font-icon=\"icon-file-document\" class=\"s256 faint-text\"></md-icon>\n</div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 light-blue-bg\" layout=\"column\" flex><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div\n class=\"h4 secondary-text\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"s16 mr-8\"></md-icon><span \nclass=\"font-weight-500\">{{vm.widget12.date}}</span><md-icon md-font-icon=\"icon-arrow-right\" class=\"s16 ml-8\"></md-icon>\n</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"white-fg\" layout=\"column\" layout-align=\"center center\" flex><div><md-icon \nmd-font-icon=\"{{vm.widget12.icon}}\" class=\"s96\"></md-icon></div><div class=\"pt-16\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"md-display-2\">{{vm.widget12.temperature}}&deg;</div><div class=\"pl-16\" \nlayout=\"column\"><div class=\"h1 text-semibold\">{{vm.widget12.event}}</div><div class=\"h4 secondary-text\">\n{{vm.widget12.location}}</div></div></div><div class=\"pt-32\" layout=\"row\" layout-align=\"center center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-windy\" class=\"s16\"></md-icon><span \nclass=\"pl-8\">22 km/h</span></div><div class=\"pl-16\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-compass\" class=\"s16\"></md-icon><span class=\"pl-8\">NW</span></div></div></div></ms-widget-front>\n<ms-widget-back class=\"p-16 light-blue-bg\" layout=\"column\" flex><div class=\"flip-to-front\"><md-button \nclass=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\">\n</md-icon></md-button></div><div class=\"pt-16 pb-16 white-fg\"><span class=\"h1\">Next 5 days</span></div><div \nclass=\"pl-8 pr-8\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"start center\" \nng-repeat=\"detail in vm.widget12.detail\"><div class=\"h4 pb-8 black-fg secondary-text\">{{detail.day}}</div><md-icon \nmd-font-icon=\"{{detail.icon}}\" class=\"s36 white-fg\"></md-icon><div class=\"h3 pt-8 white-fg\">{{detail.temperature}}&deg;\n</div></div></div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"column\" flex><div class=\"pb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h4 secondary-text\"><md-icon md-font-icon=\"icon-arrow-left\" \nclass=\"s16 mr-8\"></md-icon><span class=\"font-weight-500\">{{vm.widget13.date}}</span><md-icon \nmd-font-icon=\"icon-arrow-right\" class=\"s16 ml-8\"></md-icon></div><md-menu><md-button aria-label=\"more\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"column\" layout-align=\"center center\" flex>\n<div><md-icon md-font-icon=\"{{vm.widget13.icon}}\" class=\"s96\"></md-icon></div><div class=\"pt-16\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"md-display-2\">{{vm.widget13.temperature}}&deg;</div><div class=\"pl-16\" \nlayout=\"column\"><div class=\"h1 text-semibold\">{{vm.widget13.event}}</div><div class=\"h4 secondary-text\">\n{{vm.widget13.location}}</div></div></div><div class=\"pt-32\" layout=\"row\" layout-align=\"center center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-windy\" class=\"s16\"></md-icon><span \nclass=\"pl-8\">22 km/h</span></div><div class=\"pl-16\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-compass\" class=\"s16\"></md-icon><span class=\"pl-8\">NW</span></div></div></div></ms-widget-front>\n<ms-widget-back class=\"p-16 light-blue-bg\" layout=\"column\" flex><div class=\"flip-to-front\"><md-button \nclass=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\">\n</md-icon></md-button></div><div class=\"pt-16 pb-16 white-fg\"><span class=\"h1\">Next 5 days</span></div><div \nclass=\"pl-8 pr-8\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"start center\" \nng-repeat=\"detail in vm.widget13.detail\"><div class=\"h4 pb-8 black-fg secondary-text\">{{detail.day}}</div><md-icon \nmd-font-icon=\"{{detail.icon}}\" class=\"s36 white-fg\"></md-icon><div class=\"h3 pt-8 white-fg\">{{detail.temperature}}&deg;\n</div></div></div></ms-widget-back></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pt-16 pb-8 md-accent-bg\"><div class=\"h3\">{{vm.widget14.title}}</div></div><md-tabs \nclass=\"md-accent no-radius\" md-dynamic-height><md-tab label=\"{{tab.label}}\" ng-repeat=\"tab in vm.widget14.tabs\"><div \nlayout=\"row\" layout-align=\"start center\" layout-wrap><div flex=\"100\" flex-gt-md=\"50\" ng-repeat=\"group in tab.groups\">\n<div class=\"h2 m-16 pb-16 border-bottom\">{{group.title}}</div><div class=\"p-16 pb-32\" ng-repeat=\"data in group.data\">\n<div class=\"pb-8\" layout=\"row\" layout-align=\"space-between start\"><span class=\"h3\">{{data.title}}</span> <span \nclass=\"h3 secondary-text font-weight-500\">{{data.value}}%</span></div><md-progress-linear \nclass=\"{{data.progressColor}}\" md-mode=\"determinate\" value=\"{{data.value}}\"></md-progress-linear></div></div></div>\n</md-tab></md-tabs></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget class=\"h-250\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 red-bg white-fg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"pb-16\"><div \nclass=\"h4 weight-500 pb-8\">{{vm.widget15.title}}</div><div layout=\"row\" layout-align=\"start center\"><div class=\"pr-8\">\n<md-icon md-font-icon=\"icon-alert\" class=\"s24 hint-text\"></md-icon></div><div class=\"h1 secondary-text\">\n{{vm.widget15.value}}%</div></div></div><div><c3chart class=\"c3 stroke-2\" bindto-id=\"cpu-usage\"><chart-column \nng-repeat=\"column in vm.widget15.chart.columns\" column-id=\"{{column.id}}\" column-name=\"{{column.name}}\" \ncolumn-color=\"{{column.color}}\" column-values=\"{{column.values}}\" column-type=\"{{column.type}}\"><chart-axis>\n<chart-axis-y show=\"false\"></chart-axis-y></chart-axis><chart-legend show-legend=\"false\"><chart-size \nchart-height=\"120\"></c3chart></div></ms-widget-front></ms-widget><ms-widget class=\"h-250\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"column\" layout-align=\"space-between\" \nflex><div class=\"pb-16\"><div class=\"h4 weight-500 pb-8\">{{vm.widget16.title}}</div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"h1 secondary-text\">{{vm.widget16.value}}</div><md-icon \nmd-font-icon=\"icon-trending-up\" class=\"mh-8\"></md-icon></div></div><div><c3chart class=\"c3 stroke-2\" bindto-id=\"stock\">\n<chart-column ng-repeat=\"column in vm.widget16.chart.columns\" column-id=\"{{column.id}}\" column-name=\"{{column.name}}\" \ncolumn-color=\"{{column.color}}\" column-values=\"{{column.values}}\" column-type=\"{{column.type}}\"><chart-axis>\n<chart-axis-x show=\"false\"></chart-axis-x><chart-axis-y show=\"false\"></chart-axis-y></chart-axis><chart-legend \nshow-legend=\"false\"><chart-size chart-height=\"120\"></c3chart></div></ms-widget-front></ms-widget><ms-widget \nclass=\"h-250\" layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"p-16 white-bg\" layout=\"column\" \nlayout-align=\"space-between\" flex><div class=\"pb-16\"><div class=\"h4 weight-500 pb-8\">{{vm.widget17.title}}</div><div \nclass=\"secondary-text\">{{vm.widget17.subtitle}}</div></div><div><c3chart class=\"c3 stroke-2\" bindto-id=\"io-rate\">\n<chart-column ng-repeat=\"column in vm.widget17.chart.columns\" column-id=\"{{column.id}}\" column-name=\"{{column.name}}\" \ncolumn-color=\"{{column.color}}\" column-values=\"{{column.values}}\" column-type=\"{{column.type}}\"><chart-axis>\n<chart-axis-y show=\"false\"></chart-axis-y></chart-axis><chart-size chart-height=\"120\"></c3chart></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nclass=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"p-16 white-bg\"><div layout=\"row\" \nlayout-align=\"space-between\"><div class=\"mr-16\"><div class=\"h4 weight-500 pb-8\">{{vm.widget18.title}}</div><div \nclass=\"h1 secondary-text\">{{vm.widget18.value | number}}</div><div class=\"pt-8\" layout=\"row\" \nlayout-align=\"start center\"><div>LW: {{vm.widget18.lastWeekValue | number}}</div><div class=\"text-boxed\">\n{{vm.widget18.lastWeekDiff}}</div></div></div><c3chart flex bindto-id=\"weekly-visitors\"><chart-column \nng-repeat=\"column in vm.widget18.chart.columns\" column-id=\"{{column.id}}\" column-name=\"{{column.name}}\" \ncolumn-color=\"{{column.color}}\" column-values=\"{{column.values}}\" column-type=\"{{column.type}}\"><chart-legend \nshow-legend=\"false\"><chart-bar width=\"10\"><chart-size chart-height=\"240\"></c3chart></div></ms-widget-front></ms-widget>\n<ms-widget class=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front \nclass=\"p-16 light-blue-bg white-fg\"><div layout=\"row\" layout-align=\"space-between\"><div class=\"mr-16\"><div \nclass=\"h1 weight-500 pb-8\">{{vm.widget19.title}}</div><div class=\"h4 secondary-text weight-500 pb-8\">\n{{vm.widget19.subtitle}}</div><div layout=\"row\" layout-align=\"start center\"><div class=\"md-display-1 pr-8\">\n{{vm.widget19.value}}</div><md-icon md-font-icon=\"icon-trending-up\" class=\"s24\"></md-icon></div></div><c3chart flex \nbindto-id=\"goog-nasdaq\"><chart-column ng-repeat=\"column in vm.widget19.chart.columns\" column-id=\"{{column.id}}\" \ncolumn-name=\"{{column.name}}\" column-color=\"{{column.color}}\" column-values=\"{{column.values}}\" \ncolumn-type=\"{{column.type}}\"><chart-legend show-legend=\"false\"><chart-bar width=\"10\"><chart-size chart-height=\"240\">\n</c3chart></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/ui/icons/icons.html","<div id=\"icons\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Icons</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"https://materialdesignicons.com/\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\" layout=\"column\">\n<md-input-container class=\"md-block\"><label>Search an icon</label><input ng-model=\"vm.searchText\"></md-input-container>\n<div id=\"icons-list\" class=\"card md-whiteframe-1dp\" layout=\"row\" layout-wrap><div class=\"item\" \nng-repeat=\"icon in vm.icons | filter:{properties: {name:vm.searchText}} track by icon.properties.id\" \nlayout-align=\"start center\"><i class=\"icon icon-{{::icon.properties.name}} s40\"></i><div \nclass=\"name secondary-text text-center\">icon-{{::icon.properties.name}}</div></div></div></div></div>");
$templateCache.put("app/main/ui/material-colors/material-colors.html","<div id=\"material-colors\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Material Colors</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"https://www.google.com/design/spec/style/color.html#color-color-palette\" \ntarget=\"_blank\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div \nclass=\"content\"><md-tabs class=\"color-tabs\" md-dynamic-height md-swipe-content><md-tab \nng-repeat=\"(paletteName, palette) in vm.palettes\" \nmd-on-select=\"vm.selected = paletteName; vm.selectedPalette = palette\"><md-tab-label><span class=\"text-capitalize\">\n{{paletteName}}</span></md-tab-label></md-tab></md-tabs><md-content class=\"color-tab\"><div class=\"h3 pb-16\">\nFuse has classes for every single color from <a \nhref=\"https://www.google.com/design/spec/style/color.html#color-color-palette\" target=\"_blank\">\nMaterial Design Color Palette</a>\n for your convenient. You can use them with pretty much every element except Angular Material directives.</div><div \nclass=\"color-header colored-bg\" ng-class=\"\'md-\'+vm.selected+\'-bg\'\" layout=\"row\" layout-align=\"start start\" layout-wrap \nlayout-padding><div flex=\"100\"><h3 class=\"text-capitalize\">{{vm.selected}}</h3></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><div>500</div><div>\nrgb({{vm.selectedPalette[\'500\'].value[0]}},{{vm.selectedPalette[\'500\'].value[1]}},{{vm.selectedPalette[\'500\'].value[2]}})\n</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"colored-bg\" \nng-repeat=\"(hue, hueValue) in vm.selectedPalette\" flex=\"100\" layout=\"row\" layout-sm=\"column\" layout-padding \nng-class=\"vm.selected+\'-\'+hue+\'-bg\'\"><div flex>{{hue}}</div><div class=\"colored-bg\" \nng-class=\"\'md-\'+vm.selected+\'-\'+hue+\'-bg\'\" flex>.{{\'md-\'+vm.selected+\'-\'+hue+\'-bg\'}}</div><div flex>\n.{{vm.selected+\'-\'+hue+\'-bg\'}}</div><div class=\"fg-box white-bg md-whiteframe-2dp\" \nng-class=\"vm.selected+\'-\'+hue+\'-fg\'\">.{{vm.selected+\'-\'+hue+\'-fg\'}}</div></div></div></md-content></div></div>");
$templateCache.put("app/main/ui/theme-colors/theme-colors.html","<div id=\"theme-colors\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Theme Colors</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised md-warn reference-button\" ng-click=\"vm.createTheme($event);\"><md-icon md-font-icon=\"icon-palette\">\n</md-icon><span>Create Your Own Theme!</span></md-button></div></div><div class=\"content\"><md-tabs class=\"color-tabs\" \nmd-dynamic-height md-swipe-content md-stretch-tabs=\"always\"><md-tab label=\"Primary Color\"><md-content \nclass=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/primary/primary.html\'\"></md-content></md-tab><md-tab \nlabel=\"Accent Color\"><md-content class=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/accent/accent.html\'\">\n</md-content></md-tab><md-tab label=\"Warn Color\"><md-content class=\"color-tab\" \nng-include=\"\'app/main/ui/theme-colors/tabs/warn/warn.html\'\"></md-content></md-tab><md-tab label=\"Background Color\">\n<md-content class=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/background/background.html\'\"></md-content>\n</md-tab></md-tabs></div></div>");
$templateCache.put("app/main/ui/typography/typography.html","<div id=\"typography\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">USER INTERFACE</span></div><div class=\"title\">Typography</div></div><div \nclass=\"content\"><md-tabs md-dynamic-height><md-tab label=\"Headings\"><div class=\"md-title\">Material design headings\n</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\" flex><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption secondary-text\">112px</div><span\n class=\"md-display-4\">Display 4</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><span class=\"md-display-4\">Display 4</span></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">56px</div><span class=\"md-display-3\">Display 3</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-display-3\">Display 3</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption secondary-text\">45px</div><span class=\"md-display-2\">Display 2</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-display-2\">Display 2</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption secondary-text\">34px</div><span class=\"md-display-1\">Display 1</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-display-1\">Display 1</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption secondary-text\">24px</div><span class=\"md-headline\">Headline</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-headline\">Headline</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption secondary-text\">20px</div><span class=\"md-title\">Title</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-title\">Title</span></hljs></div>\n<div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">16px</div><span class=\"md-subhead\">Subhead</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-subhead\">Subhead</span></hljs>\n</div></div><div class=\"md-title\">Headings</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">24px</div><h1>Heading 1</h1></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h1>Heading 1</h1><div class=\"h1\">Heading 1</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">20px</div><h2>Heading 2</h2></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h2>Heading 2</h2><div class=\"h2\">Heading 2</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">16px</div><h3>Heading 3</h3></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h3>Heading 3</h3><div class=\"h3\">Heading 3</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">14px</div><h4>Heading 4</h4></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h4>Heading 4</h4><div class=\"h4\">Heading 4</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">13px</div><h5>Heading 5</h5></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h5>Heading 5</h5><div class=\"h5\">Heading 5</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">12px</div><h6>Heading 6</h6></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h6>Heading 6</h6><div class=\"h6\">Heading 6</div></hljs></div></div>\n</md-tab><md-tab label=\"Inline Text Elements\"><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><abbr \ntitle=\"Cascaded Style Sheet\">CSS</abbr></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><abbr title=\"Cascaded Style Sheet\">CSS</abbr></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>\nThis is a <mark>marked</mark> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll>This is a <mark>marked</mark> text.</hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><del>\nThis is a deleted text.</del></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\" ms-scroll><del>This is a deleted text.</del></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><s>This is a strike-through text.</s></span>\n</div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><s>\nThis is a strike-through text.</s></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span><u>This is an underlined text.</u></span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><u>This is an underlined text.</u></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\">\n<span><small>This is a small text.</small></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><small>This is a small text.</small></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><strong>\nThis is a strong text.</strong></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scrollx><strong>This is a strong text.</strong></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><em>\nThis is an italic text.</em></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\" ms-scroll><em>This is an italic text.</em></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is a <span class=\"text-super\">super</span>\n text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>\nThis is a <span class=\"text-super\">super</span> text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is a <span class=\"text-sub\">sub</span> text.\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>This is a \n<span class=\"text-sub\">sub</span> text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is a <span class=\"text-capitalize\">capitalized</span> text.\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>This is a \n<span class=\"text-capitalized\">capitalized</span> text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is an <span class=\"text-uppercase\">uppercase\n</span> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" \nms-scroll>This is an <span class=\"text-uppercase\">uppercase</span> text.</hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is a <span \nclass=\"text-lowercase\">LOWERCASE</span> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll>This is a <span class=\"text-lowercase\">LOWERCASE</span> text.</hljs></div>\n</div></md-tab><md-tab label=\"Blockquotes & Lists\"><div class=\"md-title\">Blockquotes</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p></blockquote></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p></blockquote></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe</footer>\n</blockquote></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>\n<blockquote><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe\n</footer></blockquote></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><blockquote class=\"reverse\"><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe</footer>\n</blockquote></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>\n<blockquote class=\"reverse\"><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p>\n<footer>John Doe</footer></blockquote></hljs></div></div><div class=\"md-title\">Lists</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><ol><li>Ordered list item</li><li>Ordered list item<ol><li>\nOrdered list item</li><li>Ordered list item</li></ol></li><li>Ordered list item</li><li>Ordered list item</li></ol>\n</div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><ol><li>\nOrdered list item</li><li>Ordered list item<ol><li>Ordered list item</li><li>Ordered list item</li></ol></li><li>\nOrdered list item</li><li>Ordered list item</li></ol></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><ul><li>Unordered list item</li><li>Unordered list item\n<ul><li>Unordered list item</li><li>Unordered list item</li></ul></li><li>Unordered list item</li><li>\nUnordered list item</li></ul></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\" ms-scroll><ul><li>Unordered list item</li><li>Unordered list item<ul><li>Unordered list item</li><li>\nUnordered list item</li></ul></li><li>Unordered list item</li><li>Unordered list item</li></ul></hljs></div></div><div \nclass=\"md-title\">Definition lists</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><dl><dt>Definition term</dt>\n<dd>This is the definition description</dd><dt>Another definition term</dt><dd>\nThis is also another definition description</dd></dl></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><dl><dt>Definition term</dt><dd>This is the definition description</dd><dt>\nAnother definition term</dt><dd>This is also another definition description</dd></dl></hljs></div></div></md-tab>\n<md-tab label=\"Helpers\"><div class=\"md-title\">Font weight</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div\n layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption mb-16\">From 100 to 900</div><span class=\"font-weight-100\">font-weight: 100</span> <span>...</span> \n<span class=\"font-weight-900\">font-weight: 900</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><span class=\"font-weight-100\">100 font weight</span> ... <span \nclass=\"font-weight-900\">900 font weight</span></hljs></div></div><div class=\"md-title\">Font Size</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiplies of 2, max: 120</div><span \nclass=\"font-size-20\">font-size: 20</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><span class=\"font-size-20\">font-size: 20</span></hljs></div></div><div \nclass=\"md-title\">Line Height</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">\nMultiplies of 2, max: 120</div><span>line-height: 2</span> <span>...</span> <span>line-height: 120</span></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><span class=\"line-height-2\">\n2px line height</span> ... <span class=\"line-height-120\">120px line height</span></hljs></div></div><div \nclass=\"md-title\">Other helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"text-left\">\nLeft aligned text</div></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" \nms-scroll><div class=\"text-left\">Left aligned text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"text-center\">Center aligned text</div>\n</div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><div \nclass=\"text-center\">Center aligned text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"text-right\">Right aligned text</div></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><div class=\"text-right\">\nRight aligned text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><p><span class=\"text-boxed\">Boxed text</span></p></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><p><span class=\"text-boxed\">Boxed text\n</span></p></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview md-grey-700-bg\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><p><span class=\"text-boxed-light\">Boxed text light</span></p></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><p><span class=\"text-boxed-light\">\nBoxed text light</span></p></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><p><span class=\"text-strike\">Strike-through text</span></p></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><p><span class=\"text-strike\">\nStrike-through text</span></p></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"text-italic\">Italic text</div></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><div class=\"text-italic\">Italic text\n</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><div class=\"text-semibold\">Semi-bold text</div></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><div class=\"text-semibold\">Semi-bold text</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"text-bold\">Bold text</div></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\" ms-scroll><div class=\"text-bold\">Bold text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex><span class=\"text-truncate\">\nThis is a truncated text. It will be truncated if it\'s too long. Vivamus convallis dui porta massa.</span></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><span class=\"text-truncate\">\nThis is a truncated text. It will be truncated if it\'s too long. Vivamus convallis dui porta massa.</span></hljs></div>\n</div></md-tab></md-tabs></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">B</span> <span class=\"logo-text\">\nBUENATELIER</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/main/pages/coming-soon/coming-soon.html","<div id=\"coming-soon\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"coming-soon-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"coming-soon-form\" class=\"md-whiteframe-8dp\"><div class=\"top\"><div\n class=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"COMINGSOON.TITLE\">\nHey! Thank you for checking out our app.</div><div class=\"subtitle\" translate=\"COMINGSOON.SUBTITLE\">\nIt’s not quite ready yet, but we are working hard and it will be ready in approximately:</div><timer \nend-time=\"vm.endTime\" layout=\"row\" layout-align=\"center center\" layout-wrap><div flex-xs=\"50\"><div class=\"value\">\n{{days}}</div><div class=\"type\" translate=\"COMINGSOON.DAYS\">days</div></div><div flex-xs=\"50\"><div class=\"value\">\n{{hours}}</div><div class=\"type\" translate=\"COMINGSOON.HOURS\">hours</div></div><div flex-xs=\"50\"><div class=\"value\">\n{{minutes}}</div><div class=\"type\" translate=\"COMINGSOON.MINUTES\">minutes</div></div><div flex-xs=\"50\"><div \nclass=\"value\">{{seconds}}</div><div class=\"type\" translate=\"COMINGSOON.SECONDS\">seconds</div></div></timer></div><form>\n<div class=\"message\" translate=\"COMINGSOON.MESSAGE\">\nIf you would like to be notified when the app is ready, you can subscribe to our e-mail list.</div><md-input-container \nflex md-no-float><input type=\"email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"COMINGSOON.EMAIL_ADRESS\"></md-input-container><md-button class=\"md-raised md-accent\" \naria-label=\"SUBSCRIBE\" translate=\"COMINGSOON.SUBSCRIBE\" translate-attr-aria-label=\"COMINGSOON.SUBSCRIBE\">SUBSCRIBE\n</md-button></form></div></div></div>");
$templateCache.put("app/main/pages/maintenance/maintenance.html","<div id=\"maintenance\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"maintenance-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"maintenance-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"MAINTENANCE.TITLE\">\nClosed for scheduled maintenance!</div><div class=\"subtitle\" translate=\"MAINTENANCE.SUBTITLE\">\nWe\'re sorry for the inconvenience.<br>Please check back later.</div></div></div></div>");
$templateCache.put("app/main/pages/timeline/timeline-left.html","<div id=\"timeline\" class=\"timeline-left\" ms-timeline=\"vm.timelineOptions\" ms-timeline-load-more=\"vm.loadNextPage()\">\n<div ms-timeline-item layout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" \nlayout-align-gt-md=\"center start\" ng-repeat=\"timelineItem in vm.timeline\"><div \nclass=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon md-font-icon=\"{{timelineItem.icon}}\"></md-icon></div>\n<div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">{{timelineItem.time}}</div><div class=\"event\">\n{{timelineItem.event}}</div></div><div class=\"timeline-card\" layout=\"row\" flex=\"50\"><ms-card \ntemplate=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card></div></div></div>");
$templateCache.put("app/main/pages/timeline/timeline-right.html","<div id=\"timeline\" class=\"timeline-right\" ms-timeline=\"vm.timelineOptions\" ms-timeline-load-more=\"vm.loadNextPage()\">\n<div ms-timeline-item layout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" \nlayout-align-gt-md=\"center start\" ng-repeat=\"timelineItem in vm.timeline\"><div \nclass=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon md-font-icon=\"{{timelineItem.icon}}\"></md-icon></div>\n<div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">{{timelineItem.time}}</div><div class=\"event\">\n{{timelineItem.event}}</div></div><div class=\"timeline-card\" layout=\"row\" flex=\"50\"><ms-card \ntemplate=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card></div></div></div>");
$templateCache.put("app/main/pages/timeline/timeline.html","<div id=\"timeline\" ms-timeline=\"vm.timelineOptions\" ms-timeline-load-more=\"vm.loadNextPage()\"><div ms-timeline-item \nlayout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" layout-align-gt-md=\"center start\" \nng-repeat=\"timelineItem in vm.timeline\"><div class=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon \nmd-font-icon=\"{{timelineItem.icon}}\"></md-icon></div><div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">\n{{timelineItem.time}}</div><div class=\"event\">{{timelineItem.event}}</div></div><div class=\"timeline-card\" \nlayout=\"row\" flex=\"50\"><ms-card template=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card></div>\n</div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\" class=\"s16\"></md-icon>\n</md-button></form></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex></div><div \nlayout=\"row\" layout-align=\"end center\" flex><md-progress-circular id=\"toolbar-progress\" \nng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide \nshow-gt-sm>{{ vm.userName }}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button translate translate-attr-aria-label=\"TOOLBAR.LOGOUT\" \nng-click=\"vm.logout()\">Salir</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div \nclass=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/main/pages/search/search.html","<div id=\"search\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input\" ng-model=\"vm.search\" \ntype=\"text\" placeholder=\"Search..\" translate translate-attr-placeholder=\"SEARCH.SEARCH\" flex></div><md-menu \nclass=\"search-settings\" md-position-mode=\"target-right target\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Search settings\" translate translate-attr-aria-label=\"SEARCH.SEARCH_SETTINGS\">\n<md-icon md-menu-origin md-menu-align-target md-font-icon=\"icon-cog\" class=\"icon s16\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\">\n</md-icon><span translate=\"SEARCH.SETTINGS_1\">Settings 1</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\"></md-icon><span translate=\"SEARCH.SETTINGS_2\">Settings 2\n</span></md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"content\" flex><md-tabs \nmd-dynamic-height><md-tab label=\"Classic\"><md-content class=\"classic-tab\" \nng-include=\"\'app/main/pages/search/tabs/classic/classic.html\'\"></md-content></md-tab><md-tab label=\"Emails\"><md-content\n class=\"emails-tab\" ng-include=\"\'app/main/pages/search/tabs/emails/emails.html\'\"></md-content></md-tab><md-tab \nlabel=\"Users\"><md-content class=\"users-tab\" ng-include=\"\'app/main/pages/search/tabs/users/users.html\'\"></md-content>\n</md-tab><md-tab label=\"Contacts\"><md-content class=\"contacts-tab\" \nng-include=\"\'app/main/pages/search/tabs/contacts/contacts.html\'\"></md-content></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/profile/profile.html","<div id=\"profile\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img \nclass=\"profile-image avatar huge\" src=\"assets/images/avatars/katherine.jpg\"><div class=\"name\">Katherine Wilson</div>\n</div><div class=\"actions\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-accent\" \naria-label=\"Follow\" translate=\"PROFILE.FOLLOW\" translate-attr-aria-label=\"PROFILE.FOLLOW\">Follow</md-button><md-button \nclass=\"md-raised md-primary\" translate=\"PROFILE.SEND_MESSAGE\" translate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">\nSend Message</md-button></div></div><div class=\"content\" flex><md-tabs md-dynamic-height><md-tab><md-tab-label><span \ntranslate=\"PROFILE.TIMELINE\">Timeline</span></md-tab-label><md-tab-body><md-content class=\"timeline-tab\" \nng-include=\"\'app/main/pages/profile/tabs/timeline/timeline.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"PROFILE.ABOUT\">About</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/pages/profile/tabs/about/about.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label>\n<span translate=\"PROFILE.PHOTOS_VIDEOS\">Photos & Videos</span></md-tab-label><md-tab-body><md-content \nclass=\"photos-videos-tab\" ng-include=\"\'app/main/pages/profile/tabs/photos-videos/photos-videos.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/apps/dashboards/server/dashboard-server.html","<div id=\"dashboard-server\"><div id=\"widgets\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg\"><div class=\"pb-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget1.title}}</div><md-menu><md-button aria-label=\"more\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div><nvd3 class=\"h-320\" class=\"remove-x-lines\" \noptions=\"vm.widget1.chart.options\" data=\"vm.widget1.chart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 pink-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" \nmd-font-icon=\"icon-harddisk\"></md-icon><div class=\"h3\">{{vm.widget2.title}}</div></div><md-menu><md-button \naria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" \naria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pb-24\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"h2\">{{vm.widget2.value.used}}</div><div \nclass=\"h2 secondary-text pl-8\">/ {{vm.widget2.value.total}}</div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.widget2.value.percentage}}\"></md-progress-linear></ms-widget-front><ms-widget-back \nclass=\"p-16 pr-32 pink-400-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 blue-bg white-fg\"><div class=\"pb-24\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"m-0 mr-8\" md-font-icon=\"icon-server-network\"></md-icon><div class=\"h3\">{{vm.widget3.title}}</div></div><md-menu>\n<md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"pb-24\" layout=\"row\" layout-align=\"start end\"><div class=\"h2\">{{vm.widget3.value.used}}</div><div \nclass=\"h2 pl-8 secondary-text\">/ {{vm.widget3.value.total}}</div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.widget3.value.percentage}}\"></md-progress-linear></ms-widget-front><ms-widget-back \nclass=\"p-16 pr-32 blue-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 teal-400-bg white-fg\"><div class=\"pb-24\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"m-0 mr-8\" md-font-icon=\"icon-clock-fast\"></md-icon><div class=\"h3\">{{vm.widget4.title}}</div></div><md-menu>\n<md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"pb-8 h1\">{{vm.widget4.value}}</div><div class=\"chart-fill-16\"><nvd3 \nclass=\"h-50 remove-opacity remove-line-stroke\" config=\"vm.widget4.chart.config\" options=\"vm.widget4.chart.options\" \ndata=\"vm.widget4.chart.data\"></nvd3></div></ms-widget-front><ms-widget-back class=\"p-16 pr-32 teal-400-bg white-fg\">\n<div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 indigo-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" md-font-icon=\"icon-scale\"></md-icon><div class=\"h3\">\n{{vm.widget5.title}}</div></div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div layout=\"column\" layout-align=\"space-between\" flex><div class=\"h1 pb-8\" \nlayout=\"row\" layout-align=\"start center\"><span>{{vm.widget5.value}}</span><md-icon md-font-icon=\"icon-trending-down\" \nclass=\"ml-16\"></md-icon></div><div class=\"secondary-text\">{{vm.widget5.footnote}}</div></div></ms-widget-front>\n<ms-widget-back class=\"p-16 pr-32 indigo-400-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget5.detail}}</div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg\"><div\n class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget6.title}}</div><md-menu>\n<md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div><nvd3 class=\"h-140 remove-x-lines remove-opacity\" config=\"vm.widget6.chart.config\" \noptions=\"vm.widget6.chart.options\" data=\"vm.widget6.chart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" \nflex-gt-md=\"60\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">{{vm.widget7.title}}\n</span> <span class=\"ml-16 text-boxed pink-bg white-fg\">{{vm.widget7.table.rows.length}} processes</span></div>\n<md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.widget7.dtOptions\"><thead><tr><th \nclass=\"secondary-text\" ng-repeat=\"column in ::vm.widget7.table.columns\"><div class=\"table-header\"><span \nclass=\"column-title\">{{column.title}}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in ::vm.widget7.table.rows\"><td ng-repeat=\"cell in row\"><span class=\"{{cell.classes}}\">{{cell.value}}\n</span></td></tr></tbody></table></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" \nflex-gt-md=\"40\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">{{vm.widget8.title}}\n</span> <span class=\"ml-16 text-boxed blue-bg white-fg\">Showing last {{vm.widget8.activities.length}} activity</span>\n</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"ph-16 pv-15 border-bottom\" layout=\"row\" layout-align=\"start center\" \nng-repeat=\"activity in vm.widget8.activities\"><div><i class=\"icon pr-16 mr-16 border-right\" \nng-class=\"{\'icon-arrow-down red-fg\':activity.type === \'Input\', \'icon-arrow-up green-fg\':activity.type === \'Output\'}\">\n</i></div><div class=\"h4 text-bold\" flex>{{activity.process}}</div><div class=\"h4 font-weight-500 secondary-text\">\n{{activity.value}}</div></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/apps/dashboards/project/dashboard-project.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">Welcome back, John!</span></div><div \nclass=\"toolbar\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div></div><div \nlayout=\"row\"><div class=\"selected-project\">{{vm.selectedProject.name}}</div><md-menu id=\"projects-menu\" \nmd-offset=\"0 48\"><md-button class=\"md-icon-button project-selector\" ng-click=\"$mdMenu.open()\" \naria-label=\"Select project\" md-menu-origin md-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon>\n</md-button><md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item ng-repeat=\"project in vm.projects\">\n<md-button ng-click=\"vm.selectProject(project)\" aria-label=\"{{project.name}}\"><span \nng-class=\"{\'secondary-text\': vm.selectedProject == project}\">{{project.name}}</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab label=\"Home\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" ng-model=\"vm.widget1.currentRange\" \naria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget1.ranges\" value=\"{{key}}\">{{range}}\n</md-option></md-select><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon\n md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{vm.widget1.data.count[vm.widget1.currentRange]}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget1.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget1.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.widget1.data.extra.count[vm.widget1.currentRange]}}</span></div></ms-widget-front>\n<ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget2.title}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" \naria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\">\n{{vm.widget2.data.count}}</div><div class=\"h3 secondary-text font-weight-500\">{{vm.widget2.data.label}}</div></div><div\n class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{vm.widget2.data.extra.label}}:</span> <span class=\"h4 ml-8\">\n{{vm.widget2.data.extra.count}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div \nclass=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget2.detail}}</div></ms-widget-back>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.widget3.title}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\">\n<md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"orange-fg font-size-72 line-height-72\">{{vm.widget3.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget3.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget3.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.widget3.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget4.title}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" \naria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">\n{{vm.widget4.data.count}}</div><div class=\"h3 secondary-text font-weight-500\">{{vm.widget4.data.label}}</div></div><div\n class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{vm.widget4.data.extra.label}}:</span> <span class=\"h4 ml-8\">\n{{vm.widget4.data.extra.count}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div \nclass=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back>\n</ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">{{vm.widget5.title}}</div><div class=\"pv-8\" \nlayout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-button class=\"ph-16\" \nng-repeat=\"(key, range) in vm.widget5.ranges\" ng-click=\"vm.widget5.changeRange(key)\" \nng-disabled=\"vm.widget5.currentRange == key\">{{range}}</md-button></div></div><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"100\" flex-gt-sm=\"50\"><nvd3 \nclass=\"h-420 remove-x-lines\" config=\"vm.widget5.mainChart.config\" options=\"vm.widget5.mainChart.options\" \ndata=\"vm.widget5.mainChart.data\"></nvd3></div><div class=\"p-16\" layout=\"row\" flex=\"100\" flex-gt-sm=\"50\" layout-wrap>\n<div class=\"p-16\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center\" \nng-repeat=\"(name, widget) in vm.widget5.supporting.widgets\"><div class=\"h4 secondary-text\">{{widget.data.label}}</div>\n<div class=\"md-display-1\">{{widget.data.count[vm.widget5.currentRange]}}</div><nvd3 class=\"h-50\" \nconfig=\"vm.widget5.supporting.chart.config\" options=\"vm.widget5.supporting.chart.options\" data=\"widget.chart.data\">\n</nvd3></div></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget6.title}}</div>\n<div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget6.currentRange\" \nng-change=\"vm.widget6.changeRange(vm.widget6.currentRange)\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in vm.widget6.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div \nclass=\"p-16\"><nvd3 class=\"h-400\" config=\"vm.widget6.mainChart.config\" options=\"vm.widget6.mainChart.options\" \ndata=\"vm.widget6.mainChart.data\"></nvd3></div><div class=\"pv-8 mh-16 border-top\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"pv-8 border-right\" layout=\"column\" layout-align=\"center center\" \nflex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">{{vm.widget6.footerLeft.count[vm.widget6.currentRange]}}</span> \n<span class=\"h4\">{{vm.widget6.footerLeft.title}}</span></div><div class=\"pv-8\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">\n{{vm.widget6.footerRight.count[vm.widget6.currentRange]}}</span> <span class=\"h4\">{{vm.widget6.footerRight.title}}\n</span></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front\n class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.widget7.title}}</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget7.currentRange\" \naria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget7.ranges\" value=\"{{key}}\">{{range}}\n</md-option></md-select></div></div><div class=\"p-16\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"event in vm.widget7.schedule[vm.widget7.currentRange]\"><div><div class=\"h3\">{{event.title}}</div><div><span \nclass=\"secondary-text\">{{event.time}}</span> <span ng-if=\"event.location\">, {{event.location}}</span></div></div>\n<md-button class=\"md-icon-button\" aria-label=\"More information\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button></div></ms-widget-front></ms-widget></div></md-tab><md-tab label=\"Budget Summary\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\">\n<ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">{{vm.widget8.title}}</div><md-divider></md-divider><div \nclass=\"p-16\"><nvd3 class=\"h-400\" options=\"vm.widget8.mainChart.options\" data=\"vm.widget8.mainChart.data\"></nvd3></div>\n</ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\">\n<div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget9.title}}\n</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget9.currentRange\" \nng-change=\"vm.widget9.changeRange(vm.widget9.currentRange)\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in vm.widget6.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\"><div \nclass=\"p-8\"><div class=\"h4 secondary-text\">{{vm.widget9.weeklySpent.title}}</div><div \nclass=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$</span><span>\n{{vm.widget9.weeklySpent.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex><nvd3 class=\"h-50\" \nconfig=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" data=\"vm.widget9.weeklySpent.chartData\"></nvd3>\n</div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"space-between center\"><div class=\"p-8\"><div class=\"h4 secondary-text\">\n{{vm.widget9.totalSpent.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$\n</span><span>{{vm.widget9.totalSpent.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex><nvd3 \nclass=\"h-50\" config=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" \ndata=\"vm.widget9.totalSpent.chartData\"></nvd3></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\"><div class=\"p-8\"><div class=\"h4 secondary-text\">\n{{vm.widget9.remaining.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$\n</span><span>{{vm.widget9.remaining.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex><nvd3 \nclass=\"h-50\" config=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" data=\"vm.widget9.remaining.chartData\">\n</nvd3></div></div><div class=\"pv-24 mh-24 border-top\"><div class=\"h4 secondary-text\">{{vm.widget9.totalBudget.title}}\n</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$</span><span>\n{{vm.widget9.totalBudget.count}}</span></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"simple-table-container\" ms-responsive-table><div class=\"table-title\">{{vm.widget10.title}}</div><table \nclass=\"simple\"><thead><tr><th ng-repeat=\"column in vm.widget10.table.columns\">{{column.title}}</th></tr></thead><tbody>\n<tr ng-repeat=\"row in vm.widget10.table.rows\"><td ng-repeat=\"cell in row\"><span class=\"{{cell.classes}}\">\n{{cell.value}} </span><i ng-if=\"cell.icon\" class=\"icon {{cell.icon}}\"></i></td></tr></tbody></table></div>\n</ms-widget-front></ms-widget></div></md-tab><md-tab label=\"Team Members\"><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"p-24 mb-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h2\">{{vm.widget11.title}}\n</div><div class=\"text-boxed red-bg white-fg m-0\">{{vm.widget11.table.rows.length}} members</div></div><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.widget11.dtOptions\"><thead><tr><th \nclass=\"secondary-text\" ng-repeat=\"column in ::vm.widget11.table.columns\"><div class=\"table-header\"><span \nclass=\"column-title\">{{column.title}}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in ::vm.widget11.table.rows\"><td ng-repeat=\"cell in row\"><img class=\"avatar\" ng-if=\"$index === 0\" \nng-src=\"assets/images/avatars/{{cell}}\"> <span ng-if=\"$index != 0\">{{cell}}</span></td></tr></tbody></table>\n</ms-widget-front></ms-widget></div></md-tab></md-tabs></div></div><md-sidenav class=\"sidenav md-sidenav-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div class=\"widget-group\">\n<ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div class=\"pl-16 pr-8 pv-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">\n{{vm.nowWidget.now.weekDay}}, {{vm.nowWidget.now.hour}}:{{vm.nowWidget.now.minute}}:{{vm.nowWidget.now.second}}</div>\n<md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" md-menu-origin md-menu-align-target \naria-label=\"Options\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" \nclass=\"icon\"></md-icon>Refresh</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon>Settings</md-button>\n</md-menu-item></md-menu-content></md-menu></div><div class=\"p-16 pb-24\" layout=\"column\" layout-align=\"center center\">\n<div class=\"h1 secondary-text\"><span>{{vm.nowWidget.now.month}}</span></div><div \nclass=\"font-size-72 line-height-88 secondary-text font-weight-400\">{{vm.nowWidget.now.day}}</div><div \nclass=\"h1 secondary-text\"><span>{{vm.nowWidget.now.year}}</span></div></div><md-divider></md-divider></ms-widget-front>\n</ms-widget><ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div class=\"pl-16 pr-8 pv-16\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h4\"><md-icon md-font-icon=\"icon-map-marker\" \nclass=\"icon mr-8\"></md-icon>{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].name}}</div><md-menu>\n<md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" md-menu-origin md-menu-align-target aria-label=\"Options\">\n<md-icon md-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" class=\"icon\"></md-icon>Refresh\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon \nmd-font-icon=\"icon-cog\" class=\"icon\"></md-icon>Settings</md-button></md-menu-item></md-menu-content></md-menu></div>\n<div class=\"p-16 pb-32\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"center center\">\n<md-icon md-font-icon=\"{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].icon}}\" class=\"icon s40 mr-16\">\n</md-icon><span class=\"md-display-2 font-weight-300 secondary-text\">\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].temp[vm.weatherWidget.tempUnit]}} </span><span \nclass=\"font-size-48 font-weight-300 hint-text text-super ml-8\">&deg;</span> <span \nclass=\"md-display-2 font-weight-300 hint-text\">{{vm.weatherWidget.tempUnit}}</span></div></div><div \nclass=\"grey-300-bg p-16\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-windy\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windSpeed[vm.weatherWidget.speedUnit]}} </span><span \nclass=\"secondary-text ml-5\">{{vm.weatherWidget.speedUnit}}</span></div><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-compass-outline\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windDirection}}</span></div><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-umbrella\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].rainProbability}}</span></div></div><div class=\"pv-16\">\n<div class=\"pv-16 ph-24\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"day in vm.weatherWidget.locations[vm.weatherWidget.currentLocation].next3Days\"><span class=\"h4\">{{day.name}}\n</span><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"mr-16\" md-font-icon=\"{{day.icon}}\" class=\"icon\">\n</md-icon><span class=\"h2\">{{day.temp[vm.weatherWidget.tempUnit]}}</span> <span \nclass=\"h2 font-weight-300 secondary-text text-super\">&deg;</span> <span class=\"h2 font-weight-300 secondary-text\">\n{{vm.weatherWidget.tempUnit}}</span></div></div></div><md-divider></md-divider></ms-widget-front></ms-widget></div>\n</md-sidenav></div>");
$templateCache.put("app/main/apps/dashboards/analytics/dashboard-analytics.html","<div id=\"dashboard-analytics\"><div id=\"widgets\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"p-24 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget1.title}}</div><div \nclass=\"text-boxed green-600-bg white-fg\">{{vm.widget1.onlineUsers}} online users</div></div><div \nclass=\"pb-32 border-bottom\"><nvd3 class=\"h-400 remove-x-lines remove-opacity\" options=\"vm.widget1.bigChart.options\" \ndata=\"vm.widget1.bigChart.data\"></nvd3></div><div layout=\"row\" layout-align=\"start center\" layout-wrap><div \nclass=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div \nlayout=\"column\" flex><div class=\"h3 secondary-text pb-8\">{{vm.widget1.sessions.title}}</div><div \nclass=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.sessions.value}}</div><div><nvd3 class=\"h-40\" \noptions=\"vm.widget1.sessions.options\" data=\"vm.widget1.sessions.data\"></nvd3></div></div></div><div \nclass=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div \nlayout=\"column\" flex><div class=\"h3 secondary-text pb-8\">{{vm.widget1.pageviews.title}}</div><div \nclass=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.pageviews.value}}</div><div><nvd3 class=\"h-40\" \noptions=\"vm.widget1.pageviews.options\" data=\"vm.widget1.pageviews.data\"></nvd3></div></div></div><div \nclass=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div \nlayout=\"column\" flex><div class=\"h3 secondary-text pb-8\">{{vm.widget1.pagesSessions.title}}</div><div \nclass=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.pagesSessions.value}}</div><div><nvd3 class=\"h-40\" \noptions=\"vm.widget1.pagesSessions.options\" data=\"vm.widget1.pagesSessions.data\"></nvd3></div></div></div><div \nclass=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div \nlayout=\"column\" flex><div class=\"h3 secondary-text pb-8\">{{vm.widget1.avgSessionDuration.title}}</div><div \nclass=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.avgSessionDuration.value}}</div><div><nvd3 class=\"h-40\" \noptions=\"vm.widget1.avgSessionDuration.options\" data=\"vm.widget1.avgSessionDuration.data\"></nvd3></div></div></div>\n</div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-md=\"65\"><ms-widget-front class=\"white-bg\"><div class=\"p-16\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget2.title}}</div><md-menu><md-button \naria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div>\n<ui-gmap-google-map center=\"vm.widget2.map.center\" zoom=\"vm.widget2.map.zoom\" options=\"vm.widget2.map.options\">\n<ui-gmap-markers models=\"vm.widget2.map.markers\" coords=\"\'coords\'\"><ui-gmap-windows show=\"show\"><div ng-non-bindable>\n{{sessions}}</div></ui-gmap-windows></ui-gmap-markers></ui-gmap-google-map></div></ms-widget-front></ms-widget>\n<ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-md=\"35\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget3.title}}</div>\n<div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget3.currentRange\" aria-label=\"Change range\">\n<md-option ng-repeat=\"(key, range) in vm.widget3.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div>\n<div class=\"ph-16 pv-20 border-bottom\" ng-repeat=\"page in vm.widget3.pages[vm.widget3.currentRange]\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" flex><span class=\"h4 pb-10\">{{page.path}}</span>\n<md-progress-linear class=\"md-accent\" md-mode=\"determinate\" value=\"{{page.value}}\"></md-progress-linear></div><div \nclass=\"pl-32 h3 font-weight-500 secondary-text\">{{page.value}}%</div></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 pt-16 pb-8 md-accent-bg\"><div class=\"h3\">{{vm.widget4.title}}</div>\n</div><md-tabs class=\"md-accent no-radius\" md-dynamic-height><md-tab label=\"{{tab.label}}\" \nng-repeat=\"tab in vm.widget4.tabs\"><div layout=\"row\" layout-align=\"start center\" layout-wrap><div flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\" ng-repeat=\"group in tab.groups\"><div class=\"h2 m-16 pb-16 border-bottom\">\n{{group.title}}</div><div class=\"p-16 pb-32\" ng-repeat=\"data in group.data\"><div class=\"pb-8\" layout=\"row\" \nlayout-align=\"space-between start\"><span class=\"h3\">{{data.title}}</span> <span \nclass=\"h3 secondary-text font-weight-500\">{{data.value}}%</span></div><md-progress-linear \nclass=\"{{data.progressColor}}\" md-mode=\"determinate\" value=\"{{data.value}}\"></md-progress-linear></div></div></div>\n</md-tab></md-tabs></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/components/charts/c3/c3.html","<div id=\"c3\" class=\"page-layout simple fullwidth doc-page chart-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">CHARTS</span></div><div \nclass=\"title\">C3.js</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"http://jettro.github.io/c3-angular-directive/\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><div \nclass=\"md-title\">Line Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"line-chart\"><chart-column \ncolumn-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" column-type=\"line\">\n<chart-column column-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" column-values=\"50,20,10,40,15,25\" \ncolumn-type=\"line\"><chart-grid show-x=\"false\" show-y=\"true\"></chart-grid></c3chart></div><div class=\"md-title\">\nLine Area Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"line-area-chart\"><chart-column \ncolumn-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" column-type=\"area\">\n<chart-column column-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" column-values=\"50,20,10,40,15,25\" \ncolumn-type=\"area\"><chart-grid show-x=\"false\" show-y=\"true\"></chart-grid></c3chart></div><div class=\"md-title\">\nSpline Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"spline-chart\"><chart-column \ncolumn-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" column-type=\"spline\">\n<chart-column column-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" column-values=\"50,20,10,40,15,25\" \ncolumn-type=\"spline\"><chart-grid show-x=\"false\" show-y=\"true\"></chart-grid></c3chart></div><div class=\"md-title\">\nSpline Area Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"spline-area-chart\"><chart-column \ncolumn-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" \ncolumn-type=\"area-spline\"><chart-column column-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" \ncolumn-values=\"50,20,10,40,15,25\" column-type=\"area-spline\"><chart-grid show-x=\"false\" show-y=\"true\"></chart-grid>\n</c3chart></div><div class=\"md-title\">Step Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart \nbindto-id=\"step-chart\"><chart-column column-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" \ncolumn-values=\"30,200,100,400,150,250\" column-type=\"step\"><chart-column column-id=\"data 2\" column-name=\"Data 2\" \ncolumn-color=\"green\" column-values=\"50,20,10,40,15,25\" column-type=\"step\"><chart-grid show-x=\"false\" show-y=\"true\">\n</chart-grid></c3chart></div><div class=\"md-title\">Step Area Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart \nbindto-id=\"step-area-chart\"><chart-column column-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" \ncolumn-values=\"30,200,100,400,150,250\" column-type=\"area-step\"><chart-column column-id=\"data 2\" column-name=\"Data 2\" \ncolumn-color=\"green\" column-values=\"50,20,10,40,15,25\" column-type=\"area-step\"><chart-grid show-x=\"false\" \nshow-y=\"true\"></chart-grid></c3chart></div><div class=\"md-title\">Stacked Bar Chart</div><div \nclass=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"stacked-bar-plot1-chart\"><chart-column column-id=\"data 1\" \ncolumn-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" column-type=\"bar\"><chart-column \ncolumn-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" column-values=\"50,20,10,40,15,25\" column-type=\"bar\">\n<chart-group group-values=\"data 1,data 2\"></c3chart></div><div class=\"md-title\">Scatter Plot Chart</div><div \nclass=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"scatter-plot2-chart\"><chart-column column-id=\"Data 1 x\" \ncolumn-values=\"3.2, 3.2, 3.1, 2.3, 2.8, 2.8, 3.3, 2.4, 2.9, 2.7, 2.0, 3.0, 2.2, 2.9, 2.9, 3.1, 3.0, 2.7, 2.2, 2.5, 3.2, 2.8, 2.5, 2.8, 2.9, 3.0, 2.8, 3.0, 2.9, 2.6, 2.4, 2.4, 2.7, 2.7, 3.0, 3.4, 3.1, 2.3, 3.0, 2.5, 2.6, 3.0, 2.6, 2.3, 2.7, 3.0, 2.9, 2.9, 2.5, 2.8\">\n<chart-column column-id=\"Data 2 x\" \ncolumn-values=\"3.3, 2.7, 3.0, 2.9, 3.0, 3.0, 2.5, 2.9, 2.5, 3.6, 3.2, 2.7, 3.0, 2.5, 2.8, 3.2, 3.0, 3.8, 2.6, 2.2, 3.2, 2.8, 2.8, 2.7, 3.3, 3.2, 2.8, 3.0, 2.8, 3.0, 2.8, 3.8, 2.8, 2.8, 2.6, 3.0, 3.4, 3.1, 3.0, 3.1, 3.1, 3.1, 2.7, 3.2, 3.3, 3.0, 2.5, 3.0, 3.4, 3.0\">\n<chart-column column-id=\"Data 1\" \ncolumn-values=\"1.4, 1.5, 1.5, 1.3, 1.5, 1.3, 1.6, 1.0, 1.3, 1.4, 1.0, 1.5, 1.0, 1.4, 1.3, 1.4, 1.5, 1.0, 1.5, 1.1, 1.8, 1.3, 1.5, 1.2, 1.3, 1.4, 1.4, 1.7, 1.5, 1.0, 1.1, 1.0, 1.2, 1.6, 1.5, 1.6, 1.5, 1.3, 1.3, 1.3, 1.2, 1.4, 1.2, 1.0, 1.3, 1.2, 1.3, 1.3, 1.1, 1.3\" \ncolumn-type=\"scatter\"><chart-column column-id=\"Data 2\" \ncolumn-values=\"2.5, 1.9, 2.1, 1.8, 2.2, 2.1, 1.7, 1.8, 1.8, 2.5, 2.0, 1.9, 2.1, 2.0, 2.4, 2.3, 1.8, 2.2, 2.3, 1.5, 2.3, 2.0, 2.0, 1.8, 2.1, 1.8, 1.8, 1.8, 2.1, 1.6, 1.9, 2.0, 2.2, 1.5, 1.4, 2.3, 2.4, 1.8, 1.8, 2.1, 2.4, 2.3, 1.9, 2.3, 2.5, 2.3, 1.9, 2.0, 2.3, 1.8\" \ncolumn-type=\"scatter\"><chart-axes values-xs=\"Data 1:Data 1 x,Data 2:Data 2 x\"></c3chart></div><div class=\"md-title\">\nPie Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"pie-plot1-chart\"><chart-column \ncolumn-id=\"Data 1\" column-values=\"70\" column-type=\"pie\"><chart-column column-id=\"Data 2\" column-values=\"35\" \ncolumn-type=\"pie\"><chart-column column-id=\"Data 3\" column-values=\"60\" column-type=\"pie\"><chart-pie expand=\"true\">\n</c3chart></div><div class=\"md-title\">Donut Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart \nbindto-id=\"donut-plot1-chart\"><chart-column column-id=\"Data 1\" column-values=\"70\" column-type=\"donut\"><chart-column \ncolumn-id=\"Data 2\" column-values=\"35\" column-type=\"donut\"><chart-column column-id=\"Data 3\" column-values=\"60\" \ncolumn-type=\"donut\"><chart-donut title=\"Donut\" width=\"60\"></c3chart></div><div class=\"md-title\">Gauge Chart</div><div \nclass=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"gauge-plot1-chart\"><chart-column column-id=\"Data 1\" \ncolumn-values=\"70\" column-type=\"gauge\"><chart-gauge min=\"50\" max=\"75\" units=\" hours\" width=\"39\"></c3chart></div></div>\n</div>");
$templateCache.put("app/main/components/charts/chart-js/chart-js.html","<div id=\"chartJs\" class=\"page-layout simple fullwidth doc-page chart-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">CHARTS</span></div><div \nclass=\"title\">Chart.js</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"https://github.com/jtblin/angular-chart.js\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><div \nclass=\"md-title\">Line Chart</div><div class=\"card md-whiteframe-4dp\"><canvas id=\"line\" class=\"chart chart-line\" \nchart-data=\"vm.lineChart.data\" chart-labels=\"vm.lineChart.labels\" chart-legend=\"true\" \nchart-series=\"vm.lineChart.series\"></canvas></div><div class=\"md-title\">Bar Chart</div><div \nclass=\"card md-whiteframe-4dp\"><canvas id=\"bar\" class=\"chart chart-bar\" chart-data=\"vm.barChart.data\" \nchart-labels=\"vm.barChart.labels\"></canvas></div><div class=\"md-title\">Doughnut Chart</div><div \nclass=\"card md-whiteframe-4dp\"><canvas id=\"doughnut\" class=\"chart chart-doughnut\" chart-data=\"vm.doughnutChart.data\" \nchart-labels=\"vm.doughnutChart.labels\"></canvas></div><div class=\"md-title\">Radar Chart</div><div \nclass=\"card md-whiteframe-4dp\"><canvas id=\"radar\" class=\"chart chart-radar\" chart-data=\"vm.radarChart.data\" \nchart-labels=\"vm.radarChart.labels\"></canvas></div><div class=\"md-title\">Pie Chart</div><div \nclass=\"card md-whiteframe-4dp\"><canvas id=\"pie\" class=\"chart chart-pie\" chart-data=\"vm.pieChart.data\" \nchart-labels=\"vm.pieChart.labels\"></canvas></div><div class=\"md-title\">Polar Area Chart</div><div \nclass=\"card md-whiteframe-4dp\"><canvas id=\"polar-area\" class=\"chart chart-polar-area\" chart-data=\"vm.polarChart.data\" \nchart-labels=\"vm.polarChart.labels\"></canvas></div></div></div>");
$templateCache.put("app/main/components/charts/chartist/chartist.html","<div id=\"chartist\" class=\"page-layout simple fullwidth doc-page chart-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">CHARTS</span></div><div \nclass=\"title\">Chartist</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"https://github.com/paradox41/angular-chartist.js\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><div \nclass=\"md-title\">Line Chart</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" \nchartist-data=\"vm.lineChart.data\" chartist-chart-type=\"Line\" chartist-chart-options=\"vm.lineChart.options\"></chartist>\n</div><div class=\"md-title\">Line Area Chart</div><div class=\"card md-whiteframe-4dp\"><chartist \nclass=\"ct-chart ct-golden-section\" chartist-data=\"vm.lineAreaChart.data\" chartist-chart-type=\"Line\" \nchartist-chart-options=\"vm.lineAreaChart.options\"></chartist></div><div class=\"md-title\">\nBi-polar Line Chart With Area Only</div><div class=\"card md-whiteframe-4dp\"><chartist \nclass=\"ct-chart ct-golden-section\" chartist-data=\"vm.biPolarLineChart.data\" chartist-chart-type=\"Line\" \nchartist-chart-options=\"vm.biPolarLineChart.options\"></chartist></div><div class=\"md-title\">Bar Chart</div><div \nclass=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.barChart.data\" \nchartist-chart-type=\"Bar\" chartist-chart-options=\"vm.barChart.options\" \nchartist-responsive-options=\"vm.barChart.responsiveOptions\"></chartist></div><div class=\"md-title\">Horizontal Bar Chart\n</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" \nchartist-data=\"vm.horizontalBarChart.data\" chartist-chart-type=\"Bar\" \nchartist-chart-options=\"vm.horizontalBarChart.options\"></chartist></div><div class=\"md-title\">Bi-polar Bar Chart</div>\n<div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" \nchartist-data=\"vm.biPolarBarChart.data\" chartist-chart-type=\"Bar\" chartist-chart-options=\"vm.biPolarBarChart.options\">\n</chartist></div><div class=\"md-title\">Stacked Bar Chart</div><div class=\"card md-whiteframe-4dp\"><chartist \nclass=\"ct-chart ct-golden-section\" chartist-data=\"vm.stackedBarChart.data\" chartist-chart-type=\"Bar\" \nchartist-chart-options=\"vm.stackedBarChart.options\" chartist-events=\"vm.stackedBarChart.events\"></chartist></div><div \nclass=\"md-title\">Doughnut Chart</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" \nchartist-data=\"vm.donutChart.data\" chartist-chart-type=\"Pie\" chartist-chart-options=\"vm.donutChart.options\"></chartist>\n</div><div class=\"md-title\">Pie Chart</div><div class=\"card md-whiteframe-4dp\"><chartist \nclass=\"ct-chart ct-golden-section\" chartist-data=\"vm.pieChart.data\" chartist-chart-type=\"Pie\" \nchartist-chart-options=\"vm.pieChart.options\" chartist-responsive-options=\"vm.pieChart.responsiveOptions\"></chartist>\n</div><div class=\"md-title\">Gauge Chart</div><div class=\"card md-whiteframe-4dp\"><chartist \nclass=\"ct-chart ct-golden-section\" chartist-data=\"vm.gaugeChart.data\" chartist-chart-type=\"Pie\" \nchartist-chart-options=\"vm.gaugeChart.options\"></chartist></div></div></div>");
$templateCache.put("app/main/components/charts/nvd3/nvd3.html","<div id=\"nvd3\" class=\"page-layout simple fullwidth doc-page chart-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">CHARTS</span></div><div \nclass=\"title\">nvD3</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"http://krispo.github.io/angular-nvd3/#/\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><div \nclass=\"md-title\">Line Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.lineChart.options\" \ndata=\"vm.lineChart.data\" class=\"with-3d-shadow with-transitions\"></nvd3></div><div class=\"md-title\">Stacked Area Chart\n</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.stackedAreaChart.options\" data=\"vm.stackedAreaChart.data\">\n</nvd3></div><div class=\"md-title\">Sparkline Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 \noptions=\"vm.sparklineChart.options\" data=\"vm.sparklineChart.data\"></nvd3></div><div class=\"md-title\">\nHistorical Bar Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.historicalBarChart.options\" \ndata=\"vm.historicalBarChart.data\"></nvd3></div><div class=\"md-title\">Multi Bar Horizontal Chart</div><div \nclass=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.multiBarHorizontalChart.options\" \ndata=\"vm.multiBarHorizontalChart.data\"></nvd3></div><div class=\"md-title\">Pie Chart</div><div \nclass=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.pieChart.options\" data=\"vm.pieChart.data\"></nvd3></div><div \nclass=\"md-title\">Donut Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.donutChart.options\" \ndata=\"vm.donutChart.data\"></nvd3></div><div class=\"md-title\">Bullet Chart</div><div class=\"card md-whiteframe-4dp\">\n<nvd3 options=\"vm.bulletChart.options\" data=\"vm.bulletChart.data\"></nvd3></div><div class=\"md-title\">Scatter Chart\n</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.scatterChart.options\" data=\"vm.scatterChart.data\"></nvd3>\n</div></div></div>");
$templateCache.put("app/main/components/material-docs/demo/docs-demo.tmpl.html","<div class=\"doc-demo-content doc-content\"><div flex layout=\"column\" style=\"z-index:1\"><div class=\"doc-description\" \nng-bind-html=\"demoCtrl.demoDescription.contents | toHtml\"></div><div ng-transclude></div><section \nclass=\"demo-container md-whiteframe-z1\" ng-class=\"{\'show-source\': demoCtrl.$showSource}\"><md-toolbar \nclass=\"demo-toolbar md-primary\"><div class=\"md-toolbar-tools\"><h3>{{demoCtrl.demoTitle}}</h3><span flex></span>\n<md-button class=\"md-icon-button\" aria-label=\"View Source\" ng-class=\"{ active: demoCtrl.$showSource }\" \nng-click=\"demoCtrl.$showSource = !demoCtrl.$showSource\"><md-tooltip md-autohide>View Source</md-tooltip><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_code_24px.svg\"></md-icon></md-button></div></md-toolbar>\n<md-tabs class=\"demo-source-tabs md-primary\" md-dynamic-height ng-show=\"demoCtrl.$showSource\"><md-tab \nng-repeat=\"file in demoCtrl.orderedFiles\" label=\"{{file.name}}\"><md-content md-scroll-y class=\"demo-source-container\">\n<hljs class=\"no-header\" code=\"file.contentsPromise\" lang=\"{{file.fileType}}\" \nshould-interpolate=\"demoCtrl.interpolateCode\"></hljs></md-content></md-tab></md-tabs><demo-include \nfiles=\"demoCtrl.files\" module=\"demoCtrl.demoModule\" class=\"{{demoCtrl.demoId}}\"></demo-include></section></div></div>");
$templateCache.put("app/main/ui/page-layouts/blank/blank.html","<div class=\"page-layout blank\" layout=\"row\"><h2>Blank page</h2></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-card.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span></div><div \nclass=\"title\">ms-card</div></div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><p>\n                <hljs language=\"html\" class=\"source-code\">\n                    <ms-card template=\"PATH_TO_TEMPLATE\" ng-model=\"CARD_MODEL_DATA\"></ms-card>\n                </hljs>\n                </p><span class=\"h2 pt-16\">Description:</span><p><b>ms-card</b>\n directive can be used for creating cards that follow Google\'s Material Design specifications. Currently it has 10 different pre-defined templates but you can always create your own templates and use them with the directive.\n</p><div class=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\"><thead><tr><th>Attribute</th><th>\nDescription</th></tr></thead><tbody><tr><td>template</td><td>\nThis attribute must be present in order to ms-card directive to work. It works similar to ng-include directive. You can either provide the path of the html template file or the variable that holds the path of the html template file.\n</td></tr><tr><td>ng-model</td><td>\nDirective uses ng-model to hold the card data. Data passed with using ng-model will be available in the template files within variable named card.\n</td></tr></tbody></table></div><span class=\"h2 pt-16\">Example:</span>\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-card template=\"\'app/card-templates/my-custom-template.html\'\" ng-model=\"vm.cardModel\"></ms-card>\n            </hljs>\n            <p>\nAbove directive will use <span class=\"text-boxed\">my-custom-template.html</span>\n file as a template. And you will be able to access to the <span class=\"text-boxed\">vm.cardModel</span>\n object through card variable inside the template.</p><p>Consider the following object:\n                <hljs language=\"js\" class=\"source-code\">\n                    vm.cardModel = {\n                        title      : \'My Card\',\n                        description: \'My card description\'\n                    }\n                </hljs>\n                \n</p><p>It will be available in the template file as:\n                <hljs language=\"js\" class=\"source-code\">\n                    card = {\n                        title      : \'My Card\',\n                        description: \'My card description\'\n                    }\n                </hljs>\n                </p><p>\nSo you will be able to access the title by doing\n                <hljs language=\"js\" class=\"source-code\">\n                    {{card.title}}\n                </hljs>\n                 inside the template file.</p></div>\n</div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-form-wizard.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-form-wizard</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><span class=\"h2 pt-16\">Description:</span><p>\nms-form-wizard directive is a helper directive that will help you to create form wizards. Combined with <b>md-tabs</b>\n and <b>form</b> elements, you will be able to create as much as steps you want.</p><span class=\"h2 pt-16\">Example:\n</span>\n            <hljs language=\"html\" class=\"source-code\">\n\n                <ms-form-wizard flex>\n                    <md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\">\n                        <md-tab>\n                            <md-tab-label>\n                            <span class=\"ms-form-wizard-step-label\">\n                                <span class=\"ms-form-wizard-step-number md-accent-bg\"\n                                      ng-if=\"wizardStep1.$invalid\">1</span>\n                                <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\">\n                                    <i class=\"icon-check s16\"></i>\n                                </span>\n                                <span class=\"ms-form-wizard-step-text\">Personal Information</span>\n                            </span>\n                            </md-tab-label>\n\n                            <md-tab-body>\n                                <form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate>\n                                    <div layout=\"column\" layout-gt-xs=\"row\" flex>\n                                        <md-input-container flex=\"100\" flex-gt-xs=\"50\">\n                                            <input type=\"text\" name=\"firstname\" ng-model=\"vm.formWizard.firstname\"\n                                                   placeholder=\"Firstname\"\n                                                   required>\n                                            <div ng-messages=\"wizardStep1.firstname.$error\"\n                                                 ng-show=\"wizardStep1.firstname.$touched\"\n                                                 role=\"alert\">\n                                                <div ng-message=\"required\">\n                                                    <span>Firstname field is required.</span>\n                                                </div>\n                                            </div>\n                                        </md-input-container>\n                                    </div>\n                                </form>\n                            </md-tab-body>\n                        </md-tab>\n\n                        <md-tab ng-disabled=\"wizardStep1.$invalid\">\n                            <md-tab-label>\n                            <span class=\"ms-form-wizard-step-label\">\n                                <span class=\"ms-form-wizard-step-number md-accent-bg\"\n                                      ng-if=\"wizardStep2.$invalid\">2</span>\n                                <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\">\n                                    <i class=\"icon-check s16\"></i>\n                                </span>\n                                <span class=\"ms-form-wizard-step-text\">Address</span>\n                            </span>\n                            </md-tab-label>\n\n                            <md-tab-body>\n                                <form name=\"wizardStep2\" ms-form-wizard-form novalidate>\n                                    <md-input-container class=\"md-block\">\n                                        <label>Address</label>\n                                    <textarea ng-model=\"vm.formWizard.address\" columns=\"1\" md-maxlength=\"150\"\n                                              rows=\"5\" required></textarea>\n                                        <div ng-messages=\"wizardStep2.address.$error\"\n                                             ng-show=\"wizardStep2.address.$touched\"\n                                             role=\"alert\" multiple>\n                                            <div ng-message=\"required\"><span>Address field is required.</span></div>\n                                            <div ng-message=\"md-maxlength\">\n                                                <span>Address can\'t be longer than 150 characters.</span>\n                                            </div>\n                                        </div>\n                                    </md-input-container>\n                                </form>\n                            </md-tab-body>\n                        </md-tab>\n\n                        <md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\">\n                            <md-tab-label>\n                            <span class=\"ms-form-wizard-step-label\">\n                                <span class=\"ms-form-wizard-step-number md-accent-bg\"\n                                      ng-if=\"wizardStep3.$invalid\">3</span>\n                                <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\">\n                                    <i class=\"icon-check s16\"></i>\n                                </span>\n                                <span class=\"ms-form-wizard-step-text\">Payment Method</span>\n                            </span>\n                            </md-tab-label>\n                            <md-tab-body>\n                                <form name=\"wizardStep3\" ms-form-wizard-form novalidate>\n                                    <md-input-container class=\"md-block\">\n                                        <input type=\"text\" name=\"cardholder\" ng-model=\"vm.formWizard.cardholder\"\n                                               placeholder=\"Card Holder\"\n                                               required>\n                                        <div ng-messages=\"wizardStep3.cardholder.$error\"\n                                             ng-show=\"wizardStep3.cardholder.$dirty\"\n                                             role=\"alert\">\n                                            <div ng-message=\"required\">\n                                                <span>Card holder field is required.</span>\n                                            </div>\n                                        </div>\n                                    </md-input-container>\n                                </form>\n                            </md-tab-body>\n                        </md-tab>\n                    </md-tabs>\n\n                    <div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\">\n                        <md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\"\n                                   ng-disabled=\"msWizard.isFirstStep()\">\n                            Previous\n                        </md-button>\n                        <div class=\"steps\">\n                        <span ng-repeat=\"form in msWizard.forms\"\n                              ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span>\n                        </div>\n                        <md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\"\n                                   ng-hide=\"msWizard.isLastStep()\"\n                                   ng-disabled=\"msWizard.currentStepInvalid()\">\n                            Next\n                        </md-button>\n                        <md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm(); msWizard.resetForm();\" ng-show=\"msWizard.isLastStep()\"\n                                   ng-disabled=\"msWizard.formsIncomplete()\">\n                            Send\n                        </md-button>\n                    </div>\n\n                </ms-form-wizard>\n\n            </hljs>\n            <p>For more detailed usage, we recommend you to check <b>Forms</b>\n page from our demo application.</p></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-info-bar.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-info-bar</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-info-bar>\n                    <div layout=\"row\" layout-align=\"start center\">\n                        <div class=\"white-fg\" flex hide-xs>\n                            We use cookies to ensure that we give you the best experience on our website. If you\n                            continue without changing your settings, we\'ll assume that you are happy to receive all\n                            cookies from this website.\n                        </div>\n                        <md-button class=\" md-raised\" layout=\"row\" layout-align=\"center center\" target=\"_blank\"\n                                   href=\"#\">\n                            <md-icon md-font-icon=\"icon-cart\" class=\"mr-5 s18\"></md-icon>\n                            <span>Accept</span></md-button>\n                    </div>\n                </ms-info-bar>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-info-bar</b>\n is a helper directive that you can use to show information about your app. On close, its scope will be automatically destroyed.\n</p></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-masonry.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-masonry</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><span class=\"h2 pt-16\">Description:</span><p><b>ms-masonry</b>\n is a directive that you can use to create Masonry layouts. You can use following options to configure the directive:\n</p>\n            <hljs language=\"js\" class=\"source-code\">\n                vm.masonryOptions = {\n                    columnCount     : 5,\n                    respectItemOrder: false,\n                    reLayoutDebounce: 400,\n                    responsive      : {\n                        md: 3,\n                        sm: 2,\n                        xs: 1\n                    }\n                }\n            </hljs>\n             <span class=\"h2 pt-16\">Options:</span><div \nclass=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\"><thead><tr><th>Options</th><th>Description\n</th></tr></thead><tbody><tr><td>columnCount</td><td>\n(integer) Column count defines the maximum column count of your masonry layout. ms-masonry will adjust the column count automatically based on \n<b>responsive</b> options and some other calculations.</td></tr><tr><td>respectItemOrder</td><td>\n(boolean) Defaults to false to allow classical masonry behaviour, setting it to true enforces that masonry items are kept in order, allowing consistent positioning.\n</td></tr><tr><td>reLayoutDebounce</td><td>\n(integer) Debounce amount in milliseconds before reLayout can happen. This will prevent reLayout action from happening too much if you are resizing your screen or the device rotation is being changed.\n</td></tr><tr><td>responsive</td><td>\n(object) You can define column counts for individual Angular Material media step definitions.</td></tr></tbody></table>\n</div><span class=\"h2 pt-16\">Example:</span><p>\n                <hljs language=\"js\" class=\"source-code\">\n                    <ms-masonry options=\"vm.masonryOptions\">\n                        <ms-masonry-item></ms-masonry-item>\n                        <ms-masonry-item></ms-masonry-item>\n                        <ms-masonry-item></ms-masonry-item>\n                        ...\n                    </ms-masonry>\n                </hljs>\n                </p></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-material-color-picker.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-material-color-picker</div></div><div class=\"content\" layout=\"column\"><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><span class=\"h2 pt-16\">Description:</span><p><b>ms-material-color-picker\n</b> directive allows you to pick any of the Material Design colors.</p><span class=\"h2 pt-16\">Options:</span><div \nclass=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\"><thead><tr><th>Options</th><th>Description\n</th></tr></thead><tbody><tr><td>ms-model-type</td><td>\n(string) Model type of the color picker. Can be either `class` or `obj`</td></tr><tr><td>ng-model (required)</td><td>\nValue that will be updated on color pick</td></tr></tbody></table></div><span class=\"h2 pt-16\">Example:</span><p>\nDepending on <b>ms-model-type</b>\n value, color picker will either update the model with the appropriate class name or the object:</p>\n\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-material-color-picker ms-model-type=\"obj\" ng-model=\"vm.color\"></ms-material-color-picker>\n            </hljs>\n            <p>\nYou can also use transclusion to trigger the picker. Like in the below example, you can add a button or any other element to trigger the picker:\n</p>\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-material-color-picker ms-model-type=\"obj\" ng-model=\"vm.color\">\n                    <md-button>Select a Color</md-button>\n                </ms-material-color-picker>\n            </hljs>\n            <p><b>$selectedColor</b>\n variable can be used within the color picker element to access the properties of the selected color:</p>\n\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-material-color-picker ms-model-type=\"obj\" ng-model=\"vm.color\">\n                    <md-button class=\"{{$selectedColor}}\">Select a Color</md-button>\n                </ms-material-color-picker>\n            </hljs>\n            </div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-nav.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-nav</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><p class=\"note\"><b>Note:</b> This directive is deprecated. Use <b>ms-navigation</b> instead.</p><span \nclass=\"h2 pt-16\">Description:</span><p>\nNavigation directive has couple other dependent directives. They all together used for creating the main navigation. \n<b>ms-nav</b> directive is compatible with Angular UI Router module.</p><span class=\"h2 pt-16\">Example:</span>\n\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-nav>\n\n                    <ms-nav-item ms-nav-title>\n                        <span>FUSE</span>\n                    </ms-nav-item>\n\n                    <ms-nav-item ms-nav-toggle>\n\n                        <a ms-nav-button md-ink-ripple>\n                            <i class=\"icon-tile-four s16\"></i>\n                            <span class=\"ms-nav-label\" translate=\"NAVIGATION.DASHBOARDS\">Dashboards</span>\n                            <i class=\"icon-chevron-down s16 arrow\"></i>\n                        </a>\n\n                        <ms-nav-toggle-items>\n                            <ms-nav-item>\n                                <a ms-nav-button ui-sref=\"app.dashboard-v1\" ui-sref-active=\"active\" md-ink-ripple>\n                                    <span class=\"ms-nav-label\">Dashboard v1</span>\n                                </a>\n                            </ms-nav-item>\n\n                            <ms-nav-item>\n                                <a ms-nav-button ui-sref=\"app.dashboard-v2\" ui-sref-active=\"active\" md-ink-ripple>\n                                    <span class=\"ms-nav-label\">Dashboard v2</span>\n                                </a>\n                            </ms-nav-item>\n                        </ms-nav-toggle-items>\n\n                    </ms-nav-item>\n\n                </ms-nav>\n            </hljs>\n            </div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-navigation.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-navigation</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><p>\n                <hljs language=\"js\" class=\"source-code\">\n                    msNavigationService.saveItem(\'NAVIGATION.ID\', {NAVIGATION_OPTIONS});\n                </hljs>\n                </p><span class=\"h2 pt-16\">Description:</span><p>\nSince version 1.2.0, Fuse no longer uses html based navigation. This way, you can add, update or remove navigation items at anytime from anywhere. To create navigation items, you can use Angular\'s \n<b>run</b> or <b>config</b> blocks as well as <b>services</b> and <b>controllers</b>.</p><p><b>ms-navigation</b>\n directive works parallel with <b>msNavigationService</b> and there are two main navigation styles: <b>Vertical</b>\n and <b>Horizontal</b>. The preferred style can be used by changing the layout of the template.</p><p>\nTo create a navigation item, you have to use either <b>msNavigationService</b> or <b>msNavigationServiceProvider</b>.\n</p><p class=\"mt-24\">Calling <b>saveItem</b> on <em>msNavigationService</em> or <em>msNavigationServiceProvider</em>\n will either create a menu item, or update an existing one. This way you can update any existing menu item at any times by simply referring to it by using its id.\n</p><span class=\"h2 pt-16\">Navigation Id:</span><p>\nNavigation id is a simple string that uses \"dot notation\" to create the hierarchy between the navigation items. For example, if you want to have a \"Post Blog\" navigation item under \"Blog\" navigation item, you should have \"blog.post-blog\" as the id of the navigation.\n</p><p>\nTo create a navigation item, you don\'t have to create its parent(s). If you create a navigation item by using \"dashboard.project\" id, the navigation item with the \"dashboard\" id will be automatically created for you. Then you can simply update the \"dashboard\" navigation item to change its options.\n</p><span class=\"h2 pt-16\">Navigation Options:</span><div class=\"simple-table-container md-whiteframe-1dp mv-16\"><table\n class=\"simple\"><thead><tr><th>Options</th><th>Description</th></tr></thead><tbody><tr><td>title</td><td>\n(string) Title of the navigation item</td></tr><tr><td>group</td><td>\n(bool) Determines if the navigation item is going to be used for grouping</td></tr><tr><td>icon</td><td>\n(string) Icon class name of the navigation item</td></tr><tr><td>state</td><td>\n(string) UI-Router state name for the navigation item to be linked</td></tr><tr><td>stateParams</td><td>\n(object) UI-Router state parameters</td></tr><tr><td>translate</td><td>\n(string) angular-translate translation object id (e.g. \"NAVIGATION.MAIL\")</td></tr><tr><td>class</td><td>\n(string) Custom class name(s) to be applied to the navigation item</td></tr><tr><td>badge</td><td>\n(object) Badge to show in navigation item</td></tr><tr><td>weight</td><td>\n(int) Determines the sort order of the navigation item</td></tr><tr><td>hidden</td><td>\n(function) Determines the visibility of the menu item. The function must return a <b>boolean</b> value.</td></tr>\n</tbody></table></div><span class=\"h2 pt-16\">Example:</span><p>To create a navigation item from <b>Run</b> or <b>Config\n</b> blocks, you must use <b>msNavigationServiceProvider</b>:</p>\n            <hljs language=\"js\" class=\"source-code\">\n                /** @ngInject */\n                function config(msNavigationServiceProvider)\n                {\n                    // Navigation\n                    msNavigationServiceProvider.saveItem(\'apps\', {\n                        title : \'APPS\',\n                        group : true,\n                        weight: 1\n                    });\n\n                    // Apps.Dashboards\n                    msNavigationServiceProvider.saveItem(\'apps.dashboards\', {\n                        title : \'Dashboards\',\n                        icon  : \'icon-tile-four\',\n                        class : \'navigation-dashboards\',\n                        weight: 1\n                    });\n\n                    // Apps.Dashboards.Project\n                    msNavigationServiceProvider.saveItem(\'apps.dashboards.project\', {\n                        title      : \'Project\',\n                        state      : \'app.dashboards_project\',\n                        stateParams: {\'id\': 1},\n                        badge      : {\n                            content: \'21\',\n                            color  : \'red\'\n                        },\n                        translate  : \'NAVIGATION.DASHBOARDS.PROJECT\',\n                        class      : \'navigation-dashboards project-dashboard\',\n                        weight     : 1\n                    });\n\n                    // Apps.Dashboards.Server\n                    msNavigationServiceProvider.saveItem(\'apps.dashboards.server\', {\n                        title      : \'Server\',\n                        state      : \'app.dashboards_server\',\n                        stateParams: {\'id\': 1},\n                        translate  : \'NAVIGATION.DASHBOARDS.SERVER\',\n                        class      : \'navigation-dashboards server-dashboard\',\n                        weight     : 2\n                    });\n\n                    // Apps.Dashboards.Analytics\n                    msNavigationServiceProvider.saveItem(\'apps.dashboards.analytics\', {\n                        title      : \'Analytics\',\n                        state      : \'app.dashboards_analytics\',\n                        stateParams: {\'id\': 1},\n                        translate  : \'NAVIGATION.DASHBOARDS.ANALYTICS\',\n                        class      : \'navigation-dashboards analytics-dashboard\',\n                        weight     : 3\n                    });\n                }\n            </hljs>\n            <p class=\"mt-24\">\nTo do the same thing in <b>services</b> and <b>controllers</b>, you must use <b>msNavigationService</b>:</p>\n\n            <hljs language=\"js\" class=\"source-code\">\n                /** @ngInject */\n                function TestController(msNavigationService)\n                {\n                    // Navigation\n                    msNavigationService.saveItem(\'apps\', {\n                        title : \'APPS\',\n                        group : true,\n                        weight: 1\n                    });\n\n                    // Apps.Dashboards\n                    msNavigationService.saveItem(\'apps.dashboards\', {\n                        title : \'Dashboards\',\n                        icon  : \'icon-tile-four\',\n                        class : \'navigation-dashboards\',\n                        weight: 1\n                    });\n\n                    // Apps.Dashboards.Project\n                    msNavigationService.saveItem(\'apps.dashboards.project\', {\n                        title      : \'Project\',\n                        state      : \'app.dashboards_project\',\n                        stateParams: {\'id\': 1},\n                        badge      : {\n                            content: \'21\',\n                            color  : \'red\'\n                        },\n                        translate  : \'NAVIGATION.DASHBOARDS.PROJECT\',\n                        class      : \'navigation-dashboards project-dashboard\',\n                        weight     : 1\n                    });\n\n                    // Apps.Dashboards.Server\n                    msNavigationService.saveItem(\'apps.dashboards.server\', {\n                        title      : \'Server\',\n                        state      : \'app.dashboards_server\',\n                        stateParams: {\'id\': 1},\n                        translate  : \'NAVIGATION.DASHBOARDS.SERVER\',\n                        class      : \'navigation-dashboards server-dashboard\',\n                        weight     : 2\n                    });\n\n                    // Apps.Dashboards.Analytics\n                    msNavigationService.saveItem(\'apps.dashboards.analytics\', {\n                        title      : \'Analytics\',\n                        state      : \'app.dashboards_analytics\',\n                        stateParams: {\'id\': 1},\n                        translate  : \'NAVIGATION.DASHBOARDS.ANALYTICS\',\n                        class      : \'navigation-dashboards analytics-dashboard\',\n                        weight     : 3\n                    });\n                }\n            </hljs>\n            <p class=\"mt-24\">\nYou can specify a hidden value within your navigation item configuration to have more control on its visibility. It accepts a function and that function must return a boolean value.\n</p><p>\nms-navigation will watch that function and whenever the AuthService.isAdmin value changes, the visibility of the navigation item will be updated automatically.\n</p>\n            <hljs language=\"js\" class=\"source-code\">\n                /** @ngInject */\n                function TestController(msNavigationService)\n                {\n                    // Navigation\n                    msNavigationService.saveItem(\'apps\', {\n                        title : \'APPS\',\n                        group : true,\n                        weight: 1\n                    });\n\n                    // Apps.Dashboards\n                    msNavigationService.saveItem(\'apps.dashboards\', {\n                        title : \'Dashboards\',\n                        icon  : \'icon-tile-four\',\n                        class : \'navigation-dashboards\',\n                        hidden: function ()\n                        {\n                            return AuthService.isAdmin; // must be a boolean value\n                        },\n                        weight: 1\n                    });\n                }\n            </hljs>\n            <p class=\"mt-24\">\nIf you wish to remove an item from the navigation at runtime, you can use deleteItem() method. It\'s available in both \n<b>msNavigationService</b> and <b>msNavigationServiceProvider</b>:</p>\n            <hljs language=\"js\" class=\"source-code\">\n                /** @ngInject */\n                function TestController(msNavigationService)\n                {\n                    // Delete the \'apps\' item\n                    msNavigationService.deleteItem(\'apps\');\n                }\n            </hljs>\n             <span \nclass=\"h2 pt-16\">Directive:</span><p>To show the navigation, you can use <b>ms-navigation</b> element:</p>\n\n            <hljs lang=\"html\" class=\"source-code\">\n                <ms-navigation class=\"scrollable\" folded=\"vm.folded\" root=\"apps.dashboards\"></ms-navigation>\n            </hljs>\n            <div class=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\">\n<thead><tr><th>Options</th><th>Description</th></tr></thead><tbody><tr><td>folded</td><td>\n(boolean) Sets the initial folded status of the navigation</td></tr><tr><td>root</td><td>\n(string) You can specify the root item key in here to make navigation to show only certain navigation group. This might be useful if you are showing different menu groups to different users or using Fuse as both front and backend apps.\n</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-random-class.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-random-class</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <div ms-random-class=\"vm.colors\"></div>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-random-class</b>\n directive can be used for adding randomly selected class from an array. It\'s used mainly for generating random background colors in the template, but you can use it anywhere if you find it useful.\n</p><div class=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\"><thead><tr><th>Attribute</th><th>\nDescription</th></tr></thead><tbody><tr><td>ms-random-class</td><td>\n(Array) This attribute must be present in order to ms-random-class directive to work.</td></tr></tbody></table></div>\n<span class=\"h2 pt-16\">Example:</span>\n            <hljs language=\"js\" class=\"source-code\">\n                vm.colors = [\n                    \'yellow\',\n                    \'red\',\n                    \'blue\',\n                    \'orange\',\n                    \'green\'\n                ]\n            </hljs>\n            \n            <hljs language=\"html\" class=\"source-code\">\n                <div ms-random-class=\"vm.colors\"></div>\n            </hljs>\n            </div></div>\n</div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-responsive-table.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-responsive-table</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <table class=\"simple\" ms-responsive-table>\n                    <!-- Table content -->\n                </table>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-responsive-table\n</b>\n directive is useful for making tables responsive. It will simply add a scrollable wrapper around the table to make them usable in smaller screens.\n</p></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-scroll.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-scroll</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <div ms-scroll>\n                    <!-- Some long content -->\n                </div>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-scroll</b>\n directive can be used for adding custom scrollbars to the scrollable content. Fuse uses <a \nhref=\"https://github.com/noraesae/perfect-scrollbar\" target=\"_blank\">Perfect Scrollbar</a>\n as a custom scrollbar. You can also use this directive with <em>scrollable</em> helper class. <em>scrollable</em>\n class will make any content scrollable and then you can add custom scrollbars by adding <b>ms-scroll</b>\n directive to the same element:</p>\n            <hljs language=\"html\" class=\"source-code\">\n                <div class=\"scrollable\" ms-scroll>\n                    <!-- Some long content -->\n                </div>\n            </hljs>\n            </div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-search-bar.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-search-bar</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-search-bar></ms-search-bar>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-search-bar</b>\n is an autocomplete supported search bar directive. It has various options and events for you to use.</p><span \nclass=\"h2 pt-16\">Options:</span><div class=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\">\n<thead><tr><th>Options</th><th>Description</th></tr></thead><tbody><tr><td>debounce</td><td>\n(integer) Model update debounce. Can be used to stop triggering the on-search event for every keystroke.</td></tr><tr>\n<td>on-search</td><td>\n(function (query)) A callback function that will trigger on model update. Must return an Array or a Promise object that caries an Array. Has \'query\' parameter to access the search query.\n</td></tr><tr><td>on-result-click</td><td>\n(function (item)) A callback function that will trigger on search result click. Has \'item\' parameter to access the clicked item.\n</td></tr><tr><td>on-expand</td><td>(function) A callback function that will trigger when search bar expanded.</td>\n</tr><tr><td>on-collapse</td><td>(function) A callback function that will trigger when search bar collapsed.</td></tr>\n</tbody></table></div><span class=\"h2 pt-16\">Example:</span>\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar>\n            </hljs>\n            </div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-shortcuts.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-shortcuts</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><span class=\"h2 pt-16\">Description:</span><p><b>ms-shortcuts</b>\n is a directive that you can use to add shortcuts for navigation items. It works in parallel with <b>ms-navigation</b>\n directive to get its data. It has built in search, add and remove shortcut functions.</p><span class=\"h2 pt-16\">\nExample:</span>\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-shortcuts></ms-shortcuts>\n            </hljs>\n            </div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-sidenav-helper.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-sidenav-helper</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <md-sidenav class=\"sidenav\" md-component-id=\"main-sidenav\" ms-scroll ms-sidenav-helper>\n                    <!-- Sidenav Content -->\n                </md-sidenav>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-sidenav-helper\n</b> directive is required if you use sidenavs inside the page content. You can check out the <em>\napp/main/ui/layouts/simple/left-sidenav/left-sidenav.html</em> file for the simple usage.</p><p>\nSimply, this directive will add a class to the certain elements in order to page and the sidenav act correctly on all devices.\n</p></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-splash-screen.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-splash-screen</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-splash-screen>\n                    <!-- Splash screen content -->\n                </ms-splash-screen>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-splash-screen\n</b> is a helper directive that helps splash screen to disappear.</p></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-stepper.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-stepper</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><span class=\"h2 pt-16\">Description:</span><p><b>ms-stepper</b>\n is a form step directive that follows Google\'s Material Design specifications. It allows you to create stepped forms. Unlike \n<b>ms-form-wizard</b>\n, this directive doesn\'t use any other material elements, therefore it\'s a lot more flexible and easy to use:</p><span \nclass=\"h3 pt-16\">Horizontal Stepper:</span>\n            <hljs language=\"html\" class=\"source-code\">\n                <form name=\"stepper\" ms-horizontal-stepper ng-submit=\"vm.submitStepper()\" ng-model=\"vm.stepper\" novalidate>\n                    <!-- Step 1 -->\n                    <ms-horizontal-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'Personal Information\'\">\n                        <div ng-include=\"\'app/main/ui/forms/stepper-steps/step-1.html\'\"></div>\n                    </ms-horizontal-stepper-step>\n                    <!-- / Step 1 -->\n\n                    <!-- Step 2 -->\n                    <ms-horizontal-stepper-step ng-form=\"step2\" step=\"2\" step-title=\"\'Address\'\" optional-step>\n                        <div ng-include=\"\'app/main/ui/forms/stepper-steps/step-2.html\'\"></div>\n                    </ms-horizontal-stepper-step>\n                    <!-- / Step 2 -->\n\n                    <!-- Step 3 -->\n                    <ms-horizontal-stepper-step ng-form=\"step3\" step=\"3\" step-title=\"\'Payment Method\'\">\n                        <div ng-include=\"\'app/main/ui/forms/stepper-steps/step-3.html\'\"></div>\n                    </ms-horizontal-stepper-step>\n                    <!-- / Step 3 -->\n                </form>\n            </hljs>\n            <hr><span class=\"h3 pt-16\">\nVertical Stepper:</span>\n            <hljs language=\"html\" class=\"source-code\">\n                <form name=\"stepper\" ms-vertical-stepper ng-submit=\"vm.submitStepper()\" ng-model=\"vm.stepper\" novalidate>\n                    <!-- Step 1 -->\n                    <ms-vertical-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'Personal Information\'\">\n                        <div ng-include=\"\'app/main/ui/forms/stepper-steps/step-1.html\'\"></div>\n                    </ms-vertical-stepper-step>\n                    <!-- / Step 1 -->\n\n                    <!-- Step 2 -->\n                    <ms-vertical-stepper-step ng-form=\"step2\" step=\"2\" step-title=\"\'Address\'\" optional-step>\n                        <div ng-include=\"\'app/main/ui/forms/stepper-steps/step-2.html\'\"></div>\n                    </ms-vertical-stepper-step>\n                    <!-- / Step 2 -->\n\n                    <!-- Step 3 -->\n                    <ms-vertical-stepper-step ng-form=\"step3\" step=\"3\" step-title=\"\'Payment Method\'\">\n                        <div ng-include=\"\'app/main/ui/forms/stepper-steps/step-3.html\'\"></div>\n                    </ms-vertical-stepper-step>\n                    <!-- / Step 3 -->\n                </form>\n            </hljs>\n             <span class=\"h2 pt-16\">ms-*-stepper-step</span><p>\nThis directive requires <b>ms-*-stepper</b>\n directive and it\'s used for creating individual steps. You can either directly wrap your forms with this directive, or you can use ng-include to include them.\n</p><span class=\"h2 pt-16\">ms-stepper-step Attributes</span><div \nclass=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\"><thead><tr><th>Attribute</th><th>\nDescription</th></tr></thead><tbody><tr><td>ng-form</td><td>\n(string) This attribute/directive is required for steps to work correctly. It requires a unique, string value. You can think this as the unique name of the step.\n</td></tr><tr><td>step [Optional]</td><td>\n(integer) Optional value for the step number. If you want to manually order your steps, you can use this attribute.\n</td></tr><tr><td>step-title</td><td>(string) Step title that will show up in the step navigation.</td></tr><tr><td>\noptional-step [Optional]</td><td>\nIf given, this attribute will make the step optional. Therefore, that step can be passed through without filling its input fields and it will not be included into the main form validity check.\n</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-timeline.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-timeline</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <div id=\"timeline\" ms-timeline ms-timeline-load-more=\"vm.loadNextPage()\">\n\n                    <!-- TIMELINE ITEM -->\n                    <div ms-timeline-item ng-repeat=\"timelineItem in vm.timeline\">\n\n                        <div class=\"timeline-card\">\n                            <!-- MS-CARD -->\n                            <ms-card template=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card>\n                            <!-- / MS-CARD -->\n                        </div>\n\n                        <div class=\"timeline-point md-accent-bg md-whiteframe-2dp\">\n                            <md-icon md-font-icon=\"{{timelineItem.icon}}\"></md-icon>\n                        </div>\n\n                        <div class=\"timeline-detail\">\n                            <div class=\"time\">\n                                {{timelineItem.time}}\n                            </div>\n                            <div class=\"event\">\n                                {{timelineItem.event}}\n                            </div>\n                        </div>\n                    </div>\n                    <!-- / TIMELINE ITEM -->\n\n                </div>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-timeline</b>\n directive is required for timeline. It will help loading and animating the timeline items properly. We highly recommend you to check \n<em>app/main/pages/timeline/timeline.html</em> and <em>app/main/pages/timeline/timeline.controller.js</em>\n to fully understand how to use it.</p></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-widget.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-widget</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-widget flippable=\"true\">\n\n                    <ms-widget-front class=\"padding-16 md-white-bg\">\n                        <!-- Front content -->\n                    </ms-widget-front>\n\n                    <ms-widget-back class=\"padding-16 md-white-bg\">\n                        <!-- Back content -->\n                    </ms-widget-back>\n\n                </ms-widget>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-widget</b>\n directive is a helper directive for creating widgets. When it used with helper classes such as padding, margin, height helpers, it\'s very easy to create custom widgets.\n</p><div class=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\"><thead><tr><th>Attribute</th><th>\nDescription</th></tr></thead><tbody><tr><td>flippable</td><td>\nIf it\'s true, widget will be flippable. If you don\'t want to make the widget flippable, you can make this attribute false and use only \n<b>&lt;ms-widget-front&gt;&lt;/ms-widget-front&gt;</b> wrapper to show widget content.</td></tr></tbody></table></div>\n</div></div></div>");
$templateCache.put("app/main/ui/page-layouts/demo/demo-content.html","<div class=\"demo-content\"><img src=\"assets/images/etc/early-sunrise.jpg\" class=\"md-card-image\" alt=\"sunrise\"><h1>\nEarly Sunrise</h1><h4 class=\"secondary-text\">Demo Content</h4><p>\nOne morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections.\n</p><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment. His many legs, pitifully thin compared with the size of the rest of him, waved about helplessly as he looked. \"What\'s happened to me? \" he thought. It wasn\'t a dream.\n</p><footer>John Doe</footer></blockquote><p>\nHis room, a proper human room although a little too small, lay peacefully between its four familiar walls. A collection of textile samples lay spread out on the table - Samsa was a travelling salesman - and above it there hung a picture that he had recently cut out of an illustrated magazine and housed in a nice, gilded frame.\n</p><p>\nIt showed a lady fitted out with a fur hat and fur boa who sat upright, raising a heavy fur muff that covered the whole of her lower arm towards the viewer. Gregor then turned to look out the window at the dull weather. Drops of rain could be heard hitting the pane, which made him feel quite sad.\n</p><p>\n\"How about if I sleep a little bit longer and forget all this nonsense\", he thought, but that was something he was unable to do because he was used to sleeping on his right, and in his present state couldn\'t get into that position. However hard he threw himself onto his right, he always rolled back to where he was.\n</p><p>\nHe must have tried it a hundred times, shut his eyes so that he wouldn\'t have to look at the floundering legs, and only stopped when he began to feel a mild, dull pain there that he had never felt before. \"Oh, God\", he thought, \"what a strenuous career it is that I\'ve chosen!\n</p><p>\nTravelling day in and day out. Doing business like this takes much more effort than doing your own business at home, and on top of that there\'s the curse of travelling, worries about making train connections, bad and irregular food, contact with different people all the time so that you can never get to know anyone or become friendly with them.\n</p><p>\n\"He felt a slight itch up on his belly; pushed himself slowly up on his back towards the headboard so that he could lift his head better; found where the itch was, and saw that it was covered with lots of little white spots which he didn\'t know what to make of; and when he tried to feel the place with one of his legs he drew it quickly back because as soon as he touched it he was overcome by a cold shudder. He slid back into his former position.\n</p><p>\n\"Getting up early all the time\", he thought, \"it makes you stupid. You\'ve got to get enough sleep. Other travelling salesmen live a life of luxury. For instance, whenever I go back to the guest house during the morning to copy out the contract, these gentlemen are always still sitting there eating their breakfasts. I ought to just try that with my boss; I\'d get kicked out on the spot. But who knows, maybe that would be the best thing for me...\n</p></div>");
$templateCache.put("app/main/ui/page-layouts/demo/demo-sidenav.html","<div class=\"demo-sidenav\"><md-list><md-subheader class=\"md-no-sticky\">Sidenav Demo</md-subheader><md-list-item><p>\nSidenav Item 1</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 2</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 3</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 4</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 5</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 6</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 7</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 8</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 9</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 10</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 11</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 12</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 13</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 14</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 15</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 16</p></md-list-item></md-list></div>");
$templateCache.put("app/main/components/maps/tabs/custom-marker.html","<ui-gmap-google-map center=\"vm.customMarkerMap.center\" zoom=\"vm.customMarkerMap.zoom\"><ui-gmap-marker \ncoords=\"vm.customMarkerMap.marker.coords\" idkey=\"vm.customMarkerMap.marker.id\" \noptions=\"vm.customMarkerMap.marker.options\"></ui-gmap-marker></ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/info-window.html","<ui-gmap-google-map center=\"vm.simpleMarkerMap.center\" zoom=\"vm.simpleMarkerMap.zoom\"><ui-gmap-marker \ncoords=\"vm.simpleMarkerMap.marker.coords\" idkey=\"vm.simpleMarkerMap.marker.id\"><ui-gmap-window show=\"\'true\'\"><div \nng-non-bindable=\"\"><div id=\"siteNotice\"></div><h1 id=\"firstHeading\" class=\"firstHeading\">Uluru</h1><div \nid=\"bodyContent\"><p><b>Uluru</b>, also referred to as <b>Ayers Rock</b>\n, is a large sandstone rock formation in the southern part of the Northern Territory, central Australia.</p><p>\nAttribution: Uluru, <a href=\"//en.wikipedia.org/w/index.php?title=Uluru&amp;oldid=297882194\">\nhttp://en.wikipedia.org/w/index.php?title=Uluru</a> (last visited June 22, 2009).</p></div></div></ui-gmap-window>\n</ui-gmap-marker></ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/satellite.html","<ui-gmap-google-map center=\"vm.satelliteMap.center\" zoom=\"vm.satelliteMap.zoom\" options=\"vm.satelliteMap.options\">\n</ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/simple-marker.html","<ui-gmap-google-map center=\"vm.simpleMarkerMap.center\" zoom=\"vm.simpleMarkerMap.zoom\"><ui-gmap-marker \ncoords=\"vm.simpleMarkerMap.marker.coords\" idkey=\"vm.simpleMarkerMap.marker.id\"></ui-gmap-marker></ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/simple.html","<ui-gmap-google-map center=\"vm.simpleMap.center\" zoom=\"vm.simpleMap.zoom\"></ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/terrain.html","<ui-gmap-google-map center=\"vm.terrainMap.center\" zoom=\"vm.terrainMap.zoom\" options=\"vm.terrainMap.options\">\n</ui-gmap-google-map>");
$templateCache.put("app/main/components/material-docs/layout/layout-alignment.tmpl.html","<div ng-controller=\"LayoutCtrl\" class=\"layout-content\" ng-cloak><p>The <code>layout-align</code>\n directive takes two words. The first word says how the children will be aligned in the layout\'s direction, and the second word says how the children will be aligned perpendicular to the layout\'s direction.\n</p><p>Only one value is required for this directive. For example, <code>layout=\"row\" layout-align=\"center\"</code>\n would make the elements center horizontally and use the default behavior vertically.</p><p><code>\nlayout=\"column\" layout-align=\"center end\"</code>\n would make children align along the center vertically and along the end (right) horizontally.</p><table \nclass=\"md-api-table\"><thead><tr><th>API</th><th>Sets child alignments within the layout container</th></tr></thead><tr>\n<td>layout-align</td><td>Sets default alignment unless overridden by another breakpoint.</td></tr><tr><td>\nlayout-align-xs</td><td>width &lt; <b>600</b>px</td></tr><tr><td>layout-align-gt-xs</td><td>width &gt;= <b>600</b>px\n</td></tr><tr><td>layout-align-sm</td><td><b>600</b>px &lt;= width &lt; <b>960</b>px</td></tr><tr><td>\nlayout-align-gt-sm</td><td>width &gt;= <b>960</b>px</td></tr><tr><td>layout-align-md</td><td><b>960</b>\npx &lt;= width &lt; <b>1280</b>px</td></tr><tr><td>layout-align-gt-md</td><td>width &gt;= <b>1280</b>px</td></tr><tr>\n<td>layout-align-lg</td><td><b>1280</b>px &lt;= width &lt; <b>1920</b>px</td></tr><tr><td>layout-align-gt-lg</td><td>\nwidth &gt;= <b>1920</b>px</td></tr><tr><td>layout-align-xl</td><td>width &gt;= <b>1920</b>px</td></tr></table><br><p>\nBelow is an interactive demo that lets you explore the visual results of the different settings:</p><div><docs-demo \ndemo-title=\'layout=\"{{layoutDemo.direction}}\" &nbsp; &nbsp; &nbsp; layout-align=\"{{layoutAlign()}}\"\' \nclass=\"small-demo colorNested\" interpolate-code=\"true\"><demo-file name=\"index.html\"><div \nlayout=\"{{layoutDemo.direction}}\" layout-align=\"{{layoutAlign()}}\"><div>one</div><div>two</div><div>three</div></div>\n</demo-file></docs-demo></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"space-around\"><div><md-subheader>\nLayout Direction</md-subheader><md-radio-group ng-model=\"layoutDemo.direction\"><md-radio-button value=\"row\">row\n</md-radio-button><md-radio-button value=\"column\">column</md-radio-button></md-radio-group></div><div><md-subheader>\nAlignment in Layout Direction ({{layoutDemo.direction == \'row\' ? \'horizontal\' : \'vertical\'}})</md-subheader>\n<md-radio-group ng-model=\"layoutDemo.mainAxis\"><md-radio-button value=\"\">none</md-radio-button><md-radio-button \nvalue=\"start\">start (default)</md-radio-button><md-radio-button value=\"center\">center</md-radio-button><md-radio-button\n value=\"end\">end</md-radio-button><md-radio-button value=\"space-around\">space-around</md-radio-button><md-radio-button \nvalue=\"space-between\">space-between</md-radio-button></md-radio-group></div><div><md-subheader>\nAlignment in Perpendicular Direction ({{layoutDemo.direction == \'column\' ? \'horizontal\' : \'vertical\'}})</md-subheader>\n<md-radio-group ng-model=\"layoutDemo.crossAxis\"><md-radio-button value=\"none\"><em>none</em></md-radio-button>\n<md-radio-button value=\"start\">start</md-radio-button><md-radio-button value=\"center\">center</md-radio-button>\n<md-radio-button value=\"end\">end</md-radio-button><md-radio-button value=\"stretch\">stretch (default)</md-radio-button>\n</md-radio-group></div></div></div>");
$templateCache.put("app/main/components/material-docs/layout/layout-children.tmpl.html","<div ng-controller=\"LayoutCtrl\" class=\"layout-content\" ng-cloak><h3>Children within a Layout Container</h3><p>\nTo customize the size and position of elements in a layout <b>container</b>, use the <code>flex</code>, <code>\nflex-order</code>, and <code>flex-offset</code> attributes on the container\'s <u>child</u> elements:</p><docs-demo \ndemo-title=\"Flex Directive\" class=\"small-demo colorNested\"><demo-file name=\"index.html\"><div layout=\"row\"><div \nflex=\"20\">[flex=\"20\"]</div><div flex=\"70\">[flex=\"70\"]</div><div flex hide-sm hide-xs>[flex]</div></div></demo-file>\n</docs-demo><p>Add the <code>flex</code>\n directive to a layout\'s child element and the element will flex (grow or shrink) to fit the area unused by other elements. \n<code>flex</code> defines how the element will adjust its size with respect to its <u>parent</u>\n container and the other elements within the container.</p><docs-demo demo-title=\"Flex Percent Values\" \nclass=\"small-demo colorNested-noPad\"><demo-file name=\"index.html\"><div layout=\"row\" layout-wrap><div flex=\"30\">\n[flex=\"30\"]</div><div flex=\"45\">[flex=\"45\"]</div><div flex=\"25\">[flex=\"25\"]</div><div flex=\"33\">[flex=\"33\"]</div><div \nflex=\"66\">[flex=\"66\"]</div><div flex=\"50\">[flex=\"50\"]</div><div flex>[flex]</div></div></demo-file></docs-demo><p>\nA layout child\'s <code>flex</code>\n directive can be given an integer value from 0-100. The element will stretch to the percentage of available space matching the value. Currently, the \n<code>flex</code> directive value is restricted to multiples of five, 33 or 66.</p><p>For example: <code>\nflex=\"5\", flex=\"20\", flex=\"33\", flex=\"50\", flex=\"66\", flex=\"75\", ... flex=\"100\"</code>.</p><docs-demo \ndemo-title=\"Responsive Flex Directives\" class=\"small-demo colorNested-noPad\"><demo-file name=\"index.html\"><div \nlayout=\"row\"><div flex-gt-sm=\"66\" flex=\"33\">flex 33% on mobile,<br>and 66% on gt-sm devices.</div><div flex-gt-sm=\"33\" \nflex=\"66\">flex 66% on mobile,<br>and 33% on gt-sm devices.</div></div></demo-file></docs-demo><p>See the <a \nhref=\"layout/options\">layout options page</a> for more information on responsive flex directives like <code>hide-sm\n</code> and <code>layout-wrap</code> used in the above examples.</p><br><hr><br><h3>Additional Flex Values</h3><p>\nThere are additional flex values provided by AngularJS Material to improve flexibility and to make the API easier to understand.\n</p><docs-demo demo-title=\"Other Flex Values\" class=\"small-demo colorNested-noPad\"><demo-file name=\"index.html\"><div \nlayout=\"row\" layout-wrap><div flex=\"none\">[flex=\"none\"]</div><div flex>[flex]</div><div flex=\"nogrow\">[flex=\"nogrow\"]\n</div><div flex=\"grow\">[flex=\"grow\"]</div><div flex=\"initial\">[flex=\"initial\"]</div><div flex=\"auto\">[flex=\"auto\"]\n</div><div flex=\"noshrink\">[flex=\"noshrink\"]</div><div flex=\"0\">[flex=\"0\"]</div></div></demo-file></docs-demo><table \nclass=\"md-api-table\"><tr><td>flex</td><td>Will grow and shrink as needed. Starts with a size of 0%. Same as <code>\nflex=\"0\"</code>.<br><br><b>Note:</b>\n There is a known bug with this attribute in IE11 when the parent container has no explicit height set. See our <a \nng-href=\"layout/tips#layout-column-0px-ie11\">Troubleshooting</a> page for more info.</td></tr><tr><td>flex=\"none\"</td>\n<td>Will not grow or shrink. Sized based on its <code>width</code> and <code>height</code> values.</td></tr><tr><td>\nflex=\"initial\"</td><td>Will shrink as needed. Starts with a size based on its <code>width</code> and <code>height\n</code> values.</td></tr><tr><td>flex=\"auto\"</td><td>Will grow and shrink as needed. Starts with a size based on its \n<code>width</code> and <code>height</code> values.</td></tr><tr><td>flex=\"grow\"</td><td>\nWill grow and shrink as needed. Starts with a size of 100%. Same as <code>flex=\"100\"</code>.</td></tr><tr><td>\nflex=\"nogrow\"</td><td>Will shrink as needed, but won\'t grow. Starts with a size based on its <code>width</code> and \n<code>height</code> values.</td></tr><tr><td>flex=\"noshrink\"</td><td>\nWill grow as needed, but won\'t shrink. Starts with a size based on its <code>width</code> and <code>height</code>\n values.</td></tr></table><br><hr><br><h3>Ordering HTML Elements</h3><p>Add the <code>flex-order</code>\n directive to a layout child to set its order position within the layout container. Any integer value from -20 to 20 is accepted.\n</p><docs-demo demo-title=\"Flex-Order Directive\" class=\"small-demo colorNested\"><demo-file name=\"index.html\"><div \nlayout=\"row\"><div flex flex-order=\"-1\"><p>[flex-order=\"-1\"]</p></div><div flex flex-order=\"1\" flex-order-gt-md=\"3\"><p \nhide-gt-md>[flex-order=\"1\"]</p><p hide show-gt-md>[flex-order-gt-md=\"3\"]</p></div><div flex flex-order=\"2\"><p>\n[flex-order=\"2\"]</p></div><div flex flex-order=\"3\" flex-order-gt-md=\"1\"><p hide-gt-md>[flex-order=\"3\"]</p><p hide \nshow-gt-md>[flex-order-gt-md=\"1\"]</p></div></div></demo-file></docs-demo><table class=\"md-api-table\"><thead><tr><th>API\n</th><th>Device <b>width</b> when breakpoint overrides default</th></tr></thead><tr><td>flex-order</td><td>\nSets default layout order unless overridden by another breakpoint.</td></tr><tr><td>flex-order-xs</td><td>width &lt; \n<b>600</b>px</td></tr><tr><td>flex-order-gt-xs</td><td>width &gt;= <b>600</b>px</td></tr><tr><td>flex-order-sm</td><td>\n<b>600</b>px &lt;= width &lt; <b>960</b>px</td></tr><tr><td>flex-order-gt-sm</td><td>width &gt;= <b>960</b>px</td></tr>\n<tr><td>flex-order-md</td><td><b>960</b>px &lt;= width &lt; <b>1280</b>px</td></tr><tr><td>flex-order-gt-md</td><td>\nwidth &gt;= <b>1280</b>px</td></tr><tr><td>flex-order-lg</td><td><b>1280</b>px &lt;= width &lt; <b>1920</b>px</td></tr>\n<tr><td>flex-order-gt-lg</td><td>width &gt;= <b>1920</b>px</td></tr><tr><td>flex-order-xl</td><td>width &gt;= <b>1920\n</b>px</td></tr></table><p>See the <a href=\"layout/options\">layout options page</a>\n for more information on directives like <code>hide</code>, <code>hide-gt-md</code>, and <code>show-gt-md</code>\n used in the above examples.</p><br><hr><br><h3>Add Offsets to the Preceding HTML Elements</h3><p>Add the <code>\nflex-offset</code>\n directive to a layout child to set its offset percentage within the layout container. Values must be multiples of \n<code>5</code> or <code>33</code> / <code>66</code>. These offsets establish a <code>margin-left</code>\n with respect to the preceding element or the containers left boundary.</p><p>When using <code>flex-offset</code>\n the margin-left offset is applied... regardless of your choice of <code>flex-order</code>. or if you use a <code>\nflex-direction: reverse</code>.</p><docs-demo demo-title=\"Flex-Offset Directive\" class=\"small-demo colorNested\">\n<demo-file name=\"index.html\"><div layout=\"row\"><div flex=\"66\" flex-offset=\"15\">[flex-offset=\"15\"] [flex=\"66\"]</div><div\n flex>[flex]</div></div></demo-file></docs-demo><table class=\"md-api-table\"><thead><tr><th>API</th><th>\nDevice width when breakpoint overrides default</th></tr></thead><tr><td>flex-offset</td><td>\nSets default margin-left offset (<b>%-based</b>) unless overridden by another breakpoint.</td></tr><tr><td>\nflex-offset-xs</td><td>width &lt; <b>600</b>px</td></tr><tr><td>flex-offset-gt-xs</td><td>width &gt;= <b>600</b>px</td>\n</tr><tr><td>flex-offset-sm</td><td><b>600</b>px &lt;= width &lt; <b>960</b>px</td></tr><tr><td>flex-offset-gt-sm</td>\n<td>width &gt;= <b>960</b>px</td></tr><tr><td>flex-offset-md</td><td><b>960</b>px &lt;= width &lt; <b>1280</b>px</td>\n</tr><tr><td>flex-offset-gt-md</td><td>width &gt;= <b>1280</b>px</td></tr><tr><td>flex-offset-lg</td><td><b>1280</b>\npx &lt;= width &lt; <b>1920</b>px</td></tr><tr><td>flex-offset-gt-lg</td><td>width &gt;= <b>1920</b>px</td></tr><tr>\n<td>flex-offset-xl</td><td>width &gt;= <b>1920</b>px</td></tr></table></div>");
$templateCache.put("app/main/components/material-docs/layout/layout-container.tmpl.html","<div ng-controller=\"LayoutCtrl\" class=\"layout-content\" ng-cloak><h3>Layout and Containers</h3><p>Use the <code>layout\n</code> directive on a container element to specify the layout direction for its children: horizontally in a row (\n<code>layout=\"row\"</code>) or vertically in a column (<code>layout=\"column\"</code>). Note that <code>row</code>\n is the default layout direction if you specify the <code>layout</code> directive without a value.</p><table><tr><td \nstyle=\"font-weight: bold; background-color: #DBEEF5\">row</td><td style=\"padding-left: 10px\">\nItems arranged horizontally. <code>max-height = 100%</code> and <code>max-width</code>\n is the width of the items in the container.</td></tr><tr><td style=\"font-weight: bold; background-color: #DBEEF5\">\ncolumn</td><td style=\"padding-left: 10px\">Items arranged vertically. <code>max-width = 100%</code> and <code>max-height\n</code> is the height of the items in the container.</td></tr></table><br><docs-demo demo-title=\"Layout Directive\" \nclass=\"small-demo colorNested\"><demo-file name=\"index.html\"><div layout=\"row\"><div flex>First item in row</div><div \nflex>Second item in row</div></div><div layout=\"column\"><div flex>First item in column</div><div flex>\nSecond item in column</div></div></demo-file></docs-demo><p>Note that <code>layout</code>\n only affects the flow direction for that container\'s <b>immediate</b> children.</p><hr><br><h3>\nLayouts and Responsive Breakpoints</h3><p>As discussed in the <a href=\"layout/introduction\">Layout Introduction page\n</a> you can make your layout change depending upon the device view size by using <b>breakpoint alias</b> suffixes.</p>\n<p>To make your layout automatically change depending upon the device screen size, use one to the following <code>\nlayout</code> APIs to set the layout direction for devices with view widths:</p><table class=\"md-api-table\"><thead><tr>\n<th>API</th><th>Device width when breakpoint overrides default</th></tr></thead><tr><td>layout</td><td>\nSets default layout direction unless overridden by another breakpoint.</td></tr><tr><td>layout-xs</td><td>width &lt; \n<b>600</b>px</td></tr><tr><td>layout-gt-xs</td><td>width &gt;= <b>600</b>px</td></tr><tr><td>layout-sm</td><td><b>600\n</b>px &lt;= width &lt; <b>960</b>px</td></tr><tr><td>layout-gt-sm</td><td>width &gt;= <b>960</b>px</td></tr><tr><td>\nlayout-md</td><td><b>960</b>px &lt;= width &lt; <b>1280</b>px</td></tr><tr><td>layout-gt-md</td><td>width &gt;= <b>1280\n</b>px</td></tr><tr><td>layout-lg</td><td><b>1280</b>px &lt;= width &lt; <b>1920</b>px</td></tr><tr><td>layout-gt-lg\n</td><td>width &gt;= <b>1920</b>px</td></tr><tr><td>layout-xl</td><td>width &gt;= <b>1920</b>px</td></tr></table><br>\n<p><a \nhref=\"https://camo.githubusercontent.com/ad81ae92f8b4285747ce4e48007bf3f104dd5630/687474703a2f2f6d6174657269616c2d64657369676e2e73746f726167652e676f6f676c65617069732e636f6d2f7075626c6973682f6d6174657269616c5f765f342f6d6174657269616c5f6578745f7075626c6973682f3042386f6c5631354a3761625053474678656d46695156527462316b2f6c61796f75745f61646170746976655f627265616b706f696e74735f30312e706e67\" \ntarget=\"_blank\" style=\"text-decoration: none;border: 0 none\"><img \nsrc=\"https://camo.githubusercontent.com/ad81ae92f8b4285747ce4e48007bf3f104dd5630/687474703a2f2f6d6174657269616c2d64657369676e2e73746f726167652e676f6f676c65617069732e636f6d2f7075626c6973682f6d6174657269616c5f765f342f6d6174657269616c5f6578745f7075626c6973682f3042386f6c5631354a3761625053474678656d46695156527462316b2f6c61796f75745f61646170746976655f627265616b706f696e74735f30312e706e67\" \nalt=\"\" style=\"max-width:100%;text-decoration: none;border: 0 none\"></a></p><p>\nFor the demo below, as you shrink your browser window width notice the flow direction changes to <code>column</code>\n for mobile devices (<code>xs</code>). And as you expand it will reset to <code>row</code> for <code>gt-sm</code>\n view sizes.</p><docs-demo demo-title=\"Responsive Layouts\" class=\"small-demo colorNested\"><demo-file name=\"index.html\">\n<div layout=\"row\" layout-xs=\"column\"><div flex>I\'m above on mobile, and to the left on larger devices.</div><div flex>\nI\'m below on mobile, and to the right on larger devices.</div></div></demo-file></docs-demo><p>See the <a \nhref=\"layout/options\">Layout Options page</a> for more options such as padding, alignments, etc.</p></div>");
$templateCache.put("app/main/components/material-docs/layout/layout-introduction.tmpl.html","<div ng-controller=\"LayoutCtrl\" class=\"layout-content\" ng-cloak><h3>Overview</h3><p>\nAngularJS Material\'s Layout features provide sugar to enable developers to more easily create modern, responsive layouts on top of CSS3 \n<a href=\"http://www.w3.org/TR/css3-flexbox/\">flexbox</a>\n. The layout API consists of a set of AngularJS directives that can be applied to any of your application\'s HTML content.\n</p><p>Using <b>HTML Directives</b> as the API provides an easy way to set a value (eg. <code>layout=\"row\"</code>\n) and helps with separation of concerns: Attributes define layout while CSS classes assign styling.</p><table \nclass=\"md-api-table\"><thead><tr><th>HTML Markup API</th><th>Allowed values (raw or interpolated)</th></tr></thead>\n<tbody><tr><td>layout</td><td><code>row | column</code></td></tr><tr><td>flex</td><td>\ninteger (increments of 5 for 0%->100%, 100%/3, 200%/3)</td></tr><tr><td>flex-order</td><td>\ninteger values from -20 to 20</td></tr><tr><td>flex-offset</td><td>\ninteger (increments of 5 for 0%->95%, 100%/3, 200%/3)</td></tr><tr><td>layout-align</td><td><code>\nstart|center|end|space-around|space-between</code> <code>start|center|end|stretch</code></td></tr><tr><td>layout-fill\n</td><td></td></tr><tr><td>layout-wrap</td><td></td></tr><tr><td>layout-nowrap</td><td></td></tr><tr><td>layout-margin\n</td><td></td></tr><tr><td>layout-padding</td><td></td></tr><tr><td>show</td><td></td></tr><tr><td>hide</td><td></td>\n</tr></tbody></table><p>And if we use Breakpoints as specified in Material Design:</p><p><a \nhref=\"https://camo.githubusercontent.com/ad81ae92f8b4285747ce4e48007bf3f104dd5630/687474703a2f2f6d6174657269616c2d64657369676e2e73746f726167652e676f6f676c65617069732e636f6d2f7075626c6973682f6d6174657269616c5f765f342f6d6174657269616c5f6578745f7075626c6973682f3042386f6c5631354a3761625053474678656d46695156527462316b2f6c61796f75745f61646170746976655f627265616b706f696e74735f30312e706e67\" \ntarget=\"_blank\"><img \nsrc=\"https://camo.githubusercontent.com/ad81ae92f8b4285747ce4e48007bf3f104dd5630/687474703a2f2f6d6174657269616c2d64657369676e2e73746f726167652e676f6f676c65617069732e636f6d2f7075626c6973682f6d6174657269616c5f765f342f6d6174657269616c5f6578745f7075626c6973682f3042386f6c5631354a3761625053474678656d46695156527462316b2f6c61796f75745f61646170746976655f627265616b706f696e74735f30312e706e67\" \nalt=\"\" style=\"max-width:100%\"></a></p><p>We can associate breakpoints with mediaQuery definitions using breakpoint \n<strong>alias(es)</strong>:</p><table class=\"md-api-table\"><thead><tr><th>Breakpoint</th><th>MediaQuery (pixel range)\n</th></tr></thead><tbody><tr><td>xs</td><td>\'(max-width: <b>599</b>px)\'</td></tr><tr><td>gt-xs</td><td>\'(min-width: <b>\n600</b>px)\'</td></tr><tr><td>sm</td><td>\'(min-width: <b>600</b>px) and (max-width: <b>959</b>px)\'</td></tr><tr><td>\ngt-sm</td><td>\'(min-width: <b>960</b>px)\'</td></tr><tr><td>md</td><td>\'(min-width: <b>960</b>px) and (max-width: <b>\n1279</b>px)\'</td></tr><tr><td>gt-md</td><td>\'(min-width: <b>1280</b>px)\'</td></tr><tr><td>lg</td><td>\'(min-width: <b>\n1280</b>px) and (max-width: <b>1919</b>px)\'</td></tr><tr><td>gt-lg</td><td>\'(min-width: <b>1920</b>px)\'</td></tr><tr>\n<td>xl</td><td>\'(min-width: <b>1920</b>px)\'</td></tr></tbody></table><br><hr><h3>API with Responsive Breakpoints</h3>\n<p>Now we can combine the breakpoint <code>alias</code>\n with the Layout API to easily support Responsive breakpoints with our simple Layout markup convention. The <code>alias\n</code> is simply used as <b>suffix</b> extensions to the Layout API keyword.<br>e.g.</p><p>\nThis notation results in, for example, the following table for the <code>layout</code> and <code>flex</code> APIs:</p>\n<table class=\"md-api-table\"><thead><tr><th>layout API</th><th>flex API</th><th>Activates when device</th></tr></thead>\n<tr><td>layout</td><td>flex</td><td>Sets default layout direction &amp; flex unless overridden by another breakpoint.\n</td></tr><tr><td>layout-xs</td><td>flex-xs</td><td>width &lt; <b>600</b>px</td></tr><tr><td>layout-gt-xs</td><td>\nflex-gt-xs</td><td>width &gt;= <b>600</b>px</td></tr><tr><td>layout-sm</td><td>flex-sm</td><td><b>600</b>\npx &lt;= width &lt; <b>960</b>px</td></tr><tr><td>layout-gt-sm</td><td>flex-gt-sm</td><td>width &gt;= <b>960</b>px</td>\n</tr><tr><td>layout-md</td><td>flex-md</td><td><b>960</b>px &lt;= width &lt; <b>1280</b>px</td></tr><tr><td>\nlayout-gt-md</td><td>flex-gt-md</td><td>width &gt;= <b>1280</b>px</td></tr><tr><td>layout-lg</td><td>flex-lg</td><td>\n<b>1280</b>px &lt;= width &lt; <b>1920</b>px</td></tr><tr><td>layout-gt-lg</td><td>flex-gt-lg</td><td>width &gt;= <b>\n1920</b>px</td></tr><tr><td>layout-xl</td><td>flex-xl</td><td>width &gt;= <b>1920</b>px</td></tr></table><p>\nBelow is an example usage of the Responsive Layout API:</p><hljs lang=\"html\"><div layout=\"column\" class=\"zero\"><div \nflex=\"33\" flex-md=\"{{ vm.box1Width }}\" class=\"one\"></div><div flex=\"33\" layout=\"{{ vm.direction }}\" layout-md=\"row\" \nclass=\"two\"><div flex=\"20\" flex-md=\"10\" hide-lg class=\"two_one\"></div><div flex=\"30px\" show hide-md=\"{{ vm.hideBox }}\" \nflex-md=\"25\" class=\"two_two\"></div><div flex=\"20\" flex-md=\"65\" class=\"two_three\"></div></div><div flex class=\"three\">\n</div></div></hljs><br><p>\nThis Layout API means it is much easier to set up and maintain flexbox layouts vs. defining everything via CSS. The developer uses the Layout HTML API to specify \n<b><i>intention</i></b> and the Layout engine handles all the issues of CSS flexbox styling.</p><p class=\"layout_note\">\nThe Layout engine will log console warnings when it encounters conflicts or known issues.</p><br><br><hr><br><h3>\nUnder-the-Hood</h3><p>Due to performance problems when using Attribute Selectors with <b>Internet Explorer</b>\n browsers; see the following for more details:</p><p>\nLayout directives dynamically generate class selectors at runtime. And the Layout CSS classNames and styles have each been predefined in the \n<code>angular-material.css</code> stylesheet.</p><p class=\"layout_note\">\nDevelopers should continue to use Layout directives in the HTML markup as the classes may change between releases.</p>\n<p>Let\'s see how this directive-to-className transformation works. Consider the simple use of the <code>layout</code>\n and <code>flex</code> directives (API):</p><hljs lang=\"html\"><div><div layout=\"row\"><div flex>First item in row</div>\n<div flex=\"20\">Second item in row</div></div><div layout=\"column\"><div flex=\"66\">First item in column</div><div \nflex=\"33\">Second item in column</div></div></div></hljs><p>At runtime, these attributes are transformed to CSS classes.\n</p><hljs lang=\"html\"><div><div class=\"ng-scope layout-row\"><div class=\"flex\">First item in row</div><div \nclass=\"flex-20\">Second item in row</div></div><div class=\"ng-scope layout-column\"><div class=\"flex-33\">\nFirst item in column</div><div class=\"flex-66\">Second item in column</div></div></div></hljs><p>\nUsing the style classes above defined in <code>angular-material.css</code></p><hljs lang=\"css\">\n.flex { -webkit-flex: 1 1 0%; -ms-flex: 1 1 0%; flex: 1 1 0%; box-sizing: border-box; } .flex-20 { -webkit-flex: 1 1 20%; -ms-flex: 1 1 20%; flex: 1 1 20%; max-width: 20%; max-height: 100%; box-sizing: border-box; } .layout-row .flex-33 { -webkit-flex: 1 1 calc(100% / 3); -ms-flex: 1 1 calc(100% / 3); flex: 1 1 calc(100% / 3); box-sizing: border-box; } .layout-row .flex-66 { -webkit-flex: 1 1 calc(200% / 3); -ms-flex: 1 1 calc(200% / 3); flex: 1 1 calc(200% / 3); box-sizing: border-box; } .layout-row .flex-33 { max-width: calc(100% / 3); max-height: 100%; } .layout-row .flex-66 { max-width: calc(200% / 3); max-height: 100%; } .layout-column .flex-33 { max-width: 100%; max-height: calc(100% / 3); } .layout-column .flex-66 { max-width: 100%; max-height: calc(200% / 3); }\n</hljs></div>");
$templateCache.put("app/main/components/material-docs/layout/layout-options.tmpl.html","<div ng-controller=\"LayoutCtrl\" class=\"layout-content layout-options\" ng-cloak><docs-demo \ndemo-title=\"Responsive Layout\" class=\"small-demo colorNested\"><demo-file name=\"index.html\"><div layout=\"row\" \nlayout-sm=\"column\"><div flex>I\'m above on mobile, and to the left on larger devices.</div><div flex>\nI\'m below on mobile, and to the right on larger devices.</div></div></demo-file></docs-demo><p>See the <a \nhref=\"layout/container\">Container Elements</a> page for a basic explanation of layout directives.<br>\nTo make your layout change depending upon the device screen size, there are other <code>layout</code>\n directives available:</p><table class=\"md-api-table\"><thead><tr><th>API</th><th>Activates when device</th></tr>\n</thead><tr><td>layout</td><td>Sets default layout direction unless overridden by another breakpoint.</td></tr><tr><td>\nlayout-xs</td><td>width &lt; <b>600</b>px</td></tr><tr><td>layout-gt-xs</td><td>width &gt;= <b>600</b>px</td></tr><tr>\n<td>layout-sm</td><td><b>600</b>px &lt;= width &lt; <b>960</b>px</td></tr><tr><td>layout-gt-sm</td><td>width &gt;= <b>\n960</b>px</td></tr><tr><td>layout-md</td><td><b>960</b>px &lt;= width &lt; <b>1280</b>px</td></tr><tr><td>layout-gt-md\n</td><td>width &gt;= <b>1280</b>px</td></tr><tr><td>layout-lg</td><td><b>1280</b>px &lt;= width &lt; <b>1920</b>px</td>\n</tr><tr><td>layout-gt-lg</td><td>width &gt;= <b>1920</b>px</td></tr><tr><td>layout-xl</td><td>width &gt;= <b>1920</b>\npx</td></tr></table><br><br><hr><br><h3>Layout Margin, Padding, Wrap and Fill</h3><br><docs-demo \ndemo-title=\"Layout Margin, Padding, and Fill\" class=\"small-demo colorNested-noPad\"><demo-file name=\"index.html\"><div \nlayout=\"row\" layout-margin><div flex>Parent layout and this element have margins.</div></div><div layout=\"row\" \nlayout-padding><div flex>Parent layout and this element have padding.</div></div><div layout=\"row\" layout-fill \nstyle=\"min-height: 224px\"><div flex>Parent layout is set to fill available space.</div></div><div layout=\"row\" \nlayout-padding layout-margin layout-fill style=\"min-height: 224px\"><div flex>I am using all three at once.</div></div>\n</demo-file></docs-demo><p><code>layout-margin</code> adds margin around each <code>flex</code>\n child. It also adds a margin to the layout container itself.<br><code>layout-padding</code> adds padding inside each \n<code>flex</code> child. It also adds padding to the layout container itself.<br><code>layout-fill</code>\n forces the layout element to fill its parent container.</p><p>Here is a non-trivial group of <code>flex</code>\n elements using <code>layout-wrap</code></p><docs-demo demo-title=\"Wrap\" class=\"small-demo colorNested-noPad\">\n<demo-file name=\"index.html\"><div layout=\"row\" layout-wrap><div flex=\"33\">[flex=33]</div><div flex=\"66\">[flex=66]</div>\n<div flex=\"66\">[flex=66]</div><div flex=\"33\">[flex=33]</div><div flex=\"33\">[flex=33]</div><div flex=\"33\">[flex=33]\n</div><div flex=\"33\">[flex=33]</div></div></demo-file></docs-demo><p><code>layout-wrap</code> allows <code>flex</code>\n children to wrap within the container if the elements use more than 100%.<br></p><br><br><hr><br><h3>Show &amp; Hide\n</h3><p>Use the <code>show</code> <code>hide</code>\n APIs to responsively show or hide elements. While these work similar to <code>ng-show</code> and <code>ng-hide</code>\n, these AngularJS Material Layout directives are mediaQuery-aware.</p><docs-demo demo-title=\"Hide and Show Directives\" \nclass=\"small-demo colorNested\"><demo-file name=\"index.html\"><div layout=\"row\"><div hide show-gt-sm flex>\nOnly show on gt-sm devices.</div><div hide-gt-sm flex>Shown on small and medium.<br>Hidden on gt-sm devices.</div><div \nshow hide-gt-md flex>Shown on small and medium size devices.<br>Hidden on gt-md devices.</div><div hide show-md flex>\nShown on medium size devices only.</div><div hide show-gt-lg flex>Shown on devices larger than 1200px wide only.</div>\n</div></demo-file></docs-demo><br><table class=\"md-api-table\"><thead><tr><th>hide (display: none)</th><th>\nshow (negates hide)</th><th>Activates when:</th></tr></thead><tr><td>hide-xs</td><td>show-xs</td><td>width &lt; <b>600\n</b>px</td></tr><tr><td>hide-gt-xs</td><td>show-gt-xs</td><td>width &gt;= <b>600</b>px</td></tr><tr><td>hide-sm</td>\n<td>show-sm</td><td><b>600</b>px &lt;= width &lt; <b>960</b>px</td></tr><tr><td>hide-gt-sm</td><td>show-gt-sm</td><td>\nwidth &gt;= <b>960</b>px</td></tr><tr><td>hide-md</td><td>show-md</td><td><b>960</b>px &lt;= width &lt; <b>1280</b>px\n</td></tr><tr><td>hide-gt-md</td><td>show-gt-md</td><td>width &gt;= <b>1280</b>px</td></tr><tr><td>hide-lg</td><td>\nshow-lg</td><td><b>1280</b>px &lt;= width &lt; <b>1920</b>px</td></tr><tr><td>hide-gt-lg</td><td>show-gt-lg</td><td>\nwidth &gt;= <b>1920</b>px</td></tr><tr><td>hide-xl</td><td>show-xl</td><td>width &gt;= <b>1920</b>px</td></tr></table>\n</div>");
$templateCache.put("app/main/components/material-docs/layout/layout-tips.tmpl.html","<style>ul.spaced li {\n    margin-bottom: 15px;\n  }</style><div ng-controller=\"LayoutTipsCtrl as tips\" \nclass=\"layout-content\"><h3>Overview</h3><p>The AngularJS Material Layout system uses the current <a \nhref=\"http://www.w3.org/TR/css3-flexbox/\">Flexbox</a>\n feature set. More importantly, it also adds syntactic sugar to allow developers to easily and quickly add Responsive features to HTML containers and elements.\n</p><p>\nAs you use the Layout features, you may encounter scenarios where the layouts do not render as expected; especially with IE 10 and 11 browsers. There may also be cases where you need to add custom HTML, CSS and Javascript to achieve your desired results.\n</p><br><hr><h3>Resources</h3><p>\nIf you are experiencing an issue in a particular browser, we highly recommend using the following resources for known issues and workarounds.\n</p><ul><li><a href=\"https://github.com/philipwalton/flexbugs#flexbugs\" target=\"_blank\">FlexBugs</a></li><li><a \nhref=\"https://philipwalton.github.io/solved-by-flexbox/\" target=\"_blank\">Solved by FlexBugs</a></li><li><a \nhref=\"http://philipwalton.com/articles/normalizing-cross-browser-flexbox-bugs/\" target=\"_blank\">\nNormalizing Cross-browser Flexbox Bugs</a></li><li style=\"margin-bottom: 20px\"><a \nhref=\"http://caniuse.com/#search=flex\" target=\"_blank\">Can I use flexbox...? ( see the <code>Known Issues</code> tab)\n</a></li><li><a href=\"https://groups.google.com/forum/#!forum/ngmaterial\">AngularJS Material Forum</a></li><li \nstyle=\"margin-top: 20px\"><a href=\"https://css-tricks.com/snippets/css/a-guide-to-flexbox/\" target=\"_blank\">\nA Complete Guide to Flexbox</a></li><li style=\"margin-bottom: 20px\"><a \nhref=\"https://scotch.io/tutorials/a-visual-guide-to-css3-flexbox-properties\" target=\"_blank\">\nA Visual Guide to CSS3 Flexbox Properties</a></li></ul><br><hr><h3>General Tips</h3><p>\nBelow, you will find solutions to some of the more common scenarios and problems that may arise when using Material\'s Layout system. The following sections offer general guidelines and tips when using the \n<code>flex</code> and <code>layout</code> directives within your own applications.</p><ul class=\"spaced\"><li>\nWhen building your application\'s Layout, it is usually best to start with a mobile version that looks and works correctly, and then apply styling for larger devices using the \n<code>flex-gt-*</code> or <code>hide-gt-*</code>\n attributes. This approach typically leads to less frustration than starting big and attempting to fix issues on smaller devices.\n</li><li>Some elements like <code>&lt;fieldset&gt;</code> and <code>&lt;button&gt;</code>\n do not always work correctly with flex. Additionally, some of the AngularJS Material components provide their own styles. If you are having difficulty with a specific element/component, but not others, try applying the flex attributes to a parent or child \n<code>&lt;div&gt;</code> of the element instead.</li><li>Some Flexbox properties such as <code>flex-direction</code> \n<u>cannot</u> be animated.</li><li>\nFlexbox can behave differently on different browsers. You should test as many as possible on a regular basis so that you can catch and fix layout issues more quickly.\n</li></ul><br><hr><h3>Layout Column</h3><p>In some scenarios <code>layout=\"column\"</code>\n and breakpoints (xs, gt-xs, xs, gt-sm, etc.) may not work as expected due to CSS specificity rules.</p><div \nclass=\"md-whiteframe-3dp\"><iframe height=\"700\" scrolling=\"no\" \nsrc=\"//codepen.io/team/AngularMaterial/embed/obgapg/?height=700&theme-id=21180&default-tab=result\" frameborder=\"no\" \nallowtransparency=\"true\" allowfullscreen=\"true\" style=\"width: 100%\">See the Pen <a \nhref=\"http://codepen.io/team/AngularMaterial/pen/obgapg/\">Card Layouts (corrected)</a> by AngularJS Material (<a \nhref=\"http://codepen.io/AngularMaterial\">@AngularMaterial</a>) on <a href=\"http://codepen.io\">CodePen</a>.</iframe>\n</div><p>This is easily fixed simply by inverting the layout logic so that the default is <code>layout=\'row\'</code>\n. To see how the layout changes, shrink the browser window its width is &lt; 600px;</p><br><hr><h3 \nid=\"layout-column-0px-ie11\">IE11 - Layout Column, 0px Height</h3><p>\nIn Internet Explorer 11, when you have a column layout with unspecified height and flex items inside, the browser can get confused and incorrectly calculate the height of each item (and thus the container) as \n<code>0px</code>, making the items overlap and not take up the proper amount of space.</p><p class=\"layout_note\"><b>\nNote:</b>\n The flex items below actually do have some height. This is because our doc-specific CSS provides a small bit of padding (\n<code>8px</code>). We felt that the extra padding made for a better demo of the actual issue.</p><docs-demo \ndemo-title=\"IE11 - Layout Column, 0px Height\" class=\"colorNested\"><demo-file name=\"index.html\"><div flex \nlayout=\"column\"><div flex>11111<br>11111<br>11111</div><div flex>22222<br>22222<br>22222</div><div flex>33333<br>33333\n<br>33333</div></div></demo-file></docs-demo><p>\nUnfortunately, there is no IE11 specific fix available, and the suggested workaround is to set the <code>flex-basis\n</code> property to <code>auto</code> instead of <code>0px</code> (which is the default setting).</p><p>\nYou can easily achieve this using the <code>flex=\"auto\"</code> attribute that the Layout system provides.</p><docs-demo\n demo-title=\"IE11 - Layout Column, 0px Height (Fix 1)\" class=\"colorNested\"><demo-file name=\"index.html\"><div flex \nlayout=\"column\"><div flex=\"auto\">11111<br>11111<br>11111</div><div flex=\"auto\">22222<br>22222<br>22222</div><div \nflex=\"auto\">33333<br>33333<br>33333</div></div></demo-file></docs-demo><p>\nAlternatively, you can manually set the height of the layout container (<code>400px</code> in the demo below).</p>\n<docs-demo demo-title=\"IE11 - Layout Column, 0px Height (Fix 2)\" class=\"colorNested\"><demo-file name=\"index.html\"><div \nflex layout=\"column\" style=\"height: 400px\"><div flex>11111<br>11111<br>11111</div><div flex>22222<br>22222<br>22222\n</div><div flex>33333<br>33333<br>33333</div></div></demo-file></docs-demo><br><hr><h3>Flex Element Heights</h3><p>\nFirefox currently has an issue calculating the proper height of flex containers whose children are flex, but have more content than can properly fit within the container.\n</p><p>This is particularly problematic if the <code>flex</code> children are <code>md-content</code>\n components as it will prevent the content from scrolling correctly, instead scrolling the entire body.</p><div \nclass=\"md-whiteframe-3dp\"><iframe height=\"376\" scrolling=\"no\" \nsrc=\"//codepen.io/team/AngularMaterial/embed/NxKBwW/?height=376&theme-id=0&default-tab=result\" frameborder=\"no\" \nallowtransparency=\"true\" allowfullscreen=\"true\" style=\"width: 100%\">See the Pen <a \nhref=\"http://codepen.io/team/AngularMaterial/pen/NxKBwW/\">AngularJS Material Basic App</a> by AngularJS Material (<a \nhref=\"http://codepen.io/AngularMaterial\">@AngularJSMaterial</a>) on <a href=\"http://codepen.io\">CodePen</a>.</iframe>\n</div><p>Notice in the above Codepen how we must set <code>overflow: auto</code> on the div with the <code>\nchange-my-css</code> class in order for Firefox to properly calculate the height and shrink to the available space.</p>\n</div>");
$templateCache.put("app/main/components/tables/datatable/datatable.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Tables</span></div><div \nclass=\"title\">Datatable</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"https://l-lin.github.io/angular-datatables\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><div \nclass=\"md-title mb-32\">Zero Configuration</div><div class=\"white-bg md-whiteframe-4dp\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Position</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Office</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Age</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Start Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Salary</span></div></th></tr></thead><tbody><tr \nng-repeat=\"employee in ::vm.employees\"><td>{{ employee.name }}</td><td>{{ employee.position }}</td><td>\n{{ employee.office }}</td><td>{{ employee.age }}</td><td>{{ employee.startDate }}</td><td>{{ employee.salary }}</td>\n</tr></tbody></table></div></div></div>");
$templateCache.put("app/main/components/tables/simple-table/simple-table.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Tables</span></div><div \nclass=\"title\">Simple Table</div></div></div><div class=\"content\">\nTables are used to present raw data sets, and usually appear in desktop enterprise products.<p>Data sets may include:\n</p><ul><li>Three or more columns of data</li><li>A corresponding visualization</li><li>\nThe ability for users to query and manipulate data at scale</li></ul><div \nclass=\"simple-table-container md-whiteframe-4dp\"><div class=\"table-title\">Employees</div><table class=\"simple\" \nms-responsive-table><thead><tr><th>Name</th><th>Position</th><th>Office</th><th class=\"text-right\">Age</th><th \nclass=\"text-right\">Start Date</th><th class=\"text-right\">Salary</th></tr></thead><tfoot><tr><td></td></tr></tfoot>\n<tbody><tr ng-repeat=\"person in vm.employees\"><td class=\"name\">{{person.name}}</td><td class=\"position\">\n{{person.position}}</td><td class=\"office\">{{person.office}}</td><td class=\"age text-right\">{{person.age}}</td><td \nclass=\"start-date text-right\">{{person.startDate}}</td><td class=\"salary text-right\">{{person.salary | currency}}</td>\n</tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"FORGOTPASSWORD.TITLE\">Recover your password\n</div><form name=\"forgotPasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"email\" \nname=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" translate=\"FORGOTPASSWORD.SEND_RESET_LINK\" \ntranslate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\">SEND RESET LINK</md-button></form><div class=\"login\" \nlayout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.pages_auth_login\" \ntranslate=\"FORGOTPASSWORD.GO_BACK\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/lock/lock.html","<div id=\"lock\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"lock-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"lock-form\" class=\"md-whiteframe-8dp\"><div layout=\"row\" \nlayout-align=\"start center\" layout-sm=\"column\" layout-align-sm=\"center center\"><div class=\"avatar-container\"><img \nclass=\"avatar big\" src=\"assets/images/avatars/katherine.jpg\"><md-icon md-font-icon=\"icon-lock\" \nclass=\"md-warn-fg s36 md-hue-2\"></md-icon></div><div flex layout=\"column\" layout-align=\"start\" \nlayout-align-sm=\"center center\"><div class=\"title\" translate=\"LOCK.TITLE\">Your session is locked</div><div \nclass=\"subtitle\" translate=\"LOCK.SUBTITLE\">Due to inactivity, your session is locked. Enter your password to continue.\n</div></div></div><form name=\"lockForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input \nng-model=\"vm.form.username\" placeholder=\"Username\" translate translate-attr-placeholder=\"LOCK.USERNAME\" \ndisabled=\"disabled\"></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"LOCK.PASSWORD\" required><div ng-messages=\"lockForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"LOCK.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"UNLOCK\" \nng-disabled=\"lockForm.$invalid || lockForm.$pristine\" translate=\"LOCK.UNLOCK\" translate-attr-aria-label=\"LOCK.UNLOCK\">\nUNLOCK</md-button></form><div class=\"message\"><a ui-sref=\"app.pages_auth_login\" class=\"md-accent-color\"><span \ntranslate=\"LOCK.ARE_YOU_NOT\">Are you not</span><span> Jane Doe?</span></a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>F\n</span></div><div class=\"title\" translate=\"LOGIN.TITLE\">Log in to your account</div><form name=\"loginForm\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nplaceholder=\"Email\" translate translate-attr-placeholder=\"LOGIN.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nplaceholder=\"Password\" translate translate-attr-placeholder=\"LOGIN.PASSWORD\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN.REMEMBER_ME\">Remember Me</span>\n</md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\" \ntranslate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \ntranslate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form><div class=\"separator\"><span\n class=\"text\" translate=\"LOGIN.OR\">OR</span></div><md-button class=\"md-raised google\"><div layout=\"row\" \nlayout-align=\"center center\"><span><md-icon md-font-icon=\"icon-google-plus\" class=\"s16\"></md-icon><span \ntranslate=\"LOGIN.WITH_GOOGLE\">Log in with Google</span></span></div></md-button><md-button class=\"md-raised facebook\">\n<div layout=\"row\" layout-align=\"center center\"><span><md-icon md-font-icon=\"icon-facebook\" class=\"s16\"></md-icon><span \ntranslate=\"LOGIN.WITH_FACEBOOK\">Log in with Facebook</span></span></div></md-button><div class=\"register\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"LOGIN.DONT_HAVE_ACCOUNT\">\nDon\'t have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_register\" translate=\"LOGIN.CREATE_ACCOUNT\">\nCreate an account</a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/login-v2/login-v2.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\"><div id=\"login-v2-intro\" flex hide show-gt-sm><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"LOGIN_V2.INTRO_TITLE\">Welcome to the FUSE!\n</div><div class=\"description\" translate=\"LOGIN_V2.INTRO_DESCRIPTION\">\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.\n</div></div><div id=\"login-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div \nid=\"login-v2-form\"><div class=\"logo md-accent-bg\" hide-gt-sm><span>F</span></div><div class=\"title\" \ntranslate=\"LOGIN_V2.TITLE\">Log in to your account</div><div class=\"description\" translate=\"LOGIN_V2.DESCRIPTION\">\nSed mollis velit facilisis facilisis viverra</div><form name=\"loginForm\" novalidate><md-input-container \nclass=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate \ntranslate-attr-placeholder=\"LOGIN_V2.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN_V2.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"LOGIN_V2.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" placeholder=\"Password\" translate translate-attr-placeholder=\"LOGIN_V2.PASSWORD\" required>\n<div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN_V2.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN_V2.REMEMBER_ME\">Remember Me\n</span></md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\" \ntranslate=\"LOGIN_V2.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \ntranslate=\"LOGIN_V2.LOG_IN\" translate-attr-aria-label=\"LOGIN_V2.LOG_IN\">LOG IN</md-button></form><div \nclass=\"separator\"><span class=\"text\" translate=\"LOGIN_V2.OR\">OR</span></div><div layout=\"column\" \nlayout-align=\"start center\"><md-button class=\"md-raised google\"><div layout=\"row\" layout-align=\"center center\"><span>\n<md-icon md-font-icon=\"icon-google-plus\" class=\"s16\"></md-icon><span translate=\"LOGIN_V2.WITH_GOOGLE\">\nLog in with Google</span></span></div></md-button><md-button class=\"md-raised facebook\"><div layout=\"row\" \nlayout-align=\"center center\"><span><md-icon md-font-icon=\"icon-facebook\" class=\"s16\"></md-icon><span \ntranslate=\"LOGIN_V2.WITH_FACEBOOK\">Log in with Facebook</span></span></div></md-button></div><div class=\"register\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"LOGIN_V2.DONT_HAVE_ACCOUNT\">\nDon\'t have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_register-v2\" translate=\"LOGIN_V2.CREATE_ACCOUNT\">\nCreate an account</a></div></div></div></div>");
$templateCache.put("app/main/pages/errors/404/error-404.html","<div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR404.CODE\">404</div><div class=\"message\" \ntranslate=\"ERROR404.MESSAGE\">Sorry but we couldn’t find the page you are looking for</div><div \nclass=\"search md-whiteframe-1dp\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon><input ng-model=\"vm.search\" type=\"text\" placeholder=\"Search for anything\" translate \ntranslate-attr-placeholder=\"ERROR404.SEARCH\" flex></div><a class=\"back-link md-accent-color\" href=\"/\" \ntranslate=\"ERROR404.GO_BACK\">Go back to dashboard</a></div></div>");
$templateCache.put("app/main/pages/errors/500/error-500.html","<div id=\"error-500\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR500.CODE\">500</div><div class=\"message\" \ntranslate=\"ERROR500.MESSAGE\">Well, you broke the internet!</div><div class=\"sub-message\" \ntranslate=\"ERROR500.SUBMESSAGE\">Just kidding, looks like we have an internal issue, please try again in couple minutes\n</div><a class=\"report-link md-accent-color\" href=\"/\" translate=\"ERROR500.REPORT\">Report this problem</a></div></div>");
$templateCache.put("app/main/pages/auth/register-v2/register-v2.html","<div id=\"register-v2\" layout=\"row\" layout-align=\"start\"><div id=\"register-v2-intro\" flex hide show-gt-sm><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"REGISTER_V2.INTRO_TITLE\">\nWelcome to the FUSE!</div><div class=\"description\" translate=\"REGISTER_V2.INTRO_DESCRIPTION\">\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.\n</div></div><div id=\"register-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" layout=\"column\" flex \nms-scroll><div id=\"register-v2-form\"><div class=\"logo md-accent-bg\" hide-gt-sm><span>F</span></div><div class=\"title\" \ntranslate=\"REGISTER_V2.TITLE\">Create an account</div><div class=\"description\" translate=\"REGISTER_V2.DESCRIPTION\">\nSed mollis velit facilisis facilisis viverra</div><form name=\"registerForm\" novalidate><md-input-container \nclass=\"md-block\" md-no-float><input name=\"username\" ng-model=\"vm.form.username\" placeholder=\"Name\" translate \ntranslate-attr-placeholder=\"REGISTER_V2.NAME\" required><div ng-messages=\"registerForm.username.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.USERNAME_REQUIRED\">Username field is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" \nng-model=\"vm.form.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"REGISTER_V2.EMAIL\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"REGISTER_V2.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"REGISTER_V2.PASSWORD\" required><div ng-messages=\"registerForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.PASSWORD_REQUIRED\">\nPassword field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float>\n<input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" \ntranslate translate-attr-placeholder=\"REGISTER_V2.PASSWORD_CONFIRM\" required><div \nng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER_V2.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div>\n</md-input-container><div class=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" \nng-model=\"data.cb1\" aria-label=\"I read and accept\" required></md-checkbox><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"start center\"><span translate=\"REGISTER_V2.READ_ACCEPT\">I read and accept</span> <a href=\"#\" \nclass=\"md-accent-color\" translate=\"REGISTER_V2.TERMS_COND\">terms and conditions</a></div></div><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER_V2.CREATE_ACCOUNT\" \ntranslate-attr-aria-label=\"REGISTER_V2.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button></form><div class=\"login\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"REGISTER_V2.ALREADY_HAVE\">\nAlready have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_login-v2\" translate=\"REGISTER_V2.LOGIN\">Log in\n</a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/register/register.html","<div id=\"register\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"register-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"register-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>F\n</span></div><div class=\"title\" translate=\"REGISTER.TITLE\">Create an account</div><form name=\"registerForm\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input name=\"username\" ng-model=\"vm.form.username\" placeholder=\"Name\" \ntranslate translate-attr-placeholder=\"REGISTER.NAME\" required><div ng-messages=\"registerForm.username.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.USERNAME_REQUIRED\">Username field is required\n</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"email\" \nname=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"REGISTER.EMAIL\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"REGISTER.PASSWORD\" required><div ng-messages=\"registerForm.password.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" translate \ntranslate-attr-placeholder=\"REGISTER.PASSWORD_CONFIRM\" required><div ng-messages=\"registerForm.passwordConfirm.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">\nPassword (Confirm) field is required</span></div></div></md-input-container><div class=\"terms\" layout=\"row\" \nlayout-align=\"center center\"><md-checkbox name=\"terms\" ng-model=\"data.cb1\" aria-label=\"I read and accept\" required>\n</md-checkbox><div layout=\"row\" layout-sm=\"column\" layout-align=\"start center\"><span translate=\"REGISTER.READ_ACCEPT\">\nI read and accept</span> <a href=\"#\" class=\"md-accent-color\" translate=\"REGISTER.TERMS_COND\">terms and conditions</a>\n</div></div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER.CREATE_ACCOUNT\" \ntranslate-attr-aria-label=\"REGISTER.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button></form><div class=\"login\" \nlayout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"REGISTER.ALREADY_HAVE\">\nAlready have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_login\" translate=\"REGISTER.LOGIN\">Log in</a>\n</div></div></div></div>");
$templateCache.put("app/main/pages/auth/reset-password/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"RESETPASSWORD.TITLE\">Reset your password\n</div><form name=\"resetPasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"email\" \nname=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"resetPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"RESETPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" placeholder=\"Password\" translate translate-attr-placeholder=\"RESETPASSWORD.PASSWORD\" \nrequired><div ng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.PASSWORD_CONFIRM\" required><div \nng-messages=\"resetPasswordForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"UPDATE MY PASSWORD\" ng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\" \ntranslate=\"RESETPASSWORD.UPDATE_PASSWORD\" translate-attr-aria-label=\"RESETPASSWORD.UPDATE_PASSWORD\">RESET MY PASSWORD\n</md-button></form></div></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/main/menu/presupuestos/budget/budget.html","<div id=\"budget\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-products-button md-icon-button\" \naria-label=\"Go to budgets\" ng-click=\"vm.gotoBudgets()\" translate translate-attr-aria-label=\"BG.GO_TO_BUDGETS\"><md-icon \nmd-font-icon=\"icon-arrow-left-bold-circle-outline\" class=\"s32\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\"><span \ntranslate=\"BG.BUDGET\">Budget</span> <span>{{vm.presupuesto.codigo}}</span></div><div class=\"subtitle secondary-text\">\n<span translate=\"BG.BUDGET_DETAIL\">Budget details</span></div></div></div></div><div><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.gotoBudgets()\"><md-icon md-font-icon=\"icon-cancel\" \nclass=\"s30 icon-cancel\"></md-icon><span translate=\"BG.CANCEL\">CANCELAR</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.save()\" ng-disabled=\"budgetForm.$invalid\"><md-icon \nmd-font-icon=\"icon-check-circle\" class=\"s30 icon-check-circle\"></md-icon><span translate=\"BG.SAVE_BUDGET\">\nGUARDAR PRESUPUESTO</span></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h2 text-uppercase\" translate=\"BG.BUDGET_TITLE\">\nDatos generales del presupuesto</span></div><md-content class=\"content grey-100-bg\" flex ms-scroll><form \nname=\"budgetForm\"><div layout=\"row\" flex=\"100\"><div \nclass=\"budget-detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\" flex=\"50\" flex-gt-xs=\"50\" \nflex-gt-md=\"50\"><span class=\"h2 text-uppercase\" translate=\"BG.BUDGET\">PRESUPUESTO</span><div class=\"separadorVertical\">\n</div><div layout=\"row\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><span class=\"negrita\" translate=\"BG.BUDGET_CODE\">\nNúmero de presupuesto</span> <span class=\"negrita\">: {{vm.presupuesto.codigo}}</span></div><div layout=\"row\" \nflex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><md-input-container class=\"md-block\" flex=\"45\" flex-gt-xs=\"45\" \nflex-gt-md=\"45\" ng-show=\"{{vm.mode == \'update\'}}\"><label class=\"blue-900-fg\" translate=\"BG.CUSTOMER_ORDER_NUMBER\">\nNúmero de pedido cliente (PC)</label><input type=\"text\" name=\"numeroPC\" ng-model=\"vm.presupuesto.numeroPC\" \nreadonly=\"readonly\"></md-input-container></div><div class=\"separadorVertical\"></div><div layout=\"row\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><md-input-container class=\"md-block\" flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\"><label\n class=\"blue-900-fg\" translate=\"BG.DATE\">Fecha presupuesto</label><md-datepicker ng-model=\"vm.fechaConFormato\" \nname=\"dtFecha\" md-min-date=\"minDate\" md-max-date=\"maxDate\" required></md-datepicker><div \nng-messages=\"budgetForm.dtFecha.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"valid\"><span \ntranslate=\"BG.ERRORS.INVALID_DATE\">Formato de fecha incorrecto (debe tener el formato \'dd/mm/yyyy\')</span></div><div \nng-message=\"required\"><span translate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container><div flex=\"10\" flex-gt-xs=\"10\" flex-gt-md=\"10\"></div><md-input-container class=\"md-block\" \nflex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\" ng-show=\"{{vm.mode == \'update\'}}\"><label class=\"blue-900-fg\" \ntranslate=\"BG.BUDGET_STATUS\">Estado del presupuesto</label><input type=\"text\" name=\"numeroPC\" \nng-model=\"vm.presupuesto.estado\" readonly=\"readonly\"></md-input-container></div><div class=\"separadorVertical\"></div>\n</div><div layout=\"column\" flex=\"5\"></div><div class=\"budget-detail-form-container md-background-bg md-whiteframe-1dp\" \nflex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\"><span class=\"h2 text-uppercase\" translate=\"BG.SHOP_DATA\">DATOS DE LA TIENDA\n</span><div class=\"separadorVertical\"></div><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"100\" \nflex-gt-md=\"100\"><label class=\"blue-900-fg\" translate=\"BG.SHOP\">Tienda</label><input type=\"text\" name=\"tienda\" \nng-model=\"vm.presupuesto.usuario\" disabled=\"disabled\"></md-input-container><md-input-container class=\"md-block\" \nflex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><label class=\"blue-900-fg\" translate=\"BG.SHOP_PHONE\">Teléfono Tienda\n</label><input type=\"text\" name=\"telefono\" ng-model=\"vm.presupuesto.telefonoTienda\" required><div \nng-messages=\"budgetForm.telefono.$error\" ng-show=\"budgetForm.telefono.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><label \nclass=\"blue-900-fg\" translate=\"BG.ATTENDED_BY\">Atendido por</label><input type=\"text\" name=\"vendedor\" \nng-model=\"vm.presupuesto.vendedor\" required><div ng-messages=\"budgetForm.vendedor.$error\" \nng-show=\"budgetForm.vendedor.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container></div></div><div \nclass=\"separadorVertical\"></div><div layout=\"column\" flex=\"100\"><div \nclass=\"budget-detail-form-container md-background-bg md-whiteframe-1dp\" flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\"><span\n class=\"h2 text-uppercase\" translate=\"BG.CUSTOMER_DATA\">DATOS DEL CLIENTE</span><br><br><md-input-container \nclass=\"md-block\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><label class=\"blue-900-fg\" translate=\"BG.COMPLETE_NAME\">\nNombre completo</label><input type=\"text\" name=\"cliente\" ng-model=\"vm.presupuesto.cliente\" required><div \nng-messages=\"budgetForm.cliente.$error\" ng-show=\"budgetForm.cliente.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container><md-input-container\n class=\"md-block\"><label class=\"blue-900-fg\" translate=\"BG.CUSTOMER_COMMENTS\">Observaciones</label><textarea \nng-model=\"vm.presupuesto.observacionesCliente\" md-maxlength=\"250\" rows=\"5\" md-select-on-focus></textarea>\n</md-input-container></div></div></form></md-content></div></div></div>");
$templateCache.put("app/main/menu/presupuestos/framing-budget/framingBudget.html","<div id=\"framingBudget\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-products-button md-icon-button\" \naria-label=\"Go to budgets\" ng-click=\"vm.gotoBudgets()\" translate translate-attr-aria-label=\"BG.GO_TO_BUDGETS\"><md-icon \nmd-font-icon=\"icon-arrow-left-bold-circle-outline\" class=\"s32\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\"><span \ntranslate=\"BG.BUDGET\">Budget</span> <span>{{vm.presupuestoMarco.codigoPresupuesto}}</span></div><div \nclass=\"subtitle secondary-text\"><span translate=\"BG.BUDGET_DETAIL\">Budget details</span></div></div></div></div><div>\n<md-button class=\"md-raised md-background\" ng-click=\"vm.gotoBudgets()\"><md-icon md-font-icon=\"icon-cancel\" \nclass=\"s30 icon-cancel\"></md-icon><span translate=\"BG.CANCEL\">CANCELAR</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.save(vm.presupuestoMarco,true,$event)\" ng-show=\"vm.budgetCalculated\">\n<md-icon md-font-icon=\"icon-check-circle\" class=\"s30 icon-check-circle\"></md-icon><span translate=\"BG.SAVE_BUDGET\">\nGUARDAR PRESUPUESTO</span></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><md-content \nclass=\"content grey-100-bg\" flex ms-scroll><form name=\"budgetForm\"><div layout=\"row\" flex=\"100\"><div \nclass=\"budget-detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\" flex=\"50\" flex-gt-xs=\"50\" \nflex-gt-md=\"50\"><span class=\"h2 text-uppercase\" translate=\"BG.FRAMING_CONFIG\">CONFIGURACIÓN DE LA ENMARCACION</span>\n<br><md-toolbar class=\"toolbar-height grey-800-bg\"><div class=\"md-toolbar-tools\"><h2 flex md-truncate><span \ntranslate=\"BG.MEASURES\">Medidas</span></h2><md-button class=\"md-icon-button\" aria-label=\"show content\" \nng-click=\"vm.desplegarContraerContenido(vm.desplegadoContenidoMedidas,\'capaMedidas\')\"><md-icon \nmd-font-icon=\"icon-cancel\" class=\"{{vm.iconoDesplegarContraerMedidas}}\"></md-icon><md-tooltip md-direction=\"down\">\n{{vm.textoDesplegarContraerMedidas}}</md-tooltip></md-button></div></md-toolbar><div class=\"blue-grey-50-bg\" \nng-show=\"vm.desplegadoContenidoMedidas\"><div layout=\"column\" class=\"contenidoInteriorCapa\"><md-radio-group \nng-model=\"vm.presupuestoMarco.medidaExteriorValorString\" layout=\"row\" flex><div flex=\"10\" flex-gt-xs=\"10\" \nflex-gt-md=\"10\"></div><md-radio-button value=\"false\" class=\"md-primary\" flex=\"30\" flex-gt-xs=\"30\" flex-gt-md=\"30\" \nng-click=\"vm.resetValoresPresupuesto(\'TODOS_LOS_VALORES\',false)\"><span translate=\"BG.INTERIOR_MEASURE\">Medida interior\n</span></md-radio-button><div flex=\"10\" flex-gt-xs=\"10\" flex-gt-md=\"10\"></div><md-radio-button value=\"true\" flex=\"30\" \nflex-gt-xs=\"30\" flex-gt-md=\"30\" ng-click=\"vm.resetValoresPresupuesto(\'TODOS_LOS_VALORES\',false)\"><span \ntranslate=\"BG.EXTERIOR_MEASURE\">Medida exterior</span></md-radio-button></md-radio-group><div \nclass=\"separadorVertical\"></div><div layout=\"row\" flex><md-input-container class=\"md-block\" flex=\"45\" flex-gt-xs=\"45\" \nflex-gt-md=\"45\"><label class=\"blue-900-fg\" translate=\"BG.MEASURE1\">Medida 1 (cm)</label><input type=\"number\" \nstep=\"0.01\" name=\"width\" ng-model=\"vm.presupuestoMarco.width\" \nng-change=\"vm.resetValoresPresupuesto(\'TODOS_LOS_VALORES\',false)\" required><div ng-messages=\"budgetForm.width.$error\" \nng-show=\"budgetForm.width.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BG.ERRORS.FIELD_REQUIRED\">\nCampo obligatorio</span></div></div></md-input-container><div flex=\"10\" flex-gt-xs=\"10\" flex-gt-md=\"10\"></div>\n<md-input-container class=\"md-block\" flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\"><label class=\"blue-900-fg\" \ntranslate=\"BG.MEASURE2\">Medida 2 (cm)</label><input type=\"number\" step=\"0.01\" name=\"height\" \nng-model=\"vm.presupuestoMarco.height\" ng-change=\"vm.resetValoresPresupuesto(\'TODOS_LOS_VALORES\',false)\" required><div \nng-messages=\"budgetForm.height.$error\" ng-show=\"budgetForm.height.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container></div>\n<md-radio-group ng-model=\"vm.presupuestoMarco.clienteDejaObraValorString\" layout=\"row\" flex><div flex=\"45\" \nflex-gt-xs=\"45\" flex-gt-md=\"45\"><span translate=\"BG.CUSTOMER_LEAVE_WORK_TO_FRAME\">El cliente deja obra para enmarcar\n</span></div><md-radio-button value=\"true\" flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span translate=\"BG.YES\">Sí</span>\n</md-radio-button><md-radio-button value=\"false\" class=\"md-primary\" flex=\"25\" flex-gt-xs=\"25\" flex-gt-md=\"25\"><span \ntranslate=\"BG.NO\">No</span></md-radio-button></md-radio-group><div class=\"separadorVertical\"></div><md-radio-group \nng-model=\"vm.presupuestoMarco.obraConDesperfectosValorString\" layout=\"row\" flex><div flex=\"30\" flex-gt-xs=\"30\" \nflex-gt-md=\"30\"><span translate=\"BG.ARTWORK_STATE\">Estado de la obra:</span></div><md-radio-button value=\"false\" \nclass=\"md-primary\" flex=\"35\" flex-gt-xs=\"35\" flex-gt-md=\"35\"><span translate=\"BG.PERFECT_STATE\">En perfecto estado\n</span></md-radio-button><md-radio-button value=\"true\" flex=\"35\" flex-gt-xs=\"35\" flex-gt-md=\"35\"><span \ntranslate=\"BG.WITH_DAMAGE\">Con defectos</span></md-radio-button></md-radio-group><div class=\"separadorVertical\"></div>\n<md-input-container class=\"md-block\"><label class=\"blue-900-fg\" translate=\"BG.ARTWORK_COMMENTS\">\nObservaciones sobre la obra</label><textarea ng-model=\"vm.presupuestoMarco.observacionesObra\" md-maxlength=\"250\" \nrows=\"3\" md-select-on-focus></textarea></md-input-container><div class=\"separadorVertical\"></div><div layout=\"row\" \nclass=\"navigation-buttons\" layout-align=\"end end\" flex=\"100\"><md-button class=\"md-raised md-grey-800-bg button-width\" \nng-click=\"vm.gotoStep(\'presupuestos\')\"><span><md-icon md-font-icon=\"icon-arrow-left-bold-circle-outline grey-A100-fg\">\n</md-icon></span><span translate=\"BG.BACK\" class=\"grey-A100-fg\">Atrás</span></md-button><md-button \nclass=\"md-raised green-600-bg button-width\" ng-click=\"vm.gotoStep(\'ppt1\')\"><span translate=\"BG.NEXT\" \nclass=\"grey-A100-fg\">Siguiente</span> <span><md-icon md-font-icon=\"icon-arrow-right-bold-circle-outline grey-A100-fg\">\n</md-icon></span></md-button></div></div></div><div class=\"separadorVertical\"></div><md-toolbar \nclass=\"toolbar-height grey-800-bg\"><div class=\"md-toolbar-tools\"><h2 flex md-truncate><span \ntranslate=\"BG.PPT1_SELECTION\">Selección del passe-partout 1</span></h2><md-button class=\"md-icon-button\" \naria-label=\"show content\" ng-click=\"vm.desplegarContraerContenido(vm.desplegadoContenidoPpt1, \'capaPpt1\')\"><md-icon \nmd-font-icon=\"icon-cancel\" class=\"{{vm.iconoDesplegarContraerPpt1}}\"></md-icon><md-tooltip md-direction=\"down\">\n{{vm.textoDesplegarContraerPpt1}}</md-tooltip></md-button></div></md-toolbar><div class=\"blue-grey-50-bg\" \nng-show=\"vm.desplegadoContenidoPpt1\"><div layout=\"column\" class=\"contenidoInteriorCapa\"><div layout=\"row\" flex><div \nflex=\"30\" flex-gt-xs=\"30\" flex-gt-md=\"30\"></div><div flex=\"40\" flex-gt-xs=\"40\" flex-gt-md=\"40\" \nlayout-align=\"center center\"><img id=\"croquisEntrecallePpt1\"></div><div flex=\"30\" flex-gt-xs=\"30\" flex-gt-md=\"30\">\n</div></div><div class=\"separadorVertical\"></div><div layout=\"row\" flex><md-input-container class=\"md-block\" flex=\"45\" \nflex-gt-xs=\"45\" flex-gt-md=\"45\"><label class=\"blue-900-fg\" translate=\"BG.WIDTH_PPT\">Ancho entrecalle (cm)</label><input\n type=\"number\" step=\"0.01\" name=\"widthPpt1\" ng-model=\"vm.presupuestoMarco.widthPpt1\" \nng-change=\"vm.resetValoresPresupuesto(\'PPT2\',true)\"><div ng-messages=\"budgetForm.widthPpt1.$error\" \nng-show=\"budgetForm.widthPpt1.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container><div flex=\"10\" \nflex-gt-xs=\"10\" flex-gt-md=\"10\"></div><md-input-container class=\"md-block\" flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\">\n<label class=\"blue-900-fg\" translate=\"BG.HEIGHT_PPT\">Alto entrecalle (cm)</label><input type=\"number\" step=\"0.01\" \nname=\"heightPpt1\" ng-model=\"vm.presupuestoMarco.heightPpt1\" ng-change=\"vm.resetValoresPresupuesto(\'PPT2\',true)\"><div \nng-messages=\"budgetForm.heightPpt1.$error\" ng-show=\"budgetForm.heightPpt1.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container></div><div layout=\"row\" flex><md-input-container class=\"md-block\" flex=\"40\" flex-gt-xs=\"40\" \nflex-gt-md=\"40\"><label class=\"blue-900-fg\" translate=\"BG.PPT_NUMBER\">Número de Passe-partout</label><input \ntype=\"number\" name=\"numeroPpt1\" ng-model=\"vm.numeroPpt1\" required><div ng-messages=\"budgetForm.numeroPpt1.$error\" \nng-show=\"budgetForm.numeroPpt1.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container><div flex=\"10\" \nflex-gt-xs=\"10\" flex-gt-md=\"10\"></div><md-button class=\"md-raised button-height\" \nng-click=\"vm.insertarPpt1(vm.numeroPpt1)\"><span translate=\"BG.INSERT_PPT\">INSERTAR PASSE-PARTOUT</span></md-button>\n<md-button class=\"md-raised button-height button-width30\" ng-click=\"vm.resetValoresPresupuesto(\'PPT1\',false)\" \naria-label=\"Delete row\" translate translate-attr-aria-label=\"BG.DELETE\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s30 red-500-fg\"></md-icon></md-button></div><div class=\"blue-grey-100-bg tablaMolduras\"><div layout=\"row\" flex>\n<div flex=\"25\" flex-gt-xs=\"25\" flex-gt-md=\"25\"><span class=\"negrita\" translate=\"BG.ARTICLE_NUMBER_ABR\">Nº Art.</span>\n</div><div flex=\"60\" flex-gt-xs=\"60\" flex-gt-md=\"60\"><span class=\"negrita\" translate=\"BG.ARTICLE_DESCRIPTION\">\nDescripción art.</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span class=\"negrita\" translate=\"BG.PVP\">\nPVP</span></div></div><div layout=\"row\" flex><div flex=\"15\" flex-gt-xs=\"25\" flex-gt-md=\"25\"><span>\n{{vm.ppt1Seleccionada.numeroPpt}}</span></div><div flex=\"60\" flex-gt-xs=\"60\" flex-gt-md=\"60\"><span>\n{{vm.ppt1Seleccionada.descripcion}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.ppt1Seleccionada.precioLeroyMerlin}}</span></div></div></div><div class=\"separadorVertical\"></div><div \nlayout=\"row\" flex><md-input-container flex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><md-checkbox \nng-model=\"vm.presupuestoMarco.multiventana\" aria-label=\"Activo\" ng-init=\"vm.presupuestoMarco.multiventana=false\"><span \ntranslate=\"BG.MULTI-WINDOW\">Multi-ventana</span></md-checkbox></md-input-container><md-input-container flex=\"50\" \nflex-gt-xs=\"50\" flex-gt-md=\"50\"><md-checkbox ng-model=\"vm.presupuestoMarco.pptFondo\" aria-label=\"Activo\" \nng-init=\"vm.presupuestoMarco.pptFondo=false\"><span translate=\"BG.PPT_AS_BACKGROUND\">Passe-partout como fondo</span>\n</md-checkbox></md-input-container></div><div class=\"blue-grey-100-bg tablaMolduras\" \nng-show=\"vm.presupuestoMarco.multiventana\"><md-input-container class=\"md-block\" flex=\"30\" flex-gt-xs=\"30\" \nflex-gt-md=\"30\"><label class=\"blue-900-fg\" translate=\"BG.WINDOWS_AMOUNT\">Nº de ventanas</label><input type=\"number\" \nname=\"windowsAmount\" min=\"2\" max=\"10\" ng-model=\"vm.presupuestoMarco.numeroVentanas\"><div \nng-messages=\"budgetForm.windowsAmount.$error\" ng-show=\"budgetForm.windowsAmount.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label class=\"blue-900-fg\" \ntranslate=\"BG.MULTI-WINDOWS_COMMENTS\">Especificaciones de las ventanas del passe-partout</label><textarea \nng-model=\"vm.presupuestoMarco.EspecificacionesVentanas\" md-maxlength=\"250\" rows=\"3\" md-select-on-focus></textarea>\n</md-input-container><div layout=\"row\" flex=\"100\" layout-align=\"start start\"><md-input-container flex=\"50\" \nflex-gt-xs=\"50\" flex-gt-md=\"50\" class=\"md-block\" md-no-float><label class=\"blue-900-fg\" \ntranslate=\"BG.CROQUIS_MULTI-WINDOWS_IMAGE\">Adjuntar imagen con el croquis de las ventanas:</label><input name=\"file\" \nng-model=\"vm.presupuestoMarco.nombreImagenVentanas\"></md-input-container><input type=\"file\" id=\"fileInput\" \nname=\"fileInput\" ng-change=\"vm.handleFileSelect($event)\" class=\"ng-hide\" ngf-select ng-model=\"vm.fileUploaded\" \nngf-accept=\"\'*/*\'\"><div flex=\"5\" flex-gt-xs=\"5\" flex-gt-md=\"5\"></div><md-button class=\"md-raised upload-button\" \nng-click=\"vm.selectFile()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-upload\" class=\"s32\"></md-icon><div class=\"title\" translate=\"BG.UPLOAD_IMAGE\" \ntranslate-attr-aria-label=\"BG.UPLOAD_IMAGE\">SUBIR IMAGEN</div></div></md-button><md-button \nclass=\"md-raised button-height button-width30\" ng-click=\"vm.resetImagenCroquis()\" aria-label=\"Delete row\" translate \ntranslate-attr-aria-label=\"BG.DELETE\"><md-icon md-font-icon=\"icon-delete\" class=\"s30 red-500-fg\"></md-icon></md-button>\n</div></div><div class=\"separadorVertical\"></div><div layout=\"row\" class=\"navigation-buttons\" layout-align=\"end end\" \nflex=\"100\"><md-button class=\"md-raised md-grey-800-bg button-width\" ng-click=\"vm.gotoStep(\'medidas\')\"><span><md-icon \nmd-font-icon=\"icon-arrow-left-bold-circle-outline grey-A100-fg\"></md-icon></span><span translate=\"BG.BACK\" \nclass=\"grey-A100-fg\">Atrás</span></md-button><md-button class=\"md-raised md-grey-800-bg button-width\" \nng-click=\"vm.omitirPaso(\'ppt1\')\"><span translate=\"BG.SKIP\" class=\"grey-A100-fg\">Omitir</span> <span><md-icon \nmd-font-icon=\"icon-cancel grey-A100-fg\"></md-icon></span></md-button><md-button \nclass=\"md-raised green-600-bg button-width\" ng-click=\"vm.gotoStep(\'ppt2\')\" ng-show=\"vm.activarBotonSiguienteParaPpt1\">\n<span translate=\"BG.NEXT\" class=\"grey-A100-fg\">Siguiente</span> <span><md-icon \nmd-font-icon=\"icon-arrow-right-bold-circle-outline grey-A100-fg\"></md-icon></span></md-button></div></div></div><div \nclass=\"separadorVertical\"></div><md-toolbar class=\"toolbar-height grey-800-bg\"><div class=\"md-toolbar-tools\"><h2 flex \nmd-truncate><span translate=\"BG.PPT2_SELECTION\">Selección de passe-partout 2</span></h2><md-button \nclass=\"md-icon-button\" aria-label=\"show content\" \nng-click=\"vm.desplegarContraerContenido(vm.desplegadoContenidoPpt2, \'capaPpt2\')\"><md-icon md-font-icon=\"icon-cancel\" \nclass=\"{{vm.iconoDesplegarContraerPpt2}}\"></md-icon><md-tooltip md-direction=\"down\">{{vm.textoDesplegarContraerPpt2}}\n</md-tooltip></md-button></div></md-toolbar><div class=\"blue-grey-50-bg\" ng-show=\"vm.desplegadoContenidoPpt2\"><div \nlayout=\"column\" class=\"contenidoInteriorCapa\"><div layout=\"row\" flex><div flex=\"30\" flex-gt-xs=\"30\" flex-gt-md=\"30\">\n</div><div flex=\"40\" flex-gt-xs=\"40\" flex-gt-md=\"40\" layout-align=\"center center\"><img id=\"croquisEntrecallePpt2\">\n</div><div flex=\"30\" flex-gt-xs=\"30\" flex-gt-md=\"30\"></div></div><div class=\"separadorVertical\"></div><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\"><label \nclass=\"blue-900-fg\" translate=\"BG.WIDTH_PPT\">Ancho entrecalle (cm)</label><input type=\"number\" step=\"0.01\" \nname=\"widthPpt2\" ng-model=\"vm.presupuestoMarco.widthPpt2\" ng-change=\"vm.resetValoresPresupuesto(\'MOLDURA1\',true)\"><div \nng-messages=\"budgetForm.widthPpt2.$error\" ng-show=\"budgetForm.widthPpt2.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container><div flex=\"10\" flex-gt-xs=\"10\" flex-gt-md=\"10\"></div><md-input-container class=\"md-block\" \nflex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\"><label class=\"blue-900-fg\" translate=\"BG.HEIGHT_PPT\">Alto entrecalle (cm)\n</label><input type=\"number\" step=\"0.01\" name=\"heightPpt2\" ng-model=\"vm.presupuestoMarco.heightPpt2\" \nng-change=\"vm.resetValoresPresupuesto(\'MOLDURA1\',true)\"><div ng-messages=\"budgetForm.heightPpt2.$error\" \nng-show=\"budgetForm.heightPpt2.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container></div><div layout=\"row\" \nflex><md-input-container class=\"md-block\" flex=\"40\" flex-gt-xs=\"40\" flex-gt-md=\"40\"><label class=\"blue-900-fg\" \ntranslate=\"BG.PPT_NUMBER\">Número de passe-partout.</label><input type=\"number\" name=\"numeroPpt2\" \nng-model=\"vm.numeroPpt2\" required><div ng-messages=\"budgetForm.numeroPpt2.$error\" \nng-show=\"budgetForm.numeroPpt2.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container><div flex=\"10\" \nflex-gt-xs=\"10\" flex-gt-md=\"10\"></div><md-button class=\"md-raised button-height\" \nng-click=\"vm.insertarPpt2(vm.numeroPpt2)\"><span translate=\"BG.INSERT_PPT\">INSERTAR PASSE-PARTOUT</span></md-button>\n<md-button class=\"md-raised button-height button-width30\" ng-click=\"vm.resetValoresPresupuesto(\'PPT2\',false)\" \naria-label=\"Delete row\" translate translate-attr-aria-label=\"BG.DELETE\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s30 red-500-fg\"></md-icon></md-button></div><div class=\"blue-grey-100-bg tablaMolduras\"><div layout=\"row\" flex>\n<div flex=\"25\" flex-gt-xs=\"25\" flex-gt-md=\"25\"><span class=\"negrita\" translate=\"BG.ARTICLE_NUMBER_ABR\">Nº Art.</span>\n</div><div flex=\"60\" flex-gt-xs=\"60\" flex-gt-md=\"60\"><span class=\"negrita\" translate=\"BG.ARTICLE_DESCRIPTION\">\nDescripción art.</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span class=\"negrita\" translate=\"BG.PVP\">\nPVP</span></div></div><div layout=\"row\" flex><div flex=\"15\" flex-gt-xs=\"25\" flex-gt-md=\"25\"><span>\n{{vm.ppt2Seleccionada.numeroPpt}}</span></div><div flex=\"60\" flex-gt-xs=\"60\" flex-gt-md=\"60\"><span>\n{{vm.ppt2Seleccionada.descripcion}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.ppt2Seleccionada.precioLeroyMerlin}}</span></div></div></div><div class=\"separadorVertical\"></div><div \nlayout=\"row\" class=\"navigation-buttons\" layout-align=\"end end\" flex=\"100\"><md-button \nclass=\"md-raised md-grey-800-bg button-width\" ng-click=\"vm.gotoStep(\'ppt1\')\"><span><md-icon \nmd-font-icon=\"icon-arrow-left-bold-circle-outline grey-A100-fg\"></md-icon></span><span translate=\"BG.BACK\" \nclass=\"grey-A100-fg\">Atrás</span></md-button><md-button class=\"md-raised md-grey-800-bg button-width\" \nng-click=\"vm.omitirPaso(\'ppt2\')\"><span translate=\"BG.SKIP\" class=\"grey-A100-fg\">Omitir</span> <span><md-icon \nmd-font-icon=\"icon-cancel grey-A100-fg\"></md-icon></span></md-button><md-button \nclass=\"md-raised green-600-bg button-width\" ng-click=\"vm.gotoStep(\'moldura1\')\" \nng-show=\"vm.activarBotonSiguienteParaPpt2\"><span translate=\"BG.NEXT\" class=\"grey-A100-fg\">Siguiente</span> <span>\n<md-icon md-font-icon=\"icon-arrow-right-bold-circle-outline grey-A100-fg\"></md-icon></span></md-button></div></div>\n</div><div class=\"separadorVertical\"></div><md-toolbar class=\"toolbar-height grey-800-bg\"><div \nclass=\"md-toolbar-tools\"><h2 flex md-truncate><span translate=\"BG.MOLDING1_SELECTION\">Selección de moldura 1</span>\n</h2><md-button class=\"md-icon-button\" aria-label=\"show content\" \nng-click=\"vm.desplegarContraerContenido(vm.desplegadoContenidoMoldura1, \'capaMoldura1\')\"><md-icon \nmd-font-icon=\"icon-cancel\" class=\"{{vm.iconoDesplegarContraerMoldura1}}\"></md-icon><md-tooltip md-direction=\"down\">\n{{vm.textoDesplegarContraerMoldura1}}</md-tooltip></md-button></div></md-toolbar><div class=\"blue-grey-50-bg\" \nng-show=\"vm.desplegadoContenidoMoldura1\"><div layout=\"column\" class=\"contenidoInteriorCapa\"><div \nclass=\"separadorVertical\"></div><div class=\"separadorVertical\"></div><div layout=\"row\" flex><md-input-container \nclass=\"md-block\" flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\"><label class=\"blue-900-fg\" translate=\"BG.MOLDING_NUMBER\">\nNúmero de moldura 1</label><input type=\"number\" name=\"numeroMoldura1\" ng-model=\"vm.numeroMoldura1\" required><div \nng-messages=\"budgetForm.numeroMoldura1.$error\" ng-show=\"budgetForm.numeroMoldura1.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container><div flex=\"10\" flex-gt-xs=\"10\" flex-gt-md=\"10\"></div><md-button class=\"md-raised button-height\" \nng-click=\"vm.insertarMoldura1(vm.numeroMoldura1)\"><span translate=\"BG.INSERT_MOLDING\">INSERTAR MOLDURA</span>\n</md-button><md-button class=\"md-raised button-height button-width30\" \nng-click=\"vm.resetValoresPresupuesto(\'MOLDURA1\',false)\" aria-label=\"Delete row\" translate \ntranslate-attr-aria-label=\"BG.DELETE\"><md-icon md-font-icon=\"icon-delete\" class=\"s30 red-500-fg\"></md-icon></md-button>\n</div><div class=\"blue-grey-100-bg tablaMolduras\"><div layout=\"row\" flex><div flex=\"25\" flex-gt-xs=\"25\" \nflex-gt-md=\"25\"><span class=\"negrita\" translate=\"BG.MOLDING_NUMBER_ABR\">Nº Mold.</span></div><div flex=\"60\" \nflex-gt-xs=\"60\" flex-gt-md=\"60\"><span class=\"negrita\" translate=\"BG.MOLDING_DESCRIPTION\">Descripción moldura</span>\n</div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span class=\"negrita\" translate=\"BG.PVP\">PVP</span></div></div>\n<div layout=\"row\" flex><div flex=\"15\" flex-gt-xs=\"25\" flex-gt-md=\"25\"><span>{{vm.moldura1Seleccionada.numeroMoldura}}\n</span></div><div flex=\"60\" flex-gt-xs=\"60\" flex-gt-md=\"60\"><span>{{vm.moldura1Seleccionada.descripcion}}</span></div>\n<div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>{{vm.moldura1Seleccionada.precioLeroyMerlin}}</span></div></div>\n</div><div class=\"separadorVertical\"></div><div layout=\"row\" class=\"navigation-buttons\" layout-align=\"end end\" \nflex=\"100\"><md-button class=\"md-raised md-grey-800-bg button-width\" ng-click=\"vm.gotoStep(\'ppt2\')\"><span><md-icon \nmd-font-icon=\"icon-arrow-left-bold-circle-outline grey-A100-fg\"></md-icon></span><span translate=\"BG.BACK\" \nclass=\"grey-A100-fg\">Atrás</span></md-button><md-button class=\"md-raised green-600-bg button-width\" \nng-click=\"vm.gotoStep(\'moldura2\')\" ng-show=\"vm.activarBotonSiguienteParaMoldura1\"><span translate=\"BG.NEXT\" \nclass=\"grey-A100-fg\">Siguiente</span> <span><md-icon md-font-icon=\"icon-arrow-right-bold-circle-outline grey-A100-fg\">\n</md-icon></span></md-button></div></div></div><div class=\"separadorVertical\"></div><md-toolbar \nclass=\"toolbar-height grey-800-bg\"><div class=\"md-toolbar-tools\"><h2 flex md-truncate><span \ntranslate=\"BG.MOLDING2_SELECTION\">Selección de moldura 2</span></h2><md-button class=\"md-icon-button\" \naria-label=\"show content\" ng-click=\"vm.desplegarContraerContenido(vm.desplegadoContenidoMoldura2, \'capaMoldura2\')\">\n<md-icon md-font-icon=\"icon-cancel\" class=\"{{vm.iconoDesplegarContraerMoldura2}}\"></md-icon><md-tooltip \nmd-direction=\"down\">{{vm.textoDesplegarContraerMoldura2}}</md-tooltip></md-button></div></md-toolbar><div \nclass=\"blue-grey-50-bg\" ng-show=\"vm.desplegadoContenidoMoldura2\"><div layout=\"column\" class=\"contenidoInteriorCapa\">\n<div class=\"separadorVertical\"></div><div class=\"separadorVertical\"></div><div layout=\"row\" flex><md-input-container \nclass=\"md-block\" flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\"><label class=\"blue-900-fg\" translate=\"BG.MOLDING_NUMBER\">\nNúmero de moldura</label><input type=\"number\" name=\"numeroMoldura2\" ng-model=\"vm.numeroMoldura2\" required><div \nng-messages=\"budgetForm.numeroMoldura2.$error\" ng-show=\"budgetForm.numeroMoldura2.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container><div flex=\"10\" flex-gt-xs=\"10\" flex-gt-md=\"10\"></div><md-button class=\"md-raised button-height\" \nng-click=\"vm.insertarMoldura2(vm.numeroMoldura2)\"><span translate=\"BG.INSERT_MOLDING\">INSERTAR MOLDURA</span>\n</md-button><md-button class=\"md-raised button-height button-width30\" \nng-click=\"vm.resetValoresPresupuesto(\'MOLDURA2\',false)\" aria-label=\"Delete row\" translate \ntranslate-attr-aria-label=\"BG.DELETE\"><md-icon md-font-icon=\"icon-delete\" class=\"s30 red-500-fg\"></md-icon></md-button>\n</div><div class=\"blue-grey-100-bg tablaMolduras\"><div layout=\"row\" flex><div flex=\"25\" flex-gt-xs=\"25\" \nflex-gt-md=\"25\"><span class=\"negrita\" translate=\"BG.MOLDING_NUMBER_ABR\">Nº Mold.</span></div><div flex=\"60\" \nflex-gt-xs=\"60\" flex-gt-md=\"60\"><span class=\"negrita\" translate=\"BG.MOLDING_DESCRIPTION\">Descripción moldura</span>\n</div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span class=\"negrita\" translate=\"BG.PVP\">PVP</span></div></div>\n<div layout=\"row\" flex><div flex=\"15\" flex-gt-xs=\"25\" flex-gt-md=\"25\"><span>{{vm.moldura2Seleccionada.numeroMoldura}}\n</span></div><div flex=\"60\" flex-gt-xs=\"60\" flex-gt-md=\"60\"><span>{{vm.moldura2Seleccionada.descripcion}}</span></div>\n<div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>{{vm.moldura2Seleccionada.precioLeroyMerlin}}</span></div></div>\n</div><div class=\"separadorVertical\"></div><div layout=\"row\" class=\"navigation-buttons\" layout-align=\"end end\" \nflex=\"100\"><md-button class=\"md-raised md-grey-800-bg button-width\" ng-click=\"vm.gotoStep(\'moldura1\')\"><span><md-icon \nmd-font-icon=\"icon-arrow-left-bold-circle-outline grey-A100-fg\"></md-icon></span><span translate=\"BG.BACK\" \nclass=\"grey-A100-fg\">Atrás</span></md-button><md-button class=\"md-raised md-grey-800-bg button-width\" \nng-click=\"vm.omitirPaso(\'moldura2\')\"><span translate=\"BG.SKIP\" class=\"grey-A100-fg\">Omitir</span> <span><md-icon \nmd-font-icon=\"icon-cancel grey-A100-fg\"></md-icon></span></md-button><md-button \nclass=\"md-raised green-600-bg button-width\" ng-click=\"vm.gotoStep(\'moldura3\')\" \nng-show=\"vm.activarBotonSiguienteParaMoldura2\"><span translate=\"BG.NEXT\" class=\"grey-A100-fg\">Siguiente</span> <span>\n<md-icon md-font-icon=\"icon-arrow-right-bold-circle-outline grey-A100-fg\"></md-icon></span></md-button></div></div>\n</div><div class=\"separadorVertical\"></div><md-toolbar class=\"toolbar-height grey-800-bg\"><div \nclass=\"md-toolbar-tools\"><h2 flex md-truncate><span translate=\"BG.MOLDING3_SELECTION\">Selección de moldura 3</span>\n</h2><md-button class=\"md-icon-button\" aria-label=\"show content\" \nng-click=\"vm.desplegarContraerContenido(vm.desplegadoContenidoMoldura3, \'capaMoldura3\')\"><md-icon \nmd-font-icon=\"icon-cancel\" class=\"{{vm.iconoDesplegarContraerMoldura3}}\"></md-icon><md-tooltip md-direction=\"down\">\n{{vm.textoDesplegarContraerMoldura3}}</md-tooltip></md-button></div></md-toolbar><div class=\"blue-grey-50-bg\" \nng-show=\"vm.desplegadoContenidoMoldura3\"><div layout=\"column\" class=\"contenidoInteriorCapa\"><div \nclass=\"separadorVertical\"></div><div class=\"separadorVertical\"></div><div layout=\"row\" flex><md-input-container \nclass=\"md-block\" flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\"><label class=\"blue-900-fg\" translate=\"BG.MOLDING_NUMBER\">\nNúmero de moldura</label><input type=\"number\" name=\"numeroMoldura3\" ng-model=\"vm.numeroMoldura3\" required><div \nng-messages=\"budgetForm.numeroMoldura3.$error\" ng-show=\"budgetForm.numeroMoldura3.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container><div flex=\"10\" flex-gt-xs=\"10\" flex-gt-md=\"10\"></div><md-button class=\"md-raised button-height\" \nng-click=\"vm.insertarMoldura3(vm.numeroMoldura3)\"><span translate=\"BG.INSERT_MOLDING\">INSERTAR MOLDURA</span>\n</md-button><md-button class=\"md-raised button-height button-width30\" \nng-click=\"vm.resetValoresPresupuesto(\'MOLDURA3\',false)\" aria-label=\"Delete row\" translate \ntranslate-attr-aria-label=\"BG.DELETE\"><md-icon md-font-icon=\"icon-delete\" class=\"s30 red-500-fg\"></md-icon></md-button>\n</div><div class=\"blue-grey-100-bg tablaMolduras\"><div layout=\"row\" flex><div flex=\"25\" flex-gt-xs=\"25\" \nflex-gt-md=\"25\"><span class=\"negrita\" translate=\"BG.MOLDING_NUMBER_ABR\">Nº Mold.</span></div><div flex=\"60\" \nflex-gt-xs=\"60\" flex-gt-md=\"60\"><span class=\"negrita\" translate=\"BG.MOLDING_DESCRIPTION\">Descripción moldura</span>\n</div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span class=\"negrita\" translate=\"BG.PVP\">PVP</span></div></div>\n<div layout=\"row\" flex><div flex=\"15\" flex-gt-xs=\"25\" flex-gt-md=\"25\"><span>{{vm.moldura3Seleccionada.numeroMoldura}}\n</span></div><div flex=\"60\" flex-gt-xs=\"60\" flex-gt-md=\"60\"><span>{{vm.moldura3Seleccionada.descripcion}}</span></div>\n<div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>{{vm.moldura3Seleccionada.precioLeroyMerlin}}</span></div></div>\n</div><div class=\"separadorVertical\"></div><div layout=\"row\" class=\"navigation-buttons\" layout-align=\"end end\" \nflex=\"100\"><md-button class=\"md-raised md-grey-800-bg button-width\" ng-click=\"vm.gotoStep(\'moldura2\')\"><span><md-icon \nmd-font-icon=\"icon-arrow-left-bold-circle-outline grey-A100-fg\"></md-icon></span><span translate=\"BG.BACK\" \nclass=\"grey-A100-fg\">Atrás</span></md-button><md-button class=\"md-raised md-grey-800-bg button-width\" \nng-click=\"vm.omitirPaso(\'moldura3\')\"><span translate=\"BG.SKIP\" class=\"grey-A100-fg\">Omitir</span> <span><md-icon \nmd-font-icon=\"icon-cancel grey-A100-fg\"></md-icon></span></md-button><md-button \nclass=\"md-raised green-600-bg button-width\" ng-click=\"vm.gotoStep(\'cristalTrasera\')\" \nng-show=\"vm.activarBotonSiguienteParaMoldura3\"><span translate=\"BG.NEXT\" class=\"grey-A100-fg\">Siguiente</span> <span>\n<md-icon md-font-icon=\"icon-arrow-right-bold-circle-outline grey-A100-fg\"></md-icon></span></md-button></div></div>\n</div><div class=\"separadorVertical\"></div><md-toolbar class=\"toolbar-height grey-800-bg\"><div \nclass=\"md-toolbar-tools\"><h2 flex md-truncate><span translate=\"BG.GLASS_AND_BACK_SELECTION\">\nSelección de cristal y trasera</span></h2><md-button class=\"md-icon-button\" aria-label=\"show content\" \nng-click=\"vm.desplegarContraerContenido(vm.desplegadoContenidoCristalTrasera, \'capaCristalTrasera\')\"><md-icon \nmd-font-icon=\"icon-cancel\" class=\"{{vm.iconoDesplegarContraerCristalTrasera}}\"></md-icon><md-tooltip \nmd-direction=\"down\">{{vm.textoDesplegarContraerCristalTrasera}}</md-tooltip></md-button></div></md-toolbar><div \nclass=\"blue-grey-50-bg\" ng-show=\"vm.desplegadoContenidoCristalTrasera\"><div layout=\"column\" \nclass=\"contenidoInteriorCapa\"><div class=\"separadorVertical\"></div><div layout=\"row\" flex \nng-hide=\"vm.ocultarSelectorCristal\"><md-input-container flex=\"30\" flex-gt-xs=\"30\" flex-gt-md=\"30\"><md-checkbox \nng-model=\"vm.presupuestoMarco.dobleCristal\" aria-label=\"Activo\" ng-init=\"vm.presupuestoMarco.dobleCristal=false\" \nng-change=\"vm.reseteaCombosSeleccionCristalYtrasera()\"><span translate=\"BG.DOUBLE_GLASS\">Doble cristal</span>\n</md-checkbox></md-input-container></div><div ng-show=\"!vm.presupuestoMarco.dobleCristal\"><div \nng-hide=\"vm.ocultarSelectorCristal\"><md-input-container class=\"md-block\" flex=\"90\" flex-gt-xs=\"90\" flex-gt-md=\"90\" \nng-show=\"vm.mostrarTodosCristales\"><label class=\"blue-900-fg\" translate=\"BG.GLASS_SELECTION\">Selección del cristal\n</label><md-select name=\"cristal\" placeholder=\"\" ng-model=\"vm.numeroCristal\" \nmd-on-close=\"vm.assignNumeroCristal(vm.numeroCristal)\" required><md-option ng-value=\"cristal.numeroArticulo\" \nng-repeat=\"cristal in vm.cristales\">{{cristal.descripcion}}</md-option></md-select><div \nng-messages=\"budgetForm.cristal.$error\" ng-show=\"budgetForm.cristal.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container><md-input-container\n class=\"md-block\" flex=\"90\" flex-gt-xs=\"90\" flex-gt-md=\"90\" ng-show=\"!vm.mostrarTodosCristales\"><label \nclass=\"blue-900-fg\" translate=\"BG.GLASS_SELECTION\">Selección del cristal</label><md-select name=\"cristal\" \nplaceholder=\"\" ng-model=\"vm.numeroCristal\" md-on-close=\"vm.assignNumeroCristal(vm.numeroCristal)\" required><md-option \nng-value=\"cristal.numeroArticulo\" ng-repeat=\"cristal in vm.cristalesConRestriccion\">{{cristal.descripcion}}</md-option>\n</md-select><div ng-messages=\"budgetForm.cristal.$error\" ng-show=\"budgetForm.cristal.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container></div><div ng-show=\"vm.ocultarSelectorCristal\"><span class=\"h4 red-500-fg\">\nNOTA: Las molduras especiales (nº 17 a 20 y nº 45 a 48) no pueden llevar cristal</span></div><md-input-container \nclass=\"md-block\" flex=\"90\" flex-gt-xs=\"90\" flex-gt-md=\"90\"><label class=\"blue-900-fg\" translate=\"BG.BACK_SELECTION\">\nSelección de la trasera</label><md-select name=\"trasera\" placeholder=\"\" ng-model=\"vm.numeroTrasera\" \nmd-on-close=\"vm.assignNumeroTrasera(vm.numeroTrasera)\" required><md-option ng-value=\"trasera.numeroArticulo\" \nng-repeat=\"trasera in vm.traseras\">{{trasera.descripcion}}</md-option></md-select><div \nng-messages=\"budgetForm.trasera.$error\" ng-show=\"budgetForm.trasera.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container></div><div \nlayout=\"row\" class=\"navigation-buttons\" layout-align=\"end end\" flex=\"100\"><md-button class=\"md-raised button-height\" \nng-click=\"vm.insertarCristalTrasera()\"><span translate=\"BG.INSERT_ARTICLES\">INSERTAR ARTÍCULOS</span></md-button></div>\n<div class=\"separadorVertical\"></div><div layout=\"row\" class=\"navigation-buttons\" layout-align=\"end end\" flex=\"100\">\n<md-button class=\"md-raised md-grey-800-bg button-width\" ng-click=\"vm.gotoStep(\'moldura3\')\"><span><md-icon \nmd-font-icon=\"icon-arrow-left-bold-circle-outline grey-A100-fg\"></md-icon></span><span translate=\"BG.BACK\" \nclass=\"grey-A100-fg\">Atrás</span></md-button><md-button class=\"md-raised green-600-bg button-width\" \nng-click=\"vm.gotoStep(\'unidades\')\" ng-show=\"vm.activarBotonSiguienteParaCristalTrasera\"><span translate=\"BG.NEXT\" \nclass=\"grey-A100-fg\">Siguiente</span> <span><md-icon md-font-icon=\"icon-arrow-right-bold-circle-outline grey-A100-fg\">\n</md-icon></span></md-button></div></div></div><div class=\"separadorVertical\"></div><md-toolbar \nclass=\"toolbar-height grey-800-bg\"><div class=\"md-toolbar-tools\"><h2 flex md-truncate><span \ntranslate=\"BG.NUMBER_OF_UNITS_TO_FRAMING\">Número de unidades a enmarcar</span></h2><md-button class=\"md-icon-button\" \naria-label=\"show content\" ng-click=\"vm.desplegarContraerContenido(vm.desplegadoContenidoUnidades,\'capaUnidades\')\">\n<md-icon md-font-icon=\"icon-cancel\" class=\"{{vm.iconoDesplegarContraerUnidades}}\"></md-icon><md-tooltip \nmd-direction=\"down\">{{vm.textoDesplegarContraerUnidades}}</md-tooltip></md-button></div></md-toolbar><div \nclass=\"blue-grey-50-bg\" ng-show=\"vm.desplegadoContenidoUnidades\"><div layout=\"column\" class=\"contenidoInteriorCapa\">\n<md-input-container class=\"md-block\" flex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><label class=\"blue-900-fg\" \ntranslate=\"BG.NUMBER_OF_UNITS_TO_FRAMING\">Número de unidades a enmarcar</label><input type=\"number\" name=\"unidades\" \nng-model=\"vm.presupuestoMarco.unidades\" ng-change=\"vm.actualizaTotalPresupuesto()\" required><div \nng-messages=\"budgetForm.unidades.$error\" ng-show=\"budgetForm.unidades.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container><div layout=\"row\" class=\"navigation-buttons\" layout-align=\"center end\" flex=\"80\"><md-button \nclass=\"md-raised md-red-900-bg button-width2\" ng-click=\"vm.calculateBudget()\" \nng-show=\"vm.activarBotonCalcularPresupuesto\"><span><md-icon md-font-icon=\"icon-calculator grey-A100-fg\"></md-icon>\n</span><span translate=\"BG.CALCULATE_BUDGET\" class=\"grey-A100-fg\">CALCULAR PRESUPUESTO</span></md-button></div><div \nclass=\"separadorVertical\"></div><div layout=\"row\" class=\"navigation-buttons\" layout-align=\"end end\" flex=\"100\" \nng-show=\"vm.budgetCalculated\"><md-button class=\"md-raised md-grey-800-bg button-width2\" \nng-click=\"vm.gotoStep(\'cristalTrasera\')\"><span><md-icon \nmd-font-icon=\"icon-arrow-left-bold-circle-outline grey-A100-fg\"></md-icon></span><span translate=\"BG.BACK\" \nclass=\"grey-A100-fg\">Atrás</span></md-button><md-button class=\"md-raised md-grey-800-bg button-width2\" \nng-click=\"vm.save(vm.presupuestoMarco,false,$event)\"><span><md-icon \nmd-font-icon=\"icon-plus-circle-outline grey-A100-fg\"></md-icon></span><span translate=\"BG.ADD_OTHER_BUDGET\" \nclass=\"grey-A100-fg\">AÑADIR OTRO PRESUPUESTO</span></md-button><md-button class=\"md-raised green-600-bg button-width2\" \nng-click=\"vm.save(vm.presupuestoMarco,true,$event)\"><span translate=\"BG.FINISH_ORDER\" class=\"grey-A100-fg\">\nFINALIZAR PEDIDO</span> <span><md-icon md-font-icon=\"icon-arrow-right-bold-circle-outline grey-A100-fg\"></md-icon>\n</span></md-button></div></div></div></div><div layout=\"column\" flex=\"5\" flex-gt-xs=\"5\" flex-gt-md=\"5\"></div><div \nclass=\"budget-detail-form-container md-background-bg md-whiteframe-1dp\" flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\"><span\n class=\"h2 text-uppercase\" translate=\"BG.BUDGET_SUMMARY\">RESUMEN DEL PRESUPUESTO</span><br><br><div \nclass=\"blue-grey-50-bg tablaMolduras\"><div layout=\"row\" flex><div flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><span \nclass=\"negrita\" translate=\"BG.ARTICLE_REFERENCE_ABR\">Ref. Art.</span></div><div flex=\"50\" flex-gt-xs=\"50\" \nflex-gt-md=\"50\"><span class=\"negrita\" translate=\"BG.ARTICLE_DESCRIPTION\">Descripción artículo</span></div><div \nflex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span class=\"negrita\" translate=\"BG.MULTIPLIER\">Mult.</span></div><div \nflex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span class=\"negrita\" translate=\"BG.PVP\">PVP</span></div></div><div \nlayout=\"row\" flex ng-show=\"vm.muestraLineaPresupuestoParaPpt1\"><div flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><span>\n{{vm.presupuestoMarco.refLeroyMerlinPpt1}}</span></div><div flex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><span>\n{{vm.presupuestoMarco.descripcionPpt1}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoMarco.multiplicadorPpt1}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoMarco.subtotalPpt1}}</span></div></div><div layout=\"row\" flex \nng-show=\"vm.muestraLineaPresupuestoParaPpt2\"><div flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><span>\n{{vm.presupuestoMarco.refLeroyMerlinPpt2}}</span></div><div flex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><span>\n{{vm.presupuestoMarco.descripcionPpt2}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoMarco.multiplicadorPpt2}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoMarco.subtotalPpt2}}</span></div></div><div layout=\"row\" flex \nng-show=\"vm.muestraLineaPresupuestoParaMoldura1\"><div flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><span>\n{{vm.presupuestoMarco.refLeroyMerlinMoldura1}}</span></div><div flex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><span>\n{{vm.presupuestoMarco.descripcion1}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoMarco.multiplicadorMoldura1}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoMarco.subtotalMoldura1}}</span></div></div><div layout=\"row\" flex \nng-show=\"vm.muestraLineaPresupuestoParaMoldura2\"><div flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><span>\n{{vm.presupuestoMarco.refLeroyMerlinMoldura2}}</span></div><div flex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><span>\n{{vm.presupuestoMarco.descripcion2}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoMarco.multiplicadorMoldura2}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoMarco.subtotalMoldura2}}</span></div></div><div layout=\"row\" flex \nng-show=\"vm.muestraLineaPresupuestoParaMoldura3\"><div flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><span>\n{{vm.presupuestoMarco.refLeroyMerlinMoldura3}}</span></div><div flex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><span>\n{{vm.presupuestoMarco.descripcion3}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoMarco.multiplicadorMoldura3}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoMarco.subtotalMoldura3}}</span></div></div><div layout=\"row\" flex \nng-show=\"vm.muestraLineaPresupuestoParaCristal\"><div flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><span>\n{{vm.presupuestoMarco.refLeroyMerlinCristal}}</span></div><div flex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><span>\n{{vm.presupuestoMarco.descripcionCristal}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoMarco.multiplicadorCristal}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoMarco.subtotalCristal}}</span></div></div><div layout=\"row\" flex \nng-show=\"vm.muestraLineaPresupuestoParaTrasera\"><div flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><span>\n{{vm.presupuestoMarco.refLeroyMerlinTrasera}}</span></div><div flex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><span>\n{{vm.presupuestoMarco.descripcionTrasera}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoMarco.multiplicadorTrasera}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoMarco.subtotalTrasera}}</span></div></div><div layout=\"row\" flex \nng-show=\"vm.muestraLineaPresupuestoParaMultiventana\"><div flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><span>\n{{vm.presupuestoMarco.refLeroyMerlinMultiventana}}</span></div><div flex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><span>\n{{vm.presupuestoMarco.descripcionMultiventana}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoMarco.multiplicadorMultiventana}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoMarco.subtotalMultiventana}}</span></div></div></div><div class=\"separadorVerticalx2\"></div><div \nclass=\"blue-grey-100-bg tablaMolduras\"><div layout=\"row\" flex><div flex=\"65\" flex-gt-xs=\"65\" flex-gt-md=\"65\"></div><div\n flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><span class=\"negrita\" translate=\"BG.SUBTOTAL\">Subtotal</span></div><div \nflex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>{{vm.presupuestoMarco.subtotal}}</span></div></div><div layout=\"row\" \nflex><div flex=\"65\" flex-gt-xs=\"65\" flex-gt-md=\"65\"></div><div flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><span \nclass=\"negrita\">x {{vm.presupuestoMarco.unidades}} unidades</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\">\n<span>{{vm.presupuestoMarco.total}}</span></div></div><div layout=\"row\" flex><div flex=\"65\" flex-gt-xs=\"65\" \nflex-gt-md=\"65\"></div><div flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><span class=\"negrita\" translate=\"BG.VAT\">IVA (21%)\n</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>{{vm.presupuestoMarco.iva}}</span></div></div><div \nlayout=\"row\" flex><div flex=\"65\" flex-gt-xs=\"65\" flex-gt-md=\"65\"></div><div flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\">\n<span class=\"negrita\" translate=\"BG.TOTAL\">TOTAL</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoMarco.totalConIva}}</span></div></div></div><div class=\"separadorVerticalx2\"></div><span \nclass=\"h2 text-uppercase\" translate=\"BG.PRODUCT_DETAIL\">DETALLE DE ARTICULO</span><br><br><div flex=\"45\" \nflex-gt-xs=\"45\" flex-gt-md=\"45\" layout-align=\"center center\" ng-show=\"vm.muestraLineaPresupuestoParaPpt1\"><img \nid=\"pptImage1\"></div><div class=\"separadorVerticalx2\"></div><div flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\" \nlayout-align=\"center center\" ng-show=\"vm.muestraLineaPresupuestoParaPpt2\"><img id=\"pptImage2\"></div><div \nclass=\"separadorVerticalx2\"></div><div layout=\"row\" flex ng-show=\"vm.muestraLineaPresupuestoParaMoldura1\"><div \nflex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\" layout-align=\"center center\"><img id=\"moldingImage1\"></div><div flex=\"10\" \nflex-gt-xs=\"10\" flex-gt-md=\"10\"></div><div flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\" layout-align=\"center center\"><img \nid=\"outlineImage1\"></div></div><div class=\"separadorVerticalx2\"></div><div layout=\"row\" flex \nng-show=\"vm.muestraLineaPresupuestoParaMoldura2\"><div flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\" \nlayout-align=\"center center\"><img id=\"moldingImage2\"></div><div flex=\"10\" flex-gt-xs=\"10\" flex-gt-md=\"10\"></div><div \nflex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\" layout-align=\"center center\"><img id=\"outlineImage2\"></div></div><div \nclass=\"separadorVerticalx2\"></div><div layout=\"row\" flex ng-show=\"vm.muestraLineaPresupuestoParaMoldura3\"><div \nflex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\" layout-align=\"center center\"><img id=\"moldingImage3\"></div><div flex=\"10\" \nflex-gt-xs=\"10\" flex-gt-md=\"10\"></div><div flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\" layout-align=\"center center\"><img \nid=\"outlineImage3\"></div></div></div></div><div class=\"separadorVertical\"></div></form></md-content></div></div></div>");
$templateCache.put("app/main/menu/presupuestos/mirror-budget/mirrorBudget.html","<div id=\"mirrorBudget\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-products-button md-icon-button\" \naria-label=\"Go to budgets\" ng-click=\"vm.gotoBudgets()\" translate translate-attr-aria-label=\"BG.GO_TO_BUDGETS\"><md-icon \nmd-font-icon=\"icon-arrow-left-bold-circle-outline\" class=\"s32\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\"><span \ntranslate=\"BG.BUDGET\">Budget</span> <span>{{vm.presupuestoEspejo.codigoPresupuesto}}</span></div><div \nclass=\"subtitle secondary-text\"><span translate=\"BG.BUDGET_DETAIL\">Budget details</span></div></div></div></div><div>\n<md-button class=\"md-raised md-background\" ng-click=\"vm.gotoBudgets()\"><md-icon md-font-icon=\"icon-cancel\" \nclass=\"s30 icon-cancel\"></md-icon><span translate=\"BG.CANCEL\">CANCELAR</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.save(vm.presupuestoEspejo,true,$event)\" ng-show=\"vm.budgetCalculated\">\n<md-icon md-font-icon=\"icon-check-circle\" class=\"s30 icon-check-circle\"></md-icon><span translate=\"BG.SAVE_BUDGET\">\nGUARDAR PRESUPUESTO</span></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><md-content \nclass=\"content grey-100-bg\" flex ms-scroll><form name=\"budgetForm\"><div layout=\"row\" flex=\"100\"><div \nclass=\"budget-detail-form-container md-background-bg md-whiteframe-1dp\" layout=\"column\" flex=\"50\" flex-gt-xs=\"50\" \nflex-gt-md=\"50\"><span class=\"h2 text-uppercase\" translate=\"BG.MIRROR_CONFIG\">CONFIGURACIÓN DEL ESPEJO</span><br>\n<md-toolbar class=\"toolbar-height grey-800-bg\"><div class=\"md-toolbar-tools\"><h2 flex md-truncate><span \ntranslate=\"BG.MEASURES\">Medidas</span></h2><md-button class=\"md-icon-button\" aria-label=\"show content\" \nng-click=\"vm.desplegarContraerContenido(vm.desplegadoContenidoMedidas,\'capaMedidas\')\"><md-icon \nmd-font-icon=\"icon-cancel\" class=\"{{vm.iconoDesplegarContraerMedidas}}\"></md-icon><md-tooltip md-direction=\"down\">\n{{vm.textoDesplegarContraerMedidas}}</md-tooltip></md-button></div></md-toolbar><div class=\"blue-grey-50-bg\" \nng-show=\"vm.desplegadoContenidoMedidas\"><div layout=\"column\" class=\"contenidoInteriorCapa\"><md-radio-group \nng-model=\"vm.presupuestoEspejo.medidaExteriorValorString\" layout=\"row\" flex><div flex=\"10\" flex-gt-xs=\"10\" \nflex-gt-md=\"10\"></div><md-radio-button value=\"true\" flex=\"30\" flex-gt-xs=\"30\" flex-gt-md=\"30\" \nng-click=\"vm.resetValoresPresupuesto(\'TODAS_LAS_MOLDURAS\',false)\"><span translate=\"BG.EXTERIOR_MEASURE\">Medida exterior\n</span></md-radio-button><div flex=\"10\" flex-gt-xs=\"10\" flex-gt-md=\"10\"></div><md-radio-button value=\"false\" \nclass=\"md-primary\" flex=\"30\" flex-gt-xs=\"30\" flex-gt-md=\"30\" \nng-click=\"vm.resetValoresPresupuesto(\'TODAS_LAS_MOLDURAS\',false)\"><span translate=\"BG.INTERIOR_MEASURE\">Medida interior\n</span></md-radio-button></md-radio-group><div class=\"separadorVertical\"></div><div layout=\"row\" flex>\n<md-input-container class=\"md-block\" flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\"><label class=\"blue-900-fg\" \ntranslate=\"BG.MEASURE1\">Medida 1 (cm)</label><input type=\"number\" step=\"0.01\" name=\"width\" \nng-model=\"vm.presupuestoEspejo.width\" ng-change=\"vm.resetValoresPresupuesto(\'TODAS_LAS_MOLDURAS\',false)\" required><div \nng-messages=\"medidasForm.width.$error\" ng-show=\"medidasForm.width.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container><div flex=\"10\" \nflex-gt-xs=\"10\" flex-gt-md=\"10\"></div><md-input-container class=\"md-block\" flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\">\n<label class=\"blue-900-fg\" translate=\"BG.MEASURE2\">Medida 2 (cm)</label><input type=\"number\" step=\"0.01\" name=\"height\" \nng-model=\"vm.presupuestoEspejo.height\" ng-change=\"vm.resetValoresPresupuesto(\'TODAS_LAS_MOLDURAS\',false)\" required><div\n ng-messages=\"medidasForm.height.$error\" ng-show=\"medidasForm.height.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container></div><div \nlayout=\"row\" class=\"navigation-buttons\" layout-align=\"end end\" flex=\"100\"><md-button class=\"md-raised button-height\" \nng-click=\"vm.insertarEspejo()\"><span translate=\"BG.INSERT_MIRROR\">INSERTAR ESPEJO</span></md-button></div><div \nclass=\"separadorVertical\"></div><div layout=\"row\" class=\"navigation-buttons\" layout-align=\"end end\" flex=\"100\">\n<md-button class=\"md-raised md-grey-800-bg button-width\" ng-click=\"vm.gotoStep(\'presupuestos\')\"><span><md-icon \nmd-font-icon=\"icon-arrow-left-bold-circle-outline grey-A100-fg\"></md-icon></span><span translate=\"BG.BACK\" \nclass=\"grey-A100-fg\">Atrás</span></md-button><md-button class=\"md-raised green-600-bg button-width\" \nng-click=\"vm.gotoStep(\'moldura1\')\" ng-show=\"vm.activarBotonSiguienteParaMedidas\"><span translate=\"BG.NEXT\" \nclass=\"grey-A100-fg\">Siguiente</span> <span><md-icon md-font-icon=\"icon-arrow-right-bold-circle-outline grey-A100-fg\">\n</md-icon></span></md-button></div></div></div><div class=\"separadorVertical\"></div><md-toolbar \nclass=\"toolbar-height grey-800-bg\"><div class=\"md-toolbar-tools\"><h2 flex md-truncate><span \ntranslate=\"BG.MOLDING1_SELECTION\">Selección de moldura 1</span></h2><md-button class=\"md-icon-button\" \naria-label=\"show content\" ng-click=\"vm.desplegarContraerContenido(vm.desplegadoContenidoMoldura1, \'capaMoldura1\')\">\n<md-icon md-font-icon=\"icon-cancel\" class=\"{{vm.iconoDesplegarContraerMoldura1}}\"></md-icon><md-tooltip \nmd-direction=\"down\">{{vm.textoDesplegarContraerMoldura1}}</md-tooltip></md-button></div></md-toolbar><div \nclass=\"blue-grey-50-bg\" ng-show=\"vm.desplegadoContenidoMoldura1\"><div layout=\"column\" class=\"contenidoInteriorCapa\">\n<div layout=\"row\" flex><md-input-container class=\"md-block\" flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\"><label \nclass=\"blue-900-fg\" translate=\"BG.MOLDING_NUMBER\">Número de moldura 1</label><input type=\"number\" \nname=\"numeroMoldura1\" ng-model=\"vm.numeroMoldura1\" ng-change=\"vm.resetValoresPresupuesto(\'MOLDURA2\',false)\" required>\n<div ng-messages=\"budgetForm.numeroMoldura1.$error\" ng-show=\"budgetForm.numeroMoldura1.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container><div flex=\"10\" flex-gt-xs=\"10\" flex-gt-md=\"10\"></div><md-button class=\"md-raised button-height\" \nng-click=\"vm.insertarMoldura1(vm.numeroMoldura1)\"><span translate=\"BG.INSERT_MOLDING\">INSERTAR MOLDURA</span>\n</md-button><md-button class=\"md-raised button-height button-width30\" \nng-click=\"vm.resetValoresPresupuesto(\'MOLDURA1\',false)\" aria-label=\"Delete row\" translate \ntranslate-attr-aria-label=\"BG.DELETE\"><md-icon md-font-icon=\"icon-delete\" class=\"s30 red-500-fg\"></md-icon></md-button>\n</div><div class=\"blue-grey-100-bg tablaMolduras\"><div layout=\"row\" flex><div flex=\"25\" flex-gt-xs=\"25\" \nflex-gt-md=\"25\"><span class=\"negrita\" translate=\"BG.MOLDING_NUMBER_ABR\">Nº Mold.</span></div><div flex=\"60\" \nflex-gt-xs=\"60\" flex-gt-md=\"60\"><span class=\"negrita\" translate=\"BG.MOLDING_DESCRIPTION\">Descripción moldura</span>\n</div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span class=\"negrita\" translate=\"BG.PVP\">PVP</span></div></div>\n<div layout=\"row\" flex><div flex=\"15\" flex-gt-xs=\"25\" flex-gt-md=\"25\"><span>{{vm.moldura1Seleccionada.numeroMoldura}}\n</span></div><div flex=\"60\" flex-gt-xs=\"60\" flex-gt-md=\"60\"><span>{{vm.moldura1Seleccionada.descripcion}}</span></div>\n<div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>{{vm.moldura1Seleccionada.precioLeroyMerlin}}</span></div></div>\n</div><div class=\"separadorVertical\"></div><div layout=\"row\" class=\"navigation-buttons\" layout-align=\"end end\" \nflex=\"100\"><md-button class=\"md-raised md-grey-800-bg button-width\" ng-click=\"vm.gotoStep(\'medidas\')\"><span><md-icon \nmd-font-icon=\"icon-arrow-left-bold-circle-outline grey-A100-fg\"></md-icon></span><span translate=\"BG.BACK\" \nclass=\"grey-A100-fg\">Atrás</span></md-button><md-button class=\"md-raised green-600-bg button-width\" \nng-click=\"vm.gotoStep(\'moldura2\')\" ng-show=\"vm.activarBotonSiguienteParaMoldura1\"><span translate=\"BG.NEXT\" \nclass=\"grey-A100-fg\">Siguiente</span> <span><md-icon md-font-icon=\"icon-arrow-right-bold-circle-outline grey-A100-fg\">\n</md-icon></span></md-button></div></div></div><div class=\"separadorVertical\"></div><md-toolbar \nclass=\"toolbar-height grey-800-bg\"><div class=\"md-toolbar-tools\"><h2 flex md-truncate><span \ntranslate=\"BG.MOLDING2_SELECTION\">Selección de moldura 2</span></h2><md-button class=\"md-icon-button\" \naria-label=\"show content\" ng-click=\"vm.desplegarContraerContenido(vm.desplegadoContenidoMoldura2, \'capaMoldura2\')\">\n<md-icon md-font-icon=\"icon-cancel\" class=\"{{vm.iconoDesplegarContraerMoldura2}}\"></md-icon><md-tooltip \nmd-direction=\"down\">{{vm.textoDesplegarContraerMoldura2}}</md-tooltip></md-button></div></md-toolbar><div \nclass=\"blue-grey-50-bg\" ng-show=\"vm.desplegadoContenidoMoldura2\"><div layout=\"column\" class=\"contenidoInteriorCapa\">\n<div layout=\"row\" flex><md-input-container class=\"md-block\" flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\"><label \nclass=\"blue-900-fg\" translate=\"BG.MOLDING_NUMBER\">Número de moldura</label><input type=\"number\" name=\"numeroMoldura2\" \nng-model=\"vm.numeroMoldura2\" required><div ng-messages=\"budgetForm.numeroMoldura2.$error\" \nng-show=\"budgetForm.numeroMoldura2.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container><div flex=\"10\" \nflex-gt-xs=\"10\" flex-gt-md=\"10\"></div><md-button class=\"md-raised button-height\" \nng-click=\"vm.insertarMoldura2(vm.numeroMoldura2)\"><span translate=\"BG.INSERT_MOLDING\">INSERTAR MOLDURA</span>\n</md-button><md-button class=\"md-raised button-height button-width30\" \nng-click=\"vm.resetValoresPresupuesto(\'MOLDURA2\',false)\" aria-label=\"Delete row\" translate \ntranslate-attr-aria-label=\"BG.DELETE\"><md-icon md-font-icon=\"icon-delete\" class=\"s30 red-500-fg\"></md-icon></md-button>\n</div><div class=\"blue-grey-100-bg tablaMolduras\"><div layout=\"row\" flex><div flex=\"25\" flex-gt-xs=\"25\" \nflex-gt-md=\"25\"><span class=\"negrita\" translate=\"BG.MOLDING_NUMBER_ABR\">Nº Mold.</span></div><div flex=\"60\" \nflex-gt-xs=\"60\" flex-gt-md=\"60\"><span class=\"negrita\" translate=\"BG.MOLDING_DESCRIPTION\">Descripción moldura</span>\n</div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span class=\"negrita\" translate=\"BG.PVP\">PVP</span></div></div>\n<div layout=\"row\" flex><div flex=\"15\" flex-gt-xs=\"25\" flex-gt-md=\"25\"><span>{{vm.moldura2Seleccionada.numeroMoldura}}\n</span></div><div flex=\"60\" flex-gt-xs=\"60\" flex-gt-md=\"60\"><span>{{vm.moldura2Seleccionada.descripcion}}</span></div>\n<div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>{{vm.moldura2Seleccionada.precioLeroyMerlin}}</span></div></div>\n</div><div class=\"separadorVertical\"></div><div layout=\"row\" class=\"navigation-buttons\" layout-align=\"end end\" \nflex=\"100\"><md-button class=\"md-raised md-grey-800-bg button-width\" ng-click=\"vm.gotoStep(\'moldura1\')\"><span><md-icon \nmd-font-icon=\"icon-arrow-left-bold-circle-outline grey-A100-fg\"></md-icon></span><span translate=\"BG.BACK\" \nclass=\"grey-A100-fg\">Atrás</span></md-button><md-button class=\"md-raised md-grey-800-bg button-width\" \nng-click=\"vm.omitirPaso(\'moldura2\')\"><span translate=\"BG.SKIP\" class=\"grey-A100-fg\">Omitir</span> <span><md-icon \nmd-font-icon=\"icon-cancel grey-A100-fg\"></md-icon></span></md-button><md-button \nclass=\"md-raised green-600-bg button-width\" ng-click=\"vm.gotoStep(\'unidades\')\" \nng-show=\"vm.activarBotonSiguienteParaMoldura2\"><span translate=\"BG.NEXT\" class=\"grey-A100-fg\">Siguiente</span> <span>\n<md-icon md-font-icon=\"icon-arrow-right-bold-circle-outline grey-A100-fg\"></md-icon></span></md-button></div></div>\n</div><div class=\"separadorVertical\"></div><md-toolbar class=\"toolbar-height grey-800-bg\"><div \nclass=\"md-toolbar-tools\"><h2 flex md-truncate><span translate=\"BG.NUMBER_OF_UNITS_TO_FRAMING\">\nNúmero de unidades a enmarcar</span></h2><md-button class=\"md-icon-button\" aria-label=\"show content\" \nng-click=\"vm.desplegarContraerContenido(vm.desplegadoContenidoUnidades,\'capaUnidades\')\"><md-icon \nmd-font-icon=\"icon-cancel\" class=\"{{vm.iconoDesplegarContraerUnidades}}\"></md-icon><md-tooltip md-direction=\"down\">\n{{vm.textoDesplegarContraerUnidades}}</md-tooltip></md-button></div></md-toolbar><div class=\"blue-grey-50-bg\" \nng-show=\"vm.desplegadoContenidoUnidades\"><div layout=\"column\" class=\"contenidoInteriorCapa\"><md-input-container \nclass=\"md-block\" flex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><label class=\"blue-900-fg\" \ntranslate=\"BG.NUMBER_OF_UNITS_TO_FRAMING\">Número de unidades a enmarcar</label><input type=\"number\" name=\"unidades\" \nng-model=\"vm.presupuestoEspejo.unidades\" ng-change=\"vm.actualizaTotalPresupuesto()\" required><div \nng-messages=\"budgetForm.unidades.$error\" ng-show=\"budgetForm.unidades.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container><div layout=\"row\" class=\"navigation-buttons\" layout-align=\"center end\" flex=\"80\"><md-button \nclass=\"md-raised md-red-900-bg button-width2\" ng-click=\"vm.calculateBudget()\" \nng-show=\"vm.activarBotonCalcularPresupuesto\"><span><md-icon md-font-icon=\"icon-calculator grey-A100-fg\"></md-icon>\n</span><span translate=\"BG.CALCULATE_BUDGET\" class=\"grey-A100-fg\">CALCULAR PRESUPUESTO</span></md-button></div><div \nclass=\"separadorVertical\"></div><div layout=\"row\" class=\"navigation-buttons\" layout-align=\"end end\" flex=\"100\" \nng-show=\"vm.budgetCalculated\"><md-button class=\"md-raised md-grey-800-bg button-width2\" \nng-click=\"vm.gotoStep(\'moldura2\')\"><span><md-icon md-font-icon=\"icon-arrow-left-bold-circle-outline grey-A100-fg\">\n</md-icon></span><span translate=\"BG.BACK\" class=\"grey-A100-fg\">Atrás</span></md-button><md-button \nclass=\"md-raised md-grey-800-bg button-width2\" ng-click=\"vm.save(vm.presupuestoEspejo,false,$event)\"><span><md-icon \nmd-font-icon=\"icon-arrow-left-bold-circle-outline grey-A100-fg\"></md-icon></span><span translate=\"BG.ADD_OTHER_BUDGET\" \nclass=\"grey-A100-fg\">AÑADIR OTRO PRESUPUESTO</span></md-button><md-button class=\"md-raised green-600-bg button-width2\" \nng-click=\"vm.save(vm.presupuestoEspejo,true,$event)\"><span translate=\"BG.FINISH_ORDER\" class=\"grey-A100-fg\">\nFINALIZAR PEDIDO</span> <span><md-icon md-font-icon=\"icon-arrow-right-bold-circle-outline grey-A100-fg\"></md-icon>\n</span></md-button></div></div></div></div><div layout=\"column\" flex=\"5\" flex-gt-xs=\"5\" flex-gt-md=\"5\"></div><div \nclass=\"budget-detail-form-container md-background-bg md-whiteframe-1dp\" flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\"><span\n class=\"h2 text-uppercase\" translate=\"BG.BUDGET_SUMMARY\">RESUMEN DEL PRESUPUESTO</span><br><br><div \nclass=\"blue-grey-50-bg tablaMolduras\"><div layout=\"row\" flex><div flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><span \nclass=\"negrita\" translate=\"BG.ARTICLE_REFERENCE_ABR\">Ref. Art.</span></div><div flex=\"50\" flex-gt-xs=\"50\" \nflex-gt-md=\"50\"><span class=\"negrita\" translate=\"BG.ARTICLE_DESCRIPTION\">Descripción artículo</span></div><div \nflex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span class=\"negrita\" translate=\"BG.MULTIPLIER\">Mult.</span></div><div \nflex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span class=\"negrita\" translate=\"BG.PVP\">PVP</span></div></div><div \nlayout=\"row\" flex ng-show=\"vm.muestraLineaPresupuestoParaEspejo\"><div flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><span>\n{{vm.presupuestoEspejo.refLeroyMerlinEspejo}}</span></div><div flex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><span>\n{{vm.presupuestoEspejo.descripcionEspejo}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoEspejo.multiplicadorEspejo}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoEspejo.subtotalEspejo}}</span></div></div><div layout=\"row\" flex \nng-show=\"vm.muestraLineaPresupuestoParaTrasera\"><div flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><span>\n{{vm.presupuestoEspejo.refLeroyMerlinTrasera}}</span></div><div flex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><span>\n{{vm.presupuestoEspejo.descripcionTrasera}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoEspejo.multiplicadorTrasera}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoEspejo.subtotalTrasera}}</span></div></div><div layout=\"row\" flex \nng-show=\"vm.muestraLineaPresupuestoParaMoldura1\"><div flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><span>\n{{vm.presupuestoEspejo.refLeroyMerlinMoldura1}}</span></div><div flex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><span>\n{{vm.presupuestoEspejo.descripcion1}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoEspejo.multiplicadorMoldura1}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoEspejo.subtotalMoldura1}}</span></div></div><div layout=\"row\" flex \nng-show=\"vm.muestraLineaPresupuestoParaMoldura2\"><div flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><span>\n{{vm.presupuestoEspejo.refLeroyMerlinMoldura2}}</span></div><div flex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><span>\n{{vm.presupuestoEspejo.descripcion2}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoEspejo.multiplicadorMoldura2}}</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoEspejo.subtotalMoldura2}}</span></div></div></div><div class=\"separadorVerticalx2\"></div><div \nclass=\"blue-grey-100-bg tablaMolduras\"><div layout=\"row\" flex><div flex=\"65\" flex-gt-xs=\"65\" flex-gt-md=\"65\"></div><div\n flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><span class=\"negrita\" translate=\"BG.SUBTOTAL\">Subtotal</span></div><div \nflex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>{{vm.presupuestoEspejo.subtotal}}</span></div></div><div layout=\"row\" \nflex><div flex=\"65\" flex-gt-xs=\"65\" flex-gt-md=\"65\"></div><div flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><span \nclass=\"negrita\">x {{vm.presupuestoEspejo.unidades}} unidades</span></div><div flex=\"15\" flex-gt-xs=\"15\" \nflex-gt-md=\"15\"><span>{{vm.presupuestoEspejo.total}}</span></div></div><div layout=\"row\" flex><div flex=\"65\" \nflex-gt-xs=\"65\" flex-gt-md=\"65\"></div><div flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><span class=\"negrita\" \ntranslate=\"BG.VAT\">IVA (21%)</span></div><div flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>\n{{vm.presupuestoEspejo.iva}}</span></div></div><div layout=\"row\" flex><div flex=\"65\" flex-gt-xs=\"65\" flex-gt-md=\"65\">\n</div><div flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><span class=\"negrita\" translate=\"BG.TOTAL\">TOTAL</span></div><div \nflex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\"><span>{{vm.presupuestoEspejo.totalConIva}}</span></div></div></div><div \nclass=\"separadorVerticalx2\"></div><span class=\"h2 text-uppercase\" translate=\"BG.PRODUCT_DETAIL\">DETALLE DE ARTICULO\n</span><br><br><div layout=\"row\" flex ng-show=\"vm.muestraLineaPresupuestoParaMoldura1\"><div flex=\"45\" flex-gt-xs=\"45\" \nflex-gt-md=\"45\" layout-align=\"center center\"><img id=\"moldingImage1\"></div><div flex=\"10\" flex-gt-xs=\"10\" \nflex-gt-md=\"10\"></div><div flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\" layout-align=\"center center\"><img \nid=\"outlineImage1\"></div></div><div class=\"separadorVerticalx2\"></div><div layout=\"row\" flex \nng-show=\"vm.muestraLineaPresupuestoParaMoldura2\"><div flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\" \nlayout-align=\"center center\"><img id=\"moldingImage2\"></div><div flex=\"10\" flex-gt-xs=\"10\" flex-gt-md=\"10\"></div><div \nflex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\" layout-align=\"center center\"><img id=\"outlineImage2\"></div></div></div></div>\n<div class=\"separadorVertical\"></div></form></md-content></div></div></div>");
$templateCache.put("app/main/menu/presupuestos/budgets/budgets.html","<div id=\"budgets\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cart-outline\" class=\"s30 icon-cart-outline\"></md-icon><span translate=\"BG.BUDGETS\">\nPresupuestos</span></div><div class=\"order-count secondary-text\"><span translate=\"BG.TOTAL_BUDGETS\">Total presupuestos:\n</span> <span>{{vm.totalPresupuestos}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" \nflex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"budgets-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"BG.SEARCH\" flex></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-input-container class=\"md-block white-fg\"><div \nclass=\"white-fg secondary-text\"><span translate=\"BG.NUMBER_OF_RECORDS\">Nº de registros a mostrar</span></div><md-select\n ng-if=\"vm.role == \'administrator\'\" name=\"numeroRegistros\" ng-model=\"vm.numeroRegistros\" \nng-change=\"vm.getPresupuestos(vm.numeroRegistros)\"><md-option ng-value=\"100\" ng-selected=\"true\">100 registros\n</md-option><md-option ng-value=\"250\">250 registros</md-option><md-option ng-value=\"500\">500 registros</md-option>\n<md-option ng-value=\"1000000\">TODOS los registros</md-option></md-select><md-select ng-if=\"vm.role == \'user\'\" \nname=\"numeroRegistros\" ng-model=\"vm.numeroRegistros\" \nng-change=\"vm.getPresupuestosOfUsuario(vm.userKey,vm.numeroRegistros)\"><md-option ng-value=\"100\" ng-selected=\"true\">\n100 registros</md-option><md-option ng-value=\"250\">250 registros</md-option><md-option ng-value=\"500\">500 registros\n</md-option><md-option ng-value=\"1000000\">TODOS los registros</md-option></md-select></md-input-container></div><div>\n<md-button class=\"md-raised md-background\" ng-click=\"vm.gotoAddBudget()\"><span><md-icon \nmd-font-icon=\"icon-plus-circle-outline\" class=\"s30 icon-plus-circle-outline\"></md-icon></span><span \ntranslate=\"BG.ADD_BUDGET\">Añadir Presupuesto</span></md-button></div></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr class=\"md-grey-100-bg\"><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Nº PRESUP.</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Fecha</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cliente</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Tipo</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Uds</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Importe</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Tienda</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Nº PC</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Estado</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"></span></div></th></tr></thead><tbody><tr \nng-repeat=\"presupuesto in vm.presupuestos\"><td>{{presupuesto.codigoPresupuesto}}</td><td class=\"date\">\n{{presupuesto.fechaTimestamp | date:\'dd/MM/yyyy\'}}</td><td>{{presupuesto.cliente}}</td><td>{{presupuesto.tipo}}</td>\n<td>{{presupuesto.unidades}}</td><td>{{presupuesto.importe}}</td><td>{{presupuesto.usuario}}</td><td>\n{{presupuesto.numeroPC}}</td><td><md-button class=\"md-icon-button\" \nng-click=\"vm.showMenuDialogEstado($event,presupuesto.presupuesto_key,presupuesto.estado,presupuesto.numeroPD,presupuesto.numeroPC)\" \naria-label=\"Edit budget\" translate translate-attr-aria-label=\"BG.BUDGET_EDIT\"><div \nng-if=\"presupuesto.estado == \'Pendiente\'\"><md-icon md-font-icon=\"icon-help-circle\"></md-icon></div><div \nng-if=\"presupuesto.estado == \'Aprobado\'\"><md-icon md-font-icon=\"icon-checkbox-marked-circle \" class=\"green-500-fg\">\n</md-icon></div><div ng-if=\"presupuesto.estado == \'Anulado\'\"><md-icon md-font-icon=\"icon-cancel\" class=\"red-500-fg\">\n</md-icon></div></md-button></td><td><md-button class=\"md-icon-button\" \nng-click=\"vm.gotoBudgetDetail(presupuesto.presupuesto_key)\" aria-label=\"Edit budget\" translate \ntranslate-attr-aria-label=\"BG.BUDGET_EDIT\"><md-icon md-font-icon=\"icon-pencil-box-outline\" class=\"s25 blue-500-fg\">\n</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.copyBudget(presupuesto.presupuesto_key)\" \naria-label=\"User details\" translate translate-attr-aria-label=\"BG.BUDGET_COPY\"><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s25\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.showConfirmDeleteDialog($event,presupuesto.$id)\" aria-label=\"Budget delete\" translate \ntranslate-attr-aria-label=\"BG.DELETE\" ng-if=\"vm.role == \'administrator\'\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s25 red-500-fg\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.printOrderDialog($event,presupuesto.presupuesto_key,presupuesto.numeroPC)\" aria-label=\"User details\" \ntranslate translate-attr-aria-label=\"BG.BUDGET_COPY\"><md-icon md-font-icon=\"icon-printer\" class=\"s25\"></md-icon>\n</md-button><md-button class=\"md-icon-button-go\" \nng-click=\"vm.showMenuDialog($event,presupuesto.presupuesto_key,presupuesto.tipo)\" \nng-if=\"(vm.role == \'administrator\') || (presupuesto.estado==\'Pendiente\')\"><md-icon \nmd-font-icon=\"icon-arrow-right-bold-circle-outline\" class=\"s36 green-600-fg\"></md-icon></md-button></td></tr></tbody>\n</table></div></div></div></div>");
$templateCache.put("app/main/menu/usuarios/user/user.html","<div id=\"user\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-products-button md-icon-button\" \naria-label=\"Go to budgets\" ng-click=\"vm.gotoUsers()\" translate translate-attr-aria-label=\"US.GO_TO_USERS\"><md-icon \nmd-font-icon=\"icon-arrow-left-bold-circle-outline\" class=\"s32\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\"><span translate=\"US.USER\">\nUsuarios</span> <span>{{vm.usuario.codigo}}</span></div><div class=\"subtitle secondary-text\"><span \ntranslate=\"US.USER_DETAIL\">User details</span></div></div></div></div><div><md-button class=\"md-raised md-background\" \nng-click=\"vm.gotoUsers()\"><md-icon md-font-icon=\"icon-cancel\" class=\"s30 icon-cancel\"></md-icon><span \ntranslate=\"US.CANCEL\">CANCELAR</span></md-button><md-button class=\"md-raised md-background\" ng-click=\"vm.save()\" \nng-disabled=\"userForm.$invalid\"><md-icon md-font-icon=\"icon-check-circle\" class=\"s30 icon-check-circle\"></md-icon><span\n translate=\"US.SAVE_USER\">GUARDAR USUARIO</span></md-button></div></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span class=\"h2 text-uppercase\" \ntranslate=\"US.USER_DETAIL_TITLE\">Datos del usuarios</span></div><md-content class=\"content grey-100-bg\" flex ms-scroll>\n<form name=\"userForm\"><div layout=\"column\" flex=\"100\"><div \nclass=\"budget-detail-form-container md-background-bg md-whiteframe-1dp\" flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\">\n<md-input-container class=\"md-block\" flex=\"30\" flex-gt-xs=\"30\" flex-gt-md=\"30\"><label class=\"blue-900-fg\" \ntranslate=\"US.USER_CODE\">Código de usuario</label><input type=\"text\" name=\"codigo\" ng-model=\"vm.usuario.codigo\" \nrequired><div ng-messages=\"userForm.codigo.$error\" ng-show=\"userForm.codigo.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"US.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container><div layout=\"row\" flex><md-input-container class=\"md-block\" flex=\"60\" flex-gt-xs=\"60\" \nflex-gt-md=\"60\"><label class=\"blue-900-fg\" translate=\"US.COMPLETE_NAME\">Nombre completo (o nombre de tienda)</label>\n<input type=\"text\" name=\"nombre\" ng-model=\"vm.usuario.nombre\" required><div ng-messages=\"userForm.nombre.$error\" \nng-show=\"userForm.nombre.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"US.ERRORS.FIELD_REQUIRED\">\nCampo obligatorio</span></div></div></md-input-container><div flex=\"5\" flex-gt-xs=\"5\" flex-gt-md=\"5\"></div>\n<md-input-container class=\"md-block\" flex=\"35\" flex-gt-xs=\"35\" flex-gt-md=\"35\"><label class=\"blue-900-fg\" \ntranslate=\"US.COMPANY\">Empresa</label><md-select name=\"empresa_key\" ng-model=\"vm.usuario.empresa_key\" \nmd-on-close=\"vm.assignCompany(vm.usuario.empresa_key)\" required><md-option ng-value=\"empresa.$id\" \nng-repeat=\"empresa in vm.empresas\">{{empresa.nombre}}</md-option></md-select><div \nng-messages=\"userForm.empresa_key.$error\" ng-show=\"userForm.empresa.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"US.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container></div><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex=\"50\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><label \nclass=\"blue-900-fg\" translate=\"US.EMAIL\">E-mail</label><input type=\"text\" name=\"email\" ng-model=\"vm.usuario.email\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"userForm.email.$error\" ng-show=\"userForm.email.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"US.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div><div \nng-message=\"pattern\"><span translate=\"US.ERRORS.EMAIL_MUST_VALID\">El e-mail debe tener un formato válido</span></div>\n</div></md-input-container><div flex=\"5\" flex-gt-xs=\"5\" flex-gt-md=\"5\"></div><md-input-container class=\"md-block\" \nflex=\"30\" flex-gt-xs=\"30\" flex-gt-md=\"30\"><label class=\"blue-900-fg\" translate=\"US.PASSWORD\">Contraseña</label><input \ntype=\"password\" name=\"password\" ng-model=\"vm.usuario.password\" ng-minlength=\"6\" required><div \nng-messages=\"userForm.password.$error\" ng-show=\"userForm.password.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"US.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div><div ng-message=\"minlength\"><span \ntranslate=\"US.ERRORS.MIN_LENGTH\">La contraseña debe tener un mínimo de 6 caracteres</span></div></div>\n</md-input-container><div flex=\"5\" flex-gt-xs=\"5\" flex-gt-md=\"5\"></div><md-input-container class=\"md-block\" flex=\"30\" \nflex-gt-xs=\"30\" flex-gt-md=\"30\"><label class=\"blue-900-fg\" translate=\"US.PASSWORD_CONFIRMATION\">Confirmación contraseña\n</label><input type=\"password\" name=\"passwordConfirmation\" ng-model=\"vm.passwordConfirmation\" ng-minlength=\"6\" \nrequired><div ng-messages=\"userForm.passwordConfirmation.$error\" ng-show=\"userForm.passwordConfirmation.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"US.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div><div \nng-message=\"minlength\"><span translate=\"US.ERRORS.MIN_LENGTH\">La contraseña debe tener un mínimo de 6 caracteres</span>\n</div></div></md-input-container></div><div layout=\"row\" flex><md-input-container class=\"md-block\" flex=\"70\" \nflex-gt-xs=\"70\" flex-gt-md=\"70\"><label class=\"blue-900-fg\" translate=\"US.CONTACT_PERSON\">Persona de contacto</label>\n<input type=\"text\" name=\"personaContacto\" ng-model=\"vm.usuario.personaContacto\" required><div \nng-messages=\"userForm.personaContacto.$error\" ng-show=\"userForm.personaContacto.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"US.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container><div flex=\"5\" flex-gt-xs=\"5\" flex-gt-md=\"5\"></div><md-input-container class=\"md-block\" flex=\"25\" \nflex-gt-xs=\"25\" flex-gt-md=\"25\"><label class=\"blue-900-fg\" translate=\"US.PHONE\">Teléfono</label><input type=\"text\" \nname=\"telefono\" ng-model=\"vm.usuario.telefonoCliente\" required><div ng-messages=\"userForm.telefono.$error\" \nng-show=\"userForm.telefono.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"US.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container></div><md-input-container\n class=\"md-block\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><label class=\"blue-900-fg\" translate=\"US.ADDRESS\">\nDirección</label><input type=\"text\" name=\"direccion\" ng-model=\"vm.usuario.direccionCliente\"></md-input-container><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex=\"70\" flex-gt-xs=\"70\" flex-gt-md=\"70\"><label \nclass=\"blue-900-fg\" translate=\"US.CITY\">Ciudad</label><input type=\"text\" name=\"ciudad\" \nng-model=\"vm.usuario.ciudadCliente\"></md-input-container><div flex=\"5\" flex-gt-xs=\"5\" flex-gt-md=\"5\"></div>\n<md-input-container class=\"md-block\" flex=\"25\" flex-gt-xs=\"25\" flex-gt-md=\"25\"><label class=\"blue-900-fg\" \ntranslate=\"US.POSTAL_CODE\">Código postal</label><input type=\"text\" name=\"codigoPostal\" \nng-model=\"vm.usuario.codigoPostalCliente\"></md-input-container></div><md-input-container class=\"md-block\" flex=\"70\" \nflex-gt-xs=\"70\" flex-gt-md=\"70\"><label class=\"blue-900-fg\" translate=\"US.PROVINCE\">Provincia</label><md-select \nflex=\"65\" flex-gt-xs=\"65\" flex-gt-md=\"65\" name=\"provincia\" ng-model=\"vm.usuario.provinciaCliente\"><md-option \nng-value=\"provincia\" ng-repeat=\"provincia in vm.provincias\">{{provincia}}</md-option></md-select></md-input-container>\n<div layout=\"row\" flex=\"100\"><md-input-container flex=\"100\" flex-gt-xs=\"30\" flex-gt-md=\"30\"><md-checkbox \nng-model=\"vm.usuario.administrador\" aria-label=\"Administrador\" ng-init=\"vm.usuario.administrador=false\"><span \ntranslate=\"US.ADMINISTRATOR\">Administrador</span></md-checkbox></md-input-container><div flex=\"100\" flex-gt-xs=\"10\" \nflex-gt-md=\"5\"></div><md-input-container flex=\"100\" flex-gt-xs=\"30\" flex-gt-md=\"30\"><md-checkbox \nng-model=\"vm.usuario.activo\" aria-label=\"Activo\" ng-init=\"vm.usuario.activo=true\"><span translate=\"US.ACTIVE\">Activo\n</span></md-checkbox></md-input-container></div></div></div></form></md-content></div></div></div>");
$templateCache.put("app/main/menu/usuarios/users/users.html","<div id=\"users\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account-multiple\" class=\"s30 icon-account-multiple\"></md-icon><span translate=\"US.USERS\">\nUsuarios</span></div><div class=\"order-count secondary-text\"><span translate=\"US.TOTAL_USERS\">Total usuarios:</span> \n<span>{{vm.totalUsuarios}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon\n md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"users-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"US.SEARCH\" flex></div><div>\n<md-button class=\"md-raised md-background\" ng-click=\"vm.gotoAddUser()\"><span><md-icon \nmd-font-icon=\"icon-plus-circle-outline\" class=\"s30 icon-plus-circle-outline\"></md-icon></span><span \ntranslate=\"US.ADD_USER\">Añadir Usuario</span></md-button></div></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\"><div\n class=\"table-header\"><span class=\"column-title\">Código</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Nombre</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Empresa</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">E-mail</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Admin</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Activo</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"></span></div></th></tr></thead><tbody><tr \nng-repeat=\"user in vm.usuarios\"><td>{{user.codigo}}</td><td>{{user.nombre}}</td><td>{{user.empresa}}</td><td>\n{{user.email}}</td><td>{{user.administrador}}</td><td>{{user.activo}}</td><td><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.gotoUserDetail(user.$id)\" aria-label=\"User details\" translate \ntranslate-attr-aria-label=\"USERS.DETAILS\"><md-icon md-font-icon=\"icon-pencil-box-outline\" class=\"s25 blue-500-fg\">\n</md-icon></md-button><md-button class=\"delete-button md-icon-button\" \nng-click=\"vm.showConfirmDeleteDialog($event,user.$id)\" aria-label=\"User delete\" translate \ntranslate-attr-aria-label=\"USERS.DELETE\"><md-icon md-font-icon=\"icon-delete\" class=\"s25 red-500-fg\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/e-commerce/views/dashboard/dashboard.html","<div id=\"dashboard-ecommerce\" class=\"page-layout blank\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"content\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" \nng-model=\"vm.widget1.currentRange\" aria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget1.ranges\" \nvalue=\"{{key}}\">{{range}}</md-option></md-select><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{vm.widget1.data.count[vm.widget1.currentRange]}}%</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget1.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget1.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.widget1.data.extra.count[vm.widget1.currentRange]}}</span></div></ms-widget-front>\n<ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget2.title}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" \naria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\">\n${{vm.widget2.data.count}}</div><div class=\"h3 secondary-text font-weight-500\">{{vm.widget2.data.label}}</div></div>\n<div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{vm.widget2.data.extra.label}}:</span> <span class=\"h4 ml-8\">\n${{vm.widget2.data.extra.count}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div \nclass=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget2.detail}}</div></ms-widget-back>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.widget3.title}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\">\n<md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"orange-fg font-size-72 line-height-72\">{{vm.widget3.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget3.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget3.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.widget3.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget4.title}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" \naria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">\n${{vm.widget4.data.count}}</div><div class=\"h3 secondary-text font-weight-500\">{{vm.widget4.data.label}}</div></div>\n<div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{vm.widget4.data.extra.label}}:</span> <span class=\"h4 ml-8\">\n${{vm.widget4.data.extra.count}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div \nclass=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back>\n</ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">{{vm.widget5.title}}</div><div class=\"pv-8\" \nlayout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-button class=\"ph-16\" \nng-repeat=\"(key, range) in vm.widget5.ranges\" ng-click=\"vm.widget5.changeRange(key)\" \nng-disabled=\"vm.widget5.currentRange == key\">{{range}}</md-button></div></div><div class=\"p-16\"><nvd3 \nclass=\"h-420 remove-x-lines\" config=\"vm.widget5.mainChart.config\" options=\"vm.widget5.mainChart.options\" \ndata=\"vm.widget5.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.widget6.title}}</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget6.currentRange\" \nng-change=\"vm.widget6.changeRange(vm.widget6.currentRange)\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in vm.widget6.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div \nclass=\"p-16\"><nvd3 class=\"h-400\" config=\"vm.widget6.mainChart.config\" options=\"vm.widget6.mainChart.options\" \ndata=\"vm.widget6.mainChart.data\"></nvd3></div><div class=\"pv-8 mh-16 border-top\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"pv-8 border-right\" layout=\"column\" layout-align=\"center center\" \nflex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">{{vm.widget6.footerLeft.count[vm.widget6.currentRange]}}</span> \n<span class=\"h4\">{{vm.widget6.footerLeft.title}}</span></div><div class=\"pv-8\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">\n{{vm.widget6.footerRight.count[vm.widget6.currentRange]}}</span> <span class=\"h4\">{{vm.widget6.footerRight.title}}\n</span></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front\n class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.widget7.title}}</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget7.currentRange\" \naria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget7.ranges\" value=\"{{key}}\">{{range}}\n</md-option></md-select></div></div><div class=\"p-16\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"customer in vm.widget7.customers[vm.widget7.currentRange]\"><div><div class=\"h3\">{{customer.name}}</div><span\n ng-if=\"customer.location\">{{customer.location}}</span></div><md-button class=\"md-icon-button\" \naria-label=\"More information\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div></ms-widget-front>\n</ms-widget></div></div></div></div>");
$templateCache.put("app/main/apps/e-commerce/views/order/order.html","<div id=\"e-commerce-order\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-orders-button md-icon-button\" aria-label=\"Go to orders\" ng-click=\"vm.gotoOrders()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO_ORDERS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\"><span translate=\"EC.ORDER\">Order</span> <span>\n{{vm.order.reference}}</span></div><div class=\"subtitle secondary-text\"><span translate=\"EC.FROM\">from</span> <span>\n{{vm.order.customer.firstName}} {{vm.order.customer.lastName}}</span></div></div></div></div><div class=\"content\">\n<md-tabs md-dynamic-height><md-tab><md-tab-label><span translate=\"EC.ORDER_DETAILS\">Order Details</span></md-tab-label>\n<md-tab-body><div class=\"order-detail-form-container customer md-background-bg md-whiteframe-1dp\"><div class=\"pb-16\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account\" class=\"m-0 mr-16\"></md-icon><div \nclass=\"h2 secondary-text\" translate=\"EC.CUSTOMER\">Customer</div></div><div class=\"customer\"><table class=\"simple\" \nms-responsive-table><thead><tr><th translate=\"EC.NAME\">Name</th><th translate=\"EC.EMAIL\">Email</th><th \ntranslate=\"EC.PHONE\">Phone</th><th translate=\"EC.COMPANY\">Company</th></tr></thead><tbody><tr><td><div layout=\"row\" \nlayout-align=\"start center\"><img class=\"avatar\" ng-src=\"{{vm.order.customer.avatar}}\"> <span class=\"name text-nowrap\">\n{{vm.order.customer.firstName}} {{vm.order.customer.lastName}}</span></div></td><td><span class=\"email\">\n{{vm.order.customer.email}}</span></td><td><span class=\"phone\">{{vm.order.customer.phone}}</span></td><td><span \nclass=\"phone\">{{vm.order.customer.company}}</span></td><td></td></tr></tbody></table><md-tabs class=\"addresses\">\n<md-tab><md-tab-label><span translate=\"EC.SHIPPING_ADDRESS\">Shipping Address</span></md-tab-label><md-tab-body><div \nclass=\"address\">{{vm.order.customer.shippingAddress}}</div><ui-gmap-google-map center=\"vm.shippingAddressMap.center\" \nzoom=\"vm.shippingAddressMap.zoom\"><ui-gmap-marker coords=\"vm.shippingAddressMap.center\" \nidkey=\"vm.shippingAddressMap.marker.id\"></ui-gmap-marker></ui-gmap-google-map></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"EC.INVOICE_ADDRESS\">Invoice Address</span></md-tab-label><md-tab-body><div \nclass=\"address\">{{vm.order.customer.invoiceAddress}}</div><ui-gmap-google-map center=\"vm.invoiceAddressMap.center\" \nzoom=\"vm.invoiceAddressMap.zoom\"><ui-gmap-marker coords=\"vm.invoiceAddressMap.center\" \nidkey=\"vm.invoiceAddressMap.marker.id\"></ui-gmap-marker></ui-gmap-google-map></md-tab-body></md-tab></md-tabs></div>\n</div><div class=\"order-detail-form-container status md-background-bg md-whiteframe-1dp\"><div class=\"pb-16\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clock\" class=\"m-0 mr-16\"></md-icon><div \nclass=\"h2 secondary-text\" translate=\"EC.ORDER_STATUS\">Order Status</div></div><table class=\"simple\" \nms-responsive-table><thead><tr><th translate=\"EC.STATUS\">Status</th><th translate=\"EC.UPDATED_ON\">Updated On</th></tr>\n</thead><tbody><tr ng-repeat=\"status in vm.order.status\"><td><span class=\"status {{status.color}}\">{{status.name}}\n</span></td><td>{{status.date}}</td></tr></tbody></table><div class=\"update-status\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex><label>Select a status</label><md-select ng-model=\"vm.newStatus\">\n<md-option ng-repeat=\"status in vm.orderStatuses\" value=\"{{status.id}}\">{{status.name}}</md-option></md-select>\n</md-input-container><md-button class=\"md-raised md-accent\" ng-click=\"vm.updateStatus(vm.newStatus)\" \nng-disabled=\"!vm.newStatus\">Update Status</md-button></div></div><div \nclass=\"order-detail-form-container payments md-background-bg md-whiteframe-1dp\"><div class=\"pb-16\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-cash\" class=\"m-0 mr-16\"></md-icon><div \nclass=\"h2 secondary-text\" translate=\"EC.PAYMENT\">Payment</div></div><table class=\"simple\" ms-responsive-table><thead>\n<tr><th translate=\"EC.TRANSACTION_ID\">TransactionID</th><th translate=\"EC.PAYMENT_METHOD\">Payment Method</th><th \ntranslate=\"EC.AMOUNT\">Amount</th><th translate=\"EC.DATE\">Date</th></tr></thead><tbody><tr><td>\n{{vm.order.payment.transactionId}}</td><td>{{vm.order.payment.method}}</td><td>{{vm.order.payment.amount}}</td><td>\n{{vm.order.payment.date}}</td></tr></tbody></table></div><div \nclass=\"order-detail-form-container shipping md-background-bg md-whiteframe-1dp\"><div class=\"pb-16\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-truck\" class=\"m-0 mr-16\"></md-icon><div \nclass=\"h2 secondary-text\" translate=\"EC.SHIPPING\">Shipping</div></div><table class=\"simple\" ms-responsive-table><thead>\n<tr><th translate=\"EC.TRACKING_CODE\">Tracking Code</th><th translate=\"EC.CARRIER\">Carrier</th><th \ntranslate=\"EC.WEIGHT\">Weight</th><th translate=\"EC.FEE\">Fee</th><th translate=\"EC.DATE\">Date</th></tr></thead><tbody>\n<tr ng-repeat=\"shipping in vm.order.shippingDetails\"><td class=\"tracking-code\" editable-text=\"shipping.tracking\">\n{{shipping.tracking || \'Click to add a tracking code\'}}</td><td>{{shipping.carrier}}</td><td>{{shipping.weight}}</td>\n<td>{{shipping.fee}}</td><td>{{shipping.date}}</td></tr></tbody></table></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"EC.PRODUCTS\">Products</span></md-tab-label><md-tab-body><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Image</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Price</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Quantity</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"product in ::vm.order.products\"><td>{{product.id}}</td><td><img class=\"product-image\" \nng-src=\"{{product.image}}\"></td><td>{{product.name}}</td><td>{{product.price}}</td><td>{{product.quantity}}</td><td>\n<md-button class=\"edit-button md-icon-button\" ng-click=\"vm.gotoProductDetail(product.id)\" aria-label=\"Product details\" \ntranslate translate-attr-aria-label=\"EC.PRODUCT_DETAILS\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button></td></tr></tbody></table></div></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"EC.INVOICE\">\nInvoice</span></md-tab-label><md-tab-body><div id=\"invoice\" class=\"compact\"><div class=\"invoice-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\"><div class=\"invoice-date\">{{vm.order.date}}</div><div layout=\"row\" \nlayout-align=\"space-between stretch\"><div class=\"client\"><div class=\"invoice-number mb-8\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"title\" translate=\"INVOICE.INVOICE\">INVOICE</span> <span class=\"number\">\n{{vm.order.reference}}</span></div><div class=\"info\"><div class=\"title\">\n{{vm.order.customer.firstName}} {{vm.order.customer.lastName}}</div><div class=\"address\">\n{{vm.order.customer.invoiceAddress}}</div><div class=\"phone\">{{vm.order.customer.phone}}</div><div class=\"email\">\n{{vm.order.customer.email}}</div></div></div><div class=\"issuer md-accent-bg\" layout=\"row\" layout-align=\"start center\">\n<div class=\"logo\" layout=\"row\" layout-align=\"center center\"><span>F</span></div><div class=\"info\"><div class=\"title\">\nFUSE INC.</div><div class=\"address\">2810 Country Club Road Cranford, NJ 07016</div><div class=\"phone\">+66 123 455 87\n</div><div class=\"email\">hello@fuseinc.com</div><div class=\"website\">www.fuseinc.com</div></div></div></div></div><div \nclass=\"content\"><table class=\"simple invoice-table\"><thead><th translate=\"EC.INVOICE_PRODUCT\">PRODUCT</th><th \nclass=\"text-right\" translate=\"EC.INVOICE_PRICE\">PRICE</th><th translate=\"EC.INVOICE_QUANTITY\">QUANTITY</th><th \nclass=\"text-right\" translate=\"EC.INVOICE_TOTAL\">TOTAL</th></thead><tbody><tr ng-repeat=\"product in vm.order.products\">\n<td><div class=\"title\">{{product.name}}</div></td><td class=\"text-right\">{{product.price}}</td><td>{{product.quantity}}\n</td><td class=\"text-right\">{{product.total}}</td></tr></tbody></table><table class=\"simple invoice-table-footer\">\n<tbody><tr class=\"subtotal\"><td translate=\"EC.INVOICE_SUBTOTAL\">SUBTOTAL</td><td>{{vm.order.subtotal}}</td></tr><tr \nclass=\"tax\"><td translate=\"EC.INVOICE_TAX\">TAX</td><td>{{vm.order.tax}}</td></tr><tr class=\"discount\"><td \ntranslate=\"EC.INVOICE_DISCOUNT\">DISCOUNT</td><td>{{vm.order.discount}}</td></tr><tr class=\"total\"><td \ntranslate=\"EC.INVOICE_TOTAL\">TOTAL</td><td>{{vm.order.total}}</td></tr></tbody></table></div><div class=\"footer\"><div \nlayout=\"row\" layout-align=\"start start\"><div class=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><div>F\n</div></div><div class=\"small-note\">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class=\"page-break\"></div></div></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/apps/e-commerce/views/orders/orders.html","<div id=\"e-commerce-orders\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cart-outline\"></md-icon><span translate=\"EC.ORDERS\">Orders</span></div><div \nclass=\"order-count secondary-text\"><span translate=\"EC.TOTAL_ORDERS\">Total orders:</span> <span>{{vm.orders.length}}\n</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"EC.SEARCH\" flex></div>\n</div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead>\n<tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Reference</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Total</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Payment</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"order in ::vm.orders\"><td>{{order.id}}</td><td>{{order.reference}}</td><td>\n{{order.customer[\'firstName\']}} {{order.customer[\'lastName\']}}</td><td>{{order.total}}</td><td>\n{{order.payment[\'method\']}}</td><td>{{order.status[0].id}}</td><td class=\"date\">{{order.date}}</td><td><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.gotoOrderDetail(order.id)\" aria-label=\"Order details\" translate \ntranslate-attr-aria-label=\"EC.ORDER_DETAILS\"><md-icon md-font-icon=\"icon-dots-horizontal\" class=\"s16\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/e-commerce/views/product/product.html","<div id=\"e-commerce-product\" class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ng-click=\"vm.gotoProducts()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"product-image\" hide-xs><img ng-src=\"{{vm.product.images[0].url}}\">\n</div><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{vm.product.name}}</div><div \nclass=\"subtitle secondary-text\"><span translate=\"EC.PRODUCT_DETAIL\">Product Detail</span></div></div></div></div><div>\n<md-button class=\"md-raised md-background\" ng-click=\"vm.saveProduct()\" ng-disabled=\"!vm.isFormValid(\'productForm\')\">\n<span translate=\"EC.SAVE\">SAVE</span></md-button></div></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab>\n<md-tab-label><span translate=\"EC.BASIC_INFO\">Basic Info</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form id=\"productForm\" name=\"productForm\">\n<md-input-container class=\"md-block\"><label translate=\"EC.PRODUCT_NAME\">Product Name</label><input type=\"text\" \nng-model=\"vm.product.name\" required></md-input-container><h3 class=\"secondary-text\" translate=\"EC.PRODUCT_DESCRIPTION\">\nProduct Description</h3><text-angular ta-toolbar=\"vm.taToolbar\" ng-model=\"vm.product.description\" class=\"pb-32\">\n</text-angular><md-input-container class=\"md-block\"><label translate=\"EC.CATEGORIES\">Categories</label><md-select \nng-model=\"vm.product.categories\" md-on-open=\"vm.onCategoriesSelectorOpen()\" \nmd-on-close=\"vm.onCategoriesSelectorClose()\" multiple=\"multiple\"><md-select-header><input type=\"search\" \nclass=\"md-text\" ng-model=\"vm.categoriesSelectFilter\" placeholder=\"Search for a category\"></md-select-header>\n<md-optgroup><md-option ng-value=\"category\" \nng-repeat=\"category in vm.product.categories | filter:vm.categoriesSelectFilter\">{{category}}</md-option></md-optgroup>\n</md-select></md-input-container><h3 class=\"tags secondary-text\" translate=\"EC.TAGS\">Tags</h3><md-chips \nng-model=\"vm.product.tags\" placeholder=\"Enter a tag\" delete-button-label=\"Remove Tag\" \ndelete-hint=\"Press delete to remove tag\" secondary-placeholder=\"+Tag\"></md-chips></form></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span translate=\"EC.PRODUCT_IMAGES\">Product Images</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div id=\"product-image-uploader\" \nflow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.upload()\" \nflow-file-added=\"vm.fileAdded($file)\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\" flow-drop flow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" \nng-class=\"{\'dropping\':vm.dropping}\"><div class=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"EC.DROP_TO_UPLOAD\">Drop to upload</span></div><div class=\"upload-button\" layout=\"column\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" flow-btn>Upload</md-button><span \nclass=\"secondary-text mt-8\">You can also drop images here to upload. Only PNG, JPG - Max. 8MB</span></div><div \nclass=\"mv-32\" layout=\"row\" layout-align=\"center center\"><div class=\"image-zoom-area\"><img \nwip-image-zoom=\"vm.imageZoomOptions\"></div></div><div layout=\"row\" layout-align=\"start start\" layout-wrap><div \nng-repeat=\"image in vm.product.images\" ng-switch=\"image.type\"><div class=\"product-image uploading\" \nng-switch-when=\"uploading\" layout=\"row\" layout-align=\"center center\"><div class=\"overlay\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-linear md-mode=\"determinate\" value=\"{{image.file.progress() * 100}}\">\n</md-progress-linear></div><img class=\"media\" flow-img=\"image.file\"></div><div class=\"product-image\" \nng-switch-when=\"image\" layout=\"row\" layout-align=\"center center\"><img class=\"media\" ng-src=\"{{image.url}}\" \nng-click=\"vm.updateImageZoomOptions(image.url)\"></div></div></div><div class=\"p-8 font-size-12\" layout=\"row\" \nlayout-align=\"center center\">Click on images to activate the zoom!</div></div></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"EC.PRICING\">Pricing</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form><md-input-container \nclass=\"md-block md-icon-float\"><label translate=\"EC.TAX_EXCL_PRICE\">Tax Excluded Price</label><md-icon \nmd-font-icon=\"icon icon-currency-usd\"></md-icon><input type=\"number\" step=\"0.01\" ng-model=\"vm.product.priceTaxExcl\">\n</md-input-container><md-input-container class=\"md-block md-icon-float\"><label translate=\"EC.TAX_INCL_PRICE\">\nTax Included Price</label><md-icon md-font-icon=\"icon icon-currency-usd\"></md-icon><input type=\"number\" step=\"0.01\" \nng-model=\"vm.product.priceTaxIncl\"></md-input-container><md-input-container class=\"md-block md-icon-float\"><label \ntranslate=\"EC.TAX_RATE\">Tax Rate</label><md-icon md-font-icon=\"icon icon-percent\"></md-icon><input type=\"number\" \nstep=\"0.01\" ng-model=\"vm.product.taxRate\"></md-input-container><md-input-container class=\"md-block md-icon-float\">\n<label translate=\"EC.COMPARED_PRICE\">Compared Price</label><md-icon md-font-icon=\"icon icon-currency-usd\"></md-icon>\n<input type=\"number\" step=\"0.01\" ng-model=\"vm.product.comparedPrice\"><div class=\"input-hint\">\nAdd a compare price to show next to the real price</div></md-input-container></form></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span translate=\"EC.INVENTORY\">Inventory</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form><md-input-container class=\"md-block\">\n<label translate=\"EC.SKU\">SKU</label><input type=\"text\" ng-model=\"vm.product.sku\"></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"EC.BARCODE\">Barcode</label><input type=\"text\" \nng-model=\"vm.product.barcode\"></md-input-container><md-input-container class=\"md-block\"><label translate=\"EC.QUANTITY\">\nQuantity</label><input type=\"number\" step=\"1\" ng-model=\"vm.product.quantity\"></md-input-container></form></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"EC.SHIPPING\">Shipping</span></md-tab-label><md-tab-body>\n<div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form><div layout-gt-sm=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"EC.WIDTH\">Width</label>\n<input type=\"text\" ng-model=\"vm.product.width\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm>\n<label translate=\"EC.HEIGHT\">Height</label><input type=\"text\" ng-model=\"vm.product.height\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"EC.DEPTH\">Depth</label><input type=\"text\" \nng-model=\"vm.product.depth\"></md-input-container></div><md-input-container class=\"md-block\"><label \ntranslate=\"EC.WEIGHT\">Weight</label><input type=\"text\" ng-model=\"vm.product.weight\"></md-input-container>\n<md-input-container class=\"md-block md-icon-float\"><label translate=\"EC.EXTRA_SHIPPING_FEE\">Extra Shipping Fee</label>\n<md-icon md-font-icon=\"icon icon-currency-usd\"></md-icon><input type=\"text\" ng-model=\"vm.product.extraShippingFee\">\n</md-input-container></form></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/apps/e-commerce/views/products/products.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span translate=\"EC.PRODUCTS\">Products</span></div><div \nclass=\"product-count secondary-text\"><span translate=\"EC.TOTAL_PRODUCTS\">Total products:</span> <span>\n{{vm.products.length}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"EC.SEARCH\" flex></div><div>\n<md-button class=\"md-raised md-background\" ng-click=\"vm.gotoAddProduct()\"><span translate=\"EC.ADD_NEW_PRODUCT\">\nAdd New Product</span></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Image</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Category</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Price</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Quantity</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Active</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Actions</span></div></th></tr></thead><tbody><tr ng-repeat=\"product in ::vm.products\"><td>\n{{product.id}}</td><td><img class=\"product-image\" ng-src=\"{{product.images[0].url}}\"></td><td>{{product.name}}</td><td>\n{{product.categories[0]}}</td><td>{{product.priceTaxIncl}}</td><td>{{product.quantity}}</td><td>{{product.active}}</td>\n<td><md-button class=\"edit-button md-icon-button\" ng-click=\"vm.gotoProductDetail(product.id)\" \naria-label=\"Product details\" translate translate-attr-aria-label=\"EC.PRODUCT_DETAILS\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/calendar/dialogs/event-detail/event-detail-dialog.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{vm.calendarEvent.title}}</span> <span flex></span><md-button \nclass=\"edit-event-button md-fab md-warn\" ng-click=\"vm.editEvent(vm.calendarEvent)\" aria-label=\"Edit event\" translate \ntranslate-attr-aria-label=\"CALENDAR.EDIT_EVENT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"event-details\" layout=\"column\"><div class=\"event-detail-row\" \nlayout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-clock\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\">{{vm.calendarEvent.start.format(\'MMMM Do YYYY, h:mm:ss a\')}} <span ng-if=\"vm.calendarEvent.end\">-</span>\n {{vm.calendarEvent.end.format(\'MMMM Do YYYY, h:mm:ss a\')}}</span> <span class=\"secondary-text\">\n{{vm.calendarEvent.repeat || \'Does not repeat\'}}</span></div></div><div class=\"event-detail-row\" layout=\"row\" \nlayout-align=\"start start\"><md-icon md-font-icon=\"icon-bell-ring-outline\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\" translate=\"CALENDAR.30_MIN_BEFORE\">30 minutes before</span> <span class=\"h4\" \ntranslate=\"CALENDAR.15_MIN_BEFORE\">15 minutes before</span> <span class=\"h4\" translate=\"CALENDAR.30_MIN_LATER\">\n30 minutes later</span></div></div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><div layout=\"column\" flex><span class=\"h4\">Istanbul, Turkey</span></div></div>\n<div class=\"event-detail-row\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account\"></md-icon>\n<div layout=\"row\" flex><img src=\"assets/images/avatars/alice.jpg\" class=\"avatar\" alt=\"alice\"> <img \nsrc=\"assets/images/avatars/joyce.jpg\" class=\"avatar\" alt=\"joyce\"> <img src=\"assets/images/avatars/vincent.jpg\" \nclass=\"avatar\" alt=\"vincent\"></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/calendar/dialogs/event-form/event-form-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><label translate=\"CALENDAR.TITLE\">Title</label><input name=\"title\" ng-model=\"vm.calendarEvent.title\" \nrequired md-autofocus><div ng-messages=\"eventForm.title.$error\" ng-show=\"eventForm.title.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"CALENDAR.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div>\n</md-input-container><md-list class=\"all-day\"><md-list-item><p translate=\"CALENDAR.ALL_DAY\">All Day</p><md-switch \nclass=\"md-secondary\" ng-model=\"vm.calendarEvent.allday\" aria-label=\"All day\" translate \ntranslate-attr-aria-label=\"CALENDAR.ALL_DAY\"></md-switch></md-list-item></md-list><div layout=\"row\" class=\"date-row\">\n<md-datepicker ng-model=\"vm.calendarEvent.start\" md-placeholder=\"Start Date\" ng-model-options=\"{ timezone: \'UTC\' }\">\n</md-datepicker><md-input-container class=\"no-errors-spacer\" flex md-no-float><input \nng-model=\"vm.calendarEvent.startTime\" placeholder=\"Start Time\" translate \ntranslate-attr-placeholder=\"CALENDAR.START_TIME\"></md-input-container></div><div layout=\"row\" class=\"date-row\">\n<md-datepicker ng-model=\"vm.calendarEvent.end\" md-placeholder=\"End Date\" ng-model-options=\"{ timezone: \'UTC\' }\">\n</md-datepicker><md-input-container class=\"no-errors-spacer\" flex md-no-float><input \nng-model=\"vm.calendarEvent.endTime\" placeholder=\"End Time\" translate translate-attr-placeholder=\"CALENDAR.END_TIME\">\n</md-input-container></div><md-input-container class=\"md-block\" flex><label translate=\"CALENDAR.REPEAT\">Repeat</label>\n<input ng-model=\"vm.calendarEvent.repeat\"></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"CALENDAR.LOCATION\">Location</label><input ng-model=\"vm.calendarEvent.location\"></md-input-container><div \nclass=\"notifications\" layout=\"column\"><div class=\"title\" translate=\"CALENDAR.NOTIFICATIONS\">Notifications</div>\n<md-select ng-model=\"notification\" placeholder=\"Notification\" \nng-repeat=\"notification in vm.calendarEvent.notifications\"><md-option ng-repeat=\"opt in vm.notifications\" \nvalue=\"{{opt}}\">{{opt}}</md-option></md-select><md-button aria-label=\"+ Add Another Notification\" \ntranslate=\"CALENDAR.ADD_NOTIFICATION\" translate-attr-aria-label=\"CALENDAR.ADD_NOTIFICATION\">+ Add Another Notification\n</md-button></div><md-input-container flex class=\"md-block textarea-container\"><label translate=\"CALENDAR.NOTES\">Notes\n</label><textarea ng-model=\"vm.task.notes\" md-maxlength=\"250\" max-rows=\"4\"></textarea></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button \nng-click=\"vm.saveEvent()\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\" translate=\"CALENDAR.SAVE\" \ntranslate-attr-aria-label=\"CALENDAR.SAVE\">SAVE</md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.removeEvent()\" aria-label=\"Delete\" translate translate-attr-aria-label=\"CALENDAR.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"CALENDAR.DELETE\">Delete</span></md-tooltip>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/gantt-chart/sidenavs/settings/settings-sidenav.html","<md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" \naria-label=\"Settings\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button><h2><span>Settings</span></h2></div>\n</md-toolbar><md-content class=\"content\" layout-padding><md-list><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"GANTT.EDIT\">Edit</span></md-subheader><md-list-item><md-icon md-font-icon=\"icon-pencil\"></md-icon><p \ntranslate=\"GANTT.DRAW\">Draw</p><md-checkbox class=\"md-secondary\" ng-model=\"vm.options.draw\"></md-checkbox>\n</md-list-item><md-list-item><md-icon md-font-icon=\"icon-lock\"></md-icon><p translate=\"GANTT.READ_ONLY\">Read only</p>\n<md-checkbox class=\"md-secondary\" ng-model=\"vm.options.readOnly\"></md-checkbox></md-list-item><md-divider></md-divider>\n<md-subheader class=\"md-no-sticky\"><span translate=\"GANTT.SNAP\">Snap</span></md-subheader><md-list-item><md-icon \nmd-font-icon=\"icon-magnet\"></md-icon><p translate=\"GANTT.SNAP_AREA\">Snap area</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.columnMagnet\" placeholder=\"Snap area\"><md-option value=\"column\" \ntranslate=\"GANTT.COLUMN\">Column</md-option><md-option value=\"1 second\" translate=\"GANTT.1_SECOND\">1 second</md-option>\n<md-option value=\"1 minute\" translate=\"GANTT.1_MINUTE\">1 minute</md-option><md-option value=\"5 minutes\" \ntranslate=\"GANTT.5_MINUTES\">5 minutes</md-option><md-option value=\"15 minutes\" translate=\"GANTT.15_MINUTES\">15 minutes\n</md-option><md-option value=\"1 hour\" translate=\"GANTT.1_HOUR\">1 hour</md-option><md-option value=\"1 day\" \ntranslate=\"GANTT.1_DAY\">1 day</md-option><md-option value=\"5 days\" translate=\"GANTT.5_DAYS\">5 days</md-option>\n</md-select></md-list-item><md-list-item><md-icon md-font-icon=\"icon-view-day\"></md-icon><p translate=\"GANTT.DAILY\">\nDaily</p><md-checkbox class=\"md-secondary\" ng-model=\"vm.options.daily\"></md-checkbox></md-list-item><md-list-item>\n<md-icon md-font-icon=\"icon-lock\"></md-icon><p translate=\"GANTT.TIME_FRAMES\">Time frames</p><md-checkbox \nclass=\"md-secondary\" ng-model=\"vm.options.timeFramesMagnet\"></md-checkbox></md-list-item><md-divider></md-divider>\n<md-subheader class=\"md-no-sticky\"><span translate=\"GANTT.SIDEBAR\">Sidebar</span></md-subheader><md-list-item><md-icon \nmd-font-icon=\"icon-eye\"></md-icon><p translate=\"GANTT.SHOW_SIDEBAR\">Show Sidebar</p><md-checkbox class=\"md-secondary\" \nng-model=\"vm.options.labelsEnabled\"></md-checkbox></md-list-item><md-list-item><md-icon md-font-icon=\"icon-code-tags\">\n</md-icon><p translate=\"GANTT.RESIZABLE\">Resizable</p><md-checkbox class=\"md-secondary\" \nng-model=\"vm.options.allowSideResizing\"></md-checkbox></md-list-item><md-list-item><md-icon \nmd-font-icon=\"icon-view-headline\"></md-icon><p translate=\"GANTT.LIST_MODE\">List Mode</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.sideMode\" placeholder=\"List\"><md-option value=\"Tree\" \ntranslate=\"GANTT.TREE\">Tree</md-option><md-option value=\"Table\" translate=\"GANTT.TABLE\">Table</md-option><md-option \nvalue=\"TreeTable\" translate=\"GANTT.TREE_TABLE\">TreeTable</md-option><md-option value=\"Disabled\" \ntranslate=\"GANTT.DISABLED\">Disabled</md-option></md-select></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\"><span translate=\"GANTT.TIMELINE\">Timeline</span></md-subheader><md-list-item><md-icon \nmd-font-icon=\"icon-view-headline\"></md-icon><p translate=\"GANTT.GROUPS\">Groups</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.groupDisplayMode\" placeholder=\"Groups\"><md-option value=\"group\" \ntranslate=\"GANTT.GROUP\">Group</md-option><md-option value=\"overview\" translate=\"GANTT.OVERVIEW\">Overview</md-option>\n<md-option value=\"promote\" translate=\"GANTT.PROMOTE\">Promote</md-option><md-option value=\"Disabled\" \ntranslate=\"GANTT.DISABLED\">Disabled</md-option></md-select></md-list-item><md-divider></md-divider><md-list-item>\n<md-icon md-font-icon=\"icon-calendar-today\"></md-icon><p translate=\"GANTT.TODAY\">Today</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.currentDate\" placeholder=\"Today\"><md-option value=\"none\" \ntranslate=\"GANTT.NONE\">None</md-option><md-option value=\"line\" translate=\"GANTT.LINE\">Line</md-option><md-option \nvalue=\"column\" translate=\"GANTT.COLUMN\">Column</md-option></md-select></md-list-item><md-divider></md-divider>\n<md-list-item><md-icon md-font-icon=\"icon-arrow-expand\"></md-icon><p translate=\"GANTT.EXPAND\">Expand</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.autoExpand\" placeholder=\"Today\"><md-option value=\"none\" \ntranslate=\"GANTT.NONE\">None</md-option><md-option value=\"both\" translate=\"GANTT.BOTH\">Both</md-option><md-option \nvalue=\"left\" translate=\"GANTT.LEFT\">Left</md-option><md-option value=\"right\" translate=\"GANTT.RIGHT\">Right</md-option>\n</md-select></md-list-item><md-divider></md-divider><md-list-item><md-icon md-font-icon=\"icon-content-cut\"></md-icon><p\n translate=\"GANTT.OUT_OF_RANGE\">Out of range</p><md-select class=\"simplified md-secondary\" \nng-model=\"vm.options.taskOutOfRange\" placeholder=\"Out of range\"><md-option value=\"expand\" translate=\"GANTT.EXPAND\">\nEXPAND</md-option><md-option value=\"truncate\" translate=\"GANTT.TRUNCATE\">Truncate</md-option></md-select>\n</md-list-item><md-divider></md-divider></md-list></md-content>");
$templateCache.put("app/main/apps/chat/sidenavs/left/left-sidenav.html","<div ng-show=\"vm.leftSidenavView === \'contacts\'\" class=\"view contacts-view animate-slide-left\" \nng-include=\"\'app/main/apps/chat/sidenavs/left/views/contacts/contacts-view.html\'\" layout=\"column\" flex></div><div \nng-show=\"vm.leftSidenavView ===\'user\'\" class=\"view user-view animate-slide-left\" \nng-include=\"\'app/main/apps/chat/sidenavs/left/views/user/user-view.html\'\" layout=\"column\" flex></div><div \nng-hide=\"vm.leftSidenavView\" class=\"view chats-view animate-slide-right\" \nng-include=\"\'app/main/apps/chat/sidenavs/left/views/chats/chats-view.html\'\" layout=\"column\" flex></div>");
$templateCache.put("app/main/apps/gantt-chart/dialogs/add-edit/add-dialog.html","<md-dialog class=\"gantt-chart-add-edit-dialog\" aria-label=\"Add Dialog\" ng-cloak><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">Add</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"close dialog\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-tabs md-dynamic-height><md-tab><md-tab-label><span translate=\"GANTT.ADD_ROW\">Add Row</span>\n</md-tab-label><md-tab-body><div ng-include=\"\'app/main/apps/gantt-chart/dialogs/add-edit/views/row-form-view.html\'\">\n</div></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"GANTT.ADD_TASK\">Add Task</span></md-tab-label>\n<md-tab-body><div ng-include=\"\'app/main/apps/gantt-chart/dialogs/add-edit/views/task-form-view.html\'\"></div>\n</md-tab-body></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/gantt-chart/dialogs/add-edit/edit-dialog.html","<md-dialog class=\"gantt-chart-add-edit-dialog\" aria-label=\"Edit Dialog\" ng-cloak><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">Edit</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"close dialog\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll ng-if=\"vm.formView === \'row\'\" \nng-include=\"\'app/main/apps/gantt-chart/dialogs/add-edit/views/row-form-view.html\'\"></md-dialog-content>\n<md-dialog-content ms-scroll ng-if=\"vm.formView === \'task\'\" \nng-include=\"\'app/main/apps/gantt-chart/dialogs/add-edit/views/task-form-view.html\'\"></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/chat/sidenavs/right/right-sidenav.html","<div class=\"view contact-view\" ng-include=\"\'app/main/apps/chat/sidenavs/right/views/contact/contact-view.html\'\" \nlayout=\"column\" flex></div>");
$templateCache.put("app/main/apps/mail/dialogs/compose/compose-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"MAIL.NEW_MESSAGE\">New Message</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><label translate=\"MAIL.FROM\">From</label><input ng-model=\"vm.form.from\" type=\"email\" \ndisabled=\"disabled\"></md-input-container><md-input-container class=\"md-block to\" \nng-class=\"{\'hidden-cc\': vm.hiddenCC, \'hidden-bcc\': vm.hiddenBCC}\"><label translate=\"MAIL.TO\">To</label><input \nng-model=\"vm.form.to\" type=\"email\" md-autofocus><div class=\"cc-bcc\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"show-cc\" ng-show=\"vm.hiddenCC\" ng-click=\"vm.hiddenCC = false\">CC</div><div class=\"show-bcc\" \nng-show=\"vm.hiddenBCC\" ng-click=\"vm.hiddenBCC = false\">BCC</div></div></md-input-container><md-input-container \nclass=\"md-block\" ng-hide=\"vm.hiddenCC\"><label translate=\"MAIL.CC\">Cc</label><input ng-model=\"vm.form.cc\" type=\"email\">\n</md-input-container><md-input-container class=\"md-block\" ng-hide=\"vm.hiddenBCC\"><label translate=\"MAIL.BCC\">Bcc\n</label><input ng-model=\"vm.form.bcc\" type=\"t\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"MAIL.SUBJECT\">Subject</label><input ng-model=\"vm.form.subject\" type=\"text\"></md-input-container>\n<text-angular ng-model=\"vm.form.message\"></text-angular><div class=\"attachment-list\"><div class=\"attachment\" \nlayout=\"row\" layout-align=\"space-between center\"><div><span class=\"filename\">attachment-2.doc</span> <span \nclass=\"size\">(12 Kb)</span></div><md-button class=\"md-icon-button\" aria-label=\"Delete attachment\" translate \ntranslate-attr-aria-label=\"MAIL.DELETE_ATTACHMENT\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon>\n</md-button></div><div class=\"attachment\" layout=\"row\" layout-align=\"space-between center\"><div><span class=\"filename\">\nattachment-1.jpg</span> <span class=\"size\">(350 Kb)</span></div><md-button class=\"md-icon-button\" \naria-label=\"Delete attachment\" translate translate-attr-aria-label=\"MAIL.DELETE_ATTACHMENT\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nng-click=\"vm.closeDialog()\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"MAIL.SEND\" \ntranslate-attr-aria-label=\"MAIL.SEND\">SEND</md-button><md-button class=\"md-icon-button\" aria-label=\"Attach file\" \ntranslate-attr-aria-label=\"MAIL.ATTACH_FILE\"><md-icon md-font-icon=\"icon-paperclip\"></md-icon><md-tooltip><span \ntranslate=\"MAIL.ATTACH_FILE\"></span></md-tooltip></md-button></div><div layout=\"row\"><md-button class=\"md-icon-button\" \naria-label=\"Delete\" translate-attr-aria-label=\"MAIL.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip>\n<span translate=\"MAIL.DELETE\"></span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/scrumboard/dialogs/card/card-dialog.html","<md-dialog class=\"card-dialog\" aria-label=\"Card Dialog\" ng-cloak><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><div class=\"due-date\"><div \nng-if=\"!vm.card.due\" moment-picker=\"vm.card.due\" format=\"x\" min-view=\"year\" max-view=\"hour\" start-view=\"month\">\n<md-button class=\"md-icon-button\" aria-label=\"Due date\" translate translate-attr-aria-label=\"SB.DUE_DATE\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-calendar\"></md-icon></md-button></div></div><md-menu \nng-if=\"vm.card.due\" md-offset=\"0 48\" class=\"remove-due-date\"><md-button class=\"md-icon-button\" aria-label=\"Members\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-calendar\"></md-icon></md-button><md-menu-content \nclass=\"remove-due-date-menu-content\" width=\"4\" ms-scroll><md-menu-item><md-button ng-click=\"vm.card.due = \'\'\" \naria-label=\"remove due date\" translate-attr-aria-label=\"SB.REMOVE_DUE_DATE\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><span translate=\"SB.REMOVE_DUE_DATE\">Remove Due Date</span></md-button></md-menu-item></md-menu-content>\n</md-menu><md-menu md-offset=\"0 48\" class=\"labels\"><md-button class=\"md-icon-button\" aria-label=\"Label\" translate \ntranslate-attr-aria-label=\"SB.LABEL\" ng-click=\"vm.labelTabIndex = 0;$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-label-outline\"></md-icon></md-button><md-menu-content class=\"labels-menu-content\" width=\"4\" \nms-scroll><md-tabs md-selected=\"vm.labelTabIndex\" md-dynamic-height><md-tab><md-tab-body><md-menu-item>\n<md-input-container class=\"no-errors-spacer\" md-no-float><input placeholder=\"Search labels...\" type=\"text\" \nng-model=\"vm.labelSearchText\" autocomplete=\"off\" translate-attr-palceholder=\"SB.SEARCH_LABELS\"></md-input-container>\n</md-menu-item><md-menu-item class=\"label\" ng-repeat=\"label in vm.labels | filter: vm.filterLabel\"><md-button \nclass=\"label-toggle-button\" md-prevent-menu-close ng-class=\"\'md-\'+label.color+\'-bg\'\" \nng-click=\"vm.toggleInArray(label.id, vm.card.idLabels)\" aria-label=\"Toggle Label\" translate \ntranslate-attr-aria-label=\"SB.TOGGLE_LABEL\"><div layout=\"row\" layout-align=\"space-between center\" flex><span>\n{{label.name}}</span> <i ng-if=\"vm.exists(label.id, vm.card.idLabels)\" class=\"icon-check s16\"></i></div></md-button>\n<md-button class=\"md-icon-button label-edit-button\" md-prevent-menu-close \nng-click=\"vm.editLabelId = label.id; vm.labelTabIndex = 2\" aria-label=\"Edit Label\" translate \ntranslate-attr-aria-label=\"SB.EDIT_LABEL\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button class=\"add-label-button\" \nmd-prevent-menu-close ng-click=\"vm.labelTabIndex = 1\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon><span \ntranslate=\"SB.ADD_NEW_LABEL\">Add new label</span></md-button></md-menu-item></md-tab-body></md-tab><md-tab>\n<md-tab-body><div class=\"add-label-tab-content\"><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<md-button class=\"md-icon-button\" md-prevent-menu-close ng-click=\"vm.labelTabIndex = 0\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"SB.BACK\"><i class=\"icon-arrow-left s20\"></i></md-button><span flex \ntranslate=\"SB.CREATE_LABEL\">Create Label</span></div><div class=\"content\" layout=\"column\" layout-align=\"start stretch\">\n<form ng-submit=\"vm.addNewLabel(); vm.labelTabIndex = 0\" layout=\"column\"><md-input-container class=\"no-errors-spacer\" \nmd-no-float><input placeholder=\"Label Name\" type=\"text\" ng-model=\"vm.newLabelName\" translate \ntranslate-attr-placeholder=\"SB.LABEL_NAME\"></md-input-container><div class=\"label-color-picker\" layout=\"row\" \nlayout-wrap><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" \nlayout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.newLabelColor\" ng-value=\"palette\" \naria-label=\"{{palette}}\"> <i class=\"icon-check s18\" ng-if=\"vm.newLabelColor === palette\"></i></label></div><md-button \ntype=\"submit\" md-prevent-menu-close class=\"create-button md-accent md-raised\" aria-label=\"Create\" translate \ntranslate-attr-aria-label=\"SB.CREATE\"><span translate=\"SB.CREATE\">Create</span></md-button></form></div></div>\n</md-tab-body></md-tab><md-tab><md-tab-body><div class=\"edit-label-tab-content\"><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-icon-button\" md-prevent-menu-close \nng-click=\"vm.labelTabIndex = 0\" aria-label=\"back\" translate translate-attr-aria-label=\"SB.BACK\"><i \nclass=\"icon-arrow-left s20\"></i></md-button><span flex translate=\"SB.EDIT_LABEL\">Edit Label</span></div><div \nclass=\"content\" layout=\"column\" layout-align=\"start stretch\"><md-input-container class=\"no-errors-spacer\" md-no-float>\n<input placeholder=\"Label Name\" type=\"text\" ng-model=\"vm.board.labels.getById(vm.editLabelId).name\" translate \ntranslate-attr-placeholder=\"SB.LABEL_NAME\"></md-input-container><div class=\"label-color-picker\" layout=\"row\" \nlayout-wrap><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" \nlayout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" \nng-model=\"vm.board.labels.getById(vm.editLabelId).color\" ng-value=\"palette\" aria-label=\"{{palette}}\"> <i \nng-if=\"vm.board.labels.getById(vm.editLabelId).color === palette\" class=\"icon-check s18\"></i></label></div><div \nlayout=\"row\" layout-align=\"end center\" flex><md-button class=\"remove-button md-icon-button\" type=\"submit\" \nmd-prevent-menu-close ng-click=\"vm.removeLabel(); vm.labelTabIndex=0\" aria-label=\"remove\" translate \ntranslate-attr-aria-label=\"SB.REMOVE\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div>\n</md-tab-body></md-tab></md-tabs></md-menu-content></md-menu><md-menu md-offset=\"0 48\" class=\"members\"><md-button \nclass=\"md-icon-button\" aria-label=\"Members\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-account-multiple\"></md-icon></md-button><md-menu-content class=\"members-menu-content\" width=\"4\" \nms-scroll><md-menu-item><md-input-container class=\"no-errors-spacer\" md-no-float><input \nplaceholder=\"Search members...\" autocomplete=\"off\" type=\"text\" ng-model=\"vm.memberSearchText\" translate \ntranslate-attr-placeholder=\"SB.SEARCH_MEMBERS\"></md-input-container></md-menu-item><md-menu-item class=\"member\" \nng-repeat=\"member in vm.members  | filter: vm.filterMember\"><md-button \nng-click=\"vm.toggleInArray(member.id, vm.card.idMembers)\" md-prevent-menu-close aria-label=\"toggle member\" translate \ntranslate-attr-aria-label=\"SB.TOGGLE_MEMBER\"><div layout=\"row\" layout-align=\"space-between center\" flex><div \nlayout=\"row\" layout-align=\"start center\"><img alt=\"{{ member.name }}\" ng-src=\"{{ member.avatar }}\" class=\"avatar\"><p \nclass=\"member-name\">{{ member.name }}</p></div><i class=\"icon-check s16\" \nng-if=\"vm.exists(member.id, vm.card.idMembers)\"></i></div></md-button></md-menu-item></md-menu-content></md-menu>\n<md-button class=\"md-icon-button\" ng-click=\"\" aria-label=\"Attachment\" translate \ntranslate-attr-aria-label=\"SB.ATTACHMENT\"><md-icon md-font-icon=\"icon-attachment\"></md-icon></md-button><md-menu \nmd-offset=\"0 48px\" class=\"checklist\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"checklist\" translate translate-attr-aria-label=\"SB.CHECKLIST\"><md-icon md-menu-origin \nmd-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-menu-content class=\"checklist-menu-content\" width=\"4\">\n<form ng-submit=\"vm.createCheckList()\" layout=\"column\" layout-align=\"start end\"><md-input-container \nclass=\"no-errors-spacer\" md-no-float><input placeholder=\"Checklist Title\" autocomplete=\"off\" type=\"text\" \nng-model=\"vm.newCheckListTitle\" translate translate-attr-placeholder=\"SB.CHECKLIST_TITLE\"></md-input-container>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Add Checklist\" translate \ntranslate-attr-aria-label=\"SB.ADD_CHECKLIST\"><span translate=\"SB.ADD_CHECKLIST\">Add Checklist</span></md-button></form>\n</md-menu-content></md-menu><md-menu md-offset=\"0 48px\" class=\"subscribe\"><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"Subscribe\" translate translate-attr-aria-label=\"SB.SUBSCRIBE\"><md-icon \nmd-menu-origin ng-if=\"vm.card.subscribed\" md-font-icon=\"icon-eye\"></md-icon><md-icon md-menu-origin \nng-if=\"!vm.card.subscribed\" md-font-icon=\"icon-eye-off\"></md-icon></md-button><md-menu-content \nclass=\"subscribe-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.card.subscribed = !vm.card.subscribed\" \naria-label=\"Subscribed\" translate translate-attr-aria-label=\"SB.SUBSCRIBED\"><span ng-if=\"!vm.card.subscribed\" \ntranslate=\"SB.SUBSCRIBE\">Subscribe</span> <span ng-if=\"vm.card.subscribed\" translate=\"SB.UNSUBSCRIBE\">Unsubscribe\n</span></md-button></md-menu-item></md-menu-content></md-menu><md-menu md-offset=\"0 48px\" class=\"options\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"Options\" translate \ntranslate-attr-aria-label=\"SB.OPTIONS\"><md-icon md-menu-origin md-font-icon=\"icon-dots-horizontal\"></md-icon>\n</md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button \nng-click=\"vm.removeCard()\" aria-label=\"Remove Card\" translate translate-attr-aria-label=\"SB.REMOVE_CARD\"><md-icon \nmd-font-icon=\"icon-delete\" md-menu-align-target></md-icon><span translate=\"SB.REMOVE_CARD\">Remove Card</span>\n</md-button></md-menu-item></md-menu-content></md-menu><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close Dialog\" translate translate-attr-aria-label=\"SB.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" \nlayout-align=\"space-between start\"><div layout=\"column\" layout-align=\"start stretch\" flex><div class=\"card-breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><span>{{vm.board.name}}</span> <i class=\"icon-menu-right\"></i> <span>\n{{vm.getCardList().name}}</span></div><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.card.subscribed\" class=\"card-subscribe s18\" md-font-icon=\"icon-eye\"></md-icon><div class=\"card-name\"><span \neditable-text=\"vm.card.name\">{{vm.card.name}}</span></div></div></div><div ng-if=\"vm.card.due\" class=\"due-date\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"picker day-picker\" moment-picker=\"vm.card.due\" format=\"x\" \nmin-view=\"year\" max-view=\"month\" start-view=\"month\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"s18 icon icon-calendar\"></i> <span>{{vm.card.due | date:\'mediumDate\'}}</span></div></div><div \nclass=\"picker hour-picker\" moment-picker=\"vm.card.due\" format=\"x\" min-view=\"day\" max-view=\"hour\" start-view=\"day\"><div \nlayout=\"row\" layout-align=\"start center\"><i class=\"s18 icon icon-clock\"></i> <span>{{vm.card.due | date:\'shortTime\'}}\n</span></div></div><div class=\"remove-due-date\" layout=\"row\" layout-align=\"center center\" ng-click=\"vm.card.due = \'\'\">\n<i class=\"s16 icon icon-close\"></i></div></div></div><div class=\"description\"><md-input-container class=\"md-block\">\n<label translate=\"SB.DESCRIPTION\">Description</label><textarea ng-model=\"vm.card.description\" columns=\"1\" \nmd-maxlength=\"150\" max-rows=\"4\"></textarea></md-input-container></div><div class=\"sections\"><div \nng-if=\"vm.card.idLabels[0] || vm.card.idMembers[0]\" class=\"section\" layout=\"row\"><div ng-if=\"vm.card.idLabels[0]\" flex \nclass=\"labels\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-label-outline s18\">\n</i> <span class=\"section-title\" translate=\"SB.LABELS\">Labels</span></div><div class=\"section-content\"><md-chips \nclass=\"label-chips\" ng-model=\"vm.card.idLabels\" md-autocomplete-snap md-require-match=\"true\" \nmd-transform-chip=\"$chip.id\"><md-autocomplete md-selected-item=\"vm.selectedLabel\" md-search-text=\"vm.searchLabelText\" \nmd-items=\"label in vm.labelQuerySearch(vm.searchLabelText)\" md-item-text=\"label.name\" placeholder=\"Search for a label\">\n<span md-highlight-text=\"vm.searchLabelText\">{{label.name}}</span></md-autocomplete><md-chip-template \nclass=\"label-chip\" ng-class=\"\'md-\'+vm.board.labels.getById($chip).color+\'-bg\'\"><span>\n{{vm.board.labels.getById($chip).name}}</span></md-chip-template><button md-chip-remove class=\"md-primary\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s18\"></md-icon></button></md-chips></div></div><div ng-if=\"vm.card.idMembers[0]\" flex \nclass=\"members\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon-account-multiple s18\"></i> <span class=\"section-title\" translate=\"SB.MEMBERS\">Members</span></div><div \nclass=\"section-content\"><md-chips class=\"member-chips\" ng-model=\"vm.card.idMembers\" md-autocomplete-snap \nmd-require-match=\"true\" md-transform-chip=\"$chip.id\"><md-autocomplete md-selected-item=\"vm.selectedMember\" \nmd-search-text=\"vm.searchText\" md-items=\"member in vm.memberQuerySearch(vm.searchText)\" md-item-text=\"member.name\" \nplaceholder=\"Search for a member\"><span md-highlight-text=\"vm.searchText\">{{member.name}}</span></md-autocomplete>\n<md-chip-template class=\"member-chip\"><img class=\"member-chip-avatar\" \nng-src=\"{{vm.board.members.getById($chip).avatar}}\"><md-tooltip>{{vm.board.members.getById($chip).name}}</md-tooltip>\n</md-chip-template><button md-chip-remove class=\"md-primary\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon>\n</button></md-chips></div></div></div><div ng-if=\"vm.card.attachments[0]\" class=\"section\"><div class=\"attachments\"><div\n class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-attachment s18\"></i> <span \nclass=\"section-title\" translate=\"SB.ATTACHMENTS\">Attachments</span></div><div class=\"section-content\"><div \nclass=\"attachment\" ng-repeat=\"item in vm.card.attachments\" ng-switch=\"item.type\"><div ng-switch-when=\"image\" \nlayout=\"row\"><div class=\"attachment-preview md-whiteframe-2dp\" ng-style=\"{\'background-image\': \'url({{item.src}})\'}\">\n</div><div class=\"attachment-content\" layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><span \nclass=\"attachment-name\">{{item.name}}</span> <i ng-if=\"vm.card.idAttachmentCover === item.id\" \nclass=\"icon-star yellow-700-fg attachment-is-cover s18\"></i></div><span class=\"attachment-time\">{{item.time}}</span>\n<md-menu><md-button class=\"md-raised attachment-actions-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"attachment actions\"><span layout=\"row\" layout-align=\"center center\"><span translate=\"SB.ACTIONS\">Actions\n</span> <i class=\"icon-chevron-down s20\"></i></span></md-button><md-menu-content><md-menu-item><md-button \nng-click=\"vm.toggleCoverImage(item.id)\" aria-label=\"Toggle Cover Image\" translate \ntranslate-attr-aria-label=\"SB.TOGGLE_COVER_IMAGE\"><span ng-if=\"vm.card.idAttachmentCover !== item.id\" translate \ntranslate=\"SB.MAKE_COVER\">Make Cover</span> <span ng-if=\"vm.card.idAttachmentCover === item.id\" translate \ntranslate=\"SB.REMOVE_COVER\">Remove Cover</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.removeAttachment(item)\" aria-label=\"Remove Attachment\" translate \ntranslate-attr-aria-label=\"SB.REMOVE_ATTACHMENT\"><span translate=\"SB.REMOVE_ATTACHMENT\">Remove Attachment</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div></div><div ng-switch-when=\"link\" layout=\"row\"><div \nclass=\"attachment-preview md-whiteframe-2dp\" layout=\"column\" layout-align=\"center center\"><span translate=\"SB.LINK\">\nLINK</span></div><div class=\"attachment-content\" layout=\"column\"><span class=\"attachment-url\">{{item.url}}</span> <span\n class=\"attachment-time\">{{item.time}}</span></div></div></div><md-button class=\"add-attachment-button\" \naria-label=\"add attachment\"><div layout=\"row\" layout-align=\"start center\"><i class=\"icon-plus s20\"></i> <span \ntranslate=\"SB.ADD_AN_ATTACHMENT\">Add an attachment</span></div></md-button></div></div></div><div \nng-if=\"vm.card.checklists\" class=\"section\" ng-repeat=\"checklist in vm.card.checklists\"><div class=\"checklist\"><div \nclass=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-checkbox-marked s18\"></i> <span flex \nclass=\"section-title\" ng-hide=\"editChecklistForm.$visible\">{{checklist.name}}</span> <span flex class=\"section-title\" \neditable-text=\"checklist.name\" ng-show=\"editChecklistForm.$visible\" e-form=\"editChecklistForm\"></span><md-menu \nmd-position-mode=\"target-right target\" class=\"options\"><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"options\" translate translate-attr-aria-label=\"SB.OPTIONS\"><md-icon \nmd-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\">\n<md-menu-item><md-button ng-click=\"editChecklistForm.$show()\" aria-label=\"Edit\" translate \ntranslate-attr-aria-label=\"SB.EDIT\"><md-icon md-font-icon=\"icon-pencil\" class=\"s20\"></md-icon><span \ntranslate=\"SB.EDIT_CHECKLIST\">Edit Checklist</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.removeChecklist(checklist)\" aria-label=\"Remove Checklist\" translate \ntranslate-attr-aria-label=\"SB.REMOVE_CHECKLIST\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"SB.REMOVE_CHECKLIST\">Remove Checklist</span></md-button></md-menu-item></md-menu-content></md-menu></div>\n<div class=\"section-content\"><div class=\"checklist-progress\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"checklist-progress-value\">{{checklist.checkItemsChecked}} / {{checklist.checkItems.length}}</span>\n<md-progress-linear class=\"md-accent checklist-progressbar\" md-mode=\"determinate\" \nvalue=\"{{100 * checklist.checkItemsChecked / checklist.checkItems.length}}\"></md-progress-linear></div><div \nclass=\"check-items\"><div class=\"check-item\" ng-repeat=\"checkItem in checklist.checkItems\" layout=\"row\" \nlayout-align=\"space-between center\"><md-checkbox ng-model=\"checkItem.checked\" \nng-change=\"vm.updateCheckedCount(checklist)\" aria-label=\"{{checkItem.name}}\" ng-hide=\"editCheckItemForm.$visible\">\n{{checkItem.name}}</md-checkbox><span flex editable-text=\"checkItem.name\" ng-show=\"editCheckItemForm.$visible\" \ne-form=\"editCheckItemForm\"></span><md-menu md-position-mode=\"target-right target\" class=\"options\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"options\" translate \ntranslate-attr-aria-label=\"SB.OPTIONS\"><md-icon md-menu-origin md-font-icon=\"icon-dots-vertical\" class=\"s20\"></md-icon>\n</md-button><md-menu-content class=\"options-menu-content\"><md-menu-item><md-button \nng-click=\"editCheckItemForm.$show()\" aria-label=\"Edit\" translate translate-attr-aria-label=\"SB.EDIT\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s20\"></md-icon><span translate=\"SB.EDIT\">Edit</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.removeChecklistItem(checkItem, checklist.checkItems)\" aria-label=\"Remove\" \ntranslate translate-attr-aria-label=\"SB.REMOVE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"SB.REMOVE\">Remove</span></md-button></md-menu-item></md-menu-content></md-menu></div></div><form \nname=\"newCheckItemForm\" class=\"new-check-item-form\" \nng-submit=\"vm.addCheckItem(vm[checklist.id].newCheckItem, checklist);vm[checklist.id].newCheckItem = \'\'\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"no-errors-spacer\" flex><label><i class=\"icon-plus s18\"></i> \n<span translate=\"SB.ADD_AN_ITEM\">Add an item</span></label><input type=\"text\" autocomplete=\"off\" \nng-model=\"vm[checklist.id].newCheckItem\"></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" \naria-label=\"Add\" translate translate-attr-aria-label=\"SB.ADD\"><span translate=\"SB.ADD\">Add</span></md-button></form>\n</div></div></div><div class=\"section\"><div class=\"comments\"><div class=\"section-header\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-comment s18\"></i> <span class=\"section-title\" translate=\"SB.COMMENTS\">\nComments</span></div><div class=\"section-content\"><form name=\"cardCommentForm\" \nng-submit=\"vm.addNewComment(vm.newCommentText); vm.newCommentText =\'\'\" class=\"comment new-comment\" layout=\"column\" \nlayout-align=\"start\" no-validate><div layout=\"row\"><img class=\"comment-member-avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-input-container flex md-no-float><textarea placeholder=\"Write a comment..\" \nng-model=\"vm.newCommentText\" required max-rows=\"4\" translate translate-attr-placeholder=\"SB.WRITE_A_COMMENT\">\n</textarea></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent\" ng-disabled=\"cardCommentForm.$invalid || cardCommentForm.$pristine\" aria-label=\"Add\"><span \ntranslate=\"SB.ADD\">Add</span></md-button></div></form><div class=\"comment\" layout=\"row\" \nng-repeat=\"comment in vm.card.comments\"><img class=\"comment-member-avatar\" \nng-src=\"{{vm.board.members.getById(comment.idMember).avatar}}\"><div layout=\"column\"><div class=\"comment-member-name\">\n{{vm.board.members.getById(comment.idMember).name}}</div><div class=\"comment-bubble\">{{comment.message}}</div><div \nclass=\"comment-time secondary-text\">{{comment.time}}</div></div></div></div></div></div><div \nng-if=\"vm.card.activities[0]\" class=\"section\"><div class=\"activities\"><div class=\"section-header\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-format-list-bulleted s18\"></i> <span class=\"section-title\" \ntranslate=\"SB.ACTIVITY\">Activity</span></div><div class=\"section-content\"><div class=\"activity\" layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"activity in vm.card.activities\"><img class=\"activity-member-avatar\" \nng-src=\"{{vm.board.members.getById(activity.idMember).avatar}}\"><div class=\"activity-member-name\">\n{{vm.board.members.getById(activity.idMember).name}}</div><div class=\"activity-message\">{{activity.message}}</div><div \nclass=\"activity-time secondary-text\">{{activity.time}}</div></div></div></div></div></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/apps/mail/views/classic/classic-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-checkbox class=\"no-label\" aria-label=\"{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 0\" ng-click=\"vm.toggleSelectThreads()\" ng-if=\"!vm.currentThread\"></md-checkbox>\n<md-menu class=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"Filters\" translate translate-attr-aria-label=\"MAIL.FILTERS\"><md-icon \nmd-font-icon=\"icon-menu-down\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.selectThreads()\" aria-label=\"All\" translate=\"MAIL.ALL\" translate-attr-aria-label=\"MAIL.ALL\">All\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deselectThreads()\" aria-label=\"None\" \ntranslate=\"MAIL.NONE\" translate-attr-aria-label=\"MAIL.NONE\">None</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'read\', true)\" aria-label=\"Read\" translate=\"MAIL.READ\" \ntranslate-attr-aria-label=\"MAIL.READ\">Read</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'read\', false)\" aria-label=\"Unread\" translate=\"MAIL.UNREAD\" \ntranslate-attr-aria-label=\"MAIL.UNREAD\">Unread</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'important\', true)\" aria-label=\"Important\" translate=\"MAIL.IMPORTANT\" \ntranslate-attr-aria-label=\"MAIL.IMPORTANT\">Important</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'important\', false)\" aria-label=\"Not Important\" translate=\"MAIL.NOT_IMPORTANT\" \ntranslate-attr-aria-label=\"MAIL.NOT_IMPORTANT\">Not Important</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'starred\', true)\" aria-label=\"Starred\" translate=\"MAIL.STARRED\" \ntranslate-attr-aria-label=\"MAIL.STARRED\">Starred</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'starred\', false)\" aria-label=\"Unstarred\" translate=\"MAIL.UNSTARRED\" \ntranslate-attr-aria-label=\"MAIL.UNSTARRED\">Unstarred</md-button></md-menu-item></md-menu-content></md-menu><md-button \nclass=\"md-icon-button close-thread\" aria-label=\"Back\" ng-click=\"vm.closeThread()\" ng-if=\"vm.currentThread\" translate \ntranslate-attr-aria-label=\"MAIL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div \nclass=\"action-buttons\" layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.selectedThreads.length > 0 || vm.currentThread\" hide show-gt-xs><div class=\"divider-vertical\"></div>\n<md-button class=\"md-icon-button\" aria-label=\"Archive\" translate translate-attr-aria-label=\"MAIL.ARCHIVE\"><md-icon \nmd-font-icon=\"icon-archive\"></md-icon><md-tooltip><span translate=\"MAIL.ARCHIVE\">Archive</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"Spam\" translate translate-attr-aria-label=\"MAIL.SPAM\">\n<md-icon md-font-icon=\"icon-alert-octagon\"></md-icon><md-tooltip><span translate=\"MAIL.SPAM\">Spam</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"Delete\" translate translate-attr-aria-label=\"MAIL.DELETE\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"MAIL.DELETE\">Delete</span></md-tooltip>\n</md-button><div class=\"divider-vertical\"></div><md-button class=\"md-icon-button\" aria-label=\"Move to\" translate \ntranslate-attr-aria-label=\"MAIL.MOVE_TO\"><md-icon md-font-icon=\"icon-folder\"></md-icon><md-tooltip><span \ntranslate=\"MAIL.MOVE_TO\">Move to</span></md-tooltip></md-button><md-menu><md-button class=\"md-icon-button\" \naria-label=\"Labels\" translate translate-attr-aria-label=\"MAIL.LABELS\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-font-icon=\"icon-label\"></md-icon><md-tooltip><span translate=\"MAIL.LABELS\">Labels</span></md-tooltip></md-button>\n<md-menu-content class=\"thread-labels-toggle-list\" width=\"3\"><md-list><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"MAIL.LABELS\">Labels</span></md-subheader><md-list-item ng-repeat=\"label in vm.labels\" \nng-click=\"vm.toggleLabel(label)\"><div layout=\"row\" layout-align=\"start center\"><div class=\"w-10 h-10 mr-16\" \nng-class=\"label.color\"></div><div>{{label.title}}</div></div><md-icon md-font-icon=\"icon-checkbox-blank-outline\" \nclass=\"md-secondary\" ng-if=\"vm.currentThread && !vm.isLabelExist(label)\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked\" class=\"md-accent md-secondary\" ng-if=\"vm.currentThread && vm.isLabelExist(label)\">\n</md-icon></md-list-item></md-list></md-menu-content></md-menu><div class=\"divider-vertical\"></div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"MAIL.MORE\" translate \ntranslate-attr-aria-label=\"MAIL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content\n width=\"3\"><md-menu-item><md-button ng-click=\"vm.setThreadStatus(\'read\', true)\"><span translate=\"MAIL.MARK_AS_READ\">\nMark as read</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setThreadStatus(\'read\', false)\">\n<span translate=\"MAIL.MARK_AS_UNREAD\">Mark as unread</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setThreadStatus(\'important\', true)\"><span translate=\"MAIL.MARK_AS_IMPORTANT\">Mark as important</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setThreadStatus(\'important\', false)\"><span \ntranslate=\"MAIL.MARK_AS_NOT_IMPORTANT\">Mark as not important</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setThreadStatus(\'starred\', true)\"><span translate=\"MAIL.ADD_STAR\">Add star</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.setThreadStatus(\'starred\', false)\"><span \ntranslate=\"MAIL.REMOVE_STAR\">Remove star</span></md-button></md-menu-item></md-menu-content></md-menu></div><md-menu \nclass=\"actions-menu\" ng-show=\"vm.selectedThreads.length > 0 || vm.currentThread\" hide-gt-xs><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"Mail Actions\" translate \ntranslate-attr-aria-label=\"MAIL.ACTIONS\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Archive\" translate-attr-aria-label=\"MAIL.ARCHIVE\">\n<md-icon md-font-icon=\"icon-archive\"></md-icon><span translate=\"MAIL.ARCHIVE\">Archive</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Spam\" translate-attr-aria-label=\"MAIL.SPAM\"><md-icon \nmd-font-icon=\"icon-alert-octagon\"></md-icon><span translate=\"MAIL.SPAM\">Spam</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Delete\" translate-aria-label=\"MAIL.DELETE\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><span translate=\"MAIL.DELETE\">Delete</span></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Move To\" translate-attr-aria-label=\"MAIL.MOVE_TO\"><md-icon md-font-icon=\"icon-folder-move\"></md-icon><span \ntranslate=\"MAIL.MOVE_TO\">Move To</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Labels\" \ntranslate-attr-aria-label=\"MAIL.LABELS\"><md-icon md-font-icon=\"icon-label\"></md-icon><span translate=\"MAIL.LABELS\">\nLabels</span></md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"page-info\" hide-sm>1 - 100 of 980</span><md-button \nclass=\"md-icon-button arrow\" aria-label=\"Previous\" translate translate-attr-aria-label=\"MAIL.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span translate=\"MAIL.PREVIOUS\">Previous</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" translate translate-attr-aria-label=\"MAIL.NEXT\">\n<md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span translate=\"MAIL.NEXT\">Next</span></md-tooltip>\n</md-button><md-menu class=\"settings-menu\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"Settings\" translate translate-attr-aria-label=\"MAIL.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.changeView(\'classic\')\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView !== \'classic\'\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView === \'classic\'\"></md-icon><span \ntranslate=\"MAIL.CLASSIC_VIEW\">Classic View</span></md-button></md-menu-item><md-menu-item hide-xs><md-button \nng-click=\"vm.changeView(\'outlook\')\"><md-icon md-font-icon=\"icon-checkbox-blank-outline\" \nng-if=\"vm.currentView !== \'outlook\'\"></md-icon><md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" \nng-if=\"vm.currentView === \'outlook\'\"></md-icon><span translate=\"MAIL.OUTLOOK_VIEW\">Outlook View</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><div class=\"content-wrapper\" layout=\"column\" flex><div \nclass=\"content thread-detail\" ng-if=\"vm.currentThread\" \nng-include=\"\'app/main/apps/mail/views/classic/detail/detail.html\'\" ms-scroll flex></div><div \nclass=\"content thread-list\" ng-if=\"!vm.currentThread\" ng-include=\"\'app/main/apps/mail/views/classic/list/list.html\'\" \nms-scroll flex></div></div>");
$templateCache.put("app/main/apps/mail/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon></span>\n<span class=\"logo-text\" translate=\"MAIL.MAILBOX\">Mailbox</span></div><div class=\"account\"><div class=\"title\">John Doe\n</div><md-select class=\"account-selection simplified\" placeholder=\"Mail Selection\" ng-model=\"vm.selectedAccount\">\n<md-option ng-repeat=\"(provider, address) in vm.accounts\" value=\"{{provider}}\">{{address}}</md-option></md-select>\n</div></div><md-content ms-scroll class=\"content\" flex><div class=\"compose-button\"><md-button \nclass=\"md-accent md-raised\" aria-label=\"compose\" ng-click=\"vm.composeDialog($event)\" translate=\"MAIL.COMPOSE\">COMPOSE\n</md-button></div><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\" \nng-repeat=\"folder in vm.folders\" ng-click=\"vm.loadFolder(folder.name)\" \nng-class=\"{\'selected\':vm.isFolderActive(folder.name)}\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{folder.icon}}\" class=\"s16\"></md-icon><span class=\"title\">{{folder.title}}</span></div></md-button><div \nclass=\"item subheader\" translate=\"MAIL.LABELS\">Labels</div><md-button class=\"item\" ng-repeat=\"label in vm.labels\" \nng-click=\"vm.loadLabel(label.name)\" ng-class=\"{\'selected\':vm.isLabelActive(label.name)}\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"h-10 w-10 mr-16\" ng-class=\"label.color\"></div><span class=\"title\">\n{{label.title}}</span></div></md-button></div></md-content>");
$templateCache.put("app/main/apps/mail/views/outlook/outlook-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-checkbox class=\"no-label\" aria-label=\"{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 0\" ng-click=\"vm.toggleSelectThreads()\"></md-checkbox><md-menu \nclass=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"Filters\" translate translate-attr-aria-label=\"MAIL.FILTERS\"><md-icon md-font-icon=\"icon-menu-down\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectThreads()\" \naria-label=\"All\" translate=\"MAIL.ALL\" translate-attr-aria-label=\"MAIL.ALL\">All</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.deselectThreads()\" aria-label=\"None\" translate=\"MAIL.NONE\" \ntranslate-attr-aria-label=\"MAIL.NONE\">None</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'read\', true)\" aria-label=\"Read\" translate=\"MAIL.READ\" \ntranslate-attr-aria-label=\"MAIL.READ\">Read</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'read\', false)\" aria-label=\"Unread\" translate=\"MAIL.UNREAD\" \ntranslate-attr-aria-label=\"MAIL.UNREAD\">Unread</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'important\', true)\" aria-label=\"Important\" translate=\"MAIL.IMPORTANT\" \ntranslate-attr-aria-label=\"MAIL.IMPORTANT\">Important</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'important\', false)\" aria-label=\"Not Important\" translate=\"MAIL.NOT_IMPORTANT\" \ntranslate-attr-aria-label=\"MAIL.NOT_IMPORTANT\">Not Important</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'starred\', true)\" aria-label=\"Starred\" translate=\"MAIL.STARRED\" \ntranslate-attr-aria-label=\"MAIL.STARRED\">Starred</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'starred\', false)\" aria-label=\"Unstarred\" translate=\"MAIL.UNSTARRED\" \ntranslate-attr-aria-label=\"MAIL.UNSTARRED\">Unstarred</md-button></md-menu-item></md-menu-content></md-menu><div \nclass=\"action-buttons\" layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.selectedThreads.length > 0 || vm.currentThread\" hide show-gt-xs><div class=\"divider-vertical\"></div>\n<md-button class=\"md-icon-button\" aria-label=\"Archive\" translate translate-attr-aria-label=\"MAIL.ARCHIVE\"><md-icon \nmd-font-icon=\"icon-archive\"></md-icon><md-tooltip><span translate=\"MAIL.ARCHIVE\">Archive</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"Spam\" translate translate-attr-aria-label=\"MAIL.SPAM\">\n<md-icon md-font-icon=\"icon-alert-octagon\"></md-icon><md-tooltip><span translate=\"MAIL.SPAM\">Spam</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"Delete\" translate translate-attr-aria-label=\"MAIL.DELETE\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"MAIL.DELETE\">Delete</span></md-tooltip>\n</md-button><div class=\"divider-vertical\"></div><md-button class=\"md-icon-button\" aria-label=\"Move to\" translate \ntranslate-attr-aria-label=\"MAIL.MOVE_TO\"><md-icon md-font-icon=\"icon-folder\"></md-icon><md-tooltip><span \ntranslate=\"MAIL.MOVE_TO\">Move to</span></md-tooltip></md-button><md-menu><md-button class=\"md-icon-button\" \naria-label=\"Labels\" translate translate-attr-aria-label=\"MAIL.LABELS\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-font-icon=\"icon-label\"></md-icon><md-tooltip><span translate=\"MAIL.LABELS\">Labels</span></md-tooltip></md-button>\n<md-menu-content class=\"thread-labels-toggle-list\" width=\"3\"><md-list><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"MAIL.LABELS\">Labels</span></md-subheader><md-list-item ng-repeat=\"label in vm.labels\" \nng-click=\"vm.toggleLabel(label)\"><div layout=\"row\" layout-align=\"start center\"><div class=\"w-10 h-10 mr-16\" \nng-class=\"label.color\"></div><div>{{label.title}}</div></div><md-icon md-font-icon=\"icon-checkbox-blank-outline\" \nclass=\"md-secondary\" ng-if=\"vm.currentThread && !vm.isLabelExist(label)\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked\" class=\"md-accent md-secondary\" ng-if=\"vm.currentThread && vm.isLabelExist(label)\">\n</md-icon></md-list-item></md-list></md-menu-content></md-menu><div class=\"divider-vertical\"></div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"MAIL.MORE\" translate \ntranslate-attr-aria-label=\"MAIL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content\n width=\"3\"><md-menu-item><md-button ng-click=\"vm.setThreadStatus(\'read\', true)\"><span translate=\"MAIL.MARK_AS_READ\">\nMark as read</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setThreadStatus(\'read\', false)\">\n<span translate=\"MAIL.MARK_AS_UNREAD\">Mark as unread</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setThreadStatus(\'important\', true)\"><span translate=\"MAIL.MARK_AS_IMPORTANT\">Mark as important</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setThreadStatus(\'important\', false)\"><span \ntranslate=\"MAIL.MARK_AS_NOT_IMPORTANT\">Mark as not important</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setThreadStatus(\'starred\', true)\"><span translate=\"MAIL.ADD_STAR\">Add star</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.setThreadStatus(\'starred\', false)\"><span \ntranslate=\"MAIL.REMOVE_STAR\">Remove star</span></md-button></md-menu-item></md-menu-content></md-menu></div><md-menu \nclass=\"actions-menu\" ng-show=\"vm.selectedThreads.length > 0 || vm.currentThread\" hide-gt-xs><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"Mail Actions\" translate \ntranslate-attr-aria-label=\"MAIL.ACTIONS\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Archive\" translate-attr-aria-label=\"MAIL.ARCHIVE\">\n<md-icon md-font-icon=\"icon-archive\"></md-icon><span translate=\"MAIL.ARCHIVE\">Archive</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Spam\" translate-attr-aria-label=\"MAIL.SPAM\"><md-icon \nmd-font-icon=\"icon-alert-octagon\"></md-icon><span translate=\"MAIL.SPAM\">Spam</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Delete\" translate-aria-label=\"MAIL.DELETE\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><span translate=\"MAIL.DELETE\">Delete</span></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Move To\" translate-attr-aria-label=\"MAIL.MOVE_TO\"><md-icon md-font-icon=\"icon-folder-move\"></md-icon><span \ntranslate=\"MAIL.MOVE_TO\">Move To</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Labels\" \ntranslate-attr-aria-label=\"MAIL.LABELS\"><md-icon md-font-icon=\"icon-label\"></md-icon><span translate=\"MAIL.LABELS\">\nLabels</span></md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"page-info\" hide-sm>1 - 100 of 980</span><md-button \nclass=\"md-icon-button arrow\" aria-label=\"Previous\" translate translate-attr-aria-label=\"MAIL.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span translate=\"MAIL.PREVIOUS\">Previous</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" translate translate-attr-aria-label=\"MAIL.NEXT\">\n<md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span translate=\"MAIL.NEXT\">Next</span></md-tooltip>\n</md-button><md-menu class=\"settings-menu\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"Settings\" translate translate-attr-aria-label=\"MAIL.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.changeView(\'classic\')\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView !== \'classic\'\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView === \'classic\'\"></md-icon><span \ntranslate=\"MAIL.CLASSIC_VIEW\">Classic View</span></md-button></md-menu-item><md-menu-item hide-xs><md-button \nng-click=\"vm.changeView(\'outlook\')\"><md-icon md-font-icon=\"icon-checkbox-blank-outline\" \nng-if=\"vm.currentView !== \'outlook\'\"></md-icon><md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" \nng-if=\"vm.currentView === \'outlook\'\"></md-icon><span translate=\"MAIL.OUTLOOK_VIEW\">Outlook View</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><div class=\"content-wrapper\" layout=\"row\" flex><div \nclass=\"content thread-list\" ng-include=\"\'app/main/apps/mail/views/outlook/list/list.html\'\" ms-scroll flex=\"50\"></div>\n<div class=\"content thread-detail\" ng-include=\"\'app/main/apps/mail/views/outlook/detail/detail.html\'\" ms-scroll \nlayout=\"column\" flex=\"50\"></div></div>");
$templateCache.put("app/main/apps/scrumboard/directives/ms-sb-add-card/ms-sb-add-card.html","<div class=\"ms-sb-add-card-button\" layout=\"row\" layout-align=\"start center\" ng-hide=\"formActive\"><div><i \nclass=\"icon-plus s20\"></i></div><span translate=\"SB.ADD_A_CARD\">Add a card</span></div><div \nclass=\"ms-sb-add-card-form-wrapper\" ng-hide=\"!formActive\"><form ng-submit=\"vm.addNewCard()\" \nclass=\"ms-sb-add-card-form\" layout=\"column\"><md-input-container flex md-no-float><input placeholder=\"Card title\" \ntype=\"text\" autocomplete=\"off\" ng-model=\"vm.newCardName\" translate-attr-placeholder=\"SB.CARD_TITLE\">\n</md-input-container><div layout=\"row\" layout-align=\"space-between center\"><md-button type=\"submit\" \nclass=\"add-button md-accent md-raised\" aria-label=\"add\" translate-attr-aria-label=\"SB.ADD\"><span translate=\"SB.ADD\">Add\n</span></md-button><md-button ng-click=\"toggleForm()\" class=\"cancel-button md-icon-button\" aria-label=\"cancel\" \ntranslate-attr-aria-label=\"SB.CANCEL\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></form></div>");
$templateCache.put("app/main/apps/scrumboard/views/board/board-view.html","<div id=\"board\" ng-class=\"vm.board.settings.color+\'-100-bg\'\" ui-sortable=\"vm.sortableListOptions\" \nng-model=\"vm.board.lists\" layout=\"row\"><div class=\"list-wrapper\" ng-repeat=\"list in vm.board.lists track by list.id\">\n<div class=\"list md-whiteframe-1dp\" layout=\"column\"><div class=\"list-header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"list-header-name\"><span editable-text=\"list.name\">{{list.name}}</span>\n</div><md-menu md-offset=\"0 48px\" class=\"options list-header-option-button\"><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"Options\" translate translate-attr-aria-label=\"SB.OPTIONS\"><md-icon \nmd-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" \nwidth=\"4\"><md-menu-item><md-button ng-click=\"vm.removeList($event,list)\" aria-label=\"Remove List\" translate \ntranslate-attr-aria-label=\"SB.REMOVE_LIST\"><md-icon md-font-icon=\"icon-delete\" md-menu-align-target></md-icon><span \ntranslate=\"SB.REMOVE_LIST\">Remove List</span></md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"list-content\" layout=\"column\"><div class=\"list-cards\" ui-sortable=\"vm.sortableCardOptions\" \nng-model=\"list.idCards\" ms-scroll><div ng-if=\"cardId\" class=\"list-card md-whiteframe-2dp\" \nng-repeat=\"cardId in list.idCards | filter: vm.cardFilter track by $index\" \nng-click=\"vm.openCardDialog($event, cardId)\"><div \nng-if=\"vm.board.settings.cardCoverImages && vm.board.cards.getById(cardId).idAttachmentCover\" class=\"list-card-cover\">\n<img \nng-src=\"{{vm.board.cards.getById(cardId).attachments.getById(vm.board.cards.getById(cardId).idAttachmentCover).src}}\">\n</div><div class=\"list-card-details\"><div class=\"list-card-sort-handle\"><md-icon md-font-icon=\"icon-cursor-move\" \nclass=\"icon s16\"></md-icon></div><div ng-if=\"vm.board.cards.getById(cardId).idLabels.length > 0\" \nclass=\"list-card-labels\" layout=\"row\" layout-wrap><span class=\"list-card-label\" \nng-class=\"\'md-\'+vm.board.labels.getById(labelId).color+\'-bg\'\" \nng-repeat=\"labelId in vm.board.cards.getById(cardId).idLabels\"><md-tooltip>{{vm.board.labels.getById(labelId).name}}\n</md-tooltip></span></div><div class=\"list-card-name\">{{vm.board.cards.getById(cardId).name}}</div><div \nng-if=\"vm.board.cards.getById(cardId).due || vm.board.cards.getById(cardId).checkItems\" class=\"list-card-badges\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"badge due-date\" \nng-class=\"{\'overdue\': vm.isOverdue(vm.board.cards.getById(cardId).due)}\" ng-if=\"vm.board.cards.getById(cardId).due\" \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon-clock s16\"></i> <span>\n{{vm.board.cards.getById(cardId).due | date:\'mediumDate\'}}</span> </span><span \nng-if=\"vm.board.cards.getById(cardId).checkItems\" class=\"badge check-items\" \nng-class=\"{\'completed\': vm.board.cards.getById(cardId).checkItemsChecked === vm.board.cards.getById(cardId).checkItems}\" \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon-checkbox-marked-circle s16\"></i> <span>\n{{vm.board.cards.getById(cardId).checkItemsChecked}}</span> <span>/</span> <span>\n{{vm.board.cards.getById(cardId).checkItems}}</span></span></div><div \nng-if=\"vm.board.cards.getById(cardId).idMembers.length > 0\" class=\"list-card-members\" layout=\"row\"><div \nclass=\"list-card-member\" ng-repeat=\"memberId in vm.board.cards.getById(cardId).idMembers\"><img \nclass=\"list-card-member-avatar\" ng-src=\"{{vm.board.members.getById(memberId).avatar}}\"><md-tooltip><div class=\"name\">\n{{ vm.board.members.getById(memberId).name}}</div></md-tooltip></div></div></div><div class=\"list-card-footer\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span \nng-if=\"vm.board.cards.getById(cardId).subscribed\" class=\"list-card-footer-item\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-eye s18\"></i> </span><span \nng-if=\"vm.board.cards.getById(cardId).description !== \'\'\" class=\"list-card-footer-item\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-document s18\"></i></span></div><div layout=\"row\" layout-align=\"end center\">\n<span class=\"list-card-footer-item\" ng-if=\"vm.board.cards.getById(cardId).attachments\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-attachment s18\"></i> <span class=\"value\">\n{{vm.board.cards.getById(cardId).attachments.length}}</span> </span><span class=\"list-card-footer-item\" \nng-if=\"vm.board.cards.getById(cardId).comments\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-comment s18\">\n</i> <span class=\"value\">{{vm.board.cards.getById(cardId).comments.length}}</span></span></div></div></div></div></div>\n<div class=\"list-footer\"><ms-sb-add-card ms-list-id=\"list.id\"></ms-sb-add-card></div></div></div><div \nclass=\"new-list-wrapper\"><div class=\"list new-list md-whiteframe-1dp\"><span editable-text=\"vm.newListName\" \ne-form=\"newListForm\" onaftersave=\"vm.addNewList()\"></span><md-button class=\"new-list-form-button\" \nng-click=\"newListForm.$show()\" ng-hide=\"newListForm.$visible\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon-plus md-red-bg\"></i> <span translate=\"SB.ADD_A_LIST\">Add a list</span></div></md-button></div></div></div>");
$templateCache.put("app/main/apps/scrumboard/views/boards/boards-view.html","<div id=\"boards\" class=\"md-accent-bg\" layout=\"column\" flex><div id=\"board-selector\" layout=\"column\" \nlayout-align=\"start center\" flex><h1 translate=\"SB.SCRUMBOARD_APP\">Scrumboard App</h1><div class=\"board-list\" \nlayout=\"row\" layout-align=\"center center\" layout-wrap><div class=\"board-list-item\" ng-repeat=\"board in vm.boardList\" \nui-sref=\"app.scrumboard.boards.board({id:board.id, uri:board.uri})\" layout=\"column\" layout-align=\"center center\">\n<md-icon md-font-icon=\"icon-trello\" class=\"icon s64\"></md-icon><div class=\"board-name\">{{board.name}}</div></div><div \nclass=\"board-list-item add-new-board\" layout=\"column\" layout-align=\"center center\" \nui-sref=\"app.scrumboard.boards.addBoard\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"icon s64\"></md-icon><div \nclass=\"board-name\" translate=\"SB.ADD_NEW_BOARD\">Add new board</div></div></div></div></div>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><span flex \nclass=\"menu-title\" translate=\"SB.FILTER_CARDS\">Filter Cards</span><md-button ng-if=\"vm.filteringIsOn()\" \nng-click=\"vm.clearFilters()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"SB.CLEAR_FILTER\">Clear Filters</span>\n</md-tooltip></md-button></div></md-toolbar><md-content class=\"\" ms-scroll><md-list><md-subheader class=\"md-no-sticky\" \ntranslate=\"SB.FILTER_BY_CARD_NAME\">Filter by Card Name</md-subheader><md-list-item><input flex \nplaceholder=\"Type Card Name\" type=\"text\" ng-model=\"vm.cardFilters.name\" translate \ntranslate-attr-placeholder=\"SB.TYPE_CARD_NAME\"></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\" translate=\"SB.FILTER_BY_LABELS\">Filter by Labels</md-subheader><md-list-item class=\"label\" \nng-repeat=\"label in vm.labels\" ng-click=\"vm.toggleInArray(label.id, vm.cardFilters.labels)\"><md-icon \nmd-font-icon=\"icon-label\" ng-class=\"label.color+\'-fg\'\" class=\"label-icon\"></md-icon><p>{{label.name}}</p><i \nclass=\"icon-check s16\" ng-if=\"vm.exists(label.id, vm.cardFilters.labels)\"></i></md-list-item><md-divider></md-divider>\n<md-subheader class=\"md-no-sticky\" translate=\"SB.FILTER_BY_MEMBERS\">Filter by Members</md-subheader><md-list-item \nclass=\"member\" ng-repeat=\"member in vm.members\" ng-click=\"vm.toggleInArray(member.id, vm.cardFilters.members)\" \naria-label=\"Toggle Member\"><img alt=\"{{ member.name }}\" ng-src=\"{{ member.avatar }}\" class=\"md-avatar\"><p \nclass=\"member-name\">{{ member.name }}</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(member.id, vm.cardFilters.members)\"></i></md-list-item></md-list></md-content>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/settings/settings-sidenav.html","<md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><md-button \nng-hide=\"vm.selectedMenu === \'Settings\'\" class=\"md-icon-button\" ng-click=\"vm.selectedMenu = \'Settings\'\" \naria-label=\"back\" translate translate-attr-aria-label=\"SB.BACK\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button><span flex class=\"menu-title\">{{vm.selectedMenu}}</span></div></md-toolbar><md-content \nng-show=\"vm.selectedMenu === \'Settings\'\" class=\"animate-slide-right settings\" ms-scroll ms-sidenav-helper><md-list>\n<md-list-item class=\"item\" ng-click=\"vm.selectedMenu = \'Board Color\'\"><md-icon md-font-icon=\"icon-format-color-fill\" \nclass=\"s18\"></md-icon><p class=\"title\" translate=\"SB.BOARD_COLOR\">Board Color</p></md-list-item><md-list-item \nclass=\"item\" ng-click=\"vm.board.settings.cardCoverImages = !vm.board.settings.cardCoverImages\"><md-icon \nmd-font-icon=\"icon-image-area\" class=\"s18\"></md-icon><p flex class=\"title\" translate=\"SB.CARD_COVER_IMAGES\">\nCard Cover Images</p><md-icon ng-show=\"vm.board.settings.cardCoverImages\" md-font-icon=\"icon-check\" class=\"s18\">\n</md-icon></md-list-item><md-list-item class=\"item\" \nng-click=\"vm.board.settings.subscribed = !vm.board.settings.subscribed\"><md-icon md-font-icon=\"icon-eye\" class=\"s18\">\n</md-icon><p flex class=\"title\" translate=\"SB.SUBSCRIBE\">Subscribe</p><md-icon ng-show=\"vm.board.settings.subscribed\" \nmd-font-icon=\"icon-check\" class=\"s18\"></md-icon></md-list-item><md-list-item class=\"item\"><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s18\"></md-icon><p class=\"title\" translate=\"SB.COPY_BOARD\">Copy Board</p>\n</md-list-item><md-list-item class=\"item\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon><p class=\"title\" \ntranslate=\"SB.DELETE_BOARD\">Delete Board</p></md-list-item><md-divider></md-divider><md-list-item class=\"item\" \nng-click=\"vm.selectedMenu = \'Labels\'\" aria-label=\"inbox\"><md-icon md-font-icon=\"icon-label\" class=\"s18\"></md-icon><p \nclass=\"title\" translate=\"SB.LABELS\">Labels</p></md-list-item><md-list-item class=\"item\" \nng-click=\"vm.selectedMenu = \'Members\'\" aria-label=\"inbox\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s18\">\n</md-icon><p class=\"title\" translate=\"SB.MEMBERS\">Members</p></md-list-item></md-list></md-content><md-content \nng-show=\"vm.selectedMenu === \'Board Color\'\" class=\"animate-slide-left board-color-selection\"><div layout=\"column\" \nlayout-fill ng-include=\"\'app/main/apps/scrumboard/sidenavs/settings/menus/color/color-menu.html\'\" \nng-controller=\"ColorMenuController as vm\"></div></md-content><md-content ng-show=\"vm.selectedMenu === \'Labels\'\" \nclass=\"animate-slide-left labels\"><div layout=\"column\" layout-fill \nng-include=\"\'app/main/apps/scrumboard/sidenavs/settings/menus/labels/labels-menu.html\'\" \nng-controller=\"LabelsMenuController as vm\"></div></md-content><md-content ng-show=\"vm.selectedMenu === \'Members\'\" \nclass=\"animate-slide-left members\"><div layout=\"column\" layout-fill \nng-include=\"\'app/main/apps/scrumboard/sidenavs/settings/menus/members/members-menu.html\'\" \nng-controller=\"MembersMenuController as vm\"></div></md-content>");
$templateCache.put("app/main/apps/file-manager/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"FM.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" \ntranslate translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span \ntranslate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" \ntranslate translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span \ntranslate=\"FM.MORE\">More</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div \nclass=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.modified}}</div></div></div>\n<md-content class=\"content\" flex ms-scroll><div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" \nlayout-align=\"center center\"><i class=\"icon-{{vm.selected.type}} s48\"></i></div><md-list class=\"offline-switch\">\n<md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch class=\"md-secondary\" \nng-model=\"vm.selected.offline\" aria-label=\"Toggle offline\" translate translate-attr-aria-label=\"FM.TOOGLE_OFFLINE\">\n</md-switch></md-list-item></md-list><div class=\"title\" translate=\"FM.INFO\">Info</div><table><tr class=\"type\"><th \ntranslate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr class=\"size\"><th translate=\"FM.SIZE\">Size</th><td>\n{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class=\"location\"><th translate=\"FM.LOCATION\">Location\n</th><td>{{vm.selected.location}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>\n{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>\n{{vm.selected.modified}}</td></tr><tr class=\"opened\"><th translate=\"FM.OPENED\">Opened</th><td>{{vm.selected.opened}}\n</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created}}</td></tr></table>\n</div></md-content>");
$templateCache.put("app/main/apps/file-manager/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon>\n</span><span class=\"logo-text\" translate=\"FM.FILE_MANAGER\">File Manager</span></div><div class=\"account\"><div \nclass=\"title\">John Doe</div><md-select class=\"account-selection simplified\" ng-model=\"vm.selectedAccount\" \nplaceholder=\"Select Account\"><md-option ng-repeat=\"(provider, address) in vm.accounts\" value=\"{{provider}}\">{{address}}\n</md-option></md-select></div></div><div class=\"content\"><div class=\"navigation-simple\" layout=\"column\"><md-button \nclass=\"item\" aria-label=\"inbox\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-folder\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.MY_FILES\">My Files</div></div>\n</md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.STARRED\">Starred</div></div>\n</md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-folder-account\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.SHARRED_WITH_ME\">\nSharred with me</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-clock\" class=\"s16\"></md-icon><div class=\"title\" \ntranslate=\"FM.RECENT\">Recent</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"s16\"></md-icon><div\n class=\"title\" translate=\"FM.OFFLINE\">Offline</div></div></md-button></div></div>");
$templateCache.put("app/main/apps/file-manager/views/grid/grid-view.html","<div class=\"grid-view\" layout=\"column\"><div class=\"folders\" layout=\"row\" layout-wrap><div \nclass=\"md-background-bg md-hue-2 md-whiteframe-1dp item folder\" ng-click=\"vm.select(folder)\" \nng-repeat=\"folder in vm.folders | filter:global.search\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" class=\"title\" layout-align=\"start center\"><span class=\"file-icon\"><i md-font-icon=\"icon-{{folder.type}}\">\n</i> </span><span class=\"name\">{{folder.name}}</span></div><div class=\"show-details\" hide-gt-md><md-button \nclass=\"md-icon-button sidenav-toggle\" aria-label=\"Details\" translate translate-attr-aria-label=\"FM.DETAILS\"><md-icon \nmd-font-icon=\"icon-information-outline\" ng-click=\"vm.toggleDetails(folder)\"></md-icon></md-button></div></div></div>\n<div class=\"files\" layout=\"row\" layout-wrap><div ng-click=\"vm.select(file)\" class=\"md-whiteframe-1dp item file\" \nng-repeat=\"file in vm.files | filter:global.search\" layout=\"column\"><div class=\"preview\"><img \nng-src=\"{{file.preview}}\"></div><div class=\"bottom md-background-bg md-hue-2\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" class=\"title\" layout-align=\"start center\" flex><span \nclass=\"file-icon\"><i md-font-icon=\"icon-{{file.type}}\"></i> </span><span class=\"name\">{{file.name}}</span></div><div \nclass=\"show-details\" hide-gt-md><md-button class=\"md-icon-button sidenav-toggle\" aria-label=\"Details\" translate \ntranslate-attr-aria-label=\"FM.DETAILS\"><md-icon md-font-icon=\"icon-information-outline\" \nng-click=\"vm.toggleDetails(file)\"></md-icon></md-button></div></div></div></div></div>");
$templateCache.put("app/main/apps/file-manager/views/list/list-view.html","<table class=\"simple list-view\"><thead><tr><th></th><th translate=\"FM.NAME\">Name</th><th hide show-gt-sm \ntranslate=\"FM.TYPE\">Type</th><th hide-xs translate=\"FM.OWNER\">Owner</th><th hide-xs translate=\"FM.SIZE\">Size</th><th \nhide show-gt-md translate=\"FM.LAST_MODIFIED\">Last Modified</th><th hide-gt-md></th></tr></thead><tbody><tr \nng-repeat=\"folder in vm.folders | filter:global.search\" ng-click=\"vm.select(folder)\" \nng-class=\"{\'selected\' : vm.selected === folder}\"><td class=\"file-icon\"><i class=\"icon-{{folder.type}}\"></i></td><td \nclass=\"name\">{{folder.name}}</td><td class=\"type\" hide show-gt-sm>{{folder.type}}</td><td class=\"owner\" hide-xs>\n{{folder.owner}}</td><td class=\"size\" hide-xs>{{folder.size === \'\' ? \'-\': folder.size}}</td><td class=\"last-modified\" \nhide show-gt-md>{{folder.modified}}</td><td class=\"show-details\" hide-gt-md><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleDetails(folder)\" aria-label=\"Toggle details sidenav\"><md-icon \nmd-font-icon=\"icon-information-outline\"></md-icon></md-button></td></tr><tr \nng-repeat=\"file in vm.files | filter:global.search\" ng-click=\"vm.select(file)\" \nng-class=\"{\'selected\' : vm.selected === file}\"><td class=\"file-icon\"><i class=\"icon-{{file.type}}\"></i></td><td \nclass=\"name\">{{file.name}}</td><td class=\"type\" hide show-gt-sm>{{file.type}}</td><td class=\"owner\" hide-xs>\n{{file.owner}}</td><td class=\"size\" hide-xs>{{file.size === \'\' ? \'-\': file.size}}</td><td class=\"last-modified\" hide \nshow-gt-md>{{file.modified}}</td><td class=\"show-details\" hide-gt-md><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleDetails(file)\" aria-label=\"Details\" translate translate-attr-aria-label=\"FM.DETAILS\"><md-icon \nmd-font-icon=\"icon-information-outline\"></md-icon></md-button></td></tr></tbody></table>");
$templateCache.put("app/main/apps/scrumboard/views/calendar/calendar-view.html","<div id=\"board-calendar\" class=\"page-layout simple right-sidenav\" flex layout=\"row\" \nng-class=\"vm.board.settings.color+\'-100-bg\'\"><md-sidenav class=\"sidenav scheduled-tasks-sidenav md-sidenav-left\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"scheduled-tasks-sidenav\" \nng-include=\"\'app/main/apps/scrumboard/views/calendar/sidenavs/scheduled-tasks/scheduled-tasks-sidenav.html\'\" ms-scroll \nms-sidenav-helper></md-sidenav><div id=\"calendar\" class=\"md-whiteframe-2dp\" flex layout=\"column\" \nng-class=\"vm.currentMonthShort\"><div class=\"calendar-header\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\"><md-button hide-gt-md class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'scheduled-tasks-sidenav\')\" \naria-label=\"Scheduled Cards Sidenav\"><md-icon md-font-icon=\"icon-calendar-clock\"></md-icon><md-tooltip><span \ntranslate=\"SB.SCHEDULED_CARDS\">Scheduled Cards</span></md-tooltip></md-button><div class=\"\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" \naria-label=\"Previous\" translate translate-attr-aria-label=\"SB.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon></md-button><div class=\"title\">{{vm.calendarView.title}}</div><md-button class=\"md-icon-button arrow\" \nng-click=\"vm.calendar.next()\" aria-label=\"Next\" translate translate-attr-aria-label=\"SB.NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div><div><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.today()\" aria-label=\"Today\" translate translate-attr-aria-label=\"SB.TODAY\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span translate=\"SB.TODAY\">Today</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" \ntranslate translate-attr-aria-label=\"SB.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span \ntranslate=\"SB.DAY\">Day</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"Week\" translate translate-attr-aria-label=\"SB.WEEK\">\n<md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span translate=\"SB.WEEK\">Week</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate \ntranslate-attr-aria-label=\"SB.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span \ntranslate=\"SB.MONTH\">Month</span></md-tooltip></md-button></div></div><div class=\"calendar-main\" ms-scroll flex \nui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.eventSources\" calendar=\"main\"></div></div></div>");
$templateCache.put("app/main/apps/notes/sidenavs/main/main-sidenav.html","<div ms-scroll class=\"content\"><md-list><md-list-item ng-click=\"vm.filterChange(\'notes\')\" \nng-class=\"{\'selected\':vm.listType ===\'notes\'}\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-lightbulb\" class=\"mr-16\"></md-icon><span translate=\"NOTES.NOTES\">Notes</span></div></md-list-item>\n<md-list-item ng-click=\"vm.filterChange(\'reminders\')\" ng-class=\"{\'selected\':vm.listType ===\'reminders\'}\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-bell\" class=\"mr-16\"></md-icon><span \ntranslate=\"NOTES.REMINDERS\">Reminders</span></div></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\"><span translate=\"NOTES.LABELS\">Labels</span></md-subheader><md-list-item \nng-repeat=\"label in vm.labels\" ng-class=\"{\'selected\':vm.noteListType.name === label.name}\" class=\"label\" layout=\"row\" \nlayout-align=\"start center\" flex><ms-material-color-picker ng-model=\"label.color\"><md-icon class=\"mr-16\" \nmd-font-icon=\"icon-label\" ng-style=\"{color:$selectedColor.bgColorValue}\"></md-icon></ms-material-color-picker><span \nclass=\"label-name text-transclude\" flex ng-hide=\"editLabelForm.$visible\" ng-click=\"vm.filterChange(label)\">\n{{label.name}} </span><span flex editable-text=\"label.name\" e-form=\"editLabelForm\" ng-show=\"editLabelForm.$visible\">\n{{label.name}}</span><md-button class=\"md-icon-button\" ng-hide=\"editLabelForm.$visible\" \nng-click=\"editLabelForm.$show()\" aria-label=\"edit label\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-hide=\"editLabelForm.$visible\" \nng-click=\"vm.deleteLabel($event, label)\" aria-label=\"delete label\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\">\n</md-icon></md-button></md-list-item><md-list-item class=\"new-label-form\" ng-show=\"newLabelForm.$visible\"><p \neditable-text=\"vm.newLabel.name\" e-form=\"newLabelForm\" onaftersave=\"vm.addNewLabel(vm.newLabel)\"></p></md-list-item>\n<md-list-item class=\"\" ng-click=\"newLabelForm.$show()\" ng-hide=\"newLabelForm.$visible\"><p class=\"md-accent-fg\" \ntranslate=\"NOTES.NEW_LABEL\">New Label</p></md-list-item><md-divider></md-divider><md-list-item \nng-click=\"vm.filterChange(\'archive\')\" ng-class=\"{\'selected\':vm.listType ===\'archive\'}\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-archive\" class=\"mr-16\"></md-icon><span \ntranslate=\"NOTES.ARCHIVE\">Archive</span></div></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/notes/directives/ms-note-form/ms-note-form.html","<form ng-submit=\"MsNoteForm.submit()\" ng-class=\"MsNoteForm.note.color\"><div ng-if=\"MsNoteForm.note.image\" \nclass=\"image-wrapper\"><img class=\"md-card-image\" ng-src=\"{{MsNoteForm.note.image}}\"><md-button \nclass=\"md-fab md-mini delete-image-button\" ng-click=\"MsNoteForm.deleteImage()\" aria-label=\"delete image\" translate \ntranslate-attr-aria-label=\"NOTES.DELETE_IMAGE\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><input \ntype=\"text\" class=\"note-title-input\" placeholder=\"Title\" ng-model=\"MsNoteForm.note.title\" \nng-class=\"MsNoteForm.note.color\"><md-input-container md-no-float ng-class=\"MsNoteForm.note.color\"><textarea \ntype=\"text\" class=\"note-description-textarea\" placeholder=\"Take a note..\" translate \ntranslate-attr-placeholder=\"NOTES.TAKE_A_NOTE\" ng-model=\"MsNoteForm.note.description\">\n    </textarea>\n</md-input-container><md-list class=\"checklist\" ng-if=\"MsNoteForm.note.checklist.length > 0\"><md-divider></md-divider>\n<md-list-item ng-repeat=\"item in MsNoteForm.note.checklist\"><md-checkbox ng-model=\"item.checked\" \naria-label=\"toggle check\"></md-checkbox><p ng-class=\"{\'text-strike md-secondary-text\':item.checked}\">{{item.text}}</p>\n<md-icon ng-click=\"$event.preventDefault();$event.stopPropagation();MsNoteForm.deleteCheckItem(item)\" \nclass=\"md-secondary\" md-font-icon=\"icon-close-circle\" aria-label=\"remove\"></md-icon><md-divider></md-divider>\n</md-list-item></md-list><div class=\"checklist-form\" \nng-if=\"MsNoteForm.note.checklist.length > 0 || MsNoteForm.checkListForm\" layout=\"row\" layout-align=\"space-between end\">\n<md-input-container class=\"\" md-no-float flex><input id=\"new-checklist-item-input\" type=\"text\" placeholder=\"List item\" \nng-model=\"MsNoteForm.newCheckListItem\" \nng-keydown=\"$event.keyCode === 13 ? $event.preventDefault() + MsNoteForm.addChecklistItem():\'\';\"></md-input-container>\n<md-button class=\"md-icon-button\" ng-click=\"MsNoteForm.addChecklistItem()\" aria-label=\"add\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"labels\" ng-if=\"MsNoteForm.note.labels.length > 0\" \nlayout=\"row\" layout-wrap layout-align=\"end start\"><div class=\"label\" ng-repeat=\"labelId in MsNoteForm.note.labels\" \nng-class=\"MsNoteForm.labels.getById(labelId).color\">{{MsNoteForm.labels.getById(labelId).name}}</div></div><div \nng-if=\"MsNoteForm.type ===\'edit\'\" class=\"date text-right p-16\">{{MsNoteForm.note.time | altDate}}</div><div \nclass=\"footer\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"actions\" layout=\"row\" layout-align=\"center center\"><div id=\"image-uploader\" \nflow-init=\"MsNoteForm.ngFlowOptions\" flow-name=\"MsNoteForm.ngFlow.flow\" flow-files-submitted=\"MsNoteForm.upload()\" \nflow-file-success=\"MsNoteForm.imageSuccess($file, $message)\" flow-complete=\"MsNoteForm.uploadComplete()\" \nflow-file-added=\"!!{svg:1,png:1,gif:1,jpg:1,jpeg:1}[$file.getExtension()]\"><md-button flow-btn \nclass=\"add-img-button md-icon-button\" aria-label=\"Add image\" translate translate-attr-aria-label=\"NOTES.ADD_IMAGE\">\n<md-icon md-font-icon=\"icon-file-image-box\" class=\"s20\"></md-icon></md-button></div><md-button class=\"md-icon-button\" \naria-label=\"checklist\" ng-click=\"MsNoteForm.checklistFormToggle()\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-marked\" class=\"s20\"></md-icon></md-button><md-menu class=\"label-menu\"><md-button \nclass=\"md-icon-button\" aria-label=\"Label\" translate translate-attr-aria-label=\"NOTES.LABEL\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-label\" class=\"s20\"></md-icon></md-button>\n<md-menu-content class=\"notes-labels-menu-content\" width=\"4\" ms-scroll><md-menu-item><md-input-container \nclass=\"no-errors-spacer\" md-no-float><input placeholder=\"Search labels...\" type=\"text\" \nng-model=\"MsNoteForm.labelSearchText\" autocomplete=\"off\" translate-attr-palceholder=\"NOTES.SEARCH_LABELS\">\n</md-input-container></md-menu-item><md-menu-item class=\"label\" \nng-repeat=\"label in MsNoteForm.labels | filter: MsNoteForm.labelSearchText\"><md-button class=\"label-toggle-button\" \nmd-prevent-menu-close ng-class=\"label.color\" ng-click=\"MsNoteForm.toggleInArray(label.id, MsNoteForm.note.labels)\" \naria-label=\"Toggle Label\" translate translate-attr-aria-label=\"NOTES.TOGGLE_LABEL\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><span>{{label.name}}</span> <i \nng-if=\"MsNoteForm.exists(label.id, MsNoteForm.note.labels)\" class=\"icon-check s16\"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu><md-button class=\"md-icon-button\" ng-click=\"MsNoteForm.toggleArchive()\" \naria-label=\"archive\"><md-icon md-font-icon=\"icon-archive\" class=\"s20\"></md-icon></md-button><ms-material-color-picker \nng-model=\"MsNoteForm.note.color\"><md-button class=\"md-icon-button\" aria-label=\"color\"><md-icon \nmd-font-icon=\"icon-palette\" class=\"s20\"></md-icon></md-button></ms-material-color-picker><md-datepicker \nclass=\"reminder\" ng-model=\"MsNoteForm.note.reminder\" md-placeholder=\"Add reminder\" ms-datepicker-fix></md-datepicker>\n</div><div layout=\"row\" layout-align=\"end center\"><md-button ng-if=\"MsNoteForm.type ===\'edit\'\" \nng-click=\"MsNoteForm.deleteNote()\" class=\"md-icon-button\" aria-label=\"delete note\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button><md-button ng-if=\"MsNoteForm.type ===\'edit\'\" type=\"submit\" translate=\"NOTES.SAVE\" \nng-disabled=\"MsNoteForm.isNotValid()\">Save</md-button><md-button ng-if=\"MsNoteForm.type ===\'new\'\" type=\"submit\" \ntranslate=\"NOTES.ADD\" ng-disabled=\"MsNoteForm.isNotValid()\">Add</md-button></div></div></form>");
$templateCache.put("app/main/apps/notes/directives/ms-new-note/ms-new-note.html","<ms-note-form note-type=\"\'new\'\"></ms-note-form><div ms-new-note-button class=\"new-note-button\"><span \ntranslate=\"NOTES.TAKE_A_NOTE\">Take a note..</span></div>");
$templateCache.put("app/main/apps/notes/directives/ms-note-item/ms-note-item.html","<md-card ng-class=\"MsNoteItem.note.color\"><img ng-if=\"MsNoteItem.note.image\" class=\"md-card-image\" \nng-src=\"{{MsNoteItem.note.image}}\"><md-card-content><md-card-title ng-if=\"MsNoteItem.note.title\"><md-card-title-text>\n{{MsNoteItem.note.title}}</md-card-title-text></md-card-title><md-description ng-if=\"MsNoteItem.note.description\">\n<span>{{MsNoteItem.note.description}}</span></md-description><div ng-if=\"MsNoteItem.note.checklist.length > 0\" \nclass=\"checklist\"><div class=\"checklist-item\" ng-repeat=\"checkItem in  MsNoteItem.note.checklist\" layout=\"row\" \nlayout-align=\"start center\"><md-checkbox ng-model=\"checkItem.checked\" \nng-click=\"$event.preventDefault();$event.stopPropagation()\" aria-label=\"{{checkItem.text}}\"></md-checkbox><span \nclass=\"text-truncate\" ng-class=\"{\'text-strike md-secondary-text\':checkItem.checked}\" flex>{{checkItem.text}}</span>\n</div></div><div class=\"labels\" ng-if=\"MsNoteItem.note.labels.length > 0\" layout=\"row\" layout-wrap \nlayout-align=\"end start\"><div class=\"label\" ng-repeat=\"labelId in MsNoteItem.note.labels\" \nng-click=\"$event.preventDefault();$event.stopPropagation();vm.filterChange(vm.labels.getById(labelId))\" \nng-class=\"vm.labels.getById(labelId).color\">{{vm.labels.getById(labelId).name}}</div></div><div \nng-if=\"vm.noteListType ===\'reminders\' && MsNoteItem.note.reminder\" class=\"reminder secondary-text text-right\"><md-icon \nmd-font-icon=\"icon-bell\" class=\"s16 mr-8\"></md-icon><span>{{MsNoteItem.note.reminder | altDate}}</span></div>\n</md-card-content></md-card>");
$templateCache.put("app/main/apps/contacts/dialogs/contact/contact-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" \nflex layout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{vm.contact.avatar}}\" class=\"md-avatar avatar contact-avatar huge\" alt=\"{{vm.contact.name}}\"><div \nclass=\"contact-name\">{{vm.contact.name}}</div></div></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" \nlayout=\"row\" layout-align=\"center center\"><div flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleInArray(vm.contact.id, vm.user.starred)\" aria-label=\"Toggle starred\" \ntranslate translate-attr-aria-label=\"CONTACTS.TOGGLE_STARRED\"><md-icon \nng-if=\"vm.exists(vm.contact.id,vm.user.starred)\" md-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon \nng-if=\"!vm.exists(vm.contact.id,vm.user.starred)\" md-font-icon=\"icon-star-outline\"></md-icon></md-button><md-menu>\n<md-button class=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon \nmd-font-icon=\"icon-account-multiple-plus\" ng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" \nng-click=\"vm.toggleInArray(vm.contact.id,group.contactIds)\"><p class=\"pl-8\" \nng-style=\"vm.exists(vm.contact.id,group.contactIds) && {\'font-weight\':\'500\'}\">{{group.name}}</p></md-list-item>\n</md-menu-content></md-menu></div></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"CONTACTS.NAME_REQUIRED\">Name (required)</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"vm.contact.name\" type=\"text\" ng-required \nmd-autofocus></md-input-container><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"CONTACTS.LAST_NAME\">Last name</label><md-icon></md-icon><input ng-model=\"vm.contact.lastName\" type=\"text\">\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label translate=\"CONTACTS.NICKNAME\">Nickname\n</label><md-icon></md-icon><input ng-model=\"vm.contact.nickname\" type=\"text\"></md-input-container><div \nng-if=\"!vm.allFields\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent\" \nng-click=\"vm.allFields = true\" translate=\"CONTACTS.SHOW_ALL_FIELDS\">Show All Fields</md-button></div><div \nng-if=\"vm.allFields\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-phone\"></md-icon><input \nng-model=\"vm.contact.phone\" type=\"text\" placeholder=\"Phone number\" translate \ntranslate-attr-placeholder=\"CONTACTS.PHONE_NUMBER\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-email\" class=\"email\"></md-icon><input ng-model=\"vm.contact.email\" type=\"email\" placeholder=\"Email\" \ntranslate translate-attr-placeholder=\"CONTACTS.EMAIL\"></md-input-container><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-domain\"></md-icon><input ng-model=\"vm.contact.company\" type=\"text\" placeholder=\"Company\" \ntranslate translate-attr-placeholder=\"CONTACTS.COMPANY\"></md-input-container><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-worker\"></md-icon><input ng-model=\"vm.contact.jobTitle\" type=\"text\" \nplaceholder=\"Job title\" translate translate-attr-placeholder=\"CONTACTS.JOB_TITLE\"></md-input-container><md-datepicker \nclass=\"birthday-input\" ng-model=\"vm.contact.birthday\" md-placeholder=\"Birthday\" ng-required=\"false\"></md-datepicker>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-home\"></md-icon><input ng-model=\"vm.contact.address\" \ntype=\"text\" placeholder=\"Address\" translate translate-attr-placeholder=\"CONTACTS.ADDRESS\"></md-input-container><div \nlayout=\"row\" class=\"md-block textarea-wrapper\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-note\"></md-icon>\n<md-input-container flex><label translate translate-attr-placeholder=\"CONTACTS.NOTES\">Notes</label><textarea \nng-model=\"vm.contact.notes\" type=\"text\" max-rows=\"4\"></textarea></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"vm.allFields = false\" \ntranslate=\"CONTACTS.FEWER_FIELDS\">Fewer Fields</md-button></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-if=\"!vm.newContact\" ng-click=\"vm.saveContact()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"SAVE\" translate=\"CONTACTS.SAVE\" \ntranslate-attr-aria-label=\"CONTACTS.SAVE\">SAVE</md-button><md-button type=\"submit\" ng-if=\"vm.newContact\" \nng-click=\"vm.addNewContact()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"Add Task\" translate=\"CONTACTS.ADD_CONTACT\" \ntranslate-attr-aria-label=\"CONTACTS.ADD_CONTACT\">ADD CONTACT</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteContactConfirm($event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CONTACTS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CONTACTS.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/todo/dialogs/task/task-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-input-container class=\"md-block\"><label translate=\"TODO.TITLE\">Title</label><input name=\"title\" \nng-model=\"vm.task.title\" required md-autofocus><div ng-messages=\"taskForm.title.$error\" \nng-show=\"taskForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"TODO.ERRORS.TITLE_REQUIRED\">\nTitle field is required</span></div></div></md-input-container><div class=\"tags\"><label translate=\"TODO.TAGS\">Tags\n</label><md-chips ng-model=\"vm.task.tags\" md-transform-chip=\"vm.newTag($chip)\"><md-chip-template><span \nng-if=\"$chip.color\" class=\"color\" ng-style=\"{\'background-color\':$chip.color}\"></span> <span>{{$chip.label}}</span>\n</md-chip-template></md-chips></div><div layout-xs=\"column\" layout=\"row\"><div flex class=\"date-container\"><label \ntranslate=\"TODO.START_DATE\">Start Date</label><md-datepicker flex ng-model=\"vm.task.startDate\" \nmd-placeholder=\"Start Date\"></md-datepicker></div><div flex class=\"date-container\"><label translate=\"TODO.DUE_DATE\">\nDue Date</label><md-datepicker flex ng-model=\"vm.task.dueDate\" md-placeholder=\"Due Date\"></md-datepicker></div></div>\n<div class=\"notes\"><label translate=\"TODO.NOTES\">Notes</label><text-angular ng-model=\"vm.task.notes\"></text-angular>\n</div><div class=\"attachment-list\"><div class=\"attachment\" layout=\"row\" layout-align=\"space-between center\"><div><span \nclass=\"filename\">attachment-2.doc</span> <span class=\"size\">(12 Kb)</span></div><md-button class=\"md-icon-button\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"delete attachment\" class=\"s16\"></md-icon></md-button></div><div \nclass=\"attachment\" layout=\"row\" layout-align=\"space-between center\"><div><span class=\"filename\">attachment-1.jpg</span>\n <span class=\"size\">(350 Kb)</span></div><md-button class=\"md-icon-button\" aria-label=\"Delete attachment\" translate \ntranslate-attr-aria-label=\"TODO.DELETE_ATTACHMENT\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon>\n</md-button></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-if=\"!vm.newTask\" ng-click=\"vm.saveTask()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"SAVE\" \ntranslate=\"TODO.SAVE\" translate-attr-aria-label=\"TODO.SAVE\">SAVE</md-button><md-button type=\"submit\" \nng-if=\"vm.newTask\" ng-click=\"vm.addNewTask()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"Add Task\" translate=\"TODO.ADD_TASK\" \ntranslate-attr-aria-label=\"TODO.ADD_TASK\">ADD TASK</md-button><md-button class=\"md-icon-button\" \naria-label=\"Attach file\" translate translate-attr-aria-label=\"TODO.ATTACH_FILE\"><md-icon md-font-icon=\"icon-paperclip\">\n</md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Insert picture\" translate \ntranslate-attr-aria-label=\"TODO.INSERT_PICTURE\"><md-icon md-font-icon=\"icon-file-image-box\"></md-icon></md-button>\n</div><div layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteTask($event)\" aria-label=\"Delete\" \ntranslate translate-attr-aria-label=\"TODO.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"TODO.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/contacts/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{vm.user.avatar}}\" \nclass=\"md-avatar avatar mr-16\" alt=\"{{vm.user.name}}\"> <span class=\"font-weight-500 font-size-14\">{{vm.user.name}}\n</span></div><md-divider></md-divider><div ms-scroll class=\"content scrollable\"><md-list><md-list-item \nng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType ===\'all\'}\"><p translate=\"CONTACTS.ALL_CONTACTS\">\nAll contacts</p></md-list-item><md-list-item ng-click=\"vm.filterChange(\'frequent\')\" \nng-class=\"{\'selected\':vm.listType ===\'frequent\'}\"><p translate=\"CONTACTS.FREQUENTLY_CONTACTED\">Frequently contacted</p>\n</md-list-item><md-list-item ng-click=\"vm.filterChange(\'starred\')\" ng-class=\"{\'selected\':vm.listType ===\'starred\'}\"><p \ntranslate=\"CONTACTS.STARRED_CONTACTS\">Starred contacts</p></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\">Groups</md-subheader><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" \nng-click=\"vm.filterChange(group)\" ng-class=\"{\'selected\':vm.listType.name === group.name}\"><p class=\"pl-8\">\n{{group.name}}</p></md-list-item><md-list-item class=\"new-group-form\" ng-show=\"newListForm.$visible\"><p class=\"pl-8\" \neditable-text=\"vm.newGroupName\" e-form=\"newListForm\" onaftersave=\"vm.addNewGroup()\"></p></md-list-item><md-list-item \nclass=\"\" ng-click=\"newListForm.$show()\" ng-hide=\"newListForm.$visible\"><p class=\"pl-8 md-accent-fg\" \ntranslate=\"CONTACTS.NEW_GROUP\">New Group</p></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/todo/views/list/list-view.html","<div class=\"todo-items\" ng-sortable=\"vm.sortableOptions\" ng-model=\"vm.tasks\" \nng-class=\"{\'sortable\': vm.taskOrder === \'\'}\"><div class=\"todo-item\" md-ink-ripple layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.openTaskDialog($event, task)\" \nng-repeat=\"task in vm.tasks | orderBy:vm.taskOrder:vm.taskOrderDescending | filter:global.search | filter:vm.taskFilters.search | filterByTags:vm.taskFilters.tags | filter:{\'completed\': vm.taskFilters.completed} | filter:{\'deleted\': vm.taskFilters.deleted} | filter:{\'important\': vm.taskFilters.important} | filter:{\'starred\':vm.taskFilters.starred} | filter:vm.filterByStartDate | filter:vm.filterByDueDate track by $index\" \nng-class=\"{\'starred\': task.starred, \'selected\': task.selected, \'completed\': task.completed}\"><div class=\"handle\" \nng-click=\"vm.preventDefault($event)\"><md-icon md-font-icon=\"icon-drag-vertical\" class=\"icon\"></md-icon></div>\n<md-checkbox class=\"no-label\" ng-checked=\"task.completed\" ng-click=\"vm.toggleCompleted(task, $event)\" \naria-label=\"{{task.completed ? \'Not completed\' : \'Completed\'}}\"></md-checkbox><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex><div class=\"title\">{{task.title}}</div><div class=\"notes\">\n{{task.notes}}</div><div class=\"tags\" layout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"tag\" \nlayout=\"row\" layout-align=\"start center\" data-ng-repeat=\"tag in task.tags\"><div class=\"tag-color\" \nng-style=\"{\'background-color\': tag.color}\"></div><div class=\"tag-label\">{{tag.label}}</div></div></div></div><div \nclass=\"buttons\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"is-important red-600-fg\" ng-if=\"task.important\"></md-icon><md-icon md-font-icon=\"icon-star\" \nclass=\"is-starred amber-600-fg\" ng-if=\"task.starred\"></md-icon><md-menu><md-button class=\"md-icon-button\" \naria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdMenu.open($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"task.completed = !task.completed\" aria-label=\"Toggle done\" translate-attr-aria-label=\"TODO.TOGGLE_DONE\">\n<md-icon ng-class=\"task.completed === false ? \'grey-fg\' : \'blue-fg\'\" md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"s18\"></md-icon><span ng-show=\"!task.completed\" translate=\"TODO.MARK_AS_DONE\">Mark as done</span> <span \nng-show=\"task.completed\" translate=\"TODO.MARK_AS_UNDONE\">Mark as undone</span></md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"task.important = !task.important\" aria-label=\"Toggle important\" \ntranslate-attr-aria-label=\"TODO.TOGGLE_IMPORTANT\"><md-icon \nng-class=\"task.important === false ? \'grey-fg\' : \'red-600-fg\'\" md-font-icon=\"icon-alert-circle\" class=\"s18\"></md-icon>\n<span ng-show=\"!task.important\" translate=\"TODO.MARK_AS_IMPORTANT\">Mark as important</span> <span \nng-show=\"task.important\" translate=\"TODO.REMOVE_IMPORTANT\">Remove important</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"task.starred = !task.starred\" aria-label=\"Toggle star\" \ntranslate-attr-aria-label=\"TODO.TOGGLE_STAR\"><md-icon ng-class=\"task.starred === false ? \'grey-fg\' : \'amber-600-fg\'\" \nmd-font-icon=\"icon-star\" class=\"s18\"></md-icon><span ng-show=\"!task.starred\" translate=\"TODO.ADD_STAR\">Add star</span> \n<span ng-show=\"task.starred\" translate=\"TODO.REMOVE_STAR\">Remove star</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div></div>");
$templateCache.put("app/main/apps/todo/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-checkbox-marked\" class=\"s24\"></md-icon>\n</span><span class=\"logo-text\" translate=\"TODO.TO_DO\">To-Do</span></div><md-select \nclass=\"project-selection simplified\" ng-model=\"vm.selectedProject\" placeholder=\"Select Project\"><md-option \nng-repeat=\"(project, title) in vm.projects\" value=\"{{project}}\">{{title}}</md-option></md-select></div><md-content \nclass=\"content\" flex ms-scroll><div class=\"add-task-button\"><md-button class=\"md-accent md-raised\" \nng-click=\"vm.openTaskDialog($event)\" aria-label=\"ADD TASK\" translate=\"TODO.ADD_TASK\" \ntranslate-attr-aria-label=\"TODO.ADD_TASK\">ADD TASK</md-button></div><div class=\"navigation-simple\" layout=\"column\">\n<md-button class=\"item\" aria-label=\"All Tasks\" translate translate-attr-aria-label=\"TODO.ALL_TASKS\" \nng-class=\"{\'selected\':vm.showAllTasks}\" ng-click=\"vm.resetFilters()\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-view-headline\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.ALL_TASKS\">\nAll Tasks</span></div></md-button><div class=\"item subheader\" translate=\"TODO.FILTERS\">Filters</div><md-button \nclass=\"item\" aria-label=\"Starred\" translate translate-attr-aria-label=\"TODO.STARRED\" \nng-click=\"vm.toggleFilterWithEmpty(\'starred\')\" ng-class=\"{\'selected\':vm.taskFilters.starred}\"><md-icon \nmd-font-icon=\"icon-star\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.STARRED\">Starred</span></md-button>\n<md-button class=\"item\" aria-label=\"Priority\" translate translate-attr-aria-label=\"TODO.PRIORITY\" \nng-click=\"vm.toggleFilterWithEmpty(\'important\')\" ng-class=\"{\'selected\':vm.taskFilters.important}\"><md-icon \nmd-font-icon=\"icon-alert-circle\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.PRIORITY\">Priority</span>\n</md-button><md-button class=\"item\" aria-label=\"Scheduled\" translate translate-attr-aria-label=\"TODO.SCHEDULED\" \nng-click=\"vm.toggleFilterWithEmpty(\'dueDate\')\" ng-class=\"{\'selected\':vm.taskFilters.dueDate}\"><md-icon \nmd-font-icon=\"icon-clock\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.SCHEDULED\">Scheduled</span>\n</md-button><md-button class=\"item\" aria-label=\"Today\" translate translate-attr-aria-label=\"TODO.TODAY\" \nng-click=\"vm.toggleFilterWithEmpty(\'startDate\')\" ng-class=\"{\'selected\':vm.taskFilters.startDate}\"><md-icon \nmd-font-icon=\"icon-calendar-today\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.TODAY\">Today</span>\n</md-button><md-button class=\"item\" aria-label=\"Done\" translate translate-attr-aria-label=\"TODO.DONE\" \nng-click=\"vm.toggleFilterWithEmpty(\'completed\')\" ng-class=\"{\'selected\':vm.taskFilters.completed}\"><md-icon \nmd-font-icon=\"icon-check\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.DONE\">Done</span></md-button>\n<md-button class=\"item\" aria-label=\"Deleted\" translate translate-attr-aria-label=\"TODO.DELETED\" \nng-click=\"vm.toggleFilter(\'deleted\')\" ng-class=\"{\'selected\':vm.taskFilters.deleted}\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.DELETED\">Deleted</span>\n</md-button><div class=\"item subheader\" translate=\"TODO.TAGS\">Tags</div><md-button class=\"tag item\" \naria-label=\"tag {{tag.label}}\" ng-repeat=\"tag in vm.tags\" ng-click=\"vm.toggleTagFilter(tag)\" \nng-class=\"{\'selected\':vm.isTagFilterExists(tag)}\"><md-icon md-font-icon=\"icon-label\" class=\"s16\" \nng-style=\"{\'color\' : tag.color}\"></md-icon><span class=\"title\">{{tag.label}}</span></md-button></div></md-content>");
$templateCache.put("app/main/components/material-docs/partials/CSS/button.html","<div class=\"doc-content theming\"><h1 id=\"-lt-md-button-gt-\">&lt;md-button&gt;</h1><p>\nBelow is a snapshot of the AngularJS Material <strong>button</strong>\n component demos with the default themes and standard options:</p><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/210413/7947020/fafde934-093f-11e5-9584-27eb2deedd0f.png\" \nalt=\"buttonsdemo\"></p><p><br></p><h3 id=\"css-styles\">CSS Styles</h3><p>The base CSS class for all <code>\n&lt;md-button&gt;</code> components is <code>.md-button</code>:</p><hljs lang=\"css\">\n.md-button { padding: 0 6px 0 6px; margin: 6px 8px 6px 8px; min-width: 88px; border-radius: 3px; font-size: 14px; text-align: center; text-transform: uppercase; text-decoration:none; border: none; outline: none; }\n</hljs><p>When defining custom CSS overrides, developers should create their own CSS class. For example, to define a \n<code>.btn1</code> override to <strong>md-button</strong> use:</p><hljs lang=\"css\">\n.btn1 { // your custom overrides here }</hljs><hljs lang=\"html\"><md-button class=\"btn1\" ng-click=\"acceptOffer();\">\nAccept</md-button></hljs><p><br></p><h3 id=\"theme-requirements\">Theme Requirements</h3><p>\nAll AngularJS Material components have specific CSS rules constructed using the theme name and theme-class overrides. For the \n<strong>Default</strong> theme, however, these rules are added to the components styles using the <code>\n.md-default-theme</code> class. If, however, you have configured a custom theme called <code>companyX</code> that is \n<strong>NOT</strong> the default theme, then any CSS overrides <strong>must</strong>\n use fully-specified classname. For <code>&lt;md-button&gt;</code> the <strong>fully-specified classname</strong>\n will be <code>.md-button.md-companyX-theme.btn1</code>.</p><hljs lang=\"css\">\n.md-button.md-companyX-theme.btn1 { } .md-button.md-companyX-theme.md-primary.btn1 { } .md-button.md-companyX-theme.md-accent.btn1 { } .md-button.md-companyX-theme.md-warn.btn1 { }\n</hljs><p><br></p><h2 id=\"flat-buttons\">Flat Buttons</h2><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/210413/7945984/bda14884-0939-11e5-9196-131ded20ca77.png\" \nalt=\"mdbuttonflatdefault3\"></p><hljs lang=\"html\"><md-button>Button</md-button></hljs><hljs lang=\"css\">\n.md-button { color : currentColor; } .md-button:not([disabled]):hover { background-color: rgba(158, 158, 158, 0.2); } .md-button[disabled] { color : rgba(0, 0, 0, 0.26); background-color: transparent; }\n</hljs><p><br></p><h4 id=\"custom-css-overrides\">Custom CSS Overrides</h4><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/210413/7945987/c1b1c700-0939-11e5-879c-ba804ca03267.png\" \nalt=\"mdbuttonflatdefault_overrides2\"></p><hljs lang=\"html\"><md-button class=\"btn1\">Button</md-button></hljs><hljs \nlang=\"css\">\n.btn1 { color : rgb(49, 46, 46); background-color: rgba(255, 222, 121, 0.96); border-radius: 10px 0 0 10px; font-size: 16px; } .btn1:not([disabled]):hover { background-color: rgba(107, 103, 91, 0.96); color: white; } .btn1[disabled] { color : rgb(187, 187, 187); background-color: rgba(230, 230, 229, 0.96); }\n</hljs><p><br></p><h2 id=\"raised-buttons\">Raised Buttons</h2><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/1292882/7254163/fe898728-e849-11e4-943b-a9cd88ec9573.PNG\" \nalt=\"raisedbutton\"></p><p>Add the <code>.md-raised</code> class to create a raised button:</p><hljs lang=\"html\">\n<md-button class=\"md-raised\">Button</md-button></hljs><hljs lang=\"css\">\n.md-button.md-raised:not([disabled]) { box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26); }</hljs><p><br></p><h2 \nid=\"cornered-buttons\">Cornered buttons</h2><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/1292882/7254379/682592ac-e84b-11e4-8d33-78314cea8bda.PNG\" \nalt=\"corneredbutton\"></p><p>Add the <code>.md-cornered</code> class to create a button with corners:</p><hljs \nlang=\"html\"><md-button class=\"md-raised md-cornered\">Button</md-button></hljs><hljs lang=\"css\">\n.md-button.md-cornered { border-radius: 0; }</hljs><p><br></p><h2 id=\"default-fab-button\">Default FAB Button</h2><p>\n<img src=\"https://cloud.githubusercontent.com/assets/1292882/7254736/8fec7ee8-e84d-11e4-9cf9-58ea9221c3c2.PNG\" \nalt=\"floatingbutton\"></p><p>Add the <code>.md-fab</code> class in order to create a floating action button (aka FAB):\n</p><hljs lang=\"html\"><md-button class=\"md-fab\" aria-label=\"Eat cake\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/cake.svg\"></md-icon></md-button></hljs><hljs lang=\"css\">\n.md-button.md-fab { line-height: 5.6rem; min-width: 0; width: 5.6rem; height: 5.6rem; border-radius: 50%; }</hljs><p>\n<br></p><h2 id=\"mini-fab-button\">Mini FAB Button</h2><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/1292882/7273617/1fcca280-e8fe-11e4-9588-231a9e860be1.PNG\" \nalt=\"minibutton\"></p><p>Add the <code>.md-mini</code> class in order to create small, mini-FAB buttons:</p><hljs \nlang=\"html\"><md-button class=\"md-fab md-mini\" aria-label=\"Eat cake\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/cake.svg\"></md-icon></md-button></hljs><hljs lang=\"css\">\n.md-button.md-fab.md-mini { line-height: 4rem; width: 4rem; height: 4rem; }</hljs><p><br></p><h2 \nid=\"icon-button-using-svgs\">Icon button using SVGs</h2><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/1292882/7273908/d701bd8a-e900-11e4-84c7-44c580c7372d.PNG\" \nalt=\"iconbutton\"></p><p>Create icon buttons by adding the <code>.md-icon-button</code> class and the <code>\n&lt;md-icon ...&gt;</code> component:</p><hljs lang=\"html\"><md-button class=\"md-icon-button md-primary\" \naria-label=\"Settings\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/menu.svg\"></md-icon></md-button>\n</hljs><hljs lang=\"css\">\n.md-button.md-icon-button { margin: 0 0.6rem; height: 4.8rem; min-width: 0; line-height: 4.8rem; padding-left: 0; padding-right: 0; width: 4.8rem; }\n</hljs><p><br></p><h2 id=\"icon-button-using-font-icons\">Icon button using Font-icons</h2><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/1292882/7670414/f57721ba-fcab-11e4-9a22-67970063797c.PNG\" \nalt=\"fonticonbutton\"></p><p>Here is another example of a button with font icons:</p><hljs lang=\"html\"><md-button>\n<md-icon md-font-icon=\"icon-home\" ng-style=\"{color: \'green\', \'font-size\':\'36px\', height:\'36px\'}\"></md-icon></md-button>\n</hljs><p><br></p><h2 id=\"grouping-with-css-overrides\">Grouping with CSS Overrides</h2><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/210413/7961138/1b48bb16-09cb-11e5-9283-bdda28b8bb66.png\" \nalt=\"mdbuttongroup\"></p><p>Using the customization approaches documented above, we can easily create a mdButtonGroup:\n</p><hljs lang=\"html\"><section layout=\"row\" layout-align=\"center center\"><md-button class=\"groupX left\">Apple\n</md-button><md-button class=\"groupX middle\">Samsung</md-button><md-button class=\"groupX middle\">Sony</md-button>\n<md-button class=\"groupX right\">B&amp;O</md-button></section></hljs><hljs lang=\"css\">\n.groupX { font-size: 16px; margin: 20px 0; padding: 3px 15px 3px 15px; color: rgb(49, 46, 46); background-color: rgba(224, 224, 224, 0.96); text-transform: none; font-weight: 400; min-width:100px; } .md-button.left { border-radius: 10px 0 0 10px; } .md-button.middle { border-radius: 0; border-left: 1px solid rgba(230, 230, 230, 0.96); border-right: 1px solid rgba(230, 230, 230, 0.96); } .md-button.right { border-radius: 0 10px 10px 0; } .md-button:not([disabled]):hover { background-color: rgba(193, 193, 193, 0.96); color: rgba(44, 65, 164, 0.96); transition: 0.3s; }\n</hljs></div>");
$templateCache.put("app/main/components/material-docs/partials/CSS/checkbox.html","<div class=\"doc-content theming\"><h2>CSS Styles</h2><p>The css decalaration of the <code>&lt;md-checkbox&gt;</code>\n component is:</p><hljs lang=\"css\">\nmd-checkbox { margin: 8px; cursor: pointer; padding-left: 18px; padding-right: 0; line-height: 26px; min-width: 18px; min-height: 18px; }\n</hljs><p><br></p><h3>Ink color</h3><p>In order to change the color when the checkbox is checked:</p><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/1292882/8035909/b2130da0-0dfc-11e5-932f-4424d3b46d5b.PNG\" \nalt=\"greencheckbox\"></p><hljs lang=\"html\"><md-checkbox class=\"green\">Green Checkbox</md-checkbox></hljs><hljs \nlang=\"css\">md-checkbox.md-checked.green .md-icon { background-color: rgba(0, 255, 0, 0.87); }</hljs><p><br></p><h3>\nDisabled</h3><p>In order to change the color when a disabled checkbox is checked:</p><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/1292882/8036177/dc941a86-0dfe-11e5-8892-ac19ec6926fe.PNG\" \nalt=\"checkboxdisabledred\"><br></p><hljs lang=\"html\"><md-checkbox ng-disabled=\"true\" class=\"red\" ng-model=\"data.cb4\" \nng-init=\"data.cb4=true\">Checkbox: Disabled, Checked</md-checkbox></hljs><hljs lang=\"css\">\nmd-checkbox.md-checked[disabled].red .md-icon { background-color: rgba(255, 0, 0, 0.26); }</hljs><p><br></p><h3>Borders\n</h3><p>In order to add a custom border do the following:</p><img \nsrc=\"https://cloud.githubusercontent.com/assets/1292882/8037214/388dd40c-0e05-11e5-82a7-4bfa2541e968.PNG\" \nalt=\"checkboxcustomborder\"><br><br><hljs lang=\"html\"><div><md-checkbox ng-model=\"data.cb2\" aria-label=\"Checkbox 2\" \nng-true-value=\"\'yup\'\" ng-false-value=\"\'nope\'\">Default Border</md-checkbox></div><div><md-checkbox ng-model=\"data.cb2\" \naria-label=\"Checkbox 2\" ng-true-value=\"\'yup\'\" class=\"dotted\" ng-false-value=\"\'nope\'\">Custom Border</md-checkbox></div>\n</hljs><hljs lang=\"css\">md-checkbox.dotted .md-icon { border-width: 1px; border-style: dashed; }</hljs><br><h3>Bi-Di\n</h3><p>The mdCheckbox directive supports bi-directional specifiers in the <code>&lt;html dir=&quot;rtl&quot;&gt;\n</code> tag:</p><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/1292882/8036091/fb40bcf6-0dfd-11e5-8319-25e68939d1a3.PNG\" \nalt=\"checkboxrtl\"></p></div>");
$templateCache.put("app/main/components/material-docs/partials/CSS/typography.html","<div class=\"doc-content theming\"><p>\nAngularJS Material provides typography CSS classes you can use to create visual consistency across your application.\n</p><p style=\"text-align: center\"><a href=\"https://material.google.com/style/typography.html\">\nMaterial Design Typography Specification</a></p><section class=\"demo-container\"><md-toolbar class=\"demo-toolbar\"><div \nclass=\"md-toolbar-tools\"><h3>General Typography</h3></div></md-toolbar><div class=\"md-whiteframe-z1 docs-list\"><p>\nAngularJS Material uses the <a href=\"https://fonts.google.com/?selection.family=Roboto\">Roboto</a>\n font for all of its components.</p><p>The <code>Roboto</code> font will be <b>not</b>\n automatically loaded by AngularJS Material itself. The developer is responsible for loading all fonts used in their application. Shown below is a sample \n<i>link</i> markup used to load the <code>Roboto</code> font from a CDN.</p><hljs lang=\"html\"><link rel=\"stylesheet\" \nhref=\"https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,400italic\"></hljs><h4 class=\"md-title\">Notes</h4>\n<p>When <code>Roboto</code> isn&#39;t loaded, then the typography will fallback to the following fonts:</p><ul><li>- \n<code>Helvetica Neue</code></li><li>- <code>sans-serif</code></li></ul></div></section><section class=\"demo-container\">\n<md-toolbar class=\"demo-toolbar\"><div class=\"md-toolbar-tools\"><h3>Heading Styles</h3></div></md-toolbar><div \nclass=\"md-whiteframe-z1 docs-list\"><p style=\"margin-top: 0\">To preserve <a \nhref=\"http://webaim.org/techniques/semanticstructure/\">semantic structures</a>, you should style the <code>&lt;h1&gt;\n</code> - <code>&lt;h6&gt;</code> heading tags with the styling classes shown below:</p><div layout=\"row\" \nclass=\"docs-descriptions\"><h4 class=\"md-body-1\" flex=\"25\" id=\"headings-selectors\">Selectors</h4><h4 class=\"md-body-1\" \nid=\"headings-output\">Output</h4></div><md-divider></md-divider><ul><li layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" \naria-describedby=\"headings-selectors\"><code>.md-display-4</code></span><h5 flex aria-describedby=\"headings-output\" \nclass=\"md-display-4 docs-output\">Light 112px</h5></li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" \nclass=\"docs-definition\" aria-describedby=\"headings-selectors\"><code>.md-display-3</code></span><h5 \naria-describedby=\"headings-output\" class=\"md-display-3 docs-output\">Regular 56px</h5></li><li layout=\"row\" \nlayout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"headings-selectors\"><code>\n.md-display-2</code></span><h5 aria-describedby=\"headings-output\" class=\"md-display-2 docs-output\">Regular 45px</h5>\n</li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" \naria-describedby=\"headings-selectors\"><code>.md-display-1</code></span><h5 aria-describedby=\"headings-output\" \nclass=\"md-display-1 docs-output\">Regular 34px</h5></li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" \nclass=\"docs-definition\" aria-describedby=\"headings-selectors\"><code>.md-headline</code></span><h5 \naria-describedby=\"headings-output\" class=\"md-headline docs-output\">Regular 24px</h5></li><li layout=\"row\" \nlayout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"headings-selectors\"><code>\n.md-title</code></span><h5 aria-describedby=\"headings-output\" class=\"md-title docs-output\">Medium 20px</h5></li><li \nlayout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"headings-selectors\">\n<code>.md-subhead</code></span><h5 aria-describedby=\"headings-output\" class=\"md-subhead docs-output\">Regular 16px</h5>\n</li></ul><h4 class=\"md-title\">Example</h4><hljs lang=\"html\"><h1 class=\"md-display-3\">Headline</h1><h2 \nclass=\"md-display-1\">Headline</h2><h3 class=\"md-headline\">Headline</h3></hljs><br><span class=\"md-body-1\">\nNote: Base font size is <code>10px</code> for easy rem units (1.2rem = 12px). Body font size is <code>14px</code>\n. sp = scalable pixels.</span></div></section><section class=\"demo-container\"><md-toolbar class=\"demo-toolbar\"><div \nclass=\"md-toolbar-tools\"><h3>Body Copy</h3></div></md-toolbar><div class=\"md-whiteframe-z1 docs-list\"><div \nlayout=\"row\" class=\"docs-descriptions\"><h4 class=\"md-body-1\" flex=\"25\" id=\"body-selectors\">Selectors</h4><h4 \nclass=\"md-body-1\" id=\"body-output\">Output</h4></div><md-divider></md-divider><ul><li layout=\"row\" \nlayout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"body-selectors\"><code>.md-body-1\n</code><br></span><p class=\"docs-output md-body-1\" aria-describedby=\"body-output\">Regular 14px</p></li><li \nlayout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"body-selectors\">\n<code>.md-body-2</code></span><p class=\"md-body-2 docs-output\" aria-describedby=\"body-output\">Medium 14px</p></li><li \nlayout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"body-selectors\">\n<code>.md-button</code></span><div class=\"docs-output\" aria-describedby=\"body-output\"><md-button class=\"md-raised\" \nstyle=\"margin-left:0; margin-right:0\">Medium 14px</md-button></div></li><li layout=\"row\" layout-align=\"start center\">\n<span flex=\"25\" class=\"docs-definition\" aria-describedby=\"body-selectors\"><code>.md-caption</code><br></span><div \nclass=\"docs-output\" aria-describedby=\"body-output\"><small class=\"md-caption\">Regular 12px</small></div></li></ul><h4 \nclass=\"md-title\">Examples</h4><hljs lang=\"html\"><p class=\"md-body-2\">Body copy with medium weight.</p><md-button>Button\n</md-button><p class=\"md-body-1\">Regular body copy <small class=\"md-caption\">with small text</small>.</p><span \nclass=\"md-caption\">Caption</span></hljs></div></section></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-1.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Lastname</span> field to reveal the conditional step!\n</p><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"firstname\" ng-model=\"vm.horizontalStepper.step1.firstname\" placeholder=\"Firstname\" required><div \nng-messages=\"horizontalStep1.firstname.$error\" ng-show=\"horizontalStep1.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.horizontalStepper.step1.lastname\" \nplaceholder=\"Lastname\"><div ng-messages=\"horizontalStep1.lastname.$error\" ng-show=\"horizontalStep1.lastname.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.</span></div></div></md-input-container></div>\n</div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-2.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Birthplace</span>\n field to reveal another conditional step! Conditional step-ception!</p><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"birthplace\" \nng-model=\"vm.horizontalStepper.step2.birthplace\" placeholder=\"Birthplace\"></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-3.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"ssn\" ng-model=\"vm.horizontalStepper.step3.ssn\" \nplaceholder=\"Social Security Number\"></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-4.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\"><label>Address\n</label><textarea ng-model=\"vm.horizontalStepper.step4.address\" md-maxlength=\"150\" max-rows=\"5\"></textarea><div \nng-messages=\"horizontalStep4.address.$error\" ng-show=\"horizontalStep4.address.$touched\" role=\"alert\"></div>\n</md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-5.html","<div class=\"md-inline-form\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"cardholder\" \nng-model=\"vm.horizontalStepper.step5.cardholder\" placeholder=\"Card Holder\" required><div \nng-messages=\"horizontalStep5.cardholder.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard holder field is required.</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"cardnumber\" \nng-model=\"vm.horizontalStepper.step5.cardnumber\" placeholder=\"Card Number\" required><div \nng-messages=\"horizontalStep5.cardnumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard number field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\">\n<input type=\"text\" name=\"CC2\" ng-model=\"vm.horizontalStepper.step5.cc2\" placeholder=\"CC2\" md-maxlength=\"3\" required>\n<div ng-messages=\"horizontalStep5.cc2.$error\" role=\"alert\" multipl><div ng-message=\"required\"><span>\nCC2 field is required.</span></div><div ng-message=\"md-maxlength\"><span>CC2 can\'t be longer than 3 characters.</span>\n</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" \nname=\"expirationDate\" ng-model=\"vm.horizontalStepper.step5.expirationDate\" placeholder=\"Expiration Date\" required><div \nng-messages=\"horizontalStep5.expirationDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nExpiration date field is required.</span></div></div></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-1.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Lastname</span> field to reveal the conditional step!\n</p><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"firstname\" ng-model=\"vm.verticalStepper.step1.firstname\" placeholder=\"Firstname\" required><div \nng-messages=\"verticalStep1.firstname.$error\" ng-show=\"verticalStep1.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.verticalStepper.step1.lastname\" \nplaceholder=\"Lastname\"><div ng-messages=\"verticalStep1.lastname.$error\" ng-show=\"verticalStep1.lastname.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.</span></div></div></md-input-container></div>\n</div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-2.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Birthplace</span>\n field to reveal another conditional step! Conditional step-ception!</p><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"birthplace\" \nng-model=\"vm.verticalStepper.step2.birthplace\" placeholder=\"Birthplace\"></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-3.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"ssn\" ng-model=\"vm.verticalStepper.step3.ssn\" \nplaceholder=\"Social Security Number\"></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-4.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\"><label>Address\n</label><textarea ng-model=\"vm.verticalStepper.step4.address\" md-maxlength=\"150\" max-rows=\"5\"></textarea><div \nng-messages=\"verticalStep4.address.$error\" ng-show=\"verticalStep4.address.$touched\" role=\"alert\"></div>\n</md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-5.html","<div class=\"md-inline-form\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"cardholder\" \nng-model=\"vm.verticalStepper.step5.cardholder\" placeholder=\"Card Holder\" required><div \nng-messages=\"step5.cardholder.$error\" role=\"alert\"><div ng-message=\"required\"><span>Card holder field is required.\n</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" \nflex-gt-xs=\"33\"><input type=\"text\" name=\"cardnumber\" ng-model=\"vm.verticalStepper.step5.cardnumber\" \nplaceholder=\"Card Number\" required><div ng-messages=\"verticalStep5.cardnumber.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Card number field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"CC2\" ng-model=\"vm.verticalStepper.step5.cc2\" placeholder=\"CC2\" \nmd-maxlength=\"3\" required><div ng-messages=\"verticalStep5.cc2.$error\" role=\"alert\" multipl><div ng-message=\"required\">\n<span>CC2 field is required.</span></div><div ng-message=\"md-maxlength\"><span>CC2 can\'t be longer than 3 characters.\n</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" \nname=\"expirationDate\" ng-model=\"vm.verticalStepper.step5.expirationDate\" placeholder=\"Expiration Date\" required><div \nng-messages=\"verticalStep5.expirationDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nExpiration date field is required.</span></div></div></md-input-container></div></div>");
$templateCache.put("app/main/ui/theme-colors/dialogs/custom-theme/custom-theme-dialog.html","<md-dialog class=\"custom-theme-dialog\" aria-label=\"Custom Theme\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nCustom Theme Generator</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nlayout=\"row\" ng-repeat=\"type in [\'primary\', \'accent\', \'warn\', \'background\']\"><h3 class=\"type\">{{type}}</h3>\n<md-input-container><label>Palette</label><md-select ng-model=\"vm.theme[type].name\" \nng-style=\"{\'background-color\': vm.rgba(vm.palettes[vm.theme[type].name][\'500\'].value), \'color\': vm.rgba(vm.palettes[vm.theme[type].name][\'500\'].contrast, 1)}\">\n<md-option ng-value=\"palette\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\">{{palette}}\n</md-option></md-select></md-input-container><div layout=\"row\" \nng-repeat=\"hueType in [\'default\', \'hue-1\', \'hue-2\', \'hue-3\']\"><md-input-container><label>{{hueType}}</label><md-select \nng-model=\"vm.theme[type].hues[hueType]\" \nng-style=\"{\'background-color\': vm.rgba(vm.palettes[vm.theme[type].name][vm.theme[type].hues[hueType]].value), \'color\': vm.rgba(vm.palettes[vm.theme[type].name][vm.theme[type].hues[hueType]].contrast, 1)}\">\n<md-option ng-value=\"hue\" ng-repeat=\"(hue, opt) in vm.palettes[vm.theme[type].name]\" \nng-style=\"{\'background-color\': vm.rgba(opt.value), \'color\': vm.rgba(opt.contrast, 1)}\">{{hue}}</md-option></md-select>\n</md-input-container></div></div><md-divider></md-divider><div layout=\"row\"><p>\nTo make this theme permanent, copy the below code and add it into the \"fuseThemes\" object in \"core/theming/fuse-themes.constant.js\" file. You can also replace the \"CUSTOM_THEME_NAME\" with your theme name.\n</p></div><div layout=\"row\"><textarea readonly=\"readonly\" class=\"theme-object\">\"CUSTOM_THEME_NAME\" : {{vm.theme}}\n</textarea></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.setTheme()\">Set Theme</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/ui/theme-colors/tabs/accent/accent.html","<div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-accent-bg\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.accent.color}}</div><div flex>\n.md-accent-bg</div></div><div class=\"md-accent-bg\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div>\n<div flex>{{vm.themes.active.theme.accent.contrast1}}</div><div flex>.md-accent-bg</div></div><div \nclass=\"md-accent-bg\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>\nSecondary Text / Icon</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.accent.contrast2}}</div><div \nclass=\"secondary-text\" flex>.md-accent-bg .secondary-text</div></div><div class=\"md-accent-bg\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.accent.contrast3}}</div><div class=\"hint-text\" flex>\n.md-accent-bg .hint-text</div></div><div class=\"md-accent-bg\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding>\n<div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.accent.contrast4}}</div><div class=\"fade-text\" flex>.md-accent-bg .divider</div></div><div \nflex=\"100\" class=\"md-accent-fg\" layout=\"row\" layout-padding><div flex>As foreground color</div><div flex>\n{{vm.themes.active.theme.accent.color}}</div><div flex>.md-accent-fg</div></div></div><div class=\"color\" layout=\"row\" \nlayout-wrap layout-align=\"center center\"><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div\n flex>Hue 1</div><div flex>{{vm.themes.active.theme.accent.hue1.color}}</div><div flex>.md-accent-bg .md-hue-1</div>\n</div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.accent.hue1.contrast1}}</div><div flex>.md-accent-bg</div></div><div \nclass=\"md-accent-bg md-hue-1\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.accent.hue1.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-accent-bg .md-hue-1 .secondary-text</div></div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.accent.hue1.contrast3}}</div><div class=\"hint-text\" flex>.md-accent-bg .md-hue-1 .hint-text\n</div></div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.accent.hue1.contrast4}}</div><div class=\"fade-text\" flex>.md-accent-bg .md-hue-1 .divider\n</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-1\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.accent.hue1.color}}</div><div flex>.md-accent-fg</div></div></div><div \nclass=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-accent-bg md-hue-2\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Hue 2</div><div flex>{{vm.themes.active.theme.accent.hue2.color}}</div><div flex>\n.md-accent-bg .md-hue-2</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>\nPrimary Text</div><div flex>{{vm.themes.active.theme.accent.hue2.contrast1}}</div><div flex>.md-accent-bg</div></div>\n<div class=\"md-accent-bg md-hue-2\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.accent.hue2.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-accent-bg .md-hue-2 .secondary-text</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.accent.hue2.contrast3}}</div><div class=\"hint-text\" flex>.md-accent-bg .md-hue-2 .hint-text\n</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.accent.hue2.contrast4}}</div><div class=\"fade-text\" flex>.md-accent-bg .md-hue-2 .divider\n</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-2\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.accent.hue2.color}}</div><div flex>.md-accent-fg</div></div></div><div \nclass=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-accent-bg md-hue-3\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Hue 3</div><div flex>{{vm.themes.active.theme.accent.hue3.color}}</div><div flex>\n.md-accent-bg .md-hue-3</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>\nPrimary Text</div><div flex>{{vm.themes.active.theme.accent.hue3.contrast1}}</div><div flex>.md-accent-bg</div></div>\n<div class=\"md-accent-bg md-hue-3\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.accent.hue3.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-accent-bg .md-hue-3 .secondary-text</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.accent.hue3.contrast3}}</div><div class=\"hint-text\" flex>.md-accent-bg .md-hue-3 .hint-text\n</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.accent.hue3.contrast4}}</div><div class=\"fade-text\" flex>.md-accent-bg .md-hue-3 .divider\n</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-3\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.accent.hue3.color}}</div><div flex>.md-accent-fg</div></div></div>");
$templateCache.put("app/main/ui/theme-colors/tabs/primary/primary.html","<div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-primary-bg\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.primary.color}}</div><div flex>\n.md-primary-bg</div></div><div class=\"md-primary-bg\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text\n</div><div flex>{{vm.themes.active.theme.primary.contrast1}}</div><div flex>.md-primary-bg</div></div><div \nclass=\"md-primary-bg\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>\nSecondary Text / Icon</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.primary.contrast2}}</div><div \nclass=\"secondary-text\" flex>.md-primary-bg .secondary-text</div></div><div class=\"md-primary-bg\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.primary.contrast3}}</div><div class=\"hint-text\" flex>\n.md-primary-bg .hint-text</div></div><div class=\"md-primary-bg\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding>\n<div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.primary.contrast4}}</div><div class=\"fade-text\" flex>.md-primary-bg .divider</div></div><div \nflex=\"100\" class=\"md-primary-fg\" layout=\"row\" layout-padding><div flex>As foreground color</div><div flex>\n{{vm.themes.active.theme.primary.color}}</div><div flex>.md-primary-fg</div></div></div><div class=\"color\" \nlayout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" \nlayout-padding><div flex>Hue 1</div><div flex>{{vm.themes.active.theme.primary.hue1.color}}</div><div flex>\n.md-primary-bg .md-hue-1</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div \nflex>Primary Text</div><div flex>{{vm.themes.active.theme.primary.hue1.contrast1}}</div><div flex>.md-primary-bg</div>\n</div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.primary.hue1.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-primary-bg .md-hue-1 .secondary-text</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.primary.hue1.contrast3}}</div><div class=\"hint-text\" flex>.md-primary-bg .md-hue-1 .hint-text\n</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.primary.hue1.contrast4}}</div><div class=\"fade-text\" flex>.md-primary-bg .md-hue-1 .divider\n</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-1\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.primary.hue1.color}}</div><div flex>.md-primary-fg</div></div></div><div \nclass=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-primary-bg md-hue-2\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Hue 2</div><div flex>{{vm.themes.active.theme.primary.hue2.color}}</div><div \nflex>.md-primary-bg .md-hue-2</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding>\n<div flex>Primary Text</div><div flex>{{vm.themes.active.theme.primary.hue2.contrast1}}</div><div flex>.md-primary-bg\n</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.primary.hue2.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-primary-bg .md-hue-2 .secondary-text</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.primary.hue2.contrast3}}</div><div class=\"hint-text\" flex>.md-primary-bg .md-hue-2 .hint-text\n</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.primary.hue2.contrast4}}</div><div class=\"fade-text\" flex>.md-primary-bg .md-hue-2 .divider\n</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-2\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.primary.hue2.color}}</div><div flex>.md-primary-fg</div></div></div><div \nclass=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-primary-bg md-hue-3\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Hue 3</div><div flex>{{vm.themes.active.theme.primary.hue3.color}}</div><div \nflex>.md-primary-bg .md-hue-3</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding>\n<div flex>Primary Text</div><div flex>{{vm.themes.active.theme.primary.hue3.contrast1}}</div><div flex>.md-primary-bg\n</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.primary.hue3.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-primary-bg .md-hue-3 .secondary-text</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.primary.hue3.contrast3}}</div><div class=\"hint-text\" flex>.md-primary-bg .md-hue-3 .hint-text\n</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.primary.hue3.contrast4}}</div><div class=\"fade-text\" flex>.md-primary-bg .md-hue-3 .divider\n</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-3\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.primary.hue3.color}}</div><div flex>.md-primary-fg</div></div></div>");
$templateCache.put("app/main/ui/theme-colors/tabs/background/background.html","<div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-background-bg\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.background.color}}</div><div \nflex>.md-background-bg</div></div><div class=\"md-background-bg\" flex=\"100\" layout=\"row\" layout-padding><div flex>\nPrimary Text</div><div flex>{{vm.themes.active.theme.background.contrast1}}</div><div flex>.md-background-bg</div>\n</div><div class=\"md-background-bg\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.background.contrast2}}</div><div class=\"secondary-text\" flex>.md-background-bg .secondary-text\n</div></div><div class=\"md-background-bg\" flex=\"100\" class=\"hint-text\" layout=\"row\" layout-padding><div \nclass=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.background.contrast3}}</div><div class=\"hint-text\" flex>.md-background-bg .hint-text</div>\n</div><div class=\"md-background-bg\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" flex>\nFade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.background.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-background-bg .divider</div></div><div flex=\"100\" class=\"md-primary-bg md-background-fg\" \nlayout=\"row\" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.background.color}}\n</div><div flex>.md-background-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap \nlayout-align=\"center center\"><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div flex>\nHue 1</div><div flex>{{vm.themes.active.theme.background.hue1.color}}</div><div flex>.md-background-bg .md-hue-1</div>\n</div><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div \nflex>{{vm.themes.active.theme.background.hue1.contrast1}}</div><div flex>.md-background-bg</div></div><div \nclass=\"md-background-bg md-hue-1\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.background.hue1.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-background-bg .md-hue-1 .secondary-text</div></div><div class=\"md-background-bg md-hue-1\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.background.hue1.contrast3}}</div><div class=\"hint-text\" flex>\n.md-background-bg .md-hue-1 .hint-text</div></div><div class=\"md-background-bg md-hue-1\" flex=\"100\" class=\"divider\" \nlayout=\"row\" layout-padding><div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.background.hue1.contrast4}}</div><div class=\"fade-text\" flex>\n.md-background-bg .md-hue-1 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding><div \nflex class=\"md-background-fg md-hue-1\">As foreground color</div><div flex class=\"md-background-fg md-hue-1\">\n{{vm.themes.active.theme.background.hue1.color}}</div><div flex class=\"md-background-fg md-hue-1\">.md-background-fg\n</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div \nclass=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>Hue 2</div><div flex>\n{{vm.themes.active.theme.background.hue2.color}}</div><div flex>.md-background-bg .md-hue-2</div></div><div \nclass=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.background.hue2.contrast1}}</div><div flex>.md-background-bg</div></div><div \nclass=\"md-background-bg md-hue-2\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.background.hue2.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-background-bg .md-hue-2 .secondary-text</div></div><div class=\"md-background-bg md-hue-2\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.background.hue2.contrast3}}</div><div class=\"hint-text\" flex>\n.md-background-bg .md-hue-2 .hint-text</div></div><div class=\"md-background-bg md-hue-2\" flex=\"100\" class=\"divider\" \nlayout=\"row\" layout-padding><div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.background.hue2.contrast4}}</div><div class=\"fade-text\" flex>\n.md-background-bg .md-hue-2 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding><div \nflex class=\"md-background-fg md-hue-2\">As foreground color</div><div flex class=\"md-background-fg md-hue-2\">\n{{vm.themes.active.theme.background.hue2.color}}</div><div flex class=\"md-background-fg md-hue-2\">.md-background-fg\n</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div \nclass=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>Hue 3</div><div flex>\n{{vm.themes.active.theme.background.hue3.color}}</div><div flex>.md-background-bg .md-hue-3</div></div><div \nclass=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.background.hue3.contrast1}}</div><div flex>.md-background-bg</div></div><div \nclass=\"md-background-bg md-hue-3\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.background.hue3.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-background-bg .md-hue-3 .secondary-text</div></div><div class=\"md-background-bg md-hue-3\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.background.hue3.contrast3}}</div><div class=\"hint-text\" flex>\n.md-background-bg .md-hue-3 .hint-text</div></div><div class=\"md-background-bg md-hue-3\" flex=\"100\" class=\"divider\" \nlayout=\"row\" layout-padding><div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.background.hue3.contrast4}}</div><div class=\"fade-text\" flex>\n.md-background-bg .md-hue-3 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding><div \nflex class=\"md-background-fg md-hue-3\">As foreground color</div><div flex class=\"md-background-fg md-hue-3\">\n{{vm.themes.active.theme.background.hue3.color}}</div><div flex class=\"md-background-fg md-hue-3\">.md-background-fg\n</div></div></div>");
$templateCache.put("app/main/ui/theme-colors/tabs/warn/warn.html","<div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-warn-bg\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.warn.color}}</div><div flex>\n.md-warn-bg</div></div><div class=\"md-warn-bg\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div \nflex>{{vm.themes.active.theme.warn.contrast1}}</div><div flex>.md-warn-bg</div></div><div class=\"md-warn-bg\" \nflex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>Secondary Text / Icon\n</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.warn.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-warn-bg .secondary-text</div></div><div class=\"md-warn-bg\" flex=\"100\" class=\"hint-text\" layout=\"row\" \nlayout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.warn.contrast3}}</div><div class=\"hint-text\" flex>.md-warn-bg .hint-text</div></div><div \nclass=\"md-warn-bg\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" flex>\nFade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.warn.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-warn-bg .divider</div></div><div flex=\"100\" class=\"md-warn-fg\" layout=\"row\" layout-padding>\n<div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.color}}</div><div flex>.md-warn-fg</div>\n</div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-warn-bg md-hue-1\" \nflex=\"100\" layout=\"row\" layout-padding><div flex>Hue 1</div><div flex>{{vm.themes.active.theme.warn.hue1.color}}</div>\n<div flex>.md-warn-bg .md-hue-1</div></div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div\n flex>Primary Text</div><div flex>{{vm.themes.active.theme.warn.hue1.contrast1}}</div><div flex>.md-warn-bg</div></div>\n<div class=\"md-warn-bg md-hue-1\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.warn.hue1.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-warn-bg .md-hue-1 .secondary-text</div></div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.warn.hue1.contrast3}}</div><div class=\"hint-text\" flex>.md-warn-bg .md-hue-1 .hint-text</div>\n</div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" \nflex>Fade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.warn.hue1.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-warn-bg .md-hue-1 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-1\" \nlayout=\"row\" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.hue1.color}}\n</div><div flex>.md-warn-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\">\n<div class=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>Hue 2</div><div flex>\n{{vm.themes.active.theme.warn.hue2.color}}</div><div flex>.md-warn-bg .md-hue-2</div></div><div \nclass=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.warn.hue2.contrast1}}</div><div flex>.md-warn-bg</div></div><div class=\"md-warn-bg md-hue-2\" \nflex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>Secondary Text / Icon\n</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.warn.hue2.contrast2}}</div><div class=\"secondary-text\" \nflex>.md-warn-bg .md-hue-2 .secondary-text</div></div><div class=\"md-warn-bg md-hue-2\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.warn.hue2.contrast3}}</div><div class=\"hint-text\" flex>.md-warn-bg .md-hue-2 .hint-text</div>\n</div><div class=\"md-warn-bg md-hue-2\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" \nflex>Fade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.warn.hue2.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-warn-bg .md-hue-2 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-2\" \nlayout=\"row\" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.hue2.color}}\n</div><div flex>.md-warn-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\">\n<div class=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>Hue 3</div><div flex>\n{{vm.themes.active.theme.warn.hue3.color}}</div><div flex>.md-warn-bg .md-hue-3</div></div><div \nclass=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.warn.hue3.contrast1}}</div><div flex>.md-warn-bg</div></div><div class=\"md-warn-bg md-hue-3\" \nflex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>Secondary Text / Icon\n</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.warn.hue3.contrast2}}</div><div class=\"secondary-text\" \nflex>.md-warn-bg .md-hue-3 .secondary-text</div></div><div class=\"md-warn-bg md-hue-3\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.warn.hue3.contrast3}}</div><div class=\"hint-text\" flex>.md-warn-bg .md-hue-3 .hint-text</div>\n</div><div class=\"md-warn-bg md-hue-3\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" \nflex>Fade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.warn.hue3.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-warn-bg .md-hue-3 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-3\" \nlayout=\"row\" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.hue3.color}}\n</div><div flex>.md-warn-fg</div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/Theming/01_introduction.html","<div class=\"doc-content theming\"><p>\nMaterial Design is a visual language with specifications for innovative user experiences (UX) and user interface (UI) elements. Themes convey meaning through color, tones, and contrasts, similar to how Layouts convey meaning through keylines and alignments.\n</p><p>Theme <a href=\"http://www.google.com/design/spec/style/color.html#color-ui-color-palette\"><strong>color palettes\n</strong></a>\n, alphas, and shadows deliver a consistent tone to your application and a unified feel for all AngularJS Material UI components.\n</p><p>\nTheming allows changing the color of your AngularJS Material application. If you need more custom styling (such as layout changes including padding, margins, etc) you will need to either write CSS rules with custom selectors, or build a custom version of the \n<code>angular-material.css</code> file using SASS and custom variables.</p><blockquote><p><b>Note:</b>\n The Material Theming system provides the <a ng-href=\"/api/service/$mdThemingProvider#setNonce\"><code>\n$mdThemingProvider.setNonce()</code></a> method to meet the requirements of a CSP-policy enabled application.</p>\n</blockquote><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/210413/4816236/bf7783dc-5edd-11e4-88ef-1f8b6e87e1d7.png\" \nalt=\"color palette\" style=\"max-width: 100%\"></p><h2 id=\"theming-approach\">Theming Approach</h2><p>\nAngularJS Material makes it easy to design an app which follows the Material style guide&#39;s suggested design patterns:\n</p><blockquote><p>\nLimit your selection of colors by choosing three color hues from the primary palette and one accent color from the secondary palette. The accent color may or may not need fallback options.\n</p></blockquote><p>This concept is central to how AngularJS Material approaches theming.</p><h2 id=\"important-terms\">\nImportant Terms</h2><h3 id=\"hues-shades\">Hues / Shades</h3><p>A hue/shade is a single color within a palette.</p><h3 \nid=\"palettes\">Palettes</h3><p>\nA palette is a collection of hues. By default, AngularJS Material ships with all palettes from the material design spec built in. Valid palettes include:\n</p><ul><li>red</li><li>pink</li><li>purple</li><li>deep-purple</li><li>indigo</li><li>blue</li><li>light-blue</li><li>\ncyan</li><li>teal</li><li>green</li><li>light-green</li><li>lime</li><li>yellow</li><li>amber</li><li>orange</li><li>\ndeep-orange</li><li>brown</li><li>grey</li><li>blue-grey</li></ul><h3 id=\"color-intentions\">Color Intentions</h3><p>\nA color intention is a mapping of a palette for a given intention within your application.</p><p>\nValid color intentions in AngularJS Material include:</p><ul><li><em>primary</em>\n - used to represent primary interface elements for a user</li><li><em>accent</em>\n - used to represent secondary interface elements for a user</li><li><em>warn</em>\n - used to represent interface elements that the user should be careful of</li></ul><h3 id=\"themes\">Themes</h3><p>\nA theme is a configuration of palettes used for specific color intentions. A theme also specifies a background color palette to be used for the application.\n</p></div>");
$templateCache.put("app/main/components/material-docs/partials/Theming/02_declarative_syntax.html","<div class=\"doc-content theming\"><p>\nTheming in AngularJS Material uses classes to apply an intention group to a given component. Most components in AngularJS Material support intention classes as expected, including:\n</p><ul><li>md-button</li><li>md-checkbox</li><li>md-progress-circular</li><li>md-progress-linear</li><li>\nmd-radio-button</li><li>md-slider</li><li>md-switch</li><li>md-tabs</li><li>md-input-container</li><li>md-toolbar</li>\n</ul><h3 id=\"specifying-intention-group\">Specifying intention group</h3><p>\nThe classes to apply the color intention for a given component are as follows: <code>md-primary</code>, <code>md-accent\n</code>, <code>md-warn</code>.</p><hljs lang=\"html\"><md-button class=\"md-primary\">Click me</md-button><md-button \nclass=\"md-accent\">or maybe me</md-button><md-button class=\"md-warn\">Careful</md-button></hljs><h3 \nid=\"differentiating-within-an-intention-group-\">Differentiating within an intention group.</h3><p>\nIf you need to slightly differentiate an element, you can specify an additional class of <code>md-hue-1</code>, <code>\nmd-hue-2</code>, or <code>md-hue-3</code>. Use these classes sparingly in your application to avoid overwhelming users.\n</p><hljs lang=\"html\"><md-button class=\"md-primary\">Click me</md-button><md-button class=\"md-primary md-hue-1\">Click me\n</md-button><md-button class=\"md-primary md-hue-2\">Click me</md-button></hljs></div>");
$templateCache.put("app/main/components/material-docs/partials/Theming/03_configuring_a_theme.html","<div class=\"doc-content theming\"><h2 id=\"configuring-a-theme\">Configuring a theme</h2><p>\nBy default your AngularJS Material application will use the default theme, a theme that is pre-configured with the following palettes for intention groups:\n</p><ul><li><em>primary</em> - indigo</li><li><em>accent</em> - pink</li><li><em>warn</em> - red</li><li><em>background\n</em> - grey (note that white is in this palette)</li></ul><p>Configuring of the default theme is done by using the \n<code>$mdThemingProvider</code> during application configuration.</p><h3 id=\"configuring-color-intentions\">\nConfiguring Color Intentions</h3><p>\nYou can specify a color palette for a given color intention by calling the appropriate configuration method (<code>\ntheme.primaryPalette</code>, <code>theme.accentPalette</code>, <code>theme.warnPalette</code>, <code>\ntheme.backgroundPalette</code>).</p><hljs lang=\"js\">\nangular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.theme(&#39;default&#39;) .primaryPalette(&#39;pink&#39;) .accentPalette(&#39;orange&#39;); });\n</hljs><h3 id=\"specifying-dark-themes\">Specifying Dark Themes</h3><p>You can mark a theme as dark by calling <code>\ntheme.dark()</code>.</p><hljs lang=\"js\">\nangular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.theme(&#39;default&#39;) .dark(); });\n</hljs><h3 id=\"specifying-custom-hues-for-color-intentions\">Specifying Custom Hues For Color Intentions</h3><p>\nYou can specify the hues from a palette that will be used by an intention group by default and for the <code>md-hue-1\n</code>, <code>md-hue-2</code>, <code>md-hue-3</code> classes.</p><p>By default, shades <code>500</code>, <code>300\n</code> <code>800</code> and <code>A100</code> are used for <code>primary</code> and <code>warn</code>\n intentions, while <code>A200</code>, <code>A100</code>, <code>A400</code> and <code>A700</code> are used for <code>\naccent</code>.</p><hljs lang=\"js\">\nangular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.theme(&#39;default&#39;) .primaryPalette(&#39;pink&#39;, { &#39;default&#39;: &#39;400&#39;, // by default use shade 400 from the pink palette for primary intentions &#39;hue-1&#39;: &#39;100&#39;, // use shade 100 for the \n<code>md-hue-1</code> class &#39;hue-2&#39;: &#39;600&#39;, // use shade 600 for the <code>md-hue-2</code>\n class &#39;hue-3&#39;: &#39;A100&#39; // use shade A100 for the <code>md-hue-3</code>\n class }) // If you specify less than all of the keys, it will inherit from the // default shades .accentPalette(&#39;purple&#39;, { &#39;default&#39;: &#39;200&#39; // use shade 200 for default, and keep all other shades the same }); });\n</hljs><h3 id=\"defining-custom-palettes\">Defining Custom Palettes</h3><p>\nAs mentioned before, AngularJS Material ships with the Material Design Spec&#39;s color palettes built in. In the event that you need to define a custom color palette, you can use \n<code>$mdThemingProvider</code>\n to define it, thereby making it available to your theme for use in its intention groups. Note that you must specify all hues in the definition map.\n</p><hljs lang=\"js\">\nangular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.definePalette(&#39;amazingPaletteName&#39;, { &#39;50&#39;: &#39;ffebee&#39;, &#39;100&#39;: &#39;ffcdd2&#39;, &#39;200&#39;: &#39;ef9a9a&#39;, &#39;300&#39;: &#39;e57373&#39;, &#39;400&#39;: &#39;ef5350&#39;, &#39;500&#39;: &#39;f44336&#39;, &#39;600&#39;: &#39;e53935&#39;, &#39;700&#39;: &#39;d32f2f&#39;, &#39;800&#39;: &#39;c62828&#39;, &#39;900&#39;: &#39;b71c1c&#39;, &#39;A100&#39;: &#39;ff8a80&#39;, &#39;A200&#39;: &#39;ff5252&#39;, &#39;A400&#39;: &#39;ff1744&#39;, &#39;A700&#39;: &#39;d50000&#39;, &#39;contrastDefaultColor&#39;: &#39;light&#39;, // whether, by default, text (contrast) // on this palette should be dark or light &#39;contrastDarkColors&#39;: [&#39;50&#39;, &#39;100&#39;, //hues which contrast should be &#39;dark&#39; by default &#39;200&#39;, &#39;300&#39;, &#39;400&#39;, &#39;A100&#39;], &#39;contrastLightColors&#39;: undefined // could also specify this if default was &#39;dark&#39; }); $mdThemingProvider.theme(&#39;default&#39;) .primaryPalette(&#39;amazingPaletteName&#39;) });\n</hljs><h3 id=\"extending-existing-palettes\">Extending Existing Palettes</h3><p>\nSometimes it is easier to extend an existing color palette to change a few properties than to define a whole new palette. You can use \n<code>$mdThemingProvider.extendPalette</code> to quickly extend an existing color palette.</p><hljs lang=\"js\">\nangular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { // Extend the red theme with a different color and make the contrast color black instead of white. // For example: raised button text will be black instead of white. var neonRedMap = $mdThemingProvider.extendPalette(&#39;red&#39;, { &#39;500&#39;: &#39;#ff0000&#39;, &#39;contrastDefaultColor&#39;: &#39;dark&#39; }); // Register the new color palette map with the name \n<code>neonRed</code>\n $mdThemingProvider.definePalette(&#39;neonRed&#39;, neonRedMap); // Use that theme for the primary intentions $mdThemingProvider.theme(&#39;default&#39;) .primaryPalette(&#39;neonRed&#39;); });\n</hljs><h3 id=\"disable-theming\">Disable Theming</h3><p>You can disable theming by calling <code>disableTheming()</code>\n.</p><hljs lang=\"js\">\nangular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.disableTheming(); });\n</hljs></div>");
$templateCache.put("app/main/components/material-docs/partials/Theming/04_multiple_themes.html","<div class=\"doc-content theming\"><p>In most applications, declaring multiple themes is <strong>not</strong>\n necessary. Instead, you should configure the <code>default</code>\n theme for your needs. If you need multiple themes in a single application, AngularJS Material does provide tools to make this possible.\n</p><h3 id=\"registering-another-theme\">Registering another theme</h3><p>Use the <code>$mdThemingProvider</code>\n to register a second theme within your application. By default all themes will inherit from the <code>default</code>\n theme. Once you have registered the second theme, you can configure it with the same chainable interface used on the default theme.\n</p><hljs lang=\"js\">\nangular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.theme(&#39;altTheme&#39;) .primaryPalette(&#39;purple&#39;) // specify primary color, all // other color intentions will be inherited // from default });\n</hljs><h3 id=\"using-another-theme\">Using another theme</h3><h4 id=\"via-the-provider\">Via the Provider</h4><p>\nYou can change the default theme to be used across your entire application using the provider:</p><hljs lang=\"js\">\n$mdThemingProvider.setDefaultTheme(&#39;altTheme&#39;);</hljs><h4 id=\"via-a-directive\">Via a Directive</h4><p>\nAngularJS Material also exposes the <code>md-theme</code>\n directive which will set the theme on an element and all child elements.</p><p>\nIn the following example, the application will use the <code>default</code> theme, while the second child <code>div\n</code> will use the <code>altTheme</code>. This allows you to theme different parts of your application differently.\n</p><hljs lang=\"html\"><div><md-button class=\"md-primary\">I will be blue (by default)</md-button><div \nmd-theme=\"altTheme\"><md-button class=\"md-primary\">I will be purple (altTheme)</md-button></div></div></hljs><h4 \nid=\"dynamic-themes\">Dynamic Themes</h4><p>By default, to save on performance, theming directives will <strong>not\n</strong> watch <code>md-theme</code>\n for changes. If you need themes to be dynamically modified, you will need to use the <code>md-theme-watch</code>\n directive.</p><hljs lang=\"html\"><div><md-button ng-click=\"dynamicTheme = \'default\'\">Default</md-button><md-button \nng-click=\"dynamicTheme = \'altTheme\'\">altTheme</md-button><div md-theme=\"{{ dynamicTheme }}\" md-theme-watch><md-button \nclass=\"md-primary\">I&#39;m dynamic</md-button></div></div></hljs><p>\nIf you need this behavior in your entire application (ie. on all <code>md-theme</code> directives) you can use the \n<code>$mdThemingProvider</code> to enable it.</p><hljs lang=\"js\">$mdThemingProvider.alwaysWatchTheme(true);</hljs><h4 \nid=\"lazy-generate-themes\">Lazy Generate Themes</h4><p>\nBy default, every theme is generated when defined. You can disable this in the configuration section using the <code>\n$mdThemingProvider</code>.</p><hljs lang=\"js\">\nangular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { //disable theme generation $mdThemingProvider.generateThemesOnDemand(true); //themes are still defined in config, but the css is not generated $mdThemingProvider.theme(&#39;altTheme&#39;) .primaryPalette(&#39;purple&#39;) .accentPalette(&#39;green&#39;); });\n</hljs><p>If you do this, you must generate the theme before using it using <code>$mdTheming</code>.</p><hljs \nlang=\"js\">//generate the predefined theme named altTheme $mdTheming.generateTheme(&#39;altTheme&#39;);</hljs><p>\nThe theme name that is passed in must match the name of the theme that was defined as part of the configuration block.\n</p></div>");
$templateCache.put("app/main/components/material-docs/partials/Theming/05_under_the_hood.html","<div class=\"doc-content theming\"><h3 id=\"under-the-hood\">Under the Hood</h3><p>\nAngularJS Material dynamically generates CSS for registered themes by injecting several <code>&lt;script&gt;</code>\n tags into the <code>&lt;head&gt;</code>\n section of the application at runtime. Here is how that process currently works:</p><ol><li><p>\nDuring the AngularJS Material build process, a function in <code>gulp/util.js</code> called <a \nhref=\"https://github.com/angular/material/blob/master/gulp/util.js#L223\">themeBuildStream()</a> compiles all <code>\n*-theme.scss</code> files from components into a single CSS string that is injected into the <code>material.core</code>\n module as a constant called <code>$MD_THEME_CSS</code>.</p></li><li><p>At runtime, a function in <code>\nsrc/core/services/theming/theming.js</code> called <a \nhref=\"https://github.com/angular/material/blob/master/src/core/services/theming/theming.js#L917\">generateAllThemes()\n</a> parses <code>$MD_THEME_CSS</code> to generate the <code>&lt;style&gt;</code> tags that are added to the <code>\n&lt;head&gt;</code> section of the application. A closure variable called <code>GENERATED</code>\n is used to keep track of the themes that have had their CSS generated.</p></li><li><p>\nFor each of the four (4) palettes (e.g. <code>primary</code>, <code>accent</code>, <code>warn</code> and <code>\nbackground</code>) <em>in each registered theme</em> (including the default theme), there are four (4) <code>\n&lt;style&gt;</code> tags added to the <code>&lt;head&gt;</code> section (e.g. <code>.md-primary</code>, <code>\n.md-primary.md-hue-1</code>, <code>.md-primary.md-hue-2</code>, <code>.md-primary.md-hue-3</code>\n). Each registered theme results in 16 <code>&lt;style&gt;</code> tags being generated.</p></li></ol></div>");
$templateCache.put("app/main/components/material-docs/partials/Theming/06_browser_color.html","<div class=\"doc-content theming\"><div class=\"layout_note\"><span>This feature is <strong>mobile</strong> only</span>\n</div><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/6004537/18006666/50519c7e-6ba9-11e6-905b-c3751c20549c.png\" \nalt=\"browser color\"></p><p>Enables browser header coloring with <a href=\"https://material.google.com/style/color.html\">\nMaterial Design Colors</a> and the theming system.</p><p>For more information, please visit:<br><a \nhref=\"https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color\">\nhttps://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color</a>.</p><p>\nBelow are usage examples for both the AngularJS configuration phase, and during runtime.</p><h3 id=\"config-phase\">\nConfig Phase</h3><hljs lang=\"js\">\nmyAppModule .config(function($mdThemingProvider) { // Enable browser color $mdThemingProvider.enableBrowserColor({ theme: &#39;myTheme&#39;, // Default is &#39;default&#39; palette: &#39;accent&#39;, // Default is &#39;primary&#39;, any basic material palette and extended palettes are available hue: &#39;200&#39; // Default is &#39;800&#39; }); });\n</hljs><h3 id=\"runtime\">Runtime</h3><hljs lang=\"js\">\nmyAppModule .controller(&#39;myCtrl&#39;, function($scope, $mdTheming) { var removeFunction = $mdTheming.setBrowserColor({ theme: &#39;myTheme&#39;, // Default is &#39;default&#39; palette: &#39;accent&#39;, // Default is &#39;primary&#39;, any basic material palette and extended palettes are available hue: &#39;200&#39; // Default is &#39;800&#39; }); $scope.$on(&#39;$destroy&#39;, function () { removeFunction(); // COMPLETELY removes the browser color }) })\n</hljs><p>For api reference please visit <a ng-href=\"/api/service/$mdThemingProvider#enableBrowserColor\">\n$mdThemingProvider</a> documentation.</p></div>");
$templateCache.put("app/main/ui/page-layouts/carded/fullwidth/fullwidth.html","<div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\"><span class=\"h2 white-fg\">Fullwidth with independent scroll</span></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span>\nContent toolbar</span></div><md-content class=\"content\" flex ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/fullwidth-ii/fullwidth-ii.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\"><span class=\"h2 white-fg\">Fullwidth with page scroll</span></div><div \nclass=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span>Content toolbar</span></div>\n<md-content class=\"content\" ms-scroll><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div>\n</md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/left-sidenav/left-sidenav.html","<div class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav \nclass=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nclass=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" flex ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">\nLeft sidenav with independent scroll</span></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button><p>Content toolbar</p></div><md-content class=\"content\" flex ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/left-sidenav-ii/left-sidenav-ii.html","<div class=\"page-layout carded left-sidenav single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div class=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav><div class=\"center\" \nflex><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">Left sidenav with page scroll</span></div></div>\n<div class=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><p>\nContent toolbar</p></div><md-content class=\"content\" ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/right-sidenav/right-sidenav.html","<div class=\"page-layout carded right-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">\nRight sidenav with independent scroll</span></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><p>Content toolbar</p><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle right pane\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content class=\"content\" flex ms-scroll>\n<div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div><md-sidenav \nclass=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div class=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" ms-scroll flex><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/carded/right-sidenav-ii/right-sidenav-ii.html","<div class=\"page-layout carded right-sidenav single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">Right sidenav with page scroll\n</span></div></div><div class=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><p>\nContent toolbar</p><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle right pane\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content \nclass=\"content\" ms-scroll><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div>\n</div><md-sidenav class=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" \nms-scroll ms-sidenav-helper><div class=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/simple/fullwidth/fullwidth.html","<div class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\"><span class=\"h2\">Fullwidth</span></div><div \nclass=\"content md-background-bg\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/simple/left-sidenav/left-sidenav.html","<div class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"row\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button><div><span class=\"h2\">Left sidenav with independent scroll</span></div></div><div \nclass=\"content md-background-bg\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div>\n</div>");
$templateCache.put("app/main/ui/page-layouts/simple/left-sidenav-ii/left-sidenav-ii.html","<div class=\"page-layout simple left-sidenav single-scroll\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"row\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button><div><span class=\"h2\">Left sidenav with page scroll</span></div></div><div \nclass=\"content md-background-bg\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div>\n</div>");
$templateCache.put("app/main/ui/page-layouts/simple/left-sidenav-iii/left-sidenav-iii.html","<div class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><span class=\"h2\">Inner Left Sidenav</span></div>\n<div class=\"content\" md-background-bg layout=\"row\" ms-scroll><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div class=\"header\"><p>\nSidenav header</p></div><md-content class=\"content\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav><div flex \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/simple/right-sidenav/right-sidenav.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div><span class=\"h2\">\nRight sidenav with independent scroll</span></div><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button></div><div class=\"content md-background-bg\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div><md-sidenav \nclass=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/simple/right-sidenav-ii/right-sidenav-ii.html","<div class=\"page-layout simple right-sidenav single-scroll\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div><span class=\"h2\">\nRight sidenav with page scroll</span></div><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button></div><div class=\"content md-background-bg\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div><md-sidenav \nclass=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/simple/right-sidenav-iii/right-sidenav-iii.html","<div class=\"page-layout simple right-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><span class=\"h2\">Inner Right Sidenav</span></div>\n<div class=\"content\" md-background-bg layout=\"row\" ms-scroll><div flex \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div><md-sidenav class=\"sidenav md-sidenav-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div class=\"header\"><p>\nSidenav header</p></div><md-content class=\"content\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav></div></div>");
$templateCache.put("app/main/ui/page-layouts/simple/tabbed/tabbed.html","<div class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\"><span class=\"h2\">Tabbed</span>\n</div><div class=\"content\"><md-tabs md-dynamic-height><md-tab label=\"Tab 1\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-tab><md-tab label=\"Tab 2\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-tab><md-tab label=\"Tab 3\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/invoice/views/compact/compact.html","<div id=\"invoice\" class=\"compact page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\"><div class=\"invoice-date\">{{vm.invoice.date}}</div><div \nlayout=\"row\" layout-align=\"space-between stretch\"><div class=\"client\"><div class=\"invoice-number\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"title\" translate=\"INVOICE.INVOICE\">INVOICE</span> <span class=\"number\">\n{{vm.invoice.number}}</span></div><div class=\"due-date\" layout=\"row\" layout-align=\"start center\"><span class=\"title\" \ntranslate=\"INVOICE.DUE_DATE\">DUE DATE</span> <span class=\"date\">{{vm.invoice.dueDate}}</span></div><div class=\"info\">\n<div class=\"title\">{{vm.invoice.client.title}}</div><div ng-if=\"vm.invoice.client.address\" class=\"address\">\n{{vm.invoice.client.address}}</div><div ng-if=\"vm.invoice.client.phone\" class=\"phone\">{{vm.invoice.client.phone}}</div>\n<div ng-if=\"vm.invoice.client.email\" class=\"email\">{{vm.invoice.client.email}}</div><div \nng-if=\"vm.invoice.client.website\" class=\"website\">{{vm.invoice.client.website}}</div></div></div><div \nclass=\"issuer md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><span>F</span></div><div class=\"info\"><div class=\"title\">{{vm.invoice.from.title}}</div>\n<div ng-if=\"vm.invoice.from.address\" class=\"address\">{{vm.invoice.from.address}}</div><div \nng-if=\"vm.invoice.from.phone\" class=\"phone\">{{vm.invoice.from.phone}}</div><div ng-if=\"vm.invoice.from.email\" \nclass=\"email\">{{vm.invoice.from.email}}</div><div ng-if=\"vm.invoice.from.website\" class=\"website\">\n{{vm.invoice.from.website}}</div></div></div></div></div><div class=\"content\"><table class=\"simple invoice-table\">\n<thead><th translate=\"INVOICE.SERVICE\">SERVICE</th><th translate=\"INVOICE.UNIT\">UNIT</th><th class=\"text-right\" \ntranslate=\"INVOICE.UNIT_PRICE\">UNIT PRICE</th><th class=\"text-right\" translate=\"INVOICE.QUANTITY\">QUANTITY</th><th \nclass=\"text-right\" translate=\"INVOICE.TOTAL\">TOTAL</th></thead><tbody><tr ng-repeat=\"service in vm.invoice.services\">\n<td><div class=\"title\">{{service.title}}</div></td><td>{{service.unit}}</td><td class=\"text-right\">\n{{service.unitPrice | currency}}</td><td class=\"text-right\">{{service.quantity}}</td><td class=\"text-right\">\n{{service.total | currency}}</td></tr><tr ng-repeat=\"service in vm.invoice.services\"><td><div class=\"title\">\n{{service.title}}</div></td><td>{{service.unit}}</td><td class=\"text-right\">{{service.unitPrice | currency}}</td><td \nclass=\"text-right\">{{service.quantity}}</td><td class=\"text-right\">{{service.total | currency}}</td></tr></tbody>\n</table><table class=\"simple invoice-table-footer\"><tbody><tr class=\"subtotal\"><td translate=\"INVOICE.SUBTOTAL\">\nSUBTOTAL</td><td>{{vm.invoice.subtotal | currency}}</td></tr><tr class=\"tax\"><td translate=\"INVOICE.TAX\">TAX</td><td>\n{{vm.invoice.tax | currency}}</td></tr><tr class=\"discount\"><td translate=\"INVOICE.DISCOUNT\">DISCOUNT</td><td>\n-{{vm.invoice.discount | currency}}</td></tr><tr class=\"total\"><td translate=\"INVOICE.TOTAL\">TOTAL</td><td>\n{{vm.invoice.total | currency}}</td></tr></tbody></table></div><div class=\"footer\"><div class=\"note\" \ntranslate=\"INVOICE.NOTE\">Please pay within 15 days. Thank you for your business.</div><div layout=\"row\" \nlayout-align=\"start start\"><div class=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><div>F</div></div>\n<div class=\"small-note\" translate=\"INVOICE.SMALL_NOTE\">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/pages/invoice/views/modern/modern.html","<div id=\"invoice\" class=\"modern page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div class=\"ids\" \nlayout=\"column\"><div layout=\"row\" class=\"seller\" layout-align=\"start center\"><div class=\"logo md-accent-bg\" \nlayout=\"row\" layout-align=\"center center\"><div>F</div></div><div class=\"divider\"></div><div class=\"detail\"><div \nclass=\"title\">{{vm.invoice.from.title}}</div><div ng-if=\"vm.invoice.from.address\" class=\"address\">\n{{vm.invoice.from.address}}</div><div ng-if=\"vm.invoice.from.phone\" class=\"phone\"><span translate=\"INVOICE.PHONE\">Phone\n</span>: {{vm.invoice.from.phone}}</div><div ng-if=\"vm.invoice.from.email\" class=\"email\"><span \ntranslate=\"INVOICE.EMAIL\">Email</span>: {{vm.invoice.from.email}}</div><div ng-if=\"vm.invoice.from.website\" \nclass=\"website\"><span translate=\"INVOICE.WEB\">Web</span>: {{vm.invoice.from.website}}</div></div></div><div \nlayout=\"row\" class=\"client\" layout-align=\"start center\"><div class=\"label\" layout=\"row\" layout-align=\"end center\"><div \ntranslate=\"INVOICE.CLIENT\">CLIENT</div></div><div class=\"divider\"></div><div class=\"detail\"><div class=\"title\">\n{{vm.invoice.client.title}}</div><div ng-if=\"vm.invoice.client.address\" class=\"address\">{{vm.invoice.client.address}}\n</div><div ng-if=\"vm.invoice.client.phone\" class=\"phone\"><span translate=\"INVOICE.PHONE\">Phone</span>\n: {{vm.invoice.client.phone}}</div><div ng-if=\"vm.invoice.client.email\" class=\"email\"><span translate=\"INVOICE.EMAIL\">\nEmail</span>: {{vm.invoice.client.email}}</div><div ng-if=\"vm.invoice.client.website\" class=\"website\"><span \ntranslate=\"INVOICE.WEB\">Web</span>: {{vm.invoice.client.website}}</div></div></div></div><table class=\"summary\"><tr \nclass=\"code\"><td class=\"label\" translate=\"INVOICE.INVOICE\">INVOICE</td><td class=\"value\">{{vm.invoice.number}}</td>\n</tr><tr><td class=\"label\" translate=\"INVOICE.INVOICE_DATE\">INVOICE DATE</td><td class=\"value\">{{vm.invoice.date}}</td>\n</tr><tr><td class=\"label\" translate=\"INVOICE.DUE_DATE\">DUE DATE</td><td class=\"value\">{{vm.invoice.dueDate}}</td></tr>\n<tr><td class=\"label\" translate=\"INVOICE.TOTAL_DUE\">TOTAL DUE</td><td class=\"value\">{{vm.invoice.total | currency}}\n</td></tr></table></div><div class=\"content\"><table class=\"simple invoice-table\"><thead><th \ntranslate=\"INVOICE.SERVICE\">SERVICE</th><th translate=\"INVOICE.UNIT\">UNIT</th><th class=\"text-right\" \ntranslate=\"INVOICE.UNIT_PRICE\">UNIT PRICE</th><th class=\"text-right\" translate=\"INVOICE.QUANTITY\">QUANTITY</th><th \nclass=\"text-right\" translate=\"INVOICE.TOTAL\">TOTAL</th></thead><tbody><tr ng-repeat=\"service in vm.invoice.services\">\n<td><div class=\"title\">{{service.title}}</div><div class=\"detail\">{{service.detail}}</div></td><td>{{service.unit}}\n</td><td class=\"text-right\">{{service.unitPrice | currency}}</td><td class=\"text-right\">{{service.quantity}}</td><td \nclass=\"text-right\">{{service.total | currency}}</td></tr></tbody></table><table class=\"simple invoice-table-footer\">\n<tbody><tr class=\"subtotal\"><td translate=\"INVOICE.SUBTOTAL\">SUBTOTAL</td><td>{{vm.invoice.subtotal | currency}}</td>\n</tr><tr class=\"tax\"><td translate=\"INVOICE.TAX\">TAX</td><td>{{vm.invoice.tax | currency}}</td></tr><tr \nclass=\"discount\"><td translate=\"INVOICE.DISCOUNT\">DISCOUNT</td><td>-{{vm.invoice.discount | currency}}</td></tr><tr \nclass=\"total\"><td translate=\"INVOICE.TOTAL\">TOTAL</td><td>{{vm.invoice.total | currency}}</td></tr></tbody></table>\n</div><div class=\"footer\"><div class=\"note\" translate=\"INVOICE.NOTE\">\nPlease pay within 15 days. Thank you for your business.</div><div layout=\"row\" layout-align=\"start start\"><div \nclass=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><div>F</div></div><div class=\"small-note\" \ntranslate=\"INVOICE.SMALL_NOTE\">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/pages/search/tabs/classic/classic.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><span class=\"result-count h3 secondary-text\"><span>54</span> <span \ntranslate=\"SEARCH.RESULTS\">Results</span></span><div class=\"pager\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> <span>:</span> </span><span class=\"page-info\">\n<span>1</span> <span>-</span> <span>10</span> <span translate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button \nclass=\"md-icon-button\" aria-label=\"previous page\" translate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" \ntranslate translate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon>\n</md-button></div></div><div class=\"results\"><div class=\"result-item\" ng-repeat=\"item in vm.classic\"><div \nclass=\"title\">{{item.title}}</div><div class=\"url\">{{item.url}}</div><div class=\"excerpt\">{{item.excerpt}}</div></div>\n</div><div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink ng-href=\"#\" \naria-label=\"Go to previous page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" \naria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to next page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/profile/tabs/about/about.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"65\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" \ntranslate=\"PROFILE.GENERAL_INFORMATION\">General Information</div></header><div class=\"content\"><div class=\"info-line\">\n<div class=\"title\" translate=\"PROFILE.GENDER\">Gender</div><div class=\"info\">{{vm.about.general.gender}}</div></div><div\n class=\"info-line\"><div class=\"title\" translate=\"PROFILE.BIRTHDAY\">Birthday</div><div class=\"info\">\n{{vm.about.general.birthday}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.LOCATIONS\">\nLocations</div><div class=\"info location\" ng-repeat=\"location in vm.about.general.locations\"><span>{{location}}</span>\n<md-icon md-font-icon=\"icon-map-marker\" class=\"s16\"></md-icon></div></div><div class=\"info-line\"><div class=\"title\" \ntranslate=\"PROFILE.ABOUT_ME\">About Me</div><div class=\"info\">{{vm.about.general.about}}</div></div></div></div><div \nclass=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" \ntranslate=\"PROFILE.WORK\">Work</div></header><div class=\"content\"><div class=\"info-line\"><div class=\"title\" \ntranslate=\"PROFILE.OCCUPATION\">Occupation</div><div class=\"info\">{{vm.about.work.occupation}}</div></div><div \nclass=\"info-line\"><div class=\"title\" translate=\"PROFILE.SKILLS\">Skills</div><div class=\"info\">{{vm.about.work.skills}}\n</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.JOBS\">Jobs</div><table class=\"info jobs\"><tr \nclass=\"job\" ng-repeat=\"job in vm.about.work.jobs\"><td class=\"company\">{{job.company}}</td><td class=\"date\">{{job.date}}\n</td></tr></table></div></div></div><div class=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\"><header\n class=\"md-accent-bg\"><div class=\"title\" translate=\"PROFILE.CONTACT\">Contact</div></header><div class=\"content\"><div \nclass=\"info-line\"><div class=\"title\" translate=\"PROFILE.ADDRESS\">Address</div><div class=\"info\">\n{{vm.about.contact.address}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.TEL\">Tel.</div>\n<div class=\"info\" ng-repeat=\"tel in vm.about.contact.tel\"><span>{{tel}}</span></div></div><div class=\"info-line\"><div \nclass=\"title\" translate=\"PROFILE.WEBSITE\">Website</div><div class=\"info\" \nng-repeat=\"website in vm.about.contact.websites\"><span>{{website}}</span></div></div><div class=\"info-line\"><div \nclass=\"title\" translate=\"PROFILE.EMAILS\">Emails</div><div class=\"info\" ng-repeat=\"email in vm.about.contact.emails\">\n<span>{{email}}</span></div></div></div></div></div><div class=\"about-sidebar\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"35\"><div class=\"profile-box friends md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.FRIENDS\">\nFriends</div><div class=\"more secondary-text\"><span translate=\"PROFILE.SEE\">See</span> <span>454</span> <span \ntranslate=\"PROFILE.MORE\">More</span></div></header><div class=\"content\" layout=\"row\" layout-wrap><div class=\"friend\" \nflex=\"20\" ng-repeat=\"friend in vm.about.friends\"><img ng-src=\"{{friend.avatar}}\"></div></div></div><div \nclass=\"profile-box groups md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.JOINED_GROUPS\">Joined Groups</div><div \nclass=\"more secondary-text\"><span translate=\"PROFILE.SEE\">See</span> <span>6</span> <span translate=\"PROFILE.MORE\">More\n</span></div></header><div class=\"content\"><div class=\"group\" ng-repeat=\"group in vm.about.groups\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{group.logo}}\" \nclass=\"logo\" alt=\"{{group.name}}\"><div><div class=\"name\">{{group.name}}</div><div class=\"category\">{{group.category}}\n</div><div class=\"members\">{{group.members}} people</div></div></div><md-button class=\"md-icon-button\" \naria-label=\"more\" translate translate-attr-aria-label=\"PROFILE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button></div></div></div></div></div>");
$templateCache.put("app/main/pages/search/tabs/emails/emails.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.EMAILS\">E-Mails</span> <span \nclass=\"secondary-text\"><span>87</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> \n<span>:</span> </span><span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span \ntranslate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" \ntranslate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</div><div class=\"results\"><div class=\"result-item {{mail.status}}\" ng-repeat=\"mail in vm.mails | filter: vm.search\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" ng-if=\"mail.from.avatar\" \nalt=\"{{mail.from.name}}\" ng-src=\"{{mail.from.avatar}}\"><div class=\"avatar\" ng-if=\"!mail.from.avatar\" \nms-random-class=\"vm.colors\">{{mail.from.name[0]}}</div><div class=\"info\" flex layout=\"column\"><div \nclass=\"name text-truncate\">{{mail.from.name}}</div><div class=\"subject secondary-text text-truncate\">{{mail.subject}}\n</div><div class=\"message secondary-text text-truncate\">{{mail.message | htmlToPlaintext}}</div></div><div \nlayout=\"column\" layout-align=\"center end\"><div class=\"time secondary-text\">{{mail.time}}</div></div></div></div></div>\n<div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink ng-href=\"#\" \naria-label=\"Go to previous page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" \naria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to next page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/search/tabs/users/users.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.USERS\">Users</span> <span \nclass=\"secondary-text\"><span>87</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> \n<span>:</span> </span><span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span \ntranslate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" \ntranslate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</div><table class=\"results simple clickable\" ms-responsive-table><thead><tr><th translate=\"SEARCH.NAME\">Name</th><th \ntranslate=\"SEARCH.POSITION\">Position</th><th translate=\"SEARCH.OFFICE\">Office</th><th class=\"text-right\" \ntranslate=\"SEARCH.AGE\">Age</th><th class=\"text-right\" translate=\"SEARCH.START_DATE\">Start Date</th><th \nclass=\"text-right\" translate=\"SEARCH.SALARY\">Salary</th><th class=\"text-left\" translate=\"SEARCH.EMAIL\">Email</th></tr>\n</thead><tbody><tr class=\"result-item user\" ng-repeat=\"user in vm.users\"><td class=\"name\">{{user.name}}</td><td \nclass=\"position\">{{user.position}}</td><td class=\"office\">{{user.office}}</td><td class=\"age text-right\">{{user.age}}\n</td><td class=\"start-date text-right\">{{user.startDate}}</td><td class=\"salary text-right\">{{user.salary | currency}}\n</td><td class=\"email text-left\">{{user.email}}</td></tr></tbody></table><div class=\"simple-pagination\"><md-button \nclass=\"pagination-item disabled\" md-no-ink ng-href=\"#\" aria-label=\"Go to previous page\" translate \ntranslate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button>\n<md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" aria-label=\"Go to page 1\"><span>1</span></md-button>\n<md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to next page\" translate \ntranslate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/search/tabs/contacts/contacts.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.CONTACTS\">Contacts</span> <span \nclass=\"secondary-text\"><span>13</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> \n<span>:</span> </span><span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span \ntranslate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" \ntranslate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</div><table class=\"results simple clickable\" ms-responsive-table><thead><tr><th></th><th translate=\"SEARCH.NAME\">Name\n</th><th translate=\"SEARCH.POSITION\">Position</th><th translate=\"SEARCH.PHONE\">Phone</th><th translate=\"SEARCH.EMAIL\">\nEmail</th></tr></thead><tbody><tr class=\"result-item\" ng-repeat=\"contact in vm.contacts\"><td \nclass=\"text-left avatar-cell\" ng-if=\"contact.avatar\"><img class=\"avatar\" alt=\"{{contact.name}}\" \nng-src=\"{{contact.avatar}}\"></td><td class=\"text-left avatar-cell\" ng-if=\"!contact.avatar\"><div class=\"avatar\" \nms-random-class=\"vm.colors\">{{contact.name[0]}}</div></td><td class=\"name\">{{contact.name}}</td><td class=\"position\">\n{{contact.position}}</td><td class=\"phone\">{{contact.phone}}</td><td class=\"email\">{{contact.email}}</td></tr></tbody>\n</table><div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink ng-href=\"#\" \naria-label=\"Go to previous page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" \naria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to next page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/profile/tabs/photos-videos/photos-videos.html","<div class=\"photos-videos\"><div class=\"period\" data-ng-repeat=\"period in vm.photosVideos\"><div class=\"period-title\">\n<span class=\"name\">{{period.name}}</span> <span class=\"info\">{{period.info}}</span></div><div class=\"period-media\" \nlayout=\"row\" layout-wrap><div class=\"media\" ng-repeat=\"media in period.media\"><img class=\"preview\" \nng-src=\"{{media.preview}}\" title=\"{{media.title}}\"><div class=\"title\">{{media.title}}</div></div></div></div></div>");
$templateCache.put("app/main/pages/profile/tabs/timeline/timeline.html","<div layout=\"row\" layout-wrap><div class=\"timeline\" layout=\"column\" flex=\"100\" flex-gt-sm=\"55\" flex-gt-md=\"65\" \nflex-order=\"2\" flex-order-gt-sm=\"1\"><div class=\"profile-box add-post md-whiteframe-1dp\"><div class=\"form\" flex>\n<textarea placeholder=\"Write something..\" translate translate-attr-placeholder=\"PROFILE.WRITE_SOMETHING\"></textarea>\n<footer layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" aria-label=\"insert photo\" translate translate-attr-aria-label=\"PROFILE.INSERT_PHOTO\"><md-icon \nmd-font-icon=\"icon-file-image-box\"></md-icon><md-tooltip><span translate=\"PROFILE.INSERT_PHOTO\">insert photo</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"add person\" translate \ntranslate-attr-aria-label=\"PROFILE.ADD_PERSON\"><md-icon md-font-icon=\"icon-person-plus\"></md-icon><md-tooltip><span \ntranslate=\"PROFILE.ADD_PERSON\">add person</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \naria-label=\"add location\" translate translate-attr-aria-label=\"PROFILE.LOCATION\"><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><md-tooltip><span translate=\"PROFILE.LOCATION\">add location</span>\n</md-tooltip></md-button></div><md-button ng-click=\"\" class=\"post-button md-accent md-raised\" aria-label=\"POST\" \ntranslate=\"PROFILE.POST\" translate-attr-aria-label=\"PROFILE.POST\">POST</md-button></footer></div></div><md-divider>\n</md-divider><div class=\"timeline-item md-whiteframe-1dp\" ng-repeat=\"post in vm.posts\"><header layout=\"row\" \nlayout-align=\"space-between start\"><div class=\"user\" layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" \nng-src=\"{{post.user.avatar}}\"><div layout=\"column\"><div class=\"title\"><span class=\"username md-accent-color\">\n{{post.user.name}}</span> <span ng-if=\"post.type == \'post\'\" translate=\"PROFILE.TYPE_POST\">posted on your timeline\n</span> <span ng-if=\"post.type == \'something\'\" translate=\"PROFILE.TYPE_SOMETHING\">shared something with you</span> \n<span ng-if=\"post.type == \'video\'\" translate=\"PROFILE.TYPE_VIDEO\">shared a video with you</span> <span \nng-if=\"post.type == \'article\'\" translate=\"PROFILE.TYPE_ARTICLE\">shared an article with you</span></div><div \nclass=\"time\">{{post.time}}</div></div></div><md-button class=\"md-icon-button\" aria-label=\"more\" translate \ntranslate-attr-aria-label=\"PROFILE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></header><div\n class=\"content\"><div ng-if=\"post.message\" class=\"message\">{{post.message}}</div><div ng-if=\"post.media\" class=\"media\">\n<img ng-if=\"post.media.type === \'image\'\" ng-src=\"{{post.media.preview}}\"><div ng-if=\"post.media.type === \'video\'\" \nng-bind-html=\"post.media.embed | toTrusted\"></div></div><div ng-if=\"post.article\" layout=\"column\" class=\"article\"><div \nclass=\"media\"><img ng-src=\"{{post.article.media.preview}}\"></div><div class=\"title\">{{post.article.title}}</div><div \nclass=\"subtitle\">{{post.article.subtitle}}</div><div class=\"excerpt\">{{post.article.excerpt}}</div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"like-button\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-heart-outline\" class=\"s16\"></md-icon><span translate=\"PROFILE.LIKE\">Like</span>&nbsp;<span>\n({{post.like}})</span></div></md-button><md-button class=\"share-button\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-share\" class=\"s16\"></md-icon><span translate=\"PROFILE.SHARE\">Share</span>&nbsp;<span>\n({{post.share}})</span></div></md-button></div></div><footer class=\"\" layout=\"column\" layout-align=\"start start\"><div \nng-if=\"post.comments\" class=\"comment-count\">{{post.comments.length}} comments<md-icon \nmd-font-icon=\"icon-keyboard_arrow_down\"></md-icon></div><div class=\"comment\" layout=\"row\" layout-fill \nng-repeat=\"comment in post.comments\"><img ng-src=\"{{comment.user.avatar}}\" class=\"avatar\"><div flex layout=\"column\">\n<div layout=\"row\" layout-align=\"start center\"><span class=\"username\">{{comment.user.name}}</span> <span class=\"time\">\n{{comment.time}}</span></div><div class=\"message\">{{comment.message}}</div><div class=\"actions\" layout=\"row\" \nlayout-align=\"space-between center\"><a href=\"#\" class=\"reply-button md-accent-color\" translate=\"PROFILE.REPLY\">Reply\n</a><md-icon flex md-font-icon=\"icon-flag\" class=\"report-button s16\"></md-icon></div></div></div><div class=\"reply\" \nlayout=\"row\" layout-fill><img src=\"assets/images/avatars/profile.jpg\" class=\"avatar\"><form flex><textarea \nplaceholder=\"Add a comment...\" translate translate-attr-placeholder=\"PROFILE.ADD_COMMENT\"></textarea><md-button \nng-click=\"\" class=\"post-comment-button md-accent md-raised\" aria-label=\"Post Comment\" translate=\"PROFILE.POST_COMMENT\" \ntranslate-aria-label=\"PROFILE.POST_COMMENT\">Post Comment</md-button></form></div></footer></div></div><div \nclass=\"timeline-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"45\" flex-gt-md=\"35\" flex-order=\"1\" \nflex-order-gt-sm=\"2\"><div class=\"profile-box latest-activity md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" \ntranslate=\"PROFILE.LATEST_ACTIVITY\">Latest Activity</div><div class=\"more secondary-text\" translate=\"PROFILE.SEE_ALL\">\nSee All</div></header><div class=\"content\" layout=\"row\" layout-wrap><div class=\"activities\"><div class=\"activity\" \nlayout=\"row\" layout-align=\"start start\" ng-repeat=\"activity in vm.activities\"><img ng-src=\"{{activity.user.avatar}}\" \nclass=\"avatar\" alt=\"{{activity.user.name}}\"><div layout=\"column\"><div><span class=\"username md-accent-color\">\n{{activity.user.name}}</span> <span class=\"message\">{{activity.message}}</span></div><span class=\"time secondary-text\">\n{{activity.time}}</span></div></div></div></div></div></div></div>");
$templateCache.put("app/main/menu/presupuestos/budgets/menuDialog/menu-dialog.html","<md-dialog class=\"menu-dialog\" aria-label=\"Menu presupuestos\"><form ng-cloak><md-toolbar><div class=\"md-toolbar-tools\">\n<h2>Selección tipo de presupuesto</h2><span flex></span><md-button class=\"md-icon-button-close\" \nng-click=\"vm.closeDialog()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" \nlayout-align=\"center\" flex=\"100\"><div layout=\"column\" flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\"><center><md-button \nclass=\"md-icon-button\" ng-click=\"vm.gotoFramingBudget(vm.presupuestoKey)\" aria-label=\"Enmarcacion\" translate \ntranslate-attr-aria-label=\"BG.FRAMING\" ng-disabled=\"vm.desactivaEnmarcacion\"><md-icon md-font-icon=\"icon-picture\" \nclass=\"s90 green-500-fg\" ng-show=\"!vm.desactivaEnmarcacion\"></md-icon><md-icon md-font-icon=\"icon-picture\" \nclass=\"s90 grey-900-fg\" ng-show=\"vm.desactivaEnmarcacion\"></md-icon></md-button><span translate=\"BG.FRAMING\">\nEnmarcación</span></center></div><div flex=\"10\" flex-gt-xs=\"10\" flex-gt-md=\"10\"></div><div layout=\"column\" flex=\"45\" \nflex-gt-xs=\"45\" flex-gt-md=\"45\"><center><md-button class=\"md-icon-button\" \nng-click=\"vm.gotoMirrorBudget(vm.presupuestoKey)\" aria-label=\"Enmarcación espejo\" translate \ntranslate-attr-aria-label=\"BG.MIRROR_FRAMING\" ng-disabled=\"vm.desactivaEspejo\"><md-icon \nmd-font-icon=\"icon-crop-square\" class=\"s110 green-500-fg\" ng-show=\"!vm.desactivaEspejo\"></md-icon><md-icon \nmd-font-icon=\"icon-crop-square\" class=\"s110 grey-900-fg\" ng-show=\"vm.desactivaEspejo\"></md-icon></md-button><span \ntranslate=\"BG.MIRROR_FRAMING\">Enmarcación espejo</span></center></div></div><div class=\"separador-vertical\"></div>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/menu/presupuestos/budgets/menuDialogEstado/menu-dialog-estado.html","<md-dialog class=\"md-dialog-estado\" aria-label=\"Número pedido\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nAsignación número PC y estado</h2><span flex></span><md-button class=\"md-icon-button-close\" \nng-click=\"vm.closeDialog()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"budgetForm\"><div \nlayout=\"row\" layout-align=\"center\" flex=\"100\"><md-input-container class=\"md-block\" flex=\"50\" flex-gt-xs=\"50\" \nflex-gt-md=\"50\"><label class=\"blue-900-fg\" translate=\"BG.BUDGET_STATUS\">Estado del presupuesto</label><md-select \nname=\"estado\" placeholder=\"\" ng-model=\"vm.presupuesto.estado\" required><md-option ng-value=\"estado\" \nng-repeat=\"estado in vm.estados\">{{estado}}</md-option></md-select><div ng-messages=\"budgetForm.estado.$error\" \nng-show=\"budgetForm.estado.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container></div><div \nclass=\"separador-vertical\"></div><div layout=\"row\" layout-align=\"center\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\" \nng-if=\"vm.presupuesto.estado == \'Aprobado\'\"><md-input-container class=\"md-block\" flex=\"50\" flex-gt-xs=\"50\" \nflex-gt-md=\"50\"><label class=\"blue-900-fg\" translate=\"BG.CUSTOMER_ORDER_NUMBER\">\nNúmero de pedido cliente (PC) (6 dígitos)</label><input type=\"text\" name=\"numeroPC\" size=\"6\" maxlength=\"6\" \nng-model=\"vm.presupuesto.numeroPC\" ng-minlength=\"6\" required><div ng-messages=\"budgetForm.numeroPC.$error\" \nng-show=\"budgetForm.numeroPC.$touched\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div><div ng-message=\"minlength\"><span \ntranslate=\"BG.ERRORS.MIN_LENGTH\">El campo debe tener 6 caracteres</span></div></div></md-input-container></div><div \nlayout=\"row\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><span><b>\nNOTA: Si el cliente tiene otros presupuestos Aprobados recuerda asignarle<br>\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; el Número de Pedido de Cliente (PC)</b></span>\n</div><div class=\"separador-vertical\"></div><div layout=\"row\" layout-align=\"center\" flex=\"100\"><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.save()\" ng-disabled=\"budgetForm.$invalid\"><md-icon \nmd-font-icon=\"icon-check-circle\" class=\"s30 icon-check-circle\"></md-icon><span translate=\"BG.SAVE\">GUARDAR</span>\n</md-button></div></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/menu/presupuestos/budgets/printOrderDialog/print-order-dialog.html","<md-dialog class=\"print-order-dialog\" aria-label=\"Report\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"BG.PRINT.TITLE\">PRESUPUESTO</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" tranlate translate-aria-label=\"BG.PRINT.CLOSE_WINDOW\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div id=\"divToPrint\"><div layout=\"row\" \nlayout-align=\"start start\"><table style=\"width:100%\"><tr><td width=\"50%\" align=\"left\"><img width=\"100\" height=\"83\" \nsrc=\"https://firebasestorage.googleapis.com/v0/b/buenatelier-app.appspot.com/o/Buenatelier%2Flogos%2Flogo-aki_125x100.png?alt=media&token=2780755d-fa24-4923-9090-c58e13ce177a\">\n</td><td width=\"50%\">&nbsp;</td></tr></table></div><br><table style=\"width:100%\"><tr><td width=\"50%\"><span \nstyle=\"font-family: arial;font-size: 11px;font-weight: bold;text-transform: uppercase\" \ntranslate=\"BG.PRINT.BUDGET_INFO\">DATOS DEL PRESUPUESTO</span></td><td width=\"50%\"><span \nstyle=\"font-family: arial;font-size: 11px;font-weight: bold;text-transform: uppercase\" translate=\"BG.PRINT.SHOP_INFO\">\nDATOS DE LA TIENDA</span></td></tr><tr><td><span style=\"font-family: arial;font-size: 11px\"><b>Nº Presupuesto:</b>\n {{vm.presupuestoData.codigo}}</span></td><td><span style=\"font-family: arial;font-size: 11px\"><b>Tienda: </b>\n{{vm.presupuestoData.usuario}}</span></td></tr><tr><td><span style=\"font-family: arial;font-size: 11px\"><b>\nNº Pedido Cliente (PC): </b>{{vm.presupuestoData.numeroPC}}</span></td><td><span \nstyle=\"font-family: arial;font-size: 11px\"><b>Teléfono tienda: </b>{{vm.presupuestoData.telefonoTienda}}</span></td>\n</tr><tr><td><span style=\"font-family: arial;font-size: 11px\"><b>Fecha: </b>\n{{vm.presupuestoData.fechaTimestamp | date:\'dd/MM/yyyy\'}}</span></td><td><span \nstyle=\"font-family: arial;font-size: 11px\"><b>Atendido por: </b>{{vm.presupuestoData.vendedor}}</span></td></tr><tr>\n<td>&nbsp;</td><td>&nbsp;</td></tr><tr><td><span \nstyle=\"font-family: arial;font-size: 11px;font-weight: bold;text-transform: uppercase\" \ntranslate=\"BG.PRINT.CUSTOMER_INFO\">DATOS DEL CLIENTE</span></td><td></td></tr><tr><td><span \nstyle=\"font-family: arial;font-size: 11px\"><b>Nombre cliente: </b>{{vm.presupuestoData.cliente}}</span></td><td><span \nstyle=\"font-family: arial;font-size: 11px\"><b>Observaciones: </b>{{vm.presupuestoData.observacionesCliente}}</span>\n</td></tr><tr><td>&nbsp;</td><td>&nbsp;</td></tr><tr><td><span \nstyle=\"font-family: arial;font-size: 11px;font-weight: bold;text-transform: uppercase\" \ntranslate=\"BG.PRINT.BUDGET_DETAIL\">DETALLE DEL PRESUPUESTO</span></td><td></td></tr><tr><td><span \nstyle=\"font-family: arial;font-size: 11px\"><b>Tipo de presupuesto: </b>{{vm.presupuestoData.tipo}}</span></td><td><span\n style=\"font-family: arial;font-size: 11px\"><b>Medidas: </b>\n{{vm.presupuestoDetalle.width}} x {{vm.presupuestoDetalle.height}} cm ({{vm.textoMedidaExteriorInterior}})</span></td>\n</tr><tr><td><span style=\"font-family: arial;font-size: 11px\"><b>El cliente deja obra: </b>{{vm.textoClienteDejaObra}}\n</span></td><td><span style=\"font-family: arial;font-size: 11px\" \nng-if=\"vm.presupuestoDetalle.clienteDejaObraValorString == \'true\'\"><b>Obra con desperfectos: </b>\n{{vm.textoObraConDesperfectos}}</span></td></tr><tr ng-if=\"vm.presupuestoDetalle.clienteDejaObraValorString == \'true\'\">\n<td><span style=\"font-family: arial;font-size: 11px\"><b>Observaciones de la obra: </b>\n{{vm.presupuestoDetalle.observacionesObra}}</span></td><td>&nbsp;</td></tr><tr><td>&nbsp;</td><td>&nbsp;</td></tr><tr \nng-if=\"vm.presupuestoDetalle.numeroPpt1 != null\"><td><span style=\"font-family: arial;font-size: 11px\"><b>\nEntrecalle Passe-partout 1: </b>{{vm.presupuestoDetalle.widthPpt1}} cm y {{vm.presupuestoDetalle.widthPpt1}} cm </span>\n</td><td><span style=\"font-family: arial;font-size: 11px\"><b>Passe-partout con ventanas: </b>{{vm.textoPptConVentanas}}\n</span></td></tr><tr ng-if=\"vm.presupuestoDetalle.multiventana == \'true\'\"><td><span \nstyle=\"font-family: arial;font-size: 11px\"><b>Especificaciones ventanas del passe-partout: </b>\n{{vm.presupuestoDetalle.EspecificacionesVentanas}}</span></td><td><span style=\"font-family: arial;font-size: 11px\"><b>\nNúmero de ventanas del passe-partout: </b>{{vm.presupuestoDetalle.numeroVentanas}}</span></td></tr><tr \nng-if=\"vm.presupuestoDetalle.multiventana == \'true\'\"><td>&nbsp;</td><td>&nbsp;</td></tr><tr \nng-if=\"vm.presupuestoDetalle.numeroPpt2 != null\"><td><span style=\"font-family: arial;font-size: 11px\"><b>\nEntrecalle Passe-partout 2: </b>{{vm.presupuestoDetalle.widthPpt2}} cm y {{vm.presupuestoDetalle.widthPpt2}} cm </span>\n</td><td>&nbsp;</td></tr></table><table style=\"width:100%;border-collapse:collapse;border:1px solid black\"><tr \nstyle=\"background-color:#CCCCCC\"><td style=\"width:10%;border:1px solid black;text-align:center\"><span \nstyle=\"font-family: arial;font-size: 11px;font-weight: bold\" translate=\"BG.PRINT.ARTICLE_REFERENCE\">Ref. Art.</span>\n</td><td style=\"width:65%;border:1px solid black;text-align:center\"><span \nstyle=\"font-family: arial;font-size: 11px;font-weight: bold\" translate=\"BG.PRINT.ARTICLE_DESCRIPTION\">\nDescripción Artículo</span></td><td style=\"width:15%;border:1px solid black;text-align:center\"><span \nstyle=\"font-family: arial;font-size: 11px;font-weight: bold\" translate=\"BG.PRINT.MULTIPLIER\">Multiplicador</span></td>\n<td style=\"width:10%;border:1px solid black;text-align:center\"><span \nstyle=\"font-family: arial;font-size: 11px;font-weight: bold\" translate=\"BG.PRINT.PVP\">PVP</span></td></tr><tr \nng-if=\"vm.presupuestoDetalle.numeroEspejo != null\"><td style=\"border:1px solid black;text-align:center\"><span \nstyle=\"font-family: arial;font-size: 11px\">{{ vm.presupuestoDetalle.refLeroyMerlinEspejo }}</span></td><td \nstyle=\"border:1px solid black;text-align:center\"><span style=\"font-family: arial;font-size: 11px\">\n{{ vm.presupuestoDetalle.descripcionEspejo }}</span></td><td style=\"border:1px solid black;text-align:center\"><span \nstyle=\"font-family: arial;font-size: 11px\">{{ vm.presupuestoDetalle.multiplicadorEspejo }}</span></td><td \nstyle=\"border:1px solid black;text-align:center\"><span style=\"font-family: arial;font-size: 11px\">\n{{ vm.presupuestoDetalle.subtotalEspejo }}</span></td></tr><tr ng-if=\"vm.presupuestoDetalle.numeroPpt1 != null\"><td \nstyle=\"border:1px solid black;text-align:center\"><span style=\"font-family: arial;font-size: 11px\">\n{{ vm.presupuestoDetalle.refLeroyMerlinPpt1 }}</span></td><td style=\"border:1px solid black;text-align:center\"><span \nstyle=\"font-family: arial;font-size: 11px\">{{ vm.presupuestoDetalle.descripcionPpt1 }}</span></td><td \nstyle=\"border:1px solid black;text-align:center\"><span style=\"font-family: arial;font-size: 11px\">\n{{ vm.presupuestoDetalle.multiplicadorPpt1 }}</span></td><td style=\"border:1px solid black;text-align:center\"><span \nstyle=\"font-family: arial;font-size: 11px\">{{ vm.presupuestoDetalle.subtotalPpt1 }}</span></td></tr><tr \nng-if=\"vm.presupuestoDetalle.numeroPpt2 != null\"><td style=\"border:1px solid black;text-align:center\"><span \nstyle=\"font-family: arial;font-size: 11px\">{{ vm.presupuestoDetalle.refLeroyMerlinPpt2 }}</span></td><td \nstyle=\"border:1px solid black;text-align:center\"><span style=\"font-family: arial;font-size: 11px\">\n{{ vm.presupuestoDetalle.descripcionPpt2 }}</span></td><td style=\"border:1px solid black;text-align:center\"><span \nstyle=\"font-family: arial;font-size: 11px\">{{ vm.presupuestoDetalle.multiplicadorPpt2 }}</span></td><td \nstyle=\"border:1px solid black;text-align:center\"><span style=\"font-family: arial;font-size: 11px\">\n{{ vm.presupuestoDetalle.subtotalPpt2 }}</span></td></tr><tr ng-if=\"vm.presupuestoDetalle.numeroMoldura1 != null\"><td \nstyle=\"border:1px solid black;text-align:center\"><span style=\"font-family: arial;font-size: 11px\">\n{{ vm.presupuestoDetalle.refLeroyMerlinMoldura1 }}</span></td><td style=\"border:1px solid black;text-align:center\">\n<span style=\"font-family: arial;font-size: 11px\">{{ vm.presupuestoDetalle.descripcion1 }}</span></td><td \nstyle=\"border:1px solid black;text-align:center\"><span style=\"font-family: arial;font-size: 11px\">\n{{ vm.presupuestoDetalle.multiplicadorMoldura1 }}</span></td><td style=\"border:1px solid black;text-align:center\"><span\n style=\"font-family: arial;font-size: 11px\">{{ vm.presupuestoDetalle.subtotalMoldura1 }}</span></td></tr><tr \nng-if=\"vm.presupuestoDetalle.numeroMoldura2 != null\"><td style=\"border:1px solid black;text-align:center\"><span \nstyle=\"font-family: arial;font-size: 11px\">{{ vm.presupuestoDetalle.refLeroyMerlinMoldura2 }}</span></td><td \nstyle=\"border:1px solid black;text-align:center\"><span style=\"font-family: arial;font-size: 11px\">\n{{ vm.presupuestoDetalle.descripcion2 }}</span></td><td style=\"border:1px solid black;text-align:center\"><span \nstyle=\"font-family: arial;font-size: 11px\">{{ vm.presupuestoDetalle.multiplicadorMoldura2 }}</span></td><td \nstyle=\"border:1px solid black;text-align:center\"><span style=\"font-family: arial;font-size: 11px\">\n{{ vm.presupuestoDetalle.subtotalMoldura2 }}</span></td></tr><tr ng-if=\"vm.presupuestoDetalle.numeroMoldura3 != null\">\n<td style=\"border:1px solid black;text-align:center\"><span style=\"font-family: arial;font-size: 11px\">\n{{ vm.presupuestoDetalle.refLeroyMerlinMoldura3 }}</span></td><td style=\"border:1px solid black;text-align:center\">\n<span style=\"font-family: arial;font-size: 11px\">{{ vm.presupuestoDetalle.descripcion3 }}</span></td><td \nstyle=\"border:1px solid black;text-align:center\"><span style=\"font-family: arial;font-size: 11px\">\n{{ vm.presupuestoDetalle.multiplicadorMoldura3 }}</span></td><td style=\"border:1px solid black;text-align:center\"><span\n style=\"font-family: arial;font-size: 11px\">{{ vm.presupuestoDetalle.subtotalMoldura3 }}</span></td></tr><tr \nng-if=\"vm.presupuestoDetalle.numeroCristal != null\"><td style=\"border:1px solid black;text-align:center\"><span \nstyle=\"font-family: arial;font-size: 11px\">{{ vm.presupuestoDetalle.refLeroyMerlinCristal }}</span></td><td \nstyle=\"border:1px solid black;text-align:center\"><span style=\"font-family: arial;font-size: 11px\">\n{{ vm.presupuestoDetalle.descripcionCristal }}</span></td><td style=\"border:1px solid black;text-align:center\"><span \nstyle=\"font-family: arial;font-size: 11px\">{{ vm.presupuestoDetalle.multiplicadorCristal }}</span></td><td \nstyle=\"border:1px solid black;text-align:center\"><span style=\"font-family: arial;font-size: 11px\">\n{{ vm.presupuestoDetalle.subtotalCristal }}</span></td></tr><tr ng-if=\"vm.presupuestoDetalle.numeroTrasera != null\"><td\n style=\"border:1px solid black;text-align:center\"><span style=\"font-family: arial;font-size: 11px\">\n{{ vm.presupuestoDetalle.refLeroyMerlinTrasera }}</span></td><td style=\"border:1px solid black;text-align:center\"><span\n style=\"font-family: arial;font-size: 11px\">{{ vm.presupuestoDetalle.descripcionTrasera }}</span></td><td \nstyle=\"border:1px solid black;text-align:center\"><span style=\"font-family: arial;font-size: 11px\">\n{{ vm.presupuestoDetalle.multiplicadorTrasera }}</span></td><td style=\"border:1px solid black;text-align:center\"><span \nstyle=\"font-family: arial;font-size: 11px\">{{ vm.presupuestoDetalle.subtotalTrasera }}</span></td></tr><tr><td \ncolspan=\"4\">&nbsp;</td></tr><tr><td colspan=\"2\"></td><td style=\"border:1px solid black;text-align:center\"><span \nstyle=\"font-family: arial;font-size: 11px;font-weight: bold\">Subtotal</span></td><td \nstyle=\"border:1px solid black;text-align:center\"><span style=\"font-family: arial;font-size: 11px;font-weight: bold\">\n{{ vm.presupuestoDetalle.subtotal }}</span></td></tr><tr><td colspan=\"2\"></td><td \nstyle=\"border:1px solid black;text-align:center\"><span style=\"font-family: arial;font-size: 11px;font-weight: bold\">\nx {{ vm.presupuestoDetalle.unidades }} unidades</span></td><td style=\"border:1px solid black;text-align:center\"><span \nstyle=\"font-family: arial;font-size: 11px;font-weight: bold\">{{ vm.presupuestoDetalle.total }}</span></td></tr><tr><td \ncolspan=\"2\"></td><td style=\"border:1px solid black;text-align:center\"><span \nstyle=\"font-family: arial;font-size: 11px;font-weight: bold\">IVA (21%)</span></td><td \nstyle=\"border:1px solid black;text-align:center\"><span style=\"font-family: arial;font-size: 11px;font-weight: bold\">\n{{ vm.presupuestoDetalle.iva }}</span></td></tr><tr><td colspan=\"2\"></td><td \nstyle=\"border:1px solid black;text-align:center;background-color:#CCCCCC\"><span \nstyle=\"font-family: arial;font-size: 11px;font-weight: bold\">TOTAL </span></td><td \nstyle=\"border:1px solid black;text-align:center;background-color:#CCCCCC\"><span \nstyle=\"font-family: arial;font-size: 11px;font-weight: bold\">{{ vm.presupuestoDetalle.totalConIva }}</span></td></tr>\n</table><br><div style=\"text-align:justify\"><span style=\"font-family: arial;font-size: 11px;font-weight: bold\">\nObservaciones:</span> <span style=\"font-family: arial;font-size: 11px\">{{ vm.presupuestoData.observacionesCliente }}\n</span></div><br><table style=\"width:100%;border-collapse:collapse;border:1px solid black\"><tr><td \nstyle=\"width:50%;border:1px solid black;text-align:left\"><span \nstyle=\"font-family: arial;font-size: 11px;font-weight: bold\">FIRMA AKI<br><br><br>Vendedor:</span></td><td \nstyle=\"width:50%;border:1px solid black;text-align:left\"><span \nstyle=\"font-family: arial;font-size: 11px;font-weight: bold\">FIRMA CLIENTE<br><br><br><br></span></td></tr></table><div\n style=\"text-align:justify\"><span style=\"font-family: arial;font-size: 9px;font-style:italic\"><br><b>\nVALIDEZ DEL PRESUPUESTO: 3 DÍAS</b><br>\nSe establecen las siguientes CONDICIONES PARTICULARES aplicables al servicio de enmarcado y que prevalecerán sobre las condiciones generales del contrato pedido-cliente en aquello que pudieran resultar incompatibles:\n<br><b>I. Sobre la entrega.</b>\nUsted podrá elegir entre recoger la mercancía en la tienda en la que ha solicitado el pedido o el envío a su domicilio. En caso de optar por el envío a su domicilio: - Si usted no se hallase en su domicilio en la fecha y hora accordada con AKI para la entrega, el operador de transporte concertará una nueva fecha de entrega con usted, que no será superior a 2 días laborables, y que podrá tener lugar, en su domicilio o en la tienda de AKI en la que ha solicitado el pedido. Si usted optase de nuevo por la entrega en su domicilio y este segundo intento de entrega también resultase fallido, el operador de transporte procederá entonces a depositar la mercancía en la tienda de AKI en la que ha solicitado el pedido, quedando allí a disposición.\n<br><b>II. Devoluciones.</b>\nDe acuerdo con la Política de Devoluciones de AKI, no se admitirán devoluciones del servicio de enmarcado por ser un servicio solicitado a medida por el cliente.\n<br><b>III. Límite de responsabilidad.</b>\nEn caso de que durante el servicio de enmarcado la mercancía sufriera algún daño o pérdida imputable a AKI o a algunas de las empresas intervinientes en el servicio, la cantidad a indemnizar, previa valoración oportuna, podrá ser de hasta 600 euros. Queda excluida cualquier responsabilidad por lucro cesante y por daños indirectos o consecuenciales de cualquier tipo.\n</span></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"center center\"><md-button ng-click=\"vm.print(\'divToPrint\')\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Print\" translate=\"BG.PRINT.GENERATE_DOCUMENT\" \ntranslate-attr-aria-label=\"BG.PRINT.GENERATE_DOCUMENT\">GENERAR DOCUMENTO</md-button></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/menu/productos/molduras/molding/molding.html","<div id=\"molding\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-moldings-button md-icon-button\" \naria-label=\"Go to Moldings\" ng-click=\"vm.gotoMoldings()\" translate translate-attr-aria-label=\"MD.GO_TO_MOLDINGS\">\n<md-icon md-font-icon=\"icon-arrow-left-bold-circle-outline\" class=\"s32\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\"><span \ntranslate=\"MD.MOLDING\">MOLDING</span> <span>{{vm.moldura.numeroMoldura}}</span></div><div \nclass=\"subtitle secondary-text\"><span translate=\"MD.MOLDING_DETAIL\">MOLDING details</span></div></div></div></div><div>\n<md-button class=\"md-raised md-background\" ng-click=\"vm.gotoMoldings()\"><md-icon md-font-icon=\"icon-cancel\" \nclass=\"s30 icon-cancel\"></md-icon><span translate=\"MD.CANCEL\">CANCELAR</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.save()\" ng-disabled=\"moldingForm.$invalid\"><md-icon \nmd-font-icon=\"icon-check-circle\" class=\"s30 icon-check-circle\"></md-icon><span translate=\"MD.SAVE_MOLDING\">\nGUARDAR MOLDURA</span></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h2 text-uppercase\" translate=\"MD.MOLDING_DETAIL_TITLE\">\nDatos de la moldura</span></div><md-content class=\"content grey-100-bg\" flex ms-scroll><form name=\"moldingForm\"><div \nlayout=\"column\" flex=\"100\"><div class=\"budget-detail-form-container md-background-bg md-whiteframe-1dp\" flex=\"45\" \nflex-gt-xs=\"45\" flex-gt-md=\"45\"><div layout=\"row\" flex><md-input-container class=\"md-block\" flex=\"25\" flex-gt-xs=\"25\" \nflex-gt-md=\"25\"><label class=\"blue-900-fg\" translate=\"MD.MOLDING_NUMBER\">Número de moldura</label><input type=\"number\" \nname=\"numeroMoldura\" ng-model=\"vm.moldura.numeroMoldura\" required><div ng-messages=\"moldingForm.numeroMoldura.$error\" \nng-show=\"moldingForm.numeroMoldura.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MD.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container><div flex=\"10\" \nflex-gt-xs=\"10\" flex-gt-md=\"10\"></div><md-input-container class=\"md-block\" flex=\"25\" flex-gt-xs=\"25\" flex-gt-md=\"25\">\n<label class=\"blue-900-fg\" translate=\"MD.PROVIDER_REF\">Referencia proveedor</label><input type=\"text\" \nname=\"refProveedor\" ng-model=\"vm.moldura.refProveedor\" required><div ng-messages=\"moldingForm.refProveedor.$error\" \nng-show=\"moldingForm.refProveedor.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MD.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container><div flex=\"10\" \nflex-gt-xs=\"10\" flex-gt-md=\"10\"></div><md-input-container class=\"md-block\" flex=\"25\" flex-gt-xs=\"25\" flex-gt-md=\"25\">\n<label class=\"blue-900-fg\" translate=\"MD.REF1\">Referencia 1</label><input type=\"text\" name=\"refLeroyMerlin\" \nng-model=\"vm.moldura.refLeroyMerlin\" required><div ng-messages=\"moldingForm.refLeroyMerlin.$error\" \nng-show=\"moldingForm.refLeroyMerlin.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MD.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container></div><md-input-container\n class=\"md-block\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><label class=\"blue-900-fg\" translate=\"MD.DESCRIPTION\">\nDescripción</label><input type=\"text\" name=\"descripcion\" ng-model=\"vm.moldura.descripcion\" required><div \nng-messages=\"moldingForm.descripcion.$error\" ng-show=\"moldingForm.descripcion.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MD.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container><div layout=\"row\" flex><md-input-container flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><md-checkbox \nng-model=\"vm.moldura.limitacion70cm\" aria-label=\"Activo\" ng-init=\"vm.moldura.limitacion70cm=true\"><span \ntranslate=\"MD.MOLDING_LIMIT_70CM\">Limitación &lt; 70cm</span></md-checkbox></md-input-container><div flex=\"5\" \nflex-gt-xs=\"5\" flex-gt-md=\"5\"></div><md-input-container class=\"md-block\" flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\">\n<label class=\"blue-900-fg\" translate=\"MD.WASTE\">Desperdicio</label><input type=\"number\" step=\"0.01\" name=\"desperdicio\" \nng-model=\"vm.moldura.desperdicio\" required><div ng-messages=\"moldingForm.desperdicio.$error\" \nng-show=\"moldingForm.desperdicio.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MD.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container><div flex=\"5\" \nflex-gt-xs=\"5\" flex-gt-md=\"5\"></div><md-input-container class=\"md-block\" flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\">\n<label class=\"blue-900-fg\" translate=\"MD.COST_PRICE\">Precio de coste</label><input type=\"number\" step=\"0.01\" \nname=\"precioCoste\" ng-model=\"vm.moldura.precioCoste\" required><div ng-messages=\"moldingForm.precioCoste.$error\" \nng-show=\"moldingForm.precioCoste.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MD.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container><div flex=\"5\" \nflex-gt-xs=\"5\" flex-gt-md=\"5\"></div><md-input-container class=\"md-block\" flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\">\n<label class=\"blue-900-fg\" translate=\"MD.PVP1\">PVP 1</label><input type=\"number\" step=\"0.01\" name=\"precioLeroyMerlin\" \nng-model=\"vm.moldura.precioLeroyMerlin\" required><div ng-messages=\"moldingForm.precioLeroyMerlin.$error\" \nng-show=\"moldingForm.precioLeroyMerlin.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MD.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container></div><div layout=\"row\" \nflex=\"100\" layout-align=\"start start\"><md-input-container flex=\"40\" flex-gt-xs=\"40\" flex-gt-md=\"40\" class=\"md-block\" \nmd-no-float><label class=\"blue-900-fg\" translate=\"MD.MOLDING_IMAGE\">\nImagen de la moldura (tamaño de Ancho x Alto píxels):</label><input name=\"file\" ng-model=\"vm.moldura.nombreImagen\">\n</md-input-container><input type=\"file\" id=\"fileInput\" name=\"fileInput\" ng-change=\"vm.handleFileSelect($event)\" \nclass=\"ng-hide\" ngf-select ng-model=\"vm.fileUploaded\" ngf-accept=\"\'*/*\'\"><div flex=\"5\" flex-gt-xs=\"5\" flex-gt-md=\"5\">\n</div><md-button class=\"md-raised upload-button\" ng-click=\"vm.selectFile()\"><div class=\"context\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-upload\" class=\"s32\"></md-icon><div class=\"title\" \ntranslate=\"MD.UPLOAD_IMAGE\" translate-attr-aria-label=\"MD.UPLOAD_IMAGE\">SUBIR IMAGEN</div></div></md-button><div \nflex=\"5\" flex-gt-xs=\"5\" flex-gt-md=\"5\"></div><div flex=\"35\" layout-align=\"center start\" flex-gt-xs=\"35\" \nflex-gt-md=\"35\"><img id=\"imageFromStorage\"></div></div><div class=\"separadorVertical\"></div><div layout=\"row\" \nflex=\"100\" layout-align=\"start start\"><md-input-container flex=\"40\" flex-gt-xs=\"40\" flex-gt-md=\"40\" class=\"md-block\" \nmd-no-float><label class=\"blue-900-fg\" translate=\"MD.MOLDING_PROFILE_IMAGE\">\nImagen del perfil (tamaño de Ancho x Alto píxels):</label><input name=\"file2\" ng-model=\"vm.moldura.nombreImagenPerfil\">\n</md-input-container><input type=\"file\" id=\"fileInput2\" name=\"fileInput2\" ng-change=\"vm.handleFileSelect2($event)\" \nclass=\"ng-hide\" ngf-select ng-model=\"vm.fileUploaded2\" ngf-accept=\"\'*/*\'\"><div flex=\"5\" flex-gt-xs=\"5\" flex-gt-md=\"5\">\n</div><md-button class=\"md-raised upload-button\" ng-click=\"vm.selectFile2()\"><div class=\"context\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-upload\" class=\"s32\"></md-icon><div class=\"title\" \ntranslate=\"MD.UPLOAD_IMAGE\" translate-attr-aria-label=\"MD.UPLOAD_IMAGE\">SUBIR IMAGEN</div></div></md-button><div \nflex=\"5\" flex-gt-xs=\"5\" flex-gt-md=\"5\"></div><div flex=\"35\" layout-align=\"center start\" flex-gt-xs=\"35\" \nflex-gt-md=\"35\"><img id=\"profileImageFromStorage\"></div></div><md-input-container class=\"md-block\"><label \nclass=\"blue-900-fg\" translate=\"MD.COMMENTS\">Observaciones</label><textarea ng-model=\"vm.moldura.observaciones\" \nmd-maxlength=\"250\" rows=\"5\" md-select-on-focus></textarea></md-input-container><md-input-container flex=\"30\" \nflex-gt-xs=\"30\" flex-gt-md=\"30\"><md-checkbox ng-model=\"vm.moldura.activo\" aria-label=\"Activo\" \nng-init=\"vm.moldura.activo=true\"><span translate=\"MD.ACTIVE\">Activo</span></md-checkbox></md-input-container></div>\n</div></form></md-content></div></div></div>");
$templateCache.put("app/main/menu/productos/molduras/moldings/moldings.html","<div id=\"moldings\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-arrange-send-backward\" class=\"s30 icon-arrange-send-backward\"></md-icon><span \ntranslate=\"MD.MOLDINGS\">Molduras</span></div><div class=\"order-count secondary-text\"><span \ntranslate=\"MD.TOTAL_MOLDINGS\">Total molduras:</span> <span>{{vm.totalMolduras}}</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"moldings-search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"MD.SEARCH\" flex></div><div><md-button class=\"md-raised md-background\" \nng-click=\"vm.gotoAddMolding()\"><span><md-icon md-font-icon=\"icon-plus-circle-outline\" \nclass=\"s30 icon-plus-circle-outline\"></md-icon></span><span translate=\"MD.ADD_MOLDING\">Añadir Moldura</span>\n</md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Nº Mold.</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ref Prov.</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ref 1</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Descripción</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">&lt; 70cm</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Desperdicio</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Coste</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">PVP 1</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Activo</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"></span></div></th></tr></thead><tbody><tr ng-repeat=\"moldura in vm.molduras\"><td>\n{{moldura.numeroMoldura}}</td><td>{{moldura.refProveedor}}</td><td>{{moldura.refLeroyMerlin}}</td><td>\n{{moldura.descripcion}}</td><td>{{moldura.limitacion70cm}}</td><td>{{moldura.desperdicio}}</td><td>\n{{moldura.precioCoste}}</td><td>{{moldura.precioLeroyMerlin}}</td><td>{{moldura.activo}}</td><td><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.gotoMoldingDetail(moldura.$id)\" aria-label=\"Molding details\" translate \ntranslate-attr-aria-label=\"MD.MOLDING_DETAIL\"><md-icon md-font-icon=\"icon-pencil-box-outline\" class=\"s25 blue-500-fg\">\n</md-icon></md-button><md-button class=\"delete-button md-icon-button\" \nng-click=\"vm.showConfirmDeleteDialog($event,moldura.$id)\" aria-label=\"Molding delete\" translate \ntranslate-attr-aria-label=\"MD.DELETE\"><md-icon md-font-icon=\"icon-delete\" class=\"s25 red-500-fg\"></md-icon></md-button>\n</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/menu/productos/varios/varios/varios.html","<div id=\"varios\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-arrange-send-backward\" class=\"s30 icon-arrange-send-backward\"></md-icon><span \ntranslate=\"VARIOS.PRODUCTS\">Productos</span></div><div class=\"order-count secondary-text\"><span \ntranslate=\"VARIOS.TOTAL_PRODUCTS\">Total productos:</span> <span>{{vm.totalVarios}}</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"varios-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"VARIOS.SEARCH\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.gotoAddVario()\"><span><md-icon md-font-icon=\"icon-plus-circle-outline\" \nclass=\"s30 icon-plus-circle-outline\"></md-icon></span><span translate=\"VARIOS.ADD_PRODUCT\">Añadir Producto</span>\n</md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr class=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Nº ART.</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ref Prov.</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ref 1</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Descripción</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Tipo</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ancho máx(cm)</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Alto máx(cm)</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Coste</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">PVP 1</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Activo</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"></span></div></th></tr></thead><tbody><tr ng-repeat=\"vario in vm.varios\"><td>\n{{vario.numeroArticulo}}</td><td>{{vario.refProveedor}}</td><td>{{vario.refLeroyMerlin}}</td><td>{{vario.descripcion}}\n</td><td>{{vario.tipo}}</td><td>{{vario.limitacionAnchoCm}}</td><td>{{vario.limitacionAltoCm}}</td><td>\n{{vario.precioCoste}}</td><td>{{vario.precioLeroyMerlin}}</td><td>{{vario.activo}}</td><td><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.gotoVarioDetail(vario.$id)\" aria-label=\"Product details\" translate \ntranslate-attr-aria-label=\"VARIOS.PRODUCT_DETAIL\"><md-icon md-font-icon=\"icon-pencil-box-outline\" \nclass=\"s25 blue-500-fg\"></md-icon></md-button><md-button class=\"delete-button md-icon-button\" \nng-click=\"vm.showConfirmDeleteDialog($event,vario.$id)\" aria-label=\"Product delete\" translate \ntranslate-attr-aria-label=\"VARIOS.DELETE\"><md-icon md-font-icon=\"icon-delete\" class=\"s25 red-500-fg\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/menu/productos/varios/vario/vario.html","<div id=\"vario\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-moldings-button md-icon-button\" \naria-label=\"Go to Passe-partouts\" ng-click=\"vm.gotoVarios()\" translate \ntranslate-attr-aria-label=\"VARIOS.GO_TO_PRODUCTS\"><md-icon md-font-icon=\"icon-arrow-left-bold-circle-outline\" \nclass=\"s32\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h2\"><span translate=\"VARIOS.PRODUCT\">Producto</span> <span>\n{{vm.vario.numeroArticulo}}</span></div><div class=\"subtitle secondary-text\"><span translate=\"VARIOS.PRODUCT_DETAIL\">\nPRODUCT details</span></div></div></div></div><div><md-button class=\"md-raised md-background\" \nng-click=\"vm.gotoVarios()\"><md-icon md-font-icon=\"icon-cancel\" class=\"s30 icon-cancel\"></md-icon><span \ntranslate=\"VARIOS.CANCEL\">CANCELAR</span></md-button><md-button class=\"md-raised md-background\" ng-click=\"vm.save()\" \nng-disabled=\"varioForm.$invalid\"><md-icon md-font-icon=\"icon-check-circle\" class=\"s30 icon-check-circle\"></md-icon>\n<span translate=\"VARIOS.SAVE_PRODUCT\">GUARDAR PRODUCTO</span></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span class=\"h2 text-uppercase\" \ntranslate=\"VARIOS.PRODUCT_DETAIL_TITLE\">Datos del producto</span></div><md-content class=\"content grey-100-bg\" flex \nms-scroll><form name=\"varioForm\"><div layout=\"column\" flex=\"100\"><div \nclass=\"budget-detail-form-container md-background-bg md-whiteframe-1dp\" flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex=\"25\" flex-gt-xs=\"25\" flex-gt-md=\"25\"><label \nclass=\"blue-900-fg\" translate=\"VARIOS.PRODUCT_NUMBER\">Número de producto</label><input type=\"text\" \nname=\"numeroProducto\" ng-model=\"vm.vario.numeroArticulo\" readonly=\"readonly\" required><div \nng-messages=\"varioForm.numeroProducto.$error\" ng-show=\"varioForm.numeroProducto.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"VARIOS.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container><div flex=\"10\" flex-gt-xs=\"10\" flex-gt-md=\"10\"></div><md-input-container class=\"md-block\" \nflex=\"25\" flex-gt-xs=\"25\" flex-gt-md=\"25\"><label class=\"blue-900-fg\" translate=\"VARIOS.PROVIDER_REF\">\nReferencia proveedor</label><input type=\"text\" name=\"refProveedor\" ng-model=\"vm.vario.refProveedor\" required><div \nng-messages=\"varioForm.refProveedor.$error\" ng-show=\"varioForm.refProveedor.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"VARIOS.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container><div flex=\"10\" flex-gt-xs=\"10\" flex-gt-md=\"10\"></div><md-input-container class=\"md-block\" \nflex=\"25\" flex-gt-xs=\"25\" flex-gt-md=\"25\"><label class=\"blue-900-fg\" translate=\"VARIOS.REF1\">Referencia 1</label><input\n type=\"text\" name=\"refLeroyMerlin\" ng-model=\"vm.vario.refLeroyMerlin\" required><div \nng-messages=\"varioForm.refLeroyMerlin.$error\" ng-show=\"varioForm.refLeroyMerlin.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"VARIOS.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container></div><div layout=\"row\" flex><md-input-container class=\"md-block\" flex=\"75\" flex-gt-xs=\"75\" \nflex-gt-md=\"75\"><label class=\"blue-900-fg\" translate=\"VARIOS.DESCRIPTION\">Descripción</label><input type=\"text\" \nname=\"descripcion\" ng-model=\"vm.vario.descripcion\" required><div ng-messages=\"varioForm.descripcion.$error\" \nng-show=\"varioForm.descripcion.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"VARIOS.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container><div flex=\"10\" \nflex-gt-xs=\"10\" flex-gt-md=\"10\"></div><md-input-container class=\"md-block\" flex=\"15\" flex-gt-xs=\"15\" flex-gt-md=\"15\">\n<label class=\"blue-900-fg\" translate=\"VARIOS.TYPE_PRODUCT\">Tipo de producto</label><md-select name=\"tipo\" \nplaceholder=\"\" ng-model=\"vm.vario.tipo\" required><md-option ng-value=\"tipo\" ng-repeat=\"tipo in vm.tipos\">{{tipo}}\n</md-option></md-select><div ng-messages=\"varioForm.tipo.$error\" ng-show=\"varioForm.tipo.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"BG.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container></div><div layout=\"row\" flex><md-input-container class=\"md-block\" flex=\"20\" flex-gt-xs=\"20\" \nflex-gt-md=\"20\"><label class=\"blue-900-fg\" translate=\"VARIOS.MAX_WIDTH_CM\">Ancho máx(cm)</label><input type=\"number\" \nname=\"limitacionAnchoCm\" ng-model=\"vm.vario.limitacionAnchoCm\" required><div \nng-messages=\"varioForm.limitacionAnchoCm.$error\" ng-show=\"varioForm.limitacionAnchoCm.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"VARIOS.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container><div flex=\"5\" flex-gt-xs=\"5\" flex-gt-md=\"5\"></div><md-input-container class=\"md-block\" flex=\"20\" \nflex-gt-xs=\"20\" flex-gt-md=\"20\"><label class=\"blue-900-fg\" translate=\"VARIOS.MAX_HEIGHT_CM\">Alto máx(cm)</label><input \ntype=\"number\" name=\"limitacionAltoCm\" ng-model=\"vm.vario.limitacionAltoCm\" required><div \nng-messages=\"varioForm.limitacionAltoCm.$error\" ng-show=\"varioForm.limitacionAltoCm.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"VARIOS.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container><div flex=\"5\" flex-gt-xs=\"5\" flex-gt-md=\"5\"></div><md-input-container class=\"md-block\" flex=\"20\" \nflex-gt-xs=\"20\" flex-gt-md=\"20\"><label class=\"blue-900-fg\" translate=\"VARIOS.COST_PRICE\">Precio de coste(m2)</label>\n<input type=\"number\" step=\"0.01\" name=\"precioCoste\" ng-model=\"vm.vario.precioCoste\" required><div \nng-messages=\"varioForm.precioCoste.$error\" ng-show=\"varioForm.precioCoste.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"VARIOS.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container><div flex=\"5\" flex-gt-xs=\"5\" flex-gt-md=\"5\"></div><md-input-container class=\"md-block\" flex=\"20\" \nflex-gt-xs=\"20\" flex-gt-md=\"20\"><label class=\"blue-900-fg\" translate=\"VARIOS.PVP1\">PVP 1 (m2)</label><input \ntype=\"number\" step=\"0.01\" name=\"precioLeroyMerlin\" ng-model=\"vm.vario.precioLeroyMerlin\" required><div \nng-messages=\"varioForm.precioLeroyMerlin.$error\" ng-show=\"varioForm.precioLeroyMerlin.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"VARIOS.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container></div><md-input-container class=\"md-block\"><label class=\"blue-900-fg\" translate=\"VARIOS.COMMENTS\">\nObservaciones</label><textarea ng-model=\"vm.vario.observaciones\" md-maxlength=\"250\" rows=\"5\" md-select-on-focus>\n</textarea></md-input-container><md-input-container flex=\"30\" flex-gt-xs=\"30\" flex-gt-md=\"30\"><md-checkbox \nng-model=\"vm.vario.activo\" aria-label=\"Activo\" ng-init=\"vm.vario.activo=true\"><span translate=\"VARIOS.ACTIVE\">Activo\n</span></md-checkbox></md-input-container></div></div></form></md-content></div></div></div>");
$templateCache.put("app/main/menu/productos/servicios/servicios/servicios.html","<div id=\"servicios\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-arrange-send-backward\" class=\"s30 icon-arrange-send-backward\"></md-icon><span \ntranslate=\"SERVICIOS.SERVICES\">Servicios</span></div><div class=\"order-count secondary-text\"><span \ntranslate=\"SERVICIOS.TOTAL_SERVICES\">Total servicios:</span> <span>{{vm.totalServicios}}</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"servicios-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SERVICIOS.SEARCH\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.gotoAddServicio()\" ng-disabled=\"true\"><span><md-icon \nmd-font-icon=\"icon-plus-circle-outline\" class=\"s30 icon-plus-circle-outline\"></md-icon></span><span \ntranslate=\"SERVICIOS.ADD_SERVICE\">Añadir Servicio</span></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr \nclass=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ref Servicio\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ref 1</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Descripción</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Coste</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">PVP 1</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Activo</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"></span></div></th></tr></thead><tbody><tr \nng-repeat=\"servicio in vm.servicios\"><td>{{servicio.referencia}}</td><td>{{servicio.refLeroyMerlin}}</td><td>\n{{servicio.descripcion}}</td><td>{{servicio.precioCoste}}</td><td>{{servicio.precioLeroyMerlin}}</td><td>\n{{servicio.activo}}</td><td><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.gotoServicioDetail(servicio.$id)\" aria-label=\"Service details\" translate \ntranslate-attr-aria-label=\"SERVICIOS.SERVICE_DETAIL\"><md-icon md-font-icon=\"icon-pencil-box-outline\" \nclass=\"s25 blue-500-fg\"></md-icon></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/menu/productos/servicios/servicio/servicio.html","<div id=\"servicio\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-moldings-button md-icon-button\" \naria-label=\"Go to Services\" ng-click=\"vm.gotoServicios()\" translate \ntranslate-attr-aria-label=\"SERVICIOS.GO_TO_SERVICES\"><md-icon md-font-icon=\"icon-arrow-left-bold-circle-outline\" \nclass=\"s32\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h2\"><span translate=\"SERVICIOS.SERVICE\">Servicio</span> <span>\n{{vm.servicio.referencia}}</span></div><div class=\"subtitle secondary-text\"><span translate=\"SERVICIOS.SERVICE_DETAIL\">\nSERVICE details</span></div></div></div></div><div><md-button class=\"md-raised md-background\" \nng-click=\"vm.gotoServicios()\"><md-icon md-font-icon=\"icon-cancel\" class=\"s30 icon-cancel\"></md-icon><span \ntranslate=\"SERVICIOS.CANCEL\">CANCELAR</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"vm.save()\" ng-disabled=\"servicioForm.$invalid\"><md-icon md-font-icon=\"icon-check-circle\" \nclass=\"s30 icon-check-circle\"></md-icon><span translate=\"SERVICIOS.SAVE_SERVICE\">GUARDAR SERVICIO</span></md-button>\n</div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h2 text-uppercase\" translate=\"SERVICIOS.SERVICE_DETAIL_TITLE\">\nDatos del servicio</span></div><md-content class=\"content grey-100-bg\" flex ms-scroll><form name=\"servicioForm\"><div \nlayout=\"column\" flex=\"100\"><div class=\"budget-detail-form-container md-background-bg md-whiteframe-1dp\" flex=\"45\" \nflex-gt-xs=\"45\" flex-gt-md=\"45\"><div layout=\"row\" flex><md-input-container class=\"md-block\" flex=\"25\" flex-gt-xs=\"25\" \nflex-gt-md=\"25\"><label class=\"blue-900-fg\" translate=\"SERVICIOS.SERVICE_REF\">Ref. servicio</label><input type=\"text\" \nname=\"referenciaServicio\" ng-model=\"vm.servicio.referencia\"><div ng-messages=\"servicioForm.referenciaServicio.$error\" \nng-show=\"servicioForm.referenciaServicio.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SERVICIOS.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container><div flex=\"10\" \nflex-gt-xs=\"10\" flex-gt-md=\"10\"></div><md-input-container class=\"md-block\" flex=\"25\" flex-gt-xs=\"25\" flex-gt-md=\"25\">\n<label class=\"blue-900-fg\" translate=\"SERVICIOS.REF1\">Referencia 1</label><input type=\"text\" name=\"refLeroyMerlin\" \nng-model=\"vm.servicio.refLeroyMerlin\" required><div ng-messages=\"servicioForm.refLeroyMerlin.$error\" \nng-show=\"servicioForm.refLeroyMerlin.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SERVICIOS.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container></div><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><label \nclass=\"blue-900-fg\" translate=\"SERVICIOS.DESCRIPTION\">Descripción (sólo lectura)</label><input type=\"text\" \nname=\"descripcion\" ng-model=\"vm.servicio.descripcion\" required readonly=\"readonly\"><div \nng-messages=\"servicioForm.descripcion.$error\" ng-show=\"servicioForm.descripcion.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"SERVICIOS.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container></div><div layout=\"row\" flex><md-input-container class=\"md-block\" flex=\"25\" flex-gt-xs=\"25\" \nflex-gt-md=\"25\"><label class=\"blue-900-fg\" translate=\"SERVICIOS.COST_PRICE\">Precio de coste(m2)</label><input \ntype=\"number\" step=\"0.01\" name=\"precioCoste\" ng-model=\"vm.servicio.precioCoste\" required><div \nng-messages=\"servicioForm.precioCoste.$error\" ng-show=\"servicioForm.precioCoste.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"SERVICIOS.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container><div flex=\"10\" flex-gt-xs=\"10\" flex-gt-md=\"10\"></div><md-input-container class=\"md-block\" \nflex=\"25\" flex-gt-xs=\"25\" flex-gt-md=\"25\"><label class=\"blue-900-fg\" translate=\"SERVICIOS.PVP1\">PVP 1 (m2)</label>\n<input type=\"number\" step=\"0.01\" name=\"precioLeroyMerlin\" ng-model=\"vm.servicio.precioLeroyMerlin\" required><div \nng-messages=\"servicioForm.precioLeroyMerlin.$error\" ng-show=\"servicioForm.precioLeroyMerlin.$touched\" role=\"alert\"><div\n ng-message=\"required\"><span translate=\"SERVICIOS.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container></div><md-input-container class=\"md-block\"><label class=\"blue-900-fg\" \ntranslate=\"SERVICIOS.COMMENTS\">Observaciones</label><textarea ng-model=\"vm.servicio.observaciones\" md-maxlength=\"250\" \nrows=\"5\" md-select-on-focus></textarea></md-input-container><md-input-container flex=\"30\" flex-gt-xs=\"30\" \nflex-gt-md=\"30\"><md-checkbox ng-model=\"vm.servicio.activo\" aria-label=\"Activo\" ng-init=\"vm.servicio.activo=true\"><span \ntranslate=\"SERVICIOS.ACTIVE\">Activo</span></md-checkbox></md-input-container></div></div></form></md-content></div>\n</div></div>");
$templateCache.put("app/main/menu/productos/passepartouts/passepartouts/passepartouts.html","<div id=\"passepartouts\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-arrange-send-backward\" class=\"s30 icon-arrange-send-backward\"></md-icon><span \ntranslate=\"PPT.PASSE-PARTOUTS\">Passe-partouts</span></div><div class=\"order-count secondary-text\"><span \ntranslate=\"PPT.TOTAL_PASSE-PARTOTUS\">Total passe-partouts:</span> <span>{{vm.totalPassepartouts}}</span></div></div>\n<div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"passepartouts-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"PPT.SEARCH\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.gotoAddPassepartout()\"><span><md-icon \nmd-font-icon=\"icon-plus-circle-outline\" class=\"s30 icon-plus-circle-outline\"></md-icon></span><span \ntranslate=\"PPT.ADD_PASSE-PARTOUT\">Añadir Passe-partout</span></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr \nclass=\"md-grey-100-bg\"><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Nº Ppt.</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ref Prov.</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ref 1</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Descripción</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Ancho máx(cm)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Alto máx(cm)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Coste</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">PVP 1</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Activo</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"></span></div></th></tr></thead><tbody><tr \nng-repeat=\"passepartout in vm.passepartouts\"><td>{{passepartout.numeroPpt}}</td><td>{{passepartout.refProveedor}}</td>\n<td>{{passepartout.refLeroyMerlin}}</td><td>{{passepartout.descripcion}}</td><td>{{passepartout.limitacionAnchoCm}}\n</td><td>{{passepartout.limitacionAltoCm}}</td><td>{{passepartout.precioCoste}}</td><td>\n{{passepartout.precioLeroyMerlin}}</td><td>{{passepartout.activo}}</td><td><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.gotoPassepartoutDetail(passepartout.$id)\" \naria-label=\"Passe-partout details\" translate translate-attr-aria-label=\"PPT.PASSE-PARTOUT_DETAIL\"><md-icon \nmd-font-icon=\"icon-pencil-box-outline\" class=\"s25 blue-500-fg\"></md-icon></md-button><md-button \nclass=\"delete-button md-icon-button\" ng-click=\"vm.showConfirmDeleteDialog($event,passepartout.$id)\" \naria-label=\"Passe-partout delete\" translate translate-attr-aria-label=\"PPT.DELETE\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s25 red-500-fg\"></md-icon></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/menu/productos/passepartouts/passepartout/passepartout.html","<div id=\"passepartout\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-moldings-button md-icon-button\" \naria-label=\"Go to Passe-partouts\" ng-click=\"vm.gotoPassepartouts()\" translate \ntranslate-attr-aria-label=\"PPT.GO_TO_PASSE-PARTOUTS\"><md-icon md-font-icon=\"icon-arrow-left-bold-circle-outline\" \nclass=\"s32\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h2\"><span translate=\"PPT.PASSE-PARTOUT\">PASSE-PARTOUT</span> <span>\n{{vm.passepartout.numeroPpt}}</span></div><div class=\"subtitle secondary-text\"><span \ntranslate=\"PPT.PASSE-PARTOUT_DETAIL\">PASSE-PARTOUT details</span></div></div></div></div><div><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.gotoPassepartouts()\"><md-icon md-font-icon=\"icon-cancel\" \nclass=\"s30 icon-cancel\"></md-icon><span translate=\"PPT.CANCEL\">CANCELAR</span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.save()\" ng-disabled=\"passepartoutForm.$invalid\"><md-icon \nmd-font-icon=\"icon-check-circle\" class=\"s30 icon-check-circle\"></md-icon><span translate=\"PPT.SAVE_PASSE-PARTOUT\">\nGUARDAR PASSE-PARTOUT</span></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span class=\"h2 text-uppercase\" \ntranslate=\"PPT.PASSE-PARTOUT_DETAIL_TITLE\">Datos del passe-partout</span></div><md-content class=\"content grey-100-bg\" \nflex ms-scroll><form name=\"passepartoutForm\"><div layout=\"column\" flex=\"100\"><div \nclass=\"budget-detail-form-container md-background-bg md-whiteframe-1dp\" flex=\"45\" flex-gt-xs=\"45\" flex-gt-md=\"45\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex=\"25\" flex-gt-xs=\"25\" flex-gt-md=\"25\"><label \nclass=\"blue-900-fg\" translate=\"PPT.PASSE-PARTOUT_NUMBER\">Número de passe-partout</label><input type=\"number\" \nname=\"numeroPassepartout\" ng-model=\"vm.passepartout.numeroPpt\" required><div \nng-messages=\"passepartoutForm.numeroPassepartout.$error\" ng-show=\"passepartoutForm.numeroPassepartout.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PPT.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div>\n</div></md-input-container><div flex=\"10\" flex-gt-xs=\"10\" flex-gt-md=\"10\"></div><md-input-container class=\"md-block\" \nflex=\"25\" flex-gt-xs=\"25\" flex-gt-md=\"25\"><label class=\"blue-900-fg\" translate=\"PPT.PROVIDER_REF\">Referencia proveedor\n</label><input type=\"text\" name=\"refProveedor\" ng-model=\"vm.passepartout.refProveedor\" required><div \nng-messages=\"passepartoutForm.refProveedor.$error\" ng-show=\"passepartoutForm.refProveedor.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PPT.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container><div flex=\"10\" flex-gt-xs=\"10\" flex-gt-md=\"10\"></div><md-input-container class=\"md-block\" \nflex=\"25\" flex-gt-xs=\"25\" flex-gt-md=\"25\"><label class=\"blue-900-fg\" translate=\"PPT.REF1\">Referencia 1</label><input \ntype=\"text\" name=\"refLeroyMerlin\" ng-model=\"vm.passepartout.refLeroyMerlin\" required><div \nng-messages=\"passepartoutForm.refLeroyMerlin.$error\" ng-show=\"passepartoutForm.refLeroyMerlin.$touched\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"PPT.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container></div><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><label \nclass=\"blue-900-fg\" translate=\"PPT.DESCRIPTION\">Descripción</label><input type=\"text\" name=\"descripcion\" \nng-model=\"vm.passepartout.descripcion\" required><div ng-messages=\"passepartoutForm.descripcion.$error\" \nng-show=\"passepartoutForm.descripcion.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PPT.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container><div layout=\"row\" flex>\n<md-input-container class=\"md-block\" flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><label class=\"blue-900-fg\" \ntranslate=\"PPT.PASSE-PARTOUT_MAX_WIDTH_CM\">Ancho máx(cm)</label><input type=\"number\" name=\"limitacionAnchoCm\" \nng-model=\"vm.passepartout.limitacionAnchoCm\" required><div ng-messages=\"passepartoutForm.limitacionAnchoCm.$error\" \nng-show=\"passepartoutForm.limitacionAnchoCm.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PPT.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div></md-input-container><div flex=\"5\" \nflex-gt-xs=\"5\" flex-gt-md=\"5\"></div><md-input-container class=\"md-block\" flex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\">\n<label class=\"blue-900-fg\" translate=\"PPT.PASSE-PARTOUT_MAX_HEIGHT_CM\">Alto máx(cm)</label><input type=\"number\" \nname=\"limitacionAltoCm\" ng-model=\"vm.passepartout.limitacionAltoCm\" required><div \nng-messages=\"passepartoutForm.limitacionAltoCm.$error\" ng-show=\"passepartoutForm.limitacionAltoCm.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PPT.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div>\n</div></md-input-container><div flex=\"5\" flex-gt-xs=\"5\" flex-gt-md=\"5\"></div><md-input-container class=\"md-block\" \nflex=\"20\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><label class=\"blue-900-fg\" translate=\"PPT.COST_PRICE\">Precio de coste</label>\n<input type=\"number\" step=\"0.01\" name=\"precioCoste\" ng-model=\"vm.passepartout.precioCoste\" required><div \nng-messages=\"passepartoutForm.precioCoste.$error\" ng-show=\"passepartoutForm.precioCoste.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PPT.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div></div>\n</md-input-container><div flex=\"5\" flex-gt-xs=\"5\" flex-gt-md=\"5\"></div><md-input-container class=\"md-block\" flex=\"20\" \nflex-gt-xs=\"20\" flex-gt-md=\"20\"><label class=\"blue-900-fg\" translate=\"PPT.PVP1\">PVP 1</label><input type=\"number\" \nstep=\"0.01\" name=\"precioLeroyMerlin\" ng-model=\"vm.passepartout.precioLeroyMerlin\" required><div \nng-messages=\"passepartoutForm.precioLeroyMerlin.$error\" ng-show=\"passepartoutForm.precioLeroyMerlin.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PPT.ERRORS.FIELD_REQUIRED\">Campo obligatorio</span></div>\n</div></md-input-container></div><div layout=\"row\" flex=\"100\" layout-align=\"start start\"><md-input-container flex=\"40\" \nflex-gt-xs=\"40\" flex-gt-md=\"40\" class=\"md-block\" md-no-float><label class=\"blue-900-fg\" \ntranslate=\"PPT.PASSE-PARTOUT_IMAGE\">Imagen del passe-partout (tamaño de Ancho x Alto píxels):</label><input \nname=\"file\" ng-model=\"vm.passepartout.nombreImagen\"></md-input-container><input type=\"file\" id=\"fileInput\" \nname=\"fileInput\" ng-change=\"vm.handleFileSelect($event)\" class=\"ng-hide\" ngf-select ng-model=\"vm.fileUploaded\" \nngf-accept=\"\'*/*\'\"><div flex=\"5\" flex-gt-xs=\"5\" flex-gt-md=\"5\"></div><md-button class=\"md-raised upload-button\" \nng-click=\"vm.selectFile()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-upload\" class=\"s32\"></md-icon><div class=\"title\" translate=\"PPT.UPLOAD_IMAGE\" \ntranslate-attr-aria-label=\"PPT.UPLOAD_IMAGE\">SUBIR IMAGEN</div></div></md-button><div flex=\"5\" flex-gt-xs=\"5\" \nflex-gt-md=\"5\"></div><div flex=\"35\" layout-align=\"center start\" flex-gt-xs=\"35\" flex-gt-md=\"35\"><img \nid=\"imageFromStorage\"></div></div><div class=\"separadorVertical\"></div><div layout=\"row\" flex=\"100\" \nlayout-align=\"start start\"><md-input-container flex=\"40\" flex-gt-xs=\"40\" flex-gt-md=\"40\" class=\"md-block\" md-no-float>\n<label class=\"blue-900-fg\" translate=\"PPT.PASSE-PARTOUT_IMAGE2\">\nImagen 2 del passe-partout (tamaño de Ancho x Alto píxels):</label><input name=\"file2\" \nng-model=\"vm.passepartout.nombreImagen2\"></md-input-container><input type=\"file\" id=\"fileInput2\" name=\"fileInput2\" \nng-change=\"vm.handleFileSelect2($event)\" class=\"ng-hide\" ngf-select ng-model=\"vm.fileUploaded2\" ngf-accept=\"\'*/*\'\"><div\n flex=\"5\" flex-gt-xs=\"5\" flex-gt-md=\"5\"></div><md-button class=\"md-raised upload-button\" ng-click=\"vm.selectFile2()\">\n<div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-upload\" class=\"s32\">\n</md-icon><div class=\"title\" translate=\"PPT.UPLOAD_IMAGE\" translate-attr-aria-label=\"PPT.UPLOAD_IMAGE\">SUBIR IMAGEN\n</div></div></md-button><div flex=\"5\" flex-gt-xs=\"5\" flex-gt-md=\"5\"></div><div flex=\"35\" layout-align=\"center start\" \nflex-gt-xs=\"35\" flex-gt-md=\"35\"><img id=\"image2FromStorage\"></div></div><md-input-container class=\"md-block\"><label \nclass=\"blue-900-fg\" translate=\"PPT.COMMENTS\">Observaciones</label><textarea ng-model=\"vm.passepartout.observaciones\" \nmd-maxlength=\"250\" rows=\"5\" md-select-on-focus></textarea></md-input-container><md-input-container flex=\"30\" \nflex-gt-xs=\"30\" flex-gt-md=\"30\"><md-checkbox ng-model=\"vm.passepartout.activo\" aria-label=\"Activo\" \nng-init=\"vm.passepartout.activo=true\"><span translate=\"PPT.ACTIVE\">Activo</span></md-checkbox></md-input-container>\n</div></div></form></md-content></div></div></div>");
$templateCache.put("app/main/apps/gantt-chart/dialogs/add-edit/views/row-form-view.html","<div class=\"row\" layout=\"column\"><form name=\"rowForm\" ng-submit=\"vm.dialogType === \'add\'?vm.addNewRow():vm.saveRow();\">\n<div class=\"form-content\"><div layout=\"row\"><div flex class=\"input-block\"><md-input-container flex class=\"row-name\">\n<label>Row Name</label><input name=\"name\" ng-model=\"vm.row.name\" required md-autofocus></md-input-container></div>\n</div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex>\n<md-input-container flex><label>Parent Row:</label><md-select ng-model=\"vm.row.parent\"><md-option ng-value=\"\'\'\">\nNo Parent</md-option><md-option ng-repeat=\"row in vm.chartData\" ng-value=\"row.id\">{{row.name}}</md-option></md-select>\n</md-input-container></div><div class=\"input-block\" flex layout=\"row\" layout-align=\"space-between center\"><label>\nSortable:</label><md-switch ng-model=\"vm.row.sortable\" aria-label=\"Sortable\"></md-switch></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start center\"><div class=\"input-block\" flex layout=\"row\" \nlayout-align=\"space-between center\"><label>Row Color:</label><ms-material-color-picker ng-model=\"vm.row.classes[1]\">\n</ms-material-color-picker></div><div flex class=\"input-block\"><md-input-container flex layout=\"row\" \nlayout-align=\"space-between center\"><label>Extra Class</label><input name=\"name\" ng-model=\"vm.row.classes[0]\">\n</md-input-container></div></div></div><md-dialog-actions><md-button ng-if=\"vm.dialogType === \'edit\'\" \nclass=\"md-icon-button\" ng-click=\"vm.removeRow()\" aria-label=\"Remove\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button><md-button type=\"submit\" class=\"md-accent md-raised\" ng-disabled=\"rowForm.$invalid || rowForm.$pristine\" \naria-label=\"Save\"><span ng-if=\"vm.dialogType === \'add\'\">Add</span> <span ng-if=\"vm.dialogType === \'edit\'\">Save</span>\n</md-button></md-dialog-actions></form></div>");
$templateCache.put("app/main/apps/gantt-chart/dialogs/add-edit/views/task-form-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\" \nng-submit=\"vm.dialogType === \'add\'?vm.addNewTask():vm.saveTask();\"><div class=\"form-content\"><div layout=\"row\"><div \nflex class=\"input-block\"><md-input-container flex class=\"task-name\"><label>Task Name</label><input name=\"name\" \nng-model=\"vm.task.name\" required md-autofocus></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex layout=\"row\" layout-align=\"space-between center\"><label>From:\n</label><md-datepicker name=\"fromDate\" ms-datepicker-fix ng-model=\"vm.task.from\" md-placeholder=\"Select Date\" \nng-required></md-datepicker></div><div class=\"input-block\" flex layout=\"row\" layout-align=\"space-between center\">\n<label>To:</label><md-datepicker name=\"toDate\" ms-datepicker-fix ng-model=\"vm.task.to\" md-placeholder=\"Select Date\" \nng-required></md-datepicker></div></div><div ng-if=\"vm.dialogType === \'add\'\" layout=\"row\" layout-align=\"start start\">\n<div flex class=\"input-block\"><md-input-container><label>Row:</label><md-select name=\"rowId\" ng-model=\"vm.taskRowId\" \nrequired><md-option ng-repeat=\"row in vm.chartData\" ng-value=\"row.id\">{{row.name}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"row\" layout-align=\"start center\" class=\"input-block\"><label flex=\"25\">\nProgress: <small>{{vm.task.progress}}</small></label><md-slider flex ng-model=\"vm.task.progress\" step=\"1\" min=\"0\" \nmax=\"100\" aria-label=\"Progress\"></md-slider></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start center\">\n<div class=\"input-block\" flex layout=\"row\" layout-align=\"space-between center\"><label>Task Color:</label>\n<ms-material-color-picker ng-model=\"vm.task.classes[1]\"></ms-material-color-picker></div><div flex class=\"input-block\">\n<md-input-container flex layout=\"row\" layout-align=\"space-between center\"><label>Extra Class</label><input name=\"name\" \nng-model=\"vm.task.classes[0]\"></md-input-container></div></div></div><md-dialog-actions><md-button \nng-if=\"vm.dialogType === \'edit\'\" class=\"md-icon-button\" ng-click=\"vm.removeTask()\" aria-label=\"Remove\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button><md-button class=\"md-accent md-raised\" type=\"submit\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"Save\"><span ng-if=\"vm.dialogType === \'add\'\">Add\n</span> <span ng-if=\"vm.dialogType === \'edit\'\">Save</span></md-button></md-dialog-actions></form></div>");
$templateCache.put("app/main/apps/mail/views/outlook/detail/detail.html","<div ng-if=\"!vm.currentThread\" class=\"no-thread-selected\" layout=\"column\" layout-align=\"center center\" flex><md-icon \nmd-font-icon=\"icon-email\" class=\"s120 grey-400-fg\"></md-icon><span class=\"hint-text\" \ntranslate=\"MAIL.SELECT_MESSAGE_TO_READ\">Select a message to read</span></div><div ng-if=\"vm.currentThread\"><div \nclass=\"thread-header\" layout=\"row\" layout-align=\"space-between center\"><div><div class=\"subject\" flex>\n{{vm.currentThread.subject}}</div><div class=\"labels\"><div class=\"label\" \nng-repeat=\"labelId in vm.currentThread.labels\" ng-class=\"vm.getLabelColor(labelId)\">{{vm.getLabelTitle(labelId)}}</div>\n</div></div><div class=\"actions\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleThreadStatus(\'starred\')\" aria-label=\"Toggle starred\" translate \ntranslate-attr-toogle-starred=\"MAIL.TOGGLE_STARRED\"><md-icon ng-if=\"vm.currentThread.starred\" md-font-icon=\"icon-star\" \nclass=\"amber-fg\"></md-icon><md-icon ng-if=\"!vm.currentThread.starred\" md-font-icon=\"icon-star-outline\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.toggleThreadStatus(\'important\')\" \naria-label=\"Toggle important\" translate translate-attr-toogle-starred=\"MAIL.TOGGLE_IMPORTANT\"><md-icon \nng-if=\"vm.currentThread.important\" md-font-icon=\"icon-label\" class=\"amber-300-fg\"></md-icon><md-icon \nng-if=\"!vm.currentThread.important\" md-font-icon=\"icon-label-outline\"></md-icon></md-button></div></div><div \nclass=\"thread-content\"><div class=\"info\" layout=\"row\" layout-align=\"space-between start\"><div layout=\"column\" \nlayout-align=\"start start\"><div layout=\"row\" layout-align=\"start start\"><div><img ng-if=\"vm.currentThread.from.avatar\" \nalt=\"{{vm.currentThread.from.name}}\" ng-src=\"{{vm.currentThread.from.avatar}}\" class=\"avatar\"><div \nng-if=\"!vm.currentThread.from.avatar\" class=\"avatar\" ms-random-class=\"vm.colors\">{{vm.currentThread.from.name[0]}}\n</div></div><div layout=\"column\" layout-align=\"start start\"><div class=\"name\">{{vm.currentThread.from.name}}</div><div \nclass=\"to\" layout=\"row\" layout-align=\"start center\"><div class=\"to-text\" translate=\"MAIL.INFO.TO\">to</div><div>\n{{vm.currentThread.to[0].name}}</div></div></div></div><a class=\"toggle-details md-accent-color\" \nng-hide=\"vm.selectedMailShowDetails\" ng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\" \ntranslate=\"MAIL.SHOW_DETAILS\">Show Details </a><a class=\"toggle-details md-accent-color\" \nng-show=\"vm.selectedMailShowDetails\" ng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\" \ntranslate=\"MAIL.HIDE_DETAILS\">Hide Details</a><div ng-show=\"vm.selectedMailShowDetails\" class=\"details\" layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\"><span class=\"title\" translate=\"MAIL.DETAILS.FROM\">From:</span> <span \nclass=\"title\" translate=\"MAIL.DETAILS.TO\">To:</span> <span class=\"title\" translate=\"MAIL.DETAILS.DATE\">Date:</span>\n</div><div layout=\"column\"><span class=\"detail\">{{vm.currentThread.from.email}}</span> <span class=\"detail\">\n{{vm.currentThread.to[0].email}}</span> <span class=\"detail\">{{vm.currentThread.time}}</span></div></div></div>\n<md-menu><md-button aria-label=\"More\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" translate \ntranslate-aria-label=\"MAIL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button aria-label=\"Reply\" translate-aria-label=\"MAIL.REPLY\" \nng-click=\"vm.replyDialog($event)\"><md-icon md-font-icon=\"icon-reply\"></md-icon><span translate=\"MAIL.REPLY\">Reply\n</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Forward\" translate-aria-label=\"MAIL.FORWARD\">\n<md-icon md-font-icon=\"icon-forward\"></md-icon><span translate=\"MAIL.FORWARD\">Forward</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Print\" translate-aria-label=\"MAIL.PRINT\"><md-icon md-font-icon=\"icon-printer\">\n</md-icon><span translate=\"MAIL.PRINT\">Print</span></md-button></md-menu-item></md-menu-content></md-menu></div><div \nng-bind-html=\"vm.currentThread.message\"></div></div><div ng-if=\"vm.currentThread.attachments\" \nclass=\"thread-attachments\"><div class=\"title\"><span translte=\"MAIL.ATTACHMENTS\">Attachments</span>\n ({{vm.currentThread.attachments.length}})</div><div class=\"attachment-list\" layout-wrap layout=\"row\"><div \nclass=\"attachment\" layout=\"column\" ng-repeat=\"attachment in vm.currentThread.attachments\"><img class=\"preview\" \nng-src=\"{{attachment.preview}}\"><div layout=\"column\"><a href=\"#\" class=\"md-accent-color link\" translate=\"MAIL.VIEW\">\nView</a> <a href=\"#\" class=\"md-accent-color link\" translate=\"MAIL.DOWNLOAD\">Download</a><div class=\"size\">\n({{attachment.size}})</div></div></div></div></div></div>");
$templateCache.put("app/main/apps/mail/views/classic/detail/detail.html","<div class=\"thread-header\" layout=\"row\" layout-align=\"space-between center\"><div><div class=\"subject\" flex>\n{{vm.currentThread.subject}}</div><div class=\"labels\"><div class=\"label\" \nng-repeat=\"labelId in vm.currentThread.labels\" ng-class=\"vm.getLabelColor(labelId)\">{{vm.getLabelTitle(labelId)}}</div>\n</div></div><div class=\"actions\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleThreadStatus(\'starred\')\" aria-label=\"Toggle starred\" translate \ntranslate-attr-toogle-starred=\"MAIL.TOGGLE_STARRED\"><md-icon ng-if=\"vm.currentThread.starred\" md-font-icon=\"icon-star\" \nclass=\"amber-fg\"></md-icon><md-icon ng-if=\"!vm.currentThread.starred\" md-font-icon=\"icon-star-outline\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.toggleThreadStatus(\'important\')\" \naria-label=\"Toggle important\" translate translate-attr-toogle-starred=\"MAIL.TOGGLE_IMPORTANT\"><md-icon \nng-if=\"vm.currentThread.important\" md-font-icon=\"icon-label\" class=\"amber-300-fg\"></md-icon><md-icon \nng-if=\"!vm.currentThread.important\" md-font-icon=\"icon-label-outline\"></md-icon></md-button></div></div><div \nclass=\"thread-content\"><div class=\"info\" layout=\"row\" layout-align=\"space-between start\"><div layout=\"column\" \nlayout-align=\"start start\"><div layout=\"row\" layout-align=\"start start\"><div><img ng-if=\"vm.currentThread.from.avatar\" \nalt=\"{{vm.currentThread.from.name}}\" ng-src=\"{{vm.currentThread.from.avatar}}\" class=\"avatar\"><div \nng-if=\"!vm.currentThread.from.avatar\" class=\"avatar\" ms-random-class=\"vm.colors\">{{vm.currentThread.from.name[0]}}\n</div></div><div layout=\"column\" layout-align=\"start start\"><div class=\"name\">{{vm.currentThread.from.name}}</div><div \nclass=\"to\" layout=\"row\" layout-align=\"start center\"><div class=\"to-text\" translate=\"MAIL.INFO.TO\">to</div><div>\n{{vm.currentThread.to[0].name}}</div></div></div></div><a class=\"toggle-details md-accent-color\" \nng-hide=\"vm.selectedMailShowDetails\" ng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\" \ntranslate=\"MAIL.SHOW_DETAILS\">Show Details </a><a class=\"toggle-details md-accent-color\" \nng-show=\"vm.selectedMailShowDetails\" ng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\" \ntranslate=\"MAIL.HIDE_DETAILS\">Hide Details</a><div ng-show=\"vm.selectedMailShowDetails\" class=\"details\" layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\"><span class=\"title\" translate=\"MAIL.DETAILS.FROM\">From:</span> <span \nclass=\"title\" translate=\"MAIL.DETAILS.TO\">To:</span> <span class=\"title\" translate=\"MAIL.DETAILS.DATE\">Date:</span>\n</div><div layout=\"column\"><span class=\"detail\">{{vm.currentThread.from.email}}</span> <span class=\"detail\">\n{{vm.currentThread.to[0].email}}</span> <span class=\"detail\">{{vm.currentThread.time}}</span></div></div></div>\n<md-menu><md-button aria-label=\"More\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" translate \ntranslate-aria-label=\"MAIL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button aria-label=\"Reply\" translate-aria-label=\"MAIL.REPLY\" \nng-click=\"vm.replyDialog($event)\"><md-icon md-font-icon=\"icon-reply\"></md-icon><span translate=\"MAIL.REPLY\">Reply\n</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Forward\" translate-aria-label=\"MAIL.FORWARD\">\n<md-icon md-font-icon=\"icon-forward\"></md-icon><span translate=\"MAIL.FORWARD\">Forward</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Print\" translate-aria-label=\"MAIL.PRINT\"><md-icon md-font-icon=\"icon-printer\">\n</md-icon><span translate=\"MAIL.PRINT\">Print</span></md-button></md-menu-item></md-menu-content></md-menu></div><div \nng-bind-html=\"vm.currentThread.message\"></div></div><div ng-if=\"vm.currentThread.attachments\" \nclass=\"thread-attachments\"><div class=\"title\"><span translte=\"MAIL.ATTACHMENTS\">Attachments</span>\n ({{vm.currentThread.attachments.length}})</div><div class=\"attachment-list\" layout-wrap layout=\"row\"><div \nclass=\"attachment\" layout=\"column\" ng-repeat=\"attachment in vm.currentThread.attachments\"><img class=\"preview\" \nng-src=\"{{attachment.preview}}\"><div layout=\"column\"><a href=\"#\" class=\"md-accent-color link\" translate=\"MAIL.VIEW\">\nView</a> <a href=\"#\" class=\"md-accent-color link\" translate=\"MAIL.DOWNLOAD\">Download</a><div class=\"size\">\n({{attachment.size}})</div></div></div></div></div>");
$templateCache.put("app/main/apps/mail/views/classic/list/list.html","<div class=\"no-threads\" ng-if=\"vm.threads.length === 0\">There are no messages in \'{{vm.currentFilter.filter}}\'!</div>\n<div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" ng-if=\"!vm.threads && vm.loadingThreads\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div>\nLoading your mails...</div></div><div class=\"thread {{thread.status}}\" md-ink-ripple ng-if=\"!vm.loadingThreads\" \nng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search\" ng-click=\"vm.openThread(thread)\" \nng-class=\"{\'unread\': !thread.read, \'current-thread\': vm.currentThread === thread, \'selected\': vm.isSelected(thread)}\">\n<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(thread)\" \nng-click=\"vm.toggleSelectThread(thread, $event)\" aria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"info\" flex layout=\"column\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><img \nclass=\"avatar\" ng-if=\"thread.from.avatar\" alt=\"{{thread.from.name}}\" ng-src=\"{{thread.from.avatar}}\"><div \nclass=\"avatar\" ng-if=\"!thread.from.avatar\" ms-random-class=\"vm.colors\">{{thread.from.name[0]}}</div><span \nclass=\"text-truncate\">{{thread.from.name}}</span><md-icon md-font-icon=\"icon-paperclip\" class=\"has-attachment s16\" \nng-if=\"thread.hasAttachments\"></md-icon></div><div class=\"subject text-truncate\">{{thread.subject}}</div><div \nclass=\"message text-truncate\">\n{{thread.message | htmlToPlaintext | limitTo:180}}{{thread.message.length > 180 ? \'...\' : \'\'}}<div class=\"labels\"><div \nclass=\"label\" ng-repeat=\"labelId in thread.labels\" ng-class=\"vm.getLabelColor(labelId)\">{{vm.getLabelTitle(labelId)}}\n</div></div></div></div><div layout=\"column\" layout-align=\"space-between end\"><div class=\"time\">{{thread.time}}</div>\n<div class=\"actions\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleThreadStatus(\'starred\', thread, $event)\" aria-label=\"Toggle starred\" translate \ntranslate-attr-aria-label=\"MAIL.TOGGLE_STARRED\"><md-icon ng-if=\"thread.starred\" md-font-icon=\"icon-star\" \nclass=\"amber-fg\"></md-icon><md-icon ng-if=\"!thread.starred\" md-font-icon=\"icon-star-outline\"></md-icon></md-button>\n<md-button class=\"md-icon-button\" ng-click=\"vm.toggleThreadStatus(\'important\', thread, $event)\" \naria-label=\"Toggle important\" translate translate-attr-aria-label=\"MAIL.TOGGLE_IMPORTANT\"><md-icon \nng-if=\"thread.important\" md-font-icon=\"icon-label\" class=\"amber-300-fg\"></md-icon><md-icon ng-if=\"!thread.important\" \nmd-font-icon=\"icon-label-outline\"></md-icon></md-button></div></div></div></div>");
$templateCache.put("app/main/apps/mail/views/outlook/list/list.html","<div class=\"no-threads\" ng-if=\"vm.threads.length === 0\">There are no messages in \'{{vm.currentFilter.filter}}\'!</div>\n<div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" ng-if=\"!vm.threads && vm.loadingThreads\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div>\nLoading your mails...</div></div><div class=\"thread {{thread.status}}\" md-ink-ripple ng-if=\"!vm.loadingThreads\" \nng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search\" ng-click=\"vm.openThread(thread)\" \nng-class=\"{\'unread\': !thread.read, \'current-thread\': vm.currentThread === thread, \'selected\': vm.isSelected(thread)}\">\n<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(thread)\" \nng-click=\"vm.toggleSelectThread(thread, $event)\" aria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"info\" flex layout=\"column\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><img \nclass=\"avatar\" ng-if=\"thread.from.avatar\" alt=\"{{thread.from.name}}\" ng-src=\"{{thread.from.avatar}}\"><div \nclass=\"avatar\" ng-if=\"!thread.from.avatar\" ms-random-class=\"vm.colors\">{{thread.from.name[0]}}</div><span \nclass=\"text-truncate\">{{thread.from.name}}</span><md-icon md-font-icon=\"icon-paperclip\" class=\"has-attachment s16\" \nng-if=\"thread.hasAttachments\"></md-icon></div><div class=\"subject text-truncate\">{{thread.subject}}</div><div \nclass=\"message text-truncate\">\n{{thread.message | htmlToPlaintext | limitTo:90}}{{thread.message.length > 90 ? \'...\' : \'\'}}<div class=\"labels\"><div \nclass=\"label\" ng-repeat=\"labelId in thread.labels\" ng-class=\"vm.getLabelColor(labelId)\">{{vm.getLabelTitle(labelId)}}\n</div></div></div></div><div layout=\"column\" layout-align=\"space-between end\"><div class=\"time\">{{thread.time}}</div>\n</div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.autocomplete/index.html","<div class=\"doc-content\"><h1><code>material.components.autocomplete</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.bottomSheet/index.html","<div class=\"doc-content\"><h1><code>material.components.bottomSheet</code></h1><p>BottomSheet</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.card/index.html","<div class=\"doc-content\"><h1><code>material.components.card</code></h1><p>Card components.</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.button/index.html","<div class=\"doc-content\"><h1><code>material.components.button</code></h1><p>Button</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.checkbox/index.html","<div class=\"doc-content\"><h1><code>material.components.checkbox</code></h1><p>Checkbox module!</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.colors/index.html","<div class=\"doc-content\"><h1><code>material.components.colors</code></h1><p>Define $mdColors service and a <code>\nmd-colors=&quot;&quot;</code> attribute directive</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.chips/index.html","<div class=\"doc-content\"><h1><code>material.components.chips</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.content/index.html","<div class=\"doc-content\"><h1><code>material.components.content</code></h1><p>Scrollable content</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.datepicker/index.html","<div class=\"doc-content\"><h1><code>material.components.datepicker</code></h1><p>Module for the datepicker component.\n</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.dialog/index.html","<div class=\"doc-content\"><h1><code>material.components.dialog</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.divider/index.html","<div class=\"doc-content\"><h1><code>material.components.divider</code></h1><p>Divider module!</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabActions/index.html","<div class=\"doc-content\"><h1><code>material.components.fabActions</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabSpeedDial/index.html","<div class=\"doc-content\"><h1><code>material.components.fabSpeedDial</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabToolbar/index.html","<div class=\"doc-content\"><h1><code>material.components.fabToolbar</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.gridList/index.html","<div class=\"doc-content\"><h1><code>material.components.gridList</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.menuBar/index.html","<div class=\"doc-content\"><h1><code>material.components.menuBar</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.icon/index.html","<div class=\"doc-content\"><h1><code>material.components.icon</code></h1><p>Icon</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.list/index.html","<div class=\"doc-content\"><h1><code>material.components.list</code></h1><p>List module</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.menu/index.html","<div class=\"doc-content\"><h1><code>material.components.menu</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.input/index.html","<div class=\"doc-content\"><h1><code>material.components.input</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.navBar/index.html","<div class=\"doc-content\"><h1><code>material.components.navBar</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.panel/index.html","<div class=\"doc-content\"><h1><code>material.components.panel</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.progressCircular/index.html","<div class=\"doc-content\"><h1><code>material.components.progressCircular</code></h1><p>Module for a circular progressbar\n</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.progressLinear/index.html","<div class=\"doc-content\"><h1><code>material.components.progressLinear</code></h1><p>Linear Progress module!</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.select/index.html","<div class=\"doc-content\"><h1><code>material.components.select</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.showHide/index.html","<div class=\"doc-content\"><h1><code>material.components.showHide</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.radioButton/index.html","<div class=\"doc-content\"><h1><code>material.components.radioButton</code></h1><p>radioButton module!</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sidenav/index.html","<div class=\"doc-content\"><h1><code>material.components.sidenav</code></h1><p>A Sidenav QP component.</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.slider/index.html","<div class=\"doc-content\"><h1><code>material.components.slider</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.swipe/index.html","<div class=\"doc-content\"><h1><code>material.components.swipe</code></h1><p>Swipe module!</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sticky/index.html","<div class=\"doc-content\"><h1><code>material.components.sticky</code></h1><p>Sticky effects for md</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.subheader/index.html","<div class=\"doc-content\"><h1><code>material.components.subheader</code></h1><p>SubHeader module</p><p>\nSubheaders are special list tiles that delineate distinct sections of a list or grid list and are typically related to the current filtering or sorting criteria. Subheader tiles are either displayed inline with tiles or can be associated with content, for example, in an adjacent column.\n</p><p>\nUpon scrolling, subheaders remain pinned to the top of the screen and remain pinned until pushed on or off screen by the next subheader. @see \n<a href=\"https://www.google.com/design/spec/components/subheaders.html\">Material Design Specifications</a></p>\n<blockquote><p>To improve the visual grouping of content, use the system color for your subheaders.</p></blockquote>\n</div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.switch/index.html","<div class=\"doc-content\"><h1><code>material.components.switch</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.tabs/index.html","<div class=\"doc-content\"><h1><code>material.components.tabs</code></h1><p>Tabs, created with the <code>&lt;md-tabs&gt;\n</code> directive provide <em>tabbed</em>\n navigation with different styles. The Tabs component consists of clickable tabs that are aligned horizontally side-by-side.\n</p><p>Features include support for:</p><ul><li>static or dynamic tabs,</li><li>responsive designs,</li><li>\naccessibility support (ARIA),</li><li>tab pagination,</li><li>external or internal tab content,</li><li>\nfocus indicators and arrow-key navigations,</li><li>programmatic lookup and access to tab controllers, and</li><li>\ndynamic transitions through different tab contents.</li></ul></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.toast/index.html","<div class=\"doc-content\"><h1><code>material.components.toast</code></h1><p>Toast</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.tooltip/index.html","<div class=\"doc-content\"><h1><code>material.components.tooltip</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.toolbar/index.html","<div class=\"doc-content\"><h1><code>material.components.toolbar</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.truncate/index.html","<div class=\"doc-content\"><h1><code>material.components.truncate</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.virtualRepeat/index.html","<div class=\"doc-content\"><h1><code>material.components.virtualRepeat</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.whiteframe/index.html","<div class=\"doc-content\"><h1><code>material.components.whiteframe</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.aria/index.html","<div class=\"doc-content\"><h1><code>material.core.aria</code></h1><p>\nAria Expectations for AngularJS Material components.</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.compiler/index.html","<div class=\"doc-content\"><h1><code>material.core.compiler</code></h1><p>\nAngularJS Material template and element compiler.</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.colorUtil/index.html","<div class=\"doc-content\"><h1><code>material.core.colorUtil</code></h1><p>Color Util</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.liveannouncer/index.html","<div class=\"doc-content\"><h1><code>material.core.liveannouncer</code></h1><p>\nAngularJS Material Live Announcer to provide accessibility for Voice Readers.</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.componentRegistry/index.html","<div class=\"doc-content\"><h1><code>material.core.componentRegistry</code></h1><p>\nA component instance registration service. Note: currently this as a private service in the SideNav component.</p>\n</div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.interaction/index.html","<div class=\"doc-content\"><h1><code>material.core.interaction</code></h1><p>\nUser interaction detection to provide proper accessibility.</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.ripple/index.html","<div class=\"doc-content\"><h1><code>material.core.ripple</code></h1><p>Ripple</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.theming/index.html","<div class=\"doc-content\"><h1><code>material.core.theming</code></h1><p>Theming</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.util/index.html","<div class=\"doc-content\"><h1><code>material.core.util</code></h1><p>Util</p></div>");
$templateCache.put("app/main/apps/chat/sidenavs/right/views/contact/contact-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div \ntranslate=\"CHAT.CONTACT_INFO\">Contact Info</div><div flex></div><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'right-sidenav\')\" aria-label=\"back\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" flex layout=\"column\" \nlayout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{vm.contacts.getById(vm.chatContactId).avatar}}\" class=\"md-avatar avatar contact-avatar huge\" \nalt=\"{{vm.contacts.getById(vm.chatContactId).name}}\"><div class=\"contact-name\">\n{{vm.contacts.getById(vm.chatContactId).name}}</div></div></div></md-toolbar><md-content class=\"md-hue-2\" flex \nms-scroll ms-padding><md-card><md-card-title translate=\"CHAT.MOOD\">Mood</md-card-title><md-card-content><span \nclass=\"mood\" ng-if=\"vm.contacts.getById(vm.chatContactId).mood\">{{vm.contacts.getById(vm.chatContactId).mood}}</span>\n</md-card-content></md-card></md-content>");
$templateCache.put("app/main/apps/chat/sidenavs/left/views/user/user-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleLeftSidenavView(false)\" aria-label=\"back\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{vm.user.avatar}}\" class=\"md-avatar avatar user-avatar huge\" alt=\"{{vm.user.name}}\"><div class=\"user-name\">\n{{vm.user.name}}</div></div></div></md-toolbar><md-content class=\"md-hue-2\" flex ms-scroll ms-padding><md-card>\n<md-card-title>Mood</md-card-title><md-card-content><span class=\"mood\" editable-textarea=\"vm.user.mood\" e-rows=\"7\" \ne-cols=\"40\">{{vm.user.mood || \'CHAT.ENTER_MOOD_MESSAGE\' | translate}}</span></md-card-content></md-card></md-content>");
$templateCache.put("app/main/apps/chat/sidenavs/left/views/contacts/contacts-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleLeftSidenavView(false)\" aria-label=\"back button\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><h3><span translate=\"CHAT.CONTACTS\">CONTACTS</span></h3></div><div\n class=\"md-toolbar-tools md-toolbar-tools-bottom\"><div class=\"search-wrapper md-whiteframe-1dp\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex ng-model=\"vm.contactSearch\" type=\"text\" \nplaceholder=\"Search contact\" translate=\"\" translate-attr-placeholder=\"CHAT.CONTACTS_SEARCH_PLACEHOLDER\"></div></div>\n</div></md-toolbar><md-content flex ms-scroll><md-list class=\"contact-list\"><md-list-item class=\"contact md-3-line\" \nng-repeat=\"contact in vm.contacts  | filter: {name: vm.contactSearch} | orderBy: \'name\' :false | filter:query as filteredContact\" \nng-style=\"{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': filteredContact.length - $index}\" \nng-click=\"vm.getChat(contact.id)\"><div class=\"fist-letter md-accent-fg\" \nng-if=\"vm.contacts[$index].name.charAt(0) !== vm.contacts[$index-1].name.charAt(0)\">{{contact.name.charAt(0)}}</div>\n<div class=\"avatar-wrapper\"><img ng-src=\"{{contact.avatar}}\" class=\"md-avatar avatar\" alt=\"{{contact.name}}\"> <i \nclass=\"icon icon- s16 status\" ng-class=\"contact.status\"></i></div><div class=\"md-list-item-text\"><h3>{{contact.name}}\n</h3><p class=\"mood\">{{contact.mood}}</p></div></md-list-item></md-list><div ng-if=\"filteredContact.length <= 0\" \nclass=\"no-results-message\" translate=\"CHAT.NO_RESULTS\">No results..</div></md-content>");
$templateCache.put("app/main/apps/chat/sidenavs/left/views/chats/chats-view.html","<md-toolbar class=\"md-tall\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div class=\"avatar-wrapper\"><img \nng-click=\"vm.toggleLeftSidenavView(\'user\')\" ng-src=\"{{vm.user.avatar}}\" class=\"md-avatar avatar\" \nalt=\"{{vm.user.name}}\"><md-menu id=\"user-status-menu\"><i ng-click=\"$mdMenu.open()\" class=\"icon icon- s16 status\" \nng-class=\"vm.user.status\"></i><md-menu-content><md-menu-item><md-button ng-click=\"vm.setUserStatus(\'online\')\"><div \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon s16 status icon-checkbox-marked-circle mr-8 green-fg\"></i> \n<span translate=\"CHAT.STATUS_ONLINE\">Online</span></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setUserStatus(\'away\')\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon s16 status icon-clock mr-8 yellow-fg\"></i> <span translate=\"CHAT.STATUS_AWAY\">Away</span></div></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.setUserStatus(\'do-not-disturb\')\"><div layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon s16 status icon-minus-circle mr-8 red-fg\"></i> <span \ntranslate=\"CHAT.STATUS_DO_NOT_DISTURB\">Do not disturb</span></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setUserStatus(\'offline\')\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon s16 status icon-checkbox-blank-circle-outline mr-8 green-fg\"></i> <span translate=\"CHAT.STATUS_OFFLINE\">\nOffline</span></div></md-button></md-menu-item></md-menu-content></md-menu></div><md-menu \nmd-position-mode=\"target-right target\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open()\" aria-label=\"more\">\n<md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.toggleLeftSidenavView(\'user\')\" translate=\"CHAT.PROFILE\">Profile</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"\" translate=\"CHAT.LOGOUT\">Logout</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-bottom\"><div class=\"search-wrapper md-whiteframe-1dp\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex ng-model=\"vm.chatSearch\" type=\"text\" \nplaceholder=\"Search or start new chat\" translate=\"\" translate-attr-placeholder=\"CHAT.CHAT_SEARCH_PLACEHOLDER\"></div>\n</div></div></md-toolbar><md-content flex ms-scroll><md-list class=\"chat-list\"><div \nng-show=\"vm.chatSearch && filteredChat.length > 0\" class=\"md-accent-fg subheader\" \nng-style=\"{\'transform\':\'translate3d(0px, 0px, 0px)\', \'z-index\': filteredChat.length + filteredContact.length }\" \ntranslate=\"CHAT.CHATS\">CHATS</div><md-list-item class=\"contact md-3-line\" \nng-style=\"{\'transform\': ( vm.chatSearch && filteredChat.length > 0 ) ?\'translate3d(0px, \'+($index + 1)* 100+\'%, 0px)\': \'translate3d(0px, \'+$index* 100+\'%, 0px)\', \'z-index\': filteredChat.length + filteredContact.length - $index}\" \nng-repeat=\"contact in vm.contacts  | filter: { lastMessage:{}} | filter: {name: vm.chatSearch}  |  orderBy: \'lastMessage.time\' :true | filter:query as filteredChat\" \nng-click=\"vm.getChat(contact.id)\" ng-class=\"{\'unread\':contact.unread}\"><div class=\"avatar-wrapper\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar avatar\" alt=\"{{contact.name}}\"> <i class=\"icon icon- s16 status\" \nng-class=\"contact.status\"></i></div><div class=\"md-list-item-text\"><h3 class=\"name\">{{contact.name}}</h3><p \nclass=\"last-message text-truncate\">{{contact.lastMessage.message}}</p></div><div layout=\"column\" \nlayout-align=\"center end\"><div class=\"last-message-time\">{{contact.lastMessage.time | altDate}}</div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div></div><md-divider>\n</md-divider></md-list-item></md-list><md-list class=\"contact-list\"><div \nng-show=\"vm.chatSearch && filteredContact.length > 0\" class=\"md-accent-fg subheader\" \nng-style=\"{\'transform\': (filteredContact.length > 0 && filteredChat.length > 0 ) ? \'translate3d(0px, \'+(filteredChat.length +1) * 100+\'%, 0px)\':\'translate3d(0px, 0px, 0px)\', \'z-index\': filteredContact.length}\" \ntranslate=\"CHAT.CONTACTS\">CONTACTS</div><md-list-item class=\"contact md-3-line\" ng-show=\"vm.chatSearch\" \nng-style=\"{\'transform\': (filteredContact.length > 0 && filteredChat.length > 0 ) ?\'translate3d(0px, \'+(filteredChat.length + $index +2)* 100+\'%, 0px)\': \'translate3d(0px, \'+ ($index + 1)* 100+\'%, 0px)\', \'z-index\': filteredContact.length - $index}\" \nng-repeat=\"contact in vm.contacts  | filter: { lastMessage:null} | filter: {name: vm.chatSearch} | orderBy: \'name\' :false | filter:query as filteredContact\" \nng-click=\"vm.getChat(contact.id)\"><div class=\"avatar-wrapper\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar avatar\" alt=\"{{contact.name}}\"> <i class=\"icon icon- s16 status\" ng-class=\"contact.status\"></i></div>\n<div class=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"mood\">{{contact.mood}}</p></div><md-divider>\n</md-divider></md-list-item></md-list><div ng-hide=\"(filteredChat.length + filteredContact.length) > 0\" \nclass=\"no-results-message\" translate=\"CHAT.NO_RESULTS\">No results..</div></md-content><md-button \nclass=\"md-fab contacts-button\" ng-click=\"vm.toggleLeftSidenavView(\'contacts\')\" aria-label=\"contacts button\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/settings/menus/color/color-menu.html","<div class=\"header md-whiteframe-2dp\"><md-list><md-list-item class=\"selected-color\"><p class=\"title\" flex>\nSelected Color:</p><div ng-if=\"!vm.board.settings.color\" class=\"preview md-background-bg md-hue-1\"></div><div \nng-if=\"vm.board.settings.color\" class=\"preview\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\">\n{{vm.board.settings.color}}</div><md-button class=\"md-icon-button\" ng-click=\"vm.board.settings.color = \'\'\" \naria-label=\"Default Color\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon></md-button></md-list-item></md-list>\n</div><div flex class=\"content\" ms-scroll ms-sidenav-helper><md-list><md-list-item class=\"color\" \nng-repeat=\"(paletteName, palette) in vm.palettes\" ng-click=\"vm.board.settings.color = paletteName\" \nng-class=\"\'md-\'+paletteName+\'-bg\'\" aria-label=\"color select\"><p flex>{{paletteName}}</p><i class=\"icon-check s16\" \nng-if=\"paletteName === vm.board.settings.color\"></i></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/settings/menus/members/members-menu.html","<md-list><md-subheader class=\"md-no-sticky\">Add New Member</md-subheader><md-list-item class=\"add-new-member\"><form \nng-submit=\"vm.newMember()\" layout=\"row\" layout-align=\"start center\"><input flex placeholder=\"Type Member Name\" \ntype=\"text\" ng-model=\"vm.newMemberSearchInput\"><md-button type=\"submit\" class=\"md-accent md-raised\" \naria-label=\"Add New Member\">Add</md-button></form></md-list-item><md-divider></md-divider><md-list-item class=\"member\" \nng-repeat=\"member in vm.board.members\"><img alt=\"{{ member.name }}\" ng-src=\"{{ member.avatar }}\" class=\"md-avatar\"><p \nclass=\"member-name\">{{ member.name }}</p><md-button ng-click=\"vm.removeMember($event, member.id);\" \nclass=\"remove-button md-icon-button\" aria-label=\"remove\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button>\n</md-list-item></md-list>");
$templateCache.put("app/main/apps/scrumboard/sidenavs/settings/menus/labels/labels-menu.html","<md-list><md-subheader class=\"md-no-sticky\">Add New Label</md-subheader><md-list-item class=\"label\"><div layout=\"row\" \nlayout-align=\"start center\"><md-menu md-offset=\"0 52px\"><md-button class=\"md-icon-button label-color-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"label color\"><md-icon md-font-icon=\"icon-label\" \nng-class=\"vm.newLabelColor+\'-fg\'\" class=\"label-icon\"></md-icon></md-button><md-menu-content \nclass=\"labels-settings-menu-content\" width=\"3\"><div class=\"new-label-color-pick\" layout=\"row\" layout-wrap><label \nclass=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" \nlayout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.newLabelColor\" ng-value=\"palette\" \naria-label=\"{{palette}}\" ng-click=\"$mdMenu.hide()\"> <i class=\"icon-check s18\" ng-if=\"label.color === palette\"></i>\n</label></div></md-menu-content></md-menu><span editable-text=\"vm.newLabelName\" e-form=\"newLabelForm\" \nonaftersave=\"vm.addNewLabel()\"></span><p flex class=\"title new-label-form-button\" ng-click=\"newLabelForm.$show()\" \nng-hide=\"newLabelForm.$visible\">Enter New Label Name</p></div></md-list-item><md-divider></md-divider><md-list-item \nclass=\"label\" ng-repeat=\"label in vm.board.labels\"><div layout=\"row\" layout-align=\"start center\" flex><md-menu \nmd-offset=\"0 52px\"><md-button class=\"md-icon-button label-color-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"label color\"><md-icon md-font-icon=\"icon-label\" ng-class=\"label.color+\'-fg\'\" class=\"label-icon\"></md-icon>\n</md-button><md-menu-content class=\"labels-settings-menu-content\" width=\"3\"><div class=\"new-label-color-pick\" \nlayout=\"row\" layout-wrap><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" \nlayout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"label.color\" ng-value=\"palette\" \naria-label=\"{{palette}}\" ng-click=\"$mdMenu.hide()\"> <i class=\"icon-check s18\" ng-if=\"label.color === palette\"></i>\n</label></div></md-menu-content></md-menu><p flex class=\"title\" editable-text=\"label.name\">{{label.name}}</p><md-button\n ng-click=\"vm.removeLabel($event, label.id);\" class=\"remove-button md-icon-button\" aria-label=\"remove\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></md-list-item></md-list>");
$templateCache.put("app/main/apps/scrumboard/views/calendar/sidenavs/scheduled-tasks/scheduled-tasks-sidenav.html","<div class=\"md-title sidenav-title\">Scheduled Cards</div><div class=\"cards\"><div ng-if=\"vm.cards.length <= 0\"><span \ntranslate=\"SB.NO_SCHEDULED_CARD\">There is no scheduled card.</span></div><div class=\"card\" layout=\"row\" \nng-repeat=\"card in vm.cards\"><md-button class=\"md-raised card-date\" ng-click=\"vm.goToDate(card.start)\"><div \nclass=\"day-in-week\">{{card.due | date:\'EEEE\'}}</div><div class=\"day\">{{card.due | date:\'d\' }}</div><div \nclass=\"month-year\">{{card.due | date:\'MMM yyyy\'}}</div></md-button><div class=\"card-title\" flex layout=\"column\" \nlayout-align=\"center start\" ng-click=\"vm.openCardDialog($event, card.idCard)\"><span>{{card.title}}</span></div></div>\n</div>");
$templateCache.put("app/main/apps/scrumboard/views/calendar/dialogs/event/event-dialog.html","<md-dialog class=\"event-calendar-dialog\" aria-label=\"Event Dialog\" ng-cloak><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">\n{{vm.dueDate | date:\'mediumDate\':\'UTC\'}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"close dialog\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-tabs md-dynamic-height><md-tab><md-tab-label>\n<span translate=\"SB.ADD_A_CARD\">Add a card</span></md-tab-label><md-tab-body><div class=\"new-card\" layout=\"column\">\n<form name=\"newCardForm\" novalidate><md-input-container class=\"new-card-name md-block\" md-no-float><input name=\"name\" \nng-model=\"vm.newCard.name\" placeholder=\"Card name\" required><div ng-messages=\"newCardForm.name.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"SB.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div>\n</md-input-container><div class=\"lists\"><p>Select a list:</p><md-radio-group ng-model=\"vm.newCard.listId\" required>\n<md-radio-button ng-repeat=\"list in vm.board.lists\" ng-value=\"list.id\">{{list.name}}</md-radio-button></md-radio-group>\n</div><md-dialog-actions><md-button class=\"md-accent md-raised\" ng-click=\"vm.addNewCard()\" \nng-disabled=\"newCardForm.$invalid || newCardForm.$pristine\">Add</md-button></md-dialog-actions></form></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"SB.ASSIGN_THE_DATE_TO_CARDS\">Assign the date to cards\n</span></md-tab-label><md-tab-body><div class=\"assign-due-date\"><md-list class=\"cards\"><md-content \nclass=\"cards-content\" flex ms-scroll><md-list-item class=\"card\" ng-repeat=\"card in vm.board.cards\" \nng-click=\"vm.toggleInArray(card.id, vm.selectedCards)\" aria-label=\"card\"><p layout=\"column\" layout-align=\"start start\">\n<span class=\"card-name\">{{card.name}}</span> <span ng-if=\"card.due\" class=\"card-date\">{{card.due | date}}</span></p>\n<md-checkbox ng-checked=\"vm.exists(card.id, vm.selectedCards)\" ng-click=\"vm.toggleInArray(card.id, vm.selectedCards)\" \nclass=\"md-secondary\" aria-label=\"card\"></md-checkbox></md-list-item></md-content></md-list><md-dialog-actions>\n<md-button ng-disabled=\"!vm.selectedCards[0]\" ng-click=\"vm.assignDueDate()\" class=\"md-accent md-raised\">Assign\n</md-button></md-dialog-actions></div></md-tab-body></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.autocomplete/directive/mdAutocomplete.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>&lt;md-autocomplete&gt;</code>\n is a special input component with a drop-down of all possible matches to a custom query. This component allows you to provide real-time suggestions as the user types in the input area.\n</p><p>\nTo start, you will need to specify the required parameters and provide a template for your results. The content inside \n<code>md-autocomplete</code> will be treated as a template.</p><p>\nIn more complex cases, you may want to include other content such as a message to display when no matches were found. You can do this by wrapping your template in \n<code>md-item-template</code> and adding a tag for <code>md-not-found</code>. An example of this is shown below.</p><p>\nTo reset the displayed value you must clear both values for <code>md-search-text</code> and <code>md-selected-item\n</code>.</p><h3 id=\"validation\">Validation</h3><p>You can use <code>ng-messages</code>\n to include validation the same way that you would normally validate; however, if you want to replicate a standard input with a floating label, you will have to do the following:\n</p><ul><li>Make sure that your template is wrapped in <code>md-item-template</code></li><li>Add your <code>ng-messages\n</code> code inside of <code>md-autocomplete</code></li><li>Add your validation properties to <code>md-autocomplete\n</code> (ie. <code>required</code>)</li><li>Add a <code>name</code> to <code>md-autocomplete</code>\n (to be used on the generated <code>input</code>)</li></ul><p>There is an example below of how this should look.</p><h3\n id=\"snapping-drop-down\">Snapping Drop-Down</h3><p>\nYou can cause the autocomplete drop-down to snap to an ancestor element by applying the <code>md-autocomplete-snap\n</code> attribute to that element. You can also snap to the width of the <code>md-autocomplete-snap</code>\n element by setting the attribute&#39;s value to <code>width</code> (ie. <code>md-autocomplete-snap=&quot;width&quot;\n</code>).</p><h3 id=\"notes\">Notes</h3><p><strong>Autocomplete Dropdown Items Rendering</strong></p><p>The <code>\nmd-autocomplete</code> uses the the <a ng-href=\"api/directive/mdVirtualRepeatContainer\">VirtualRepeat</a>\n directive for displaying the results inside of the dropdown.<br></p><blockquote><p>\nWhen encountering issues regarding the item template please take a look at the <a \nng-href=\"api/directive/mdVirtualRepeatContainer\">VirtualRepeatContainer</a> documentation.</p></blockquote><p><strong>\nAutocomplete inside of a Virtual Repeat</strong></p><p>When using the <code>md-autocomplete</code>\n directive inside of a <a ng-href=\"api/directive/mdVirtualRepeatContainer\">VirtualRepeatContainer</a>\n the dropdown items might not update properly, because caching of the results is enabled by default.</p><p>\nThe autocomplete will then show invalid dropdown items, because the VirtualRepeat only updates the scope bindings, rather than re-creating the \n<code>md-autocomplete</code> and the previous cached results will be used.</p><blockquote><p>\nTo avoid such problems ensure that the autocomplete does not cache any results.</p></blockquote><hljs lang=\"html\">\n<md-autocomplete md-no-cache=\"true\" md-selected-item=\"selectedItem\" md-items=\"item in items\" \nmd-search-text=\"searchText\" md-item-text=\"item.display\"><span>{{ item.display }}</span></md-autocomplete></hljs></div>\n<div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><h3 id=\"basic-example\">Basic Example</h3><hljs lang=\"html\">\n<md-autocomplete md-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-items=\"item in getMatches(searchText)\" \nmd-item-text=\"item.display\"><span md-highlight-text=\"searchText\">{{item.display}}</span></md-autocomplete></hljs><h3 \nid=\"example-with-not-found-message\">Example with &quot;not found&quot; message</h3><hljs lang=\"html\"><md-autocomplete \nmd-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-items=\"item in getMatches(searchText)\" \nmd-item-text=\"item.display\"><md-item-template><span md-highlight-text=\"searchText\">{{item.display}}</span>\n</md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></hljs><p>\nIn this example, our code utilizes <code>md-item-template</code> and <code>md-not-found</code>\n to specify the different parts that make up our component.</p><h3 id=\"clear-button-for-the-input\">\nClear button for the input</h3><p>\nBy default, for floating label autocomplete&#39;s the clear button is not showing up (<a \nhref=\"https://material.google.com/components/text-fields.html#text-fields-auto-complete-text-field\">See specs</a>)</p>\n<p>Nevertheless, developers are able to explicitly toggle the clear button for all types of autocomplete&#39;s.</p>\n<hljs lang=\"html\"><md-autocomplete ... md-clear-button=\"true\"></md-autocomplete><md-autocomplete ... \nmd-clear-button=\"false\"></md-autocomplete></hljs><h3 id=\"example-with-validation\">Example with validation</h3><hljs \nlang=\"html\"><form name=\"autocompleteForm\"><md-autocomplete required md-input-name=\"autocomplete\" \nmd-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-items=\"item in getMatches(searchText)\" \nmd-item-text=\"item.display\"><md-item-template><span md-highlight-text=\"searchText\">{{item.display}}</span>\n</md-item-template><div ng-messages=\"autocompleteForm.autocomplete.$error\"><div ng-message=\"required\">\nThis field is required</div></div></md-autocomplete></form></hljs><p>In this example, our code utilizes <code>\nmd-item-template</code> and <code>ng-messages</code> to specify input validation for the field.</p><h3 \nid=\"asynchronous-results\">Asynchronous Results</h3><p>\nThe autocomplete items expression also supports promises, which will resolve with the query results.</p><hljs \nlang=\"js\">\nfunction AppController($scope, $http) { $scope.query = function(searchText) { return $http .get(BACKEND_URL + &#39;/items/&#39; + searchText) .then(function(data) { // Map the response object to the data object. return data; }); }; }\n</hljs><hljs lang=\"html\"><md-autocomplete md-selected-item=\"selectedItem\" md-search-text=\"searchText\" \nmd-items=\"item in query(searchText)\"><md-item-template><span md-highlight-text=\"searchText\">{{item}}</span>\n</md-item-template></md-autocomplete></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-items</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nAn expression in the format of <code>item in results</code> to iterate over matches for your search.<br><br>The <code>\nresults</code>\n expression can be also a function, which returns the results synchronously or asynchronously (per Promise)</p></td>\n</tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-selected-item-change <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nAn expression to be run each time a new item is selected</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-search-text-change <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nAn expression to be run each time the search text updates</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-search-text <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nA model to bind the search query text to</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">\nmd-selected-item <span hide show-sm><code class=\"api-type label type-hint type-hint-object\">object</code></span></td>\n<td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td \nclass=\"description\"><p>A model to bind the selected item to</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-item-text <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nAn expression that will convert your object to a single string.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">placeholder <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>Placeholder text that will be forwarded to the input.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-no-cache <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nDisables the internal caching that happens in autocomplete</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">ng-disabled <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></td><td class=\"description\"><p>Determines whether or not to disable the input field</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-require-match <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen set to true, the autocomplete will add a validator, which will evaluate to false, when no item is currently selected.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-min-length <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nSpecifies the minimum length of text before autocomplete will make suggestions</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-delay <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nSpecifies the amount of time (in milliseconds) to wait before looking for results</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-clear-button <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhether the clear button for the autocomplete input should show up or not.</p></td></tr><tr class=\"api-params-item\"><td\n style=\"white-space: nowrap\">md-autofocus <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></td><td class=\"description\"><p>If true, the autocomplete will be automatically focused when a <code>\n$mdDialog</code>, <code>$mdBottomsheet</code> or <code>$mdSidenav</code>, which contains the autocomplete, is opening.\n<br><br>Also the autocomplete will immediately focus the input element.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-no-asterisk <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></td><td class=\"description\"><p>When present, asterisk will not be appended to the floating label</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-autoselect <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nIf set to true, the first item will be automatically selected in the dropdown upon open.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-menu-class <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThis will be applied to the dropdown menu for styling</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-floating-label <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThis will add a floating label to autocomplete and wrap it in <code>md-input-container</code></p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-input-name <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThe name attribute given to the input element to be used with FormController</p></td></tr><tr class=\"api-params-item\">\n<td style=\"white-space: nowrap\">md-select-on-focus <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nWhen present the inputs text will be automatically selected on focus.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-input-id <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>An ID to be added to the input element</p></td></tr><tr class=\"api-params-item\">\n<td style=\"white-space: nowrap\">md-input-minlength <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nThe minimum length for the input&#39;s value for validation</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-input-maxlength <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nThe maximum length for the input&#39;s value for validation</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-select-on-match <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen set, autocomplete will automatically select exact the item if the search text is an exact match.<br><br>\nExact match means that there is only one match showing up.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-match-case-insensitive <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When set and using \n<code>md-select-on-match</code>, autocomplete will select on case-insensitive match</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-escape-options <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nOverride escape key logic. Default is <code>blur clear</code>.<br>Options: <code>blur | clear</code>, <code>none</code>\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-dropdown-items <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nSpecifies the maximum amount of items to be shown in the dropdown.<br><br>\nWhen the dropdown doesn&#39;t fit into the viewport, the dropdown will shrink as less as possible.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-dropdown-position <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nOverrides the default dropdown position. Options: <code>top</code>, <code>bottom</code>.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">ng-trim <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nIf set to false, the search text will be not trimmed automatically. Defaults to true.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">ng-pattern <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nAdds the pattern validator to the ngModel of the search text. <a \nhref=\"https://docs.angularjs.org/api/ng/directive/ngPattern\">ngPattern Directive</a></p></td></tr></tbody></table>\n</div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.autocomplete/directive/mdHighlightText.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>md-highlight-text</code>\n directive allows you to specify text that should be highlighted within an element. Highlighted text will be wrapped in \n<code>&lt;span class=&quot;highlight&quot;&gt;&lt;/span&gt;</code>\n which can be styled through CSS. Please note that child elements may not be used with this directive.</p></div><div>\n<section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><input placeholder=\"Enter a search term...\" \nng-model=\"searchTerm\" type=\"text\"><ul><li ng-repeat=\"result in results\" md-highlight-text=\"searchTerm\">{{result.text}}\n</li></ul></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-highlight-text</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nA model to be searched for</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-highlight-flags \n<span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>A list of flags (loosely based on JavaScript RexExp flags).</p><h4 id=\"-supported-flags-\">\n<strong>Supported flags</strong>:</h4><ul><li><code>g</code>: Find all matches within the provided text</li><li><code>i\n</code>: Ignore case when searching for matches</li><li><code>$</code>\n: Only match if the text ends with the search term</li><li><code>^</code>\n: Only match if the text begins with the search term</li></ul></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.card/directive/mdCard.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-card&gt;</code> directive is a container element used within <code>\n&lt;md-content&gt;</code> containers.</p><p>\nAn image included as a direct descendant will fill the card&#39;s width. If you want to avoid this, you can add the \n<code>md-image-no-fill</code> class to the parent element. The <code>&lt;md-card-content&gt;</code>\n container will wrap text content and provide padding. An <code>&lt;md-card-footer&gt;</code>\n element can be optionally included to put content flush against the bottom edge of the card.</p><p>\nAction buttons can be included in an <code>&lt;md-card-actions&gt;</code> element, similar to <code>\n&lt;md-dialog-actions&gt;</code>. You can then position buttons using layout attributes.</p><p>Card is built with:</p>\n<ul><li><code>&lt;md-card-header&gt;</code> - Header for the card, holds avatar, text and squared image<ul><li><code>\n&lt;md-card-avatar&gt;</code> - Card avatar<ul><li><code>md-user-avatar</code> - Class for user image</li><li><code>\n&lt;md-icon&gt;</code></li></ul></li><li><code>&lt;md-card-header-text&gt;</code>\n - Contains elements for the card description<ul><li><code>md-title</code> - Class for the card title</li><li><code>\nmd-subhead</code> - Class for the card sub header</li></ul></li></ul></li><li><code>&lt;img&gt;</code>\n - Image for the card</li><li><code>&lt;md-card-title&gt;</code> - Card content title<ul><li><code>\n&lt;md-card-title-text&gt;</code><ul><li><code>md-headline</code> - Class for the card content title</li><li><code>\nmd-subhead</code> - Class for the card content sub header</li></ul></li><li><code>&lt;md-card-title-media&gt;</code>\n - Squared image within the title<ul><li><code>md-media-sm</code> - Class for small image</li><li><code>md-media-md\n</code> - Class for medium image</li><li><code>md-media-lg</code> - Class for large image</li><li><code>md-media-xl\n</code> - Class for extra large image</li></ul></li></ul></li><li><code>&lt;md-card-content&gt;</code> - Card content\n</li><li><code>&lt;md-card-actions&gt;</code> - Card actions<ul><li><code>&lt;md-card-icon-actions&gt;</code>\n - Icon actions</li></ul></li></ul><p>\nCards have constant width and variable heights; where the maximum height is limited to what can fit within a single view on a platform, but it can temporarily expand as needed.\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><h3 id=\"card-with-optional-footer\">\nCard with optional footer</h3><hljs lang=\"html\"><md-card><img src=\"card-image.png\" class=\"md-card-image\" \nalt=\"image caption\"><md-card-content><h2>Card headline</h2><p>Card content</p></md-card-content><md-card-footer>\nCard footer</md-card-footer></md-card></hljs><h3 id=\"card-with-actions\">Card with actions</h3><hljs lang=\"html\">\n<md-card><img src=\"card-image.png\" class=\"md-card-image\" alt=\"image caption\"><md-card-content><h2>Card headline</h2><p>\nCard content</p></md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button>Action 1\n</md-button><md-button>Action 2</md-button></md-card-actions></md-card></hljs><h3 \nid=\"card-with-header-image-title-actions-and-content\">Card with header, image, title actions and content</h3><hljs \nlang=\"html\"><md-card><md-card-header><md-card-avatar><img class=\"md-user-avatar\" src=\"avatar.png\"></md-card-avatar>\n<md-card-header-text><span class=\"md-title\">Title</span> <span class=\"md-subhead\">Sub header</span>\n</md-card-header-text></md-card-header><img ng-src=\"card-image.png\" class=\"md-card-image\" alt=\"image caption\">\n<md-card-title><md-card-title-text><span class=\"md-headline\">Card headline</span> <span class=\"md-subhead\">\nCard subheader</span></md-card-title-text></md-card-title><md-card-actions layout=\"row\" layout-align=\"start center\">\n<md-button>Action 1</md-button><md-button>Action 2</md-button><md-card-icon-actions><md-button class=\"md-icon-button\" \naria-label=\"icon\"><md-icon md-svg-icon=\"icon\"></md-icon></md-button></md-card-icon-actions></md-card-actions>\n<md-card-content><p>Card content</p></md-card-content></md-card></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.bottomSheet/service/$mdBottomSheet.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>$mdBottomSheet</code>\n opens a bottom sheet over the app and provides a simple promise API.</p><h2 id=\"restrictions\">Restrictions</h2><ul>\n<li>The bottom sheet&#39;s template must have an outer <code>&lt;md-bottom-sheet&gt;</code> element.</li><li>Add the \n<code>md-grid</code> class to the bottom sheet for a grid layout.</li><li>Add the <code>md-list</code>\n class to the bottom sheet for a list layout.</li></ul></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage\n</h2><hljs lang=\"html\"><div ng-controller=\"MyController\"><md-button ng-click=\"openBottomSheet()\">Open a Bottom Sheet!\n</md-button></div></hljs><hljs lang=\"js\">\nvar app = angular.module(&#39;app&#39;, [&#39;ngMaterial&#39;]); app.controller(&#39;MyController&#39;, function($scope, $mdBottomSheet) { $scope.openBottomSheet = function() { $mdBottomSheet.show({ template: &#39;\n<md-bottom-sheet>&#39; + &#39;Hello!<md-button ng-click=\"closeBottomSheet()\">Close</md-button>&#39; + &#39;\n</md-bottom-sheet>\n&#39; }) // Fires when the hide() method is used .then(function() { console.log(&#39;You clicked the button to close the bottom sheet!&#39;); }) // Fires when the cancel() method is used .catch(function() { console.log(&#39;You hit escape or clicked the backdrop to close.&#39;); }); }; $scope.closeBottomSheet = function($scope, $mdBottomSheet) { $mdBottomSheet.hide(); } });\n</hljs></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"show\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdBottomSheet.show(options);</code></h3><div \nclass=\"service-desc\"><p>Show a bottom sheet with the specified options.</p><p><em><b>Note:</b> You should <b>always</b>\n provide a <code>.catch()</code> method in case the user hits the <code>esc</code>\n key or clicks the background to close. In this case, the <code>cancel()</code>\n method will automatically be called on the bottom sheet which will <code>reject()</code>\n the promise. See the @usage section above for an example.</em></p><p>Newer versions of Angular will throw a <code>\nPossibly unhandled rejection</code> exception if you forget this.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* options</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>\nAn options object, with the following properties:</p><ul><li><code>templateUrl</code> - <code>{string=}</code>\n: The url of an html template file that will be used as the content of the bottom sheet. Restrictions: the template must have an outer \n<code>md-bottom-sheet</code> element.</li><li><code>template</code> - <code>{string=}</code>\n: Same as templateUrl, except this is an actual template string.</li><li><code>scope</code> - <code>{object=}</code>\n: the scope to link the template / controller to. If none is specified, it will create a new child scope. This scope will be destroyed when the bottom sheet is removed unless \n<code>preserveScope</code> is set to true.</li><li><code>preserveScope</code> - <code>{boolean=}</code>\n: whether to preserve the scope when the element is removed. Default is false</li><li><code>controller</code> - <code>\n{string=}</code>: The controller to associate with this bottom sheet.</li><li><code>locals</code> - <code>{string=}\n</code>\n: An object containing key/value pairs. The keys will be used as names of values to inject into the controller. For example, \n<code>locals: {three: 3}</code> would inject <code>three</code> into the controller with the value of 3.</li><li><code>\nclickOutsideToClose</code> - <code>{boolean=}</code>\n: Whether the user can click outside the bottom sheet to close it. Default true.</li><li><code>bindToController</code>\n - <code>{boolean=}</code>: When set to true, the locals will be bound to the controller instance.</li><li><code>\ndisableBackdrop</code> - <code>{boolean=}</code>: When set to true, the bottomsheet will not show a backdrop.</li><li>\n<code>escapeToClose</code> - <code>{boolean=}</code>\n: Whether the user can press escape to close the bottom sheet. Default true.</li><li><code>resolve</code> - <code>\n{object=}</code>\n: Similar to locals, except it takes promises as values and the bottom sheet will not open until the promises resolve.\n</li><li><code>controllerAs</code> - <code>{string=}</code>: An alias to assign the controller to on the scope.</li>\n<li><code>parent</code> - <code>{element=}</code>: The element to append the bottom sheet to. The <code>parent</code>\n may be a <code>function</code>, <code>string</code>, <code>object</code>\n, or null. Defaults to appending to the body of the root element (or the root element) of the application. e.g. angular.element(document.getElementById(&#39;content&#39;)) or &quot;#content&quot;\n</li><li><code>disableParentScroll</code> - <code>{boolean=}</code>\n: Whether to disable scrolling while the bottom sheet is open. Default true.</li></ul></td></tr></tbody></table><table \nclass=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-promise\">promise</code></td><td class=\"description\"><p>\nA promise that can be resolved with <code>$mdBottomSheet.hide()</code> or rejected with <code>$mdBottomSheet.cancel()\n</code>.</p></td></tr></tbody></table></div></li><li id=\"hide\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdBottomSheet.hide([response]);</code></h3><div class=\"service-desc\"><p>\nHide the existing bottom sheet and resolve the promise returned from <code>$mdBottomSheet.show()</code>\n. This call will close the most recently opened/current bottomsheet (if any).</p><p><em><b>Note:</b> Use a <code>\n.then()</code> on your <code>.show()</code> to handle this callback.</em></p></div><div class=\"method-param-table\">\n<table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">response <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">*</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">*</code></td><td class=\"description\"><p>\nAn argument for the resolved promise.</p></td></tr></tbody></table></div></li><li id=\"cancel\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdBottomSheet.cancel([response]);</code></h3><div \nclass=\"service-desc\"><p>Hide the existing bottom sheet and reject the promise returned from <code>$mdBottomSheet.show()\n</code>.</p><p><em><b>Note:</b> Use a <code>.catch()</code> on your <code>.show()</code> to handle this callback.</em>\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">response <span hide \nshow-sm><code class=\"api-type label type-hint type-hint-object\">*</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-object\">*</code></td><td class=\"description\"><p>\nAn argument for the rejected promise.</p></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.backdrop/directive/mdBackdrop.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>&lt;md-backdrop&gt;</code>\n is a backdrop element used by other components, such as dialog and bottom sheet. Apply class <code>opaque</code>\n to make the backdrop use the theme backdrop color.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage\n</h2><ul><li>as element:<pre><code>&lt;md-backdrop&gt;&#13;&#10;...&#13;&#10;&lt;/md-backdrop&gt;&#13;</code></pre>\n</li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.button/directive/mdButton.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>&lt;md-button&gt;</code>\n is a button directive with optional ink ripples (default enabled).</p><p>If you supply a <code>href</code> or <code>\nng-href</code> attribute, it will become an <code>&lt;a&gt;</code> element. Otherwise, it will become a <code>\n&lt;button&gt;</code> element. As per the <a href=\"https://material.google.com/style/color.html#color-color-palette\">\nMaterial Design specifications</a>\n the FAB button background is filled with the accent color [by default]. The primary color palette may be used with the \n<code>md-primary</code> class.</p><p>\nDevelopers can also change the color palette of the button, by using the following classes</p><ul><li><code>md-primary\n</code></li><li><code>md-accent</code></li><li><code>md-warn</code></li></ul><p>See for example</p><hljs lang=\"html\">\n<md-button class=\"md-primary\">Primary Button</md-button></hljs><p>\nButton can be also raised, which means that they will use the current color palette to fill the button.</p><hljs \nlang=\"html\"><md-button class=\"md-accent md-raised\">Raised and Accent Button</md-button></hljs><p>\nIt is also possible to disable the focus effect on the button, by using the following markup.</p><hljs lang=\"html\">\n<md-button class=\"md-no-focus\">No Focus Style</md-button></hljs></div><div><section class=\"api-section\"><h2 id=\"Usage\">\nUsage</h2><p>Regular buttons:</p><hljs lang=\"html\"><md-button>Flat Button</md-button><md-button \nhref=\"http://google.com\">Flat link</md-button><md-button class=\"md-raised\">Raised Button</md-button><md-button \nng-disabled=\"true\">Disabled Button</md-button><md-button><md-icon md-svg-src=\"your/icon.svg\"></md-icon>Register Now\n</md-button></hljs><p>FAB buttons:</p><hljs lang=\"html\"><md-button class=\"md-fab\" aria-label=\"FAB\"><md-icon \nmd-svg-src=\"your/icon.svg\"></md-icon></md-button><md-button class=\"md-fab md-mini\" aria-label=\"Mini FAB\"><md-icon \nmd-svg-src=\"your/icon.svg\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Custom Icon Button\">\n<md-icon md-svg-icon=\"path/to/your.svg\"></md-icon></md-button></hljs></section><div class=\"api-param-section\"><h2>\nAttributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-no-ink <span hide \nshow-sm><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td \nclass=\"description\"><p>If present, disable ripple ink effects.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">ng-disabled <span hide show-sm><code class=\"api-type label type-hint type-hint-expression\">\nexpression</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nEn/Disable based on the expression</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">\nmd-ripple-size <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>Overrides the default ripple size logic. Options: <code>full</code>, <code>partial</code>, \n<code>auto</code></p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">aria-label <span hide \nshow-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>\nAdds alternative text to button for accessibility, useful for icon buttons. If no default text is found, a warning will be logged.\n</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.checkbox/directive/mdCheckbox.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The checkbox directive is used like the normal <a \nhref=\"https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D\">angular checkbox</a>.</p><p>As per the <a \nhref=\"http://www.google.com/design/spec/style/color.html#color-color-schemes\">material design spec</a>\n the checkbox is in the accent color by default. The primary color palette may be used with the <code>md-primary</code>\n class.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-checkbox \nng-model=\"isChecked\" aria-label=\"Finished?\">Finished ?</md-checkbox><md-checkbox md-no-ink ng-model=\"hasInk\" \naria-label=\"No Ink Effects\">No Ink Effects</md-checkbox><md-checkbox ng-disabled=\"true\" ng-model=\"isDisabled\" \naria-label=\"Disabled\">Disabled</md-checkbox></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* ng-model</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nAssignable angular expression to data-bind to.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">name <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>Property name of the form under which the control is published.</p></td></tr><tr\n class=\"api-params-item\"><td style=\"white-space: nowrap\">ng-true-value <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nThe value to which the expression should be set when selected.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">ng-false-value <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nThe value to which the expression should be set when not selected.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">ng-change <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>\nAngularJS expression to be executed when input changes due to user interaction with the input element.</p></td></tr><tr\n class=\"api-params-item\"><td style=\"white-space: nowrap\">md-no-ink <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nUse of attribute indicates use of ripple ink effects</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">aria-label <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>\nAdds label to checkbox for accessibility. Defaults to checkbox&#39;s text. If no default text is found, a warning will be logged.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-indeterminate <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nThis determines when the checkbox should be rendered as &#39;indeterminate&#39;. If a truthy expression or no value is passed in the checkbox renders in the md-indeterminate state. If falsy expression is passed in it just looks like a normal unchecked checkbox. The indeterminate, checked, and unchecked states are mutually exclusive. A box cannot be in any two states at the same time. Adding the &#39;md-indeterminate&#39; attribute overrides any checked/unchecked rendering logic. When using the &#39;md-indeterminate&#39; attribute use &#39;ng-checked&#39; to define rendering logic instead of using &#39;ng-model&#39;.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">ng-checked <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nIf this expression evaluates as truthy, the &#39;md-checked&#39; css class is added to the checkbox and it will appear checked.\n</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.colors/service/$mdColors.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nWith only defining themes, one couldn&#39;t get non AngularJS Material elements colored with Material colors, <code>\n$mdColors</code>\n service is used by the md-color directive to convert the 1..n color expressions to RGBA values and will apply those values to element as CSS property values.\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">\nangular.controller(&#39;myCtrl&#39;, function ($mdColors) { var color = $mdColors.getThemeColor(&#39;myTheme-red-200-0.5&#39;); ... });\n</hljs></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"applyThemeColors\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdColors.applyThemeColors(element, colorExpression);</code></h3><div class=\"service-desc\"><p>\nGets a color json object, keys are css properties and values are string of the wanted color Then calculate the rgba() values based on the theme color parts\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* element</b> <span \nhide show-sm><code class=\"api-type label type-hint type-hint-domelement\">DOMElement</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-domelement\">DOMElement</code></td><td \nclass=\"description\"><p>the element to apply the styles on.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* colorExpression</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>\njson object, keys are css properties and values are string of the wanted color, for example: <code>\n{color: &#39;red-A200-0.3&#39;}</code>.</p></td></tr></tbody></table></div></li><li id=\"getThemeColor\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdColors.getThemeColor(expression);</code></h3>\n<div class=\"service-desc\"><p>Get parsed color from expression</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* expression</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nstring of a color expression (for instance <code>&#39;red-700-0.8&#39;</code>)</p></td></tr></tbody></table><table \nclass=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\na css color expression (for instance <code>rgba(211, 47, 47, 0.8)</code>)</p></td></tr></tbody></table></div></li></ul>\n</section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.colors/directive/mdColors.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>mdColors</code>\n directive will apply the theme-based color expression as RGBA CSS style values.</p><p>\nThe format will be similar to our color defining in the scss files:</p><h2 id=\"-theme-palette-hue-opacity-\"><code>\n[?theme]-[palette]-[?hue]-[?opacity]</code></h2><ul><li>[theme] - default value is the default theme</li><li>\n[palette] - can be either palette name or primary/accent/warn/background</li><li>\n[hue] - default is 500 (hue-x can be used with primary/accent/warn/background)</li><li><p>[opacity] - default is 1</p>\n<blockquote><p><code>?</code> indicates optional parameter</p></blockquote></li></ul></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div \nmd-colors=\"{background: \'myTheme-accent-900-0.43\'}\"><div \nmd-colors=\"{color: \'red-A100\', \'border-color\': \'primary-600\'}\"><span>Color demo</span></div></div></hljs><p><code>\nmdColors</code>\n directive will automatically watch for changes in the expression if it recognizes an interpolation expression or a function. For performance options, you can use \n<code>::</code> prefix to the <code>md-colors</code> expression to indicate a one-time data binding.</p><hljs \nlang=\"html\"><md-card md-colors=\"::{background: \'{{theme}}-primary-700\'}\"></md-card></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.content/directive/mdContent.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-content&gt;</code>\n directive is a container element useful for scrollable content. It achieves this by setting the CSS <code>overflow\n</code> property to <code>auto</code> so that content can properly scroll.</p><p>In general, <code>&lt;md-content&gt;\n</code>\n components are not designed to be nested inside one another. If possible, it is better to make them siblings. This often results in a better user experience as having nested scrollbars may confuse the user.\n</p><h2 id=\"troubleshooting\">Troubleshooting</h2><p>In some cases, you may wish to apply the <code>md-no-momentum\n</code>\n class to ensure that Safari&#39;s momentum scrolling is disabled. Momentum scrolling can cause flickering issues while scrolling SVG icons and some other components.\n</p><p>Additionally, we now also offer the <code>md-no-flicker</code>\n class which can be applied to any element and uses a Webkit-specific filter of <code>blur(0px)</code>\n that forces GPU rendering of all elements inside (which eliminates the flicker on iOS devices).</p><p><em><b>Note:</b>\n Forcing an element to render on the GPU can have unintended side-effects, especially related to the z-index of elements. Please use with caution and only on the elements needed.\n</em></p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>Add the <code>[layout-padding]</code>\n attribute to make the content padded.</p><hljs lang=\"html\"><md-content layout-padding>\nLorem ipsum dolor sit amet, ne quod novum mei.</md-content></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.chips/directive/mdChip.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>&lt;md-chip&gt;</code> is a component used within <code>&lt;md-chips&gt;\n</code> and is responsible for rendering individual chips.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">\nUsage</h2><hljs lang=\"html\"><md-chip>{{$chip}}</md-chip></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.chips/directive/mdChipRemove.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>Designates an element to be used as the delete button for a chip.<br>\nThis element is passed as a child of the <code>md-chips</code> element.</p><p>\nThe designated button will be just appended to the chip and removes the given chip on click.<br>\nBy default the button is not being styled by the <code>md-chips</code> component.</p></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-chips><button md-chip-remove=\"\"><md-icon \nmd-svg-icon=\"md-close\"></md-icon></button></md-chips></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.chips/directive/mdChips.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>&lt;md-chips&gt;</code>\n is an input component for building lists of strings or objects. The list items are displayed as &#39;chips&#39;. This component can make use of an \n<code>&lt;input&gt;</code> element or an <code>&lt;md-autocomplete&gt;</code> element.</p><h3 id=\"custom-templates\">\nCustom templates</h3><p>\nA custom template may be provided to render the content of each chip. This is achieved by specifying an <code>\n&lt;md-chip-template&gt;</code> element containing the custom content as a child of <code>&lt;md-chips&gt;</code>.</p>\n<p>Note: Any attributes on <code>&lt;md-chip-template&gt;</code>\n will be dropped as only the innerHTML is used for the chip template. The variables <code>$chip</code> and <code>$index\n</code> are available in the scope of <code>&lt;md-chip-template&gt;</code>\n, representing the chip object and its index in the list of chips, respectively. To override the chip delete control, include an element (ideally a button) with the attribute \n<code>md-chip-remove</code>\n. A click listener to remove the chip will be added automatically. The element is also placed as a sibling to the chip content (on which there are also click listeners) to avoid a nested ng-click situation.\n</p><p>Sometimes developers want to limit the amount of possible chips.<br>\nYou can specify the maximum amount of chips by using the following markup.</p><hljs lang=\"html\"><md-chips \nng-model=\"myItems\" placeholder=\"Add an item\" md-max-chips=\"5\"></md-chips></hljs><p>\nIn some cases, you have an autocomplete inside of the <code>md-chips</code>.<br>\nWhen the maximum amount of chips has been reached, you can also disable the autocomplete selection.<br>\nHere is an example markup.</p><hljs lang=\"html\"><md-chips ng-model=\"myItems\" md-max-chips=\"5\"><md-autocomplete \nng-hide=\"myItems.length > 5\" ...></md-autocomplete></md-chips></hljs><h3 id=\"accessibility\">Accessibility</h3><p>The \n<code>md-chips</code>\n component supports keyboard and screen reader users since Version 1.1.2. In order to achieve this, we modified the chips behavior to select newly appended chips for \n<code>300ms</code> before re-focusing the input and allowing the user to type.</p><p>\nFor most users, this delay is small enough that it will not be noticeable but allows certain screen readers to function properly (JAWS and NVDA in particular).\n</p><p>We introduced a new <code>md-chip-append-delay</code>\n option to allow developers to better control this behavior.</p><p>\nPlease refer to the documentation of this option (below) for more information.</p></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-chips ng-model=\"myItems\" placeholder=\"Add an item\" \nreadonly=\"isReadOnly\"></md-chips></hljs><p></p><h3>Validation</h3>When using <a \nhref=\"https://docs.angularjs.org/api/ngMessages\">ngMessages</a>, you can show errors based on our custom validators.<p>\n</p><hljs lang=\"html\"><form name=\"userForm\"><md-chips name=\"fruits\" ng-model=\"myItems\" placeholder=\"Add an item\" \nmd-max-chips=\"5\"></md-chips><div ng-messages=\"userForm.fruits.$error\" ng-if=\"userForm.$dirty\"><div \nng-message=\"md-max-chips\">You reached the maximum amount of chips</div></div></form></hljs></section><div \nclass=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* ng-model</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code><code class=\"api-type label type-hint type-hint-object\">\nobject</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>\nA model to which the list of items will be bound.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* md-transform-chip</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nAn expression of form <code>myFunction($chip)</code> that when called expects one of the following return values:</p>\n<ul><li>an object representing the <code>$chip</code> input string</li><li><code>undefined</code> to simply add the \n<code>$chip</code> input string, or</li><li><code>null</code> to prevent the chip from being appended</li></ul></td>\n</tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-require-match</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nIf true, and the chips template contains an autocomplete, only allow selection of pre-defined chips (i.e. you cannot add new ones).\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">placeholder <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nPlaceholder text that will be forwarded to the input.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">secondary-placeholder <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nPlaceholder text that will be forwarded to the input, displayed when there is at least one item in the list</p></td>\n</tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-removable <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nEnables or disables the deletion of chips through the removal icon or the Delete/Backspace key. Defaults to true.</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">readonly <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nDisables list manipulation (deleting or adding list items), hiding the input and delete buttons. If no <code>ng-model\n</code> is provided, the chips will automatically be marked as readonly.<br><br>When <code>md-removable</code>\n is not defined, the <code>md-remove</code> behavior will be overwritten and disabled.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-enable-chip-edit <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nSet this to &quot;true&quot; to enable editing of chip contents. The user can go into edit mode with pressing &quot;space&quot;, &quot;enter&quot;, or double clicking on the chip. Chip edit is only supported for chips with basic template.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-max-chips <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nThe maximum number of chips allowed to add through user input.<br><br>The validation property <code>md-max-chips</code>\n can be used when the max chips amount is reached.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-add-on-blur <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></td><td class=\"description\"><p>\nWhen set to true, remaining text inside of the input will be converted into a new chip on blur.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-on-add <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nAn expression which will be called when a chip has been added.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-on-remove <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nAn expression which will be called when a chip has been removed.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-on-select <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nAn expression which will be called when a chip is selected.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">input-aria-label <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nA string read by screen readers to identify the input.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">container-hint <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>\nA string read by screen readers informing users of how to navigate the chips. Used in readonly mode.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">delete-hint <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nA string read by screen readers instructing users that pressing the delete key will remove the chip.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">delete-button-label <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nA label for the delete button. Also hidden and read by screen readers.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-separator-keys <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nAn array of key codes used to separate chips.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">\nmd-chip-append-delay <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span>\n</td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>\nThe number of milliseconds that the component will select a newly appended chip before allowing a user to type into the input. This is \n<strong>necessary</strong>\n for keyboard accessibility for screen readers. It defaults to 300ms and any number less than 300 can cause issues with screen readers (particularly JAWS and sometimes NVDA).\n</p><p><em>Available since Version 1.1.2.</em></p><p><strong>Note:</strong> You can safely set this to <code>0</code>\n in one of the following two instances:</p><ol><li><p>\nYou are targeting an iOS or Safari-only application (where users would use VoiceOver) or only ChromeVox users.</p></li>\n<li><p>If you have utilized the <code>md-separator-keys</code> to disable the <code>enter</code>\n keystroke in favor of another one (such as <code>,</code> or <code>;</code>).</p></li></ol></td></tr></tbody></table>\n</div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.chips/directive/mdContactChips.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>&lt;md-contact-chips&gt;</code> is an input component based on <code>md-chips\n</code> and makes use of an <code>md-autocomplete</code>\n element. The component allows the caller to supply a query expression which returns a list of possible contacts. The user can select one of these and add it to the list of chips.\n</p><p>You may also use the <code>md-highlight-text</code>\n directive along with its parameters to control the appearance of the matched text inside of the contacts&#39; autocomplete popup.\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-contact-chips \nng-model=\"ctrl.contacts\" md-contacts=\"ctrl.querySearch($query)\" md-contact-name=\"name\" md-contact-image=\"image\" \nmd-contact-email=\"email\" placeholder=\"To\"></md-contact-chips></hljs></section><div class=\"api-param-section\"><h2>\nAttributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* ng-model</b> <span\n hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code><code class=\"api-type label type-hint type-hint-object\">\nobject</code></td><td class=\"description\"><p>A model to bind the list of items to</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-contacts</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nAn expression expected to return contacts matching the search test, <code>$query</code>\n. If this expression involves a promise, a loading bar is displayed while waiting for it to resolve.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-contact-name</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThe field name of the contact object representing the contact&#39;s name.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* md-contact-email</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThe field name of the contact object representing the contact&#39;s email address.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-contact-image</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThe field name of the contact object representing the contact&#39;s image.</p></td></tr><tr class=\"api-params-item\"><td\n style=\"white-space: nowrap\">placeholder <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>Placeholder text that will be forwarded to the input.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">secondary-placeholder <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nPlaceholder text that will be forwarded to the input, displayed when there is at least on item in the list</p></td>\n</tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-min-length <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nSpecifies the minimum length of text before autocomplete will make suggestions</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">filter-selected <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nWhether to filter selected contacts from the list of suggestions shown in the autocomplete.</p><p><strong>*Note:\n</strong> This attribute has been removed but may come back.*</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.datepicker/directive/mdCalendar.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>&lt;md-calendar&gt;</code>\n is a component that renders a calendar that can be used to select a date. It is a part of the <code>\n&lt;md-datepicker&gt;</code> pane, however it can also be used on it&#39;s own.</p></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-calendar ng-model=\"birthday\"></md-calendar></hljs>\n</section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\">\n<thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* ng-model</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-date\">\nDate</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-date\">Date\n</code></td><td class=\"description\"><p>The component&#39;s model. Should be a Date object.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-min-date <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-date\">Date</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-date\">Date</code></td><td class=\"description\"><p>\nExpression representing the minimum date.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">\nmd-max-date <span hide show-sm><code class=\"api-type label type-hint type-hint-date\">Date</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-date\">Date</code></td><td \nclass=\"description\"><p>Expression representing the maximum date.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-date-filter <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-function\">function(Date): boolean</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-function\">function(Date): boolean</code>\n</td><td class=\"description\"><p>Function expecting a date and returning a boolean whether it can be selected or not.\n</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.datepicker/directive/mdDatepicker.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>&lt;md-datepicker&gt;</code>\n is a component used to select a single date. For information on how to configure internationalization for the date picker, see \n<code>$mdDateLocaleProvider</code>.</p><p>This component supports <a \nhref=\"https://docs.angularjs.org/api/ngMessages/directive/ngMessages\">ngMessages</a>. Supported attributes are:</p><ul>\n<li><code>required</code>: whether a required date is not set.</li><li><code>mindate</code>\n: whether the selected date is before the minimum allowed date.</li><li><code>maxdate</code>\n: whether the selected date is after the maximum allowed date.</li><li><code>debounceInterval</code>\n: ms to delay input processing (since last debounce reset); default value 500ms</li></ul></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-datepicker ng-model=\"birthday\"></md-datepicker>\n</hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* ng-model</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-date\">Date</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-date\">Date</code></td><td class=\"description\"><p>\nThe component&#39;s model. Expects either a JavaScript Date object or a value that can be parsed into one (e.g. a ISO 8601 string).\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">ng-model-options <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">Object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">Object</code></td><td class=\"description\"><p>\nAllows tuning of the way in which <code>ng-model</code> is being updated. Also allows for a timezone to be specified. \n<a href=\"https://docs.angularjs.org/api/ng/directive/ngModelOptions#usage\">Read more at the ngModelOptions docs.</a>\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">ng-change <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nExpression evaluated when the model value changes.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">ng-focus <span hide show-sm><code class=\"api-type label type-hint type-hint-expression\">\nexpression</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nExpression evaluated when the input is focused or the calendar is opened.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">ng-blur <span hide show-sm><code class=\"api-type label type-hint type-hint-expression\">\nexpression</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nExpression evaluated when focus is removed from the input or the calendar is closed.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">ng-disabled <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhether the datepicker is disabled.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">\nng-required <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td \nclass=\"description\"><p>Whether a value is required for the datepicker.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-min-date <span hide show-sm><code class=\"api-type label type-hint type-hint-date\">Date\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-date\">Date</code>\n</td><td class=\"description\"><p>Expression representing a min date (inclusive).</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-max-date <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-date\">Date</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-date\">Date</code></td><td class=\"description\"><p>\nExpression representing a max date (inclusive).</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-date-filter <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-function\">function(Date): boolean</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-function\">function(Date): boolean</code>\n</td><td class=\"description\"><p>Function expecting a date and returning a boolean whether it can be selected or not.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-placeholder <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">String</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">String</code></td><td class=\"description\"><p>\nThe date input placeholder value.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">\nmd-open-on-focus <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">String</code></span></td>\n<td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">String</code></td><td \nclass=\"description\"><p>When present, the calendar will be opened when the input is focused.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-is-open <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">Boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">Boolean</code></td><td class=\"description\"><p>\nExpression that can be used to open the datepicker&#39;s calendar on-demand.</p></td></tr><tr class=\"api-params-item\">\n<td style=\"white-space: nowrap\">md-current-view <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">String</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">String</code></td><td class=\"description\"><p>\nDefault open view of the calendar pane. Can be either &quot;month&quot; or &quot;year&quot;.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-hide-icons <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">String</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">String</code></td><td class=\"description\"><p>\nDetermines which datepicker icons should be hidden. Note that this may cause the datepicker to not align properly with other components. \n<strong>Use at your own risk.</strong> Possible values are:</p><ul><li><code>&quot;all&quot;</code> - Hides all icons.\n</li><li><code>&quot;calendar&quot;</code> - Only hides the calendar icon.</li><li><code>&quot;triangle&quot;</code>\n - Only hides the triangle icon.</li></ul></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">\nmd-date-locale <span hide show-sm><code class=\"api-type label type-hint type-hint-object\">Object</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">Object</code></td><td \nclass=\"description\"><p>Allows for the values from the <code>$mdDateLocaleProvider</code>\n to be ovewritten on a per-element basis (e.g. <code>msgOpenCalendar</code> can be overwritten with <code>\nmd-date-locale=&quot;{ msgOpenCalendar: &#39;Open a special calendar&#39; }&quot;</code>).</p></td></tr></tbody>\n</table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.datepicker/service/$mdDateLocaleProvider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>$mdDateLocaleProvider</code> is the provider that creates the <code>\n$mdDateLocale</code>\n service. This provider that allows the user to specify messages, formatters, and parsers for date internationalization. The \n<code>$mdDateLocale</code> service itself is consumed by AngularJS Material components that deal with dates.</p></div>\n<div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">\nmyAppModule.config(function($mdDateLocaleProvider) { // Example of a French localization. $mdDateLocaleProvider.months = [&#39;janvier&#39;, &#39;février&#39;, &#39;mars&#39;, ...]; $mdDateLocaleProvider.shortMonths = [&#39;janv&#39;, &#39;févr&#39;, &#39;mars&#39;, ...]; $mdDateLocaleProvider.days = [&#39;dimanche&#39;, &#39;lundi&#39;, &#39;mardi&#39;, ...]; $mdDateLocaleProvider.shortDays = [&#39;Di&#39;, &#39;Lu&#39;, &#39;Ma&#39;, ...]; // Can change week display to start on Monday. $mdDateLocaleProvider.firstDayOfWeek = 1; // Optional. $mdDateLocaleProvider.dates = [1, 2, 3, 4, 5, 6, ...]; // Example uses moment.js to parse and format dates. $mdDateLocaleProvider.parseDate = function(dateString) { var m = moment(dateString, &#39;L&#39;, true); return m.isValid() ? m.toDate() : new Date(NaN); }; $mdDateLocaleProvider.formatDate = function(date) { var m = moment(date); return m.isValid() ? m.format(&#39;L&#39;) : &#39;&#39;; }; $mdDateLocaleProvider.monthHeaderFormatter = function(date) { return myShortMonths[date.getMonth()] + &#39; &#39; + date.getFullYear(); }; // In addition to date display, date components also need localized messages // for aria-labels for screen-reader users. $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) { return &#39;Semaine &#39; + weekNumber; }; $mdDateLocaleProvider.msgCalendar = &#39;Calendrier&#39;; $mdDateLocaleProvider.msgOpenCalendar = &#39;Ouvrir le calendrier&#39;; // You can also set when your calendar begins and ends. $mdDateLocaleProvider.firstRenderableDate = new Date(1776, 6, 4); $mdDateLocaleProvider.lastRenderableDate = new Date(2012, 11, 21); });\n</hljs></section><section class=\"api-section\"><h2>Properties</h2><br><ul class=\"methods\"><li id=\"months\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdDateLocaleProvider.months</code></h3><div \nclass=\"service-desc\"><p>Array of month names (in order).</p></div><div class=\"method-param-table\"></div></li><li \nid=\"shortMonths\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdDateLocaleProvider.shortMonths</code></h3><div class=\"service-desc\"><p>Array of abbreviated month names.</p></div>\n<div class=\"method-param-table\"></div></li><li id=\"days\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdDateLocaleProvider.days</code></h3><div class=\"service-desc\"><p>\nArray of the days of the week (in order).</p></div><div class=\"method-param-table\"></div></li><li id=\"shortDays\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdDateLocaleProvider.shortDays</code></h3><div \nclass=\"service-desc\"><p>Array of abbreviated days of the week.</p></div><div class=\"method-param-table\"></div></li><li \nid=\"dates\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdDateLocaleProvider.dates</code>\n</h3><div class=\"service-desc\"><p>\nArray of dates of the month. Only necessary for locales using a numeral system other than [1, 2, 3...].</p></div><div \nclass=\"method-param-table\"></div></li><li id=\"firstDayOfWeek\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdDateLocaleProvider.firstDayOfWeek</code></h3><div class=\"service-desc\"><p>\nThe first day of the week. Sunday = 0, Monday = 1, etc.</p></div><div class=\"method-param-table\"></div></li><li \nid=\"parseDate\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdDateLocaleProvider.parseDate\n</code></h3><div class=\"service-desc\"><p>Function to parse a date object from a string.</p></div><div \nclass=\"method-param-table\"></div></li><li id=\"formatDate\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdDateLocaleProvider.formatDate</code></h3><div class=\"service-desc\"><p>\nFunction to format a date object to a string. The datepicker directive also provides the time zone, if it was specified.\n</p></div><div class=\"method-param-table\"></div></li><li id=\"monthHeaderFormatter\"><h3 class=\"method-function-syntax\">\n<code class=\"method-function-syntax\">$mdDateLocaleProvider.monthHeaderFormatter</code></h3><div class=\"service-desc\">\n<p>Function that returns the label for a month given a date.</p></div><div class=\"method-param-table\"></div></li><li \nid=\"monthFormatter\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdDateLocaleProvider.monthFormatter</code></h3><div class=\"service-desc\"><p>\nFunction that returns the full name of a month for a given date.</p></div><div class=\"method-param-table\"></div></li>\n<li id=\"weekNumberFormatter\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdDateLocaleProvider.weekNumberFormatter</code></h3><div class=\"service-desc\"><p>\nFunction that returns a label for a week given the week number.</p></div><div class=\"method-param-table\"></div></li><li\n id=\"msgCalendar\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdDateLocaleProvider.msgCalendar</code></h3><div class=\"service-desc\"><p>\nTranslation of the label &quot;Calendar&quot; for the current locale.</p></div><div class=\"method-param-table\"></div>\n</li><li id=\"msgOpenCalendar\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdDateLocaleProvider.msgOpenCalendar</code></h3><div class=\"service-desc\"><p>\nTranslation of the button label &quot;Open calendar&quot; for the current locale.</p></div><div \nclass=\"method-param-table\"></div></li><li id=\"firstRenderableDate\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdDateLocaleProvider.firstRenderableDate</code></h3><div class=\"service-desc\"><p>\nThe date from which the datepicker calendar will begin rendering. Note that this will be ignored if a minimum date is set. Defaults to January 1st 1880.\n</p></div><div class=\"method-param-table\"></div></li><li id=\"lastRenderableDate\"><h3 class=\"method-function-syntax\">\n<code class=\"method-function-syntax\">$mdDateLocaleProvider.lastRenderableDate</code></h3><div class=\"service-desc\"><p>\nThe last date that will be rendered by the datepicker calendar. Note that this will be ignored if a maximum date is set. Defaults to January 1st 2130.\n</p></div><div class=\"method-param-table\"></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.dialog/directive/mdDialog.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>&lt;md-dialog&gt;</code>\n - The dialog&#39;s template must be inside this element.</p><p>Inside, use an <code>&lt;md-dialog-content&gt;</code>\n element for the dialog&#39;s content, and use an <code>&lt;md-dialog-actions&gt;</code>\n element for the dialog&#39;s actions.</p><h2 id=\"css\">CSS</h2><ul><li><code>.md-dialog-content</code>\n - class that sets the padding on the content as the spec file</li></ul><h2 id=\"notes\">Notes</h2><ul><li>\nIf you specify an <code>id</code> for the <code>&lt;md-dialog&gt;</code>, the <code>&lt;md-dialog-content&gt;</code>\n will have the same <code>id</code> prefixed with <code>dialogContent_</code>.</li></ul></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><h3 id=\"dialog-template\">Dialog template</h3><hljs lang=\"html\"><md-dialog \naria-label=\"List dialog\"><md-dialog-content><md-list><md-list-item ng-repeat=\"item in items\"><p>Number {{item}}</p>\n</md-list-item></md-list></md-dialog-content><md-dialog-actions><md-button ng-click=\"closeDialog()\" class=\"md-primary\">\nClose Dialog</md-button></md-dialog-actions></md-dialog></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.dialog/service/$mdDialog.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>$mdDialog</code>\n opens a dialog over the app to inform users about critical information or require them to make decisions. There are two approaches for setup: a simple promise API and regular object syntax.\n</p><h2 id=\"restrictions\">Restrictions</h2><ul><li>The dialog is always given an isolate scope.</li><li>\nThe dialog&#39;s template must have an outer <code>&lt;md-dialog&gt;</code> element. Inside, use an <code>\n&lt;md-dialog-content&gt;</code> element for the dialog&#39;s content, and use an <code>&lt;md-dialog-actions&gt;\n</code> element for the dialog&#39;s actions.</li><li>\nDialogs must cover the entire application to keep interactions inside of them. Use the <code>parent</code>\n option to change where dialogs are appended.</li></ul><h2 id=\"sizing\">Sizing</h2><ul><li>\nComplex dialogs can be sized with <code>flex=&quot;percentage&quot;</code>, i.e. <code>flex=&quot;66&quot;</code>.</li>\n<li>Default max-width is 80% of the <code>rootElement</code> or <code>parent</code>.</li></ul><h2 id=\"css\">CSS</h2><ul>\n<li><code>.md-dialog-content</code> - class that sets the padding on the content as the spec file</li></ul></div><div>\n<section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div ng-app=\"demoApp\" \nng-controller=\"EmployeeController\"><div><md-button ng-click=\"showAlert()\" class=\"md-raised md-warn\">Employee Alert!\n</md-button></div><div><md-button ng-click=\"showDialog($event)\" class=\"md-raised\">Custom Dialog</md-button></div><div>\n<md-button ng-click=\"closeAlert()\" ng-disabled=\"!hasAlert()\" class=\"md-raised\">Close Alert</md-button></div><div>\n<md-button ng-click=\"showGreeting($event)\" class=\"md-raised md-primary\">Greet Employee</md-button></div></div></hljs>\n<h3 id=\"javascript-object-syntax\">JavaScript: object syntax</h3><hljs lang=\"js\">\n(function(angular, undefined){ &quot;use strict&quot;; angular .module(&#39;demoApp&#39;, [&#39;ngMaterial&#39;]) .controller(&#39;AppCtrl&#39;, AppController); function AppController($scope, $mdDialog) { var alert; $scope.showAlert = showAlert; $scope.showDialog = showDialog; $scope.items = [1, 2, 3]; // Internal method function showAlert() { alert = $mdDialog.alert({ title: &#39;Attention&#39;, textContent: &#39;This is an example of how easy dialogs can be!&#39;, ok: &#39;Close&#39; }); $mdDialog .show( alert ) .finally(function() { alert = undefined; }); } function showDialog($event) { var parentEl = angular.element(document.body); $mdDialog.show({ parent: parentEl, targetEvent: $event, template: &#39;\n<md-dialog aria-label=\"List dialog\">&#39; + &#39;<md-dialog-content>&#39;+ &#39;<md-list>&#39;+ &#39;<md-list-item \nng-repeat=\"item in items\">&#39;+ &#39;<p>Number {{item}}</p>&#39; + &#39;&#39;+ &#39;</md-list-item></md-list>\n&#39;+ &#39;</md-dialog-content>&#39; + &#39;<md-dialog-actions>&#39; + &#39;<md-button ng-click=\"closeDialog()\" \nclass=\"md-primary\">&#39; + &#39; Close Dialog&#39; + &#39;</md-button>&#39; + &#39;</md-dialog-actions>&#39; + &#39;\n</md-dialog>\n&#39;, locals: { items: $scope.items }, controller: DialogController }); function DialogController($scope, $mdDialog, items) { $scope.items = items; $scope.closeDialog = function() { $mdDialog.hide(); } } } } })(angular);\n</hljs><h3 id=\"multiple-dialogs\">Multiple Dialogs</h3><p>Using the <code>multiple</code> option for the <code>$mdDialog\n</code> service allows developers to show multiple dialogs at the same time.</p><hljs lang=\"js\">\n// From plain options $mdDialog.show({ multiple: true }); // From a dialog preset $mdDialog.show( $mdDialog .alert() .multiple(true) );\n</hljs><h3 id=\"pre-rendered-dialogs\">Pre-Rendered Dialogs</h3><p>By using the <code>contentElement</code>\n option, it is possible to use an already existing element in the DOM.</p><blockquote><p>\nPre-rendered dialogs will be not linked to any scope and will not instantiate any new controller.<br>\nYou can manually link the elements to a scope or instantiate a controller from the template (<code>ng-controller</code>\n)</p></blockquote><hljs lang=\"js\">\n$scope.showPrerenderedDialog = function() { $mdDialog.show({ contentElement: &#39;#myStaticDialog&#39;, parent: angular.element(document.body) }); };\n</hljs><p>When using a string as value, <code>$mdDialog</code>\n will automatically query the DOM for the specified CSS selector.</p><hljs lang=\"html\"><div style=\"visibility: hidden\">\n<div class=\"md-dialog-container\" id=\"myStaticDialog\"><md-dialog>This is a pre-rendered dialog.</md-dialog></div></div>\n</hljs><p><strong>Notice</strong>: It is important, to use the <code>.md-dialog-container</code>\n as the content element, otherwise the dialog will not show up.</p><p>It also possible to use a DOM element for the \n<code>contentElement</code> option.</p><ul><li><code>contentElement: document.querySelector(&#39;#myStaticDialog&#39;)\n</code></li><li><code>contentElement: angular.element(TEMPLATE)</code></li></ul><p>When using a <code>template</code>\n as content element, it will be not compiled upon open. This allows you to compile the element yourself and use it each time the dialog opens.\n</p><h3 id=\"custom-presets\">Custom Presets</h3><p>\nDevelopers are also able to create their own preset, which can be easily used without repeating their options each time.\n</p><hljs lang=\"js\">$mdDialogProvider.addPreset(&#39;testPreset&#39;, { options: function() { return { template: &#39;\n<md-dialog>&#39; + &#39;This is a custom preset&#39; + &#39;</md-dialog>\n&#39;, controllerAs: &#39;dialog&#39;, bindToController: true, clickOutsideToClose: true, escapeToClose: true }; } });\n</hljs><p>After you created your preset at config phase, you can easily access it.</p><hljs lang=\"js\">\n$mdDialog.show( $mdDialog.testPreset() );</hljs><h3 id=\"javascript-promise-api-syntax-custom-dialog-template\">\nJavaScript: promise API syntax, custom dialog template</h3><hljs lang=\"js\">\n(function(angular, undefined){ &quot;use strict&quot;; angular .module(&#39;demoApp&#39;, [&#39;ngMaterial&#39;]) .controller(&#39;EmployeeController&#39;, EmployeeEditor) .controller(&#39;GreetingController&#39;, GreetingController); // Fictitious Employee Editor to show how to use simple and complex dialogs. function EmployeeEditor($scope, $mdDialog) { var alert; $scope.showAlert = showAlert; $scope.closeAlert = closeAlert; $scope.showGreeting = showCustomGreeting; $scope.hasAlert = function() { return !!alert }; $scope.userName = $scope.userName || &#39;Bobby&#39;; // Dialog #1 - Show simple alert dialog and cache // reference to dialog instance function showAlert() { alert = $mdDialog.alert() .title(&#39;Attention, &#39; + $scope.userName) .textContent(&#39;This is an example of how easy dialogs can be!&#39;) .ok(&#39;Close&#39;); $mdDialog .show( alert ) .finally(function() { alert = undefined; }); } // Close the specified dialog instance and resolve with &#39;finished&#39; flag // Normally this is not needed, just use &#39;$mdDialog.hide()&#39; to close // the most recent dialog popup. function closeAlert() { $mdDialog.hide( alert, &quot;finished&quot; ); alert = undefined; } // Dialog #2 - Demonstrate more complex dialogs construction and popup. function showCustomGreeting($event) { $mdDialog.show({ targetEvent: $event, template: &#39;\n<md-dialog>&#39; + &#39;<md-dialog-content>Hello {{ employee }}!</md-dialog-content>&#39; + &#39;<md-dialog-actions>\n&#39; + &#39;<md-button ng-click=\"closeDialog()\" class=\"md-primary\">&#39; + &#39; Close Greeting&#39; + &#39;\n</md-button>&#39; + &#39;</md-dialog-actions>&#39; + &#39;</md-dialog>\n&#39;, controller: &#39;GreetingController&#39;, onComplete: afterShowAnimation, locals: { employee: $scope.userName } }); // When the &#39;enter&#39; animation finishes... function afterShowAnimation(scope, element, options) { // post-show code here: DOM element focus, etc. } } // Dialog #3 - Demonstrate use of ControllerAs and passing $scope to dialog // Here we used ng-controller=&quot;GreetingController as vm&quot; and // $scope.vm ===\n<controller instance>\nfunction showCustomGreeting() { $mdDialog.show({ clickOutsideToClose: true, scope: $scope, // use parent scope in template preserveScope: true, // do not forget this if use parent scope // Since GreetingController is instantiated with ControllerAs syntax // AND we are passing the parent &#39;$scope&#39; to the dialog, we MUST // use &#39;vm.\n<xxx>&#39; in the template markup template: &#39;<md-dialog>&#39; + &#39;<md-dialog-content>\n&#39; + &#39; Hi There {{vm.employee}}&#39; + &#39;</md-dialog-content>&#39; + &#39;</md-dialog>\n&#39;, controller: function DialogController($scope, $mdDialog) { $scope.closeDialog = function() { $mdDialog.hide(); } } }); } } // Greeting controller used with the more complex &#39;showCustomGreeting()&#39; custom dialog function GreetingController($scope, $mdDialog, employee) { // Assigned from construction \n<code>locals</code>\n options... $scope.employee = employee; $scope.closeDialog = function() { // Easily hides most recent dialog shown... // no specific instance reference is needed. $mdDialog.hide(); }; } })(angular);\n</xxx></controller></hljs></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li \nid=\"alert\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdDialog.alert();</code></h3><div \nclass=\"service-desc\"><p>Builds a preconfigured dialog with the specified message.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>an <code>\n$mdDialogPreset</code> with the chainable configuration methods:</p><ul><li>\n$mdDialogPreset#title(string) - Sets the alert title.</li><li>\n$mdDialogPreset#textContent(string) - Sets the alert message.</li><li>\n$mdDialogPreset#htmlContent(string) - Sets the alert message as HTML. Requires ngSanitize module to be loaded. HTML is not run through Angular&#39;s compiler.\n</li><li>$mdDialogPreset#ok(string) - Sets the alert &quot;Okay&quot; button text.</li><li>\n$mdDialogPreset#theme(string) - Sets the theme of the alert dialog.</li><li>\n$mdDialogPreset#targetEvent(DOMClickEvent=) - A click&#39;s event object. When passed in as an option, the location of the click will be used as the starting point for the opening animation of the the dialog.\n</li></ul></td></tr></tbody></table></div></li><li id=\"confirm\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdDialog.confirm();</code></h3><div class=\"service-desc\"><p>\nBuilds a preconfigured dialog with the specified message. You can call show and the promise returned will be resolved only if the user clicks the confirm action on the dialog.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th>\n</tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td \nclass=\"description\"><p>an <code>$mdDialogPreset</code> with the chainable configuration methods:</p><p>\nAdditionally, it supports the following methods:</p><ul><li>$mdDialogPreset#title(string) - Sets the confirm title.\n</li><li>$mdDialogPreset#textContent(string) - Sets the confirm message.</li><li>\n$mdDialogPreset#htmlContent(string) - Sets the confirm message as HTML. Requires ngSanitize module to be loaded. HTML is not run through Angular&#39;s compiler.\n</li><li>$mdDialogPreset#ok(string) - Sets the confirm &quot;Okay&quot; button text.</li><li>\n$mdDialogPreset#cancel(string) - Sets the confirm &quot;Cancel&quot; button text.</li><li>\n$mdDialogPreset#theme(string) - Sets the theme of the confirm dialog.</li><li>\n$mdDialogPreset#targetEvent(DOMClickEvent=) - A click&#39;s event object. When passed in as an option, the location of the click will be used as the starting point for the opening animation of the the dialog.\n</li></ul></td></tr></tbody></table></div></li><li id=\"prompt\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdDialog.prompt();</code></h3><div class=\"service-desc\"><p>\nBuilds a preconfigured dialog with the specified message and input box. You can call show and the promise returned will be resolved only if the user clicks the prompt action on the dialog, passing the input value as the first argument.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th>\n</tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td \nclass=\"description\"><p>an <code>$mdDialogPreset</code> with the chainable configuration methods:</p><p>\nAdditionally, it supports the following methods:</p><ul><li>$mdDialogPreset#title(string) - Sets the prompt title.</li>\n<li>$mdDialogPreset#textContent(string) - Sets the prompt message.</li><li>\n$mdDialogPreset#htmlContent(string) - Sets the prompt message as HTML. Requires ngSanitize module to be loaded. HTML is not run through Angular&#39;s compiler.\n</li><li>$mdDialogPreset#placeholder(string) - Sets the placeholder text for the input.</li><li>\n$mdDialogPreset#initialValue(string) - Sets the initial value for the prompt input.</li><li>\n$mdDialogPreset#ok(string) - Sets the prompt &quot;Okay&quot; button text.</li><li>\n$mdDialogPreset#cancel(string) - Sets the prompt &quot;Cancel&quot; button text.</li><li>\n$mdDialogPreset#theme(string) - Sets the theme of the prompt dialog.</li><li>\n$mdDialogPreset#targetEvent(DOMClickEvent=) - A click&#39;s event object. When passed in as an option, the location of the click will be used as the starting point for the opening animation of the the dialog.\n</li></ul></td></tr></tbody></table></div></li><li id=\"show\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdDialog.show(optionsOrPreset);</code></h3><div class=\"service-desc\"><p>\nShow a dialog with the specified options.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead>\n<tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* optionsOrPreset</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>Either provide an <code>\n$mdDialogPreset</code> returned from <code>alert()</code>, and <code>confirm()</code>\n, or an options object with the following properties:</p><ul><li><code>templateUrl</code> - <code>{string=}</code>\n: The url of a template that will be used as the content of the dialog.</li><li><code>template</code> - <code>{string=}\n</code>: HTML template to show in the dialog. This <strong>must</strong> be trusted HTML with respect to Angular&#39;s \n<a href=\"https://docs.angularjs.org/api/ng/service/$sce\">$sce service</a>. This template should <strong>never</strong>\n be constructed with any kind of user input or user data.</li><li><code>contentElement</code> - <code>{string|Element}\n</code>: Instead of using a template, which will be compiled each time a dialog opens, you can also use a DOM element.\n<br><ul><li>When specifying an element, which is present on the DOM, <code>$mdDialog</code>\n will temporary fetch the element into the dialog and restores it at the old DOM position upon close.</li><li>\nWhen specifying a string, the string be used as a CSS selector, to lookup for the element in the DOM.</li></ul></li>\n<li><code>autoWrap</code> - <code>{boolean=}</code>: Whether or not to automatically wrap the template with a <code>\n&lt;md-dialog&gt;</code>\n tag if one is not provided. Defaults to true. Can be disabled if you provide a custom dialog directive.</li><li><code>\ntargetEvent</code> - <code>{DOMClickEvent=}</code>\n: A click&#39;s event object. When passed in as an option, the location of the click will be used as the starting point for the opening animation of the the dialog.\n</li><li><code>openFrom</code> - <code>{string|Element|object}</code>\n: The query selector, DOM element or the Rect object that is used to determine the bounds (top, left, height, width) from which the Dialog will originate.\n</li><li><code>closeTo</code> - <code>{string|Element|object}</code>\n: The query selector, DOM element or the Rect object that is used to determine the bounds (top, left, height, width) to which the Dialog will target.\n</li><li><code>scope</code> - <code>{object=}</code>\n: the scope to link the template / controller to. If none is specified, it will create a new isolate scope. This scope will be destroyed when the dialog is removed unless \n<code>preserveScope</code> is set to true.</li><li><code>preserveScope</code> - <code>{boolean=}</code>\n: whether to preserve the scope when the element is removed. Default is false</li><li><code>disableParentScroll</code>\n - <code>{boolean=}</code>: Whether to disable scrolling while the dialog is open. Default true.</li><li><code>\nhasBackdrop</code> - <code>{boolean=}</code>\n: Whether there should be an opaque backdrop behind the dialog. Default true.</li><li><code>clickOutsideToClose</code>\n - <code>{boolean=}</code>: Whether the user can click outside the dialog to close it. Default false.</li><li><code>\nescapeToClose</code> - <code>{boolean=}</code>: Whether the user can press escape to close the dialog. Default true.\n</li><li><code>focusOnOpen</code> - <code>{boolean=}</code>\n: An option to override focus behavior on open. Only disable if focusing some other way, as focus management is required for dialogs to be accessible. Defaults to true.\n</li><li><code>controller</code> - <code>{function|string=}</code>\n: The controller to associate with the dialog. The controller will be injected with the local <code>$mdDialog</code>\n, which passes along a scope for the dialog.</li><li><code>locals</code> - <code>{object=}</code>\n: An object containing key/value pairs. The keys will be used as names of values to inject into the controller. For example, \n<code>locals: {three: 3}</code> would inject <code>three</code> into the controller, with the value 3. If <code>\nbindToController</code> is true, they will be copied to the controller instead.</li><li><code>bindToController</code>\n - <code>bool</code>: bind the locals to the controller, instead of passing them in.</li><li><code>resolve</code> - \n<code>{object=}</code>\n: Similar to locals, except it takes promises as values, and the dialog will not open until all of the promises resolve.\n</li><li><code>controllerAs</code> - <code>{string=}</code>: An alias to assign the controller to on the scope.</li>\n<li><code>parent</code> - <code>{element=}</code>\n: The element to append the dialog to. Defaults to appending to the root element of the application.</li><li><code>\nonShowing</code> - <code>function(scope, element)</code>\n: Callback function used to announce the show() action is starting.</li><li><code>onComplete</code> - <code>\nfunction(scope, element)</code>: Callback function used to announce when the show() action is finished.</li><li><code>\nonRemoving</code> - <code>function(element, removePromise)</code>\n: Callback function used to announce the close/hide() action is starting. This allows developers to run custom animations in parallel the close animations.\n</li><li><code>fullscreen</code> <code>{boolean=}</code>\n: An option to toggle whether the dialog should show in fullscreen or not. Defaults to <code>false</code>.</li><li>\n<code>multiple</code> <code>{boolean=}</code>\n: An option to allow this dialog to display over one that&#39;s currently open.</li></ul></td></tr></tbody></table>\n<table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-promise\">promise</code></td><td class=\"description\"><p>\nA promise that can be resolved with <code>$mdDialog.hide()</code> or rejected with <code>$mdDialog.cancel()</code>.</p>\n</td></tr></tbody></table></div></li><li id=\"hide\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdDialog.hide([response]);</code></h3><div class=\"service-desc\"><p>\nHide an existing dialog and resolve the promise returned from <code>$mdDialog.show()</code>.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">response <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">*</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">*</code></td><td class=\"description\"><p>\nAn argument for the resolved promise.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns\n</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise\n</code></td><td class=\"description\"><p>A promise that is resolved when the dialog has been closed.</p></td></tr>\n</tbody></table></div></li><li id=\"cancel\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdDialog.cancel([response]);</code></h3><div class=\"service-desc\"><p>\nHide an existing dialog and reject the promise returned from <code>$mdDialog.show()</code>.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">response <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">*</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">*</code></td><td class=\"description\"><p>\nAn argument for the rejected promise.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns\n</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise\n</code></td><td class=\"description\"><p>A promise that is resolved when the dialog has been closed.</p></td></tr>\n</tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.divider/directive/mdDivider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nDividers group and separate content within lists and page layouts using strong visual and spatial distinctions. This divider is a thin rule, lightweight enough to not distract the user from content.\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-divider></md-divider>\n<md-divider md-inset></md-divider></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-inset <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nAdd this attribute to activate the inset divider style.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabSpeedDial/directive/mdFabSpeedDial.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-fab-speed-dial&gt;</code>\n directive is used to present a series of popup elements (usually <code>&lt;md-button&gt;</code>\ns) for quick access to common actions.</p><p>\nThere are currently two animations available by applying one of the following classes to the component:</p><ul><li>\n<code>md-fling</code>\n - The speed dial items appear from underneath the trigger and move into their appropriate positions.</li><li><code>\nmd-scale</code> - The speed dial items appear in their proper places by scaling from 0% to 100%.</li></ul><p>\nYou may also easily position the trigger by applying one one of the following classes to the <code>\n&lt;md-fab-speed-dial&gt;</code> element:</p><ul><li><code>md-fab-top-left</code></li><li><code>md-fab-top-right</code>\n</li><li><code>md-fab-bottom-left</code></li><li><code>md-fab-bottom-right</code></li></ul><p>These CSS classes use \n<code>position: absolute</code>, so you need to ensure that the container element also uses <code>position: absolute\n</code> or <code>position: relative</code> in order for them to work.</p><p>Additionally, you may use the standard \n<code>ng-mouseenter</code> and <code>ng-mouseleave</code>\n directives to open or close the speed dial. However, if you wish to allow users to hover over the empty space where the actions will appear, you must also add the \n<code>md-hover-full</code>\n class to the speed dial element. Without this, the hover effect will only occur on top of the trigger.</p><p>\nSee the demos for more information.</p><h2 id=\"troubleshooting\">Troubleshooting</h2><p>\nIf your speed dial shows the closing animation upon launch, you may need to use <code>ng-cloak</code>\n on the parent container to ensure that it is only visible once ready. We have plans to remove this necessity in the future.\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-fab-speed-dial \nmd-direction=\"up\" class=\"md-fling\"><md-fab-trigger><md-button aria-label=\"Add...\"><md-icon \nmd-svg-src=\"/assets/angular-material-assets/img/icons/plus.svg\"></md-icon></md-button></md-fab-trigger><md-fab-actions>\n<md-button aria-label=\"Add User\"><md-icon md-svg-src=\"/assets/angular-material-assets/img/icons/user.svg\"></md-icon>\n</md-button><md-button aria-label=\"Add Group\"><md-icon \nmd-svg-src=\"/assets/angular-material-assets/img/icons/group.svg\"></md-icon></md-button></md-fab-actions>\n</md-fab-speed-dial></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\">\n<table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-direction</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nFrom which direction you would like the speed dial to appear relative to the trigger element.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-open <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nProgrammatically control whether or not the speed-dial is visible.</p></td></tr></tbody></table></div></div></div>\n</div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabActions/directive/mdFabActions.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-fab-actions&gt;</code> directive is used inside of a <code>\n&lt;md-fab-speed-dial&gt;</code> or <code>&lt;md-fab-toolbar&gt;</code>\n directive to mark an element (or elements) as the actions and setup the proper event listeners.</p></div><div><section\n class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>See the <code>&lt;md-fab-speed-dial&gt;</code> or <code>\n&lt;md-fab-toolbar&gt;</code> directives for example usage.</p></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabToolbar/directive/mdFabToolbar.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-fab-toolbar&gt;</code>\n directive is used to present a toolbar of elements (usually <code>&lt;md-button&gt;</code>\ns) for quick access to common actions when a floating action button is activated (via click or keyboard navigation).\n</p><p>You may also easily position the trigger by applying one one of the following classes to the <code>\n&lt;md-fab-toolbar&gt;</code> element:</p><ul><li><code>md-fab-top-left</code></li><li><code>md-fab-top-right</code>\n</li><li><code>md-fab-bottom-left</code></li><li><code>md-fab-bottom-right</code></li></ul><p>These CSS classes use \n<code>position: absolute</code>, so you need to ensure that the container element also uses <code>position: absolute\n</code> or <code>position: relative</code> in order for them to work.</p></div><div><section class=\"api-section\"><h2 \nid=\"Usage\">Usage</h2><hljs lang=\"html\"><md-fab-toolbar md-direction=\"left\"><md-fab-trigger><md-button \naria-label=\"Add...\"><md-icon md-svg-src=\"/assets/angular-material-assets/img/icons/plus.svg\"></md-icon></md-button>\n</md-fab-trigger><md-toolbar><md-fab-actions><md-button aria-label=\"Add User\"><md-icon \nmd-svg-src=\"/assets/angular-material-assets/img/icons/user.svg\"></md-icon></md-button><md-button \naria-label=\"Add Group\"><md-icon md-svg-src=\"/assets/angular-material-assets/img/icons/group.svg\"></md-icon></md-button>\n</md-fab-actions></md-toolbar></md-fab-toolbar></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-direction</b> <span hide show-sm>\n<code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nFrom which direction you would like the toolbar items to appear relative to the trigger element. Supports <code>left\n</code> and <code>right</code> directions.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">\nmd-open <span hide show-sm><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td\n style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td \nclass=\"description\"><p>Programmatically control whether or not the toolbar is visible.</p></td></tr></tbody></table>\n</div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.gridList/directive/mdGridList.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nGrid lists are an alternative to standard list views. Grid lists are distinct from grids used for layouts and other visual presentations.\n</p><p>\nA grid list is best suited to presenting a homogenous data type, typically images, and is optimized for visual comprehension and differentiating between like data types.\n</p><p>\nA grid list is a continuous element consisting of tessellated, regular subdivisions called cells that contain tiles (\n<code>md-grid-tile</code>).</p><p><img \nsrc=\"//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7OVlEaXZ5YmU1Xzg/components_grids_usage2.png\" \nstyle=\"width: 300px; height: auto; margin-right: 16px\" alt=\"Concept of grid explained visually\"> <img \nsrc=\"//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7VGhsOE5idWlJWXM/components_grids_usage3.png\" \nstyle=\"width: 300px; height: auto\" alt=\"Grid concepts legend\"></p><p>\nCells are arrayed vertically and horizontally within the grid.</p><p>\nTiles hold content and can span one or more cells vertically or horizontally.</p><h3 id=\"responsive-attributes\">\nResponsive Attributes</h3><p>The <code>md-grid-list</code>\n directive supports &quot;responsive&quot; attributes, which allow different <code>md-cols</code>, <code>md-gutter\n</code> and <code>md-row-height</code> values depending on the currently matching media query.</p><p>\nIn order to set a responsive attribute, first define the fallback value with the standard attribute name, then add additional attributes with the following convention: \n<code>{base-attribute-name}-{media-query-name}=&quot;{value}&quot;</code> (ie. <code>md-cols-lg=&quot;8&quot;</code>)\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>Basic:</p><hljs lang=\"html\"><md-grid-list \nmd-cols=\"5\" md-gutter=\"1em\" md-row-height=\"4:3\"><md-grid-tile></md-grid-tile></md-grid-list></hljs><p>\nFixed-height rows:</p><hljs lang=\"html\"><md-grid-list md-cols=\"4\" md-row-height=\"200px\" ...><md-grid-tile>\n</md-grid-tile></md-grid-list></hljs><p>Fit rows:</p><hljs lang=\"html\"><md-grid-list md-cols=\"4\" md-row-height=\"fit\" \nstyle=\"height: 400px\" ...><md-grid-tile></md-grid-tile></md-grid-list></hljs><p>Using responsive attributes:</p><hljs \nlang=\"html\"><md-grid-list md-cols-sm=\"2\" md-cols-md=\"4\" md-cols-lg=\"8\" md-cols-gt-lg=\"12\" ...><md-grid-tile>\n</md-grid-tile></md-grid-list></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-cols</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nNumber of columns in the grid.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>\n* md-row-height</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span>\n</td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>One of</p><ul><li>CSS length - Fixed height rows (eg. <code>8px</code> or <code>1rem</code>)\n</li><li><code>{width}:{height}</code> - Ratio of width to height (eg. <code>md-row-height=&quot;16:9&quot;</code>)\n</li><li><code>&quot;fit&quot;</code>\n - Height will be determined by subdividing the available height by the number of rows</li></ul></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-gutter <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThe amount of space between tiles in CSS units (default 1px)</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-on-layout <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nExpression to evaluate after layout. Event object is available as <code>$event</code>\n, and contains performance information.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.gridList/directive/mdGridTile.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>Tiles contain the content of an <code>md-grid-list</code>\n. They span one or more grid cells vertically or horizontally, and use <code>md-grid-tile-{footer,header}</code>\n to display secondary content.</p><h3 id=\"responsive-attributes\">Responsive Attributes</h3><p>The <code>md-grid-tile\n</code> directive supports &quot;responsive&quot; attributes, which allow different <code>md-rowspan</code> and <code>\nmd-colspan</code> values depending on the currently matching media query.</p><p>\nIn order to set a responsive attribute, first define the fallback value with the standard attribute name, then add additional attributes with the following convention: \n<code>{base-attribute-name}-{media-query-name}=&quot;{value}&quot;</code> (ie. <code>md-colspan-sm=&quot;4&quot;</code>\n)</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>With header:</p><hljs lang=\"html\">\n<md-grid-tile><md-grid-tile-header><h3>This is a header</h3></md-grid-tile-header></md-grid-tile></hljs><p>With footer:\n</p><hljs lang=\"html\"><md-grid-tile><md-grid-tile-footer><h3>This is a footer</h3></md-grid-tile-footer></md-grid-tile>\n</hljs><p>Spanning multiple rows/columns:</p><hljs lang=\"html\"><md-grid-tile md-colspan=\"2\" md-rowspan=\"3\">\n</md-grid-tile></hljs><p>Responsive attributes:</p><hljs lang=\"html\"><md-grid-tile md-colspan=\"1\" md-colspan-sm=\"3\" \nmd-colspan-md=\"5\"></md-grid-tile></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-colspan <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nThe number of columns to span (default 1). Cannot exceed the number of columns in the grid. Supports interpolation.</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-rowspan <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nThe number of rows to span (default 1). Supports interpolation.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.menuBar/directive/mdMenuBar.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nMenu bars are containers that hold multiple menus. They change the behavior and appearence of the <code>md-menu</code>\n directive to behave similar to an operating system provided menu.</p></div><div><section class=\"api-section\"><h2 \nid=\"Usage\">Usage</h2><hljs lang=\"html\"><md-menu-bar><md-menu><button ng-click=\"$mdMenu.open()\">File</button>\n<md-menu-content><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'share\', $event)\">Share...</md-button>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-menu-item><md-menu><md-button \nng-click=\"$mdMenu.open()\">New</md-button><md-menu-content><md-menu-item><md-button \nng-click=\"ctrl.sampleAction(\'New Document\', $event)\">Document</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"ctrl.sampleAction(\'New Spreadsheet\', $event)\">Spreadsheet</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"ctrl.sampleAction(\'New Presentation\', $event)\">Presentation</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"ctrl.sampleAction(\'New Form\', $event)\">Form</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"ctrl.sampleAction(\'New Drawing\', $event)\">Drawing</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item></md-menu-item></md-menu-content></md-menu></md-menu-bar></hljs><h2 id=\"menu-bar-controls\">\nMenu Bar Controls</h2><p>You may place <code>md-menu-items</code>\n that function as controls within menu bars. There are two modes that are exposed via the <code>type</code>\n attribute of the <code>md-menu-item</code>. <code>type=&quot;checkbox&quot;</code>\n will function as a boolean control for the <code>ng-model</code> attribute of the <code>md-menu-item</code>. <code>\ntype=&quot;radio&quot;</code> will function like a radio button, setting the <code>ngModel</code> to the <code>string\n</code> value of the <code>value</code> attribute. If you need non-string values, you can use <code>ng-value</code>\n to provide an expression (this is similar to how angular&#39;s native <code>input[type=radio]</code> works.</p><hljs \nlang=\"html\"><md-menu-bar><md-menu><button ng-click=\"$mdMenu.open()\">Sample Menu</button><md-menu-content><md-menu-item \ntype=\"checkbox\" ng-model=\"settings.allowChanges\">Allow changes</md-menu-item><md-menu-divider></md-menu-divider>\n<md-menu-item type=\"radio\" ng-model=\"settings.mode\" ng-value=\"1\">Mode 1</md-menu-item><md-menu-item type=\"radio\" \nng-model=\"settings.mode\" ng-value=\"1\">Mode 2</md-menu-item><md-menu-item type=\"radio\" ng-model=\"settings.mode\" \nng-value=\"1\">Mode 3</md-menu-item></md-menu-content></md-menu></md-menu-bar></hljs><h3 id=\"nesting-menus\">Nesting Menus\n</h3><p>\nMenus may be nested within menu bars. This is commonly called cascading menus. To nest a menu place the nested menu inside the content of the \n<code>md-menu-item</code>.</p><hljs lang=\"html\"><md-menu-item><md-menu><button ng-click=\"$mdMenu.open()\">New\n<md-menu-content><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Document\', $event)\">Document</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Spreadsheet\', $event)\">Spreadsheet</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Presentation\', $event)\">Presentation\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Form\', $event)\">Form</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Drawing\', $event)\">Drawing</md-button>\n</md-menu-item></md-menu-content></button></md-menu></md-menu-item></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.icon/directive/mdIcon.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>md-icon</code>\n directive makes it easier to use vector-based icons in your app (as opposed to raster-based icons types like PNG). The directive supports both icon fonts and SVG icons.\n</p><p>Icons should be considered view-only elements that should not be used directly as buttons; instead nest a <code>\n&lt;md-icon&gt;</code> inside a <code>md-button</code> to add hover and click features.</p><h3 id=\"icon-fonts\">\nIcon fonts</h3><p>\nIcon fonts are a technique in which you use a font where the glyphs in the font are your icons instead of text. Benefits include a straightforward way to bundle everything into a single HTTP request, simple scaling, easy color changing, and more.\n</p><p><code>md-icon</code>\n lets you consume an icon font by letting you reference specific icons in that font by name rather than character code.\n</p><h3 id=\"svg\">SVG</h3><p>For SVGs, the problem with using <code>&lt;img&gt;</code> or a CSS <code>background-image\n</code>\n is that you can&#39;t take advantage of some SVG features, such as styling specific parts of the icon with CSS or SVG animation.\n</p><p><code>md-icon</code> makes it easier to use SVG icons by <em>inlining</em> the SVG into an <code>&lt;svg&gt;\n</code>\n element in the document. The most straightforward way of referencing an SVG icon is via URL, just like a traditional \n<code>&lt;img&gt;</code>. <code>$mdIconProvider</code>, as a convenience, lets you <em>name</em>\n an icon so you can reference it by name instead of URL throughout your templates.</p><p>\nAdditionally, you may not want to make separate HTTP requests for every icon, so you can bundle your SVG icons together and pre-load them with $mdIconProvider as an icon set. An icon set can also be given a name, which acts as a namespace for individual icons, so you can reference them like \n<code>&quot;social:cake&quot;</code>.</p><p>\nWhen using SVGs, both external SVGs (via URLs) or sets of SVGs [from icon sets] can be easily loaded and used. When using font-icons, developers must follow three (3) simple steps:\n</p><ol><li>Load the font library. e.g.<br><code>\n&lt;link href=&quot;https://fonts.googleapis.com/icon?family=Material+Icons&quot; rel=&quot;stylesheet&quot;&gt;</code>\n</li><li>\nUse either (a) font-icon class names or (b) a fontset and a font ligature to render the font glyph by using its textual name \n<em>or</em> numerical character reference. Note that <code>material-icons</code>\n is the default fontset when none is specified.</li><li>Use any of the following templates:<br><ul><li><code>\n&lt;md-icon md-font-icon=&quot;classname&quot;&gt;&lt;/md-icon&gt;</code></li><li><code>\n&lt;md-icon md-font-set=&quot;font library classname or alias&quot;&gt;textual_name&lt;/md-icon&gt;</code></li><li>\n<code>&lt;md-icon&gt; numerical_character_reference &lt;/md-icon&gt;</code></li><li><code>\n&lt;md-icon ng_bind=&quot;&#39;textual_name&#39;&quot;&gt;&lt;/md-icon&gt;</code></li><li><code>\n&lt;md-icon ng-bind=&quot;scopeVariable&quot;&gt;&lt;/md-icon&gt;</code></li></ul></li></ol><p>\nFull details for these steps can be found:</p><ul><li><a href=\"http://google.github.io/material-design-icons/\">\nhttp://google.github.io/material-design-icons/</a></li><li><a \nhref=\"http://google.github.io/material-design-icons/#icon-font-for-the-web\">\nhttp://google.github.io/material-design-icons/#icon-font-for-the-web</a></li></ul><p>The Material Design icon style \n<code>.material-icons</code> and the icon font references are published in Material Design Icons:</p><ul><li><a \nhref=\"https://design.google.com/icons/\">https://design.google.com/icons/</a></li><li><a \nhref=\"https://design.google.com/icons/#ic_accessibility\">https://design.google.com/icons/#ic_accessibility</a></li>\n</ul><h3 id=\"localization\">Localization</h3><p>Because an <code>md-icon</code>\n element&#39;s text content is not intended to translated, it is recommended to declare the text content for an <code>\nmd-icon</code> element in its start tag. Instead of using the HTML text content, consider using <code>ng-bind</code>\n with a scope variable or literal string.</p><p>Examples:</p><ul><li><code>\n&lt;md-icon ng-bind=&quot;myIconVariable&quot;&gt;&lt;/md-icon&gt;</code></li><li><code>\n&lt;md-icon ng-bind=&quot;&#39;menu&#39;&quot;&gt;&lt;/md-icon&gt;</code></li></ul><p></p><h2 \nid=\"material_design_icons\">Material Design Icons</h2>\nUsing the Material Design Icon-Selector, developers can easily and quickly search for a Material Design font-icon and determine its textual name and character reference code. Click on any icon to see the slide-up information panel with details regarding a SVG download or information on the font-icon usage.\n<p></p><p><a href=\"https://www.google.com/design/icons/#ic_accessibility\" target=\"_blank\" style=\"border-bottom:none\">\n<img src=\"https://cloud.githubusercontent.com/assets/210413/7902490/fe8dd14c-0780-11e5-98fb-c821cc6475e6.png\" \naria-label=\"Material Design Icon-Selector\" style=\"max-width:75%;padding-left:10%\"> </a></p><p><span \nclass=\"image_caption\">Click on the image above to link to the <a \nhref=\"https://design.google.com/icons/#ic_accessibility\" target=\"_blank\">Material Design Icon-Selector</a>. </span></p>\n</div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>When using SVGs:</p><hljs lang=\"html\"><md-icon \nmd-svg-icon=\"social:android\" aria-label=\"android \"></md-icon><md-icon md-svg-src=\"/android.svg\" aria-label=\"android \">\n</md-icon><md-icon md-svg-src=\"{{ getAndroid() }}\" aria-label=\"android \"></md-icon></hljs><p>Use the <code>\n$mdIconProvider</code> to configure your application with svg iconsets.</p><hljs lang=\"js\">\nangular.module(&#39;appSvgIconSets&#39;, [&#39;ngMaterial&#39;]) .controller(&#39;DemoCtrl&#39;, function($scope) {}) .config(function($mdIconProvider) { $mdIconProvider .iconSet(&#39;social&#39;, &#39;assets/angular-material-assets/img/icons/sets/social-icons.svg&#39;, 24) .defaultIconSet(&#39;assets/angular-material-assets/img/icons/sets/core-icons.svg&#39;, 24); });\n</hljs><p>When using Font Icons with classnames:</p><hljs lang=\"html\"><md-icon md-font-icon=\"android\" \naria-label=\"android\"></md-icon><md-icon class=\"icon_home\" aria-label=\"Home\"></md-icon></hljs><p>\nWhen using Material Font Icons with ligatures:</p><hljs lang=\"html\"><md-icon>face</md-icon><md-icon \nmd-font-set=\"material-icons\">face</md-icon><md-icon>&#xE87C;</md-icon><md-icon class=\"material-icons md-light md-48\">\nface</md-icon></hljs><p>When using other Font-Icon libraries:</p><hljs lang=\"js\">\n// Specify a font-icon style alias angular.config(function($mdIconProvider) { $mdIconProvider.fontSet(&#39;md&#39;, &#39;material-icons&#39;); });\n</hljs><hljs lang=\"html\"><md-icon md-font-set=\"md\">favorite</md-icon></hljs></section><div class=\"api-param-section\">\n<h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th>\n<th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-font-icon\n</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>\nString name of CSS icon associated with the font-face will be used to render the icon. Requires the fonts and the named CSS styles to be preloaded.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-font-set</b> <span hide show-sm><code\n class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nCSS style name associated with the font library; which will be assigned as the class for the font-icon ligature. This value may also be an alias that is used to lookup the classname; internally use \n<code>$mdIconProvider.fontSet(&lt;alias&gt;)</code> to determine the style name.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-svg-src</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nString URL (or expression) used to load, cache, and display an external SVG.</p></td></tr><tr class=\"api-params-item\">\n<td style=\"white-space: nowrap\"><b>* md-svg-icon</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nmd-svg-icon String name used for lookup of the icon from the internal cache; interpolated strings or expressions may also be used. Specific set names can be used with the syntax \n<code>&lt;set name&gt;:&lt;icon name&gt;</code>.<br><br>\nTo use icon sets, developers are required to pre-register the sets using the <code>$mdIconProvider</code> service.</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">aria-label <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nLabels icon for accessibility. If an empty string is provided, icon will be hidden from accessibility layer with <code>\naria-hidden=&quot;true&quot;</code>\n. If there&#39;s no aria-label on the icon nor a label on the parent element, a warning will be logged to the console.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">alt <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nLabels icon for accessibility. If an empty string is provided, icon will be hidden from accessibility layer with <code>\naria-hidden=&quot;true&quot;</code>\n. If there&#39;s no alt on the icon nor a label on the parent element, a warning will be logged to the console.</p>\n</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.icon/service/$mdIcon.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>$mdIcon</code> service is a function used to lookup SVG icons.</p></div>\n<div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">\nfunction SomeDirective($mdIcon) { // See if the icon has already been loaded, if not // then lookup the icon from the registry cache, load and cache // it for future requests. // NOTE: ID queries require configuration with $mdIconProvider $mdIcon(&#39;android&#39;).then(function(iconEl) { element.append(iconEl); }); $mdIcon(&#39;work:chair&#39;).then(function(iconEl) { element.append(iconEl); }); // Load and cache the external SVG using a URL $mdIcon(&#39;assets/angular-material-assets/img/icons/android.svg&#39;).then(function(iconEl) { element.append(iconEl); }); };\n</hljs><blockquote><p><b>Note:</b> The <code>&lt;md-icon&gt;</code> directive internally uses the <code>$mdIcon</code>\n service to query, loaded, and instantiate SVG DOM elements.</p></blockquote></section><section class=\"api-section\">\n<div class=\"api-param-section\"><h2>Arguments</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr>\n<th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* id</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>\nQuery value for a unique Id or URL. If the argument is a URL, then the service will retrieve the icon element from its internal cache or load the icon and cache it first. If the value is not a URL-type string, then an ID lookup is performed. The Id may be a unique icon ID or may include an iconSet ID prefix.\n</p><p>For the <strong>id</strong>\n query to work properly, this means that all id-to-URL mappings must have been previously configured using the <code>\n$mdIconProvider</code>.</p></td></tr></tbody></table></div></div><section class=\"api-section\"></section><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody>\n<tr><td><code class=\"api-type label type-hint type-hint-angular\">angular.$q.Promise</code></td><td class=\"description\">\n<p>\nA promise that gets resolved to a clone of the initial SVG DOM element; which was created from the SVG markup in the SVG data file. If an error occurs (e.g. the icon cannot be found) the promise will get rejected.\n</p></td></tr></tbody></table></div></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.icon/service/$mdIconProvider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>$mdIconProvider</code>\n is used only to register icon IDs with URLs. These configuration features allow icons and icon sets to be pre-registered and associated with source URLs \n<strong>before</strong> the <code>&lt;md-icon /&gt;</code> directives are compiled.</p><p>\nIf using font-icons, the developer is responsible for loading the fonts.</p><p>\nIf using SVGs, loading of the actual svg files are deferred to on-demand requests and are loaded internally by the \n<code>$mdIcon</code> service using the <code>$templateRequest</code> service. When an SVG is requested by name/ID, the \n<code>$mdIcon</code>\n service searches its registry for the associated source URL; that URL is used to on-demand load and parse the SVG dynamically.\n</p><p>The <code>$templateRequest</code> service expects the icons source to be loaded over trusted URLs.<br>\nThis means, when loading icons from an external URL, you have to trust the URL in the <code>$sceDelegateProvider</code>\n.</p><hljs lang=\"js\">\napp.config(function($sceDelegateProvider) { $sceDelegateProvider.resourceUrlWhitelist([ // Adding &#39;self&#39; to the whitelist, will allow requests from the current origin. &#39;self&#39;, // Using double asterisks here, will allow all URLs to load. // We recommend to only specify the given domain you want to allow. &#39;**&#39; ]); });\n</hljs><p>Read more about the <a href=\"https://docs.angularjs.org/api/ng/provider/$sceDelegateProvider\">\n$sceDelegateProvider</a>.</p><p><strong>Notice:</strong>\n Most font-icons libraries do not support ligatures (for example <code>fontawesome</code>).<br>\nIn such cases you are not able to use the icon&#39;s ligature name - Like so:</p><hljs lang=\"html\"><md-icon \nmd-font-set=\"fa\">fa-bell</md-icon></hljs><p>You should instead use the given unicode, instead of the ligature name.</p>\n<p></p><p ng-hide=\"true\">##// Notice we can&#39;t use a hljs element here, because the characters will be escaped.</p>\n<p></p><pre><code class=\"lang-html\">&lt;md-icon md-font-set=&quot;fa&quot;&gt;&amp;#xf0f3&lt;/md-icon&gt;\n</code></pre>\n<p>All unicode ligatures are prefixed with the <code>&amp;#x</code> string.</p></div><div><section class=\"api-section\">\n<h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">\napp.config(function($mdIconProvider) { // Configure URLs for icons specified by [set:]id. $mdIconProvider .defaultFontSet( &#39;fa&#39; ) // This sets our default fontset className. .defaultIconSet(&#39;my/app/icons.svg&#39;) // Register a default set of SVG icons .iconSet(&#39;social&#39;, &#39;my/app/social.svg&#39;) // Register a named icon set of SVGs .icon(&#39;android&#39;, &#39;my/app/android.svg&#39;) // Register a specific icon (by name) .icon(&#39;work:chair&#39;, &#39;my/app/chair.svg&#39;); // Register icon in a specific set });\n</hljs><p>\nSVG icons and icon sets can be easily pre-loaded and cached using either (a) a build process or (b) a runtime <strong>\nstartup</strong> process (shown below):</p><hljs lang=\"js\">\napp.config(function($mdIconProvider) { // Register a default set of SVG icon definitions $mdIconProvider.defaultIconSet(&#39;my/app/icons.svg&#39;) }) .run(function($templateRequest){ // Pre-fetch icons sources by URL and cache in the $templateCache... // subsequent $templateRequest calls will look there first. var urls = [ &#39;imy/app/icons.svg&#39;, &#39;assets/angular-material-assets/img/icons/android.svg&#39;]; angular.forEach(urls, function(url) { $templateRequest(url); }); });\n</hljs><blockquote><p><b>Note:</b> The loaded SVG data is subsequently cached internally for future requests.</p>\n</blockquote></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"icon\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdIconProvider.icon(id, url, [viewBoxSize]);\n</code></h3><div class=\"service-desc\"><p>\nRegister a source URL for a specific icon name; the name may include optional &#39;icon set&#39; name prefix. These icons will later be retrieved from the cache using \n<code>$mdIcon( &lt;icon name&gt; )</code></p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead>\n<tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* id</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>Icon name/id used to register the icon</p></td></tr><tr class=\"api-params-item\">\n<td style=\"white-space: nowrap\"><b>* url</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nspecifies the external location for the data file. Used internally by <code>$templateRequest</code>\n to load the data or as part of the lookup in <code>$templateCache</code> if pre-loading was configured.</p></td></tr>\n<tr class=\"api-params-item\"><td style=\"white-space: nowrap\">viewBoxSize <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nSets the width and height the icon&#39;s viewBox. It is ignored for icons with an existing viewBox. Default size is 24.\n</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>an <code>\n$mdIconProvider</code> reference; used to support method call chains for the API</p></td></tr></tbody></table></div>\n</li><li id=\"iconSet\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdIconProvider.iconSet(id, url, [viewBoxSize]);</code></h3><div class=\"service-desc\"><p>\nRegister a source URL for a &#39;named&#39; set of icons; group of SVG definitions where each definition has an icon id. Individual icons can be subsequently retrieved from this cached set using \n<code>$mdIcon(&lt;icon set name&gt;:&lt;icon name&gt;)</code></p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* id</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nIcon name/id used to register the iconset</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>\n* url</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>specifies the external location for the data file. Used internally by <code>$templateRequest\n</code> to load the data or as part of the lookup in <code>$templateCache</code> if pre-loading was configured.</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">viewBoxSize <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nSets the width and height of the viewBox of all icons in the set. It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size. Default value is 24.\n</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>an <code>\n$mdIconProvider</code> reference; used to support method call chains for the API</p></td></tr></tbody></table></div>\n</li><li id=\"defaultIconSet\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdIconProvider.defaultIconSet(url, [viewBoxSize]);</code></h3><div class=\"service-desc\"><p>\nRegister a source URL for the default &#39;named&#39; set of icons. Unless explicitly registered, subsequent lookups of icons will failover to search this &#39;default&#39; icon set. Icon can be retrieved from this cached, default set using \n<code>$mdIcon(&lt;name&gt;)</code></p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* url</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>specifies the external location for the data file. Used internally by <code>\n$templateRequest</code> to load the data or as part of the lookup in <code>$templateCache</code>\n if pre-loading was configured.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">viewBoxSize \n<span hide show-sm><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td \nclass=\"description\"><p>\nSets the width and height of the viewBox of all icons in the set. It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size. Default value is 24.\n</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>an <code>\n$mdIconProvider</code> reference; used to support method call chains for the API</p></td></tr></tbody></table></div>\n</li><li id=\"defaultFontSet\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdIconProvider.defaultFontSet(name);</code></h3><div class=\"service-desc\"><p>\nWhen using Font-Icons, AngularJS Material assumes the the Material Design icons will be used and automatically configures the default font-set == &#39;material-icons&#39;. Note that the font-set references the font-icon library class style that should be applied to the \n<code>&lt;md-icon&gt;</code>.</p><p>Configuring the default means that the attributes <code>\nmd-font-set=&quot;material-icons&quot;</code> or <code>class=&quot;material-icons&quot;</code>\n do not need to be explicitly declared on the <code>&lt;md-icon&gt;</code> markup. For example:</p><p><code>\n&lt;md-icon&gt; face &lt;/md-icon&gt;</code> will render as <code>\n&lt;span class=&quot;material-icons&quot;&gt; face &lt;/span&gt;</code>, and</p><p><code>\n&lt;md-icon md-font-set=&quot;fa&quot;&gt; face &lt;/md-icon&gt;</code> will render as <code>\n&lt;span class=&quot;fa&quot;&gt; face &lt;/span&gt;</code></p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* name</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nof the font-library style that should be applied to the md-icon DOM element</p></td></tr></tbody></table></div></li><li\n id=\"fontSet\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdIconProvider.fontSet(alias, className);</code></h3><div class=\"service-desc\"><p>When using a font set for <code>\n&lt;md-icon&gt;</code> you must specify the correct font classname in the <code>md-font-set</code>\n attribute. If the fonset className is really long, your markup may become cluttered... an easy solution is to define an \n<code>alias</code> for your fontset:</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr>\n<th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* alias</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>of the specified fontset.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* className</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>of the fontset.</p></td>\n</tr></tbody></table></div></li><li id=\"defaultViewBoxSize\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdIconProvider.defaultViewBoxSize([viewBoxSize]);</code></h3><div class=\"service-desc\">\n<p>While <code>&lt;md-icon /&gt;</code>\n markup can also be style with sizing CSS, this method configures the default width <strong>and</strong>\n height used for all icons; unless overridden by specific CSS. The default sizing is (24px, 24px).</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">viewBoxSize <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nSets the width and height of the viewBox for an icon or an icon set. All icons in a set should be the same size. The default value is 24.\n</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>an <code>\n$mdIconProvider</code> reference; used to support method call chains for the API</p></td></tr></tbody></table></div>\n</li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.list/directive/mdList.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-list&gt;</code> directive is a list container for 1..n <code>\n&lt;md-list-item&gt;</code> tags.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs \nlang=\"html\"><md-list><md-list-item class=\"md-2-line\" ng-repeat=\"item in todos\"><md-checkbox ng-model=\"item.done\">\n</md-checkbox><div class=\"md-list-item-text\"><h3>{{item.title}}</h3><p>{{item.description}}</p></div></md-list-item>\n</md-list></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.list/directive/mdListItem.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>A <code>md-list-item</code>\n element can be used to represent some information in a row.<br></p></div><div><section class=\"api-section\"><h2 \nid=\"Usage\">Usage</h2><h3 id=\"single-row-item\">Single Row Item</h3><hljs lang=\"html\"><md-list-item><span>Single Row Item\n</span></md-list-item></hljs><h3 id=\"multiple-lines\">Multiple Lines</h3><p>\nBy using the following markup, you will be able to have two lines inside of one <code>md-list-item</code>.</p><hljs \nlang=\"html\"><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><p>First Line</p><p>\nSecond Line</p></div></md-list-item></hljs><p>It is also possible to have three lines inside of one list item.</p><hljs\n lang=\"html\"><md-list-item class=\"md-3-line\"><div class=\"md-list-item-text\" layout=\"column\"><p>First Line</p><p>\nSecond Line</p><p>Third Line</p></div></md-list-item></hljs><h3 id=\"secondary-items\">Secondary Items</h3><p>\nSecondary items are elements which will be aligned at the end of the <code>md-list-item</code>.</p><hljs lang=\"html\">\n<md-list-item><span>Single Row Item</span><md-button class=\"md-secondary\">Secondary Button</md-button></md-list-item>\n</hljs><p>It also possible to have multiple secondary items inside of one <code>md-list-item</code>.</p><hljs \nlang=\"html\"><md-list-item><span>Single Row Item</span><md-button class=\"md-secondary\">First Button</md-button>\n<md-button class=\"md-secondary\">Second Button</md-button></md-list-item></hljs><h3 id=\"proxy-item\">Proxy Item</h3><p>\nProxies are elements, which will execute their specific action on click<br>Currently supported proxy items are</p><ul>\n<li><code>md-checkbox</code> (Toggle)</li><li><code>md-switch</code> (Toggle)</li><li><code>md-menu</code> (Open)</li>\n</ul><p>This means, when using a supported proxy item inside of <code>md-list-item</code>\n, the list item will automatically become clickable and executes the associated action of the proxy element on click.\n</p><p>It is possible to disable this behavior by applying the <code>md-no-proxy</code> class to the list item.</p>\n<hljs lang=\"html\"><md-list-item class=\"md-no-proxy\"><span>No Proxy List</span><md-checkbox class=\"md-secondary\">\n</md-checkbox></md-list-item></hljs><p>Here are a few examples of proxy elements inside of a list item.</p><hljs \nlang=\"html\"><md-list-item><span>First Line</span><md-checkbox class=\"md-secondary\"></md-checkbox></md-list-item></hljs>\n<p>The <code>md-checkbox</code> element will be automatically detected as a proxy element and will toggle on click.</p>\n<hljs lang=\"html\"><md-list-item><span>First Line</span><md-switch class=\"md-secondary\"></md-switch></md-list-item>\n</hljs><p>The recognized <code>md-switch</code> will toggle its state, when the user clicks on the <code>md-list-item\n</code>.</p><p>It is also possible to have a <code>md-menu</code> inside of a <code>md-list-item</code>.</p><hljs \nlang=\"html\"><md-list-item><p>Click anywhere to fire the secondary action</p><md-menu class=\"md-secondary\"><md-button \nclass=\"md-icon-button\"><md-icon md-svg-icon=\"communication:message\"></md-icon></md-button><md-menu-content width=\"4\">\n<md-menu-item><md-button>Redial</md-button></md-menu-item><md-menu-item><md-button>Check voicemail</md-button>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button>Notifications</md-button></md-menu-item>\n</md-menu-content></md-menu></md-list-item></hljs><p>The menu will automatically open, when the users clicks on the \n<code>md-list-item</code>.<br></p><p>If the developer didn&#39;t specify any position mode on the menu, the <code>\nmd-list-item</code> will automatically detect the position mode and applies it to the <code>md-menu</code>.</p><h3 \nid=\"avatars\">Avatars</h3><p>Sometimes you may want to have some avatars inside of the <code>md-list-item</code>.<br>\nYou are able to create a optimized icon for the list item, by applying the <code>.md-avatar</code> class on the <code>\n&lt;img&gt;</code> element.</p><hljs lang=\"html\"><md-list-item><img src=\"my-avatar.png\" class=\"md-avatar\"> <span>\nAlan Turing</span></md-list-item></hljs><p>When using <code>&lt;md-icon&gt;</code> for an avatar, you have to use the \n<code>.md-avatar-icon</code> class.</p><hljs lang=\"html\"><md-list-item><md-icon class=\"md-avatar-icon\" \nmd-svg-icon=\"avatars:timothy\"></md-icon><span>Timothy Kopra</span></md-list-item></hljs><p>In cases, you have a <code>\nmd-list-item</code>\n, which doesn&#39;t have any avatar, but you want to align it with the other avatar items, you have to use the <code>\n.md-offset</code> class.</p><hljs lang=\"html\"><md-list-item class=\"md-offset\"><span>Jon Doe</span></md-list-item>\n</hljs><h3 id=\"dom-modification\">DOM modification</h3><p>The <code>md-list-item</code>\n component automatically detects if the list item should be clickable.</p><hr><p>If the <code>md-list-item</code>\n is clickable, we wrap all content inside of a <code>&lt;div&gt;</code>\n and create an overlaying button, which will will execute the given actions (like <code>ng-href</code>, <code>ng-click\n</code>)</p><p>\nWe create an overlaying button, instead of wrapping all content inside of the button, because otherwise some elements may not be clickable inside of the button.\n</p><hr><p>When using a secondary item inside of your list item, the <code>md-list-item</code>\n component will automatically create a secondary container at the end of the <code>md-list-item</code>\n, which contains all secondary items.</p><p>\nThe secondary item container is not static, because otherwise the overflow will not work properly on the list item.</p>\n</section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.menu/directive/mdMenu.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nMenus are elements that open when clicked. They are useful for displaying additional options within the context of an action.\n</p><p>Every <code>md-menu</code>\n must specify exactly two child elements. The first element is what is left in the DOM and is used to open the menu. This element is called the trigger element. The trigger element&#39;s scope has access to \n<code>$mdMenu.open($event)</code>\n which it may call to open the menu. By passing $event as argument, the corresponding event is stopped from propagating up the DOM-tree. Similarly, \n<code>$mdMenu.close()</code> can be used to close the menu.</p><p>The second element is the <code>md-menu-content\n</code> element which represents the contents of the menu when it is open. Typically this will contain <code>\nmd-menu-item</code>s, but you can do custom content as well.</p><hljs lang=\"html\"><md-menu><md-button \nng-click=\"$mdMenu.open($event)\" class=\"md-icon-button\" aria-label=\"Open sample menu\"><md-icon md-svg-icon=\"call:phone\">\n</md-icon></md-button><md-menu-content><md-menu-item><md-button ng-click=\"doSomething()\">Do Something</md-button>\n</md-menu-item></md-menu-content></md-menu></hljs><h2 id=\"sizing-menus\">Sizing Menus</h2><p>\nThe width of the menu when it is open may be specified by specifying a <code>width</code> attribute on the <code>\nmd-menu-content</code> element. See the <a href=\"https://material.google.com/components/menus.html#menus-simple-menus\">\nMaterial Design Spec</a> for more information.</p><h2 id=\"aligning-menus\">Aligning Menus</h2><p>\nWhen a menu opens, it is important that the content aligns with the trigger element. Failure to align menus can result in jarring experiences for users as content suddenly shifts. To help with this, \n<code>md-menu</code> provides serveral APIs to help with alignment.</p><h3 id=\"target-mode\">Target Mode</h3><p>\nBy default, <code>md-menu</code> will attempt to align the <code>md-menu-content</code>\n by aligning designated child elements in both the trigger and the menu content.</p><p>\nTo specify the alignment element in the <code>trigger</code> you can use the <code>md-menu-origin</code>\n attribute on a child element. If no <code>md-menu-origin</code> is specified, the <code>md-menu</code>\n will be used as the origin element.</p><p>Similarly, the <code>md-menu-content</code> may specify a <code>\nmd-menu-align-target</code> for a <code>md-menu-item</code> to specify the node that it should try and align with.</p>\n<p>\nIn this example code, we specify an icon to be our origin element, and an icon in our menu content to be our alignment target. This ensures that both icons are aligned when the menu opens.\n</p><hljs lang=\"html\"><md-menu><md-button ng-click=\"$mdMenu.open($event)\" class=\"md-icon-button\" \naria-label=\"Open some menu\"><md-icon md-menu-origin md-svg-icon=\"call:phone\"></md-icon></md-button><md-menu-content>\n<md-menu-item><md-button ng-click=\"doSomething()\" aria-label=\"Do something\"><md-icon md-menu-align-target \nmd-svg-icon=\"call:phone\"></md-icon>Do Something</md-button></md-menu-item></md-menu-content></md-menu></hljs><p>\nSometimes we want to specify alignment on the right side of an element, for example if we have a menu on the right side a toolbar, we want to right align our menu content.\n</p><p>We can specify the origin by using the <code>md-position-mode</code> attribute on both the <code>x</code> and \n<code>y</code> axis. Right now only the <code>x-axis</code>\n has more than one option. You may specify the default mode of <code>target target</code> or <code>target-right target\n</code> to specify a right-oriented alignment target. See the position section of the demos for more examples.</p><h3 \nid=\"menu-offsets\">Menu Offsets</h3><p>\nIt is sometimes unavoidable to need to have a deeper level of control for the positioning of a menu to ensure perfect alignment. \n<code>md-menu</code> provides the <code>md-offset</code>\n attribute to allow pixel level specificty of adjusting the exact positioning.</p><p>\nThis offset is provided in the format of <code>x y</code> or <code>n</code> where <code>n</code>\n will be used in both the <code>x</code> and <code>y</code> axis.</p><p>For example, to move a menu by <code>2px</code>\n down from the top, we can use:</p><hljs lang=\"html\"><md-menu md-offset=\"0 2\"></md-menu></hljs><h3 id=\"auto-focus\">\nAuto Focus</h3><p>By default, when a menu opens, <code>md-menu</code> focuses the first button in the menu content.</p>\n<p>But sometimes you would like to focus another specific menu item instead of the first.<br>\nThis can be done by applying the <code>md-autofocus</code> directive on the given element.</p><hljs lang=\"html\">\n<md-menu-item><md-button md-autofocus ng-click=\"doSomething()\">Auto Focus</md-button></md-menu-item></hljs><h3 \nid=\"preventing-close\">Preventing close</h3><p>\nSometimes you would like to be able to click on a menu item without having the menu close. To do this, AngularJS Material exposes the \n<code>md-prevent-menu-close</code>\n attribute which can be added to a button inside a menu to stop the menu from automatically closing. You can then close the menu either by using \n<code>$mdMenu.close()</code> in the template, or programatically by injecting <code>$mdMenu</code> and calling <code>\n$mdMenu.hide()</code>.</p><hljs lang=\"html\"><md-menu-content ng-mouseleave=\"$mdMenu.close()\"><md-menu-item><md-button \nng-click=\"doSomething()\" aria-label=\"Do something\" md-prevent-menu-close=\"md-prevent-menu-close\"><md-icon \nmd-menu-align-target md-svg-icon=\"call:phone\"></md-icon>Do Something</md-button></md-menu-item></md-menu-content>\n</hljs></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-menu><md-button \nng-click=\"$mdMenu.open($event)\" class=\"md-icon-button\"><md-icon md-svg-icon=\"call:phone\"></md-icon></md-button>\n<md-menu-content><md-menu-item><md-button ng-click=\"doSomething()\">Do Something</md-button></md-menu-item>\n</md-menu-content></md-menu></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-position-mode</b> <span hide \nshow-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>The position mode in the form of <code>x</code>, <code>y</code>. Default value is <code>target\n</code>,<code>target</code>. Right now the <code>x</code> axis also supports <code>target-right</code>.</p></td></tr>\n<tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-offset</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nAn offset to apply to the dropdown after positioning <code>x</code>, <code>y</code>. Default value is <code>0</code>,\n<code>0</code>.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.input/directive/mdInput.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>You can use any <code>&lt;input&gt;</code> or <code>&lt;textarea&gt;</code>\n element as a child of an <code>&lt;md-input-container&gt;</code>\n. This allows you to build complex forms for data entry.</p><p>\nWhen the input is required and uses a floating label, then the label will automatically contain an asterisk (<code>*\n</code>).<br>This behavior can be disabled by using the <code>md-no-asterisk</code> attribute.</p></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-input-container><label>Color</label><input \ntype=\"text\" ng-model=\"color\" required md-maxlength=\"10\"></md-input-container></hljs><h3>With Errors</h3><p><code>\nmd-input-container</code> also supports errors using the standard <code>ng-messages</code>\n directives and animates the messages when they become visible using from the <code>ngEnter</code>/<code>ngLeave</code>\n events or the <code>ngShow</code>/<code>ngHide</code> events.</p><p>\nBy default, the messages will be hidden until the input is in an error state. This is based off of the <code>\nmd-is-error</code> expression of the <code>md-input-container</code>\n. This gives the user a chance to fill out the form before the errors become visible.</p><hljs lang=\"html\"><form \nname=\"colorForm\"><md-input-container><label>Favorite Color</label><input name=\"favoriteColor\" ng-model=\"favoriteColor\" \nrequired><div ng-messages=\"colorForm.favoriteColor.$error\"><div ng-message=\"required\">This is required!</div></div>\n</md-input-container></form></hljs><p>\nWe automatically disable this auto-hiding functionality if you provide any of the following visibility directives on the \n<code>ng-messages</code> container:</p><ul><li><code>ng-if</code></li><li><code>ng-show</code>/<code>ng-hide</code>\n</li><li><code>ng-switch-when</code>/<code>ng-switch-default</code></li></ul><p>\nYou can also disable this functionality manually by adding the <code>md-auto-hide=&quot;false&quot;</code>\n expression to the <code>ng-messages</code>\n container. This may be helpful if you always want to see the error messages or if you are building your own visibilty directive.\n</p><p><em><b>Note:</b> The <code>md-auto-hide</code>\n attribute is a static string that is only checked upon initialization of the <code>ng-messages</code>\n directive to see if it equals the string <code>false</code>.</em></p><hljs lang=\"html\"><form name=\"userForm\">\n<md-input-container><label>Last Name</label><input name=\"lastName\" ng-model=\"lastName\" required md-maxlength=\"10\" \nminlength=\"4\"><div ng-messages=\"userForm.lastName.$error\" ng-show=\"userForm.lastName.$dirty\"><div \nng-message=\"required\">This is required!</div><div ng-message=\"md-maxlength\">That&#39;s too long!</div><div \nng-message=\"minlength\">That&#39;s too short!</div></div></md-input-container><md-input-container><label>Biography\n</label><textarea name=\"bio\" ng-model=\"biography\" required md-maxlength=\"150\"></textarea><div \nng-messages=\"userForm.bio.$error\" ng-show=\"userForm.bio.$dirty\"><div ng-message=\"required\">This is required!</div><div \nng-message=\"md-maxlength\">That&#39;s too long!</div></div></md-input-container><md-input-container><input \naria-label=\"title\" ng-model=\"title\"></md-input-container><md-input-container><input placeholder=\"title\" \nng-model=\"title\"></md-input-container></form></hljs><h3>Notes</h3><ul><li>Requires <a \nhref=\"https://docs.angularjs.org/api/ngMessages\">ngMessages</a>.</li><li>Behaves like the <a \nhref=\"https://docs.angularjs.org/api/ng/directive/input\">AngularJS input directive</a>.</li></ul><p>The <code>md-input\n</code> and <code>md-input-container</code>\n directives use very specific positioning to achieve the error animation effects. Therefore, it is <em>not</em>\n advised to use the Layout system inside of the <code>&lt;md-input-container&gt;</code>\n tags. Instead, use relative or absolute positioning.</p><p></p><h3>Textarea directive</h3>The <code>textarea</code>\n element within a <code>md-input-container</code> has the following specific behavior:<p></p><ul><li>By default the \n<code>textarea</code> grows as the user types. This can be disabled via the <code>md-no-autogrow</code> attribute.</li>\n<li>If a <code>textarea</code> has the <code>rows</code> attribute, it will treat the <code>rows</code>\n as the minimum height and will continue growing as the user types. For example a textarea with <code>\nrows=&quot;3&quot;</code>\n will be 3 lines of text high initially. If no rows are specified, the directive defaults to 1.</li><li>\nThe textarea&#39;s height gets set on initialization, as well as while the user is typing. In certain situations (e.g. while animating) the directive might have been initialized, before the element got it&#39;s final height. In those cases, you can trigger a resize manually by broadcasting a \n<code>md-resize-textarea</code> event on the scope.</li><li>If you want a <code>textarea</code>\n to stop growing at a certain point, you can specify the <code>max-rows</code> attribute.</li><li>\nThe textarea&#39;s bottom border acts as a handle which users can drag, in order to resize the element vertically. Once the user has resized a \n<code>textarea</code>, the autogrowing functionality becomes disabled. If you don&#39;t want a <code>textarea</code>\n to be resizeable by the user, you can add the <code>md-no-resize</code> attribute.</li></ul></section><div \nclass=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-maxlength <span hide show-sm><code class=\"api-type label type-hint type-hint-number\">\nnumber</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-number\">number\n</code></td><td class=\"description\"><p>\nThe maximum number of characters allowed in this input. If this is specified, a character counter will be shown underneath the input.\n<br><br>The purpose of <strong><code>md-maxlength</code></strong>\n is exactly to show the max length counter text. If you don&#39;t want the counter text and only need &quot;plain&quot; validation, you can use the &quot;simple&quot; \n<code>ng-maxlength</code> or maxlength attributes.<br><br><strong>Note:</strong>\n Only valid for text/string inputs (not numeric).</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">aria-label <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>\nAria-label is required when no label is present. A warning message will be logged in the console if not present.</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">placeholder <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nAn alternative approach to using aria-label when the label is not PRESENT. The placeholder text is copied to the aria-label attribute.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-no-autogrow <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen present, textareas will not grow automatically.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-no-asterisk <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></td><td class=\"description\"><p>\nWhen present, an asterisk will not be appended to the inputs floating label</p></td></tr><tr class=\"api-params-item\">\n<td style=\"white-space: nowrap\">md-no-resize <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nDisables the textarea resize handle.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">max-rows \n<span hide show-sm><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td \nclass=\"description\"><p>The maximum amount of rows for a textarea.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-detect-hidden <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen present, textareas will be sized properly when they are revealed after being hidden. This is off by default for performance reasons because it guarantees a reflow every digest cycle.\n</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.input/directive/mdInputContainer.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>&lt;md-input-container&gt;</code>\n is the parent of any input or textarea element.</p><p>\nInput and textarea elements will not behave properly unless the md-input-container parent is provided.</p><p>A single \n<code>&lt;md-input-container&gt;</code> should contain only one <code>&lt;input&gt;</code>\n element, otherwise it will throw an error.</p><p><b>Exception:</b> Hidden inputs (<code>\n&lt;input type=&quot;hidden&quot; /&gt;</code>\n) are ignored and will not throw an error, so you may combine these with other inputs.</p><p><b>Note:</b> When using \n<code>ngMessages</code> with your input element, make sure the message and container elements are <em>block</em>\n elements, otherwise animations applied to the messages will not look as intended. Either use a <code>div</code>\n and apply the <code>ng-message</code> and <code>ng-messages</code> classes respectively, or use the <code>md-block\n</code> class on your element.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\">\n<md-input-container><label>Username</label><input type=\"text\" ng-model=\"user.name\"></md-input-container>\n<md-input-container><label>Description</label><textarea ng-model=\"user.description\"></textarea></md-input-container>\n</hljs><p></p><h3>When disabling floating labels</h3><p></p><hljs lang=\"html\"><md-input-container md-no-float><input \ntype=\"text\" placeholder=\"Non-Floating Label\"></md-input-container></hljs></section><div class=\"api-param-section\"><h2>\nAttributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-is-error <span hide \nshow-sm><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td \nclass=\"description\"><p>\nWhen the given expression evaluates to true, the input container will go into error state. Defaults to erroring if the input has been touched and is invalid.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-no-float <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When present, <code>\nplaceholder</code> attributes on the input will not be converted to floating labels.</p></td></tr></tbody></table>\n</div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.input/directive/mdSelectOnFocus.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>md-select-on-focus</code>\n directive allows you to automatically select the element&#39;s input text on focus.</p><p></p><h3>Notes</h3><p></p>\n<ul><li>The use of <code>md-select-on-focus</code> is restricted to <code>&lt;input&gt;</code> and <code>\n&lt;textarea&gt;</code> elements.</li></ul></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p></p><h3>\nUsing with an Input</h3><p></p><hljs lang=\"html\"><md-input-container><label>Auto Select</label><input type=\"text\" \nmd-select-on-focus></md-input-container></hljs><p></p><h3>Using with a Textarea</h3><p></p><hljs lang=\"html\">\n<md-input-container><label>Auto Select</label><textarea md-select-on-focus>This text will be selected on focus.\n</textarea></md-input-container></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.navBar/directive/mdNavBar.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-nav-bar&gt;</code>\n directive renders a list of material tabs that can be used for top-level page navigation. Unlike <code>&lt;md-tabs&gt;\n</code>, it has no concept of a tab body and no bar pagination.</p><p>\nBecause it deals with page navigation, certain routing concepts are built-in. Route changes via via ng-href, ui-sref, or ng-click events are supported. Alternatively, the user could simply watch currentNavItem for changes.\n</p><p>Accessibility functionality is implemented as a site navigator with a listbox, according to <a \nhref=\"https://www.w3.org/TR/wai-aria-practices/#Site_Navigator_Tabbed_Style\">\nhttps://www.w3.org/TR/wai-aria-practices/#Site_Navigator_Tabbed_Style</a></p></div><div><section class=\"api-section\">\n<h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-nav-bar md-selected-nav-item=\"currentNavItem\"><md-nav-item \nmd-nav-click=\"goto(\'page1\')\" name=\"page1\">Page One</md-nav-item><md-nav-item md-nav-href=\"#page2\" name=\"page3\">Page Two\n</md-nav-item><md-nav-item md-nav-sref=\"page3\" name=\"page2\">Page Three</md-nav-item><md-nav-item \nmd-nav-sref=\"app.page4\" sref-opts=\"{reload: true, notify: true}\" name=\"page4\">Page Four</md-nav-item></md-nav-bar>\n</hljs><hljs lang=\"js\">\n(function() { &#39;use strict&#39;; $rootScope.$on(&#39;$routeChangeSuccess&#39;, function(event, current) { $scope.currentLink = getCurrentLinkFromRoute(current); }); });\n</hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">mdSelectedNavItem <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThe name of the current tab; this must match the name attribute of <code>&lt;md-nav-item&gt;</code></p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">mdNoInkBar <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nIf set to true, the ink bar will be hidden.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">\nnavBarAriaLabel <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td\n style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>An aria-label for the nav-bar</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.navBar/directive/mdNavItem.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>&lt;md-nav-item&gt;</code> describes a page navigation link within the <code>\n&lt;md-nav-bar&gt;</code> component. It renders an md-button as the actual link.</p><p>\nExactly one of the mdNavClick, mdNavHref, mdNavSref attributes are required to be specified.</p></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>See <code>&lt;md-nav-bar&gt;</code> for usage.</p></section><div \nclass=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">mdNavClick <span hide show-sm><code class=\"api-type label type-hint type-hint-function\">\nFunction=</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-function\">\nFunction=</code></td><td class=\"description\"><p>\nFunction which will be called when the link is clicked to change the page. Renders as an <code>ng-click</code>.</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">mdNavHref <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nurl to transition to when this link is clicked. Renders as an <code>ng-href</code>.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">mdNavSref <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nUi-router state to transition to when this link is clicked. Renders as a <code>ui-sref</code>.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">srefOpts <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">Object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">Object</code></td><td class=\"description\"><p>\nUi-router options that are passed to the <code>$state.go()</code>\n function. See the [Ui-router documentation for details] (<a \nhref=\"https://ui-router.github.io/docs/latest/interfaces/transition.transitionoptions.html\">\nhttps://ui-router.github.io/docs/latest/interfaces/transition.transitionoptions.html</a>).</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">name <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThe name of this link. Used by the nav bar to know which link is currently selected.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">aria-label <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nAdds alternative text for accessibility</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.panel/service/$mdPanel.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>$mdPanel</code>\n is a robust, low-level service for creating floating panels on the screen. It can be used to implement tooltips, dialogs, pop-ups, etc.\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">\n(function(angular, undefined) { &#39;use strict&#39;; angular .module(&#39;demoApp&#39;, [&#39;ngMaterial&#39;]) .controller(&#39;DemoDialogController&#39;, DialogController); var panelRef; function showPanel($event) { var panelPosition = $mdPanel.newPanelPosition() .absolute() .top(&#39;50%&#39;) .left(&#39;50%&#39;); var panelAnimation = $mdPanel.newPanelAnimation() .targetEvent($event) .defaultAnimation(&#39;md-panel-animate-fly&#39;) .closeTo(&#39;.show-button&#39;); var config = { attachTo: angular.element(document.body), controller: DialogController, controllerAs: &#39;ctrl&#39;, position: panelPosition, animation: panelAnimation, targetEvent: $event, templateUrl: &#39;dialog-template.html&#39;, clickOutsideToClose: true, escapeToClose: true, focusOnOpen: true } $mdPanel.open(config) .then(function(result) { panelRef = result; }); } function DialogController(MdPanelRef) { function closeDialog() { if (MdPanelRef) MdPanelRef.close(); } } })(angular);\n</hljs></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"create\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdPanel.create([config]);</code></h3><div \nclass=\"service-desc\"><p>Creates a panel with the specified options.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">config <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">Object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">Object</code></td><td class=\"description\"><p>\nSpecific configuration object that may contain the following properties:</p><ul><li><code>id</code> - <code>{string=}\n</code>\n: An ID to track the panel by. When an ID is provided, the created panel is added to a tracked panels object. Any subsequent requests made to create a panel with that ID are ignored. This is useful in having the panel service not open multiple panels from the same user interaction when there is no backdrop and events are propagated. Defaults to an arbitrary string that is not tracked.\n</li><li><code>template</code> - <code>{string=}</code>: HTML template to show in the panel. This <strong>must</strong>\n be trusted HTML with respect to AngularJS’s <a href=\"https://docs.angularjs.org/api/ng/service/$sce\">$sce service</a>.\n</li><li><code>templateUrl</code> - <code>{string=}</code>: The URL that will be used as the content of the panel.</li>\n<li><code>contentElement</code> - <code>{(string|!angular.JQLite|!Element)=}</code>\n: Pre-compiled element to be used as the panel&#39;s content.</li><li><code>controller</code> - <code>\n{(function|string)=}</code>\n: The controller to associate with the panel. The controller can inject a reference to the returned panelRef, which allows the panel to be closed, hidden, and shown. Any fields passed in through locals or resolve will be bound to the controller.\n</li><li><code>controllerAs</code> - <code>{string=}</code>: An alias to assign the controller to on the scope.</li>\n<li><code>bindToController</code> - <code>{boolean=}</code>\n: Binds locals to the controller instead of passing them in. Defaults to true, as this is a best practice.</li><li>\n<code>locals</code> - <code>{Object=}</code>\n: An object containing key/value pairs. The keys will be used as names of values to inject into the controller. For example, \n<code>locals: {three: 3}</code> would inject <code>three</code> into the controller, with the value 3.</li><li><code>\nresolve</code> - <code>{Object=}</code>\n: Similar to locals, except it takes promises as values. The panel will not open until all of the promises resolve.\n</li><li><code>attachTo</code> - <code>{(string|!angular.JQLite|!Element)=}</code>\n: The element to attach the panel to. Defaults to appending to the root element of the application.</li><li><code>\npropagateContainerEvents</code> - <code>{boolean=}</code>\n: Whether pointer or touch events should be allowed to propagate &#39;go through&#39; the container, aka the wrapper, of the panel. Defaults to false.\n</li><li><code>panelClass</code> - <code>{string=}</code>\n: A css class to apply to the panel element. This class should define any borders, box-shadow, etc. for the panel.</li>\n<li><code>zIndex</code> - <code>{number=}</code>: The z-index to place the panel at. Defaults to 80.</li><li><code>\nposition</code> - <code>{MdPanelPosition=}</code>\n: An MdPanelPosition object that specifies the alignment of the panel. For more information, see <code>MdPanelPosition\n</code>.</li><li><code>clickOutsideToClose</code> - <code>{boolean=}</code>\n: Whether the user can click outside the panel to close it. Defaults to false.</li><li><code>escapeToClose</code> - \n<code>{boolean=}</code>: Whether the user can press escape to close the panel. Defaults to false.</li><li><code>\nonCloseSuccess</code> - <code>{function(!panelRef, string)=}</code>\n: Function that is called after the close successfully finishes. The first parameter passed into this function is the current panelRef and the 2nd is an optional string explaining the close reason. The currently supported closeReasons can be found in the MdPanelRef.closeReasons enum. These are by default passed along by the panel.\n</li><li><code>trapFocus</code> - <code>{boolean=}</code>: Whether focus should be trapped within the panel. If <code>\ntrapFocus</code>\n is true, the user will not be able to interact with the rest of the page until the panel is dismissed. Defaults to false.\n</li><li><code>focusOnOpen</code> - <code>{boolean=}</code>\n: An option to override focus behavior on open. Only disable if focusing some other way, as focus management is required for panels to be accessible. Defaults to true.\n</li><li><code>fullscreen</code> - <code>{boolean=}</code>: Whether the panel should be full screen. Applies the class \n<code>._md-panel-fullscreen</code> to the panel on open. Defaults to false.</li><li><code>animation</code> - <code>\n{MdPanelAnimation=}</code>\n: An MdPanelAnimation object that specifies the animation of the panel. For more information, see <code>\nMdPanelAnimation</code>.</li><li><code>hasBackdrop</code> - <code>{boolean=}</code>\n: Whether there should be an opaque backdrop behind the panel. Defaults to false.</li><li><code>disableParentScroll\n</code> - <code>{boolean=}</code>: Whether the user can scroll the page behind the panel. Defaults to false.</li><li>\n<code>onDomAdded</code> - <code>{function=}</code>\n: Callback function used to announce when the panel is added to the DOM.</li><li><code>onOpenComplete</code> - <code>\n{function=}</code>: Callback function used to announce when the open() action is finished.</li><li><code>onRemoving\n</code> - <code>{function=}</code>: Callback function used to announce the close/hide() action is starting.</li><li>\n<code>onDomRemoved</code> - <code>{function=}</code>\n: Callback function used to announce when the panel is removed from the DOM.</li><li><code>origin</code> - <code>\n{(string|!angular.JQLite|!Element)=}</code>\n: The element to focus on when the panel closes. This is commonly the element which triggered the opening of the panel. If you do not use \n<code>origin</code>, you need to control the focus manually.</li><li><code>groupName</code> - <code>\n{(string|!Array&lt;string&gt;)=}</code>\n: A group name or an array of group names. The group name is used for creating a group of panels. The group is used for configuring the number of open panels and identifying specific behaviors for groups. For instance, all tooltips could be identified using the same groupName.\n</li></ul></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr>\n</thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelref\">MdPanelRef</code></td><td \nclass=\"description\"><p>panelRef</p></td></tr></tbody></table></div></li><li id=\"open\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdPanel.open([config]);</code></h3><div \nclass=\"service-desc\"><p>\nCalls the create method above, then opens the panel. This is a shortcut for creating and then calling open manually. If custom methods need to be called when the panel is added to the DOM or opened, do not use this method. Instead create the panel, chain promises on the domAdded and openComplete methods, and call open from the returned panelRef.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">config <span hide \nshow-sm><code class=\"api-type label type-hint type-hint-object\">Object</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">Object</code></td><td \nclass=\"description\"><p>Specific configuration object that may contain the properties defined in <code>$mdPanel.create\n</code>.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr>\n</thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-object\">!angular.$q.Promise&lt;!MdPanelRef&gt;\n</code></td><td class=\"description\"><p>panelRef A promise that resolves to an instance of the panel.</p></td></tr>\n</tbody></table></div></li><li id=\"newPanelPosition\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdPanel.newPanelPosition();</code></h3><div class=\"service-desc\"><p>\nReturns a new instance of the MdPanelPosition object. Use this to create the position config object.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code></td><td \nclass=\"description\"><p>panelPosition</p></td></tr></tbody></table></div></li><li id=\"newPanelAnimation\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdPanel.newPanelAnimation();</code></h3><div \nclass=\"service-desc\"><p>\nReturns a new instance of the MdPanelAnimation object. Use this to create the animation config object.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelanimation\">MdPanelAnimation</code></td><td \nclass=\"description\"><p>panelAnimation</p></td></tr></tbody></table></div></li><li id=\"newPanelGroup\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdPanel.newPanelGroup(groupName, [config]);</code>\n</h3><div class=\"service-desc\"><p>Creates a panel group and adds it to a tracked list of panel groups.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* groupName</b> <span hide show-sm>\n<code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nName of the group to create.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">config <span \nhide show-sm><code class=\"api-type label type-hint type-hint-object\">Object</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">Object</code></td><td \nclass=\"description\"><p>Specific configuration object that may contain the following properties:</p><ul><li><code>\nmaxOpen</code> - <code>{number=}</code>\n: The maximum number of panels that are allowed to be open within a defined panel group.</li></ul></td></tr></tbody>\n</table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-object\">\n!Object&lt;string, {panels: !Array&lt;!MdPanelRef&gt;, openPanels: !Array&lt;!MdPanelRef&gt;, maxOpen: number}&gt;\n</code></td><td class=\"description\"><p>panelGroup</p></td></tr></tbody></table></div></li><li id=\"setGroupMaxOpen\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdPanel.setGroupMaxOpen(groupName, maxOpen);\n</code></h3><div class=\"service-desc\"><p>\nSets the maximum number of panels in a group that can be opened at a given time.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* groupName</b> <span hide show-sm>\n<code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThe name of the group to configure.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>\n* maxOpen</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td \nclass=\"description\"><p>\nThe maximum number of panels that can be opened. Infinity can be passed in to remove the maxOpen limit.</p></td></tr>\n</tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.panel/service/$mdPanelProvider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>$mdPanelProvider</code>\n allows users to create configuration presets that will be stored within a cached presets object. When the configuration is needed, the user can request the preset by passing it as the first parameter in the \n<code>$mdPanel.create</code> or <code>$mdPanel.open</code> methods.</p></div><div><section class=\"api-section\"><h2 \nid=\"Usage\">Usage</h2><hljs lang=\"js\">\n(function(angular, undefined) { &#39;use strict&#39;; angular .module(&#39;demoApp&#39;, [&#39;ngMaterial&#39;]) .config(DemoConfig) .controller(&#39;DemoCtrl&#39;, DemoCtrl) .controller(&#39;DemoMenuCtrl&#39;, DemoMenuCtrl); function DemoConfig($mdPanelProvider) { $mdPanelProvider.definePreset(&#39;demoPreset&#39;, { attachTo: angular.element(document.body), controller: DemoMenuCtrl, controllerAs: &#39;ctrl&#39;, template: &#39;&#39; + &#39;\n<div class=\"menu-panel\" md-whiteframe=\"4\">&#39; + &#39;<div class=\"menu-content\">&#39; + &#39;<div class=\"menu-item\" \nng-repeat=\"item in ctrl.items\">&#39; + &#39; <button class=\"md-button\">&#39; + &#39; <span>{{item}}</span>&#39; + &#39;\n</button>&#39; + &#39;</div>&#39; + &#39;<md-divider></md-divider>&#39; + &#39;<div class=\"menu-item\">&#39; + &#39; \n<button class=\"md-button\" ng-click=\"ctrl.closeMenu()\">&#39; + &#39; <span>Close Menu</span>&#39; + &#39;</button>\n&#39; + &#39;</div>&#39; + &#39;</div>&#39; + &#39;</div>\n&#39;, panelClass: &#39;menu-panel-container&#39;, focusOnOpen: false, zIndex: 100, propagateContainerEvents: true, groupName: &#39;menus&#39; }); } function PanelProviderCtrl($mdPanel) { this.navigation = { name: &#39;navigation&#39;, items: [ &#39;Home&#39;, &#39;About&#39;, &#39;Contact&#39; ] }; this.favorites = { name: &#39;favorites&#39;, items: [ &#39;Add to Favorites&#39; ] }; this.more = { name: &#39;more&#39;, items: [ &#39;Account&#39;, &#39;Sign Out&#39; ] }; $mdPanel.newPanelGroup(&#39;menus&#39;, { maxOpen: 2 }); this.showMenu = function($event, menu) { $mdPanel.open(&#39;demoPreset&#39;, { id: &#39;menu_&#39; + menu.name, position: $mdPanel.newPanelPosition() .relativeTo($event.srcElement) .addPanelPosition( $mdPanel.xPosition.ALIGN_START, $mdPanel.yPosition.BELOW ), locals: { items: menu.items }, openFrom: $event }); }; } function PanelMenuCtrl(mdPanelRef) { this.closeMenu = function() { mdPanelRef &amp;&amp; mdPanelRef.close(); }; } })(angular);\n</hljs></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"definePreset\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdPanelProvider.definePreset(name, preset);</code>\n</h3><div class=\"service-desc\"><p>Takes the passed in preset name and preset configuration object and adds it to the \n<code>_presets</code> object of the provider. This <code>_presets</code> object is then passed along to the <code>\n$mdPanel</code> service.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter\n</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">\n<b>* name</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>Preset name.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>\n* preset</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-object\">Object</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">Object</code></td><td \nclass=\"description\"><p>\nSpecific configuration object that can contain any and all of the parameters avaialble within the <code>$mdPanel.create\n</code>\n method. However, parameters that pertain to id, position, animation, and user interaction are not allowed and will be removed from the preset configuration.\n</p></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.panel/type/MdPanelAnimation.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nAnimation configuration object. To use, create an MdPanelAnimation with the desired properties, then pass the object as part of $mdPanel creation.\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">\nvar panelAnimation = new MdPanelAnimation() .openFrom(myButtonEl) .duration(1337) .closeTo(&#39;.my-button&#39;) .withAnimation($mdPanel.animation.SCALE); $mdPanel.create({ animation: panelAnimation });\n</hljs></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"openFrom\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelAnimation.openFrom();</code></h3><div \nclass=\"service-desc\"><p>Specifies where to start the open animation. <code>openFrom</code>\n accepts a click event object, query selector, DOM element, or a Rect object that is used to determine the bounds. When passed a click event, the location of the click will be used as the position to start the animation.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* </b><span hide \nshow-sm><code class=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-element\">Element</code><code \nclass=\"api-type label type-hint type-hint-event\">Event</code><code class=\"api-type label type-hint type-hint-object\">\n{top: number, left: number}</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-element\">Element</code><code \nclass=\"api-type label type-hint type-hint-event\">Event</code><code class=\"api-type label type-hint type-hint-object\">\n{top: number, left: number}</code></td><td class=\"description\"></td></tr></tbody></table><table class=\"md-api-table\">\n<thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-mdpanelanimation\">MdPanelAnimation</code></td><td class=\"description\"></td>\n</tr></tbody></table></div></li><li id=\"closeTo\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">MdPanelAnimation.closeTo();</code></h3><div class=\"service-desc\"><p>\nSpecifies where to animate the panel close. <code>closeTo</code>\n accepts a query selector, DOM element, or a Rect object that is used to determine the bounds.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* </b><span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-element\">Element</code><code \nclass=\"api-type label type-hint type-hint-object\">{top: number, left: number}</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-element\">Element</code><code \nclass=\"api-type label type-hint type-hint-object\">{top: number, left: number}</code></td><td class=\"description\"></td>\n</tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody>\n<tr><td><code class=\"api-type label type-hint type-hint-mdpanelanimation\">MdPanelAnimation</code></td><td \nclass=\"description\"></td></tr></tbody></table></div></li><li id=\"withAnimation\"><h3 class=\"method-function-syntax\">\n<code class=\"method-function-syntax\">MdPanelAnimation.withAnimation(cssClass);</code></h3><div class=\"service-desc\"><p>\nSpecifies the animation class.</p><p>\nThere are several default animations that can be used: ($mdPanel.animation) SLIDE: The panel slides in and out from the specified elements. It will not fade in or out. SCALE: The panel scales in and out. Slide and fade are included in this animation. FADE: The panel fades in and out.\n</p><p>\nCustom classes will by default fade in and out unless &quot;transition: opacity 1ms&quot; is added to the to custom class.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* cssClass</b> <span\n hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-object\">{open: string, close: string}</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-object\">{open: string, close: string}</code></td><td class=\"description\">\n</td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelanimation\">MdPanelAnimation</code></td><td \nclass=\"description\"></td></tr></tbody></table></div></li><li id=\"duration\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">MdPanelAnimation.duration(duration);</code></h3><div class=\"service-desc\"><p>\nSpecifies the duration of the animation in milliseconds. The <code>duration</code>\n method accepts either a number or an object with separate open and close durations.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* duration</b> <span hide show-sm>\n<code class=\"api-type label type-hint type-hint-number\">number</code><code \nclass=\"api-type label type-hint type-hint-object\">{open: number, close: number}</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-number\">number</code><code \nclass=\"api-type label type-hint type-hint-object\">{open: number, close: number}</code></td><td class=\"description\">\n</td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelanimation\">MdPanelAnimation</code></td><td \nclass=\"description\"></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.panel/type/MdPanelPosition.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>Object for configuring the position of the panel.</p></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><h4 id=\"centering-the-panel\">Centering the panel</h4><hljs lang=\"js\">\nnew MdPanelPosition().absolute().center();</hljs><h4 id=\"overlapping-the-panel-with-an-element\">\nOverlapping the panel with an element</h4><hljs lang=\"js\">\nnew MdPanelPosition() .relativeTo(someElement) .addPanelPosition( $mdPanel.xPosition.ALIGN_START, $mdPanel.yPosition.ALIGN_TOPS );\n</hljs><h4 id=\"aligning-the-panel-with-the-bottom-of-an-element\">Aligning the panel with the bottom of an element</h4>\n<hljs lang=\"js\">\nnew MdPanelPosition() .relativeTo(someElement) .addPanelPosition($mdPanel.xPosition.CENTER, $mdPanel.yPosition.BELOW);\n</hljs></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"absolute\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelPosition.absolute();</code></h3><div \nclass=\"service-desc\"><p>\nPositions the panel absolutely relative to the parent element. If the parent is document.body, this is equivalent to positioning the panel absolutely within the viewport.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th>\n</tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code>\n</td><td class=\"description\"></td></tr></tbody></table></div></li><li id=\"relativeTo\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelPosition.relativeTo(element);</code></h3>\n<div class=\"service-desc\"><p>Positions the panel relative to a specific element.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* element</b> <span hide show-sm>\n<code class=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-element\">Element</code><code \nclass=\"api-type label type-hint type-hint-angular\">angular.JQLite</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-element\">Element</code><code \nclass=\"api-type label type-hint type-hint-angular\">angular.JQLite</code></td><td class=\"description\"><p>\nQuery selector, DOM element, or angular element to position the panel with respect to.</p></td></tr></tbody></table>\n<table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code></td><td class=\"description\"></td>\n</tr></tbody></table></div></li><li id=\"top\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\nMdPanelPosition.top([top]);</code></h3><div class=\"service-desc\"><p>Sets the value of <code>top</code>\n for the panel. Clears any previously set vertical position.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">top <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Value of <code>top\n</code>. Defaults to &#39;0&#39;.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th>\n<th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelposition\">\nMdPanelPosition</code></td><td class=\"description\"></td></tr></tbody></table></div></li><li id=\"bottom\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelPosition.bottom([bottom]);</code></h3><div \nclass=\"service-desc\"><p>Sets the value of <code>bottom</code>\n for the panel. Clears any previously set vertical position.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">bottom <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Value of <code>bottom\n</code>. Defaults to &#39;0&#39;.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th>\n<th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelposition\">\nMdPanelPosition</code></td><td class=\"description\"></td></tr></tbody></table></div></li><li id=\"start\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelPosition.start([start]);</code></h3><div \nclass=\"service-desc\"><p>Sets the panel to the start of the page - <code>left</code> if <code>ltr</code> or <code>right\n</code> for <code>rtl</code>. Clears any previously set horizontal position.</p></div><div class=\"method-param-table\">\n<table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">start <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nValue of position. Defaults to &#39;0&#39;.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>\nReturns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code></td><td class=\"description\"></td>\n</tr></tbody></table></div></li><li id=\"end\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\nMdPanelPosition.end([end]);</code></h3><div class=\"service-desc\"><p>Sets the panel to the end of the page - <code>right\n</code> if <code>ltr</code> or <code>left</code> for <code>rtl</code>. Clears any previously set horizontal position.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">end <span hide show-sm>\n<code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nValue of position. Defaults to &#39;0&#39;.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>\nReturns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code></td><td class=\"description\"></td>\n</tr></tbody></table></div></li><li id=\"left\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\nMdPanelPosition.left([left]);</code></h3><div class=\"service-desc\"><p>Sets the value of <code>left</code>\n for the panel. Clears any previously set horizontal position.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">left <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Value of <code>left\n</code>. Defaults to &#39;0&#39;.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th>\n<th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelposition\">\nMdPanelPosition</code></td><td class=\"description\"></td></tr></tbody></table></div></li><li id=\"right\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelPosition.right([right]);</code></h3><div \nclass=\"service-desc\"><p>Sets the value of <code>right</code>\n for the panel. Clears any previously set horizontal position.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">right <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Value of <code>right\n</code>. Defaults to &#39;0&#39;.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th>\n<th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelposition\">\nMdPanelPosition</code></td><td class=\"description\"></td></tr></tbody></table></div></li><li id=\"centerHorizontally\"><h3\n class=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelPosition.centerHorizontally();</code></h3>\n<div class=\"service-desc\"><p>\nCenters the panel horizontally in the viewport. Clears any previously set horizontal position.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code></td><td \nclass=\"description\"></td></tr></tbody></table></div></li><li id=\"centerVertically\"><h3 class=\"method-function-syntax\">\n<code class=\"method-function-syntax\">MdPanelPosition.centerVertically();</code></h3><div class=\"service-desc\"><p>\nCenters the panel vertically in the viewport. Clears any previously set vertical position.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code></td><td \nclass=\"description\"></td></tr></tbody></table></div></li><li id=\"center\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">MdPanelPosition.center();</code></h3><div class=\"service-desc\"><p>\nCenters the panel horizontally and vertically in the viewport. This is equivalent to calling both <code>\ncenterHorizontally</code> and <code>centerVertically</code>\n. Clears any previously set horizontal and vertical positions.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code></td><td class=\"description\"></td>\n</tr></tbody></table></div></li><li id=\"addPanelPosition\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">MdPanelPosition.addPanelPosition(xPosition, yPosition);</code></h3><div \nclass=\"service-desc\"><p>\nSets the x and y position for the panel relative to another element. Can be called multiple times to specify an ordered list of panel positions. The first position which allows the panel to be completely on-screen will be chosen; the last position will be chose whether it is on-screen or not.\n</p><p>xPosition must be one of the following values available on $mdPanel.xPosition:</p><p>\nCENTER | ALIGN_START | ALIGN_END | OFFSET_START | OFFSET_END</p><pre>\n   *************\n   *           *\n   *   PANEL   *\n   *           *\n   *************\n  A B    C    D E\n\nA: OFFSET_START (for LTR displays)\nB: ALIGN_START (for LTR displays)\nC: CENTER\nD: ALIGN_END (for LTR displays)\nE: OFFSET_END (for LTR displays)\n\n</pre><p>yPosition must be one of the following values available on $mdPanel.yPosition:</p><p>\nCENTER | ALIGN_TOPS | ALIGN_BOTTOMS | ABOVE | BELOW</p><pre>\n  F\n  G *************\n    *           *\n  H *   PANEL   *\n    *           *\n  I *************\n  J\n\nF: BELOW\nG: ALIGN_TOPS\nH: CENTER\nI: ALIGN_BOTTOMS\nJ: ABOVE\n\n</pre></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* xPosition</b> \n<span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* yPosition</b> <span \nhide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description\n</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition\n</code></td><td class=\"description\"></td></tr></tbody></table></div></li><li id=\"withOffsetX\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelPosition.withOffsetX(offsetX);</code></h3>\n<div class=\"service-desc\"><p>Sets the value of the offset in the x-direction.</p></div><div class=\"method-param-table\">\n<table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* offsetX</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"></td></tr></tbody></table>\n<table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code></td><td class=\"description\"></td>\n</tr></tbody></table></div></li><li id=\"withOffsetY\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">MdPanelPosition.withOffsetY(offsetY);</code></h3><div class=\"service-desc\"><p>\nSets the value of the offset in the y-direction.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\">\n<thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* offsetY</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"></td></tr></tbody></table>\n<table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code></td><td class=\"description\"></td>\n</tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.panel/type/MdPanelRef.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nA reference to a created panel. This reference contains a unique id for the panel, along with the following properties:\n</p><ul><li><code>id</code> - <code>{string}</code>\n: The unique id for the panel. This id is used to track when a panel was interacted with.</li><li><code>config</code>\n - <code>{!Object=}</code>: The entire config object that was used in create.</li><li><code>isAttached</code> - <code>\n{boolean}</code>: Whether the panel is attached to the DOM. Visibility to the user does not factor into isAttached.\n</li><li><code>panelContainer</code> - <code>{angular.JQLite}</code>\n: The wrapper element containing the panel. This property is added in order to have access to the <code>addClass</code>\n, <code>removeClass</code>, <code>toggleClass</code>, etc methods.</li><li><code>panelEl</code> - <code>\n{angular.JQLite}</code>: The panel element. This property is added in order to have access to the <code>addClass</code>\n, <code>removeClass</code>, <code>toggleClass</code>, etc methods.</li></ul></div><div><section class=\"api-section\">\n<h2>Methods</h2><br><ul class=\"methods\"><li id=\"open\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">MdPanelRef.open();</code></h3><div class=\"service-desc\"><p>Attaches and shows the panel.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th>\n</tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-angular\">angular.$q.Promise</code></td><td \nclass=\"description\"><p>A promise that is resolved when the panel is opened.</p></td></tr></tbody></table></div></li><li\n id=\"close\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelRef.close();</code></h3><div\n class=\"service-desc\"><p>Hides and detaches the panel. Note that this will <strong>not</strong>\n destroy the panel. If you don&#39;t intend on using the panel again, call the <a href=\"#destroy\">destroy</a>\n method afterwards.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th>\n<th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-angular\">\nangular.$q.Promise</code></td><td class=\"description\"><p>A promise that is resolved when the panel is closed.</p></td>\n</tr></tbody></table></div></li><li id=\"attach\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">MdPanelRef.attach();</code></h3><div class=\"service-desc\"><p>\nCreate the panel elements and attach them to the DOM. The panel will be hidden by default.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-angular\">angular.$q.Promise</code></td><td \nclass=\"description\"><p>A promise that is resolved when the panel is attached.</p></td></tr></tbody></table></div></li>\n<li id=\"detach\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelRef.detach();</code>\n</h3><div class=\"service-desc\"><p>Removes the panel from the DOM. This will NOT hide the panel before removing it.</p>\n</div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr>\n</thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-angular\">angular.$q.Promise</code></td><td \nclass=\"description\"><p>A promise that is resolved when the panel is detached.</p></td></tr></tbody></table></div></li>\n<li id=\"show\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelRef.show();</code></h3>\n<div class=\"service-desc\"><p>Shows the panel.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\">\n<thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-angular\">angular.$q.Promise</code></td><td class=\"description\"><p>\nA promise that is resolved when the panel has shown and animations are completed.</p></td></tr></tbody></table></div>\n</li><li id=\"hide\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelRef.hide();</code>\n</h3><div class=\"service-desc\"><p>Hides the panel.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-angular\">angular.$q.Promise</code></td><td class=\"description\"><p>\nA promise that is resolved when the panel has hidden and animations are completed.</p></td></tr></tbody></table></div>\n</li><li id=\"destroy\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelRef.destroy();\n</code></h3><div class=\"service-desc\"><p>Destroys the panel. The panel cannot be opened again after this is called.</p>\n</div><div class=\"method-param-table\"></div></li><li id=\"addClass\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">MdPanelRef.addClass(newClass, toElement);</code></h3><div class=\"service-desc\"><p>\nAdds a class to the panel. DO NOT use this hide/show the panel.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* newClass</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>class to be added.</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* toElement</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhether or not to add the class to the panel element instead of the container.</p></td></tr></tbody></table></div></li>\n<li id=\"removeClass\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\nMdPanelRef.removeClass(oldClass, fromElement);</code></h3><div class=\"service-desc\"><p>\nRemoves a class from the panel. DO NOT use this to hide/show the panel.</p></div><div class=\"method-param-table\"><table\n class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* oldClass</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Class to be removed.</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* fromElement</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhether or not to remove the class from the panel element instead of the container.</p></td></tr></tbody></table></div>\n</li><li id=\"toggleClass\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\nMdPanelRef.toggleClass(toggleClass, onElement);</code></h3><div class=\"service-desc\"><p>\nToggles a class on the panel. DO NOT use this to hide/show the panel.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* toggleClass</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Class to be toggled.</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* onElement</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhether or not to remove the class from the panel element instead of the container.</p></td></tr></tbody></table></div>\n</li><li id=\"updatePosition\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\nMdPanelRef.updatePosition(position);</code></h3><div class=\"service-desc\"><p>\nUpdates the position configuration of a panel. Use this to update the position of a panel that is open, without having to close and re-open the panel.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* position</b> <span\n hide show-sm><code class=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code>\n</td><td class=\"description\"></td></tr></tbody></table></div></li><li id=\"addToGroup\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelRef.addToGroup(groupName);</code></h3><div \nclass=\"service-desc\"><p>\nAdds a panel to a group if the panel does not exist within the group already. A panel can only exist within a single group.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* groupName</b> \n<span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>The name of the group to add the panel to.</p></td></tr></tbody></table></div></li><li \nid=\"removeFromGroup\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\nMdPanelRef.removeFromGroup(groupName);</code></h3><div class=\"service-desc\"><p>\nRemoves a panel from a group if the panel exists within that group. The group must be created ahead of time.</p></div>\n<div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description\n</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* groupName</b> <span hide \nshow-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>The name of the group.</p></td></tr></tbody></table></div></li><li id=\"registerInterceptor\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelRef.registerInterceptor(type, callback);\n</code></h3><div class=\"service-desc\"><p>\nRegisters an interceptor with the panel. The callback should return a promise, which will allow the action to continue when it gets resolved, or will prevent an action if it is rejected. The interceptors are called sequentially and it reverse order. \n<code>type</code> must be one of the following values available on <code>$mdPanel.interceptorTypes</code>:</p><ul><li>\n<code>CLOSE</code> - Gets called before the panel begins closing.</li></ul></div><div class=\"method-param-table\"><table\n class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* type</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Type of interceptor.</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* callback</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">!angular.$q.Promise&lt;any&gt;</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">!angular.$q.Promise&lt;any&gt;\n</code></td><td class=\"description\"><p>Callback to be registered.</p></td></tr></tbody></table><table \nclass=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-mdpanelref\">MdPanelRef</code></td><td class=\"description\"></td></tr></tbody>\n</table></div></li><li id=\"removeInterceptor\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\nMdPanelRef.removeInterceptor(type, callback);</code></h3><div class=\"service-desc\"><p>Removes a registered interceptor.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* type</b> <span \nhide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>Type of interceptor to be removed.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* callback</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-function\">function(): !angular.$q.Promise&lt;any&gt;</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-function\">\nfunction(): !angular.$q.Promise&lt;any&gt;</code></td><td class=\"description\"><p>Interceptor to be removed.</p></td>\n</tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody>\n<tr><td><code class=\"api-type label type-hint type-hint-mdpanelref\">MdPanelRef</code></td><td class=\"description\"></td>\n</tr></tbody></table></div></li><li id=\"removeAllInterceptors\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">MdPanelRef.removeAllInterceptors([type]);</code></h3><div class=\"service-desc\"><p>\nRemoves all interceptors. If a type is supplied, only the interceptors of that type will be cleared.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">type <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nType of interceptors to be removed.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns\n</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelref\">\nMdPanelRef</code></td><td class=\"description\"></td></tr></tbody></table></div></li><li id=\"updateAnimation\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelRef.updateAnimation(animation);</code></h3>\n<div class=\"service-desc\"><p>\nUpdates the animation configuration for a panel. You can use this to change the panel&#39;s animation without having to re-create it.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* animation</b> \n<span hide show-sm><code class=\"api-type label type-hint type-hint-mdpanelanimation\">MdPanelAnimation</code></span>\n</td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-mdpanelanimation\">MdPanelAnimation\n</code></td><td class=\"description\"></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.progressCircular/directive/mdProgressCircular.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nThe circular progress directive is used to make loading content in your app as delightful and painless as possible by minimizing the amount of visual change a user sees before they can view and interact with content.\n</p><p>\nFor operations where the percentage of the operation completed can be determined, use a determinate indicator. They give users a quick sense of how long an operation will take.\n</p><p>\nFor operations where the user is asked to wait a moment while something finishes up, and it’s not necessary to expose what&#39;s happening behind the scenes and how long it will take, use an indeterminate indicator.\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-progress-circular \nmd-mode=\"determinate\" value=\"...\"></md-progress-circular><md-progress-circular md-mode=\"determinate\" ng-value=\"...\">\n</md-progress-circular><md-progress-circular md-mode=\"determinate\" value=\"...\" md-diameter=\"100\">\n</md-progress-circular><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></hljs></section><div \nclass=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* md-mode</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nSelect from one of two modes: <strong>&#39;determinate&#39;</strong> and <strong>&#39;indeterminate&#39;</strong>.</p>\n<p>Note: if the <code>md-mode</code> value is set as undefined or specified as not 1 of the two (2) valid modes, then \n<strong>&#39;indeterminate&#39;</strong> will be auto-applied as the mode.</p><p>Note: if not configured, the <code>\nmd-mode=&quot;indeterminate&quot;</code> will be auto injected as an attribute. If <code>value=&quot;&quot;</code>\n is also specified, however, then <code>md-mode=&quot;determinate&quot;</code> would be auto-injected instead.</p></td>\n</tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">value <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nIn determinate mode, this number represents the percentage of the circular progress. Default: 0</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-diameter <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nThis specifies the diameter of the circular progress. The value should be a pixel-size value (eg &#39;100&#39;). If this attribute is not present then a default value of &#39;50px&#39; is assumed.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">ng-disabled <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nDetermines whether to disable the progress element.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.progressLinear/directive/mdProgressLinear.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nThe linear progress directive is used to make loading content in your app as delightful and painless as possible by minimizing the amount of visual change a user sees before they can view and interact with content.\n</p><p>\nEach operation should only be represented by one activity indicator For example: one refresh operation should not display both a refresh bar and an activity circle.\n</p><p>\nFor operations where the percentage of the operation completed can be determined, use a determinate indicator. They give users a quick sense of how long an operation will take.\n</p><p>\nFor operations where the user is asked to wait a moment while something finishes up, and it’s not necessary to expose what&#39;s happening behind the scenes and how long it will take, use an indeterminate indicator.\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-progress-linear \nmd-mode=\"determinate\" value=\"...\"></md-progress-linear><md-progress-linear md-mode=\"determinate\" ng-value=\"...\">\n</md-progress-linear><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear><md-progress-linear \nmd-mode=\"buffer\" value=\"...\" md-buffer-value=\"...\"></md-progress-linear><md-progress-linear md-mode=\"query\">\n</md-progress-linear></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\">\n<table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-mode</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nSelect from one of four modes: determinate, indeterminate, buffer or query.</p><p>Note: if the <code>md-mode</code>\n value is set as undefined or specified as 1 of the four (4) valid modes, then <code>indeterminate</code>\n will be auto-applied as the mode.</p><p>Note: if not configured, the <code>md-mode=&quot;indeterminate&quot;</code>\n will be auto injected as an attribute. If <code>value=&quot;&quot;</code> is also specified, however, then <code>\nmd-mode=&quot;determinate&quot;</code> would be auto-injected instead.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">value <span hide show-sm><code class=\"api-type label type-hint type-hint-number\">number\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-number\">number\n</code></td><td class=\"description\"><p>\nIn determinate and buffer modes, this number represents the percentage of the primary progress bar. Default: 0</p></td>\n</tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-buffer-value <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nIn the buffer mode, this number represents the percentage of the secondary progress bar. Default: 0</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">ng-disabled <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nDetermines whether to disable the progress element.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.progressCircular/service/$mdProgressCircular.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>Allows the user to specify the default options for the <code>progressCircular</code>\n directive.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">\nmyAppModule.config(function($mdProgressCircularProvider) { // Example of changing the default progress options. $mdProgressCircularProvider.configure({ progressSize: 100, strokeWidth: 20, duration: 800 }); });\n</hljs></section><section class=\"api-section\"><h2>Properties</h2><br><ul class=\"methods\"><li id=\"progressSize\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdProgressCircular.progressSize</code></h3><div \nclass=\"service-desc\"><p>Diameter of the progress circle in pixels.</p></div><div class=\"method-param-table\"></div></li>\n<li id=\"strokeWidth\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdProgressCircular.strokeWidth</code></h3><div class=\"service-desc\"><p>\nWidth of the circle&#39;s stroke as a percentage of the circle&#39;s size.</p></div><div class=\"method-param-table\">\n</div></li><li id=\"duration\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdProgressCircular.duration</code></h3><div class=\"service-desc\"><p>Length of the circle animation in milliseconds.\n</p></div><div class=\"method-param-table\"></div></li><li id=\"easeFn\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdProgressCircular.easeFn</code></h3><div class=\"service-desc\"><p>\nDefault easing animation function.</p></div><div class=\"method-param-table\"></div></li><li id=\"easingPresets\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdProgressCircular.easingPresets</code></h3><div \nclass=\"service-desc\"><p>Collection of pre-defined easing functions.</p></div><div class=\"method-param-table\"></div>\n</li><li id=\"durationIndeterminate\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdProgressCircular.durationIndeterminate</code></h3><div class=\"service-desc\"><p>\nDuration of the indeterminate animation.</p></div><div class=\"method-param-table\"></div></li><li \nid=\"startIndeterminate\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdProgressCircular.startIndeterminate</code></h3><div class=\"service-desc\"><p>Indeterminate animation start point.</p>\n</div><div class=\"method-param-table\"></div></li><li id=\"endIndeterminate\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdProgressCircular.endIndeterminate</code></h3><div class=\"service-desc\"><p>\nIndeterminate animation end point.</p></div><div class=\"method-param-table\"></div></li><li id=\"easeFnIndeterminate\"><h3\n class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdProgressCircular.easeFnIndeterminate</code>\n</h3><div class=\"service-desc\"><p>Easing function to be used when animating between the indeterminate values.</p></div>\n<div class=\"method-param-table\"></div></li><li id=\"configure\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdProgressCircular.configure</code></h3><div class=\"service-desc\"><p>\nUsed to modify the default options.</p></div><div class=\"method-param-table\"></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.radioButton/directive/mdRadioButton.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-radio-button&gt;</code>\ndirective is the child directive required to be used within <code>&lt;md-radio-group&gt;</code> elements.</p><p>\nWhile similar to the <code>&lt;input type=&quot;radio&quot; ng-model=&quot;&quot; value=&quot;&quot;&gt;</code>\n directive, the <code>&lt;md-radio-button&gt;</code>\n directive provides ink effects, ARIA support, and supports use within named radio groups.</p></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-radio-button value=\"1\" aria-label=\"Label 1\">Label 1\n</md-radio-button><md-radio-button ng-value=\"specialValue\" aria-label=\"Green\">Green</md-radio-button></hljs></section>\n<div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr>\n<th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* ngValue</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nAngularJS expression which sets the value to which the expression should be set when selected.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* value</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThe value to which the expression should be set when selected.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">name <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>Property name of the form under which the control is published.</p></td></tr><tr\n class=\"api-params-item\"><td style=\"white-space: nowrap\">aria-label <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nAdds label to radio button for accessibility. Defaults to radio button&#39;s text. If no text content is available, a warning will be logged.\n</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.radioButton/directive/mdRadioGroup.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-radio-group&gt;</code>\n directive identifies a grouping container for the 1..n grouped radio buttons; specified using nested <code>\n&lt;md-radio-button&gt;</code> tags.</p><p>As per the <a \nhref=\"http://www.google.com/design/spec/style/color.html#color-ui-color-application\">material design spec</a>\n the radio button is in the accent color by default. The primary color palette may be used with the <code>md-primary\n</code> class.</p><p>Note: <code>&lt;md-radio-group&gt;</code> and <code>&lt;md-radio-button&gt;</code>\n handle tabindex differently than the native <code>&lt;input type=&#39;radio&#39;&gt;</code>\n controls. Whereas the native controls force the user to tab through all the radio buttons, <code>\n&lt;md-radio-group&gt;</code> is focusable, and by default the <code>&lt;md-radio-button&gt;</code>s are not.</p></div>\n<div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-radio-group ng-model=\"selected\">\n<md-radio-button ng-repeat=\"d in colorOptions\" ng-value=\"d.value\" aria-label=\"{{ d.label }}\">{{ d.label }}\n</md-radio-button></md-radio-group></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* ng-model</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nAssignable angular expression to data-bind to.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* ngModel</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nAssignable angular expression to data-bind to.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-no-ink <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></td><td class=\"description\"><p>Use of attribute indicates flag to disable ink ripple effects.</p></td>\n</tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">ngChange <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nAngularJS expression to be executed when input changes due to user interaction with the input element.</p></td></tr>\n</tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.select/directive/mdSelect.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>Displays a select box, bound to an ng-model.</p><p>\nWhen the select is required and uses a floating label, then the label will automatically contain an asterisk (<code>*\n</code>). This behavior can be disabled by using the <code>md-no-asterisk</code> attribute.</p><p>\nBy default, the select will display with an underline to match other form elements. This can be disabled by applying the \n<code>md-no-underline</code> CSS class.</p><h3 id=\"option-params\">Option Params</h3><p>When applied, <code>\nmd-option-empty</code>\n will mark the option as &quot;empty&quot; allowing the option to clear the select and put it back in it&#39;s default state. You may supply this attribute on any option you wish, however, it is automatically applied to an option whose \n<code>value</code> or <code>ng-value</code> are not defined.</p><p><strong>Automatically Applied</strong></p><ul><li>\n<code>&lt;md-option&gt;</code></li><li><code>&lt;md-option value&gt;</code></li><li><code>\n&lt;md-option value=&quot;&quot;&gt;</code></li><li><code>&lt;md-option ng-value&gt;</code></li><li><code>\n&lt;md-option ng-value=&quot;&quot;&gt;</code></li></ul><p><strong>NOT Automatically Applied</strong></p><ul><li><code>\n&lt;md-option ng-value=&quot;1&quot;&gt;</code></li><li><code>&lt;md-option ng-value=&quot;&#39;&#39;&quot;&gt;</code>\n</li><li><code>&lt;md-option ng-value=&quot;undefined&quot;&gt;</code></li><li><code>\n&lt;md-option value=&quot;undefined&quot;&gt;</code> (this evaluates to the string <code>&quot;undefined&quot;</code>)\n</li><li><code ng-non-bindable>&lt;md-option ng-value=&quot;{{someValueThatMightBeUndefined}}&quot;&gt;</code></li>\n</ul><p><strong>Note:</strong> A value of <code>undefined</code> <strong><em>is considered a valid value</em></strong>\n (and does not auto-apply this attribute) since you may wish this to be your &quot;Not Available&quot; or &quot;None&quot; option.\n</p><p><strong>Note:</strong> Using the <code>value</code> attribute (as opposed to <code>ng-value</code>\n) always evaluates to a string, so <code>value=&quot;null&quot;</code> will require the test <code>\nng-if=&quot;myValue != &#39;null&#39;&quot;</code> rather than <code>ng-if=&quot;!myValue&quot;</code>.</p></div><div>\n<section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>\nWith a placeholder (label and aria-label are added dynamically)</p><hljs lang=\"html\"><md-input-container><md-select \nng-model=\"someModel\" placeholder=\"Select a state\"><md-option ng-value=\"opt\" ng-repeat=\"opt in neighborhoods2\">{{ opt }}\n</md-option></md-select></md-input-container></hljs><p>With an explicit label</p><hljs lang=\"html\"><md-input-container>\n<label>State</label><md-select ng-model=\"someModel\"><md-option ng-value=\"opt\" ng-repeat=\"opt in neighborhoods2\">\n{{ opt }}</md-option></md-select></md-input-container></hljs><p>With a select-header</p><p>\nWhen a developer needs to put more than just a text label in the md-select-menu, they should use the md-select-header. The user can put custom HTML inside of the header and style it to their liking. One common use case of this would be a sticky search bar.\n</p><p>When using the md-select-header the labels that would previously be added to the OptGroupDirective are ignored.\n</p><hljs lang=\"html\"><md-input-container><md-select ng-model=\"someModel\"><md-select-header><span>Neighborhoods -\n</span></md-select-header><md-option ng-value=\"opt\" ng-repeat=\"opt in neighborhoods2\">{{ opt }}</md-option></md-select>\n</md-input-container></hljs><h2 id=\"selects-and-object-equality\">Selects and object equality</h2><p>When using a <code>\nmd-select</code>\n to pick from a list of objects, it is important to realize how javascript handles equality. Consider the following example:\n</p><hljs lang=\"js\">\nangular.controller(&#39;MyCtrl&#39;, function($scope) { $scope.users = [ { id: 1, name: &#39;Bob&#39; }, { id: 2, name: &#39;Alice&#39; }, { id: 3, name: &#39;Steve&#39; } ]; $scope.selectedUser = { id: 1, name: &#39;Bob&#39; }; });\n</hljs><hljs lang=\"html\"><div ng-controller=\"MyCtrl\"><md-select ng-model=\"selectedUser\"><md-option ng-value=\"user\" \nng-repeat=\"user in users\">{{ user.name }}</md-option></md-select></div></hljs><p>\nAt first one might expect that the select should be populated with &quot;Bob&quot; as the selected user. However, this is not true. To determine whether something is selected, \n<code>ngModelController</code> is looking at whether <code>$scope.selectedUser == (any user in $scope.users);</code>;\n</p><p>Javascript&#39;s <code>==</code>\n operator does not check for deep equality (ie. that all properties on the object are the same), but instead whether the objects are \n<em>the same object in memory</em>\n. In this case, we have two instances of identical objects, but they exist in memory as unique entities. Because of this, the select will have no value populated for a selected user.\n</p><p>To get around this, <code>ngModelController</code> provides a <code>track by</code>\n option that allows us to specify a different expression which will be used for the equality operator. As such, we can update our \n<code>html</code> to make use of this by specifying the <code>\nng-model-options=&quot;{trackBy: &#39;$value.id&#39;}&quot;</code> on the <code>md-select</code>\n element. This converts our equality expression to be <code>\n$scope.selectedUser.id == (any id in $scope.users.map(function(u) { return u.id; }));</code>\n which results in Bob being selected as desired.</p><p>Working HTML:</p><hljs lang=\"html\"><div ng-controller=\"MyCtrl\">\n<md-select ng-model=\"selectedUser\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-value=\"user\" \nng-repeat=\"user in users\">{{ user.name }}</md-option></md-select></div></hljs></section><div class=\"api-param-section\">\n<h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th>\n<th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* ng-model</b> \n<span hide show-sm><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td \nclass=\"description\"><p>The model!</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">multiple \n<span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td \nclass=\"description\"><p>\nWhen set to true, allows for more than one option to be selected. The model is an array with the selected choices.</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-on-close <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nExpression to be evaluated when the select is closed.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-on-open <span hide show-sm><code class=\"api-type label type-hint type-hint-expression\">\nexpression</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nExpression to be evaluated when opening the select. Will hide the select options and show a spinner until the evaluated promise resolves.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-selected-text <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nExpression to be evaluated that will return a string to be displayed as a placeholder in the select input box when it is closed. The value will be treated as \n<em>text</em> (not html).</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-selected-html \n<span hide show-sm><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td \nclass=\"description\"><p>\nExpression to be evaluated that will return a string to be displayed as a placeholder in the select input box when it is closed. The value will be treated as \n<em>html</em>. The value must either be explicitly marked as trustedHtml or the ngSanitize module must be loaded.</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">placeholder <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Placeholder hint text.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-no-asterisk <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen set to true, an asterisk will not be appended to the floating label. <strong>Note:</strong>\n This attribute is only evaluated once; it is not watched.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">aria-label <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>\nOptional label for accessibility. Only necessary if no placeholder or explicit label is present.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-container-class <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nClass list to get applied to the <code>.md-select-menu-container</code> element (for custom styling).</p></td></tr>\n</tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sidenav/service/$mdSidenav.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>$mdSidenav</code>\n makes it easy to interact with multiple sidenavs in an app. When looking up a sidenav instance, you can either look it up synchronously or wait for it to be initializied asynchronously. This is done by passing the second argument to \n<code>$mdSidenav</code>.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">\n// Async lookup for sidenav instance; will resolve when the instance is available $mdSidenav(componentId, true).then(function(instance) { $log.debug( componentId + &quot;is now ready&quot; ); }); // Sync lookup for sidenav instance; this will resolve immediately. $mdSidenav(componentId).then(function(instance) { $log.debug( componentId + &quot;is now ready&quot; ); }); // Async toggle the given sidenav; // when instance is known ready and lazy lookup is not needed. $mdSidenav(componentId) .toggle() .then(function(){ $log.debug(&#39;toggled&#39;); }); // Async open the given sidenav $mdSidenav(componentId) .open() .then(function(){ $log.debug(&#39;opened&#39;); }); // Async close the given sidenav $mdSidenav(componentId) .close() .then(function(){ $log.debug(&#39;closed&#39;); }); // Sync check to see if the specified sidenav is set to be open $mdSidenav(componentId).isOpen(); // Sync check to whether given sidenav is locked open // If this is true, the sidenav will be open regardless of close() $mdSidenav(componentId).isLockedOpen(); // On close callback to handle close, backdrop click or escape key pressed // Callback happens BEFORE the close action occurs. $mdSidenav(componentId).onClose(function () { $log.debug(&#39;closing&#39;); });\n</hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sidenav/directive/mdSidenav.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>A Sidenav component that can be opened and closed programatically.</p><p>\nBy default, upon opening it will slide out on top of the main content area.</p><p>\nFor keyboard and screen reader accessibility, focus is sent to the sidenav wrapper by default. It can be overridden with the \n<code>md-autofocus</code> directive on the child element you want focused.</p></div><div><section class=\"api-section\">\n<h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div layout=\"row\" ng-controller=\"MyController\"><md-sidenav \nmd-component-id=\"left\" class=\"md-sidenav-left\">Left Nav!</md-sidenav><md-content>Center Content<md-button \nng-click=\"openLeftMenu()\">Open Left Menu</md-button></md-content><md-sidenav md-component-id=\"right\" \nmd-is-locked-open=\"$mdMedia(\'min-width: 333px\')\" class=\"md-sidenav-right\"><form><md-input-container><label \nfor=\"testInput\">Test input</label><input id=\"testInput\" type=\"text\" ng-model=\"data\" md-autofocus></md-input-container>\n</form></md-sidenav></div></hljs><hljs lang=\"js\">\nvar app = angular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]); app.controller(&#39;MyController&#39;, function($scope, $mdSidenav) { $scope.openLeftMenu = function() { $mdSidenav(&#39;left&#39;).toggle(); }; });\n</hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-is-open <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nA model bound to whether the sidenav is opened.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-disable-backdrop <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen present in the markup, the sidenav will not show a backdrop.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-component-id <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>componentId to use with $mdSidenav service.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-is-locked-open <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nWhen this expression evaluates to true, the sidenav &#39;locks open&#39;: it falls into the content&#39;s flow instead of appearing over it. This overrides the \n<code>md-is-open</code> attribute.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">\nmd-disable-scroll-target <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code>\n</span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td>\n<td class=\"description\"><p>\nSelector, pointing to an element, whose scrolling will be disabled when the sidenav is opened. By default this is the sidenav&#39;s direct parent.\n</p><p>\nThe $mdMedia() service is exposed to the is-locked-open attribute, which can be given a media query or one of the \n<code>sm</code>, <code>gt-sm</code>, <code>md</code>, <code>gt-md</code>, <code>lg</code> or <code>gt-lg</code>\n presets. Examples:</p><ul><li><code>&lt;md-sidenav md-is-locked-open=&quot;shouldLockOpen&quot;&gt;&lt;/md-sidenav&gt;\n</code></li><li><code>\n&lt;md-sidenav md-is-locked-open=&quot;$mdMedia(&#39;min-width: 1000px&#39;)&quot;&gt;&lt;/md-sidenav&gt;</code></li>\n<li><code>&lt;md-sidenav md-is-locked-open=&quot;$mdMedia(&#39;sm&#39;)&quot;&gt;&lt;/md-sidenav&gt;</code>\n (locks open on small screens)</li></ul></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sidenav/directive/mdSidenavFocus.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>mdSidenavFocus</code>\n provides a way to specify the focused element when a sidenav opens. This is completely optional, as the sidenav itself is focused by default.\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-sidenav><form>\n<md-input-container><label for=\"testInput\">Label</label><input id=\"testInput\" type=\"text\" md-sidenav-focus>\n</md-input-container></form></md-sidenav></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.slider/directive/mdSlider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-slider&gt;</code>\n component allows the user to choose from a range of values.</p><p>As per the <a \nhref=\"http://www.google.com/design/spec/style/color.html#color-ui-color-application\">material design spec</a>\n the slider is in the accent color by default. The primary color palette may be used with the <code>md-primary</code>\n class.</p><p>\nIt has two modes: &#39;normal&#39; mode, where the user slides between a wide range of values, and &#39;discrete&#39; mode, where the user slides between only a few select values.\n</p><p>To enable discrete mode, add the <code>md-discrete</code> attribute to a slider, and use the <code>step</code>\n attribute to change the distance between values the user is allowed to pick.</p></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><p></p><h4>Normal Mode</h4><p></p><hljs lang=\"html\"><md-slider \nng-model=\"myValue\" min=\"5\" max=\"500\"></md-slider></hljs><h4>Discrete Mode</h4><hljs lang=\"html\"><md-slider md-discrete \nng-model=\"myDiscreteValue\" step=\"10\" min=\"10\" max=\"130\"></md-slider></hljs><h4>Invert Mode</h4><hljs lang=\"html\">\n<md-slider md-invert ng-model=\"myValue\" step=\"10\" min=\"10\" max=\"130\"></md-slider></hljs></section><div \nclass=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-discrete <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></td><td class=\"description\"><p>Whether to enable discrete mode.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-invert <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhether to enable invert mode.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">step <span \nhide show-sm><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td \nclass=\"description\"><p>The distance between values the user is allowed to pick. Default 1.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">min <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nThe minimum value the user is allowed to pick. Default 0.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">max <span hide show-sm><code class=\"api-type label type-hint type-hint-number\">number\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-number\">number\n</code></td><td class=\"description\"><p>The maximum value the user is allowed to pick. Default 100.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">round <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nThe amount of numbers after the decimal point, maximum is 6 to prevent scientific notation. Default 3.</p></td></tr>\n</tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.slider/directive/mdSliderContainer.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-slider-container&gt;</code>\n contains slider with two other elements.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p></p>\n<h4>Normal Mode</h4><p></p><hljs lang=\"html\"></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.swipe/directive/mdSwipeDown.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nThe md-swipe-down directive allows you to specify custom behavior when an element is swiped down.</p></div><div>\n<section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div md-swipe-down=\"onSwipDown()\">\nSwipe me down!</div></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.swipe/directive/mdSwipeLeft.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nThe md-swipe-left directive allows you to specify custom behavior when an element is swiped left.</p></div><div>\n<section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div md-swipe-left=\"onSwipeLeft()\">\nSwipe me left!</div></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.swipe/directive/mdSwipeRight.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nThe md-swipe-right directive allows you to specify custom behavior when an element is swiped right.</p></div><div>\n<section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div md-swipe-right=\"onSwipeRight()\">\nSwipe me right!</div></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.swipe/directive/mdSwipeUp.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nThe md-swipe-up directive allows you to specify custom behavior when an element is swiped up.</p></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div md-swipe-up=\"onSwipeUp()\">Swipe me up!</div></hljs>\n</section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sticky/service/$mdSticky.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>$mdSticky</code>service provides a mixin to make elements sticky.</p><p>\nWhenever the current browser supports stickiness natively, the <code>$mdSticky</code>\n service will just use the native browser stickiness.</p><p>By default the <code>$mdSticky</code>\n service compiles the cloned element, when not specified through the <code>elementClone</code>\n parameter, in the same scope as the actual element lives.</p><p></p><h3>Notes</h3>\nWhen using an element which is containing a compiled directive, which changed its DOM structure during compilation, you should compile the clone yourself using the plain template.\n<br><br>See the right usage below:<p></p><hljs lang=\"js\">\nangular.module(&#39;myModule&#39;) .directive(&#39;stickySelect&#39;, function($mdSticky, $compile) { var SELECT_TEMPLATE = &#39;\n<md-select ng-model=\"selected\">&#39; + &#39;<md-option>Option 1</md-option>&#39; + &#39;</md-select>\n&#39;; return { restrict: &#39;E&#39;, replace: true, template: SELECT_TEMPLATE, link: function(scope,element) { $mdSticky(scope, element, $compile(SELECT_TEMPLATE)(scope)); } }; });\n</hljs></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">\nangular.module(&#39;myModule&#39;) .directive(&#39;stickyText&#39;, function($mdSticky, $compile) { return { restrict: &#39;E&#39;, template: &#39;\n<span>Sticky Text</span>&#39;, link: function(scope,element) { $mdSticky(scope, element); } }; });</hljs></section>\n<section class=\"api-section\"><section class=\"api-section\"></section><div class=\"api-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td></td><td \nclass=\"description\"><p>A <code>$mdSticky</code> function that takes three arguments:</p><ul><li><code>scope</code></li>\n<li><code>element</code>: The element that will be &#39;sticky&#39;</li><li><code>elementClone</code>\n: A clone of the element, that will be shown when the user starts scrolling past the original element. If not provided, it will use the result of \n<code>element.clone()</code> and compiles it in the given scope.</li></ul></td></tr></tbody></table></div></section>\n</div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.subheader/directive/mdSubheader.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>md-subheader</code> directive creates a sticky subheader for a section.\n</p><p>Developers are able to disable the stickiness of the subheader by using the following markup</p><hljs \nlang=\"html\"><md-subheader class=\"md-no-sticky\">Not Sticky</md-subheader></hljs><h3 id=\"notes\">Notes</h3><ul><li>The \n<code>md-subheader</code> directive uses the <a ng-href=\"api/service/$mdSticky\">$mdSticky</a>\n service to make the subheader sticky.</li></ul><blockquote><p>\nWhenever the current browser doesn&#39;t support stickiness natively, the subheader will be compiled twice to create a sticky clone of the subheader.\n</p></blockquote></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-subheader>\nOnline Friends</md-subheader></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.switch/directive/mdSwitch.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\">\n<md-switch ng-model=\"isActive\" aria-label=\"Finished?\">Finished ?</md-switch><md-switch md-no-ink ng-model=\"hasInk\" \naria-label=\"No Ink Effects\">No Ink Effects</md-switch><md-switch ng-disabled=\"true\" ng-model=\"isDisabled\" \naria-label=\"Disabled\">Disabled</md-switch></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* ng-model</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nAssignable angular expression to data-bind to.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">name <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>Property name of the form under which the control is published.</p></td></tr><tr\n class=\"api-params-item\"><td style=\"white-space: nowrap\">ng-true-value <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nThe value to which the expression should be set when selected.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">ng-false-value <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nThe value to which the expression should be set when not selected.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">ng-change <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>\nAngularJS expression to be executed when input changes due to user interaction with the input element.</p></td></tr><tr\n class=\"api-params-item\"><td style=\"white-space: nowrap\">ng-disabled <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nEn/Disable based on the expression.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-no-ink \n<span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td \nclass=\"description\"><p>Use of attribute indicates use of ripple ink effects.</p></td></tr><tr class=\"api-params-item\">\n<td style=\"white-space: nowrap\">aria-label <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>\nPublish the button label used by screen-readers for accessibility. Defaults to the switch&#39;s text.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-invert <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen set to true, the switch will be inverted.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.tabs/directive/mdTab.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-tab&gt;</code> is a nested directive used within <code>\n&lt;md-tabs&gt;</code> to specify a tab with a <strong>label</strong> and optional <em>view content</em>.</p><p>If the \n<code>label</code> attribute is not specified, then an optional <code>&lt;md-tab-label&gt;</code>\n tag can be used to specify more complex tab header markup. If neither the <strong>label</strong> nor the <strong>\nmd-tab-label</strong> are specified, then the nested markup of the <code>&lt;md-tab&gt;</code>\n is used as the tab header markup.</p><p>Please note that if you use <code>&lt;md-tab-label&gt;</code>, your content \n<strong>MUST</strong> be wrapped in the <code>&lt;md-tab-body&gt;</code>\n tag. This is to define a clear separation between the tab content and the tab label.</p><p>\nThis container is used by the TabsController to show/hide the active tab&#39;s content view. This synchronization is automatically managed by the internal TabsController whenever the tab selection changes. Selection changes can be initiated via data binding changes, programmatic invocation, or user gestures.\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-tab label=\"\" ng-disabled \nmd-on-select=\"\" md-on-deselect=\"\"><h3>My Tab content</h3></md-tab><md-tab><md-tab-label><h3>My Tab content</h3>\n</md-tab-label><md-tab-body><p>\nSed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.\n</p></md-tab-body></md-tab></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">label <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nOptional attribute to specify a simple string as the tab label</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">ng-disabled <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></td><td class=\"description\"><p>If present and expression evaluates to truthy, disabled tab selection.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-on-deselect <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nExpression to be evaluated after the tab has been de-selected.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-on-select <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nExpression to be evaluated after the tab has been selected.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-active <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></td><td class=\"description\"><p>\nWhen true, sets the active tab. Note: There can only be one active tab at a time.</p></td></tr></tbody></table></div>\n</div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.tabs/directive/mdTabs.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-tabs&gt;</code> directive serves as the container for 1..n <code>\n&lt;md-tab&gt;</code> child directives to produces a Tabs components. In turn, the nested <code>&lt;md-tab&gt;</code>\n directive is used to specify a tab label for the <strong>header button</strong>\n and a [optional] tab view content that will be associated with each tab button.</p><p>\nBelow is the markup for its simplest usage:</p><hljs lang=\"html\"><md-tabs><md-tab label=\"Tab #1\"></md-tab><md-tab \nlabel=\"Tab #2\"></md-tab><md-tab label=\"Tab #3\"></md-tab></md-tabs></hljs><p>Tabs supports three (3) usage scenarios:\n</p><ol><li>Tabs (buttons only)</li><li>Tabs with internal view content</li><li>Tabs with external view content</li>\n</ol><p><strong>Tab-only</strong>\n support is useful when tab buttons are used for custom navigation regardless of any other components, content, or views.\n</p><p><i><b>Note:</b> If you are using the Tabs component for page-level navigation, please take a look at the <a \nng-href=\"./api/directive/mdNavBar\">NavBar component</a> instead as it can handle this case a bit more natively.</i></p>\n<p><strong>Tabs with internal views</strong>\n are the traditional usages where each tab has associated view content and the view switching is managed internally by the Tabs component.\n</p><p><strong>Tabs with external view content</strong>\n is often useful when content associated with each tab is independently managed and data-binding notifications announce tab selection changes.\n</p><p>Additional features also include:</p><ul><li>Content can include any markup.</li><li>\nIf a tab is disabled while active/selected, then the next tab will be auto-selected.</li></ul><h3 \nid=\"explanation-of-tab-stretching\">Explanation of tab stretching</h3><p>\nInitially, tabs will have an inherent size. This size will either be defined by how much space is needed to accommodate their text or set by the user through CSS. Calculations will be based on this size.\n</p><p>\nOn mobile devices, tabs will be expanded to fill the available horizontal space. When this happens, all tabs will become the same size.\n</p><p>On desktops, by default, stretching will never occur.</p><p>This default behavior can be overridden through the \n<code>md-stretch-tabs</code> attribute. Here is a table showing when stretching will occur:</p><table><thead><tr><th>\n<code>md-stretch-tabs</code></th><th>mobile</th><th>desktop</th></tr></thead><tbody><tr><td><code>auto</code></td><td>\nstretched</td><td>---</td></tr><tr><td><code>always</code></td><td>stretched</td><td>stretched</td></tr><tr><td><code>\nnever</code></td><td>---</td><td>---</td></tr></tbody></table></div><div><section class=\"api-section\"><h2 id=\"Usage\">\nUsage</h2><hljs lang=\"html\"><md-tabs md-selected=\"selectedIndex\"><img \nng-src=\"assets/angular-material-assets/img/angular.png\" class=\"centered\"><md-tab \nng-repeat=\"tab in tabs | orderBy:predicate:reversed\" md-on-select=\"onTabSelected(tab)\" \nmd-on-deselect=\"announceDeselected(tab)\" ng-disabled=\"tab.disabled\"><md-tab-label>{{tab.title}} <img \nsrc=\"assets/angular-material-assets/img/removeTab.png\" ng-click=\"removeTab(tab)\" class=\"delete\"></md-tab-label>\n<md-tab-body>{{tab.content}}</md-tab-body></md-tab></md-tabs></hljs></section><div class=\"api-param-section\"><h2>\nAttributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-selected <span hide \nshow-sm><code class=\"api-type label type-hint type-hint-integer\">integer</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-integer\">integer</code></td><td \nclass=\"description\"><p>Index of the active/selected tab</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-no-ink <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></td><td class=\"description\"><p>If present, disables ink ripple effects.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-no-ink-bar <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nIf present, disables the selection ink bar.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">\nmd-align-tabs <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>Attribute to indicate position of tab buttons: <code>bottom</code> or <code>top</code>\n; default is <code>top</code></p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-stretch-tabs \n<span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>Attribute to indicate whether or not to stretch tabs: <code>auto</code>, <code>always</code>\n, or <code>never</code>; default is <code>auto</code></p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-dynamic-height <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen enabled, the tab wrapper will resize based on the contents of the selected tab</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-border-bottom <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nIf present, shows a solid <code>1px</code> border between the tabs and their content</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-center-tabs <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen enabled, tabs will be centered provided there is no need for pagination</p></td></tr><tr class=\"api-params-item\">\n<td style=\"white-space: nowrap\">md-no-pagination <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen enabled, pagination will remain off</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">\nmd-swipe-content <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td>\n<td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td \nclass=\"description\"><p>When enabled, swipe gestures will be enabled for the content area to jump between tabs</p></td>\n</tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-enable-disconnect <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen enabled, scopes will be disconnected for tabs that are not being displayed. This provides a performance boost, but may also cause unexpected issues and is not recommended for most users.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-autoselect <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen present, any tabs added after the initial load will be automatically selected</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-no-select-click <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen enabled, click events will not be fired when selecting tabs</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.toast/service/$mdToast.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>$mdToast</code>\n is a service to build a toast notification on any position on the screen with an optional duration, and provides a simple promise API.\n</p><p>The toast will be always positioned at the <code>bottom</code>, when the screen size is between <code>600px\n</code> and <code>959px</code> (<code>sm</code> breakpoint)</p><h2 id=\"restrictions-on-custom-toasts\">\nRestrictions on custom toasts</h2><ul><li>The toast&#39;s template must have an outer <code>&lt;md-toast&gt;</code>\n element.</li><li>For a toast action, use element with class <code>md-action</code>.</li><li>Add the class <code>\nmd-capsule</code> for curved corners.</li></ul><h3 id=\"custom-presets\">Custom Presets</h3><p>\nDevelopers are also able to create their own preset, which can be easily used without repeating their options each time.\n</p><hljs lang=\"js\">$mdToastProvider.addPreset(&#39;testPreset&#39;, { options: function() { return { template: &#39;\n<md-toast>&#39; + &#39;<div class=\"md-toast-content\">&#39; + &#39;This is a custom preset&#39; + &#39;</div>\n&#39; + &#39;</md-toast>&#39;, controllerAs: &#39;toast&#39;, bindToController: true }; } });</hljs><p>\nAfter you created your preset at config phase, you can easily access it.</p><hljs lang=\"js\">\n$mdToast.show( $mdToast.testPreset() );</hljs><h2 id=\"parent-container-notes\">Parent container notes</h2><p>\nThe toast is positioned using absolute positioning relative to its first non-static parent container. Thus, if the requested parent container uses static positioning, we will temporarily set its positioning to \n<code>relative</code> while the toast is visible and reset it when the toast is hidden.</p><p>\nBecause of this, it is usually best to ensure that the parent container has a fixed height and prevents scrolling by setting the \n<code>overflow: hidden;</code>\n style. Since the position is based off of the parent&#39;s height, the toast may be mispositioned if you allow the parent to scroll.\n</p><p>\nYou can, however, have a scrollable element inside of the container; just make sure the container itself does not scroll.\n</p><hljs lang=\"html\"><div layout-fill id=\"toast-container\"><md-content>I can have lots of content and scroll!\n</md-content></div></hljs></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div \nng-controller=\"MyController\"><md-button ng-click=\"openToast()\">Open a Toast!</md-button></div></hljs><hljs lang=\"js\">\nvar app = angular.module(&#39;app&#39;, [&#39;ngMaterial&#39;]); app.controller(&#39;MyController&#39;, function($scope, $mdToast) { $scope.openToast = function($event) { $mdToast.show($mdToast.simple().textContent(&#39;Hello!&#39;)); // Could also do $mdToast.showSimple(&#39;Hello&#39;); }; });\n</hljs></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"showSimple\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdToast.showSimple(message);</code></h3><div \nclass=\"service-desc\"><p>Convenience method which builds and shows a simple toast.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* message</b> <span hide show-sm>\n<code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThe message to display inside the toast</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns\n</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise\n</code></td><td class=\"description\"><p>A promise that can be resolved with <code>$mdToast.hide()</code>\n or rejected with <code>$mdToast.cancel()</code>.</p></td></tr></tbody></table></div></li><li id=\"simple\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdToast.simple();</code></h3><div \nclass=\"service-desc\"><p>Builds a preconfigured toast.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>a <code>$mdToastPreset</code>\n with the following chainable configuration methods.</p><p><em><strong>Note:</strong>\n These configuration methods are provided in addition to the methods provided by the <code>build()</code> and <code>\nshow()</code> methods below.</em></p><table class=\"md-api-table methods\"><thead><tr><th>Method</th><th>Description</th>\n</tr></thead><tbody><tr><td><code>.textContent(string)</code></td><td>Sets the toast content to the specified string\n</td></tr><tr><td><code>.action(string)</code></td><td>Adds an action button.<br>\nIf clicked, the promise (returned from <code>show()</code>) will resolve with the value <code>&#39;ok&#39;</code>\n; otherwise, it is resolved with <code>true</code> after a <code>hideDelay</code> timeout</td></tr><tr><td><code>\n.highlightAction(boolean)</code></td><td>Whether or not the action button will have an additional highlight class.<br>\nBy default the <code>accent</code> color will be applied to the action button.</td></tr><tr><td><code>\n.highlightClass(string)</code></td><td>If set, the given class will be applied to the highlighted action button.<br>\nThis allows you to specify the highlight color easily. Highlight classes are <code>md-primary</code>, <code>md-warn\n</code> and <code>md-accent</code></td></tr><tr><td><code>.capsule(boolean)</code></td><td>Whether or not to add the \n<code>md-capsule</code> class to the toast to provide rounded corners</td></tr><tr><td><code>.theme(string)</code></td>\n<td>Sets the theme on the toast to the requested theme. Default is <code>$mdThemingProvider</code>&#39;s default.</td>\n</tr><tr><td><code>.toastClass(string)</code></td><td>Sets a class on the toast element</td></tr></tbody></table></td>\n</tr></tbody></table></div></li><li id=\"updateTextContent\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdToast.updateTextContent();</code></h3><div class=\"service-desc\"><p>\nUpdates the content of an existing toast. Useful for updating things like counts, etc.</p></div><div \nclass=\"method-param-table\"></div></li><li id=\"build\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdToast.build();</code></h3><div class=\"service-desc\"><p>Creates a custom <code>\n$mdToastPreset</code> that you can configure.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\">\n<thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>a <code>$mdToastPreset</code>\n with the chainable configuration methods for shows&#39; options (see below).</p></td></tr></tbody></table></div></li>\n<li id=\"show\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdToast.show(optionsOrPreset);\n</code></h3><div class=\"service-desc\"><p>Shows the toast.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* optionsOrPreset</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>Either provide an <code>\n$mdToastPreset</code> returned from <code>simple()</code> and <code>build()</code>\n, or an options object with the following properties:</p><ul><li><code>templateUrl</code> - <code>{string=}</code>\n: The url of an html template file that will be used as the content of the toast. Restrictions: the template must have an outer \n<code>md-toast</code> element.</li><li><code>template</code> - <code>{string=}</code>\n: Same as templateUrl, except this is an actual template string.</li><li><code>autoWrap</code> - <code>{boolean=}\n</code>: Whether or not to automatically wrap the template content with a <code>\n&lt;div class=&quot;md-toast-content&quot;&gt;</code>\n if one is not provided. Defaults to true. Can be disabled if you provide a custom toast directive.</li><li><code>scope\n</code> - <code>{object=}</code>\n: the scope to link the template / controller to. If none is specified, it will create a new child scope. This scope will be destroyed when the toast is removed unless \n<code>preserveScope</code> is set to true.</li><li><code>preserveScope</code> - <code>{boolean=}</code>\n: whether to preserve the scope when the element is removed. Default is false</li><li><code>hideDelay</code> - <code>\n{number=}</code>\n: How many milliseconds the toast should stay active before automatically closing. Set to 0 or false to have the toast stay open until closed manually. Default: 3000.\n</li><li><code>position</code> - <code>{string=}</code>: Sets the position of the toast.<br>\nAvailable: any combination of <code>&#39;bottom&#39;</code>, <code>&#39;left&#39;</code>, <code>&#39;top&#39;</code>, \n<code>&#39;right&#39;</code>, <code>&#39;end&#39;</code> and <code>&#39;start&#39;</code>. The properties <code>\n&#39;end&#39;</code> and <code>&#39;start&#39;</code> are dynamic and can be used for RTL support.<br>\nDefault combination: <code>&#39;bottom left&#39;</code>.</li><li><code>toastClass</code> - <code>{string=}</code>\n: A class to set on the toast element.</li><li><code>controller</code> - <code>{string=}</code>\n: The controller to associate with this toast. The controller will be injected the local <code>$mdToast.hide( )</code>\n, which is a function used to hide the toast.</li><li><code>locals</code> - <code>{string=}</code>\n: An object containing key/value pairs. The keys will be used as names of values to inject into the controller. For example, \n<code>locals: {three: 3}</code> would inject <code>three</code> into the controller with the value of 3.</li><li><code>\nbindToController</code> - <code>bool</code>: bind the locals to the controller, instead of passing them in.</li><li>\n<code>resolve</code> - <code>{object=}</code>\n: Similar to locals, except it takes promises as values and the toast will not open until the promises resolve.</li>\n<li><code>controllerAs</code> - <code>{string=}</code>: An alias to assign the controller to on the scope.</li><li>\n<code>parent</code> - <code>{element=}</code>\n: The element to append the toast to. Defaults to appending to the root element of the application.</li></ul></td></tr>\n</tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td>\n<code class=\"api-type label type-hint type-hint-promise\">promise</code></td><td class=\"description\"><p>\nA promise that can be resolved with <code>$mdToast.hide()</code> or rejected with <code>$mdToast.cancel()</code>. \n<code>$mdToast.hide()</code>\n will resolve either with a Boolean value == &#39;true&#39; or the value passed as an argument to <code>$mdToast.hide()\n</code>. And <code>$mdToast.cancel()</code> will resolve the promise with a Boolean value == &#39;false&#39;</p></td>\n</tr></tbody></table></div></li><li id=\"hide\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdToast.hide([response]);</code></h3><div class=\"service-desc\"><p>\nHide an existing toast and resolve the promise returned from <code>$mdToast.show()</code>.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">response <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">*</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">*</code></td><td class=\"description\"><p>\nAn argument for the resolved promise.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns\n</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise\n</code></td><td class=\"description\"><p>\na promise that is called when the existing element is removed from the DOM. The promise is resolved with either a Boolean value == &#39;true&#39; or the value passed as the argument to \n<code>.hide()</code>.</p></td></tr></tbody></table></div></li><li id=\"cancel\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdToast.cancel([response]);</code></h3><div class=\"service-desc\"><p><code>DEPRECATED\n</code>\n - The promise returned from opening a toast is used only to notify about the closing of the toast. As such, there isn&#39;t any reason to also allow that promise to be rejected, since it&#39;s not clear what the difference between resolve and reject would be.\n</p><p>Hide the existing toast and reject the promise returned from <code>$mdToast.show()</code>.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">response <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">*</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">*</code></td><td class=\"description\"><p>\nAn argument for the rejected promise.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns\n</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise\n</code></td><td class=\"description\"><p>\na promise that is called when the existing element is removed from the DOM The promise is resolved with a Boolean value == &#39;false&#39;.\n</p></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.tooltip/directive/mdTooltip.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nTooltips are used to describe elements that are interactive and primarily graphical (not textual).</p><p>Place a <code>\n&lt;md-tooltip&gt;</code> as a child of the element it describes.</p><p>\nA tooltip will activate when the user hovers over, focuses, or touches the parent element.</p></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-button class=\"md-fab md-accent\" aria-label=\"Play\">\n<md-tooltip>Play Music</md-tooltip><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_play_arrow_24px.svg\"></md-icon></md-button></hljs></section>\n<div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr>\n<th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-z-index <span hide show-sm><code class=\"api-type label type-hint type-hint-number\">\nnumber</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-number\">number\n</code></td><td class=\"description\"><p>\nThe visual level that the tooltip will appear in comparison with the rest of the elements of the application.</p></td>\n</tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-visible <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nBoolean bound to whether the tooltip is currently visible.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-delay <span hide show-sm><code class=\"api-type label type-hint type-hint-number\">number\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-number\">number\n</code></td><td class=\"description\"><p>\nHow many milliseconds to wait to show the tooltip after the user hovers over, focuses, or touches the parent element. Defaults to 0ms on non-touch devices and 75ms on touch.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-autohide <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nIf present or provided with a boolean value, the tooltip will hide on mouse leave, regardless of focus.</p></td></tr>\n<tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-direction <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThe direction that the tooltip is shown, relative to the parent element. Supports top, right, bottom, and left. Defaults to bottom.\n</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.toolbar/directive/mdToolbar.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>md-toolbar</code> is used to place a toolbar in your app.</p><p>\nToolbars are usually used above a content area to display the title of the current page, and show relevant action buttons for that page.\n</p><p>You can change the height of the toolbar by adding either the <code>md-medium-tall</code> or <code>md-tall\n</code> class to the toolbar.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\">\n<div layout=\"column\" layout-fill><md-toolbar><div class=\"md-toolbar-tools\"><h2 md-truncate flex>My App&#39;s Title</h2>\n<md-button>Right Bar Button</md-button></div></md-toolbar><md-content>Hello!</md-content></div></hljs><p><i><b>Note:\n</b> The code above shows usage with the <code>md-truncate</code>\n component which provides an ellipsis if the title is longer than the width of the Toolbar.</i></p><h2 id=\"css-styles\">\nCSS &amp; Styles</h2><p>The <code>&lt;md-toolbar&gt;</code>\n provides a few custom CSS classes that you may use to enhance the functionality of your toolbar.</p><div>\n<docs-css-api-table><docs-css-selector code=\"md-toolbar .md-toolbar-tools\">The <code>md-toolbar-tools</code>\n class provides quite a bit of automatic styling for your toolbar buttons and text. When applied, it will center the buttons and text vertically for you.\n</docs-css-selector></docs-css-api-table></div><h3 id=\"private-classes\">Private Classes</h3><p>\nCurrently, the only private class is the <code>md-toolbar-transitions</code>\n class. All other classes are considered public.</p></section><div class=\"api-param-section\"><h2>Attributes</h2><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-scroll-shrink <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhether the header should shrink away as the user scrolls down, and reveal itself as the user scrolls up.</p><p><em>\n<strong>Note (1):</strong> for scrollShrink to work, the toolbar must be a sibling of a <code>md-content</code>\n element, placed before it. See the scroll shrink demo.</em></p><p><em><strong>Note (2):</strong> The <code>\nmd-scroll-shrink</code> attribute is only parsed on component initialization, it does not watch for scope changes.</em>\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-shrink-speed-factor <span hide show-sm>\n<code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nHow much to change the speed of the toolbar&#39;s shrinking by. For example, if 0.25 is given then the toolbar will shrink at one fourth the rate at which the user scrolls down. Default 0.5.\n</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.truncate/directive/mdTruncate.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>md-truncate</code>\n component displays a label that will automatically clip text which is wider than the component. By default, it displays an ellipsis, but you may apply the \n<code>md-clip</code> CSS class to override this default and use a standard &quot;clipping&quot; approach.</p><p><i><b>\nNote:</b> The <code>md-truncate</code> component does not automatically adjust it&#39;s width. You must provide the \n<code>flex</code> attribute, or some other CSS-based width management. See the <a ng-href=\"./demo/truncate\">demos</a>\n for examples.</i></p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><h3 id=\"as-an-element\">\nAs an Element</h3><hljs lang=\"html\"><div layout=\"row\"><md-button>Back</md-button><md-truncate flex>\nChapter 1 - The Way of the Old West</md-truncate><md-button>Forward</md-button></div></hljs><h3 id=\"as-an-attribute\">\nAs an Attribute</h3><hljs lang=\"html\"><h2 md-truncate style=\"max-width: 100px\">Some Title With a Lot of Text</h2>\n</hljs><h2 id=\"css-styles\">CSS &amp; Styles</h2><p><code>&lt;md-truncate&gt;</code>\n provides two CSS classes that you may use to control the type of clipping.</p><p><i><b>Note:</b> The <code>md-truncate\n</code> also applies a setting of <code>width: 0;</code> when used with the <code>flex</code>\n attribute to fix an issue with the flex element not shrinking properly.</i></p><div><docs-css-api-table>\n<docs-css-selector code=\".md-ellipsis\">\nAssigns the &quot;ellipsis&quot; behavior (default) which will cut off mid-word and append an ellipsis (&hellip;) to the end of the text.\n</docs-css-selector><docs-css-selector code=\".md-clip\">\nAssigns the &quot;clipping&quot; behavior which will simply chop off the text. This may happen mid-word or even mid-character.\n</docs-css-selector></docs-css-api-table></div></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.whiteframe/directive/mdWhiteframe.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The md-whiteframe directive allows you to apply an elevation shadow to an element.\n</p><p>The attribute values needs to be a number between 1 and 24 or -1. When set to -1 no style is applied.</p><h3 \nid=\"notes\">Notes</h3><ul><li>If there is no value specified it defaults to 4dp.</li><li>\nIf the value is not valid it defaults to 4dp.</li></ul></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage\n</h2><hljs lang=\"html\"><div md-whiteframe=\"3\"><span>Elevation of 3dp</span></div></hljs><hljs lang=\"html\"><div \nmd-whiteframe=\"-1\"><span>No elevation shadow applied</span></div></hljs><hljs lang=\"html\"><div ng-init=\"elevation = 5\" \nmd-whiteframe=\"{{elevation}}\"><span>Elevation of 5dp with an interpolated value</span></div></hljs></section></div>\n</div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.virtualRepeat/directive/mdVirtualRepeat.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>md-virtual-repeat</code>\n specifies an element to repeat using virtual scrolling.</p><p>\nVirtual repeat is a limited substitute for ng-repeat that renders only enough DOM nodes to fill the container and recycling them as the user scrolls.\n</p><p>\nArrays, but not objects are supported for iteration. Track by, as alias, and (key, value) syntax are not supported.</p>\n<h3 id=\"on-demand-async-item-loading\">On-Demand Async Item Loading</h3><p>When using the <code>md-on-demand</code>\n attribute and loading some asynchronous data, the <code>getItemAtIndex</code> function will mostly return nothing.</p>\n<hljs lang=\"js\">\nDynamicItems.prototype.getItemAtIndex = function(index) { if (this.pages[index]) { return this.pages[index]; } else { // This is an asynchronous action and does not return any value. this.loadPage(index); } };\n</hljs><p>This means that the VirtualRepeat will not have any value for the given index.<br>\nAfter the data loading completed, the user expects the VirtualRepeat to recognize the change.</p><p>\nTo make sure that the VirtualRepeat properly detects any change, you need to run the operation in another digest.</p>\n<hljs lang=\"js\">\nDynamicItems.prototype.loadPage = function(index) { var self = this; // Trigger a new digest by using $timeout $timeout(function() { self.pages[index] = Data; }); };\n</hljs><blockquote><p><b>Note:</b> Please also review the <a ng-href=\"api/directive/mdVirtualRepeatContainer\">\nVirtualRepeatContainer</a> documentation for more information.</p></blockquote></div><div><section class=\"api-section\">\n<h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-virtual-repeat-container><div md-virtual-repeat=\"i in items\">\nHello {{i}}!</div></md-virtual-repeat-container><md-virtual-repeat-container md-orient-horizontal><div \nmd-virtual-repeat=\"i in items\" md-item-size=\"20\">Hello {{i}}!</div></md-virtual-repeat-container></hljs></section><div \nclass=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-item-size <span hide show-sm><code class=\"api-type label type-hint type-hint-number\">\nnumber</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-number\">number\n</code></td><td class=\"description\"><p>\nThe height or width of the repeated elements (which must be identical for each element). Optional. Will attempt to read the size from the dom if missing, but still assumes that all repeated nodes have same height or width.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-extra-name <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nEvaluates to an additional name to which the current iterated item can be assigned on the repeated scope (needed for use in \n<code>md-autocomplete</code>).</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-on-demand \n<span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td \nclass=\"description\"><p>\nWhen present, treats the md-virtual-repeat argument as an object that can fetch rows rather than an array.</p><p>\n<strong>NOTE:</strong> This object must implement the following interface with two (2) methods:</p><ul><li><code>\ngetItemAtIndex: function(index) [object]</code>\n The item at that index or null if it is not yet loaded (it should start downloading the item in that case).</li><li>\n<code>getLength: function() [number]</code>\n The data length to which the repeater container should be sized. Ideally, when the count is known, this method should return it. Otherwise, return a higher number than the currently loaded items to produce an infinite-scroll behavior.\n</li></ul></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.virtualRepeat/directive/mdVirtualRepeatContainer.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>md-virtual-repeat-container</code>\n provides the scroll container for md-virtual-repeat.</p><p>\nVirtualRepeat is a limited substitute for ng-repeat that renders only enough DOM nodes to fill the container and recycling them as the user scrolls.\n</p><p>\nOnce an element is not visible anymore, the VirtualRepeat recycles it and will reuse it for another visible item by replacing the previous dataset with the new one.\n</p><h3 id=\"common-issues\">Common Issues</h3><ul><li><p>\nWhen having one-time bindings inside of the view template, the VirtualRepeat will not properly update the bindings for new items, since the view will be recycled.\n</p></li><li><p>\nDirectives inside of a VirtualRepeat will be only compiled (linked) once, because those are will be recycled items and used for other items. The VirtualRepeat just updates the scope bindings.\n</p></li></ul><h3 id=\"notes\">Notes</h3><blockquote><p>The VirtualRepeat is a similar implementation to the Android <a \nhref=\"https://developer.android.com/reference/android/support/v7/widget/RecyclerView.html\">RecyclerView</a></p>\n</blockquote><blockquote><p>Please also review the <a ng-href=\"api/directive/mdVirtualRepeat\">VirtualRepeat</a>\n documentation for more information.</p></blockquote></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2>\n<hljs lang=\"html\"><md-virtual-repeat-container md-top-index=\"topIndex\"><div md-virtual-repeat=\"i in items\" \nmd-item-size=\"20\">Hello {{i}}!</div></md-virtual-repeat-container></hljs></section><div class=\"api-param-section\"><h2>\nAttributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-top-index <span \nhide show-sm><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td \nclass=\"description\"><p>\nBinds the index of the item that is at the top of the scroll container to $scope. It can both read and set the scroll position.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-orient-horizontal <span hide show-sm><code\n class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhether the container should scroll horizontally (defaults to orientation and scrolling vertically).</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-auto-shrink <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen present, the container will shrink to fit the number of items when that number is less than its original size.</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-auto-shrink-min <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nMinimum number of items that md-auto-shrink will shrink to (default: 0).</p></td></tr></tbody></table></div></div>\n</div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.aria/service/$mdAriaProvider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>Modify options of the <code>$mdAria</code>\n service, which will be used by most of the AngularJS Material components.</p><p>You are able to disable <code>$mdAria\n</code> warnings, by using the following markup.</p><hljs lang=\"js\">\napp.config(function($mdAriaProvider) { // Globally disables all ARIA warnings. $mdAriaProvider.disableWarnings(); });\n</hljs></div><div><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"disableWarnings\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdAriaProvider.disableWarnings();</code></h3><div \nclass=\"service-desc\"><p>Disables all ARIA warnings generated by AngularJS Material.</p></div><div \nclass=\"method-param-table\"></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.compiler/service/$mdCompiler.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nThe $mdCompiler service is an abstraction of AngularJS&#39;s compiler, that allows developers to easily compile an element with options like in a Directive Definition Object.\n</p><blockquote><p>The compiler powers a lot of components inside of AngularJS Material. Like the <code>$mdPanel</code>\n or <code>$mdDialog</code>.</p></blockquote></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>\nBasic Usage with a template</p><hljs lang=\"js\">\n$mdCompiler.compile({ templateUrl: &#39;modal.html&#39;, controller: &#39;ModalCtrl&#39;, locals: { modal: myModalInstance; } }).then(function (compileData) { compileData.element; // Compiled DOM element compileData.link(myScope); // Instantiate controller and link element to scope. });\n</hljs><p>Example with a content element</p><hljs lang=\"js\">\n// Create a virtual element and link it manually. // The compiler doesn&#39;t need to recompile the element each time. var myElement = $compile(&#39;\n<span>Test</span>\n&#39;)(myScope); $mdCompiler.compile({ contentElement: myElement }).then(function (compileData) { compileData.element // Content Element (same as above) compileData.link // This does nothing when using a contentElement. });\n</hljs><blockquote><p>\nContent Element is a significant performance improvement when the developer already knows that the compiled element will be always the same and the scope will not change either.\n</p></blockquote><p>The <code>contentElement</code>\n option also supports DOM elements which will be temporary removed and restored at its old position.</p><hljs \nlang=\"js\">\nvar domElement = document.querySelector(&#39;#myElement&#39;); $mdCompiler.compile({ contentElement: myElement }).then(function (compileData) { compileData.element // Content Element (same as above) compileData.link // This does nothing when using a contentElement. });\n</hljs><p>The <code>$mdCompiler</code> can also query for the element in the DOM itself.</p><hljs lang=\"js\">\n$mdCompiler.compile({ contentElement: &#39;#myElement&#39; }).then(function (compileData) { compileData.element // Content Element (same as above) compileData.link // This does nothing when using a contentElement. });\n</hljs></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"compile\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdCompiler.compile(options);</code></h3><div \nclass=\"service-desc\"><p>A method to compile a HTML template with the AngularJS compiler. The <code>$mdCompiler</code>\n is wrapper around the AngularJS compiler and provides extra functionality like controller instantiation or async resolves.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* options</b> <span \nhide show-sm><code class=\"api-type label type-hint type-hint-object\">Object</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">Object</code></td><td \nclass=\"description\"><p>An options object, with the following properties:</p><ul><li><code>controller</code> - <code>\n{string|Function}</code>\n Controller fn that should be associated with newly created scope or the name of a registered controller if passed as a string.\n</li><li><code>controllerAs</code> - <code>{string=}</code>\n A controller alias name. If present the controller will be published to scope under the <code>controllerAs</code>\n name.</li><li><code>contentElement</code> - <code>{string|Element}</code>\n: Instead of using a template, which will be compiled each time, you can also use a DOM element.<br></li><li><code>\ntemplate</code> - <code>{string=}</code> An html template as a string.</li><li><code>templateUrl</code> - <code>\n{string=}</code> A path to an html template.</li><li><code>transformTemplate</code> - <code>{function(template)=}\n</code>\n A function which transforms the template after it is loaded. It will be given the template string as a parameter, and should return a a new string representing the transformed template.\n</li><li><code>resolve</code> - <code>{Object.&lt;string, function&gt;=}</code>\n - An optional map of dependencies which should be injected into the controller. If any of these dependencies are promises, the compiler will wait for them all to be resolved, or if one is rejected before the controller is instantiated \n<code>compile()</code> will fail..<ul><li><code>key</code> - <code>{string}</code>\n: a name of a dependency to be injected into the controller.</li><li><code>factory</code> - <code>{string|function}\n</code>: If <code>string</code>\n then it is an alias for a service. Otherwise if function, then it is injected and the return value is treated as the dependency. If the result is a promise, it is resolved before its value is injected into the controller.\n</li></ul></li></ul></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description\n</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-object\">Object</code></td><td \nclass=\"description\"><p>promise A promise, which will be resolved with a <code>compileData</code> object. <code>\ncompileData</code> has the following properties:</p><ul><li><code>element</code> - <code>{element}</code>\n: an uncompiled element matching the provided template.</li><li><code>link</code> - <code>{function(scope)}</code>\n: A link function, which, when called, will compile the element and instantiate the provided controller (if given).\n</li><li><code>locals</code> - <code>{object}</code>: The locals which will be passed into the controller once <code>\nlink</code> is called. If <code>bindToController</code> is true, they will be coppied to the ctrl instead</li></ul>\n</td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.liveannouncer/service/$mdLiveAnnouncer.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>Service to announce messages to supported screenreaders.</p><blockquote><p>The \n<code>$mdLiveAnnouncer</code> service is internally used for components to provide proper accessibility.</p>\n</blockquote><hljs lang=\"js\">\nmodule.controller(&#39;AppCtrl&#39;, function($mdLiveAnnouncer) { // Basic announcement (Polite Mode) $mdLiveAnnouncer.announce(&#39;Hey Google&#39;); // Custom announcement (Assertive Mode) $mdLiveAnnouncer.announce(&#39;Hey Google&#39;, &#39;assertive&#39;); });\n</hljs></div><div><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"announce\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdLiveAnnouncer.announce(message, politeness);\n</code></h3><div class=\"service-desc\"><p>Announces messages to supported screenreaders.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* message</b> <span hide show-sm>\n<code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nMessage to be announced to the screenreader</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">\n<b>* politeness</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-object\">&#39;off&#39;</code>\n<code class=\"api-type label type-hint type-hint-object\">&#39;polite&#39;</code><code \nclass=\"api-type label type-hint type-hint-object\">&#39;assertive&#39;</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">&#39;off&#39;</code><code \nclass=\"api-type label type-hint type-hint-object\">&#39;polite&#39;</code><code \nclass=\"api-type label type-hint type-hint-object\">&#39;assertive&#39;</code></td><td class=\"description\"><p>\nThe politeness of the announcer element.</p></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.interaction/service/$mdInteraction.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nService which keeps track of the last interaction type and validates them for several browsers. The service hooks into the document&#39;s body and listens for touch, mouse and keyboard events.\n</p><p>The most recent interaction type can be retrieved by calling the <code>getLastInteractionType</code> method.</p>\n<p>Here is an example markup for using the interaction service.</p><hljs lang=\"js\">\nvar lastType = $mdInteraction.getLastInteractionType(); if (lastType === &#39;keyboard&#39;) { // We only restore the focus for keyboard users. restoreFocus(); }\n</hljs></div><div><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"getLastInteractionType\">\n<h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdInteraction.getLastInteractionType();</code>\n</h3><div class=\"service-desc\"><p>Retrieves the last interaction type triggered in body.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-null\">null</code></td><td class=\"description\"><p>Last interaction type.</p>\n</td></tr></tbody></table></div></li><li id=\"isUserInvoked\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdInteraction.isUserInvoked([checkDelay]);</code></h3><div class=\"service-desc\"><p>\nMethod to detect whether any interaction happened recently or not.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">checkDelay <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nTime to check for any interaction to have been triggered.</p></td></tr></tbody></table><table class=\"md-api-table\">\n<thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhether there was any interaction or not.</p></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.gestures/service/$mdGestureProvider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nIn some scenarios on Mobile devices (without jQuery), the click events should NOT be hijacked. <code>$mdGestureProvider\n</code> is used to configure the Gesture module to ignore or skip click hijacking on mobile devices.</p><hljs \nlang=\"js\">\napp.config(function($mdGestureProvider) { // For mobile devices without jQuery loaded, do not // intercept click events during the capture phase. $mdGestureProvider.skipClickHijack(); });\n</hljs></div><div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.ripple/service/$mdInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>$mdInkRipple</code> is a service for adding ripples to any element</p></div>\n<div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">\napp.factory(&#39;$myElementInkRipple&#39;, function($mdInkRipple) { return { attach: function (scope, element, options) { return $mdInkRipple.attach(scope, element, angular.extend({ center: false, dimBackground: true }, options)); } }; }); app.controller(&#39;myController&#39;, function ($scope, $element, $myElementInkRipple) { $scope.onClick = function (ev) { $myElementInkRipple.attach($scope, angular.element(ev.target), { center: true }); } });\n</hljs><h3 id=\"disabling-ripples-globally\">Disabling ripples globally</h3><p>\nIf you want to disable ink ripples globally, for all components, you can call the <code>disableInkRipple</code>\n method in your app&#39;s config.</p><p><hljs lang=\"js\">\napp.config(function ($mdInkRippleProvider) { $mdInkRippleProvider.disableInkRipple(); });</hljs></p></section><section \nclass=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"attach\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdInkRipple.attach([scope], [element], [options]);</code></h3><div \nclass=\"service-desc\"><p>Attaching given scope, element and options to inkRipple controller</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">scope <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>\nScope within the current context</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">element <span\n hide show-sm><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td \nclass=\"description\"><p>The element the ripple effect should be applied to</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">options <span hide show-sm><code class=\"api-type label type-hint type-hint-object\">object\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object\n</code></td><td class=\"description\"><p>(Optional) Configuration options to override the defaultRipple configuration</p>\n<ul><li><code>center</code> - Whether the ripple should start from the center of the container element</li><li><code>\ndimBackground</code> - Whether the background should be dimmed with the ripple color</li><li><code>colorElement</code>\n - The element the ripple should take its color from, defined by css property <code>color</code></li><li><code>\nfitRipple</code> - Whether the ripple should fill the element</li></ul></td></tr></tbody></table></div></li><li \nid=\"disableInkRipple\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdInkRipple.disableInkRipple();</code></h3><div class=\"service-desc\"><p>\nA config-time method that, when called, disables ripples globally.</p></div><div class=\"method-param-table\"></div></li>\n</ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.ripple/directive/mdInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>md-ink-ripple</code>\n directive allows you to specify the ripple color or id a ripple is allowed.</p></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><h3 id=\"string-values\">String values</h3><hljs lang=\"html\"><any \nmd-ink-ripple=\"#FF0000\">Ripples in red</any><any md-ink-ripple=\"false\">Not rippling</any></hljs><h3 \nid=\"interpolated-values\">Interpolated values</h3><hljs lang=\"html\"><any md-ink-ripple=\"{{ randomColor() }}\">\nRipples with the return value of &#39;randomColor&#39; function</any><any md-ink-ripple=\"{{ canRipple() }}\">\nRipples if &#39;canRipple&#39; function return value is not &#39;false&#39; or &#39;0&#39;</any></hljs></section><div \nclass=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* md-ink-ripple</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>A color string <code>\n#FF0000</code> or boolean (<code>false</code> or <code>0</code>) for preventing ripple</p></td></tr></tbody></table>\n</div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.meta/service/$$mdMeta.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>A provider and a service that simplifies meta tags access</p><p>\nNote: This is intended only for use with dynamic meta tags such as browser color and title. Tags that are only processed when the page is rendered (such as \n<code>charset</code>, and <code>http-equiv</code>) will not work since <code>$$mdMeta</code>\n adds the tags after the page has already been loaded.</p><pre><code class=\"lang-js\">\napp.config(function($$mdMetaProvider) {\n  var removeMeta = $$mdMetaProvider.setMeta(&#39;meta-name&#39;, &#39;content&#39;);\n  var metaValue  = $$mdMetaProvider.getMeta(&#39;meta-name&#39;); // -&gt; &#39;content&#39;\n\n  removeMeta();\n});\n\napp.controller(&#39;myController&#39;, function($$mdMeta) {\n  var removeMeta = $$mdMeta.setMeta(&#39;meta-name&#39;, &#39;content&#39;);\n  var metaValue  = $$mdMeta.getMeta(&#39;meta-name&#39;); // -&gt; &#39;content&#39;\n\n  removeMeta();\n});\n\n</code></pre></div><div><section class=\"api-section\"><section class=\"api-section\"></section><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody>\n<tr><td><code class=\"api-type label type-hint type-hint-object\">$$mdMeta.$service</code></td><td class=\"description\">\n</td></tr></tbody></table></div></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li \nid=\"setMeta\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$$mdMeta.setMeta(name, content);\n</code></h3><div class=\"service-desc\"><p>\nCreates meta element with the &#39;name&#39; and &#39;content&#39; attributes, if the meta tag is already created than we replace the &#39;content&#39; value\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* name</b> <span \nhide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>meta tag &#39;name&#39; attribute value</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* content</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nmeta tag &#39;content&#39; attribute value</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>\nReturns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-function\">\nfunction</code></td><td class=\"description\"><p>remove function</p></td></tr></tbody></table></div></li><li \nid=\"getMeta\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$$mdMeta.getMeta(name);</code>\n</h3><div class=\"service-desc\"><p>Gets the &#39;content&#39; attribute value of the wanted meta element</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* name</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nmeta tag &#39;name&#39; attribute value</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns\n</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>content attribute value</p></td></tr></tbody></table></div></li></ul></section>\n</div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.theming/service/$mdTheming.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>Service that makes an element apply theming related <b>classes</b> to itself.</p>\n<hljs lang=\"js\">\napp.directive(&#39;myFancyDirective&#39;, function($mdTheming) { return { restrict: &#39;e&#39;, link: function(scope, el, attrs) { $mdTheming(el); $mdTheming.defineTheme(&#39;myTheme&#39;, { primary: &#39;blue&#39;, accent: &#39;pink&#39;, dark: true }) } }; });\n</hljs></div><div><section class=\"api-section\"><div class=\"api-param-section\"><h2>Arguments</h2><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">element <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-element\">element</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-element\">element</code></td><td class=\"description\"><p>to apply theming to\n</p></td></tr></tbody></table></div></div><section class=\"api-section\"></section></section><section \nclass=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"registered\"><h3 class=\"method-function-syntax\">\n<code class=\"method-function-syntax\">$mdTheming.registered(themeName);</code></h3><div class=\"service-desc\"><p>\nDetermine is specified theme name is a valid, registered theme</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* themeName</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nthe theme to check if registered</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th>\n<th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-boolean\">boolean</code>\n</td><td class=\"description\"><p>whether the theme is registered or not</p></td></tr></tbody></table></div></li><li \nid=\"defaultTheme\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdTheming.defaultTheme();\n</code></h3><div class=\"service-desc\"><p>Returns the default theme</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>The default theme</p>\n</td></tr></tbody></table></div></li><li id=\"generateTheme\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdTheming.generateTheme(name);</code></h3><div class=\"service-desc\"><p>\nLazy generate themes - by default, every theme is generated when defined. You can disable this in the configuration section using the \n<code>$mdThemingProvider.generateThemesOnDemand(true);</code></p><p>\nThe theme name that is passed in must match the name of the theme that was defined as part of the configuration block.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* name</b> <span \nhide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>theme name to generate</p></td></tr></tbody></table></div></li><li id=\"setBrowserColor\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdTheming.setBrowserColor(options);</code></h3>\n<div class=\"service-desc\"><p>Sets browser header coloring for more info please visit: <a \nhref=\"https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color\">\nhttps://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color</a></p><p>\nThe default color is <code>800</code> from <code>primary</code> palette of the <code>default</code> theme</p><p>\noptions are:<br><code>theme</code> - A defined theme via <code>$mdThemeProvider</code>\n to use the palettes from. Default is <code>default</code> theme.<br><code>palette</code>\n - Can be any one of the basic material design palettes, extended defined palettes and &#39;primary&#39;, &#39;accent&#39;, &#39;background&#39; and &#39;warn&#39;. Default is \n<code>primary</code><br><code>hue</code> - The hue from the selected palette. Default is <code>800</code></p></div><div\n class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* options</b> <span hide show-sm>\n<code class=\"api-type label type-hint type-hint-object\">Object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">Object</code></td><td class=\"description\"><p>\nOptions object for the browser color</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns\n</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-function\">Function\n</code></td><td class=\"description\"><p>remove function of the browser color</p></td></tr></tbody></table></div></li><li\n id=\"defineTheme\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdTheming.defineTheme(name, options);</code></h3><div class=\"service-desc\"><p>\nDynamically define a theme by an options object</p><p>options are:<br><code>primary</code>\n - The primary palette of the theme.<br><code>accent</code> - The accent palette of the theme.<br><code>warn</code>\n - The warn palette of the theme.<br><code>background</code> - The background palette of the theme.<br><code>dark\n</code> - Indicates if it&#39;s a dark theme.<br></p></div><div class=\"method-param-table\"><table class=\"md-api-table\">\n<thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* name</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nString</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">String\n</code></td><td class=\"description\"><p>Theme name to define</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* options</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">Object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">Object</code></td><td class=\"description\"><p>Theme definition options\n</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">Promise&lt;string&gt;</code></td><td \nclass=\"description\"><p>A resolved promise with the theme name</p></td></tr></tbody></table></div></li></ul></section>\n<section class=\"api-section\"><h2>Properties</h2><br><ul class=\"methods\"><li id=\"THEMES\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdTheming.THEMES</code></h3><div \nclass=\"service-desc\"><p>Property to get all the themes defined</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-object\">Object</code></td><td class=\"description\"><p>\nAll the themes defined with their properties</p></td></tr></tbody></table></div></li><li id=\"PALETTES\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdTheming.PALETTES</code></h3><div \nclass=\"service-desc\"><p>Property to get all the palettes defined</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-object\">Object</code></td><td class=\"description\"><p>\nAll the palettes defined with their colors</p></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.theming/service/$mdThemingProvider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>Provider to configure the <code>$mdTheming</code> service.</p><h3 \nid=\"default-theme\">Default Theme</h3><p>The <code>$mdThemingProvider</code>\n uses by default the following theme configuration:</p><ul><li>Primary Palette: <code>Blue</code></li><li>\nAccent Palette: <code>Pink</code></li><li>Warn Palette: <code>Deep-Orange</code></li><li>Background Palette: <code>Grey\n</code></li></ul><p>If you don&#39;t want to use the <code>md-theme</code>\n directive on the elements itself, you may want to overwrite the default theme.<br>\nThis can be done by using the following markup.</p><hljs lang=\"js\">\nmyAppModule.config(function($mdThemingProvider) { $mdThemingProvider .theme(&#39;default&#39;) .primaryPalette(&#39;blue&#39;) .accentPalette(&#39;teal&#39;) .warnPalette(&#39;red&#39;) .backgroundPalette(&#39;grey&#39;); });\n</hljs><h3 id=\"dynamic-themes\">Dynamic Themes</h3><p>By default, if you change a theme at runtime, the <code>$mdTheming\n</code> service will not detect those changes.<br>\nIf you have an application, which changes its theme on runtime, you have to enable theme watching.</p><hljs lang=\"js\">\nmyAppModule.config(function($mdThemingProvider) { // Enable theme watching. $mdThemingProvider.alwaysWatchTheme(true); });\n</hljs><h3 id=\"custom-theme-styles\">Custom Theme Styles</h3><p>\nSometimes you may want to use your own theme styles for some custom components.<br>\nYou are able to register your own styles by using the following markup.</p><hljs lang=\"js\">\nmyAppModule.config(function($mdThemingProvider) { // Register our custom stylesheet into the theming provider. $mdThemingProvider.registerStyles(STYLESHEET); });\n</hljs><p>The <code>registerStyles</code>\n method only accepts strings as value, so you&#39;re actually not able to load an external stylesheet file into the \n<code>$mdThemingProvider</code>.</p><p>\nIf it&#39;s necessary to load an external stylesheet, we suggest using a bundler, which supports including raw content, like \n<a href=\"https://github.com/webpack/raw-loader\">raw-loader</a> for <code>webpack</code>.</p><hljs lang=\"js\">\nmyAppModule.config(function($mdThemingProvider) { // Register your custom stylesheet into the theming provider. $mdThemingProvider.registerStyles(require(&#39;../styles/my-component.theme.css&#39;)); });\n</hljs><h3 id=\"browser-color\">Browser color</h3><p>Enables browser header coloring for more info please visit: <a \nhref=\"https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color\">\nhttps://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color</a></p><p>\nOptions parameter:<br><code>theme</code> - A defined theme via <code>$mdThemeProvider</code>\n to use the palettes from. Default is <code>default</code> theme.<br><code>palette</code>\n - Can be any one of the basic material design palettes, extended defined palettes and &#39;primary&#39;, &#39;accent&#39;, &#39;background&#39; and &#39;warn&#39;. Default is \n<code>primary</code>.<br><code>hue</code> - The hue from the selected palette. Default is <code>800</code><br></p><hljs\n lang=\"js\">\nmyAppModule.config(function($mdThemingProvider) { // Enable browser color $mdThemingProvider.enableBrowserColor({ theme: &#39;myTheme&#39;, // Default is &#39;default&#39; palette: &#39;accent&#39;, // Default is &#39;primary&#39;, any basic material palette and extended palettes are available hue: &#39;200&#39; // Default is &#39;800&#39; }); });\n</hljs></div><div><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"registerStyles\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdThemingProvider.registerStyles(styles);</code>\n</h3><div class=\"service-desc\"></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* styles</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>The styles to be appended to AngularJS Material&#39;s built in theme css.</p>\n</td></tr></tbody></table></div></li><li id=\"setNonce\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdThemingProvider.setNonce(nonceValue);</code></h3><div class=\"service-desc\"></div><div\n class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* nonceValue</b> <span hide show-sm>\n<code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThe nonce to be added as an attribute to the theme style tags. Setting a value allows the use of CSP policy without using the unsafe-inline directive.\n</p></td></tr></tbody></table></div></li><li id=\"setDefaultTheme\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdThemingProvider.setDefaultTheme(themeName);</code></h3><div class=\"service-desc\">\n</div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* themeName</b> \n<span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>Default theme name to be applied to elements. Default value is <code>default</code>.</p></td>\n</tr></tbody></table></div></li><li id=\"alwaysWatchTheme\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdThemingProvider.alwaysWatchTheme(watch);</code></h3><div class=\"service-desc\"></div>\n<div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description\n</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* watch</b> <span hide show-sm>\n<code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhether or not to always watch themes for changes and re-apply classes when they change. Default is <code>false</code>\n. Enabling can reduce performance.</p></td></tr></tbody></table></div></li><li id=\"enableBrowserColor\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdThemingProvider.enableBrowserColor([options]);\n</code></h3><div class=\"service-desc\"></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">options <span hide show-sm><code class=\"api-type label type-hint type-hint-object\">Object\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">Object\n</code></td><td class=\"description\"><p>Options object for the browser color<br><code>theme</code>\n - A defined theme via <code>$mdThemeProvider</code> to use the palettes from. Default is <code>default</code> theme.\n<br><code>palette</code>\n - Can be any one of the basic material design palettes, extended defined palettes and &#39;primary&#39;, &#39;accent&#39;, &#39;background&#39; and &#39;warn&#39;. Default is \n<code>primary</code>.<br><code>hue</code> - The hue from the selected palette. Default is <code>800</code><br></p></td>\n</tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody>\n<tr><td><code class=\"api-type label type-hint type-hint-function\">Function</code></td><td class=\"description\"><p>\nremove function of the browser color</p></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.util/directive/mdAutofocus.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>[md-autofocus]</code>\n provides an optional way to identify the focused element when a <code>$mdDialog</code>, <code>$mdBottomSheet</code>, \n<code>$mdMenu</code> or <code>$mdSidenav</code> opens or upon page load for input-like elements.</p><p>\nWhen one of these opens, it will find the first nested element with the <code>[md-autofocus]</code>\n attribute directive and optional expression. An expression may be specified as the directive value to enable conditional activation of the autofocus.\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><h3 id=\"dialog\">Dialog</h3><hljs lang=\"html\">\n<md-dialog><form><md-input-container><label for=\"testInput\">Label</label><input id=\"testInput\" type=\"text\" \nmd-autofocus></md-input-container></form></md-dialog></hljs><h3 id=\"bottomsheet\">Bottomsheet</h3><hljs lang=\"html\">\n<md-bottom-sheet class=\"md-list md-has-header\"><md-subheader>Comment Actions</md-subheader><md-list><md-list-item \nng-repeat=\"item in items\"><md-button md-autofocus=\"$index == 2\"><md-icon md-svg-src=\"{{item.icon}}\"></md-icon><span \nclass=\"md-inline-list-icon-label\">{{ item.name }}</span></md-button></md-list-item></md-list></md-bottom-sheet></hljs>\n<h3 id=\"autocomplete\">Autocomplete</h3><hljs lang=\"html\"><md-autocomplete md-autofocus md-selected-item=\"selectedItem\" \nmd-search-text=\"searchText\" md-items=\"item in getMatches(searchText)\" md-item-text=\"item.display\"><span \nmd-highlight-text=\"searchText\">{{item.display}}</span></md-autocomplete></hljs><h3 id=\"sidenav\">Sidenav</h3><hljs \nlang=\"html\"><div layout=\"row\" ng-controller=\"MyController\"><md-sidenav md-component-id=\"left\" class=\"md-sidenav-left\">\nLeft Nav!</md-sidenav><md-content>Center Content<md-button ng-click=\"openLeftMenu()\">Open Left Menu</md-button>\n</md-content><md-sidenav md-component-id=\"right\" md-is-locked-open=\"$mdMedia(\'min-width: 333px\')\" \nclass=\"md-sidenav-right\"><form><md-input-container><label for=\"testInput\">Test input</label><input id=\"testInput\" \ntype=\"text\" ng-model=\"data\" md-autofocus></md-input-container></form></md-sidenav></div></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core/service/$mdButtonInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nProvides ripple effects for md-button. See $mdInkRipple service for all possible configuration options.</p></div><div>\n<section class=\"api-section\"><div class=\"api-param-section\"><h2>Arguments</h2><div class=\"api-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">scope <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>\nScope within the current context</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">element <span\n hide show-sm><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td \nclass=\"description\"><p>The element the ripple effect should be applied to</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">options <span hide show-sm><code class=\"api-type label type-hint type-hint-object\">object\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object\n</code></td><td class=\"description\"><p>(Optional) Configuration options to override the default ripple configuration\n</p></td></tr></tbody></table></div></div><section class=\"api-section\"></section></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core/service/$mdCheckboxInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nProvides ripple effects for md-checkbox. See $mdInkRipple service for all possible configuration options.</p></div>\n<div><section class=\"api-section\"><div class=\"api-param-section\"><h2>Arguments</h2><div class=\"api-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">scope <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>\nScope within the current context</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">element <span\n hide show-sm><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td \nclass=\"description\"><p>The element the ripple effect should be applied to</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">options <span hide show-sm><code class=\"api-type label type-hint type-hint-object\">object\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object\n</code></td><td class=\"description\"><p>(Optional) Configuration options to override the defaultripple configuration</p>\n</td></tr></tbody></table></div></div><section class=\"api-section\"></section></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core/service/$mdListInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nProvides ripple effects for md-list. See $mdInkRipple service for all possible configuration options.</p></div><div>\n<section class=\"api-section\"><div class=\"api-param-section\"><h2>Arguments</h2><div class=\"api-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">scope <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>\nScope within the current context</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">element <span\n hide show-sm><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td \nclass=\"description\"><p>The element the ripple effect should be applied to</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">options <span hide show-sm><code class=\"api-type label type-hint type-hint-object\">object\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object\n</code></td><td class=\"description\"><p>(Optional) Configuration options to override the defaultripple configuration</p>\n</td></tr></tbody></table></div></div><section class=\"api-section\"></section></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core/service/$mdMedia.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>$mdMedia</code>\n is used to evaluate whether a given media query is true or false given the current device&#39;s screen / window size. The media query will be re-evaluated on resize, allowing you to register a watch.\n</p><p><code>$mdMedia</code> also has pre-programmed support for media queries that match the layout breakpoints:</p>\n<table class=\"md-api-table\"><thead><tr><th>Breakpoint</th><th>mediaQuery</th></tr></thead><tbody><tr><td>xs</td><td>\n(max-width: 599px)</td></tr><tr><td>gt-xs</td><td>(min-width: 600px)</td></tr><tr><td>sm</td><td>\n(min-width: 600px) and (max-width: 959px)</td></tr><tr><td>gt-sm</td><td>(min-width: 960px)</td></tr><tr><td>md</td>\n<td>(min-width: 960px) and (max-width: 1279px)</td></tr><tr><td>gt-md</td><td>(min-width: 1280px)</td></tr><tr><td>lg\n</td><td>(min-width: 1280px) and (max-width: 1919px)</td></tr><tr><td>gt-lg</td><td>(min-width: 1920px)</td></tr><tr>\n<td>xl</td><td>(min-width: 1920px)</td></tr><tr><td>landscape</td><td>landscape</td></tr><tr><td>portrait</td><td>\nportrait</td></tr><tr><td>print</td><td>print</td></tr></tbody></table><p>See Material Design&#39;s <a \nhref=\"https://material.google.com/layout/responsive-ui.html\">Layout - Adaptive UI</a> for more details.</p><p><a \nhref=\"https://www.google.com/design/spec/layout/adaptive-ui.html\"><img \nsrc=\"https://material-design.storage.googleapis.com/publish/material_v_4/material_ext_publish/0B8olV15J7abPSGFxemFiQVRtb1k/layout_adaptive_breakpoints_01.png\" \nwidth=\"100%\" height=\"100%\"></a></p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">\napp.controller(&#39;MyController&#39;, function($mdMedia, $scope) { $scope.$watch(function() { return $mdMedia(&#39;lg&#39;); }, function(big) { $scope.bigScreen = big; }); $scope.screenIsSmall = $mdMedia(&#39;sm&#39;); $scope.customQuery = $mdMedia(&#39;(min-width: 1234px)&#39;); $scope.anotherCustom = $mdMedia(&#39;max-width: 300px&#39;); });\n</hljs></section><section class=\"api-section\"><section class=\"api-section\"></section><div class=\"api-param-table\">\n<table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\na boolean representing whether or not the given media query is true or false.</p></td></tr></tbody></table></div>\n</section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core/service/$mdTabInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nProvides ripple effects for md-tabs. See $mdInkRipple service for all possible configuration options.</p></div><div>\n<section class=\"api-section\"><div class=\"api-param-section\"><h2>Arguments</h2><div class=\"api-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">scope <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>\nScope within the current context</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">element <span\n hide show-sm><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td \nclass=\"description\"><p>The element the ripple effect should be applied to</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">options <span hide show-sm><code class=\"api-type label type-hint type-hint-object\">object\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object\n</code></td><td class=\"description\"><p>(Optional) Configuration options to override the defaultripple configuration</p>\n</td></tr></tbody></table></div></div><section class=\"api-section\"></section></section></div></div>");}]);